//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsTenantAvailableOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resolveTenantId(body: ResolveTenantIdInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResolveTenantId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processResolveTenantId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    mobileRegister(body: MobileRegisterInput | undefined): Observable<MobileRegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/MobileRegister";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMobileRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMobileRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MobileRegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MobileRegisterOutput>;
        }));
    }

    protected processMobileRegister(response: HttpResponseBase): Observable<MobileRegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MobileRegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MobileRegisterOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendPasswordResetCode(body: SendPasswordResetCodeInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendPasswordResetCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPasswordResetCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPasswordResetCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSendPasswordResetCode(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendPasswordResetCodeMobile(body: SendPasswordResetCodeInputMobile | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendPasswordResetCodeMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPasswordResetCodeMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPasswordResetCodeMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendPasswordResetCodeMobile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordInput | undefined): Observable<ResetPasswordOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResetPasswordOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResetPasswordOutput>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<ResetPasswordOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResetPasswordOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendEmailActivationLink(body: SendEmailActivationLinkInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendEmailActivationLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmailActivationLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailActivationLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendEmailActivationLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activateEmail(body: ActivateEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/ActivateEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userid (optional) 
     * @return Success
     */
    activateUserWithoutEmail(userid: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/ActivateUserWithoutEmail?";
        if (userid === null)
            throw new Error("The parameter 'userid' cannot be null.");
        else if (userid !== undefined)
            url_ += "userid=" + encodeURIComponent("" + userid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateUserWithoutEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateUserWithoutEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateUserWithoutEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    impersonate(body: ImpersonateInput | undefined): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Impersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processImpersonate(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImpersonateOutput>(null as any);
    }

    /**
     * @return Success
     */
    backToImpersonator(): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/BackToImpersonator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBackToImpersonator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBackToImpersonator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processBackToImpersonator(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImpersonateOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    switchToLinkedAccount(body: SwitchToLinkedAccountInput | undefined): Observable<SwitchToLinkedAccountOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/SwitchToLinkedAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSwitchToLinkedAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchToLinkedAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwitchToLinkedAccountOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwitchToLinkedAccountOutput>;
        }));
    }

    protected processSwitchToLinkedAccount(response: HttpResponseBase): Observable<SwitchToLinkedAccountOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SwitchToLinkedAccountOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwitchToLinkedAccountOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    signUpForSelfService(body: SignupModel | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Account/SignUpForSelfService";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignUpForSelfService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignUpForSelfService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSignUpForSelfService(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param userNameOrEmailAddress (optional) 
     * @return Success
     */
    forgotPassword(userNameOrEmailAddress: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Account/ForgotPassword?";
        if (userNameOrEmailAddress !== undefined && userNameOrEmailAddress !== null)
            url_ += "UserNameOrEmailAddress=" + encodeURIComponent("" + userNameOrEmailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processForgotPassword(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param mobileNumber (optional) 
     * @param email (optional) 
     * @return Success
     */
    getContactInfo(mobileNumber: string | null | undefined, email: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Account/GetContactInfo?";
        if (mobileNumber !== undefined && mobileNumber !== null)
            url_ += "mobileNumber=" + encodeURIComponent("" + mobileNumber) + "&";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetContactInfo(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    changePasswordByID(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Account/ChangePasswordByID?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePasswordByID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePasswordByID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processChangePasswordByID(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable()
export class ActivityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentEmployee(): Observable<Employee> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetCurrentEmployee";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Employee>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Employee>;
        }));
    }

    protected processGetCurrentEmployee(response: HttpResponseBase): Observable<Employee> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Employee.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Employee>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateActivity(body: Activity | undefined): Observable<GetActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/CreateOrUpdateActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetActivityDto>;
        }));
    }

    protected processCreateOrUpdateActivity(response: HttpResponseBase): Observable<GetActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetActivityDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getActivityById(id: number | undefined): Observable<Activity> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetActivityById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Activity>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Activity>;
        }));
    }

    protected processGetActivityById(response: HttpResponseBase): Observable<Activity> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Activity.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Activity>(null as any);
    }

    /**
     * @param date (optional) 
     * @param employeeId (optional) 
     * @return Success
     */
    getActivities(date: moment.Moment | undefined, employeeId: number | null | undefined): Observable<ResponseGetActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetActivities?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (employeeId !== undefined && employeeId !== null)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseGetActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseGetActivityDto>;
        }));
    }

    protected processGetActivities(response: HttpResponseBase): Observable<ResponseGetActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseGetActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseGetActivityDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteActivity(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activity/DeleteActivity?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteActivity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @param firstname (optional) 
     * @param lastname (optional) 
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getActivitySummery(employeeId: number | undefined, firstname: string | null | undefined, lastname: string | null | undefined, month: number | null | undefined, year: number | null | undefined): Observable<ActivitySummeryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetActivitySummery?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (firstname !== undefined && firstname !== null)
            url_ += "firstname=" + encodeURIComponent("" + firstname) + "&";
        if (lastname !== undefined && lastname !== null)
            url_ += "Lastname=" + encodeURIComponent("" + lastname) + "&";
        if (month !== undefined && month !== null)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year !== undefined && year !== null)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivitySummery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivitySummery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivitySummeryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivitySummeryDto[]>;
        }));
    }

    protected processGetActivitySummery(response: HttpResponseBase): Observable<ActivitySummeryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivitySummeryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivitySummeryDto[]>(null as any);
    }
}

@Injectable()
export class AdvanceDetialsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAdvanceDetialsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceDetials/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAdvanceDetialsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAdvanceDetialsForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAdvanceDetialsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAdvanceDetialsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAdvanceDetialsForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAdvanceDetialsForEdit(id: number | undefined): Observable<GetAdvanceDetialsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceDetials/GetAdvanceDetialsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvanceDetialsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvanceDetialsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAdvanceDetialsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAdvanceDetialsForEditOutput>;
        }));
    }

    protected processGetAdvanceDetialsForEdit(response: HttpResponseBase): Observable<GetAdvanceDetialsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAdvanceDetialsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAdvanceDetialsForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditAdvanceDetialsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceDetials/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceDetials/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class AdvanceRequestsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAdvanceRequestForEditNew(input: number | undefined): Observable<GetManualAdvanceRequestForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/GetAdvanceRequestForEditNew?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvanceRequestForEditNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvanceRequestForEditNew(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetManualAdvanceRequestForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetManualAdvanceRequestForEditOutput>;
        }));
    }

    protected processGetAdvanceRequestForEditNew(response: HttpResponseBase): Observable<GetManualAdvanceRequestForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetManualAdvanceRequestForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetManualAdvanceRequestForEditOutput>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param employeeID (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllManualAdvanceDetails(filter: string | null | undefined, employeeID: number | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetManualAdvanceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/GetAllManualAdvanceDetails?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (employeeID === null)
            throw new Error("The parameter 'employeeID' cannot be null.");
        else if (employeeID !== undefined)
            url_ += "EmployeeID=" + encodeURIComponent("" + employeeID) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllManualAdvanceDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllManualAdvanceDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetManualAdvanceForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetManualAdvanceForViewDto>;
        }));
    }

    protected processGetAllManualAdvanceDetails(response: HttpResponseBase): Observable<PagedResultDtoOfGetManualAdvanceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetManualAdvanceForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetManualAdvanceForViewDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createorEditManualAdvanceRequest(body: CreateOrEditAdvanceRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/CreateorEditManualAdvanceRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateorEditManualAdvanceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateorEditManualAdvanceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateorEditManualAdvanceRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createorEditAdvanceReturned(body: CreateOrEditAdvanceReturnDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/CreateorEditAdvanceReturned";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateorEditAdvanceReturned(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateorEditAdvanceReturned(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateorEditAdvanceReturned(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAdvanceStatement(body: GetAdvanceStatementInput | undefined): Observable<AdvanceStatementReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/GetAdvanceStatement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvanceStatement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvanceStatement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdvanceStatementReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdvanceStatementReportDto[]>;
        }));
    }

    protected processGetAdvanceStatement(response: HttpResponseBase): Observable<AdvanceStatementReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdvanceStatementReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdvanceStatementReportDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAdvanceReturnForEdit(id: number | undefined): Observable<CreateOrEditAdvanceReturnDto> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/GetAdvanceReturnForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvanceReturnForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvanceReturnForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditAdvanceReturnDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditAdvanceReturnDto>;
        }));
    }

    protected processGetAdvanceReturnForEdit(response: HttpResponseBase): Observable<CreateOrEditAdvanceReturnDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditAdvanceReturnDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditAdvanceReturnDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAdvance(body: CreateOrEditAdvanceRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/UpdateAdvance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAdvance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAdvance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAdvance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteAdvanceReturn(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/DeleteAdvanceReturn?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAdvanceReturn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAdvanceReturn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAdvanceReturn(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getAllAdvanceDetails(month: number | undefined, year: number | undefined): Observable<PagedResultDtoOfGetAdvanceRequestForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/GetAllAdvanceDetails?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAdvanceDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAdvanceDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAdvanceRequestForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAdvanceRequestForViewDto>;
        }));
    }

    protected processGetAllAdvanceDetails(response: HttpResponseBase): Observable<PagedResultDtoOfGetAdvanceRequestForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAdvanceRequestForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAdvanceRequestForViewDto>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getAllAdvanceDetailsPreMonth(month: number | undefined, year: number | undefined): Observable<PagedResultDtoOfGetAdvanceRequestForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/GetAllAdvanceDetailsPreMonth?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAdvanceDetailsPreMonth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAdvanceDetailsPreMonth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAdvanceRequestForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAdvanceRequestForViewDto>;
        }));
    }

    protected processGetAllAdvanceDetailsPreMonth(response: HttpResponseBase): Observable<PagedResultDtoOfGetAdvanceRequestForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAdvanceRequestForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAdvanceRequestForViewDto>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getAllAdvanceDetailsAfterProc(month: number | undefined, year: number | undefined): Observable<PagedResultDtoOfGetAdvanceRequestForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/GetAllAdvanceDetailsAfterProc?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAdvanceDetailsAfterProc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAdvanceDetailsAfterProc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAdvanceRequestForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAdvanceRequestForViewDto>;
        }));
    }

    protected processGetAllAdvanceDetailsAfterProc(response: HttpResponseBase): Observable<PagedResultDtoOfGetAdvanceRequestForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAdvanceRequestForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAdvanceRequestForViewDto>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param empId (optional) 
     * @return Success
     */
    getAllAdvanceReturn(searchText: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined, empId: number | undefined): Observable<PagedResultDtoOfAdvanceReturnDto> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/GetAllAdvanceReturn?";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (empId === null)
            throw new Error("The parameter 'empId' cannot be null.");
        else if (empId !== undefined)
            url_ += "EmpId=" + encodeURIComponent("" + empId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAdvanceReturn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAdvanceReturn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAdvanceReturnDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAdvanceReturnDto>;
        }));
    }

    protected processGetAllAdvanceReturn(response: HttpResponseBase): Observable<PagedResultDtoOfAdvanceReturnDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAdvanceReturnDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAdvanceReturnDto>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param searchName (optional) 
     * @return Success
     */
    getAllAdvancee(month: number | undefined, year: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined, searchName: string | null | undefined): Observable<PagedResultDtoOfGetAdvanceRequestForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/GetAllAdvancee?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (searchName !== undefined && searchName !== null)
            url_ += "searchName=" + encodeURIComponent("" + searchName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAdvancee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAdvancee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAdvanceRequestForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAdvanceRequestForViewDto>;
        }));
    }

    protected processGetAllAdvancee(response: HttpResponseBase): Observable<PagedResultDtoOfGetAdvanceRequestForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAdvanceRequestForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAdvanceRequestForViewDto>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getEmployeeAdvancee(month: number | undefined, year: number | undefined): Observable<PagedResultDtoOfGetAdvanceRequestForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/GetEmployeeAdvancee?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeAdvancee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeAdvancee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAdvanceRequestForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAdvanceRequestForViewDto>;
        }));
    }

    protected processGetEmployeeAdvancee(response: HttpResponseBase): Observable<PagedResultDtoOfGetAdvanceRequestForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAdvanceRequestForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAdvanceRequestForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    documentAllowOrNot(id: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/DocumentAllowOrNot?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentAllowOrNot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentAllowOrNot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDocumentAllowOrNot(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @param filter (optional) 
     * @param maxAmountFilter (optional) 
     * @param minAmountFilter (optional) 
     * @param maxAdvanceRequestDateFilter (optional) 
     * @param minAdvanceRequestDateFilter (optional) 
     * @param maxAdvanceRequireDateFilter (optional) 
     * @param minAdvanceRequireDateFilter (optional) 
     * @param maxNoOfEMIFilter (optional) 
     * @param minNoOfEMIFilter (optional) 
     * @param remarksFilter (optional) 
     * @param advanceTypeTypeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(employeeId: number | undefined, filter: string | null | undefined, maxAmountFilter: number | null | undefined, minAmountFilter: number | null | undefined, maxAdvanceRequestDateFilter: moment.Moment | null | undefined, minAdvanceRequestDateFilter: moment.Moment | null | undefined, maxAdvanceRequireDateFilter: moment.Moment | null | undefined, minAdvanceRequireDateFilter: moment.Moment | null | undefined, maxNoOfEMIFilter: number | null | undefined, minNoOfEMIFilter: number | null | undefined, remarksFilter: string | null | undefined, advanceTypeTypeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAdvanceRequestForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/GetAll?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxAmountFilter !== undefined && maxAmountFilter !== null)
            url_ += "MaxAmountFilter=" + encodeURIComponent("" + maxAmountFilter) + "&";
        if (minAmountFilter !== undefined && minAmountFilter !== null)
            url_ += "MinAmountFilter=" + encodeURIComponent("" + minAmountFilter) + "&";
        if (maxAdvanceRequestDateFilter !== undefined && maxAdvanceRequestDateFilter !== null)
            url_ += "MaxAdvanceRequestDateFilter=" + encodeURIComponent(maxAdvanceRequestDateFilter ? "" + maxAdvanceRequestDateFilter.toISOString() : "") + "&";
        if (minAdvanceRequestDateFilter !== undefined && minAdvanceRequestDateFilter !== null)
            url_ += "MinAdvanceRequestDateFilter=" + encodeURIComponent(minAdvanceRequestDateFilter ? "" + minAdvanceRequestDateFilter.toISOString() : "") + "&";
        if (maxAdvanceRequireDateFilter !== undefined && maxAdvanceRequireDateFilter !== null)
            url_ += "MaxAdvanceRequireDateFilter=" + encodeURIComponent(maxAdvanceRequireDateFilter ? "" + maxAdvanceRequireDateFilter.toISOString() : "") + "&";
        if (minAdvanceRequireDateFilter !== undefined && minAdvanceRequireDateFilter !== null)
            url_ += "MinAdvanceRequireDateFilter=" + encodeURIComponent(minAdvanceRequireDateFilter ? "" + minAdvanceRequireDateFilter.toISOString() : "") + "&";
        if (maxNoOfEMIFilter !== undefined && maxNoOfEMIFilter !== null)
            url_ += "MaxNoOfEMIFilter=" + encodeURIComponent("" + maxNoOfEMIFilter) + "&";
        if (minNoOfEMIFilter !== undefined && minNoOfEMIFilter !== null)
            url_ += "MinNoOfEMIFilter=" + encodeURIComponent("" + minNoOfEMIFilter) + "&";
        if (remarksFilter !== undefined && remarksFilter !== null)
            url_ += "RemarksFilter=" + encodeURIComponent("" + remarksFilter) + "&";
        if (advanceTypeTypeFilter !== undefined && advanceTypeTypeFilter !== null)
            url_ += "AdvanceTypeTypeFilter=" + encodeURIComponent("" + advanceTypeTypeFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAdvanceRequestForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAdvanceRequestForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAdvanceRequestForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAdvanceRequestForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAdvanceRequestForViewDto>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @param filter (optional) 
     * @param maxAmountFilter (optional) 
     * @param minAmountFilter (optional) 
     * @param maxAdvanceRequestDateFilter (optional) 
     * @param minAdvanceRequestDateFilter (optional) 
     * @param maxAdvanceRequireDateFilter (optional) 
     * @param minAdvanceRequireDateFilter (optional) 
     * @param maxNoOfEMIFilter (optional) 
     * @param minNoOfEMIFilter (optional) 
     * @param remarksFilter (optional) 
     * @param advanceTypeTypeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAdvance(employeeId: number | undefined, filter: string | null | undefined, maxAmountFilter: number | null | undefined, minAmountFilter: number | null | undefined, maxAdvanceRequestDateFilter: moment.Moment | null | undefined, minAdvanceRequestDateFilter: moment.Moment | null | undefined, maxAdvanceRequireDateFilter: moment.Moment | null | undefined, minAdvanceRequireDateFilter: moment.Moment | null | undefined, maxNoOfEMIFilter: number | null | undefined, minNoOfEMIFilter: number | null | undefined, remarksFilter: string | null | undefined, advanceTypeTypeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAdvanceRequestForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/GetAllAdvance?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxAmountFilter !== undefined && maxAmountFilter !== null)
            url_ += "MaxAmountFilter=" + encodeURIComponent("" + maxAmountFilter) + "&";
        if (minAmountFilter !== undefined && minAmountFilter !== null)
            url_ += "MinAmountFilter=" + encodeURIComponent("" + minAmountFilter) + "&";
        if (maxAdvanceRequestDateFilter !== undefined && maxAdvanceRequestDateFilter !== null)
            url_ += "MaxAdvanceRequestDateFilter=" + encodeURIComponent(maxAdvanceRequestDateFilter ? "" + maxAdvanceRequestDateFilter.toISOString() : "") + "&";
        if (minAdvanceRequestDateFilter !== undefined && minAdvanceRequestDateFilter !== null)
            url_ += "MinAdvanceRequestDateFilter=" + encodeURIComponent(minAdvanceRequestDateFilter ? "" + minAdvanceRequestDateFilter.toISOString() : "") + "&";
        if (maxAdvanceRequireDateFilter !== undefined && maxAdvanceRequireDateFilter !== null)
            url_ += "MaxAdvanceRequireDateFilter=" + encodeURIComponent(maxAdvanceRequireDateFilter ? "" + maxAdvanceRequireDateFilter.toISOString() : "") + "&";
        if (minAdvanceRequireDateFilter !== undefined && minAdvanceRequireDateFilter !== null)
            url_ += "MinAdvanceRequireDateFilter=" + encodeURIComponent(minAdvanceRequireDateFilter ? "" + minAdvanceRequireDateFilter.toISOString() : "") + "&";
        if (maxNoOfEMIFilter !== undefined && maxNoOfEMIFilter !== null)
            url_ += "MaxNoOfEMIFilter=" + encodeURIComponent("" + maxNoOfEMIFilter) + "&";
        if (minNoOfEMIFilter !== undefined && minNoOfEMIFilter !== null)
            url_ += "MinNoOfEMIFilter=" + encodeURIComponent("" + minNoOfEMIFilter) + "&";
        if (remarksFilter !== undefined && remarksFilter !== null)
            url_ += "RemarksFilter=" + encodeURIComponent("" + remarksFilter) + "&";
        if (advanceTypeTypeFilter !== undefined && advanceTypeTypeFilter !== null)
            url_ += "AdvanceTypeTypeFilter=" + encodeURIComponent("" + advanceTypeTypeFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAdvance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAdvance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAdvanceRequestForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAdvanceRequestForEditOutput>;
        }));
    }

    protected processGetAllAdvance(response: HttpResponseBase): Observable<PagedResultDtoOfGetAdvanceRequestForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAdvanceRequestForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAdvanceRequestForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAdvanceRequestForView(id: number | undefined): Observable<GetAdvanceRequestForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/GetAdvanceRequestForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvanceRequestForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvanceRequestForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAdvanceRequestForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAdvanceRequestForViewDto>;
        }));
    }

    protected processGetAdvanceRequestForView(response: HttpResponseBase): Observable<GetAdvanceRequestForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAdvanceRequestForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAdvanceRequestForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAdvanceRequestForEdit(id: number | undefined): Observable<GetAdvanceRequestForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/GetAdvanceRequestForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvanceRequestForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvanceRequestForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAdvanceRequestForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAdvanceRequestForEditOutput>;
        }));
    }

    protected processGetAdvanceRequestForEdit(response: HttpResponseBase): Observable<GetAdvanceRequestForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAdvanceRequestForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAdvanceRequestForEditOutput>(null as any);
    }

    /**
     * @param requestId (optional) 
     * @return Success
     */
    getApprovalStatusWithLog(requestId: number | undefined): Observable<RequestFlowOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/GetApprovalStatusWithLog?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovalStatusWithLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovalStatusWithLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestFlowOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestFlowOutputDto>;
        }));
    }

    protected processGetApprovalStatusWithLog(response: HttpResponseBase): Observable<RequestFlowOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestFlowOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RequestFlowOutputDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAdvanceRequestsForApproval(id: number | undefined): Observable<GetAdvanceRequestForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/GetAdvanceRequestsForApproval?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvanceRequestsForApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvanceRequestsForApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAdvanceRequestForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAdvanceRequestForEditOutput>;
        }));
    }

    protected processGetAdvanceRequestsForApproval(response: HttpResponseBase): Observable<GetAdvanceRequestForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAdvanceRequestForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAdvanceRequestForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getWorkFlowRequest(id: number | undefined): Observable<GetWorkFlowRequestForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/GetWorkFlowRequest?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkFlowRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkFlowRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWorkFlowRequestForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWorkFlowRequestForEditOutput>;
        }));
    }

    protected processGetWorkFlowRequest(response: HttpResponseBase): Observable<GetWorkFlowRequestForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetWorkFlowRequestForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetWorkFlowRequestForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCompoffView(id: number | undefined): Observable<GetWorkFlowRequestForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/GetCompoffView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompoffView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompoffView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWorkFlowRequestForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWorkFlowRequestForEditOutput>;
        }));
    }

    protected processGetCompoffView(response: HttpResponseBase): Observable<GetWorkFlowRequestForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetWorkFlowRequestForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetWorkFlowRequestForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAdvanceRequestsForApprovalView(id: number | undefined): Observable<GetAdvanceRequestForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/GetAdvanceRequestsForApprovalView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvanceRequestsForApprovalView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvanceRequestsForApprovalView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAdvanceRequestForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAdvanceRequestForEditOutput>;
        }));
    }

    protected processGetAdvanceRequestsForApprovalView(response: HttpResponseBase): Observable<GetAdvanceRequestForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAdvanceRequestForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAdvanceRequestForEditOutput>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(employeeId: number | undefined, body: CreateOrEditAdvanceRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/CreateOrEdit?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxAmountFilter (optional) 
     * @param minAmountFilter (optional) 
     * @param maxAdvanceRequestDateFilter (optional) 
     * @param minAdvanceRequestDateFilter (optional) 
     * @param maxAdvanceRequireDateFilter (optional) 
     * @param minAdvanceRequireDateFilter (optional) 
     * @param maxNoOfEMIFilter (optional) 
     * @param minNoOfEMIFilter (optional) 
     * @param remarksFilter (optional) 
     * @param advanceTypeTypeFilter (optional) 
     * @return Success
     */
    getAdvanceRequestsToExcel(filter: string | null | undefined, maxAmountFilter: number | null | undefined, minAmountFilter: number | null | undefined, maxAdvanceRequestDateFilter: moment.Moment | null | undefined, minAdvanceRequestDateFilter: moment.Moment | null | undefined, maxAdvanceRequireDateFilter: moment.Moment | null | undefined, minAdvanceRequireDateFilter: moment.Moment | null | undefined, maxNoOfEMIFilter: number | null | undefined, minNoOfEMIFilter: number | null | undefined, remarksFilter: string | null | undefined, advanceTypeTypeFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/GetAdvanceRequestsToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxAmountFilter !== undefined && maxAmountFilter !== null)
            url_ += "MaxAmountFilter=" + encodeURIComponent("" + maxAmountFilter) + "&";
        if (minAmountFilter !== undefined && minAmountFilter !== null)
            url_ += "MinAmountFilter=" + encodeURIComponent("" + minAmountFilter) + "&";
        if (maxAdvanceRequestDateFilter !== undefined && maxAdvanceRequestDateFilter !== null)
            url_ += "MaxAdvanceRequestDateFilter=" + encodeURIComponent(maxAdvanceRequestDateFilter ? "" + maxAdvanceRequestDateFilter.toISOString() : "") + "&";
        if (minAdvanceRequestDateFilter !== undefined && minAdvanceRequestDateFilter !== null)
            url_ += "MinAdvanceRequestDateFilter=" + encodeURIComponent(minAdvanceRequestDateFilter ? "" + minAdvanceRequestDateFilter.toISOString() : "") + "&";
        if (maxAdvanceRequireDateFilter !== undefined && maxAdvanceRequireDateFilter !== null)
            url_ += "MaxAdvanceRequireDateFilter=" + encodeURIComponent(maxAdvanceRequireDateFilter ? "" + maxAdvanceRequireDateFilter.toISOString() : "") + "&";
        if (minAdvanceRequireDateFilter !== undefined && minAdvanceRequireDateFilter !== null)
            url_ += "MinAdvanceRequireDateFilter=" + encodeURIComponent(minAdvanceRequireDateFilter ? "" + minAdvanceRequireDateFilter.toISOString() : "") + "&";
        if (maxNoOfEMIFilter !== undefined && maxNoOfEMIFilter !== null)
            url_ += "MaxNoOfEMIFilter=" + encodeURIComponent("" + maxNoOfEMIFilter) + "&";
        if (minNoOfEMIFilter !== undefined && minNoOfEMIFilter !== null)
            url_ += "MinNoOfEMIFilter=" + encodeURIComponent("" + minNoOfEMIFilter) + "&";
        if (remarksFilter !== undefined && remarksFilter !== null)
            url_ += "RemarksFilter=" + encodeURIComponent("" + remarksFilter) + "&";
        if (advanceTypeTypeFilter !== undefined && advanceTypeTypeFilter !== null)
            url_ += "AdvanceTypeTypeFilter=" + encodeURIComponent("" + advanceTypeTypeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvanceRequestsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvanceRequestsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetAdvanceRequestsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @param empId (optional) 
     * @return Success
     */
    getAdvanceReturnsToExcel(searchText: string | null | undefined, empId: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/GetAdvanceReturnsToExcel?";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (empId === null)
            throw new Error("The parameter 'empId' cannot be null.");
        else if (empId !== undefined)
            url_ += "empId=" + encodeURIComponent("" + empId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvanceReturnsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvanceReturnsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetAdvanceReturnsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAdvanceStatementToExcel(body: GetAdvanceStatementInput | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/GetAdvanceStatementToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvanceStatementToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvanceStatementToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetAdvanceStatementToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllAdvanceTypeForTableDropdown(): Observable<AdvanceRequestAdvanceTypeLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/GetAllAdvanceTypeForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAdvanceTypeForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAdvanceTypeForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdvanceRequestAdvanceTypeLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdvanceRequestAdvanceTypeLookupTableDto[]>;
        }));
    }

    protected processGetAllAdvanceTypeForTableDropdown(response: HttpResponseBase): Observable<AdvanceRequestAdvanceTypeLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdvanceRequestAdvanceTypeLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdvanceRequestAdvanceTypeLookupTableDto[]>(null as any);
    }

    /**
     * @param advanceTypeId (optional) 
     * @return Success
     */
    getSalaryAdvanceDetails(advanceTypeId: number | undefined): Observable<AdvanceValidationDetail> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/GetSalaryAdvanceDetails?";
        if (advanceTypeId === null)
            throw new Error("The parameter 'advanceTypeId' cannot be null.");
        else if (advanceTypeId !== undefined)
            url_ += "advanceTypeId=" + encodeURIComponent("" + advanceTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalaryAdvanceDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalaryAdvanceDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdvanceValidationDetail>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdvanceValidationDetail>;
        }));
    }

    protected processGetSalaryAdvanceDetails(response: HttpResponseBase): Observable<AdvanceValidationDetail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdvanceValidationDetail.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdvanceValidationDetail>(null as any);
    }

    /**
     * @param empData (optional) 
     * @param locData (optional) 
     * @param deptData (optional) 
     * @param fromdate (optional) 
     * @param toDate (optional) 
     * @param flag (optional) 
     * @param advanceTypeId (optional) 
     * @return Success
     */
    getAdvanceRegisterNew(empData: EmployeeData[] | null | undefined, locData: LocationData[] | null | undefined, deptData: DepartmentData[] | null | undefined, fromdate: moment.Moment | undefined, toDate: moment.Moment | undefined, flag: number | undefined, advanceTypeId: number | undefined): Observable<GetAdvanceRegisterData[]> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/GetAdvanceRegisterNew?";
        if (empData !== undefined && empData !== null)
            empData && empData.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "EmpData[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (locData !== undefined && locData !== null)
            locData && locData.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "LocData[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (deptData !== undefined && deptData !== null)
            deptData && deptData.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "DeptData[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "Fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (flag === null)
            throw new Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "Flag=" + encodeURIComponent("" + flag) + "&";
        if (advanceTypeId === null)
            throw new Error("The parameter 'advanceTypeId' cannot be null.");
        else if (advanceTypeId !== undefined)
            url_ += "AdvanceTypeId=" + encodeURIComponent("" + advanceTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvanceRegisterNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvanceRegisterNew(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAdvanceRegisterData[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAdvanceRegisterData[]>;
        }));
    }

    protected processGetAdvanceRegisterNew(response: HttpResponseBase): Observable<GetAdvanceRegisterData[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAdvanceRegisterData.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAdvanceRegisterData[]>(null as any);
    }

    /**
     * @param empData (optional) 
     * @param locData (optional) 
     * @param deptData (optional) 
     * @param fromdate (optional) 
     * @param toDate (optional) 
     * @param flag (optional) 
     * @param advanceTypeId (optional) 
     * @return Success
     */
    getAdvanceRegisterNewExcel(empData: EmployeeData[] | null | undefined, locData: LocationData[] | null | undefined, deptData: DepartmentData[] | null | undefined, fromdate: moment.Moment | undefined, toDate: moment.Moment | undefined, flag: number | undefined, advanceTypeId: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/GetAdvanceRegisterNewExcel?";
        if (empData !== undefined && empData !== null)
            empData && empData.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "EmpData[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (locData !== undefined && locData !== null)
            locData && locData.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "LocData[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (deptData !== undefined && deptData !== null)
            deptData && deptData.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "DeptData[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "Fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (flag === null)
            throw new Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "Flag=" + encodeURIComponent("" + flag) + "&";
        if (advanceTypeId === null)
            throw new Error("The parameter 'advanceTypeId' cannot be null.");
        else if (advanceTypeId !== undefined)
            url_ += "AdvanceTypeId=" + encodeURIComponent("" + advanceTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvanceRegisterNewExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvanceRegisterNewExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetAdvanceRegisterNewExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    savedAdvance(body: GetAdvanceRequestForViewDto[] | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/SavedAdvance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavedAdvance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavedAdvance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSavedAdvance(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    advanceCreateOnSalary(body: CreateOrEditAdvanceRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceRequests/AdvanceCreateOnSalary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdvanceCreateOnSalary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdvanceCreateOnSalary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAdvanceCreateOnSalary(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class AdvanceTypesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param typeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, typeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAdvanceTypeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceTypes/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (typeFilter !== undefined && typeFilter !== null)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAdvanceTypeForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAdvanceTypeForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAdvanceTypeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAdvanceTypeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAdvanceTypeForViewDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param typeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAdvance(filter: string | null | undefined, typeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAdvanceTypeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceTypes/GetAllAdvance?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (typeFilter !== undefined && typeFilter !== null)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAdvance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAdvance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAdvanceTypeForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAdvanceTypeForViewDto>;
        }));
    }

    protected processGetAllAdvance(response: HttpResponseBase): Observable<PagedResultDtoOfGetAdvanceTypeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAdvanceTypeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAdvanceTypeForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAdvanceTypeForView(id: number | undefined): Observable<GetAdvanceTypeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceTypes/GetAdvanceTypeForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvanceTypeForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvanceTypeForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAdvanceTypeForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAdvanceTypeForViewDto>;
        }));
    }

    protected processGetAdvanceTypeForView(response: HttpResponseBase): Observable<GetAdvanceTypeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAdvanceTypeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAdvanceTypeForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAdvanceTypeForEdit(id: number | undefined): Observable<GetAdvanceTypeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceTypes/GetAdvanceTypeForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvanceTypeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvanceTypeForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAdvanceTypeForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAdvanceTypeForEditOutput>;
        }));
    }

    protected processGetAdvanceTypeForEdit(response: HttpResponseBase): Observable<GetAdvanceTypeForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAdvanceTypeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAdvanceTypeForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditAdvanceTypeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceTypes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceTypes/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param typeFilter (optional) 
     * @return Success
     */
    getAdvanceTypesToExcel(filter: string | null | undefined, typeFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AdvanceTypes/GetAdvanceTypesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (typeFilter !== undefined && typeFilter !== null)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvanceTypesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvanceTypesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetAdvanceTypesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class AnnouncementsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAnnouncementForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Announcements/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAnnouncementForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAnnouncementForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAnnouncementForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAnnouncementForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAnnouncementForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAnnouncementForView(id: number | undefined): Observable<GetAnnouncementForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Announcements/GetAnnouncementForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnouncementForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnouncementForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAnnouncementForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAnnouncementForViewDto>;
        }));
    }

    protected processGetAnnouncementForView(response: HttpResponseBase): Observable<GetAnnouncementForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAnnouncementForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAnnouncementForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAnnouncementForEdit(id: number | undefined): Observable<GetAnnouncementForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Announcements/GetAnnouncementForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnouncementForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnouncementForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAnnouncementForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAnnouncementForEditOutput>;
        }));
    }

    protected processGetAnnouncementForEdit(response: HttpResponseBase): Observable<GetAnnouncementForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAnnouncementForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAnnouncementForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditAnnouncementDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Announcements/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Announcements/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @return Success
     */
    getAnnouncementsToExcel(filter: string | null | undefined, nameFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Announcements/GetAnnouncementsToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnouncementsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnouncementsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetAnnouncementsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class AssetServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditAssetDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Asset/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Asset/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAssetForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAssetForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAssetForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAssetForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAssetForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAssetForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAssetForEdit(id: number | undefined): Observable<GetAssetForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Asset/GetAssetForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAssetForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAssetForEditOutput>;
        }));
    }

    protected processGetAssetForEdit(response: HttpResponseBase): Observable<GetAssetForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAssetForView(id: number | undefined): Observable<GetAssetForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/GetAssetForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAssetForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAssetForViewDto>;
        }));
    }

    protected processGetAssetForView(response: HttpResponseBase): Observable<GetAssetForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetForViewDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @return Success
     */
    getAssetToExcel(filter: string | null | undefined, nameFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/GetAssetToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetAssetToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @return Success
     */
    getAssets(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/Asset/GetAssets";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetAssets(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }
}

@Injectable()
export class AssetMasterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAssetRequestConfirmation(): Observable<AssetRequestConfirmationDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetMaster/GetAssetRequestConfirmation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetRequestConfirmation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetRequestConfirmation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetRequestConfirmationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetRequestConfirmationDto>;
        }));
    }

    protected processGetAssetRequestConfirmation(response: HttpResponseBase): Observable<AssetRequestConfirmationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetRequestConfirmationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetRequestConfirmationDto>(null as any);
    }

    /**
     * @param assetId (optional) 
     * @param isConfirm (optional) 
     * @return Success
     */
    updateAssetRequestConfirmation(assetId: number | undefined, isConfirm: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AssetMaster/UpdateAssetRequestConfirmation?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "AssetId=" + encodeURIComponent("" + assetId) + "&";
        if (isConfirm === null)
            throw new Error("The parameter 'isConfirm' cannot be null.");
        else if (isConfirm !== undefined)
            url_ += "IsConfirm=" + encodeURIComponent("" + isConfirm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAssetRequestConfirmation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAssetRequestConfirmation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAssetRequestConfirmation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param assetNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, assetNameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAssetMasterForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetMaster/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (assetNameFilter !== undefined && assetNameFilter !== null)
            url_ += "AssetNameFilter=" + encodeURIComponent("" + assetNameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAssetMasterForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAssetMasterForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAssetMasterForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAssetMasterForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAssetMasterForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAssetMasterForView(id: number | undefined): Observable<GetAssetMasterForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetMaster/GetAssetMasterForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetMasterForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetMasterForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAssetMasterForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAssetMasterForViewDto>;
        }));
    }

    protected processGetAssetMasterForView(response: HttpResponseBase): Observable<GetAssetMasterForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetMasterForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetMasterForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAssetMasterForEdit(id: number | undefined): Observable<GetAssetMasterForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AssetMaster/GetAssetMasterForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetMasterForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetMasterForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAssetMasterForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAssetMasterForEditOutput>;
        }));
    }

    protected processGetAssetMasterForEdit(response: HttpResponseBase): Observable<GetAssetMasterForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssetMasterForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssetMasterForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditAssetMaster(body: CreateOrEditAssetMasterDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AssetMaster/createOrEditAssetMaster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditAssetMaster(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditAssetMaster(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditAssetMaster(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditAssetMasterDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AssetMaster/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param tranId (optional) 
     * @return Success
     */
    acknowledgeAsset(tranId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AssetMaster/AcknowledgeAsset?";
        if (tranId === null)
            throw new Error("The parameter 'tranId' cannot be null.");
        else if (tranId !== undefined)
            url_ += "tranId=" + encodeURIComponent("" + tranId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcknowledgeAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcknowledgeAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAcknowledgeAsset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param tranId (optional) 
     * @return Success
     */
    getAssetIdByTranId(tranId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AssetMaster/GetAssetIdByTranId?";
        if (tranId === null)
            throw new Error("The parameter 'tranId' cannot be null.");
        else if (tranId !== undefined)
            url_ += "tranId=" + encodeURIComponent("" + tranId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetIdByTranId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetIdByTranId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetAssetIdByTranId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AssetMaster/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param assetNameFilter (optional) 
     * @return Success
     */
    getAssetMasterForExcel(filter: string | null | undefined, assetNameFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetMaster/GetAssetMasterForExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (assetNameFilter !== undefined && assetNameFilter !== null)
            url_ += "AssetNameFilter=" + encodeURIComponent("" + assetNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetMasterForExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetMasterForExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetAssetMasterForExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param assetTypeId (optional) 
     * @return Success
     */
    getAsset(assetTypeId: number | undefined): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/AssetMaster/GetAsset?";
        if (assetTypeId === null)
            throw new Error("The parameter 'assetTypeId' cannot be null.");
        else if (assetTypeId !== undefined)
            url_ += "AssetTypeId=" + encodeURIComponent("" + assetTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetAsset(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    allAsset(body: GetAssetByUserDto | undefined): Observable<PagedResultDtoOfGetAssetByUserDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetMaster/AllAsset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAllAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAssetByUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAssetByUserDto>;
        }));
    }

    protected processAllAsset(response: HttpResponseBase): Observable<PagedResultDtoOfGetAssetByUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAssetByUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAssetByUserDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param assetNameFilter (optional) 
     * @return Success
     */
    getAssignAssetForExcel(filter: string | null | undefined, assetNameFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetMaster/GetAssignAssetForExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (assetNameFilter !== undefined && assetNameFilter !== null)
            url_ += "AssetNameFilter=" + encodeURIComponent("" + assetNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignAssetForExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignAssetForExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetAssignAssetForExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @return Success
     */
    getHRHeadId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AssetMaster/GetHRHeadId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHRHeadId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHRHeadId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetHRHeadId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class AssetsFnFServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param employeeid (optional) 
     * @return Success
     */
    getAssetFnF(employeeid: number | undefined): Observable<PagedResultDtoOfGetAssetMasterForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetsFnF/GetAssetFnF?";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetFnF(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetFnF(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAssetMasterForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAssetMasterForViewDto>;
        }));
    }

    protected processGetAssetFnF(response: HttpResponseBase): Observable<PagedResultDtoOfGetAssetMasterForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAssetMasterForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAssetMasterForViewDto>(null as any);
    }

    /**
     * @param employeeid (optional) 
     * @return Success
     */
    checkIfEmployee(employeeid: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/AssetsFnF/CheckIfEmployee?";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckIfEmployee(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CreateOrEditAssetMasterDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AssetsFnF/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class AttendanceCorrectionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param fromdate (optional) 
     * @param todate (optional) 
     * @param employeeId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAttendance(filter: string | null | undefined, fromdate: moment.Moment | undefined, todate: moment.Moment | undefined, employeeId: number | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAttendanceCorrectionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/GetAllAttendance?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (todate === null)
            throw new Error("The parameter 'todate' cannot be null.");
        else if (todate !== undefined)
            url_ += "Todate=" + encodeURIComponent(todate ? "" + todate.toISOString() : "") + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAttendance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAttendance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAttendanceCorrectionForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAttendanceCorrectionForEditOutput>;
        }));
    }

    protected processGetAllAttendance(response: HttpResponseBase): Observable<PagedResultDtoOfGetAttendanceCorrectionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAttendanceCorrectionForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAttendanceCorrectionForEditOutput>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param fromdate (optional) 
     * @param todate (optional) 
     * @param employeeId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllONDuty(filter: string | null | undefined, fromdate: moment.Moment | undefined, todate: moment.Moment | undefined, employeeId: number | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetOnDutyForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/GetAllONDuty?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (todate === null)
            throw new Error("The parameter 'todate' cannot be null.");
        else if (todate !== undefined)
            url_ += "Todate=" + encodeURIComponent(todate ? "" + todate.toISOString() : "") + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllONDuty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllONDuty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetOnDutyForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetOnDutyForEditOutput>;
        }));
    }

    protected processGetAllONDuty(response: HttpResponseBase): Observable<PagedResultDtoOfGetOnDutyForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetOnDutyForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetOnDutyForEditOutput>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param fromdate (optional) 
     * @param todate (optional) 
     * @param employeeId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getManualOnDuty(filter: string | null | undefined, fromdate: moment.Moment | undefined, todate: moment.Moment | undefined, employeeId: number | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetManualOnDutyForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/GetManualOnDuty?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (todate === null)
            throw new Error("The parameter 'todate' cannot be null.");
        else if (todate !== undefined)
            url_ += "Todate=" + encodeURIComponent(todate ? "" + todate.toISOString() : "") + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManualOnDuty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManualOnDuty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetManualOnDutyForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetManualOnDutyForEditOutput>;
        }));
    }

    protected processGetManualOnDuty(response: HttpResponseBase): Observable<PagedResultDtoOfGetManualOnDutyForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetManualOnDutyForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetManualOnDutyForEditOutput>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrEditOnDutyManual(employeeId: number | undefined, body: CreateOrEditOnDutyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/CreateOrEditOnDutyManual?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditOnDutyManual(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditOnDutyManual(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditOnDutyManual(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getManualOnDutyForEdit(id: number | undefined): Observable<CreateOrEditOnDutyDto> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/GetManualOnDutyForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManualOnDutyForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManualOnDutyForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditOnDutyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditOnDutyDto>;
        }));
    }

    protected processGetManualOnDutyForEdit(response: HttpResponseBase): Observable<CreateOrEditOnDutyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditOnDutyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditOnDutyDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param fromdate (optional) 
     * @param todate (optional) 
     * @param employeeId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllShortLeave(filter: string | null | undefined, fromdate: moment.Moment | undefined, todate: moment.Moment | undefined, employeeId: number | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetShortLeaveForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/GetAllShortLeave?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (todate === null)
            throw new Error("The parameter 'todate' cannot be null.");
        else if (todate !== undefined)
            url_ += "Todate=" + encodeURIComponent(todate ? "" + todate.toISOString() : "") + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllShortLeave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllShortLeave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetShortLeaveForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetShortLeaveForEditOutput>;
        }));
    }

    protected processGetAllShortLeave(response: HttpResponseBase): Observable<PagedResultDtoOfGetShortLeaveForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetShortLeaveForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetShortLeaveForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAttendanceCorrectionForApprovalview(id: number | undefined): Observable<GetAttendanceCorrectionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/GetAttendanceCorrectionForApprovalview?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceCorrectionForApprovalview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceCorrectionForApprovalview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAttendanceCorrectionForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAttendanceCorrectionForEditOutput>;
        }));
    }

    protected processGetAttendanceCorrectionForApprovalview(response: HttpResponseBase): Observable<GetAttendanceCorrectionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAttendanceCorrectionForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAttendanceCorrectionForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAttendanceCorrectionForApproval(id: number | undefined): Observable<GetAttendanceCorrectionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/GetAttendanceCorrectionForApproval?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceCorrectionForApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceCorrectionForApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAttendanceCorrectionForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAttendanceCorrectionForEditOutput>;
        }));
    }

    protected processGetAttendanceCorrectionForApproval(response: HttpResponseBase): Observable<GetAttendanceCorrectionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAttendanceCorrectionForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAttendanceCorrectionForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOnDutyForApproval(id: number | undefined): Observable<GetOnDutyForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/GetOnDutyForApproval?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnDutyForApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnDutyForApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOnDutyForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOnDutyForEditOutput>;
        }));
    }

    protected processGetOnDutyForApproval(response: HttpResponseBase): Observable<GetOnDutyForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOnDutyForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOnDutyForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getShortLeaveForApproval(id: number | undefined): Observable<GetShortLeaveForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/GetShortLeaveForApproval?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShortLeaveForApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShortLeaveForApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetShortLeaveForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetShortLeaveForEditOutput>;
        }));
    }

    protected processGetShortLeaveForApproval(response: HttpResponseBase): Observable<GetShortLeaveForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetShortLeaveForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetShortLeaveForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getShortLeaveForApprovalView(id: number | undefined): Observable<GetShortLeaveForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/GetShortLeaveForApprovalView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShortLeaveForApprovalView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShortLeaveForApprovalView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetShortLeaveForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetShortLeaveForEditOutput>;
        }));
    }

    protected processGetShortLeaveForApprovalView(response: HttpResponseBase): Observable<GetShortLeaveForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetShortLeaveForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetShortLeaveForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOnDutyForApprovalView(id: number | undefined): Observable<GetOnDutyForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/GetOnDutyForApprovalView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnDutyForApprovalView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnDutyForApprovalView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOnDutyForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOnDutyForEditOutput>;
        }));
    }

    protected processGetOnDutyForApprovalView(response: HttpResponseBase): Observable<GetOnDutyForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOnDutyForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOnDutyForEditOutput>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(employeeId: number | undefined, body: CreateOrEditAttendanceCorrectionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/CreateOrEdit?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrEditOnDuty(employeeId: number | undefined, body: CreateOrEditOnDutyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/CreateOrEditOnDuty?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditOnDuty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditOnDuty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditOnDuty(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    getAttendanceRuleValidateForShortLeave(employeeId: number | undefined): Observable<GetShortLeave> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/GetAttendanceRuleValidateForShortLeave?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceRuleValidateForShortLeave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceRuleValidateForShortLeave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetShortLeave>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetShortLeave>;
        }));
    }

    protected processGetAttendanceRuleValidateForShortLeave(response: HttpResponseBase): Observable<GetShortLeave> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetShortLeave.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetShortLeave>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrEditShortLeave(employeeId: number | undefined, body: CreateOrEditShortLeaveDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/CreateOrEditShortLeave?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditShortLeave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditShortLeave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditShortLeave(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param employeeId (optional) 
     * @return Success
     */
    getAttendanceCorrectionsToExcel(filter: string | null | undefined, employeeId: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/GetAttendanceCorrectionsToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceCorrectionsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceCorrectionsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetAttendanceCorrectionsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param employeeId (optional) 
     * @return Success
     */
    getOnDutyToExcel(filter: string | null | undefined, employeeId: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/GetOnDutyToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnDutyToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnDutyToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetOnDutyToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @return Success
     */
    getManualOnDutyExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/GetManualOnDutyExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManualOnDutyExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManualOnDutyExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetManualOnDutyExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    exportToFileShortLeave(employeeId: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/ExportToFileShortLeave?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportToFileShortLeave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToFileShortLeave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportToFileShortLeave(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param date (optional) 
     * @param employeeId (optional) 
     * @return Success
     */
    getAttendanceByDate(date: moment.Moment | undefined, employeeId: number | undefined): Observable<CreateOrEditAttendanceCorrectionDto> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/GetAttendanceByDate?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceByDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceByDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditAttendanceCorrectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditAttendanceCorrectionDto>;
        }));
    }

    protected processGetAttendanceByDate(response: HttpResponseBase): Observable<CreateOrEditAttendanceCorrectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditAttendanceCorrectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditAttendanceCorrectionDto>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    getAttendanceRules(employeeId: number | undefined): Observable<GetAttendanceRuleValidation> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/GetAttendanceRules?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceRules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAttendanceRuleValidation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAttendanceRuleValidation>;
        }));
    }

    protected processGetAttendanceRules(response: HttpResponseBase): Observable<GetAttendanceRuleValidation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAttendanceRuleValidation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAttendanceRuleValidation>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAttendancedApprove(id: number | undefined): Observable<GetAttendanceRuleValidation> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/GetAttendancedApprove?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendancedApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendancedApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAttendanceRuleValidation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAttendanceRuleValidation>;
        }));
    }

    protected processGetAttendancedApprove(response: HttpResponseBase): Observable<GetAttendanceRuleValidation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAttendanceRuleValidation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAttendanceRuleValidation>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    getAttendanceRuleValidate(employeeId: number | undefined): Observable<GetAttendanceValidation> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/GetAttendanceRuleValidate?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceRuleValidate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceRuleValidate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAttendanceValidation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAttendanceValidation>;
        }));
    }

    protected processGetAttendanceRuleValidate(response: HttpResponseBase): Observable<GetAttendanceValidation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAttendanceValidation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAttendanceValidation>(null as any);
    }

    /**
     * @return Success
     */
    getShiftRules(): Observable<GetShiftForValidation> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/GetShiftRules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShiftRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShiftRules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetShiftForValidation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetShiftForValidation>;
        }));
    }

    protected processGetShiftRules(response: HttpResponseBase): Observable<GetShiftForValidation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetShiftForValidation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetShiftForValidation>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @param type (optional) 
     * @return Success
     */
    getOnDutyWorkflowStats(employeeId: number | undefined, type: string | null | undefined): Observable<GetOnDutyMonthlyStats> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/GetOnDutyWorkflowStats?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnDutyWorkflowStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnDutyWorkflowStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOnDutyMonthlyStats>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOnDutyMonthlyStats>;
        }));
    }

    protected processGetOnDutyWorkflowStats(response: HttpResponseBase): Observable<GetOnDutyMonthlyStats> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOnDutyMonthlyStats.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOnDutyMonthlyStats>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @param type (optional) 
     * @return Success
     */
    getShortLeaveWorkflowStats(employeeId: number | undefined, type: string | null | undefined): Observable<GetShortLeaveMonthlyStats> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/GetShortLeaveWorkflowStats?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShortLeaveWorkflowStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShortLeaveWorkflowStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetShortLeaveMonthlyStats>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetShortLeaveMonthlyStats>;
        }));
    }

    protected processGetShortLeaveWorkflowStats(response: HttpResponseBase): Observable<GetShortLeaveMonthlyStats> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetShortLeaveMonthlyStats.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetShortLeaveMonthlyStats>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @param attendanceDate (optional) 
     * @return Success
     */
    getShiftTimeForEmployee(employeeId: number | undefined, attendanceDate: moment.Moment | undefined): Observable<ShiftTimeDto> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/GetShiftTimeForEmployee?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (attendanceDate === null)
            throw new Error("The parameter 'attendanceDate' cannot be null.");
        else if (attendanceDate !== undefined)
            url_ += "attendanceDate=" + encodeURIComponent(attendanceDate ? "" + attendanceDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShiftTimeForEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShiftTimeForEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftTimeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftTimeDto>;
        }));
    }

    protected processGetShiftTimeForEmployee(response: HttpResponseBase): Observable<ShiftTimeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftTimeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShiftTimeDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param attendanceDate (optional) 
     * @return Success
     */
    sendPreviousDayAttendanceCorrectionAlerts(tenantId: number | undefined, attendanceDate: moment.Moment | null | undefined): Observable<AttendanceCorrectionAlertResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceCorrections/SendPreviousDayAttendanceCorrectionAlerts?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (attendanceDate !== undefined && attendanceDate !== null)
            url_ += "attendanceDate=" + encodeURIComponent(attendanceDate ? "" + attendanceDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPreviousDayAttendanceCorrectionAlerts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPreviousDayAttendanceCorrectionAlerts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendanceCorrectionAlertResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendanceCorrectionAlertResultDto>;
        }));
    }

    protected processSendPreviousDayAttendanceCorrectionAlerts(response: HttpResponseBase): Observable<AttendanceCorrectionAlertResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttendanceCorrectionAlertResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AttendanceCorrectionAlertResultDto>(null as any);
    }
}

@Injectable()
export class AttendancePunchsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAttendancePunchForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AttendancePunchs/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAttendancePunchForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAttendancePunchForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAttendancePunchForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAttendancePunchForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAttendancePunchForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAttendancePunchForView(id: number | undefined): Observable<GetAttendancePunchForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AttendancePunchs/GetAttendancePunchForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendancePunchForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendancePunchForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAttendancePunchForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAttendancePunchForViewDto>;
        }));
    }

    protected processGetAttendancePunchForView(response: HttpResponseBase): Observable<GetAttendancePunchForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAttendancePunchForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAttendancePunchForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAttendancePunchForEdit(id: number | undefined): Observable<GetAttendancePunchForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AttendancePunchs/GetAttendancePunchForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendancePunchForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendancePunchForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAttendancePunchForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAttendancePunchForEditOutput>;
        }));
    }

    protected processGetAttendancePunchForEdit(response: HttpResponseBase): Observable<GetAttendancePunchForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAttendancePunchForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAttendancePunchForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditAttendancePunchDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AttendancePunchs/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AttendancePunchs/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class AttendanceRulesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAttendanceRuleForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceRules/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAttendanceRuleForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAttendanceRuleForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAttendanceRuleForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAttendanceRuleForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAttendanceRuleForViewDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllAttendanceRuleforWizard(): Observable<PagedResultDtoOfGetAttendanceRuleForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceRules/GetAllAttendanceRuleforWizard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAttendanceRuleforWizard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAttendanceRuleforWizard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAttendanceRuleForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAttendanceRuleForViewDto>;
        }));
    }

    protected processGetAllAttendanceRuleforWizard(response: HttpResponseBase): Observable<PagedResultDtoOfGetAttendanceRuleForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAttendanceRuleForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAttendanceRuleForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAttendanceRuleForView(id: number | undefined): Observable<GetAttendanceRuleForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceRules/GetAttendanceRuleForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceRuleForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceRuleForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAttendanceRuleForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAttendanceRuleForViewDto>;
        }));
    }

    protected processGetAttendanceRuleForView(response: HttpResponseBase): Observable<GetAttendanceRuleForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAttendanceRuleForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAttendanceRuleForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAttendanceRuleForEdit(id: number | undefined): Observable<GetAttendanceRuleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceRules/GetAttendanceRuleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceRuleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceRuleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAttendanceRuleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAttendanceRuleForEditOutput>;
        }));
    }

    protected processGetAttendanceRuleForEdit(response: HttpResponseBase): Observable<GetAttendanceRuleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAttendanceRuleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAttendanceRuleForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditAttendanceRuleDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceRules/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceRules/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    getAttendanceRulesToExcel(filter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AttendanceRules/GetAttendanceRulesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceRulesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceRulesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetAttendanceRulesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class AttendancesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param number (optional) 
     * @param currentDate (optional) 
     * @return Success
     */
    dailyEmployeeAttendanceSummary(number: string | null | undefined, currentDate: moment.Moment | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/DailyEmployeeAttendanceSummary?";
        if (number !== undefined && number !== null)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (currentDate === null)
            throw new Error("The parameter 'currentDate' cannot be null.");
        else if (currentDate !== undefined)
            url_ += "currentDate=" + encodeURIComponent(currentDate ? "" + currentDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDailyEmployeeAttendanceSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDailyEmployeeAttendanceSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDailyEmployeeAttendanceSummary(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getShiftDetailsEmployee(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetShiftDetails> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/GetShiftDetailsEmployee?";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShiftDetailsEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShiftDetailsEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetShiftDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetShiftDetails>;
        }));
    }

    protected processGetShiftDetailsEmployee(response: HttpResponseBase): Observable<PagedResultDtoOfGetShiftDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetShiftDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetShiftDetails>(null as any);
    }

    /**
     * @param fromdate (optional) 
     * @param toDate (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateShiftAttendance(fromdate: moment.Moment | undefined, toDate: moment.Moment | undefined, body: UpdateshiftAttendance[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/UpdateShiftAttendance?";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateShiftAttendance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateShiftAttendance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateShiftAttendance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param fromdate (optional) 
     * @param toDate (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateShiftAttendanceFromEmployeePage(fromdate: moment.Moment | undefined, toDate: moment.Moment | undefined, body: UpdateshiftAttendance[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/UpdateShiftAttendanceFromEmployeePage?";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateShiftAttendanceFromEmployeePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateShiftAttendanceFromEmployeePage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateShiftAttendanceFromEmployeePage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getAllAttendanceData(month: number | undefined, year: number | undefined): Observable<Atdata[]> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/GetAllAttendanceData?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAttendanceData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAttendanceData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Atdata[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Atdata[]>;
        }));
    }

    protected processGetAllAttendanceData(response: HttpResponseBase): Observable<Atdata[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Atdata.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Atdata[]>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getAllAttendanceWeekOffData(month: number | undefined, year: number | undefined): Observable<Week[]> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/GetAllAttendanceWeekOffData?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAttendanceWeekOffData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAttendanceWeekOffData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Week[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Week[]>;
        }));
    }

    protected processGetAllAttendanceWeekOffData(response: HttpResponseBase): Observable<Week[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Week.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Week[]>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getAllAttendanceHolidayData(month: number | undefined, year: number | undefined): Observable<Holiday[]> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/GetAllAttendanceHolidayData?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAttendanceHolidayData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAttendanceHolidayData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Holiday[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Holiday[]>;
        }));
    }

    protected processGetAllAttendanceHolidayData(response: HttpResponseBase): Observable<Holiday[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Holiday.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Holiday[]>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getAllAttendanceShiftData(month: number | undefined, year: number | undefined): Observable<Shift2[]> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/GetAllAttendanceShiftData?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAttendanceShiftData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAttendanceShiftData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Shift2[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Shift2[]>;
        }));
    }

    protected processGetAllAttendanceShiftData(response: HttpResponseBase): Observable<Shift2[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Shift2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Shift2[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param employeeFirstName (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getManualAttendance(filter: string | null | undefined, employeeFirstName: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAttendanceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/GetManualAttendance?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (employeeFirstName !== undefined && employeeFirstName !== null)
            url_ += "EmployeeFirstName=" + encodeURIComponent("" + employeeFirstName) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManualAttendance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManualAttendance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAttendanceForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAttendanceForViewDto>;
        }));
    }

    protected processGetManualAttendance(response: HttpResponseBase): Observable<PagedResultDtoOfGetAttendanceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAttendanceForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAttendanceForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAttendanceForEditNew(id: number | undefined): Observable<GetAttendanceForEditOutputNew> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/GetAttendanceForEditNew?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceForEditNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceForEditNew(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAttendanceForEditOutputNew>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAttendanceForEditOutputNew>;
        }));
    }

    protected processGetAttendanceForEditNew(response: HttpResponseBase): Observable<GetAttendanceForEditOutputNew> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAttendanceForEditOutputNew.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAttendanceForEditOutputNew>(null as any);
    }

    /**
     * @param attendanceDate (optional) 
     * @param in1 (optional) 
     * @param out1 (optional) 
     * @param in2 (optional) 
     * @param out2 (optional) 
     * @param in3 (optional) 
     * @param out3 (optional) 
     * @param in4 (optional) 
     * @param out4 (optional) 
     * @param in5 (optional) 
     * @param out5 (optional) 
     * @param firsthalf (optional) 
     * @param secondhalf (optional) 
     * @param employeeId (optional) 
     * @param latecomingEarlyGoing (optional) 
     * @param remarks (optional) 
     * @param attendanceRemarks (optional) 
     * @param attendanceStatus (optional) 
     * @param id (optional) 
     * @return Success
     */
    getCompOffCount(attendanceDate: moment.Moment | undefined, in1: string | null | undefined, out1: string | null | undefined, in2: string | null | undefined, out2: string | null | undefined, in3: string | null | undefined, out3: string | null | undefined, in4: string | null | undefined, out4: string | null | undefined, in5: string | null | undefined, out5: string | null | undefined, firsthalf: string | null | undefined, secondhalf: string | null | undefined, employeeId: number | null | undefined, latecomingEarlyGoing: number | null | undefined, remarks: string | null | undefined, attendanceRemarks: string | null | undefined, attendanceStatus: string | null | undefined, id: number | null | undefined): Observable<RequestForApproval> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/getCompOffCount?";
        if (attendanceDate === null)
            throw new Error("The parameter 'attendanceDate' cannot be null.");
        else if (attendanceDate !== undefined)
            url_ += "AttendanceDate=" + encodeURIComponent(attendanceDate ? "" + attendanceDate.toISOString() : "") + "&";
        if (in1 !== undefined && in1 !== null)
            url_ += "In1=" + encodeURIComponent("" + in1) + "&";
        if (out1 !== undefined && out1 !== null)
            url_ += "Out1=" + encodeURIComponent("" + out1) + "&";
        if (in2 !== undefined && in2 !== null)
            url_ += "In2=" + encodeURIComponent("" + in2) + "&";
        if (out2 !== undefined && out2 !== null)
            url_ += "Out2=" + encodeURIComponent("" + out2) + "&";
        if (in3 !== undefined && in3 !== null)
            url_ += "In3=" + encodeURIComponent("" + in3) + "&";
        if (out3 !== undefined && out3 !== null)
            url_ += "Out3=" + encodeURIComponent("" + out3) + "&";
        if (in4 !== undefined && in4 !== null)
            url_ += "In4=" + encodeURIComponent("" + in4) + "&";
        if (out4 !== undefined && out4 !== null)
            url_ += "Out4=" + encodeURIComponent("" + out4) + "&";
        if (in5 !== undefined && in5 !== null)
            url_ += "In5=" + encodeURIComponent("" + in5) + "&";
        if (out5 !== undefined && out5 !== null)
            url_ += "Out5=" + encodeURIComponent("" + out5) + "&";
        if (firsthalf !== undefined && firsthalf !== null)
            url_ += "Firsthalf=" + encodeURIComponent("" + firsthalf) + "&";
        if (secondhalf !== undefined && secondhalf !== null)
            url_ += "Secondhalf=" + encodeURIComponent("" + secondhalf) + "&";
        if (employeeId !== undefined && employeeId !== null)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (latecomingEarlyGoing !== undefined && latecomingEarlyGoing !== null)
            url_ += "latecomingEarlyGoing=" + encodeURIComponent("" + latecomingEarlyGoing) + "&";
        if (remarks !== undefined && remarks !== null)
            url_ += "Remarks=" + encodeURIComponent("" + remarks) + "&";
        if (attendanceRemarks !== undefined && attendanceRemarks !== null)
            url_ += "AttendanceRemarks=" + encodeURIComponent("" + attendanceRemarks) + "&";
        if (attendanceStatus !== undefined && attendanceStatus !== null)
            url_ += "AttendanceStatus=" + encodeURIComponent("" + attendanceStatus) + "&";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompOffCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompOffCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestForApproval>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestForApproval>;
        }));
    }

    protected processGetCompOffCount(response: HttpResponseBase): Observable<RequestForApproval> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestForApproval.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RequestForApproval>(null as any);
    }

    /**
     * @param index (optional) 
     * @param body (optional) 
     * @return Success
     */
    addAttendance(index: number | null | undefined, body: CreateAttendanceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/AddAttendance?";
        if (index !== undefined && index !== null)
            url_ += "index=" + encodeURIComponent("" + index) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAttendance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAttendance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddAttendance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateBulkAttendance(body: CreateAttendanceDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/UpdateBulkAttendance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBulkAttendance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBulkAttendance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBulkAttendance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @param attendanceDate (optional) 
     * @return Success
     */
    getShiftDetailsForAttendance(employeeId: number | null | undefined, attendanceDate: moment.Moment | undefined): Observable<UpdateshiftAttendance> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/GetShiftDetailsForAttendance?";
        if (employeeId !== undefined && employeeId !== null)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (attendanceDate === null)
            throw new Error("The parameter 'attendanceDate' cannot be null.");
        else if (attendanceDate !== undefined)
            url_ += "attendanceDate=" + encodeURIComponent(attendanceDate ? "" + attendanceDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShiftDetailsForAttendance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShiftDetailsForAttendance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateshiftAttendance>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateshiftAttendance>;
        }));
    }

    protected processGetShiftDetailsForAttendance(response: HttpResponseBase): Observable<UpdateshiftAttendance> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateshiftAttendance.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateshiftAttendance>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return Success
     */
    updateAttandance(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/UpdateAttandance?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAttandance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAttandance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAttandance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param date (optional) 
     * @return Success
     */
    processAttandance(date: moment.Moment | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/ProcessAttandance?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessAttandance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessAttandance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processProcessAttandance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    syncAttandance(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/SyncAttandance";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncAttandance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncAttandance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSyncAttandance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param fromdate (optional) 
     * @param todate (optional) 
     * @param employeeId (optional) 
     * @param departmentId (optional) 
     * @param branchId (optional) 
     * @param flag (optional) 
     * @param sortingPreference (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(fromdate: moment.Moment | undefined, todate: moment.Moment | undefined, employeeId: number | undefined, departmentId: number | undefined, branchId: number | undefined, flag: number | undefined, sortingPreference: number | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAttendanceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/GetAll?";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (todate === null)
            throw new Error("The parameter 'todate' cannot be null.");
        else if (todate !== undefined)
            url_ += "Todate=" + encodeURIComponent(todate ? "" + todate.toISOString() : "") + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "DepartmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (branchId === null)
            throw new Error("The parameter 'branchId' cannot be null.");
        else if (branchId !== undefined)
            url_ += "BranchId=" + encodeURIComponent("" + branchId) + "&";
        if (flag === null)
            throw new Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        if (sortingPreference !== undefined && sortingPreference !== null)
            url_ += "SortingPreference=" + encodeURIComponent("" + sortingPreference) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAttendanceForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAttendanceForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAttendanceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAttendanceForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAttendanceForViewDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAttendanceForBulkEdit(body: GetAttendancesForBulkInput | undefined): Observable<AttendanceBulkEditResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/GetAttendanceForBulkEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceForBulkEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceForBulkEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendanceBulkEditResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendanceBulkEditResultDto>;
        }));
    }

    protected processGetAttendanceForBulkEdit(response: HttpResponseBase): Observable<AttendanceBulkEditResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttendanceBulkEditResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AttendanceBulkEditResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportAttendanceForBulkEditExcel(body: GetAttendancesForBulkInput | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/ExportAttendanceForBulkEditExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAttendanceForBulkEditExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAttendanceForBulkEditExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processExportAttendanceForBulkEditExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCheckInOutTime(body: GetAttendancesForBulkInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/UpdateCheckInOutTime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCheckInOutTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCheckInOutTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCheckInOutTime(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param fromdate (optional) 
     * @param todate (optional) 
     * @param employeeFirstNameFilter (optional) 
     * @param employeeid (optional) 
     * @return Success
     */
    getAllUserAttandance(filter: string | null | undefined, fromdate: moment.Moment | undefined, todate: moment.Moment | undefined, employeeFirstNameFilter: string | null | undefined, employeeid: number | null | undefined): Observable<GetAttendanceForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/GetAllUserAttandance?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (todate === null)
            throw new Error("The parameter 'todate' cannot be null.");
        else if (todate !== undefined)
            url_ += "Todate=" + encodeURIComponent(todate ? "" + todate.toISOString() : "") + "&";
        if (employeeFirstNameFilter !== undefined && employeeFirstNameFilter !== null)
            url_ += "EmployeeFirstNameFilter=" + encodeURIComponent("" + employeeFirstNameFilter) + "&";
        if (employeeid !== undefined && employeeid !== null)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserAttandance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserAttandance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAttendanceForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAttendanceForViewDto[]>;
        }));
    }

    protected processGetAllUserAttandance(response: HttpResponseBase): Observable<GetAttendanceForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAttendanceForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAttendanceForViewDto[]>(null as any);
    }

    /**
     * @param monthdata (optional) 
     * @param curyear (optional) 
     * @param employeeId (optional) 
     * @return Success
     */
    getUserAttendance(monthdata: number | undefined, curyear: number | undefined, employeeId: number | undefined): Observable<GetTotalAttendanceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/GetUserAttendance?";
        if (monthdata === null)
            throw new Error("The parameter 'monthdata' cannot be null.");
        else if (monthdata !== undefined)
            url_ += "monthdata=" + encodeURIComponent("" + monthdata) + "&";
        if (curyear === null)
            throw new Error("The parameter 'curyear' cannot be null.");
        else if (curyear !== undefined)
            url_ += "curyear=" + encodeURIComponent("" + curyear) + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAttendance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAttendance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTotalAttendanceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTotalAttendanceDto[]>;
        }));
    }

    protected processGetUserAttendance(response: HttpResponseBase): Observable<GetTotalAttendanceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetTotalAttendanceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTotalAttendanceDto[]>(null as any);
    }

    /**
     * @param fromdate (optional) 
     * @param todate (optional) 
     * @param empId (optional) 
     * @return Success
     */
    viewPunches(fromdate: moment.Moment | undefined, todate: moment.Moment | undefined, empId: number | null | undefined): Observable<GetPunchesForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/ViewPunches?";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (todate === null)
            throw new Error("The parameter 'todate' cannot be null.");
        else if (todate !== undefined)
            url_ += "Todate=" + encodeURIComponent(todate ? "" + todate.toISOString() : "") + "&";
        if (empId !== undefined && empId !== null)
            url_ += "empId=" + encodeURIComponent("" + empId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processViewPunches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processViewPunches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPunchesForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPunchesForViewDto[]>;
        }));
    }

    protected processViewPunches(response: HttpResponseBase): Observable<GetPunchesForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetPunchesForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPunchesForViewDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAttendanceForView(id: number | undefined): Observable<GetAttendanceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/GetAttendanceForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAttendanceForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAttendanceForViewDto>;
        }));
    }

    protected processGetAttendanceForView(response: HttpResponseBase): Observable<GetAttendanceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAttendanceForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAttendanceForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAttendanceForEdit(id: number | undefined): Observable<GetAttendanceForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/GetAttendanceForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAttendanceForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAttendanceForEditOutput>;
        }));
    }

    protected processGetAttendanceForEdit(response: HttpResponseBase): Observable<GetAttendanceForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAttendanceForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAttendanceForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditAttendanceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllEmployeeForTableDropdown(): Observable<AttendanceEmployeeLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/GetAllEmployeeForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEmployeeForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEmployeeForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendanceEmployeeLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendanceEmployeeLookupTableDto[]>;
        }));
    }

    protected processGetAllEmployeeForTableDropdown(response: HttpResponseBase): Observable<AttendanceEmployeeLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttendanceEmployeeLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AttendanceEmployeeLookupTableDto[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param fromdate (optional) 
     * @param todate (optional) 
     * @param employeeId (optional) 
     * @param departmentId (optional) 
     * @param branchId (optional) 
     * @param flag (optional) 
     * @param sortingPreference (optional) 
     * @return Success
     */
    getAttandanceToExcel(filter: string | null | undefined, fromdate: moment.Moment | undefined, todate: moment.Moment | undefined, employeeId: number | undefined, departmentId: number | undefined, branchId: number | undefined, flag: number | undefined, sortingPreference: number | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/GetAttandanceToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (todate === null)
            throw new Error("The parameter 'todate' cannot be null.");
        else if (todate !== undefined)
            url_ += "Todate=" + encodeURIComponent(todate ? "" + todate.toISOString() : "") + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "DepartmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (branchId === null)
            throw new Error("The parameter 'branchId' cannot be null.");
        else if (branchId !== undefined)
            url_ += "BranchId=" + encodeURIComponent("" + branchId) + "&";
        if (flag === null)
            throw new Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        if (sortingPreference !== undefined && sortingPreference !== null)
            url_ += "SortingPreference=" + encodeURIComponent("" + sortingPreference) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttandanceToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttandanceToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetAttandanceToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param fromdate (optional) 
     * @param todate (optional) 
     * @param employeeId (optional) 
     * @param departmentId (optional) 
     * @param branchId (optional) 
     * @param flag (optional) 
     * @param sortingPreference (optional) 
     * @return Success
     */
    getAttandanceUserToExcel(filter: string | null | undefined, fromdate: moment.Moment | undefined, todate: moment.Moment | undefined, employeeId: number | undefined, departmentId: number | undefined, branchId: number | undefined, flag: number | undefined, sortingPreference: number | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/GetAttandanceUserToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (todate === null)
            throw new Error("The parameter 'todate' cannot be null.");
        else if (todate !== undefined)
            url_ += "Todate=" + encodeURIComponent(todate ? "" + todate.toISOString() : "") + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "DepartmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (branchId === null)
            throw new Error("The parameter 'branchId' cannot be null.");
        else if (branchId !== undefined)
            url_ += "BranchId=" + encodeURIComponent("" + branchId) + "&";
        if (flag === null)
            throw new Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        if (sortingPreference !== undefined && sortingPreference !== null)
            url_ += "SortingPreference=" + encodeURIComponent("" + sortingPreference) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttandanceUserToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttandanceUserToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetAttandanceUserToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param employeeid (optional) 
     * @return Success
     */
    generatePdfSalarySlip(monthYear: string | null | undefined, employeeid: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/GeneratePdfSalarySlip?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "MonthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "Employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneratePdfSalarySlip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratePdfSalarySlip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGeneratePdfSalarySlip(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param imageData (optional) 
     * @return Success
     */
    import(imageData: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (imageData !== null && imageData !== undefined)
            content_.append("ImageData", imageData.data, imageData.fileName ? imageData.fileName : "ImageData");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAttandanceExcel(): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/GetAttandanceExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttandanceExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttandanceExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetAttandanceExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getMonthWiseExcel(): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/GetMonthWiseExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthWiseExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthWiseExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetMonthWiseExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    syncAttandaceSheet(body: PortList | undefined): Observable<AttandanceAlreadyExits[]> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/SyncAttandaceSheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncAttandaceSheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncAttandaceSheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttandanceAlreadyExits[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttandanceAlreadyExits[]>;
        }));
    }

    protected processSyncAttandaceSheet(response: HttpResponseBase): Observable<AttandanceAlreadyExits[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttandanceAlreadyExits.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AttandanceAlreadyExits[]>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    attendanceProcess(month: number | undefined, year: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/AttendanceProcess?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttendanceProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttendanceProcess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAttendanceProcess(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getWorkingHours(): Observable<WorkingHoursDto> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/GetWorkingHours";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkingHours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkingHours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkingHoursDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkingHoursDto>;
        }));
    }

    protected processGetWorkingHours(response: HttpResponseBase): Observable<WorkingHoursDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkingHoursDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkingHoursDto>(null as any);
    }

    /**
     * @param date (optional) 
     * @param employeeId (optional) 
     * @return Success
     */
    getPunches(date: moment.Moment | undefined, employeeId: number | undefined): Observable<PunchesDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/GetPunches?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPunches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPunches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchesDto[]>;
        }));
    }

    protected processGetPunches(response: HttpResponseBase): Observable<PunchesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PunchesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PunchesDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditBiometric(body: BiometricMasterDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/CreateOrEditBiometric";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditBiometric(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditBiometric(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditBiometric(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllBiometricList(): Observable<BiometricMasterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/GetAllBiometricList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBiometricList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBiometricList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BiometricMasterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BiometricMasterDto[]>;
        }));
    }

    protected processGetAllBiometricList(response: HttpResponseBase): Observable<BiometricMasterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BiometricMasterDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BiometricMasterDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBiometricDeviceById(id: number | undefined): Observable<BiometricMasterDto> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/GetBiometricDeviceById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBiometricDeviceById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBiometricDeviceById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BiometricMasterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BiometricMasterDto>;
        }));
    }

    protected processGetBiometricDeviceById(response: HttpResponseBase): Observable<BiometricMasterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BiometricMasterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BiometricMasterDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteBiometricDevice(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Attendances/DeleteBiometricDevice?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBiometricDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBiometricDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteBiometricDevice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class AuditLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param browserInfo (optional) 
     * @param hasException (optional) 
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAuditLogs(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, userName: string | null | undefined, serviceName: string | null | undefined, methodName: string | null | undefined, browserInfo: string | null | undefined, hasException: boolean | null | undefined, minExecutionDuration: number | null | undefined, maxExecutionDuration: number | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfAuditLogListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogs?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (userName !== undefined && userName !== null)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName !== undefined && serviceName !== null)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName !== undefined && methodName !== null)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo !== undefined && browserInfo !== null)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException !== undefined && hasException !== null)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration !== undefined && minExecutionDuration !== null)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration !== undefined && maxExecutionDuration !== null)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAuditLogListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAuditLogListDto>;
        }));
    }

    protected processGetAuditLogs(response: HttpResponseBase): Observable<PagedResultDtoOfAuditLogListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAuditLogListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAuditLogListDto>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param browserInfo (optional) 
     * @param hasException (optional) 
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAuditLogsToExcel(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, userName: string | null | undefined, serviceName: string | null | undefined, methodName: string | null | undefined, browserInfo: string | null | undefined, hasException: boolean | null | undefined, minExecutionDuration: number | null | undefined, maxExecutionDuration: number | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogsToExcel?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (userName !== undefined && userName !== null)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName !== undefined && serviceName !== null)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName !== undefined && methodName !== null)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo !== undefined && browserInfo !== null)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException !== undefined && hasException !== null)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration !== undefined && minExecutionDuration !== null)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration !== undefined && maxExecutionDuration !== null)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetAuditLogsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @return Success
     */
    getEntityHistoryObjectTypes(): Observable<NameValueDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityHistoryObjectTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityHistoryObjectTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityHistoryObjectTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameValueDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameValueDto[]>;
        }));
    }

    protected processGetEntityHistoryObjectTypes(response: HttpResponseBase): Observable<NameValueDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueDto[]>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param entityTypeFullName (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getEntityChanges(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, userName: string | null | undefined, entityTypeFullName: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfEntityChangeListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChanges?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (userName !== undefined && userName !== null)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName !== undefined && entityTypeFullName !== null)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
        }));
    }

    protected processGetEntityChanges(response: HttpResponseBase): Observable<PagedResultDtoOfEntityChangeListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEntityChangeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfEntityChangeListDto>(null as any);
    }

    /**
     * @param entityTypeFullName (optional) 
     * @param entityId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getEntityTypeChanges(entityTypeFullName: string | null | undefined, entityId: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfEntityChangeListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityTypeChanges?";
        if (entityTypeFullName !== undefined && entityTypeFullName !== null)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (entityId !== undefined && entityId !== null)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityTypeChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityTypeChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
        }));
    }

    protected processGetEntityTypeChanges(response: HttpResponseBase): Observable<PagedResultDtoOfEntityChangeListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEntityChangeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfEntityChangeListDto>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param entityTypeFullName (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getEntityChangesToExcel(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, userName: string | null | undefined, entityTypeFullName: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChangesToExcel?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (userName !== undefined && userName !== null)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName !== undefined && entityTypeFullName !== null)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityChangesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityChangesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetEntityChangesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param entityChangeId (optional) 
     * @return Success
     */
    getEntityPropertyChanges(entityChangeId: number | undefined): Observable<EntityPropertyChangeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityPropertyChanges?";
        if (entityChangeId === null)
            throw new Error("The parameter 'entityChangeId' cannot be null.");
        else if (entityChangeId !== undefined)
            url_ += "entityChangeId=" + encodeURIComponent("" + entityChangeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityPropertyChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityPropertyChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityPropertyChangeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityPropertyChangeDto[]>;
        }));
    }

    protected processGetEntityPropertyChanges(response: HttpResponseBase): Observable<EntityPropertyChangeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityPropertyChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EntityPropertyChangeDto[]>(null as any);
    }
}

@Injectable()
export class BackGroudSchedulerJobsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    checktenantSubscription(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BackGroudSchedulerJobs/ChecktenantSubscription";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChecktenantSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChecktenantSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChecktenantSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param requestedBy (optional) 
     * @param body (optional) 
     * @return Success
     */
    checkNextLevelApprovalIsSameAsCurrent(requestedBy: number | undefined, body: Workflow[] | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BackGroudSchedulerJobs/CheckNextLevelApprovalIsSameAsCurrent?";
        if (requestedBy === null)
            throw new Error("The parameter 'requestedBy' cannot be null.");
        else if (requestedBy !== undefined)
            url_ += "requestedBy=" + encodeURIComponent("" + requestedBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckNextLevelApprovalIsSameAsCurrent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckNextLevelApprovalIsSameAsCurrent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckNextLevelApprovalIsSameAsCurrent(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return Success
     */
    backGroudJobWorker(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BackGroudSchedulerJobs/BackGroudJobWorker";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBackGroudJobWorker(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBackGroudJobWorker(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBackGroudJobWorker(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class BankBranchDetailsesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param branchNameFilter (optional) 
     * @param ifsccodeFilter (optional) 
     * @param micrCodeFilter (optional) 
     * @param iBanNoFilter (optional) 
     * @param locationFilter (optional) 
     * @param addressFilter (optional) 
     * @param bankBranchBankNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, branchNameFilter: string | null | undefined, ifsccodeFilter: string | null | undefined, micrCodeFilter: string | null | undefined, iBanNoFilter: string | null | undefined, locationFilter: string | null | undefined, addressFilter: string | null | undefined, bankBranchBankNameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBankBranchDetailsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BankBranchDetailses/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (branchNameFilter !== undefined && branchNameFilter !== null)
            url_ += "BranchNameFilter=" + encodeURIComponent("" + branchNameFilter) + "&";
        if (ifsccodeFilter !== undefined && ifsccodeFilter !== null)
            url_ += "IfsccodeFilter=" + encodeURIComponent("" + ifsccodeFilter) + "&";
        if (micrCodeFilter !== undefined && micrCodeFilter !== null)
            url_ += "MicrCodeFilter=" + encodeURIComponent("" + micrCodeFilter) + "&";
        if (iBanNoFilter !== undefined && iBanNoFilter !== null)
            url_ += "IBanNoFilter=" + encodeURIComponent("" + iBanNoFilter) + "&";
        if (locationFilter !== undefined && locationFilter !== null)
            url_ += "LocationFilter=" + encodeURIComponent("" + locationFilter) + "&";
        if (addressFilter !== undefined && addressFilter !== null)
            url_ += "AddressFilter=" + encodeURIComponent("" + addressFilter) + "&";
        if (bankBranchBankNameFilter !== undefined && bankBranchBankNameFilter !== null)
            url_ += "BankBranchBankNameFilter=" + encodeURIComponent("" + bankBranchBankNameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetBankBranchDetailsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetBankBranchDetailsForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetBankBranchDetailsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBankBranchDetailsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBankBranchDetailsForViewDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    getAllBankDetails(filter: number | undefined): Observable<GetBankBranchDetailsForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BankBranchDetailses/getAllBankDetails?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBankDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBankDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBankBranchDetailsForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBankBranchDetailsForViewDto[]>;
        }));
    }

    protected processGetAllBankDetails(response: HttpResponseBase): Observable<GetBankBranchDetailsForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetBankBranchDetailsForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBankBranchDetailsForViewDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBankBranchDetailsForView(id: number | undefined): Observable<GetBankBranchDetailsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BankBranchDetailses/GetBankBranchDetailsForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBankBranchDetailsForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBankBranchDetailsForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBankBranchDetailsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBankBranchDetailsForViewDto>;
        }));
    }

    protected processGetBankBranchDetailsForView(response: HttpResponseBase): Observable<GetBankBranchDetailsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBankBranchDetailsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBankBranchDetailsForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBankBranchDetailsForEdit(id: number | undefined): Observable<GetBankBranchDetailsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/BankBranchDetailses/GetBankBranchDetailsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBankBranchDetailsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBankBranchDetailsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBankBranchDetailsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBankBranchDetailsForEditOutput>;
        }));
    }

    protected processGetBankBranchDetailsForEdit(response: HttpResponseBase): Observable<GetBankBranchDetailsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBankBranchDetailsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBankBranchDetailsForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditBankBranchDetailsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BankBranchDetailses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BankBranchDetailses/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param branchNameFilter (optional) 
     * @param ifsccodeFilter (optional) 
     * @param micrCodeFilter (optional) 
     * @param iBanNoFilter (optional) 
     * @param locationFilter (optional) 
     * @param addressFilter (optional) 
     * @param bankBranchBankNameFilter (optional) 
     * @return Success
     */
    getBankBranchDetailsesToExcel(filter: string | null | undefined, branchNameFilter: string | null | undefined, ifsccodeFilter: string | null | undefined, micrCodeFilter: string | null | undefined, iBanNoFilter: string | null | undefined, locationFilter: string | null | undefined, addressFilter: string | null | undefined, bankBranchBankNameFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/BankBranchDetailses/GetBankBranchDetailsesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (branchNameFilter !== undefined && branchNameFilter !== null)
            url_ += "BranchNameFilter=" + encodeURIComponent("" + branchNameFilter) + "&";
        if (ifsccodeFilter !== undefined && ifsccodeFilter !== null)
            url_ += "IfsccodeFilter=" + encodeURIComponent("" + ifsccodeFilter) + "&";
        if (micrCodeFilter !== undefined && micrCodeFilter !== null)
            url_ += "MicrCodeFilter=" + encodeURIComponent("" + micrCodeFilter) + "&";
        if (iBanNoFilter !== undefined && iBanNoFilter !== null)
            url_ += "IBanNoFilter=" + encodeURIComponent("" + iBanNoFilter) + "&";
        if (locationFilter !== undefined && locationFilter !== null)
            url_ += "LocationFilter=" + encodeURIComponent("" + locationFilter) + "&";
        if (addressFilter !== undefined && addressFilter !== null)
            url_ += "AddressFilter=" + encodeURIComponent("" + addressFilter) + "&";
        if (bankBranchBankNameFilter !== undefined && bankBranchBankNameFilter !== null)
            url_ += "BankBranchBankNameFilter=" + encodeURIComponent("" + bankBranchBankNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBankBranchDetailsesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBankBranchDetailsesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetBankBranchDetailsesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllBankBranchForTableDropdown(): Observable<BankBranchDetailsBankBranchLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BankBranchDetailses/GetAllBankBranchForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBankBranchForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBankBranchForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankBranchDetailsBankBranchLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankBranchDetailsBankBranchLookupTableDto[]>;
        }));
    }

    protected processGetAllBankBranchForTableDropdown(response: HttpResponseBase): Observable<BankBranchDetailsBankBranchLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BankBranchDetailsBankBranchLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BankBranchDetailsBankBranchLookupTableDto[]>(null as any);
    }
}

@Injectable()
export class BankBranchsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param bankNameFilter (optional) 
     * @param shortNameFilter (optional) 
     * @param addressFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, bankNameFilter: string | null | undefined, shortNameFilter: string | null | undefined, addressFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBankBranchForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BankBranchs/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (bankNameFilter !== undefined && bankNameFilter !== null)
            url_ += "BankNameFilter=" + encodeURIComponent("" + bankNameFilter) + "&";
        if (shortNameFilter !== undefined && shortNameFilter !== null)
            url_ += "ShortNameFilter=" + encodeURIComponent("" + shortNameFilter) + "&";
        if (addressFilter !== undefined && addressFilter !== null)
            url_ += "AddressFilter=" + encodeURIComponent("" + addressFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetBankBranchForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetBankBranchForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetBankBranchForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBankBranchForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBankBranchForViewDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllData(): Observable<GetBankBranchForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BankBranchs/GetAllData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBankBranchForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBankBranchForViewDto[]>;
        }));
    }

    protected processGetAllData(response: HttpResponseBase): Observable<GetBankBranchForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetBankBranchForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBankBranchForViewDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBankBranchForView(id: number | undefined): Observable<GetBankBranchForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BankBranchs/GetBankBranchForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBankBranchForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBankBranchForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBankBranchForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBankBranchForViewDto>;
        }));
    }

    protected processGetBankBranchForView(response: HttpResponseBase): Observable<GetBankBranchForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBankBranchForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBankBranchForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBankBranchForEdit(id: number | undefined): Observable<GetBankBranchForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/BankBranchs/GetBankBranchForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBankBranchForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBankBranchForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBankBranchForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBankBranchForEditOutput>;
        }));
    }

    protected processGetBankBranchForEdit(response: HttpResponseBase): Observable<GetBankBranchForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBankBranchForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBankBranchForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditBankBranchDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BankBranchs/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BankBranchs/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param bankNameFilter (optional) 
     * @param shortNameFilter (optional) 
     * @param addressFilter (optional) 
     * @return Success
     */
    getBankBranchsToExcel(filter: string | null | undefined, bankNameFilter: string | null | undefined, shortNameFilter: string | null | undefined, addressFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/BankBranchs/GetBankBranchsToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (bankNameFilter !== undefined && bankNameFilter !== null)
            url_ += "BankNameFilter=" + encodeURIComponent("" + bankNameFilter) + "&";
        if (shortNameFilter !== undefined && shortNameFilter !== null)
            url_ += "ShortNameFilter=" + encodeURIComponent("" + shortNameFilter) + "&";
        if (addressFilter !== undefined && addressFilter !== null)
            url_ += "AddressFilter=" + encodeURIComponent("" + addressFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBankBranchsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBankBranchsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetBankBranchsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class BirthdayWishesSettingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: BirthdayWishesSettingDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BirthdayWishesSetting/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatenewhires(body: NewHiresSettingDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BirthdayWishesSetting/Updatenewhires";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatenewhires(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatenewhires(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatenewhires(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getForEdit(): Observable<BirthdayWishesSettingDto> {
        let url_ = this.baseUrl + "/api/services/app/BirthdayWishesSetting/GetForEdit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BirthdayWishesSettingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BirthdayWishesSettingDto>;
        }));
    }

    protected processGetForEdit(response: HttpResponseBase): Observable<BirthdayWishesSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BirthdayWishesSettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BirthdayWishesSettingDto>(null as any);
    }

    /**
     * @return Success
     */
    getForEditNewHires(): Observable<NewHiresSettingDto> {
        let url_ = this.baseUrl + "/api/services/app/BirthdayWishesSetting/GetForEditNewHires";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForEditNewHires(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForEditNewHires(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NewHiresSettingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NewHiresSettingDto>;
        }));
    }

    protected processGetForEditNewHires(response: HttpResponseBase): Observable<NewHiresSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NewHiresSettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NewHiresSettingDto>(null as any);
    }
}

@Injectable()
export class CachingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllCaches(): Observable<ListResultDtoOfCacheDto> {
        let url_ = this.baseUrl + "/api/services/app/Caching/GetAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCaches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfCacheDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfCacheDto>;
        }));
    }

    protected processGetAllCaches(response: HttpResponseBase): Observable<ListResultDtoOfCacheDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfCacheDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfCacheDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    clearCache(body: EntityDtoOfString | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearCache";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    clearAllCaches(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearAllCaches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearAllCaches(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class CandidateDocumnetsesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxDocumentTypeIdFilter (optional) 
     * @param minDocumentTypeIdFilter (optional) 
     * @param nameFilter (optional) 
     * @param documentUrlFilter (optional) 
     * @param remarksFilter (optional) 
     * @param candidateNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxDocumentTypeIdFilter: number | null | undefined, minDocumentTypeIdFilter: number | null | undefined, nameFilter: string | null | undefined, documentUrlFilter: string | null | undefined, remarksFilter: string | null | undefined, candidateNameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCandidateDocumnetsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidateDocumnetses/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxDocumentTypeIdFilter !== undefined && maxDocumentTypeIdFilter !== null)
            url_ += "MaxDocumentTypeIdFilter=" + encodeURIComponent("" + maxDocumentTypeIdFilter) + "&";
        if (minDocumentTypeIdFilter !== undefined && minDocumentTypeIdFilter !== null)
            url_ += "MinDocumentTypeIdFilter=" + encodeURIComponent("" + minDocumentTypeIdFilter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (documentUrlFilter !== undefined && documentUrlFilter !== null)
            url_ += "DocumentUrlFilter=" + encodeURIComponent("" + documentUrlFilter) + "&";
        if (remarksFilter !== undefined && remarksFilter !== null)
            url_ += "RemarksFilter=" + encodeURIComponent("" + remarksFilter) + "&";
        if (candidateNameFilter !== undefined && candidateNameFilter !== null)
            url_ += "CandidateNameFilter=" + encodeURIComponent("" + candidateNameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetCandidateDocumnetsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetCandidateDocumnetsForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCandidateDocumnetsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCandidateDocumnetsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCandidateDocumnetsForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCandidateDocumnetsForView(id: number | undefined): Observable<GetCandidateDocumnetsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidateDocumnetses/GetCandidateDocumnetsForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateDocumnetsForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateDocumnetsForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCandidateDocumnetsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCandidateDocumnetsForViewDto>;
        }));
    }

    protected processGetCandidateDocumnetsForView(response: HttpResponseBase): Observable<GetCandidateDocumnetsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCandidateDocumnetsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCandidateDocumnetsForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCandidateDocumnetsForEdit(id: number | undefined): Observable<GetCandidateDocumnetsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CandidateDocumnetses/GetCandidateDocumnetsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateDocumnetsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateDocumnetsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCandidateDocumnetsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCandidateDocumnetsForEditOutput>;
        }));
    }

    protected processGetCandidateDocumnetsForEdit(response: HttpResponseBase): Observable<GetCandidateDocumnetsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCandidateDocumnetsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCandidateDocumnetsForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditCandidateDocumnetsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CandidateDocumnetses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CandidateDocumnetses/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxDocumentTypeIdFilter (optional) 
     * @param minDocumentTypeIdFilter (optional) 
     * @param nameFilter (optional) 
     * @param documentUrlFilter (optional) 
     * @param remarksFilter (optional) 
     * @param candidateNameFilter (optional) 
     * @return Success
     */
    getCandidateDocumnetsesToExcel(filter: string | null | undefined, maxDocumentTypeIdFilter: number | null | undefined, minDocumentTypeIdFilter: number | null | undefined, nameFilter: string | null | undefined, documentUrlFilter: string | null | undefined, remarksFilter: string | null | undefined, candidateNameFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidateDocumnetses/GetCandidateDocumnetsesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxDocumentTypeIdFilter !== undefined && maxDocumentTypeIdFilter !== null)
            url_ += "MaxDocumentTypeIdFilter=" + encodeURIComponent("" + maxDocumentTypeIdFilter) + "&";
        if (minDocumentTypeIdFilter !== undefined && minDocumentTypeIdFilter !== null)
            url_ += "MinDocumentTypeIdFilter=" + encodeURIComponent("" + minDocumentTypeIdFilter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (documentUrlFilter !== undefined && documentUrlFilter !== null)
            url_ += "DocumentUrlFilter=" + encodeURIComponent("" + documentUrlFilter) + "&";
        if (remarksFilter !== undefined && remarksFilter !== null)
            url_ += "RemarksFilter=" + encodeURIComponent("" + remarksFilter) + "&";
        if (candidateNameFilter !== undefined && candidateNameFilter !== null)
            url_ += "CandidateNameFilter=" + encodeURIComponent("" + candidateNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateDocumnetsesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateDocumnetsesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetCandidateDocumnetsesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllCandidateForTableDropdown(): Observable<CandidateDocumnetsCandidateLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CandidateDocumnetses/GetAllCandidateForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCandidateForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCandidateForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateDocumnetsCandidateLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateDocumnetsCandidateLookupTableDto[]>;
        }));
    }

    protected processGetAllCandidateForTableDropdown(response: HttpResponseBase): Observable<CandidateDocumnetsCandidateLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CandidateDocumnetsCandidateLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CandidateDocumnetsCandidateLookupTableDto[]>(null as any);
    }
}

@Injectable()
export class CandidateinterviewDetailsesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxRoundIdFilter (optional) 
     * @param minRoundIdFilter (optional) 
     * @param maxInterviwerIdFilter (optional) 
     * @param minInterviwerIdFilter (optional) 
     * @param maxInterviwerDateFilter (optional) 
     * @param minInterviwerDateFilter (optional) 
     * @param feedbackFilter (optional) 
     * @param statusFilter (optional) 
     * @param candidateNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxRoundIdFilter: number | null | undefined, minRoundIdFilter: number | null | undefined, maxInterviwerIdFilter: number | null | undefined, minInterviwerIdFilter: number | null | undefined, maxInterviwerDateFilter: moment.Moment | null | undefined, minInterviwerDateFilter: moment.Moment | null | undefined, feedbackFilter: string | null | undefined, statusFilter: string | null | undefined, candidateNameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCandidateinterviewDetailsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidateinterviewDetailses/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxRoundIdFilter !== undefined && maxRoundIdFilter !== null)
            url_ += "MaxRoundIdFilter=" + encodeURIComponent("" + maxRoundIdFilter) + "&";
        if (minRoundIdFilter !== undefined && minRoundIdFilter !== null)
            url_ += "MinRoundIdFilter=" + encodeURIComponent("" + minRoundIdFilter) + "&";
        if (maxInterviwerIdFilter !== undefined && maxInterviwerIdFilter !== null)
            url_ += "MaxInterviwerIdFilter=" + encodeURIComponent("" + maxInterviwerIdFilter) + "&";
        if (minInterviwerIdFilter !== undefined && minInterviwerIdFilter !== null)
            url_ += "MinInterviwerIdFilter=" + encodeURIComponent("" + minInterviwerIdFilter) + "&";
        if (maxInterviwerDateFilter !== undefined && maxInterviwerDateFilter !== null)
            url_ += "MaxInterviwerDateFilter=" + encodeURIComponent(maxInterviwerDateFilter ? "" + maxInterviwerDateFilter.toISOString() : "") + "&";
        if (minInterviwerDateFilter !== undefined && minInterviwerDateFilter !== null)
            url_ += "MinInterviwerDateFilter=" + encodeURIComponent(minInterviwerDateFilter ? "" + minInterviwerDateFilter.toISOString() : "") + "&";
        if (feedbackFilter !== undefined && feedbackFilter !== null)
            url_ += "FeedbackFilter=" + encodeURIComponent("" + feedbackFilter) + "&";
        if (statusFilter !== undefined && statusFilter !== null)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (candidateNameFilter !== undefined && candidateNameFilter !== null)
            url_ += "CandidateNameFilter=" + encodeURIComponent("" + candidateNameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetCandidateinterviewDetailsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetCandidateinterviewDetailsForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCandidateinterviewDetailsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCandidateinterviewDetailsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCandidateinterviewDetailsForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCandidateinterviewDetailsForView(id: number | undefined): Observable<GetCandidateinterviewDetailsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidateinterviewDetailses/GetCandidateinterviewDetailsForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateinterviewDetailsForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateinterviewDetailsForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCandidateinterviewDetailsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCandidateinterviewDetailsForViewDto>;
        }));
    }

    protected processGetCandidateinterviewDetailsForView(response: HttpResponseBase): Observable<GetCandidateinterviewDetailsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCandidateinterviewDetailsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCandidateinterviewDetailsForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCandidateinterviewDetailsForEdit(id: number | undefined): Observable<GetCandidateinterviewDetailsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CandidateinterviewDetailses/GetCandidateinterviewDetailsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateinterviewDetailsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateinterviewDetailsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCandidateinterviewDetailsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCandidateinterviewDetailsForEditOutput>;
        }));
    }

    protected processGetCandidateinterviewDetailsForEdit(response: HttpResponseBase): Observable<GetCandidateinterviewDetailsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCandidateinterviewDetailsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCandidateinterviewDetailsForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditCandidateinterviewDetailsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CandidateinterviewDetailses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CandidateinterviewDetailses/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxRoundIdFilter (optional) 
     * @param minRoundIdFilter (optional) 
     * @param maxInterviwerIdFilter (optional) 
     * @param minInterviwerIdFilter (optional) 
     * @param maxInterviwerDateFilter (optional) 
     * @param minInterviwerDateFilter (optional) 
     * @param feedbackFilter (optional) 
     * @param statusFilter (optional) 
     * @param candidateNameFilter (optional) 
     * @return Success
     */
    getCandidateinterviewDetailsesToExcel(filter: string | null | undefined, maxRoundIdFilter: number | null | undefined, minRoundIdFilter: number | null | undefined, maxInterviwerIdFilter: number | null | undefined, minInterviwerIdFilter: number | null | undefined, maxInterviwerDateFilter: moment.Moment | null | undefined, minInterviwerDateFilter: moment.Moment | null | undefined, feedbackFilter: string | null | undefined, statusFilter: string | null | undefined, candidateNameFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidateinterviewDetailses/GetCandidateinterviewDetailsesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxRoundIdFilter !== undefined && maxRoundIdFilter !== null)
            url_ += "MaxRoundIdFilter=" + encodeURIComponent("" + maxRoundIdFilter) + "&";
        if (minRoundIdFilter !== undefined && minRoundIdFilter !== null)
            url_ += "MinRoundIdFilter=" + encodeURIComponent("" + minRoundIdFilter) + "&";
        if (maxInterviwerIdFilter !== undefined && maxInterviwerIdFilter !== null)
            url_ += "MaxInterviwerIdFilter=" + encodeURIComponent("" + maxInterviwerIdFilter) + "&";
        if (minInterviwerIdFilter !== undefined && minInterviwerIdFilter !== null)
            url_ += "MinInterviwerIdFilter=" + encodeURIComponent("" + minInterviwerIdFilter) + "&";
        if (maxInterviwerDateFilter !== undefined && maxInterviwerDateFilter !== null)
            url_ += "MaxInterviwerDateFilter=" + encodeURIComponent(maxInterviwerDateFilter ? "" + maxInterviwerDateFilter.toISOString() : "") + "&";
        if (minInterviwerDateFilter !== undefined && minInterviwerDateFilter !== null)
            url_ += "MinInterviwerDateFilter=" + encodeURIComponent(minInterviwerDateFilter ? "" + minInterviwerDateFilter.toISOString() : "") + "&";
        if (feedbackFilter !== undefined && feedbackFilter !== null)
            url_ += "FeedbackFilter=" + encodeURIComponent("" + feedbackFilter) + "&";
        if (statusFilter !== undefined && statusFilter !== null)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (candidateNameFilter !== undefined && candidateNameFilter !== null)
            url_ += "CandidateNameFilter=" + encodeURIComponent("" + candidateNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateinterviewDetailsesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateinterviewDetailsesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetCandidateinterviewDetailsesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllCandidateForTableDropdown(): Observable<CandidateinterviewDetailsCandidateLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CandidateinterviewDetailses/GetAllCandidateForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCandidateForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCandidateForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateinterviewDetailsCandidateLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateinterviewDetailsCandidateLookupTableDto[]>;
        }));
    }

    protected processGetAllCandidateForTableDropdown(response: HttpResponseBase): Observable<CandidateinterviewDetailsCandidateLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CandidateinterviewDetailsCandidateLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CandidateinterviewDetailsCandidateLookupTableDto[]>(null as any);
    }
}

@Injectable()
export class CandidateQualificationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param qualificationFilter (optional) 
     * @param candidateNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, qualificationFilter: string | null | undefined, candidateNameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCandidateQualificationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidateQualifications/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (qualificationFilter !== undefined && qualificationFilter !== null)
            url_ += "QualificationFilter=" + encodeURIComponent("" + qualificationFilter) + "&";
        if (candidateNameFilter !== undefined && candidateNameFilter !== null)
            url_ += "CandidateNameFilter=" + encodeURIComponent("" + candidateNameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetCandidateQualificationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetCandidateQualificationForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCandidateQualificationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCandidateQualificationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCandidateQualificationForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCandidateQualificationForView(id: number | undefined): Observable<GetCandidateQualificationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidateQualifications/GetCandidateQualificationForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateQualificationForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateQualificationForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCandidateQualificationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCandidateQualificationForViewDto>;
        }));
    }

    protected processGetCandidateQualificationForView(response: HttpResponseBase): Observable<GetCandidateQualificationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCandidateQualificationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCandidateQualificationForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCandidateQualificationForEdit(id: number | undefined): Observable<GetCandidateQualificationForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CandidateQualifications/GetCandidateQualificationForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateQualificationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateQualificationForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCandidateQualificationForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCandidateQualificationForEditOutput>;
        }));
    }

    protected processGetCandidateQualificationForEdit(response: HttpResponseBase): Observable<GetCandidateQualificationForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCandidateQualificationForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCandidateQualificationForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditCandidateQualificationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CandidateQualifications/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CandidateQualifications/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param qualificationFilter (optional) 
     * @param candidateNameFilter (optional) 
     * @return Success
     */
    getCandidateQualificationsToExcel(filter: string | null | undefined, qualificationFilter: string | null | undefined, candidateNameFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidateQualifications/GetCandidateQualificationsToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (qualificationFilter !== undefined && qualificationFilter !== null)
            url_ += "QualificationFilter=" + encodeURIComponent("" + qualificationFilter) + "&";
        if (candidateNameFilter !== undefined && candidateNameFilter !== null)
            url_ += "CandidateNameFilter=" + encodeURIComponent("" + candidateNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateQualificationsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateQualificationsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetCandidateQualificationsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCandidateForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfCandidateQualificationCandidateLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/CandidateQualifications/GetAllCandidateForLookupTable?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCandidateForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCandidateForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCandidateQualificationCandidateLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCandidateQualificationCandidateLookupTableDto>;
        }));
    }

    protected processGetAllCandidateForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfCandidateQualificationCandidateLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCandidateQualificationCandidateLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCandidateQualificationCandidateLookupTableDto>(null as any);
    }
}

@Injectable()
export class CandidatesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param fatherNameFilter (optional) 
     * @param maxContactNumberFilter (optional) 
     * @param minContactNumberFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, fatherNameFilter: string | null | undefined, maxContactNumberFilter: number | null | undefined, minContactNumberFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCandidateForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Candidates/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (fatherNameFilter !== undefined && fatherNameFilter !== null)
            url_ += "FatherNameFilter=" + encodeURIComponent("" + fatherNameFilter) + "&";
        if (maxContactNumberFilter !== undefined && maxContactNumberFilter !== null)
            url_ += "MaxContactNumberFilter=" + encodeURIComponent("" + maxContactNumberFilter) + "&";
        if (minContactNumberFilter !== undefined && minContactNumberFilter !== null)
            url_ += "MinContactNumberFilter=" + encodeURIComponent("" + minContactNumberFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetCandidateForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetCandidateForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCandidateForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCandidateForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCandidateForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCandidateForView(id: number | undefined): Observable<GetCandidateForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Candidates/GetCandidateForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCandidateForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCandidateForViewDto>;
        }));
    }

    protected processGetCandidateForView(response: HttpResponseBase): Observable<GetCandidateForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCandidateForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCandidateForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCandidateForEdit(id: number | undefined): Observable<GetCandidateForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Candidates/GetCandidateForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCandidateForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCandidateForEditOutput>;
        }));
    }

    protected processGetCandidateForEdit(response: HttpResponseBase): Observable<GetCandidateForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCandidateForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCandidateForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditCandidateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Candidates/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Candidates/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param fatherNameFilter (optional) 
     * @param maxContactNumberFilter (optional) 
     * @param minContactNumberFilter (optional) 
     * @return Success
     */
    getCandidatesToExcel(filter: string | null | undefined, nameFilter: string | null | undefined, fatherNameFilter: string | null | undefined, maxContactNumberFilter: number | null | undefined, minContactNumberFilter: number | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Candidates/GetCandidatesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (fatherNameFilter !== undefined && fatherNameFilter !== null)
            url_ += "FatherNameFilter=" + encodeURIComponent("" + fatherNameFilter) + "&";
        if (maxContactNumberFilter !== undefined && maxContactNumberFilter !== null)
            url_ += "MaxContactNumberFilter=" + encodeURIComponent("" + maxContactNumberFilter) + "&";
        if (minContactNumberFilter !== undefined && minContactNumberFilter !== null)
            url_ += "MinContactNumberFilter=" + encodeURIComponent("" + minContactNumberFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidatesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidatesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetCandidatesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @return Success
     */
    getJobOpeing(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/Candidates/GetJobOpeing";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobOpeing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobOpeing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetJobOpeing(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param jobid (optional) 
     * @return Success
     */
    getAllJobRoundlist(jobid: number | undefined): Observable<RoundInterview[]> {
        let url_ = this.baseUrl + "/api/services/app/Candidates/GetAllJobRoundlist?";
        if (jobid === null)
            throw new Error("The parameter 'jobid' cannot be null.");
        else if (jobid !== undefined)
            url_ += "jobid=" + encodeURIComponent("" + jobid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllJobRoundlist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllJobRoundlist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoundInterview[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoundInterview[]>;
        }));
    }

    protected processGetAllJobRoundlist(response: HttpResponseBase): Observable<RoundInterview[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoundInterview.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoundInterview[]>(null as any);
    }

    /**
     * @param jobId (optional) 
     * @return Success
     */
    getMatchedCandidatesByJob(jobId: number | undefined): Observable<CandidateMatchListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Candidates/GetMatchedCandidatesByJob?";
        if (jobId === null)
            throw new Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMatchedCandidatesByJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMatchedCandidatesByJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateMatchListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateMatchListDto[]>;
        }));
    }

    protected processGetMatchedCandidatesByJob(response: HttpResponseBase): Observable<CandidateMatchListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CandidateMatchListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CandidateMatchListDto[]>(null as any);
    }

    /**
     * @param jobId (optional) 
     * @return Success
     */
    findCandidatesForJob(jobId: number | undefined): Observable<CandidateMatchDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Candidates/FindCandidatesForJob?";
        if (jobId === null)
            throw new Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindCandidatesForJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindCandidatesForJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateMatchDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateMatchDto[]>;
        }));
    }

    protected processFindCandidatesForJob(response: HttpResponseBase): Observable<CandidateMatchDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CandidateMatchDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CandidateMatchDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    scheduleInterview(body: ScheduleInterviewInput | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Candidates/ScheduleInterview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleInterview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleInterview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processScheduleInterview(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param token (optional) 
     * @return Success
     */
    getInterviewByToken(token: string | null | undefined): Observable<RecruitmentInterviewDto> {
        let url_ = this.baseUrl + "/api/services/app/Candidates/GetInterviewByToken?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInterviewByToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInterviewByToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecruitmentInterviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecruitmentInterviewDto>;
        }));
    }

    protected processGetInterviewByToken(response: HttpResponseBase): Observable<RecruitmentInterviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecruitmentInterviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RecruitmentInterviewDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findCandidatesForJobs(body: number[] | null | undefined): Observable<{ [key: string]: CandidateMatchDto[]; }> {
        let url_ = this.baseUrl + "/api/services/app/Candidates/FindCandidatesForJobs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindCandidatesForJobs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindCandidatesForJobs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: CandidateMatchDto[]; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: CandidateMatchDto[]; }>;
        }));
    }

    protected processFindCandidatesForJobs(response: HttpResponseBase): Observable<{ [key: string]: CandidateMatchDto[]; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] ? resultData200[key].map((i: any) => CandidateMatchDto.fromJS(i)) : [];
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ [key: string]: CandidateMatchDto[]; }>(null as any);
    }

    /**
     * @param token (optional) 
     * @return Success
     */
    startInterviewByToken(token: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Candidates/StartInterviewByToken?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartInterviewByToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartInterviewByToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStartInterviewByToken(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param token (optional) 
     * @return Success
     */
    endInterviewByToken(token: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Candidates/EndInterviewByToken?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEndInterviewByToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEndInterviewByToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEndInterviewByToken(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    processBeyondPresenceWebhook(body: BeyondPresenceWebhookDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Candidates/ProcessBeyondPresenceWebhook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessBeyondPresenceWebhook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessBeyondPresenceWebhook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processProcessBeyondPresenceWebhook(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param token (optional) 
     * @return Success
     */
    finalizeInterviewByToken(token: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Candidates/FinalizeInterviewByToken?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalizeInterviewByToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalizeInterviewByToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinalizeInterviewByToken(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getInterviewResult(id: number | undefined): Observable<RecruitmentInterviewResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Candidates/GetInterviewResult?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInterviewResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInterviewResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecruitmentInterviewResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecruitmentInterviewResultDto>;
        }));
    }

    protected processGetInterviewResult(response: HttpResponseBase): Observable<RecruitmentInterviewResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecruitmentInterviewResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RecruitmentInterviewResultDto>(null as any);
    }
}

@Injectable()
export class ChatServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUserChatFriendsWithSettings(): Observable<GetUserChatFriendsWithSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatFriendsWithSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserChatFriendsWithSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserChatFriendsWithSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserChatFriendsWithSettingsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserChatFriendsWithSettingsOutput>;
        }));
    }

    protected processGetUserChatFriendsWithSettings(response: HttpResponseBase): Observable<GetUserChatFriendsWithSettingsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserChatFriendsWithSettingsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserChatFriendsWithSettingsOutput>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param minMessageId (optional) 
     * @return Success
     */
    getUserChatMessages(tenantId: number | null | undefined, userId: number | undefined, minMessageId: number | null | undefined): Observable<ListResultDtoOfChatMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatMessages?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (minMessageId !== undefined && minMessageId !== null)
            url_ += "MinMessageId=" + encodeURIComponent("" + minMessageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserChatMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserChatMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfChatMessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfChatMessageDto>;
        }));
    }

    protected processGetUserChatMessages(response: HttpResponseBase): Observable<ListResultDtoOfChatMessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfChatMessageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfChatMessageDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    markAllUnreadMessagesOfUserAsRead(body: MarkAllUnreadMessagesOfUserAsReadInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Chat/MarkAllUnreadMessagesOfUserAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAllUnreadMessagesOfUserAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAllUnreadMessagesOfUserAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkAllUnreadMessagesOfUserAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class CitiesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param stateNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, stateNameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Cities/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (stateNameFilter !== undefined && stateNameFilter !== null)
            url_ += "StateNameFilter=" + encodeURIComponent("" + stateNameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetCityForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetCityForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCityForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCityForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCityForView(id: number | undefined): Observable<GetCityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Cities/GetCityForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCityForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCityForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCityForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCityForViewDto>;
        }));
    }

    protected processGetCityForView(response: HttpResponseBase): Observable<GetCityForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCityForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCityForEdit(id: number | undefined): Observable<GetCityForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Cities/GetCityForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCityForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCityForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCityForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCityForEditOutput>;
        }));
    }

    protected processGetCityForEdit(response: HttpResponseBase): Observable<GetCityForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCityForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCityForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditCityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Cities/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Cities/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param stateNameFilter (optional) 
     * @return Success
     */
    getCitiesToExcel(filter: string | null | undefined, nameFilter: string | null | undefined, stateNameFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Cities/GetCitiesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (stateNameFilter !== undefined && stateNameFilter !== null)
            url_ += "StateNameFilter=" + encodeURIComponent("" + stateNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCitiesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCitiesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetCitiesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllStateForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfCityStateLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Cities/GetAllStateForLookupTable?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStateForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStateForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCityStateLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCityStateLookupTableDto>;
        }));
    }

    protected processGetAllStateForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfCityStateLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCityStateLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCityStateLookupTableDto>(null as any);
    }
}

@Injectable()
export class ClearanceTaskListAppServicesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param employeeid (optional) 
     * @return Success
     */
    getStatusTaks(employeeid: number | undefined): Observable<GetstatusListForView[]> {
        let url_ = this.baseUrl + "/api/services/app/ClearanceTaskListAppServices/GetStatusTaks?";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatusTaks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatusTaks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetstatusListForView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetstatusListForView[]>;
        }));
    }

    protected processGetStatusTaks(response: HttpResponseBase): Observable<GetstatusListForView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetstatusListForView.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetstatusListForView[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdittaskstatus(body: CreateorEditStatusTask | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ClearanceTaskListAppServices/CreateOrEdittaskstatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdittaskstatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdittaskstatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdittaskstatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param employeeid (optional) 
     * @return Success
     */
    getTaskName(employeeid: number | undefined): Observable<ClearanceTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClearanceTaskListAppServices/GetTaskName?";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClearanceTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClearanceTaskDto[]>;
        }));
    }

    protected processGetTaskName(response: HttpResponseBase): Observable<ClearanceTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClearanceTaskDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClearanceTaskDto[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetClearanceListForView> {
        let url_ = this.baseUrl + "/api/services/app/ClearanceTaskListAppServices/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetClearanceListForView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetClearanceListForView>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetClearanceListForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetClearanceListForView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetClearanceListForView>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEndListForView(id: number | undefined): Observable<GetClearanceListForView> {
        let url_ = this.baseUrl + "/api/services/app/ClearanceTaskListAppServices/GetEndListForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEndListForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEndListForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetClearanceListForView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetClearanceListForView>;
        }));
    }

    protected processGetEndListForView(response: HttpResponseBase): Observable<GetClearanceListForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetClearanceListForView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetClearanceListForView>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDivisionForEdit(id: number | undefined): Observable<CreateOrEditClearanceTaskList> {
        let url_ = this.baseUrl + "/api/services/app/ClearanceTaskListAppServices/GetDivisionForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDivisionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDivisionForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditClearanceTaskList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditClearanceTaskList>;
        }));
    }

    protected processGetDivisionForEdit(response: HttpResponseBase): Observable<CreateOrEditClearanceTaskList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditClearanceTaskList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditClearanceTaskList>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditClearanceTaskList | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ClearanceTaskListAppServices/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ClearanceTaskListAppServices/delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class CommonLookupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param onlyFreeItems (optional) 
     * @return Success
     */
    getEditionsForCombobox(onlyFreeItems: boolean | undefined): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetEditionsForCombobox?";
        if (onlyFreeItems === null)
            throw new Error("The parameter 'onlyFreeItems' cannot be null.");
        else if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionsForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionsForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>;
        }));
    }

    protected processGetEditionsForCombobox(response: HttpResponseBase): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfSubscribableEditionComboboxItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfSubscribableEditionComboboxItemDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findUsers(body: FindUsersInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
        }));
    }

    protected processFindUsers(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNameValueDto>(null as any);
    }

    /**
     * @return Success
     */
    getDefaultEditionName(): Observable<GetDefaultEditionNameOutput> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetDefaultEditionName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultEditionName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultEditionName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDefaultEditionNameOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDefaultEditionNameOutput>;
        }));
    }

    protected processGetDefaultEditionName(response: HttpResponseBase): Observable<GetDefaultEditionNameOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDefaultEditionNameOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDefaultEditionNameOutput>(null as any);
    }
}

@Injectable()
export class CompanyDetailServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getTenencyDetailsList(): Observable<TenancyDetailsDetailsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CompanyDetail/GetTenencyDetailsList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenencyDetailsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenencyDetailsList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenancyDetailsDetailsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenancyDetailsDetailsDto[]>;
        }));
    }

    protected processGetTenencyDetailsList(response: HttpResponseBase): Observable<TenancyDetailsDetailsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenancyDetailsDetailsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenancyDetailsDetailsDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllDepartemntys(): Observable<GetDepartmentsForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CompanyDetail/GetAllDepartemntys";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDepartemntys(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDepartemntys(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDepartmentsForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDepartmentsForViewDto[]>;
        }));
    }

    protected processGetAllDepartemntys(response: HttpResponseBase): Observable<GetDepartmentsForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetDepartmentsForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDepartmentsForViewDto[]>(null as any);
    }

    /**
     * @return Success
     */
    generatePdf(): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CompanyDetail/GeneratePdf";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneratePdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratePdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGeneratePdf(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }
}

@Injectable()
export class ContratorsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param streetAddressFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, streetAddressFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetContratorForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Contrators/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (streetAddressFilter !== undefined && streetAddressFilter !== null)
            url_ += "StreetAddressFilter=" + encodeURIComponent("" + streetAddressFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetContratorForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetContratorForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetContratorForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetContratorForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetContratorForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getContratorForView(id: number | undefined): Observable<GetContratorForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Contrators/GetContratorForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContratorForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContratorForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetContratorForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetContratorForViewDto>;
        }));
    }

    protected processGetContratorForView(response: HttpResponseBase): Observable<GetContratorForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetContratorForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetContratorForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getContratorForEdit(id: number | undefined): Observable<GetContratorForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Contrators/GetContratorForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContratorForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContratorForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetContratorForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetContratorForEditOutput>;
        }));
    }

    protected processGetContratorForEdit(response: HttpResponseBase): Observable<GetContratorForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetContratorForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetContratorForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditContratorDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Contrators/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Contrators/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param streetAddressFilter (optional) 
     * @return Success
     */
    getContratorsToExcel(filter: string | null | undefined, nameFilter: string | null | undefined, streetAddressFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Contrators/GetContratorsToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (streetAddressFilter !== undefined && streetAddressFilter !== null)
            url_ += "StreetAddressFilter=" + encodeURIComponent("" + streetAddressFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContratorsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContratorsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetContratorsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param contractorid (optional) 
     * @return Success
     */
    getContractorBill(monthYear: string | null | undefined, contractorid: number | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/Contrators/GetContractorBill?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (contractorid === null)
            throw new Error("The parameter 'contractorid' cannot be null.");
        else if (contractorid !== undefined)
            url_ += "contractorid=" + encodeURIComponent("" + contractorid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContractorBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContractorBill(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetContractorBill(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }
}

@Injectable()
export class CountriesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param nationalityFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, nationalityFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCountryForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Countries/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (nationalityFilter !== undefined && nationalityFilter !== null)
            url_ += "NationalityFilter=" + encodeURIComponent("" + nationalityFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetCountryForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetCountryForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCountryForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCountryForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCountryForViewDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllWizards(): Observable<GetCountryForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Countries/GetAllWizards";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWizards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWizards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCountryForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCountryForViewDto[]>;
        }));
    }

    protected processGetAllWizards(response: HttpResponseBase): Observable<GetCountryForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetCountryForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCountryForViewDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCountryForView(id: number | undefined): Observable<GetCountryForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Countries/GetCountryForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountryForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountryForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCountryForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCountryForViewDto>;
        }));
    }

    protected processGetCountryForView(response: HttpResponseBase): Observable<GetCountryForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCountryForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCountryForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCountryForEdit(id: number | undefined): Observable<GetCountryForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Countries/GetCountryForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountryForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountryForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCountryForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCountryForEditOutput>;
        }));
    }

    protected processGetCountryForEdit(response: HttpResponseBase): Observable<GetCountryForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCountryForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCountryForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditCountryDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Countries/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Countries/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param nationalityFilter (optional) 
     * @return Success
     */
    getCountriesToExcel(filter: string | null | undefined, nameFilter: string | null | undefined, nationalityFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Countries/GetCountriesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (nationalityFilter !== undefined && nationalityFilter !== null)
            url_ += "NationalityFilter=" + encodeURIComponent("" + nationalityFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountriesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountriesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetCountriesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class CustomerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateCustomer(body: Customer | undefined): Observable<GetCustomerDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/CreateOrUpdateCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCustomerDto>;
        }));
    }

    protected processCreateOrUpdateCustomer(response: HttpResponseBase): Observable<GetCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCustomerDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCustomerForEdit(id: number | undefined): Observable<Customer> {
        let url_ = this.baseUrl + "/api/services/app/Customer/GetCustomerForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Customer>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Customer>;
        }));
    }

    protected processGetCustomerForEdit(response: HttpResponseBase): Observable<Customer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Customer.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Customer>(null as any);
    }

    /**
     * @param customer (optional) 
     * @return Success
     */
    getCustomersForWeb(customer: string | null | undefined): Observable<GetCustomerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Customer/GetCustomersForWeb?";
        if (customer !== undefined && customer !== null)
            url_ += "Customer=" + encodeURIComponent("" + customer) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomersForWeb(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomersForWeb(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCustomerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCustomerDto[]>;
        }));
    }

    protected processGetCustomersForWeb(response: HttpResponseBase): Observable<GetCustomerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetCustomerDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCustomerDto[]>(null as any);
    }

    /**
     * @param customer (optional) 
     * @return Success
     */
    getCustomers(customer: string | null | undefined): Observable<GetCustomerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Customer/GetCustomers?";
        if (customer !== undefined && customer !== null)
            url_ += "Customer=" + encodeURIComponent("" + customer) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCustomerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCustomerDto[]>;
        }));
    }

    protected processGetCustomers(response: HttpResponseBase): Observable<GetCustomerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetCustomerDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCustomerDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteCustomer(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Customer/DeleteCustomer?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCustomer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCustomerForMobileApp(body: Customer | undefined): Observable<Customer> {
        let url_ = this.baseUrl + "/api/services/app/Customer/CreateCustomerForMobileApp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCustomerForMobileApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCustomerForMobileApp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Customer>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Customer>;
        }));
    }

    protected processCreateCustomerForMobileApp(response: HttpResponseBase): Observable<Customer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Customer.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Customer>(null as any);
    }
}

@Injectable()
export class CustomerMappingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getClient(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMapping/GetClient";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetClient(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    getEditDropdown(employeeId: number | undefined): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMapping/GetEditDropdown?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetEditDropdown(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateOrEditCustomerMappingDtos | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMapping/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCustomerMappingForEdit(id: number | undefined): Observable<GetCustomerMappingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMapping/GetCustomerMappingForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerMappingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerMappingForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCustomerMappingForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCustomerMappingForEditOutput>;
        }));
    }

    protected processGetCustomerMappingForEdit(response: HttpResponseBase): Observable<GetCustomerMappingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCustomerMappingForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCustomerMappingForEditOutput>(null as any);
    }

    /**
     * @param employeeNameFilter (optional) 
     * @return Success
     */
    getAll(employeeNameFilter: string | null | undefined): Observable<CreateOrEditCustomerMappingDtos[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMapping/GetAll?";
        if (employeeNameFilter !== undefined && employeeNameFilter !== null)
            url_ += "employeeNameFilter=" + encodeURIComponent("" + employeeNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditCustomerMappingDtos[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditCustomerMappingDtos[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CreateOrEditCustomerMappingDtos[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditCustomerMappingDtos.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditCustomerMappingDtos[]>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    getCustomerMappingsByEmployeeId(employeeId: number | undefined): Observable<CustomerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMapping/GetCustomerMappingsByEmployeeId?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerMappingsByEmployeeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerMappingsByEmployeeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerDto[]>;
        }));
    }

    protected processGetCustomerMappingsByEmployeeId(response: HttpResponseBase): Observable<CustomerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto[]>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    deleteCustomerMappingsByEmployeeId(employeeId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMapping/DeleteCustomerMappingsByEmployeeId?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCustomerMappingsByEmployeeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustomerMappingsByEmployeeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCustomerMappingsByEmployeeId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined): Observable<CreateOrEditCustomerMappingDtos> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMapping/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditCustomerMappingDtos>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditCustomerMappingDtos>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<CreateOrEditCustomerMappingDtos> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditCustomerMappingDtos.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditCustomerMappingDtos>(null as any);
    }

    /**
     * @param fullName (optional) 
     * @param customerName (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getEmployeeVisitDetail(fullName: string | null | undefined, customerName: string | null | undefined, startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ValueTupleOfInt32ListOfVisitEmpdtos> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMapping/GetEmployeeVisitDetail?";
        if (fullName !== undefined && fullName !== null)
            url_ += "fullName=" + encodeURIComponent("" + fullName) + "&";
        if (customerName !== undefined && customerName !== null)
            url_ += "customerName=" + encodeURIComponent("" + customerName) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeVisitDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeVisitDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValueTupleOfInt32ListOfVisitEmpdtos>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValueTupleOfInt32ListOfVisitEmpdtos>;
        }));
    }

    protected processGetEmployeeVisitDetail(response: HttpResponseBase): Observable<ValueTupleOfInt32ListOfVisitEmpdtos> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValueTupleOfInt32ListOfVisitEmpdtos.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValueTupleOfInt32ListOfVisitEmpdtos>(null as any);
    }

    /**
     * @param fullName (optional) 
     * @param customerName (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getEmployeeVisitSummary(fullName: string | null | undefined, customerName: string | null | undefined, startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ValueTupleOfListOfEmployeeVisitSummaryDtoInt32> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMapping/GetEmployeeVisitSummary?";
        if (fullName !== undefined && fullName !== null)
            url_ += "fullName=" + encodeURIComponent("" + fullName) + "&";
        if (customerName !== undefined && customerName !== null)
            url_ += "customerName=" + encodeURIComponent("" + customerName) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeVisitSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeVisitSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValueTupleOfListOfEmployeeVisitSummaryDtoInt32>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValueTupleOfListOfEmployeeVisitSummaryDtoInt32>;
        }));
    }

    protected processGetEmployeeVisitSummary(response: HttpResponseBase): Observable<ValueTupleOfListOfEmployeeVisitSummaryDtoInt32> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValueTupleOfListOfEmployeeVisitSummaryDtoInt32.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValueTupleOfListOfEmployeeVisitSummaryDtoInt32>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    updateVisitSummary(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMapping/UpdateVisitSummary?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateVisitSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVisitSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateVisitSummary(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param fullName (optional) 
     * @param customerName (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getEmployeeVisitToExcel(fullName: string | null | undefined, customerName: string | null | undefined, startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMapping/GetEmployeeVisitToExcel?";
        if (fullName !== undefined && fullName !== null)
            url_ += "fullName=" + encodeURIComponent("" + fullName) + "&";
        if (customerName !== undefined && customerName !== null)
            url_ += "customerName=" + encodeURIComponent("" + customerName) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeVisitToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeVisitToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetEmployeeVisitToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class DataCapturingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param dateCaptured (optional) 
     * @param employeeId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, dateCaptured: moment.Moment | null | undefined, employeeId: number | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetDataCaptureForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/DataCapturing/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (dateCaptured !== undefined && dateCaptured !== null)
            url_ += "DateCaptured=" + encodeURIComponent(dateCaptured ? "" + dateCaptured.toISOString() : "") + "&";
        if (employeeId !== undefined && employeeId !== null)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetDataCaptureForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetDataCaptureForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetDataCaptureForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetDataCaptureForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetDataCaptureForViewDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param dateCaptured (optional) 
     * @param employeeId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllforEmployee(filter: string | null | undefined, dateCaptured: moment.Moment | null | undefined, employeeId: number | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetDataCaptureForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/DataCapturing/GetAllforEmployee?";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (dateCaptured !== undefined && dateCaptured !== null)
            url_ += "DateCaptured=" + encodeURIComponent(dateCaptured ? "" + dateCaptured.toISOString() : "") + "&";
        if (employeeId !== undefined && employeeId !== null)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllforEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllforEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetDataCaptureForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetDataCaptureForViewDto>;
        }));
    }

    protected processGetAllforEmployee(response: HttpResponseBase): Observable<PagedResultDtoOfGetDataCaptureForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetDataCaptureForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetDataCaptureForViewDto>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    getEmployeesWithKraNames(employeeId: number | undefined): Observable<GetEmployeeKRADataForView[]> {
        let url_ = this.baseUrl + "/api/services/app/DataCapturing/GetEmployeesWithKraNames?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeesWithKraNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeesWithKraNames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmployeeKRADataForView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmployeeKRADataForView[]>;
        }));
    }

    protected processGetEmployeesWithKraNames(response: HttpResponseBase): Observable<GetEmployeeKRADataForView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetEmployeeKRADataForView.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeeKRADataForView[]>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeesWithKraNamesForEmployeeData(): Observable<GetEmployeeKRADataForView[]> {
        let url_ = this.baseUrl + "/api/services/app/DataCapturing/GetEmployeesWithKraNamesForEmployeeData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeesWithKraNamesForEmployeeData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeesWithKraNamesForEmployeeData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmployeeKRADataForView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmployeeKRADataForView[]>;
        }));
    }

    protected processGetEmployeesWithKraNamesForEmployeeData(response: HttpResponseBase): Observable<GetEmployeeKRADataForView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetEmployeeKRADataForView.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeeKRADataForView[]>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeesWithKraNamesForEmployee(): Observable<GetEmployeeKRADataForView[]> {
        let url_ = this.baseUrl + "/api/services/app/DataCapturing/GetEmployeesWithKraNamesForEmployee";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeesWithKraNamesForEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeesWithKraNamesForEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmployeeKRADataForView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmployeeKRADataForView[]>;
        }));
    }

    protected processGetEmployeesWithKraNamesForEmployee(response: HttpResponseBase): Observable<GetEmployeeKRADataForView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetEmployeeKRADataForView.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeeKRADataForView[]>(null as any);
    }

    /**
     * @param kpikraid (optional) 
     * @param dataValue (optional) 
     * @return Success
     */
    checkCriteriaValue(kpikraid: number | undefined, dataValue: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/DataCapturing/CheckCriteriaValue?";
        if (kpikraid === null)
            throw new Error("The parameter 'kpikraid' cannot be null.");
        else if (kpikraid !== undefined)
            url_ += "kpikraid=" + encodeURIComponent("" + kpikraid) + "&";
        if (dataValue === null)
            throw new Error("The parameter 'dataValue' cannot be null.");
        else if (dataValue !== undefined)
            url_ += "dataValue=" + encodeURIComponent("" + dataValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCriteriaValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCriteriaValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheckCriteriaValue(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateorEditDataCaptureDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DataCapturing/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteDataCapture(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DataCapturing/DeleteDataCapture?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDataCapture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDataCapture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDataCapture(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @param name (optional) 
     * @param id (optional) 
     * @return Success
     */
    getEmployeeKra(employeeId: number | undefined, name: string | null | undefined, id: number | undefined): Observable<EmployeeKraDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DataCapturing/GetEmployeeKra?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeKra(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeKra(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeKraDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeKraDto[]>;
        }));
    }

    protected processGetEmployeeKra(response: HttpResponseBase): Observable<EmployeeKraDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeKraDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeKraDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getKRA(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/DataCapturing/GetKRA";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKRA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKRA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetKRA(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @param datacapturedId (optional) 
     * @return Success
     */
    getViewData(datacapturedId: number | undefined): Observable<GetEmployeeKRADataForView> {
        let url_ = this.baseUrl + "/api/services/app/DataCapturing/GetViewData?";
        if (datacapturedId === null)
            throw new Error("The parameter 'datacapturedId' cannot be null.");
        else if (datacapturedId !== undefined)
            url_ += "datacapturedId=" + encodeURIComponent("" + datacapturedId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetViewData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetViewData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmployeeKRADataForView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmployeeKRADataForView>;
        }));
    }

    protected processGetViewData(response: HttpResponseBase): Observable<GetEmployeeKRADataForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmployeeKRADataForView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeeKRADataForView>(null as any);
    }

    /**
     * @param datacapturedId (optional) 
     * @return Success
     */
    getDataCaptureForEdita(datacapturedId: number | undefined): Observable<GetEmployeeKRADataForView> {
        let url_ = this.baseUrl + "/api/services/app/DataCapturing/GetDataCaptureForEdita?";
        if (datacapturedId === null)
            throw new Error("The parameter 'datacapturedId' cannot be null.");
        else if (datacapturedId !== undefined)
            url_ += "datacapturedId=" + encodeURIComponent("" + datacapturedId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataCaptureForEdita(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataCaptureForEdita(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmployeeKRADataForView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmployeeKRADataForView>;
        }));
    }

    protected processGetDataCaptureForEdita(response: HttpResponseBase): Observable<GetEmployeeKRADataForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmployeeKRADataForView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeeKRADataForView>(null as any);
    }
}

@Injectable()
export class DemoUiComponentsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param date (optional) 
     * @return Success
     */
    sendAndGetDate(date: moment.Moment | null | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDate?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateToStringOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateToStringOutput>;
        }));
    }

    protected processSendAndGetDate(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateToStringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DateToStringOutput>(null as any);
    }

    /**
     * @param date (optional) 
     * @return Success
     */
    sendAndGetDateTime(date: moment.Moment | null | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateTime?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetDateTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDateTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateToStringOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateToStringOutput>;
        }));
    }

    protected processSendAndGetDateTime(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateToStringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DateToStringOutput>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    sendAndGetDateRange(startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateRange?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetDateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateToStringOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateToStringOutput>;
        }));
    }

    protected processSendAndGetDateRange(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateToStringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DateToStringOutput>(null as any);
    }

    /**
     * @param searchTerm (optional) 
     * @return Success
     */
    getCountries(searchTerm: string | null | undefined): Observable<NameValueOfString[]> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/GetCountries?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameValueOfString[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameValueOfString[]>;
        }));
    }

    protected processGetCountries(response: HttpResponseBase): Observable<NameValueOfString[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueOfString.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueOfString[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendAndGetSelectedCountries(body: NameValueOfString[] | null | undefined): Observable<NameValueOfString[]> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetSelectedCountries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetSelectedCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetSelectedCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameValueOfString[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameValueOfString[]>;
        }));
    }

    protected processSendAndGetSelectedCountries(response: HttpResponseBase): Observable<NameValueOfString[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueOfString.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueOfString[]>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    sendAndGetValue(input: string | null | undefined): Observable<StringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetValue?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringOutput>;
        }));
    }

    protected processSendAndGetValue(response: HttpResponseBase): Observable<StringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StringOutput>(null as any);
    }
}

@Injectable()
export class DepartmentsesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetDepartmentsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Departmentses/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetDepartmentsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetDepartmentsForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetDepartmentsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetDepartmentsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetDepartmentsForViewDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllDepartemntys(): Observable<GetDepartmentsForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Departmentses/GetAllDepartemntys";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDepartemntys(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDepartemntys(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDepartmentsForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDepartmentsForViewDto[]>;
        }));
    }

    protected processGetAllDepartemntys(response: HttpResponseBase): Observable<GetDepartmentsForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetDepartmentsForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDepartmentsForViewDto[]>(null as any);
    }

    /**
     * @return Success
     */
    generatePdf(): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Departmentses/GeneratePdf";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneratePdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratePdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGeneratePdf(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getTenencyDetailsList(): Observable<TenancyDetailsDetailsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Departmentses/GetTenencyDetailsList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenencyDetailsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenencyDetailsList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenancyDetailsDetailsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenancyDetailsDetailsDto[]>;
        }));
    }

    protected processGetTenencyDetailsList(response: HttpResponseBase): Observable<TenancyDetailsDetailsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenancyDetailsDetailsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenancyDetailsDetailsDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDepartmentsForView(id: number | undefined): Observable<GetDepartmentsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Departmentses/GetDepartmentsForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDepartmentsForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartmentsForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDepartmentsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDepartmentsForViewDto>;
        }));
    }

    protected processGetDepartmentsForView(response: HttpResponseBase): Observable<GetDepartmentsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDepartmentsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDepartmentsForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDepartmentsForEdit(id: number | undefined): Observable<GetDepartmentsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Departmentses/GetDepartmentsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDepartmentsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartmentsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDepartmentsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDepartmentsForEditOutput>;
        }));
    }

    protected processGetDepartmentsForEdit(response: HttpResponseBase): Observable<GetDepartmentsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDepartmentsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDepartmentsForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditDepartmentsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Departmentses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Departmentses/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @return Success
     */
    getDepartmentsesToExcel(filter: string | null | undefined, nameFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Departmentses/GetDepartmentsesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDepartmentsesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartmentsesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetDepartmentsesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class DesignationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetDesignationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Designations/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetDesignationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetDesignationForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetDesignationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetDesignationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetDesignationForViewDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllDesgin(): Observable<GetDesignationForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Designations/GetAllDesgin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDesgin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDesgin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDesignationForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDesignationForViewDto[]>;
        }));
    }

    protected processGetAllDesgin(response: HttpResponseBase): Observable<GetDesignationForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetDesignationForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDesignationForViewDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDesignationForView(id: number | undefined): Observable<GetDesignationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Designations/GetDesignationForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDesignationForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDesignationForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDesignationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDesignationForViewDto>;
        }));
    }

    protected processGetDesignationForView(response: HttpResponseBase): Observable<GetDesignationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDesignationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDesignationForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDesignationForEdit(id: number | undefined): Observable<GetDesignationForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Designations/GetDesignationForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDesignationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDesignationForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDesignationForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDesignationForEditOutput>;
        }));
    }

    protected processGetDesignationForEdit(response: HttpResponseBase): Observable<GetDesignationForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDesignationForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDesignationForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditDesignationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Designations/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Designations/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @return Success
     */
    getDesignationsToExcel(filter: string | null | undefined, nameFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Designations/GetDesignationsToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDesignationsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDesignationsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetDesignationsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class DivisionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetDivisionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Divisions/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetDivisionForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetDivisionForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetDivisionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetDivisionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetDivisionForViewDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllDivis(): Observable<GetDivisionForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Divisions/GetAllDivis";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDivis(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDivis(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDivisionForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDivisionForViewDto[]>;
        }));
    }

    protected processGetAllDivis(response: HttpResponseBase): Observable<GetDivisionForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetDivisionForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDivisionForViewDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDivisionForView(id: number | undefined): Observable<GetDivisionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Divisions/GetDivisionForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDivisionForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDivisionForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDivisionForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDivisionForViewDto>;
        }));
    }

    protected processGetDivisionForView(response: HttpResponseBase): Observable<GetDivisionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDivisionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDivisionForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDivisionForEdit(id: number | undefined): Observable<GetDivisionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Divisions/GetDivisionForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDivisionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDivisionForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDivisionForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDivisionForEditOutput>;
        }));
    }

    protected processGetDivisionForEdit(response: HttpResponseBase): Observable<GetDivisionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDivisionForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDivisionForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditDivisionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Divisions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Divisions/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @return Success
     */
    getDivisionsToExcel(filter: string | null | undefined, nameFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Divisions/GetDivisionsToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDivisionsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDivisionsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetDivisionsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class DocumentTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetDocumentTypeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentType/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetDocumentTypeForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetDocumentTypeForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetDocumentTypeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetDocumentTypeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetDocumentTypeForViewDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllDocumnetwizards(): Observable<GetDocumentTypeForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DocumentType/GetAllDocumnetwizards";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDocumnetwizards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDocumnetwizards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDocumentTypeForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDocumentTypeForViewDto[]>;
        }));
    }

    protected processGetAllDocumnetwizards(response: HttpResponseBase): Observable<GetDocumentTypeForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetDocumentTypeForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDocumentTypeForViewDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDocumentForView(id: number | undefined): Observable<GetDocumentTypeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentType/GetDocumentForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDocumentTypeForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDocumentTypeForViewDto>;
        }));
    }

    protected processGetDocumentForView(response: HttpResponseBase): Observable<GetDocumentTypeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDocumentTypeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDocumentTypeForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDocumentForEdit(id: number | undefined): Observable<GetDocumentTypeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/DocumentType/GetDocumentForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDocumentTypeForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDocumentTypeForEditOutput>;
        }));
    }

    protected processGetDocumentForEdit(response: HttpResponseBase): Observable<GetDocumentTypeForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDocumentTypeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDocumentTypeForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditDocumentTypeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentType/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentType/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class DropdownServicesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param type (optional) 
     * @param requestedBy (optional) 
     * @param requestId (optional) 
     * @return Success
     */
    getRequestFlow(type: WorkflowRequestType | undefined, requestedBy: number | undefined, requestId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetRequestFlow?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (requestedBy === null)
            throw new Error("The parameter 'requestedBy' cannot be null.");
        else if (requestedBy !== undefined)
            url_ += "requestedBy=" + encodeURIComponent("" + requestedBy) + "&";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestFlow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestFlow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetRequestFlow(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    getAttendancePanel(): Observable<AttendanceDetailsPanel[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetAttendancePanel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendancePanel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendancePanel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendanceDetailsPanel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendanceDetailsPanel[]>;
        }));
    }

    protected processGetAttendancePanel(response: HttpResponseBase): Observable<AttendanceDetailsPanel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttendanceDetailsPanel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AttendanceDetailsPanel[]>(null as any);
    }

    /**
     * @param attendanceDate (optional) 
     * @return Success
     */
    getAttendancePunches(attendanceDate: moment.Moment | undefined): Observable<AttendanceInOutPunches> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetAttendancePunches?";
        if (attendanceDate === null)
            throw new Error("The parameter 'attendanceDate' cannot be null.");
        else if (attendanceDate !== undefined)
            url_ += "attendanceDate=" + encodeURIComponent(attendanceDate ? "" + attendanceDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendancePunches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendancePunches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendanceInOutPunches>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendanceInOutPunches>;
        }));
    }

    protected processGetAttendancePunches(response: HttpResponseBase): Observable<AttendanceInOutPunches> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttendanceInOutPunches.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AttendanceInOutPunches>(null as any);
    }

    /**
     * @return Success
     */
    getKRAs(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetKRAs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKRAs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKRAs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetKRAs(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getKRA(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetKRA";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKRA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKRA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetKRA(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getCustomerMappedToEmployee(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetCustomerMappedToEmployee";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerMappedToEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerMappedToEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetCustomerMappedToEmployee(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    userRole(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/UserRole";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUserRole(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param imageName (optional) 
     * @param imageData (optional) 
     * @return Success
     */
    saveFtbImageServer(imageName: string | null | undefined, imageData: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/SaveFtbImageServer?";
        if (imageName !== undefined && imageName !== null)
            url_ += "ImageName=" + encodeURIComponent("" + imageName) + "&";
        if (imageData !== undefined && imageData !== null)
            url_ += "ImageData=" + encodeURIComponent("" + imageData) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveFtbImageServer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveFtbImageServer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveFtbImageServer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param imgName (optional) 
     * @param fileName (optional) 
     * @return Success
     */
    downLoadFileTemplete(imgName: string | null | undefined, fileName: string | null | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/DownLoadFileTemplete?";
        if (imgName !== undefined && imgName !== null)
            url_ += "ImgName=" + encodeURIComponent("" + imgName) + "&";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownLoadFileTemplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownLoadFileTemplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processDownLoadFileTemplete(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeNames(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetEmployeeNames";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeNames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetEmployeeNames(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getFtpCredential(): Observable<FtpDto> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetFtpCredential";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFtpCredential(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFtpCredential(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FtpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FtpDto>;
        }));
    }

    protected processGetFtpCredential(response: HttpResponseBase): Observable<FtpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FtpDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FtpDto>(null as any);
    }

    /**
     * @return Success
     */
    getLeaveCycleType(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetLeaveCycleType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveCycleType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveCycleType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetLeaveCycleType(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    getPerformanceCycleType(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetPerformanceCycleType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPerformanceCycleType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPerformanceCycleType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetPerformanceCycleType(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param v (optional) 
     * @param ftpUser (optional) 
     * @param ftpPassword (optional) 
     * @return Success
     */
    checkIfFileExistsOnServer(v: string | null | undefined, ftpUser: string | null | undefined, ftpPassword: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/CheckIfFileExistsOnServer?";
        if (v !== undefined && v !== null)
            url_ += "v=" + encodeURIComponent("" + v) + "&";
        if (ftpUser !== undefined && ftpUser !== null)
            url_ += "ftpUser=" + encodeURIComponent("" + ftpUser) + "&";
        if (ftpPassword !== undefined && ftpPassword !== null)
            url_ += "ftpPassword=" + encodeURIComponent("" + ftpPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfFileExistsOnServer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfFileExistsOnServer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckIfFileExistsOnServer(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeNamesBySessionRole(): Observable<DropDownNature[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetEmployeeNamesBySessionRole";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeNamesBySessionRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeNamesBySessionRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDownNature[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDownNature[]>;
        }));
    }

    protected processGetEmployeeNamesBySessionRole(response: HttpResponseBase): Observable<DropDownNature[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownNature.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownNature[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getselectedemployeebyid(id: number | undefined): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/Getselectedemployeebyid?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetselectedemployeebyid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetselectedemployeebyid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetselectedemployeebyid(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getTenancyLogo(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetTenancyLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenancyLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenancyLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetTenancyLogo(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    getBranchLogo(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetBranchLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBranchLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBranchLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetBranchLogo(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    getAdvanceReferences(employeeId: number | undefined): Observable<AdvanceReferenceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetAdvanceReferences?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvanceReferences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvanceReferences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdvanceReferenceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdvanceReferenceDto[]>;
        }));
    }

    protected processGetAdvanceReferences(response: HttpResponseBase): Observable<AdvanceReferenceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdvanceReferenceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdvanceReferenceDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getProjects(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetProjects";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetProjects(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getHrByTenant(): Observable<HrTenantGroupDTO[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetHrByTenant";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHrByTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHrByTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HrTenantGroupDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HrTenantGroupDTO[]>;
        }));
    }

    protected processGetHrByTenant(response: HttpResponseBase): Observable<HrTenantGroupDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HrTenantGroupDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HrTenantGroupDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    getClients(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetClients";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetClients(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeesForManagerReview(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetEmployeesForManagerReview";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeesForManagerReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeesForManagerReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetEmployeesForManagerReview(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeesRoleWise(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetEmployeesRoleWise";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeesRoleWise(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeesRoleWise(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetEmployeesRoleWise(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getFeedbackData(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetFeedbackData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeedbackData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeedbackData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetFeedbackData(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getKPIPolicy(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetKPIPolicy";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKPIPolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKPIPolicy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetKPIPolicy(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getReviewCycleForReport(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetReviewCycleForReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewCycleForReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewCycleForReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetReviewCycleForReport(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getReviewCycle(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetReviewCycle";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewCycle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewCycle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetReviewCycle(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getAdvanceType(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetAdvanceType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvanceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvanceType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetAdvanceType(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getOnDutyType(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetOnDutyType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnDutyType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnDutyType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetOnDutyType(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getShortLeaveType(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetShortLeaveType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShortLeaveType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShortLeaveType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetShortLeaveType(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param requestby (optional) 
     * @return Success
     */
    getMstExpense(requestby: number | undefined): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetMstExpense?";
        if (requestby === null)
            throw new Error("The parameter 'requestby' cannot be null.");
        else if (requestby !== undefined)
            url_ += "requestby=" + encodeURIComponent("" + requestby) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMstExpense(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMstExpense(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetMstExpense(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param requestby (optional) 
     * @return Success
     */
    getMstExpenseNaturewise(requestby: number | undefined): Observable<DropDownExpenseNatureWise[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetMstExpenseNaturewise?";
        if (requestby === null)
            throw new Error("The parameter 'requestby' cannot be null.");
        else if (requestby !== undefined)
            url_ += "requestby=" + encodeURIComponent("" + requestby) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMstExpenseNaturewise(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMstExpenseNaturewise(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDownExpenseNatureWise[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDownExpenseNatureWise[]>;
        }));
    }

    protected processGetMstExpenseNaturewise(response: HttpResponseBase): Observable<DropDownExpenseNatureWise[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownExpenseNatureWise.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownExpenseNatureWise[]>(null as any);
    }

    /**
     * @param employeeid (optional) 
     * @return Success
     */
    getMstExpenseMobile(employeeid: number | undefined): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetMstExpenseMobile?";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMstExpenseMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMstExpenseMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetMstExpenseMobile(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getShift(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetShift";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetShift(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeForLeave(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetEmployeeForLeave";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeForLeave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeForLeave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetEmployeeForLeave(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    statusEmployee(employeeId: number | undefined): Observable<EmployeeActiveStatus> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/StatusEmployee?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatusEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatusEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeActiveStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeActiveStatus>;
        }));
    }

    protected processStatusEmployee(response: HttpResponseBase): Observable<EmployeeActiveStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeActiveStatus.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeActiveStatus>(null as any);
    }

    /**
     * @param branchId (optional) 
     * @return Success
     */
    getEmployeeMultiBranchWise(branchId: number[] | null | undefined): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetEmployeeMultiBranchWise?";
        if (branchId !== undefined && branchId !== null)
            branchId && branchId.forEach(item => { url_ += "branchId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeMultiBranchWise(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeMultiBranchWise(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetEmployeeMultiBranchWise(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param branchId (optional) 
     * @return Success
     */
    getEmployeeBranchWise(branchId: number | null | undefined): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetEmployeeBranchWise?";
        if (branchId !== undefined && branchId !== null)
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeBranchWise(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeBranchWise(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetEmployeeBranchWise(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getEmployee(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetEmployee";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetEmployee(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeMultiSelect(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetEmployeeMultiSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeMultiSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeMultiSelect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetEmployeeMultiSelect(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param role (optional) 
     * @return Success
     */
    getEmployeeForProfilePageRoleWise(role: string | null | undefined): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetEmployeeForProfilePageRoleWise?";
        if (role !== undefined && role !== null)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeForProfilePageRoleWise(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeForProfilePageRoleWise(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetEmployeeForProfilePageRoleWise(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param flag (optional) 
     * @return Success
     */
    getEmployeeForProfilePage(flag: number | undefined): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetEmployeeForProfilePage?";
        if (flag === null)
            throw new Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeForProfilePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeForProfilePage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetEmployeeForProfilePage(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param branchId (optional) 
     * @return Success
     */
    getEmployeeExit(branchId: number | undefined): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetEmployeeExit?";
        if (branchId === null)
            throw new Error("The parameter 'branchId' cannot be null.");
        else if (branchId !== undefined)
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeExit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeExit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetEmployeeExit(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeFilterForAdvanceReport(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetEmployeeFilterForAdvanceReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeFilterForAdvanceReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeFilterForAdvanceReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetEmployeeFilterForAdvanceReport(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeesFromPolicy(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetEmployeesFromPolicy";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeesFromPolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeesFromPolicy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetEmployeesFromPolicy(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getDocument(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetDocument";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetDocument(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getFeeback(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetFeeback";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeeback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeeback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetFeeback(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getDegination(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetDegination";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDegination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDegination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetDegination(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getReasonFnF(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetReasonFnF";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReasonFnF(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReasonFnF(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetReasonFnF(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getExpenseName(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetExpenseName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExpenseName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExpenseName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetExpenseName(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getPolicyCritera(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetPolicyCritera";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolicyCritera(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolicyCritera(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetPolicyCritera(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getLocation(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetLocation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetLocation(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getNature(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetNature";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNature(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNature(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetNature(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getDepartment(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetDepartment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDepartment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetDepartment(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param departmentId (optional) 
     * @return Success
     */
    getAlSubDepartment(departmentId: number[] | null | undefined): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetAlSubDepartment?";
        if (departmentId !== undefined && departmentId !== null)
            departmentId && departmentId.forEach(item => { url_ += "DepartmentId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlSubDepartment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlSubDepartment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetAlSubDepartment(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param departmentId (optional) 
     * @return Success
     */
    getAlEmployeeDepartment(locationId: number[] | null | undefined, departmentId: number[] | null | undefined): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/getAlEmployeeDepartment?";
        if (locationId !== undefined && locationId !== null)
            locationId && locationId.forEach(item => { url_ += "LocationId=" + encodeURIComponent("" + item) + "&"; });
        if (departmentId !== undefined && departmentId !== null)
            departmentId && departmentId.forEach(item => { url_ += "DepartmentId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlEmployeeDepartment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlEmployeeDepartment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetAlEmployeeDepartment(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getAlEmployeeLocation(locationId: number[] | null | undefined): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/getAlEmployeeLocation?";
        if (locationId !== undefined && locationId !== null)
            locationId && locationId.forEach(item => { url_ += "LocationId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlEmployeeLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlEmployeeLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetAlEmployeeLocation(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param departmentId (optional) 
     * @param subDepartmentId (optional) 
     * @return Success
     */
    getAlEmployeeSubDepartment(locationId: number[] | null | undefined, departmentId: number[] | null | undefined, subDepartmentId: number[] | null | undefined): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/getAlEmployeeSubDepartment?";
        if (locationId !== undefined && locationId !== null)
            locationId && locationId.forEach(item => { url_ += "LocationId=" + encodeURIComponent("" + item) + "&"; });
        if (departmentId !== undefined && departmentId !== null)
            departmentId && departmentId.forEach(item => { url_ += "DepartmentId=" + encodeURIComponent("" + item) + "&"; });
        if (subDepartmentId !== undefined && subDepartmentId !== null)
            subDepartmentId && subDepartmentId.forEach(item => { url_ += "SubDepartmentId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlEmployeeSubDepartment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlEmployeeSubDepartment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetAlEmployeeSubDepartment(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param departmentId (optional) 
     * @return Success
     */
    subGetDepartment(departmentId: number | undefined): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/SubGetDepartment?";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "DepartmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubGetDepartment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubGetDepartment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processSubGetDepartment(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getDivision(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetDivision";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDivision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDivision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetDivision(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param stateID (optional) 
     * @return Success
     */
    getHeadquarter(stateID: number | undefined): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetHeadquarter?";
        if (stateID === null)
            throw new Error("The parameter 'stateID' cannot be null.");
        else if (stateID !== undefined)
            url_ += "StateID=" + encodeURIComponent("" + stateID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHeadquarter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHeadquarter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetHeadquarter(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getNationality(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetNationality";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNationality(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNationality(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetNationality(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getMstGroup(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetMstGroup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMstGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMstGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetMstGroup(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getContractor(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetContractor";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContractor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContractor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetContractor(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getCountry(): Observable<DropDownCountry[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetCountry";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDownCountry[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDownCountry[]>;
        }));
    }

    protected processGetCountry(response: HttpResponseBase): Observable<DropDownCountry[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownCountry.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownCountry[]>(null as any);
    }

    /**
     * @return Success
     */
    getUser(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetUser(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getReportManager(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetReportManager";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportManager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetReportManager(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getFunctionalManager(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetFunctionalManager";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFunctionalManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFunctionalManager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetFunctionalManager(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param countryId (optional) 
     * @return Success
     */
    getState(countryId: number | undefined): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetState?";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "CountryId=" + encodeURIComponent("" + countryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetState(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getStateData(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetStateData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStateData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStateData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetStateData(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param stateID (optional) 
     * @return Success
     */
    getCity(stateID: number | undefined): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetCity?";
        if (stateID === null)
            throw new Error("The parameter 'stateID' cannot be null.");
        else if (stateID !== undefined)
            url_ += "StateID=" + encodeURIComponent("" + stateID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetCity(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param employeeId (optional) 
     * @return Success
     */
    getMobileLeaveTypesMrr(tenantId: number | undefined, employeeId: number | undefined): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetMobileLeaveTypesMrr?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMobileLeaveTypesMrr(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMobileLeaveTypesMrr(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetMobileLeaveTypesMrr(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getMobileLeaveTypes(tenantId: number | undefined): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetMobileLeaveTypes?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMobileLeaveTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMobileLeaveTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetMobileLeaveTypes(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getLeaveTypes(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetLeaveTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetLeaveTypes(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    isReportingManager(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/IsReportingManager";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsReportingManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsReportingManager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsReportingManager(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return Success
     */
    getLeaveTypes2(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetLeaveTypes2";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveTypes2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveTypes2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetLeaveTypes2(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param employeeIds (optional) 
     * @return Success
     */
    getLeaveTypesToCreate(employeeIds: number | null | undefined): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetLeaveTypesToCreate?";
        if (employeeIds !== undefined && employeeIds !== null)
            url_ += "EmployeeIds=" + encodeURIComponent("" + employeeIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveTypesToCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveTypesToCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetLeaveTypesToCreate(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param leaveType (optional) 
     * @return Success
     */
    getLeaveBalance(leaveType: number | undefined): Observable<LeaveBlanceDetails[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetLeaveBalance?";
        if (leaveType === null)
            throw new Error("The parameter 'leaveType' cannot be null.");
        else if (leaveType !== undefined)
            url_ += "LeaveType=" + encodeURIComponent("" + leaveType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveBalance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveBalance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveBlanceDetails[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveBlanceDetails[]>;
        }));
    }

    protected processGetLeaveBalance(response: HttpResponseBase): Observable<LeaveBlanceDetails[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LeaveBlanceDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveBlanceDetails[]>(null as any);
    }

    /**
     * @return Success
     */
    getOnlyLeaveTypes(): Observable<DropDownLeaveType[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetOnlyLeaveTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnlyLeaveTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnlyLeaveTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDownLeaveType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDownLeaveType[]>;
        }));
    }

    protected processGetOnlyLeaveTypes(response: HttpResponseBase): Observable<DropDownLeaveType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownLeaveType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownLeaveType[]>(null as any);
    }

    /**
     * @param departmentId (optional) 
     * @param locationId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getEmployeeForShift(departmentId: number | undefined, locationId: number | undefined, tenantId: number | undefined): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetEmployeeForShift?";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeForShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeForShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetEmployeeForShift(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getDepartmentforShift(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetDepartmentforShift";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDepartmentforShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartmentforShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetDepartmentforShift(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getLocationForshift(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetLocationForshift";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationForshift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationForshift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetLocationForshift(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getPolicies(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetPolicies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolicies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolicies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetPolicies(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param isValid (optional) 
     * @return Success
     */
    getEmployees(isValid: boolean | undefined): Observable<DropDownEmployee[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetEmployees?";
        if (isValid === null)
            throw new Error("The parameter 'isValid' cannot be null.");
        else if (isValid !== undefined)
            url_ += "IsValid=" + encodeURIComponent("" + isValid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployees(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDownEmployee[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDownEmployee[]>;
        }));
    }

    protected processGetEmployees(response: HttpResponseBase): Observable<DropDownEmployee[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownEmployee.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownEmployee[]>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeesForExpense(): Observable<DropDownEmployee[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetEmployeesForExpense";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeesForExpense(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeesForExpense(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDownEmployee[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDownEmployee[]>;
        }));
    }

    protected processGetEmployeesForExpense(response: HttpResponseBase): Observable<DropDownEmployee[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownEmployee.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownEmployee[]>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @param flag (optional) 
     * @return Success
     */
    getQuarterName(month: number | undefined, year: number | undefined, flag: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/getQuarterName?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (flag === null)
            throw new Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuarterName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuarterName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetQuarterName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getHalfYear(month: number | undefined, year: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/getHalfYear?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHalfYear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHalfYear(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetHalfYear(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getMonthYear(month: number | undefined, year: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/getMonthYear?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthYear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthYear(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetMonthYear(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @return Success
     */
    getFromDate(monthYear: string | null | undefined): Observable<moment.Moment> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/getFromDate?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFromDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFromDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<moment.Moment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<moment.Moment>;
        }));
    }

    protected processGetFromDate(response: HttpResponseBase): Observable<moment.Moment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? moment(resultData200.toString()) : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<moment.Moment>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @return Success
     */
    getToDate(monthYear: string | null | undefined): Observable<moment.Moment> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/getToDate?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetToDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<moment.Moment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<moment.Moment>;
        }));
    }

    protected processGetToDate(response: HttpResponseBase): Observable<moment.Moment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? moment(resultData200.toString()) : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<moment.Moment>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    getCycle(employeeId: number | undefined): Observable<ReviewCycleDropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetCycle?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCycle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCycle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReviewCycleDropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReviewCycleDropDown[]>;
        }));
    }

    protected processGetCycle(response: HttpResponseBase): Observable<ReviewCycleDropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReviewCycleDropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReviewCycleDropDown[]>(null as any);
    }

    /**
     * @return Success
     */
    getPerformanceCycle(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/getPerformanceCycle";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPerformanceCycle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPerformanceCycle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetPerformanceCycle(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    getRoles(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param aadharCard (optional) 
     * @return Success
     */
    getPreviousEmployeeCode(aadharCard: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/GetPreviousEmployeeCode?";
        if (aadharCard !== undefined && aadharCard !== null)
            url_ += "aadharCard=" + encodeURIComponent("" + aadharCard) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreviousEmployeeCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreviousEmployeeCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetPreviousEmployeeCode(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/DropdownServices/getEmployeeId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetEmployeeId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class DuesOverridesFnFServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param employeeid (optional) 
     * @return Success
     */
    getDuesOverrides(employeeid: number | undefined): Observable<GetDuesOverridesDto> {
        let url_ = this.baseUrl + "/api/services/app/DuesOverridesFnF/GetDuesOverrides?";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDuesOverrides(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDuesOverrides(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDuesOverridesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDuesOverridesDto>;
        }));
    }

    protected processGetDuesOverrides(response: HttpResponseBase): Observable<GetDuesOverridesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDuesOverridesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDuesOverridesDto>(null as any);
    }

    /**
     * @param employeeid (optional) 
     * @param deduction (optional) 
     * @param noticeperiod (optional) 
     * @return Success
     */
    save(employeeid: number | undefined, deduction: number | undefined, noticeperiod: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DuesOverridesFnF/Save?";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        if (deduction === null)
            throw new Error("The parameter 'deduction' cannot be null.");
        else if (deduction !== undefined)
            url_ += "deduction=" + encodeURIComponent("" + deduction) + "&";
        if (noticeperiod === null)
            throw new Error("The parameter 'noticeperiod' cannot be null.");
        else if (noticeperiod !== undefined)
            url_ += "noticeperiod=" + encodeURIComponent("" + noticeperiod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class EditionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getEditions(): Observable<ListResultDtoOfEditionListDto> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfEditionListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfEditionListDto>;
        }));
    }

    protected processGetEditions(response: HttpResponseBase): Observable<ListResultDtoOfEditionListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfEditionListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfEditionListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEditionForEdit(id: number | null | undefined): Observable<GetEditionEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionForEdit?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEditionEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEditionEditOutput>;
        }));
    }

    protected processGetEditionForEdit(response: HttpResponseBase): Observable<GetEditionEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEditionEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEditionEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEdition(body: CreateEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/CreateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEdition(body: UpdateEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/UpdateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteEdition(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/DeleteEdition?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveTenantsToAnotherEdition(body: MoveTenantsToAnotherEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/MoveTenantsToAnotherEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveTenantsToAnotherEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveTenantsToAnotherEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMoveTenantsToAnotherEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param selectedEditionId (optional) 
     * @param addAllItem (optional) 
     * @param onlyFreeItems (optional) 
     * @return Success
     */
    getEditionComboboxItems(selectedEditionId: number | null | undefined, addAllItem: boolean | undefined, onlyFreeItems: boolean | undefined): Observable<SubscribableEditionComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionComboboxItems?";
        if (selectedEditionId !== undefined && selectedEditionId !== null)
            url_ += "selectedEditionId=" + encodeURIComponent("" + selectedEditionId) + "&";
        if (addAllItem === null)
            throw new Error("The parameter 'addAllItem' cannot be null.");
        else if (addAllItem !== undefined)
            url_ += "addAllItem=" + encodeURIComponent("" + addAllItem) + "&";
        if (onlyFreeItems === null)
            throw new Error("The parameter 'onlyFreeItems' cannot be null.");
        else if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionComboboxItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscribableEditionComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscribableEditionComboboxItemDto[]>;
        }));
    }

    protected processGetEditionComboboxItems(response: HttpResponseBase): Observable<SubscribableEditionComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscribableEditionComboboxItemDto[]>(null as any);
    }

    /**
     * @param editionId (optional) 
     * @return Success
     */
    getTenantCount(editionId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetTenantCount?";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTenantCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class EducationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditEducationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Education/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Education/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetEducationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Education/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetEducationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetEducationForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetEducationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEducationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEducationForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEducationForEdit(id: number | undefined): Observable<CreateOrEditEducationDto> {
        let url_ = this.baseUrl + "/api/services/app/Education/GetEducationForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducationForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditEducationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditEducationDto>;
        }));
    }

    protected processGetEducationForEdit(response: HttpResponseBase): Observable<CreateOrEditEducationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditEducationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditEducationDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEducationForView(id: number | undefined): Observable<CreateOrEditEducationDto> {
        let url_ = this.baseUrl + "/api/services/app/Education/GetEducationForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducationForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducationForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditEducationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditEducationDto>;
        }));
    }

    protected processGetEducationForView(response: HttpResponseBase): Observable<CreateOrEditEducationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditEducationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditEducationDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllEducationWithSpecializations(): Observable<PagedResultDtoOfGetEducationWithSpecializations> {
        let url_ = this.baseUrl + "/api/services/app/Education/GetAllEducationWithSpecializations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEducationWithSpecializations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEducationWithSpecializations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetEducationWithSpecializations>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetEducationWithSpecializations>;
        }));
    }

    protected processGetAllEducationWithSpecializations(response: HttpResponseBase): Observable<PagedResultDtoOfGetEducationWithSpecializations> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEducationWithSpecializations.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEducationWithSpecializations>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @return Success
     */
    getEducationToExcel(filter: string | null | undefined, nameFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Education/GetEducationToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducationToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducationToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetEducationToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class EmplolyeeCodeSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param preFixFilter (optional) 
     * @param maxStartingNoFilter (optional) 
     * @param minStartingNoFilter (optional) 
     * @param editableFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, preFixFilter: string | null | undefined, maxStartingNoFilter: number | null | undefined, minStartingNoFilter: number | null | undefined, editableFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetEmplolyeeCodeSettingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/EmplolyeeCodeSettings/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (preFixFilter !== undefined && preFixFilter !== null)
            url_ += "PreFixFilter=" + encodeURIComponent("" + preFixFilter) + "&";
        if (maxStartingNoFilter !== undefined && maxStartingNoFilter !== null)
            url_ += "MaxStartingNoFilter=" + encodeURIComponent("" + maxStartingNoFilter) + "&";
        if (minStartingNoFilter !== undefined && minStartingNoFilter !== null)
            url_ += "MinStartingNoFilter=" + encodeURIComponent("" + minStartingNoFilter) + "&";
        if (editableFilter !== undefined && editableFilter !== null)
            url_ += "EditableFilter=" + encodeURIComponent("" + editableFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetEmplolyeeCodeSettingForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetEmplolyeeCodeSettingForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetEmplolyeeCodeSettingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEmplolyeeCodeSettingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEmplolyeeCodeSettingForViewDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllEmployeeTenant(): Observable<GetEmplolyeeCodeSettingForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EmplolyeeCodeSettings/GetAllEmployeeTenant";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEmployeeTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEmployeeTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmplolyeeCodeSettingForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmplolyeeCodeSettingForViewDto[]>;
        }));
    }

    protected processGetAllEmployeeTenant(response: HttpResponseBase): Observable<GetEmplolyeeCodeSettingForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetEmplolyeeCodeSettingForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmplolyeeCodeSettingForViewDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEmplolyeeCodeSettingForView(id: number | undefined): Observable<GetEmplolyeeCodeSettingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/EmplolyeeCodeSettings/GetEmplolyeeCodeSettingForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmplolyeeCodeSettingForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmplolyeeCodeSettingForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmplolyeeCodeSettingForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmplolyeeCodeSettingForViewDto>;
        }));
    }

    protected processGetEmplolyeeCodeSettingForView(response: HttpResponseBase): Observable<GetEmplolyeeCodeSettingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmplolyeeCodeSettingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmplolyeeCodeSettingForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEmplolyeeCodeSettingForEdit(id: number | undefined): Observable<GetEmplolyeeCodeSettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/EmplolyeeCodeSettings/GetEmplolyeeCodeSettingForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmplolyeeCodeSettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmplolyeeCodeSettingForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmplolyeeCodeSettingForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmplolyeeCodeSettingForEditOutput>;
        }));
    }

    protected processGetEmplolyeeCodeSettingForEdit(response: HttpResponseBase): Observable<GetEmplolyeeCodeSettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmplolyeeCodeSettingForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmplolyeeCodeSettingForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditEmplolyeeCodeSettingDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmplolyeeCodeSettings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmplolyeeCodeSettings/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param preFixFilter (optional) 
     * @param maxStartingNoFilter (optional) 
     * @param minStartingNoFilter (optional) 
     * @param editableFilter (optional) 
     * @return Success
     */
    getEmplolyeeCodeSettingsToExcel(filter: string | null | undefined, preFixFilter: string | null | undefined, maxStartingNoFilter: number | null | undefined, minStartingNoFilter: number | null | undefined, editableFilter: number | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/EmplolyeeCodeSettings/GetEmplolyeeCodeSettingsToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (preFixFilter !== undefined && preFixFilter !== null)
            url_ += "PreFixFilter=" + encodeURIComponent("" + preFixFilter) + "&";
        if (maxStartingNoFilter !== undefined && maxStartingNoFilter !== null)
            url_ += "MaxStartingNoFilter=" + encodeURIComponent("" + maxStartingNoFilter) + "&";
        if (minStartingNoFilter !== undefined && minStartingNoFilter !== null)
            url_ += "MinStartingNoFilter=" + encodeURIComponent("" + minStartingNoFilter) + "&";
        if (editableFilter !== undefined && editableFilter !== null)
            url_ += "EditableFilter=" + encodeURIComponent("" + editableFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmplolyeeCodeSettingsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmplolyeeCodeSettingsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetEmplolyeeCodeSettingsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class EmployeeAccountDetailsServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEmployeeAccountDetailsForEdit(id: number | undefined): Observable<GetEmployeeAccountDetailsEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeAccountDetailsService/GetEmployeeAccountDetailsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeAccountDetailsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeAccountDetailsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmployeeAccountDetailsEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmployeeAccountDetailsEditOutput>;
        }));
    }

    protected processGetEmployeeAccountDetailsForEdit(response: HttpResponseBase): Observable<GetEmployeeAccountDetailsEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmployeeAccountDetailsEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeeAccountDetailsEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateorEditAccountDetails | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeAccountDetailsService/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEmployeeOtherDetailsForEdit(id: number | undefined): Observable<GetEmployeeOtherDetailsEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeAccountDetailsService/GetEmployeeOtherDetailsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeOtherDetailsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeOtherDetailsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmployeeOtherDetailsEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmployeeOtherDetailsEditOutput>;
        }));
    }

    protected processGetEmployeeOtherDetailsForEdit(response: HttpResponseBase): Observable<GetEmployeeOtherDetailsEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmployeeOtherDetailsEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeeOtherDetailsEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    employeeOtherDetailsCreate(body: CreateOrEditEmployeeOtherDetials | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeAccountDetailsService/EmployeeOtherDetailsCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployeeOtherDetailsCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployeeOtherDetailsCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEmployeeOtherDetailsCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEmployeePerviousDetailsForEdit(id: number | undefined): Observable<GetCreateorEditEmployeePerivouseDetails> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeAccountDetailsService/GetEmployeePerviousDetailsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeePerviousDetailsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeePerviousDetailsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCreateorEditEmployeePerivouseDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCreateorEditEmployeePerivouseDetails>;
        }));
    }

    protected processGetEmployeePerviousDetailsForEdit(response: HttpResponseBase): Observable<GetCreateorEditEmployeePerivouseDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCreateorEditEmployeePerivouseDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCreateorEditEmployeePerivouseDetails>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    employeePerviousDetailsCreate(body: CreateoreditEmployeeperivouesDetails | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeAccountDetailsService/EmployeePerviousDetailsCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployeePerviousDetailsCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployeePerviousDetailsCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEmployeePerviousDetailsCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeAccountDetailsService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class EmployeeAttendanceModeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param firstName (optional) 
     * @param lastName (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(firstName: string | null | undefined, lastName: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetEmployeeAttendanceModeDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeAttendanceMode/GetAll?";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetEmployeeAttendanceModeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetEmployeeAttendanceModeDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetEmployeeAttendanceModeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEmployeeAttendanceModeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEmployeeAttendanceModeDto>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    getBranchMode(employeeId: number | undefined): Observable<PagedResultDtoOfGetBranchModeDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeAttendanceMode/GetBranchMode?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBranchMode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBranchMode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetBranchModeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetBranchModeDto>;
        }));
    }

    protected processGetBranchMode(response: HttpResponseBase): Observable<PagedResultDtoOfGetBranchModeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBranchModeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBranchModeDto>(null as any);
    }

    /**
     * @param excelFile (optional) 
     * @return Success
     */
    importEmployeeAttendanceModeFromExcel(excelFile: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeAttendanceMode/ImportEmployeeAttendanceModeFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile !== null && excelFile !== undefined)
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportEmployeeAttendanceModeFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportEmployeeAttendanceModeFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportEmployeeAttendanceModeFromExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAttendanceMode(body: GetEmployeeAttendanceModeDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeAttendanceMode/UpdateAttendanceMode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAttendanceMode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAttendanceMode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAttendanceMode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAttendanceModeToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeAttendanceMode/GetAttendanceModeToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceModeToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceModeToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetAttendanceModeToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeAttendanceBlankFormat(): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeAttendanceMode/GetEmployeeAttendanceBlankFormat";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeAttendanceBlankFormat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeAttendanceBlankFormat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetEmployeeAttendanceBlankFormat(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }
}

@Injectable()
export class EmployeebankdetailsesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxPayModeFilter (optional) 
     * @param minPayModeFilter (optional) 
     * @param ifsccodeFilter (optional) 
     * @param maxAccountNumberFilter (optional) 
     * @param minAccountNumberFilter (optional) 
     * @param maxEffectiveMonthYearFilter (optional) 
     * @param minEffectiveMonthYearFilter (optional) 
     * @param maxEmployeeIDFilter (optional) 
     * @param minEmployeeIDFilter (optional) 
     * @param bankBranchBankNameFilter (optional) 
     * @param bankBranchDetailsBranchNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxPayModeFilter: number | null | undefined, minPayModeFilter: number | null | undefined, ifsccodeFilter: string | null | undefined, maxAccountNumberFilter: number | null | undefined, minAccountNumberFilter: number | null | undefined, maxEffectiveMonthYearFilter: moment.Moment | null | undefined, minEffectiveMonthYearFilter: moment.Moment | null | undefined, maxEmployeeIDFilter: number | null | undefined, minEmployeeIDFilter: number | null | undefined, bankBranchBankNameFilter: string | null | undefined, bankBranchDetailsBranchNameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetEmployeebankdetailsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Employeebankdetailses/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxPayModeFilter !== undefined && maxPayModeFilter !== null)
            url_ += "MaxPayModeFilter=" + encodeURIComponent("" + maxPayModeFilter) + "&";
        if (minPayModeFilter !== undefined && minPayModeFilter !== null)
            url_ += "MinPayModeFilter=" + encodeURIComponent("" + minPayModeFilter) + "&";
        if (ifsccodeFilter !== undefined && ifsccodeFilter !== null)
            url_ += "IfsccodeFilter=" + encodeURIComponent("" + ifsccodeFilter) + "&";
        if (maxAccountNumberFilter !== undefined && maxAccountNumberFilter !== null)
            url_ += "MaxAccountNumberFilter=" + encodeURIComponent("" + maxAccountNumberFilter) + "&";
        if (minAccountNumberFilter !== undefined && minAccountNumberFilter !== null)
            url_ += "MinAccountNumberFilter=" + encodeURIComponent("" + minAccountNumberFilter) + "&";
        if (maxEffectiveMonthYearFilter !== undefined && maxEffectiveMonthYearFilter !== null)
            url_ += "MaxEffectiveMonthYearFilter=" + encodeURIComponent(maxEffectiveMonthYearFilter ? "" + maxEffectiveMonthYearFilter.toISOString() : "") + "&";
        if (minEffectiveMonthYearFilter !== undefined && minEffectiveMonthYearFilter !== null)
            url_ += "MinEffectiveMonthYearFilter=" + encodeURIComponent(minEffectiveMonthYearFilter ? "" + minEffectiveMonthYearFilter.toISOString() : "") + "&";
        if (maxEmployeeIDFilter !== undefined && maxEmployeeIDFilter !== null)
            url_ += "MaxEmployeeIDFilter=" + encodeURIComponent("" + maxEmployeeIDFilter) + "&";
        if (minEmployeeIDFilter !== undefined && minEmployeeIDFilter !== null)
            url_ += "MinEmployeeIDFilter=" + encodeURIComponent("" + minEmployeeIDFilter) + "&";
        if (bankBranchBankNameFilter !== undefined && bankBranchBankNameFilter !== null)
            url_ += "BankBranchBankNameFilter=" + encodeURIComponent("" + bankBranchBankNameFilter) + "&";
        if (bankBranchDetailsBranchNameFilter !== undefined && bankBranchDetailsBranchNameFilter !== null)
            url_ += "BankBranchDetailsBranchNameFilter=" + encodeURIComponent("" + bankBranchDetailsBranchNameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetEmployeebankdetailsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetEmployeebankdetailsForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetEmployeebankdetailsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEmployeebankdetailsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEmployeebankdetailsForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEmployeebankdetailsForView(id: number | undefined): Observable<GetEmployeebankdetailsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Employeebankdetailses/GetEmployeebankdetailsForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeebankdetailsForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeebankdetailsForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmployeebankdetailsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmployeebankdetailsForViewDto>;
        }));
    }

    protected processGetEmployeebankdetailsForView(response: HttpResponseBase): Observable<GetEmployeebankdetailsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmployeebankdetailsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeebankdetailsForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEmployeebankdetailsForEdit(id: number | undefined): Observable<GetEmployeebankdetailsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Employeebankdetailses/GetEmployeebankdetailsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeebankdetailsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeebankdetailsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmployeebankdetailsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmployeebankdetailsForEditOutput>;
        }));
    }

    protected processGetEmployeebankdetailsForEdit(response: HttpResponseBase): Observable<GetEmployeebankdetailsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmployeebankdetailsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeebankdetailsForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditEmployeebankdetailsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employeebankdetailses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employeebankdetailses/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxPayModeFilter (optional) 
     * @param minPayModeFilter (optional) 
     * @param ifsccodeFilter (optional) 
     * @param maxAccountNumberFilter (optional) 
     * @param minAccountNumberFilter (optional) 
     * @param maxEffectiveMonthYearFilter (optional) 
     * @param minEffectiveMonthYearFilter (optional) 
     * @param maxEmployeeIDFilter (optional) 
     * @param minEmployeeIDFilter (optional) 
     * @param bankBranchBankNameFilter (optional) 
     * @param bankBranchDetailsBranchNameFilter (optional) 
     * @return Success
     */
    getEmployeebankdetailsesToExcel(filter: string | null | undefined, maxPayModeFilter: number | null | undefined, minPayModeFilter: number | null | undefined, ifsccodeFilter: string | null | undefined, maxAccountNumberFilter: number | null | undefined, minAccountNumberFilter: number | null | undefined, maxEffectiveMonthYearFilter: moment.Moment | null | undefined, minEffectiveMonthYearFilter: moment.Moment | null | undefined, maxEmployeeIDFilter: number | null | undefined, minEmployeeIDFilter: number | null | undefined, bankBranchBankNameFilter: string | null | undefined, bankBranchDetailsBranchNameFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Employeebankdetailses/GetEmployeebankdetailsesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxPayModeFilter !== undefined && maxPayModeFilter !== null)
            url_ += "MaxPayModeFilter=" + encodeURIComponent("" + maxPayModeFilter) + "&";
        if (minPayModeFilter !== undefined && minPayModeFilter !== null)
            url_ += "MinPayModeFilter=" + encodeURIComponent("" + minPayModeFilter) + "&";
        if (ifsccodeFilter !== undefined && ifsccodeFilter !== null)
            url_ += "IfsccodeFilter=" + encodeURIComponent("" + ifsccodeFilter) + "&";
        if (maxAccountNumberFilter !== undefined && maxAccountNumberFilter !== null)
            url_ += "MaxAccountNumberFilter=" + encodeURIComponent("" + maxAccountNumberFilter) + "&";
        if (minAccountNumberFilter !== undefined && minAccountNumberFilter !== null)
            url_ += "MinAccountNumberFilter=" + encodeURIComponent("" + minAccountNumberFilter) + "&";
        if (maxEffectiveMonthYearFilter !== undefined && maxEffectiveMonthYearFilter !== null)
            url_ += "MaxEffectiveMonthYearFilter=" + encodeURIComponent(maxEffectiveMonthYearFilter ? "" + maxEffectiveMonthYearFilter.toISOString() : "") + "&";
        if (minEffectiveMonthYearFilter !== undefined && minEffectiveMonthYearFilter !== null)
            url_ += "MinEffectiveMonthYearFilter=" + encodeURIComponent(minEffectiveMonthYearFilter ? "" + minEffectiveMonthYearFilter.toISOString() : "") + "&";
        if (maxEmployeeIDFilter !== undefined && maxEmployeeIDFilter !== null)
            url_ += "MaxEmployeeIDFilter=" + encodeURIComponent("" + maxEmployeeIDFilter) + "&";
        if (minEmployeeIDFilter !== undefined && minEmployeeIDFilter !== null)
            url_ += "MinEmployeeIDFilter=" + encodeURIComponent("" + minEmployeeIDFilter) + "&";
        if (bankBranchBankNameFilter !== undefined && bankBranchBankNameFilter !== null)
            url_ += "BankBranchBankNameFilter=" + encodeURIComponent("" + bankBranchBankNameFilter) + "&";
        if (bankBranchDetailsBranchNameFilter !== undefined && bankBranchDetailsBranchNameFilter !== null)
            url_ += "BankBranchDetailsBranchNameFilter=" + encodeURIComponent("" + bankBranchDetailsBranchNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeebankdetailsesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeebankdetailsesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetEmployeebankdetailsesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllBankBranchForTableDropdown(): Observable<EmployeebankdetailsBankBranchLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employeebankdetailses/GetAllBankBranchForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBankBranchForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBankBranchForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeebankdetailsBankBranchLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeebankdetailsBankBranchLookupTableDto[]>;
        }));
    }

    protected processGetAllBankBranchForTableDropdown(response: HttpResponseBase): Observable<EmployeebankdetailsBankBranchLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeebankdetailsBankBranchLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeebankdetailsBankBranchLookupTableDto[]>(null as any);
    }

    /**
     * @param bankBranchId (optional) 
     * @return Success
     */
    getAllBankBranchDetailsForTableDropdown(bankBranchId: number | undefined): Observable<EmployeebankdetailsBankBranchDetailsLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employeebankdetailses/GetAllBankBranchDetailsForTableDropdown?";
        if (bankBranchId === null)
            throw new Error("The parameter 'bankBranchId' cannot be null.");
        else if (bankBranchId !== undefined)
            url_ += "bankBranchId=" + encodeURIComponent("" + bankBranchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBankBranchDetailsForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBankBranchDetailsForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeebankdetailsBankBranchDetailsLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeebankdetailsBankBranchDetailsLookupTableDto[]>;
        }));
    }

    protected processGetAllBankBranchDetailsForTableDropdown(response: HttpResponseBase): Observable<EmployeebankdetailsBankBranchDetailsLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeebankdetailsBankBranchDetailsLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeebankdetailsBankBranchDetailsLookupTableDto[]>(null as any);
    }

    /**
     * @param ifscCode (optional) 
     * @return Success
     */
    verifyIfscCode(ifscCode: string | null | undefined): Observable<IfscVerificationDto> {
        let url_ = this.baseUrl + "/api/services/app/Employeebankdetailses/VerifyIfscCode?";
        if (ifscCode !== undefined && ifscCode !== null)
            url_ += "ifscCode=" + encodeURIComponent("" + ifscCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyIfscCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyIfscCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IfscVerificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IfscVerificationDto>;
        }));
    }

    protected processVerifyIfscCode(response: HttpResponseBase): Observable<IfscVerificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IfscVerificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IfscVerificationDto>(null as any);
    }
}

@Injectable()
export class EmployeesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getBlankEmployeeSalaryProcessExcelFormat(): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetBlankEmployeeSalaryProcessExcelFormat";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBlankEmployeeSalaryProcessExcelFormat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBlankEmployeeSalaryProcessExcelFormat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetBlankEmployeeSalaryProcessExcelFormat(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importEmployeeSalaryProcess(body: EmployeeInputeFileDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/ImportEmployeeSalaryProcess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportEmployeeSalaryProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportEmployeeSalaryProcess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportEmployeeSalaryProcess(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    processleave(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/processleave";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessleave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessleave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processProcessleave(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importBulkEmployeeSalaryStructure(body: EmployeeInputeFileDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/ImportBulkEmployeeSalaryStructure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportBulkEmployeeSalaryStructure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportBulkEmployeeSalaryStructure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportBulkEmployeeSalaryStructure(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importBulkEmployeeDataStructure(body: EmployeeInputeFileDto | undefined): Observable<ErrorFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Employees/ImportBulkEmployeeDataStructure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportBulkEmployeeDataStructure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportBulkEmployeeDataStructure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErrorFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErrorFileDto>;
        }));
    }

    protected processImportBulkEmployeeDataStructure(response: HttpResponseBase): Observable<ErrorFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ErrorFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ErrorFileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveUpdateRejectedRowEdits(body: ImportRejectedEmployeeRowUpdateDto[] | null | undefined): Observable<ImportRejectedEmployeeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employees/SaveUpdateRejectedRowEdits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveUpdateRejectedRowEdits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveUpdateRejectedRowEdits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportRejectedEmployeeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportRejectedEmployeeDto[]>;
        }));
    }

    protected processSaveUpdateRejectedRowEdits(response: HttpResponseBase): Observable<ImportRejectedEmployeeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImportRejectedEmployeeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportRejectedEmployeeDto[]>(null as any);
    }

    /**
     * @param batchId (optional) 
     * @param body (optional) 
     * @return Success
     */
    reprocessUpdateRejectedRows(batchId: string | null | undefined, body: ImportRejectedEmployeeRowUpdateDto[] | null | undefined): Observable<ErrorFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Employees/ReprocessUpdateRejectedRows?";
        if (batchId !== undefined && batchId !== null)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReprocessUpdateRejectedRows(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReprocessUpdateRejectedRows(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErrorFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErrorFileDto>;
        }));
    }

    protected processReprocessUpdateRejectedRows(response: HttpResponseBase): Observable<ErrorFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ErrorFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ErrorFileDto>(null as any);
    }

    /**
     * @param empid (optional) 
     * @param banknamess (optional) 
     * @param bankbranchnamess (optional) 
     * @param acountnumber (optional) 
     * @param ifsccode (optional) 
     * @return Success
     */
    updatebankdetails(empid: number | undefined, banknamess: string | null | undefined, bankbranchnamess: string | null | undefined, acountnumber: string | null | undefined, ifsccode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/updatebankdetails?";
        if (empid === null)
            throw new Error("The parameter 'empid' cannot be null.");
        else if (empid !== undefined)
            url_ += "empid=" + encodeURIComponent("" + empid) + "&";
        if (banknamess !== undefined && banknamess !== null)
            url_ += "banknamess=" + encodeURIComponent("" + banknamess) + "&";
        if (bankbranchnamess !== undefined && bankbranchnamess !== null)
            url_ += "bankbranchnamess=" + encodeURIComponent("" + bankbranchnamess) + "&";
        if (acountnumber !== undefined && acountnumber !== null)
            url_ += "acountnumber=" + encodeURIComponent("" + acountnumber) + "&";
        if (ifsccode !== undefined && ifsccode !== null)
            url_ += "ifsccode=" + encodeURIComponent("" + ifsccode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatebankdetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatebankdetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatebankdetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param employeeCode (optional) 
     * @param email (optional) 
     * @param boimetric (optional) 
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    imortvalidation(employeeCode: string | null | undefined, email: string | null | undefined, boimetric: string | null | undefined, id: string | null | undefined, body: RowErrorDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/Imortvalidation?";
        if (employeeCode !== undefined && employeeCode !== null)
            url_ += "employeeCode=" + encodeURIComponent("" + employeeCode) + "&";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (boimetric !== undefined && boimetric !== null)
            url_ += "boimetric=" + encodeURIComponent("" + boimetric) + "&";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImortvalidation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImortvalidation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImortvalidation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEmployeeForMRR(body: CreateOrEditEmployeeForMRRDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/CreateEmployeeForMRR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEmployeeForMRR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEmployeeForMRR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateEmployeeForMRR(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    inactiveToActive(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/InactiveToActive?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInactiveToActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInactiveToActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInactiveToActive(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    activeToInactive(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/ActiveToInactive?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActiveToInactive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActiveToInactive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActiveToInactive(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllEmployeeForNewRoute(): Observable<GetEmployeeForListViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetAllEmployeeForNewRoute";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEmployeeForNewRoute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEmployeeForNewRoute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmployeeForListViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmployeeForListViewDto[]>;
        }));
    }

    protected processGetAllEmployeeForNewRoute(response: HttpResponseBase): Observable<GetEmployeeForListViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetEmployeeForListViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeeForListViewDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getCurrentLogIn(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetCurrentLogIn";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLogIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLogIn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetCurrentLogIn(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @param empName (optional) 
     * @return Success
     */
    getContractEmployee(empName: string | null | undefined): Observable<ContractEmployeeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetContractEmployee?";
        if (empName !== undefined && empName !== null)
            url_ += "empName=" + encodeURIComponent("" + empName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContractEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContractEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractEmployeeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractEmployeeDto[]>;
        }));
    }

    protected processGetContractEmployee(response: HttpResponseBase): Observable<ContractEmployeeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContractEmployeeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContractEmployeeDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditContractEmp(body: ContractEmployeeDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/CreateOrEditContractEmp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditContractEmp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditContractEmp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditContractEmp(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @return Success
     */
    getContractList(monthYear: string | null | undefined): Observable<ContractEmployeeSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetContractList?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContractList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContractList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractEmployeeSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractEmployeeSummaryDto[]>;
        }));
    }

    protected processGetContractList(response: HttpResponseBase): Observable<ContractEmployeeSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContractEmployeeSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContractEmployeeSummaryDto[]>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param empName (optional) 
     * @return Success
     */
    getContractEmployeesForEdit(monthYear: string | null | undefined, empName: string | null | undefined): Observable<ContractEmployeeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetContractEmployeesForEdit?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (empName !== undefined && empName !== null)
            url_ += "empName=" + encodeURIComponent("" + empName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContractEmployeesForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContractEmployeesForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractEmployeeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractEmployeeDto[]>;
        }));
    }

    protected processGetContractEmployeesForEdit(response: HttpResponseBase): Observable<ContractEmployeeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContractEmployeeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContractEmployeeDto[]>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @return Success
     */
    deleteContractEmployees(monthYear: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/DeleteContractEmployees?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteContractEmployees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteContractEmployees(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteContractEmployees(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @return Success
     */
    checkIfMonthYearExists(monthYear: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Employees/CheckIfMonthYearExists?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfMonthYearExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfMonthYearExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckIfMonthYearExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param date (optional) 
     * @param sendInfoToAll (optional) 
     * @param departmentId (optional) 
     * @param branchId (optional) 
     * @param onlyBirthdayEmployees (optional) 
     * @param tenantId (optional) 
     * @param bithdayWiseMail (optional) 
     * @return Success
     */
    sendBirthdayEmails(date: moment.Moment | undefined, sendInfoToAll: boolean | undefined, departmentId: number | null | undefined, branchId: number | null | undefined, onlyBirthdayEmployees: boolean | undefined, tenantId: number | null | undefined, bithdayWiseMail: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/SendBirthdayEmails?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (sendInfoToAll === null)
            throw new Error("The parameter 'sendInfoToAll' cannot be null.");
        else if (sendInfoToAll !== undefined)
            url_ += "sendInfoToAll=" + encodeURIComponent("" + sendInfoToAll) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (branchId !== undefined && branchId !== null)
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&";
        if (onlyBirthdayEmployees === null)
            throw new Error("The parameter 'onlyBirthdayEmployees' cannot be null.");
        else if (onlyBirthdayEmployees !== undefined)
            url_ += "onlyBirthdayEmployees=" + encodeURIComponent("" + onlyBirthdayEmployees) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (bithdayWiseMail !== undefined && bithdayWiseMail !== null)
            url_ += "BithdayWiseMail=" + encodeURIComponent("" + bithdayWiseMail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendBirthdayEmails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendBirthdayEmails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendBirthdayEmails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    migrateInputFileTableDocuments(): Observable<MigrateDocumentsResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Employees/MigrateInputFileTableDocuments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMigrateInputFileTableDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMigrateInputFileTableDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MigrateDocumentsResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MigrateDocumentsResultDto>;
        }));
    }

    protected processMigrateInputFileTableDocuments(response: HttpResponseBase): Observable<MigrateDocumentsResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MigrateDocumentsResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MigrateDocumentsResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeesForAttendanceCorrectionAlert(): Observable<AttendanceCorrectionAlertEmployeeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetEmployeesForAttendanceCorrectionAlert";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeesForAttendanceCorrectionAlert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeesForAttendanceCorrectionAlert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendanceCorrectionAlertEmployeeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendanceCorrectionAlertEmployeeDto[]>;
        }));
    }

    protected processGetEmployeesForAttendanceCorrectionAlert(response: HttpResponseBase): Observable<AttendanceCorrectionAlertEmployeeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttendanceCorrectionAlertEmployeeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AttendanceCorrectionAlertEmployeeDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAttendanceCorrectionAlert(body: UpdateAttendanceCorrectionAlertInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/UpdateAttendanceCorrectionAlert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAttendanceCorrectionAlert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAttendanceCorrectionAlert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAttendanceCorrectionAlert(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    updateImeinumber(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/updateImeinumber?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateImeinumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateImeinumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateImeinumber(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    sendWhatsAppMessage(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/SendWhatsAppMessage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendWhatsAppMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendWhatsAppMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendWhatsAppMessage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param firstName (optional) 
     * @param lastName (optional) 
     * @param employeeCode (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllEmployeeSalaryData(filter: string | null | undefined, firstName: string | null | undefined, lastName: string | null | undefined, employeeCode: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetEmployeeForSalaryViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetAllEmployeeSalaryData?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (employeeCode !== undefined && employeeCode !== null)
            url_ += "EmployeeCode=" + encodeURIComponent("" + employeeCode) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEmployeeSalaryData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEmployeeSalaryData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetEmployeeForSalaryViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetEmployeeForSalaryViewDto>;
        }));
    }

    protected processGetAllEmployeeSalaryData(response: HttpResponseBase): Observable<PagedResultDtoOfGetEmployeeForSalaryViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEmployeeForSalaryViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEmployeeForSalaryViewDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSalary(body: GetEmployeeForSalaryViewDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/updateSalary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSalary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSalary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSalary(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getProbationEmployeeCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetProbationEmployeeCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProbationEmployeeCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProbationEmployeeCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetProbationEmployeeCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    totalEmployeeCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Employees/TotalEmployeeCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalEmployeeCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalEmployeeCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processTotalEmployeeCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param firstName (optional) 
     * @param lastName (optional) 
     * @param employeeName (optional) 
     * @param employeeCode (optional) 
     * @param email (optional) 
     * @param designation (optional) 
     * @param location (optional) 
     * @param department (optional) 
     * @param departmentName (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, firstName: string | null | undefined, lastName: string | null | undefined, employeeName: string | null | undefined, employeeCode: string | null | undefined, email: string | null | undefined, designation: number | null | undefined, location: number | null | undefined, department: number | null | undefined, departmentName: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetEmployeeForListViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (employeeName !== undefined && employeeName !== null)
            url_ += "EmployeeName=" + encodeURIComponent("" + employeeName) + "&";
        if (employeeCode !== undefined && employeeCode !== null)
            url_ += "EmployeeCode=" + encodeURIComponent("" + employeeCode) + "&";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (designation !== undefined && designation !== null)
            url_ += "Designation=" + encodeURIComponent("" + designation) + "&";
        if (location !== undefined && location !== null)
            url_ += "Location=" + encodeURIComponent("" + location) + "&";
        if (department !== undefined && department !== null)
            url_ += "Department=" + encodeURIComponent("" + department) + "&";
        if (departmentName !== undefined && departmentName !== null)
            url_ += "DepartmentName=" + encodeURIComponent("" + departmentName) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetEmployeeForListViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetEmployeeForListViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetEmployeeForListViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEmployeeForListViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEmployeeForListViewDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param firstName (optional) 
     * @param lastName (optional) 
     * @param employeeName (optional) 
     * @param employeeCode (optional) 
     * @param email (optional) 
     * @param designation (optional) 
     * @param location (optional) 
     * @param department (optional) 
     * @param departmentName (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllEmployeeForFaceReco(filter: string | null | undefined, firstName: string | null | undefined, lastName: string | null | undefined, employeeName: string | null | undefined, employeeCode: string | null | undefined, email: string | null | undefined, designation: number | null | undefined, location: number | null | undefined, department: number | null | undefined, departmentName: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetEmployeeForListViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetAllEmployeeForFaceReco?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (employeeName !== undefined && employeeName !== null)
            url_ += "EmployeeName=" + encodeURIComponent("" + employeeName) + "&";
        if (employeeCode !== undefined && employeeCode !== null)
            url_ += "EmployeeCode=" + encodeURIComponent("" + employeeCode) + "&";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (designation !== undefined && designation !== null)
            url_ += "Designation=" + encodeURIComponent("" + designation) + "&";
        if (location !== undefined && location !== null)
            url_ += "Location=" + encodeURIComponent("" + location) + "&";
        if (department !== undefined && department !== null)
            url_ += "Department=" + encodeURIComponent("" + department) + "&";
        if (departmentName !== undefined && departmentName !== null)
            url_ += "DepartmentName=" + encodeURIComponent("" + departmentName) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEmployeeForFaceReco(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEmployeeForFaceReco(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetEmployeeForListViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetEmployeeForListViewDto>;
        }));
    }

    protected processGetAllEmployeeForFaceReco(response: HttpResponseBase): Observable<PagedResultDtoOfGetEmployeeForListViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEmployeeForListViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEmployeeForListViewDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getEmployeesByTenant(tenantId: number | undefined): Observable<BasicEmployeeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetEmployeesByTenant?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeesByTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeesByTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BasicEmployeeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BasicEmployeeDto[]>;
        }));
    }

    protected processGetEmployeesByTenant(response: HttpResponseBase): Observable<BasicEmployeeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BasicEmployeeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BasicEmployeeDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllEmployeebyReportingManager(): Observable<TreeNode[]> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetAllEmployeebyReportingManager";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEmployeebyReportingManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEmployeebyReportingManager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TreeNode[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TreeNode[]>;
        }));
    }

    protected processGetAllEmployeebyReportingManager(response: HttpResponseBase): Observable<TreeNode[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreeNode.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreeNode[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param flag (optional) 
     * @param parentId (optional) 
     * @return Success
     */
    buildOrganisationChart(id: number | undefined, flag: boolean | undefined, parentId: number | undefined): Observable<TreeNode[]> {
        let url_ = this.baseUrl + "/api/services/app/Employees/BuildOrganisationChart?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (flag === null)
            throw new Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        if (parentId === null)
            throw new Error("The parameter 'parentId' cannot be null.");
        else if (parentId !== undefined)
            url_ += "ParentId=" + encodeURIComponent("" + parentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildOrganisationChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildOrganisationChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TreeNode[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TreeNode[]>;
        }));
    }

    protected processBuildOrganisationChart(response: HttpResponseBase): Observable<TreeNode[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreeNode.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreeNode[]>(null as any);
    }

    /**
     * @param imgName (optional) 
     * @param documentType (optional) 
     * @return Success
     */
    employeeImagesetup(imgName: string | null | undefined, documentType: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Employees/EmployeeImagesetup?";
        if (imgName !== undefined && imgName !== null)
            url_ += "ImgName=" + encodeURIComponent("" + imgName) + "&";
        if (documentType !== undefined && documentType !== null)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployeeImagesetup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployeeImagesetup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processEmployeeImagesetup(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param firstName (optional) 
     * @param lastName (optional) 
     * @param employeeName (optional) 
     * @param employeeCode (optional) 
     * @param email (optional) 
     * @param designation (optional) 
     * @param location (optional) 
     * @param department (optional) 
     * @param departmentName (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllEmployeeConfromation(filter: string | null | undefined, firstName: string | null | undefined, lastName: string | null | undefined, employeeName: string | null | undefined, employeeCode: string | null | undefined, email: string | null | undefined, designation: number | null | undefined, location: number | null | undefined, department: number | null | undefined, departmentName: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetEmployeeForListViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetAllEmployeeConfromation?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (employeeName !== undefined && employeeName !== null)
            url_ += "EmployeeName=" + encodeURIComponent("" + employeeName) + "&";
        if (employeeCode !== undefined && employeeCode !== null)
            url_ += "EmployeeCode=" + encodeURIComponent("" + employeeCode) + "&";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (designation !== undefined && designation !== null)
            url_ += "Designation=" + encodeURIComponent("" + designation) + "&";
        if (location !== undefined && location !== null)
            url_ += "Location=" + encodeURIComponent("" + location) + "&";
        if (department !== undefined && department !== null)
            url_ += "Department=" + encodeURIComponent("" + department) + "&";
        if (departmentName !== undefined && departmentName !== null)
            url_ += "DepartmentName=" + encodeURIComponent("" + departmentName) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEmployeeConfromation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEmployeeConfromation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetEmployeeForListViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetEmployeeForListViewDto>;
        }));
    }

    protected processGetAllEmployeeConfromation(response: HttpResponseBase): Observable<PagedResultDtoOfGetEmployeeForListViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEmployeeForListViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEmployeeForListViewDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param firstName (optional) 
     * @param lastName (optional) 
     * @param employeeName (optional) 
     * @param employeeCode (optional) 
     * @param email (optional) 
     * @param designation (optional) 
     * @param location (optional) 
     * @param department (optional) 
     * @param departmentName (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllEmployeeSeparation(filter: string | null | undefined, firstName: string | null | undefined, lastName: string | null | undefined, employeeName: string | null | undefined, employeeCode: string | null | undefined, email: string | null | undefined, designation: number | null | undefined, location: number | null | undefined, department: number | null | undefined, departmentName: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetEmployeeForListViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetAllEmployeeSeparation?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (employeeName !== undefined && employeeName !== null)
            url_ += "EmployeeName=" + encodeURIComponent("" + employeeName) + "&";
        if (employeeCode !== undefined && employeeCode !== null)
            url_ += "EmployeeCode=" + encodeURIComponent("" + employeeCode) + "&";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (designation !== undefined && designation !== null)
            url_ += "Designation=" + encodeURIComponent("" + designation) + "&";
        if (location !== undefined && location !== null)
            url_ += "Location=" + encodeURIComponent("" + location) + "&";
        if (department !== undefined && department !== null)
            url_ += "Department=" + encodeURIComponent("" + department) + "&";
        if (departmentName !== undefined && departmentName !== null)
            url_ += "DepartmentName=" + encodeURIComponent("" + departmentName) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEmployeeSeparation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEmployeeSeparation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetEmployeeForListViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetEmployeeForListViewDto>;
        }));
    }

    protected processGetAllEmployeeSeparation(response: HttpResponseBase): Observable<PagedResultDtoOfGetEmployeeForListViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEmployeeForListViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEmployeeForListViewDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param firstName (optional) 
     * @param lastName (optional) 
     * @param employeeName (optional) 
     * @param employeeCode (optional) 
     * @param email (optional) 
     * @param designation (optional) 
     * @param location (optional) 
     * @param department (optional) 
     * @param departmentName (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllEmployeeContracotr(filter: string | null | undefined, firstName: string | null | undefined, lastName: string | null | undefined, employeeName: string | null | undefined, employeeCode: string | null | undefined, email: string | null | undefined, designation: number | null | undefined, location: number | null | undefined, department: number | null | undefined, departmentName: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetEmployeeForListViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetAllEmployeeContracotr?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (employeeName !== undefined && employeeName !== null)
            url_ += "EmployeeName=" + encodeURIComponent("" + employeeName) + "&";
        if (employeeCode !== undefined && employeeCode !== null)
            url_ += "EmployeeCode=" + encodeURIComponent("" + employeeCode) + "&";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (designation !== undefined && designation !== null)
            url_ += "Designation=" + encodeURIComponent("" + designation) + "&";
        if (location !== undefined && location !== null)
            url_ += "Location=" + encodeURIComponent("" + location) + "&";
        if (department !== undefined && department !== null)
            url_ += "Department=" + encodeURIComponent("" + department) + "&";
        if (departmentName !== undefined && departmentName !== null)
            url_ += "DepartmentName=" + encodeURIComponent("" + departmentName) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEmployeeContracotr(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEmployeeContracotr(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetEmployeeForListViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetEmployeeForListViewDto>;
        }));
    }

    protected processGetAllEmployeeContracotr(response: HttpResponseBase): Observable<PagedResultDtoOfGetEmployeeForListViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEmployeeForListViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEmployeeForListViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEmployeeForView(id: number | undefined): Observable<GetEmployeeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetEmployeeForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmployeeForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmployeeForViewDto>;
        }));
    }

    protected processGetEmployeeForView(response: HttpResponseBase): Observable<GetEmployeeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmployeeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeeForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMyProfileEmployeeForView(id: number | undefined): Observable<GetEmployeeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetMyProfileEmployeeForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyProfileEmployeeForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyProfileEmployeeForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmployeeForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmployeeForViewDto>;
        }));
    }

    protected processGetMyProfileEmployeeForView(response: HttpResponseBase): Observable<GetEmployeeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmployeeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeeForViewDto>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeProfilePictureWithoutFTP(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetEmployeeProfilePictureWithoutFTP";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeProfilePictureWithoutFTP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeProfilePictureWithoutFTP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEmployeeProfilePictureWithoutFTP(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeProfilePicture(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetEmployeeProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEmployeeProfilePicture(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEmployeeForEdit(id: number | undefined): Observable<GetEmployeeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetEmployeeForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmployeeForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmployeeForEditOutput>;
        }));
    }

    protected processGetEmployeeForEdit(response: HttpResponseBase): Observable<GetEmployeeForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmployeeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeeForEditOutput>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeForEditUpdateEetails(): Observable<GetEmployeeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetEmployeeForEditUpdateEetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeForEditUpdateEetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeForEditUpdateEetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmployeeForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmployeeForEditOutput>;
        }));
    }

    protected processGetEmployeeForEditUpdateEetails(response: HttpResponseBase): Observable<GetEmployeeForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmployeeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeeForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEmployeeForEditUpdateEetailsApproval(id: number | undefined): Observable<GetEmployeeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetEmployeeForEditUpdateEetailsApproval?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeForEditUpdateEetailsApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeForEditUpdateEetailsApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmployeeForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmployeeForEditOutput>;
        }));
    }

    protected processGetEmployeeForEditUpdateEetailsApproval(response: HttpResponseBase): Observable<GetEmployeeForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmployeeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeeForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    save(body: CreateOrEditEmployeeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    getEmployeeStatusData(employeeId: number | undefined): Observable<EmployeeStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetEmployeeStatusData?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeStatusData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeStatusData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeStatusDto>;
        }));
    }

    protected processGetEmployeeStatusData(response: HttpResponseBase): Observable<EmployeeStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeStatusDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEmployeeStatus(body: EmployeeStatusDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/UpdateEmployeeStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEmployeeStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEmployeeStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateEmployeeStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditEmployeeDto | undefined): Observable<CreateOrEditEmployeeDto> {
        let url_ = this.baseUrl + "/api/services/app/Employees/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditEmployeeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditEmployeeDto>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<CreateOrEditEmployeeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditEmployeeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditEmployeeDto>(null as any);
    }

    /**
     * @param aadharCard (optional) 
     * @param panCard (optional) 
     * @param excludeEmployeeId (optional) 
     * @return Success
     */
    checkAadharOrPanDuplicate(aadharCard: string | null | undefined, panCard: string | null | undefined, excludeEmployeeId: number | null | undefined): Observable<AadharPanDuplicateResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Employees/CheckAadharOrPanDuplicate?";
        if (aadharCard !== undefined && aadharCard !== null)
            url_ += "aadharCard=" + encodeURIComponent("" + aadharCard) + "&";
        if (panCard !== undefined && panCard !== null)
            url_ += "panCard=" + encodeURIComponent("" + panCard) + "&";
        if (excludeEmployeeId !== undefined && excludeEmployeeId !== null)
            url_ += "excludeEmployeeId=" + encodeURIComponent("" + excludeEmployeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckAadharOrPanDuplicate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckAadharOrPanDuplicate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AadharPanDuplicateResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AadharPanDuplicateResultDto>;
        }));
    }

    protected processCheckAadharOrPanDuplicate(response: HttpResponseBase): Observable<AadharPanDuplicateResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AadharPanDuplicateResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AadharPanDuplicateResultDto>(null as any);
    }

    /**
     * @param attendanceDate (optional) 
     * @return Success
     */
    createAttendanceRecordfront(attendanceDate: moment.Moment | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/CreateAttendanceRecordfront?";
        if (attendanceDate === null)
            throw new Error("The parameter 'attendanceDate' cannot be null.");
        else if (attendanceDate !== undefined)
            url_ += "attendanceDate=" + encodeURIComponent(attendanceDate ? "" + attendanceDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAttendanceRecordfront(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAttendanceRecordfront(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateAttendanceRecordfront(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param firstNameFilter (optional) 
     * @param middleNameFilter (optional) 
     * @param maxMobileNoFilter (optional) 
     * @param minMobileNoFilter (optional) 
     * @param maxCurrentCountryIdFilter (optional) 
     * @param minCurrentCountryIdFilter (optional) 
     * @param status (optional) 
     * @return Success
     */
    getEmployeesToExcel(filter: string | null | undefined, firstNameFilter: string | null | undefined, middleNameFilter: string | null | undefined, maxMobileNoFilter: number | null | undefined, minMobileNoFilter: number | null | undefined, maxCurrentCountryIdFilter: number | null | undefined, minCurrentCountryIdFilter: number | null | undefined, status: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetEmployeesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (firstNameFilter !== undefined && firstNameFilter !== null)
            url_ += "FirstNameFilter=" + encodeURIComponent("" + firstNameFilter) + "&";
        if (middleNameFilter !== undefined && middleNameFilter !== null)
            url_ += "MiddleNameFilter=" + encodeURIComponent("" + middleNameFilter) + "&";
        if (maxMobileNoFilter !== undefined && maxMobileNoFilter !== null)
            url_ += "MaxMobileNoFilter=" + encodeURIComponent("" + maxMobileNoFilter) + "&";
        if (minMobileNoFilter !== undefined && minMobileNoFilter !== null)
            url_ += "MinMobileNoFilter=" + encodeURIComponent("" + minMobileNoFilter) + "&";
        if (maxCurrentCountryIdFilter !== undefined && maxCurrentCountryIdFilter !== null)
            url_ += "MaxCurrentCountryIdFilter=" + encodeURIComponent("" + maxCurrentCountryIdFilter) + "&";
        if (minCurrentCountryIdFilter !== undefined && minCurrentCountryIdFilter !== null)
            url_ += "MinCurrentCountryIdFilter=" + encodeURIComponent("" + minCurrentCountryIdFilter) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetEmployeesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param employeeCode (optional) 
     * @param email (optional) 
     * @param mobileNumber (optional) 
     * @param boimetric (optional) 
     * @param id (optional) 
     * @return Success
     */
    validaation(employeeCode: string | null | undefined, email: string | null | undefined, mobileNumber: string | null | undefined, boimetric: string | null | undefined, id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/validaation?";
        if (employeeCode !== undefined && employeeCode !== null)
            url_ += "employeeCode=" + encodeURIComponent("" + employeeCode) + "&";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (mobileNumber !== undefined && mobileNumber !== null)
            url_ += "MobileNumber=" + encodeURIComponent("" + mobileNumber) + "&";
        if (boimetric !== undefined && boimetric !== null)
            url_ += "boimetric=" + encodeURIComponent("" + boimetric) + "&";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidaation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidaation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidaation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param employeeCode (optional) 
     * @param email (optional) 
     * @param mobileNumber (optional) 
     * @param boimetric (optional) 
     * @param id (optional) 
     * @return Success
     */
    validation(employeeCode: string | null | undefined, email: string | null | undefined, mobileNumber: string | null | undefined, boimetric: string | null | undefined, id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/validation?";
        if (employeeCode !== undefined && employeeCode !== null)
            url_ += "employeeCode=" + encodeURIComponent("" + employeeCode) + "&";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (mobileNumber !== undefined && mobileNumber !== null)
            url_ += "MobileNumber=" + encodeURIComponent("" + mobileNumber) + "&";
        if (boimetric !== undefined && boimetric !== null)
            url_ += "boimetric=" + encodeURIComponent("" + boimetric) + "&";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    manulaEnableSelfService(body: CreateNewManualPassword | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/ManulaEnableSelfService";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processManulaEnableSelfService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processManulaEnableSelfService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processManulaEnableSelfService(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getManualForEdit(id: number | undefined): Observable<GetManualForEdit> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetManualForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManualForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManualForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetManualForEdit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetManualForEdit>;
        }));
    }

    protected processGetManualForEdit(response: HttpResponseBase): Observable<GetManualForEdit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetManualForEdit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetManualForEdit>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getManualSMSForEdit(id: number | undefined): Observable<GetManualSMSForEdit> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetManualSMSForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManualSMSForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManualSMSForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetManualSMSForEdit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetManualSMSForEdit>;
        }));
    }

    protected processGetManualSMSForEdit(response: HttpResponseBase): Observable<GetManualSMSForEdit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetManualSMSForEdit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetManualSMSForEdit>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    smsEnableSelfService(body: CreateNewManualSMSPassword | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/SmsEnableSelfService";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSmsEnableSelfService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSmsEnableSelfService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSmsEnableSelfService(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAbpUser(body: User | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/CreateAbpUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAbpUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAbpUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateAbpUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    enableSelfServiceList(body: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/EnableSelfServiceList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableSelfServiceList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableSelfServiceList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEnableSelfServiceList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    enableSelfService(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/EnableSelfService?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableSelfService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableSelfService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEnableSelfService(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    generateEmpCode(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GenerateEmpCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateEmpCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateEmpCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateEmpCode(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeEditable(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetEmployeeEditable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeEditable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeEditable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetEmployeeEditable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return Success
     */
    getTenantMrrExists(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetTenantMrrExists";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantMrrExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantMrrExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetTenantMrrExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeDimensionDropdown(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetEmployeeDimensionDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeDimensionDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeDimensionDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetEmployeeDimensionDropdown(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param directoryPath (optional) 
     * @param ftpUser (optional) 
     * @param ftpPassword (optional) 
     * @return Success
     */
    ftpDirectoryExists(directoryPath: string | null | undefined, ftpUser: string | null | undefined, ftpPassword: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Employees/FtpDirectoryExists?";
        if (directoryPath !== undefined && directoryPath !== null)
            url_ += "directoryPath=" + encodeURIComponent("" + directoryPath) + "&";
        if (ftpUser !== undefined && ftpUser !== null)
            url_ += "ftpUser=" + encodeURIComponent("" + ftpUser) + "&";
        if (ftpPassword !== undefined && ftpPassword !== null)
            url_ += "ftpPassword=" + encodeURIComponent("" + ftpPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFtpDirectoryExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFtpDirectoryExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processFtpDirectoryExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param imageName (optional) 
     * @param body (optional) 
     * @return Success
     */
    saveFtbImageServer(imageName: string | null | undefined, body: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Employees/SaveFtbImageServer?";
        if (imageName !== undefined && imageName !== null)
            url_ += "ImageName=" + encodeURIComponent("" + imageName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveFtbImageServer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveFtbImageServer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveFtbImageServer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveFtbServer(body: FtbImage | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Employees/SaveFtbServer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveFtbServer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveFtbServer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveFtbServer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param imgName (optional) 
     * @param fileName (optional) 
     * @return Success
     */
    downLoadFileTemplete(imgName: string | null | undefined, fileName: string | null | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employees/DownLoadFileTemplete?";
        if (imgName !== undefined && imgName !== null)
            url_ += "ImgName=" + encodeURIComponent("" + imgName) + "&";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownLoadFileTemplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownLoadFileTemplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processDownLoadFileTemplete(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param imgName (optional) 
     * @param documentType (optional) 
     * @return Success
     */
    downLoadFile(imgName: string | null | undefined, documentType: string | null | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employees/DownLoadFile?";
        if (imgName !== undefined && imgName !== null)
            url_ += "ImgName=" + encodeURIComponent("" + imgName) + "&";
        if (documentType !== undefined && documentType !== null)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownLoadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownLoadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processDownLoadFile(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param imgName (optional) 
     * @param documentType (optional) 
     * @return Success
     */
    editDownloadFile(imgName: string | null | undefined, documentType: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Employees/EditDownloadFile?";
        if (imgName !== undefined && imgName !== null)
            url_ += "ImgName=" + encodeURIComponent("" + imgName) + "&";
        if (documentType !== undefined && documentType !== null)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processEditDownloadFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    getBlankEmployeeExcelFormat(): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetBlankEmployeeExcelFormat";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBlankEmployeeExcelFormat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBlankEmployeeExcelFormat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetBlankEmployeeExcelFormat(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getBulkEmployeeExcelFormat(): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetBulkEmployeeExcelFormat";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBulkEmployeeExcelFormat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBulkEmployeeExcelFormat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetBulkEmployeeExcelFormat(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getBulkEmployeeSalaryExcelFormat(): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetBulkEmployeeSalaryExcelFormat";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBulkEmployeeSalaryExcelFormat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBulkEmployeeSalaryExcelFormat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetBulkEmployeeSalaryExcelFormat(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getBulkEmployeeIncreamentExcelFormat(): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetBulkEmployeeIncreamentExcelFormat";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBulkEmployeeIncreamentExcelFormat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBulkEmployeeIncreamentExcelFormat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetBulkEmployeeIncreamentExcelFormat(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importEmployeeDependentBlankFormat(body: EmployeeInputeFileDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/ImportEmployeeDependentBlankFormat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportEmployeeDependentBlankFormat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportEmployeeDependentBlankFormat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportEmployeeDependentBlankFormat(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getBlankEmployeeDependentsExcelFormat(): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetBlankEmployeeDependentsExcelFormat";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBlankEmployeeDependentsExcelFormat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBlankEmployeeDependentsExcelFormat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetBlankEmployeeDependentsExcelFormat(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getBlankEmployeeQualificationsExcelFormat(): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetBlankEmployeeQualificationsExcelFormat";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBlankEmployeeQualificationsExcelFormat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBlankEmployeeQualificationsExcelFormat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetBlankEmployeeQualificationsExcelFormat(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importEmployeeQualificationsBlankFormat(body: EmployeeInputeFileDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/ImportEmployeeQualificationsBlankFormat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportEmployeeQualificationsBlankFormat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportEmployeeQualificationsBlankFormat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportEmployeeQualificationsBlankFormat(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importEmployeeCreate(body: CreateOrEditEmployeeDtoPort[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/ImportEmployeeCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportEmployeeCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportEmployeeCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportEmployeeCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param skipBatchClear (optional) 
     * @param body (optional) 
     * @return Success
     */
    importEmployeeCreateBlankFormat(skipBatchClear: boolean | undefined, body: EmployeeInputeFileDto | undefined): Observable<ErrorFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Employees/ImportEmployeeCreateBlankFormat?";
        if (skipBatchClear === null)
            throw new Error("The parameter 'skipBatchClear' cannot be null.");
        else if (skipBatchClear !== undefined)
            url_ += "skipBatchClear=" + encodeURIComponent("" + skipBatchClear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportEmployeeCreateBlankFormat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportEmployeeCreateBlankFormat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErrorFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErrorFileDto>;
        }));
    }

    protected processImportEmployeeCreateBlankFormat(response: HttpResponseBase): Observable<ErrorFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ErrorFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ErrorFileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveRejectedEmployeeRowEdits(body: ImportRejectedEmployeeRowUpdateDto[] | null | undefined): Observable<ImportRejectedEmployeeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employees/SaveRejectedEmployeeRowEdits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveRejectedEmployeeRowEdits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveRejectedEmployeeRowEdits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportRejectedEmployeeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportRejectedEmployeeDto[]>;
        }));
    }

    protected processSaveRejectedEmployeeRowEdits(response: HttpResponseBase): Observable<ImportRejectedEmployeeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImportRejectedEmployeeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportRejectedEmployeeDto[]>(null as any);
    }

    /**
     * @param batchId (optional) 
     * @return Success
     */
    getRejectedEmployeeRows(batchId: string | null | undefined): Observable<ImportRejectedEmployeeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetRejectedEmployeeRows?";
        if (batchId !== undefined && batchId !== null)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRejectedEmployeeRows(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRejectedEmployeeRows(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportRejectedEmployeeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportRejectedEmployeeDto[]>;
        }));
    }

    protected processGetRejectedEmployeeRows(response: HttpResponseBase): Observable<ImportRejectedEmployeeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImportRejectedEmployeeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportRejectedEmployeeDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getPendingImportBatches(): Observable<PendingImportBatchDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetPendingImportBatches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingImportBatches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingImportBatches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingImportBatchDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingImportBatchDto[]>;
        }));
    }

    protected processGetPendingImportBatches(response: HttpResponseBase): Observable<PendingImportBatchDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PendingImportBatchDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PendingImportBatchDto[]>(null as any);
    }

    /**
     * @param batchId (optional) 
     * @return Success
     */
    cancelImportBatch(batchId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/CancelImportBatch?";
        if (batchId !== undefined && batchId !== null)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelImportBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelImportBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelImportBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    cancelRejectedRow(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/CancelRejectedRow?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelRejectedRow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelRejectedRow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelRejectedRow(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param batchId (optional) 
     * @param body (optional) 
     * @return Success
     */
    reprocessRejectedEmployeeRows(batchId: string | null | undefined, body: ImportRejectedEmployeeRowUpdateDto[] | null | undefined): Observable<ErrorFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Employees/ReprocessRejectedEmployeeRows?";
        if (batchId !== undefined && batchId !== null)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReprocessRejectedEmployeeRows(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReprocessRejectedEmployeeRows(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErrorFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErrorFileDto>;
        }));
    }

    protected processReprocessRejectedEmployeeRows(response: HttpResponseBase): Observable<ErrorFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ErrorFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ErrorFileDto>(null as any);
    }

    /**
     * @param banknamess (optional) 
     * @param branchnamess (optional) 
     * @param data (optional) 
     * @param accountnumber (optional) 
     * @param ifsccode (optional) 
     * @return Success
     */
    createbankdetails(banknamess: string | null | undefined, branchnamess: string | null | undefined, data: number | undefined, accountnumber: string | null | undefined, ifsccode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/createbankdetails?";
        if (banknamess !== undefined && banknamess !== null)
            url_ += "banknamess=" + encodeURIComponent("" + banknamess) + "&";
        if (branchnamess !== undefined && branchnamess !== null)
            url_ += "branchnamess=" + encodeURIComponent("" + branchnamess) + "&";
        if (data === null)
            throw new Error("The parameter 'data' cannot be null.");
        else if (data !== undefined)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        if (accountnumber !== undefined && accountnumber !== null)
            url_ += "accountnumber=" + encodeURIComponent("" + accountnumber) + "&";
        if (ifsccode !== undefined && ifsccode !== null)
            url_ += "ifsccode=" + encodeURIComponent("" + ifsccode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatebankdetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatebankdetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreatebankdetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getBlankEmployeeLeaveRequestExcelFormat(): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetBlankEmployeeLeaveRequestExcelFormat";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBlankEmployeeLeaveRequestExcelFormat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBlankEmployeeLeaveRequestExcelFormat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetBlankEmployeeLeaveRequestExcelFormat(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importLeaveRequest(body: EmployeeInputeFileDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/ImportLeaveRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportLeaveRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportLeaveRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportLeaveRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class EmployeeSalaryComponentsesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    getOTRateForEmployee(employeeId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/GetOTRateForEmployee?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOTRateForEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOTRateForEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetOTRateForEmployee(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @param employeeid (optional) 
     * @param leaveType (optional) 
     * @return Success
     */
    getUsedLeaveForAMonth(month: number | undefined, year: number | undefined, employeeid: number | undefined, leaveType: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/GetUsedLeaveForAMonth?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        if (leaveType !== undefined && leaveType !== null)
            url_ += "leaveType=" + encodeURIComponent("" + leaveType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsedLeaveForAMonth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsedLeaveForAMonth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetUsedLeaveForAMonth(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @param employeeid (optional) 
     * @return Success
     */
    getLeaveBalanceDetailsForSalarySlip(month: number | undefined, year: number | undefined, employeeid: number | undefined): Observable<LeaveDetailsForSalarySlip[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/GetLeaveBalanceDetailsForSalarySlip?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveBalanceDetailsForSalarySlip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveBalanceDetailsForSalarySlip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveDetailsForSalarySlip[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveDetailsForSalarySlip[]>;
        }));
    }

    protected processGetLeaveBalanceDetailsForSalarySlip(response: HttpResponseBase): Observable<LeaveDetailsForSalarySlip[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LeaveDetailsForSalarySlip.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveDetailsForSalarySlip[]>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param employeeId (optional) 
     * @return Success
     */
    getEmployeeSalary(monthYear: string | null | undefined, employeeId: number | null | undefined): Observable<EmployeeSalaryReportData> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/GetEmployeeSalary?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "MonthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (employeeId !== undefined && employeeId !== null)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeSalary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeSalary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeSalaryReportData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeSalaryReportData>;
        }));
    }

    protected processGetEmployeeSalary(response: HttpResponseBase): Observable<EmployeeSalaryReportData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeSalaryReportData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeSalaryReportData>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param employeeid (optional) 
     * @return Success
     */
    generatePdfSalarySlip(monthYear: string | null | undefined, employeeid: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/GeneratePdfSalarySlip?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "MonthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "Employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneratePdfSalarySlip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratePdfSalarySlip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGeneratePdfSalarySlip(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param employeeId (optional) 
     * @return Success
     */
    getSalaryRegisterPdf(monthYear: string | null | undefined, employeeId: number | undefined): Observable<SalaryRegisterPdfReportData[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/GetSalaryRegisterPdf?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "MonthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalaryRegisterPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalaryRegisterPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalaryRegisterPdfReportData[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalaryRegisterPdfReportData[]>;
        }));
    }

    protected processGetSalaryRegisterPdf(response: HttpResponseBase): Observable<SalaryRegisterPdfReportData[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalaryRegisterPdfReportData.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SalaryRegisterPdfReportData[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxPayComponetFilter (optional) 
     * @param minPayComponetFilter (optional) 
     * @param maxAmountFilter (optional) 
     * @param minAmountFilter (optional) 
     * @param approvalFilter (optional) 
     * @param statusFilter (optional) 
     * @param employeeEmployeeCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxPayComponetFilter: number | null | undefined, minPayComponetFilter: number | null | undefined, maxAmountFilter: number | null | undefined, minAmountFilter: number | null | undefined, approvalFilter: number | null | undefined, statusFilter: string | null | undefined, employeeEmployeeCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetEmployeeSalaryComponentsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxPayComponetFilter !== undefined && maxPayComponetFilter !== null)
            url_ += "MaxPayComponetFilter=" + encodeURIComponent("" + maxPayComponetFilter) + "&";
        if (minPayComponetFilter !== undefined && minPayComponetFilter !== null)
            url_ += "MinPayComponetFilter=" + encodeURIComponent("" + minPayComponetFilter) + "&";
        if (maxAmountFilter !== undefined && maxAmountFilter !== null)
            url_ += "MaxAmountFilter=" + encodeURIComponent("" + maxAmountFilter) + "&";
        if (minAmountFilter !== undefined && minAmountFilter !== null)
            url_ += "MinAmountFilter=" + encodeURIComponent("" + minAmountFilter) + "&";
        if (approvalFilter !== undefined && approvalFilter !== null)
            url_ += "ApprovalFilter=" + encodeURIComponent("" + approvalFilter) + "&";
        if (statusFilter !== undefined && statusFilter !== null)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (employeeEmployeeCodeFilter !== undefined && employeeEmployeeCodeFilter !== null)
            url_ += "EmployeeEmployeeCodeFilter=" + encodeURIComponent("" + employeeEmployeeCodeFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetEmployeeSalaryComponentsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetEmployeeSalaryComponentsForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetEmployeeSalaryComponentsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEmployeeSalaryComponentsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEmployeeSalaryComponentsForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEmployeeSalaryComponentsForView(id: number | undefined): Observable<GetEmployeeSalaryComponentsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/GetEmployeeSalaryComponentsForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeSalaryComponentsForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeSalaryComponentsForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmployeeSalaryComponentsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmployeeSalaryComponentsForViewDto>;
        }));
    }

    protected processGetEmployeeSalaryComponentsForView(response: HttpResponseBase): Observable<GetEmployeeSalaryComponentsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmployeeSalaryComponentsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeeSalaryComponentsForViewDto>(null as any);
    }

    /**
     * @param emp (optional) 
     * @param monthYear (optional) 
     * @return Success
     */
    getEmployeeSalaryComponentsForViewInAssignSalary(emp: number | undefined, monthYear: string | null | undefined): Observable<PaySalaryComponetStructure[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/GetEmployeeSalaryComponentsForViewInAssignSalary?";
        if (emp === null)
            throw new Error("The parameter 'emp' cannot be null.");
        else if (emp !== undefined)
            url_ += "Emp=" + encodeURIComponent("" + emp) + "&";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeSalaryComponentsForViewInAssignSalary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeSalaryComponentsForViewInAssignSalary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaySalaryComponetStructure[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaySalaryComponetStructure[]>;
        }));
    }

    protected processGetEmployeeSalaryComponentsForViewInAssignSalary(response: HttpResponseBase): Observable<PaySalaryComponetStructure[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaySalaryComponetStructure.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaySalaryComponetStructure[]>(null as any);
    }

    /**
     * @param emp (optional) 
     * @return Success
     */
    getEmployeeSalaryComponentsForEdit(emp: number | undefined): Observable<PaySalaryComponetStructure[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/GetEmployeeSalaryComponentsForEdit?";
        if (emp === null)
            throw new Error("The parameter 'emp' cannot be null.");
        else if (emp !== undefined)
            url_ += "Emp=" + encodeURIComponent("" + emp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeSalaryComponentsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeSalaryComponentsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaySalaryComponetStructure[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaySalaryComponetStructure[]>;
        }));
    }

    protected processGetEmployeeSalaryComponentsForEdit(response: HttpResponseBase): Observable<PaySalaryComponetStructure[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaySalaryComponetStructure.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaySalaryComponetStructure[]>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeSalaryApprove(): Observable<PaySalaryComponetApprove[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/GetEmployeeSalaryApprove";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeSalaryApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeSalaryApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaySalaryComponetApprove[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaySalaryComponetApprove[]>;
        }));
    }

    protected processGetEmployeeSalaryApprove(response: HttpResponseBase): Observable<PaySalaryComponetApprove[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaySalaryComponetApprove.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaySalaryComponetApprove[]>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    getEmployeeSalarycomponentForEdit(employeeId: number | undefined): Observable<GetEmployeeSalaryComponentsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/GetEmployeeSalarycomponentForEdit?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeSalarycomponentForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeSalarycomponentForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmployeeSalaryComponentsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmployeeSalaryComponentsForEditOutput>;
        }));
    }

    protected processGetEmployeeSalarycomponentForEdit(response: HttpResponseBase): Observable<GetEmployeeSalaryComponentsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmployeeSalaryComponentsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeeSalaryComponentsForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditEmployeeSalaryComponentsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approveEmployeeSalaryStructure(body: CreateOrEditEmployeeSalaryComponentsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/ApproveEmployeeSalaryStructure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveEmployeeSalaryStructure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveEmployeeSalaryStructure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApproveEmployeeSalaryStructure(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxPayComponetFilter (optional) 
     * @param minPayComponetFilter (optional) 
     * @param maxAmountFilter (optional) 
     * @param minAmountFilter (optional) 
     * @param approvalFilter (optional) 
     * @param statusFilter (optional) 
     * @param employeeEmployeeCodeFilter (optional) 
     * @return Success
     */
    getEmployeeSalaryComponentsesToExcel(filter: string | null | undefined, maxPayComponetFilter: number | null | undefined, minPayComponetFilter: number | null | undefined, maxAmountFilter: number | null | undefined, minAmountFilter: number | null | undefined, approvalFilter: number | null | undefined, statusFilter: string | null | undefined, employeeEmployeeCodeFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/GetEmployeeSalaryComponentsesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxPayComponetFilter !== undefined && maxPayComponetFilter !== null)
            url_ += "MaxPayComponetFilter=" + encodeURIComponent("" + maxPayComponetFilter) + "&";
        if (minPayComponetFilter !== undefined && minPayComponetFilter !== null)
            url_ += "MinPayComponetFilter=" + encodeURIComponent("" + minPayComponetFilter) + "&";
        if (maxAmountFilter !== undefined && maxAmountFilter !== null)
            url_ += "MaxAmountFilter=" + encodeURIComponent("" + maxAmountFilter) + "&";
        if (minAmountFilter !== undefined && minAmountFilter !== null)
            url_ += "MinAmountFilter=" + encodeURIComponent("" + minAmountFilter) + "&";
        if (approvalFilter !== undefined && approvalFilter !== null)
            url_ += "ApprovalFilter=" + encodeURIComponent("" + approvalFilter) + "&";
        if (statusFilter !== undefined && statusFilter !== null)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (employeeEmployeeCodeFilter !== undefined && employeeEmployeeCodeFilter !== null)
            url_ += "EmployeeEmployeeCodeFilter=" + encodeURIComponent("" + employeeEmployeeCodeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeSalaryComponentsesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeSalaryComponentsesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetEmployeeSalaryComponentsesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @return Success
     */
    getPayGrades(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/GetPayGrades";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayGrades(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayGrades(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetPayGrades(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param payGrade (optional) 
     * @return Success
     */
    getPayComponetList(payGrade: number | undefined): Observable<PaySalaryComponetStructure[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/GetPayComponetList?";
        if (payGrade === null)
            throw new Error("The parameter 'payGrade' cannot be null.");
        else if (payGrade !== undefined)
            url_ += "PayGrade=" + encodeURIComponent("" + payGrade) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayComponetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayComponetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaySalaryComponetStructure[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaySalaryComponetStructure[]>;
        }));
    }

    protected processGetPayComponetList(response: HttpResponseBase): Observable<PaySalaryComponetStructure[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaySalaryComponetStructure.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaySalaryComponetStructure[]>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    salayAlreadyAssign(employeeId: number | undefined): Observable<SalaryAndJoinDateDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/SalayAlreadyAssign?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalayAlreadyAssign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalayAlreadyAssign(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalaryAndJoinDateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalaryAndJoinDateDto>;
        }));
    }

    protected processSalayAlreadyAssign(response: HttpResponseBase): Observable<SalaryAndJoinDateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalaryAndJoinDateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SalaryAndJoinDateDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateCandidateOfferLetter(body: GetCandidateForViewDto | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/GenerateCandidateOfferLetter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateCandidateOfferLetter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateCandidateOfferLetter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGenerateCandidateOfferLetter(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param empEMail (optional) 
     * @param subject (optional) 
     * @param body (optional) 
     * @param filepath (optional) 
     * @param isHtml (optional) 
     * @return Success
     */
    sendAttachementMail(empEMail: string | null | undefined, subject: string | null | undefined, body: string | null | undefined, filepath: string | null | undefined, isHtml: boolean | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/SendAttachementMail?";
        if (empEMail !== undefined && empEMail !== null)
            url_ += "empEMail=" + encodeURIComponent("" + empEMail) + "&";
        if (subject !== undefined && subject !== null)
            url_ += "Subject=" + encodeURIComponent("" + subject) + "&";
        if (body !== undefined && body !== null)
            url_ += "Body=" + encodeURIComponent("" + body) + "&";
        if (filepath !== undefined && filepath !== null)
            url_ += "Filepath=" + encodeURIComponent("" + filepath) + "&";
        if (isHtml === null)
            throw new Error("The parameter 'isHtml' cannot be null.");
        else if (isHtml !== undefined)
            url_ += "isHtml=" + encodeURIComponent("" + isHtml) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAttachementMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAttachementMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSendAttachementMail(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateOfferLetter(body: GetEmployeeForListViewDto | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/GenerateOfferLetter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateOfferLetter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateOfferLetter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGenerateOfferLetter(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendOfferLetter(body: GetEmployeeForListViewDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/SendOfferLetter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendOfferLetter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendOfferLetter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSendOfferLetter(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    generatePromotionLetterbyemployeeId(id: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/GeneratePromotionLetterbyemployeeId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneratePromotionLetterbyemployeeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratePromotionLetterbyemployeeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGeneratePromotionLetterbyemployeeId(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    sendPromotionLetterbyemployeeId(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/SendPromotionLetterbyemployeeId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPromotionLetterbyemployeeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPromotionLetterbyemployeeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSendPromotionLetterbyemployeeId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateExperienceLetter(body: GetEmployeeForListViewDto | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/GenerateExperienceLetter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateExperienceLetter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateExperienceLetter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGenerateExperienceLetter(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendExperienceLetter(body: GetEmployeeForListViewDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/SendExperienceLetter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendExperienceLetter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendExperienceLetter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSendExperienceLetter(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateRelievingLetter(body: GetEmployeeForListViewDto | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/GenerateRelievingLetter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateRelievingLetter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateRelievingLetter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGenerateRelievingLetter(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendRelievingLetter(body: GetEmployeeForListViewDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/SendRelievingLetter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendRelievingLetter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendRelievingLetter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSendRelievingLetter(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateAppotimentLetter(body: GetEmployeeForListViewDto | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/GenerateAppotimentLetter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateAppotimentLetter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateAppotimentLetter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGenerateAppotimentLetter(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendGenerateAppotimentLetter(body: GetEmployeeForListViewDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/SendGenerateAppotimentLetter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendGenerateAppotimentLetter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendGenerateAppotimentLetter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSendGenerateAppotimentLetter(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateConformationLetter(body: GetEmployeeForListViewDto | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/GenerateConformationLetter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateConformationLetter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateConformationLetter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGenerateConformationLetter(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendConformationLetter(body: GetEmployeeForListViewDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/SendConformationLetter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendConformationLetter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendConformationLetter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSendConformationLetter(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateResignationLetter(body: GetEmployeeForListViewDto | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/GenerateResignationLetter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateResignationLetter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateResignationLetter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGenerateResignationLetter(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendResignationLetter(body: GetEmployeeForListViewDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/SendResignationLetter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendResignationLetter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendResignationLetter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSendResignationLetter(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateIncrementLetter(body: GetEmployeeForListViewDto | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/GenerateIncrementLetter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateIncrementLetter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateIncrementLetter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGenerateIncrementLetter(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendIncrementLetter(body: GetEmployeeForListViewDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/SendIncrementLetter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendIncrementLetter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendIncrementLetter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSendIncrementLetter(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @param employeeid (optional) 
     * @return Success
     */
    getLeaveDetails(month: number | undefined, year: number | undefined, employeeid: number | undefined): Observable<LeaveBlanceByTypeDetails> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/GetLeaveDetails?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveBlanceByTypeDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveBlanceByTypeDetails>;
        }));
    }

    protected processGetLeaveDetails(response: HttpResponseBase): Observable<LeaveBlanceByTypeDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeaveBlanceByTypeDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveBlanceByTypeDetails>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @param employeeid (optional) 
     * @return Success
     */
    getLeaveData(month: number | undefined, year: number | undefined, employeeid: number | undefined): Observable<LeaveBalanceList[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/GetLeaveData?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveBalanceList[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveBalanceList[]>;
        }));
    }

    protected processGetLeaveData(response: HttpResponseBase): Observable<LeaveBalanceList[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LeaveBalanceList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveBalanceList[]>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @param employeeid (optional) 
     * @return Success
     */
    getLeaveBalanceStatistics(month: number | undefined, year: number | undefined, employeeid: number | undefined): Observable<GetBalanceDtaDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/GetLeaveBalanceStatistics?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveBalanceStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveBalanceStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBalanceDtaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBalanceDtaDto>;
        }));
    }

    protected processGetLeaveBalanceStatistics(response: HttpResponseBase): Observable<GetBalanceDtaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBalanceDtaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBalanceDtaDto>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param empid (optional) 
     * @return Success
     */
    getSalaryStatmentForApi(monthYear: string | null | undefined, empid: number | undefined): Observable<SalaryRegisterPdfReportData[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSalaryComponentses/GetSalaryStatmentForApi?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "MonthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (empid === null)
            throw new Error("The parameter 'empid' cannot be null.");
        else if (empid !== undefined)
            url_ += "Empid=" + encodeURIComponent("" + empid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalaryStatmentForApi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalaryStatmentForApi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalaryRegisterPdfReportData[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalaryRegisterPdfReportData[]>;
        }));
    }

    protected processGetSalaryStatmentForApi(response: HttpResponseBase): Observable<SalaryRegisterPdfReportData[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalaryRegisterPdfReportData.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SalaryRegisterPdfReportData[]>(null as any);
    }
}

@Injectable()
export class EmployeeStateInsuranceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxAccountno01Filter (optional) 
     * @param minAccountno01Filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxAccountno01Filter: number | null | undefined, minAccountno01Filter: number | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetEmployeeStateInsuranceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeStateInsurance/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxAccountno01Filter !== undefined && maxAccountno01Filter !== null)
            url_ += "MaxAccountno01Filter=" + encodeURIComponent("" + maxAccountno01Filter) + "&";
        if (minAccountno01Filter !== undefined && minAccountno01Filter !== null)
            url_ += "MinAccountno01Filter=" + encodeURIComponent("" + minAccountno01Filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetEmployeeStateInsuranceForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetEmployeeStateInsuranceForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetEmployeeStateInsuranceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEmployeeStateInsuranceForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEmployeeStateInsuranceForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEmployeeStateInsuranceForView(id: number | undefined): Observable<GetEmployeeStateInsuranceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeStateInsurance/GetEmployeeStateInsuranceForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeStateInsuranceForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeStateInsuranceForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmployeeStateInsuranceForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmployeeStateInsuranceForViewDto>;
        }));
    }

    protected processGetEmployeeStateInsuranceForView(response: HttpResponseBase): Observable<GetEmployeeStateInsuranceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmployeeStateInsuranceForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeeStateInsuranceForViewDto>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeStateInsuranceForEdit(): Observable<GetEmployeeStateInsuranceForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeStateInsurance/GetEmployeeStateInsuranceForEdit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeStateInsuranceForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeStateInsuranceForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmployeeStateInsuranceForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmployeeStateInsuranceForEditOutput>;
        }));
    }

    protected processGetEmployeeStateInsuranceForEdit(response: HttpResponseBase): Observable<GetEmployeeStateInsuranceForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmployeeStateInsuranceForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeeStateInsuranceForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditEmployeeStateInsuranceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeStateInsurance/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeStateInsurance/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class EmployeeVPFServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetEmployeeVPFViewListDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeVPF/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetEmployeeVPFViewListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetEmployeeVPFViewListDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetEmployeeVPFViewListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEmployeeVPFViewListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEmployeeVPFViewListDto>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @param vpfAmt (optional) 
     * @return Success
     */
    updateVPF(employeeId: number | undefined, vpfAmt: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeVPF/UpdateVPF?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (vpfAmt !== undefined && vpfAmt !== null)
            url_ += "vpfAmt=" + encodeURIComponent("" + vpfAmt) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateVPF(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVPF(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateVPF(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    getEmployeeVPFForEdit(employeeId: number | undefined): Observable<GetEmployeeVPFViewListDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeVPF/GetEmployeeVPFForEdit?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeVPFForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeVPFForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmployeeVPFViewListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmployeeVPFViewListDto>;
        }));
    }

    protected processGetEmployeeVPFForEdit(response: HttpResponseBase): Observable<GetEmployeeVPFViewListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmployeeVPFViewListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeeVPFViewListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeVPF/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    syncEmployeeVPFPortedSheet(body: EmployeeVPFportedAttendance | undefined): Observable<EmployeeVPFportAlreadyExits[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeVPF/SyncEmployeeVPFPortedSheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncEmployeeVPFPortedSheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncEmployeeVPFPortedSheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeVPFportAlreadyExits[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeVPFportAlreadyExits[]>;
        }));
    }

    protected processSyncEmployeeVPFPortedSheet(response: HttpResponseBase): Observable<EmployeeVPFportAlreadyExits[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeVPFportAlreadyExits.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeVPFportAlreadyExits[]>(null as any);
    }
}

@Injectable()
export class ExitInterviewServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfExitInterviewDto> {
        let url_ = this.baseUrl + "/api/services/app/ExitInterview/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfExitInterviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfExitInterviewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfExitInterviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfExitInterviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfExitInterviewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getQuestionForView(id: number | undefined): Observable<ExitInterviewDto> {
        let url_ = this.baseUrl + "/api/services/app/ExitInterview/GetQuestionForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuestionForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuestionForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExitInterviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExitInterviewDto>;
        }));
    }

    protected processGetQuestionForView(response: HttpResponseBase): Observable<ExitInterviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExitInterviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExitInterviewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getQuestionForEdit(id: number | undefined): Observable<GetquestionforEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ExitInterview/GetQuestionForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuestionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuestionForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetquestionforEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetquestionforEditOutput>;
        }));
    }

    protected processGetQuestionForEdit(response: HttpResponseBase): Observable<GetquestionforEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetquestionforEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetquestionforEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditquestionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExitInterview/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExitInterview/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param quesid (optional) 
     * @return Success
     */
    getAnswerscount(quesid: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ExitInterview/GetAnswerscount?";
        if (quesid === null)
            throw new Error("The parameter 'quesid' cannot be null.");
        else if (quesid !== undefined)
            url_ += "quesid=" + encodeURIComponent("" + quesid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnswerscount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnswerscount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetAnswerscount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    getAllInterviewQuestion(): Observable<ExitInterviewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ExitInterview/GetAllInterviewQuestion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInterviewQuestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInterviewQuestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExitInterviewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExitInterviewDto[]>;
        }));
    }

    protected processGetAllInterviewQuestion(response: HttpResponseBase): Observable<ExitInterviewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExitInterviewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExitInterviewDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createQuizLog(body: SaveQuizLogDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExitInterview/CreateQuizLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateQuizLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateQuizLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateQuizLog(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param empid (optional) 
     * @return Success
     */
    getQuizLogForEdit(empid: number | undefined): Observable<GetInterviewLogEditDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ExitInterview/GetQuizLogForEdit?";
        if (empid === null)
            throw new Error("The parameter 'empid' cannot be null.");
        else if (empid !== undefined)
            url_ += "Empid=" + encodeURIComponent("" + empid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuizLogForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuizLogForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetInterviewLogEditDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetInterviewLogEditDto[]>;
        }));
    }

    protected processGetQuizLogForEdit(response: HttpResponseBase): Observable<GetInterviewLogEditDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetInterviewLogEditDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetInterviewLogEditDto[]>(null as any);
    }

    /**
     * @param empid (optional) 
     * @return Success
     */
    getExitInerviewLogForView(empid: number | undefined): Observable<GetInterviewLogViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ExitInterview/GetExitInerviewLogForView?";
        if (empid === null)
            throw new Error("The parameter 'empid' cannot be null.");
        else if (empid !== undefined)
            url_ += "Empid=" + encodeURIComponent("" + empid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExitInerviewLogForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExitInerviewLogForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetInterviewLogViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetInterviewLogViewDto[]>;
        }));
    }

    protected processGetExitInerviewLogForView(response: HttpResponseBase): Observable<GetInterviewLogViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetInterviewLogViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetInterviewLogViewDto[]>(null as any);
    }
}

@Injectable()
export class ExitInterviewAnswerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param quesid (optional) 
     * @return Success
     */
    getAll(quesid: number | undefined): Observable<PagedResultDtoOfGetAnswersForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ExitInterviewAnswer/GetAll?";
        if (quesid === null)
            throw new Error("The parameter 'quesid' cannot be null.");
        else if (quesid !== undefined)
            url_ += "quesid=" + encodeURIComponent("" + quesid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAnswersForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAnswersForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAnswersForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAnswersForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAnswersForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAnswerForView(id: number | undefined): Observable<GetAnswersForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ExitInterviewAnswer/GetAnswerForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnswerForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnswerForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAnswersForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAnswersForViewDto>;
        }));
    }

    protected processGetAnswerForView(response: HttpResponseBase): Observable<GetAnswersForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAnswersForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAnswersForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAnswerForEdit(id: number | undefined): Observable<GetAnswerForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ExitInterviewAnswer/GetAnswerForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnswerForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnswerForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAnswerForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAnswerForEditOutput>;
        }));
    }

    protected processGetAnswerForEdit(response: HttpResponseBase): Observable<GetAnswerForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAnswerForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAnswerForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditAnswerDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExitInterviewAnswer/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExitInterviewAnswer/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCountryForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfQuestionAnsLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/ExitInterviewAnswer/GetAllCountryForLookupTable?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCountryForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCountryForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfQuestionAnsLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfQuestionAnsLookupTableDto>;
        }));
    }

    protected processGetAllCountryForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfQuestionAnsLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfQuestionAnsLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfQuestionAnsLookupTableDto>(null as any);
    }
}

@Injectable()
export class ExitTaskListServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEndListForView(id: number | undefined): Observable<GetEndListForView> {
        let url_ = this.baseUrl + "/api/services/app/ExitTaskList/GetEndListForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEndListForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEndListForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEndListForView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEndListForView>;
        }));
    }

    protected processGetEndListForView(response: HttpResponseBase): Observable<GetEndListForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEndListForView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEndListForView>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDivisionForEdit(id: number | undefined): Observable<GetEndTaskForEdit> {
        let url_ = this.baseUrl + "/api/services/app/ExitTaskList/GetDivisionForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDivisionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDivisionForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEndTaskForEdit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEndTaskForEdit>;
        }));
    }

    protected processGetDivisionForEdit(response: HttpResponseBase): Observable<GetEndTaskForEdit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEndTaskForEdit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEndTaskForEdit>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditTaskList | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExitTaskList/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ExpenseServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAllExpenseForView> {
        let url_ = this.baseUrl + "/api/services/app/Expense/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAllExpenseForView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAllExpenseForView>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllExpenseForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAllExpenseForView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllExpenseForView>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getExpenseForView(id: number | undefined): Observable<GetAllExpenseForView> {
        let url_ = this.baseUrl + "/api/services/app/Expense/GetExpenseForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExpenseForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExpenseForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllExpenseForView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllExpenseForView>;
        }));
    }

    protected processGetExpenseForView(response: HttpResponseBase): Observable<GetAllExpenseForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllExpenseForView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAllExpenseForView>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAllEditExpense(id: number | undefined): Observable<GetAllEditExpense> {
        let url_ = this.baseUrl + "/api/services/app/Expense/GetAllEditExpense?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEditExpense(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEditExpense(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllEditExpense>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllEditExpense>;
        }));
    }

    protected processGetAllEditExpense(response: HttpResponseBase): Observable<GetAllEditExpense> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllEditExpense.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAllEditExpense>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditExpense | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Expense/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Expense/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ExpensePolicyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetExpensePolicyForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ExpensePolicy/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetExpensePolicyForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetExpensePolicyForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetExpensePolicyForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetExpensePolicyForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetExpensePolicyForViewDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllExpensesForWizard(): Observable<PagedResultDtoOfGetExpensePolicyForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ExpensePolicy/GetAllExpensesForWizard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllExpensesForWizard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExpensesForWizard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetExpensePolicyForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetExpensePolicyForViewDto>;
        }));
    }

    protected processGetAllExpensesForWizard(response: HttpResponseBase): Observable<PagedResultDtoOfGetExpensePolicyForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetExpensePolicyForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetExpensePolicyForViewDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllInstallExpensePolicy(): Observable<GetExpensePolicyForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ExpensePolicy/GetAllInstallExpensePolicy";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInstallExpensePolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInstallExpensePolicy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExpensePolicyForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExpensePolicyForViewDto[]>;
        }));
    }

    protected processGetAllInstallExpensePolicy(response: HttpResponseBase): Observable<GetExpensePolicyForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetExpensePolicyForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetExpensePolicyForViewDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getExpensePolicyForView(id: number | undefined): Observable<GetExpensePolicyForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ExpensePolicy/GetExpensePolicyForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExpensePolicyForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExpensePolicyForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExpensePolicyForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExpensePolicyForViewDto>;
        }));
    }

    protected processGetExpensePolicyForView(response: HttpResponseBase): Observable<GetExpensePolicyForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExpensePolicyForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetExpensePolicyForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPolicyForEdit(id: number | undefined): Observable<GetExpensePolicyForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ExpensePolicy/GetPolicyForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolicyForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolicyForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExpensePolicyForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExpensePolicyForEditOutput>;
        }));
    }

    protected processGetPolicyForEdit(response: HttpResponseBase): Observable<GetExpensePolicyForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExpensePolicyForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetExpensePolicyForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditExpensePolicy | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExpensePolicy/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExpensePolicy/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    expenseModule(id: number | undefined): Observable<NewExpenseModule[]> {
        let url_ = this.baseUrl + "/api/services/app/ExpensePolicy/ExpenseModule?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExpenseModule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExpenseModule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NewExpenseModule[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NewExpenseModule[]>;
        }));
    }

    protected processExpenseModule(response: HttpResponseBase): Observable<NewExpenseModule[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NewExpenseModule.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NewExpenseModule[]>(null as any);
    }
}

@Injectable()
export class ExpensePolicyMapAppServicesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertMapPolicy(body: CreateOrEditExpenseMapPolicyDtoNew[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExpensePolicyMapAppServices/InsertMapPolicy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertMapPolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertMapPolicy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInsertMapPolicy(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param policyid (optional) 
     * @return Success
     */
    getAllPolicyData(policyid: number | undefined): Observable<GetExpenseMapPolicyDtoNew[]> {
        let url_ = this.baseUrl + "/api/services/app/ExpensePolicyMapAppServices/GetAllPolicyData?";
        if (policyid === null)
            throw new Error("The parameter 'policyid' cannot be null.");
        else if (policyid !== undefined)
            url_ += "policyid=" + encodeURIComponent("" + policyid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPolicyData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPolicyData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExpenseMapPolicyDtoNew[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExpenseMapPolicyDtoNew[]>;
        }));
    }

    protected processGetAllPolicyData(response: HttpResponseBase): Observable<GetExpenseMapPolicyDtoNew[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetExpenseMapPolicyDtoNew.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetExpenseMapPolicyDtoNew[]>(null as any);
    }
}

@Injectable()
export class FinalSettlementAppServicesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param empId (optional) 
     * @return Success
     */
    getSalarySettlement(empId: number | undefined): Observable<ValueTupleOfListOfGetSalarySettlementDtoListOfString> {
        let url_ = this.baseUrl + "/api/services/app/FinalSettlementAppServices/GetSalarySettlement?";
        if (empId === null)
            throw new Error("The parameter 'empId' cannot be null.");
        else if (empId !== undefined)
            url_ += "EmpId=" + encodeURIComponent("" + empId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalarySettlement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalarySettlement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValueTupleOfListOfGetSalarySettlementDtoListOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValueTupleOfListOfGetSalarySettlementDtoListOfString>;
        }));
    }

    protected processGetSalarySettlement(response: HttpResponseBase): Observable<ValueTupleOfListOfGetSalarySettlementDtoListOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValueTupleOfListOfGetSalarySettlementDtoListOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValueTupleOfListOfGetSalarySettlementDtoListOfString>(null as any);
    }

    /**
     * @param employeeid (optional) 
     * @param monthname (optional) 
     * @return Success
     */
    getPayables(employeeid: number | undefined, monthname: string | null | undefined): Observable<GetPayables[]> {
        let url_ = this.baseUrl + "/api/services/app/FinalSettlementAppServices/GetPayables?";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        if (monthname !== undefined && monthname !== null)
            url_ += "monthname=" + encodeURIComponent("" + monthname) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayables(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayables(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPayables[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPayables[]>;
        }));
    }

    protected processGetPayables(response: HttpResponseBase): Observable<GetPayables[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetPayables.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPayables[]>(null as any);
    }

    /**
     * @param empid (optional) 
     * @return Success
     */
    saveFinalize(empid: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FinalSettlementAppServices/SaveFinalize?";
        if (empid === null)
            throw new Error("The parameter 'empid' cannot be null.");
        else if (empid !== undefined)
            url_ += "empid=" + encodeURIComponent("" + empid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveFinalize(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveFinalize(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveFinalize(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param empid (optional) 
     * @return Success
     */
    getEmployeeSalary(empid: number | undefined): Observable<EmployeeSalaryFNFtData[]> {
        let url_ = this.baseUrl + "/api/services/app/FinalSettlementAppServices/GetEmployeeSalary?";
        if (empid === null)
            throw new Error("The parameter 'empid' cannot be null.");
        else if (empid !== undefined)
            url_ += "Empid=" + encodeURIComponent("" + empid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeSalary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeSalary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeSalaryFNFtData[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeSalaryFNFtData[]>;
        }));
    }

    protected processGetEmployeeSalary(response: HttpResponseBase): Observable<EmployeeSalaryFNFtData[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeSalaryFNFtData.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeSalaryFNFtData[]>(null as any);
    }
}

@Injectable()
export class FreezsalariesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getDate(month: number | undefined, year: number | undefined): Observable<GetFreezsalaryForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Freezsalaries/GetDate?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFreezsalaryForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFreezsalaryForViewDto>;
        }));
    }

    protected processGetDate(response: HttpResponseBase): Observable<GetFreezsalaryForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFreezsalaryForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFreezsalaryForViewDto>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getFreezeDate(month: number | undefined, year: number | undefined): Observable<GetFreezsalaryForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Freezsalaries/GetFreezeDate?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFreezeDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFreezeDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFreezsalaryForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFreezsalaryForViewDto>;
        }));
    }

    protected processGetFreezeDate(response: HttpResponseBase): Observable<GetFreezsalaryForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFreezsalaryForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFreezsalaryForViewDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param monthYearFilter (optional) 
     * @param maxFreezDateFilter (optional) 
     * @param minFreezDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, monthYearFilter: string | null | undefined, maxFreezDateFilter: moment.Moment | null | undefined, minFreezDateFilter: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetFreezsalaryForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Freezsalaries/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (monthYearFilter !== undefined && monthYearFilter !== null)
            url_ += "monthYearFilter=" + encodeURIComponent("" + monthYearFilter) + "&";
        if (maxFreezDateFilter !== undefined && maxFreezDateFilter !== null)
            url_ += "MaxFreezDateFilter=" + encodeURIComponent(maxFreezDateFilter ? "" + maxFreezDateFilter.toISOString() : "") + "&";
        if (minFreezDateFilter !== undefined && minFreezDateFilter !== null)
            url_ += "MinFreezDateFilter=" + encodeURIComponent(minFreezDateFilter ? "" + minFreezDateFilter.toISOString() : "") + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetFreezsalaryForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetFreezsalaryForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetFreezsalaryForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetFreezsalaryForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetFreezsalaryForViewDto>(null as any);
    }

    /**
     * @return Success
     */
    isBonusAvailable(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Freezsalaries/IsBonusAvailable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsBonusAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsBonusAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsBonusAvailable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getAllCheckbox(month: number | undefined, year: number | undefined): Observable<GetFreezsalaryForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Freezsalaries/GetAllCheckbox?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCheckbox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCheckbox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFreezsalaryForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFreezsalaryForViewDto[]>;
        }));
    }

    protected processGetAllCheckbox(response: HttpResponseBase): Observable<GetFreezsalaryForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetFreezsalaryForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFreezsalaryForViewDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFreezsalaryForView(id: number | undefined): Observable<GetFreezsalaryForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Freezsalaries/GetFreezsalaryForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFreezsalaryForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFreezsalaryForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFreezsalaryForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFreezsalaryForViewDto>;
        }));
    }

    protected processGetFreezsalaryForView(response: HttpResponseBase): Observable<GetFreezsalaryForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFreezsalaryForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFreezsalaryForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFreezsalaryForEdit(id: number | undefined): Observable<GetFreezsalaryForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Freezsalaries/GetFreezsalaryForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFreezsalaryForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFreezsalaryForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFreezsalaryForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFreezsalaryForEditOutput>;
        }));
    }

    protected processGetFreezsalaryForEdit(response: HttpResponseBase): Observable<GetFreezsalaryForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFreezsalaryForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFreezsalaryForEditOutput>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getUnfreezeSalary(month: number | undefined, year: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Freezsalaries/GetUnfreezeSalary?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnfreezeSalary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnfreezeSalary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetUnfreezeSalary(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditFreezsalaryDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Freezsalaries/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Freezsalaries/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param monthYearFilter (optional) 
     * @param maxFreezDateFilter (optional) 
     * @param minFreezDateFilter (optional) 
     * @return Success
     */
    getFreezsalariesToExcel(filter: string | null | undefined, monthYearFilter: string | null | undefined, maxFreezDateFilter: moment.Moment | null | undefined, minFreezDateFilter: moment.Moment | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Freezsalaries/GetFreezsalariesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (monthYearFilter !== undefined && monthYearFilter !== null)
            url_ += "monthYearFilter=" + encodeURIComponent("" + monthYearFilter) + "&";
        if (maxFreezDateFilter !== undefined && maxFreezDateFilter !== null)
            url_ += "MaxFreezDateFilter=" + encodeURIComponent(maxFreezDateFilter ? "" + maxFreezDateFilter.toISOString() : "") + "&";
        if (minFreezDateFilter !== undefined && minFreezDateFilter !== null)
            url_ += "MinFreezDateFilter=" + encodeURIComponent(minFreezDateFilter ? "" + minFreezDateFilter.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFreezsalariesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFreezsalariesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetFreezsalariesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @return Success
     */
    getMonthYear(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/Freezsalaries/GetMonthYear";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthYear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthYear(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetMonthYear(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number[]>(null as any);
    }

    /**
     * @return Success
     */
    getBlankAdditionDeductionFormat(): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Freezsalaries/GetBlankAdditionDeductionFormat";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBlankAdditionDeductionFormat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBlankAdditionDeductionFormat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetBlankAdditionDeductionFormat(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }
}

@Injectable()
export class FriendshipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFriendshipRequest(body: CreateFriendshipRequestInput | undefined): Observable<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFriendshipRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFriendshipRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FriendDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FriendDto>;
        }));
    }

    protected processCreateFriendshipRequest(response: HttpResponseBase): Observable<FriendDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FriendDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FriendDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFriendshipRequestByUserName(body: CreateFriendshipRequestByUserNameInput | undefined): Observable<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequestByUserName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFriendshipRequestByUserName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFriendshipRequestByUserName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FriendDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FriendDto>;
        }));
    }

    protected processCreateFriendshipRequestByUserName(response: HttpResponseBase): Observable<FriendDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FriendDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FriendDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    blockUser(body: BlockUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/BlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBlockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBlockUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBlockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unblockUser(body: UnblockUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/UnblockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnblockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnblockUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnblockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    acceptFriendshipRequest(body: AcceptFriendshipRequestInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/AcceptFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptFriendshipRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptFriendshipRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAcceptFriendshipRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class GeneratePdfServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param monthYear (optional) 
     * @param employeeid (optional) 
     * @return Success
     */
    createPDF(monthYear: string | null | undefined, employeeid: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/GeneratePdf/CreatePDF?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "MonthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "Employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePDF(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePDF(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreatePDF(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class GpsTrackingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    startTrip(body: GpsTripDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/GpsTracking/StartTrip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartTrip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartTrip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processStartTrip(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    isEmployeePunchedIn(employeeId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/GpsTracking/IsEmployeePunchedIn?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsEmployeePunchedIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsEmployeePunchedIn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsEmployeePunchedIn(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    employeeDayStart(body: GpsLocationDto | undefined): Observable<GpsLocationResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/GpsTracking/EmployeeDayStart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployeeDayStart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployeeDayStart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GpsLocationResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GpsLocationResponseDto>;
        }));
    }

    protected processEmployeeDayStart(response: HttpResponseBase): Observable<GpsLocationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GpsLocationResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GpsLocationResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    endTrip(body: GpsTripDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/GpsTracking/EndTrip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEndTrip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEndTrip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processEndTrip(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param reportType (optional) 
     * @param isLatestOnly (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param employeeIds (optional) 
     * @return Success
     */
    getGpsReport(reportType: GpsReportType | undefined, isLatestOnly: boolean | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, employeeIds: number[] | null | undefined): Observable<GpsReportResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/GpsTracking/GetGpsReport?";
        if (reportType === null)
            throw new Error("The parameter 'reportType' cannot be null.");
        else if (reportType !== undefined)
            url_ += "ReportType=" + encodeURIComponent("" + reportType) + "&";
        if (isLatestOnly === null)
            throw new Error("The parameter 'isLatestOnly' cannot be null.");
        else if (isLatestOnly !== undefined)
            url_ += "IsLatestOnly=" + encodeURIComponent("" + isLatestOnly) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (employeeIds !== undefined && employeeIds !== null)
            employeeIds && employeeIds.forEach(item => { url_ += "EmployeeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGpsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGpsReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GpsReportResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GpsReportResponseDto>;
        }));
    }

    protected processGetGpsReport(response: HttpResponseBase): Observable<GpsReportResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GpsReportResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GpsReportResponseDto>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param employeeIds (optional) 
     * @return Success
     */
    getMovementReport(fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, employeeIds: number[] | null | undefined): Observable<MovementReportDto> {
        let url_ = this.baseUrl + "/api/services/app/GpsTracking/GetMovementReport?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (employeeIds !== undefined && employeeIds !== null)
            employeeIds && employeeIds.forEach(item => { url_ += "EmployeeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMovementReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMovementReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MovementReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MovementReportDto>;
        }));
    }

    protected processGetMovementReport(response: HttpResponseBase): Observable<MovementReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MovementReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MovementReportDto>(null as any);
    }

    /**
     * @param isTripView (optional) 
     * @param body (optional) 
     * @return Success
     */
    exportGpsReportSimple(isTripView: boolean | undefined, body: GetGpsReportInput | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/GpsTracking/ExportGpsReportSimple?";
        if (isTripView === null)
            throw new Error("The parameter 'isTripView' cannot be null.");
        else if (isTripView !== undefined)
            url_ += "isTripView=" + encodeURIComponent("" + isTripView) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportGpsReportSimple(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportGpsReportSimple(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportGpsReportSimple(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param tripId (optional) 
     * @return Success
     */
    getTripRoute(tripId: number | undefined): Observable<TripRouteDto> {
        let url_ = this.baseUrl + "/api/services/app/GpsTracking/GetTripRoute?";
        if (tripId === null)
            throw new Error("The parameter 'tripId' cannot be null.");
        else if (tripId !== undefined)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTripRoute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTripRoute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TripRouteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TripRouteDto>;
        }));
    }

    protected processGetTripRoute(response: HttpResponseBase): Observable<TripRouteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TripRouteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TripRouteDto>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param employeeId (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    getTrips(fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, employeeId: number | undefined, page: number | undefined, pageSize: number | undefined): Observable<PagedTripResultDto> {
        let url_ = this.baseUrl + "/api/services/app/GpsTracking/GetTrips?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrips(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrips(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedTripResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedTripResultDto>;
        }));
    }

    protected processGetTrips(response: HttpResponseBase): Observable<PagedTripResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedTripResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedTripResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    notifyLocationDisabled(body: LocationDisabledDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/GpsTracking/NotifyLocationDisabled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyLocationDisabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyLocationDisabled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processNotifyLocationDisabled(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class HeadquarterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param headQuarterName (optional) 
     * @param statename (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(headQuarterName: string | null | undefined, statename: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAllHQForView> {
        let url_ = this.baseUrl + "/api/services/app/Headquarter/GetAll?";
        if (headQuarterName !== undefined && headQuarterName !== null)
            url_ += "headQuarterName=" + encodeURIComponent("" + headQuarterName) + "&";
        if (statename !== undefined && statename !== null)
            url_ += "statename=" + encodeURIComponent("" + statename) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAllHQForView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAllHQForView>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllHQForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAllHQForView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllHQForView>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHeadQuarterForView(id: number | undefined): Observable<GetAllHQForView> {
        let url_ = this.baseUrl + "/api/services/app/Headquarter/GetHeadQuarterForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHeadQuarterForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHeadQuarterForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllHQForView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllHQForView>;
        }));
    }

    protected processGetHeadQuarterForView(response: HttpResponseBase): Observable<GetAllHQForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllHQForView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAllHQForView>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditHeadQuarterDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Headquarter/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHeadQuarterForEdit(id: number | undefined): Observable<GetHeadquarterForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Headquarter/GetHeadQuarterForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHeadQuarterForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHeadQuarterForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHeadquarterForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHeadquarterForEditOutput>;
        }));
    }

    protected processGetHeadQuarterForEdit(response: HttpResponseBase): Observable<GetHeadquarterForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetHeadquarterForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetHeadquarterForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Headquarter/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param headQuarterName (optional) 
     * @param statename (optional) 
     * @return Success
     */
    getHeadquartersToExcel(headQuarterName: string | null | undefined, statename: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Headquarter/GetHeadquartersToExcel?";
        if (headQuarterName !== undefined && headQuarterName !== null)
            url_ += "headQuarterName=" + encodeURIComponent("" + headQuarterName) + "&";
        if (statename !== undefined && statename !== null)
            url_ += "statename=" + encodeURIComponent("" + statename) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHeadquartersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHeadquartersToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetHeadquartersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class HoldiayPoliciesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param maxMaxHolidayNoFilter (optional) 
     * @param minMaxHolidayNoFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, maxMaxHolidayNoFilter: number | null | undefined, minMaxHolidayNoFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetHoldiayPolicyForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/HoldiayPolicies/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxMaxHolidayNoFilter !== undefined && maxMaxHolidayNoFilter !== null)
            url_ += "MaxMaxHolidayNoFilter=" + encodeURIComponent("" + maxMaxHolidayNoFilter) + "&";
        if (minMaxHolidayNoFilter !== undefined && minMaxHolidayNoFilter !== null)
            url_ += "MinMaxHolidayNoFilter=" + encodeURIComponent("" + minMaxHolidayNoFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetHoldiayPolicyForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetHoldiayPolicyForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetHoldiayPolicyForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetHoldiayPolicyForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetHoldiayPolicyForViewDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllInstallPolice(): Observable<GetHoldiayPolicyForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HoldiayPolicies/GetAllInstallPolice";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInstallPolice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInstallPolice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHoldiayPolicyForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHoldiayPolicyForViewDto[]>;
        }));
    }

    protected processGetAllInstallPolice(response: HttpResponseBase): Observable<GetHoldiayPolicyForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetHoldiayPolicyForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetHoldiayPolicyForViewDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHoldiayPolicyForView(id: number | undefined): Observable<GetHoldiayPolicyForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/HoldiayPolicies/GetHoldiayPolicyForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHoldiayPolicyForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHoldiayPolicyForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHoldiayPolicyForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHoldiayPolicyForViewDto>;
        }));
    }

    protected processGetHoldiayPolicyForView(response: HttpResponseBase): Observable<GetHoldiayPolicyForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetHoldiayPolicyForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetHoldiayPolicyForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHoldiayPolicyForEdit(id: number | undefined): Observable<GetHoldiayPolicyForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/HoldiayPolicies/GetHoldiayPolicyForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHoldiayPolicyForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHoldiayPolicyForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHoldiayPolicyForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHoldiayPolicyForEditOutput>;
        }));
    }

    protected processGetHoldiayPolicyForEdit(response: HttpResponseBase): Observable<GetHoldiayPolicyForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetHoldiayPolicyForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetHoldiayPolicyForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditHoldiayPolicyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HoldiayPolicies/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HoldiayPolicies/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param maxMaxHolidayNoFilter (optional) 
     * @param minMaxHolidayNoFilter (optional) 
     * @return Success
     */
    getHoldiayPoliciesToExcel(filter: string | null | undefined, nameFilter: string | null | undefined, maxMaxHolidayNoFilter: number | null | undefined, minMaxHolidayNoFilter: number | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/HoldiayPolicies/GetHoldiayPoliciesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxMaxHolidayNoFilter !== undefined && maxMaxHolidayNoFilter !== null)
            url_ += "MaxMaxHolidayNoFilter=" + encodeURIComponent("" + maxMaxHolidayNoFilter) + "&";
        if (minMaxHolidayNoFilter !== undefined && minMaxHolidayNoFilter !== null)
            url_ += "MinMaxHolidayNoFilter=" + encodeURIComponent("" + minMaxHolidayNoFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHoldiayPoliciesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHoldiayPoliciesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetHoldiayPoliciesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param policyid (optional) 
     * @param body (optional) 
     * @return Success
     */
    insertMapPolicy(policyid: number | undefined, body: CreateOrEditHolidayMapPolicyDtoNew[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HoldiayPolicies/InsertMapPolicy?";
        if (policyid === null)
            throw new Error("The parameter 'policyid' cannot be null.");
        else if (policyid !== undefined)
            url_ += "policyid=" + encodeURIComponent("" + policyid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertMapPolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertMapPolicy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInsertMapPolicy(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param policyid (optional) 
     * @param policyType (optional) 
     * @return Success
     */
    getAllPolicyData(policyid: number | undefined, policyType: string | null | undefined): Observable<CreateOrEditHolidayMapPolicyDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HoldiayPolicies/GetAllPolicyData?";
        if (policyid === null)
            throw new Error("The parameter 'policyid' cannot be null.");
        else if (policyid !== undefined)
            url_ += "policyid=" + encodeURIComponent("" + policyid) + "&";
        if (policyType !== undefined && policyType !== null)
            url_ += "policyType=" + encodeURIComponent("" + policyType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPolicyData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPolicyData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditHolidayMapPolicyDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditHolidayMapPolicyDto[]>;
        }));
    }

    protected processGetAllPolicyData(response: HttpResponseBase): Observable<CreateOrEditHolidayMapPolicyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditHolidayMapPolicyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditHolidayMapPolicyDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getLocation(): Observable<BranchDropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/HoldiayPolicies/GetLocation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchDropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchDropDown[]>;
        }));
    }

    protected processGetLocation(response: HttpResponseBase): Observable<BranchDropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BranchDropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BranchDropDown[]>(null as any);
    }

    /**
     * @param policyName (optional) 
     * @return Success
     */
    isAlreadyAssigned(policyName: string | null | undefined): Observable<AlreadyAssignedDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HoldiayPolicies/isAlreadyAssigned?";
        if (policyName !== undefined && policyName !== null)
            url_ += "policyName=" + encodeURIComponent("" + policyName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsAlreadyAssigned(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsAlreadyAssigned(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlreadyAssignedDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlreadyAssignedDto[]>;
        }));
    }

    protected processIsAlreadyAssigned(response: HttpResponseBase): Observable<AlreadyAssignedDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlreadyAssignedDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlreadyAssignedDto[]>(null as any);
    }
}

@Injectable()
export class HolidaiesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param holidayNameFilter (optional) 
     * @param nationalHolidayFilter (optional) 
     * @param reservedHolidayFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, holidayNameFilter: string | null | undefined, nationalHolidayFilter: number | null | undefined, reservedHolidayFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetHolidayForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Holidaies/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (holidayNameFilter !== undefined && holidayNameFilter !== null)
            url_ += "HolidayNameFilter=" + encodeURIComponent("" + holidayNameFilter) + "&";
        if (nationalHolidayFilter !== undefined && nationalHolidayFilter !== null)
            url_ += "NationalHolidayFilter=" + encodeURIComponent("" + nationalHolidayFilter) + "&";
        if (reservedHolidayFilter !== undefined && reservedHolidayFilter !== null)
            url_ += "ReservedHolidayFilter=" + encodeURIComponent("" + reservedHolidayFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetHolidayForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetHolidayForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetHolidayForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetHolidayForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetHolidayForViewDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param holidayNameFilter (optional) 
     * @param nationalHolidayFilter (optional) 
     * @param reservedHolidayFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllHolidayMobile(filter: string | null | undefined, holidayNameFilter: string | null | undefined, nationalHolidayFilter: number | null | undefined, reservedHolidayFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetHolidayForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Holidaies/GetAllHolidayMobile?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (holidayNameFilter !== undefined && holidayNameFilter !== null)
            url_ += "HolidayNameFilter=" + encodeURIComponent("" + holidayNameFilter) + "&";
        if (nationalHolidayFilter !== undefined && nationalHolidayFilter !== null)
            url_ += "NationalHolidayFilter=" + encodeURIComponent("" + nationalHolidayFilter) + "&";
        if (reservedHolidayFilter !== undefined && reservedHolidayFilter !== null)
            url_ += "ReservedHolidayFilter=" + encodeURIComponent("" + reservedHolidayFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllHolidayMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllHolidayMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetHolidayForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetHolidayForViewDto>;
        }));
    }

    protected processGetAllHolidayMobile(response: HttpResponseBase): Observable<PagedResultDtoOfGetHolidayForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetHolidayForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetHolidayForViewDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllHoliday(): Observable<GetHolidayForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Holidaies/GetAllHoliday";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllHoliday(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllHoliday(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHolidayForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHolidayForViewDto[]>;
        }));
    }

    protected processGetAllHoliday(response: HttpResponseBase): Observable<GetHolidayForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetHolidayForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetHolidayForViewDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHolidayForView(id: number | undefined): Observable<GetHolidayForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Holidaies/GetHolidayForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHolidayForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHolidayForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHolidayForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHolidayForViewDto>;
        }));
    }

    protected processGetHolidayForView(response: HttpResponseBase): Observable<GetHolidayForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetHolidayForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetHolidayForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHolidayForEdit(id: number | undefined): Observable<GetHolidayForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Holidaies/GetHolidayForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHolidayForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHolidayForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHolidayForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHolidayForEditOutput>;
        }));
    }

    protected processGetHolidayForEdit(response: HttpResponseBase): Observable<GetHolidayForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetHolidayForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetHolidayForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditHolidayDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Holidaies/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Holidaies/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param holidayNameFilter (optional) 
     * @param nationalHolidayFilter (optional) 
     * @param reservedHolidayFilter (optional) 
     * @return Success
     */
    getHolidaiesToExcel(filter: string | null | undefined, holidayNameFilter: string | null | undefined, nationalHolidayFilter: number | null | undefined, reservedHolidayFilter: number | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Holidaies/GetHolidaiesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (holidayNameFilter !== undefined && holidayNameFilter !== null)
            url_ += "HolidayNameFilter=" + encodeURIComponent("" + holidayNameFilter) + "&";
        if (nationalHolidayFilter !== undefined && nationalHolidayFilter !== null)
            url_ += "NationalHolidayFilter=" + encodeURIComponent("" + nationalHolidayFilter) + "&";
        if (reservedHolidayFilter !== undefined && reservedHolidayFilter !== null)
            url_ += "ReservedHolidayFilter=" + encodeURIComponent("" + reservedHolidayFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHolidaiesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHolidaiesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetHolidaiesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param branchId (optional) 
     * @param holidayNameFilter (optional) 
     * @param year (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getBranchWiseHolidayList(branchId: number | null | undefined, holidayNameFilter: string | null | undefined, year: number | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfBranchWiseHolidayDto> {
        let url_ = this.baseUrl + "/api/services/app/Holidaies/GetBranchWiseHolidayList?";
        if (branchId !== undefined && branchId !== null)
            url_ += "BranchId=" + encodeURIComponent("" + branchId) + "&";
        if (holidayNameFilter !== undefined && holidayNameFilter !== null)
            url_ += "HolidayNameFilter=" + encodeURIComponent("" + holidayNameFilter) + "&";
        if (year !== undefined && year !== null)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBranchWiseHolidayList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBranchWiseHolidayList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfBranchWiseHolidayDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfBranchWiseHolidayDto>;
        }));
    }

    protected processGetBranchWiseHolidayList(response: HttpResponseBase): Observable<PagedResultDtoOfBranchWiseHolidayDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBranchWiseHolidayDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfBranchWiseHolidayDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    branchwiseExportToExcel(body: GetBranchWiseHolidayListInput | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Holidaies/BranchwiseExportToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBranchwiseExportToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBranchwiseExportToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processBranchwiseExportToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class HolidaypolicyDetailsesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxHolidayPolicyFilter (optional) 
     * @param minHolidayPolicyFilter (optional) 
     * @param maxHolidayIdFilter (optional) 
     * @param minHolidayIdFilter (optional) 
     * @param maxFinancialYearFilter (optional) 
     * @param minFinancialYearFilter (optional) 
     * @param maxHolidayDateFilter (optional) 
     * @param minHolidayDateFilter (optional) 
     * @param applicableFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxHolidayPolicyFilter: number | null | undefined, minHolidayPolicyFilter: number | null | undefined, maxHolidayIdFilter: number | null | undefined, minHolidayIdFilter: number | null | undefined, maxFinancialYearFilter: number | null | undefined, minFinancialYearFilter: number | null | undefined, maxHolidayDateFilter: moment.Moment | null | undefined, minHolidayDateFilter: moment.Moment | null | undefined, applicableFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetHolidaypolicyDetailsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/HolidaypolicyDetailses/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxHolidayPolicyFilter !== undefined && maxHolidayPolicyFilter !== null)
            url_ += "MaxHolidayPolicyFilter=" + encodeURIComponent("" + maxHolidayPolicyFilter) + "&";
        if (minHolidayPolicyFilter !== undefined && minHolidayPolicyFilter !== null)
            url_ += "MinHolidayPolicyFilter=" + encodeURIComponent("" + minHolidayPolicyFilter) + "&";
        if (maxHolidayIdFilter !== undefined && maxHolidayIdFilter !== null)
            url_ += "MaxHolidayIdFilter=" + encodeURIComponent("" + maxHolidayIdFilter) + "&";
        if (minHolidayIdFilter !== undefined && minHolidayIdFilter !== null)
            url_ += "MinHolidayIdFilter=" + encodeURIComponent("" + minHolidayIdFilter) + "&";
        if (maxFinancialYearFilter !== undefined && maxFinancialYearFilter !== null)
            url_ += "MaxFinancialYearFilter=" + encodeURIComponent("" + maxFinancialYearFilter) + "&";
        if (minFinancialYearFilter !== undefined && minFinancialYearFilter !== null)
            url_ += "MinFinancialYearFilter=" + encodeURIComponent("" + minFinancialYearFilter) + "&";
        if (maxHolidayDateFilter !== undefined && maxHolidayDateFilter !== null)
            url_ += "MaxHolidayDateFilter=" + encodeURIComponent(maxHolidayDateFilter ? "" + maxHolidayDateFilter.toISOString() : "") + "&";
        if (minHolidayDateFilter !== undefined && minHolidayDateFilter !== null)
            url_ += "MinHolidayDateFilter=" + encodeURIComponent(minHolidayDateFilter ? "" + minHolidayDateFilter.toISOString() : "") + "&";
        if (applicableFilter !== undefined && applicableFilter !== null)
            url_ += "ApplicableFilter=" + encodeURIComponent("" + applicableFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetHolidaypolicyDetailsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetHolidaypolicyDetailsForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetHolidaypolicyDetailsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetHolidaypolicyDetailsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetHolidaypolicyDetailsForViewDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    getAllHolidays(filter: string | null | undefined): Observable<PagedResultDtoOfGetHoliday> {
        let url_ = this.baseUrl + "/api/services/app/HolidaypolicyDetailses/GetAllHolidays?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllHolidays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllHolidays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetHoliday>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetHoliday>;
        }));
    }

    protected processGetAllHolidays(response: HttpResponseBase): Observable<PagedResultDtoOfGetHoliday> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetHoliday.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetHoliday>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHolidaypolicyDetailsForView(id: number | undefined): Observable<GetHolidaypolicyDetailsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/HolidaypolicyDetailses/GetHolidaypolicyDetailsForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHolidaypolicyDetailsForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHolidaypolicyDetailsForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHolidaypolicyDetailsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHolidaypolicyDetailsForViewDto>;
        }));
    }

    protected processGetHolidaypolicyDetailsForView(response: HttpResponseBase): Observable<GetHolidaypolicyDetailsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetHolidaypolicyDetailsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetHolidaypolicyDetailsForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHolidaypolicyDetailsForEdit(id: number | undefined): Observable<GetHolidaypolicyDetailsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/HolidaypolicyDetailses/GetHolidaypolicyDetailsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHolidaypolicyDetailsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHolidaypolicyDetailsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHolidaypolicyDetailsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHolidaypolicyDetailsForEditOutput>;
        }));
    }

    protected processGetHolidaypolicyDetailsForEdit(response: HttpResponseBase): Observable<GetHolidaypolicyDetailsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetHolidaypolicyDetailsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetHolidaypolicyDetailsForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditHolidaypolicyDetailsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HolidaypolicyDetailses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param holidayids (optional) 
     * @return Success
     */
    getHolidaydate(holidayids: number | undefined): Observable<moment.Moment> {
        let url_ = this.baseUrl + "/api/services/app/HolidaypolicyDetailses/GetHolidaydate?";
        if (holidayids === null)
            throw new Error("The parameter 'holidayids' cannot be null.");
        else if (holidayids !== undefined)
            url_ += "holidayids=" + encodeURIComponent("" + holidayids) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHolidaydate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHolidaydate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<moment.Moment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<moment.Moment>;
        }));
    }

    protected processGetHolidaydate(response: HttpResponseBase): Observable<moment.Moment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? moment(resultData200.toString()) : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<moment.Moment>(null as any);
    }

    /**
     * @return Success
     */
    sPupate(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HolidaypolicyDetailses/SPupate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSPupate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSPupate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSPupate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HolidaypolicyDetailses/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxHolidayPolicyFilter (optional) 
     * @param minHolidayPolicyFilter (optional) 
     * @param maxHolidayIdFilter (optional) 
     * @param minHolidayIdFilter (optional) 
     * @param maxFinancialYearFilter (optional) 
     * @param minFinancialYearFilter (optional) 
     * @param maxHolidayDateFilter (optional) 
     * @param minHolidayDateFilter (optional) 
     * @param applicableFilter (optional) 
     * @return Success
     */
    getHolidaypolicyDetailsesToExcel(filter: string | null | undefined, maxHolidayPolicyFilter: number | null | undefined, minHolidayPolicyFilter: number | null | undefined, maxHolidayIdFilter: number | null | undefined, minHolidayIdFilter: number | null | undefined, maxFinancialYearFilter: number | null | undefined, minFinancialYearFilter: number | null | undefined, maxHolidayDateFilter: moment.Moment | null | undefined, minHolidayDateFilter: moment.Moment | null | undefined, applicableFilter: number | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/HolidaypolicyDetailses/GetHolidaypolicyDetailsesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxHolidayPolicyFilter !== undefined && maxHolidayPolicyFilter !== null)
            url_ += "MaxHolidayPolicyFilter=" + encodeURIComponent("" + maxHolidayPolicyFilter) + "&";
        if (minHolidayPolicyFilter !== undefined && minHolidayPolicyFilter !== null)
            url_ += "MinHolidayPolicyFilter=" + encodeURIComponent("" + minHolidayPolicyFilter) + "&";
        if (maxHolidayIdFilter !== undefined && maxHolidayIdFilter !== null)
            url_ += "MaxHolidayIdFilter=" + encodeURIComponent("" + maxHolidayIdFilter) + "&";
        if (minHolidayIdFilter !== undefined && minHolidayIdFilter !== null)
            url_ += "MinHolidayIdFilter=" + encodeURIComponent("" + minHolidayIdFilter) + "&";
        if (maxFinancialYearFilter !== undefined && maxFinancialYearFilter !== null)
            url_ += "MaxFinancialYearFilter=" + encodeURIComponent("" + maxFinancialYearFilter) + "&";
        if (minFinancialYearFilter !== undefined && minFinancialYearFilter !== null)
            url_ += "MinFinancialYearFilter=" + encodeURIComponent("" + minFinancialYearFilter) + "&";
        if (maxHolidayDateFilter !== undefined && maxHolidayDateFilter !== null)
            url_ += "MaxHolidayDateFilter=" + encodeURIComponent(maxHolidayDateFilter ? "" + maxHolidayDateFilter.toISOString() : "") + "&";
        if (minHolidayDateFilter !== undefined && minHolidayDateFilter !== null)
            url_ += "MinHolidayDateFilter=" + encodeURIComponent(minHolidayDateFilter ? "" + minHolidayDateFilter.toISOString() : "") + "&";
        if (applicableFilter !== undefined && applicableFilter !== null)
            url_ += "ApplicableFilter=" + encodeURIComponent("" + applicableFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHolidaypolicyDetailsesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHolidaypolicyDetailsesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetHolidaypolicyDetailsesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class HostDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param incomeStatisticsDateInterval (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getDashboardStatisticsData(incomeStatisticsDateInterval: ChartDateInterval | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<HostDashboardData> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetDashboardStatisticsData?";
        if (incomeStatisticsDateInterval === null)
            throw new Error("The parameter 'incomeStatisticsDateInterval' cannot be null.");
        else if (incomeStatisticsDateInterval !== undefined)
            url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardStatisticsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardStatisticsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HostDashboardData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HostDashboardData>;
        }));
    }

    protected processGetDashboardStatisticsData(response: HttpResponseBase): Observable<HostDashboardData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HostDashboardData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HostDashboardData>(null as any);
    }

    /**
     * @param incomeStatisticsDateInterval (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getIncomeStatistics(incomeStatisticsDateInterval: ChartDateInterval | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<GetIncomeStatisticsDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetIncomeStatistics?";
        if (incomeStatisticsDateInterval === null)
            throw new Error("The parameter 'incomeStatisticsDateInterval' cannot be null.");
        else if (incomeStatisticsDateInterval !== undefined)
            url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncomeStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncomeStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetIncomeStatisticsDataOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetIncomeStatisticsDataOutput>;
        }));
    }

    protected processGetIncomeStatistics(response: HttpResponseBase): Observable<GetIncomeStatisticsDataOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIncomeStatisticsDataOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetIncomeStatisticsDataOutput>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getEditionTenantStatistics(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<GetEditionTenantStatisticsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetEditionTenantStatistics?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionTenantStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionTenantStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEditionTenantStatisticsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEditionTenantStatisticsOutput>;
        }));
    }

    protected processGetEditionTenantStatistics(response: HttpResponseBase): Observable<GetEditionTenantStatisticsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEditionTenantStatisticsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEditionTenantStatisticsOutput>(null as any);
    }
}

@Injectable()
export class HostSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<HostSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HostSettingsEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HostSettingsEditDto>;
        }));
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<HostSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HostSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HostSettingsEditDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAllSettings(body: HostSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param password (optional) 
     * @return Success
     */
    updateSMTPPassword(password: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/UpdateSMTPPassword?";
        if (password !== undefined && password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSMTPPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSMTPPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSMTPPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTestEmail(body: SendTestEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class HRMSReportsServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param fromdate (optional) 
     * @param todate (optional) 
     * @param locationId (optional) 
     * @param departmentId (optional) 
     * @return Success
     */
    getExpenseRegisterDetails(fromdate: moment.Moment | undefined, todate: moment.Moment | undefined, locationId: number | undefined, departmentId: number | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetExpenseRegisterDetails?";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (todate === null)
            throw new Error("The parameter 'todate' cannot be null.");
        else if (todate !== undefined)
            url_ += "todate=" + encodeURIComponent(todate ? "" + todate.toISOString() : "") + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExpenseRegisterDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExpenseRegisterDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetExpenseRegisterDetails(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param fromdate (optional) 
     * @param todate (optional) 
     * @param locationId (optional) 
     * @param departmentId (optional) 
     * @return Success
     */
    getExpenseRegisterDetailsExcel(fromdate: moment.Moment | undefined, todate: moment.Moment | undefined, locationId: number | undefined, departmentId: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetExpenseRegisterDetailsExcel?";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (todate === null)
            throw new Error("The parameter 'todate' cannot be null.");
        else if (todate !== undefined)
            url_ += "todate=" + encodeURIComponent(todate ? "" + todate.toISOString() : "") + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExpenseRegisterDetailsExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExpenseRegisterDetailsExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetExpenseRegisterDetailsExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param formDate (optional) 
     * @param toDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAdvanceRequest(filter: string | null | undefined, formDate: moment.Moment | undefined, toDate: moment.Moment | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TabularReportOfAdvanceRequestsTable> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetAdvanceRequest?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (formDate === null)
            throw new Error("The parameter 'formDate' cannot be null.");
        else if (formDate !== undefined)
            url_ += "FormDate=" + encodeURIComponent(formDate ? "" + formDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvanceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvanceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TabularReportOfAdvanceRequestsTable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TabularReportOfAdvanceRequestsTable>;
        }));
    }

    protected processGetAdvanceRequest(response: HttpResponseBase): Observable<TabularReportOfAdvanceRequestsTable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TabularReportOfAdvanceRequestsTable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TabularReportOfAdvanceRequestsTable>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @return Success
     */
    getPFForm12A(monthYear: string | null | undefined): Observable<PFForm12A> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetPFForm12A?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPFForm12A(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPFForm12A(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PFForm12A>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PFForm12A>;
        }));
    }

    protected processGetPFForm12A(response: HttpResponseBase): Observable<PFForm12A> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PFForm12A.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PFForm12A>(null as any);
    }

    /**
     * @param fromdate (optional) 
     * @param todate (optional) 
     * @return Success
     */
    getLwfContribution(fromdate: moment.Moment | undefined, todate: moment.Moment | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetLwfContribution?";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (todate === null)
            throw new Error("The parameter 'todate' cannot be null.");
        else if (todate !== undefined)
            url_ += "todate=" + encodeURIComponent(todate ? "" + todate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLwfContribution(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLwfContribution(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetLwfContribution(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param fromdate (optional) 
     * @param todate (optional) 
     * @return Success
     */
    getLwfContributionExcel(fromdate: moment.Moment | undefined, todate: moment.Moment | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetLwfContributionExcel?";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (todate === null)
            throw new Error("The parameter 'todate' cannot be null.");
        else if (todate !== undefined)
            url_ += "todate=" + encodeURIComponent(todate ? "" + todate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLwfContributionExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLwfContributionExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetLwfContributionExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @return Success
     */
    getMonthlyPFChallan(monthYear: string | null | undefined): Observable<MonthlyPFChallan> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetMonthlyPFChallan?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthlyPFChallan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthlyPFChallan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonthlyPFChallan>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonthlyPFChallan>;
        }));
    }

    protected processGetMonthlyPFChallan(response: HttpResponseBase): Observable<MonthlyPFChallan> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonthlyPFChallan.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MonthlyPFChallan>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @return Success
     */
    getMonthlyESIChallan(monthYear: string | null | undefined): Observable<MonthlyPFChallan> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetMonthlyESIChallan?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthlyESIChallan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthlyESIChallan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonthlyPFChallan>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonthlyPFChallan>;
        }));
    }

    protected processGetMonthlyESIChallan(response: HttpResponseBase): Observable<MonthlyPFChallan> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonthlyPFChallan.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MonthlyPFChallan>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @return Success
     */
    getPFDCRUploadExcel(monthYear: string | null | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetPFDCRUploadExcel?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPFDCRUploadExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPFDCRUploadExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetPFDCRUploadExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @return Success
     */
    getPFDCRUploadNotePad(monthYear: string | null | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetPFDCRUploadNotePad?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPFDCRUploadNotePad(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPFDCRUploadNotePad(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetPFDCRUploadNotePad(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param fromdate (optional) 
     * @param employeeName (optional) 
     * @param branchid (optional) 
     * @return Success
     */
    getLeaveregisterReport(fromdate: moment.Moment | undefined, employeeName: string | null | undefined, branchid: number | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetLeaveregisterReport?";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (employeeName !== undefined && employeeName !== null)
            url_ += "EmployeeName=" + encodeURIComponent("" + employeeName) + "&";
        if (branchid === null)
            throw new Error("The parameter 'branchid' cannot be null.");
        else if (branchid !== undefined)
            url_ += "branchid=" + encodeURIComponent("" + branchid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveregisterReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveregisterReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetLeaveregisterReport(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param fromdate (optional) 
     * @param employeeName (optional) 
     * @param branchid (optional) 
     * @return Success
     */
    getLeaveRegisterReportExcel(fromdate: moment.Moment | undefined, employeeName: string | null | undefined, branchid: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetLeaveRegisterReportExcel?";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (employeeName !== undefined && employeeName !== null)
            url_ += "EmployeeName=" + encodeURIComponent("" + employeeName) + "&";
        if (branchid === null)
            throw new Error("The parameter 'branchid' cannot be null.");
        else if (branchid !== undefined)
            url_ += "branchid=" + encodeURIComponent("" + branchid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveRegisterReportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveRegisterReportExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetLeaveRegisterReportExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPunchSummaryReport(body: GetPunchSummaryParameterDto | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetPunchSummaryReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPunchSummaryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPunchSummaryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetPunchSummaryReport(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPunchSummaryReportExcel(body: GetPunchSummaryParameterDto | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetPunchSummaryReportExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPunchSummaryReportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPunchSummaryReportExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetPunchSummaryReportExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param assetType (optional) 
     * @return Success
     */
    getAssetReports(id: number | undefined, assetType: number | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetAssetReports?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (assetType === null)
            throw new Error("The parameter 'assetType' cannot be null.");
        else if (assetType !== undefined)
            url_ += "assetType=" + encodeURIComponent("" + assetType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetAssetReports(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param id (optional) 
     * @param assetType (optional) 
     * @return Success
     */
    getAssetReportExcel(id: number | undefined, assetType: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetAssetReportExcel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (assetType === null)
            throw new Error("The parameter 'assetType' cannot be null.");
        else if (assetType !== undefined)
            url_ += "assetType=" + encodeURIComponent("" + assetType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetReportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetReportExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetAssetReportExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param paymentmode (optional) 
     * @param locationId (optional) 
     * @return Success
     */
    getBankPaymentSheet(monthYear: string | null | undefined, paymentmode: number | undefined, locationId: number | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetBankPaymentSheet?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (paymentmode === null)
            throw new Error("The parameter 'paymentmode' cannot be null.");
        else if (paymentmode !== undefined)
            url_ += "paymentmode=" + encodeURIComponent("" + paymentmode) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBankPaymentSheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBankPaymentSheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetBankPaymentSheet(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param paymentmode (optional) 
     * @param locationId (optional) 
     * @return Success
     */
    getBankPaymentSheetExcel(monthYear: string | null | undefined, paymentmode: number | undefined, locationId: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetBankPaymentSheetExcel?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (paymentmode === null)
            throw new Error("The parameter 'paymentmode' cannot be null.");
        else if (paymentmode !== undefined)
            url_ += "paymentmode=" + encodeURIComponent("" + paymentmode) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBankPaymentSheetExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBankPaymentSheetExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetBankPaymentSheetExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @return Success
     */
    previewProcess(monthYear: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/PreviewProcess?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreviewProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreviewProcess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPreviewProcess(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param employmentTypeId (optional) 
     * @param locationIds (optional) 
     * @param departmentId (optional) 
     * @param employeeid (optional) 
     * @return Success
     */
    getSalaryPreview(monthYear: string | null | undefined, employmentTypeId: number | undefined, locationIds: number[] | null | undefined, departmentId: number | undefined, employeeid: number | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetSalaryPreview?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (employmentTypeId === null)
            throw new Error("The parameter 'employmentTypeId' cannot be null.");
        else if (employmentTypeId !== undefined)
            url_ += "employmentTypeId=" + encodeURIComponent("" + employmentTypeId) + "&";
        if (locationIds !== undefined && locationIds !== null)
            locationIds && locationIds.forEach(item => { url_ += "locationIds=" + encodeURIComponent("" + item) + "&"; });
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalaryPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalaryPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetSalaryPreview(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param employmentTypeId (optional) 
     * @param locationIds (optional) 
     * @param departmentId (optional) 
     * @param employeeid (optional) 
     * @return Success
     */
    getSalarPreviewExcel(monthYear: string | null | undefined, employmentTypeId: number | undefined, locationIds: number[] | null | undefined, departmentId: number | undefined, employeeid: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetSalarPreviewExcel?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (employmentTypeId === null)
            throw new Error("The parameter 'employmentTypeId' cannot be null.");
        else if (employmentTypeId !== undefined)
            url_ += "employmentTypeId=" + encodeURIComponent("" + employmentTypeId) + "&";
        if (locationIds !== undefined && locationIds !== null)
            locationIds && locationIds.forEach(item => { url_ += "locationIds=" + encodeURIComponent("" + item) + "&"; });
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalarPreviewExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalarPreviewExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetSalarPreviewExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param monthyear (optional) 
     * @param locationId (optional) 
     * @param employeeid (optional) 
     * @param department (optional) 
     * @param flag (optional) 
     * @return Success
     */
    getReportForDATEofJoining(monthyear: string | null | undefined, locationId: number | undefined, employeeid: number | undefined, department: number | undefined, flag: number | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetReportForDATEofJoining?";
        if (monthyear !== undefined && monthyear !== null)
            url_ += "monthyear=" + encodeURIComponent("" + monthyear) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        if (department === null)
            throw new Error("The parameter 'department' cannot be null.");
        else if (department !== undefined)
            url_ += "department=" + encodeURIComponent("" + department) + "&";
        if (flag === null)
            throw new Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportForDATEofJoining(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportForDATEofJoining(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetReportForDATEofJoining(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param monthyear (optional) 
     * @param locationId (optional) 
     * @param employeeid (optional) 
     * @param department (optional) 
     * @param flag (optional) 
     * @return Success
     */
    getReportForDATEofJoiningExcel(monthyear: string | null | undefined, locationId: number | undefined, employeeid: number | undefined, department: number | undefined, flag: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetReportForDATEofJoiningExcel?";
        if (monthyear !== undefined && monthyear !== null)
            url_ += "monthyear=" + encodeURIComponent("" + monthyear) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        if (department === null)
            throw new Error("The parameter 'department' cannot be null.");
        else if (department !== undefined)
            url_ += "department=" + encodeURIComponent("" + department) + "&";
        if (flag === null)
            throw new Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportForDATEofJoiningExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportForDATEofJoiningExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetReportForDATEofJoiningExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param employeeid (optional) 
     * @param locationId (optional) 
     * @param department (optional) 
     * @return Success
     */
    getReportForDetailsExsistingEmp(employeeid: number | undefined, locationId: number | undefined, department: number | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/getReportForDetailsExsistingEmp?";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (department === null)
            throw new Error("The parameter 'department' cannot be null.");
        else if (department !== undefined)
            url_ += "department=" + encodeURIComponent("" + department) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportForDetailsExsistingEmp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportForDetailsExsistingEmp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetReportForDetailsExsistingEmp(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param employeeid (optional) 
     * @return Success
     */
    getReportForExsistingofJoiningExcel(employeeid: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetReportForExsistingofJoiningExcel?";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportForExsistingofJoiningExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportForExsistingofJoiningExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetReportForExsistingofJoiningExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param employmentTypeId (optional) 
     * @param locationId (optional) 
     * @param departmentId (optional) 
     * @param employeeid (optional) 
     * @return Success
     */
    getPayoutRegister(monthYear: string | null | undefined, employmentTypeId: number | undefined, locationId: number | undefined, departmentId: number | undefined, employeeid: number | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetPayoutRegister?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (employmentTypeId === null)
            throw new Error("The parameter 'employmentTypeId' cannot be null.");
        else if (employmentTypeId !== undefined)
            url_ += "employmentTypeId=" + encodeURIComponent("" + employmentTypeId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayoutRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayoutRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetPayoutRegister(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param employmentTypeId (optional) 
     * @param locationId (optional) 
     * @param departmentId (optional) 
     * @param employeeid (optional) 
     * @return Success
     */
    getPayoutRegisterExcel(monthYear: string | null | undefined, employmentTypeId: number | undefined, locationId: number | undefined, departmentId: number | undefined, employeeid: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetPayoutRegisterExcel?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (employmentTypeId === null)
            throw new Error("The parameter 'employmentTypeId' cannot be null.");
        else if (employmentTypeId !== undefined)
            url_ += "employmentTypeId=" + encodeURIComponent("" + employmentTypeId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayoutRegisterExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayoutRegisterExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetPayoutRegisterExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param year (optional) 
     * @param filterEmpId (optional) 
     * @param showNegativeAllowedLeaves (optional) 
     * @return Success
     */
    leaveConsolidatedReport(year: number | undefined, filterEmpId: number | undefined, showNegativeAllowedLeaves: boolean | undefined): Observable<ClumnRowDataLeave[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/LeaveConsolidatedReport?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (filterEmpId === null)
            throw new Error("The parameter 'filterEmpId' cannot be null.");
        else if (filterEmpId !== undefined)
            url_ += "filterEmpId=" + encodeURIComponent("" + filterEmpId) + "&";
        if (showNegativeAllowedLeaves === null)
            throw new Error("The parameter 'showNegativeAllowedLeaves' cannot be null.");
        else if (showNegativeAllowedLeaves !== undefined)
            url_ += "showNegativeAllowedLeaves=" + encodeURIComponent("" + showNegativeAllowedLeaves) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLeaveConsolidatedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLeaveConsolidatedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowDataLeave[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowDataLeave[]>;
        }));
    }

    protected processLeaveConsolidatedReport(response: HttpResponseBase): Observable<ClumnRowDataLeave[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClumnRowDataLeave.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowDataLeave[]>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param reportFlag (optional) 
     * @param cyclevalue (optional) 
     * @param filterEmpId (optional) 
     * @param filterLocationId (optional) 
     * @param department (optional) 
     * @return Success
     */
    getLateComingReport(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, reportFlag: number | undefined, cyclevalue: string | null | undefined, filterEmpId: number | undefined, filterLocationId: number | undefined, department: string | null | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetLateComingReport?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (reportFlag === null)
            throw new Error("The parameter 'reportFlag' cannot be null.");
        else if (reportFlag !== undefined)
            url_ += "reportFlag=" + encodeURIComponent("" + reportFlag) + "&";
        if (cyclevalue !== undefined && cyclevalue !== null)
            url_ += "cyclevalue=" + encodeURIComponent("" + cyclevalue) + "&";
        if (filterEmpId === null)
            throw new Error("The parameter 'filterEmpId' cannot be null.");
        else if (filterEmpId !== undefined)
            url_ += "filterEmpId=" + encodeURIComponent("" + filterEmpId) + "&";
        if (filterLocationId === null)
            throw new Error("The parameter 'filterLocationId' cannot be null.");
        else if (filterLocationId !== undefined)
            url_ += "filterLocationId=" + encodeURIComponent("" + filterLocationId) + "&";
        if (department !== undefined && department !== null)
            url_ += "department=" + encodeURIComponent("" + department) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLateComingReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLateComingReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetLateComingReport(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param filterLocationId (optional) 
     * @param filterDepartmentId (optional) 
     * @param filterEmpId (optional) 
     * @param fromMonth (optional) 
     * @param toMonth (optional) 
     * @param year (optional) 
     * @return Success
     */
    getYearlySalarySummaryReport(filterLocationId: number | undefined, filterDepartmentId: number | undefined, filterEmpId: number | undefined, fromMonth: number | undefined, toMonth: number | undefined, year: number | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetYearlySalarySummaryReport?";
        if (filterLocationId === null)
            throw new Error("The parameter 'filterLocationId' cannot be null.");
        else if (filterLocationId !== undefined)
            url_ += "filterLocationId=" + encodeURIComponent("" + filterLocationId) + "&";
        if (filterDepartmentId === null)
            throw new Error("The parameter 'filterDepartmentId' cannot be null.");
        else if (filterDepartmentId !== undefined)
            url_ += "filterDepartmentId=" + encodeURIComponent("" + filterDepartmentId) + "&";
        if (filterEmpId === null)
            throw new Error("The parameter 'filterEmpId' cannot be null.");
        else if (filterEmpId !== undefined)
            url_ += "filterEmpId=" + encodeURIComponent("" + filterEmpId) + "&";
        if (fromMonth === null)
            throw new Error("The parameter 'fromMonth' cannot be null.");
        else if (fromMonth !== undefined)
            url_ += "FromMonth=" + encodeURIComponent("" + fromMonth) + "&";
        if (toMonth === null)
            throw new Error("The parameter 'toMonth' cannot be null.");
        else if (toMonth !== undefined)
            url_ += "ToMonth=" + encodeURIComponent("" + toMonth) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetYearlySalarySummaryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetYearlySalarySummaryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetYearlySalarySummaryReport(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param filterLocationId (optional) 
     * @param filterDepartmentId (optional) 
     * @param filterEmpId (optional) 
     * @param fromMonth (optional) 
     * @param toMonth (optional) 
     * @param year (optional) 
     * @return Success
     */
    getYearlySalarySummaryReportExcel(filterLocationId: number | undefined, filterDepartmentId: number | undefined, filterEmpId: number | undefined, fromMonth: number | undefined, toMonth: number | undefined, year: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetYearlySalarySummaryReportExcel?";
        if (filterLocationId === null)
            throw new Error("The parameter 'filterLocationId' cannot be null.");
        else if (filterLocationId !== undefined)
            url_ += "filterLocationId=" + encodeURIComponent("" + filterLocationId) + "&";
        if (filterDepartmentId === null)
            throw new Error("The parameter 'filterDepartmentId' cannot be null.");
        else if (filterDepartmentId !== undefined)
            url_ += "filterDepartmentId=" + encodeURIComponent("" + filterDepartmentId) + "&";
        if (filterEmpId === null)
            throw new Error("The parameter 'filterEmpId' cannot be null.");
        else if (filterEmpId !== undefined)
            url_ += "filterEmpId=" + encodeURIComponent("" + filterEmpId) + "&";
        if (fromMonth === null)
            throw new Error("The parameter 'fromMonth' cannot be null.");
        else if (fromMonth !== undefined)
            url_ += "FromMonth=" + encodeURIComponent("" + fromMonth) + "&";
        if (toMonth === null)
            throw new Error("The parameter 'toMonth' cannot be null.");
        else if (toMonth !== undefined)
            url_ += "ToMonth=" + encodeURIComponent("" + toMonth) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetYearlySalarySummaryReportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetYearlySalarySummaryReportExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetYearlySalarySummaryReportExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param year (optional) 
     * @param filterEmpId (optional) 
     * @param showNegativeAllowedLeaves (optional) 
     * @return Success
     */
    exportLeaveConsolidatedReportToExcel(year: number | undefined, filterEmpId: number | undefined, showNegativeAllowedLeaves: boolean | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/ExportLeaveConsolidatedReportToExcel?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (filterEmpId === null)
            throw new Error("The parameter 'filterEmpId' cannot be null.");
        else if (filterEmpId !== undefined)
            url_ += "filterEmpId=" + encodeURIComponent("" + filterEmpId) + "&";
        if (showNegativeAllowedLeaves === null)
            throw new Error("The parameter 'showNegativeAllowedLeaves' cannot be null.");
        else if (showNegativeAllowedLeaves !== undefined)
            url_ += "showNegativeAllowedLeaves=" + encodeURIComponent("" + showNegativeAllowedLeaves) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportLeaveConsolidatedReportToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportLeaveConsolidatedReportToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processExportLeaveConsolidatedReportToExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return Success
     */
    getEmployeeAttendanceSummaryReportExcel(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetEmployeeAttendanceSummaryReportExcel?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeAttendanceSummaryReportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeAttendanceSummaryReportExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetEmployeeAttendanceSummaryReportExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return Success
     */
    getEmployeeAttendanceSummaryReport(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined): Observable<EmployeeDailySummary[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetEmployeeAttendanceSummaryReport?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeAttendanceSummaryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeAttendanceSummaryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeDailySummary[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeDailySummary[]>;
        }));
    }

    protected processGetEmployeeAttendanceSummaryReport(response: HttpResponseBase): Observable<EmployeeDailySummary[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeDailySummary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeDailySummary[]>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param employeeid (optional) 
     * @param branchid (optional) 
     * @param departmentId (optional) 
     * @return Success
     */
    getAttendanceSummaryReport(fromDate: string | null | undefined, toDate: string | null | undefined, employeeid: number | undefined, branchid: number | undefined, departmentId: number | undefined): Observable<AttendanceSummaryDTO[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetAttendanceSummaryReport?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        if (branchid === null)
            throw new Error("The parameter 'branchid' cannot be null.");
        else if (branchid !== undefined)
            url_ += "branchid=" + encodeURIComponent("" + branchid) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceSummaryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceSummaryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendanceSummaryDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendanceSummaryDTO[]>;
        }));
    }

    protected processGetAttendanceSummaryReport(response: HttpResponseBase): Observable<AttendanceSummaryDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttendanceSummaryDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AttendanceSummaryDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getRequestApprovalPendingReport(body: GetRequestPendingParameterDto | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetRequestApprovalPendingReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestApprovalPendingReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestApprovalPendingReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetRequestApprovalPendingReport(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getLeaveRegisterReport(body: GetLeaveRegisterReport | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetLeaveRegisterReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveRegisterReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveRegisterReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetLeaveRegisterReport(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getLeaveRegisterYearlyReportExcel(body: GetYearlyLeaveReport | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetLeaveRegisterYearlyReportExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveRegisterYearlyReportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveRegisterYearlyReportExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetLeaveRegisterYearlyReportExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getLeaveRegisterMonthlyReportExcel(body: GetMonthlyLeaveReport | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetLeaveRegisterMonthlyReportExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveRegisterMonthlyReportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveRegisterMonthlyReportExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetLeaveRegisterMonthlyReportExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getLeaveRegisterDetailsReportExcel(body: GetLeaveRegisterReport | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetLeaveRegisterDetailsReportExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveRegisterDetailsReportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveRegisterDetailsReportExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetLeaveRegisterDetailsReportExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getRequestApprovalPendingReportExcel(body: GetRequestPendingParameterDto | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/getRequestApprovalPendingReportExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestApprovalPendingReportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestApprovalPendingReportExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetRequestApprovalPendingReportExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getPerformanceReportUsingDataCaptureData(month: number | undefined, year: number | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetPerformanceReportUsingDataCaptureData?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPerformanceReportUsingDataCaptureData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPerformanceReportUsingDataCaptureData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetPerformanceReportUsingDataCaptureData(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getPerformanceReportUsingDataCaptureDataExcel(month: number | undefined, year: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetPerformanceReportUsingDataCaptureDataExcel?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPerformanceReportUsingDataCaptureDataExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPerformanceReportUsingDataCaptureDataExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetPerformanceReportUsingDataCaptureDataExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param employeeid (optional) 
     * @param branchid (optional) 
     * @param includeInOutTimes (optional) 
     * @param departmentId (optional) 
     * @return Success
     */
    getAttendanceSummaryExcel(fromDate: string | null | undefined, toDate: string | null | undefined, employeeid: number | undefined, branchid: number | undefined, includeInOutTimes: boolean | undefined, departmentId: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetAttendanceSummaryExcel?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        if (branchid === null)
            throw new Error("The parameter 'branchid' cannot be null.");
        else if (branchid !== undefined)
            url_ += "branchid=" + encodeURIComponent("" + branchid) + "&";
        if (includeInOutTimes === null)
            throw new Error("The parameter 'includeInOutTimes' cannot be null.");
        else if (includeInOutTimes !== undefined)
            url_ += "includeInOutTimes=" + encodeURIComponent("" + includeInOutTimes) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceSummaryExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceSummaryExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetAttendanceSummaryExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param employeeid (optional) 
     * @param branchid (optional) 
     * @param departmentId (optional) 
     * @return Success
     */
    getModifiedAttendanceSummaryReport(fromDate: string | null | undefined, toDate: string | null | undefined, employeeid: number | undefined, branchid: number | undefined, departmentId: number | undefined): Observable<AttendanceSummaryDTO[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetModifiedAttendanceSummaryReport?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        if (branchid === null)
            throw new Error("The parameter 'branchid' cannot be null.");
        else if (branchid !== undefined)
            url_ += "branchid=" + encodeURIComponent("" + branchid) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetModifiedAttendanceSummaryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetModifiedAttendanceSummaryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendanceSummaryDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendanceSummaryDTO[]>;
        }));
    }

    protected processGetModifiedAttendanceSummaryReport(response: HttpResponseBase): Observable<AttendanceSummaryDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttendanceSummaryDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AttendanceSummaryDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPunchReport(body: GetPunchSummaryParameterDto | undefined): Observable<PunchReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetPunchReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPunchReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPunchReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PunchReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PunchReportDto[]>;
        }));
    }

    protected processGetPunchReport(response: HttpResponseBase): Observable<PunchReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PunchReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PunchReportDto[]>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param employeeid (optional) 
     * @param branchid (optional) 
     * @param includeInOutTimes (optional) 
     * @param departmentId (optional) 
     * @return Success
     */
    getModifiedAttendanceSummaryExcel(fromDate: string | null | undefined, toDate: string | null | undefined, employeeid: number | undefined, branchid: number | undefined, includeInOutTimes: boolean | undefined, departmentId: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetModifiedAttendanceSummaryExcel?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        if (branchid === null)
            throw new Error("The parameter 'branchid' cannot be null.");
        else if (branchid !== undefined)
            url_ += "branchid=" + encodeURIComponent("" + branchid) + "&";
        if (includeInOutTimes === null)
            throw new Error("The parameter 'includeInOutTimes' cannot be null.");
        else if (includeInOutTimes !== undefined)
            url_ += "includeInOutTimes=" + encodeURIComponent("" + includeInOutTimes) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetModifiedAttendanceSummaryExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetModifiedAttendanceSummaryExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetModifiedAttendanceSummaryExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param reportFlag (optional) 
     * @param cyclevalue (optional) 
     * @param filterEmpId (optional) 
     * @param filterLocationId (optional) 
     * @param department (optional) 
     * @return Success
     */
    getLateComingSummaryReportExcel(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, reportFlag: number | undefined, cyclevalue: string | null | undefined, filterEmpId: number | undefined, filterLocationId: number | undefined, department: string | null | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetLateComingSummaryReportExcel?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (reportFlag === null)
            throw new Error("The parameter 'reportFlag' cannot be null.");
        else if (reportFlag !== undefined)
            url_ += "reportFlag=" + encodeURIComponent("" + reportFlag) + "&";
        if (cyclevalue !== undefined && cyclevalue !== null)
            url_ += "cyclevalue=" + encodeURIComponent("" + cyclevalue) + "&";
        if (filterEmpId === null)
            throw new Error("The parameter 'filterEmpId' cannot be null.");
        else if (filterEmpId !== undefined)
            url_ += "filterEmpId=" + encodeURIComponent("" + filterEmpId) + "&";
        if (filterLocationId === null)
            throw new Error("The parameter 'filterLocationId' cannot be null.");
        else if (filterLocationId !== undefined)
            url_ += "filterLocationId=" + encodeURIComponent("" + filterLocationId) + "&";
        if (department !== undefined && department !== null)
            url_ += "department=" + encodeURIComponent("" + department) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLateComingSummaryReportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLateComingSummaryReportExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetLateComingSummaryReportExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param fromdate (optional) 
     * @param todate (optional) 
     * @return Success
     */
    getAuditLogReport(fromdate: moment.Moment | undefined, todate: moment.Moment | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetAuditLogReport?";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (todate === null)
            throw new Error("The parameter 'todate' cannot be null.");
        else if (todate !== undefined)
            url_ += "todate=" + encodeURIComponent(todate ? "" + todate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetAuditLogReport(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param fromdate (optional) 
     * @param todate (optional) 
     * @return Success
     */
    getAuditLogReportToExcel(fromdate: moment.Moment | undefined, todate: moment.Moment | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/getAuditLogReportToExcel?";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (todate === null)
            throw new Error("The parameter 'todate' cannot be null.");
        else if (todate !== undefined)
            url_ += "todate=" + encodeURIComponent(todate ? "" + todate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogReportToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogReportToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetAuditLogReportToExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param employmentTypeId (optional) 
     * @param locationId (optional) 
     * @param departmentId (optional) 
     * @return Success
     */
    getSalaryRegisterBasic(employmentTypeId: number | undefined, locationId: number | undefined, departmentId: number | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetSalaryRegisterBasic?";
        if (employmentTypeId === null)
            throw new Error("The parameter 'employmentTypeId' cannot be null.");
        else if (employmentTypeId !== undefined)
            url_ += "employmentTypeId=" + encodeURIComponent("" + employmentTypeId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalaryRegisterBasic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalaryRegisterBasic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetSalaryRegisterBasic(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param flag (optional) 
     * @param departmentid (optional) 
     * @param locationid (optional) 
     * @param fromdate (optional) 
     * @param todate (optional) 
     * @return Success
     */
    getMonthlyExpenseReport(flag: number | undefined, departmentid: number | null | undefined, locationid: number | null | undefined, fromdate: moment.Moment | undefined, todate: moment.Moment | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetMonthlyExpenseReport?";
        if (flag === null)
            throw new Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        if (departmentid !== undefined && departmentid !== null)
            url_ += "departmentid=" + encodeURIComponent("" + departmentid) + "&";
        if (locationid !== undefined && locationid !== null)
            url_ += "locationid=" + encodeURIComponent("" + locationid) + "&";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (todate === null)
            throw new Error("The parameter 'todate' cannot be null.");
        else if (todate !== undefined)
            url_ += "todate=" + encodeURIComponent(todate ? "" + todate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthlyExpenseReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthlyExpenseReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetMonthlyExpenseReport(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param flag (optional) 
     * @param departmentid (optional) 
     * @param locationid (optional) 
     * @param fromdate (optional) 
     * @param todate (optional) 
     * @return Success
     */
    getMonthlyExpenseExcelReport(flag: number | undefined, departmentid: number | null | undefined, locationid: number | null | undefined, fromdate: moment.Moment | undefined, todate: moment.Moment | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetMonthlyExpenseExcelReport?";
        if (flag === null)
            throw new Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        if (departmentid !== undefined && departmentid !== null)
            url_ += "departmentid=" + encodeURIComponent("" + departmentid) + "&";
        if (locationid !== undefined && locationid !== null)
            url_ += "locationid=" + encodeURIComponent("" + locationid) + "&";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (todate === null)
            throw new Error("The parameter 'todate' cannot be null.");
        else if (todate !== undefined)
            url_ += "todate=" + encodeURIComponent(todate ? "" + todate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthlyExpenseExcelReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthlyExpenseExcelReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetMonthlyExpenseExcelReport(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param departmentid (optional) 
     * @param locationid (optional) 
     * @param fromdate (optional) 
     * @param todate (optional) 
     * @param status (optional) 
     * @param flag (optional) 
     * @return Success
     */
    getMonthlyExpenseRegister(departmentid: number | null | undefined, locationid: number | null | undefined, fromdate: moment.Moment | undefined, todate: moment.Moment | undefined, status: number | undefined, flag: number | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetMonthlyExpenseRegister?";
        if (departmentid !== undefined && departmentid !== null)
            url_ += "departmentid=" + encodeURIComponent("" + departmentid) + "&";
        if (locationid !== undefined && locationid !== null)
            url_ += "locationid=" + encodeURIComponent("" + locationid) + "&";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (todate === null)
            throw new Error("The parameter 'todate' cannot be null.");
        else if (todate !== undefined)
            url_ += "todate=" + encodeURIComponent(todate ? "" + todate.toISOString() : "") + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (flag === null)
            throw new Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthlyExpenseRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthlyExpenseRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetMonthlyExpenseRegister(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param departmentid (optional) 
     * @param locationid (optional) 
     * @param fromdate (optional) 
     * @param todate (optional) 
     * @param status (optional) 
     * @param flag (optional) 
     * @return Success
     */
    getExpenseRegisterExcelReport(departmentid: number | null | undefined, locationid: number | null | undefined, fromdate: moment.Moment | undefined, todate: moment.Moment | undefined, status: number | undefined, flag: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetExpenseRegisterExcelReport?";
        if (departmentid !== undefined && departmentid !== null)
            url_ += "departmentid=" + encodeURIComponent("" + departmentid) + "&";
        if (locationid !== undefined && locationid !== null)
            url_ += "locationid=" + encodeURIComponent("" + locationid) + "&";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (todate === null)
            throw new Error("The parameter 'todate' cannot be null.");
        else if (todate !== undefined)
            url_ += "todate=" + encodeURIComponent(todate ? "" + todate.toISOString() : "") + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (flag === null)
            throw new Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExpenseRegisterExcelReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExpenseRegisterExcelReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetExpenseRegisterExcelReport(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param employmentTypeId (optional) 
     * @param locationId (optional) 
     * @param departmentId (optional) 
     * @return Success
     */
    getSalarySummaryReport(employmentTypeId: number | undefined, locationId: number | undefined, departmentId: number | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetSalarySummaryReport?";
        if (employmentTypeId === null)
            throw new Error("The parameter 'employmentTypeId' cannot be null.");
        else if (employmentTypeId !== undefined)
            url_ += "employmentTypeId=" + encodeURIComponent("" + employmentTypeId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalarySummaryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalarySummaryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetSalarySummaryReport(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param leavetypeId (optional) 
     * @param fromdate (optional) 
     * @param todate (optional) 
     * @param employeeName (optional) 
     * @return Success
     */
    getLeaveConsumedReport(leavetypeId: number | undefined, fromdate: moment.Moment | undefined, todate: moment.Moment | undefined, employeeName: string | null | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetLeaveConsumedReport?";
        if (leavetypeId === null)
            throw new Error("The parameter 'leavetypeId' cannot be null.");
        else if (leavetypeId !== undefined)
            url_ += "leavetypeId=" + encodeURIComponent("" + leavetypeId) + "&";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (todate === null)
            throw new Error("The parameter 'todate' cannot be null.");
        else if (todate !== undefined)
            url_ += "todate=" + encodeURIComponent(todate ? "" + todate.toISOString() : "") + "&";
        if (employeeName !== undefined && employeeName !== null)
            url_ += "EmployeeName=" + encodeURIComponent("" + employeeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveConsumedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveConsumedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetLeaveConsumedReport(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param leavetypeId (optional) 
     * @param fromdate (optional) 
     * @param todate (optional) 
     * @param employeeName (optional) 
     * @return Success
     */
    getLeaveConsumedExcelReport(leavetypeId: number | undefined, fromdate: moment.Moment | undefined, todate: moment.Moment | undefined, employeeName: string | null | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetLeaveConsumedExcelReport?";
        if (leavetypeId === null)
            throw new Error("The parameter 'leavetypeId' cannot be null.");
        else if (leavetypeId !== undefined)
            url_ += "leavetypeId=" + encodeURIComponent("" + leavetypeId) + "&";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (todate === null)
            throw new Error("The parameter 'todate' cannot be null.");
        else if (todate !== undefined)
            url_ += "todate=" + encodeURIComponent(todate ? "" + todate.toISOString() : "") + "&";
        if (employeeName !== undefined && employeeName !== null)
            url_ += "EmployeeName=" + encodeURIComponent("" + employeeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveConsumedExcelReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveConsumedExcelReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetLeaveConsumedExcelReport(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param employmentTypeId (optional) 
     * @param locationId (optional) 
     * @param departmentId (optional) 
     * @return Success
     */
    getSalarySummaryExcel(employmentTypeId: number | undefined, locationId: number | undefined, departmentId: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetSalarySummaryExcel?";
        if (employmentTypeId === null)
            throw new Error("The parameter 'employmentTypeId' cannot be null.");
        else if (employmentTypeId !== undefined)
            url_ += "employmentTypeId=" + encodeURIComponent("" + employmentTypeId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalarySummaryExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalarySummaryExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetSalarySummaryExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param departmentId (optional) 
     * @param divisionId (optional) 
     * @param designationId (optional) 
     * @return Success
     */
    getEmployeesListingReport(departmentId: number | undefined, divisionId: number | undefined, designationId: number | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetEmployeesListingReport?";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (divisionId === null)
            throw new Error("The parameter 'divisionId' cannot be null.");
        else if (divisionId !== undefined)
            url_ += "divisionId=" + encodeURIComponent("" + divisionId) + "&";
        if (designationId === null)
            throw new Error("The parameter 'designationId' cannot be null.");
        else if (designationId !== undefined)
            url_ += "designationId=" + encodeURIComponent("" + designationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeesListingReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeesListingReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetEmployeesListingReport(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param departmentId (optional) 
     * @param divisionId (optional) 
     * @param designationId (optional) 
     * @return Success
     */
    getEmployeesUnderProbationListingReport(departmentId: number | undefined, divisionId: number | undefined, designationId: number | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetEmployeesUnderProbationListingReport?";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (divisionId === null)
            throw new Error("The parameter 'divisionId' cannot be null.");
        else if (divisionId !== undefined)
            url_ += "divisionId=" + encodeURIComponent("" + divisionId) + "&";
        if (designationId === null)
            throw new Error("The parameter 'designationId' cannot be null.");
        else if (designationId !== undefined)
            url_ += "designationId=" + encodeURIComponent("" + designationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeesUnderProbationListingReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeesUnderProbationListingReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetEmployeesUnderProbationListingReport(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param departmentId (optional) 
     * @param divisionId (optional) 
     * @param designationId (optional) 
     * @return Success
     */
    getEmployeesListingExcel(departmentId: number | undefined, divisionId: number | undefined, designationId: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetEmployeesListingExcel?";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (divisionId === null)
            throw new Error("The parameter 'divisionId' cannot be null.");
        else if (divisionId !== undefined)
            url_ += "divisionId=" + encodeURIComponent("" + divisionId) + "&";
        if (designationId === null)
            throw new Error("The parameter 'designationId' cannot be null.");
        else if (designationId !== undefined)
            url_ += "designationId=" + encodeURIComponent("" + designationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeesListingExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeesListingExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetEmployeesListingExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param departmentId (optional) 
     * @param divisionId (optional) 
     * @param designationId (optional) 
     * @return Success
     */
    getEmployees_UnderProbationListingExcel(departmentId: number | undefined, divisionId: number | undefined, designationId: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetEmployees_UnderProbationListingExcel?";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (divisionId === null)
            throw new Error("The parameter 'divisionId' cannot be null.");
        else if (divisionId !== undefined)
            url_ += "divisionId=" + encodeURIComponent("" + divisionId) + "&";
        if (designationId === null)
            throw new Error("The parameter 'designationId' cannot be null.");
        else if (designationId !== undefined)
            url_ += "designationId=" + encodeURIComponent("" + designationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployees_UnderProbationListingExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployees_UnderProbationListingExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetEmployees_UnderProbationListingExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param reportID (optional) 
     * @param formDate (optional) 
     * @param toDate (optional) 
     * @param employeeName (optional) 
     * @return Success
     */
    getTableInformation(reportID: number | undefined, formDate: moment.Moment | undefined, toDate: moment.Moment | undefined, employeeName: string | null | undefined): Observable<ClumnRow> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetTableInformation?";
        if (reportID === null)
            throw new Error("The parameter 'reportID' cannot be null.");
        else if (reportID !== undefined)
            url_ += "ReportID=" + encodeURIComponent("" + reportID) + "&";
        if (formDate === null)
            throw new Error("The parameter 'formDate' cannot be null.");
        else if (formDate !== undefined)
            url_ += "FormDate=" + encodeURIComponent(formDate ? "" + formDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (employeeName !== undefined && employeeName !== null)
            url_ += "EmployeeName=" + encodeURIComponent("" + employeeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTableInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTableInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRow>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRow>;
        }));
    }

    protected processGetTableInformation(response: HttpResponseBase): Observable<ClumnRow> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRow.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRow>(null as any);
    }

    /**
     * @param reportID (optional) 
     * @param formDate (optional) 
     * @param toDate (optional) 
     * @param employeeName (optional) 
     * @return Success
     */
    getDynamiReortForCompExcel(reportID: number | undefined, formDate: moment.Moment | undefined, toDate: moment.Moment | undefined, employeeName: string | null | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetDynamiReortForCompExcel?";
        if (reportID === null)
            throw new Error("The parameter 'reportID' cannot be null.");
        else if (reportID !== undefined)
            url_ += "ReportID=" + encodeURIComponent("" + reportID) + "&";
        if (formDate === null)
            throw new Error("The parameter 'formDate' cannot be null.");
        else if (formDate !== undefined)
            url_ += "FormDate=" + encodeURIComponent(formDate ? "" + formDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (employeeName !== undefined && employeeName !== null)
            url_ += "EmployeeName=" + encodeURIComponent("" + employeeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDynamiReortForCompExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDynamiReortForCompExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetDynamiReortForCompExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param employmentTypeid (optional) 
     * @param locationId (optional) 
     * @return Success
     */
    getPFStatement(monthYear: string | null | undefined, employmentTypeid: number | undefined, locationId: number | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetPFStatement?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (employmentTypeid === null)
            throw new Error("The parameter 'employmentTypeid' cannot be null.");
        else if (employmentTypeid !== undefined)
            url_ += "employmentTypeid=" + encodeURIComponent("" + employmentTypeid) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPFStatement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPFStatement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetPFStatement(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param employmentTypeid (optional) 
     * @param locationId (optional) 
     * @return Success
     */
    getExcePfExcel(monthYear: string | null | undefined, employmentTypeid: number | undefined, locationId: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetExcePfExcel?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (employmentTypeid === null)
            throw new Error("The parameter 'employmentTypeid' cannot be null.");
        else if (employmentTypeid !== undefined)
            url_ += "employmentTypeid=" + encodeURIComponent("" + employmentTypeid) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExcePfExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExcePfExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetExcePfExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param employmentTypeid (optional) 
     * @param locationId (optional) 
     * @return Success
     */
    getPfPdf(monthYear: string | null | undefined, employmentTypeid: number | undefined, locationId: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetPfPdf?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (employmentTypeid === null)
            throw new Error("The parameter 'employmentTypeid' cannot be null.");
        else if (employmentTypeid !== undefined)
            url_ += "employmentTypeid=" + encodeURIComponent("" + employmentTypeid) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPfPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPfPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetPfPdf(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param fromMonth (optional) 
     * @param toMonth (optional) 
     * @param year (optional) 
     * @param employeeId (optional) 
     * @param branch (optional) 
     * @param department (optional) 
     * @return Success
     */
    getAttendancePeriodicExcel(fromMonth: number | undefined, toMonth: number | undefined, year: number | undefined, employeeId: number | undefined, branch: number | undefined, department: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetAttendancePeriodicExcel?";
        if (fromMonth === null)
            throw new Error("The parameter 'fromMonth' cannot be null.");
        else if (fromMonth !== undefined)
            url_ += "fromMonth=" + encodeURIComponent("" + fromMonth) + "&";
        if (toMonth === null)
            throw new Error("The parameter 'toMonth' cannot be null.");
        else if (toMonth !== undefined)
            url_ += "toMonth=" + encodeURIComponent("" + toMonth) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (branch === null)
            throw new Error("The parameter 'branch' cannot be null.");
        else if (branch !== undefined)
            url_ += "branch=" + encodeURIComponent("" + branch) + "&";
        if (department === null)
            throw new Error("The parameter 'department' cannot be null.");
        else if (department !== undefined)
            url_ += "department=" + encodeURIComponent("" + department) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendancePeriodicExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendancePeriodicExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetAttendancePeriodicExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param fromMonth (optional) 
     * @param toMonth (optional) 
     * @param year (optional) 
     * @param employeeId (optional) 
     * @param branch (optional) 
     * @param department (optional) 
     * @return Success
     */
    getAttendancePeriodicReport(fromMonth: number | undefined, toMonth: number | undefined, year: number | undefined, employeeId: number | undefined, branch: number | undefined, department: number | undefined): Observable<EmployeeAttendanceReportDto> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetAttendancePeriodicReport?";
        if (fromMonth === null)
            throw new Error("The parameter 'fromMonth' cannot be null.");
        else if (fromMonth !== undefined)
            url_ += "fromMonth=" + encodeURIComponent("" + fromMonth) + "&";
        if (toMonth === null)
            throw new Error("The parameter 'toMonth' cannot be null.");
        else if (toMonth !== undefined)
            url_ += "toMonth=" + encodeURIComponent("" + toMonth) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (branch === null)
            throw new Error("The parameter 'branch' cannot be null.");
        else if (branch !== undefined)
            url_ += "branch=" + encodeURIComponent("" + branch) + "&";
        if (department === null)
            throw new Error("The parameter 'department' cannot be null.");
        else if (department !== undefined)
            url_ += "department=" + encodeURIComponent("" + department) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendancePeriodicReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendancePeriodicReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeAttendanceReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeAttendanceReportDto>;
        }));
    }

    protected processGetAttendancePeriodicReport(response: HttpResponseBase): Observable<EmployeeAttendanceReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeAttendanceReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeAttendanceReportDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllEmployeeIds(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetAllEmployeeIds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEmployeeIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEmployeeIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetAllEmployeeIds(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number[]>(null as any);
    }

    /**
     * @param monthyear (optional) 
     * @param employeeid (optional) 
     * @param branchid (optional) 
     * @param department (optional) 
     * @return Success
     */
    getAttendanceReport(monthyear: string | null | undefined, employeeid: number | undefined, branchid: number | undefined, department: number | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetAttendanceReport?";
        if (monthyear !== undefined && monthyear !== null)
            url_ += "monthyear=" + encodeURIComponent("" + monthyear) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        if (branchid === null)
            throw new Error("The parameter 'branchid' cannot be null.");
        else if (branchid !== undefined)
            url_ += "branchid=" + encodeURIComponent("" + branchid) + "&";
        if (department === null)
            throw new Error("The parameter 'department' cannot be null.");
        else if (department !== undefined)
            url_ += "department=" + encodeURIComponent("" + department) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetAttendanceReport(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getLeaveSummaryMonthly(body: GetMonthlyLeaveReport | undefined): Observable<LeaveSummaryTransformedDto> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetLeaveSummaryMonthly";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveSummaryMonthly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveSummaryMonthly(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveSummaryTransformedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveSummaryTransformedDto>;
        }));
    }

    protected processGetLeaveSummaryMonthly(response: HttpResponseBase): Observable<LeaveSummaryTransformedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeaveSummaryTransformedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveSummaryTransformedDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getLeaveSummaryYearly(body: GetYearlyLeaveReport | undefined): Observable<LeaveSummaryTransformedDto> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetLeaveSummaryYearly";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveSummaryYearly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveSummaryYearly(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveSummaryTransformedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveSummaryTransformedDto>;
        }));
    }

    protected processGetLeaveSummaryYearly(response: HttpResponseBase): Observable<LeaveSummaryTransformedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeaveSummaryTransformedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveSummaryTransformedDto>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @param employeeName (optional) 
     * @param branchid (optional) 
     * @param showNegativeAllowedLeaves (optional) 
     * @return Success
     */
    getLeaveSummary(month: string | null | undefined, year: string | null | undefined, employeeName: string | null | undefined, branchid: number | undefined, showNegativeAllowedLeaves: boolean | undefined): Observable<LeaveSummaryTransformedDto> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetLeaveSummary?";
        if (month !== undefined && month !== null)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year !== undefined && year !== null)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (employeeName !== undefined && employeeName !== null)
            url_ += "EmployeeName=" + encodeURIComponent("" + employeeName) + "&";
        if (branchid === null)
            throw new Error("The parameter 'branchid' cannot be null.");
        else if (branchid !== undefined)
            url_ += "branchid=" + encodeURIComponent("" + branchid) + "&";
        if (showNegativeAllowedLeaves === null)
            throw new Error("The parameter 'showNegativeAllowedLeaves' cannot be null.");
        else if (showNegativeAllowedLeaves !== undefined)
            url_ += "showNegativeAllowedLeaves=" + encodeURIComponent("" + showNegativeAllowedLeaves) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveSummaryTransformedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveSummaryTransformedDto>;
        }));
    }

    protected processGetLeaveSummary(response: HttpResponseBase): Observable<LeaveSummaryTransformedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeaveSummaryTransformedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveSummaryTransformedDto>(null as any);
    }

    /**
     * @param monthyear (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param employeeid (optional) 
     * @param branchid (optional) 
     * @return Success
     */
    getCompensatoryOffReport(monthyear: string | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, employeeid: number | undefined, branchid: number | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetCompensatoryOffReport?";
        if (monthyear !== undefined && monthyear !== null)
            url_ += "monthyear=" + encodeURIComponent("" + monthyear) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        if (branchid === null)
            throw new Error("The parameter 'branchid' cannot be null.");
        else if (branchid !== undefined)
            url_ += "branchid=" + encodeURIComponent("" + branchid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompensatoryOffReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompensatoryOffReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetCompensatoryOffReport(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    onDutySummaryReport(body: OnDutyReport | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/OnDutySummaryReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDutySummaryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDutySummaryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processOnDutySummaryReport(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    arrearReportExcel(body: ArrearReport | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/ArrearReportExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArrearReportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArrearReportExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processArrearReportExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    arrearReport(body: ArrearReport | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/ArrearReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArrearReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArrearReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processArrearReport(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    onDutySummaryReportExcel(body: OnDutyReport | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/OnDutySummaryReportExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnDutySummaryReportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnDutySummaryReportExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processOnDutySummaryReportExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param employeeid (optional) 
     * @param branchid (optional) 
     * @param departmentId (optional) 
     * @return Success
     */
    getMissingDocumentReportForExcel(employeeid: number | undefined, branchid: number | undefined, departmentId: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetMissingDocumentReportForExcel?";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        if (branchid === null)
            throw new Error("The parameter 'branchid' cannot be null.");
        else if (branchid !== undefined)
            url_ += "branchid=" + encodeURIComponent("" + branchid) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMissingDocumentReportForExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMissingDocumentReportForExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetMissingDocumentReportForExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param employeeid (optional) 
     * @param branchid (optional) 
     * @param departmentId (optional) 
     * @return Success
     */
    getMissingDocumentReport(employeeid: number | undefined, branchid: number | undefined, departmentId: number | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetMissingDocumentReport?";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        if (branchid === null)
            throw new Error("The parameter 'branchid' cannot be null.");
        else if (branchid !== undefined)
            url_ += "branchid=" + encodeURIComponent("" + branchid) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMissingDocumentReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMissingDocumentReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetMissingDocumentReport(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @return Success
     */
    reviewPending(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/ReviewPending";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReviewPending(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReviewPending(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processReviewPending(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param employeeName (optional) 
     * @return Success
     */
    getReviewPendingDetails(employeeName: string | null | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetReviewPendingDetails?";
        if (employeeName !== undefined && employeeName !== null)
            url_ += "EmployeeName=" + encodeURIComponent("" + employeeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewPendingDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewPendingDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetReviewPendingDetails(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param employeeid (optional) 
     * @param branchid (optional) 
     * @return Success
     */
    getCompensatoryOffExcel(monthYear: string | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, employeeid: number | undefined, branchid: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetCompensatoryOffExcel?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        if (branchid === null)
            throw new Error("The parameter 'branchid' cannot be null.");
        else if (branchid !== undefined)
            url_ += "branchid=" + encodeURIComponent("" + branchid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompensatoryOffExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompensatoryOffExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetCompensatoryOffExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param cyclevalue (optional) 
     * @param filterEmpId (optional) 
     * @param filterLocationId (optional) 
     * @return Success
     */
    getIncrementReport(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, cyclevalue: string | null | undefined, filterEmpId: number | undefined, filterLocationId: number | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetIncrementReport?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (cyclevalue !== undefined && cyclevalue !== null)
            url_ += "cyclevalue=" + encodeURIComponent("" + cyclevalue) + "&";
        if (filterEmpId === null)
            throw new Error("The parameter 'filterEmpId' cannot be null.");
        else if (filterEmpId !== undefined)
            url_ += "filterEmpId=" + encodeURIComponent("" + filterEmpId) + "&";
        if (filterLocationId === null)
            throw new Error("The parameter 'filterLocationId' cannot be null.");
        else if (filterLocationId !== undefined)
            url_ += "filterLocationId=" + encodeURIComponent("" + filterLocationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncrementReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncrementReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetIncrementReport(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param cyclevalue (optional) 
     * @param filterEmpId (optional) 
     * @param filterLocationId (optional) 
     * @return Success
     */
    getIncrementReportExcel(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, cyclevalue: string | null | undefined, filterEmpId: number | undefined, filterLocationId: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetIncrementReportExcel?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (cyclevalue !== undefined && cyclevalue !== null)
            url_ += "cyclevalue=" + encodeURIComponent("" + cyclevalue) + "&";
        if (filterEmpId === null)
            throw new Error("The parameter 'filterEmpId' cannot be null.");
        else if (filterEmpId !== undefined)
            url_ += "filterEmpId=" + encodeURIComponent("" + filterEmpId) + "&";
        if (filterLocationId === null)
            throw new Error("The parameter 'filterLocationId' cannot be null.");
        else if (filterLocationId !== undefined)
            url_ += "filterLocationId=" + encodeURIComponent("" + filterLocationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncrementReportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncrementReportExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetIncrementReportExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param year (optional) 
     * @param employeeTypeId (optional) 
     * @param locationId (optional) 
     * @return Success
     */
    getPFECrsummary(year: string | null | undefined, employeeTypeId: number | undefined, locationId: number | undefined): Observable<ClumnRowDatasetList> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetPFECrsummary?";
        if (year !== undefined && year !== null)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (employeeTypeId === null)
            throw new Error("The parameter 'employeeTypeId' cannot be null.");
        else if (employeeTypeId !== undefined)
            url_ += "employeeTypeId=" + encodeURIComponent("" + employeeTypeId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPFECrsummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPFECrsummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowDatasetList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowDatasetList>;
        }));
    }

    protected processGetPFECrsummary(response: HttpResponseBase): Observable<ClumnRowDatasetList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowDatasetList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowDatasetList>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param employeeTypeId (optional) 
     * @param locationId (optional) 
     * @return Success
     */
    getPFECRSummaryExcel(monthYear: string | null | undefined, employeeTypeId: number | undefined, locationId: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetPFECRSummaryExcel?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (employeeTypeId === null)
            throw new Error("The parameter 'employeeTypeId' cannot be null.");
        else if (employeeTypeId !== undefined)
            url_ += "employeeTypeId=" + encodeURIComponent("" + employeeTypeId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPFECRSummaryExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPFECRSummaryExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetPFECRSummaryExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param monthyear (optional) 
     * @param employeeTypeId (optional) 
     * @param locationId (optional) 
     * @return Success
     */
    getPfChartSummary(monthyear: string | null | undefined, employeeTypeId: number | undefined, locationId: number | undefined): Observable<PfSummaryChart> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetPfChartSummary?";
        if (monthyear !== undefined && monthyear !== null)
            url_ += "monthyear=" + encodeURIComponent("" + monthyear) + "&";
        if (employeeTypeId === null)
            throw new Error("The parameter 'employeeTypeId' cannot be null.");
        else if (employeeTypeId !== undefined)
            url_ += "employeeTypeId=" + encodeURIComponent("" + employeeTypeId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPfChartSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPfChartSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PfSummaryChart>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PfSummaryChart>;
        }));
    }

    protected processGetPfChartSummary(response: HttpResponseBase): Observable<PfSummaryChart> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PfSummaryChart.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PfSummaryChart>(null as any);
    }

    /**
     * @param monthyear (optional) 
     * @param employeeTypeId (optional) 
     * @param locationId (optional) 
     * @return Success
     */
    getESIChartSummary(monthyear: string | null | undefined, employeeTypeId: number | undefined, locationId: number | undefined): Observable<ESIChartSummary> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetESIChartSummary?";
        if (monthyear !== undefined && monthyear !== null)
            url_ += "monthyear=" + encodeURIComponent("" + monthyear) + "&";
        if (employeeTypeId === null)
            throw new Error("The parameter 'employeeTypeId' cannot be null.");
        else if (employeeTypeId !== undefined)
            url_ += "employeeTypeId=" + encodeURIComponent("" + employeeTypeId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetESIChartSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetESIChartSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ESIChartSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ESIChartSummary>;
        }));
    }

    protected processGetESIChartSummary(response: HttpResponseBase): Observable<ESIChartSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ESIChartSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ESIChartSummary>(null as any);
    }

    /**
     * @param frommonthYear (optional) 
     * @param tomonthyear (optional) 
     * @param employmentTypeid (optional) 
     * @param locationId (optional) 
     * @return Success
     */
    getESIForm7(frommonthYear: string | null | undefined, tomonthyear: string | null | undefined, employmentTypeid: number | undefined, locationId: number | undefined): Observable<ClumnRowDataESI> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetESIForm7?";
        if (frommonthYear !== undefined && frommonthYear !== null)
            url_ += "frommonthYear=" + encodeURIComponent("" + frommonthYear) + "&";
        if (tomonthyear !== undefined && tomonthyear !== null)
            url_ += "tomonthyear=" + encodeURIComponent("" + tomonthyear) + "&";
        if (employmentTypeid === null)
            throw new Error("The parameter 'employmentTypeid' cannot be null.");
        else if (employmentTypeid !== undefined)
            url_ += "employmentTypeid=" + encodeURIComponent("" + employmentTypeid) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetESIForm7(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetESIForm7(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowDataESI>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowDataESI>;
        }));
    }

    protected processGetESIForm7(response: HttpResponseBase): Observable<ClumnRowDataESI> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowDataESI.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowDataESI>(null as any);
    }

    /**
     * @param frommonthYear (optional) 
     * @param tomonthyear (optional) 
     * @param employmentTypeid (optional) 
     * @param locationId (optional) 
     * @return Success
     */
    getESIFORM7Excel(frommonthYear: string | null | undefined, tomonthyear: string | null | undefined, employmentTypeid: number | undefined, locationId: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetESIFORM7Excel?";
        if (frommonthYear !== undefined && frommonthYear !== null)
            url_ += "frommonthYear=" + encodeURIComponent("" + frommonthYear) + "&";
        if (tomonthyear !== undefined && tomonthyear !== null)
            url_ += "tomonthyear=" + encodeURIComponent("" + tomonthyear) + "&";
        if (employmentTypeid === null)
            throw new Error("The parameter 'employmentTypeid' cannot be null.");
        else if (employmentTypeid !== undefined)
            url_ += "employmentTypeid=" + encodeURIComponent("" + employmentTypeid) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetESIFORM7Excel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetESIFORM7Excel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetESIFORM7Excel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @param employeeName (optional) 
     * @param branchid (optional) 
     * @param showNegativeAllowedLeaves (optional) 
     * @return Success
     */
    getLeaveSummaryExcel(month: string | null | undefined, year: string | null | undefined, employeeName: string | null | undefined, branchid: number | undefined, showNegativeAllowedLeaves: boolean | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetLeaveSummaryExcel?";
        if (month !== undefined && month !== null)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year !== undefined && year !== null)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (employeeName !== undefined && employeeName !== null)
            url_ += "EmployeeName=" + encodeURIComponent("" + employeeName) + "&";
        if (branchid === null)
            throw new Error("The parameter 'branchid' cannot be null.");
        else if (branchid !== undefined)
            url_ += "branchid=" + encodeURIComponent("" + branchid) + "&";
        if (showNegativeAllowedLeaves === null)
            throw new Error("The parameter 'showNegativeAllowedLeaves' cannot be null.");
        else if (showNegativeAllowedLeaves !== undefined)
            url_ += "showNegativeAllowedLeaves=" + encodeURIComponent("" + showNegativeAllowedLeaves) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveSummaryExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveSummaryExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetLeaveSummaryExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param employmentTypeId (optional) 
     * @param locationId (optional) 
     * @param departmentId (optional) 
     * @param employeeId (optional) 
     * @param showArrearBreakup (optional) 
     * @return Success
     */
    generateSalaryRegisterPdf(monthYear: string | null | undefined, employmentTypeId: number | undefined, locationId: number | undefined, departmentId: number | undefined, employeeId: number | undefined, showArrearBreakup: boolean | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GenerateSalaryRegisterPdf?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (employmentTypeId === null)
            throw new Error("The parameter 'employmentTypeId' cannot be null.");
        else if (employmentTypeId !== undefined)
            url_ += "employmentTypeId=" + encodeURIComponent("" + employmentTypeId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (showArrearBreakup === null)
            throw new Error("The parameter 'showArrearBreakup' cannot be null.");
        else if (showArrearBreakup !== undefined)
            url_ += "showArrearBreakup=" + encodeURIComponent("" + showArrearBreakup) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateSalaryRegisterPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateSalaryRegisterPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGenerateSalaryRegisterPdf(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param employmentTypeId (optional) 
     * @param locationId (optional) 
     * @param departmentId (optional) 
     * @param employeeId (optional) 
     * @param showArrearBreakup (optional) 
     * @param pdfHeaderCompanyName (optional) 
     * @param pdfHeaderCompanyAddress (optional) 
     * @return Success
     */
    generateEmployeeRegisterBulkSlipPdf(monthYear: string | null | undefined, employmentTypeId: number | undefined, locationId: number | undefined, departmentId: number | undefined, employeeId: number | undefined, showArrearBreakup: boolean | undefined, pdfHeaderCompanyName: string | null | undefined, pdfHeaderCompanyAddress: string | null | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GenerateEmployeeRegisterBulkSlipPdf?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (employmentTypeId === null)
            throw new Error("The parameter 'employmentTypeId' cannot be null.");
        else if (employmentTypeId !== undefined)
            url_ += "employmentTypeId=" + encodeURIComponent("" + employmentTypeId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (showArrearBreakup === null)
            throw new Error("The parameter 'showArrearBreakup' cannot be null.");
        else if (showArrearBreakup !== undefined)
            url_ += "showArrearBreakup=" + encodeURIComponent("" + showArrearBreakup) + "&";
        if (pdfHeaderCompanyName !== undefined && pdfHeaderCompanyName !== null)
            url_ += "pdfHeaderCompanyName=" + encodeURIComponent("" + pdfHeaderCompanyName) + "&";
        if (pdfHeaderCompanyAddress !== undefined && pdfHeaderCompanyAddress !== null)
            url_ += "pdfHeaderCompanyAddress=" + encodeURIComponent("" + pdfHeaderCompanyAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateEmployeeRegisterBulkSlipPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateEmployeeRegisterBulkSlipPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGenerateEmployeeRegisterBulkSlipPdf(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param employmentTypeId (optional) 
     * @param departmentId (optional) 
     * @param employeeId (optional) 
     * @param body (optional) 
     * @return Success
     */
    generateEmployeePreRegisterBulkSlipPdf(monthYear: string | null | undefined, employmentTypeId: number | undefined, departmentId: number | undefined, employeeId: number | undefined, body: number[] | null | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GenerateEmployeePreRegisterBulkSlipPdf?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (employmentTypeId === null)
            throw new Error("The parameter 'employmentTypeId' cannot be null.");
        else if (employmentTypeId !== undefined)
            url_ += "employmentTypeId=" + encodeURIComponent("" + employmentTypeId) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateEmployeePreRegisterBulkSlipPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateEmployeePreRegisterBulkSlipPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGenerateEmployeePreRegisterBulkSlipPdf(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param employmentTypeId (optional) 
     * @param departmentId (optional) 
     * @param employeeId (optional) 
     * @param showArrearBreakup (optional) 
     * @param pdfHeaderCompanyName (optional) 
     * @param pdfHeaderCompanyAddress (optional) 
     * @param body (optional) 
     * @return Success
     */
    generateEmployeePreSalarBulkSlipPdf(monthYear: string | null | undefined, employmentTypeId: number | undefined, departmentId: number | undefined, employeeId: number | undefined, showArrearBreakup: boolean | undefined, pdfHeaderCompanyName: string | null | undefined, pdfHeaderCompanyAddress: string | null | undefined, body: number[] | null | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GenerateEmployeePreSalarBulkSlipPdf?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (employmentTypeId === null)
            throw new Error("The parameter 'employmentTypeId' cannot be null.");
        else if (employmentTypeId !== undefined)
            url_ += "employmentTypeId=" + encodeURIComponent("" + employmentTypeId) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (showArrearBreakup === null)
            throw new Error("The parameter 'showArrearBreakup' cannot be null.");
        else if (showArrearBreakup !== undefined)
            url_ += "showArrearBreakup=" + encodeURIComponent("" + showArrearBreakup) + "&";
        if (pdfHeaderCompanyName !== undefined && pdfHeaderCompanyName !== null)
            url_ += "pdfHeaderCompanyName=" + encodeURIComponent("" + pdfHeaderCompanyName) + "&";
        if (pdfHeaderCompanyAddress !== undefined && pdfHeaderCompanyAddress !== null)
            url_ += "pdfHeaderCompanyAddress=" + encodeURIComponent("" + pdfHeaderCompanyAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateEmployeePreSalarBulkSlipPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateEmployeePreSalarBulkSlipPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGenerateEmployeePreSalarBulkSlipPdf(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param employmentTypeId (optional) 
     * @param locationId (optional) 
     * @param departmentId (optional) 
     * @param employeeid (optional) 
     * @return Success
     */
    getSalaryRegister(monthYear: string | null | undefined, employmentTypeId: number | undefined, locationId: number | undefined, departmentId: number | undefined, employeeid: number | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetSalaryRegister?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (employmentTypeId === null)
            throw new Error("The parameter 'employmentTypeId' cannot be null.");
        else if (employmentTypeId !== undefined)
            url_ += "employmentTypeId=" + encodeURIComponent("" + employmentTypeId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalaryRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalaryRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetSalaryRegister(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @param employeeid (optional) 
     * @return Success
     */
    getLeaveDetails(month: number | undefined, year: number | undefined, employeeid: number | undefined): Observable<LeaveBlanceByTypeDetails> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetLeaveDetails?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveBlanceByTypeDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveBlanceByTypeDetails>;
        }));
    }

    protected processGetLeaveDetails(response: HttpResponseBase): Observable<LeaveBlanceByTypeDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeaveBlanceByTypeDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveBlanceByTypeDetails>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param employeeid (optional) 
     * @param branchid (optional) 
     * @param department (optional) 
     * @return Success
     */
    getAttendanceExcel(monthYear: string | null | undefined, employeeid: number | undefined, branchid: number | undefined, department: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetAttendanceExcel?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        if (branchid === null)
            throw new Error("The parameter 'branchid' cannot be null.");
        else if (branchid !== undefined)
            url_ += "branchid=" + encodeURIComponent("" + branchid) + "&";
        if (department === null)
            throw new Error("The parameter 'department' cannot be null.");
        else if (department !== undefined)
            url_ += "department=" + encodeURIComponent("" + department) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetAttendanceExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param employmentTypeId (optional) 
     * @param locationId (optional) 
     * @param departmentId (optional) 
     * @param employeeid (optional) 
     * @param showArrearBreakup (optional) 
     * @return Success
     */
    getSalarExcel(monthYear: string | null | undefined, employmentTypeId: number | undefined, locationId: number | undefined, departmentId: number | undefined, employeeid: number | undefined, showArrearBreakup: boolean | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetSalarExcel?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (employmentTypeId === null)
            throw new Error("The parameter 'employmentTypeId' cannot be null.");
        else if (employmentTypeId !== undefined)
            url_ += "employmentTypeId=" + encodeURIComponent("" + employmentTypeId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        if (showArrearBreakup === null)
            throw new Error("The parameter 'showArrearBreakup' cannot be null.");
        else if (showArrearBreakup !== undefined)
            url_ += "showArrearBreakup=" + encodeURIComponent("" + showArrearBreakup) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalarExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalarExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetSalarExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param employmentTypeId (optional) 
     * @param locationId (optional) 
     * @param departmentId (optional) 
     * @return Success
     */
    getSalaryBASICExcel(employmentTypeId: number | undefined, locationId: number | undefined, departmentId: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetSalaryBASICExcel?";
        if (employmentTypeId === null)
            throw new Error("The parameter 'employmentTypeId' cannot be null.");
        else if (employmentTypeId !== undefined)
            url_ += "employmentTypeId=" + encodeURIComponent("" + employmentTypeId) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalaryBASICExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalaryBASICExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetSalaryBASICExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param employmentTypeid (optional) 
     * @param locationId (optional) 
     * @return Success
     */
    getEsiStatementtatement(monthYear: string | null | undefined, employmentTypeid: number | undefined, locationId: number | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetEsiStatementtatement?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (employmentTypeid === null)
            throw new Error("The parameter 'employmentTypeid' cannot be null.");
        else if (employmentTypeid !== undefined)
            url_ += "employmentTypeid=" + encodeURIComponent("" + employmentTypeid) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEsiStatementtatement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEsiStatementtatement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetEsiStatementtatement(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param employmentTypeid (optional) 
     * @param locationId (optional) 
     * @return Success
     */
    getExceEsiExcel(monthYear: string | null | undefined, employmentTypeid: number | undefined, locationId: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetExceEsiExcel?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (employmentTypeid === null)
            throw new Error("The parameter 'employmentTypeid' cannot be null.");
        else if (employmentTypeid !== undefined)
            url_ += "employmentTypeid=" + encodeURIComponent("" + employmentTypeid) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExceEsiExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExceEsiExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetExceEsiExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param employmentTypeid (optional) 
     * @param locationId (optional) 
     * @return Success
     */
    getPTStatement(monthYear: string | null | undefined, employmentTypeid: number | undefined, locationId: number | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetPTStatement?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (employmentTypeid === null)
            throw new Error("The parameter 'employmentTypeid' cannot be null.");
        else if (employmentTypeid !== undefined)
            url_ += "employmentTypeid=" + encodeURIComponent("" + employmentTypeid) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPTStatement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPTStatement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetPTStatement(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param employmentTypeid (optional) 
     * @param locationId (optional) 
     * @return Success
     */
    getExcePtExcel(monthYear: string | null | undefined, employmentTypeid: number | undefined, locationId: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetExcePtExcel?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (employmentTypeid === null)
            throw new Error("The parameter 'employmentTypeid' cannot be null.");
        else if (employmentTypeid !== undefined)
            url_ += "employmentTypeid=" + encodeURIComponent("" + employmentTypeid) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExcePtExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExcePtExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetExcePtExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param formDate (optional) 
     * @param toDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getEmployeeRegisterList(filter: string | null | undefined, formDate: moment.Moment | undefined, toDate: moment.Moment | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<{ [key: string]: any; }[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetEmployeeRegisterList?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (formDate === null)
            throw new Error("The parameter 'formDate' cannot be null.");
        else if (formDate !== undefined)
            url_ += "FormDate=" + encodeURIComponent(formDate ? "" + formDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeRegisterList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeRegisterList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: any; }[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: any; }[]>;
        }));
    }

    protected processGetEmployeeRegisterList(response: HttpResponseBase): Observable<{ [key: string]: any; }[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ [key: string]: any; }[]>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param employmentTypeid (optional) 
     * @param locationId (optional) 
     * @return Success
     */
    getSalaryStatementtatement(monthYear: string | null | undefined, employmentTypeid: number | undefined, locationId: number | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetSalaryStatementtatement?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (employmentTypeid === null)
            throw new Error("The parameter 'employmentTypeid' cannot be null.");
        else if (employmentTypeid !== undefined)
            url_ += "employmentTypeid=" + encodeURIComponent("" + employmentTypeid) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalaryStatementtatement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalaryStatementtatement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetSalaryStatementtatement(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param employmentTypeid (optional) 
     * @param locationId (optional) 
     * @return Success
     */
    getExceSalaryExcel(monthYear: string | null | undefined, employmentTypeid: number | undefined, locationId: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRMSReportsService/GetExceSalaryExcel?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (employmentTypeid === null)
            throw new Error("The parameter 'employmentTypeid' cannot be null.");
        else if (employmentTypeid !== undefined)
            url_ += "employmentTypeid=" + encodeURIComponent("" + employmentTypeid) + "&";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExceSalaryExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExceSalaryExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetExceSalaryExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }
}

@Injectable()
export class ServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    index(imagePath: string | null): Observable<void> {
        let url_ = this.baseUrl + "/{imagePath}";
        if (imagePath === undefined || imagePath === null)
            throw new Error("The parameter 'imagePath' must be defined.");
        url_ = url_.replace("{imagePath}", encodeURIComponent("" + imagePath));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processIndex(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class IncentiveDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getAllIncentiveDetailsPreMonthProcessed(month: number | undefined, year: number | undefined): Observable<PagedResultDtoOfGetIncentiveDetailsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/IncentiveDetails/GetAllIncentiveDetailsPreMonthProcessed?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllIncentiveDetailsPreMonthProcessed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllIncentiveDetailsPreMonthProcessed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetIncentiveDetailsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetIncentiveDetailsForViewDto>;
        }));
    }

    protected processGetAllIncentiveDetailsPreMonthProcessed(response: HttpResponseBase): Observable<PagedResultDtoOfGetIncentiveDetailsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetIncentiveDetailsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetIncentiveDetailsForViewDto>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getAllIncentiveDetails(month: number | undefined, year: number | undefined): Observable<PagedResultDtoOfGetIncentiveDetailsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/IncentiveDetails/GetAllIncentiveDetails?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllIncentiveDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllIncentiveDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetIncentiveDetailsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetIncentiveDetailsForViewDto>;
        }));
    }

    protected processGetAllIncentiveDetails(response: HttpResponseBase): Observable<PagedResultDtoOfGetIncentiveDetailsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetIncentiveDetailsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetIncentiveDetailsForViewDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: IncentiveDetailsDTO[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/IncentiveDetails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/IncentiveDetails/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @param query (optional) 
     * @return Success
     */
    getAllIncentive(month: number | undefined, year: number | undefined, query: string | null | undefined): Observable<IncentiveDetailsListDto> {
        let url_ = this.baseUrl + "/api/services/app/IncentiveDetails/GetAllIncentive?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllIncentive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllIncentive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncentiveDetailsListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncentiveDetailsListDto>;
        }));
    }

    protected processGetAllIncentive(response: HttpResponseBase): Observable<IncentiveDetailsListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IncentiveDetailsListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IncentiveDetailsListDto>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getAllIncentiveAfterProcess(month: number | undefined, year: number | undefined): Observable<IncentiveDetailsListDto> {
        let url_ = this.baseUrl + "/api/services/app/IncentiveDetails/GetAllIncentiveAfterProcess?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllIncentiveAfterProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllIncentiveAfterProcess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncentiveDetailsListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncentiveDetailsListDto>;
        }));
    }

    protected processGetAllIncentiveAfterProcess(response: HttpResponseBase): Observable<IncentiveDetailsListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IncentiveDetailsListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IncentiveDetailsListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getIncentiveTypeForEdit(id: number | undefined): Observable<IncentiveDetailsDTO> {
        let url_ = this.baseUrl + "/api/services/app/IncentiveDetails/GetIncentiveTypeForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncentiveTypeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncentiveTypeForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncentiveDetailsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncentiveDetailsDTO>;
        }));
    }

    protected processGetIncentiveTypeForEdit(response: HttpResponseBase): Observable<IncentiveDetailsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IncentiveDetailsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IncentiveDetailsDTO>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getIncentiveTypeForView(id: number | undefined): Observable<IncentiveDetailsDTO> {
        let url_ = this.baseUrl + "/api/services/app/IncentiveDetails/GetIncentiveTypeForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncentiveTypeForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncentiveTypeForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncentiveDetailsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncentiveDetailsDTO>;
        }));
    }

    protected processGetIncentiveTypeForView(response: HttpResponseBase): Observable<IncentiveDetailsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IncentiveDetailsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IncentiveDetailsDTO>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getIncentiveTypeToExcel(filter: string | null | undefined, nameFilter: string | null | undefined, descriptionFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/IncentiveDetails/GetIncentiveTypeToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (descriptionFilter !== undefined && descriptionFilter !== null)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncentiveTypeToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncentiveTypeToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetIncentiveTypeToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class IncentiveTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: IncentiveTypeDTO | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/IncentiveType/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/IncentiveType/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, descriptionFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetIncentiveTypeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/IncentiveType/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (descriptionFilter !== undefined && descriptionFilter !== null)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetIncentiveTypeForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetIncentiveTypeForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetIncentiveTypeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetIncentiveTypeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetIncentiveTypeForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getIncentiveTypeForEdit(id: number | undefined): Observable<IncentiveTypeDTO> {
        let url_ = this.baseUrl + "/api/services/app/IncentiveType/GetIncentiveTypeForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncentiveTypeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncentiveTypeForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncentiveTypeDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncentiveTypeDTO>;
        }));
    }

    protected processGetIncentiveTypeForEdit(response: HttpResponseBase): Observable<IncentiveTypeDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IncentiveTypeDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IncentiveTypeDTO>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getIncentiveTypeForView(id: number | undefined): Observable<IncentiveTypeDTO> {
        let url_ = this.baseUrl + "/api/services/app/IncentiveType/GetIncentiveTypeForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncentiveTypeForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncentiveTypeForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncentiveTypeDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncentiveTypeDTO>;
        }));
    }

    protected processGetIncentiveTypeForView(response: HttpResponseBase): Observable<IncentiveTypeDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IncentiveTypeDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IncentiveTypeDTO>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getIncentiveTypeToExcel(filter: string | null | undefined, nameFilter: string | null | undefined, descriptionFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/IncentiveType/GetIncentiveTypeToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (descriptionFilter !== undefined && descriptionFilter !== null)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncentiveTypeToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncentiveTypeToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetIncentiveTypeToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class IncrementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    witheffectFrom(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Increment/WitheffectFrom?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWitheffectFrom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWitheffectFrom(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processWitheffectFrom(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param filterBranch (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, filterBranch: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetIncrementDataView> {
        let url_ = this.baseUrl + "/api/services/app/Increment/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (filterBranch !== undefined && filterBranch !== null)
            url_ += "FilterBranch=" + encodeURIComponent("" + filterBranch) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetIncrementDataView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetIncrementDataView>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetIncrementDataView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetIncrementDataView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetIncrementDataView>(null as any);
    }

    /**
     * @param id (optional) 
     * @param requestForApprovalId (optional) 
     * @return Success
     */
    getIncrementRequestForEdit(id: number | undefined, requestForApprovalId: number | null | undefined): Observable<GetincrementListDataForEdit> {
        let url_ = this.baseUrl + "/api/services/app/Increment/GetIncrementRequestForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (requestForApprovalId !== undefined && requestForApprovalId !== null)
            url_ += "RequestForApprovalId=" + encodeURIComponent("" + requestForApprovalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncrementRequestForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncrementRequestForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetincrementListDataForEdit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetincrementListDataForEdit>;
        }));
    }

    protected processGetIncrementRequestForEdit(response: HttpResponseBase): Observable<GetincrementListDataForEdit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetincrementListDataForEdit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetincrementListDataForEdit>(null as any);
    }

    /**
     * @param empid (optional) 
     * @return Success
     */
    getHistoryData(empid: number | undefined): Observable<IncrementRequestPayload[]> {
        let url_ = this.baseUrl + "/api/services/app/Increment/GetHistoryData?";
        if (empid === null)
            throw new Error("The parameter 'empid' cannot be null.");
        else if (empid !== undefined)
            url_ += "empid=" + encodeURIComponent("" + empid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistoryData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistoryData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncrementRequestPayload[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncrementRequestPayload[]>;
        }));
    }

    protected processGetHistoryData(response: HttpResponseBase): Observable<IncrementRequestPayload[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IncrementRequestPayload.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IncrementRequestPayload[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: IncrementRequestPayload | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Increment/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importEmployeeIncrement(body: EmployeeInputeFileDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Increment/ImportEmployeeIncrement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportEmployeeIncrement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportEmployeeIncrement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportEmployeeIncrement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param date (optional) 
     * @return Success
     */
    convertToMMyyyy(date: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Increment/ConvertToMMyyyy?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConvertToMMyyyy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConvertToMMyyyy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processConvertToMMyyyy(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable()
export class InstallServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setup(body: InstallDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Install/Setup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAppSettingsJson(): Observable<AppSettingsJsonDto> {
        let url_ = this.baseUrl + "/api/services/app/Install/GetAppSettingsJson";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppSettingsJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppSettingsJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppSettingsJsonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppSettingsJsonDto>;
        }));
    }

    protected processGetAppSettingsJson(response: HttpResponseBase): Observable<AppSettingsJsonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppSettingsJsonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppSettingsJsonDto>(null as any);
    }

    /**
     * @return Success
     */
    checkDatabase(): Observable<CheckDatabaseOutput> {
        let url_ = this.baseUrl + "/api/services/app/Install/CheckDatabase";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckDatabaseOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckDatabaseOutput>;
        }));
    }

    protected processCheckDatabase(response: HttpResponseBase): Observable<CheckDatabaseOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckDatabaseOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckDatabaseOutput>(null as any);
    }
}

@Injectable()
export class InvestmentDeclarationAppServicesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    getAllUserDecalaration(employeeId: number | undefined): Observable<InvestmentDecUserForView[]> {
        let url_ = this.baseUrl + "/api/services/app/InvestmentDeclarationAppServices/GetAllUserDecalaration?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserDecalaration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserDecalaration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvestmentDecUserForView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvestmentDecUserForView[]>;
        }));
    }

    protected processGetAllUserDecalaration(response: HttpResponseBase): Observable<InvestmentDecUserForView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvestmentDecUserForView.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvestmentDecUserForView[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllTaxSaving(): Observable<Taxsavingforviewdto[]> {
        let url_ = this.baseUrl + "/api/services/app/InvestmentDeclarationAppServices/GetAllTaxSaving";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTaxSaving(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTaxSaving(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Taxsavingforviewdto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Taxsavingforviewdto[]>;
        }));
    }

    protected processGetAllTaxSaving(response: HttpResponseBase): Observable<Taxsavingforviewdto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Taxsavingforviewdto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Taxsavingforviewdto[]>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    getAll(employeeId: number | undefined): Observable<Ccinvestmentforviewdto[]> {
        let url_ = this.baseUrl + "/api/services/app/InvestmentDeclarationAppServices/GetAll?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Ccinvestmentforviewdto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Ccinvestmentforviewdto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<Ccinvestmentforviewdto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Ccinvestmentforviewdto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Ccinvestmentforviewdto[]>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    getAllOtherDeduction(employeeId: number | null | undefined): Observable<Otherinvestmentforviewdto[]> {
        let url_ = this.baseUrl + "/api/services/app/InvestmentDeclarationAppServices/GetAllOtherDeduction?";
        if (employeeId !== undefined && employeeId !== null)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOtherDeduction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOtherDeduction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Otherinvestmentforviewdto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Otherinvestmentforviewdto[]>;
        }));
    }

    protected processGetAllOtherDeduction(response: HttpResponseBase): Observable<Otherinvestmentforviewdto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Otherinvestmentforviewdto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Otherinvestmentforviewdto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateorEditInvestmentDecDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InvestmentDeclarationAppServices/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditOtherDeduction(body: CreateorEditInvestmentDecDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InvestmentDeclarationAppServices/CreateOrEditOtherDeduction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditOtherDeduction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditOtherDeduction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditOtherDeduction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InvestmentDeclarationAppServices/Delete?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param imageName (optional) 
     * @param imageData (optional) 
     * @return Success
     */
    saveFtbImageServer(imageName: string | null | undefined, imageData: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/InvestmentDeclarationAppServices/SaveFtbImageServer?";
        if (imageName !== undefined && imageName !== null)
            url_ += "ImageName=" + encodeURIComponent("" + imageName) + "&";
        if (imageData !== undefined && imageData !== null)
            url_ += "ImageData=" + encodeURIComponent("" + imageData) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveFtbImageServer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveFtbImageServer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveFtbImageServer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param v (optional) 
     * @param ftpUser (optional) 
     * @param ftpPassword (optional) 
     * @return Success
     */
    checkIfFileExistsOnServer(v: string | null | undefined, ftpUser: string | null | undefined, ftpPassword: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/InvestmentDeclarationAppServices/CheckIfFileExistsOnServer?";
        if (v !== undefined && v !== null)
            url_ += "v=" + encodeURIComponent("" + v) + "&";
        if (ftpUser !== undefined && ftpUser !== null)
            url_ += "ftpUser=" + encodeURIComponent("" + ftpUser) + "&";
        if (ftpPassword !== undefined && ftpPassword !== null)
            url_ += "ftpPassword=" + encodeURIComponent("" + ftpPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfFileExistsOnServer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfFileExistsOnServer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckIfFileExistsOnServer(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param documenttypeid (optional) 
     * @return Success
     */
    downLoadFileTemplete(documenttypeid: string | null | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InvestmentDeclarationAppServices/DownLoadFileTemplete?";
        if (documenttypeid !== undefined && documenttypeid !== null)
            url_ += "documenttypeid=" + encodeURIComponent("" + documenttypeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownLoadFileTemplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownLoadFileTemplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processDownLoadFileTemplete(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }
}

@Injectable()
export class InvoiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getInvoiceInfo(id: number | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoiceInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto>;
        }));
    }

    protected processGetInvoiceInfo(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createInvoice(body: CreateInvoiceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CreateInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateInvoice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class JobOpeningsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param experinceFilter (optional) 
     * @param qualificationFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, experinceFilter: string | null | undefined, qualificationFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetJobOpeningForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/JobOpenings/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (experinceFilter !== undefined && experinceFilter !== null)
            url_ += "ExperinceFilter=" + encodeURIComponent("" + experinceFilter) + "&";
        if (qualificationFilter !== undefined && qualificationFilter !== null)
            url_ += "QualificationFilter=" + encodeURIComponent("" + qualificationFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetJobOpeningForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetJobOpeningForEditOutput>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetJobOpeningForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetJobOpeningForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetJobOpeningForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getJobOpeningForApproval(id: number | undefined): Observable<GetJobOpeningForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/JobOpenings/GetJobOpeningForApproval?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobOpeningForApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobOpeningForApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetJobOpeningForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetJobOpeningForEditOutput>;
        }));
    }

    protected processGetJobOpeningForApproval(response: HttpResponseBase): Observable<GetJobOpeningForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJobOpeningForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetJobOpeningForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getJobOpeningForView(id: number | undefined): Observable<GetJobOpeningForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/JobOpenings/GetJobOpeningForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobOpeningForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobOpeningForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetJobOpeningForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetJobOpeningForViewDto>;
        }));
    }

    protected processGetJobOpeningForView(response: HttpResponseBase): Observable<GetJobOpeningForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJobOpeningForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetJobOpeningForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getJobOpeningForEdit(id: number | undefined): Observable<GetJobOpeningForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/JobOpenings/GetJobOpeningForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobOpeningForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobOpeningForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetJobOpeningForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetJobOpeningForEditOutput>;
        }));
    }

    protected processGetJobOpeningForEdit(response: HttpResponseBase): Observable<GetJobOpeningForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJobOpeningForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetJobOpeningForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditJobOpeningDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/JobOpenings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    closedOpening(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/JobOpenings/ClosedOpening?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClosedOpening(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClosedOpening(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClosedOpening(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSublocation(id: number | undefined): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/JobOpenings/GetSublocation?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSublocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSublocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetSublocation(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getlocation(id: number | undefined): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/JobOpenings/Getlocation?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetlocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetlocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetlocation(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/JobOpenings/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param experinceFilter (optional) 
     * @param qualificationFilter (optional) 
     * @return Success
     */
    getJobOpeningsToExcel(filter: string | null | undefined, nameFilter: string | null | undefined, experinceFilter: string | null | undefined, qualificationFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/JobOpenings/GetJobOpeningsToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (experinceFilter !== undefined && experinceFilter !== null)
            url_ += "ExperinceFilter=" + encodeURIComponent("" + experinceFilter) + "&";
        if (qualificationFilter !== undefined && qualificationFilter !== null)
            url_ += "QualificationFilter=" + encodeURIComponent("" + qualificationFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobOpeningsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobOpeningsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetJobOpeningsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class JObRoundDetailsesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param maxInterviewerFilter (optional) 
     * @param minInterviewerFilter (optional) 
     * @param jobOpeningPostionCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, maxInterviewerFilter: number | null | undefined, minInterviewerFilter: number | null | undefined, jobOpeningPostionCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetJObRoundDetailsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/JObRoundDetailses/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxInterviewerFilter !== undefined && maxInterviewerFilter !== null)
            url_ += "MaxInterviewerFilter=" + encodeURIComponent("" + maxInterviewerFilter) + "&";
        if (minInterviewerFilter !== undefined && minInterviewerFilter !== null)
            url_ += "MinInterviewerFilter=" + encodeURIComponent("" + minInterviewerFilter) + "&";
        if (jobOpeningPostionCodeFilter !== undefined && jobOpeningPostionCodeFilter !== null)
            url_ += "JobOpeningPostionCodeFilter=" + encodeURIComponent("" + jobOpeningPostionCodeFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetJObRoundDetailsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetJObRoundDetailsForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetJObRoundDetailsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetJObRoundDetailsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetJObRoundDetailsForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getJObRoundDetailsForView(id: number | undefined): Observable<GetJObRoundDetailsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/JObRoundDetailses/GetJObRoundDetailsForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJObRoundDetailsForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJObRoundDetailsForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetJObRoundDetailsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetJObRoundDetailsForViewDto>;
        }));
    }

    protected processGetJObRoundDetailsForView(response: HttpResponseBase): Observable<GetJObRoundDetailsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJObRoundDetailsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetJObRoundDetailsForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getJObRoundDetailsForEdit(id: number | undefined): Observable<GetJObRoundDetailsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/JObRoundDetailses/GetJObRoundDetailsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJObRoundDetailsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJObRoundDetailsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetJObRoundDetailsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetJObRoundDetailsForEditOutput>;
        }));
    }

    protected processGetJObRoundDetailsForEdit(response: HttpResponseBase): Observable<GetJObRoundDetailsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJObRoundDetailsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetJObRoundDetailsForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditJObRoundDetailsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/JObRoundDetailses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/JObRoundDetailses/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param maxInterviewerFilter (optional) 
     * @param minInterviewerFilter (optional) 
     * @param jobOpeningPostionCodeFilter (optional) 
     * @return Success
     */
    getJObRoundDetailsesToExcel(filter: string | null | undefined, nameFilter: string | null | undefined, maxInterviewerFilter: number | null | undefined, minInterviewerFilter: number | null | undefined, jobOpeningPostionCodeFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/JObRoundDetailses/GetJObRoundDetailsesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxInterviewerFilter !== undefined && maxInterviewerFilter !== null)
            url_ += "MaxInterviewerFilter=" + encodeURIComponent("" + maxInterviewerFilter) + "&";
        if (minInterviewerFilter !== undefined && minInterviewerFilter !== null)
            url_ += "MinInterviewerFilter=" + encodeURIComponent("" + minInterviewerFilter) + "&";
        if (jobOpeningPostionCodeFilter !== undefined && jobOpeningPostionCodeFilter !== null)
            url_ += "JobOpeningPostionCodeFilter=" + encodeURIComponent("" + jobOpeningPostionCodeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJObRoundDetailsesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJObRoundDetailsesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetJObRoundDetailsesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllJobOpeningForTableDropdown(): Observable<JObRoundDetailsJobOpeningLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/JObRoundDetailses/GetAllJobOpeningForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllJobOpeningForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllJobOpeningForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JObRoundDetailsJobOpeningLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JObRoundDetailsJobOpeningLookupTableDto[]>;
        }));
    }

    protected processGetAllJobOpeningForTableDropdown(response: HttpResponseBase): Observable<JObRoundDetailsJobOpeningLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JObRoundDetailsJobOpeningLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JObRoundDetailsJobOpeningLookupTableDto[]>(null as any);
    }
}

@Injectable()
export class KPIAssignPolicyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param firstname (optional) 
     * @param lastname (optional) 
     * @param designation (optional) 
     * @param status (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(firstname: string | null | undefined, lastname: string | null | undefined, designation: string | null | undefined, status: number | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetKPIPolicyAssignmentDto> {
        let url_ = this.baseUrl + "/api/services/app/KPIAssignPolicy/GetAll?";
        if (firstname !== undefined && firstname !== null)
            url_ += "firstname=" + encodeURIComponent("" + firstname) + "&";
        if (lastname !== undefined && lastname !== null)
            url_ += "lastname=" + encodeURIComponent("" + lastname) + "&";
        if (designation !== undefined && designation !== null)
            url_ += "designation=" + encodeURIComponent("" + designation) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetKPIPolicyAssignmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetKPIPolicyAssignmentDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetKPIPolicyAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetKPIPolicyAssignmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetKPIPolicyAssignmentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrEditKPIPolicyAssignment[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/KPIAssignPolicy/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param empData (optional) 
     * @param locData (optional) 
     * @param deptData (optional) 
     * @param kPIPolicyID (optional) 
     * @param fromdate (optional) 
     * @param toDate (optional) 
     * @param flag (optional) 
     * @return Success
     */
    getScoreCardReport(empData: EmployeeData[] | null | undefined, locData: LocationData[] | null | undefined, deptData: DepartmentData[] | null | undefined, kPIPolicyID: number | undefined, fromdate: moment.Moment | undefined, toDate: moment.Moment | undefined, flag: boolean | undefined): Observable<GetEmployeeScoreCard[]> {
        let url_ = this.baseUrl + "/api/services/app/KPIAssignPolicy/GetScoreCardReport?";
        if (empData !== undefined && empData !== null)
            empData && empData.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "EmpData[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (locData !== undefined && locData !== null)
            locData && locData.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "LocData[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (deptData !== undefined && deptData !== null)
            deptData && deptData.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "DeptData[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (kPIPolicyID === null)
            throw new Error("The parameter 'kPIPolicyID' cannot be null.");
        else if (kPIPolicyID !== undefined)
            url_ += "KPIPolicyID=" + encodeURIComponent("" + kPIPolicyID) + "&";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "Fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (flag === null)
            throw new Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScoreCardReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScoreCardReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmployeeScoreCard[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmployeeScoreCard[]>;
        }));
    }

    protected processGetScoreCardReport(response: HttpResponseBase): Observable<GetEmployeeScoreCard[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetEmployeeScoreCard.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeeScoreCard[]>(null as any);
    }

    /**
     * @param empData (optional) 
     * @param locData (optional) 
     * @param deptData (optional) 
     * @param kPIPolicyID (optional) 
     * @param fromdate (optional) 
     * @param toDate (optional) 
     * @param flag (optional) 
     * @return Success
     */
    getScoreCardReportExcel(empData: EmployeeData[] | null | undefined, locData: LocationData[] | null | undefined, deptData: DepartmentData[] | null | undefined, kPIPolicyID: number | undefined, fromdate: moment.Moment | undefined, toDate: moment.Moment | undefined, flag: boolean | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/KPIAssignPolicy/GetScoreCardReportExcel?";
        if (empData !== undefined && empData !== null)
            empData && empData.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "EmpData[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (locData !== undefined && locData !== null)
            locData && locData.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "LocData[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (deptData !== undefined && deptData !== null)
            deptData && deptData.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "DeptData[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (kPIPolicyID === null)
            throw new Error("The parameter 'kPIPolicyID' cannot be null.");
        else if (kPIPolicyID !== undefined)
            url_ += "KPIPolicyID=" + encodeURIComponent("" + kPIPolicyID) + "&";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "Fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (flag === null)
            throw new Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScoreCardReportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScoreCardReportExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetScoreCardReportExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param empData (optional) 
     * @param locData (optional) 
     * @param deptData (optional) 
     * @param kPIPolicyID (optional) 
     * @param fromdate (optional) 
     * @param toDate (optional) 
     * @param flag (optional) 
     * @return Success
     */
    getScoreCardDetailedReport(empData: EmployeeData[] | null | undefined, locData: LocationData[] | null | undefined, deptData: DepartmentData[] | null | undefined, kPIPolicyID: number | undefined, fromdate: moment.Moment | undefined, toDate: moment.Moment | undefined, flag: boolean | undefined): Observable<GetEmployeeScoreCardDetailed[]> {
        let url_ = this.baseUrl + "/api/services/app/KPIAssignPolicy/GetScoreCardDetailedReport?";
        if (empData !== undefined && empData !== null)
            empData && empData.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "EmpData[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (locData !== undefined && locData !== null)
            locData && locData.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "LocData[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (deptData !== undefined && deptData !== null)
            deptData && deptData.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "DeptData[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (kPIPolicyID === null)
            throw new Error("The parameter 'kPIPolicyID' cannot be null.");
        else if (kPIPolicyID !== undefined)
            url_ += "KPIPolicyID=" + encodeURIComponent("" + kPIPolicyID) + "&";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "Fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (flag === null)
            throw new Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScoreCardDetailedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScoreCardDetailedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmployeeScoreCardDetailed[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmployeeScoreCardDetailed[]>;
        }));
    }

    protected processGetScoreCardDetailedReport(response: HttpResponseBase): Observable<GetEmployeeScoreCardDetailed[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetEmployeeScoreCardDetailed.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeeScoreCardDetailed[]>(null as any);
    }

    /**
     * @param empData (optional) 
     * @param locData (optional) 
     * @param deptData (optional) 
     * @param kPIPolicyID (optional) 
     * @param fromdate (optional) 
     * @param toDate (optional) 
     * @param flag (optional) 
     * @return Success
     */
    getScoreCardDetailedReportExcel(empData: EmployeeData[] | null | undefined, locData: LocationData[] | null | undefined, deptData: DepartmentData[] | null | undefined, kPIPolicyID: number | undefined, fromdate: moment.Moment | undefined, toDate: moment.Moment | undefined, flag: boolean | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/KPIAssignPolicy/GetScoreCardDetailedReportExcel?";
        if (empData !== undefined && empData !== null)
            empData && empData.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "EmpData[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (locData !== undefined && locData !== null)
            locData && locData.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "LocData[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (deptData !== undefined && deptData !== null)
            deptData && deptData.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "DeptData[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (kPIPolicyID === null)
            throw new Error("The parameter 'kPIPolicyID' cannot be null.");
        else if (kPIPolicyID !== undefined)
            url_ += "KPIPolicyID=" + encodeURIComponent("" + kPIPolicyID) + "&";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "Fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (flag === null)
            throw new Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScoreCardDetailedReportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScoreCardDetailedReportExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetScoreCardDetailedReportExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @return Success
     */
    getEMRData(): Observable<EmployeeAndManagerReviewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/KPIAssignPolicy/GetEMRData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEMRData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEMRData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeAndManagerReviewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeAndManagerReviewDto[]>;
        }));
    }

    protected processGetEMRData(response: HttpResponseBase): Observable<EmployeeAndManagerReviewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeAndManagerReviewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeAndManagerReviewDto[]>(null as any);
    }
}

@Injectable()
export class KPICriteriaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditCriteria | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/KPICriteria/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCriteriaList(id: number | undefined): Observable<CreateOrEditCriteriaList[]> {
        let url_ = this.baseUrl + "/api/services/app/KPICriteria/GetCriteriaList?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCriteriaList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCriteriaList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditCriteriaList[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditCriteriaList[]>;
        }));
    }

    protected processGetCriteriaList(response: HttpResponseBase): Observable<CreateOrEditCriteriaList[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditCriteriaList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditCriteriaList[]>(null as any);
    }
}

@Injectable()
export class KraAppServicesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllKra(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetKraForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/KraAppServices/GetAllKra?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllKra(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllKra(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetKraForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetKraForViewDto>;
        }));
    }

    protected processGetAllKra(response: HttpResponseBase): Observable<PagedResultDtoOfGetKraForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetKraForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetKraForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOnKraForView(id: number | undefined): Observable<GetKraForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/KraAppServices/GetOnKraForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnKraForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnKraForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetKraForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetKraForViewDto>;
        }));
    }

    protected processGetOnKraForView(response: HttpResponseBase): Observable<GetKraForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetKraForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetKraForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getKraForEdit(id: number | undefined): Observable<GetKraForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/KraAppServices/GetKraForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKraForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKraForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetKraForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetKraForEditOutput>;
        }));
    }

    protected processGetKraForEdit(response: HttpResponseBase): Observable<GetKraForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetKraForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetKraForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditKraDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/KraAppServices/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/KraAppServices/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    isActive(input: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/KraAppServices/IsActive?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processIsActive(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getKraToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/KraAppServices/GetKraToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKraToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKraToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetKraToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @return Success
     */
    getKraBlankFormat(): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/KraAppServices/GetKraBlankFormat";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKraBlankFormat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKraBlankFormat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetKraBlankFormat(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param excelFile (optional) 
     * @return Success
     */
    importKraFromExcel(excelFile: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/KraAppServices/ImportKraFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile !== null && excelFile !== undefined)
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportKraFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportKraFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportKraFromExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class LabourWelfaresettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxLWFDesductiononBasisFilter (optional) 
     * @param minLWFDesductiononBasisFilter (optional) 
     * @param maxDeductLwfOnArrearFilter (optional) 
     * @param minDeductLwfOnArrearFilter (optional) 
     * @param maxDeductLwfonSettlementFilter (optional) 
     * @param minDeductLwfonSettlementFilter (optional) 
     * @param labourwelfareRegistrationFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxLWFDesductiononBasisFilter: number | null | undefined, minLWFDesductiononBasisFilter: number | null | undefined, maxDeductLwfOnArrearFilter: number | null | undefined, minDeductLwfOnArrearFilter: number | null | undefined, maxDeductLwfonSettlementFilter: number | null | undefined, minDeductLwfonSettlementFilter: number | null | undefined, labourwelfareRegistrationFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetLabourWelfaresettingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/LabourWelfaresettings/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxLWFDesductiononBasisFilter !== undefined && maxLWFDesductiononBasisFilter !== null)
            url_ += "MaxLWFDesductiononBasisFilter=" + encodeURIComponent("" + maxLWFDesductiononBasisFilter) + "&";
        if (minLWFDesductiononBasisFilter !== undefined && minLWFDesductiononBasisFilter !== null)
            url_ += "MinLWFDesductiononBasisFilter=" + encodeURIComponent("" + minLWFDesductiononBasisFilter) + "&";
        if (maxDeductLwfOnArrearFilter !== undefined && maxDeductLwfOnArrearFilter !== null)
            url_ += "MaxDeductLwfOnArrearFilter=" + encodeURIComponent("" + maxDeductLwfOnArrearFilter) + "&";
        if (minDeductLwfOnArrearFilter !== undefined && minDeductLwfOnArrearFilter !== null)
            url_ += "MinDeductLwfOnArrearFilter=" + encodeURIComponent("" + minDeductLwfOnArrearFilter) + "&";
        if (maxDeductLwfonSettlementFilter !== undefined && maxDeductLwfonSettlementFilter !== null)
            url_ += "MaxDeductLwfonSettlementFilter=" + encodeURIComponent("" + maxDeductLwfonSettlementFilter) + "&";
        if (minDeductLwfonSettlementFilter !== undefined && minDeductLwfonSettlementFilter !== null)
            url_ += "MinDeductLwfonSettlementFilter=" + encodeURIComponent("" + minDeductLwfonSettlementFilter) + "&";
        if (labourwelfareRegistrationFilter !== undefined && labourwelfareRegistrationFilter !== null)
            url_ += "LabourwelfareRegistrationFilter=" + encodeURIComponent("" + labourwelfareRegistrationFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetLabourWelfaresettingForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetLabourWelfaresettingForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetLabourWelfaresettingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetLabourWelfaresettingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetLabourWelfaresettingForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLabourWelfaresettingForView(id: number | undefined): Observable<GetLabourWelfaresettingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/LabourWelfaresettings/GetLabourWelfaresettingForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLabourWelfaresettingForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLabourWelfaresettingForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLabourWelfaresettingForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLabourWelfaresettingForViewDto>;
        }));
    }

    protected processGetLabourWelfaresettingForView(response: HttpResponseBase): Observable<GetLabourWelfaresettingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLabourWelfaresettingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLabourWelfaresettingForViewDto>(null as any);
    }

    /**
     * @return Success
     */
    getLabourWelfaresettingForEdit(): Observable<GetLabourWelfaresettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/LabourWelfaresettings/GetLabourWelfaresettingForEdit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLabourWelfaresettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLabourWelfaresettingForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLabourWelfaresettingForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLabourWelfaresettingForEditOutput>;
        }));
    }

    protected processGetLabourWelfaresettingForEdit(response: HttpResponseBase): Observable<GetLabourWelfaresettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLabourWelfaresettingForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLabourWelfaresettingForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditLabourWelfaresettingDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LabourWelfaresettings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LabourWelfaresettings/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxLWFDesductiononBasisFilter (optional) 
     * @param minLWFDesductiononBasisFilter (optional) 
     * @param maxDeductLwfOnArrearFilter (optional) 
     * @param minDeductLwfOnArrearFilter (optional) 
     * @param maxDeductLwfonSettlementFilter (optional) 
     * @param minDeductLwfonSettlementFilter (optional) 
     * @param labourwelfareRegistrationFilter (optional) 
     * @return Success
     */
    getLabourWelfaresettingsToExcel(filter: string | null | undefined, maxLWFDesductiononBasisFilter: number | null | undefined, minLWFDesductiononBasisFilter: number | null | undefined, maxDeductLwfOnArrearFilter: number | null | undefined, minDeductLwfOnArrearFilter: number | null | undefined, maxDeductLwfonSettlementFilter: number | null | undefined, minDeductLwfonSettlementFilter: number | null | undefined, labourwelfareRegistrationFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/LabourWelfaresettings/GetLabourWelfaresettingsToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxLWFDesductiononBasisFilter !== undefined && maxLWFDesductiononBasisFilter !== null)
            url_ += "MaxLWFDesductiononBasisFilter=" + encodeURIComponent("" + maxLWFDesductiononBasisFilter) + "&";
        if (minLWFDesductiononBasisFilter !== undefined && minLWFDesductiononBasisFilter !== null)
            url_ += "MinLWFDesductiononBasisFilter=" + encodeURIComponent("" + minLWFDesductiononBasisFilter) + "&";
        if (maxDeductLwfOnArrearFilter !== undefined && maxDeductLwfOnArrearFilter !== null)
            url_ += "MaxDeductLwfOnArrearFilter=" + encodeURIComponent("" + maxDeductLwfOnArrearFilter) + "&";
        if (minDeductLwfOnArrearFilter !== undefined && minDeductLwfOnArrearFilter !== null)
            url_ += "MinDeductLwfOnArrearFilter=" + encodeURIComponent("" + minDeductLwfOnArrearFilter) + "&";
        if (maxDeductLwfonSettlementFilter !== undefined && maxDeductLwfonSettlementFilter !== null)
            url_ += "MaxDeductLwfonSettlementFilter=" + encodeURIComponent("" + maxDeductLwfonSettlementFilter) + "&";
        if (minDeductLwfonSettlementFilter !== undefined && minDeductLwfonSettlementFilter !== null)
            url_ += "MinDeductLwfonSettlementFilter=" + encodeURIComponent("" + minDeductLwfonSettlementFilter) + "&";
        if (labourwelfareRegistrationFilter !== undefined && labourwelfareRegistrationFilter !== null)
            url_ += "LabourwelfareRegistrationFilter=" + encodeURIComponent("" + labourwelfareRegistrationFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLabourWelfaresettingsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLabourWelfaresettingsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetLabourWelfaresettingsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class LanguageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLanguages(): Observable<GetLanguagesOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLanguagesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLanguagesOutput>;
        }));
    }

    protected processGetLanguages(response: HttpResponseBase): Observable<GetLanguagesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLanguagesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLanguagesOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLanguageForEdit(id: number | null | undefined): Observable<GetLanguageForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageForEdit?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLanguageForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLanguageForEditOutput>;
        }));
    }

    protected processGetLanguageForEdit(response: HttpResponseBase): Observable<GetLanguageForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLanguageForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLanguageForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLanguage(body: CreateOrUpdateLanguageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/CreateOrUpdateLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteLanguage(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/DeleteLanguage?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setDefaultLanguage(body: SetDefaultLanguageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/SetDefaultLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDefaultLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDefaultLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetDefaultLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @param baseLanguageName (optional) 
     * @param targetValueFilter (optional) 
     * @param filterText (optional) 
     * @return Success
     */
    getLanguageTexts(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | null | undefined, sourceName: string, baseLanguageName: string | null | undefined, targetLanguageName: string, targetValueFilter: string | null | undefined, filterText: string | null | undefined): Observable<PagedResultDtoOfLanguageTextListDto> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageTexts?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined and cannot be null.");
        else
            url_ += "SourceName=" + encodeURIComponent("" + sourceName) + "&";
        if (baseLanguageName !== undefined && baseLanguageName !== null)
            url_ += "BaseLanguageName=" + encodeURIComponent("" + baseLanguageName) + "&";
        if (targetLanguageName === undefined || targetLanguageName === null)
            throw new Error("The parameter 'targetLanguageName' must be defined and cannot be null.");
        else
            url_ += "TargetLanguageName=" + encodeURIComponent("" + targetLanguageName) + "&";
        if (targetValueFilter !== undefined && targetValueFilter !== null)
            url_ += "TargetValueFilter=" + encodeURIComponent("" + targetValueFilter) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageTexts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageTexts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLanguageTextListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLanguageTextListDto>;
        }));
    }

    protected processGetLanguageTexts(response: HttpResponseBase): Observable<PagedResultDtoOfLanguageTextListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLanguageTextListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLanguageTextListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateLanguageText(body: UpdateLanguageTextInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/UpdateLanguageText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLanguageText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLanguageText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateLanguageText(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class LeaveBlancesesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxEmployeeIdFilter (optional) 
     * @param minEmployeeIdFilter (optional) 
     * @param financeYearFilter (optional) 
     * @param maxLeaveUsedFilter (optional) 
     * @param minLeaveUsedFilter (optional) 
     * @param maxLeaveTypeFilter (optional) 
     * @param minLeaveTypeFilter (optional) 
     * @param maxLeaveBalanceFilter (optional) 
     * @param minLeaveBalanceFilter (optional) 
     * @param maxCarryForwardLeaveFilter (optional) 
     * @param minCarryForwardLeaveFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxEmployeeIdFilter: number | null | undefined, minEmployeeIdFilter: number | null | undefined, financeYearFilter: string | null | undefined, maxLeaveUsedFilter: number | null | undefined, minLeaveUsedFilter: number | null | undefined, maxLeaveTypeFilter: number | null | undefined, minLeaveTypeFilter: number | null | undefined, maxLeaveBalanceFilter: number | null | undefined, minLeaveBalanceFilter: number | null | undefined, maxCarryForwardLeaveFilter: number | null | undefined, minCarryForwardLeaveFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetLeaveBlancesForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/LeaveBlanceses/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxEmployeeIdFilter !== undefined && maxEmployeeIdFilter !== null)
            url_ += "MaxEmployeeIdFilter=" + encodeURIComponent("" + maxEmployeeIdFilter) + "&";
        if (minEmployeeIdFilter !== undefined && minEmployeeIdFilter !== null)
            url_ += "MinEmployeeIdFilter=" + encodeURIComponent("" + minEmployeeIdFilter) + "&";
        if (financeYearFilter !== undefined && financeYearFilter !== null)
            url_ += "FinanceYearFilter=" + encodeURIComponent("" + financeYearFilter) + "&";
        if (maxLeaveUsedFilter !== undefined && maxLeaveUsedFilter !== null)
            url_ += "MaxLeaveUsedFilter=" + encodeURIComponent("" + maxLeaveUsedFilter) + "&";
        if (minLeaveUsedFilter !== undefined && minLeaveUsedFilter !== null)
            url_ += "MinLeaveUsedFilter=" + encodeURIComponent("" + minLeaveUsedFilter) + "&";
        if (maxLeaveTypeFilter !== undefined && maxLeaveTypeFilter !== null)
            url_ += "MaxLeaveTypeFilter=" + encodeURIComponent("" + maxLeaveTypeFilter) + "&";
        if (minLeaveTypeFilter !== undefined && minLeaveTypeFilter !== null)
            url_ += "MinLeaveTypeFilter=" + encodeURIComponent("" + minLeaveTypeFilter) + "&";
        if (maxLeaveBalanceFilter !== undefined && maxLeaveBalanceFilter !== null)
            url_ += "MaxLeaveBalanceFilter=" + encodeURIComponent("" + maxLeaveBalanceFilter) + "&";
        if (minLeaveBalanceFilter !== undefined && minLeaveBalanceFilter !== null)
            url_ += "MinLeaveBalanceFilter=" + encodeURIComponent("" + minLeaveBalanceFilter) + "&";
        if (maxCarryForwardLeaveFilter !== undefined && maxCarryForwardLeaveFilter !== null)
            url_ += "MaxCarryForwardLeaveFilter=" + encodeURIComponent("" + maxCarryForwardLeaveFilter) + "&";
        if (minCarryForwardLeaveFilter !== undefined && minCarryForwardLeaveFilter !== null)
            url_ += "MinCarryForwardLeaveFilter=" + encodeURIComponent("" + minCarryForwardLeaveFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetLeaveBlancesForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetLeaveBlancesForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetLeaveBlancesForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetLeaveBlancesForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetLeaveBlancesForViewDto>(null as any);
    }

    /**
     * @return Success
     */
    leaveBalanceSync(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeaveBlanceses/leaveBalanceSync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLeaveBalanceSync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLeaveBalanceSync(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLeaveBalanceSync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLeaveBlancesForView(id: number | undefined): Observable<GetLeaveBlancesForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/LeaveBlanceses/GetLeaveBlancesForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveBlancesForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveBlancesForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLeaveBlancesForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLeaveBlancesForViewDto>;
        }));
    }

    protected processGetLeaveBlancesForView(response: HttpResponseBase): Observable<GetLeaveBlancesForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLeaveBlancesForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLeaveBlancesForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLeaveBlancesForEdit(id: number | undefined): Observable<GetLeaveBlancesForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/LeaveBlanceses/GetLeaveBlancesForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveBlancesForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveBlancesForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLeaveBlancesForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLeaveBlancesForEditOutput>;
        }));
    }

    protected processGetLeaveBlancesForEdit(response: HttpResponseBase): Observable<GetLeaveBlancesForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLeaveBlancesForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLeaveBlancesForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditLeaveBlancesDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeaveBlanceses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeaveBlanceses/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxEmployeeIdFilter (optional) 
     * @param minEmployeeIdFilter (optional) 
     * @param financeYearFilter (optional) 
     * @param maxLeaveUsedFilter (optional) 
     * @param minLeaveUsedFilter (optional) 
     * @param maxLeaveTypeFilter (optional) 
     * @param minLeaveTypeFilter (optional) 
     * @param maxLeaveBalanceFilter (optional) 
     * @param minLeaveBalanceFilter (optional) 
     * @param maxCarryForwardLeaveFilter (optional) 
     * @param minCarryForwardLeaveFilter (optional) 
     * @return Success
     */
    getLeaveBlancesesToExcel(filter: string | null | undefined, maxEmployeeIdFilter: number | null | undefined, minEmployeeIdFilter: number | null | undefined, financeYearFilter: string | null | undefined, maxLeaveUsedFilter: number | null | undefined, minLeaveUsedFilter: number | null | undefined, maxLeaveTypeFilter: number | null | undefined, minLeaveTypeFilter: number | null | undefined, maxLeaveBalanceFilter: number | null | undefined, minLeaveBalanceFilter: number | null | undefined, maxCarryForwardLeaveFilter: number | null | undefined, minCarryForwardLeaveFilter: number | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/LeaveBlanceses/GetLeaveBlancesesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxEmployeeIdFilter !== undefined && maxEmployeeIdFilter !== null)
            url_ += "MaxEmployeeIdFilter=" + encodeURIComponent("" + maxEmployeeIdFilter) + "&";
        if (minEmployeeIdFilter !== undefined && minEmployeeIdFilter !== null)
            url_ += "MinEmployeeIdFilter=" + encodeURIComponent("" + minEmployeeIdFilter) + "&";
        if (financeYearFilter !== undefined && financeYearFilter !== null)
            url_ += "FinanceYearFilter=" + encodeURIComponent("" + financeYearFilter) + "&";
        if (maxLeaveUsedFilter !== undefined && maxLeaveUsedFilter !== null)
            url_ += "MaxLeaveUsedFilter=" + encodeURIComponent("" + maxLeaveUsedFilter) + "&";
        if (minLeaveUsedFilter !== undefined && minLeaveUsedFilter !== null)
            url_ += "MinLeaveUsedFilter=" + encodeURIComponent("" + minLeaveUsedFilter) + "&";
        if (maxLeaveTypeFilter !== undefined && maxLeaveTypeFilter !== null)
            url_ += "MaxLeaveTypeFilter=" + encodeURIComponent("" + maxLeaveTypeFilter) + "&";
        if (minLeaveTypeFilter !== undefined && minLeaveTypeFilter !== null)
            url_ += "MinLeaveTypeFilter=" + encodeURIComponent("" + minLeaveTypeFilter) + "&";
        if (maxLeaveBalanceFilter !== undefined && maxLeaveBalanceFilter !== null)
            url_ += "MaxLeaveBalanceFilter=" + encodeURIComponent("" + maxLeaveBalanceFilter) + "&";
        if (minLeaveBalanceFilter !== undefined && minLeaveBalanceFilter !== null)
            url_ += "MinLeaveBalanceFilter=" + encodeURIComponent("" + minLeaveBalanceFilter) + "&";
        if (maxCarryForwardLeaveFilter !== undefined && maxCarryForwardLeaveFilter !== null)
            url_ += "MaxCarryForwardLeaveFilter=" + encodeURIComponent("" + maxCarryForwardLeaveFilter) + "&";
        if (minCarryForwardLeaveFilter !== undefined && minCarryForwardLeaveFilter !== null)
            url_ += "MinCarryForwardLeaveFilter=" + encodeURIComponent("" + minCarryForwardLeaveFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveBlancesesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveBlancesesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetLeaveBlancesesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class LeaveRequestsesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param leaveId (optional) 
     * @param request (optional) 
     * @param maxLeaveTypeIdFilter (optional) 
     * @param minLeaveTypeIdFilter (optional) 
     * @param maxLeaveFromFilter (optional) 
     * @param minLeaveFromFilter (optional) 
     * @param maxLeaveToFilter (optional) 
     * @param minLeaveToFilter (optional) 
     * @param maxLeaveDaysFilter (optional) 
     * @param minLeaveDaysFilter (optional) 
     * @param requestReasonsFilter (optional) 
     * @param leaveStatusFilter (optional) 
     * @param maxCreatedByFilter (optional) 
     * @param minCreatedByFilter (optional) 
     * @param maxCreatedOnFilter (optional) 
     * @param minCreatedOnFilter (optional) 
     * @param maxUpdateByFilter (optional) 
     * @param minUpdateByFilter (optional) 
     * @param maxUpdatedOnFilter (optional) 
     * @param minUpdatedOnFilter (optional) 
     * @param employeeid (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, leaveId: number | undefined, request: string | null | undefined, maxLeaveTypeIdFilter: number | null | undefined, minLeaveTypeIdFilter: number | null | undefined, maxLeaveFromFilter: moment.Moment | null | undefined, minLeaveFromFilter: moment.Moment | null | undefined, maxLeaveToFilter: moment.Moment | null | undefined, minLeaveToFilter: moment.Moment | null | undefined, maxLeaveDaysFilter: number | null | undefined, minLeaveDaysFilter: number | null | undefined, requestReasonsFilter: string | null | undefined, leaveStatusFilter: string | null | undefined, maxCreatedByFilter: number | null | undefined, minCreatedByFilter: number | null | undefined, maxCreatedOnFilter: moment.Moment | null | undefined, minCreatedOnFilter: moment.Moment | null | undefined, maxUpdateByFilter: number | null | undefined, minUpdateByFilter: number | null | undefined, maxUpdatedOnFilter: moment.Moment | null | undefined, minUpdatedOnFilter: moment.Moment | null | undefined, employeeid: number | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetLeaveRequestsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (leaveId === null)
            throw new Error("The parameter 'leaveId' cannot be null.");
        else if (leaveId !== undefined)
            url_ += "leaveId=" + encodeURIComponent("" + leaveId) + "&";
        if (request !== undefined && request !== null)
            url_ += "request=" + encodeURIComponent("" + request) + "&";
        if (maxLeaveTypeIdFilter !== undefined && maxLeaveTypeIdFilter !== null)
            url_ += "MaxLeaveTypeIdFilter=" + encodeURIComponent("" + maxLeaveTypeIdFilter) + "&";
        if (minLeaveTypeIdFilter !== undefined && minLeaveTypeIdFilter !== null)
            url_ += "MinLeaveTypeIdFilter=" + encodeURIComponent("" + minLeaveTypeIdFilter) + "&";
        if (maxLeaveFromFilter !== undefined && maxLeaveFromFilter !== null)
            url_ += "MaxLeaveFromFilter=" + encodeURIComponent(maxLeaveFromFilter ? "" + maxLeaveFromFilter.toISOString() : "") + "&";
        if (minLeaveFromFilter !== undefined && minLeaveFromFilter !== null)
            url_ += "MinLeaveFromFilter=" + encodeURIComponent(minLeaveFromFilter ? "" + minLeaveFromFilter.toISOString() : "") + "&";
        if (maxLeaveToFilter !== undefined && maxLeaveToFilter !== null)
            url_ += "MaxLeaveToFilter=" + encodeURIComponent(maxLeaveToFilter ? "" + maxLeaveToFilter.toISOString() : "") + "&";
        if (minLeaveToFilter !== undefined && minLeaveToFilter !== null)
            url_ += "MinLeaveToFilter=" + encodeURIComponent(minLeaveToFilter ? "" + minLeaveToFilter.toISOString() : "") + "&";
        if (maxLeaveDaysFilter !== undefined && maxLeaveDaysFilter !== null)
            url_ += "MaxLeaveDaysFilter=" + encodeURIComponent("" + maxLeaveDaysFilter) + "&";
        if (minLeaveDaysFilter !== undefined && minLeaveDaysFilter !== null)
            url_ += "MinLeaveDaysFilter=" + encodeURIComponent("" + minLeaveDaysFilter) + "&";
        if (requestReasonsFilter !== undefined && requestReasonsFilter !== null)
            url_ += "RequestReasonsFilter=" + encodeURIComponent("" + requestReasonsFilter) + "&";
        if (leaveStatusFilter !== undefined && leaveStatusFilter !== null)
            url_ += "LeaveStatusFilter=" + encodeURIComponent("" + leaveStatusFilter) + "&";
        if (maxCreatedByFilter !== undefined && maxCreatedByFilter !== null)
            url_ += "MaxCreatedByFilter=" + encodeURIComponent("" + maxCreatedByFilter) + "&";
        if (minCreatedByFilter !== undefined && minCreatedByFilter !== null)
            url_ += "MinCreatedByFilter=" + encodeURIComponent("" + minCreatedByFilter) + "&";
        if (maxCreatedOnFilter !== undefined && maxCreatedOnFilter !== null)
            url_ += "MaxCreatedOnFilter=" + encodeURIComponent(maxCreatedOnFilter ? "" + maxCreatedOnFilter.toISOString() : "") + "&";
        if (minCreatedOnFilter !== undefined && minCreatedOnFilter !== null)
            url_ += "MinCreatedOnFilter=" + encodeURIComponent(minCreatedOnFilter ? "" + minCreatedOnFilter.toISOString() : "") + "&";
        if (maxUpdateByFilter !== undefined && maxUpdateByFilter !== null)
            url_ += "MaxUpdateByFilter=" + encodeURIComponent("" + maxUpdateByFilter) + "&";
        if (minUpdateByFilter !== undefined && minUpdateByFilter !== null)
            url_ += "MinUpdateByFilter=" + encodeURIComponent("" + minUpdateByFilter) + "&";
        if (maxUpdatedOnFilter !== undefined && maxUpdatedOnFilter !== null)
            url_ += "MaxUpdatedOnFilter=" + encodeURIComponent(maxUpdatedOnFilter ? "" + maxUpdatedOnFilter.toISOString() : "") + "&";
        if (minUpdatedOnFilter !== undefined && minUpdatedOnFilter !== null)
            url_ += "MinUpdatedOnFilter=" + encodeURIComponent(minUpdatedOnFilter ? "" + minUpdatedOnFilter.toISOString() : "") + "&";
        if (employeeid !== undefined && employeeid !== null)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetLeaveRequestsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetLeaveRequestsForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetLeaveRequestsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetLeaveRequestsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetLeaveRequestsForViewDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param leaveId (optional) 
     * @param request (optional) 
     * @param maxLeaveTypeIdFilter (optional) 
     * @param minLeaveTypeIdFilter (optional) 
     * @param maxLeaveFromFilter (optional) 
     * @param minLeaveFromFilter (optional) 
     * @param maxLeaveToFilter (optional) 
     * @param minLeaveToFilter (optional) 
     * @param maxLeaveDaysFilter (optional) 
     * @param minLeaveDaysFilter (optional) 
     * @param requestReasonsFilter (optional) 
     * @param leaveStatusFilter (optional) 
     * @param maxCreatedByFilter (optional) 
     * @param minCreatedByFilter (optional) 
     * @param maxCreatedOnFilter (optional) 
     * @param minCreatedOnFilter (optional) 
     * @param maxUpdateByFilter (optional) 
     * @param minUpdateByFilter (optional) 
     * @param maxUpdatedOnFilter (optional) 
     * @param minUpdatedOnFilter (optional) 
     * @param employeeid (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllLeave(filter: string | null | undefined, leaveId: number | undefined, request: string | null | undefined, maxLeaveTypeIdFilter: number | null | undefined, minLeaveTypeIdFilter: number | null | undefined, maxLeaveFromFilter: moment.Moment | null | undefined, minLeaveFromFilter: moment.Moment | null | undefined, maxLeaveToFilter: moment.Moment | null | undefined, minLeaveToFilter: moment.Moment | null | undefined, maxLeaveDaysFilter: number | null | undefined, minLeaveDaysFilter: number | null | undefined, requestReasonsFilter: string | null | undefined, leaveStatusFilter: string | null | undefined, maxCreatedByFilter: number | null | undefined, minCreatedByFilter: number | null | undefined, maxCreatedOnFilter: moment.Moment | null | undefined, minCreatedOnFilter: moment.Moment | null | undefined, maxUpdateByFilter: number | null | undefined, minUpdateByFilter: number | null | undefined, maxUpdatedOnFilter: moment.Moment | null | undefined, minUpdatedOnFilter: moment.Moment | null | undefined, employeeid: number | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfLeaveOnSelfService> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/GetAllLeave?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (leaveId === null)
            throw new Error("The parameter 'leaveId' cannot be null.");
        else if (leaveId !== undefined)
            url_ += "leaveId=" + encodeURIComponent("" + leaveId) + "&";
        if (request !== undefined && request !== null)
            url_ += "request=" + encodeURIComponent("" + request) + "&";
        if (maxLeaveTypeIdFilter !== undefined && maxLeaveTypeIdFilter !== null)
            url_ += "MaxLeaveTypeIdFilter=" + encodeURIComponent("" + maxLeaveTypeIdFilter) + "&";
        if (minLeaveTypeIdFilter !== undefined && minLeaveTypeIdFilter !== null)
            url_ += "MinLeaveTypeIdFilter=" + encodeURIComponent("" + minLeaveTypeIdFilter) + "&";
        if (maxLeaveFromFilter !== undefined && maxLeaveFromFilter !== null)
            url_ += "MaxLeaveFromFilter=" + encodeURIComponent(maxLeaveFromFilter ? "" + maxLeaveFromFilter.toISOString() : "") + "&";
        if (minLeaveFromFilter !== undefined && minLeaveFromFilter !== null)
            url_ += "MinLeaveFromFilter=" + encodeURIComponent(minLeaveFromFilter ? "" + minLeaveFromFilter.toISOString() : "") + "&";
        if (maxLeaveToFilter !== undefined && maxLeaveToFilter !== null)
            url_ += "MaxLeaveToFilter=" + encodeURIComponent(maxLeaveToFilter ? "" + maxLeaveToFilter.toISOString() : "") + "&";
        if (minLeaveToFilter !== undefined && minLeaveToFilter !== null)
            url_ += "MinLeaveToFilter=" + encodeURIComponent(minLeaveToFilter ? "" + minLeaveToFilter.toISOString() : "") + "&";
        if (maxLeaveDaysFilter !== undefined && maxLeaveDaysFilter !== null)
            url_ += "MaxLeaveDaysFilter=" + encodeURIComponent("" + maxLeaveDaysFilter) + "&";
        if (minLeaveDaysFilter !== undefined && minLeaveDaysFilter !== null)
            url_ += "MinLeaveDaysFilter=" + encodeURIComponent("" + minLeaveDaysFilter) + "&";
        if (requestReasonsFilter !== undefined && requestReasonsFilter !== null)
            url_ += "RequestReasonsFilter=" + encodeURIComponent("" + requestReasonsFilter) + "&";
        if (leaveStatusFilter !== undefined && leaveStatusFilter !== null)
            url_ += "LeaveStatusFilter=" + encodeURIComponent("" + leaveStatusFilter) + "&";
        if (maxCreatedByFilter !== undefined && maxCreatedByFilter !== null)
            url_ += "MaxCreatedByFilter=" + encodeURIComponent("" + maxCreatedByFilter) + "&";
        if (minCreatedByFilter !== undefined && minCreatedByFilter !== null)
            url_ += "MinCreatedByFilter=" + encodeURIComponent("" + minCreatedByFilter) + "&";
        if (maxCreatedOnFilter !== undefined && maxCreatedOnFilter !== null)
            url_ += "MaxCreatedOnFilter=" + encodeURIComponent(maxCreatedOnFilter ? "" + maxCreatedOnFilter.toISOString() : "") + "&";
        if (minCreatedOnFilter !== undefined && minCreatedOnFilter !== null)
            url_ += "MinCreatedOnFilter=" + encodeURIComponent(minCreatedOnFilter ? "" + minCreatedOnFilter.toISOString() : "") + "&";
        if (maxUpdateByFilter !== undefined && maxUpdateByFilter !== null)
            url_ += "MaxUpdateByFilter=" + encodeURIComponent("" + maxUpdateByFilter) + "&";
        if (minUpdateByFilter !== undefined && minUpdateByFilter !== null)
            url_ += "MinUpdateByFilter=" + encodeURIComponent("" + minUpdateByFilter) + "&";
        if (maxUpdatedOnFilter !== undefined && maxUpdatedOnFilter !== null)
            url_ += "MaxUpdatedOnFilter=" + encodeURIComponent(maxUpdatedOnFilter ? "" + maxUpdatedOnFilter.toISOString() : "") + "&";
        if (minUpdatedOnFilter !== undefined && minUpdatedOnFilter !== null)
            url_ += "MinUpdatedOnFilter=" + encodeURIComponent(minUpdatedOnFilter ? "" + minUpdatedOnFilter.toISOString() : "") + "&";
        if (employeeid !== undefined && employeeid !== null)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLeave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLeave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLeaveOnSelfService>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLeaveOnSelfService>;
        }));
    }

    protected processGetAllLeave(response: HttpResponseBase): Observable<PagedResultDtoOfLeaveOnSelfService> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLeaveOnSelfService.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLeaveOnSelfService>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    leaveRequestCancel(input: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/LeaveRequestCancel?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLeaveRequestCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLeaveRequestCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processLeaveRequestCancel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param month (optional) 
     * @param employeeId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCancelledLeavetoFilter(filter: string | null | undefined, month: number | undefined, employeeId: number | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCancelledLeaveForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/GetAllCancelledLeavetoFilter?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "Month=" + encodeURIComponent("" + month) + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCancelledLeavetoFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCancelledLeavetoFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetCancelledLeaveForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetCancelledLeaveForViewDto>;
        }));
    }

    protected processGetAllCancelledLeavetoFilter(response: HttpResponseBase): Observable<PagedResultDtoOfGetCancelledLeaveForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCancelledLeaveForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCancelledLeaveForViewDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param leaveId (optional) 
     * @param request (optional) 
     * @param maxLeaveTypeIdFilter (optional) 
     * @param minLeaveTypeIdFilter (optional) 
     * @param maxLeaveFromFilter (optional) 
     * @param minLeaveFromFilter (optional) 
     * @param maxLeaveToFilter (optional) 
     * @param minLeaveToFilter (optional) 
     * @param maxLeaveDaysFilter (optional) 
     * @param minLeaveDaysFilter (optional) 
     * @param requestReasonsFilter (optional) 
     * @param leaveStatusFilter (optional) 
     * @param maxCreatedByFilter (optional) 
     * @param minCreatedByFilter (optional) 
     * @param maxCreatedOnFilter (optional) 
     * @param minCreatedOnFilter (optional) 
     * @param maxUpdateByFilter (optional) 
     * @param minUpdateByFilter (optional) 
     * @param maxUpdatedOnFilter (optional) 
     * @param minUpdatedOnFilter (optional) 
     * @param employeeid (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllLeaveAccordingtoFilter(filter: string | null | undefined, leaveId: number | undefined, request: string | null | undefined, maxLeaveTypeIdFilter: number | null | undefined, minLeaveTypeIdFilter: number | null | undefined, maxLeaveFromFilter: moment.Moment | null | undefined, minLeaveFromFilter: moment.Moment | null | undefined, maxLeaveToFilter: moment.Moment | null | undefined, minLeaveToFilter: moment.Moment | null | undefined, maxLeaveDaysFilter: number | null | undefined, minLeaveDaysFilter: number | null | undefined, requestReasonsFilter: string | null | undefined, leaveStatusFilter: string | null | undefined, maxCreatedByFilter: number | null | undefined, minCreatedByFilter: number | null | undefined, maxCreatedOnFilter: moment.Moment | null | undefined, minCreatedOnFilter: moment.Moment | null | undefined, maxUpdateByFilter: number | null | undefined, minUpdateByFilter: number | null | undefined, maxUpdatedOnFilter: moment.Moment | null | undefined, minUpdatedOnFilter: moment.Moment | null | undefined, employeeid: number | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfLeaveOnSelfService> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/GetAllLeaveAccordingtoFilter?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (leaveId === null)
            throw new Error("The parameter 'leaveId' cannot be null.");
        else if (leaveId !== undefined)
            url_ += "leaveId=" + encodeURIComponent("" + leaveId) + "&";
        if (request !== undefined && request !== null)
            url_ += "request=" + encodeURIComponent("" + request) + "&";
        if (maxLeaveTypeIdFilter !== undefined && maxLeaveTypeIdFilter !== null)
            url_ += "MaxLeaveTypeIdFilter=" + encodeURIComponent("" + maxLeaveTypeIdFilter) + "&";
        if (minLeaveTypeIdFilter !== undefined && minLeaveTypeIdFilter !== null)
            url_ += "MinLeaveTypeIdFilter=" + encodeURIComponent("" + minLeaveTypeIdFilter) + "&";
        if (maxLeaveFromFilter !== undefined && maxLeaveFromFilter !== null)
            url_ += "MaxLeaveFromFilter=" + encodeURIComponent(maxLeaveFromFilter ? "" + maxLeaveFromFilter.toISOString() : "") + "&";
        if (minLeaveFromFilter !== undefined && minLeaveFromFilter !== null)
            url_ += "MinLeaveFromFilter=" + encodeURIComponent(minLeaveFromFilter ? "" + minLeaveFromFilter.toISOString() : "") + "&";
        if (maxLeaveToFilter !== undefined && maxLeaveToFilter !== null)
            url_ += "MaxLeaveToFilter=" + encodeURIComponent(maxLeaveToFilter ? "" + maxLeaveToFilter.toISOString() : "") + "&";
        if (minLeaveToFilter !== undefined && minLeaveToFilter !== null)
            url_ += "MinLeaveToFilter=" + encodeURIComponent(minLeaveToFilter ? "" + minLeaveToFilter.toISOString() : "") + "&";
        if (maxLeaveDaysFilter !== undefined && maxLeaveDaysFilter !== null)
            url_ += "MaxLeaveDaysFilter=" + encodeURIComponent("" + maxLeaveDaysFilter) + "&";
        if (minLeaveDaysFilter !== undefined && minLeaveDaysFilter !== null)
            url_ += "MinLeaveDaysFilter=" + encodeURIComponent("" + minLeaveDaysFilter) + "&";
        if (requestReasonsFilter !== undefined && requestReasonsFilter !== null)
            url_ += "RequestReasonsFilter=" + encodeURIComponent("" + requestReasonsFilter) + "&";
        if (leaveStatusFilter !== undefined && leaveStatusFilter !== null)
            url_ += "LeaveStatusFilter=" + encodeURIComponent("" + leaveStatusFilter) + "&";
        if (maxCreatedByFilter !== undefined && maxCreatedByFilter !== null)
            url_ += "MaxCreatedByFilter=" + encodeURIComponent("" + maxCreatedByFilter) + "&";
        if (minCreatedByFilter !== undefined && minCreatedByFilter !== null)
            url_ += "MinCreatedByFilter=" + encodeURIComponent("" + minCreatedByFilter) + "&";
        if (maxCreatedOnFilter !== undefined && maxCreatedOnFilter !== null)
            url_ += "MaxCreatedOnFilter=" + encodeURIComponent(maxCreatedOnFilter ? "" + maxCreatedOnFilter.toISOString() : "") + "&";
        if (minCreatedOnFilter !== undefined && minCreatedOnFilter !== null)
            url_ += "MinCreatedOnFilter=" + encodeURIComponent(minCreatedOnFilter ? "" + minCreatedOnFilter.toISOString() : "") + "&";
        if (maxUpdateByFilter !== undefined && maxUpdateByFilter !== null)
            url_ += "MaxUpdateByFilter=" + encodeURIComponent("" + maxUpdateByFilter) + "&";
        if (minUpdateByFilter !== undefined && minUpdateByFilter !== null)
            url_ += "MinUpdateByFilter=" + encodeURIComponent("" + minUpdateByFilter) + "&";
        if (maxUpdatedOnFilter !== undefined && maxUpdatedOnFilter !== null)
            url_ += "MaxUpdatedOnFilter=" + encodeURIComponent(maxUpdatedOnFilter ? "" + maxUpdatedOnFilter.toISOString() : "") + "&";
        if (minUpdatedOnFilter !== undefined && minUpdatedOnFilter !== null)
            url_ += "MinUpdatedOnFilter=" + encodeURIComponent(minUpdatedOnFilter ? "" + minUpdatedOnFilter.toISOString() : "") + "&";
        if (employeeid !== undefined && employeeid !== null)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLeaveAccordingtoFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLeaveAccordingtoFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLeaveOnSelfService>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLeaveOnSelfService>;
        }));
    }

    protected processGetAllLeaveAccordingtoFilter(response: HttpResponseBase): Observable<PagedResultDtoOfLeaveOnSelfService> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLeaveOnSelfService.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLeaveOnSelfService>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLeaveRequestsForView(id: number | undefined): Observable<GetLeaveRequestsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/GetLeaveRequestsForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveRequestsForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveRequestsForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLeaveRequestsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLeaveRequestsForViewDto>;
        }));
    }

    protected processGetLeaveRequestsForView(response: HttpResponseBase): Observable<GetLeaveRequestsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLeaveRequestsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLeaveRequestsForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLeaveRequestsForEdit(id: number | undefined): Observable<GetLeaveRequestsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/GetLeaveRequestsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveRequestsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveRequestsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLeaveRequestsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLeaveRequestsForEditOutput>;
        }));
    }

    protected processGetLeaveRequestsForEdit(response: HttpResponseBase): Observable<GetLeaveRequestsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLeaveRequestsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLeaveRequestsForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @param flag (optional) 
     * @return Success
     */
    getLeaveRequestsForApprovalview(id: number | undefined, flag: string | null | undefined): Observable<GetLeaveRequestsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/GetLeaveRequestsForApprovalview?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (flag !== undefined && flag !== null)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveRequestsForApprovalview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveRequestsForApprovalview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLeaveRequestsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLeaveRequestsForEditOutput>;
        }));
    }

    protected processGetLeaveRequestsForApprovalview(response: HttpResponseBase): Observable<GetLeaveRequestsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLeaveRequestsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLeaveRequestsForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLeaveRequestsForApproval(id: number | undefined): Observable<GetLeaveRequestsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/GetLeaveRequestsForApproval?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveRequestsForApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveRequestsForApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLeaveRequestsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLeaveRequestsForEditOutput>;
        }));
    }

    protected processGetLeaveRequestsForApproval(response: HttpResponseBase): Observable<GetLeaveRequestsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLeaveRequestsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLeaveRequestsForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditLeaveRequestsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param requestDaysTotal (optional) 
     * @param yearlyTotalLeave (optional) 
     * @param requestCount (optional) 
     * @param body (optional) 
     * @return Success
     */
    asssginLeaveRule(requestDaysTotal: number | undefined, yearlyTotalLeave: number | undefined, requestCount: number | undefined, body: CreateOrEditLeaveRequestsDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/AsssginLeaveRule?";
        if (requestDaysTotal === null)
            throw new Error("The parameter 'requestDaysTotal' cannot be null.");
        else if (requestDaysTotal !== undefined)
            url_ += "RequestDaysTotal=" + encodeURIComponent("" + requestDaysTotal) + "&";
        if (yearlyTotalLeave === null)
            throw new Error("The parameter 'yearlyTotalLeave' cannot be null.");
        else if (yearlyTotalLeave !== undefined)
            url_ += "YearlyTotalLeave=" + encodeURIComponent("" + yearlyTotalLeave) + "&";
        if (requestCount === null)
            throw new Error("The parameter 'requestCount' cannot be null.");
        else if (requestCount !== undefined)
            url_ += "RequestCount=" + encodeURIComponent("" + requestCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAsssginLeaveRule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAsssginLeaveRule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAsssginLeaveRule(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param leaveTypeId (optional) 
     * @return Success
     */
    checkLeaveCanApplyOrNot(leaveTypeId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/checkLeaveCanApplyOrNot?";
        if (leaveTypeId === null)
            throw new Error("The parameter 'leaveTypeId' cannot be null.");
        else if (leaveTypeId !== undefined)
            url_ += "LeaveTypeId=" + encodeURIComponent("" + leaveTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckLeaveCanApplyOrNot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckLeaveCanApplyOrNot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheckLeaveCanApplyOrNot(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param requestDaysTotal (optional) 
     * @param yearlyTotalLeave (optional) 
     * @param requestCount (optional) 
     * @param body (optional) 
     * @return Success
     */
    checkExitNoticeLeave(requestDaysTotal: number | undefined, yearlyTotalLeave: number | undefined, requestCount: number | undefined, body: CreateOrEditLeaveRequestsDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/CheckExitNoticeLeave?";
        if (requestDaysTotal === null)
            throw new Error("The parameter 'requestDaysTotal' cannot be null.");
        else if (requestDaysTotal !== undefined)
            url_ += "RequestDaysTotal=" + encodeURIComponent("" + requestDaysTotal) + "&";
        if (yearlyTotalLeave === null)
            throw new Error("The parameter 'yearlyTotalLeave' cannot be null.");
        else if (yearlyTotalLeave !== undefined)
            url_ += "YearlyTotalLeave=" + encodeURIComponent("" + yearlyTotalLeave) + "&";
        if (requestCount === null)
            throw new Error("The parameter 'requestCount' cannot be null.");
        else if (requestCount !== undefined)
            url_ += "RequestCount=" + encodeURIComponent("" + requestCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckExitNoticeLeave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckExitNoticeLeave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheckExitNoticeLeave(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    isReportingManager(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/IsReportingManager";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsReportingManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsReportingManager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsReportingManager(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param creatdby (optional) 
     * @param fromdate (optional) 
     * @param leaveTo (optional) 
     * @param leaveType (optional) 
     * @return Success
     */
    cancelLeaveRequests(creatdby: number | undefined, fromdate: moment.Moment | undefined, leaveTo: moment.Moment | undefined, leaveType: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/CancelLeaveRequests?";
        if (creatdby === null)
            throw new Error("The parameter 'creatdby' cannot be null.");
        else if (creatdby !== undefined)
            url_ += "creatdby=" + encodeURIComponent("" + creatdby) + "&";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (leaveTo === null)
            throw new Error("The parameter 'leaveTo' cannot be null.");
        else if (leaveTo !== undefined)
            url_ += "LeaveTo=" + encodeURIComponent(leaveTo ? "" + leaveTo.toISOString() : "") + "&";
        if (leaveType === null)
            throw new Error("The parameter 'leaveType' cannot be null.");
        else if (leaveType !== undefined)
            url_ += "leaveType=" + encodeURIComponent("" + leaveType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelLeaveRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelLeaveRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelLeaveRequests(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUpdateDeatils(body: CreateOrEditEmployeeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/CreateUpdateDeatils";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdateDeatils(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdateDeatils(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateUpdateDeatils(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxLeaveTypeIdFilter (optional) 
     * @param minLeaveTypeIdFilter (optional) 
     * @param maxLeaveFromFilter (optional) 
     * @param minLeaveFromFilter (optional) 
     * @param maxLeaveToFilter (optional) 
     * @param minLeaveToFilter (optional) 
     * @param maxLeaveDaysFilter (optional) 
     * @param minLeaveDaysFilter (optional) 
     * @param requestReasonsFilter (optional) 
     * @param leaveStatusFilter (optional) 
     * @param maxCreatedByFilter (optional) 
     * @param minCreatedByFilter (optional) 
     * @param maxCreatedOnFilter (optional) 
     * @param minCreatedOnFilter (optional) 
     * @param maxUpdateByFilter (optional) 
     * @param minUpdateByFilter (optional) 
     * @param maxUpdatedOnFilter (optional) 
     * @param minUpdatedOnFilter (optional) 
     * @param employeeid (optional) 
     * @return Success
     */
    getLeaveRequestsesToExcel(filter: string | null | undefined, maxLeaveTypeIdFilter: number | null | undefined, minLeaveTypeIdFilter: number | null | undefined, maxLeaveFromFilter: moment.Moment | null | undefined, minLeaveFromFilter: moment.Moment | null | undefined, maxLeaveToFilter: moment.Moment | null | undefined, minLeaveToFilter: moment.Moment | null | undefined, maxLeaveDaysFilter: number | null | undefined, minLeaveDaysFilter: number | null | undefined, requestReasonsFilter: string | null | undefined, leaveStatusFilter: string | null | undefined, maxCreatedByFilter: number | null | undefined, minCreatedByFilter: number | null | undefined, maxCreatedOnFilter: moment.Moment | null | undefined, minCreatedOnFilter: moment.Moment | null | undefined, maxUpdateByFilter: number | null | undefined, minUpdateByFilter: number | null | undefined, maxUpdatedOnFilter: moment.Moment | null | undefined, minUpdatedOnFilter: moment.Moment | null | undefined, employeeid: number | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/GetLeaveRequestsesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxLeaveTypeIdFilter !== undefined && maxLeaveTypeIdFilter !== null)
            url_ += "MaxLeaveTypeIdFilter=" + encodeURIComponent("" + maxLeaveTypeIdFilter) + "&";
        if (minLeaveTypeIdFilter !== undefined && minLeaveTypeIdFilter !== null)
            url_ += "MinLeaveTypeIdFilter=" + encodeURIComponent("" + minLeaveTypeIdFilter) + "&";
        if (maxLeaveFromFilter !== undefined && maxLeaveFromFilter !== null)
            url_ += "MaxLeaveFromFilter=" + encodeURIComponent(maxLeaveFromFilter ? "" + maxLeaveFromFilter.toISOString() : "") + "&";
        if (minLeaveFromFilter !== undefined && minLeaveFromFilter !== null)
            url_ += "MinLeaveFromFilter=" + encodeURIComponent(minLeaveFromFilter ? "" + minLeaveFromFilter.toISOString() : "") + "&";
        if (maxLeaveToFilter !== undefined && maxLeaveToFilter !== null)
            url_ += "MaxLeaveToFilter=" + encodeURIComponent(maxLeaveToFilter ? "" + maxLeaveToFilter.toISOString() : "") + "&";
        if (minLeaveToFilter !== undefined && minLeaveToFilter !== null)
            url_ += "MinLeaveToFilter=" + encodeURIComponent(minLeaveToFilter ? "" + minLeaveToFilter.toISOString() : "") + "&";
        if (maxLeaveDaysFilter !== undefined && maxLeaveDaysFilter !== null)
            url_ += "MaxLeaveDaysFilter=" + encodeURIComponent("" + maxLeaveDaysFilter) + "&";
        if (minLeaveDaysFilter !== undefined && minLeaveDaysFilter !== null)
            url_ += "MinLeaveDaysFilter=" + encodeURIComponent("" + minLeaveDaysFilter) + "&";
        if (requestReasonsFilter !== undefined && requestReasonsFilter !== null)
            url_ += "RequestReasonsFilter=" + encodeURIComponent("" + requestReasonsFilter) + "&";
        if (leaveStatusFilter !== undefined && leaveStatusFilter !== null)
            url_ += "LeaveStatusFilter=" + encodeURIComponent("" + leaveStatusFilter) + "&";
        if (maxCreatedByFilter !== undefined && maxCreatedByFilter !== null)
            url_ += "MaxCreatedByFilter=" + encodeURIComponent("" + maxCreatedByFilter) + "&";
        if (minCreatedByFilter !== undefined && minCreatedByFilter !== null)
            url_ += "MinCreatedByFilter=" + encodeURIComponent("" + minCreatedByFilter) + "&";
        if (maxCreatedOnFilter !== undefined && maxCreatedOnFilter !== null)
            url_ += "MaxCreatedOnFilter=" + encodeURIComponent(maxCreatedOnFilter ? "" + maxCreatedOnFilter.toISOString() : "") + "&";
        if (minCreatedOnFilter !== undefined && minCreatedOnFilter !== null)
            url_ += "MinCreatedOnFilter=" + encodeURIComponent(minCreatedOnFilter ? "" + minCreatedOnFilter.toISOString() : "") + "&";
        if (maxUpdateByFilter !== undefined && maxUpdateByFilter !== null)
            url_ += "MaxUpdateByFilter=" + encodeURIComponent("" + maxUpdateByFilter) + "&";
        if (minUpdateByFilter !== undefined && minUpdateByFilter !== null)
            url_ += "MinUpdateByFilter=" + encodeURIComponent("" + minUpdateByFilter) + "&";
        if (maxUpdatedOnFilter !== undefined && maxUpdatedOnFilter !== null)
            url_ += "MaxUpdatedOnFilter=" + encodeURIComponent(maxUpdatedOnFilter ? "" + maxUpdatedOnFilter.toISOString() : "") + "&";
        if (minUpdatedOnFilter !== undefined && minUpdatedOnFilter !== null)
            url_ += "MinUpdatedOnFilter=" + encodeURIComponent(minUpdatedOnFilter ? "" + minUpdatedOnFilter.toISOString() : "") + "&";
        if (employeeid !== undefined && employeeid !== null)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveRequestsesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveRequestsesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetLeaveRequestsesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param leaveType (optional) 
     * @return Success
     */
    getLeaveRequestRules(leaveType: number | undefined): Observable<GetLeaveRuleDateValidation> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/GetLeaveRequestRules?";
        if (leaveType === null)
            throw new Error("The parameter 'leaveType' cannot be null.");
        else if (leaveType !== undefined)
            url_ += "LeaveType=" + encodeURIComponent("" + leaveType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveRequestRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveRequestRules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLeaveRuleDateValidation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLeaveRuleDateValidation>;
        }));
    }

    protected processGetLeaveRequestRules(response: HttpResponseBase): Observable<GetLeaveRuleDateValidation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLeaveRuleDateValidation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLeaveRuleDateValidation>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createLeaveApplicationForMRR(body: CreateOrEditLeaveApplicationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/CreateLeaveApplicationForMRR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLeaveApplicationForMRR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLeaveApplicationForMRR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateLeaveApplicationForMRR(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param month (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllMaualLeave(filter: string | null | undefined, month: number | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetLeaveRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/GetAllMaualLeave?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "Month=" + encodeURIComponent("" + month) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMaualLeave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMaualLeave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetLeaveRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetLeaveRequestDto>;
        }));
    }

    protected processGetAllMaualLeave(response: HttpResponseBase): Observable<PagedResultDtoOfGetLeaveRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetLeaveRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetLeaveRequestDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createManualLeave(body: CreateOrEditManualLeaveDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/CreateManualLeave";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateManualLeave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateManualLeave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateManualLeave(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param leaveType (optional) 
     * @param employeeid (optional) 
     * @return Success
     */
    getLeaveBalanceNew(leaveType: number | undefined, employeeid: number | undefined): Observable<LeaveBlanceDetails[]> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/GetLeaveBalanceNew?";
        if (leaveType === null)
            throw new Error("The parameter 'leaveType' cannot be null.");
        else if (leaveType !== undefined)
            url_ += "LeaveType=" + encodeURIComponent("" + leaveType) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveBalanceNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveBalanceNew(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveBlanceDetails[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveBlanceDetails[]>;
        }));
    }

    protected processGetLeaveBalanceNew(response: HttpResponseBase): Observable<LeaveBlanceDetails[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LeaveBlanceDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveBlanceDetails[]>(null as any);
    }

    /**
     * @param leaveType (optional) 
     * @param employeeid (optional) 
     * @return Success
     */
    getLeaveBalance(leaveType: number | undefined, employeeid: number | undefined): Observable<LeaveBlanceDetails[]> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/GetLeaveBalance?";
        if (leaveType === null)
            throw new Error("The parameter 'leaveType' cannot be null.");
        else if (leaveType !== undefined)
            url_ += "LeaveType=" + encodeURIComponent("" + leaveType) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveBalance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveBalance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveBlanceDetails[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveBlanceDetails[]>;
        }));
    }

    protected processGetLeaveBalance(response: HttpResponseBase): Observable<LeaveBlanceDetails[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LeaveBlanceDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveBlanceDetails[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteManuaLeave(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/DeleteManuaLeave?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteManuaLeave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteManuaLeave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteManuaLeave(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createLeaveRequest(body: CreateLeaveRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/CreateLeaveRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLeaveRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLeaveRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateLeaveRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    getAllLeaveRequest(employeeId: number | undefined): Observable<PagedResultDtoOfGetLeaveRequestsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/GetAllLeaveRequest?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLeaveRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLeaveRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetLeaveRequestsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetLeaveRequestsForEditOutput>;
        }));
    }

    protected processGetAllLeaveRequest(response: HttpResponseBase): Observable<PagedResultDtoOfGetLeaveRequestsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetLeaveRequestsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetLeaveRequestsForEditOutput>(null as any);
    }

    /**
     * @param imageName (optional) 
     * @param imageData (optional) 
     * @return Success
     */
    saveFtbImageServer(imageName: string | null | undefined, imageData: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/SaveFtbImageServer?";
        if (imageName !== undefined && imageName !== null)
            url_ += "ImageName=" + encodeURIComponent("" + imageName) + "&";
        if (imageData !== undefined && imageData !== null)
            url_ += "ImageData=" + encodeURIComponent("" + imageData) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveFtbImageServer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveFtbImageServer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveFtbImageServer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param v (optional) 
     * @param ftpUser (optional) 
     * @param ftpPassword (optional) 
     * @return Success
     */
    checkIfFileExistsOnServer(v: string | null | undefined, ftpUser: string | null | undefined, ftpPassword: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/CheckIfFileExistsOnServer?";
        if (v !== undefined && v !== null)
            url_ += "v=" + encodeURIComponent("" + v) + "&";
        if (ftpUser !== undefined && ftpUser !== null)
            url_ += "ftpUser=" + encodeURIComponent("" + ftpUser) + "&";
        if (ftpPassword !== undefined && ftpPassword !== null)
            url_ += "ftpPassword=" + encodeURIComponent("" + ftpPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfFileExistsOnServer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfFileExistsOnServer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckIfFileExistsOnServer(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param imgName (optional) 
     * @param fileName (optional) 
     * @return Success
     */
    downLoadFileTemplete(imgName: string | null | undefined, fileName: string | null | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/DownLoadFileTemplete?";
        if (imgName !== undefined && imgName !== null)
            url_ += "ImgName=" + encodeURIComponent("" + imgName) + "&";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownLoadFileTemplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownLoadFileTemplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processDownLoadFileTemplete(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @param leaveTypeId (optional) 
     * @return Success
     */
    getLeaveBalanceDetails(employeeId: number | undefined, leaveTypeId: number | undefined): Observable<LeaveBalanceDto> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/GetLeaveBalanceDetails?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (leaveTypeId === null)
            throw new Error("The parameter 'leaveTypeId' cannot be null.");
        else if (leaveTypeId !== undefined)
            url_ += "leaveTypeId=" + encodeURIComponent("" + leaveTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveBalanceDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveBalanceDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveBalanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveBalanceDto>;
        }));
    }

    protected processGetLeaveBalanceDetails(response: HttpResponseBase): Observable<LeaveBalanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeaveBalanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveBalanceDto>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @param leaveTypeId (optional) 
     * @param yearCode (optional) 
     * @return Success
     */
    getSummary(employeeId: number | undefined, leaveTypeId: number | undefined, yearCode: number | undefined): Observable<LeaveBalanceDto> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/GetSummary?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (leaveTypeId === null)
            throw new Error("The parameter 'leaveTypeId' cannot be null.");
        else if (leaveTypeId !== undefined)
            url_ += "leaveTypeId=" + encodeURIComponent("" + leaveTypeId) + "&";
        if (yearCode === null)
            throw new Error("The parameter 'yearCode' cannot be null.");
        else if (yearCode !== undefined)
            url_ += "yearCode=" + encodeURIComponent("" + yearCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveBalanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveBalanceDto>;
        }));
    }

    protected processGetSummary(response: HttpResponseBase): Observable<LeaveBalanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeaveBalanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveBalanceDto>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @param leaveTypeId (optional) 
     * @return Success
     */
    getYearlyLeaveHistory(employeeId: number | undefined, leaveTypeId: number | undefined): Observable<LeaveBalanceYearDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/GetYearlyLeaveHistory?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (leaveTypeId === null)
            throw new Error("The parameter 'leaveTypeId' cannot be null.");
        else if (leaveTypeId !== undefined)
            url_ += "leaveTypeId=" + encodeURIComponent("" + leaveTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetYearlyLeaveHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetYearlyLeaveHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveBalanceYearDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveBalanceYearDto[]>;
        }));
    }

    protected processGetYearlyLeaveHistory(response: HttpResponseBase): Observable<LeaveBalanceYearDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LeaveBalanceYearDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveBalanceYearDto[]>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @param leaveTypeId (optional) 
     * @param desiredBalance (optional) 
     * @param carryForward (optional) 
     * @return Success
     */
    updateLeaveBalance(employeeId: number | undefined, leaveTypeId: number | undefined, desiredBalance: number | undefined, carryForward: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/UpdateLeaveBalance?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (leaveTypeId === null)
            throw new Error("The parameter 'leaveTypeId' cannot be null.");
        else if (leaveTypeId !== undefined)
            url_ += "leaveTypeId=" + encodeURIComponent("" + leaveTypeId) + "&";
        if (desiredBalance === null)
            throw new Error("The parameter 'desiredBalance' cannot be null.");
        else if (desiredBalance !== undefined)
            url_ += "desiredBalance=" + encodeURIComponent("" + desiredBalance) + "&";
        if (carryForward === null)
            throw new Error("The parameter 'carryForward' cannot be null.");
        else if (carryForward !== undefined)
            url_ += "carryForward=" + encodeURIComponent("" + carryForward) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLeaveBalance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLeaveBalance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateLeaveBalance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param referenceDate (optional) 
     * @return Success
     */
    resolveLeaveYear(tenantId: number | undefined, referenceDate: moment.Moment | undefined): Observable<ValueTupleOfDateTimeDateTimeInt32> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRequestses/ResolveLeaveYear?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (referenceDate === null)
            throw new Error("The parameter 'referenceDate' cannot be null.");
        else if (referenceDate !== undefined)
            url_ += "referenceDate=" + encodeURIComponent(referenceDate ? "" + referenceDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveLeaveYear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveLeaveYear(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValueTupleOfDateTimeDateTimeInt32>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValueTupleOfDateTimeDateTimeInt32>;
        }));
    }

    protected processResolveLeaveYear(response: HttpResponseBase): Observable<ValueTupleOfDateTimeDateTimeInt32> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValueTupleOfDateTimeDateTimeInt32.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValueTupleOfDateTimeDateTimeInt32>(null as any);
    }
}

@Injectable()
export class LeaveRulesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetLeaveRuleForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRules/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetLeaveRuleForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetLeaveRuleForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetLeaveRuleForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetLeaveRuleForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetLeaveRuleForViewDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllLeaveType(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetLeaveRuleForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRules/GetAllLeaveType?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLeaveType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLeaveType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetLeaveRuleForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetLeaveRuleForViewDto>;
        }));
    }

    protected processGetAllLeaveType(response: HttpResponseBase): Observable<PagedResultDtoOfGetLeaveRuleForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetLeaveRuleForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetLeaveRuleForViewDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllLeaveWizards(): Observable<GetLeaveRuleForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRules/GetAllLeaveWizards";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLeaveWizards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLeaveWizards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLeaveRuleForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLeaveRuleForViewDto[]>;
        }));
    }

    protected processGetAllLeaveWizards(response: HttpResponseBase): Observable<GetLeaveRuleForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetLeaveRuleForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLeaveRuleForViewDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLeaveRuleForView(id: number | undefined): Observable<GetLeaveRuleForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRules/GetLeaveRuleForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveRuleForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveRuleForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLeaveRuleForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLeaveRuleForViewDto>;
        }));
    }

    protected processGetLeaveRuleForView(response: HttpResponseBase): Observable<GetLeaveRuleForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLeaveRuleForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLeaveRuleForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLeaveRuleForEdit(id: number | undefined): Observable<GetLeaveRuleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRules/GetLeaveRuleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveRuleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveRuleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLeaveRuleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLeaveRuleForEditOutput>;
        }));
    }

    protected processGetLeaveRuleForEdit(response: HttpResponseBase): Observable<GetLeaveRuleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLeaveRuleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLeaveRuleForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditLeaveRuleDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRules/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRules/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    getLeaveRulesToExcel(filter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/LeaveRules/GetLeaveRulesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveRulesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveRulesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetLeaveRulesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class LeaveTypesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param leaveTypeFilter (optional) 
     * @param leaveNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, leaveTypeFilter: string | null | undefined, leaveNameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetLeaveTypesForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/LeaveTypes/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (leaveTypeFilter !== undefined && leaveTypeFilter !== null)
            url_ += "LeaveTypeFilter=" + encodeURIComponent("" + leaveTypeFilter) + "&";
        if (leaveNameFilter !== undefined && leaveNameFilter !== null)
            url_ += "LeaveNameFilter=" + encodeURIComponent("" + leaveNameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetLeaveTypesForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetLeaveTypesForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetLeaveTypesForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetLeaveTypesForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetLeaveTypesForViewDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllLeavetype(): Observable<GetLeaveTypesForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LeaveTypes/GetAllLeavetype";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLeavetype(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLeavetype(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLeaveTypesForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLeaveTypesForViewDto[]>;
        }));
    }

    protected processGetAllLeavetype(response: HttpResponseBase): Observable<GetLeaveTypesForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetLeaveTypesForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLeaveTypesForViewDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllLeavetypeMethod(): Observable<GetLeaveTypesForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LeaveTypes/GetAllLeavetypeMethod";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLeavetypeMethod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLeavetypeMethod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLeaveTypesForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLeaveTypesForViewDto[]>;
        }));
    }

    protected processGetAllLeavetypeMethod(response: HttpResponseBase): Observable<GetLeaveTypesForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetLeaveTypesForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLeaveTypesForViewDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLeaveTypesForView(id: number | undefined): Observable<GetLeaveTypesForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/LeaveTypes/GetLeaveTypesForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveTypesForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveTypesForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLeaveTypesForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLeaveTypesForViewDto>;
        }));
    }

    protected processGetLeaveTypesForView(response: HttpResponseBase): Observable<GetLeaveTypesForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLeaveTypesForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLeaveTypesForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLeaveTypesForEdit(id: number | undefined): Observable<GetLeaveTypesForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/LeaveTypes/GetLeaveTypesForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveTypesForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveTypesForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLeaveTypesForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLeaveTypesForEditOutput>;
        }));
    }

    protected processGetLeaveTypesForEdit(response: HttpResponseBase): Observable<GetLeaveTypesForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLeaveTypesForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLeaveTypesForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditLeaveTypesDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeaveTypes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    isSpecialLeaveType(id: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/LeaveTypes/IsSpecialLeaveType?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsSpecialLeaveType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsSpecialLeaveType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsSpecialLeaveType(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeaveTypes/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteleavrule(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeaveTypes/Deleteleavrule?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteleavrule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteleavrule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteleavrule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteleavRequest(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeaveTypes/DeleteleavRequest?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteleavRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteleavRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteleavRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteleavBalance(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeaveTypes/DeleteleavBalance?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteleavBalance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteleavBalance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteleavBalance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteleavType(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeaveTypes/DeleteleavType?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteleavType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteleavType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteleavType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param leaveTypeFilter (optional) 
     * @param leaveNameFilter (optional) 
     * @return Success
     */
    getLeaveTypesToExcel(filter: string | null | undefined, leaveTypeFilter: string | null | undefined, leaveNameFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/LeaveTypes/GetLeaveTypesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (leaveTypeFilter !== undefined && leaveTypeFilter !== null)
            url_ += "LeaveTypeFilter=" + encodeURIComponent("" + leaveTypeFilter) + "&";
        if (leaveNameFilter !== undefined && leaveNameFilter !== null)
            url_ += "LeaveNameFilter=" + encodeURIComponent("" + leaveNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveTypesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveTypesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetLeaveTypesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createLeaveTypeForMRR(body: CreateOrEditLeaveTypesDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LeaveTypes/CreateLeaveTypeForMRR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLeaveTypeForMRR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLeaveTypeForMRR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateLeaveTypeForMRR(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param leaveTypeId (optional) 
     * @return Success
     */
    editableLeaveType(leaveTypeId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/LeaveTypes/editableLeaveType?";
        if (leaveTypeId === null)
            throw new Error("The parameter 'leaveTypeId' cannot be null.");
        else if (leaveTypeId !== undefined)
            url_ += "leaveTypeId=" + encodeURIComponent("" + leaveTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditableLeaveType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditableLeaveType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processEditableLeaveType(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param leaveTypeId (optional) 
     * @return Success
     */
    editableCompoffLeaveType(leaveTypeId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/LeaveTypes/editableCompoffLeaveType?";
        if (leaveTypeId === null)
            throw new Error("The parameter 'leaveTypeId' cannot be null.");
        else if (leaveTypeId !== undefined)
            url_ += "leaveTypeId=" + encodeURIComponent("" + leaveTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditableCompoffLeaveType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditableCompoffLeaveType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processEditableCompoffLeaveType(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class LocationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getlocationEmployee(): Observable<CurrentlocationEmployeeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Location/GetlocationEmployee";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetlocationEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetlocationEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentlocationEmployeeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentlocationEmployeeDto[]>;
        }));
    }

    protected processGetlocationEmployee(response: HttpResponseBase): Observable<CurrentlocationEmployeeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CurrentlocationEmployeeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrentlocationEmployeeDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getlocation(): Observable<CurrentlocationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Location/Getlocation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetlocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetlocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentlocationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentlocationDto[]>;
        }));
    }

    protected processGetlocation(response: HttpResponseBase): Observable<CurrentlocationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CurrentlocationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrentlocationDto[]>(null as any);
    }

    /**
     * @param employeeid (optional) 
     * @param fromdate (optional) 
     * @param todate (optional) 
     * @return Success
     */
    getlocationmapping(employeeid: number | undefined, fromdate: moment.Moment | undefined, todate: moment.Moment | undefined): Observable<CurrentlocationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Location/Getlocationmapping?";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (todate === null)
            throw new Error("The parameter 'todate' cannot be null.");
        else if (todate !== undefined)
            url_ += "todate=" + encodeURIComponent(todate ? "" + todate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetlocationmapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetlocationmapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentlocationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentlocationDto[]>;
        }));
    }

    protected processGetlocationmapping(response: HttpResponseBase): Observable<CurrentlocationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CurrentlocationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrentlocationDto[]>(null as any);
    }
}

@Injectable()
export class LocationsesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetLocationsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Locationses/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetLocationsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetLocationsForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetLocationsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetLocationsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetLocationsForViewDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllLocation(): Observable<GetLocationsForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Locationses/GetAllLocation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationsForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationsForViewDto[]>;
        }));
    }

    protected processGetAllLocation(response: HttpResponseBase): Observable<GetLocationsForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetLocationsForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationsForViewDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLocationsForView(id: number | undefined): Observable<GetLocationsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Locationses/GetLocationsForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationsForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationsForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationsForViewDto>;
        }));
    }

    protected processGetLocationsForView(response: HttpResponseBase): Observable<GetLocationsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLocationsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationsForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLocationsForEdit(id: number | undefined): Observable<GetLocationsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Locationses/GetLocationsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationsForEditOutput>;
        }));
    }

    protected processGetLocationsForEdit(response: HttpResponseBase): Observable<GetLocationsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLocationsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationsForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditLocationsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Locationses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Locationses/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @return Success
     */
    getLocationsesToExcel(filter: string | null | undefined, nameFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Locationses/GetLocationsesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationsesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationsesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetLocationsesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class ManualBackGroundSchedulerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    executeJob(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ManualBackGroundScheduler/ExecuteJob";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecuteJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecuteJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExecuteJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ManualLeaveAccrualServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAccruals(month: string | null | undefined, year: number | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfManualLeaveAccrualDto> {
        let url_ = this.baseUrl + "/api/services/app/ManualLeaveAccrual/GetAllAccruals?";
        if (month !== undefined && month !== null)
            url_ += "Month=" + encodeURIComponent("" + month) + "&";
        if (year !== undefined && year !== null)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAccruals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAccruals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfManualLeaveAccrualDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfManualLeaveAccrualDto>;
        }));
    }

    protected processGetAllAccruals(response: HttpResponseBase): Observable<PagedResultDtoOfManualLeaveAccrualDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfManualLeaveAccrualDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfManualLeaveAccrualDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getManualLeaveAccrualForEdit(id: number | undefined): Observable<ManualLeaveAccrualDto> {
        let url_ = this.baseUrl + "/api/services/app/ManualLeaveAccrual/GetManualLeaveAccrualForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManualLeaveAccrualForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManualLeaveAccrualForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ManualLeaveAccrualDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ManualLeaveAccrualDto>;
        }));
    }

    protected processGetManualLeaveAccrualForEdit(response: HttpResponseBase): Observable<ManualLeaveAccrualDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ManualLeaveAccrualDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ManualLeaveAccrualDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: ManualLeaveAccrualDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ManualLeaveAccrual/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ManualLeaveAccrual/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class MarkAttendancesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param employeeFirstName (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, employeeFirstName: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetMarkAttendanceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MarkAttendances/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (employeeFirstName !== undefined && employeeFirstName !== null)
            url_ += "EmployeeFirstName=" + encodeURIComponent("" + employeeFirstName) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetMarkAttendanceForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetMarkAttendanceForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetMarkAttendanceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetMarkAttendanceForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetMarkAttendanceForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMarkAttendanceForEdit(id: number | undefined): Observable<GetMarkAttendanceForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MarkAttendances/GetMarkAttendanceForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMarkAttendanceForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMarkAttendanceForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMarkAttendanceForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMarkAttendanceForEditOutput>;
        }));
    }

    protected processGetMarkAttendanceForEdit(response: HttpResponseBase): Observable<GetMarkAttendanceForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMarkAttendanceForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMarkAttendanceForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditMarkAttendanceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarkAttendances/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getDataFromsp(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarkAttendances/GetDataFromsp";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataFromsp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataFromsp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetDataFromsp(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getPocPivotQueue(): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/MarkAttendances/GetPocPivotQueue";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPocPivotQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPocPivotQueue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGetPocPivotQueue(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarkAttendances/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPunchForMRR(body: CreateOrEditMarkAttendanceMRRDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarkAttendances/CreatePunchForMRR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePunchForMRR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePunchForMRR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreatePunchForMRR(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param biometricId (optional) 
     * @return Success
     */
    reprocessPunchByBiometricId(biometricId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarkAttendances/ReprocessPunchByBiometricId?";
        if (biometricId !== undefined && biometricId !== null)
            url_ += "biometricId=" + encodeURIComponent("" + biometricId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReprocessPunchByBiometricId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReprocessPunchByBiometricId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReprocessPunchByBiometricId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    attendancePunchBioMetricAPI(body: CreateOrEditPunchBiometricDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarkAttendances/AttendancePunchBioMetricAPI";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttendancePunchBioMetricAPI(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttendancePunchBioMetricAPI(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAttendancePunchBioMetricAPI(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    attendancePunchPerfettoIdAPI(body: CreateOrEditPerfettoIdDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarkAttendances/AttendancePunchPerfettoIdAPI";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttendancePunchPerfettoIdAPI(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttendancePunchPerfettoIdAPI(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAttendancePunchPerfettoIdAPI(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    fetchAndInsertPunchData(startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/MarkAttendances/FetchAndInsertPunchData?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFetchAndInsertPunchData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFetchAndInsertPunchData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFetchAndInsertPunchData(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param office (optional) 
     * @param uName (optional) 
     * @param pwd (optional) 
     * @return Success
     */
    fetchPunchData(fromDate: string | null | undefined, toDate: string | null | undefined, office: string | null | undefined, uName: string | null | undefined, pwd: string | null | undefined): Observable<MRRDTO[]> {
        let url_ = this.baseUrl + "/api/services/app/MarkAttendances/FetchPunchData?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (office !== undefined && office !== null)
            url_ += "office=" + encodeURIComponent("" + office) + "&";
        if (uName !== undefined && uName !== null)
            url_ += "uName=" + encodeURIComponent("" + uName) + "&";
        if (pwd !== undefined && pwd !== null)
            url_ += "pwd=" + encodeURIComponent("" + pwd) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFetchPunchData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFetchPunchData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MRRDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MRRDTO[]>;
        }));
    }

    protected processFetchPunchData(response: HttpResponseBase): Observable<MRRDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MRRDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MRRDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    punchFailureCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MarkAttendances/PunchFailureCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPunchFailureCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPunchFailureCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processPunchFailureCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    getPunchFailureCounts(): Observable<EmployeePunchFailureCount[]> {
        let url_ = this.baseUrl + "/api/services/app/MarkAttendances/GetPunchFailureCounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPunchFailureCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPunchFailureCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeePunchFailureCount[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeePunchFailureCount[]>;
        }));
    }

    protected processGetPunchFailureCounts(response: HttpResponseBase): Observable<EmployeePunchFailureCount[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeePunchFailureCount.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeePunchFailureCount[]>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    getEmployeePunchFailureCounts(employeeId: string | null | undefined): Observable<EmployeePunchFailureCount[]> {
        let url_ = this.baseUrl + "/api/services/app/MarkAttendances/GetEmployeePunchFailureCounts?";
        if (employeeId !== undefined && employeeId !== null)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeePunchFailureCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeePunchFailureCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeePunchFailureCount[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeePunchFailureCount[]>;
        }));
    }

    protected processGetEmployeePunchFailureCounts(response: HttpResponseBase): Observable<EmployeePunchFailureCount[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeePunchFailureCount.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeePunchFailureCount[]>(null as any);
    }

    /**
     * @return Success
     */
    getPunchFailureForExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MarkAttendances/GetPunchFailureForExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPunchFailureForExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPunchFailureForExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetPunchFailureForExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param employeeId (optional) 
     * @param flag (optional) 
     * @return Success
     */
    punchRepostTool(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, employeeId: number | null | undefined, flag: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarkAttendances/PunchRepostTool?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (employeeId !== undefined && employeeId !== null)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (flag !== undefined && flag !== null)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPunchRepostTool(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPunchRepostTool(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPunchRepostTool(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return Success
     */
    lateComingEarlyGoingDeduction(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarkAttendances/LateComingEarlyGoingDeduction?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLateComingEarlyGoingDeduction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLateComingEarlyGoingDeduction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLateComingEarlyGoingDeduction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param date (optional) 
     * @param employeeId (optional) 
     * @return Success
     */
    createCompOffRequests(date: moment.Moment | undefined, employeeId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarkAttendances/CreateCompOffRequests?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (employeeId !== undefined && employeeId !== null)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCompOffRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCompOffRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateCompOffRequests(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addPunchForMRRAndProcessAttendance(body: AddpunchDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarkAttendances/AddPunchForMRRAndProcessAttendance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPunchForMRRAndProcessAttendance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPunchForMRRAndProcessAttendance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddPunchForMRRAndProcessAttendance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePunchesAndAttendance(body: PunchReportDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarkAttendances/updatePunchesAndAttendance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePunchesAndAttendance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePunchesAndAttendance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePunchesAndAttendance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class MobileAPIServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param empid (optional) 
     * @param status (optional) 
     * @return Success
     */
    getMyTeamData(empid: number | undefined, status: number | undefined): Observable<GetEmployeeForListMyTeamshowdata[]> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/GetMyTeamData?";
        if (empid === null)
            throw new Error("The parameter 'empid' cannot be null.");
        else if (empid !== undefined)
            url_ += "empid=" + encodeURIComponent("" + empid) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyTeamData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyTeamData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmployeeForListMyTeamshowdata[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmployeeForListMyTeamshowdata[]>;
        }));
    }

    protected processGetMyTeamData(response: HttpResponseBase): Observable<GetEmployeeForListMyTeamshowdata[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetEmployeeForListMyTeamshowdata.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeeForListMyTeamshowdata[]>(null as any);
    }

    /**
     * @param empid (optional) 
     * @param year (optional) 
     * @return Success
     */
    getSalaryStatementforEmployee(empid: number | undefined, year: number | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/GetSalaryStatementforEmployee?";
        if (empid === null)
            throw new Error("The parameter 'empid' cannot be null.");
        else if (empid !== undefined)
            url_ += "empid=" + encodeURIComponent("" + empid) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalaryStatementforEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalaryStatementforEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processGetSalaryStatementforEmployee(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditMark(body: CreateOrEditMarkAttendanceMobileDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/CreateOrEditMark";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditMark(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditMark(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditMark(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param employeeId (optional) 
     * @param tenantId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllLeave(filter: string | null | undefined, employeeId: number | undefined, tenantId: number | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetLeaveRequestsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/GetAllLeave?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLeave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLeave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetLeaveRequestsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetLeaveRequestsForEditOutput>;
        }));
    }

    protected processGetAllLeave(response: HttpResponseBase): Observable<PagedResultDtoOfGetLeaveRequestsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetLeaveRequestsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetLeaveRequestsForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteRequest(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/DeleteRequest?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLeaveRequestsForApproval(id: number | undefined): Observable<GetLeaveRequestsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/GetLeaveRequestsForApproval?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveRequestsForApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveRequestsForApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLeaveRequestsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLeaveRequestsForEditOutput>;
        }));
    }

    protected processGetLeaveRequestsForApproval(response: HttpResponseBase): Observable<GetLeaveRequestsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLeaveRequestsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLeaveRequestsForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditLeave(body: CreateOrEditLeaveRequestsMobileDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/CreateOrEditLeave";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditLeave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditLeave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditLeave(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param requestDaysTotal (optional) 
     * @param yearlyTotalLeave (optional) 
     * @param requestCount (optional) 
     * @param body (optional) 
     * @return Success
     */
    asssginLeaveRule(requestDaysTotal: number | undefined, yearlyTotalLeave: number | undefined, requestCount: number | undefined, body: CreateOrEditLeaveRequestsMobileDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/AsssginLeaveRule?";
        if (requestDaysTotal === null)
            throw new Error("The parameter 'requestDaysTotal' cannot be null.");
        else if (requestDaysTotal !== undefined)
            url_ += "RequestDaysTotal=" + encodeURIComponent("" + requestDaysTotal) + "&";
        if (yearlyTotalLeave === null)
            throw new Error("The parameter 'yearlyTotalLeave' cannot be null.");
        else if (yearlyTotalLeave !== undefined)
            url_ += "YearlyTotalLeave=" + encodeURIComponent("" + yearlyTotalLeave) + "&";
        if (requestCount === null)
            throw new Error("The parameter 'requestCount' cannot be null.");
        else if (requestCount !== undefined)
            url_ += "RequestCount=" + encodeURIComponent("" + requestCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAsssginLeaveRule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAsssginLeaveRule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAsssginLeaveRule(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param leaveType (optional) 
     * @param employeeid (optional) 
     * @return Success
     */
    getLeaveBalanceMobile(leaveType: number | undefined, employeeid: number | undefined): Observable<LeaveBlanceDetails[]> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/GetLeaveBalanceMobile?";
        if (leaveType === null)
            throw new Error("The parameter 'leaveType' cannot be null.");
        else if (leaveType !== undefined)
            url_ += "LeaveType=" + encodeURIComponent("" + leaveType) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveBalanceMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveBalanceMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveBlanceDetails[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveBlanceDetails[]>;
        }));
    }

    protected processGetLeaveBalanceMobile(response: HttpResponseBase): Observable<LeaveBlanceDetails[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LeaveBlanceDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveBlanceDetails[]>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @param filter (optional) 
     * @param tenantId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAttendance(employeeId: number | undefined, filter: string | null | undefined, tenantId: number | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAttendanceCorrectionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/GetAllAttendance?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAttendance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAttendance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAttendanceCorrectionForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAttendanceCorrectionForEditOutput>;
        }));
    }

    protected processGetAllAttendance(response: HttpResponseBase): Observable<PagedResultDtoOfGetAttendanceCorrectionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAttendanceCorrectionForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAttendanceCorrectionForEditOutput>(null as any);
    }

    /**
     * @param date (optional) 
     * @param employeeId (optional) 
     * @return Success
     */
    getAttendanceByDate(date: moment.Moment | undefined, employeeId: number | undefined): Observable<CreateOrEditAttendanceCorrectionDto> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/GetAttendanceByDate?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceByDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceByDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditAttendanceCorrectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditAttendanceCorrectionDto>;
        }));
    }

    protected processGetAttendanceByDate(response: HttpResponseBase): Observable<CreateOrEditAttendanceCorrectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditAttendanceCorrectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditAttendanceCorrectionDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAttendanceCorrectionForApproval(id: number | undefined): Observable<GetAttendanceCorrectionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/GetAttendanceCorrectionForApproval?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceCorrectionForApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceCorrectionForApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAttendanceCorrectionForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAttendanceCorrectionForEditOutput>;
        }));
    }

    protected processGetAttendanceCorrectionForApproval(response: HttpResponseBase): Observable<GetAttendanceCorrectionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAttendanceCorrectionForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAttendanceCorrectionForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditAttandnace(body: CreateOrEditAttendanceCorrectionMobileDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/CreateOrEditAttandnace";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditAttandnace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditAttandnace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditAttandnace(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param employeeid (optional) 
     * @return Success
     */
    getAttendanceRuleValidate(employeeid: number | undefined): Observable<GetAttendanceValidationmobile> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/GetAttendanceRuleValidate?";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceRuleValidate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceRuleValidate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAttendanceValidationmobile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAttendanceValidationmobile>;
        }));
    }

    protected processGetAttendanceRuleValidate(response: HttpResponseBase): Observable<GetAttendanceValidationmobile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAttendanceValidationmobile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAttendanceValidationmobile>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @param filter (optional) 
     * @param tenantId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllONDuty(employeeId: number | undefined, filter: string | null | undefined, tenantId: number | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetOnDutyForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/GetAllONDuty?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllONDuty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllONDuty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetOnDutyForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetOnDutyForEditOutput>;
        }));
    }

    protected processGetAllONDuty(response: HttpResponseBase): Observable<PagedResultDtoOfGetOnDutyForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetOnDutyForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetOnDutyForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOnDutyForApproval(id: number | undefined): Observable<GetOnDutyForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/GetOnDutyForApproval?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnDutyForApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnDutyForApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOnDutyForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOnDutyForEditOutput>;
        }));
    }

    protected processGetOnDutyForApproval(response: HttpResponseBase): Observable<GetOnDutyForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOnDutyForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOnDutyForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditOnDuty(body: CreateOrEditOnDutyMobileDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/CreateOrEditOnDuty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditOnDuty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditOnDuty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditOnDuty(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOnDuty(body: CreateOrEditOnDutyMobileDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/CreateOnDuty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOnDuty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOnDuty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOnDuty(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    requestAprovalsByEmployeeId(employeeId: number | undefined): Observable<PagedResultDtoOfGetRequestForApprovalForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/RequestAprovalsByEmployeeId?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestAprovalsByEmployeeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestAprovalsByEmployeeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetRequestForApprovalForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetRequestForApprovalForViewDto>;
        }));
    }

    protected processRequestAprovalsByEmployeeId(response: HttpResponseBase): Observable<PagedResultDtoOfGetRequestForApprovalForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetRequestForApprovalForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRequestForApprovalForViewDto>(null as any);
    }

    /**
     * @param abpuserid (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    requestAprovals(abpuserid: number | undefined, tenantId: number | undefined): Observable<PagedResultDtoOfGetRequestForApprovalForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/RequestAprovals?";
        if (abpuserid === null)
            throw new Error("The parameter 'abpuserid' cannot be null.");
        else if (abpuserid !== undefined)
            url_ += "Abpuserid=" + encodeURIComponent("" + abpuserid) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestAprovals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestAprovals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetRequestForApprovalForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetRequestForApprovalForViewDto>;
        }));
    }

    protected processRequestAprovals(response: HttpResponseBase): Observable<PagedResultDtoOfGetRequestForApprovalForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetRequestForApprovalForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRequestForApprovalForViewDto>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getFullCalenderPanel(employeeId: number | undefined, tenantId: number | undefined): Observable<AttendanceDetailsPanelMobile[]> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/GetFullCalenderPanel?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFullCalenderPanel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFullCalenderPanel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendanceDetailsPanelMobile[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendanceDetailsPanelMobile[]>;
        }));
    }

    protected processGetFullCalenderPanel(response: HttpResponseBase): Observable<AttendanceDetailsPanelMobile[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttendanceDetailsPanelMobile.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AttendanceDetailsPanelMobile[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param remarks (optional) 
     * @param type (optional) 
     * @param employeeId (optional) 
     * @return Success
     */
    approval(id: number | undefined, remarks: string | null | undefined, type: number | undefined, employeeId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/Approval?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (remarks !== undefined && remarks !== null)
            url_ += "remarks=" + encodeURIComponent("" + remarks) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApproval(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param abpUserid (optional) 
     * @return Success
     */
    advanceRequests(abpUserid: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/AdvanceRequests?";
        if (abpUserid === null)
            throw new Error("The parameter 'abpUserid' cannot be null.");
        else if (abpUserid !== undefined)
            url_ += "AbpUserid=" + encodeURIComponent("" + abpUserid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdvanceRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdvanceRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAdvanceRequests(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    advanceRequestsForMobile(employeeId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/AdvanceRequestsForMobile?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdvanceRequestsForMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdvanceRequestsForMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAdvanceRequestsForMobile(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    getAttendancePanelForMobile(employeeId: number | undefined): Observable<AttendanceDetailsPanel[]> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/GetAttendancePanelForMobile?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendancePanelForMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendancePanelForMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendanceDetailsPanel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendanceDetailsPanel[]>;
        }));
    }

    protected processGetAttendancePanelForMobile(response: HttpResponseBase): Observable<AttendanceDetailsPanel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttendanceDetailsPanel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AttendanceDetailsPanel[]>(null as any);
    }

    /**
     * @return Success
     */
    confirmationsPending(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/ConfirmationsPending";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmationsPending(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmationsPending(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processConfirmationsPending(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAdvanceType(body: CreateOrEditAdvanceRequestDtoMobile | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/CreateAdvanceType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAdvanceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAdvanceType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateAdvanceType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param advanceTypeId (optional) 
     * @param employeeId (optional) 
     * @return Success
     */
    getSalaryAdvanceDetails(advanceTypeId: number | undefined, employeeId: number | undefined): Observable<AdvanceValidationDetail> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/GetSalaryAdvanceDetails?";
        if (advanceTypeId === null)
            throw new Error("The parameter 'advanceTypeId' cannot be null.");
        else if (advanceTypeId !== undefined)
            url_ += "advanceTypeId=" + encodeURIComponent("" + advanceTypeId) + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalaryAdvanceDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalaryAdvanceDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdvanceValidationDetail>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdvanceValidationDetail>;
        }));
    }

    protected processGetSalaryAdvanceDetails(response: HttpResponseBase): Observable<AdvanceValidationDetail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdvanceValidationDetail.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdvanceValidationDetail>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param employeeID (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAdvanceMobile(filter: string | null | undefined, employeeID: number | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAdvanceRequestForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/GetAllAdvanceMobile?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (employeeID === null)
            throw new Error("The parameter 'employeeID' cannot be null.");
        else if (employeeID !== undefined)
            url_ += "EmployeeID=" + encodeURIComponent("" + employeeID) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAdvanceMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAdvanceMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAdvanceRequestForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAdvanceRequestForEditOutput>;
        }));
    }

    protected processGetAllAdvanceMobile(response: HttpResponseBase): Observable<PagedResultDtoOfGetAdvanceRequestForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAdvanceRequestForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAdvanceRequestForEditOutput>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getAllAdvanceTypeForTableDropdownType(tenantId: number | undefined): Observable<AdvanceRequestAdvanceTypeLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/GetAllAdvanceTypeForTableDropdownType?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAdvanceTypeForTableDropdownType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAdvanceTypeForTableDropdownType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdvanceRequestAdvanceTypeLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdvanceRequestAdvanceTypeLookupTableDto[]>;
        }));
    }

    protected processGetAllAdvanceTypeForTableDropdownType(response: HttpResponseBase): Observable<AdvanceRequestAdvanceTypeLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdvanceRequestAdvanceTypeLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdvanceRequestAdvanceTypeLookupTableDto[]>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @param empid (optional) 
     * @return Success
     */
    getEmployeeSalaryForMobile(monthYear: string | null | undefined, empid: number | undefined): Observable<SalaryViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/GetEmployeeSalaryForMobile?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "MonthYear=" + encodeURIComponent("" + monthYear) + "&";
        if (empid === null)
            throw new Error("The parameter 'empid' cannot be null.");
        else if (empid !== undefined)
            url_ += "Empid=" + encodeURIComponent("" + empid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeSalaryForMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeSalaryForMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalaryViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalaryViewDto[]>;
        }));
    }

    protected processGetEmployeeSalaryForMobile(response: HttpResponseBase): Observable<SalaryViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalaryViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SalaryViewDto[]>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @param employeeid (optional) 
     * @return Success
     */
    getLeaveDetails(month: number | undefined, year: number | undefined, employeeid: number | undefined): Observable<LeaveBlanceByTypeDetails> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/GetLeaveDetails?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveBlanceByTypeDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveBlanceByTypeDetails>;
        }));
    }

    protected processGetLeaveDetails(response: HttpResponseBase): Observable<LeaveBlanceByTypeDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeaveBlanceByTypeDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveBlanceByTypeDetails>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @param employeeid (optional) 
     * @return Success
     */
    getLeaveDataDashboardMobile(month: number | undefined, year: number | undefined, employeeid: number | undefined): Observable<LeaveBalanceListDashMobile[]> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/GetLeaveDataDashboardMobile?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveDataDashboardMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveDataDashboardMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveBalanceListDashMobile[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveBalanceListDashMobile[]>;
        }));
    }

    protected processGetLeaveDataDashboardMobile(response: HttpResponseBase): Observable<LeaveBalanceListDashMobile[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LeaveBalanceListDashMobile.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveBalanceListDashMobile[]>(null as any);
    }

    /**
     * @param employeeid (optional) 
     * @param tenantid (optional) 
     * @return Success
     */
    getAllHolidayForMobile(employeeid: number | undefined, tenantid: number | undefined): Observable<GetHolidayForViewMobile[]> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/GetAllHolidayForMobile?";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        if (tenantid === null)
            throw new Error("The parameter 'tenantid' cannot be null.");
        else if (tenantid !== undefined)
            url_ += "tenantid=" + encodeURIComponent("" + tenantid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllHolidayForMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllHolidayForMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHolidayForViewMobile[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHolidayForViewMobile[]>;
        }));
    }

    protected processGetAllHolidayForMobile(response: HttpResponseBase): Observable<GetHolidayForViewMobile[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetHolidayForViewMobile.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetHolidayForViewMobile[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param fromdate (optional) 
     * @param todate (optional) 
     * @param employeeFirstNameFilter (optional) 
     * @param employeeid (optional) 
     * @param employeeId (optional) 
     * @return Success
     */
    getAllUserAttandanceForMobile(filter: string | null | undefined, fromdate: moment.Moment | undefined, todate: moment.Moment | undefined, employeeFirstNameFilter: string | null | undefined, employeeid: number | null | undefined, employeeId: number | undefined): Observable<GetAttendanceForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/GetAllUserAttandanceForMobile?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (todate === null)
            throw new Error("The parameter 'todate' cannot be null.");
        else if (todate !== undefined)
            url_ += "Todate=" + encodeURIComponent(todate ? "" + todate.toISOString() : "") + "&";
        if (employeeFirstNameFilter !== undefined && employeeFirstNameFilter !== null)
            url_ += "EmployeeFirstNameFilter=" + encodeURIComponent("" + employeeFirstNameFilter) + "&";
        if (employeeid !== undefined && employeeid !== null)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserAttandanceForMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserAttandanceForMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAttendanceForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAttendanceForViewDto[]>;
        }));
    }

    protected processGetAllUserAttandanceForMobile(response: HttpResponseBase): Observable<GetAttendanceForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAttendanceForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAttendanceForViewDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    visitInorOut(body: EmployeevisitDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/VisitInorOut";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVisitInorOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVisitInorOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVisitInorOut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    startVisitDay(body: VisitDaySummaryDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/StartVisitDay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartVisitDay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartVisitDay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processStartVisitDay(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    visitIn(body: EmployeeVisitInDetailsDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/VisitIn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVisitIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVisitIn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processVisitIn(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateVisitDetails(body: EmployeeVisitDetailsUpdateDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/UpdateVisitDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateVisitDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVisitDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateVisitDetails(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    visitOut(body: EmployeeVisitOutDetailsDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/VisitOut";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVisitOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVisitOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processVisitOut(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    getCurrentyActiveVisit(): Observable<EmployeeCurrentVisitDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/GetCurrentyActiveVisit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentyActiveVisit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentyActiveVisit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeCurrentVisitDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeCurrentVisitDetailsDto>;
        }));
    }

    protected processGetCurrentyActiveVisit(response: HttpResponseBase): Observable<EmployeeCurrentVisitDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeCurrentVisitDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeCurrentVisitDetailsDto>(null as any);
    }

    /**
     * @return Success
     */
    getTodayVisitSummary(): Observable<EmployeeCurrentVisitDetailsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/GetTodayVisitSummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTodayVisitSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTodayVisitSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeCurrentVisitDetailsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeCurrentVisitDetailsDto[]>;
        }));
    }

    protected processGetTodayVisitSummary(response: HttpResponseBase): Observable<EmployeeCurrentVisitDetailsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeCurrentVisitDetailsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeCurrentVisitDetailsDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    endVisitDay(body: VisitDaySummaryEndDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/EndVisitDay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEndVisitDay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEndVisitDay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processEndVisitDay(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param v (optional) 
     * @param ftpUser (optional) 
     * @param ftpPassword (optional) 
     * @return Success
     */
    checkIfFileExistsOnServer(v: string | null | undefined, ftpUser: string | null | undefined, ftpPassword: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/CheckIfFileExistsOnServer?";
        if (v !== undefined && v !== null)
            url_ += "v=" + encodeURIComponent("" + v) + "&";
        if (ftpUser !== undefined && ftpUser !== null)
            url_ += "ftpUser=" + encodeURIComponent("" + ftpUser) + "&";
        if (ftpPassword !== undefined && ftpPassword !== null)
            url_ += "ftpPassword=" + encodeURIComponent("" + ftpPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfFileExistsOnServer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfFileExistsOnServer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckIfFileExistsOnServer(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param iamgeUrl (optional) 
     * @return Success
     */
    saveFtbImageServer(iamgeUrl: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/SaveFtbImageServer?";
        if (iamgeUrl !== undefined && iamgeUrl !== null)
            url_ += "iamgeUrl=" + encodeURIComponent("" + iamgeUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveFtbImageServer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveFtbImageServer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveFtbImageServer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param directoryPath (optional) 
     * @param ftpUser (optional) 
     * @param ftpPassword (optional) 
     * @return Success
     */
    ftpDirectoryExists(directoryPath: string | null | undefined, ftpUser: string | null | undefined, ftpPassword: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MobileAPI/FtpDirectoryExists?";
        if (directoryPath !== undefined && directoryPath !== null)
            url_ += "directoryPath=" + encodeURIComponent("" + directoryPath) + "&";
        if (ftpUser !== undefined && ftpUser !== null)
            url_ += "ftpUser=" + encodeURIComponent("" + ftpUser) + "&";
        if (ftpPassword !== undefined && ftpPassword !== null)
            url_ += "ftpPassword=" + encodeURIComponent("" + ftpPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFtpDirectoryExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFtpDirectoryExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processFtpDirectoryExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class MonthlyESIPdfServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param monthYear (optional) 
     * @return Success
     */
    getMonthlyESIChallan(monthYear: string | null | undefined): Observable<MonthlyPFChallan> {
        let url_ = this.baseUrl + "/api/services/app/MonthlyESIPdf/GetMonthlyESIChallan?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthlyESIChallan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthlyESIChallan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonthlyPFChallan>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonthlyPFChallan>;
        }));
    }

    protected processGetMonthlyESIChallan(response: HttpResponseBase): Observable<MonthlyPFChallan> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonthlyPFChallan.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MonthlyPFChallan>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @return Success
     */
    generatePdfMonthlyESIChallan(monthYear: string | null | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MonthlyESIPdf/GeneratePdfMonthlyESIChallan?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneratePdfMonthlyESIChallan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratePdfMonthlyESIChallan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGeneratePdfMonthlyESIChallan(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }
}

@Injectable()
export class MonthlyPerformanceReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @param locationId (optional) 
     * @param departmentId (optional) 
     * @param empId (optional) 
     * @return Success
     */
    getMonthlyPerformanceReport(month: number | undefined, year: number | undefined, locationId: number | null | undefined, departmentId: number | null | undefined, empId: number | null | undefined): Observable<MonthlyPerformanceReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MonthlyPerformanceReport/GetMonthlyPerformanceReport?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (locationId !== undefined && locationId !== null)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (empId !== undefined && empId !== null)
            url_ += "empId=" + encodeURIComponent("" + empId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthlyPerformanceReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthlyPerformanceReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonthlyPerformanceReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonthlyPerformanceReportDto[]>;
        }));
    }

    protected processGetMonthlyPerformanceReport(response: HttpResponseBase): Observable<MonthlyPerformanceReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MonthlyPerformanceReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MonthlyPerformanceReportDto[]>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @param locationId (optional) 
     * @param departmentId (optional) 
     * @param empId (optional) 
     * @return Success
     */
    attendancedetailsAudit(month: number | undefined, year: number | undefined, locationId: number | null | undefined, departmentId: number | null | undefined, empId: number | null | undefined): Observable<MonthlyPerformanceReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MonthlyPerformanceReport/AttendancedetailsAudit?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (locationId !== undefined && locationId !== null)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (empId !== undefined && empId !== null)
            url_ += "empId=" + encodeURIComponent("" + empId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttendancedetailsAudit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttendancedetailsAudit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonthlyPerformanceReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonthlyPerformanceReportDto[]>;
        }));
    }

    protected processAttendancedetailsAudit(response: HttpResponseBase): Observable<MonthlyPerformanceReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MonthlyPerformanceReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MonthlyPerformanceReportDto[]>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @param locationId (optional) 
     * @param departmentId (optional) 
     * @param empId (optional) 
     * @return Success
     */
    exportMonthlyPerformanceToExcelImageFormat(month: number | undefined, year: number | undefined, locationId: number | null | undefined, departmentId: number | null | undefined, empId: number | null | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MonthlyPerformanceReport/ExportMonthlyPerformanceToExcelImageFormat?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (locationId !== undefined && locationId !== null)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (empId !== undefined && empId !== null)
            url_ += "empId=" + encodeURIComponent("" + empId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportMonthlyPerformanceToExcelImageFormat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportMonthlyPerformanceToExcelImageFormat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processExportMonthlyPerformanceToExcelImageFormat(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @param locationId (optional) 
     * @param departmentId (optional) 
     * @param empId (optional) 
     * @return Success
     */
    attendancedetailsAuditExcel(month: number | undefined, year: number | undefined, locationId: number | null | undefined, departmentId: number | null | undefined, empId: number | null | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MonthlyPerformanceReport/AttendancedetailsAuditExcel?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (locationId !== undefined && locationId !== null)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (empId !== undefined && empId !== null)
            url_ += "empId=" + encodeURIComponent("" + empId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttendancedetailsAuditExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttendancedetailsAuditExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processAttendancedetailsAuditExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @param locationId (optional) 
     * @param departmentId (optional) 
     * @param empId (optional) 
     * @return Success
     */
    getMonthlyTimesheetPerformanceReport(month: number | undefined, year: number | undefined, locationId: number | null | undefined, departmentId: number | null | undefined, empId: number | null | undefined): Observable<MonthlyPerformanceReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MonthlyPerformanceReport/GetMonthlyTimesheetPerformanceReport?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (locationId !== undefined && locationId !== null)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (empId !== undefined && empId !== null)
            url_ += "empId=" + encodeURIComponent("" + empId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthlyTimesheetPerformanceReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthlyTimesheetPerformanceReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonthlyPerformanceReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonthlyPerformanceReportDto[]>;
        }));
    }

    protected processGetMonthlyTimesheetPerformanceReport(response: HttpResponseBase): Observable<MonthlyPerformanceReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MonthlyPerformanceReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MonthlyPerformanceReportDto[]>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @param locationId (optional) 
     * @param departmentId (optional) 
     * @param empId (optional) 
     * @return Success
     */
    exportMonthlyTimesheetToExcel(month: number | undefined, year: number | undefined, locationId: number | null | undefined, departmentId: number | null | undefined, empId: number | null | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MonthlyPerformanceReport/ExportMonthlyTimesheetToExcel?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (locationId !== undefined && locationId !== null)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (empId !== undefined && empId !== null)
            url_ += "empId=" + encodeURIComponent("" + empId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportMonthlyTimesheetToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportMonthlyTimesheetToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processExportMonthlyTimesheetToExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }
}

@Injectable()
export class MonthlyPFpdfServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param monthYear (optional) 
     * @return Success
     */
    getMonthlyPFChallan(monthYear: string | null | undefined): Observable<MonthlyPFChallan> {
        let url_ = this.baseUrl + "/api/services/app/MonthlyPFpdf/GetMonthlyPFChallan?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthlyPFChallan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthlyPFChallan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonthlyPFChallan>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonthlyPFChallan>;
        }));
    }

    protected processGetMonthlyPFChallan(response: HttpResponseBase): Observable<MonthlyPFChallan> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonthlyPFChallan.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MonthlyPFChallan>(null as any);
    }

    /**
     * @param monthYear (optional) 
     * @return Success
     */
    generatePdfMonthlyPFChallan(monthYear: string | null | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MonthlyPFpdf/GeneratePdfMonthlyPFChallan?";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneratePdfMonthlyPFChallan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratePdfMonthlyPFChallan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGeneratePdfMonthlyPFChallan(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }
}

@Injectable()
export class MonthWiseportattandnacesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxEmployeeIdFilter (optional) 
     * @param minEmployeeIdFilter (optional) 
     * @param monthYearFilter (optional) 
     * @param maxAttendanceFilter (optional) 
     * @param minAttendanceFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxEmployeeIdFilter: number | null | undefined, minEmployeeIdFilter: number | null | undefined, monthYearFilter: string | null | undefined, maxAttendanceFilter: number | null | undefined, minAttendanceFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetMonthWiseportattandnaceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MonthWiseportattandnaces/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxEmployeeIdFilter !== undefined && maxEmployeeIdFilter !== null)
            url_ += "MaxEmployeeIdFilter=" + encodeURIComponent("" + maxEmployeeIdFilter) + "&";
        if (minEmployeeIdFilter !== undefined && minEmployeeIdFilter !== null)
            url_ += "MinEmployeeIdFilter=" + encodeURIComponent("" + minEmployeeIdFilter) + "&";
        if (monthYearFilter !== undefined && monthYearFilter !== null)
            url_ += "MonthYearFilter=" + encodeURIComponent("" + monthYearFilter) + "&";
        if (maxAttendanceFilter !== undefined && maxAttendanceFilter !== null)
            url_ += "MaxAttendanceFilter=" + encodeURIComponent("" + maxAttendanceFilter) + "&";
        if (minAttendanceFilter !== undefined && minAttendanceFilter !== null)
            url_ += "MinAttendanceFilter=" + encodeURIComponent("" + minAttendanceFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetMonthWiseportattandnaceForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetMonthWiseportattandnaceForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetMonthWiseportattandnaceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetMonthWiseportattandnaceForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetMonthWiseportattandnaceForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMonthWiseportattandnaceForView(id: number | undefined): Observable<GetMonthWiseportattandnaceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MonthWiseportattandnaces/GetMonthWiseportattandnaceForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthWiseportattandnaceForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthWiseportattandnaceForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMonthWiseportattandnaceForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMonthWiseportattandnaceForViewDto>;
        }));
    }

    protected processGetMonthWiseportattandnaceForView(response: HttpResponseBase): Observable<GetMonthWiseportattandnaceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMonthWiseportattandnaceForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMonthWiseportattandnaceForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMonthWiseportattandnaceForEdit(id: number | undefined): Observable<GetMonthWiseportattandnaceForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MonthWiseportattandnaces/GetMonthWiseportattandnaceForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthWiseportattandnaceForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthWiseportattandnaceForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMonthWiseportattandnaceForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMonthWiseportattandnaceForEditOutput>;
        }));
    }

    protected processGetMonthWiseportattandnaceForEdit(response: HttpResponseBase): Observable<GetMonthWiseportattandnaceForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMonthWiseportattandnaceForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMonthWiseportattandnaceForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditMonthWiseportattandnaceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MonthWiseportattandnaces/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MonthWiseportattandnaces/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxEmployeeIdFilter (optional) 
     * @param minEmployeeIdFilter (optional) 
     * @param monthYearFilter (optional) 
     * @param maxAttendanceFilter (optional) 
     * @param minAttendanceFilter (optional) 
     * @return Success
     */
    getMonthWiseportattandnacesToExcel(filter: string | null | undefined, maxEmployeeIdFilter: number | null | undefined, minEmployeeIdFilter: number | null | undefined, monthYearFilter: string | null | undefined, maxAttendanceFilter: number | null | undefined, minAttendanceFilter: number | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MonthWiseportattandnaces/GetMonthWiseportattandnacesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxEmployeeIdFilter !== undefined && maxEmployeeIdFilter !== null)
            url_ += "MaxEmployeeIdFilter=" + encodeURIComponent("" + maxEmployeeIdFilter) + "&";
        if (minEmployeeIdFilter !== undefined && minEmployeeIdFilter !== null)
            url_ += "MinEmployeeIdFilter=" + encodeURIComponent("" + minEmployeeIdFilter) + "&";
        if (monthYearFilter !== undefined && monthYearFilter !== null)
            url_ += "MonthYearFilter=" + encodeURIComponent("" + monthYearFilter) + "&";
        if (maxAttendanceFilter !== undefined && maxAttendanceFilter !== null)
            url_ += "MaxAttendanceFilter=" + encodeURIComponent("" + maxAttendanceFilter) + "&";
        if (minAttendanceFilter !== undefined && minAttendanceFilter !== null)
            url_ += "MinAttendanceFilter=" + encodeURIComponent("" + minAttendanceFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthWiseportattandnacesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthWiseportattandnacesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetMonthWiseportattandnacesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    syncMonthPortedSheet(body: MonthWisportedAttendance | undefined): Observable<MonthportAlreadyExits[]> {
        let url_ = this.baseUrl + "/api/services/app/MonthWiseportattandnaces/SyncMonthPortedSheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncMonthPortedSheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncMonthPortedSheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonthportAlreadyExits[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonthportAlreadyExits[]>;
        }));
    }

    protected processSyncMonthPortedSheet(response: HttpResponseBase): Observable<MonthportAlreadyExits[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MonthportAlreadyExits.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MonthportAlreadyExits[]>(null as any);
    }
}

@Injectable()
export class MyTeamServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getPunchDataNotIn(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetEmployeeForList> {
        let url_ = this.baseUrl + "/api/services/app/MyTeam/GetPunchDataNotIn?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPunchDataNotIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPunchDataNotIn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetEmployeeForList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetEmployeeForList>;
        }));
    }

    protected processGetPunchDataNotIn(response: HttpResponseBase): Observable<PagedResultDtoOfGetEmployeeForList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEmployeeForList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEmployeeForList>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getLeaveTodays(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetLeaveTodayList> {
        let url_ = this.baseUrl + "/api/services/app/MyTeam/GetLeaveTodays?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveTodays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveTodays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetLeaveTodayList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetLeaveTodayList>;
        }));
    }

    protected processGetLeaveTodays(response: HttpResponseBase): Observable<PagedResultDtoOfGetLeaveTodayList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetLeaveTodayList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetLeaveTodayList>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getLateCommers(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetLateEmployeeList> {
        let url_ = this.baseUrl + "/api/services/app/MyTeam/GetLateCommers?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLateCommers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLateCommers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetLateEmployeeList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetLateEmployeeList>;
        }));
    }

    protected processGetLateCommers(response: HttpResponseBase): Observable<PagedResultDtoOfGetLateEmployeeList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetLateEmployeeList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetLateEmployeeList>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getTeamMemebers(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTeamMemberList> {
        let url_ = this.baseUrl + "/api/services/app/MyTeam/GetTeamMemebers?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeamMemebers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeamMemebers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTeamMemberList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTeamMemberList>;
        }));
    }

    protected processGetTeamMemebers(response: HttpResponseBase): Observable<PagedResultDtoOfGetTeamMemberList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTeamMemberList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTeamMemberList>(null as any);
    }
}

@Injectable()
export class NationalitiesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetNationalityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Nationalities/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetNationalityForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetNationalityForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetNationalityForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetNationalityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetNationalityForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getNationalityForView(id: number | undefined): Observable<GetNationalityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Nationalities/GetNationalityForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNationalityForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNationalityForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNationalityForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNationalityForViewDto>;
        }));
    }

    protected processGetNationalityForView(response: HttpResponseBase): Observable<GetNationalityForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNationalityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNationalityForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getNationalityForEdit(id: number | undefined): Observable<GetNationalityForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Nationalities/GetNationalityForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNationalityForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNationalityForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNationalityForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNationalityForEditOutput>;
        }));
    }

    protected processGetNationalityForEdit(response: HttpResponseBase): Observable<GetNationalityForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNationalityForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNationalityForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditNationalityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Nationalities/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Nationalities/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @return Success
     */
    getNationalitiesToExcel(filter: string | null | undefined, nameFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Nationalities/GetNationalitiesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNationalitiesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNationalitiesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetNationalitiesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class NotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param state (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getUserNotifications(state: UserNotificationState | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetNotificationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetUserNotifications?";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNotificationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNotificationsOutput>;
        }));
    }

    protected processGetUserNotifications(response: HttpResponseBase): Observable<GetNotificationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotificationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNotificationsOutput>(null as any);
    }

    /**
     * @return Success
     */
    setAllNotificationsAsRead(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetAllNotificationsAsRead";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAllNotificationsAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAllNotificationsAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAllNotificationsAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setNotificationAsRead(body: EntityDtoOfGuid | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetNotificationAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNotificationAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNotificationAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetNotificationAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getNotificationSettings(): Observable<GetNotificationSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNotificationSettingsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNotificationSettingsOutput>;
        }));
    }

    protected processGetNotificationSettings(response: HttpResponseBase): Observable<GetNotificationSettingsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotificationSettingsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNotificationSettingsOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateNotificationSettings(body: UpdateNotificationSettingsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/UpdateNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNotificationSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteNotification(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/DeleteNotification?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class OffersTempletesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param documentUrlFilter (optional) 
     * @param maxDocumentTypeIdFilter (optional) 
     * @param minDocumentTypeIdFilter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, documentUrlFilter: string | null | undefined, maxDocumentTypeIdFilter: number | null | undefined, minDocumentTypeIdFilter: number | null | undefined, statusFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetOffersTempleteForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/OffersTempletes/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (documentUrlFilter !== undefined && documentUrlFilter !== null)
            url_ += "DocumentUrlFilter=" + encodeURIComponent("" + documentUrlFilter) + "&";
        if (maxDocumentTypeIdFilter !== undefined && maxDocumentTypeIdFilter !== null)
            url_ += "MaxDocumentTypeIdFilter=" + encodeURIComponent("" + maxDocumentTypeIdFilter) + "&";
        if (minDocumentTypeIdFilter !== undefined && minDocumentTypeIdFilter !== null)
            url_ += "MinDocumentTypeIdFilter=" + encodeURIComponent("" + minDocumentTypeIdFilter) + "&";
        if (statusFilter !== undefined && statusFilter !== null)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetOffersTempleteForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetOffersTempleteForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetOffersTempleteForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetOffersTempleteForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetOffersTempleteForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOffersTempleteForView(id: number | undefined): Observable<GetOffersTempleteForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/OffersTempletes/GetOffersTempleteForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOffersTempleteForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOffersTempleteForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOffersTempleteForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOffersTempleteForViewDto>;
        }));
    }

    protected processGetOffersTempleteForView(response: HttpResponseBase): Observable<GetOffersTempleteForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOffersTempleteForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOffersTempleteForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOffersTempleteForEdit(id: number | undefined): Observable<GetOffersTempleteForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/OffersTempletes/GetOffersTempleteForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOffersTempleteForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOffersTempleteForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOffersTempleteForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOffersTempleteForEditOutput>;
        }));
    }

    protected processGetOffersTempleteForEdit(response: HttpResponseBase): Observable<GetOffersTempleteForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOffersTempleteForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOffersTempleteForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditOffersTempleteDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OffersTempletes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OffersTempletes/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param documentUrlFilter (optional) 
     * @param maxDocumentTypeIdFilter (optional) 
     * @param minDocumentTypeIdFilter (optional) 
     * @param statusFilter (optional) 
     * @return Success
     */
    getOffersTempletesToExcel(filter: string | null | undefined, nameFilter: string | null | undefined, documentUrlFilter: string | null | undefined, maxDocumentTypeIdFilter: number | null | undefined, minDocumentTypeIdFilter: number | null | undefined, statusFilter: number | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/OffersTempletes/GetOffersTempletesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (documentUrlFilter !== undefined && documentUrlFilter !== null)
            url_ += "DocumentUrlFilter=" + encodeURIComponent("" + documentUrlFilter) + "&";
        if (maxDocumentTypeIdFilter !== undefined && maxDocumentTypeIdFilter !== null)
            url_ += "MaxDocumentTypeIdFilter=" + encodeURIComponent("" + maxDocumentTypeIdFilter) + "&";
        if (minDocumentTypeIdFilter !== undefined && minDocumentTypeIdFilter !== null)
            url_ += "MinDocumentTypeIdFilter=" + encodeURIComponent("" + minDocumentTypeIdFilter) + "&";
        if (statusFilter !== undefined && statusFilter !== null)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOffersTempletesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOffersTempletesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetOffersTempletesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param directoryPath (optional) 
     * @param ftpUser (optional) 
     * @param ftpPassword (optional) 
     * @return Success
     */
    ftpDirectoryExists(directoryPath: string | null | undefined, ftpUser: string | null | undefined, ftpPassword: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/OffersTempletes/FtpDirectoryExists?";
        if (directoryPath !== undefined && directoryPath !== null)
            url_ += "directoryPath=" + encodeURIComponent("" + directoryPath) + "&";
        if (ftpUser !== undefined && ftpUser !== null)
            url_ += "ftpUser=" + encodeURIComponent("" + ftpUser) + "&";
        if (ftpPassword !== undefined && ftpPassword !== null)
            url_ += "ftpPassword=" + encodeURIComponent("" + ftpPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFtpDirectoryExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFtpDirectoryExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processFtpDirectoryExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveFtbServermailTemplete(body: FtbImage | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/OffersTempletes/SaveFtbServermailTemplete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveFtbServermailTemplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveFtbServermailTemplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveFtbServermailTemplete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param imgName (optional) 
     * @param documentType (optional) 
     * @param branchId (optional) 
     * @return Success
     */
    downLoadFileEmailTemplete(imgName: string | null | undefined, documentType: string | null | undefined, branchId: number | null | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OffersTempletes/DownLoadFileEmailTemplete?";
        if (imgName !== undefined && imgName !== null)
            url_ += "ImgName=" + encodeURIComponent("" + imgName) + "&";
        if (documentType !== undefined && documentType !== null)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        if (branchId !== undefined && branchId !== null)
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownLoadFileEmailTemplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownLoadFileEmailTemplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processDownLoadFileEmailTemplete(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param documenttypeid (optional) 
     * @param branchId (optional) 
     * @return Success
     */
    downLoadFileTemplete(documenttypeid: number | undefined, branchId: number | null | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OffersTempletes/DownLoadFileTemplete?";
        if (documenttypeid === null)
            throw new Error("The parameter 'documenttypeid' cannot be null.");
        else if (documenttypeid !== undefined)
            url_ += "documenttypeid=" + encodeURIComponent("" + documenttypeid) + "&";
        if (branchId !== undefined && branchId !== null)
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownLoadFileTemplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownLoadFileTemplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processDownLoadFileTemplete(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllUploadedTemplates(): Observable<UploadedOfferTemplateDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OffersTempletes/GetAllUploadedTemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUploadedTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUploadedTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadedOfferTemplateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadedOfferTemplateDto[]>;
        }));
    }

    protected processGetAllUploadedTemplates(response: HttpResponseBase): Observable<UploadedOfferTemplateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UploadedOfferTemplateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadedOfferTemplateDto[]>(null as any);
    }
}

@Injectable()
export class OndutiesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxAttendanceDateFilter (optional) 
     * @param minAttendanceDateFilter (optional) 
     * @param reasonFilter (optional) 
     * @param maxInTimeFilter (optional) 
     * @param minInTimeFilter (optional) 
     * @param maxOutTimeFilter (optional) 
     * @param minOutTimeFilter (optional) 
     * @param remarksFilter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxAttendanceDateFilter: moment.Moment | null | undefined, minAttendanceDateFilter: moment.Moment | null | undefined, reasonFilter: string | null | undefined, maxInTimeFilter: moment.Moment | null | undefined, minInTimeFilter: moment.Moment | null | undefined, maxOutTimeFilter: moment.Moment | null | undefined, minOutTimeFilter: moment.Moment | null | undefined, remarksFilter: string | null | undefined, statusFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetOndutyForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Onduties/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxAttendanceDateFilter !== undefined && maxAttendanceDateFilter !== null)
            url_ += "MaxAttendanceDateFilter=" + encodeURIComponent(maxAttendanceDateFilter ? "" + maxAttendanceDateFilter.toISOString() : "") + "&";
        if (minAttendanceDateFilter !== undefined && minAttendanceDateFilter !== null)
            url_ += "MinAttendanceDateFilter=" + encodeURIComponent(minAttendanceDateFilter ? "" + minAttendanceDateFilter.toISOString() : "") + "&";
        if (reasonFilter !== undefined && reasonFilter !== null)
            url_ += "ReasonFilter=" + encodeURIComponent("" + reasonFilter) + "&";
        if (maxInTimeFilter !== undefined && maxInTimeFilter !== null)
            url_ += "MaxInTimeFilter=" + encodeURIComponent(maxInTimeFilter ? "" + maxInTimeFilter.toISOString() : "") + "&";
        if (minInTimeFilter !== undefined && minInTimeFilter !== null)
            url_ += "MinInTimeFilter=" + encodeURIComponent(minInTimeFilter ? "" + minInTimeFilter.toISOString() : "") + "&";
        if (maxOutTimeFilter !== undefined && maxOutTimeFilter !== null)
            url_ += "MaxOutTimeFilter=" + encodeURIComponent(maxOutTimeFilter ? "" + maxOutTimeFilter.toISOString() : "") + "&";
        if (minOutTimeFilter !== undefined && minOutTimeFilter !== null)
            url_ += "MinOutTimeFilter=" + encodeURIComponent(minOutTimeFilter ? "" + minOutTimeFilter.toISOString() : "") + "&";
        if (remarksFilter !== undefined && remarksFilter !== null)
            url_ += "RemarksFilter=" + encodeURIComponent("" + remarksFilter) + "&";
        if (statusFilter !== undefined && statusFilter !== null)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetOndutyForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetOndutyForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetOndutyForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetOndutyForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetOndutyForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOndutyForEdit(id: number | undefined): Observable<GetOndutyForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Onduties/GetOndutyForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOndutyForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOndutyForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOndutyForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOndutyForEditOutput>;
        }));
    }

    protected processGetOndutyForEdit(response: HttpResponseBase): Observable<GetOndutyForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOndutyForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOndutyForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditOndutyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Onduties/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Onduties/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class OnDutyTypesAppServicesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllONDutyType(filter: string | null | undefined, nameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetOnDutyTypesForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/OnDutyTypesAppServices/GetAllONDutyType?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllONDutyType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllONDutyType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetOnDutyTypesForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetOnDutyTypesForViewDto>;
        }));
    }

    protected processGetAllONDutyType(response: HttpResponseBase): Observable<PagedResultDtoOfGetOnDutyTypesForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetOnDutyTypesForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetOnDutyTypesForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOnDutyTypesForView(id: number | undefined): Observable<GetOnDutyTypesForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/OnDutyTypesAppServices/GetOnDutyTypesForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnDutyTypesForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnDutyTypesForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOnDutyTypesForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOnDutyTypesForViewDto>;
        }));
    }

    protected processGetOnDutyTypesForView(response: HttpResponseBase): Observable<GetOnDutyTypesForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOnDutyTypesForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOnDutyTypesForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOnDutyTypesForEdit(id: number | undefined): Observable<GetOnDutyTypesForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/OnDutyTypesAppServices/GetOnDutyTypesForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnDutyTypesForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnDutyTypesForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOnDutyTypesForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOnDutyTypesForEditOutput>;
        }));
    }

    protected processGetOnDutyTypesForEdit(response: HttpResponseBase): Observable<GetOnDutyTypesForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOnDutyTypesForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOnDutyTypesForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditOnDutyTypesDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OnDutyTypesAppServices/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OnDutyTypesAppServices/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class OrganisationalChartServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getOrganisationalChart(): Observable<OrganizationalChartDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganisationalChart/GetOrganisationalChart";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganisationalChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganisationalChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationalChartDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationalChartDto[]>;
        }));
    }

    protected processGetOrganisationalChart(response: HttpResponseBase): Observable<OrganizationalChartDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationalChartDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationalChartDto[]>(null as any);
    }

    /**
     * @return Success
     */
    downloadOrganisationalChartPdf(): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganisationalChart/DownloadOrganisationalChartPdf";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadOrganisationalChartPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadOrganisationalChartPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processDownloadOrganisationalChartPdf(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }
}

@Injectable()
export class OrganizationUnitServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getOrganizationUnits(): Observable<ListResultDtoOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnits";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfOrganizationUnitDto>;
        }));
    }

    protected processGetOrganizationUnits(response: HttpResponseBase): Observable<ListResultDtoOfOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfOrganizationUnitDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getOrganizationUnitUsers(id: number | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitUsers?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrganizationUnitUserListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrganizationUnitUserListDto>;
        }));
    }

    protected processGetOrganizationUnitUsers(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrganizationUnitUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfOrganizationUnitUserListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getOrganizationUnitRoles(id: number | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfOrganizationUnitRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitRoles?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrganizationUnitRoleListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrganizationUnitRoleListDto>;
        }));
    }

    protected processGetOrganizationUnitRoles(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitRoleListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrganizationUnitRoleListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfOrganizationUnitRoleListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrganizationUnit(body: CreateOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/CreateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processCreateOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationUnitDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateOrganizationUnit(body: UpdateOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/UpdateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processUpdateOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationUnitDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveOrganizationUnit(body: MoveOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/MoveOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processMoveOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationUnitDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteOrganizationUnit(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/DeleteOrganizationUnit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param organizationUnitId (optional) 
     * @return Success
     */
    removeUserFromOrganizationUnit(userId: number | undefined, organizationUnitId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveUserFromOrganizationUnit?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUserFromOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserFromOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveUserFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param roleId (optional) 
     * @param organizationUnitId (optional) 
     * @return Success
     */
    removeRoleFromOrganizationUnit(roleId: number | undefined, organizationUnitId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveRoleFromOrganizationUnit?";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveRoleFromOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveRoleFromOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveRoleFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addUsersToOrganizationUnit(body: UsersToOrganizationUnitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddUsersToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUsersToOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUsersToOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddUsersToOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addRolesToOrganizationUnit(body: RolesToOrganizationUnitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddRolesToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRolesToOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRolesToOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddRolesToOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findUsers(body: FindOrganizationUnitUsersInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
        }));
    }

    protected processFindUsers(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNameValueDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findRoles(body: FindOrganizationUnitRolesInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
        }));
    }

    protected processFindRoles(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNameValueDto>(null as any);
    }
}

@Injectable()
export class OvertTimeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getEmployees(body: GetEmployeeParameterDto | undefined): Observable<PagedResultDtoOfGetEmployeeListDto> {
        let url_ = this.baseUrl + "/api/services/app/OvertTime/GetEmployees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployees(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetEmployeeListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetEmployeeListDto>;
        }));
    }

    protected processGetEmployees(response: HttpResponseBase): Observable<PagedResultDtoOfGetEmployeeListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEmployeeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEmployeeListDto>(null as any);
    }

    /**
     * @param otApplicable (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateOverTimeEligablity(otApplicable: boolean | undefined, body: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OvertTime/UpdateOverTimeEligablity?";
        if (otApplicable === null)
            throw new Error("The parameter 'otApplicable' cannot be null.");
        else if (otApplicable !== undefined)
            url_ += "otApplicable=" + encodeURIComponent("" + otApplicable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOverTimeEligablity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOverTimeEligablity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOverTimeEligablity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class PayablesFnFServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param employeeid (optional) 
     * @return Success
     */
    getPayables(employeeid: number | undefined): Observable<ValueTupleOfListOfGetPayablesInt32> {
        let url_ = this.baseUrl + "/api/services/app/PayablesFnF/GetPayables?";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayables(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayables(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValueTupleOfListOfGetPayablesInt32>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValueTupleOfListOfGetPayablesInt32>;
        }));
    }

    protected processGetPayables(response: HttpResponseBase): Observable<ValueTupleOfListOfGetPayablesInt32> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValueTupleOfListOfGetPayablesInt32.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValueTupleOfListOfGetPayablesInt32>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    save(body: PayDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PayablesFnF/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class PayComponetsesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPayComponetsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PayComponetses/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetPayComponetsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetPayComponetsForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPayComponetsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPayComponetsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPayComponetsForViewDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllPaycomponetWizards(): Observable<GetPayComponetsForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PayComponetses/GetAllPaycomponetWizards";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaycomponetWizards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaycomponetWizards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPayComponetsForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPayComponetsForViewDto[]>;
        }));
    }

    protected processGetAllPaycomponetWizards(response: HttpResponseBase): Observable<GetPayComponetsForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetPayComponetsForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPayComponetsForViewDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPayComponetsForView(id: number | undefined): Observable<GetPayComponetsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PayComponetses/GetPayComponetsForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayComponetsForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayComponetsForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPayComponetsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPayComponetsForViewDto>;
        }));
    }

    protected processGetPayComponetsForView(response: HttpResponseBase): Observable<GetPayComponetsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPayComponetsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPayComponetsForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPayComponetsForEdit(id: number | undefined): Observable<GetPayComponetsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/PayComponetses/GetPayComponetsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayComponetsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayComponetsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPayComponetsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPayComponetsForEditOutput>;
        }));
    }

    protected processGetPayComponetsForEdit(response: HttpResponseBase): Observable<GetPayComponetsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPayComponetsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPayComponetsForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditPayComponetsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PayComponetses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PayComponetses/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @return Success
     */
    getPayComponetsesToExcel(filter: string | null | undefined, nameFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PayComponetses/GetPayComponetsesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayComponetsesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayComponetsesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetPayComponetsesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeExpenseAccountsDropdown(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/PayComponetses/GetEmployeeExpenseAccountsDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeExpenseAccountsDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeExpenseAccountsDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetEmployeeExpenseAccountsDropdown(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }
}

@Injectable()
export class PayGradeDetailsesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param calculationTypeFilter (optional) 
     * @param formulaStringFilter (optional) 
     * @param maxAmountFilter (optional) 
     * @param minAmountFilter (optional) 
     * @param maxSequenceFilter (optional) 
     * @param minSequenceFilter (optional) 
     * @param payGradeNameFilter (optional) 
     * @param payComponetsNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, calculationTypeFilter: string | null | undefined, formulaStringFilter: string | null | undefined, maxAmountFilter: number | null | undefined, minAmountFilter: number | null | undefined, maxSequenceFilter: number | null | undefined, minSequenceFilter: number | null | undefined, payGradeNameFilter: string | null | undefined, payComponetsNameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPayGradeDetailsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PayGradeDetailses/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (calculationTypeFilter !== undefined && calculationTypeFilter !== null)
            url_ += "CalculationTypeFilter=" + encodeURIComponent("" + calculationTypeFilter) + "&";
        if (formulaStringFilter !== undefined && formulaStringFilter !== null)
            url_ += "FormulaStringFilter=" + encodeURIComponent("" + formulaStringFilter) + "&";
        if (maxAmountFilter !== undefined && maxAmountFilter !== null)
            url_ += "MaxAmountFilter=" + encodeURIComponent("" + maxAmountFilter) + "&";
        if (minAmountFilter !== undefined && minAmountFilter !== null)
            url_ += "MinAmountFilter=" + encodeURIComponent("" + minAmountFilter) + "&";
        if (maxSequenceFilter !== undefined && maxSequenceFilter !== null)
            url_ += "MaxSequenceFilter=" + encodeURIComponent("" + maxSequenceFilter) + "&";
        if (minSequenceFilter !== undefined && minSequenceFilter !== null)
            url_ += "MinSequenceFilter=" + encodeURIComponent("" + minSequenceFilter) + "&";
        if (payGradeNameFilter !== undefined && payGradeNameFilter !== null)
            url_ += "PayGradeNameFilter=" + encodeURIComponent("" + payGradeNameFilter) + "&";
        if (payComponetsNameFilter !== undefined && payComponetsNameFilter !== null)
            url_ += "PayComponetsNameFilter=" + encodeURIComponent("" + payComponetsNameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetPayGradeDetailsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetPayGradeDetailsForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPayGradeDetailsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPayGradeDetailsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPayGradeDetailsForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPayGradeDetailsForView(id: number | undefined): Observable<GetPayGradeDetailsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PayGradeDetailses/GetPayGradeDetailsForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayGradeDetailsForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayGradeDetailsForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPayGradeDetailsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPayGradeDetailsForViewDto>;
        }));
    }

    protected processGetPayGradeDetailsForView(response: HttpResponseBase): Observable<GetPayGradeDetailsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPayGradeDetailsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPayGradeDetailsForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPayGradeDetailsForEdit(id: number | undefined): Observable<CreateOrEditPayGradeDto> {
        let url_ = this.baseUrl + "/api/services/app/PayGradeDetailses/GetPayGradeDetailsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayGradeDetailsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayGradeDetailsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditPayGradeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditPayGradeDto>;
        }));
    }

    protected processGetPayGradeDetailsForEdit(response: HttpResponseBase): Observable<CreateOrEditPayGradeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditPayGradeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditPayGradeDto>(null as any);
    }

    /**
     * @param payGradeId (optional) 
     * @param payComponentId (optional) 
     * @return Success
     */
    payComponentSetValue(payGradeId: number | undefined, payComponentId: number | undefined): Observable<CreateOrEditPayGradeDto> {
        let url_ = this.baseUrl + "/api/services/app/PayGradeDetailses/PayComponentSetValue?";
        if (payGradeId === null)
            throw new Error("The parameter 'payGradeId' cannot be null.");
        else if (payGradeId !== undefined)
            url_ += "payGradeId=" + encodeURIComponent("" + payGradeId) + "&";
        if (payComponentId === null)
            throw new Error("The parameter 'payComponentId' cannot be null.");
        else if (payComponentId !== undefined)
            url_ += "payComponentId=" + encodeURIComponent("" + payComponentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPayComponentSetValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayComponentSetValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditPayGradeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditPayGradeDto>;
        }));
    }

    protected processPayComponentSetValue(response: HttpResponseBase): Observable<CreateOrEditPayGradeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditPayGradeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditPayGradeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditPayGradeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PayGradeDetailses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PayGradeDetailses/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param calculationTypeFilter (optional) 
     * @param formulaStringFilter (optional) 
     * @param maxAmountFilter (optional) 
     * @param minAmountFilter (optional) 
     * @param maxSequenceFilter (optional) 
     * @param minSequenceFilter (optional) 
     * @param payGradeNameFilter (optional) 
     * @param payComponetsNameFilter (optional) 
     * @return Success
     */
    getPayGradeDetailsesToExcel(filter: string | null | undefined, calculationTypeFilter: string | null | undefined, formulaStringFilter: string | null | undefined, maxAmountFilter: number | null | undefined, minAmountFilter: number | null | undefined, maxSequenceFilter: number | null | undefined, minSequenceFilter: number | null | undefined, payGradeNameFilter: string | null | undefined, payComponetsNameFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PayGradeDetailses/GetPayGradeDetailsesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (calculationTypeFilter !== undefined && calculationTypeFilter !== null)
            url_ += "CalculationTypeFilter=" + encodeURIComponent("" + calculationTypeFilter) + "&";
        if (formulaStringFilter !== undefined && formulaStringFilter !== null)
            url_ += "FormulaStringFilter=" + encodeURIComponent("" + formulaStringFilter) + "&";
        if (maxAmountFilter !== undefined && maxAmountFilter !== null)
            url_ += "MaxAmountFilter=" + encodeURIComponent("" + maxAmountFilter) + "&";
        if (minAmountFilter !== undefined && minAmountFilter !== null)
            url_ += "MinAmountFilter=" + encodeURIComponent("" + minAmountFilter) + "&";
        if (maxSequenceFilter !== undefined && maxSequenceFilter !== null)
            url_ += "MaxSequenceFilter=" + encodeURIComponent("" + maxSequenceFilter) + "&";
        if (minSequenceFilter !== undefined && minSequenceFilter !== null)
            url_ += "MinSequenceFilter=" + encodeURIComponent("" + minSequenceFilter) + "&";
        if (payGradeNameFilter !== undefined && payGradeNameFilter !== null)
            url_ += "PayGradeNameFilter=" + encodeURIComponent("" + payGradeNameFilter) + "&";
        if (payComponetsNameFilter !== undefined && payComponetsNameFilter !== null)
            url_ += "PayComponetsNameFilter=" + encodeURIComponent("" + payComponetsNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayGradeDetailsesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayGradeDetailsesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetPayGradeDetailsesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class PayGradesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, descriptionFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPayGradeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PayGrades/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (descriptionFilter !== undefined && descriptionFilter !== null)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetPayGradeForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetPayGradeForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPayGradeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPayGradeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPayGradeForViewDto>(null as any);
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    getAllView(name: string | null | undefined): Observable<PagedResultDtoOfGetPayGradeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PayGrades/GetAllView?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetPayGradeForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetPayGradeForViewDto>;
        }));
    }

    protected processGetAllView(response: HttpResponseBase): Observable<PagedResultDtoOfGetPayGradeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPayGradeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPayGradeForViewDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllPaygradedetails(): Observable<GetPayGradeForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PayGrades/GetAllPaygradedetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaygradedetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaygradedetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPayGradeForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPayGradeForViewDto[]>;
        }));
    }

    protected processGetAllPaygradedetails(response: HttpResponseBase): Observable<GetPayGradeForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetPayGradeForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPayGradeForViewDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPayGradeForView(id: number | undefined): Observable<GetPayGradeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PayGrades/GetPayGradeForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayGradeForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayGradeForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPayGradeForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPayGradeForViewDto>;
        }));
    }

    protected processGetPayGradeForView(response: HttpResponseBase): Observable<GetPayGradeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPayGradeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPayGradeForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPayGradeForEdit(id: number | undefined): Observable<GetPayGradeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/PayGrades/GetPayGradeForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayGradeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayGradeForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPayGradeForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPayGradeForEditOutput>;
        }));
    }

    protected processGetPayGradeForEdit(response: HttpResponseBase): Observable<GetPayGradeForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPayGradeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPayGradeForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditPayGradeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PayGrades/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PayGrades/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @return Success
     */
    getPayGradesToExcel(filter: string | null | undefined, nameFilter: string | null | undefined, descriptionFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PayGrades/GetPayGradesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (descriptionFilter !== undefined && descriptionFilter !== null)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayGradesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayGradesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetPayGradesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @return Success
     */
    getPayComponent(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/PayGrades/GetPayComponent";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetPayComponent(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param source (optional) 
     * @return Success
     */
    getPayComponentSource(source: string | null | undefined): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/PayGrades/GetPayComponentSource?";
        if (source !== undefined && source !== null)
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayComponentSource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayComponentSource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetPayComponentSource(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }

    /**
     * @param target (optional) 
     * @param payGradeId (optional) 
     * @return Success
     */
    getPayComponentTarget(target: string | null | undefined, payGradeId: number | undefined): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/PayGrades/GetPayComponentTarget?";
        if (target !== undefined && target !== null)
            url_ += "target=" + encodeURIComponent("" + target) + "&";
        if (payGradeId === null)
            throw new Error("The parameter 'payGradeId' cannot be null.");
        else if (payGradeId !== undefined)
            url_ += "payGradeId=" + encodeURIComponent("" + payGradeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayComponentTarget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayComponentTarget(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetPayComponentTarget(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }
}

@Injectable()
export class PaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param upgradeEditionId (optional) 
     * @return Success
     */
    getPaymentInfo(upgradeEditionId: number | null | undefined): Observable<PaymentInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentInfo?";
        if (upgradeEditionId !== undefined && upgradeEditionId !== null)
            url_ += "UpgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentInfoDto>;
        }));
    }

    protected processGetPaymentInfo(response: HttpResponseBase): Observable<PaymentInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentInfoDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPayment(body: CreatePaymentDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CreatePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePayment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancelPayment(body: CancelPaymentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CancelPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaymentHistory(sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfSubscriptionPaymentListDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentHistory?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSubscriptionPaymentListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSubscriptionPaymentListDto>;
        }));
    }

    protected processGetPaymentHistory(response: HttpResponseBase): Observable<PagedResultDtoOfSubscriptionPaymentListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSubscriptionPaymentListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfSubscriptionPaymentListDto>(null as any);
    }

    /**
     * @param recurringPaymentsEnabled (optional) 
     * @return Success
     */
    getActiveGateways(recurringPaymentsEnabled: boolean | null | undefined): Observable<PaymentGatewayModel[]> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetActiveGateways?";
        if (recurringPaymentsEnabled !== undefined && recurringPaymentsEnabled !== null)
            url_ += "RecurringPaymentsEnabled=" + encodeURIComponent("" + recurringPaymentsEnabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveGateways(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveGateways(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentGatewayModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentGatewayModel[]>;
        }));
    }

    protected processGetActiveGateways(response: HttpResponseBase): Observable<PaymentGatewayModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentGatewayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentGatewayModel[]>(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    getPayment(paymentId: number | undefined): Observable<SubscriptionPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPayment?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionPaymentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionPaymentDto>;
        }));
    }

    protected processGetPayment(response: HttpResponseBase): Observable<SubscriptionPaymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionPaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscriptionPaymentDto>(null as any);
    }

    /**
     * @return Success
     */
    getLastCompletedPayment(): Observable<SubscriptionPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetLastCompletedPayment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastCompletedPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastCompletedPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionPaymentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionPaymentDto>;
        }));
    }

    protected processGetLastCompletedPayment(response: HttpResponseBase): Observable<SubscriptionPaymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionPaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscriptionPaymentDto>(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    buyNowSucceed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/BuyNowSucceed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuyNowSucceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuyNowSucceed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBuyNowSucceed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    newRegistrationSucceed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/NewRegistrationSucceed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewRegistrationSucceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewRegistrationSucceed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNewRegistrationSucceed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    upgradeSucceed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/UpgradeSucceed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpgradeSucceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpgradeSucceed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpgradeSucceed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    extendSucceed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/ExtendSucceed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtendSucceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtendSucceed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExtendSucceed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    paymentFailed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/PaymentFailed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentFailed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentFailed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPaymentFailed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class PayPalPaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param paymentId (optional) 
     * @param paypalPaymentId (optional) 
     * @param paypalPayerId (optional) 
     * @return Success
     */
    confirmPayment(paymentId: number | undefined, paypalPaymentId: string | null | undefined, paypalPayerId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PayPalPayment/ConfirmPayment?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        if (paypalPaymentId !== undefined && paypalPaymentId !== null)
            url_ += "paypalPaymentId=" + encodeURIComponent("" + paypalPaymentId) + "&";
        if (paypalPayerId !== undefined && paypalPayerId !== null)
            url_ += "paypalPayerId=" + encodeURIComponent("" + paypalPayerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfirmPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getConfiguration(): Observable<PayPalConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/PayPalPayment/GetConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayPalConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayPalConfigurationDto>;
        }));
    }

    protected processGetConfiguration(response: HttpResponseBase): Observable<PayPalConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PayPalConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PayPalConfigurationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancelPayment(body: CancelPaymentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PayPalPayment/CancelPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class PerformancePolicyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param kRAid (optional) 
     * @return Success
     */
    getKRAMeasureUnit(kRAid: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PerformancePolicy/GetKRAMeasureUnit?";
        if (kRAid === null)
            throw new Error("The parameter 'kRAid' cannot be null.");
        else if (kRAid !== undefined)
            url_ += "KRAid=" + encodeURIComponent("" + kRAid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKRAMeasureUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKRAMeasureUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetKRAMeasureUnit(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPolicyNameViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PerformancePolicy/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetPolicyNameViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetPolicyNameViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPolicyNameViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPolicyNameViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPolicyNameViewDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditPerPolicyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PerformancePolicy/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPolicyForEdit(id: number | undefined): Observable<CreateOrEditPerPolicyDto> {
        let url_ = this.baseUrl + "/api/services/app/PerformancePolicy/GetPolicyForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolicyForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolicyForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditPerPolicyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditPerPolicyDto>;
        }));
    }

    protected processGetPolicyForEdit(response: HttpResponseBase): Observable<CreateOrEditPerPolicyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditPerPolicyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditPerPolicyDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPolicyForview(id: number | undefined): Observable<CreateOrEditPerPolicyDto> {
        let url_ = this.baseUrl + "/api/services/app/PerformancePolicy/GetPolicyForview?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolicyForview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolicyForview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditPerPolicyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditPerPolicyDto>;
        }));
    }

    protected processGetPolicyForview(response: HttpResponseBase): Observable<CreateOrEditPerPolicyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditPerPolicyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditPerPolicyDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PerformancePolicy/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class PermissionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        let url_ = this.baseUrl + "/api/services/app/Permission/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfFlatPermissionWithLevelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfFlatPermissionWithLevelDto>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfFlatPermissionWithLevelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfFlatPermissionWithLevelDto>(null as any);
    }
}

@Injectable()
export class PoliciesesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPoliciesForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Policieses/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetPoliciesForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetPoliciesForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPoliciesForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPoliciesForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPoliciesForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPoliciesForView(id: number | undefined): Observable<GetPoliciesForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Policieses/GetPoliciesForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPoliciesForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPoliciesForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPoliciesForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPoliciesForViewDto>;
        }));
    }

    protected processGetPoliciesForView(response: HttpResponseBase): Observable<GetPoliciesForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPoliciesForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPoliciesForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPoliciesForEdit(id: number | undefined): Observable<GetPoliciesForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Policieses/GetPoliciesForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPoliciesForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPoliciesForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPoliciesForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPoliciesForEditOutput>;
        }));
    }

    protected processGetPoliciesForEdit(response: HttpResponseBase): Observable<GetPoliciesForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPoliciesForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPoliciesForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditPoliciesDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Policieses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Policieses/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @return Success
     */
    getPoliciesesToExcel(filter: string | null | undefined, nameFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Policieses/GetPoliciesesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPoliciesesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPoliciesesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetPoliciesesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveFtbServer(body: FtbImage | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Policieses/SaveFtbServer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveFtbServer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveFtbServer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveFtbServer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param imgName (optional) 
     * @return Success
     */
    downLoadFile(imgName: string | null | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Policieses/DownLoadFile?";
        if (imgName !== undefined && imgName !== null)
            url_ += "ImgName=" + encodeURIComponent("" + imgName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownLoadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownLoadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processDownLoadFile(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param directoryPath (optional) 
     * @param ftpUser (optional) 
     * @param ftpPassword (optional) 
     * @return Success
     */
    ftpDirectoryExists(directoryPath: string | null | undefined, ftpUser: string | null | undefined, ftpPassword: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Policieses/FtpDirectoryExists?";
        if (directoryPath !== undefined && directoryPath !== null)
            url_ += "directoryPath=" + encodeURIComponent("" + directoryPath) + "&";
        if (ftpUser !== undefined && ftpUser !== null)
            url_ += "ftpUser=" + encodeURIComponent("" + ftpUser) + "&";
        if (ftpPassword !== undefined && ftpPassword !== null)
            url_ += "ftpPassword=" + encodeURIComponent("" + ftpPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFtpDirectoryExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFtpDirectoryExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processFtpDirectoryExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class ProfessionalsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxApplicableFilter (optional) 
     * @param minApplicableFilter (optional) 
     * @param maxCertificateNumberFilter (optional) 
     * @param minCertificateNumberFilter (optional) 
     * @param circleNoFilter (optional) 
     * @param maxDepositeProfessionalEmpHodSalaryTaxFilter (optional) 
     * @param minDepositeProfessionalEmpHodSalaryTaxFilter (optional) 
     * @param maxCalculateProfessionalTaxFilter (optional) 
     * @param minCalculateProfessionalTaxFilter (optional) 
     * @param maxCalculateProfessionalTaxBasedOnFilter (optional) 
     * @param minCalculateProfessionalTaxBasedOnFilter (optional) 
     * @param maxMultipleGroupFilter (optional) 
     * @param minMultipleGroupFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxApplicableFilter: number | null | undefined, minApplicableFilter: number | null | undefined, maxCertificateNumberFilter: number | null | undefined, minCertificateNumberFilter: number | null | undefined, circleNoFilter: string | null | undefined, maxDepositeProfessionalEmpHodSalaryTaxFilter: number | null | undefined, minDepositeProfessionalEmpHodSalaryTaxFilter: number | null | undefined, maxCalculateProfessionalTaxFilter: number | null | undefined, minCalculateProfessionalTaxFilter: number | null | undefined, maxCalculateProfessionalTaxBasedOnFilter: number | null | undefined, minCalculateProfessionalTaxBasedOnFilter: number | null | undefined, maxMultipleGroupFilter: number | null | undefined, minMultipleGroupFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetProfessionalForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Professionals/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxApplicableFilter !== undefined && maxApplicableFilter !== null)
            url_ += "MaxApplicableFilter=" + encodeURIComponent("" + maxApplicableFilter) + "&";
        if (minApplicableFilter !== undefined && minApplicableFilter !== null)
            url_ += "MinApplicableFilter=" + encodeURIComponent("" + minApplicableFilter) + "&";
        if (maxCertificateNumberFilter !== undefined && maxCertificateNumberFilter !== null)
            url_ += "MaxCertificateNumberFilter=" + encodeURIComponent("" + maxCertificateNumberFilter) + "&";
        if (minCertificateNumberFilter !== undefined && minCertificateNumberFilter !== null)
            url_ += "MinCertificateNumberFilter=" + encodeURIComponent("" + minCertificateNumberFilter) + "&";
        if (circleNoFilter !== undefined && circleNoFilter !== null)
            url_ += "CircleNoFilter=" + encodeURIComponent("" + circleNoFilter) + "&";
        if (maxDepositeProfessionalEmpHodSalaryTaxFilter !== undefined && maxDepositeProfessionalEmpHodSalaryTaxFilter !== null)
            url_ += "MaxDepositeProfessionalEmpHodSalaryTaxFilter=" + encodeURIComponent("" + maxDepositeProfessionalEmpHodSalaryTaxFilter) + "&";
        if (minDepositeProfessionalEmpHodSalaryTaxFilter !== undefined && minDepositeProfessionalEmpHodSalaryTaxFilter !== null)
            url_ += "MinDepositeProfessionalEmpHodSalaryTaxFilter=" + encodeURIComponent("" + minDepositeProfessionalEmpHodSalaryTaxFilter) + "&";
        if (maxCalculateProfessionalTaxFilter !== undefined && maxCalculateProfessionalTaxFilter !== null)
            url_ += "MaxCalculateProfessionalTaxFilter=" + encodeURIComponent("" + maxCalculateProfessionalTaxFilter) + "&";
        if (minCalculateProfessionalTaxFilter !== undefined && minCalculateProfessionalTaxFilter !== null)
            url_ += "MinCalculateProfessionalTaxFilter=" + encodeURIComponent("" + minCalculateProfessionalTaxFilter) + "&";
        if (maxCalculateProfessionalTaxBasedOnFilter !== undefined && maxCalculateProfessionalTaxBasedOnFilter !== null)
            url_ += "MaxCalculateProfessionalTaxBasedOnFilter=" + encodeURIComponent("" + maxCalculateProfessionalTaxBasedOnFilter) + "&";
        if (minCalculateProfessionalTaxBasedOnFilter !== undefined && minCalculateProfessionalTaxBasedOnFilter !== null)
            url_ += "MinCalculateProfessionalTaxBasedOnFilter=" + encodeURIComponent("" + minCalculateProfessionalTaxBasedOnFilter) + "&";
        if (maxMultipleGroupFilter !== undefined && maxMultipleGroupFilter !== null)
            url_ += "MaxMultipleGroupFilter=" + encodeURIComponent("" + maxMultipleGroupFilter) + "&";
        if (minMultipleGroupFilter !== undefined && minMultipleGroupFilter !== null)
            url_ += "MinMultipleGroupFilter=" + encodeURIComponent("" + minMultipleGroupFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetProfessionalForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetProfessionalForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetProfessionalForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetProfessionalForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetProfessionalForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getProfessionalForView(id: number | undefined): Observable<GetProfessionalForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Professionals/GetProfessionalForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessionalForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionalForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfessionalForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfessionalForViewDto>;
        }));
    }

    protected processGetProfessionalForView(response: HttpResponseBase): Observable<GetProfessionalForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfessionalForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProfessionalForViewDto>(null as any);
    }

    /**
     * @return Success
     */
    getProfessionalForEdit(): Observable<GetProfessionalForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Professionals/GetProfessionalForEdit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessionalForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionalForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfessionalForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfessionalForEditOutput>;
        }));
    }

    protected processGetProfessionalForEdit(response: HttpResponseBase): Observable<GetProfessionalForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfessionalForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProfessionalForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditProfessionalDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Professionals/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Professionals/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxApplicableFilter (optional) 
     * @param minApplicableFilter (optional) 
     * @param maxCertificateNumberFilter (optional) 
     * @param minCertificateNumberFilter (optional) 
     * @param circleNoFilter (optional) 
     * @param maxDepositeProfessionalEmpHodSalaryTaxFilter (optional) 
     * @param minDepositeProfessionalEmpHodSalaryTaxFilter (optional) 
     * @param maxCalculateProfessionalTaxFilter (optional) 
     * @param minCalculateProfessionalTaxFilter (optional) 
     * @param maxCalculateProfessionalTaxBasedOnFilter (optional) 
     * @param minCalculateProfessionalTaxBasedOnFilter (optional) 
     * @param maxMultipleGroupFilter (optional) 
     * @param minMultipleGroupFilter (optional) 
     * @return Success
     */
    getProfessionalsToExcel(filter: string | null | undefined, maxApplicableFilter: number | null | undefined, minApplicableFilter: number | null | undefined, maxCertificateNumberFilter: number | null | undefined, minCertificateNumberFilter: number | null | undefined, circleNoFilter: string | null | undefined, maxDepositeProfessionalEmpHodSalaryTaxFilter: number | null | undefined, minDepositeProfessionalEmpHodSalaryTaxFilter: number | null | undefined, maxCalculateProfessionalTaxFilter: number | null | undefined, minCalculateProfessionalTaxFilter: number | null | undefined, maxCalculateProfessionalTaxBasedOnFilter: number | null | undefined, minCalculateProfessionalTaxBasedOnFilter: number | null | undefined, maxMultipleGroupFilter: number | null | undefined, minMultipleGroupFilter: number | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Professionals/GetProfessionalsToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxApplicableFilter !== undefined && maxApplicableFilter !== null)
            url_ += "MaxApplicableFilter=" + encodeURIComponent("" + maxApplicableFilter) + "&";
        if (minApplicableFilter !== undefined && minApplicableFilter !== null)
            url_ += "MinApplicableFilter=" + encodeURIComponent("" + minApplicableFilter) + "&";
        if (maxCertificateNumberFilter !== undefined && maxCertificateNumberFilter !== null)
            url_ += "MaxCertificateNumberFilter=" + encodeURIComponent("" + maxCertificateNumberFilter) + "&";
        if (minCertificateNumberFilter !== undefined && minCertificateNumberFilter !== null)
            url_ += "MinCertificateNumberFilter=" + encodeURIComponent("" + minCertificateNumberFilter) + "&";
        if (circleNoFilter !== undefined && circleNoFilter !== null)
            url_ += "CircleNoFilter=" + encodeURIComponent("" + circleNoFilter) + "&";
        if (maxDepositeProfessionalEmpHodSalaryTaxFilter !== undefined && maxDepositeProfessionalEmpHodSalaryTaxFilter !== null)
            url_ += "MaxDepositeProfessionalEmpHodSalaryTaxFilter=" + encodeURIComponent("" + maxDepositeProfessionalEmpHodSalaryTaxFilter) + "&";
        if (minDepositeProfessionalEmpHodSalaryTaxFilter !== undefined && minDepositeProfessionalEmpHodSalaryTaxFilter !== null)
            url_ += "MinDepositeProfessionalEmpHodSalaryTaxFilter=" + encodeURIComponent("" + minDepositeProfessionalEmpHodSalaryTaxFilter) + "&";
        if (maxCalculateProfessionalTaxFilter !== undefined && maxCalculateProfessionalTaxFilter !== null)
            url_ += "MaxCalculateProfessionalTaxFilter=" + encodeURIComponent("" + maxCalculateProfessionalTaxFilter) + "&";
        if (minCalculateProfessionalTaxFilter !== undefined && minCalculateProfessionalTaxFilter !== null)
            url_ += "MinCalculateProfessionalTaxFilter=" + encodeURIComponent("" + minCalculateProfessionalTaxFilter) + "&";
        if (maxCalculateProfessionalTaxBasedOnFilter !== undefined && maxCalculateProfessionalTaxBasedOnFilter !== null)
            url_ += "MaxCalculateProfessionalTaxBasedOnFilter=" + encodeURIComponent("" + maxCalculateProfessionalTaxBasedOnFilter) + "&";
        if (minCalculateProfessionalTaxBasedOnFilter !== undefined && minCalculateProfessionalTaxBasedOnFilter !== null)
            url_ += "MinCalculateProfessionalTaxBasedOnFilter=" + encodeURIComponent("" + minCalculateProfessionalTaxBasedOnFilter) + "&";
        if (maxMultipleGroupFilter !== undefined && maxMultipleGroupFilter !== null)
            url_ += "MaxMultipleGroupFilter=" + encodeURIComponent("" + maxMultipleGroupFilter) + "&";
        if (minMultipleGroupFilter !== undefined && minMultipleGroupFilter !== null)
            url_ += "MinMultipleGroupFilter=" + encodeURIComponent("" + minMultipleGroupFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessionalsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionalsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetProfessionalsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class ProfileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentUserProfileForEdit(): Observable<CurrentUserProfileEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetCurrentUserProfileForEdit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserProfileForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserProfileForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentUserProfileEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentUserProfileEditDto>;
        }));
    }

    protected processGetCurrentUserProfileForEdit(response: HttpResponseBase): Observable<CurrentUserProfileEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrentUserProfileEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrentUserProfileEditDto>(null as any);
    }

    /**
     * @return Success
     */
    updateGoogleAuthenticatorKey(): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateGoogleAuthenticatorKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGoogleAuthenticatorKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGoogleAuthenticatorKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateGoogleAuthenticatorKeyOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateGoogleAuthenticatorKeyOutput>;
        }));
    }

    protected processUpdateGoogleAuthenticatorKey(response: HttpResponseBase): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGoogleAuthenticatorKeyOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateGoogleAuthenticatorKeyOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendVerificationSms(body: SendVerificationSmsInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/SendVerificationSms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendVerificationSms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendVerificationSms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendVerificationSms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifySmsCode(body: VerifySmsCodeInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/VerifySmsCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifySmsCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifySmsCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVerifySmsCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    prepareCollectedData(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/PrepareCollectedData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrepareCollectedData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrepareCollectedData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPrepareCollectedData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCurrentUserProfile(body: CurrentUserProfileEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateCurrentUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCurrentUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentUserProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCurrentUserProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProfilePicture(body: UpdateProfilePictureInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProfilePicture(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getPasswordComplexitySetting(): Observable<GetPasswordComplexitySettingOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetPasswordComplexitySetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPasswordComplexitySetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPasswordComplexitySetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPasswordComplexitySettingOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPasswordComplexitySettingOutput>;
        }));
    }

    protected processGetPasswordComplexitySetting(response: HttpResponseBase): Observable<GetPasswordComplexitySettingOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPasswordComplexitySettingOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPasswordComplexitySettingOutput>(null as any);
    }

    /**
     * @return Success
     */
    getProfilePicture(): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetProfilePicture(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProfilePictureOutput>(null as any);
    }

    /**
     * @param profilePictureId (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getFriendProfilePictureById(profilePictureId: string | null | undefined, userId: number | undefined, tenantId: number | null | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetFriendProfilePictureById?";
        if (profilePictureId !== undefined && profilePictureId !== null)
            url_ += "ProfilePictureId=" + encodeURIComponent("" + profilePictureId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFriendProfilePictureById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFriendProfilePictureById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetFriendProfilePictureById(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProfilePictureOutput>(null as any);
    }

    /**
     * @param profilePictureId (optional) 
     * @return Success
     */
    getProfilePictureById(profilePictureId: string | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureById?";
        if (profilePictureId === null)
            throw new Error("The parameter 'profilePictureId' cannot be null.");
        else if (profilePictureId !== undefined)
            url_ += "profilePictureId=" + encodeURIComponent("" + profilePictureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePictureById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePictureById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetProfilePictureById(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProfilePictureOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ProjectServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateProject(body: Project | undefined): Observable<GetProjectDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/CreateOrUpdateProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectDto>;
        }));
    }

    protected processCreateOrUpdateProject(response: HttpResponseBase): Observable<GetProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProjectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProjectDto>(null as any);
    }

    /**
     * @param searchTerm (optional) 
     * @return Success
     */
    getProjects(searchTerm: string | null | undefined): Observable<GetProjectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetProjects?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectDto[]>;
        }));
    }

    protected processGetProjects(response: HttpResponseBase): Observable<GetProjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetProjectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProjectDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getProjectForEdit(id: number | undefined): Observable<Project> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetProjectForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Project>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Project>;
        }));
    }

    protected processGetProjectForEdit(response: HttpResponseBase): Observable<Project> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Project.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Project>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteProject(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Project/DeleteProject?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteProject(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ProvidentFundsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param monthYearFilter (optional) 
     * @param maxPaymnetDateFilter (optional) 
     * @param minPaymnetDateFilter (optional) 
     * @param maxPaymentTypeFilter (optional) 
     * @param minPaymentTypeFilter (optional) 
     * @param maxBankNameFilter (optional) 
     * @param minBankNameFilter (optional) 
     * @param maxBranchNameFilter (optional) 
     * @param minBranchNameFilter (optional) 
     * @param draftNumberFilter (optional) 
     * @param maxDarftDateFilter (optional) 
     * @param minDarftDateFilter (optional) 
     * @param chequeNumberFilter (optional) 
     * @param maxChequeDateFilter (optional) 
     * @param minChequeDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, monthYearFilter: string | null | undefined, maxPaymnetDateFilter: moment.Moment | null | undefined, minPaymnetDateFilter: moment.Moment | null | undefined, maxPaymentTypeFilter: number | null | undefined, minPaymentTypeFilter: number | null | undefined, maxBankNameFilter: number | null | undefined, minBankNameFilter: number | null | undefined, maxBranchNameFilter: number | null | undefined, minBranchNameFilter: number | null | undefined, draftNumberFilter: string | null | undefined, maxDarftDateFilter: moment.Moment | null | undefined, minDarftDateFilter: moment.Moment | null | undefined, chequeNumberFilter: string | null | undefined, maxChequeDateFilter: moment.Moment | null | undefined, minChequeDateFilter: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetProvidentFundForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidentFunds/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (monthYearFilter !== undefined && monthYearFilter !== null)
            url_ += "MonthYearFilter=" + encodeURIComponent("" + monthYearFilter) + "&";
        if (maxPaymnetDateFilter !== undefined && maxPaymnetDateFilter !== null)
            url_ += "MaxPaymnetDateFilter=" + encodeURIComponent(maxPaymnetDateFilter ? "" + maxPaymnetDateFilter.toISOString() : "") + "&";
        if (minPaymnetDateFilter !== undefined && minPaymnetDateFilter !== null)
            url_ += "MinPaymnetDateFilter=" + encodeURIComponent(minPaymnetDateFilter ? "" + minPaymnetDateFilter.toISOString() : "") + "&";
        if (maxPaymentTypeFilter !== undefined && maxPaymentTypeFilter !== null)
            url_ += "MaxPaymentTypeFilter=" + encodeURIComponent("" + maxPaymentTypeFilter) + "&";
        if (minPaymentTypeFilter !== undefined && minPaymentTypeFilter !== null)
            url_ += "MinPaymentTypeFilter=" + encodeURIComponent("" + minPaymentTypeFilter) + "&";
        if (maxBankNameFilter !== undefined && maxBankNameFilter !== null)
            url_ += "MaxBankNameFilter=" + encodeURIComponent("" + maxBankNameFilter) + "&";
        if (minBankNameFilter !== undefined && minBankNameFilter !== null)
            url_ += "MinBankNameFilter=" + encodeURIComponent("" + minBankNameFilter) + "&";
        if (maxBranchNameFilter !== undefined && maxBranchNameFilter !== null)
            url_ += "MaxBranchNameFilter=" + encodeURIComponent("" + maxBranchNameFilter) + "&";
        if (minBranchNameFilter !== undefined && minBranchNameFilter !== null)
            url_ += "MinBranchNameFilter=" + encodeURIComponent("" + minBranchNameFilter) + "&";
        if (draftNumberFilter !== undefined && draftNumberFilter !== null)
            url_ += "DraftNumberFilter=" + encodeURIComponent("" + draftNumberFilter) + "&";
        if (maxDarftDateFilter !== undefined && maxDarftDateFilter !== null)
            url_ += "MaxDarftDateFilter=" + encodeURIComponent(maxDarftDateFilter ? "" + maxDarftDateFilter.toISOString() : "") + "&";
        if (minDarftDateFilter !== undefined && minDarftDateFilter !== null)
            url_ += "MinDarftDateFilter=" + encodeURIComponent(minDarftDateFilter ? "" + minDarftDateFilter.toISOString() : "") + "&";
        if (chequeNumberFilter !== undefined && chequeNumberFilter !== null)
            url_ += "ChequeNumberFilter=" + encodeURIComponent("" + chequeNumberFilter) + "&";
        if (maxChequeDateFilter !== undefined && maxChequeDateFilter !== null)
            url_ += "MaxChequeDateFilter=" + encodeURIComponent(maxChequeDateFilter ? "" + maxChequeDateFilter.toISOString() : "") + "&";
        if (minChequeDateFilter !== undefined && minChequeDateFilter !== null)
            url_ += "MinChequeDateFilter=" + encodeURIComponent(minChequeDateFilter ? "" + minChequeDateFilter.toISOString() : "") + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetProvidentFundForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetProvidentFundForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetProvidentFundForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetProvidentFundForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetProvidentFundForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getProvidentFundForView(id: number | undefined): Observable<GetProvidentFundForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidentFunds/GetProvidentFundForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProvidentFundForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProvidentFundForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProvidentFundForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProvidentFundForViewDto>;
        }));
    }

    protected processGetProvidentFundForView(response: HttpResponseBase): Observable<GetProvidentFundForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProvidentFundForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProvidentFundForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getProvidentFundForEdit(id: number | undefined): Observable<GetProvidentFundForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProvidentFunds/GetProvidentFundForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProvidentFundForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProvidentFundForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProvidentFundForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProvidentFundForEditOutput>;
        }));
    }

    protected processGetProvidentFundForEdit(response: HttpResponseBase): Observable<GetProvidentFundForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProvidentFundForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProvidentFundForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditProvidentFundDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProvidentFunds/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProvidentFunds/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param monthYearFilter (optional) 
     * @param maxPaymnetDateFilter (optional) 
     * @param minPaymnetDateFilter (optional) 
     * @param maxPaymentTypeFilter (optional) 
     * @param minPaymentTypeFilter (optional) 
     * @param maxBankNameFilter (optional) 
     * @param minBankNameFilter (optional) 
     * @param maxBranchNameFilter (optional) 
     * @param minBranchNameFilter (optional) 
     * @param draftNumberFilter (optional) 
     * @param maxDarftDateFilter (optional) 
     * @param minDarftDateFilter (optional) 
     * @param chequeNumberFilter (optional) 
     * @param maxChequeDateFilter (optional) 
     * @param minChequeDateFilter (optional) 
     * @return Success
     */
    getProvidentFundsToExcel(filter: string | null | undefined, monthYearFilter: string | null | undefined, maxPaymnetDateFilter: moment.Moment | null | undefined, minPaymnetDateFilter: moment.Moment | null | undefined, maxPaymentTypeFilter: number | null | undefined, minPaymentTypeFilter: number | null | undefined, maxBankNameFilter: number | null | undefined, minBankNameFilter: number | null | undefined, maxBranchNameFilter: number | null | undefined, minBranchNameFilter: number | null | undefined, draftNumberFilter: string | null | undefined, maxDarftDateFilter: moment.Moment | null | undefined, minDarftDateFilter: moment.Moment | null | undefined, chequeNumberFilter: string | null | undefined, maxChequeDateFilter: moment.Moment | null | undefined, minChequeDateFilter: moment.Moment | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidentFunds/GetProvidentFundsToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (monthYearFilter !== undefined && monthYearFilter !== null)
            url_ += "MonthYearFilter=" + encodeURIComponent("" + monthYearFilter) + "&";
        if (maxPaymnetDateFilter !== undefined && maxPaymnetDateFilter !== null)
            url_ += "MaxPaymnetDateFilter=" + encodeURIComponent(maxPaymnetDateFilter ? "" + maxPaymnetDateFilter.toISOString() : "") + "&";
        if (minPaymnetDateFilter !== undefined && minPaymnetDateFilter !== null)
            url_ += "MinPaymnetDateFilter=" + encodeURIComponent(minPaymnetDateFilter ? "" + minPaymnetDateFilter.toISOString() : "") + "&";
        if (maxPaymentTypeFilter !== undefined && maxPaymentTypeFilter !== null)
            url_ += "MaxPaymentTypeFilter=" + encodeURIComponent("" + maxPaymentTypeFilter) + "&";
        if (minPaymentTypeFilter !== undefined && minPaymentTypeFilter !== null)
            url_ += "MinPaymentTypeFilter=" + encodeURIComponent("" + minPaymentTypeFilter) + "&";
        if (maxBankNameFilter !== undefined && maxBankNameFilter !== null)
            url_ += "MaxBankNameFilter=" + encodeURIComponent("" + maxBankNameFilter) + "&";
        if (minBankNameFilter !== undefined && minBankNameFilter !== null)
            url_ += "MinBankNameFilter=" + encodeURIComponent("" + minBankNameFilter) + "&";
        if (maxBranchNameFilter !== undefined && maxBranchNameFilter !== null)
            url_ += "MaxBranchNameFilter=" + encodeURIComponent("" + maxBranchNameFilter) + "&";
        if (minBranchNameFilter !== undefined && minBranchNameFilter !== null)
            url_ += "MinBranchNameFilter=" + encodeURIComponent("" + minBranchNameFilter) + "&";
        if (draftNumberFilter !== undefined && draftNumberFilter !== null)
            url_ += "DraftNumberFilter=" + encodeURIComponent("" + draftNumberFilter) + "&";
        if (maxDarftDateFilter !== undefined && maxDarftDateFilter !== null)
            url_ += "MaxDarftDateFilter=" + encodeURIComponent(maxDarftDateFilter ? "" + maxDarftDateFilter.toISOString() : "") + "&";
        if (minDarftDateFilter !== undefined && minDarftDateFilter !== null)
            url_ += "MinDarftDateFilter=" + encodeURIComponent(minDarftDateFilter ? "" + minDarftDateFilter.toISOString() : "") + "&";
        if (chequeNumberFilter !== undefined && chequeNumberFilter !== null)
            url_ += "ChequeNumberFilter=" + encodeURIComponent("" + chequeNumberFilter) + "&";
        if (maxChequeDateFilter !== undefined && maxChequeDateFilter !== null)
            url_ += "MaxChequeDateFilter=" + encodeURIComponent(maxChequeDateFilter ? "" + maxChequeDateFilter.toISOString() : "") + "&";
        if (minChequeDateFilter !== undefined && minChequeDateFilter !== null)
            url_ += "MinChequeDateFilter=" + encodeURIComponent(minChequeDateFilter ? "" + minChequeDateFilter.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProvidentFundsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProvidentFundsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetProvidentFundsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class ProvidentFundSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxAccountno01Filter (optional) 
     * @param minAccountno01Filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxAccountno01Filter: number | null | undefined, minAccountno01Filter: number | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetProvidentFundSettingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidentFundSettings/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxAccountno01Filter !== undefined && maxAccountno01Filter !== null)
            url_ += "MaxAccountno01Filter=" + encodeURIComponent("" + maxAccountno01Filter) + "&";
        if (minAccountno01Filter !== undefined && minAccountno01Filter !== null)
            url_ += "MinAccountno01Filter=" + encodeURIComponent("" + minAccountno01Filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetProvidentFundSettingForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetProvidentFundSettingForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetProvidentFundSettingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetProvidentFundSettingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetProvidentFundSettingForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getProvidentFundSettingForView(id: number | undefined): Observable<GetProvidentFundSettingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidentFundSettings/GetProvidentFundSettingForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProvidentFundSettingForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProvidentFundSettingForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProvidentFundSettingForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProvidentFundSettingForViewDto>;
        }));
    }

    protected processGetProvidentFundSettingForView(response: HttpResponseBase): Observable<GetProvidentFundSettingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProvidentFundSettingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProvidentFundSettingForViewDto>(null as any);
    }

    /**
     * @return Success
     */
    getProvidentFundSettingForEdit(): Observable<GetProvidentFundSettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProvidentFundSettings/GetProvidentFundSettingForEdit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProvidentFundSettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProvidentFundSettingForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProvidentFundSettingForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProvidentFundSettingForEditOutput>;
        }));
    }

    protected processGetProvidentFundSettingForEdit(response: HttpResponseBase): Observable<GetProvidentFundSettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProvidentFundSettingForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProvidentFundSettingForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditProvidentFundSettingDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProvidentFundSettings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProvidentFundSettings/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxAccountno01Filter (optional) 
     * @param minAccountno01Filter (optional) 
     * @return Success
     */
    getProvidentFundSettingsToExcel(filter: string | null | undefined, maxAccountno01Filter: number | null | undefined, minAccountno01Filter: number | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ProvidentFundSettings/GetProvidentFundSettingsToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxAccountno01Filter !== undefined && maxAccountno01Filter !== null)
            url_ += "MaxAccountno01Filter=" + encodeURIComponent("" + maxAccountno01Filter) + "&";
        if (minAccountno01Filter !== undefined && minAccountno01Filter !== null)
            url_ += "MinAccountno01Filter=" + encodeURIComponent("" + minAccountno01Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProvidentFundSettingsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProvidentFundSettingsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetProvidentFundSettingsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class QuikLinksesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param uRLFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, uRLFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetQuikLinksForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/QuikLinkses/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (uRLFilter !== undefined && uRLFilter !== null)
            url_ += "URLFilter=" + encodeURIComponent("" + uRLFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetQuikLinksForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetQuikLinksForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetQuikLinksForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetQuikLinksForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetQuikLinksForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getQuikLinksForView(id: number | undefined): Observable<GetQuikLinksForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/QuikLinkses/GetQuikLinksForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuikLinksForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuikLinksForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetQuikLinksForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetQuikLinksForViewDto>;
        }));
    }

    protected processGetQuikLinksForView(response: HttpResponseBase): Observable<GetQuikLinksForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetQuikLinksForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetQuikLinksForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getQuikLinksForEdit(id: number | undefined): Observable<GetQuikLinksForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/QuikLinkses/GetQuikLinksForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuikLinksForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuikLinksForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetQuikLinksForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetQuikLinksForEditOutput>;
        }));
    }

    protected processGetQuikLinksForEdit(response: HttpResponseBase): Observable<GetQuikLinksForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetQuikLinksForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetQuikLinksForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditQuikLinksDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/QuikLinkses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/QuikLinkses/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param uRLFilter (optional) 
     * @return Success
     */
    getQuikLinksesToExcel(filter: string | null | undefined, nameFilter: string | null | undefined, uRLFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/QuikLinkses/GetQuikLinksesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (uRLFilter !== undefined && uRLFilter !== null)
            url_ += "URLFilter=" + encodeURIComponent("" + uRLFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuikLinksesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuikLinksesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetQuikLinksesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class ReasonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAllReasonView> {
        let url_ = this.baseUrl + "/api/services/app/Reason/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAllReasonView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAllReasonView>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllReasonView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAllReasonView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllReasonView>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getReasonForEdit(id: number | undefined): Observable<CreateOrEditReasonDto> {
        let url_ = this.baseUrl + "/api/services/app/Reason/GetReasonForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReasonForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReasonForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditReasonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditReasonDto>;
        }));
    }

    protected processGetReasonForEdit(response: HttpResponseBase): Observable<CreateOrEditReasonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditReasonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditReasonDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditReasonDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Reason/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Reason/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param attendanceDate (optional) 
     * @param shiftId (optional) 
     * @param reportType (optional) 
     * @return Success
     */
    getAttendanceReport(attendanceDate: moment.Moment | null | undefined, shiftId: number | null | undefined, reportType: string | null | undefined): Observable<AttendanceReportShiftWiseDto> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetAttendanceReport?";
        if (attendanceDate !== undefined && attendanceDate !== null)
            url_ += "attendanceDate=" + encodeURIComponent(attendanceDate ? "" + attendanceDate.toISOString() : "") + "&";
        if (shiftId !== undefined && shiftId !== null)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (reportType !== undefined && reportType !== null)
            url_ += "reportType=" + encodeURIComponent("" + reportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendanceReportShiftWiseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendanceReportShiftWiseDto>;
        }));
    }

    protected processGetAttendanceReport(response: HttpResponseBase): Observable<AttendanceReportShiftWiseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttendanceReportShiftWiseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AttendanceReportShiftWiseDto>(null as any);
    }

    /**
     * @param attendanceDate (optional) 
     * @return Success
     */
    updateLocation(attendanceDate: moment.Moment | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Report/UpdateLocation?";
        if (attendanceDate === null)
            throw new Error("The parameter 'attendanceDate' cannot be null.");
        else if (attendanceDate !== undefined)
            url_ += "attendanceDate=" + encodeURIComponent(attendanceDate ? "" + attendanceDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateLocation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ReportEmailSenderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    sendAutoMailer(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReportEmailSender/SendAutoMailer";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAutoMailer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAutoMailer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendAutoMailer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendAttendanceReportEmail(body: SendAttendanceReportMailPrms | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReportEmailSender/SendAttendanceReportEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAttendanceReportEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAttendanceReportEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendAttendanceReportEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    sendDiscripancyAutomailer(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReportEmailSender/SendDiscripancyAutomailer";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendDiscripancyAutomailer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendDiscripancyAutomailer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendDiscripancyAutomailer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ReportingEmployeesFnFServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param employeeid (optional) 
     * @return Success
     */
    getReportingEmployeesFnF(employeeid: number | undefined): Observable<ReportingEmployeeFnfDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ReportingEmployeesFnF/GetReportingEmployeesFnF?";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportingEmployeesFnF(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportingEmployeesFnF(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportingEmployeeFnfDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportingEmployeeFnfDto[]>;
        }));
    }

    protected processGetReportingEmployeesFnF(response: HttpResponseBase): Observable<ReportingEmployeeFnfDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportingEmployeeFnfDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportingEmployeeFnfDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeDropDown(): Observable<DropdownManagerEmployees[]> {
        let url_ = this.baseUrl + "/api/services/app/ReportingEmployeesFnF/GetEmployeeDropDown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeDropDown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeDropDown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownManagerEmployees[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownManagerEmployees[]>;
        }));
    }

    protected processGetEmployeeDropDown(response: HttpResponseBase): Observable<DropdownManagerEmployees[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownManagerEmployees.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropdownManagerEmployees[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    save(body: SaveReportingEmployeeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReportingEmployeesFnF/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ReportSchemasesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param reportNameFilter (optional) 
     * @param tableNameFilter (optional) 
     * @param reportColumnFilter (optional) 
     * @param reportFromFilter (optional) 
     * @param filterFilter (optional) 
     * @param groupid (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, reportNameFilter: string | null | undefined, tableNameFilter: string | null | undefined, reportColumnFilter: string | null | undefined, reportFromFilter: string | null | undefined, filterFilter: string | null | undefined, groupid: number | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetReportSchemasForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportSchemases/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (reportNameFilter !== undefined && reportNameFilter !== null)
            url_ += "ReportNameFilter=" + encodeURIComponent("" + reportNameFilter) + "&";
        if (tableNameFilter !== undefined && tableNameFilter !== null)
            url_ += "TableNameFilter=" + encodeURIComponent("" + tableNameFilter) + "&";
        if (reportColumnFilter !== undefined && reportColumnFilter !== null)
            url_ += "ReportColumnFilter=" + encodeURIComponent("" + reportColumnFilter) + "&";
        if (reportFromFilter !== undefined && reportFromFilter !== null)
            url_ += "ReportFromFilter=" + encodeURIComponent("" + reportFromFilter) + "&";
        if (filterFilter !== undefined && filterFilter !== null)
            url_ += "FilterFilter=" + encodeURIComponent("" + filterFilter) + "&";
        if (groupid === null)
            throw new Error("The parameter 'groupid' cannot be null.");
        else if (groupid !== undefined)
            url_ += "groupid=" + encodeURIComponent("" + groupid) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetReportSchemasForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetReportSchemasForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetReportSchemasForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetReportSchemasForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetReportSchemasForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getReportSchemasForView(id: number | undefined): Observable<GetReportSchemasForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportSchemases/GetReportSchemasForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportSchemasForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportSchemasForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReportSchemasForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReportSchemasForViewDto>;
        }));
    }

    protected processGetReportSchemasForView(response: HttpResponseBase): Observable<GetReportSchemasForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReportSchemasForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetReportSchemasForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getReportSchemasForEdit(id: number | undefined): Observable<GetReportSchemasForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ReportSchemases/GetReportSchemasForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportSchemasForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportSchemasForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReportSchemasForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReportSchemasForEditOutput>;
        }));
    }

    protected processGetReportSchemasForEdit(response: HttpResponseBase): Observable<GetReportSchemasForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReportSchemasForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetReportSchemasForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditReportSchemasDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReportSchemases/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReportSchemases/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param reportNameFilter (optional) 
     * @param tableNameFilter (optional) 
     * @param reportColumnFilter (optional) 
     * @param reportFromFilter (optional) 
     * @param filterFilter (optional) 
     * @return Success
     */
    getReportSchemasesToExcel(filter: string | null | undefined, reportNameFilter: string | null | undefined, tableNameFilter: string | null | undefined, reportColumnFilter: string | null | undefined, reportFromFilter: string | null | undefined, filterFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportSchemases/GetReportSchemasesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (reportNameFilter !== undefined && reportNameFilter !== null)
            url_ += "ReportNameFilter=" + encodeURIComponent("" + reportNameFilter) + "&";
        if (tableNameFilter !== undefined && tableNameFilter !== null)
            url_ += "TableNameFilter=" + encodeURIComponent("" + tableNameFilter) + "&";
        if (reportColumnFilter !== undefined && reportColumnFilter !== null)
            url_ += "ReportColumnFilter=" + encodeURIComponent("" + reportColumnFilter) + "&";
        if (reportFromFilter !== undefined && reportFromFilter !== null)
            url_ += "ReportFromFilter=" + encodeURIComponent("" + reportFromFilter) + "&";
        if (filterFilter !== undefined && filterFilter !== null)
            url_ += "FilterFilter=" + encodeURIComponent("" + filterFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportSchemasesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportSchemasesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetReportSchemasesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class RequestApprovalsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxRequestTypeFilter (optional) 
     * @param minRequestTypeFilter (optional) 
     * @param maxLevelFilter (optional) 
     * @param minLevelFilter (optional) 
     * @param maxApprovedByFilter (optional) 
     * @param minApprovedByFilter (optional) 
     * @param maxApprovedOnFilter (optional) 
     * @param minApprovedOnFilter (optional) 
     * @param remarksFilter (optional) 
     * @param notficationSendFilter (optional) 
     * @param isProcessFeedFilter (optional) 
     * @param requestForApprovalStatusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxRequestTypeFilter: number | null | undefined, minRequestTypeFilter: number | null | undefined, maxLevelFilter: number | null | undefined, minLevelFilter: number | null | undefined, maxApprovedByFilter: number | null | undefined, minApprovedByFilter: number | null | undefined, maxApprovedOnFilter: moment.Moment | null | undefined, minApprovedOnFilter: moment.Moment | null | undefined, remarksFilter: string | null | undefined, notficationSendFilter: number | null | undefined, isProcessFeedFilter: number | null | undefined, requestForApprovalStatusFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetRequestApprovalForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/RequestApprovals/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxRequestTypeFilter !== undefined && maxRequestTypeFilter !== null)
            url_ += "MaxRequestTypeFilter=" + encodeURIComponent("" + maxRequestTypeFilter) + "&";
        if (minRequestTypeFilter !== undefined && minRequestTypeFilter !== null)
            url_ += "MinRequestTypeFilter=" + encodeURIComponent("" + minRequestTypeFilter) + "&";
        if (maxLevelFilter !== undefined && maxLevelFilter !== null)
            url_ += "MaxLevelFilter=" + encodeURIComponent("" + maxLevelFilter) + "&";
        if (minLevelFilter !== undefined && minLevelFilter !== null)
            url_ += "MinLevelFilter=" + encodeURIComponent("" + minLevelFilter) + "&";
        if (maxApprovedByFilter !== undefined && maxApprovedByFilter !== null)
            url_ += "MaxApprovedByFilter=" + encodeURIComponent("" + maxApprovedByFilter) + "&";
        if (minApprovedByFilter !== undefined && minApprovedByFilter !== null)
            url_ += "MinApprovedByFilter=" + encodeURIComponent("" + minApprovedByFilter) + "&";
        if (maxApprovedOnFilter !== undefined && maxApprovedOnFilter !== null)
            url_ += "MaxApprovedOnFilter=" + encodeURIComponent(maxApprovedOnFilter ? "" + maxApprovedOnFilter.toISOString() : "") + "&";
        if (minApprovedOnFilter !== undefined && minApprovedOnFilter !== null)
            url_ += "MinApprovedOnFilter=" + encodeURIComponent(minApprovedOnFilter ? "" + minApprovedOnFilter.toISOString() : "") + "&";
        if (remarksFilter !== undefined && remarksFilter !== null)
            url_ += "RemarksFilter=" + encodeURIComponent("" + remarksFilter) + "&";
        if (notficationSendFilter !== undefined && notficationSendFilter !== null)
            url_ += "NotficationSendFilter=" + encodeURIComponent("" + notficationSendFilter) + "&";
        if (isProcessFeedFilter !== undefined && isProcessFeedFilter !== null)
            url_ += "isProcessFeedFilter=" + encodeURIComponent("" + isProcessFeedFilter) + "&";
        if (requestForApprovalStatusFilter !== undefined && requestForApprovalStatusFilter !== null)
            url_ += "RequestForApprovalStatusFilter=" + encodeURIComponent("" + requestForApprovalStatusFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetRequestApprovalForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetRequestApprovalForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetRequestApprovalForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetRequestApprovalForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRequestApprovalForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRequestApprovalForEdit(id: number | undefined): Observable<GetRequestApprovalForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/RequestApprovals/GetRequestApprovalForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestApprovalForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestApprovalForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRequestApprovalForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRequestApprovalForEditOutput>;
        }));
    }

    protected processGetRequestApprovalForEdit(response: HttpResponseBase): Observable<GetRequestApprovalForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRequestApprovalForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRequestApprovalForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditRequestApprovalDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RequestApprovals/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RequestApprovals/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllRequestForApprovalForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfRequestApprovalRequestForApprovalLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/RequestApprovals/GetAllRequestForApprovalForLookupTable?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRequestForApprovalForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRequestForApprovalForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfRequestApprovalRequestForApprovalLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfRequestApprovalRequestForApprovalLookupTableDto>;
        }));
    }

    protected processGetAllRequestForApprovalForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfRequestApprovalRequestForApprovalLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfRequestApprovalRequestForApprovalLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRequestApprovalRequestForApprovalLookupTableDto>(null as any);
    }
}

@Injectable()
export class RequestForApprovalsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetRequestForApprovalForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/RequestForApprovals/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetRequestForApprovalForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetRequestForApprovalForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetRequestForApprovalForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetRequestForApprovalForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRequestForApprovalForViewDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAproved(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetRequestForApprovalForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/RequestForApprovals/GetAllAproved?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAproved(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAproved(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetRequestForApprovalForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetRequestForApprovalForViewDto>;
        }));
    }

    protected processGetAllAproved(response: HttpResponseBase): Observable<PagedResultDtoOfGetRequestForApprovalForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetRequestForApprovalForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRequestForApprovalForViewDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllRejected(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetRequestForApprovalForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/RequestForApprovals/GetAllRejected?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRejected(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRejected(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetRequestForApprovalForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetRequestForApprovalForViewDto>;
        }));
    }

    protected processGetAllRejected(response: HttpResponseBase): Observable<PagedResultDtoOfGetRequestForApprovalForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetRequestForApprovalForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRequestForApprovalForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRequestForApprovalForView(id: number | undefined): Observable<GetRequestForApprovalForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/RequestForApprovals/GetRequestForApprovalForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestForApprovalForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestForApprovalForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRequestForApprovalForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRequestForApprovalForViewDto>;
        }));
    }

    protected processGetRequestForApprovalForView(response: HttpResponseBase): Observable<GetRequestForApprovalForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRequestForApprovalForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRequestForApprovalForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRequestForApprovalForEdit(id: number | undefined): Observable<GetRequestForApprovalForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/RequestForApprovals/GetRequestForApprovalForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestForApprovalForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestForApprovalForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRequestForApprovalForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRequestForApprovalForEditOutput>;
        }));
    }

    protected processGetRequestForApprovalForEdit(response: HttpResponseBase): Observable<GetRequestForApprovalForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRequestForApprovalForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRequestForApprovalForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditRequestForApprovalDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RequestForApprovals/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RequestForApprovals/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param fromdate (optional) 
     * @param todate (optional) 
     * @param employeeId (optional) 
     * @param departmentId (optional) 
     * @param branchId (optional) 
     * @param flag (optional) 
     * @param sortingPreference (optional) 
     * @return Success
     */
    getRequestForApprovalsToExcel(filter: string | null | undefined, fromdate: moment.Moment | undefined, todate: moment.Moment | undefined, employeeId: number | undefined, departmentId: number | undefined, branchId: number | undefined, flag: number | undefined, sortingPreference: number | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/RequestForApprovals/GetRequestForApprovalsToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (todate === null)
            throw new Error("The parameter 'todate' cannot be null.");
        else if (todate !== undefined)
            url_ += "Todate=" + encodeURIComponent(todate ? "" + todate.toISOString() : "") + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "DepartmentId=" + encodeURIComponent("" + departmentId) + "&";
        if (branchId === null)
            throw new Error("The parameter 'branchId' cannot be null.");
        else if (branchId !== undefined)
            url_ += "BranchId=" + encodeURIComponent("" + branchId) + "&";
        if (flag === null)
            throw new Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        if (sortingPreference !== undefined && sortingPreference !== null)
            url_ += "SortingPreference=" + encodeURIComponent("" + sortingPreference) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestForApprovalsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestForApprovalsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetRequestForApprovalsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param remarks (optional) 
     * @param type (optional) 
     * @param proposeddate (optional) 
     * @return Success
     */
    approvalSeparation(id: number | undefined, remarks: string | null | undefined, type: number | undefined, proposeddate: moment.Moment | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RequestForApprovals/ApprovalSeparation?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (remarks !== undefined && remarks !== null)
            url_ += "remarks=" + encodeURIComponent("" + remarks) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (proposeddate !== undefined && proposeddate !== null)
            url_ += "proposeddate=" + encodeURIComponent(proposeddate ? "" + proposeddate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprovalSeparation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprovalSeparation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApprovalSeparation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param requestforappralogId (optional) 
     * @param remarks (optional) 
     * @param type (optional) 
     * @param employeeId (optional) 
     * @return Success
     */
    approvalForMrr(id: number | undefined, requestforappralogId: number | undefined, remarks: string | null | undefined, type: number | undefined, employeeId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RequestForApprovals/ApprovalForMrr?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (requestforappralogId === null)
            throw new Error("The parameter 'requestforappralogId' cannot be null.");
        else if (requestforappralogId !== undefined)
            url_ += "requestforappralogId=" + encodeURIComponent("" + requestforappralogId) + "&";
        if (remarks !== undefined && remarks !== null)
            url_ += "remarks=" + encodeURIComponent("" + remarks) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprovalForMrr(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprovalForMrr(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApprovalForMrr(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param requestforappralogId (optional) 
     * @param remarks (optional) 
     * @param type (optional) 
     * @return Success
     */
    approval(id: number | undefined, requestforappralogId: number | undefined, remarks: string | null | undefined, type: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RequestForApprovals/Approval?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (requestforappralogId === null)
            throw new Error("The parameter 'requestforappralogId' cannot be null.");
        else if (requestforappralogId !== undefined)
            url_ += "requestforappralogId=" + encodeURIComponent("" + requestforappralogId) + "&";
        if (remarks !== undefined && remarks !== null)
            url_ += "remarks=" + encodeURIComponent("" + remarks) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApproval(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param imgName (optional) 
     * @param documentType (optional) 
     * @return Success
     */
    downLoadFile(imgName: string | null | undefined, documentType: string | null | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RequestForApprovals/DownLoadFile?";
        if (imgName !== undefined && imgName !== null)
            url_ += "ImgName=" + encodeURIComponent("" + imgName) + "&";
        if (documentType !== undefined && documentType !== null)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownLoadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownLoadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processDownLoadFile(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveFtbServer(body: FtbImage | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/RequestForApprovals/SaveFtbServer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveFtbServer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveFtbServer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveFtbServer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param directoryPath (optional) 
     * @param ftpUser (optional) 
     * @param ftpPassword (optional) 
     * @return Success
     */
    ftpDirectoryExists(directoryPath: string | null | undefined, ftpUser: string | null | undefined, ftpPassword: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/RequestForApprovals/FtpDirectoryExists?";
        if (directoryPath !== undefined && directoryPath !== null)
            url_ += "directoryPath=" + encodeURIComponent("" + directoryPath) + "&";
        if (ftpUser !== undefined && ftpUser !== null)
            url_ += "ftpUser=" + encodeURIComponent("" + ftpUser) + "&";
        if (ftpPassword !== undefined && ftpPassword !== null)
            url_ += "ftpPassword=" + encodeURIComponent("" + ftpPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFtpDirectoryExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFtpDirectoryExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processFtpDirectoryExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param imgName (optional) 
     * @param documentType (optional) 
     * @return Success
     */
    editDownloadFile(imgName: string | null | undefined, documentType: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/RequestForApprovals/EditDownloadFile?";
        if (imgName !== undefined && imgName !== null)
            url_ += "ImgName=" + encodeURIComponent("" + imgName) + "&";
        if (documentType !== undefined && documentType !== null)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processEditDownloadFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param requestId (optional) 
     * @param rejectionRemarks (optional) 
     * @return Success
     */
    sendNotficationForRejction(requestId: number | undefined, rejectionRemarks: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RequestForApprovals/sendNotficationForRejction?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (rejectionRemarks !== undefined && rejectionRemarks !== null)
            url_ += "RejectionRemarks=" + encodeURIComponent("" + rejectionRemarks) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendNotficationForRejction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendNotficationForRejction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendNotficationForRejction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    oneTimeAttUpdateAPI(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RequestForApprovals/OneTimeAttUpdateAPI";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOneTimeAttUpdateAPI(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOneTimeAttUpdateAPI(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOneTimeAttUpdateAPI(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class RequestWorkflowStepsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxLevelFilter (optional) 
     * @param minLevelFilter (optional) 
     * @param intimationOnlyFilter (optional) 
     * @param maxTurnAroundTimeFilter (optional) 
     * @param minTurnAroundTimeFilter (optional) 
     * @param roleNameFilter (optional) 
     * @param requesrFlowDescriptionFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxLevelFilter: number | null | undefined, minLevelFilter: number | null | undefined, intimationOnlyFilter: number | null | undefined, maxTurnAroundTimeFilter: number | null | undefined, minTurnAroundTimeFilter: number | null | undefined, roleNameFilter: string | null | undefined, requesrFlowDescriptionFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetRequestWorkflowStepForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/RequestWorkflowSteps/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxLevelFilter !== undefined && maxLevelFilter !== null)
            url_ += "MaxLevelFilter=" + encodeURIComponent("" + maxLevelFilter) + "&";
        if (minLevelFilter !== undefined && minLevelFilter !== null)
            url_ += "MinLevelFilter=" + encodeURIComponent("" + minLevelFilter) + "&";
        if (intimationOnlyFilter !== undefined && intimationOnlyFilter !== null)
            url_ += "IntimationOnlyFilter=" + encodeURIComponent("" + intimationOnlyFilter) + "&";
        if (maxTurnAroundTimeFilter !== undefined && maxTurnAroundTimeFilter !== null)
            url_ += "MaxTurnAroundTimeFilter=" + encodeURIComponent("" + maxTurnAroundTimeFilter) + "&";
        if (minTurnAroundTimeFilter !== undefined && minTurnAroundTimeFilter !== null)
            url_ += "MinTurnAroundTimeFilter=" + encodeURIComponent("" + minTurnAroundTimeFilter) + "&";
        if (roleNameFilter !== undefined && roleNameFilter !== null)
            url_ += "RoleNameFilter=" + encodeURIComponent("" + roleNameFilter) + "&";
        if (requesrFlowDescriptionFilter !== undefined && requesrFlowDescriptionFilter !== null)
            url_ += "RequesrFlowDescriptionFilter=" + encodeURIComponent("" + requesrFlowDescriptionFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetRequestWorkflowStepForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetRequestWorkflowStepForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetRequestWorkflowStepForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetRequestWorkflowStepForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRequestWorkflowStepForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRequestWorkflowStepForView(id: number | undefined): Observable<GetRequestWorkflowStepForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/RequestWorkflowSteps/GetRequestWorkflowStepForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestWorkflowStepForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestWorkflowStepForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRequestWorkflowStepForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRequestWorkflowStepForViewDto>;
        }));
    }

    protected processGetRequestWorkflowStepForView(response: HttpResponseBase): Observable<GetRequestWorkflowStepForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRequestWorkflowStepForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRequestWorkflowStepForViewDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditRequestWorkflowStepDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RequestWorkflowSteps/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RequestWorkflowSteps/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxLevelFilter (optional) 
     * @param minLevelFilter (optional) 
     * @param intimationOnlyFilter (optional) 
     * @param maxTurnAroundTimeFilter (optional) 
     * @param minTurnAroundTimeFilter (optional) 
     * @param roleNameFilter (optional) 
     * @param requesrFlowDescriptionFilter (optional) 
     * @return Success
     */
    getRequestWorkflowStepsToExcel(filter: string | null | undefined, maxLevelFilter: number | null | undefined, minLevelFilter: number | null | undefined, intimationOnlyFilter: number | null | undefined, maxTurnAroundTimeFilter: number | null | undefined, minTurnAroundTimeFilter: number | null | undefined, roleNameFilter: string | null | undefined, requesrFlowDescriptionFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/RequestWorkflowSteps/GetRequestWorkflowStepsToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxLevelFilter !== undefined && maxLevelFilter !== null)
            url_ += "MaxLevelFilter=" + encodeURIComponent("" + maxLevelFilter) + "&";
        if (minLevelFilter !== undefined && minLevelFilter !== null)
            url_ += "MinLevelFilter=" + encodeURIComponent("" + minLevelFilter) + "&";
        if (intimationOnlyFilter !== undefined && intimationOnlyFilter !== null)
            url_ += "IntimationOnlyFilter=" + encodeURIComponent("" + intimationOnlyFilter) + "&";
        if (maxTurnAroundTimeFilter !== undefined && maxTurnAroundTimeFilter !== null)
            url_ += "MaxTurnAroundTimeFilter=" + encodeURIComponent("" + maxTurnAroundTimeFilter) + "&";
        if (minTurnAroundTimeFilter !== undefined && minTurnAroundTimeFilter !== null)
            url_ += "MinTurnAroundTimeFilter=" + encodeURIComponent("" + minTurnAroundTimeFilter) + "&";
        if (roleNameFilter !== undefined && roleNameFilter !== null)
            url_ += "RoleNameFilter=" + encodeURIComponent("" + roleNameFilter) + "&";
        if (requesrFlowDescriptionFilter !== undefined && requesrFlowDescriptionFilter !== null)
            url_ += "RequesrFlowDescriptionFilter=" + encodeURIComponent("" + requesrFlowDescriptionFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestWorkflowStepsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestWorkflowStepsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetRequestWorkflowStepsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllRoleForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfRequestWorkflowStepRoleLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/RequestWorkflowSteps/GetAllRoleForLookupTable?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRoleForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRoleForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfRequestWorkflowStepRoleLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfRequestWorkflowStepRoleLookupTableDto>;
        }));
    }

    protected processGetAllRoleForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfRequestWorkflowStepRoleLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfRequestWorkflowStepRoleLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRequestWorkflowStepRoleLookupTableDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllRequesrFlowForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfRequestWorkflowStepRequesrFlowLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/RequestWorkflowSteps/GetAllRequesrFlowForLookupTable?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRequesrFlowForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRequesrFlowForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfRequestWorkflowStepRequesrFlowLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfRequestWorkflowStepRequesrFlowLookupTableDto>;
        }));
    }

    protected processGetAllRequesrFlowForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfRequestWorkflowStepRequesrFlowLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfRequestWorkflowStepRequesrFlowLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRequestWorkflowStepRequesrFlowLookupTableDto>(null as any);
    }
}

@Injectable()
export class ReviewStatusServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param firstName (optional) 
     * @param lastName (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllEmployeeReviewDetailsForManager(firstName: string | null | undefined, lastName: string | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetReviewStatusViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ReviewStatus/GetAllEmployeeReviewDetailsForManager?";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEmployeeReviewDetailsForManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEmployeeReviewDetailsForManager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetReviewStatusViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetReviewStatusViewDto>;
        }));
    }

    protected processGetAllEmployeeReviewDetailsForManager(response: HttpResponseBase): Observable<PagedResultDtoOfGetReviewStatusViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetReviewStatusViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetReviewStatusViewDto>(null as any);
    }

    /**
     * @param filterText (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param eMployeeId (optional) 
     * @return Success
     */
    getAllSelfReviewDetails(filterText: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined, eMployeeId: number | undefined): Observable<PagedResultDtoOfGetReviewStatusViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ReviewStatus/GetAllSelfReviewDetails?";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (eMployeeId === null)
            throw new Error("The parameter 'eMployeeId' cannot be null.");
        else if (eMployeeId !== undefined)
            url_ += "EMployeeId=" + encodeURIComponent("" + eMployeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSelfReviewDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSelfReviewDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetReviewStatusViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetReviewStatusViewDto>;
        }));
    }

    protected processGetAllSelfReviewDetails(response: HttpResponseBase): Observable<PagedResultDtoOfGetReviewStatusViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetReviewStatusViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetReviewStatusViewDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getCriteriaDataForFrontend(input: number | undefined): Observable<GetCriteriaData[]> {
        let url_ = this.baseUrl + "/api/services/app/ReviewStatus/GetCriteriaDataForFrontend?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCriteriaDataForFrontend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCriteriaDataForFrontend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCriteriaData[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCriteriaData[]>;
        }));
    }

    protected processGetCriteriaDataForFrontend(response: HttpResponseBase): Observable<GetCriteriaData[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetCriteriaData.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCriteriaData[]>(null as any);
    }

    /**
     * @param reviewId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param flag (optional) 
     * @param empid (optional) 
     * @return Success
     */
    getReviewedData(reviewId: number | undefined, fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, flag: number | undefined, empid: number | undefined): Observable<GetReviewDataForViewPopUp[]> {
        let url_ = this.baseUrl + "/api/services/app/ReviewStatus/GetReviewedData?";
        if (reviewId === null)
            throw new Error("The parameter 'reviewId' cannot be null.");
        else if (reviewId !== undefined)
            url_ += "ReviewId=" + encodeURIComponent("" + reviewId) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (flag === null)
            throw new Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        if (empid === null)
            throw new Error("The parameter 'empid' cannot be null.");
        else if (empid !== undefined)
            url_ += "empid=" + encodeURIComponent("" + empid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewedData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewedData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReviewDataForViewPopUp[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReviewDataForViewPopUp[]>;
        }));
    }

    protected processGetReviewedData(response: HttpResponseBase): Observable<GetReviewDataForViewPopUp[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetReviewDataForViewPopUp.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetReviewDataForViewPopUp[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param branchIdsList (optional) 
     * @param departmentIdsList (optional) 
     * @param employeeIdsList (optional) 
     * @param cycleNamesList (optional) 
     * @param status (optional) 
     * @return Success
     */
    getPerformanceReviewReportFromSP(tenantId: number | undefined, branchIdsList: number[] | null | undefined, departmentIdsList: number[] | null | undefined, employeeIdsList: number[] | null | undefined, cycleNamesList: string[] | null | undefined, status: string | null | undefined): Observable<GetReviewedData[]> {
        let url_ = this.baseUrl + "/api/services/app/ReviewStatus/GetPerformanceReviewReportFromSP?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (branchIdsList !== undefined && branchIdsList !== null)
            branchIdsList && branchIdsList.forEach(item => { url_ += "branchIdsList=" + encodeURIComponent("" + item) + "&"; });
        if (departmentIdsList !== undefined && departmentIdsList !== null)
            departmentIdsList && departmentIdsList.forEach(item => { url_ += "departmentIdsList=" + encodeURIComponent("" + item) + "&"; });
        if (employeeIdsList !== undefined && employeeIdsList !== null)
            employeeIdsList && employeeIdsList.forEach(item => { url_ += "employeeIdsList=" + encodeURIComponent("" + item) + "&"; });
        if (cycleNamesList !== undefined && cycleNamesList !== null)
            cycleNamesList && cycleNamesList.forEach(item => { url_ += "cycleNamesList=" + encodeURIComponent("" + item) + "&"; });
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPerformanceReviewReportFromSP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPerformanceReviewReportFromSP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReviewedData[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReviewedData[]>;
        }));
    }

    protected processGetPerformanceReviewReportFromSP(response: HttpResponseBase): Observable<GetReviewedData[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetReviewedData.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetReviewedData[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportPerformanceReviewToExcel(body: PerformanceReviewExportDto | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ReviewStatus/ExportPerformanceReviewToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPerformanceReviewToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPerformanceReviewToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportPerformanceReviewToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param reviewid (optional) 
     * @param flag (optional) 
     * @param empid (optional) 
     * @return Success
     */
    getReviewedEmployeeData(reviewid: number | undefined, flag: number | undefined, empid: number | undefined): Observable<GetCreateOrEditReviewedEmployeeData[]> {
        let url_ = this.baseUrl + "/api/services/app/ReviewStatus/GetReviewedEmployeeData?";
        if (reviewid === null)
            throw new Error("The parameter 'reviewid' cannot be null.");
        else if (reviewid !== undefined)
            url_ += "Reviewid=" + encodeURIComponent("" + reviewid) + "&";
        if (flag === null)
            throw new Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        if (empid === null)
            throw new Error("The parameter 'empid' cannot be null.");
        else if (empid !== undefined)
            url_ += "empid=" + encodeURIComponent("" + empid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewedEmployeeData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewedEmployeeData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCreateOrEditReviewedEmployeeData[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCreateOrEditReviewedEmployeeData[]>;
        }));
    }

    protected processGetReviewedEmployeeData(response: HttpResponseBase): Observable<GetCreateOrEditReviewedEmployeeData[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetCreateOrEditReviewedEmployeeData.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCreateOrEditReviewedEmployeeData[]>(null as any);
    }

    /**
     * @param reviewId (optional) 
     * @return Success
     */
    getManagerReviewForView(reviewId: number | undefined): Observable<GetReviewDataForViewPopUp[]> {
        let url_ = this.baseUrl + "/api/services/app/ReviewStatus/GetManagerReviewForView?";
        if (reviewId === null)
            throw new Error("The parameter 'reviewId' cannot be null.");
        else if (reviewId !== undefined)
            url_ += "ReviewId=" + encodeURIComponent("" + reviewId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManagerReviewForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManagerReviewForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReviewDataForViewPopUp[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReviewDataForViewPopUp[]>;
        }));
    }

    protected processGetManagerReviewForView(response: HttpResponseBase): Observable<GetReviewDataForViewPopUp[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetReviewDataForViewPopUp.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetReviewDataForViewPopUp[]>(null as any);
    }

    /**
     * @param employeeID (optional) 
     * @param reviewId (optional) 
     * @return Success
     */
    getReviewedDataForManager(employeeID: number | undefined, reviewId: number | undefined): Observable<GetReviewDataForViewPopUp[]> {
        let url_ = this.baseUrl + "/api/services/app/ReviewStatus/GetReviewedDataForManager?";
        if (employeeID === null)
            throw new Error("The parameter 'employeeID' cannot be null.");
        else if (employeeID !== undefined)
            url_ += "EmployeeID=" + encodeURIComponent("" + employeeID) + "&";
        if (reviewId === null)
            throw new Error("The parameter 'reviewId' cannot be null.");
        else if (reviewId !== undefined)
            url_ += "ReviewId=" + encodeURIComponent("" + reviewId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewedDataForManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewedDataForManager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReviewDataForViewPopUp[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReviewDataForViewPopUp[]>;
        }));
    }

    protected processGetReviewedDataForManager(response: HttpResponseBase): Observable<GetReviewDataForViewPopUp[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetReviewDataForViewPopUp.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetReviewDataForViewPopUp[]>(null as any);
    }

    /**
     * @param reviewid (optional) 
     * @param employeeid (optional) 
     * @param flag (optional) 
     * @return Success
     */
    getReviewedEmployeeDataForManager(reviewid: number | undefined, employeeid: number | undefined, flag: number | undefined): Observable<GetCreateOrEditReviewedEmployeeData[]> {
        let url_ = this.baseUrl + "/api/services/app/ReviewStatus/GetReviewedEmployeeDataForManager?";
        if (reviewid === null)
            throw new Error("The parameter 'reviewid' cannot be null.");
        else if (reviewid !== undefined)
            url_ += "Reviewid=" + encodeURIComponent("" + reviewid) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "Employeeid=" + encodeURIComponent("" + employeeid) + "&";
        if (flag === null)
            throw new Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewedEmployeeDataForManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewedEmployeeDataForManager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCreateOrEditReviewedEmployeeData[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCreateOrEditReviewedEmployeeData[]>;
        }));
    }

    protected processGetReviewedEmployeeDataForManager(response: HttpResponseBase): Observable<GetCreateOrEditReviewedEmployeeData[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetCreateOrEditReviewedEmployeeData.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCreateOrEditReviewedEmployeeData[]>(null as any);
    }

    /**
     * @param reviewId (optional) 
     * @return Success
     */
    getEmployeeIdforManager(reviewId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ReviewStatus/GetEmployeeIdforManager?";
        if (reviewId === null)
            throw new Error("The parameter 'reviewId' cannot be null.");
        else if (reviewId !== undefined)
            url_ += "reviewId=" + encodeURIComponent("" + reviewId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeIdforManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeIdforManager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetEmployeeIdforManager(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param kpikraid (optional) 
     * @param dataValue (optional) 
     * @return Success
     */
    getCountScore(kpikraid: number | undefined, dataValue: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ReviewStatus/GetCountScore?";
        if (kpikraid === null)
            throw new Error("The parameter 'kpikraid' cannot be null.");
        else if (kpikraid !== undefined)
            url_ += "kpikraid=" + encodeURIComponent("" + kpikraid) + "&";
        if (dataValue === null)
            throw new Error("The parameter 'dataValue' cannot be null.");
        else if (dataValue !== undefined)
            url_ += "dataValue=" + encodeURIComponent("" + dataValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetCountScore(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param kpikraid (optional) 
     * @param feedbackvalue (optional) 
     * @return Success
     */
    getFeedbackScore(kpikraid: number | undefined, feedbackvalue: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ReviewStatus/GetFeedbackScore?";
        if (kpikraid === null)
            throw new Error("The parameter 'kpikraid' cannot be null.");
        else if (kpikraid !== undefined)
            url_ += "kpikraid=" + encodeURIComponent("" + kpikraid) + "&";
        if (feedbackvalue === null)
            throw new Error("The parameter 'feedbackvalue' cannot be null.");
        else if (feedbackvalue !== undefined)
            url_ += "feedbackvalue=" + encodeURIComponent("" + feedbackvalue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeedbackScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeedbackScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetFeedbackScore(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param reviewId (optional) 
     * @return Success
     */
    checkEditable(reviewId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ReviewStatus/CheckEditable?";
        if (reviewId === null)
            throw new Error("The parameter 'reviewId' cannot be null.");
        else if (reviewId !== undefined)
            url_ += "ReviewId=" + encodeURIComponent("" + reviewId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckEditable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckEditable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheckEditable(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param reviewId (optional) 
     * @return Success
     */
    checkEditableForManager(reviewId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ReviewStatus/CheckEditableForManager?";
        if (reviewId === null)
            throw new Error("The parameter 'reviewId' cannot be null.");
        else if (reviewId !== undefined)
            url_ += "ReviewId=" + encodeURIComponent("" + reviewId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckEditableForManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckEditableForManager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheckEditableForManager(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    checkPendingReviewForEmployee(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ReviewStatus/CheckPendingReviewForEmployee";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckPendingReviewForEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckPendingReviewForEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheckPendingReviewForEmployee(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    checkPendingReviewForEmployeeForPopUP(): Observable<GetReviewIdForPopup[]> {
        let url_ = this.baseUrl + "/api/services/app/ReviewStatus/CheckPendingReviewForEmployeeForPopUP";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckPendingReviewForEmployeeForPopUP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckPendingReviewForEmployeeForPopUP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReviewIdForPopup[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReviewIdForPopup[]>;
        }));
    }

    protected processCheckPendingReviewForEmployeeForPopUP(response: HttpResponseBase): Observable<GetReviewIdForPopup[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetReviewIdForPopup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetReviewIdForPopup[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditForSelfReview(body: CreateOrEditReviewStatus | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReviewStatus/CreateOrEditForSelfReview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditForSelfReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditForSelfReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditForSelfReview(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param reviewType (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrEditForManagerReview(reviewType: string | null | undefined, body: CreateOrEditReviewStatus | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReviewStatus/CreateOrEditForManagerReview?";
        if (reviewType !== undefined && reviewType !== null)
            url_ += "reviewType=" + encodeURIComponent("" + reviewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditForManagerReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditForManagerReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEditForManagerReview(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReviewStatus/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param reviewid (optional) 
     * @param employeeid (optional) 
     * @param flag (optional) 
     * @return Success
     */
    generatePdfManagerReview(reviewid: number | undefined, employeeid: number | undefined, flag: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ReviewStatus/GeneratePdfManagerReview?";
        if (reviewid === null)
            throw new Error("The parameter 'reviewid' cannot be null.");
        else if (reviewid !== undefined)
            url_ += "Reviewid=" + encodeURIComponent("" + reviewid) + "&";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "Employeeid=" + encodeURIComponent("" + employeeid) + "&";
        if (flag === null)
            throw new Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneratePdfManagerReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratePdfManagerReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGeneratePdfManagerReview(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @param date (optional) 
     * @return Success
     */
    formatDate(date: moment.Moment | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ReviewStatus/FormatDate?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFormatDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFormatDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFormatDate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveScoreSetup(body: ScoreDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReviewStatus/SaveScoreSetup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveScoreSetup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveScoreSetup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveScoreSetup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getScoresSetup(): Observable<CommonScoreSetup> {
        let url_ = this.baseUrl + "/api/services/app/ReviewStatus/GetScoresSetup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScoresSetup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScoresSetup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonScoreSetup>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonScoreSetup>;
        }));
    }

    protected processGetScoresSetup(response: HttpResponseBase): Observable<CommonScoreSetup> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonScoreSetup.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommonScoreSetup>(null as any);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getRoles(permission: string | null | undefined): Observable<ListResultDtoOfRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission !== undefined && permission !== null)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfRoleListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfRoleListDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<ListResultDtoOfRoleListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfRoleListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfRoleListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | null | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRoleForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateRole(body: CreateOrUpdateRoleInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/CreateOrUpdateRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteRole(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/DeleteRole?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class RosterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getRosteringShiftData(body: GetRosterDataParam | undefined): Observable<GetRosterDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Roster/GetRosteringShiftData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRosteringShiftData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRosteringShiftData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRosterDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRosterDataDto[]>;
        }));
    }

    protected processGetRosteringShiftData(response: HttpResponseBase): Observable<GetRosterDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetRosterDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRosterDataDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateShifts(body: UpdateShiftsDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Roster/UpdateShifts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateShifts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateShifts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateShifts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class SalariesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getReimbursement(month: number | undefined, year: number | undefined): Observable<GetReimbursementDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Salaries/GetReimbursement?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReimbursement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReimbursement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReimbursementDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReimbursementDto[]>;
        }));
    }

    protected processGetReimbursement(response: HttpResponseBase): Observable<GetReimbursementDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetReimbursementDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetReimbursementDto[]>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getOnholdsalary(month: number | undefined, year: number | undefined): Observable<GetOnholdsalaryDto> {
        let url_ = this.baseUrl + "/api/services/app/Salaries/GetOnholdsalary?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnholdsalary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnholdsalary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOnholdsalaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOnholdsalaryDto>;
        }));
    }

    protected processGetOnholdsalary(response: HttpResponseBase): Observable<GetOnholdsalaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOnholdsalaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOnholdsalaryDto>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param query (optional) 
     * @return Success
     */
    processLateComingRecord(month: number | undefined, year: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined, query: string | null | undefined): Observable<PagedResultDtoOfProcessLateComing> {
        let url_ = this.baseUrl + "/api/services/app/Salaries/ProcessLateComingRecord?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessLateComingRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessLateComingRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfProcessLateComing>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfProcessLateComing>;
        }));
    }

    protected processProcessLateComingRecord(response: HttpResponseBase): Observable<PagedResultDtoOfProcessLateComing> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfProcessLateComing.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfProcessLateComing>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getOnholdsalaryForGrid(month: number | undefined, year: number | undefined): Observable<GetOnholdsalaryForGridDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Salaries/GetOnholdsalaryForGrid?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnholdsalaryForGrid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnholdsalaryForGrid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOnholdsalaryForGridDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOnholdsalaryForGridDto[]>;
        }));
    }

    protected processGetOnholdsalaryForGrid(response: HttpResponseBase): Observable<GetOnholdsalaryForGridDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetOnholdsalaryForGridDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOnholdsalaryForGridDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOnholdSalaryForEdit(id: number | undefined): Observable<CreateOrEditOnHoldSalary> {
        let url_ = this.baseUrl + "/api/services/app/Salaries/GetOnholdSalaryForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnholdSalaryForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnholdSalaryForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditOnHoldSalary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditOnHoldSalary>;
        }));
    }

    protected processGetOnholdSalaryForEdit(response: HttpResponseBase): Observable<CreateOrEditOnHoldSalary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditOnHoldSalary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditOnHoldSalary>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOnHold(body: CreateOrEditOnHoldSalary | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Salaries/CreateOnHold";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOnHold(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOnHold(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOnHold(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateOnHold(body: CreateOrEditOnHoldSalary | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Salaries/UpdateOnHold";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOnHold(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOnHold(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOnHold(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @param filter (optional) 
     * @return Success
     */
    getAllReimbursementData(month: number | undefined, year: number | undefined, filter: string | null | undefined): Observable<GetReimbursementViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Salaries/GetAllReimbursementData?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllReimbursementData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReimbursementData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReimbursementViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReimbursementViewDto[]>;
        }));
    }

    protected processGetAllReimbursementData(response: HttpResponseBase): Observable<GetReimbursementViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetReimbursementViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetReimbursementViewDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveReimbursement(body: GetReimbursementViewDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Salaries/SaveReimbursement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveReimbursement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveReimbursement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveReimbursement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getAllSalary(month: number | undefined, year: number | undefined): Observable<Salarydata[]> {
        let url_ = this.baseUrl + "/api/services/app/Salaries/GetAllSalary?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSalary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSalary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Salarydata[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Salarydata[]>;
        }));
    }

    protected processGetAllSalary(response: HttpResponseBase): Observable<Salarydata[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Salarydata.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Salarydata[]>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getAllSalaryPrev(month: number | undefined, year: number | undefined): Observable<Salarydata[]> {
        let url_ = this.baseUrl + "/api/services/app/Salaries/GetAllSalaryPrev?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSalaryPrev(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSalaryPrev(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Salarydata[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Salarydata[]>;
        }));
    }

    protected processGetAllSalaryPrev(response: HttpResponseBase): Observable<Salarydata[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Salarydata.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Salarydata[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxmonthyearFilter (optional) 
     * @param minmonthyearFilter (optional) 
     * @param maxBranchFilter (optional) 
     * @param minBranchFilter (optional) 
     * @param maxEmployeeIdFilter (optional) 
     * @param minEmployeeIdFilter (optional) 
     * @param maxPresentFilter (optional) 
     * @param minPresentFilter (optional) 
     * @param maxWeekOffFilter (optional) 
     * @param minWeekOffFilter (optional) 
     * @param maxHolidayFilter (optional) 
     * @param minHolidayFilter (optional) 
     * @param maxLeavesFilter (optional) 
     * @param minLeavesFilter (optional) 
     * @param maxEarningsFilter (optional) 
     * @param minEarningsFilter (optional) 
     * @param maxDeductionsFilter (optional) 
     * @param minDeductionsFilter (optional) 
     * @param maxnetPayFilter (optional) 
     * @param minnetPayFilter (optional) 
     * @param onHoldFilter (optional) 
     * @param hRApprovedFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxmonthyearFilter: number | null | undefined, minmonthyearFilter: number | null | undefined, maxBranchFilter: number | null | undefined, minBranchFilter: number | null | undefined, maxEmployeeIdFilter: number | null | undefined, minEmployeeIdFilter: number | null | undefined, maxPresentFilter: number | null | undefined, minPresentFilter: number | null | undefined, maxWeekOffFilter: number | null | undefined, minWeekOffFilter: number | null | undefined, maxHolidayFilter: number | null | undefined, minHolidayFilter: number | null | undefined, maxLeavesFilter: number | null | undefined, minLeavesFilter: number | null | undefined, maxEarningsFilter: number | null | undefined, minEarningsFilter: number | null | undefined, maxDeductionsFilter: number | null | undefined, minDeductionsFilter: number | null | undefined, maxnetPayFilter: number | null | undefined, minnetPayFilter: number | null | undefined, onHoldFilter: number | null | undefined, hRApprovedFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSalaryForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Salaries/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxmonthyearFilter !== undefined && maxmonthyearFilter !== null)
            url_ += "MaxmonthyearFilter=" + encodeURIComponent("" + maxmonthyearFilter) + "&";
        if (minmonthyearFilter !== undefined && minmonthyearFilter !== null)
            url_ += "MinmonthyearFilter=" + encodeURIComponent("" + minmonthyearFilter) + "&";
        if (maxBranchFilter !== undefined && maxBranchFilter !== null)
            url_ += "MaxBranchFilter=" + encodeURIComponent("" + maxBranchFilter) + "&";
        if (minBranchFilter !== undefined && minBranchFilter !== null)
            url_ += "MinBranchFilter=" + encodeURIComponent("" + minBranchFilter) + "&";
        if (maxEmployeeIdFilter !== undefined && maxEmployeeIdFilter !== null)
            url_ += "MaxEmployeeIdFilter=" + encodeURIComponent("" + maxEmployeeIdFilter) + "&";
        if (minEmployeeIdFilter !== undefined && minEmployeeIdFilter !== null)
            url_ += "MinEmployeeIdFilter=" + encodeURIComponent("" + minEmployeeIdFilter) + "&";
        if (maxPresentFilter !== undefined && maxPresentFilter !== null)
            url_ += "MaxPresentFilter=" + encodeURIComponent("" + maxPresentFilter) + "&";
        if (minPresentFilter !== undefined && minPresentFilter !== null)
            url_ += "MinPresentFilter=" + encodeURIComponent("" + minPresentFilter) + "&";
        if (maxWeekOffFilter !== undefined && maxWeekOffFilter !== null)
            url_ += "MaxWeekOffFilter=" + encodeURIComponent("" + maxWeekOffFilter) + "&";
        if (minWeekOffFilter !== undefined && minWeekOffFilter !== null)
            url_ += "MinWeekOffFilter=" + encodeURIComponent("" + minWeekOffFilter) + "&";
        if (maxHolidayFilter !== undefined && maxHolidayFilter !== null)
            url_ += "MaxHolidayFilter=" + encodeURIComponent("" + maxHolidayFilter) + "&";
        if (minHolidayFilter !== undefined && minHolidayFilter !== null)
            url_ += "MinHolidayFilter=" + encodeURIComponent("" + minHolidayFilter) + "&";
        if (maxLeavesFilter !== undefined && maxLeavesFilter !== null)
            url_ += "MaxLeavesFilter=" + encodeURIComponent("" + maxLeavesFilter) + "&";
        if (minLeavesFilter !== undefined && minLeavesFilter !== null)
            url_ += "MinLeavesFilter=" + encodeURIComponent("" + minLeavesFilter) + "&";
        if (maxEarningsFilter !== undefined && maxEarningsFilter !== null)
            url_ += "MaxEarningsFilter=" + encodeURIComponent("" + maxEarningsFilter) + "&";
        if (minEarningsFilter !== undefined && minEarningsFilter !== null)
            url_ += "MinEarningsFilter=" + encodeURIComponent("" + minEarningsFilter) + "&";
        if (maxDeductionsFilter !== undefined && maxDeductionsFilter !== null)
            url_ += "MaxDeductionsFilter=" + encodeURIComponent("" + maxDeductionsFilter) + "&";
        if (minDeductionsFilter !== undefined && minDeductionsFilter !== null)
            url_ += "MinDeductionsFilter=" + encodeURIComponent("" + minDeductionsFilter) + "&";
        if (maxnetPayFilter !== undefined && maxnetPayFilter !== null)
            url_ += "MaxnetPayFilter=" + encodeURIComponent("" + maxnetPayFilter) + "&";
        if (minnetPayFilter !== undefined && minnetPayFilter !== null)
            url_ += "MinnetPayFilter=" + encodeURIComponent("" + minnetPayFilter) + "&";
        if (onHoldFilter !== undefined && onHoldFilter !== null)
            url_ += "OnHoldFilter=" + encodeURIComponent("" + onHoldFilter) + "&";
        if (hRApprovedFilter !== undefined && hRApprovedFilter !== null)
            url_ += "HRApprovedFilter=" + encodeURIComponent("" + hRApprovedFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetSalaryForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetSalaryForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSalaryForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSalaryForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSalaryForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSalaryForView(id: number | undefined): Observable<GetSalaryForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Salaries/GetSalaryForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalaryForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalaryForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSalaryForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSalaryForViewDto>;
        }));
    }

    protected processGetSalaryForView(response: HttpResponseBase): Observable<GetSalaryForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSalaryForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSalaryForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSalaryForEdit(id: number | undefined): Observable<GetSalaryForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Salaries/GetSalaryForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalaryForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalaryForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSalaryForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSalaryForEditOutput>;
        }));
    }

    protected processGetSalaryForEdit(response: HttpResponseBase): Observable<GetSalaryForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSalaryForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSalaryForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditSalaryDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Salaries/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Salaries/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxmonthyearFilter (optional) 
     * @param minmonthyearFilter (optional) 
     * @param maxBranchFilter (optional) 
     * @param minBranchFilter (optional) 
     * @param maxEmployeeIdFilter (optional) 
     * @param minEmployeeIdFilter (optional) 
     * @param maxPresentFilter (optional) 
     * @param minPresentFilter (optional) 
     * @param maxWeekOffFilter (optional) 
     * @param minWeekOffFilter (optional) 
     * @param maxHolidayFilter (optional) 
     * @param minHolidayFilter (optional) 
     * @param maxLeavesFilter (optional) 
     * @param minLeavesFilter (optional) 
     * @param maxEarningsFilter (optional) 
     * @param minEarningsFilter (optional) 
     * @param maxDeductionsFilter (optional) 
     * @param minDeductionsFilter (optional) 
     * @param maxnetPayFilter (optional) 
     * @param minnetPayFilter (optional) 
     * @param onHoldFilter (optional) 
     * @param hRApprovedFilter (optional) 
     * @return Success
     */
    getSalariesToExcel(filter: string | null | undefined, maxmonthyearFilter: number | null | undefined, minmonthyearFilter: number | null | undefined, maxBranchFilter: number | null | undefined, minBranchFilter: number | null | undefined, maxEmployeeIdFilter: number | null | undefined, minEmployeeIdFilter: number | null | undefined, maxPresentFilter: number | null | undefined, minPresentFilter: number | null | undefined, maxWeekOffFilter: number | null | undefined, minWeekOffFilter: number | null | undefined, maxHolidayFilter: number | null | undefined, minHolidayFilter: number | null | undefined, maxLeavesFilter: number | null | undefined, minLeavesFilter: number | null | undefined, maxEarningsFilter: number | null | undefined, minEarningsFilter: number | null | undefined, maxDeductionsFilter: number | null | undefined, minDeductionsFilter: number | null | undefined, maxnetPayFilter: number | null | undefined, minnetPayFilter: number | null | undefined, onHoldFilter: number | null | undefined, hRApprovedFilter: number | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Salaries/GetSalariesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxmonthyearFilter !== undefined && maxmonthyearFilter !== null)
            url_ += "MaxmonthyearFilter=" + encodeURIComponent("" + maxmonthyearFilter) + "&";
        if (minmonthyearFilter !== undefined && minmonthyearFilter !== null)
            url_ += "MinmonthyearFilter=" + encodeURIComponent("" + minmonthyearFilter) + "&";
        if (maxBranchFilter !== undefined && maxBranchFilter !== null)
            url_ += "MaxBranchFilter=" + encodeURIComponent("" + maxBranchFilter) + "&";
        if (minBranchFilter !== undefined && minBranchFilter !== null)
            url_ += "MinBranchFilter=" + encodeURIComponent("" + minBranchFilter) + "&";
        if (maxEmployeeIdFilter !== undefined && maxEmployeeIdFilter !== null)
            url_ += "MaxEmployeeIdFilter=" + encodeURIComponent("" + maxEmployeeIdFilter) + "&";
        if (minEmployeeIdFilter !== undefined && minEmployeeIdFilter !== null)
            url_ += "MinEmployeeIdFilter=" + encodeURIComponent("" + minEmployeeIdFilter) + "&";
        if (maxPresentFilter !== undefined && maxPresentFilter !== null)
            url_ += "MaxPresentFilter=" + encodeURIComponent("" + maxPresentFilter) + "&";
        if (minPresentFilter !== undefined && minPresentFilter !== null)
            url_ += "MinPresentFilter=" + encodeURIComponent("" + minPresentFilter) + "&";
        if (maxWeekOffFilter !== undefined && maxWeekOffFilter !== null)
            url_ += "MaxWeekOffFilter=" + encodeURIComponent("" + maxWeekOffFilter) + "&";
        if (minWeekOffFilter !== undefined && minWeekOffFilter !== null)
            url_ += "MinWeekOffFilter=" + encodeURIComponent("" + minWeekOffFilter) + "&";
        if (maxHolidayFilter !== undefined && maxHolidayFilter !== null)
            url_ += "MaxHolidayFilter=" + encodeURIComponent("" + maxHolidayFilter) + "&";
        if (minHolidayFilter !== undefined && minHolidayFilter !== null)
            url_ += "MinHolidayFilter=" + encodeURIComponent("" + minHolidayFilter) + "&";
        if (maxLeavesFilter !== undefined && maxLeavesFilter !== null)
            url_ += "MaxLeavesFilter=" + encodeURIComponent("" + maxLeavesFilter) + "&";
        if (minLeavesFilter !== undefined && minLeavesFilter !== null)
            url_ += "MinLeavesFilter=" + encodeURIComponent("" + minLeavesFilter) + "&";
        if (maxEarningsFilter !== undefined && maxEarningsFilter !== null)
            url_ += "MaxEarningsFilter=" + encodeURIComponent("" + maxEarningsFilter) + "&";
        if (minEarningsFilter !== undefined && minEarningsFilter !== null)
            url_ += "MinEarningsFilter=" + encodeURIComponent("" + minEarningsFilter) + "&";
        if (maxDeductionsFilter !== undefined && maxDeductionsFilter !== null)
            url_ += "MaxDeductionsFilter=" + encodeURIComponent("" + maxDeductionsFilter) + "&";
        if (minDeductionsFilter !== undefined && minDeductionsFilter !== null)
            url_ += "MinDeductionsFilter=" + encodeURIComponent("" + minDeductionsFilter) + "&";
        if (maxnetPayFilter !== undefined && maxnetPayFilter !== null)
            url_ += "MaxnetPayFilter=" + encodeURIComponent("" + maxnetPayFilter) + "&";
        if (minnetPayFilter !== undefined && minnetPayFilter !== null)
            url_ += "MinnetPayFilter=" + encodeURIComponent("" + minnetPayFilter) + "&";
        if (onHoldFilter !== undefined && onHoldFilter !== null)
            url_ += "OnHoldFilter=" + encodeURIComponent("" + onHoldFilter) + "&";
        if (hRApprovedFilter !== undefined && hRApprovedFilter !== null)
            url_ += "HRApprovedFilter=" + encodeURIComponent("" + hRApprovedFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalariesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalariesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetSalariesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    salaryProcess(month: number | undefined, year: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Salaries/SalaryProcess?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalaryProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalaryProcess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSalaryProcess(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param year (optional) 
     * @param month (optional) 
     * @return Success
     */
    getArrearsReport(year: number | undefined, month: number | undefined): Observable<ArrearsReportDTO[]> {
        let url_ = this.baseUrl + "/api/services/app/Salaries/GetArrearsReport?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArrearsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArrearsReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArrearsReportDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArrearsReportDTO[]>;
        }));
    }

    protected processGetArrearsReport(response: HttpResponseBase): Observable<ArrearsReportDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArrearsReportDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArrearsReportDTO[]>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @param year (optional) 
     * @param month (optional) 
     * @return Success
     */
    getEmployeePayComponentsForEdit(employeeId: number | undefined, year: number | undefined, month: number | undefined): Observable<PayComponentDTO[]> {
        let url_ = this.baseUrl + "/api/services/app/Salaries/GetEmployeePayComponentsForEdit?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeePayComponentsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeePayComponentsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayComponentDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayComponentDTO[]>;
        }));
    }

    protected processGetEmployeePayComponentsForEdit(response: HttpResponseBase): Observable<PayComponentDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PayComponentDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PayComponentDTO[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param employeeId (optional) 
     * @param monthYear (optional) 
     * @return Success
     */
    getArrearsDetails(tenantId: number | undefined, employeeId: number | undefined, monthYear: string | null | undefined): Observable<ArrearsDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Salaries/GetArrearsDetails?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArrearsDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArrearsDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArrearsDetailsResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArrearsDetailsResponseDto>;
        }));
    }

    protected processGetArrearsDetails(response: HttpResponseBase): Observable<ArrearsDetailsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArrearsDetailsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArrearsDetailsResponseDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param employeeId (optional) 
     * @param monthYear (optional) 
     * @return Success
     */
    getArrearsDetailsForView(tenantId: number | undefined, employeeId: number | undefined, monthYear: string | null | undefined): Observable<ArrearsDetailsResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Salaries/GetArrearsDetailsForView?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (monthYear !== undefined && monthYear !== null)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArrearsDetailsForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArrearsDetailsForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArrearsDetailsResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArrearsDetailsResponseDto>;
        }));
    }

    protected processGetArrearsDetailsForView(response: HttpResponseBase): Observable<ArrearsDetailsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArrearsDetailsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArrearsDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveArrears(body: SaveArrearsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Salaries/SaveArrears";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveArrears(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveArrears(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveArrears(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param reqId (optional) 
     * @return Success
     */
    getPendingManualArrearApprovals(reqId: number | undefined): Observable<ManualArrearApprovalDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Salaries/GetPendingManualArrearApprovals?";
        if (reqId === null)
            throw new Error("The parameter 'reqId' cannot be null.");
        else if (reqId !== undefined)
            url_ += "reqId=" + encodeURIComponent("" + reqId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingManualArrearApprovals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingManualArrearApprovals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ManualArrearApprovalDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ManualArrearApprovalDto[]>;
        }));
    }

    protected processGetPendingManualArrearApprovals(response: HttpResponseBase): Observable<ManualArrearApprovalDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ManualArrearApprovalDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ManualArrearApprovalDto[]>(null as any);
    }
}

@Injectable()
export class SalaryAdvancesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param policyNameFilter (optional) 
     * @param maxAdvanceEligibilityFilter (optional) 
     * @param minAdvanceEligibilityFilter (optional) 
     * @param maxMaximumNoOfEMIFilter (optional) 
     * @param minMaximumNoOfEMIFilter (optional) 
     * @param maxRateOfIntrestFilter (optional) 
     * @param minRateOfIntrestFilter (optional) 
     * @param allowExceptionFilter (optional) 
     * @param maxPayComponentIdFilter (optional) 
     * @param minPayComponentIdFilter (optional) 
     * @param advanceTypeTypeFilter (optional) 
     * @param payGradeNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, policyNameFilter: string | null | undefined, maxAdvanceEligibilityFilter: number | null | undefined, minAdvanceEligibilityFilter: number | null | undefined, maxMaximumNoOfEMIFilter: number | null | undefined, minMaximumNoOfEMIFilter: number | null | undefined, maxRateOfIntrestFilter: number | null | undefined, minRateOfIntrestFilter: number | null | undefined, allowExceptionFilter: number | null | undefined, maxPayComponentIdFilter: number | null | undefined, minPayComponentIdFilter: number | null | undefined, advanceTypeTypeFilter: string | null | undefined, payGradeNameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSalaryAdvanceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SalaryAdvances/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (policyNameFilter !== undefined && policyNameFilter !== null)
            url_ += "PolicyNameFilter=" + encodeURIComponent("" + policyNameFilter) + "&";
        if (maxAdvanceEligibilityFilter !== undefined && maxAdvanceEligibilityFilter !== null)
            url_ += "MaxAdvanceEligibilityFilter=" + encodeURIComponent("" + maxAdvanceEligibilityFilter) + "&";
        if (minAdvanceEligibilityFilter !== undefined && minAdvanceEligibilityFilter !== null)
            url_ += "MinAdvanceEligibilityFilter=" + encodeURIComponent("" + minAdvanceEligibilityFilter) + "&";
        if (maxMaximumNoOfEMIFilter !== undefined && maxMaximumNoOfEMIFilter !== null)
            url_ += "MaxMaximumNoOfEMIFilter=" + encodeURIComponent("" + maxMaximumNoOfEMIFilter) + "&";
        if (minMaximumNoOfEMIFilter !== undefined && minMaximumNoOfEMIFilter !== null)
            url_ += "MinMaximumNoOfEMIFilter=" + encodeURIComponent("" + minMaximumNoOfEMIFilter) + "&";
        if (maxRateOfIntrestFilter !== undefined && maxRateOfIntrestFilter !== null)
            url_ += "MaxRateOfIntrestFilter=" + encodeURIComponent("" + maxRateOfIntrestFilter) + "&";
        if (minRateOfIntrestFilter !== undefined && minRateOfIntrestFilter !== null)
            url_ += "MinRateOfIntrestFilter=" + encodeURIComponent("" + minRateOfIntrestFilter) + "&";
        if (allowExceptionFilter !== undefined && allowExceptionFilter !== null)
            url_ += "AllowExceptionFilter=" + encodeURIComponent("" + allowExceptionFilter) + "&";
        if (maxPayComponentIdFilter !== undefined && maxPayComponentIdFilter !== null)
            url_ += "MaxPayComponentIdFilter=" + encodeURIComponent("" + maxPayComponentIdFilter) + "&";
        if (minPayComponentIdFilter !== undefined && minPayComponentIdFilter !== null)
            url_ += "MinPayComponentIdFilter=" + encodeURIComponent("" + minPayComponentIdFilter) + "&";
        if (advanceTypeTypeFilter !== undefined && advanceTypeTypeFilter !== null)
            url_ += "AdvanceTypeTypeFilter=" + encodeURIComponent("" + advanceTypeTypeFilter) + "&";
        if (payGradeNameFilter !== undefined && payGradeNameFilter !== null)
            url_ += "PayGradeNameFilter=" + encodeURIComponent("" + payGradeNameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetSalaryAdvanceForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetSalaryAdvanceForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSalaryAdvanceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSalaryAdvanceForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSalaryAdvanceForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSalaryAdvanceForView(id: number | undefined): Observable<GetSalaryAdvanceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SalaryAdvances/GetSalaryAdvanceForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalaryAdvanceForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalaryAdvanceForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSalaryAdvanceForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSalaryAdvanceForViewDto>;
        }));
    }

    protected processGetSalaryAdvanceForView(response: HttpResponseBase): Observable<GetSalaryAdvanceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSalaryAdvanceForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSalaryAdvanceForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSalaryAdvanceForEdit(id: number | undefined): Observable<GetSalaryAdvanceForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SalaryAdvances/GetSalaryAdvanceForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalaryAdvanceForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalaryAdvanceForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSalaryAdvanceForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSalaryAdvanceForEditOutput>;
        }));
    }

    protected processGetSalaryAdvanceForEdit(response: HttpResponseBase): Observable<GetSalaryAdvanceForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSalaryAdvanceForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSalaryAdvanceForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditSalaryAdvanceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalaryAdvances/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalaryAdvances/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param policyNameFilter (optional) 
     * @param maxAdvanceEligibilityFilter (optional) 
     * @param minAdvanceEligibilityFilter (optional) 
     * @param maxMaximumNoOfEMIFilter (optional) 
     * @param minMaximumNoOfEMIFilter (optional) 
     * @param maxRateOfIntrestFilter (optional) 
     * @param minRateOfIntrestFilter (optional) 
     * @param allowExceptionFilter (optional) 
     * @param maxPayComponentIdFilter (optional) 
     * @param minPayComponentIdFilter (optional) 
     * @param advanceTypeTypeFilter (optional) 
     * @param payGradeNameFilter (optional) 
     * @return Success
     */
    getSalaryAdvancesToExcel(filter: string | null | undefined, policyNameFilter: string | null | undefined, maxAdvanceEligibilityFilter: number | null | undefined, minAdvanceEligibilityFilter: number | null | undefined, maxMaximumNoOfEMIFilter: number | null | undefined, minMaximumNoOfEMIFilter: number | null | undefined, maxRateOfIntrestFilter: number | null | undefined, minRateOfIntrestFilter: number | null | undefined, allowExceptionFilter: number | null | undefined, maxPayComponentIdFilter: number | null | undefined, minPayComponentIdFilter: number | null | undefined, advanceTypeTypeFilter: string | null | undefined, payGradeNameFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SalaryAdvances/GetSalaryAdvancesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (policyNameFilter !== undefined && policyNameFilter !== null)
            url_ += "PolicyNameFilter=" + encodeURIComponent("" + policyNameFilter) + "&";
        if (maxAdvanceEligibilityFilter !== undefined && maxAdvanceEligibilityFilter !== null)
            url_ += "MaxAdvanceEligibilityFilter=" + encodeURIComponent("" + maxAdvanceEligibilityFilter) + "&";
        if (minAdvanceEligibilityFilter !== undefined && minAdvanceEligibilityFilter !== null)
            url_ += "MinAdvanceEligibilityFilter=" + encodeURIComponent("" + minAdvanceEligibilityFilter) + "&";
        if (maxMaximumNoOfEMIFilter !== undefined && maxMaximumNoOfEMIFilter !== null)
            url_ += "MaxMaximumNoOfEMIFilter=" + encodeURIComponent("" + maxMaximumNoOfEMIFilter) + "&";
        if (minMaximumNoOfEMIFilter !== undefined && minMaximumNoOfEMIFilter !== null)
            url_ += "MinMaximumNoOfEMIFilter=" + encodeURIComponent("" + minMaximumNoOfEMIFilter) + "&";
        if (maxRateOfIntrestFilter !== undefined && maxRateOfIntrestFilter !== null)
            url_ += "MaxRateOfIntrestFilter=" + encodeURIComponent("" + maxRateOfIntrestFilter) + "&";
        if (minRateOfIntrestFilter !== undefined && minRateOfIntrestFilter !== null)
            url_ += "MinRateOfIntrestFilter=" + encodeURIComponent("" + minRateOfIntrestFilter) + "&";
        if (allowExceptionFilter !== undefined && allowExceptionFilter !== null)
            url_ += "AllowExceptionFilter=" + encodeURIComponent("" + allowExceptionFilter) + "&";
        if (maxPayComponentIdFilter !== undefined && maxPayComponentIdFilter !== null)
            url_ += "MaxPayComponentIdFilter=" + encodeURIComponent("" + maxPayComponentIdFilter) + "&";
        if (minPayComponentIdFilter !== undefined && minPayComponentIdFilter !== null)
            url_ += "MinPayComponentIdFilter=" + encodeURIComponent("" + minPayComponentIdFilter) + "&";
        if (advanceTypeTypeFilter !== undefined && advanceTypeTypeFilter !== null)
            url_ += "AdvanceTypeTypeFilter=" + encodeURIComponent("" + advanceTypeTypeFilter) + "&";
        if (payGradeNameFilter !== undefined && payGradeNameFilter !== null)
            url_ += "PayGradeNameFilter=" + encodeURIComponent("" + payGradeNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalaryAdvancesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalaryAdvancesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetSalaryAdvancesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllAdvanceTypeForTableDropdown(): Observable<SalaryAdvanceAdvanceTypeLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SalaryAdvances/GetAllAdvanceTypeForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAdvanceTypeForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAdvanceTypeForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalaryAdvanceAdvanceTypeLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalaryAdvanceAdvanceTypeLookupTableDto[]>;
        }));
    }

    protected processGetAllAdvanceTypeForTableDropdown(response: HttpResponseBase): Observable<SalaryAdvanceAdvanceTypeLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalaryAdvanceAdvanceTypeLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SalaryAdvanceAdvanceTypeLookupTableDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllPayGradeForTableDropdown(): Observable<SalaryAdvancePayGradeLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SalaryAdvances/GetAllPayGradeForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPayGradeForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPayGradeForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalaryAdvancePayGradeLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalaryAdvancePayGradeLookupTableDto[]>;
        }));
    }

    protected processGetAllPayGradeForTableDropdown(response: HttpResponseBase): Observable<SalaryAdvancePayGradeLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalaryAdvancePayGradeLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SalaryAdvancePayGradeLookupTableDto[]>(null as any);
    }

    /**
     * @param payGrade (optional) 
     * @return Success
     */
    getpayComponent(payGrade: number | undefined): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/SalaryAdvances/GetpayComponent?";
        if (payGrade === null)
            throw new Error("The parameter 'payGrade' cannot be null.");
        else if (payGrade !== undefined)
            url_ += "payGrade=" + encodeURIComponent("" + payGrade) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetpayComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetpayComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetpayComponent(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }
}

@Injectable()
export class SalaryDetialsesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxmonthyearFilter (optional) 
     * @param minmonthyearFilter (optional) 
     * @param maxemployeeidFilter (optional) 
     * @param minemployeeidFilter (optional) 
     * @param maxpaycomponentFilter (optional) 
     * @param minpaycomponentFilter (optional) 
     * @param maxStandardFilter (optional) 
     * @param minStandardFilter (optional) 
     * @param maxActualFilter (optional) 
     * @param minActualFilter (optional) 
     * @param maxSalaryIdFilter (optional) 
     * @param minSalaryIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxmonthyearFilter: number | null | undefined, minmonthyearFilter: number | null | undefined, maxemployeeidFilter: number | null | undefined, minemployeeidFilter: number | null | undefined, maxpaycomponentFilter: number | null | undefined, minpaycomponentFilter: number | null | undefined, maxStandardFilter: number | null | undefined, minStandardFilter: number | null | undefined, maxActualFilter: number | null | undefined, minActualFilter: number | null | undefined, maxSalaryIdFilter: number | null | undefined, minSalaryIdFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSalaryDetialsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SalaryDetialses/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxmonthyearFilter !== undefined && maxmonthyearFilter !== null)
            url_ += "MaxmonthyearFilter=" + encodeURIComponent("" + maxmonthyearFilter) + "&";
        if (minmonthyearFilter !== undefined && minmonthyearFilter !== null)
            url_ += "MinmonthyearFilter=" + encodeURIComponent("" + minmonthyearFilter) + "&";
        if (maxemployeeidFilter !== undefined && maxemployeeidFilter !== null)
            url_ += "MaxemployeeidFilter=" + encodeURIComponent("" + maxemployeeidFilter) + "&";
        if (minemployeeidFilter !== undefined && minemployeeidFilter !== null)
            url_ += "MinemployeeidFilter=" + encodeURIComponent("" + minemployeeidFilter) + "&";
        if (maxpaycomponentFilter !== undefined && maxpaycomponentFilter !== null)
            url_ += "MaxpaycomponentFilter=" + encodeURIComponent("" + maxpaycomponentFilter) + "&";
        if (minpaycomponentFilter !== undefined && minpaycomponentFilter !== null)
            url_ += "MinpaycomponentFilter=" + encodeURIComponent("" + minpaycomponentFilter) + "&";
        if (maxStandardFilter !== undefined && maxStandardFilter !== null)
            url_ += "MaxStandardFilter=" + encodeURIComponent("" + maxStandardFilter) + "&";
        if (minStandardFilter !== undefined && minStandardFilter !== null)
            url_ += "MinStandardFilter=" + encodeURIComponent("" + minStandardFilter) + "&";
        if (maxActualFilter !== undefined && maxActualFilter !== null)
            url_ += "MaxActualFilter=" + encodeURIComponent("" + maxActualFilter) + "&";
        if (minActualFilter !== undefined && minActualFilter !== null)
            url_ += "MinActualFilter=" + encodeURIComponent("" + minActualFilter) + "&";
        if (maxSalaryIdFilter !== undefined && maxSalaryIdFilter !== null)
            url_ += "MaxSalaryIdFilter=" + encodeURIComponent("" + maxSalaryIdFilter) + "&";
        if (minSalaryIdFilter !== undefined && minSalaryIdFilter !== null)
            url_ += "MinSalaryIdFilter=" + encodeURIComponent("" + minSalaryIdFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetSalaryDetialsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetSalaryDetialsForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSalaryDetialsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSalaryDetialsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSalaryDetialsForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSalaryDetialsForView(id: number | undefined): Observable<GetSalaryDetialsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SalaryDetialses/GetSalaryDetialsForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalaryDetialsForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalaryDetialsForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSalaryDetialsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSalaryDetialsForViewDto>;
        }));
    }

    protected processGetSalaryDetialsForView(response: HttpResponseBase): Observable<GetSalaryDetialsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSalaryDetialsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSalaryDetialsForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSalaryDetialsForEdit(id: number | undefined): Observable<GetSalaryDetialsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SalaryDetialses/GetSalaryDetialsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalaryDetialsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalaryDetialsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSalaryDetialsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSalaryDetialsForEditOutput>;
        }));
    }

    protected processGetSalaryDetialsForEdit(response: HttpResponseBase): Observable<GetSalaryDetialsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSalaryDetialsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSalaryDetialsForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditSalaryDetialsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalaryDetialses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalaryDetialses/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxmonthyearFilter (optional) 
     * @param minmonthyearFilter (optional) 
     * @param maxemployeeidFilter (optional) 
     * @param minemployeeidFilter (optional) 
     * @param maxpaycomponentFilter (optional) 
     * @param minpaycomponentFilter (optional) 
     * @param maxStandardFilter (optional) 
     * @param minStandardFilter (optional) 
     * @param maxActualFilter (optional) 
     * @param minActualFilter (optional) 
     * @param maxSalaryIdFilter (optional) 
     * @param minSalaryIdFilter (optional) 
     * @return Success
     */
    getSalaryDetialsesToExcel(filter: string | null | undefined, maxmonthyearFilter: number | null | undefined, minmonthyearFilter: number | null | undefined, maxemployeeidFilter: number | null | undefined, minemployeeidFilter: number | null | undefined, maxpaycomponentFilter: number | null | undefined, minpaycomponentFilter: number | null | undefined, maxStandardFilter: number | null | undefined, minStandardFilter: number | null | undefined, maxActualFilter: number | null | undefined, minActualFilter: number | null | undefined, maxSalaryIdFilter: number | null | undefined, minSalaryIdFilter: number | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SalaryDetialses/GetSalaryDetialsesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxmonthyearFilter !== undefined && maxmonthyearFilter !== null)
            url_ += "MaxmonthyearFilter=" + encodeURIComponent("" + maxmonthyearFilter) + "&";
        if (minmonthyearFilter !== undefined && minmonthyearFilter !== null)
            url_ += "MinmonthyearFilter=" + encodeURIComponent("" + minmonthyearFilter) + "&";
        if (maxemployeeidFilter !== undefined && maxemployeeidFilter !== null)
            url_ += "MaxemployeeidFilter=" + encodeURIComponent("" + maxemployeeidFilter) + "&";
        if (minemployeeidFilter !== undefined && minemployeeidFilter !== null)
            url_ += "MinemployeeidFilter=" + encodeURIComponent("" + minemployeeidFilter) + "&";
        if (maxpaycomponentFilter !== undefined && maxpaycomponentFilter !== null)
            url_ += "MaxpaycomponentFilter=" + encodeURIComponent("" + maxpaycomponentFilter) + "&";
        if (minpaycomponentFilter !== undefined && minpaycomponentFilter !== null)
            url_ += "MinpaycomponentFilter=" + encodeURIComponent("" + minpaycomponentFilter) + "&";
        if (maxStandardFilter !== undefined && maxStandardFilter !== null)
            url_ += "MaxStandardFilter=" + encodeURIComponent("" + maxStandardFilter) + "&";
        if (minStandardFilter !== undefined && minStandardFilter !== null)
            url_ += "MinStandardFilter=" + encodeURIComponent("" + minStandardFilter) + "&";
        if (maxActualFilter !== undefined && maxActualFilter !== null)
            url_ += "MaxActualFilter=" + encodeURIComponent("" + maxActualFilter) + "&";
        if (minActualFilter !== undefined && minActualFilter !== null)
            url_ += "MinActualFilter=" + encodeURIComponent("" + minActualFilter) + "&";
        if (maxSalaryIdFilter !== undefined && maxSalaryIdFilter !== null)
            url_ += "MaxSalaryIdFilter=" + encodeURIComponent("" + maxSalaryIdFilter) + "&";
        if (minSalaryIdFilter !== undefined && minSalaryIdFilter !== null)
            url_ += "MinSalaryIdFilter=" + encodeURIComponent("" + minSalaryIdFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalaryDetialsesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalaryDetialsesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetSalaryDetialsesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class SandwichAttendancePolicyServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param tenantId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return Success
     */
    apply(tenantId: number | null | undefined, fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SandwichAttendancePolicyService/Apply?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApply(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApply(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApply(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class SeparationRequestServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAll(body: GetAllSeparationRequestInput | undefined): Observable<PagedResultDtoOfGetSeparationRequestForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SeparationRequest/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetSeparationRequestForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetSeparationRequestForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSeparationRequestForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSeparationRequestForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSeparationRequestForViewDto>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @param nameFilter (optional) 
     * @param requestType (optional) 
     * @return Success
     */
    getAllCompleted(employeeId: number | undefined, nameFilter: string | null | undefined, requestType: string | null | undefined): Observable<PagedResultDtoOfGetSeparationRequestForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SeparationRequest/GetAllCompleted?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (requestType !== undefined && requestType !== null)
            url_ += "RequestType=" + encodeURIComponent("" + requestType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCompleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCompleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetSeparationRequestForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetSeparationRequestForViewDto>;
        }));
    }

    protected processGetAllCompleted(response: HttpResponseBase): Observable<PagedResultDtoOfGetSeparationRequestForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSeparationRequestForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSeparationRequestForViewDto>(null as any);
    }

    /**
     * @param requestid (optional) 
     * @return Success
     */
    getSeparationRequestForApproval(requestid: number | undefined): Observable<GetSeparationRequestForEdit> {
        let url_ = this.baseUrl + "/api/services/app/SeparationRequest/GetSeparationRequestForApproval?";
        if (requestid === null)
            throw new Error("The parameter 'requestid' cannot be null.");
        else if (requestid !== undefined)
            url_ += "requestid=" + encodeURIComponent("" + requestid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeparationRequestForApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeparationRequestForApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSeparationRequestForEdit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSeparationRequestForEdit>;
        }));
    }

    protected processGetSeparationRequestForApproval(response: HttpResponseBase): Observable<GetSeparationRequestForEdit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSeparationRequestForEdit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSeparationRequestForEdit>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFnfCompletedStatus(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SeparationRequest/GetFnfCompletedStatus?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFnfCompletedStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFnfCompletedStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetFnfCompletedStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param empid (optional) 
     * @return Success
     */
    checkEmployee(empid: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SeparationRequest/CheckEmployee?";
        if (empid === null)
            throw new Error("The parameter 'empid' cannot be null.");
        else if (empid !== undefined)
            url_ += "empid=" + encodeURIComponent("" + empid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheckEmployee(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditSeparationRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SeparationRequest/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getExpenseForView(id: number | undefined): Observable<GetSeparationForView> {
        let url_ = this.baseUrl + "/api/services/app/SeparationRequest/GetExpenseForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExpenseForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExpenseForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSeparationForView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSeparationForView>;
        }));
    }

    protected processGetExpenseForView(response: HttpResponseBase): Observable<GetSeparationForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSeparationForView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSeparationForView>(null as any);
    }

    /**
     * @param empid (optional) 
     * @return Success
     */
    getAllLeaveTypesForSeparation(empid: number | undefined): Observable<GetAllLeaveTypForSeparationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SeparationRequest/GetAllLeaveTypesForSeparation?";
        if (empid === null)
            throw new Error("The parameter 'empid' cannot be null.");
        else if (empid !== undefined)
            url_ += "empid=" + encodeURIComponent("" + empid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLeaveTypesForSeparation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLeaveTypesForSeparation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllLeaveTypForSeparationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllLeaveTypForSeparationDto[]>;
        }));
    }

    protected processGetAllLeaveTypesForSeparation(response: HttpResponseBase): Observable<GetAllLeaveTypForSeparationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllLeaveTypForSeparationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAllLeaveTypForSeparationDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSeparationReqForEdit(id: number | undefined): Observable<GetSeparationRequestForEdit> {
        let url_ = this.baseUrl + "/api/services/app/SeparationRequest/GetSeparationReqForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeparationReqForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeparationReqForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSeparationRequestForEdit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSeparationRequestForEdit>;
        }));
    }

    protected processGetSeparationReqForEdit(response: HttpResponseBase): Observable<GetSeparationRequestForEdit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSeparationRequestForEdit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSeparationRequestForEdit>(null as any);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCurrentLoginInformationsOutput>(null as any);
    }

    /**
     * @return Success
     */
    updateUserSignInToken(): Observable<UpdateUserSignInTokenOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/UpdateUserSignInToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserSignInToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserSignInToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateUserSignInTokenOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateUserSignInTokenOutput>;
        }));
    }

    protected processUpdateUserSignInToken(response: HttpResponseBase): Observable<UpdateUserSignInTokenOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateUserSignInTokenOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateUserSignInTokenOutput>(null as any);
    }
}

@Injectable()
export class ShiftDetailsesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxWeekOfMonthFilter (optional) 
     * @param minWeekOfMonthFilter (optional) 
     * @param maxDayofWeekFilter (optional) 
     * @param minDayofWeekFilter (optional) 
     * @param shiftShiftNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxWeekOfMonthFilter: number | null | undefined, minWeekOfMonthFilter: number | null | undefined, maxDayofWeekFilter: number | null | undefined, minDayofWeekFilter: number | null | undefined, shiftShiftNameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetShiftDetailsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ShiftDetailses/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxWeekOfMonthFilter !== undefined && maxWeekOfMonthFilter !== null)
            url_ += "MaxWeekOfMonthFilter=" + encodeURIComponent("" + maxWeekOfMonthFilter) + "&";
        if (minWeekOfMonthFilter !== undefined && minWeekOfMonthFilter !== null)
            url_ += "MinWeekOfMonthFilter=" + encodeURIComponent("" + minWeekOfMonthFilter) + "&";
        if (maxDayofWeekFilter !== undefined && maxDayofWeekFilter !== null)
            url_ += "MaxDayofWeekFilter=" + encodeURIComponent("" + maxDayofWeekFilter) + "&";
        if (minDayofWeekFilter !== undefined && minDayofWeekFilter !== null)
            url_ += "MinDayofWeekFilter=" + encodeURIComponent("" + minDayofWeekFilter) + "&";
        if (shiftShiftNameFilter !== undefined && shiftShiftNameFilter !== null)
            url_ += "ShiftShiftNameFilter=" + encodeURIComponent("" + shiftShiftNameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetShiftDetailsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetShiftDetailsForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetShiftDetailsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetShiftDetailsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetShiftDetailsForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getShiftDetailsForView(id: number | undefined): Observable<GetShiftDetailsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ShiftDetailses/GetShiftDetailsForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShiftDetailsForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShiftDetailsForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetShiftDetailsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetShiftDetailsForViewDto>;
        }));
    }

    protected processGetShiftDetailsForView(response: HttpResponseBase): Observable<GetShiftDetailsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetShiftDetailsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetShiftDetailsForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getShiftDetailsForEdit(id: number | undefined): Observable<GetShiftDetailsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ShiftDetailses/GetShiftDetailsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShiftDetailsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShiftDetailsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetShiftDetailsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetShiftDetailsForEditOutput>;
        }));
    }

    protected processGetShiftDetailsForEdit(response: HttpResponseBase): Observable<GetShiftDetailsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetShiftDetailsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetShiftDetailsForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditShiftDetailsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ShiftDetailses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ShiftDetailses/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxWeekOfMonthFilter (optional) 
     * @param minWeekOfMonthFilter (optional) 
     * @param maxDayofWeekFilter (optional) 
     * @param minDayofWeekFilter (optional) 
     * @param shiftShiftNameFilter (optional) 
     * @return Success
     */
    getShiftDetailsesToExcel(filter: string | null | undefined, maxWeekOfMonthFilter: number | null | undefined, minWeekOfMonthFilter: number | null | undefined, maxDayofWeekFilter: number | null | undefined, minDayofWeekFilter: number | null | undefined, shiftShiftNameFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ShiftDetailses/GetShiftDetailsesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxWeekOfMonthFilter !== undefined && maxWeekOfMonthFilter !== null)
            url_ += "MaxWeekOfMonthFilter=" + encodeURIComponent("" + maxWeekOfMonthFilter) + "&";
        if (minWeekOfMonthFilter !== undefined && minWeekOfMonthFilter !== null)
            url_ += "MinWeekOfMonthFilter=" + encodeURIComponent("" + minWeekOfMonthFilter) + "&";
        if (maxDayofWeekFilter !== undefined && maxDayofWeekFilter !== null)
            url_ += "MaxDayofWeekFilter=" + encodeURIComponent("" + maxDayofWeekFilter) + "&";
        if (minDayofWeekFilter !== undefined && minDayofWeekFilter !== null)
            url_ += "MinDayofWeekFilter=" + encodeURIComponent("" + minDayofWeekFilter) + "&";
        if (shiftShiftNameFilter !== undefined && shiftShiftNameFilter !== null)
            url_ += "ShiftShiftNameFilter=" + encodeURIComponent("" + shiftShiftNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShiftDetailsesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShiftDetailsesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetShiftDetailsesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllShiftForTableDropdown(): Observable<ShiftDetailsShiftLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ShiftDetailses/GetAllShiftForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllShiftForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllShiftForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftDetailsShiftLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftDetailsShiftLookupTableDto[]>;
        }));
    }

    protected processGetAllShiftForTableDropdown(response: HttpResponseBase): Observable<ShiftDetailsShiftLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShiftDetailsShiftLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShiftDetailsShiftLookupTableDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllShiftWizards(): Observable<GetShiftsForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ShiftDetailses/GetAllShiftWizards";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllShiftWizards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllShiftWizards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetShiftsForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetShiftsForViewDto[]>;
        }));
    }

    protected processGetAllShiftWizards(response: HttpResponseBase): Observable<GetShiftsForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetShiftsForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetShiftsForViewDto[]>(null as any);
    }
}

@Injectable()
export class ShiftsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param shiftCodeFilter (optional) 
     * @param shiftNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, shiftCodeFilter: string | null | undefined, shiftNameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetShiftForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Shifts/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (shiftCodeFilter !== undefined && shiftCodeFilter !== null)
            url_ += "ShiftCodeFilter=" + encodeURIComponent("" + shiftCodeFilter) + "&";
        if (shiftNameFilter !== undefined && shiftNameFilter !== null)
            url_ += "ShiftNameFilter=" + encodeURIComponent("" + shiftNameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetShiftForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetShiftForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetShiftForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetShiftForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetShiftForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getShiftForView(id: number | undefined): Observable<GetShiftForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Shifts/GetShiftForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShiftForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShiftForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetShiftForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetShiftForViewDto>;
        }));
    }

    protected processGetShiftForView(response: HttpResponseBase): Observable<GetShiftForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetShiftForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetShiftForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getShiftForEdit(id: number | undefined): Observable<GetShiftForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Shifts/GetShiftForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShiftForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShiftForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetShiftForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetShiftForEditOutput>;
        }));
    }

    protected processGetShiftForEdit(response: HttpResponseBase): Observable<GetShiftForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetShiftForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetShiftForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditShiftDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Shifts/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Shifts/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param shiftCodeFilter (optional) 
     * @param shiftNameFilter (optional) 
     * @return Success
     */
    getShiftsToExcel(filter: string | null | undefined, shiftCodeFilter: string | null | undefined, shiftNameFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Shifts/GetShiftsToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (shiftCodeFilter !== undefined && shiftCodeFilter !== null)
            url_ += "ShiftCodeFilter=" + encodeURIComponent("" + shiftCodeFilter) + "&";
        if (shiftNameFilter !== undefined && shiftNameFilter !== null)
            url_ += "ShiftNameFilter=" + encodeURIComponent("" + shiftNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShiftsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShiftsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetShiftsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class ShortLeaveTypesAppServicesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllONDutyType(filter: string | null | undefined, nameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetShortLeaveTypesForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ShortLeaveTypesAppServices/GetAllONDutyType?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllONDutyType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllONDutyType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetShortLeaveTypesForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetShortLeaveTypesForViewDto>;
        }));
    }

    protected processGetAllONDutyType(response: HttpResponseBase): Observable<PagedResultDtoOfGetShortLeaveTypesForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetShortLeaveTypesForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetShortLeaveTypesForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getShortLeaveTypesForView(id: number | undefined): Observable<GetShortLeaveTypesForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ShortLeaveTypesAppServices/GetShortLeaveTypesForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShortLeaveTypesForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShortLeaveTypesForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetShortLeaveTypesForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetShortLeaveTypesForViewDto>;
        }));
    }

    protected processGetShortLeaveTypesForView(response: HttpResponseBase): Observable<GetShortLeaveTypesForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetShortLeaveTypesForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetShortLeaveTypesForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getShortLeaveTypesForEdit(id: number | undefined): Observable<GetShortLeaveTypesForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ShortLeaveTypesAppServices/GetShortLeaveTypesForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShortLeaveTypesForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShortLeaveTypesForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetShortLeaveTypesForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetShortLeaveTypesForEditOutput>;
        }));
    }

    protected processGetShortLeaveTypesForEdit(response: HttpResponseBase): Observable<GetShortLeaveTypesForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetShortLeaveTypesForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetShortLeaveTypesForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditShortLeaveTypesDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ShortLeaveTypesAppServices/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ShortLeaveTypesAppServices/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class SmsServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param userName (optional) 
     * @param phoneno (optional) 
     * @param password (optional) 
     * @return Success
     */
    smsSendserviceSelfservice(userName: string | null | undefined, phoneno: string | null | undefined, password: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SmsService/smsSendserviceSelfservice?";
        if (userName !== undefined && userName !== null)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (phoneno !== undefined && phoneno !== null)
            url_ += "phoneno=" + encodeURIComponent("" + phoneno) + "&";
        if (password !== undefined && password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSmsSendserviceSelfservice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSmsSendserviceSelfservice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSmsSendserviceSelfservice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param deviceToken (optional) 
     * @param title (optional) 
     * @param msg (optional) 
     * @return Success
     */
    sendNotification(deviceToken: string | null | undefined, title: string | null | undefined, msg: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SmsService/SendNotification?";
        if (deviceToken !== undefined && deviceToken !== null)
            url_ += "DeviceToken=" + encodeURIComponent("" + deviceToken) + "&";
        if (title !== undefined && title !== null)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        if (msg !== undefined && msg !== null)
            url_ += "msg=" + encodeURIComponent("" + msg) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSendNotification(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable()
export class StatesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param countryNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, countryNameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetStateForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/States/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (countryNameFilter !== undefined && countryNameFilter !== null)
            url_ += "CountryNameFilter=" + encodeURIComponent("" + countryNameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetStateForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetStateForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetStateForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetStateForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetStateForViewDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllStageWizards(): Observable<GetStateForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/States/GetAllStageWizards";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStageWizards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStageWizards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStateForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStateForViewDto[]>;
        }));
    }

    protected processGetAllStageWizards(response: HttpResponseBase): Observable<GetStateForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetStateForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStateForViewDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getStateForView(id: number | undefined): Observable<GetStateForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/States/GetStateForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStateForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStateForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStateForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStateForViewDto>;
        }));
    }

    protected processGetStateForView(response: HttpResponseBase): Observable<GetStateForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStateForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStateForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getStateForEdit(id: number | undefined): Observable<GetStateForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/States/GetStateForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStateForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStateForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStateForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStateForEditOutput>;
        }));
    }

    protected processGetStateForEdit(response: HttpResponseBase): Observable<GetStateForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStateForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStateForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditStateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/States/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/States/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param countryNameFilter (optional) 
     * @return Success
     */
    getStatesToExcel(filter: string | null | undefined, nameFilter: string | null | undefined, countryNameFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/States/GetStatesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (countryNameFilter !== undefined && countryNameFilter !== null)
            url_ += "CountryNameFilter=" + encodeURIComponent("" + countryNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetStatesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCountryForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfStateCountryLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/States/GetAllCountryForLookupTable?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCountryForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCountryForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfStateCountryLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfStateCountryLookupTableDto>;
        }));
    }

    protected processGetAllCountryForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfStateCountryLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfStateCountryLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfStateCountryLookupTableDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createStateForMRR(body: CreateOrEditStateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/States/CreateStateForMRR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateStateForMRR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateStateForMRR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateStateForMRR(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class StaticMasterGenerationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    generateMasters(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StaticMasterGeneration/GenerateMasters?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateMasters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateMasters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateMasters(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class StatutoryConfigurationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param type (optional) 
     * @return Success
     */
    getAll(type: boolean | undefined): Observable<PagedResultDtoOfGetStatutoryConfigurationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/StatutoryConfigurations/GetAll?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetStatutoryConfigurationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetStatutoryConfigurationForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetStatutoryConfigurationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetStatutoryConfigurationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetStatutoryConfigurationForViewDto>(null as any);
    }

    /**
     * @param type (optional) 
     * @return Success
     */
    getAllProfessional(type: boolean | undefined): Observable<PagedResultDtoOfGetStatutoryConfigurationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/StatutoryConfigurations/GetAllProfessional?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProfessional(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProfessional(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetStatutoryConfigurationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetStatutoryConfigurationForViewDto>;
        }));
    }

    protected processGetAllProfessional(response: HttpResponseBase): Observable<PagedResultDtoOfGetStatutoryConfigurationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetStatutoryConfigurationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetStatutoryConfigurationForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getStatutoryConfigurationForView(id: number | undefined): Observable<GetStatutoryConfigurationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/StatutoryConfigurations/GetStatutoryConfigurationForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatutoryConfigurationForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatutoryConfigurationForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStatutoryConfigurationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStatutoryConfigurationForViewDto>;
        }));
    }

    protected processGetStatutoryConfigurationForView(response: HttpResponseBase): Observable<GetStatutoryConfigurationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStatutoryConfigurationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStatutoryConfigurationForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getStatutoryConfigurationForEdit(id: number | undefined): Observable<GetStatutoryConfigurationForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/StatutoryConfigurations/GetStatutoryConfigurationForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatutoryConfigurationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatutoryConfigurationForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStatutoryConfigurationForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStatutoryConfigurationForEditOutput>;
        }));
    }

    protected processGetStatutoryConfigurationForEdit(response: HttpResponseBase): Observable<GetStatutoryConfigurationForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStatutoryConfigurationForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStatutoryConfigurationForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditStatutoryConfigurationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StatutoryConfigurations/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StatutoryConfigurations/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxMinimumLimitFilter (optional) 
     * @param minMinimumLimitFilter (optional) 
     * @param maxMaximumLimitFilter (optional) 
     * @param minMaximumLimitFilter (optional) 
     * @param isDeductionEmpContMonthFilter (optional) 
     * @param professionalTaxFilter (optional) 
     * @param labourTaxFilter (optional) 
     * @param stateNameFilter (optional) 
     * @param locationNameFilter (optional) 
     * @return Success
     */
    getStatutoryConfigurationsToExcel(filter: string | null | undefined, maxMinimumLimitFilter: number | null | undefined, minMinimumLimitFilter: number | null | undefined, maxMaximumLimitFilter: number | null | undefined, minMaximumLimitFilter: number | null | undefined, isDeductionEmpContMonthFilter: number | null | undefined, professionalTaxFilter: number | null | undefined, labourTaxFilter: number | null | undefined, stateNameFilter: string | null | undefined, locationNameFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/StatutoryConfigurations/GetStatutoryConfigurationsToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxMinimumLimitFilter !== undefined && maxMinimumLimitFilter !== null)
            url_ += "MaxMinimumLimitFilter=" + encodeURIComponent("" + maxMinimumLimitFilter) + "&";
        if (minMinimumLimitFilter !== undefined && minMinimumLimitFilter !== null)
            url_ += "MinMinimumLimitFilter=" + encodeURIComponent("" + minMinimumLimitFilter) + "&";
        if (maxMaximumLimitFilter !== undefined && maxMaximumLimitFilter !== null)
            url_ += "MaxMaximumLimitFilter=" + encodeURIComponent("" + maxMaximumLimitFilter) + "&";
        if (minMaximumLimitFilter !== undefined && minMaximumLimitFilter !== null)
            url_ += "MinMaximumLimitFilter=" + encodeURIComponent("" + minMaximumLimitFilter) + "&";
        if (isDeductionEmpContMonthFilter !== undefined && isDeductionEmpContMonthFilter !== null)
            url_ += "IsDeductionEmpContMonthFilter=" + encodeURIComponent("" + isDeductionEmpContMonthFilter) + "&";
        if (professionalTaxFilter !== undefined && professionalTaxFilter !== null)
            url_ += "ProfessionalTaxFilter=" + encodeURIComponent("" + professionalTaxFilter) + "&";
        if (labourTaxFilter !== undefined && labourTaxFilter !== null)
            url_ += "LabourTaxFilter=" + encodeURIComponent("" + labourTaxFilter) + "&";
        if (stateNameFilter !== undefined && stateNameFilter !== null)
            url_ += "StateNameFilter=" + encodeURIComponent("" + stateNameFilter) + "&";
        if (locationNameFilter !== undefined && locationNameFilter !== null)
            url_ += "LocationNameFilter=" + encodeURIComponent("" + locationNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatutoryConfigurationsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatutoryConfigurationsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetStatutoryConfigurationsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllStateForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfStatutoryConfigurationStateLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/StatutoryConfigurations/GetAllStateForLookupTable?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStateForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStateForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfStatutoryConfigurationStateLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfStatutoryConfigurationStateLookupTableDto>;
        }));
    }

    protected processGetAllStateForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfStatutoryConfigurationStateLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfStatutoryConfigurationStateLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfStatutoryConfigurationStateLookupTableDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllLocationForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfStatutoryConfigurationLocationLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/StatutoryConfigurations/GetAllLocationForLookupTable?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLocationForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLocationForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfStatutoryConfigurationLocationLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfStatutoryConfigurationLocationLookupTableDto>;
        }));
    }

    protected processGetAllLocationForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfStatutoryConfigurationLocationLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfStatutoryConfigurationLocationLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfStatutoryConfigurationLocationLookupTableDto>(null as any);
    }
}

@Injectable()
export class StripePaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    confirmPayment(body: StripeConfirmPaymentInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/ConfirmPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfirmPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createSubscription(body: StripeCreateSubscriptionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/CreateSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSubscription(body: StripeUpdateSubscriptionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/UpdateSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getConfiguration(): Observable<StripeConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/GetConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StripeConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StripeConfigurationDto>;
        }));
    }

    protected processGetConfiguration(response: HttpResponseBase): Observable<StripeConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StripeConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StripeConfigurationDto>(null as any);
    }
}

@Injectable()
export class SubDepartmentsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param departmentNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, departmentNameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSubDepartmentForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SubDepartments/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (departmentNameFilter !== undefined && departmentNameFilter !== null)
            url_ += "DepartmentNameFilter=" + encodeURIComponent("" + departmentNameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetSubDepartmentForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetSubDepartmentForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSubDepartmentForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSubDepartmentForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSubDepartmentForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSubDepartmentForView(id: number | undefined): Observable<GetSubDepartmentForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SubDepartments/GetSubDepartmentForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubDepartmentForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubDepartmentForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSubDepartmentForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSubDepartmentForViewDto>;
        }));
    }

    protected processGetSubDepartmentForView(response: HttpResponseBase): Observable<GetSubDepartmentForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSubDepartmentForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSubDepartmentForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSubDepartmentForEdit(id: number | undefined): Observable<GetSubDepartmentForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SubDepartments/GetSubDepartmentForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubDepartmentForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubDepartmentForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSubDepartmentForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSubDepartmentForEditOutput>;
        }));
    }

    protected processGetSubDepartmentForEdit(response: HttpResponseBase): Observable<GetSubDepartmentForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSubDepartmentForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSubDepartmentForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditSubDepartmentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SubDepartments/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SubDepartments/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param departmentNameFilter (optional) 
     * @return Success
     */
    getSubDepartmentsToExcel(filter: string | null | undefined, nameFilter: string | null | undefined, departmentNameFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SubDepartments/GetSubDepartmentsToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (departmentNameFilter !== undefined && departmentNameFilter !== null)
            url_ += "DepartmentNameFilter=" + encodeURIComponent("" + departmentNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubDepartmentsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubDepartmentsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetSubDepartmentsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllDepartmentForTableDropdown(): Observable<SubDepartmentDepartmentLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SubDepartments/GetAllDepartmentForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDepartmentForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDepartmentForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubDepartmentDepartmentLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubDepartmentDepartmentLookupTableDto[]>;
        }));
    }

    protected processGetAllDepartmentForTableDropdown(response: HttpResponseBase): Observable<SubDepartmentDepartmentLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubDepartmentDepartmentLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubDepartmentDepartmentLookupTableDto[]>(null as any);
    }
}

@Injectable()
export class SubKraServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateSubKra | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SubKra/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CreateSubKra | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SubKra/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param kraId (optional) 
     * @return Success
     */
    getAllSubKra(kraId: number | undefined): Observable<SubKraDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SubKra/GetAllSubKra?";
        if (kraId === null)
            throw new Error("The parameter 'kraId' cannot be null.");
        else if (kraId !== undefined)
            url_ += "KraId=" + encodeURIComponent("" + kraId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSubKra(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSubKra(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubKraDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubKraDto[]>;
        }));
    }

    protected processGetAllSubKra(response: HttpResponseBase): Observable<SubKraDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubKraDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubKraDto[]>(null as any);
    }

    /**
     * @param subKraId (optional) 
     * @return Success
     */
    getSubKraById(subKraId: number | undefined): Observable<CreateSubKra> {
        let url_ = this.baseUrl + "/api/services/app/SubKra/GetSubKraById?";
        if (subKraId === null)
            throw new Error("The parameter 'subKraId' cannot be null.");
        else if (subKraId !== undefined)
            url_ += "subKraId=" + encodeURIComponent("" + subKraId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubKraById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubKraById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateSubKra>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateSubKra>;
        }));
    }

    protected processGetSubKraById(response: HttpResponseBase): Observable<CreateSubKra> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateSubKra.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateSubKra>(null as any);
    }

    /**
     * @param subKraId (optional) 
     * @return Success
     */
    deleteSubKra(subKraId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SubKra/DeleteSubKra?";
        if (subKraId === null)
            throw new Error("The parameter 'subKraId' cannot be null.");
        else if (subKraId !== undefined)
            url_ += "subKraId=" + encodeURIComponent("" + subKraId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSubKra(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSubKra(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSubKra(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class SubLocationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param locationNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, locationNameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSubLocationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SubLocations/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (locationNameFilter !== undefined && locationNameFilter !== null)
            url_ += "LocationNameFilter=" + encodeURIComponent("" + locationNameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetSubLocationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetSubLocationForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSubLocationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSubLocationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSubLocationForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSubLocationForView(id: number | undefined): Observable<GetSubLocationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SubLocations/GetSubLocationForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubLocationForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubLocationForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSubLocationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSubLocationForViewDto>;
        }));
    }

    protected processGetSubLocationForView(response: HttpResponseBase): Observable<GetSubLocationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSubLocationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSubLocationForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSubLocationForEdit(id: number | undefined): Observable<GetSubLocationForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SubLocations/GetSubLocationForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubLocationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubLocationForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSubLocationForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSubLocationForEditOutput>;
        }));
    }

    protected processGetSubLocationForEdit(response: HttpResponseBase): Observable<GetSubLocationForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSubLocationForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSubLocationForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditSubLocationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SubLocations/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SubLocations/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param locationNameFilter (optional) 
     * @return Success
     */
    getSubLocationsToExcel(filter: string | null | undefined, nameFilter: string | null | undefined, locationNameFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SubLocations/GetSubLocationsToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (locationNameFilter !== undefined && locationNameFilter !== null)
            url_ += "LocationNameFilter=" + encodeURIComponent("" + locationNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubLocationsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubLocationsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetSubLocationsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllLocationForTableDropdown(): Observable<SubLocationLocationLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SubLocations/GetAllLocationForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLocationForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLocationForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubLocationLocationLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubLocationLocationLookupTableDto[]>;
        }));
    }

    protected processGetAllLocationForTableDropdown(response: HttpResponseBase): Observable<SubLocationLocationLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubLocationLocationLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubLocationLocationLookupTableDto[]>(null as any);
    }
}

@Injectable()
export class SubscriptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param upgradeEditionId (optional) 
     * @return Success
     */
    upgradeTenantToEquivalentEdition(upgradeEditionId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/UpgradeTenantToEquivalentEdition?";
        if (upgradeEditionId === null)
            throw new Error("The parameter 'upgradeEditionId' cannot be null.");
        else if (upgradeEditionId !== undefined)
            url_ += "upgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpgradeTenantToEquivalentEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpgradeTenantToEquivalentEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpgradeTenantToEquivalentEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    disableRecurringPayments(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/DisableRecurringPayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableRecurringPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableRecurringPayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisableRecurringPayments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    enableRecurringPayments(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/EnableRecurringPayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableRecurringPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableRecurringPayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEnableRecurringPayments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class TasksServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateTask(body: TaskDetail | undefined): Observable<GetTaskDto> {
        let url_ = this.baseUrl + "/api/services/app/Tasks/CreateOrUpdateTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTaskDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTaskDto>;
        }));
    }

    protected processCreateOrUpdateTask(response: HttpResponseBase): Observable<GetTaskDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTaskDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTaskDto>(null as any);
    }

    /**
     * @return Success
     */
    getTaskBlankFormat(): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tasks/GetTaskBlankFormat";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskBlankFormat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskBlankFormat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processGetTaskBlankFormat(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getTasksToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Tasks/GetTasksToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTasksToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTasksToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetTasksToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param excelFile (optional) 
     * @return Success
     */
    importTaskFromExcel(excelFile: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tasks/ImportTaskFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile !== null && excelFile !== undefined)
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportTaskFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportTaskFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportTaskFromExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filterTask (optional) 
     * @param employeeid (optional) 
     * @return Success
     */
    getTasks(filterTask: string | null | undefined, employeeid: number | null | undefined): Observable<GetTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tasks/GetTasks?";
        if (filterTask !== undefined && filterTask !== null)
            url_ += "filterTask=" + encodeURIComponent("" + filterTask) + "&";
        if (employeeid !== undefined && employeeid !== null)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTaskDto[]>;
        }));
    }

    protected processGetTasks(response: HttpResponseBase): Observable<GetTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetTaskDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTaskDto[]>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param filterTask (optional) 
     * @param employeeid (optional) 
     * @return Success
     */
    getTasksByProjectId(projectId: number | undefined, filterTask: string | null | undefined, employeeid: number | null | undefined): Observable<GetTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tasks/GetTasksByProjectId?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (filterTask !== undefined && filterTask !== null)
            url_ += "filterTask=" + encodeURIComponent("" + filterTask) + "&";
        if (employeeid !== undefined && employeeid !== null)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTasksByProjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTasksByProjectId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTaskDto[]>;
        }));
    }

    protected processGetTasksByProjectId(response: HttpResponseBase): Observable<GetTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetTaskDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTaskDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTaskForEdit(id: number | undefined): Observable<TaskDetail> {
        let url_ = this.baseUrl + "/api/services/app/Tasks/GetTaskForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskDetail>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskDetail>;
        }));
    }

    protected processGetTaskForEdit(response: HttpResponseBase): Observable<TaskDetail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskDetail.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskDetail>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteTask(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tasks/DeleteTask?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTask(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportToFile(body: GetTaskDto[] | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Tasks/ExportToFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportToFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportToFile(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class TaskTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateTaskType(body: TaskType | undefined): Observable<TaskType> {
        let url_ = this.baseUrl + "/api/services/app/TaskType/CreateOrUpdateTaskType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateTaskType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateTaskType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskType>;
        }));
    }

    protected processCreateOrUpdateTaskType(response: HttpResponseBase): Observable<TaskType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskType.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskType>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTaskTypeById(id: number | undefined): Observable<TaskType> {
        let url_ = this.baseUrl + "/api/services/app/TaskType/GetTaskTypeById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskTypeById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskTypeById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskType>;
        }));
    }

    protected processGetTaskTypeById(response: HttpResponseBase): Observable<TaskType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskType.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskType>(null as any);
    }

    /**
     * @param taskType (optional) 
     * @return Success
     */
    getAllTaskTypes(taskType: string | null | undefined): Observable<TaskType[]> {
        let url_ = this.baseUrl + "/api/services/app/TaskType/GetAllTaskTypes?";
        if (taskType !== undefined && taskType !== null)
            url_ += "taskType=" + encodeURIComponent("" + taskType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTaskTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTaskTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskType[]>;
        }));
    }

    protected processGetAllTaskTypes(response: HttpResponseBase): Observable<TaskType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskType[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteTaskType(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TaskType/DeleteTaskType?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTaskType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTaskType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTaskType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class TDSFeedingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getAllTDSDetails(month: number | undefined, year: number | undefined): Observable<PagedResultDtoOfGetTDSFeedingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TDSFeeding/GetAllTDSDetails?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTDSDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTDSDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTDSFeedingForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTDSFeedingForViewDto>;
        }));
    }

    protected processGetAllTDSDetails(response: HttpResponseBase): Observable<PagedResultDtoOfGetTDSFeedingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTDSFeedingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTDSFeedingForViewDto>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getAllBonusDetailsPreMonthProcessed(month: number | undefined, year: number | undefined): Observable<PagedResultDtoOfGetBonusFeedingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TDSFeeding/GetAllBonusDetailsPreMonthProcessed?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBonusDetailsPreMonthProcessed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBonusDetailsPreMonthProcessed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetBonusFeedingForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetBonusFeedingForViewDto>;
        }));
    }

    protected processGetAllBonusDetailsPreMonthProcessed(response: HttpResponseBase): Observable<PagedResultDtoOfGetBonusFeedingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBonusFeedingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBonusFeedingForViewDto>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getAllBonusDetailsPreMonth(month: number | undefined, year: number | undefined): Observable<PagedResultDtoOfGetBonusFeedingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TDSFeeding/GetAllBonusDetailsPreMonth?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBonusDetailsPreMonth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBonusDetailsPreMonth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetBonusFeedingForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetBonusFeedingForViewDto>;
        }));
    }

    protected processGetAllBonusDetailsPreMonth(response: HttpResponseBase): Observable<PagedResultDtoOfGetBonusFeedingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBonusFeedingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBonusFeedingForViewDto>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getAllBoxDetail(month: number | undefined, year: number | undefined): Observable<PagedResultDtoOfGetBonusFeedingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TDSFeeding/GetAllBoxDetail?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBoxDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBoxDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetBonusFeedingForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetBonusFeedingForViewDto>;
        }));
    }

    protected processGetAllBoxDetail(response: HttpResponseBase): Observable<PagedResultDtoOfGetBonusFeedingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBonusFeedingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBonusFeedingForViewDto>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getAllBonusDetails(month: number | undefined, year: number | undefined): Observable<PagedResultDtoOfGetBonusFeedingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TDSFeeding/GetAllBonusDetails?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBonusDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBonusDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetBonusFeedingForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetBonusFeedingForViewDto>;
        }));
    }

    protected processGetAllBonusDetails(response: HttpResponseBase): Observable<PagedResultDtoOfGetBonusFeedingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBonusFeedingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBonusFeedingForViewDto>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getAllBonusDetailsafterprocessed(month: number | undefined, year: number | undefined): Observable<PagedResultDtoOfGetBonusFeedingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TDSFeeding/GetAllBonusDetailsafterprocessed?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBonusDetailsafterprocessed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBonusDetailsafterprocessed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetBonusFeedingForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetBonusFeedingForViewDto>;
        }));
    }

    protected processGetAllBonusDetailsafterprocessed(response: HttpResponseBase): Observable<PagedResultDtoOfGetBonusFeedingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBonusFeedingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBonusFeedingForViewDto>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getAllTDSDetailsPreMonth(month: number | undefined, year: number | undefined): Observable<PagedResultDtoOfGetTDSFeedingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TDSFeeding/GetAllTDSDetailsPreMonth?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTDSDetailsPreMonth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTDSDetailsPreMonth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTDSFeedingForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTDSFeedingForViewDto>;
        }));
    }

    protected processGetAllTDSDetailsPreMonth(response: HttpResponseBase): Observable<PagedResultDtoOfGetTDSFeedingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTDSFeedingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTDSFeedingForViewDto>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getAllTDSDetailsAfterProc(month: number | undefined, year: number | undefined): Observable<PagedResultDtoOfGetTDSFeedingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TDSFeeding/GetAllTDSDetailsAfterProc?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTDSDetailsAfterProc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTDSDetailsAfterProc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTDSFeedingForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTDSFeedingForViewDto>;
        }));
    }

    protected processGetAllTDSDetailsAfterProc(response: HttpResponseBase): Observable<PagedResultDtoOfGetTDSFeedingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTDSFeedingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTDSFeedingForViewDto>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param query (optional) 
     * @return Success
     */
    getAllBonus(month: number | undefined, year: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined, query: string | null | undefined): Observable<PagedResultDtoOfGetBonusFeedingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TDSFeeding/GetAllBonus?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBonus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBonus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetBonusFeedingForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetBonusFeedingForViewDto>;
        }));
    }

    protected processGetAllBonus(response: HttpResponseBase): Observable<PagedResultDtoOfGetBonusFeedingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBonusFeedingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBonusFeedingForViewDto>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getBonusFeedingToExcel(month: number | undefined, year: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/TDSFeeding/GetBonusFeedingToExcel?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBonusFeedingToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBonusFeedingToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetBonusFeedingToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param query (optional) 
     * @return Success
     */
    getAllTDS(month: number | undefined, year: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined, query: string | null | undefined): Observable<PagedResultDtoOfGetTDSFeedingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TDSFeeding/GetAllTDS?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTDS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTDS(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTDSFeedingForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTDSFeedingForViewDto>;
        }));
    }

    protected processGetAllTDS(response: HttpResponseBase): Observable<PagedResultDtoOfGetTDSFeedingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTDSFeedingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTDSFeedingForViewDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTDSFeedingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TDSFeeding/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTDSFeedingForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTDSFeedingForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTDSFeedingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTDSFeedingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTDSFeedingForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTDSFeedingForView(id: number | undefined): Observable<GetTDSFeedingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TDSFeeding/GetTDSFeedingForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTDSFeedingForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTDSFeedingForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTDSFeedingForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTDSFeedingForViewDto>;
        }));
    }

    protected processGetTDSFeedingForView(response: HttpResponseBase): Observable<GetTDSFeedingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTDSFeedingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTDSFeedingForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTDSFeedingForEdit(id: number | undefined): Observable<GetTDSFeedingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TDSFeeding/GetTDSFeedingForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTDSFeedingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTDSFeedingForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTDSFeedingForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTDSFeedingForEditOutput>;
        }));
    }

    protected processGetTDSFeedingForEdit(response: HttpResponseBase): Observable<GetTDSFeedingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTDSFeedingForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTDSFeedingForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditTDSFeedingDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TDSFeeding/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TDSFeeding/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @return Success
     */
    getTDSFeedingToExcel(filter: string | null | undefined, nameFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/TDSFeeding/GetTDSFeedingToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined && nameFilter !== null)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTDSFeedingToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTDSFeedingToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetTDSFeedingToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveTDS(body: GetTDSFeedingForViewDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TDSFeeding/SaveTDS";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveTDS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveTDS(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveTDS(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveBonus(body: GetBonusFeedingForViewDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TDSFeeding/SaveBonus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveBonus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveBonus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveBonus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class TemplateSerivceForLetterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param directoryPath (optional) 
     * @param ftpUser (optional) 
     * @param ftpPassword (optional) 
     * @return Success
     */
    ftpDirectoryExists(directoryPath: string | null | undefined, ftpUser: string | null | undefined, ftpPassword: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TemplateSerivceForLetter/FtpDirectoryExists?";
        if (directoryPath !== undefined && directoryPath !== null)
            url_ += "directoryPath=" + encodeURIComponent("" + directoryPath) + "&";
        if (ftpUser !== undefined && ftpUser !== null)
            url_ += "ftpUser=" + encodeURIComponent("" + ftpUser) + "&";
        if (ftpPassword !== undefined && ftpPassword !== null)
            url_ += "ftpPassword=" + encodeURIComponent("" + ftpPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFtpDirectoryExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFtpDirectoryExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processFtpDirectoryExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveUploadFileMobile(body: UploadIamgedata | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TemplateSerivceForLetter/SaveUploadFileMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveUploadFileMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveUploadFileMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveUploadFileMobile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param imgName (optional) 
     * @param documentType (optional) 
     * @return Success
     */
    downLoadFileFromMobile(imgName: string | null | undefined, documentType: string | null | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TemplateSerivceForLetter/DownLoadFileFromMobile?";
        if (imgName !== undefined && imgName !== null)
            url_ += "ImgName=" + encodeURIComponent("" + imgName) + "&";
        if (documentType !== undefined && documentType !== null)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownLoadFileFromMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownLoadFileFromMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processDownLoadFileFromMobile(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getDocumentType(): Observable<DropDown[]> {
        let url_ = this.baseUrl + "/api/services/app/TemplateSerivceForLetter/GetDocumentType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDown[]>;
        }));
    }

    protected processGetDocumentType(response: HttpResponseBase): Observable<DropDown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDown[]>(null as any);
    }
}

@Injectable()
export class TenancyConfiguratonWizardsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getTenancySetting(): Observable<GetTenancyConfiguratonWizardForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TenancyConfiguratonWizards/GetTenancySetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenancySetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenancySetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTenancyConfiguratonWizardForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTenancyConfiguratonWizardForViewDto[]>;
        }));
    }

    protected processGetTenancySetting(response: HttpResponseBase): Observable<GetTenancyConfiguratonWizardForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetTenancyConfiguratonWizardForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTenancyConfiguratonWizardForViewDto[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxSequenceFilter (optional) 
     * @param minSequenceFilter (optional) 
     * @param featureFilter (optional) 
     * @param formFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxPercentageFilter (optional) 
     * @param minPercentageFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxSequenceFilter: number | null | undefined, minSequenceFilter: number | null | undefined, featureFilter: string | null | undefined, formFilter: string | null | undefined, statusFilter: number | null | undefined, maxPercentageFilter: number | null | undefined, minPercentageFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTenancyConfiguratonWizardForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TenancyConfiguratonWizards/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxSequenceFilter !== undefined && maxSequenceFilter !== null)
            url_ += "MaxSequenceFilter=" + encodeURIComponent("" + maxSequenceFilter) + "&";
        if (minSequenceFilter !== undefined && minSequenceFilter !== null)
            url_ += "MinSequenceFilter=" + encodeURIComponent("" + minSequenceFilter) + "&";
        if (featureFilter !== undefined && featureFilter !== null)
            url_ += "FeatureFilter=" + encodeURIComponent("" + featureFilter) + "&";
        if (formFilter !== undefined && formFilter !== null)
            url_ += "FormFilter=" + encodeURIComponent("" + formFilter) + "&";
        if (statusFilter !== undefined && statusFilter !== null)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxPercentageFilter !== undefined && maxPercentageFilter !== null)
            url_ += "MaxPercentageFilter=" + encodeURIComponent("" + maxPercentageFilter) + "&";
        if (minPercentageFilter !== undefined && minPercentageFilter !== null)
            url_ += "MinPercentageFilter=" + encodeURIComponent("" + minPercentageFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTenancyConfiguratonWizardForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTenancyConfiguratonWizardForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTenancyConfiguratonWizardForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTenancyConfiguratonWizardForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTenancyConfiguratonWizardForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTenancyConfiguratonWizardForView(id: number | undefined): Observable<GetTenancyConfiguratonWizardForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TenancyConfiguratonWizards/GetTenancyConfiguratonWizardForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenancyConfiguratonWizardForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenancyConfiguratonWizardForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTenancyConfiguratonWizardForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTenancyConfiguratonWizardForViewDto>;
        }));
    }

    protected processGetTenancyConfiguratonWizardForView(response: HttpResponseBase): Observable<GetTenancyConfiguratonWizardForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTenancyConfiguratonWizardForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTenancyConfiguratonWizardForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTenancyConfiguratonWizardForEdit(id: number | undefined): Observable<GetTenancyConfiguratonWizardForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenancyConfiguratonWizards/GetTenancyConfiguratonWizardForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenancyConfiguratonWizardForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenancyConfiguratonWizardForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTenancyConfiguratonWizardForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTenancyConfiguratonWizardForEditOutput>;
        }));
    }

    protected processGetTenancyConfiguratonWizardForEdit(response: HttpResponseBase): Observable<GetTenancyConfiguratonWizardForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTenancyConfiguratonWizardForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTenancyConfiguratonWizardForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditTenancyConfiguratonWizardDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenancyConfiguratonWizards/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateSteps(input: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenancyConfiguratonWizards/UpdateSteps?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSteps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSteps(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSteps(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getProfilePending(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TenancyConfiguratonWizards/GetProfilePending";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePending(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePending(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetProfilePending(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    getActiveIndex(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TenancyConfiguratonWizards/GetActiveIndex";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetActiveIndex(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    getInstallwizardsMenu(): Observable<GetIntallationMenu[]> {
        let url_ = this.baseUrl + "/api/services/app/TenancyConfiguratonWizards/GetInstallwizardsMenu";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInstallwizardsMenu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInstallwizardsMenu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetIntallationMenu[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetIntallationMenu[]>;
        }));
    }

    protected processGetInstallwizardsMenu(response: HttpResponseBase): Observable<GetIntallationMenu[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetIntallationMenu.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetIntallationMenu[]>(null as any);
    }

    /**
     * @return Success
     */
    getInstallwizardsMenuWizars(): Observable<GetIntallationMenu[]> {
        let url_ = this.baseUrl + "/api/services/app/TenancyConfiguratonWizards/GetInstallwizardsMenuWizars";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInstallwizardsMenuWizars(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInstallwizardsMenuWizars(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetIntallationMenu[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetIntallationMenu[]>;
        }));
    }

    protected processGetInstallwizardsMenuWizars(response: HttpResponseBase): Observable<GetIntallationMenu[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetIntallationMenu.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetIntallationMenu[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenancyConfiguratonWizards/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxSequenceFilter (optional) 
     * @param minSequenceFilter (optional) 
     * @param featureFilter (optional) 
     * @param formFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxPercentageFilter (optional) 
     * @param minPercentageFilter (optional) 
     * @return Success
     */
    getTenancyConfiguratonWizardsToExcel(filter: string | null | undefined, maxSequenceFilter: number | null | undefined, minSequenceFilter: number | null | undefined, featureFilter: string | null | undefined, formFilter: string | null | undefined, statusFilter: number | null | undefined, maxPercentageFilter: number | null | undefined, minPercentageFilter: number | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/TenancyConfiguratonWizards/GetTenancyConfiguratonWizardsToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxSequenceFilter !== undefined && maxSequenceFilter !== null)
            url_ += "MaxSequenceFilter=" + encodeURIComponent("" + maxSequenceFilter) + "&";
        if (minSequenceFilter !== undefined && minSequenceFilter !== null)
            url_ += "MinSequenceFilter=" + encodeURIComponent("" + minSequenceFilter) + "&";
        if (featureFilter !== undefined && featureFilter !== null)
            url_ += "FeatureFilter=" + encodeURIComponent("" + featureFilter) + "&";
        if (formFilter !== undefined && formFilter !== null)
            url_ += "FormFilter=" + encodeURIComponent("" + formFilter) + "&";
        if (statusFilter !== undefined && statusFilter !== null)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxPercentageFilter !== undefined && maxPercentageFilter !== null)
            url_ += "MaxPercentageFilter=" + encodeURIComponent("" + maxPercentageFilter) + "&";
        if (minPercentageFilter !== undefined && minPercentageFilter !== null)
            url_ += "MinPercentageFilter=" + encodeURIComponent("" + minPercentageFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenancyConfiguratonWizardsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenancyConfiguratonWizardsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetTenancyConfiguratonWizardsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param subscriptionEndDateStart (optional) 
     * @param subscriptionEndDateEnd (optional) 
     * @param creationDateStart (optional) 
     * @param creationDateEnd (optional) 
     * @param editionId (optional) 
     * @param editionIdSpecified (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getTenants(filter: string | null | undefined, subscriptionEndDateStart: moment.Moment | null | undefined, subscriptionEndDateEnd: moment.Moment | null | undefined, creationDateStart: moment.Moment | null | undefined, creationDateEnd: moment.Moment | null | undefined, editionId: number | null | undefined, editionIdSpecified: boolean | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfTenantListDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenants?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (subscriptionEndDateStart !== undefined && subscriptionEndDateStart !== null)
            url_ += "SubscriptionEndDateStart=" + encodeURIComponent(subscriptionEndDateStart ? "" + subscriptionEndDateStart.toISOString() : "") + "&";
        if (subscriptionEndDateEnd !== undefined && subscriptionEndDateEnd !== null)
            url_ += "SubscriptionEndDateEnd=" + encodeURIComponent(subscriptionEndDateEnd ? "" + subscriptionEndDateEnd.toISOString() : "") + "&";
        if (creationDateStart !== undefined && creationDateStart !== null)
            url_ += "CreationDateStart=" + encodeURIComponent(creationDateStart ? "" + creationDateStart.toISOString() : "") + "&";
        if (creationDateEnd !== undefined && creationDateEnd !== null)
            url_ += "CreationDateEnd=" + encodeURIComponent(creationDateEnd ? "" + creationDateEnd.toISOString() : "") + "&";
        if (editionId !== undefined && editionId !== null)
            url_ += "EditionId=" + encodeURIComponent("" + editionId) + "&";
        if (editionIdSpecified === null)
            throw new Error("The parameter 'editionIdSpecified' cannot be null.");
        else if (editionIdSpecified !== undefined)
            url_ += "EditionIdSpecified=" + encodeURIComponent("" + editionIdSpecified) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTenantListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTenantListDto>;
        }));
    }

    protected processGetTenants(response: HttpResponseBase): Observable<PagedResultDtoOfTenantListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTenantListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfTenantListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTenant(body: CreateTenantInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/CreateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTenantForEdit(id: number | undefined): Observable<TenantEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantEditDto>;
        }));
    }

    protected processGetTenantForEdit(response: HttpResponseBase): Observable<TenantEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantEditDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTenant(body: TenantEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteTenant(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/DeleteTenant?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTenantFeaturesForEdit(id: number | undefined): Observable<GetTenantFeaturesEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantFeaturesForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantFeaturesForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantFeaturesForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTenantFeaturesEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTenantFeaturesEditOutput>;
        }));
    }

    protected processGetTenantFeaturesForEdit(response: HttpResponseBase): Observable<GetTenantFeaturesEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTenantFeaturesEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTenantFeaturesEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTenantFeatures(body: UpdateTenantFeaturesInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenantFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenantFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenantFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTenantFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetTenantSpecificFeatures(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/ResetTenantSpecificFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetTenantSpecificFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetTenantSpecificFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetTenantSpecificFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unlockTenantAdmin(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UnlockTenantAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockTenantAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockTenantAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlockTenantAdmin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class TenantDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllReviewMendatePolicy(): Observable<PolicyMandateUpdateDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetAllReviewMendatePolicy";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllReviewMendatePolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReviewMendatePolicy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PolicyMandateUpdateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PolicyMandateUpdateDto[]>;
        }));
    }

    protected processGetAllReviewMendatePolicy(response: HttpResponseBase): Observable<PolicyMandateUpdateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PolicyMandateUpdateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PolicyMandateUpdateDto[]>(null as any);
    }

    /**
     * @return Success
     */
    policyReviewOtp(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/PolicyReviewOtp";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPolicyReviewOtp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPolicyReviewOtp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processPolicyReviewOtp(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    getHolidayDetails(): Observable<HolidayDetails[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetHolidayDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHolidayDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHolidayDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HolidayDetails[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HolidayDetails[]>;
        }));
    }

    protected processGetHolidayDetails(response: HttpResponseBase): Observable<HolidayDetails[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HolidayDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HolidayDetails[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePolicyAcknowledged(body: number[] | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/UpdatePolicyAcknowledged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePolicyAcknowledged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePolicyAcknowledged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdatePolicyAcknowledged(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPolicyMappingRecord(body: PolicyMandateUpdateDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/CreatePolicyMappingRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePolicyMappingRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePolicyMappingRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreatePolicyMappingRecord(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    getTeamMemeberList(): Observable<GetTeamMemberList[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetTeamMemeberList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeamMemeberList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeamMemeberList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTeamMemberList[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTeamMemberList[]>;
        }));
    }

    protected processGetTeamMemeberList(response: HttpResponseBase): Observable<GetTeamMemberList[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetTeamMemberList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTeamMemberList[]>(null as any);
    }

    /**
     * @return Success
     */
    getIncreamentDueDate(): Observable<GetIncreamentDueList[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetIncreamentDueDate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncreamentDueDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncreamentDueDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetIncreamentDueList[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetIncreamentDueList[]>;
        }));
    }

    protected processGetIncreamentDueDate(response: HttpResponseBase): Observable<GetIncreamentDueList[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetIncreamentDueList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetIncreamentDueList[]>(null as any);
    }

    /**
     * @return Success
     */
    getPunchDataNotIn(): Observable<GetEmployeeForList[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetPunchDataNotIn";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPunchDataNotIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPunchDataNotIn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmployeeForList[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmployeeForList[]>;
        }));
    }

    protected processGetPunchDataNotIn(response: HttpResponseBase): Observable<GetEmployeeForList[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetEmployeeForList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeeForList[]>(null as any);
    }

    /**
     * @return Success
     */
    getPunchDataForCheckedIn(): Observable<GetEmployeeForList[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetPunchDataForCheckedIn";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPunchDataForCheckedIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPunchDataForCheckedIn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmployeeForList[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmployeeForList[]>;
        }));
    }

    protected processGetPunchDataForCheckedIn(response: HttpResponseBase): Observable<GetEmployeeForList[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetEmployeeForList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeeForList[]>(null as any);
    }

    /**
     * @return Success
     */
    getCheckedInPunchCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetCheckedInPunchCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCheckedInPunchCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCheckedInPunchCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetCheckedInPunchCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    getLateCommers(): Observable<GetLateEmployeeList[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetLateCommers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLateCommers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLateCommers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLateEmployeeList[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLateEmployeeList[]>;
        }));
    }

    protected processGetLateCommers(response: HttpResponseBase): Observable<GetLateEmployeeList[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetLateEmployeeList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLateEmployeeList[]>(null as any);
    }

    /**
     * @return Success
     */
    getLeaveTodays(): Observable<GetOnLeaveTodayList[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetLeaveTodays";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveTodays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveTodays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOnLeaveTodayList[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOnLeaveTodayList[]>;
        }));
    }

    protected processGetLeaveTodays(response: HttpResponseBase): Observable<GetOnLeaveTodayList[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetOnLeaveTodayList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOnLeaveTodayList[]>(null as any);
    }

    /**
     * @return Success
     */
    getMemberActivity(): Observable<GetMemberActivityOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetMemberActivity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMemberActivityOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMemberActivityOutput>;
        }));
    }

    protected processGetMemberActivity(response: HttpResponseBase): Observable<GetMemberActivityOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMemberActivityOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMemberActivityOutput>(null as any);
    }

    /**
     * @param salesSummaryDatePeriod (optional) 
     * @return Success
     */
    getDashboardData(salesSummaryDatePeriod: SalesSummaryDatePeriod | undefined): Observable<GetDashboardDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDashboardData?";
        if (salesSummaryDatePeriod === null)
            throw new Error("The parameter 'salesSummaryDatePeriod' cannot be null.");
        else if (salesSummaryDatePeriod !== undefined)
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDashboardDataOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDashboardDataOutput>;
        }));
    }

    protected processGetDashboardData(response: HttpResponseBase): Observable<GetDashboardDataOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDashboardDataOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDashboardDataOutput>(null as any);
    }

    /**
     * @param salesSummaryDatePeriod (optional) 
     * @return Success
     */
    getSalesSummary(salesSummaryDatePeriod: SalesSummaryDatePeriod | undefined): Observable<GetSalesSummaryOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetSalesSummary?";
        if (salesSummaryDatePeriod === null)
            throw new Error("The parameter 'salesSummaryDatePeriod' cannot be null.");
        else if (salesSummaryDatePeriod !== undefined)
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSalesSummaryOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSalesSummaryOutput>;
        }));
    }

    protected processGetSalesSummary(response: HttpResponseBase): Observable<GetSalesSummaryOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSalesSummaryOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSalesSummaryOutput>(null as any);
    }

    /**
     * @param limit (optional) 
     * @return Success
     */
    newHiering(limit: number | undefined): Observable<NewHireingOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/NewHiering?";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewHiering(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewHiering(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NewHireingOutput[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NewHireingOutput[]>;
        }));
    }

    protected processNewHiering(response: HttpResponseBase): Observable<NewHireingOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NewHireingOutput.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NewHireingOutput[]>(null as any);
    }

    /**
     * @return Success
     */
    showInActiveTenancyNotification(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/ShowInActiveTenancyNotification";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShowInActiveTenancyNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShowInActiveTenancyNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processShowInActiveTenancyNotification(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    newHieringforMobile(): Observable<NewHireingOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/NewHieringforMobile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewHieringforMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewHieringforMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NewHireingOutput[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NewHireingOutput[]>;
        }));
    }

    protected processNewHieringforMobile(response: HttpResponseBase): Observable<NewHireingOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NewHireingOutput.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NewHireingOutput[]>(null as any);
    }

    /**
     * @return Success
     */
    birthDayWishesforMob(): Observable<NewHireingOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/BirthDayWishesforMob";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBirthDayWishesforMob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBirthDayWishesforMob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NewHireingOutput[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NewHireingOutput[]>;
        }));
    }

    protected processBirthDayWishesforMob(response: HttpResponseBase): Observable<NewHireingOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NewHireingOutput.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NewHireingOutput[]>(null as any);
    }

    /**
     * @return Success
     */
    getDailyWorkScore(): Observable<DailyWorkScoreDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDailyWorkScore";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailyWorkScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailyWorkScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DailyWorkScoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DailyWorkScoreDto>;
        }));
    }

    protected processGetDailyWorkScore(response: HttpResponseBase): Observable<DailyWorkScoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DailyWorkScoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DailyWorkScoreDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(id: number | null | undefined, body: CreateOrEditPostDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/createOrEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadpost(body: CreateOrEditPostDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/Uploadpost";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadpost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadpost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadpost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPostById(id: number | undefined): Observable<PerfetooPost> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetPostById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPostById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPostById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PerfetooPost>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PerfetooPost>;
        }));
    }

    protected processGetPostById(response: HttpResponseBase): Observable<PerfetooPost> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PerfetooPost.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PerfetooPost>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updatePost(id: number | null | undefined, body: CreateOrEditPostDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/UpdatePost?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param imageName (optional) 
     * @param imageData (optional) 
     * @return Success
     */
    saveFtbImageServer(imageName: string | null | undefined, imageData: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/SaveFtbImageServer?";
        if (imageName !== undefined && imageName !== null)
            url_ += "ImageName=" + encodeURIComponent("" + imageName) + "&";
        if (imageData !== undefined && imageData !== null)
            url_ += "ImageData=" + encodeURIComponent("" + imageData) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveFtbImageServer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveFtbImageServer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveFtbImageServer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param v (optional) 
     * @param ftpUser (optional) 
     * @param ftpPassword (optional) 
     * @return Success
     */
    checkIfFileExistsOnServer(v: string | null | undefined, ftpUser: string | null | undefined, ftpPassword: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/CheckIfFileExistsOnServer?";
        if (v !== undefined && v !== null)
            url_ += "v=" + encodeURIComponent("" + v) + "&";
        if (ftpUser !== undefined && ftpUser !== null)
            url_ += "ftpUser=" + encodeURIComponent("" + ftpUser) + "&";
        if (ftpPassword !== undefined && ftpPassword !== null)
            url_ += "ftpPassword=" + encodeURIComponent("" + ftpPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfFileExistsOnServer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfFileExistsOnServer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckIfFileExistsOnServer(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getTownHallAllLists(id: number | undefined, limit: number | undefined): Observable<TownHallList[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetTownHallAllLists?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTownHallAllLists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTownHallAllLists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TownHallList[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TownHallList[]>;
        }));
    }

    protected processGetTownHallAllLists(response: HttpResponseBase): Observable<TownHallList[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TownHallList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TownHallList[]>(null as any);
    }

    /**
     * @return Success
     */
    getKraDatas(): Observable<KraData[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetKraDatas";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKraDatas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKraDatas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KraData[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KraData[]>;
        }));
    }

    protected processGetKraDatas(response: HttpResponseBase): Observable<KraData[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KraData.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<KraData[]>(null as any);
    }

    /**
     * @param postedId (optional) 
     * @return Success
     */
    getPostByName(postedId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetPostByName?";
        if (postedId === null)
            throw new Error("The parameter 'postedId' cannot be null.");
        else if (postedId !== undefined)
            url_ += "PostedId=" + encodeURIComponent("" + postedId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPostByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPostByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetPostByName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param postid (optional) 
     * @return Success
     */
    getimage(postid: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/Getimage?";
        if (postid === null)
            throw new Error("The parameter 'postid' cannot be null.");
        else if (postid !== undefined)
            url_ += "postid=" + encodeURIComponent("" + postid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetimage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetimage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetimage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addResponse(body: ResponseList | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/AddResponse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddResponse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddResponse(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param postId (optional) 
     * @return Success
     */
    getlike(id: number | undefined, postId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/getlike?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (postId === null)
            throw new Error("The parameter 'postId' cannot be null.");
        else if (postId !== undefined)
            url_ += "PostId=" + encodeURIComponent("" + postId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetlike(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetlike(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetlike(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    likecount(id: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/likecount?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLikecount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLikecount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processLikecount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCommentcount(id: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetCommentcount?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommentcount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommentcount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetCommentcount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getComments(id: number | undefined): Observable<CommentList[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetComments?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentList[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentList[]>;
        }));
    }

    protected processGetComments(response: HttpResponseBase): Observable<CommentList[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommentList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommentList[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLikesName(id: number | undefined): Observable<CommentList[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetLikesName?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLikesName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLikesName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentList[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentList[]>;
        }));
    }

    protected processGetLikesName(response: HttpResponseBase): Observable<CommentList[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommentList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommentList[]>(null as any);
    }

    /**
     * @return Success
     */
    adminAdvanceRequest(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/AdminAdvanceRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdminAdvanceRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdminAdvanceRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAdminAdvanceRequest(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    advanceRequests(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/AdvanceRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdvanceRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdvanceRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAdvanceRequests(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param limt (optional) 
     * @return Success
     */
    getQuickLinks(limt: number | undefined): Observable<DropDownQucikLinks[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetQuickLinks?";
        if (limt === null)
            throw new Error("The parameter 'limt' cannot be null.");
        else if (limt !== undefined)
            url_ += "limt=" + encodeURIComponent("" + limt) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuickLinks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuickLinks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDownQucikLinks[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDownQucikLinks[]>;
        }));
    }

    protected processGetQuickLinks(response: HttpResponseBase): Observable<DropDownQucikLinks[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownQucikLinks.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownQucikLinks[]>(null as any);
    }

    /**
     * @param limit (optional) 
     * @return Success
     */
    birthDayWishes(limit: number | undefined): Observable<NewHireingOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/BirthDayWishes?";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBirthDayWishes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBirthDayWishes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NewHireingOutput[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NewHireingOutput[]>;
        }));
    }

    protected processBirthDayWishes(response: HttpResponseBase): Observable<NewHireingOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NewHireingOutput.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NewHireingOutput[]>(null as any);
    }

    /**
     * @return Success
     */
    announcmentData(): Observable<AnnouncemntCount[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/AnnouncmentData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAnnouncmentData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAnnouncmentData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AnnouncemntCount[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AnnouncemntCount[]>;
        }));
    }

    protected processAnnouncmentData(response: HttpResponseBase): Observable<AnnouncemntCount[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AnnouncemntCount.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AnnouncemntCount[]>(null as any);
    }

    /**
     * @return Success
     */
    confirmationsPending(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/ConfirmationsPending";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmationsPending(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmationsPending(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processConfirmationsPending(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param limit (optional) 
     * @return Success
     */
    newpenings(limit: number | undefined): Observable<NewOpenings[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/Newpenings?";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewpenings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewpenings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NewOpenings[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NewOpenings[]>;
        }));
    }

    protected processNewpenings(response: HttpResponseBase): Observable<NewOpenings[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NewOpenings.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NewOpenings[]>(null as any);
    }

    /**
     * @param limit (optional) 
     * @return Success
     */
    policesData(limit: number | undefined): Observable<PolicyeCountCount[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/PolicesData?";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPolicesData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPolicesData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PolicyeCountCount[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PolicyeCountCount[]>;
        }));
    }

    protected processPolicesData(response: HttpResponseBase): Observable<PolicyeCountCount[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PolicyeCountCount.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PolicyeCountCount[]>(null as any);
    }

    /**
     * @param imgName (optional) 
     * @return Success
     */
    downLoadFile(imgName: string | null | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/DownLoadFile?";
        if (imgName !== undefined && imgName !== null)
            url_ += "ImgName=" + encodeURIComponent("" + imgName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownLoadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownLoadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processDownLoadFile(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getRegionalStats(): Observable<GetRegionalStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetRegionalStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegionalStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegionalStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRegionalStatsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRegionalStatsOutput>;
        }));
    }

    protected processGetRegionalStats(response: HttpResponseBase): Observable<GetRegionalStatsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRegionalStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRegionalStatsOutput>(null as any);
    }

    /**
     * @return Success
     */
    getGeneralStats(): Observable<GetGeneralStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetGeneralStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGeneralStatsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGeneralStatsOutput>;
        }));
    }

    protected processGetGeneralStats(response: HttpResponseBase): Observable<GetGeneralStatsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeneralStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGeneralStatsOutput>(null as any);
    }

    /**
     * @return Success
     */
    getMonthlyLateComingsCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetMonthlyLateComingsCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMonthlyLateComingsCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMonthlyLateComingsCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetMonthlyLateComingsCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeePerformanceScore(): Observable<PerformanceScoreDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetEmployeePerformanceScore";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeePerformanceScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeePerformanceScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PerformanceScoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PerformanceScoreDto>;
        }));
    }

    protected processGetEmployeePerformanceScore(response: HttpResponseBase): Observable<PerformanceScoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PerformanceScoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PerformanceScoreDto>(null as any);
    }

    /**
     * @return Success
     */
    getCurrentQuarterForFinancialYear(): Observable<QuarterRange> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetCurrentQuarterForFinancialYear";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentQuarterForFinancialYear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentQuarterForFinancialYear(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuarterRange>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuarterRange>;
        }));
    }

    protected processGetCurrentQuarterForFinancialYear(response: HttpResponseBase): Observable<QuarterRange> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuarterRange.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuarterRange>(null as any);
    }

    /**
     * @return Success
     */
    getCurrentQuaterForCalendarYear(): Observable<QuarterRange> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetCurrentQuaterForCalendarYear";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentQuaterForCalendarYear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentQuaterForCalendarYear(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuarterRange>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuarterRange>;
        }));
    }

    protected processGetCurrentQuaterForCalendarYear(response: HttpResponseBase): Observable<QuarterRange> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuarterRange.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuarterRange>(null as any);
    }

    /**
     * @return Success
     */
    getHalfYearRangeForFinancialYear(): Observable<HalfYearRange> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetHalfYearRangeForFinancialYear";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHalfYearRangeForFinancialYear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHalfYearRangeForFinancialYear(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HalfYearRange>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HalfYearRange>;
        }));
    }

    protected processGetHalfYearRangeForFinancialYear(response: HttpResponseBase): Observable<HalfYearRange> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HalfYearRange.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HalfYearRange>(null as any);
    }

    /**
     * @return Success
     */
    getHalfYearRangeForCalendarYear(): Observable<HalfYearRange> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetHalfYearRangeForCalendarYear";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHalfYearRangeForCalendarYear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHalfYearRangeForCalendarYear(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HalfYearRange>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HalfYearRange>;
        }));
    }

    protected processGetHalfYearRangeForCalendarYear(response: HttpResponseBase): Observable<HalfYearRange> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HalfYearRange.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HalfYearRange>(null as any);
    }
}

@Injectable()
export class TenantRegistrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerTenant(body: RegisterTenantInput | undefined): Observable<RegisterTenantOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/RegisterTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterTenantOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterTenantOutput>;
        }));
    }

    protected processRegisterTenant(response: HttpResponseBase): Observable<RegisterTenantOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterTenantOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterTenantOutput>(null as any);
    }

    /**
     * @return Success
     */
    getEditionsForSelect(): Observable<EditionsSelectOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEditionsForSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionsForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionsForSelect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditionsSelectOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditionsSelectOutput>;
        }));
    }

    protected processGetEditionsForSelect(response: HttpResponseBase): Observable<EditionsSelectOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditionsSelectOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EditionsSelectOutput>(null as any);
    }

    /**
     * @param editionId (optional) 
     * @return Success
     */
    getEdition(editionId: number | undefined): Observable<EditionSelectDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEdition?";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditionSelectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditionSelectDto>;
        }));
    }

    protected processGetEdition(response: HttpResponseBase): Observable<EditionSelectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditionSelectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EditionSelectDto>(null as any);
    }
}

@Injectable()
export class TenantSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<TenantSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantSettingsEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantSettingsEditDto>;
        }));
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<TenantSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantSettingsEditDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAllSettings(body: TenantSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    clearLogo(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadlogo(body: Logodto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/Uploadlogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadlogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadlogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadlogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param imagname (optional) 
     * @param iamgeUrl (optional) 
     * @return Success
     */
    saveFtbImageServer(imagname: string | null | undefined, iamgeUrl: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/SaveFtbImageServer?";
        if (imagname !== undefined && imagname !== null)
            url_ += "Imagname=" + encodeURIComponent("" + imagname) + "&";
        if (iamgeUrl !== undefined && iamgeUrl !== null)
            url_ += "iamgeUrl=" + encodeURIComponent("" + iamgeUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveFtbImageServer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveFtbImageServer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveFtbImageServer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param v (optional) 
     * @param ftpUser (optional) 
     * @param ftpPassword (optional) 
     * @return Success
     */
    checkIfFileExistsOnServer(v: string | null | undefined, ftpUser: string | null | undefined, ftpPassword: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/CheckIfFileExistsOnServer?";
        if (v !== undefined && v !== null)
            url_ += "v=" + encodeURIComponent("" + v) + "&";
        if (ftpUser !== undefined && ftpUser !== null)
            url_ += "ftpUser=" + encodeURIComponent("" + ftpUser) + "&";
        if (ftpPassword !== undefined && ftpPassword !== null)
            url_ += "ftpPassword=" + encodeURIComponent("" + ftpPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfFileExistsOnServer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfFileExistsOnServer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckIfFileExistsOnServer(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return Success
     */
    clearCustomCss(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearCustomCss";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCustomCss(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCustomCss(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearCustomCss(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getTenantAddress(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetTenantAddress";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetTenantAddress(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param address (optional) 
     * @return Success
     */
    updateTenantAddress(address: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateTenantAddress?";
        if (address !== undefined && address !== null)
            url_ += "address=" + encodeURIComponent("" + address) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenantAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenantAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTenantAddress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param remarks (optional) 
     * @return Success
     */
    updateTenanRemarks(remarks: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateTenanRemarks?";
        if (remarks !== undefined && remarks !== null)
            url_ += "Remarks=" + encodeURIComponent("" + remarks) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenanRemarks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenanRemarks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTenanRemarks(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTestEmail(body: SendTestEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class TimeSheetHeaderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submitTimeSheet(body: SubmitTimeSheetDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimeSheetHeader/SubmitTimeSheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitTimeSheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitTimeSheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSubmitTimeSheet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param timeSheetHeaderId (optional) 
     * @param reqApprovalId (optional) 
     * @return Success
     */
    approveTimeSheet(timeSheetHeaderId: number | undefined, reqApprovalId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimeSheetHeader/ApproveTimeSheet?";
        if (timeSheetHeaderId === null)
            throw new Error("The parameter 'timeSheetHeaderId' cannot be null.");
        else if (timeSheetHeaderId !== undefined)
            url_ += "timeSheetHeaderId=" + encodeURIComponent("" + timeSheetHeaderId) + "&";
        if (reqApprovalId === null)
            throw new Error("The parameter 'reqApprovalId' cannot be null.");
        else if (reqApprovalId !== undefined)
            url_ += "reqApprovalId=" + encodeURIComponent("" + reqApprovalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveTimeSheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveTimeSheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApproveTimeSheet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param reqApprovalId (optional) 
     * @return Success
     */
    getTimeSheetDateByReqApprovalId(reqApprovalId: number | undefined): Observable<GetTimeSheetForApprovalDto> {
        let url_ = this.baseUrl + "/api/services/app/TimeSheetHeader/GetTimeSheetDateByReqApprovalId?";
        if (reqApprovalId === null)
            throw new Error("The parameter 'reqApprovalId' cannot be null.");
        else if (reqApprovalId !== undefined)
            url_ += "reqApprovalId=" + encodeURIComponent("" + reqApprovalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimeSheetDateByReqApprovalId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimeSheetDateByReqApprovalId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTimeSheetForApprovalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTimeSheetForApprovalDto>;
        }));
    }

    protected processGetTimeSheetDateByReqApprovalId(response: HttpResponseBase): Observable<GetTimeSheetForApprovalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTimeSheetForApprovalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTimeSheetForApprovalDto>(null as any);
    }

    /**
     * @param timeSheetHeaderId (optional) 
     * @param rejectionReason (optional) 
     * @return Success
     */
    rejectTimeSheet(timeSheetHeaderId: number | undefined, rejectionReason: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimeSheetHeader/RejectTimeSheet?";
        if (timeSheetHeaderId === null)
            throw new Error("The parameter 'timeSheetHeaderId' cannot be null.");
        else if (timeSheetHeaderId !== undefined)
            url_ += "timeSheetHeaderId=" + encodeURIComponent("" + timeSheetHeaderId) + "&";
        if (rejectionReason !== undefined && rejectionReason !== null)
            url_ += "rejectionReason=" + encodeURIComponent("" + rejectionReason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectTimeSheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectTimeSheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRejectTimeSheet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class TimeSheetReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param fromdate (optional) 
     * @param todate (optional) 
     * @param employeeId (optional) 
     * @param projectId (optional) 
     * @param customerId (optional) 
     * @return Success
     */
    timeSheetReport(fromdate: moment.Moment | undefined, todate: moment.Moment | undefined, employeeId: number | undefined, projectId: number | undefined, customerId: number | undefined): Observable<ClumnRowData> {
        let url_ = this.baseUrl + "/api/services/app/TimeSheetReport/timeSheetReport?";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (todate === null)
            throw new Error("The parameter 'todate' cannot be null.");
        else if (todate !== undefined)
            url_ += "todate=" + encodeURIComponent(todate ? "" + todate.toISOString() : "") + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTimeSheetReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTimeSheetReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClumnRowData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClumnRowData>;
        }));
    }

    protected processTimeSheetReport(response: HttpResponseBase): Observable<ClumnRowData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClumnRowData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClumnRowData>(null as any);
    }

    /**
     * @param fromdate (optional) 
     * @param todate (optional) 
     * @param employeeId (optional) 
     * @param projectId (optional) 
     * @param customerId (optional) 
     * @return Success
     */
    timeSheetReportExportToExcel(fromdate: moment.Moment | undefined, todate: moment.Moment | undefined, employeeId: number | undefined, projectId: number | undefined, customerId: number | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TimeSheetReport/timeSheetReportExportToExcel?";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent(fromdate ? "" + fromdate.toISOString() : "") + "&";
        if (todate === null)
            throw new Error("The parameter 'todate' cannot be null.");
        else if (todate !== undefined)
            url_ += "todate=" + encodeURIComponent(todate ? "" + todate.toISOString() : "") + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTimeSheetReportExportToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTimeSheetReportExportToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processTimeSheetReportExportToExcel(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }
}

@Injectable()
export class TimingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param defaultTimezoneScope (optional) 
     * @return Success
     */
    getTimezones(defaultTimezoneScope: SettingScopes | undefined): Observable<ListResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezones?";
        if (defaultTimezoneScope === null)
            throw new Error("The parameter 'defaultTimezoneScope' cannot be null.");
        else if (defaultTimezoneScope !== undefined)
            url_ += "DefaultTimezoneScope=" + encodeURIComponent("" + defaultTimezoneScope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimezones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimezones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfNameValueDto>;
        }));
    }

    protected processGetTimezones(response: HttpResponseBase): Observable<ListResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfNameValueDto>(null as any);
    }

    /**
     * @param selectedTimezoneId (optional) 
     * @return Success
     */
    getTimezoneComboboxItems(selectedTimezoneId: string | null | undefined): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezoneComboboxItems?";
        if (selectedTimezoneId !== undefined && selectedTimezoneId !== null)
            url_ += "SelectedTimezoneId=" + encodeURIComponent("" + selectedTimezoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimezoneComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimezoneComboboxItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDto[]>;
        }));
    }

    protected processGetTimezoneComboboxItems(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComboboxItemDto[]>(null as any);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(null as any);
    }

    /**
     * @param twoFactorVerificationCode (optional) 
     * @param rememberClient (optional) 
     * @param twoFactorRememberClientToken (optional) 
     * @param singleSignIn (optional) 
     * @param returnUrl (optional) 
     * @param deviceId (optional) 
     * @return Success
     */
    mobileAuthenticate(userNameOrEmailAddress: string, password: string, twoFactorVerificationCode: string | null | undefined, rememberClient: boolean | undefined, twoFactorRememberClientToken: string | null | undefined, singleSignIn: boolean | null | undefined, returnUrl: string | null | undefined, deviceId: string | null | undefined): Observable<MobileAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/MobileAuthenticate?";
        if (userNameOrEmailAddress === undefined || userNameOrEmailAddress === null)
            throw new Error("The parameter 'userNameOrEmailAddress' must be defined and cannot be null.");
        else
            url_ += "UserNameOrEmailAddress=" + encodeURIComponent("" + userNameOrEmailAddress) + "&";
        if (password === undefined || password === null)
            throw new Error("The parameter 'password' must be defined and cannot be null.");
        else
            url_ += "Password=" + encodeURIComponent("" + password) + "&";
        if (twoFactorVerificationCode !== undefined && twoFactorVerificationCode !== null)
            url_ += "TwoFactorVerificationCode=" + encodeURIComponent("" + twoFactorVerificationCode) + "&";
        if (rememberClient === null)
            throw new Error("The parameter 'rememberClient' cannot be null.");
        else if (rememberClient !== undefined)
            url_ += "RememberClient=" + encodeURIComponent("" + rememberClient) + "&";
        if (twoFactorRememberClientToken !== undefined && twoFactorRememberClientToken !== null)
            url_ += "TwoFactorRememberClientToken=" + encodeURIComponent("" + twoFactorRememberClientToken) + "&";
        if (singleSignIn !== undefined && singleSignIn !== null)
            url_ += "SingleSignIn=" + encodeURIComponent("" + singleSignIn) + "&";
        if (returnUrl !== undefined && returnUrl !== null)
            url_ += "ReturnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        if (deviceId !== undefined && deviceId !== null)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMobileAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMobileAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MobileAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MobileAuthenticateResultModel>;
        }));
    }

    protected processMobileAuthenticate(response: HttpResponseBase): Observable<MobileAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MobileAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MobileAuthenticateResultModel>(null as any);
    }

    /**
     * @param refreshToken (optional) 
     * @return Success
     */
    refreshToken(refreshToken: string | null | undefined): Observable<RefreshTokenResult> {
        let url_ = this.baseUrl + "/api/TokenAuth/RefreshToken?";
        if (refreshToken !== undefined && refreshToken !== null)
            url_ += "refreshToken=" + encodeURIComponent("" + refreshToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefreshTokenResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefreshTokenResult>;
        }));
    }

    protected processRefreshToken(response: HttpResponseBase): Observable<RefreshTokenResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshTokenResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RefreshTokenResult>(null as any);
    }

    /**
     * @return Success
     */
    logOut(): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/LogOut";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLogOut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTwoFactorAuthCode(body: SendTwoFactorAuthCodeModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/SendTwoFactorAuthCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTwoFactorAuthCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTwoFactorAuthCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTwoFactorAuthCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param impersonationToken (optional) 
     * @return Success
     */
    impersonatedAuthenticate(impersonationToken: string | null | undefined): Observable<ImpersonatedAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ImpersonatedAuthenticate?";
        if (impersonationToken !== undefined && impersonationToken !== null)
            url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonatedAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonatedAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonatedAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonatedAuthenticateResultModel>;
        }));
    }

    protected processImpersonatedAuthenticate(response: HttpResponseBase): Observable<ImpersonatedAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonatedAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImpersonatedAuthenticateResultModel>(null as any);
    }

    /**
     * @param switchAccountToken (optional) 
     * @return Success
     */
    linkedAccountAuthenticate(switchAccountToken: string | null | undefined): Observable<SwitchedAccountAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/LinkedAccountAuthenticate?";
        if (switchAccountToken !== undefined && switchAccountToken !== null)
            url_ += "switchAccountToken=" + encodeURIComponent("" + switchAccountToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkedAccountAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkedAccountAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwitchedAccountAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwitchedAccountAuthenticateResultModel>;
        }));
    }

    protected processLinkedAccountAuthenticate(response: HttpResponseBase): Observable<SwitchedAccountAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SwitchedAccountAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwitchedAccountAuthenticateResultModel>(null as any);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalLoginProviderInfoModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalAuthenticateResultModel>(null as any);
    }

    /**
     * @param message (optional) 
     * @param severity (optional) 
     * @return Success
     */
    testNotification(message: string | null | undefined, severity: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/TestNotification?";
        if (message !== undefined && message !== null)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (severity !== undefined && severity !== null)
            url_ += "severity=" + encodeURIComponent("" + severity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTestNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class TrnAssetMasterDetailsesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param assigne_ReturnFilter (optional) 
     * @param maxDateFilter (optional) 
     * @param minDateFilter (optional) 
     * @param maxFrom_ToFilter (optional) 
     * @param minFrom_ToFilter (optional) 
     * @param assetAssetNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, assigne_ReturnFilter: string | null | undefined, maxDateFilter: moment.Moment | null | undefined, minDateFilter: moment.Moment | null | undefined, maxFrom_ToFilter: number | null | undefined, minFrom_ToFilter: number | null | undefined, assetAssetNameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTrnAssetMasterDetailsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TrnAssetMasterDetailses/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (assigne_ReturnFilter !== undefined && assigne_ReturnFilter !== null)
            url_ += "Assigne_ReturnFilter=" + encodeURIComponent("" + assigne_ReturnFilter) + "&";
        if (maxDateFilter !== undefined && maxDateFilter !== null)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toISOString() : "") + "&";
        if (minDateFilter !== undefined && minDateFilter !== null)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toISOString() : "") + "&";
        if (maxFrom_ToFilter !== undefined && maxFrom_ToFilter !== null)
            url_ += "MaxFrom_ToFilter=" + encodeURIComponent("" + maxFrom_ToFilter) + "&";
        if (minFrom_ToFilter !== undefined && minFrom_ToFilter !== null)
            url_ += "MinFrom_ToFilter=" + encodeURIComponent("" + minFrom_ToFilter) + "&";
        if (assetAssetNameFilter !== undefined && assetAssetNameFilter !== null)
            url_ += "AssetAssetNameFilter=" + encodeURIComponent("" + assetAssetNameFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTrnAssetMasterDetailsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTrnAssetMasterDetailsForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTrnAssetMasterDetailsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTrnAssetMasterDetailsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTrnAssetMasterDetailsForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTrnAssetMasterDetailsForView(id: number | undefined): Observable<GetTrnAssetMasterDetailsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TrnAssetMasterDetailses/GetTrnAssetMasterDetailsForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrnAssetMasterDetailsForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrnAssetMasterDetailsForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTrnAssetMasterDetailsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTrnAssetMasterDetailsForViewDto>;
        }));
    }

    protected processGetTrnAssetMasterDetailsForView(response: HttpResponseBase): Observable<GetTrnAssetMasterDetailsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTrnAssetMasterDetailsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTrnAssetMasterDetailsForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTrnAssetMasterDetailsForEdit(id: number | undefined): Observable<GetTrnAssetMasterDetailsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TrnAssetMasterDetailses/GetTrnAssetMasterDetailsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrnAssetMasterDetailsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrnAssetMasterDetailsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTrnAssetMasterDetailsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTrnAssetMasterDetailsForEditOutput>;
        }));
    }

    protected processGetTrnAssetMasterDetailsForEdit(response: HttpResponseBase): Observable<GetTrnAssetMasterDetailsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTrnAssetMasterDetailsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTrnAssetMasterDetailsForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditTrnAssetMasterDetailsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrnAssetMasterDetailses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrnAssetMasterDetailses/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllAssetForTableDropdown(): Observable<TrnAssetMasterDetailsAssetLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TrnAssetMasterDetailses/GetAllAssetForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAssetForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAssetForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrnAssetMasterDetailsAssetLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrnAssetMasterDetailsAssetLookupTableDto[]>;
        }));
    }

    protected processGetAllAssetForTableDropdown(response: HttpResponseBase): Observable<TrnAssetMasterDetailsAssetLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrnAssetMasterDetailsAssetLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TrnAssetMasterDetailsAssetLookupTableDto[]>(null as any);
    }
}

@Injectable()
export class TrnExpensesClaimServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param expid (optional) 
     * @return Success
     */
    getNatureId(expid: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TrnExpensesClaim/GetNatureId?";
        if (expid === null)
            throw new Error("The parameter 'expid' cannot be null.");
        else if (expid !== undefined)
            url_ += "expid=" + encodeURIComponent("" + expid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNatureId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNatureId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNatureId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param employeeid (optional) 
     * @return Success
     */
    getAllPending(employeeid: number | undefined): Observable<GetTrnExpensesClaimForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TrnExpensesClaim/GetAllPending?";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPending(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPending(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTrnExpensesClaimForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTrnExpensesClaimForViewDto[]>;
        }));
    }

    protected processGetAllPending(response: HttpResponseBase): Observable<GetTrnExpensesClaimForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetTrnExpensesClaimForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTrnExpensesClaimForViewDto[]>(null as any);
    }

    /**
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getAllPendingBulk(month: number | undefined, year: number | undefined): Observable<CreateOrEditTrnExpensesClaimDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TrnExpensesClaim/GetAllPendingBulk?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPendingBulk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPendingBulk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditTrnExpensesClaimDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditTrnExpensesClaimDto[]>;
        }));
    }

    protected processGetAllPendingBulk(response: HttpResponseBase): Observable<CreateOrEditTrnExpensesClaimDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditTrnExpensesClaimDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditTrnExpensesClaimDto[]>(null as any);
    }

    /**
     * @param requestForApprovalId (optional) 
     * @return Success
     */
    getAllPendingBulkForApproval(requestForApprovalId: number | undefined): Observable<CreateOrEditTrnExpensesClaimDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TrnExpensesClaim/GetAllPendingBulkForApproval?";
        if (requestForApprovalId === null)
            throw new Error("The parameter 'requestForApprovalId' cannot be null.");
        else if (requestForApprovalId !== undefined)
            url_ += "RequestForApprovalId=" + encodeURIComponent("" + requestForApprovalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPendingBulkForApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPendingBulkForApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditTrnExpensesClaimDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditTrnExpensesClaimDto[]>;
        }));
    }

    protected processGetAllPendingBulkForApproval(response: HttpResponseBase): Observable<CreateOrEditTrnExpensesClaimDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreateOrEditTrnExpensesClaimDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditTrnExpensesClaimDto[]>(null as any);
    }

    /**
     * @param employeeid (optional) 
     * @return Success
     */
    getAllPendingMobile(employeeid: number | undefined): Observable<GetTrnExpensesClaimForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TrnExpensesClaim/GetAllPendingMobile?";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPendingMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPendingMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTrnExpensesClaimForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTrnExpensesClaimForViewDto[]>;
        }));
    }

    protected processGetAllPendingMobile(response: HttpResponseBase): Observable<GetTrnExpensesClaimForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetTrnExpensesClaimForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTrnExpensesClaimForViewDto[]>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    getAllSubmitted(employeeId: number | undefined): Observable<GetTrnExpensesClaimForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TrnExpensesClaim/GetAllSubmitted?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSubmitted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSubmitted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTrnExpensesClaimForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTrnExpensesClaimForViewDto[]>;
        }));
    }

    protected processGetAllSubmitted(response: HttpResponseBase): Observable<GetTrnExpensesClaimForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetTrnExpensesClaimForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTrnExpensesClaimForViewDto[]>(null as any);
    }

    /**
     * @param employeeid (optional) 
     * @return Success
     */
    getAllSubmittedMobile(employeeid: number | undefined): Observable<GetTrnExpensesClaimForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TrnExpensesClaim/GetAllSubmittedMobile?";
        if (employeeid === null)
            throw new Error("The parameter 'employeeid' cannot be null.");
        else if (employeeid !== undefined)
            url_ += "employeeid=" + encodeURIComponent("" + employeeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSubmittedMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSubmittedMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTrnExpensesClaimForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTrnExpensesClaimForViewDto[]>;
        }));
    }

    protected processGetAllSubmittedMobile(response: HttpResponseBase): Observable<GetTrnExpensesClaimForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetTrnExpensesClaimForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTrnExpensesClaimForViewDto[]>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    getAllPastClaims(employeeId: number | undefined): Observable<GetTrnExpensesClaimForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TrnExpensesClaim/GetAllPastClaims?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPastClaims(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPastClaims(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTrnExpensesClaimForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTrnExpensesClaimForViewDto[]>;
        }));
    }

    protected processGetAllPastClaims(response: HttpResponseBase): Observable<GetTrnExpensesClaimForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetTrnExpensesClaimForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTrnExpensesClaimForViewDto[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param maxexpidFilter (optional) 
     * @param minexpidFilter (optional) 
     * @param maxexpdateFilter (optional) 
     * @param minexpdateFilter (optional) 
     * @param maxamountFilter (optional) 
     * @param minamountFilter (optional) 
     * @param billnoFilter (optional) 
     * @param merchantnameFilter (optional) 
     * @param maxdistanceFilter (optional) 
     * @param mindistanceFilter (optional) 
     * @param maxtravelperiodfromFilter (optional) 
     * @param mintravelperiodfromFilter (optional) 
     * @param maxtrevelperiodtoFilter (optional) 
     * @param mintrevelperiodtoFilter (optional) 
     * @param maxownwardjourneyFilter (optional) 
     * @param minownwardjourneyFilter (optional) 
     * @param maxreturnjourneyFilter (optional) 
     * @param minreturnjourneyFilter (optional) 
     * @param hotelnameFilter (optional) 
     * @param maxcheckinFilter (optional) 
     * @param mincheckinFilter (optional) 
     * @param maxcheckoutFilter (optional) 
     * @param mincheckoutFilter (optional) 
     * @param documenturlFilter (optional) 
     * @param submissionFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxexpidFilter: number | null | undefined, minexpidFilter: number | null | undefined, maxexpdateFilter: moment.Moment | null | undefined, minexpdateFilter: moment.Moment | null | undefined, maxamountFilter: number | null | undefined, minamountFilter: number | null | undefined, billnoFilter: string | null | undefined, merchantnameFilter: string | null | undefined, maxdistanceFilter: number | null | undefined, mindistanceFilter: number | null | undefined, maxtravelperiodfromFilter: moment.Moment | null | undefined, mintravelperiodfromFilter: moment.Moment | null | undefined, maxtrevelperiodtoFilter: moment.Moment | null | undefined, mintrevelperiodtoFilter: moment.Moment | null | undefined, maxownwardjourneyFilter: moment.Moment | null | undefined, minownwardjourneyFilter: moment.Moment | null | undefined, maxreturnjourneyFilter: moment.Moment | null | undefined, minreturnjourneyFilter: moment.Moment | null | undefined, hotelnameFilter: string | null | undefined, maxcheckinFilter: moment.Moment | null | undefined, mincheckinFilter: moment.Moment | null | undefined, maxcheckoutFilter: moment.Moment | null | undefined, mincheckoutFilter: moment.Moment | null | undefined, documenturlFilter: string | null | undefined, submissionFilter: number | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTrnExpensesClaimForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TrnExpensesClaim/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxexpidFilter !== undefined && maxexpidFilter !== null)
            url_ += "MaxexpidFilter=" + encodeURIComponent("" + maxexpidFilter) + "&";
        if (minexpidFilter !== undefined && minexpidFilter !== null)
            url_ += "MinexpidFilter=" + encodeURIComponent("" + minexpidFilter) + "&";
        if (maxexpdateFilter !== undefined && maxexpdateFilter !== null)
            url_ += "MaxexpdateFilter=" + encodeURIComponent(maxexpdateFilter ? "" + maxexpdateFilter.toISOString() : "") + "&";
        if (minexpdateFilter !== undefined && minexpdateFilter !== null)
            url_ += "MinexpdateFilter=" + encodeURIComponent(minexpdateFilter ? "" + minexpdateFilter.toISOString() : "") + "&";
        if (maxamountFilter !== undefined && maxamountFilter !== null)
            url_ += "MaxamountFilter=" + encodeURIComponent("" + maxamountFilter) + "&";
        if (minamountFilter !== undefined && minamountFilter !== null)
            url_ += "MinamountFilter=" + encodeURIComponent("" + minamountFilter) + "&";
        if (billnoFilter !== undefined && billnoFilter !== null)
            url_ += "billnoFilter=" + encodeURIComponent("" + billnoFilter) + "&";
        if (merchantnameFilter !== undefined && merchantnameFilter !== null)
            url_ += "merchantnameFilter=" + encodeURIComponent("" + merchantnameFilter) + "&";
        if (maxdistanceFilter !== undefined && maxdistanceFilter !== null)
            url_ += "MaxdistanceFilter=" + encodeURIComponent("" + maxdistanceFilter) + "&";
        if (mindistanceFilter !== undefined && mindistanceFilter !== null)
            url_ += "MindistanceFilter=" + encodeURIComponent("" + mindistanceFilter) + "&";
        if (maxtravelperiodfromFilter !== undefined && maxtravelperiodfromFilter !== null)
            url_ += "MaxtravelperiodfromFilter=" + encodeURIComponent(maxtravelperiodfromFilter ? "" + maxtravelperiodfromFilter.toISOString() : "") + "&";
        if (mintravelperiodfromFilter !== undefined && mintravelperiodfromFilter !== null)
            url_ += "MintravelperiodfromFilter=" + encodeURIComponent(mintravelperiodfromFilter ? "" + mintravelperiodfromFilter.toISOString() : "") + "&";
        if (maxtrevelperiodtoFilter !== undefined && maxtrevelperiodtoFilter !== null)
            url_ += "MaxtrevelperiodtoFilter=" + encodeURIComponent(maxtrevelperiodtoFilter ? "" + maxtrevelperiodtoFilter.toISOString() : "") + "&";
        if (mintrevelperiodtoFilter !== undefined && mintrevelperiodtoFilter !== null)
            url_ += "MintrevelperiodtoFilter=" + encodeURIComponent(mintrevelperiodtoFilter ? "" + mintrevelperiodtoFilter.toISOString() : "") + "&";
        if (maxownwardjourneyFilter !== undefined && maxownwardjourneyFilter !== null)
            url_ += "MaxownwardjourneyFilter=" + encodeURIComponent(maxownwardjourneyFilter ? "" + maxownwardjourneyFilter.toISOString() : "") + "&";
        if (minownwardjourneyFilter !== undefined && minownwardjourneyFilter !== null)
            url_ += "MinownwardjourneyFilter=" + encodeURIComponent(minownwardjourneyFilter ? "" + minownwardjourneyFilter.toISOString() : "") + "&";
        if (maxreturnjourneyFilter !== undefined && maxreturnjourneyFilter !== null)
            url_ += "MaxreturnjourneyFilter=" + encodeURIComponent(maxreturnjourneyFilter ? "" + maxreturnjourneyFilter.toISOString() : "") + "&";
        if (minreturnjourneyFilter !== undefined && minreturnjourneyFilter !== null)
            url_ += "MinreturnjourneyFilter=" + encodeURIComponent(minreturnjourneyFilter ? "" + minreturnjourneyFilter.toISOString() : "") + "&";
        if (hotelnameFilter !== undefined && hotelnameFilter !== null)
            url_ += "hotelnameFilter=" + encodeURIComponent("" + hotelnameFilter) + "&";
        if (maxcheckinFilter !== undefined && maxcheckinFilter !== null)
            url_ += "MaxcheckinFilter=" + encodeURIComponent(maxcheckinFilter ? "" + maxcheckinFilter.toISOString() : "") + "&";
        if (mincheckinFilter !== undefined && mincheckinFilter !== null)
            url_ += "MincheckinFilter=" + encodeURIComponent(mincheckinFilter ? "" + mincheckinFilter.toISOString() : "") + "&";
        if (maxcheckoutFilter !== undefined && maxcheckoutFilter !== null)
            url_ += "MaxcheckoutFilter=" + encodeURIComponent(maxcheckoutFilter ? "" + maxcheckoutFilter.toISOString() : "") + "&";
        if (mincheckoutFilter !== undefined && mincheckoutFilter !== null)
            url_ += "MincheckoutFilter=" + encodeURIComponent(mincheckoutFilter ? "" + mincheckoutFilter.toISOString() : "") + "&";
        if (documenturlFilter !== undefined && documenturlFilter !== null)
            url_ += "documenturlFilter=" + encodeURIComponent("" + documenturlFilter) + "&";
        if (submissionFilter === null)
            throw new Error("The parameter 'submissionFilter' cannot be null.");
        else if (submissionFilter !== undefined)
            url_ += "submissionFilter=" + encodeURIComponent("" + submissionFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTrnExpensesClaimForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTrnExpensesClaimForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTrnExpensesClaimForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTrnExpensesClaimForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTrnExpensesClaimForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTrnExpensesClaimForView(id: number | undefined): Observable<GetTrnExpensesClaimForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TrnExpensesClaim/GetTrnExpensesClaimForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrnExpensesClaimForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrnExpensesClaimForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTrnExpensesClaimForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTrnExpensesClaimForViewDto>;
        }));
    }

    protected processGetTrnExpensesClaimForView(response: HttpResponseBase): Observable<GetTrnExpensesClaimForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTrnExpensesClaimForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTrnExpensesClaimForViewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param requestid (optional) 
     * @return Success
     */
    getTrnExpensesClaimForEdit(id: number | undefined, requestid: number | undefined): Observable<GetTrnExpensesClaimForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TrnExpensesClaim/GetTrnExpensesClaimForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (requestid === null)
            throw new Error("The parameter 'requestid' cannot be null.");
        else if (requestid !== undefined)
            url_ += "requestid=" + encodeURIComponent("" + requestid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrnExpensesClaimForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrnExpensesClaimForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTrnExpensesClaimForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTrnExpensesClaimForEditOutput>;
        }));
    }

    protected processGetTrnExpensesClaimForEdit(response: HttpResponseBase): Observable<GetTrnExpensesClaimForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTrnExpensesClaimForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTrnExpensesClaimForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBulkExpenseRequest(body: BulKCreateOrEditTrnExpensesClaimDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrnExpensesClaim/CreateBulkExpenseRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBulkExpenseRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBulkExpenseRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateBulkExpenseRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditTrnExpensesClaimDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrnExpensesClaim/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createClaimExpenseMobile(body: CreateOrEditTrnExpensesClaimDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrnExpensesClaim/CreateClaimExpenseMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateClaimExpenseMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateClaimExpenseMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateClaimExpenseMobile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    submitExpanceClaim(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrnExpensesClaim/SubmitExpanceClaim?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitExpanceClaim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitExpanceClaim(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSubmitExpanceClaim(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submitExpanceClaimSelected(body: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrnExpensesClaim/SubmitExpanceClaimSelected";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitExpanceClaimSelected(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitExpanceClaimSelected(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSubmitExpanceClaimSelected(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrnExpensesClaim/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param imageName (optional) 
     * @param imageData (optional) 
     * @return Success
     */
    saveFtbImageServer(imageName: string | null | undefined, imageData: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TrnExpensesClaim/SaveFtbImageServer?";
        if (imageName !== undefined && imageName !== null)
            url_ += "ImageName=" + encodeURIComponent("" + imageName) + "&";
        if (imageData !== undefined && imageData !== null)
            url_ += "ImageData=" + encodeURIComponent("" + imageData) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveFtbImageServer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveFtbImageServer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveFtbImageServer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param v (optional) 
     * @param ftpUser (optional) 
     * @param ftpPassword (optional) 
     * @return Success
     */
    checkIfFileExistsOnServer(v: string | null | undefined, ftpUser: string | null | undefined, ftpPassword: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TrnExpensesClaim/CheckIfFileExistsOnServer?";
        if (v !== undefined && v !== null)
            url_ += "v=" + encodeURIComponent("" + v) + "&";
        if (ftpUser !== undefined && ftpUser !== null)
            url_ += "ftpUser=" + encodeURIComponent("" + ftpUser) + "&";
        if (ftpPassword !== undefined && ftpPassword !== null)
            url_ += "ftpPassword=" + encodeURIComponent("" + ftpPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfFileExistsOnServer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfFileExistsOnServer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckIfFileExistsOnServer(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param documenttypeid (optional) 
     * @return Success
     */
    downLoadFileTemplete(documenttypeid: string | null | undefined): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TrnExpensesClaim/DownLoadFileTemplete?";
        if (documenttypeid !== undefined && documenttypeid !== null)
            url_ += "documenttypeid=" + encodeURIComponent("" + documenttypeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownLoadFileTemplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownLoadFileTemplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processDownLoadFileTemplete(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto[]>(null as any);
    }
}

@Injectable()
export class UiCustomizationSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUiManagementSettings(): Observable<ThemeSettingsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/GetUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUiManagementSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ThemeSettingsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ThemeSettingsDto[]>;
        }));
    }

    protected processGetUiManagementSettings(response: HttpResponseBase): Observable<ThemeSettingsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ThemeSettingsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ThemeSettingsDto[]>(null as any);
    }

    /**
     * @param themeName (optional) 
     * @return Success
     */
    changeThemeWithDefaultValues(themeName: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/ChangeThemeWithDefaultValues?";
        if (themeName !== undefined && themeName !== null)
            url_ += "themeName=" + encodeURIComponent("" + themeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeThemeWithDefaultValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeThemeWithDefaultValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeThemeWithDefaultValues(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUiManagementSettings(body: ThemeSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUiManagementSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUiManagementSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDefaultUiManagementSettings(body: ThemeSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateDefaultUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDefaultUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDefaultUiManagementSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDefaultUiManagementSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    useSystemDefaultSettings(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UseSystemDefaultSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUseSystemDefaultSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUseSystemDefaultSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUseSystemDefaultSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param permission (optional) 
     * @param role (optional) 
     * @param onlyLockedUsers (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getUsers(filter: string | null | undefined, permission: string | null | undefined, role: number | null | undefined, onlyLockedUsers: boolean | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsers?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (permission !== undefined && permission !== null)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        if (role !== undefined && role !== null)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (onlyLockedUsers === null)
            throw new Error("The parameter 'onlyLockedUsers' cannot be null.");
        else if (onlyLockedUsers !== undefined)
            url_ += "OnlyLockedUsers=" + encodeURIComponent("" + onlyLockedUsers) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserListDto>;
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<PagedResultDtoOfUserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserListDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param permission (optional) 
     * @param role (optional) 
     * @param onlyLockedUsers (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getUsersToExcel(filter: string | null | undefined, permission: string | null | undefined, role: number | null | undefined, onlyLockedUsers: boolean | undefined, sorting: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (permission !== undefined && permission !== null)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        if (role !== undefined && role !== null)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (onlyLockedUsers === null)
            throw new Error("The parameter 'onlyLockedUsers' cannot be null.");
        else if (onlyLockedUsers !== undefined)
            url_ += "OnlyLockedUsers=" + encodeURIComponent("" + onlyLockedUsers) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetUsersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserForEdit(id: number | null | undefined): Observable<GetUserForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserForEdit?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserForEditOutput>;
        }));
    }

    protected processGetUserForEdit(response: HttpResponseBase): Observable<GetUserForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserPermissionsForEdit(id: number | undefined): Observable<GetUserPermissionsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserPermissionsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPermissionsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPermissionsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserPermissionsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserPermissionsForEditOutput>;
        }));
    }

    protected processGetUserPermissionsForEdit(response: HttpResponseBase): Observable<GetUserPermissionsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserPermissionsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserPermissionsForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetUserSpecificPermissions(body: EntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetUserSpecificPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetUserSpecificPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetUserSpecificPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetUserSpecificPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserPermissions(body: UpdateUserPermissionsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateUserPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUserPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateUser(body: CreateOrUpdateUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateOrUpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteUser(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeleteUser?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unlockUser(body: EntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UnlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserLinkServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    linkToUser(body: LinkToUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/LinkToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLinkToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getLinkedUsers(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | null | undefined): Observable<PagedResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetLinkedUsers?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLinkedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLinkedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLinkedUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLinkedUserDto>;
        }));
    }

    protected processGetLinkedUsers(response: HttpResponseBase): Observable<PagedResultDtoOfLinkedUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLinkedUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLinkedUserDto>(null as any);
    }

    /**
     * @return Success
     */
    getRecentlyUsedLinkedUsers(): Observable<ListResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetRecentlyUsedLinkedUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentlyUsedLinkedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentlyUsedLinkedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfLinkedUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfLinkedUserDto>;
        }));
    }

    protected processGetRecentlyUsedLinkedUsers(response: HttpResponseBase): Observable<ListResultDtoOfLinkedUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfLinkedUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfLinkedUserDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unlinkUser(body: UnlinkUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/UnlinkUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlinkUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserLoginServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getRecentUserLoginAttempts(): Observable<ListResultDtoOfUserLoginAttemptDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLogin/GetRecentUserLoginAttempts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentUserLoginAttempts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentUserLoginAttempts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserLoginAttemptDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserLoginAttemptDto>;
        }));
    }

    protected processGetRecentUserLoginAttempts(response: HttpResponseBase): Observable<ListResultDtoOfUserLoginAttemptDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserLoginAttemptDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfUserLoginAttemptDto>(null as any);
    }
}

@Injectable()
export class WebLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLatestWebLogs(): Observable<GetLatestWebLogsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/GetLatestWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestWebLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLatestWebLogsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLatestWebLogsOutput>;
        }));
    }

    protected processGetLatestWebLogs(response: HttpResponseBase): Observable<GetLatestWebLogsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLatestWebLogsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLatestWebLogsOutput>(null as any);
    }

    /**
     * @return Success
     */
    downloadWebLogs(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/DownloadWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadWebLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processDownloadWebLogs(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class WhatsAppMessageServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param recient (optional) 
     * @param body (optional) 
     * @return Success
     */
    sendMessage(recient: string | null | undefined, body: HttpRequestMessage | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WhatsAppMessageService/SendMessage?";
        if (recient !== undefined && recient !== null)
            url_ += "recient=" + encodeURIComponent("" + recient) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendMessage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class WipPunchServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param status (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param employeeId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getWipPunches(status: string | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, employeeId: number | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfWipPunchDto> {
        let url_ = this.baseUrl + "/api/services/app/WipPunch/GetWipPunches?";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (employeeId !== undefined && employeeId !== null)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWipPunches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWipPunches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfWipPunchDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfWipPunchDto>;
        }));
    }

    protected processGetWipPunches(response: HttpResponseBase): Observable<PagedResultDtoOfWipPunchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfWipPunchDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfWipPunchDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    retryWipPunch(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WipPunch/RetryWipPunch?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetryWipPunch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetryWipPunch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRetryWipPunch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getWipPunchStats(): Observable<WipPunchStatsDto> {
        let url_ = this.baseUrl + "/api/services/app/WipPunch/GetWipPunchStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWipPunchStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWipPunchStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WipPunchStatsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WipPunchStatsDto>;
        }));
    }

    protected processGetWipPunchStats(response: HttpResponseBase): Observable<WipPunchStatsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WipPunchStatsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WipPunchStatsDto>(null as any);
    }

    /**
     * @return Success
     */
    triggerPunchProcessor(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WipPunch/TriggerPunchProcessor";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTriggerPunchProcessor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTriggerPunchProcessor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTriggerPunchProcessor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class WorkflowServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param workflowType (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, workflowType: number | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetWorkflowForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Workflow/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (workflowType === null)
            throw new Error("The parameter 'workflowType' cannot be null.");
        else if (workflowType !== undefined)
            url_ += "WorkflowType=" + encodeURIComponent("" + workflowType) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetWorkflowForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetWorkflowForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetWorkflowForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetWorkflowForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetWorkflowForViewDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllWorkFlowStreps(): Observable<GetWorkflowForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Workflow/GetAllWorkFlowStreps";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWorkFlowStreps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWorkFlowStreps(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWorkflowForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWorkflowForViewDto[]>;
        }));
    }

    protected processGetAllWorkFlowStreps(response: HttpResponseBase): Observable<GetWorkflowForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetWorkflowForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetWorkflowForViewDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRequesrFlowForView(id: number | undefined): Observable<WorkFlowviewDto> {
        let url_ = this.baseUrl + "/api/services/app/Workflow/GetRequesrFlowForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequesrFlowForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequesrFlowForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkFlowviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkFlowviewDto>;
        }));
    }

    protected processGetRequesrFlowForView(response: HttpResponseBase): Observable<WorkFlowviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkFlowviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkFlowviewDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRequesrFlowForEdit(id: number | undefined): Observable<GetRequesrFlowForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Workflow/GetRequesrFlowForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequesrFlowForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequesrFlowForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRequesrFlowForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRequesrFlowForEditOutput>;
        }));
    }

    protected processGetRequesrFlowForEdit(response: HttpResponseBase): Observable<GetRequesrFlowForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRequesrFlowForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRequesrFlowForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditRequestWorkflowStepDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Workflow/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Workflow/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName!: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export enum TenantAvailabilityState {
    Available = 1,
    InActive = 2,
    NotFound = 3,
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state!: TenantAvailabilityState;
    tenantId!: number | undefined;
    serverRootAddress!: string | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
            this.serverRootAddress = _data["serverRootAddress"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        data["serverRootAddress"] = this.serverRootAddress;
        return data;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
    serverRootAddress: string | undefined;
}

export class ResolveTenantIdInput implements IResolveTenantIdInput {
    c!: string | undefined;

    constructor(data?: IResolveTenantIdInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ResolveTenantIdInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveTenantIdInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["c"] = this.c;
        return data;
    }
}

export interface IResolveTenantIdInput {
    c: string | undefined;
}

export class RegisterInput implements IRegisterInput {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    password!: string;
    captchaResponse!: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin!: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class MobileRegisterInput implements IMobileRegisterInput {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    phoneNumber!: string;

    constructor(data?: IMobileRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): MobileRegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new MobileRegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IMobileRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string;
}

export class MobileRegisterOutput implements IMobileRegisterOutput {
    canLogin!: boolean;
    status!: string | undefined;

    constructor(data?: IMobileRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): MobileRegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new MobileRegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        data["status"] = this.status;
        return data;
    }
}

export interface IMobileRegisterOutput {
    canLogin: boolean;
    status: string | undefined;
}

export class SendPasswordResetCodeInput implements ISendPasswordResetCodeInput {
    emailAddress!: string;

    constructor(data?: ISendPasswordResetCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendPasswordResetCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendPasswordResetCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendPasswordResetCodeInput {
    emailAddress: string;
}

export class SendPasswordResetCodeInputMobile implements ISendPasswordResetCodeInputMobile {
    emailAddress!: string;
    tenantId!: number;

    constructor(data?: ISendPasswordResetCodeInputMobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): SendPasswordResetCodeInputMobile {
        data = typeof data === 'object' ? data : {};
        let result = new SendPasswordResetCodeInputMobile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ISendPasswordResetCodeInputMobile {
    emailAddress: string;
    tenantId: number;
}

export class ResetPasswordInput implements IResetPasswordInput {
    userId!: number;
    resetCode!: string | undefined;
    password!: string | undefined;
    returnUrl!: string | undefined;
    singleSignIn!: string | undefined;
    c!: string | undefined;

    constructor(data?: IResetPasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.resetCode = _data["resetCode"];
            this.password = _data["password"];
            this.returnUrl = _data["returnUrl"];
            this.singleSignIn = _data["singleSignIn"];
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ResetPasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["resetCode"] = this.resetCode;
        data["password"] = this.password;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        data["c"] = this.c;
        return data;
    }
}

export interface IResetPasswordInput {
    userId: number;
    resetCode: string | undefined;
    password: string | undefined;
    returnUrl: string | undefined;
    singleSignIn: string | undefined;
    c: string | undefined;
}

export class ResetPasswordOutput implements IResetPasswordOutput {
    canLogin!: boolean;
    userName!: string | undefined;
    emailAddress!: string | undefined;

    constructor(data?: IResetPasswordOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): ResetPasswordOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IResetPasswordOutput {
    canLogin: boolean;
    userName: string | undefined;
    emailAddress: string | undefined;
}

export class SendEmailActivationLinkInput implements ISendEmailActivationLinkInput {
    emailAddress!: string;

    constructor(data?: ISendEmailActivationLinkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendEmailActivationLinkInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailActivationLinkInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendEmailActivationLinkInput {
    emailAddress: string;
}

export class ActivateEmailInput implements IActivateEmailInput {
    userId!: number;
    confirmationCode!: string | undefined;
    c!: string | undefined;

    constructor(data?: IActivateEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.confirmationCode = _data["confirmationCode"];
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ActivateEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["confirmationCode"] = this.confirmationCode;
        data["c"] = this.c;
        return data;
    }
}

export interface IActivateEmailInput {
    userId: number;
    confirmationCode: string | undefined;
    c: string | undefined;
}

export class ImpersonateInput implements IImpersonateInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IImpersonateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ImpersonateInput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IImpersonateInput {
    tenantId: number | undefined;
    userId: number;
}

export class ImpersonateOutput implements IImpersonateOutput {
    impersonationToken!: string | undefined;
    tenancyName!: string | undefined;

    constructor(data?: IImpersonateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.impersonationToken = _data["impersonationToken"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): ImpersonateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["impersonationToken"] = this.impersonationToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface IImpersonateOutput {
    impersonationToken: string | undefined;
    tenancyName: string | undefined;
}

export class SwitchToLinkedAccountInput implements ISwitchToLinkedAccountInput {
    targetTenantId!: number | undefined;
    targetUserId!: number;

    constructor(data?: ISwitchToLinkedAccountInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetTenantId = _data["targetTenantId"];
            this.targetUserId = _data["targetUserId"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountInput {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchToLinkedAccountInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetTenantId"] = this.targetTenantId;
        data["targetUserId"] = this.targetUserId;
        return data;
    }
}

export interface ISwitchToLinkedAccountInput {
    targetTenantId: number | undefined;
    targetUserId: number;
}

export class SwitchToLinkedAccountOutput implements ISwitchToLinkedAccountOutput {
    switchAccountToken!: string | undefined;
    tenancyName!: string | undefined;

    constructor(data?: ISwitchToLinkedAccountOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.switchAccountToken = _data["switchAccountToken"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchToLinkedAccountOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["switchAccountToken"] = this.switchAccountToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface ISwitchToLinkedAccountOutput {
    switchAccountToken: string | undefined;
    tenancyName: string | undefined;
}

export class SignupModel implements ISignupModel {
    userNameOrEmailAddress!: string;

    constructor(data?: ISignupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
        }
    }

    static fromJS(data: any): SignupModel {
        data = typeof data === 'object' ? data : {};
        let result = new SignupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        return data;
    }
}

export interface ISignupModel {
    userNameOrEmailAddress: string;
}

export enum SubscriptionPaymentType {
    Manual = 0,
    RecurringAutomatic = 1,
    RecurringManual = 2,
}

export class Edition implements IEdition {
    name!: string;
    displayName!: string;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IEdition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Edition {
        data = typeof data === 'object' ? data : {};
        let result = new Edition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEdition {
    name: string;
    displayName: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class UserOrganizationUnit implements IUserOrganizationUnit {
    tenantId!: number | undefined;
    userId!: number;
    organizationUnitId!: number;
    isDeleted!: boolean;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUserOrganizationUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.isDeleted = _data["isDeleted"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserOrganizationUnit {
        data = typeof data === 'object' ? data : {};
        let result = new UserOrganizationUnit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["organizationUnitId"] = this.organizationUnitId;
        data["isDeleted"] = this.isDeleted;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserOrganizationUnit {
    tenantId: number | undefined;
    userId: number;
    organizationUnitId: number;
    isDeleted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class UserToken implements IUserToken {
    tenantId!: number | undefined;
    userId!: number;
    loginProvider!: string | undefined;
    name!: string | undefined;
    value!: string | undefined;
    expireDate!: moment.Moment | undefined;
    id!: number;

    constructor(data?: IUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserToken {
        data = typeof data === 'object' ? data : {};
        let result = new UserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["value"] = this.value;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserToken {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;
    id: number;
}

export class UserLogin implements IUserLogin {
    tenantId!: number | undefined;
    userId!: number;
    loginProvider!: string;
    providerKey!: string;
    id!: number;

    constructor(data?: IUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.providerKey = _data["providerKey"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserLogin {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;
    id: number;
}

export class UserRole implements IUserRole {
    tenantId!: number | undefined;
    userId!: number;
    roleId!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserRole {
    tenantId: number | undefined;
    userId: number;
    roleId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class UserClaim implements IUserClaim {
    tenantId!: number | undefined;
    userId!: number;
    claimType!: string | undefined;
    claimValue!: string | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserClaim {
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class UserPermissionSetting implements IUserPermissionSetting {
    userId!: number;
    tenantId!: number | undefined;
    name!: string;
    isGranted!: boolean;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUserPermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isGranted = _data["isGranted"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserPermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserPermissionSetting {
    userId: number;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Setting implements ISetting {
    tenantId!: number | undefined;
    userId!: number | undefined;
    name!: string;
    value!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Setting {
        data = typeof data === 'object' ? data : {};
        let result = new Setting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISetting {
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class User implements IUser {
    profilePictureId!: string | undefined;
    shouldChangePasswordOnNextLogin!: boolean;
    signInTokenExpireTimeUtc!: moment.Moment | undefined;
    signInToken!: string | undefined;
    googleAuthenticatorKey!: string | undefined;
    organizationUnits!: UserOrganizationUnit[] | undefined;
    normalizedUserName!: string;
    normalizedEmailAddress!: string;
    concurrencyStamp!: string | undefined;
    tokens!: UserToken[] | undefined;
    deleterUser!: User;
    creatorUser!: User;
    lastModifierUser!: User;
    authenticationSource!: string | undefined;
    userName!: string;
    tenantId!: number | undefined;
    emailAddress!: string;
    name!: string;
    surname!: string;
    readonly fullName!: string | undefined;
    password!: string;
    emailConfirmationCode!: string | undefined;
    passwordResetCode!: string | undefined;
    lockoutEndDateUtc!: moment.Moment | undefined;
    accessFailedCount!: number;
    isLockoutEnabled!: boolean;
    phoneNumber!: string | undefined;
    isPhoneNumberConfirmed!: boolean;
    securityStamp!: string | undefined;
    isTwoFactorEnabled!: boolean;
    logins!: UserLogin[] | undefined;
    roles!: UserRole[] | undefined;
    claims!: UserClaim[] | undefined;
    permissions!: UserPermissionSetting[] | undefined;
    settings!: Setting[] | undefined;
    isEmailConfirmed!: boolean;
    isActive!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePictureId = _data["profilePictureId"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.signInTokenExpireTimeUtc = _data["signInTokenExpireTimeUtc"] ? moment(_data["signInTokenExpireTimeUtc"].toString()) : <any>undefined;
            this.signInToken = _data["signInToken"];
            this.googleAuthenticatorKey = _data["googleAuthenticatorKey"];
            if (Array.isArray(_data["organizationUnits"])) {
                this.organizationUnits = [] as any;
                for (let item of _data["organizationUnits"])
                    this.organizationUnits!.push(UserOrganizationUnit.fromJS(item));
            }
            this.normalizedUserName = _data["normalizedUserName"];
            this.normalizedEmailAddress = _data["normalizedEmailAddress"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            if (Array.isArray(_data["tokens"])) {
                this.tokens = [] as any;
                for (let item of _data["tokens"])
                    this.tokens!.push(UserToken.fromJS(item));
            }
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.authenticationSource = _data["authenticationSource"];
            this.userName = _data["userName"];
            this.tenantId = _data["tenantId"];
            this.emailAddress = _data["emailAddress"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            (<any>this).fullName = _data["fullName"];
            this.password = _data["password"];
            this.emailConfirmationCode = _data["emailConfirmationCode"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? moment(_data["lockoutEndDateUtc"].toString()) : <any>undefined;
            this.accessFailedCount = _data["accessFailedCount"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.securityStamp = _data["securityStamp"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            if (Array.isArray(_data["logins"])) {
                this.logins = [] as any;
                for (let item of _data["logins"])
                    this.logins!.push(UserLogin.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRole.fromJS(item));
            }
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(UserClaim.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(UserPermissionSetting.fromJS(item));
            }
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings!.push(Setting.fromJS(item));
            }
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePictureId"] = this.profilePictureId;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["signInTokenExpireTimeUtc"] = this.signInTokenExpireTimeUtc ? this.signInTokenExpireTimeUtc.toISOString() : <any>undefined;
        data["signInToken"] = this.signInToken;
        data["googleAuthenticatorKey"] = this.googleAuthenticatorKey;
        if (Array.isArray(this.organizationUnits)) {
            data["organizationUnits"] = [];
            for (let item of this.organizationUnits)
                data["organizationUnits"].push(item.toJSON());
        }
        data["normalizedUserName"] = this.normalizedUserName;
        data["normalizedEmailAddress"] = this.normalizedEmailAddress;
        data["concurrencyStamp"] = this.concurrencyStamp;
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item.toJSON());
        }
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["authenticationSource"] = this.authenticationSource;
        data["userName"] = this.userName;
        data["tenantId"] = this.tenantId;
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["password"] = this.password;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        data["passwordResetCode"] = this.passwordResetCode;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : <any>undefined;
        data["accessFailedCount"] = this.accessFailedCount;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["securityStamp"] = this.securityStamp;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        if (Array.isArray(this.logins)) {
            data["logins"] = [];
            for (let item of this.logins)
                data["logins"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item.toJSON());
        }
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUser {
    profilePictureId: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    signInTokenExpireTimeUtc: moment.Moment | undefined;
    signInToken: string | undefined;
    googleAuthenticatorKey: string | undefined;
    organizationUnits: UserOrganizationUnit[] | undefined;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Tenant implements ITenant {
    leaveCycle!: number | undefined;
    performanceCycle!: number | undefined;
    maxUserCount!: number;
    graceEmployee!: number;
    tenancyAddress!: string | undefined;
    mrrExists!: boolean;
    perfettoErpExists!: boolean;
    remarks!: string | undefined;
    showLeaveOnss!: boolean;
    autoAdjustmentMaxLimit!: number | undefined;
    subscriptionEndDateUtc!: moment.Moment | undefined;
    salaryCycleStartDay!: number | undefined;
    isInTrialPeriod!: boolean;
    customCssId!: string | undefined;
    logoId!: string | undefined;
    pastNoOfDays!: number | undefined;
    futureNoOfDays!: number | undefined;
    bithdayWiseMail!: string | undefined;
    birthdayWishWhatsApp!: string | undefined;
    workAnniversaryWishWhatsApp!: string | undefined;
    marriageAnniversaryWishWhatsApp!: string | undefined;
    salaryTemplate!: number | undefined;
    logoFileType!: string | undefined;
    subscriptionPaymentType!: SubscriptionPaymentType;
    showallWishesorcurrentloc!: number | undefined;
    showallhiresorcurrentloc!: number | undefined;
    capturedFailedPunches!: boolean;
    lastPunchCapturedTime!: moment.Moment | undefined;
    countryCode!: string | undefined;
    netPayableAccode!: number | undefined;
    manualLeaveAccrual!: boolean;
    lingNetPayableWithDimension!: boolean;
    edition!: Edition;
    editionId!: number | undefined;
    creatorUser!: User;
    lastModifierUser!: User;
    deleterUser!: User;
    tenancyName!: string;
    name!: string;
    connectionString!: string | undefined;
    isActive!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ITenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveCycle = _data["leaveCycle"];
            this.performanceCycle = _data["performanceCycle"];
            this.maxUserCount = _data["maxUserCount"];
            this.graceEmployee = _data["graceEmployee"];
            this.tenancyAddress = _data["tenancyAddress"];
            this.mrrExists = _data["mrrExists"];
            this.perfettoErpExists = _data["perfettoErpExists"];
            this.remarks = _data["remarks"];
            this.showLeaveOnss = _data["showLeaveOnss"];
            this.autoAdjustmentMaxLimit = _data["autoAdjustmentMaxLimit"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? moment(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.salaryCycleStartDay = _data["salaryCycleStartDay"];
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.customCssId = _data["customCssId"];
            this.logoId = _data["logoId"];
            this.pastNoOfDays = _data["pastNoOfDays"];
            this.futureNoOfDays = _data["futureNoOfDays"];
            this.bithdayWiseMail = _data["bithdayWiseMail"];
            this.birthdayWishWhatsApp = _data["birthdayWishWhatsApp"];
            this.workAnniversaryWishWhatsApp = _data["workAnniversaryWishWhatsApp"];
            this.marriageAnniversaryWishWhatsApp = _data["marriageAnniversaryWishWhatsApp"];
            this.salaryTemplate = _data["salaryTemplate"];
            this.logoFileType = _data["logoFileType"];
            this.subscriptionPaymentType = _data["subscriptionPaymentType"];
            this.showallWishesorcurrentloc = _data["showallWishesorcurrentloc"];
            this.showallhiresorcurrentloc = _data["showallhiresorcurrentloc"];
            this.capturedFailedPunches = _data["capturedFailedPunches"];
            this.lastPunchCapturedTime = _data["lastPunchCapturedTime"] ? moment(_data["lastPunchCapturedTime"].toString()) : <any>undefined;
            this.countryCode = _data["countryCode"];
            this.netPayableAccode = _data["netPayableAccode"];
            this.manualLeaveAccrual = _data["manualLeaveAccrual"];
            this.lingNetPayableWithDimension = _data["lingNetPayableWithDimension"];
            this.edition = _data["edition"] ? Edition.fromJS(_data["edition"]) : <any>undefined;
            this.editionId = _data["editionId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Tenant {
        data = typeof data === 'object' ? data : {};
        let result = new Tenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveCycle"] = this.leaveCycle;
        data["performanceCycle"] = this.performanceCycle;
        data["maxUserCount"] = this.maxUserCount;
        data["graceEmployee"] = this.graceEmployee;
        data["tenancyAddress"] = this.tenancyAddress;
        data["mrrExists"] = this.mrrExists;
        data["perfettoErpExists"] = this.perfettoErpExists;
        data["remarks"] = this.remarks;
        data["showLeaveOnss"] = this.showLeaveOnss;
        data["autoAdjustmentMaxLimit"] = this.autoAdjustmentMaxLimit;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["salaryCycleStartDay"] = this.salaryCycleStartDay;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["customCssId"] = this.customCssId;
        data["logoId"] = this.logoId;
        data["pastNoOfDays"] = this.pastNoOfDays;
        data["futureNoOfDays"] = this.futureNoOfDays;
        data["bithdayWiseMail"] = this.bithdayWiseMail;
        data["birthdayWishWhatsApp"] = this.birthdayWishWhatsApp;
        data["workAnniversaryWishWhatsApp"] = this.workAnniversaryWishWhatsApp;
        data["marriageAnniversaryWishWhatsApp"] = this.marriageAnniversaryWishWhatsApp;
        data["salaryTemplate"] = this.salaryTemplate;
        data["logoFileType"] = this.logoFileType;
        data["subscriptionPaymentType"] = this.subscriptionPaymentType;
        data["showallWishesorcurrentloc"] = this.showallWishesorcurrentloc;
        data["showallhiresorcurrentloc"] = this.showallhiresorcurrentloc;
        data["capturedFailedPunches"] = this.capturedFailedPunches;
        data["lastPunchCapturedTime"] = this.lastPunchCapturedTime ? this.lastPunchCapturedTime.toISOString() : <any>undefined;
        data["countryCode"] = this.countryCode;
        data["netPayableAccode"] = this.netPayableAccode;
        data["manualLeaveAccrual"] = this.manualLeaveAccrual;
        data["lingNetPayableWithDimension"] = this.lingNetPayableWithDimension;
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["editionId"] = this.editionId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenant {
    leaveCycle: number | undefined;
    performanceCycle: number | undefined;
    maxUserCount: number;
    graceEmployee: number;
    tenancyAddress: string | undefined;
    mrrExists: boolean;
    perfettoErpExists: boolean;
    remarks: string | undefined;
    showLeaveOnss: boolean;
    autoAdjustmentMaxLimit: number | undefined;
    subscriptionEndDateUtc: moment.Moment | undefined;
    salaryCycleStartDay: number | undefined;
    isInTrialPeriod: boolean;
    customCssId: string | undefined;
    logoId: string | undefined;
    pastNoOfDays: number | undefined;
    futureNoOfDays: number | undefined;
    bithdayWiseMail: string | undefined;
    birthdayWishWhatsApp: string | undefined;
    workAnniversaryWishWhatsApp: string | undefined;
    marriageAnniversaryWishWhatsApp: string | undefined;
    salaryTemplate: number | undefined;
    logoFileType: string | undefined;
    subscriptionPaymentType: SubscriptionPaymentType;
    showallWishesorcurrentloc: number | undefined;
    showallhiresorcurrentloc: number | undefined;
    capturedFailedPunches: boolean;
    lastPunchCapturedTime: moment.Moment | undefined;
    countryCode: string | undefined;
    netPayableAccode: number | undefined;
    manualLeaveAccrual: boolean;
    lingNetPayableWithDimension: boolean;
    edition: Edition;
    editionId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    deleterUser: User;
    tenancyName: string;
    name: string;
    connectionString: string | undefined;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export enum NameSuffix {
    Mr = 1,
    Mrs = 2,
    Ms = 3,
}

export class EmployeeName implements IEmployeeName {
    salutation!: NameSuffix;
    readonly firstName!: string | undefined;
    readonly lastName!: string | undefined;

    constructor(data?: IEmployeeName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salutation = _data["salutation"];
            (<any>this).firstName = _data["firstName"];
            (<any>this).lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): EmployeeName {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salutation"] = this.salutation;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface IEmployeeName {
    salutation: NameSuffix;
    firstName: string | undefined;
    lastName: string | undefined;
}

export enum Gender {
    Female = 1,
    Male = 2,
}

export enum EmployeeStatus {
    Active = 1,
    Terminated = 2,
    Resigned = 3,
    Probation = 4,
}

export class Country implements ICountry {
    name!: string | undefined;
    nationality!: string | undefined;
    id!: number;

    constructor(data?: ICountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nationality = _data["nationality"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Country {
        data = typeof data === 'object' ? data : {};
        let result = new Country();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nationality"] = this.nationality;
        data["id"] = this.id;
        return data;
    }
}

export interface ICountry {
    name: string | undefined;
    nationality: string | undefined;
    id: number;
}

export enum EmployeeRelation {
    Other = 0,
    Father = 1,
    Mother = 2,
    Brother = 3,
    Sister = 4,
    Spouse = 5,
    Son = 6,
    Daughter = 7,
    Grandfather = 8,
    Grandmother = 9,
    Uncle = 10,
    Aunt = 11,
    Cousin = 12,
    Friend = 13,
}

export class EmergencyContact implements IEmergencyContact {
    name!: string | undefined;
    mobile!: string | undefined;
    relationShip!: EmployeeRelation;

    constructor(data?: IEmergencyContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.mobile = _data["mobile"];
            this.relationShip = _data["relationShip"];
        }
    }

    static fromJS(data: any): EmergencyContact {
        data = typeof data === 'object' ? data : {};
        let result = new EmergencyContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["mobile"] = this.mobile;
        data["relationShip"] = this.relationShip;
        return data;
    }
}

export interface IEmergencyContact {
    name: string | undefined;
    mobile: string | undefined;
    relationShip: EmployeeRelation;
}

export class EmploymentType implements IEmploymentType {
    readonly name!: string | undefined;
    readonly id!: number;

    constructor(data?: IEmploymentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            (<any>this).id = _data["id"];
        }
    }

    static fromJS(data: any): EmploymentType {
        data = typeof data === 'object' ? data : {};
        let result = new EmploymentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IEmploymentType {
    name: string | undefined;
    id: number;
}

export class Division implements IDivision {
    tenantId!: number;
    tenant!: Tenant;
    name!: string | undefined;
    id!: number;

    constructor(data?: IDivision) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Division {
        data = typeof data === 'object' ? data : {};
        let result = new Division();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IDivision {
    tenantId: number;
    tenant: Tenant;
    name: string | undefined;
    id: number;
}

export class Department implements IDepartment {
    tenantId!: number | undefined;
    tenant!: Tenant;
    name!: string | undefined;
    id!: number;

    constructor(data?: IDepartment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Department {
        data = typeof data === 'object' ? data : {};
        let result = new Department();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IDepartment {
    tenantId: number | undefined;
    tenant: Tenant;
    name: string | undefined;
    id: number;
}

export class SubDepartment implements ISubDepartment {
    tenantId!: number | undefined;
    tenant!: Tenant;
    name!: string | undefined;
    departmentId!: number;
    departmentFK!: Department;
    id!: number;

    constructor(data?: ISubDepartment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.name = _data["name"];
            this.departmentId = _data["departmentId"];
            this.departmentFK = _data["departmentFK"] ? Department.fromJS(_data["departmentFK"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SubDepartment {
        data = typeof data === 'object' ? data : {};
        let result = new SubDepartment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["departmentId"] = this.departmentId;
        data["departmentFK"] = this.departmentFK ? this.departmentFK.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ISubDepartment {
    tenantId: number | undefined;
    tenant: Tenant;
    name: string | undefined;
    departmentId: number;
    departmentFK: Department;
    id: number;
}

export class Designation implements IDesignation {
    tenantId!: number;
    tenant!: Tenant;
    name!: string | undefined;
    id!: number;

    constructor(data?: IDesignation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Designation {
        data = typeof data === 'object' ? data : {};
        let result = new Designation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IDesignation {
    tenantId: number;
    tenant: Tenant;
    name: string | undefined;
    id: number;
}

export class Location implements ILocation {
    tenantId!: number;
    tenant!: Tenant;
    name!: string | undefined;
    latitude!: string | undefined;
    longitude!: string | undefined;
    radius!: number;
    branchCompanyName!: string | undefined;
    branchCompanyAddress!: string | undefined;
    pt!: boolean;
    lwf!: boolean;
    state!: number;
    logoId!: string | undefined;
    logoFileType!: string | undefined;
    id!: number;

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.name = _data["name"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.radius = _data["radius"];
            this.branchCompanyName = _data["branchCompanyName"];
            this.branchCompanyAddress = _data["branchCompanyAddress"];
            this.pt = _data["pt"];
            this.lwf = _data["lwf"];
            this.state = _data["state"];
            this.logoId = _data["logoId"];
            this.logoFileType = _data["logoFileType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["radius"] = this.radius;
        data["branchCompanyName"] = this.branchCompanyName;
        data["branchCompanyAddress"] = this.branchCompanyAddress;
        data["pt"] = this.pt;
        data["lwf"] = this.lwf;
        data["state"] = this.state;
        data["logoId"] = this.logoId;
        data["logoFileType"] = this.logoFileType;
        data["id"] = this.id;
        return data;
    }
}

export interface ILocation {
    tenantId: number;
    tenant: Tenant;
    name: string | undefined;
    latitude: string | undefined;
    longitude: string | undefined;
    radius: number;
    branchCompanyName: string | undefined;
    branchCompanyAddress: string | undefined;
    pt: boolean;
    lwf: boolean;
    state: number;
    logoId: string | undefined;
    logoFileType: string | undefined;
    id: number;
}

export class Shift implements IShift {
    tenantId!: number;
    tenant!: Tenant;
    shiftCode!: string | undefined;
    shiftName!: string | undefined;
    shiftStartTime!: string;
    shiftEndTime!: string;
    markHalfDayAfterTime!: string | undefined;
    shiftHours!: number;
    nightShift!: boolean;
    breakTime!: number | undefined;
    weekOffs!: boolean;
    minimumWorkingHoursForFullDays!: number;
    minimumWorkingHoursForHaffDays!: number;
    weekOff!: string | undefined;
    showTimingsOnCalendar!: boolean;
    priorComingAllowed!: number | undefined;
    id!: number;

    constructor(data?: IShift) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.shiftCode = _data["shiftCode"];
            this.shiftName = _data["shiftName"];
            this.shiftStartTime = _data["shiftStartTime"];
            this.shiftEndTime = _data["shiftEndTime"];
            this.markHalfDayAfterTime = _data["markHalfDayAfterTime"];
            this.shiftHours = _data["shiftHours"];
            this.nightShift = _data["nightShift"];
            this.breakTime = _data["breakTime"];
            this.weekOffs = _data["weekOffs"];
            this.minimumWorkingHoursForFullDays = _data["minimumWorkingHoursForFullDays"];
            this.minimumWorkingHoursForHaffDays = _data["minimumWorkingHoursForHaffDays"];
            this.weekOff = _data["weekOff"];
            this.showTimingsOnCalendar = _data["showTimingsOnCalendar"];
            this.priorComingAllowed = _data["priorComingAllowed"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Shift {
        data = typeof data === 'object' ? data : {};
        let result = new Shift();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["shiftCode"] = this.shiftCode;
        data["shiftName"] = this.shiftName;
        data["shiftStartTime"] = this.shiftStartTime;
        data["shiftEndTime"] = this.shiftEndTime;
        data["markHalfDayAfterTime"] = this.markHalfDayAfterTime;
        data["shiftHours"] = this.shiftHours;
        data["nightShift"] = this.nightShift;
        data["breakTime"] = this.breakTime;
        data["weekOffs"] = this.weekOffs;
        data["minimumWorkingHoursForFullDays"] = this.minimumWorkingHoursForFullDays;
        data["minimumWorkingHoursForHaffDays"] = this.minimumWorkingHoursForHaffDays;
        data["weekOff"] = this.weekOff;
        data["showTimingsOnCalendar"] = this.showTimingsOnCalendar;
        data["priorComingAllowed"] = this.priorComingAllowed;
        data["id"] = this.id;
        return data;
    }
}

export interface IShift {
    tenantId: number;
    tenant: Tenant;
    shiftCode: string | undefined;
    shiftName: string | undefined;
    shiftStartTime: string;
    shiftEndTime: string;
    markHalfDayAfterTime: string | undefined;
    shiftHours: number;
    nightShift: boolean;
    breakTime: number | undefined;
    weekOffs: boolean;
    minimumWorkingHoursForFullDays: number;
    minimumWorkingHoursForHaffDays: number;
    weekOff: string | undefined;
    showTimingsOnCalendar: boolean;
    priorComingAllowed: number | undefined;
    id: number;
}

export class Contrator implements IContrator {
    tenantId!: number | undefined;
    tenant!: Tenant;
    name!: string | undefined;
    streetAddress!: string;
    city!: string | undefined;
    state!: number;
    locationIDFK!: Location;
    country!: number;
    countryFK!: Country;
    pinCode!: number;
    contactName!: string | undefined;
    contactEmail!: string | undefined;
    contactMobile!: string | undefined;
    gstIN!: string | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IContrator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.name = _data["name"];
            this.streetAddress = _data["streetAddress"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.locationIDFK = _data["locationIDFK"] ? Location.fromJS(_data["locationIDFK"]) : <any>undefined;
            this.country = _data["country"];
            this.countryFK = _data["countryFK"] ? Country.fromJS(_data["countryFK"]) : <any>undefined;
            this.pinCode = _data["pinCode"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.contactMobile = _data["contactMobile"];
            this.gstIN = _data["gstIN"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Contrator {
        data = typeof data === 'object' ? data : {};
        let result = new Contrator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["streetAddress"] = this.streetAddress;
        data["city"] = this.city;
        data["state"] = this.state;
        data["locationIDFK"] = this.locationIDFK ? this.locationIDFK.toJSON() : <any>undefined;
        data["country"] = this.country;
        data["countryFK"] = this.countryFK ? this.countryFK.toJSON() : <any>undefined;
        data["pinCode"] = this.pinCode;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["contactMobile"] = this.contactMobile;
        data["gstIN"] = this.gstIN;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IContrator {
    tenantId: number | undefined;
    tenant: Tenant;
    name: string | undefined;
    streetAddress: string;
    city: string | undefined;
    state: number;
    locationIDFK: Location;
    country: number;
    countryFK: Country;
    pinCode: number;
    contactName: string | undefined;
    contactEmail: string | undefined;
    contactMobile: string | undefined;
    gstIN: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Employment implements IEmployment {
    readonly dateOfJoining!: moment.Moment;
    employeeConfirmDate!: moment.Moment | undefined;
    dateOfLeaving!: moment.Moment | undefined;
    readonly previousEmployeeCode!: string | undefined;
    employmentType!: EmploymentType;
    readonly employmentTypeId!: number;
    division!: Division;
    department!: Department;
    subDepartment!: SubDepartment;
    designation!: Designation;
    location!: Location;
    reportingManager!: Employee;
    functionalManager!: Employee;
    readonly headquarterId!: number | undefined;
    readonly shiftId!: number | undefined;
    shift!: Shift;
    readonly contractorId!: number | undefined;
    contractor!: Contrator;
    readonly referenceDetails!: string | undefined;
    rehireEligibility!: number | undefined;
    remarks!: string | undefined;

    constructor(data?: IEmployment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).dateOfJoining = _data["dateOfJoining"] ? moment(_data["dateOfJoining"].toString()) : <any>undefined;
            this.employeeConfirmDate = _data["employeeConfirmDate"] ? moment(_data["employeeConfirmDate"].toString()) : <any>undefined;
            this.dateOfLeaving = _data["dateOfLeaving"] ? moment(_data["dateOfLeaving"].toString()) : <any>undefined;
            (<any>this).previousEmployeeCode = _data["previousEmployeeCode"];
            this.employmentType = _data["employmentType"] ? EmploymentType.fromJS(_data["employmentType"]) : <any>undefined;
            (<any>this).employmentTypeId = _data["employmentTypeId"];
            this.division = _data["division"] ? Division.fromJS(_data["division"]) : <any>undefined;
            this.department = _data["department"] ? Department.fromJS(_data["department"]) : <any>undefined;
            this.subDepartment = _data["subDepartment"] ? SubDepartment.fromJS(_data["subDepartment"]) : <any>undefined;
            this.designation = _data["designation"] ? Designation.fromJS(_data["designation"]) : <any>undefined;
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.reportingManager = _data["reportingManager"] ? Employee.fromJS(_data["reportingManager"]) : <any>undefined;
            this.functionalManager = _data["functionalManager"] ? Employee.fromJS(_data["functionalManager"]) : <any>undefined;
            (<any>this).headquarterId = _data["headquarterId"];
            (<any>this).shiftId = _data["shiftId"];
            this.shift = _data["shift"] ? Shift.fromJS(_data["shift"]) : <any>undefined;
            (<any>this).contractorId = _data["contractorId"];
            this.contractor = _data["contractor"] ? Contrator.fromJS(_data["contractor"]) : <any>undefined;
            (<any>this).referenceDetails = _data["referenceDetails"];
            this.rehireEligibility = _data["rehireEligibility"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): Employment {
        data = typeof data === 'object' ? data : {};
        let result = new Employment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateOfJoining"] = this.dateOfJoining ? this.dateOfJoining.toISOString() : <any>undefined;
        data["employeeConfirmDate"] = this.employeeConfirmDate ? this.employeeConfirmDate.toISOString() : <any>undefined;
        data["dateOfLeaving"] = this.dateOfLeaving ? this.dateOfLeaving.toISOString() : <any>undefined;
        data["previousEmployeeCode"] = this.previousEmployeeCode;
        data["employmentType"] = this.employmentType ? this.employmentType.toJSON() : <any>undefined;
        data["employmentTypeId"] = this.employmentTypeId;
        data["division"] = this.division ? this.division.toJSON() : <any>undefined;
        data["department"] = this.department ? this.department.toJSON() : <any>undefined;
        data["subDepartment"] = this.subDepartment ? this.subDepartment.toJSON() : <any>undefined;
        data["designation"] = this.designation ? this.designation.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["reportingManager"] = this.reportingManager ? this.reportingManager.toJSON() : <any>undefined;
        data["functionalManager"] = this.functionalManager ? this.functionalManager.toJSON() : <any>undefined;
        data["headquarterId"] = this.headquarterId;
        data["shiftId"] = this.shiftId;
        data["shift"] = this.shift ? this.shift.toJSON() : <any>undefined;
        data["contractorId"] = this.contractorId;
        data["contractor"] = this.contractor ? this.contractor.toJSON() : <any>undefined;
        data["referenceDetails"] = this.referenceDetails;
        data["rehireEligibility"] = this.rehireEligibility;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IEmployment {
    dateOfJoining: moment.Moment;
    employeeConfirmDate: moment.Moment | undefined;
    dateOfLeaving: moment.Moment | undefined;
    previousEmployeeCode: string | undefined;
    employmentType: EmploymentType;
    employmentTypeId: number;
    division: Division;
    department: Department;
    subDepartment: SubDepartment;
    designation: Designation;
    location: Location;
    reportingManager: Employee;
    functionalManager: Employee;
    headquarterId: number | undefined;
    shiftId: number | undefined;
    shift: Shift;
    contractorId: number | undefined;
    contractor: Contrator;
    referenceDetails: string | undefined;
    rehireEligibility: number | undefined;
    remarks: string | undefined;
}

export class State implements IState {
    name!: string | undefined;
    countryId!: number | undefined;
    country!: Country;
    id!: number;

    constructor(data?: IState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.countryId = _data["countryId"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): State {
        data = typeof data === 'object' ? data : {};
        let result = new State();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["countryId"] = this.countryId;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IState {
    name: string | undefined;
    countryId: number | undefined;
    country: Country;
    id: number;
}

export class Address implements IAddress {
    street!: string | undefined;
    city!: string | undefined;
    state!: State;
    country!: Country;
    zipCode!: string | undefined;
    district!: string | undefined;
    ward!: string | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.street = _data["street"];
            this.city = _data["city"];
            this.state = _data["state"] ? State.fromJS(_data["state"]) : <any>undefined;
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.zipCode = _data["zipCode"];
            this.district = _data["district"];
            this.ward = _data["ward"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["city"] = this.city;
        data["state"] = this.state ? this.state.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["zipCode"] = this.zipCode;
        data["district"] = this.district;
        data["ward"] = this.ward;
        return data;
    }
}

export interface IAddress {
    street: string | undefined;
    city: string | undefined;
    state: State;
    country: Country;
    zipCode: string | undefined;
    district: string | undefined;
    ward: string | undefined;
}

export class DependentType implements IDependentType {
    readonly name!: string | undefined;
    readonly id!: number;

    constructor(data?: IDependentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            (<any>this).id = _data["id"];
        }
    }

    static fromJS(data: any): DependentType {
        data = typeof data === 'object' ? data : {};
        let result = new DependentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IDependentType {
    name: string | undefined;
    id: number;
}

export class Dependent implements IDependent {
    readonly name!: string | undefined;
    phoneNumber!: string | undefined;
    readonly dateOfBirth!: moment.Moment;
    dependentType!: DependentType;
    readonly remarks!: string | undefined;
    readonly aadharcard!: string | undefined;
    readonly panCard!: string | undefined;
    id!: number;

    constructor(data?: IDependent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            (<any>this).dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : <any>undefined;
            this.dependentType = _data["dependentType"] ? DependentType.fromJS(_data["dependentType"]) : <any>undefined;
            (<any>this).remarks = _data["remarks"];
            (<any>this).aadharcard = _data["aadharcard"];
            (<any>this).panCard = _data["panCard"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Dependent {
        data = typeof data === 'object' ? data : {};
        let result = new Dependent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["dependentType"] = this.dependentType ? this.dependentType.toJSON() : <any>undefined;
        data["remarks"] = this.remarks;
        data["aadharcard"] = this.aadharcard;
        data["panCard"] = this.panCard;
        data["id"] = this.id;
        return data;
    }
}

export interface IDependent {
    name: string | undefined;
    phoneNumber: string | undefined;
    dateOfBirth: moment.Moment;
    dependentType: DependentType;
    remarks: string | undefined;
    aadharcard: string | undefined;
    panCard: string | undefined;
    id: number;
}

export class PersonalDetails implements IPersonalDetails {
    readonly email!: string | undefined;
    readonly fatherName!: string | undefined;
    readonly motherName!: string | undefined;
    readonly aadharCard!: string | undefined;
    readonly panCard!: string | undefined;
    readonly personalMobileNo!: string | undefined;
    readonly religion!: string | undefined;
    readonly bloodGroup!: string | undefined;
    readonly maritalStatus!: string | undefined;
    readonly marriageDate!: moment.Moment | undefined;
    readonly currentIllness!: string | undefined;
    currentAddress!: Address;
    permanentAddress!: Address;
    readonly dependents!: Dependent[] | undefined;

    constructor(data?: IPersonalDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).email = _data["email"];
            (<any>this).fatherName = _data["fatherName"];
            (<any>this).motherName = _data["motherName"];
            (<any>this).aadharCard = _data["aadharCard"];
            (<any>this).panCard = _data["panCard"];
            (<any>this).personalMobileNo = _data["personalMobileNo"];
            (<any>this).religion = _data["religion"];
            (<any>this).bloodGroup = _data["bloodGroup"];
            (<any>this).maritalStatus = _data["maritalStatus"];
            (<any>this).marriageDate = _data["marriageDate"] ? moment(_data["marriageDate"].toString()) : <any>undefined;
            (<any>this).currentIllness = _data["currentIllness"];
            this.currentAddress = _data["currentAddress"] ? Address.fromJS(_data["currentAddress"]) : <any>undefined;
            this.permanentAddress = _data["permanentAddress"] ? Address.fromJS(_data["permanentAddress"]) : <any>undefined;
            if (Array.isArray(_data["dependents"])) {
                (<any>this).dependents = [] as any;
                for (let item of _data["dependents"])
                    (<any>this).dependents!.push(Dependent.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PersonalDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["fatherName"] = this.fatherName;
        data["motherName"] = this.motherName;
        data["aadharCard"] = this.aadharCard;
        data["panCard"] = this.panCard;
        data["personalMobileNo"] = this.personalMobileNo;
        data["religion"] = this.religion;
        data["bloodGroup"] = this.bloodGroup;
        data["maritalStatus"] = this.maritalStatus;
        data["marriageDate"] = this.marriageDate ? this.marriageDate.toISOString() : <any>undefined;
        data["currentIllness"] = this.currentIllness;
        data["currentAddress"] = this.currentAddress ? this.currentAddress.toJSON() : <any>undefined;
        data["permanentAddress"] = this.permanentAddress ? this.permanentAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.dependents)) {
            data["dependents"] = [];
            for (let item of this.dependents)
                data["dependents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPersonalDetails {
    email: string | undefined;
    fatherName: string | undefined;
    motherName: string | undefined;
    aadharCard: string | undefined;
    panCard: string | undefined;
    personalMobileNo: string | undefined;
    religion: string | undefined;
    bloodGroup: string | undefined;
    maritalStatus: string | undefined;
    marriageDate: moment.Moment | undefined;
    currentIllness: string | undefined;
    currentAddress: Address;
    permanentAddress: Address;
    dependents: Dependent[] | undefined;
}

export class Qualification implements IQualification {
    readonly education!: string | undefined;
    readonly specialization!: string | undefined;
    readonly mode!: string | undefined;
    readonly passingYear!: number;
    readonly institution!: string | undefined;
    readonly percentage!: number | undefined;

    constructor(data?: IQualification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).education = _data["education"];
            (<any>this).specialization = _data["specialization"];
            (<any>this).mode = _data["mode"];
            (<any>this).passingYear = _data["passingYear"];
            (<any>this).institution = _data["institution"];
            (<any>this).percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): Qualification {
        data = typeof data === 'object' ? data : {};
        let result = new Qualification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["education"] = this.education;
        data["specialization"] = this.specialization;
        data["mode"] = this.mode;
        data["passingYear"] = this.passingYear;
        data["institution"] = this.institution;
        data["percentage"] = this.percentage;
        return data;
    }
}

export interface IQualification {
    education: string | undefined;
    specialization: string | undefined;
    mode: string | undefined;
    passingYear: number;
    institution: string | undefined;
    percentage: number | undefined;
}

export class DocumentType implements IDocumentType {
    tenantId!: number;
    tenant!: Tenant;
    name!: string | undefined;
    description!: string | undefined;
    mandatory!: boolean;
    id!: number;

    constructor(data?: IDocumentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.name = _data["name"];
            this.description = _data["description"];
            this.mandatory = _data["mandatory"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DocumentType {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["mandatory"] = this.mandatory;
        data["id"] = this.id;
        return data;
    }
}

export interface IDocumentType {
    tenantId: number;
    tenant: Tenant;
    name: string | undefined;
    description: string | undefined;
    mandatory: boolean;
    id: number;
}

export class Documents implements IDocuments {
    documentType!: DocumentType;
    readonly name!: string | undefined;
    readonly documentUrl!: string | undefined;
    readonly remarks!: string | undefined;

    constructor(data?: IDocuments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentType = _data["documentType"] ? DocumentType.fromJS(_data["documentType"]) : <any>undefined;
            (<any>this).name = _data["name"];
            (<any>this).documentUrl = _data["documentUrl"];
            (<any>this).remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): Documents {
        data = typeof data === 'object' ? data : {};
        let result = new Documents();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType ? this.documentType.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["documentUrl"] = this.documentUrl;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IDocuments {
    documentType: DocumentType;
    name: string | undefined;
    documentUrl: string | undefined;
    remarks: string | undefined;
}

export class IEventData implements IIEventData {
    eventTime!: moment.Moment;
    eventSource!: any | undefined;

    constructor(data?: IIEventData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventTime = _data["eventTime"] ? moment(_data["eventTime"].toString()) : <any>undefined;
            this.eventSource = _data["eventSource"];
        }
    }

    static fromJS(data: any): IEventData {
        data = typeof data === 'object' ? data : {};
        let result = new IEventData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventTime"] = this.eventTime ? this.eventTime.toISOString() : <any>undefined;
        data["eventSource"] = this.eventSource;
        return data;
    }
}

export interface IIEventData {
    eventTime: moment.Moment;
    eventSource: any | undefined;
}

export class Employee implements IEmployee {
    tenantId!: number;
    tenant!: Tenant;
    readonly abpUserId!: number | undefined;
    readonly employeeCode!: string | undefined;
    autoLeaveUtilization!: boolean | undefined;
    readonly employeePrefix!: string | undefined;
    readonly employeePostfix!: string | undefined;
    readonly longitude!: string | undefined;
    readonly latitude!: string | undefined;
    readonly radius!: number | undefined;
    readonly email!: string | undefined;
    readonly mobileNumber!: string | undefined;
    name!: EmployeeName;
    gender!: Gender;
    readonly dateOfBirth!: moment.Moment;
    readonly bioMetricId!: string | undefined;
    status!: EmployeeStatus;
    readonly employeeImage!: string | undefined;
    readonly probationMonth!: number | undefined;
    nationality!: Country;
    readonly remarks!: string | undefined;
    mrrExists!: boolean;
    emergencyContact!: EmergencyContact;
    employment!: Employment;
    personalDetails!: PersonalDetails;
    readonly qualifications!: Qualification[] | undefined;
    readonly documents!: Documents[] | undefined;
    readonly vpf!: number | undefined;
    deviceId!: string | undefined;
    dimensionCode!: number | undefined;
    attendanceCorrectionAlert!: boolean | undefined;
    incrementDueDate!: moment.Moment | undefined;
    incrementCycle!: number | undefined;
    otApplicable!: boolean | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    readonly domainEvents!: IEventData[] | undefined;
    id!: number;

    constructor(data?: IEmployee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            (<any>this).abpUserId = _data["abpUserId"];
            (<any>this).employeeCode = _data["employeeCode"];
            this.autoLeaveUtilization = _data["autoLeaveUtilization"];
            (<any>this).employeePrefix = _data["employeePrefix"];
            (<any>this).employeePostfix = _data["employeePostfix"];
            (<any>this).longitude = _data["longitude"];
            (<any>this).latitude = _data["latitude"];
            (<any>this).radius = _data["radius"];
            (<any>this).email = _data["email"];
            (<any>this).mobileNumber = _data["mobileNumber"];
            this.name = _data["name"] ? EmployeeName.fromJS(_data["name"]) : <any>undefined;
            this.gender = _data["gender"];
            (<any>this).dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : <any>undefined;
            (<any>this).bioMetricId = _data["bioMetricId"];
            this.status = _data["status"];
            (<any>this).employeeImage = _data["employeeImage"];
            (<any>this).probationMonth = _data["probationMonth"];
            this.nationality = _data["nationality"] ? Country.fromJS(_data["nationality"]) : <any>undefined;
            (<any>this).remarks = _data["remarks"];
            this.mrrExists = _data["mrrExists"];
            this.emergencyContact = _data["emergencyContact"] ? EmergencyContact.fromJS(_data["emergencyContact"]) : <any>undefined;
            this.employment = _data["employment"] ? Employment.fromJS(_data["employment"]) : <any>undefined;
            this.personalDetails = _data["personalDetails"] ? PersonalDetails.fromJS(_data["personalDetails"]) : <any>undefined;
            if (Array.isArray(_data["qualifications"])) {
                (<any>this).qualifications = [] as any;
                for (let item of _data["qualifications"])
                    (<any>this).qualifications!.push(Qualification.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                (<any>this).documents = [] as any;
                for (let item of _data["documents"])
                    (<any>this).documents!.push(Documents.fromJS(item));
            }
            (<any>this).vpf = _data["vpf"];
            this.deviceId = _data["deviceId"];
            this.dimensionCode = _data["dimensionCode"];
            this.attendanceCorrectionAlert = _data["attendanceCorrectionAlert"];
            this.incrementDueDate = _data["incrementDueDate"] ? moment(_data["incrementDueDate"].toString()) : <any>undefined;
            this.incrementCycle = _data["incrementCycle"];
            this.otApplicable = _data["otApplicable"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            if (Array.isArray(_data["domainEvents"])) {
                (<any>this).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (<any>this).domainEvents!.push(IEventData.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Employee {
        data = typeof data === 'object' ? data : {};
        let result = new Employee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["abpUserId"] = this.abpUserId;
        data["employeeCode"] = this.employeeCode;
        data["autoLeaveUtilization"] = this.autoLeaveUtilization;
        data["employeePrefix"] = this.employeePrefix;
        data["employeePostfix"] = this.employeePostfix;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["radius"] = this.radius;
        data["email"] = this.email;
        data["mobileNumber"] = this.mobileNumber;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        data["gender"] = this.gender;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["bioMetricId"] = this.bioMetricId;
        data["status"] = this.status;
        data["employeeImage"] = this.employeeImage;
        data["probationMonth"] = this.probationMonth;
        data["nationality"] = this.nationality ? this.nationality.toJSON() : <any>undefined;
        data["remarks"] = this.remarks;
        data["mrrExists"] = this.mrrExists;
        data["emergencyContact"] = this.emergencyContact ? this.emergencyContact.toJSON() : <any>undefined;
        data["employment"] = this.employment ? this.employment.toJSON() : <any>undefined;
        data["personalDetails"] = this.personalDetails ? this.personalDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.qualifications)) {
            data["qualifications"] = [];
            for (let item of this.qualifications)
                data["qualifications"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["vpf"] = this.vpf;
        data["deviceId"] = this.deviceId;
        data["dimensionCode"] = this.dimensionCode;
        data["attendanceCorrectionAlert"] = this.attendanceCorrectionAlert;
        data["incrementDueDate"] = this.incrementDueDate ? this.incrementDueDate.toISOString() : <any>undefined;
        data["incrementCycle"] = this.incrementCycle;
        data["otApplicable"] = this.otApplicable;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IEmployee {
    tenantId: number;
    tenant: Tenant;
    abpUserId: number | undefined;
    employeeCode: string | undefined;
    autoLeaveUtilization: boolean | undefined;
    employeePrefix: string | undefined;
    employeePostfix: string | undefined;
    longitude: string | undefined;
    latitude: string | undefined;
    radius: number | undefined;
    email: string | undefined;
    mobileNumber: string | undefined;
    name: EmployeeName;
    gender: Gender;
    dateOfBirth: moment.Moment;
    bioMetricId: string | undefined;
    status: EmployeeStatus;
    employeeImage: string | undefined;
    probationMonth: number | undefined;
    nationality: Country;
    remarks: string | undefined;
    mrrExists: boolean;
    emergencyContact: EmergencyContact;
    employment: Employment;
    personalDetails: PersonalDetails;
    qualifications: Qualification[] | undefined;
    documents: Documents[] | undefined;
    vpf: number | undefined;
    deviceId: string | undefined;
    dimensionCode: number | undefined;
    attendanceCorrectionAlert: boolean | undefined;
    incrementDueDate: moment.Moment | undefined;
    incrementCycle: number | undefined;
    otApplicable: boolean | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    domainEvents: IEventData[] | undefined;
    id: number;
}

export class Activity implements IActivity {
    tenantId!: number | undefined;
    employeeid!: number;
    activityDate!: moment.Moment;
    taskId!: number;
    fromTime!: moment.Moment | undefined;
    toTime!: moment.Moment | undefined;
    hoursInvested!: number | undefined;
    descriptionOfActivity!: string | undefined;
    fromEmployee!: number | undefined;
    taskStatus!: string | undefined;
    taskCompletionStatus!: string | undefined;
    taskStage!: string | undefined;
    isTaskCompleted!: boolean;
    remarks!: string | undefined;
    id!: number;

    constructor(data?: IActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.employeeid = _data["employeeid"];
            this.activityDate = _data["activityDate"] ? moment(_data["activityDate"].toString()) : <any>undefined;
            this.taskId = _data["taskId"];
            this.fromTime = _data["fromTime"] ? moment(_data["fromTime"].toString()) : <any>undefined;
            this.toTime = _data["toTime"] ? moment(_data["toTime"].toString()) : <any>undefined;
            this.hoursInvested = _data["hoursInvested"];
            this.descriptionOfActivity = _data["descriptionOfActivity"];
            this.fromEmployee = _data["fromEmployee"];
            this.taskStatus = _data["taskStatus"];
            this.taskCompletionStatus = _data["taskCompletionStatus"];
            this.taskStage = _data["taskStage"];
            this.isTaskCompleted = _data["isTaskCompleted"];
            this.remarks = _data["remarks"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Activity {
        data = typeof data === 'object' ? data : {};
        let result = new Activity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["employeeid"] = this.employeeid;
        data["activityDate"] = this.activityDate ? this.activityDate.toISOString() : <any>undefined;
        data["taskId"] = this.taskId;
        data["fromTime"] = this.fromTime ? this.fromTime.toISOString() : <any>undefined;
        data["toTime"] = this.toTime ? this.toTime.toISOString() : <any>undefined;
        data["hoursInvested"] = this.hoursInvested;
        data["descriptionOfActivity"] = this.descriptionOfActivity;
        data["fromEmployee"] = this.fromEmployee;
        data["taskStatus"] = this.taskStatus;
        data["taskCompletionStatus"] = this.taskCompletionStatus;
        data["taskStage"] = this.taskStage;
        data["isTaskCompleted"] = this.isTaskCompleted;
        data["remarks"] = this.remarks;
        data["id"] = this.id;
        return data;
    }
}

export interface IActivity {
    tenantId: number | undefined;
    employeeid: number;
    activityDate: moment.Moment;
    taskId: number;
    fromTime: moment.Moment | undefined;
    toTime: moment.Moment | undefined;
    hoursInvested: number | undefined;
    descriptionOfActivity: string | undefined;
    fromEmployee: number | undefined;
    taskStatus: string | undefined;
    taskCompletionStatus: string | undefined;
    taskStage: string | undefined;
    isTaskCompleted: boolean;
    remarks: string | undefined;
    id: number;
}

export class GetActivityDto implements IGetActivityDto {
    id!: number;
    fromTime!: string | undefined;
    toTime!: string | undefined;
    task!: string | undefined;
    project!: string | undefined;
    customer!: string | undefined;
    descriptionOfActivity!: string | undefined;
    hoursInvested!: number | undefined;
    time!: string;
    fromEmployee!: number | undefined;
    taskStatus!: string | undefined;
    taskCompletionStatus!: string | undefined;
    taskStage!: string | undefined;
    isTaskCompleted!: boolean;
    remarks!: string | undefined;

    constructor(data?: IGetActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fromTime = _data["fromTime"];
            this.toTime = _data["toTime"];
            this.task = _data["task"];
            this.project = _data["project"];
            this.customer = _data["customer"];
            this.descriptionOfActivity = _data["descriptionOfActivity"];
            this.hoursInvested = _data["hoursInvested"];
            this.time = _data["time"];
            this.fromEmployee = _data["fromEmployee"];
            this.taskStatus = _data["taskStatus"];
            this.taskCompletionStatus = _data["taskCompletionStatus"];
            this.taskStage = _data["taskStage"];
            this.isTaskCompleted = _data["isTaskCompleted"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): GetActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fromTime"] = this.fromTime;
        data["toTime"] = this.toTime;
        data["task"] = this.task;
        data["project"] = this.project;
        data["customer"] = this.customer;
        data["descriptionOfActivity"] = this.descriptionOfActivity;
        data["hoursInvested"] = this.hoursInvested;
        data["time"] = this.time;
        data["fromEmployee"] = this.fromEmployee;
        data["taskStatus"] = this.taskStatus;
        data["taskCompletionStatus"] = this.taskCompletionStatus;
        data["taskStage"] = this.taskStage;
        data["isTaskCompleted"] = this.isTaskCompleted;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IGetActivityDto {
    id: number;
    fromTime: string | undefined;
    toTime: string | undefined;
    task: string | undefined;
    project: string | undefined;
    customer: string | undefined;
    descriptionOfActivity: string | undefined;
    hoursInvested: number | undefined;
    time: string;
    fromEmployee: number | undefined;
    taskStatus: string | undefined;
    taskCompletionStatus: string | undefined;
    taskStage: string | undefined;
    isTaskCompleted: boolean;
    remarks: string | undefined;
}

export class ResponseGetActivityDto implements IResponseGetActivityDto {
    data!: GetActivityDto[] | undefined;
    status!: string | undefined;

    constructor(data?: IResponseGetActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(GetActivityDto.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResponseGetActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseGetActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["status"] = this.status;
        return data;
    }
}

export interface IResponseGetActivityDto {
    data: GetActivityDto[] | undefined;
    status: string | undefined;
}

export class ActivitySummeryDto implements IActivitySummeryDto {
    employee!: string | undefined;
    employeeId!: number;
    date!: string | undefined;
    tasks!: number;
    hoursInvested!: number;
    status!: string | undefined;
    remark!: string | undefined;

    constructor(data?: IActivitySummeryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"];
            this.employeeId = _data["employeeId"];
            this.date = _data["date"];
            this.tasks = _data["tasks"];
            this.hoursInvested = _data["hoursInvested"];
            this.status = _data["status"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): ActivitySummeryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivitySummeryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee;
        data["employeeId"] = this.employeeId;
        data["date"] = this.date;
        data["tasks"] = this.tasks;
        data["hoursInvested"] = this.hoursInvested;
        data["status"] = this.status;
        data["remark"] = this.remark;
        return data;
    }
}

export interface IActivitySummeryDto {
    employee: string | undefined;
    employeeId: number;
    date: string | undefined;
    tasks: number;
    hoursInvested: number;
    status: string | undefined;
    remark: string | undefined;
}

export class AdvanceDetialsDto implements IAdvanceDetialsDto {
    id!: number;

    constructor(data?: IAdvanceDetialsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AdvanceDetialsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvanceDetialsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IAdvanceDetialsDto {
    id: number;
}

export class GetAdvanceDetialsForViewDto implements IGetAdvanceDetialsForViewDto {
    advanceDetials!: AdvanceDetialsDto;

    constructor(data?: IGetAdvanceDetialsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advanceDetials = _data["advanceDetials"] ? AdvanceDetialsDto.fromJS(_data["advanceDetials"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAdvanceDetialsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdvanceDetialsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advanceDetials"] = this.advanceDetials ? this.advanceDetials.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAdvanceDetialsForViewDto {
    advanceDetials: AdvanceDetialsDto;
}

export class PagedResultDtoOfGetAdvanceDetialsForViewDto implements IPagedResultDtoOfGetAdvanceDetialsForViewDto {
    totalCount!: number;
    items!: GetAdvanceDetialsForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAdvanceDetialsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAdvanceDetialsForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAdvanceDetialsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAdvanceDetialsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAdvanceDetialsForViewDto {
    totalCount: number;
    items: GetAdvanceDetialsForViewDto[] | undefined;
}

export class CreateOrEditAdvanceDetialsDto implements ICreateOrEditAdvanceDetialsDto {
    id!: number | undefined;

    constructor(data?: ICreateOrEditAdvanceDetialsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAdvanceDetialsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAdvanceDetialsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditAdvanceDetialsDto {
    id: number | undefined;
}

export class GetAdvanceDetialsForEditOutput implements IGetAdvanceDetialsForEditOutput {
    advanceDetials!: CreateOrEditAdvanceDetialsDto;

    constructor(data?: IGetAdvanceDetialsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advanceDetials = _data["advanceDetials"] ? CreateOrEditAdvanceDetialsDto.fromJS(_data["advanceDetials"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAdvanceDetialsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdvanceDetialsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advanceDetials"] = this.advanceDetials ? this.advanceDetials.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAdvanceDetialsForEditOutput {
    advanceDetials: CreateOrEditAdvanceDetialsDto;
}

export class CreateOrEditAdvanceRequestDto implements ICreateOrEditAdvanceRequestDto {
    creatorUserId!: number | undefined;
    amount!: number;
    reportingManager!: boolean | undefined;
    advanceRequestDate!: moment.Moment;
    advanceRequireDate!: moment.Moment;
    noOfEMI!: number;
    remarks!: string | undefined;
    balanceAmount!: number;
    advanceTypeId!: number;
    advance_Return!: number;
    requestamount!: number;
    emiAmmount!: number;
    requestForApprovalLogId!: number | undefined;
    documentName!: string | undefined;
    documentURL!: string | undefined;
    imagePath!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAdvanceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creatorUserId = _data["creatorUserId"];
            this.amount = _data["amount"];
            this.reportingManager = _data["reportingManager"];
            this.advanceRequestDate = _data["advanceRequestDate"] ? moment(_data["advanceRequestDate"].toString()) : <any>undefined;
            this.advanceRequireDate = _data["advanceRequireDate"] ? moment(_data["advanceRequireDate"].toString()) : <any>undefined;
            this.noOfEMI = _data["noOfEMI"];
            this.remarks = _data["remarks"];
            this.balanceAmount = _data["balanceAmount"];
            this.advanceTypeId = _data["advanceTypeId"];
            this.advance_Return = _data["advance_Return"];
            this.requestamount = _data["requestamount"];
            this.emiAmmount = _data["emiAmmount"];
            this.requestForApprovalLogId = _data["requestForApprovalLogId"];
            this.documentName = _data["documentName"];
            this.documentURL = _data["documentURL"];
            this.imagePath = _data["imagePath"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAdvanceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAdvanceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creatorUserId"] = this.creatorUserId;
        data["amount"] = this.amount;
        data["reportingManager"] = this.reportingManager;
        data["advanceRequestDate"] = this.advanceRequestDate ? this.advanceRequestDate.toISOString() : <any>undefined;
        data["advanceRequireDate"] = this.advanceRequireDate ? this.advanceRequireDate.toISOString() : <any>undefined;
        data["noOfEMI"] = this.noOfEMI;
        data["remarks"] = this.remarks;
        data["balanceAmount"] = this.balanceAmount;
        data["advanceTypeId"] = this.advanceTypeId;
        data["advance_Return"] = this.advance_Return;
        data["requestamount"] = this.requestamount;
        data["emiAmmount"] = this.emiAmmount;
        data["requestForApprovalLogId"] = this.requestForApprovalLogId;
        data["documentName"] = this.documentName;
        data["documentURL"] = this.documentURL;
        data["imagePath"] = this.imagePath;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditAdvanceRequestDto {
    creatorUserId: number | undefined;
    amount: number;
    reportingManager: boolean | undefined;
    advanceRequestDate: moment.Moment;
    advanceRequireDate: moment.Moment;
    noOfEMI: number;
    remarks: string | undefined;
    balanceAmount: number;
    advanceTypeId: number;
    advance_Return: number;
    requestamount: number;
    emiAmmount: number;
    requestForApprovalLogId: number | undefined;
    documentName: string | undefined;
    documentURL: string | undefined;
    imagePath: string | undefined;
    id: number | undefined;
}

export class GetManualAdvanceRequestForEditOutput implements IGetManualAdvanceRequestForEditOutput {
    advanceRequest!: CreateOrEditAdvanceRequestDto;
    employeeFirstName!: string | undefined;

    constructor(data?: IGetManualAdvanceRequestForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advanceRequest = _data["advanceRequest"] ? CreateOrEditAdvanceRequestDto.fromJS(_data["advanceRequest"]) : <any>undefined;
            this.employeeFirstName = _data["employeeFirstName"];
        }
    }

    static fromJS(data: any): GetManualAdvanceRequestForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetManualAdvanceRequestForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advanceRequest"] = this.advanceRequest ? this.advanceRequest.toJSON() : <any>undefined;
        data["employeeFirstName"] = this.employeeFirstName;
        return data;
    }
}

export interface IGetManualAdvanceRequestForEditOutput {
    advanceRequest: CreateOrEditAdvanceRequestDto;
    employeeFirstName: string | undefined;
}

export class AdvanceRequestDto implements IAdvanceRequestDto {
    amount!: number;
    advanceRequestDate!: moment.Moment;
    advanceRequireDate!: moment.Moment;
    noOfEMI!: number;
    remarks!: string | undefined;
    advanceTypeId!: number;
    advance_Return!: number;
    completedNoOfEMI!: number;
    emiAmmount!: number;
    documentName!: string | undefined;
    documentUrl!: string | undefined;
    balanceAmount!: number;
    id!: number;

    constructor(data?: IAdvanceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.advanceRequestDate = _data["advanceRequestDate"] ? moment(_data["advanceRequestDate"].toString()) : <any>undefined;
            this.advanceRequireDate = _data["advanceRequireDate"] ? moment(_data["advanceRequireDate"].toString()) : <any>undefined;
            this.noOfEMI = _data["noOfEMI"];
            this.remarks = _data["remarks"];
            this.advanceTypeId = _data["advanceTypeId"];
            this.advance_Return = _data["advance_Return"];
            this.completedNoOfEMI = _data["completedNoOfEMI"];
            this.emiAmmount = _data["emiAmmount"];
            this.documentName = _data["documentName"];
            this.documentUrl = _data["documentUrl"];
            this.balanceAmount = _data["balanceAmount"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AdvanceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvanceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["advanceRequestDate"] = this.advanceRequestDate ? this.advanceRequestDate.toISOString() : <any>undefined;
        data["advanceRequireDate"] = this.advanceRequireDate ? this.advanceRequireDate.toISOString() : <any>undefined;
        data["noOfEMI"] = this.noOfEMI;
        data["remarks"] = this.remarks;
        data["advanceTypeId"] = this.advanceTypeId;
        data["advance_Return"] = this.advance_Return;
        data["completedNoOfEMI"] = this.completedNoOfEMI;
        data["emiAmmount"] = this.emiAmmount;
        data["documentName"] = this.documentName;
        data["documentUrl"] = this.documentUrl;
        data["balanceAmount"] = this.balanceAmount;
        data["id"] = this.id;
        return data;
    }
}

export interface IAdvanceRequestDto {
    amount: number;
    advanceRequestDate: moment.Moment;
    advanceRequireDate: moment.Moment;
    noOfEMI: number;
    remarks: string | undefined;
    advanceTypeId: number;
    advance_Return: number;
    completedNoOfEMI: number;
    emiAmmount: number;
    documentName: string | undefined;
    documentUrl: string | undefined;
    balanceAmount: number;
    id: number;
}

export class GetManualAdvanceForViewDto implements IGetManualAdvanceForViewDto {
    advanceRequest!: AdvanceRequestDto;
    advanceTypeType!: string | undefined;
    employeeCode!: string | undefined;
    employeeName!: string | undefined;
    empCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: IGetManualAdvanceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advanceRequest = _data["advanceRequest"] ? AdvanceRequestDto.fromJS(_data["advanceRequest"]) : <any>undefined;
            this.advanceTypeType = _data["advanceTypeType"];
            this.employeeCode = _data["employeeCode"];
            this.employeeName = _data["employeeName"];
            this.empCode = _data["empCode"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetManualAdvanceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetManualAdvanceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advanceRequest"] = this.advanceRequest ? this.advanceRequest.toJSON() : <any>undefined;
        data["advanceTypeType"] = this.advanceTypeType;
        data["employeeCode"] = this.employeeCode;
        data["employeeName"] = this.employeeName;
        data["empCode"] = this.empCode;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetManualAdvanceForViewDto {
    advanceRequest: AdvanceRequestDto;
    advanceTypeType: string | undefined;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    empCode: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetManualAdvanceForViewDto implements IPagedResultDtoOfGetManualAdvanceForViewDto {
    totalCount!: number;
    items!: GetManualAdvanceForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetManualAdvanceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetManualAdvanceForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetManualAdvanceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetManualAdvanceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetManualAdvanceForViewDto {
    totalCount: number;
    items: GetManualAdvanceForViewDto[] | undefined;
}

export class CreateOrEditAdvanceReturnDto implements ICreateOrEditAdvanceReturnDto {
    advanceReferenceId!: number;
    id!: number;
    employeeId!: number;
    advanceRequestDate!: moment.Moment;
    returnAmount!: number;
    mode!: string | undefined;
    remark!: string | undefined;
    returnDate!: moment.Moment | undefined;
    displayText!: string | undefined;

    constructor(data?: ICreateOrEditAdvanceReturnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advanceReferenceId = _data["advanceReferenceId"];
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.advanceRequestDate = _data["advanceRequestDate"] ? moment(_data["advanceRequestDate"].toString()) : <any>undefined;
            this.returnAmount = _data["returnAmount"];
            this.mode = _data["mode"];
            this.remark = _data["remark"];
            this.returnDate = _data["returnDate"] ? moment(_data["returnDate"].toString()) : <any>undefined;
            this.displayText = _data["displayText"];
        }
    }

    static fromJS(data: any): CreateOrEditAdvanceReturnDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAdvanceReturnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advanceReferenceId"] = this.advanceReferenceId;
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["advanceRequestDate"] = this.advanceRequestDate ? this.advanceRequestDate.toISOString() : <any>undefined;
        data["returnAmount"] = this.returnAmount;
        data["mode"] = this.mode;
        data["remark"] = this.remark;
        data["returnDate"] = this.returnDate ? this.returnDate.toISOString() : <any>undefined;
        data["displayText"] = this.displayText;
        return data;
    }
}

export interface ICreateOrEditAdvanceReturnDto {
    advanceReferenceId: number;
    id: number;
    employeeId: number;
    advanceRequestDate: moment.Moment;
    returnAmount: number;
    mode: string | undefined;
    remark: string | undefined;
    returnDate: moment.Moment | undefined;
    displayText: string | undefined;
}

export class GetAdvanceStatementInput implements IGetAdvanceStatementInput {
    employeeIds!: string | undefined;
    branchIds!: string | undefined;
    fromDate!: moment.Moment;
    toDate!: moment.Moment;

    constructor(data?: IGetAdvanceStatementInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeIds = _data["employeeIds"];
            this.branchIds = _data["branchIds"];
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAdvanceStatementInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdvanceStatementInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeIds"] = this.employeeIds;
        data["branchIds"] = this.branchIds;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetAdvanceStatementInput {
    employeeIds: string | undefined;
    branchIds: string | undefined;
    fromDate: moment.Moment;
    toDate: moment.Moment;
}

export class AdvanceStatementItemDto implements IAdvanceStatementItemDto {
    date!: moment.Moment;
    particulars!: string | undefined;
    debit!: number;
    credit!: number;
    balance!: number;

    constructor(data?: IAdvanceStatementItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.particulars = _data["particulars"];
            this.debit = _data["debit"];
            this.credit = _data["credit"];
            this.balance = _data["balance"];
        }
    }

    static fromJS(data: any): AdvanceStatementItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvanceStatementItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["particulars"] = this.particulars;
        data["debit"] = this.debit;
        data["credit"] = this.credit;
        data["balance"] = this.balance;
        return data;
    }
}

export interface IAdvanceStatementItemDto {
    date: moment.Moment;
    particulars: string | undefined;
    debit: number;
    credit: number;
    balance: number;
}

export class AdvanceStatementReportDto implements IAdvanceStatementReportDto {
    employeeCode!: string | undefined;
    employeeName!: string | undefined;
    transactions!: AdvanceStatementItemDto[] | undefined;

    constructor(data?: IAdvanceStatementReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeCode = _data["employeeCode"];
            this.employeeName = _data["employeeName"];
            if (Array.isArray(_data["transactions"])) {
                this.transactions = [] as any;
                for (let item of _data["transactions"])
                    this.transactions!.push(AdvanceStatementItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdvanceStatementReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvanceStatementReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeCode"] = this.employeeCode;
        data["employeeName"] = this.employeeName;
        if (Array.isArray(this.transactions)) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAdvanceStatementReportDto {
    employeeCode: string | undefined;
    employeeName: string | undefined;
    transactions: AdvanceStatementItemDto[] | undefined;
}

export class GetAdvanceRequestForViewDto implements IGetAdvanceRequestForViewDto {
    advanceRequest!: AdvanceRequestDto;
    advanceTypeType!: string | undefined;
    requestedBy!: number | undefined;
    employeeCode!: string | undefined;
    employeeName!: string | undefined;
    monthYear!: string | undefined;

    constructor(data?: IGetAdvanceRequestForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advanceRequest = _data["advanceRequest"] ? AdvanceRequestDto.fromJS(_data["advanceRequest"]) : <any>undefined;
            this.advanceTypeType = _data["advanceTypeType"];
            this.requestedBy = _data["requestedBy"];
            this.employeeCode = _data["employeeCode"];
            this.employeeName = _data["employeeName"];
            this.monthYear = _data["monthYear"];
        }
    }

    static fromJS(data: any): GetAdvanceRequestForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdvanceRequestForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advanceRequest"] = this.advanceRequest ? this.advanceRequest.toJSON() : <any>undefined;
        data["advanceTypeType"] = this.advanceTypeType;
        data["requestedBy"] = this.requestedBy;
        data["employeeCode"] = this.employeeCode;
        data["employeeName"] = this.employeeName;
        data["monthYear"] = this.monthYear;
        return data;
    }
}

export interface IGetAdvanceRequestForViewDto {
    advanceRequest: AdvanceRequestDto;
    advanceTypeType: string | undefined;
    requestedBy: number | undefined;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    monthYear: string | undefined;
}

export class PagedResultDtoOfGetAdvanceRequestForViewDto implements IPagedResultDtoOfGetAdvanceRequestForViewDto {
    totalCount!: number;
    items!: GetAdvanceRequestForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAdvanceRequestForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAdvanceRequestForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAdvanceRequestForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAdvanceRequestForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAdvanceRequestForViewDto {
    totalCount: number;
    items: GetAdvanceRequestForViewDto[] | undefined;
}

export class AdvanceReturnDto implements IAdvanceReturnDto {
    id!: number;
    advanceRefernceId!: number;
    employeeId!: number;
    returnDate!: moment.Moment;
    returnAmount!: number;
    mode!: string | undefined;
    remark!: string | undefined;
    displayText!: string | undefined;
    employeeName!: string | undefined;

    constructor(data?: IAdvanceReturnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.advanceRefernceId = _data["advanceRefernceId"];
            this.employeeId = _data["employeeId"];
            this.returnDate = _data["returnDate"] ? moment(_data["returnDate"].toString()) : <any>undefined;
            this.returnAmount = _data["returnAmount"];
            this.mode = _data["mode"];
            this.remark = _data["remark"];
            this.displayText = _data["displayText"];
            this.employeeName = _data["employeeName"];
        }
    }

    static fromJS(data: any): AdvanceReturnDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvanceReturnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["advanceRefernceId"] = this.advanceRefernceId;
        data["employeeId"] = this.employeeId;
        data["returnDate"] = this.returnDate ? this.returnDate.toISOString() : <any>undefined;
        data["returnAmount"] = this.returnAmount;
        data["mode"] = this.mode;
        data["remark"] = this.remark;
        data["displayText"] = this.displayText;
        data["employeeName"] = this.employeeName;
        return data;
    }
}

export interface IAdvanceReturnDto {
    id: number;
    advanceRefernceId: number;
    employeeId: number;
    returnDate: moment.Moment;
    returnAmount: number;
    mode: string | undefined;
    remark: string | undefined;
    displayText: string | undefined;
    employeeName: string | undefined;
}

export class PagedResultDtoOfAdvanceReturnDto implements IPagedResultDtoOfAdvanceReturnDto {
    totalCount!: number;
    items!: AdvanceReturnDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAdvanceReturnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AdvanceReturnDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAdvanceReturnDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAdvanceReturnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfAdvanceReturnDto {
    totalCount: number;
    items: AdvanceReturnDto[] | undefined;
}

export class GetAdvanceRequestForEditOutput implements IGetAdvanceRequestForEditOutput {
    advanceRequest!: CreateOrEditAdvanceRequestDto;
    advanceTypeType!: string | undefined;
    requestedBy!: number | undefined;
    requestFlow!: string | undefined;
    leaveRejectStatus!: string | undefined;
    monthyear!: string | undefined;

    constructor(data?: IGetAdvanceRequestForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advanceRequest = _data["advanceRequest"] ? CreateOrEditAdvanceRequestDto.fromJS(_data["advanceRequest"]) : <any>undefined;
            this.advanceTypeType = _data["advanceTypeType"];
            this.requestedBy = _data["requestedBy"];
            this.requestFlow = _data["requestFlow"];
            this.leaveRejectStatus = _data["leaveRejectStatus"];
            this.monthyear = _data["monthyear"];
        }
    }

    static fromJS(data: any): GetAdvanceRequestForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdvanceRequestForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advanceRequest"] = this.advanceRequest ? this.advanceRequest.toJSON() : <any>undefined;
        data["advanceTypeType"] = this.advanceTypeType;
        data["requestedBy"] = this.requestedBy;
        data["requestFlow"] = this.requestFlow;
        data["leaveRejectStatus"] = this.leaveRejectStatus;
        data["monthyear"] = this.monthyear;
        return data;
    }
}

export interface IGetAdvanceRequestForEditOutput {
    advanceRequest: CreateOrEditAdvanceRequestDto;
    advanceTypeType: string | undefined;
    requestedBy: number | undefined;
    requestFlow: string | undefined;
    leaveRejectStatus: string | undefined;
    monthyear: string | undefined;
}

export class PagedResultDtoOfGetAdvanceRequestForEditOutput implements IPagedResultDtoOfGetAdvanceRequestForEditOutput {
    totalCount!: number;
    items!: GetAdvanceRequestForEditOutput[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAdvanceRequestForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAdvanceRequestForEditOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAdvanceRequestForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAdvanceRequestForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAdvanceRequestForEditOutput {
    totalCount: number;
    items: GetAdvanceRequestForEditOutput[] | undefined;
}

export class ApprovalLogDto implements IApprovalLogDto {
    role!: string | undefined;
    userName!: string | undefined;
    status!: string | undefined;
    actionDate!: moment.Moment | undefined;
    remarks!: string | undefined;
    level!: number;

    constructor(data?: IApprovalLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
            this.userName = _data["userName"];
            this.status = _data["status"];
            this.actionDate = _data["actionDate"] ? moment(_data["actionDate"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
            this.level = _data["level"];
        }
    }

    static fromJS(data: any): ApprovalLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        data["userName"] = this.userName;
        data["status"] = this.status;
        data["actionDate"] = this.actionDate ? this.actionDate.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["level"] = this.level;
        return data;
    }
}

export interface IApprovalLogDto {
    role: string | undefined;
    userName: string | undefined;
    status: string | undefined;
    actionDate: moment.Moment | undefined;
    remarks: string | undefined;
    level: number;
}

export class RequestFlowOutputDto implements IRequestFlowOutputDto {
    currentStatus!: string | undefined;
    logs!: ApprovalLogDto[] | undefined;

    constructor(data?: IRequestFlowOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentStatus = _data["currentStatus"];
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(ApprovalLogDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RequestFlowOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestFlowOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentStatus"] = this.currentStatus;
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRequestFlowOutputDto {
    currentStatus: string | undefined;
    logs: ApprovalLogDto[] | undefined;
}

export class WorkFlowRequest implements IWorkFlowRequest {
    punchDate!: moment.Moment;
    compOffLeaveTypeId!: number;
    requestedDays!: number;
    tenantId!: number | undefined;
    employeeId!: number;
    requestForApprovalLogId!: number | undefined;
    remarks!: string | undefined;
    id!: number;

    constructor(data?: IWorkFlowRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.punchDate = _data["punchDate"] ? moment(_data["punchDate"].toString()) : <any>undefined;
            this.compOffLeaveTypeId = _data["compOffLeaveTypeId"];
            this.requestedDays = _data["requestedDays"];
            this.tenantId = _data["tenantId"];
            this.employeeId = _data["employeeId"];
            this.requestForApprovalLogId = _data["requestForApprovalLogId"];
            this.remarks = _data["remarks"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WorkFlowRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WorkFlowRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["punchDate"] = this.punchDate ? this.punchDate.toISOString() : <any>undefined;
        data["compOffLeaveTypeId"] = this.compOffLeaveTypeId;
        data["requestedDays"] = this.requestedDays;
        data["tenantId"] = this.tenantId;
        data["employeeId"] = this.employeeId;
        data["requestForApprovalLogId"] = this.requestForApprovalLogId;
        data["remarks"] = this.remarks;
        data["id"] = this.id;
        return data;
    }
}

export interface IWorkFlowRequest {
    punchDate: moment.Moment;
    compOffLeaveTypeId: number;
    requestedDays: number;
    tenantId: number | undefined;
    employeeId: number;
    requestForApprovalLogId: number | undefined;
    remarks: string | undefined;
    id: number;
}

export class GetWorkFlowRequestForEditOutput implements IGetWorkFlowRequestForEditOutput {
    workFlowRequests!: WorkFlowRequest;
    advanceTypeType!: string | undefined;
    requestedBy!: number | undefined;
    requestFlow!: string | undefined;
    leaveRejectStatus!: string | undefined;
    monthyear!: string | undefined;

    constructor(data?: IGetWorkFlowRequestForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workFlowRequests = _data["workFlowRequests"] ? WorkFlowRequest.fromJS(_data["workFlowRequests"]) : <any>undefined;
            this.advanceTypeType = _data["advanceTypeType"];
            this.requestedBy = _data["requestedBy"];
            this.requestFlow = _data["requestFlow"];
            this.leaveRejectStatus = _data["leaveRejectStatus"];
            this.monthyear = _data["monthyear"];
        }
    }

    static fromJS(data: any): GetWorkFlowRequestForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetWorkFlowRequestForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workFlowRequests"] = this.workFlowRequests ? this.workFlowRequests.toJSON() : <any>undefined;
        data["advanceTypeType"] = this.advanceTypeType;
        data["requestedBy"] = this.requestedBy;
        data["requestFlow"] = this.requestFlow;
        data["leaveRejectStatus"] = this.leaveRejectStatus;
        data["monthyear"] = this.monthyear;
        return data;
    }
}

export interface IGetWorkFlowRequestForEditOutput {
    workFlowRequests: WorkFlowRequest;
    advanceTypeType: string | undefined;
    requestedBy: number | undefined;
    requestFlow: string | undefined;
    leaveRejectStatus: string | undefined;
    monthyear: string | undefined;
}

export class FileDto implements IFileDto {
    fileName!: string;
    fileType!: string | undefined;
    fileToken!: string;
    content!: string | undefined;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        data["content"] = this.content;
        return data;
    }
}

export interface IFileDto {
    fileName: string;
    fileType: string | undefined;
    fileToken: string;
    content: string | undefined;
}

export class AdvanceRequestAdvanceTypeLookupTableDto implements IAdvanceRequestAdvanceTypeLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IAdvanceRequestAdvanceTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): AdvanceRequestAdvanceTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvanceRequestAdvanceTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IAdvanceRequestAdvanceTypeLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class AdvanceValidationDetail implements IAdvanceValidationDetail {
    formula!: string | undefined;
    advanceEligibility!: number;
    noOfEMI!: number;
    percentage!: number | undefined;
    dateofJoining!: moment.Moment;

    constructor(data?: IAdvanceValidationDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formula = _data["formula"];
            this.advanceEligibility = _data["advanceEligibility"];
            this.noOfEMI = _data["noOfEMI"];
            this.percentage = _data["percentage"];
            this.dateofJoining = _data["dateofJoining"] ? moment(_data["dateofJoining"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AdvanceValidationDetail {
        data = typeof data === 'object' ? data : {};
        let result = new AdvanceValidationDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formula"] = this.formula;
        data["advanceEligibility"] = this.advanceEligibility;
        data["noOfEMI"] = this.noOfEMI;
        data["percentage"] = this.percentage;
        data["dateofJoining"] = this.dateofJoining ? this.dateofJoining.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAdvanceValidationDetail {
    formula: string | undefined;
    advanceEligibility: number;
    noOfEMI: number;
    percentage: number | undefined;
    dateofJoining: moment.Moment;
}

export class EmployeeData implements IEmployeeData {
    employeeId!: number;

    constructor(data?: IEmployeeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): EmployeeData {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        return data;
    }
}

export interface IEmployeeData {
    employeeId: number;
}

export class LocationData implements ILocationData {
    locationId!: number;

    constructor(data?: ILocationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"];
        }
    }

    static fromJS(data: any): LocationData {
        data = typeof data === 'object' ? data : {};
        let result = new LocationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        return data;
    }
}

export interface ILocationData {
    locationId: number;
}

export class DepartmentData implements IDepartmentData {
    departmentId!: number;

    constructor(data?: IDepartmentData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentId = _data["departmentId"];
        }
    }

    static fromJS(data: any): DepartmentData {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentId"] = this.departmentId;
        return data;
    }
}

export interface IDepartmentData {
    departmentId: number;
}

export class GetAdvanceRegisterData implements IGetAdvanceRegisterData {
    rowIndex!: number;
    location!: string | undefined;
    department!: string | undefined;
    employeeCode!: string | undefined;
    employeeName!: string | undefined;
    advanceType!: string | undefined;
    requestDate!: moment.Moment;
    requiredOn!: moment.Moment;
    requestedAmount!: number;
    emiAmount!: number;
    noofEMI!: number;
    completedEMI!: number;
    balanceAmount!: number;
    status!: string | undefined;

    constructor(data?: IGetAdvanceRegisterData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowIndex = _data["rowIndex"];
            this.location = _data["location"];
            this.department = _data["department"];
            this.employeeCode = _data["employeeCode"];
            this.employeeName = _data["employeeName"];
            this.advanceType = _data["advanceType"];
            this.requestDate = _data["requestDate"] ? moment(_data["requestDate"].toString()) : <any>undefined;
            this.requiredOn = _data["requiredOn"] ? moment(_data["requiredOn"].toString()) : <any>undefined;
            this.requestedAmount = _data["requestedAmount"];
            this.emiAmount = _data["emiAmount"];
            this.noofEMI = _data["noofEMI"];
            this.completedEMI = _data["completedEMI"];
            this.balanceAmount = _data["balanceAmount"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GetAdvanceRegisterData {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdvanceRegisterData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowIndex"] = this.rowIndex;
        data["location"] = this.location;
        data["department"] = this.department;
        data["employeeCode"] = this.employeeCode;
        data["employeeName"] = this.employeeName;
        data["advanceType"] = this.advanceType;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["requiredOn"] = this.requiredOn ? this.requiredOn.toISOString() : <any>undefined;
        data["requestedAmount"] = this.requestedAmount;
        data["emiAmount"] = this.emiAmount;
        data["noofEMI"] = this.noofEMI;
        data["completedEMI"] = this.completedEMI;
        data["balanceAmount"] = this.balanceAmount;
        data["status"] = this.status;
        return data;
    }
}

export interface IGetAdvanceRegisterData {
    rowIndex: number;
    location: string | undefined;
    department: string | undefined;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    advanceType: string | undefined;
    requestDate: moment.Moment;
    requiredOn: moment.Moment;
    requestedAmount: number;
    emiAmount: number;
    noofEMI: number;
    completedEMI: number;
    balanceAmount: number;
    status: string | undefined;
}

export class AdvanceTypeDto implements IAdvanceTypeDto {
    type!: string | undefined;
    id!: number;

    constructor(data?: IAdvanceTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AdvanceTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvanceTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["id"] = this.id;
        return data;
    }
}

export interface IAdvanceTypeDto {
    type: string | undefined;
    id: number;
}

export class GetAdvanceTypeForViewDto implements IGetAdvanceTypeForViewDto {
    advanceType!: AdvanceTypeDto;

    constructor(data?: IGetAdvanceTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advanceType = _data["advanceType"] ? AdvanceTypeDto.fromJS(_data["advanceType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAdvanceTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdvanceTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advanceType"] = this.advanceType ? this.advanceType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAdvanceTypeForViewDto {
    advanceType: AdvanceTypeDto;
}

export class PagedResultDtoOfGetAdvanceTypeForViewDto implements IPagedResultDtoOfGetAdvanceTypeForViewDto {
    totalCount!: number;
    items!: GetAdvanceTypeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAdvanceTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAdvanceTypeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAdvanceTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAdvanceTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAdvanceTypeForViewDto {
    totalCount: number;
    items: GetAdvanceTypeForViewDto[] | undefined;
}

export class CreateOrEditAdvanceTypeDto implements ICreateOrEditAdvanceTypeDto {
    type!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAdvanceTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAdvanceTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAdvanceTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditAdvanceTypeDto {
    type: string | undefined;
    id: number | undefined;
}

export class GetAdvanceTypeForEditOutput implements IGetAdvanceTypeForEditOutput {
    advanceType!: CreateOrEditAdvanceTypeDto;

    constructor(data?: IGetAdvanceTypeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advanceType = _data["advanceType"] ? CreateOrEditAdvanceTypeDto.fromJS(_data["advanceType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAdvanceTypeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdvanceTypeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advanceType"] = this.advanceType ? this.advanceType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAdvanceTypeForEditOutput {
    advanceType: CreateOrEditAdvanceTypeDto;
}

export class AnnouncementDto implements IAnnouncementDto {
    name!: string | undefined;
    announcementDate!: moment.Moment | undefined;
    id!: number;

    constructor(data?: IAnnouncementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.announcementDate = _data["announcementDate"] ? moment(_data["announcementDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AnnouncementDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnnouncementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["announcementDate"] = this.announcementDate ? this.announcementDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IAnnouncementDto {
    name: string | undefined;
    announcementDate: moment.Moment | undefined;
    id: number;
}

export class GetAnnouncementForViewDto implements IGetAnnouncementForViewDto {
    announcement!: AnnouncementDto;

    constructor(data?: IGetAnnouncementForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.announcement = _data["announcement"] ? AnnouncementDto.fromJS(_data["announcement"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAnnouncementForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAnnouncementForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["announcement"] = this.announcement ? this.announcement.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAnnouncementForViewDto {
    announcement: AnnouncementDto;
}

export class PagedResultDtoOfGetAnnouncementForViewDto implements IPagedResultDtoOfGetAnnouncementForViewDto {
    totalCount!: number;
    items!: GetAnnouncementForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAnnouncementForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAnnouncementForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAnnouncementForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAnnouncementForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAnnouncementForViewDto {
    totalCount: number;
    items: GetAnnouncementForViewDto[] | undefined;
}

export class CreateOrEditAnnouncementDto implements ICreateOrEditAnnouncementDto {
    name!: string | undefined;
    announcementDate!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAnnouncementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.announcementDate = _data["announcementDate"] ? moment(_data["announcementDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAnnouncementDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAnnouncementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["announcementDate"] = this.announcementDate ? this.announcementDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditAnnouncementDto {
    name: string | undefined;
    announcementDate: moment.Moment | undefined;
    id: number | undefined;
}

export class GetAnnouncementForEditOutput implements IGetAnnouncementForEditOutput {
    announcement!: CreateOrEditAnnouncementDto;

    constructor(data?: IGetAnnouncementForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.announcement = _data["announcement"] ? CreateOrEditAnnouncementDto.fromJS(_data["announcement"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAnnouncementForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAnnouncementForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["announcement"] = this.announcement ? this.announcement.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAnnouncementForEditOutput {
    announcement: CreateOrEditAnnouncementDto;
}

export class CreateOrEditAssetDto implements ICreateOrEditAssetDto {
    name!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditAssetDto {
    name: string | undefined;
    id: number | undefined;
}

export class AssetDto implements IAssetDto {
    name!: string | undefined;
    id!: number;

    constructor(data?: IAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IAssetDto {
    name: string | undefined;
    id: number;
}

export class GetAssetForViewDto implements IGetAssetForViewDto {
    asset!: AssetDto;

    constructor(data?: IGetAssetForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.asset = _data["asset"] ? AssetDto.fromJS(_data["asset"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAssetForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["asset"] = this.asset ? this.asset.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAssetForViewDto {
    asset: AssetDto;
}

export class PagedResultDtoOfGetAssetForViewDto implements IPagedResultDtoOfGetAssetForViewDto {
    totalCount!: number;
    items!: GetAssetForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAssetForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAssetForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAssetForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAssetForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAssetForViewDto {
    totalCount: number;
    items: GetAssetForViewDto[] | undefined;
}

export class GetAssetForEditOutput implements IGetAssetForEditOutput {
    asset!: CreateOrEditAssetDto;

    constructor(data?: IGetAssetForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.asset = _data["asset"] ? CreateOrEditAssetDto.fromJS(_data["asset"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAssetForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["asset"] = this.asset ? this.asset.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAssetForEditOutput {
    asset: CreateOrEditAssetDto;
}

export class DropDown implements IDropDown {
    value!: number | undefined;
    label!: string | undefined;
    employeeId!: number | undefined;
    disabled!: boolean;

    constructor(data?: IDropDown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
            this.employeeId = _data["employeeId"];
            this.disabled = _data["disabled"];
        }
    }

    static fromJS(data: any): DropDown {
        data = typeof data === 'object' ? data : {};
        let result = new DropDown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        data["employeeId"] = this.employeeId;
        data["disabled"] = this.disabled;
        return data;
    }
}

export interface IDropDown {
    value: number | undefined;
    label: string | undefined;
    employeeId: number | undefined;
    disabled: boolean;
}

export class AssetRequestConfirmationDto implements IAssetRequestConfirmationDto {
    assetId!: number;
    assetName!: string | undefined;
    assetAssignedDate!: moment.Moment;
    isConfirm!: boolean | undefined;
    assetReAssignedDate!: moment.Moment | undefined;
    id!: number;

    constructor(data?: IAssetRequestConfirmationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"];
            this.assetName = _data["assetName"];
            this.assetAssignedDate = _data["assetAssignedDate"] ? moment(_data["assetAssignedDate"].toString()) : <any>undefined;
            this.isConfirm = _data["isConfirm"];
            this.assetReAssignedDate = _data["assetReAssignedDate"] ? moment(_data["assetReAssignedDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AssetRequestConfirmationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetRequestConfirmationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId;
        data["assetName"] = this.assetName;
        data["assetAssignedDate"] = this.assetAssignedDate ? this.assetAssignedDate.toISOString() : <any>undefined;
        data["isConfirm"] = this.isConfirm;
        data["assetReAssignedDate"] = this.assetReAssignedDate ? this.assetReAssignedDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IAssetRequestConfirmationDto {
    assetId: number;
    assetName: string | undefined;
    assetAssignedDate: moment.Moment;
    isConfirm: boolean | undefined;
    assetReAssignedDate: moment.Moment | undefined;
    id: number;
}

export class AssetMasterDto implements IAssetMasterDto {
    assetserialNo!: string | undefined;
    assetTypeId!: number;
    assetName!: string | undefined;
    confrtgartion!: string | undefined;
    assigendToEmployee!: number | undefined;
    assignDate!: moment.Moment | undefined;
    assetValue!: number | undefined;
    remarks!: string | undefined;
    status!: string | undefined;
    assetConfirmationFrequency!: number | undefined;
    id!: number;

    constructor(data?: IAssetMasterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetserialNo = _data["assetserialNo"];
            this.assetTypeId = _data["assetTypeId"];
            this.assetName = _data["assetName"];
            this.confrtgartion = _data["confrtgartion"];
            this.assigendToEmployee = _data["assigendToEmployee"];
            this.assignDate = _data["assignDate"] ? moment(_data["assignDate"].toString()) : <any>undefined;
            this.assetValue = _data["assetValue"];
            this.remarks = _data["remarks"];
            this.status = _data["status"];
            this.assetConfirmationFrequency = _data["assetConfirmationFrequency"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AssetMasterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetMasterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetserialNo"] = this.assetserialNo;
        data["assetTypeId"] = this.assetTypeId;
        data["assetName"] = this.assetName;
        data["confrtgartion"] = this.confrtgartion;
        data["assigendToEmployee"] = this.assigendToEmployee;
        data["assignDate"] = this.assignDate ? this.assignDate.toISOString() : <any>undefined;
        data["assetValue"] = this.assetValue;
        data["remarks"] = this.remarks;
        data["status"] = this.status;
        data["assetConfirmationFrequency"] = this.assetConfirmationFrequency;
        data["id"] = this.id;
        return data;
    }
}

export interface IAssetMasterDto {
    assetserialNo: string | undefined;
    assetTypeId: number;
    assetName: string | undefined;
    confrtgartion: string | undefined;
    assigendToEmployee: number | undefined;
    assignDate: moment.Moment | undefined;
    assetValue: number | undefined;
    remarks: string | undefined;
    status: string | undefined;
    assetConfirmationFrequency: number | undefined;
    id: number;
}

export class GetAssetMasterForViewDto implements IGetAssetMasterForViewDto {
    assetM!: AssetMasterDto;
    assetTypeIdName!: string | undefined;
    assigendToEmployee!: string | undefined;

    constructor(data?: IGetAssetMasterForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetM = _data["assetM"] ? AssetMasterDto.fromJS(_data["assetM"]) : <any>undefined;
            this.assetTypeIdName = _data["assetTypeIdName"];
            this.assigendToEmployee = _data["assigendToEmployee"];
        }
    }

    static fromJS(data: any): GetAssetMasterForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetMasterForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetM"] = this.assetM ? this.assetM.toJSON() : <any>undefined;
        data["assetTypeIdName"] = this.assetTypeIdName;
        data["assigendToEmployee"] = this.assigendToEmployee;
        return data;
    }
}

export interface IGetAssetMasterForViewDto {
    assetM: AssetMasterDto;
    assetTypeIdName: string | undefined;
    assigendToEmployee: string | undefined;
}

export class PagedResultDtoOfGetAssetMasterForViewDto implements IPagedResultDtoOfGetAssetMasterForViewDto {
    totalCount!: number;
    items!: GetAssetMasterForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAssetMasterForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAssetMasterForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAssetMasterForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAssetMasterForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAssetMasterForViewDto {
    totalCount: number;
    items: GetAssetMasterForViewDto[] | undefined;
}

export class CreateOrEditTrnAssetMasterDetailsDto implements ICreateOrEditTrnAssetMasterDetailsDto {
    assigne_Return!: string;
    date!: moment.Moment;
    from_To!: number;
    assetId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTrnAssetMasterDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assigne_Return = _data["assigne_Return"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.from_To = _data["from_To"];
            this.assetId = _data["assetId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTrnAssetMasterDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTrnAssetMasterDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assigne_Return"] = this.assigne_Return;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["from_To"] = this.from_To;
        data["assetId"] = this.assetId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTrnAssetMasterDetailsDto {
    assigne_Return: string;
    date: moment.Moment;
    from_To: number;
    assetId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditAssetMasterDto implements ICreateOrEditAssetMasterDto {
    assetserialNo!: string | undefined;
    assetTypeId!: number;
    assetName!: string | undefined;
    confrtgartion!: string | undefined;
    assigendToEmployee!: number | undefined;
    assignDate!: moment.Moment | undefined;
    assetValue!: number | undefined;
    remarks!: string | undefined;
    assetConfirmationFrequency!: number | undefined;
    trnAssetMasterDetails!: CreateOrEditTrnAssetMasterDetailsDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAssetMasterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetserialNo = _data["assetserialNo"];
            this.assetTypeId = _data["assetTypeId"];
            this.assetName = _data["assetName"];
            this.confrtgartion = _data["confrtgartion"];
            this.assigendToEmployee = _data["assigendToEmployee"];
            this.assignDate = _data["assignDate"] ? moment(_data["assignDate"].toString()) : <any>undefined;
            this.assetValue = _data["assetValue"];
            this.remarks = _data["remarks"];
            this.assetConfirmationFrequency = _data["assetConfirmationFrequency"];
            if (Array.isArray(_data["trnAssetMasterDetails"])) {
                this.trnAssetMasterDetails = [] as any;
                for (let item of _data["trnAssetMasterDetails"])
                    this.trnAssetMasterDetails!.push(CreateOrEditTrnAssetMasterDetailsDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAssetMasterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAssetMasterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetserialNo"] = this.assetserialNo;
        data["assetTypeId"] = this.assetTypeId;
        data["assetName"] = this.assetName;
        data["confrtgartion"] = this.confrtgartion;
        data["assigendToEmployee"] = this.assigendToEmployee;
        data["assignDate"] = this.assignDate ? this.assignDate.toISOString() : <any>undefined;
        data["assetValue"] = this.assetValue;
        data["remarks"] = this.remarks;
        data["assetConfirmationFrequency"] = this.assetConfirmationFrequency;
        if (Array.isArray(this.trnAssetMasterDetails)) {
            data["trnAssetMasterDetails"] = [];
            for (let item of this.trnAssetMasterDetails)
                data["trnAssetMasterDetails"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditAssetMasterDto {
    assetserialNo: string | undefined;
    assetTypeId: number;
    assetName: string | undefined;
    confrtgartion: string | undefined;
    assigendToEmployee: number | undefined;
    assignDate: moment.Moment | undefined;
    assetValue: number | undefined;
    remarks: string | undefined;
    assetConfirmationFrequency: number | undefined;
    trnAssetMasterDetails: CreateOrEditTrnAssetMasterDetailsDto[] | undefined;
    id: number | undefined;
}

export class GetAssetMasterForEditOutput implements IGetAssetMasterForEditOutput {
    employeeId!: string | undefined;
    assetM!: CreateOrEditAssetMasterDto;

    constructor(data?: IGetAssetMasterForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.assetM = _data["assetM"] ? CreateOrEditAssetMasterDto.fromJS(_data["assetM"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAssetMasterForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetMasterForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["assetM"] = this.assetM ? this.assetM.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAssetMasterForEditOutput {
    employeeId: string | undefined;
    assetM: CreateOrEditAssetMasterDto;
}

export class GetAssetByUserDto implements IGetAssetByUserDto {
    assetName!: string | undefined;
    assetserialNo!: string | undefined;
    confrtgartion!: string | undefined;
    assignDate!: moment.Moment | undefined;
    assetTypeIdName!: string | undefined;
    assigendToEmployee!: string | undefined;
    assetValue!: number | undefined;
    employeeId!: number;
    filter!: string | undefined;
    skipCount!: number;
    maxResultCount!: number;
    remarks!: string | undefined;
    assetNameFilter!: string | undefined;
    id!: number;

    constructor(data?: IGetAssetByUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetName = _data["assetName"];
            this.assetserialNo = _data["assetserialNo"];
            this.confrtgartion = _data["confrtgartion"];
            this.assignDate = _data["assignDate"] ? moment(_data["assignDate"].toString()) : <any>undefined;
            this.assetTypeIdName = _data["assetTypeIdName"];
            this.assigendToEmployee = _data["assigendToEmployee"];
            this.assetValue = _data["assetValue"];
            this.employeeId = _data["employeeId"];
            this.filter = _data["filter"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
            this.remarks = _data["remarks"];
            this.assetNameFilter = _data["assetNameFilter"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetAssetByUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssetByUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetName"] = this.assetName;
        data["assetserialNo"] = this.assetserialNo;
        data["confrtgartion"] = this.confrtgartion;
        data["assignDate"] = this.assignDate ? this.assignDate.toISOString() : <any>undefined;
        data["assetTypeIdName"] = this.assetTypeIdName;
        data["assigendToEmployee"] = this.assigendToEmployee;
        data["assetValue"] = this.assetValue;
        data["employeeId"] = this.employeeId;
        data["filter"] = this.filter;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        data["remarks"] = this.remarks;
        data["assetNameFilter"] = this.assetNameFilter;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetAssetByUserDto {
    assetName: string | undefined;
    assetserialNo: string | undefined;
    confrtgartion: string | undefined;
    assignDate: moment.Moment | undefined;
    assetTypeIdName: string | undefined;
    assigendToEmployee: string | undefined;
    assetValue: number | undefined;
    employeeId: number;
    filter: string | undefined;
    skipCount: number;
    maxResultCount: number;
    remarks: string | undefined;
    assetNameFilter: string | undefined;
    id: number;
}

export class PagedResultDtoOfGetAssetByUserDto implements IPagedResultDtoOfGetAssetByUserDto {
    totalCount!: number;
    items!: GetAssetByUserDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAssetByUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAssetByUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAssetByUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAssetByUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAssetByUserDto {
    totalCount: number;
    items: GetAssetByUserDto[] | undefined;
}

export class CreateOrEditAttendanceCorrectionDto implements ICreateOrEditAttendanceCorrectionDto {
    reason!: number;
    attendanceDate!: moment.Moment;
    requestDate!: moment.Moment;
    in1Time!: string | undefined;
    in2Time!: string | undefined;
    in3Time!: string | undefined;
    in4Time!: string | undefined;
    in5Time!: string | undefined;
    out1Time!: string | undefined;
    out2Time!: string | undefined;
    out3Time!: string | undefined;
    out4Time!: string | undefined;
    out5Time!: string | undefined;
    oldIn1Time!: string | undefined;
    oldIn2Time!: string | undefined;
    oldIn3Time!: string | undefined;
    oldIn4Time!: string | undefined;
    oldIn5Time!: string | undefined;
    oldOut1Time!: string | undefined;
    oldOut2Time!: string | undefined;
    oldOut3Time!: string | undefined;
    oldOut4Time!: string | undefined;
    oldOut5Time!: string | undefined;
    emoloyeeId!: number;
    remarks!: string | undefined;
    reportingManager!: boolean | undefined;
    requestForApprovalLogId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAttendanceCorrectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
            this.attendanceDate = _data["attendanceDate"] ? moment(_data["attendanceDate"].toString()) : <any>undefined;
            this.requestDate = _data["requestDate"] ? moment(_data["requestDate"].toString()) : <any>undefined;
            this.in1Time = _data["in1Time"];
            this.in2Time = _data["in2Time"];
            this.in3Time = _data["in3Time"];
            this.in4Time = _data["in4Time"];
            this.in5Time = _data["in5Time"];
            this.out1Time = _data["out1Time"];
            this.out2Time = _data["out2Time"];
            this.out3Time = _data["out3Time"];
            this.out4Time = _data["out4Time"];
            this.out5Time = _data["out5Time"];
            this.oldIn1Time = _data["oldIn1Time"];
            this.oldIn2Time = _data["oldIn2Time"];
            this.oldIn3Time = _data["oldIn3Time"];
            this.oldIn4Time = _data["oldIn4Time"];
            this.oldIn5Time = _data["oldIn5Time"];
            this.oldOut1Time = _data["oldOut1Time"];
            this.oldOut2Time = _data["oldOut2Time"];
            this.oldOut3Time = _data["oldOut3Time"];
            this.oldOut4Time = _data["oldOut4Time"];
            this.oldOut5Time = _data["oldOut5Time"];
            this.emoloyeeId = _data["emoloyeeId"];
            this.remarks = _data["remarks"];
            this.reportingManager = _data["reportingManager"];
            this.requestForApprovalLogId = _data["requestForApprovalLogId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAttendanceCorrectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAttendanceCorrectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        data["attendanceDate"] = this.attendanceDate ? this.attendanceDate.toISOString() : <any>undefined;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["in1Time"] = this.in1Time;
        data["in2Time"] = this.in2Time;
        data["in3Time"] = this.in3Time;
        data["in4Time"] = this.in4Time;
        data["in5Time"] = this.in5Time;
        data["out1Time"] = this.out1Time;
        data["out2Time"] = this.out2Time;
        data["out3Time"] = this.out3Time;
        data["out4Time"] = this.out4Time;
        data["out5Time"] = this.out5Time;
        data["oldIn1Time"] = this.oldIn1Time;
        data["oldIn2Time"] = this.oldIn2Time;
        data["oldIn3Time"] = this.oldIn3Time;
        data["oldIn4Time"] = this.oldIn4Time;
        data["oldIn5Time"] = this.oldIn5Time;
        data["oldOut1Time"] = this.oldOut1Time;
        data["oldOut2Time"] = this.oldOut2Time;
        data["oldOut3Time"] = this.oldOut3Time;
        data["oldOut4Time"] = this.oldOut4Time;
        data["oldOut5Time"] = this.oldOut5Time;
        data["emoloyeeId"] = this.emoloyeeId;
        data["remarks"] = this.remarks;
        data["reportingManager"] = this.reportingManager;
        data["requestForApprovalLogId"] = this.requestForApprovalLogId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditAttendanceCorrectionDto {
    reason: number;
    attendanceDate: moment.Moment;
    requestDate: moment.Moment;
    in1Time: string | undefined;
    in2Time: string | undefined;
    in3Time: string | undefined;
    in4Time: string | undefined;
    in5Time: string | undefined;
    out1Time: string | undefined;
    out2Time: string | undefined;
    out3Time: string | undefined;
    out4Time: string | undefined;
    out5Time: string | undefined;
    oldIn1Time: string | undefined;
    oldIn2Time: string | undefined;
    oldIn3Time: string | undefined;
    oldIn4Time: string | undefined;
    oldIn5Time: string | undefined;
    oldOut1Time: string | undefined;
    oldOut2Time: string | undefined;
    oldOut3Time: string | undefined;
    oldOut4Time: string | undefined;
    oldOut5Time: string | undefined;
    emoloyeeId: number;
    remarks: string | undefined;
    reportingManager: boolean | undefined;
    requestForApprovalLogId: number | undefined;
    id: number | undefined;
}

export class GetAttendanceCorrectionForEditOutput implements IGetAttendanceCorrectionForEditOutput {
    attendanceCorrection!: CreateOrEditAttendanceCorrectionDto;
    reasonName!: string | undefined;
    requestedBy!: number | undefined;
    requestDate!: moment.Moment | undefined;
    requestFlow!: string | undefined;
    leaveRejectStatus!: string | undefined;

    constructor(data?: IGetAttendanceCorrectionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendanceCorrection = _data["attendanceCorrection"] ? CreateOrEditAttendanceCorrectionDto.fromJS(_data["attendanceCorrection"]) : <any>undefined;
            this.reasonName = _data["reasonName"];
            this.requestedBy = _data["requestedBy"];
            this.requestDate = _data["requestDate"] ? moment(_data["requestDate"].toString()) : <any>undefined;
            this.requestFlow = _data["requestFlow"];
            this.leaveRejectStatus = _data["leaveRejectStatus"];
        }
    }

    static fromJS(data: any): GetAttendanceCorrectionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttendanceCorrectionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendanceCorrection"] = this.attendanceCorrection ? this.attendanceCorrection.toJSON() : <any>undefined;
        data["reasonName"] = this.reasonName;
        data["requestedBy"] = this.requestedBy;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["requestFlow"] = this.requestFlow;
        data["leaveRejectStatus"] = this.leaveRejectStatus;
        return data;
    }
}

export interface IGetAttendanceCorrectionForEditOutput {
    attendanceCorrection: CreateOrEditAttendanceCorrectionDto;
    reasonName: string | undefined;
    requestedBy: number | undefined;
    requestDate: moment.Moment | undefined;
    requestFlow: string | undefined;
    leaveRejectStatus: string | undefined;
}

export class PagedResultDtoOfGetAttendanceCorrectionForEditOutput implements IPagedResultDtoOfGetAttendanceCorrectionForEditOutput {
    totalCount!: number;
    items!: GetAttendanceCorrectionForEditOutput[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAttendanceCorrectionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAttendanceCorrectionForEditOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAttendanceCorrectionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAttendanceCorrectionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAttendanceCorrectionForEditOutput {
    totalCount: number;
    items: GetAttendanceCorrectionForEditOutput[] | undefined;
}

export class CreateOrEditOnDutyDto implements ICreateOrEditOnDutyDto {
    odType!: number;
    reportingManager!: boolean | undefined;
    date!: moment.Moment;
    inTime!: string;
    outTime!: string;
    remarks!: string | undefined;
    requestForApprovalLogId!: number | undefined;
    createrUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditOnDutyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odType = _data["odType"];
            this.reportingManager = _data["reportingManager"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.inTime = _data["inTime"];
            this.outTime = _data["outTime"];
            this.remarks = _data["remarks"];
            this.requestForApprovalLogId = _data["requestForApprovalLogId"];
            this.createrUserId = _data["createrUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditOnDutyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditOnDutyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["odType"] = this.odType;
        data["reportingManager"] = this.reportingManager;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["inTime"] = this.inTime;
        data["outTime"] = this.outTime;
        data["remarks"] = this.remarks;
        data["requestForApprovalLogId"] = this.requestForApprovalLogId;
        data["createrUserId"] = this.createrUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditOnDutyDto {
    odType: number;
    reportingManager: boolean | undefined;
    date: moment.Moment;
    inTime: string;
    outTime: string;
    remarks: string | undefined;
    requestForApprovalLogId: number | undefined;
    createrUserId: number | undefined;
    id: number | undefined;
}

export class GetOnDutyForEditOutput implements IGetOnDutyForEditOutput {
    onDuty!: CreateOrEditOnDutyDto;
    odTypeName!: string | undefined;
    requestedBy!: number | undefined;
    requestFlow!: string | undefined;
    leaveRejectStatus!: string | undefined;

    constructor(data?: IGetOnDutyForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onDuty = _data["onDuty"] ? CreateOrEditOnDutyDto.fromJS(_data["onDuty"]) : <any>undefined;
            this.odTypeName = _data["odTypeName"];
            this.requestedBy = _data["requestedBy"];
            this.requestFlow = _data["requestFlow"];
            this.leaveRejectStatus = _data["leaveRejectStatus"];
        }
    }

    static fromJS(data: any): GetOnDutyForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetOnDutyForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onDuty"] = this.onDuty ? this.onDuty.toJSON() : <any>undefined;
        data["odTypeName"] = this.odTypeName;
        data["requestedBy"] = this.requestedBy;
        data["requestFlow"] = this.requestFlow;
        data["leaveRejectStatus"] = this.leaveRejectStatus;
        return data;
    }
}

export interface IGetOnDutyForEditOutput {
    onDuty: CreateOrEditOnDutyDto;
    odTypeName: string | undefined;
    requestedBy: number | undefined;
    requestFlow: string | undefined;
    leaveRejectStatus: string | undefined;
}

export class PagedResultDtoOfGetOnDutyForEditOutput implements IPagedResultDtoOfGetOnDutyForEditOutput {
    totalCount!: number;
    items!: GetOnDutyForEditOutput[] | undefined;

    constructor(data?: IPagedResultDtoOfGetOnDutyForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetOnDutyForEditOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetOnDutyForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetOnDutyForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetOnDutyForEditOutput {
    totalCount: number;
    items: GetOnDutyForEditOutput[] | undefined;
}

export class GetManualOnDutyForEditOutput implements IGetManualOnDutyForEditOutput {
    onDuty!: CreateOrEditOnDutyDto;
    odTypeName!: string | undefined;
    requestedBy!: string | undefined;
    requestFlow!: string | undefined;
    leaveRejectStatus!: string | undefined;

    constructor(data?: IGetManualOnDutyForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onDuty = _data["onDuty"] ? CreateOrEditOnDutyDto.fromJS(_data["onDuty"]) : <any>undefined;
            this.odTypeName = _data["odTypeName"];
            this.requestedBy = _data["requestedBy"];
            this.requestFlow = _data["requestFlow"];
            this.leaveRejectStatus = _data["leaveRejectStatus"];
        }
    }

    static fromJS(data: any): GetManualOnDutyForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetManualOnDutyForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onDuty"] = this.onDuty ? this.onDuty.toJSON() : <any>undefined;
        data["odTypeName"] = this.odTypeName;
        data["requestedBy"] = this.requestedBy;
        data["requestFlow"] = this.requestFlow;
        data["leaveRejectStatus"] = this.leaveRejectStatus;
        return data;
    }
}

export interface IGetManualOnDutyForEditOutput {
    onDuty: CreateOrEditOnDutyDto;
    odTypeName: string | undefined;
    requestedBy: string | undefined;
    requestFlow: string | undefined;
    leaveRejectStatus: string | undefined;
}

export class PagedResultDtoOfGetManualOnDutyForEditOutput implements IPagedResultDtoOfGetManualOnDutyForEditOutput {
    totalCount!: number;
    items!: GetManualOnDutyForEditOutput[] | undefined;

    constructor(data?: IPagedResultDtoOfGetManualOnDutyForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetManualOnDutyForEditOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetManualOnDutyForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetManualOnDutyForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetManualOnDutyForEditOutput {
    totalCount: number;
    items: GetManualOnDutyForEditOutput[] | undefined;
}

export class CreateOrEditShortLeaveDto implements ICreateOrEditShortLeaveDto {
    shortLeaveType!: number;
    reportingManager!: boolean | undefined;
    date!: moment.Moment;
    inTime!: string;
    outTime!: string;
    remarks!: string | undefined;
    requestForApprovalLogId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditShortLeaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shortLeaveType = _data["shortLeaveType"];
            this.reportingManager = _data["reportingManager"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.inTime = _data["inTime"];
            this.outTime = _data["outTime"];
            this.remarks = _data["remarks"];
            this.requestForApprovalLogId = _data["requestForApprovalLogId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditShortLeaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditShortLeaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shortLeaveType"] = this.shortLeaveType;
        data["reportingManager"] = this.reportingManager;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["inTime"] = this.inTime;
        data["outTime"] = this.outTime;
        data["remarks"] = this.remarks;
        data["requestForApprovalLogId"] = this.requestForApprovalLogId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditShortLeaveDto {
    shortLeaveType: number;
    reportingManager: boolean | undefined;
    date: moment.Moment;
    inTime: string;
    outTime: string;
    remarks: string | undefined;
    requestForApprovalLogId: number | undefined;
    id: number | undefined;
}

export class GetShortLeaveForEditOutput implements IGetShortLeaveForEditOutput {
    shortLeave!: CreateOrEditShortLeaveDto;
    shortLeaveTypeName!: string | undefined;
    requestedBy!: number | undefined;
    requestFlow!: string | undefined;
    leaveRejectStatus!: string | undefined;

    constructor(data?: IGetShortLeaveForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shortLeave = _data["shortLeave"] ? CreateOrEditShortLeaveDto.fromJS(_data["shortLeave"]) : <any>undefined;
            this.shortLeaveTypeName = _data["shortLeaveTypeName"];
            this.requestedBy = _data["requestedBy"];
            this.requestFlow = _data["requestFlow"];
            this.leaveRejectStatus = _data["leaveRejectStatus"];
        }
    }

    static fromJS(data: any): GetShortLeaveForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetShortLeaveForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shortLeave"] = this.shortLeave ? this.shortLeave.toJSON() : <any>undefined;
        data["shortLeaveTypeName"] = this.shortLeaveTypeName;
        data["requestedBy"] = this.requestedBy;
        data["requestFlow"] = this.requestFlow;
        data["leaveRejectStatus"] = this.leaveRejectStatus;
        return data;
    }
}

export interface IGetShortLeaveForEditOutput {
    shortLeave: CreateOrEditShortLeaveDto;
    shortLeaveTypeName: string | undefined;
    requestedBy: number | undefined;
    requestFlow: string | undefined;
    leaveRejectStatus: string | undefined;
}

export class PagedResultDtoOfGetShortLeaveForEditOutput implements IPagedResultDtoOfGetShortLeaveForEditOutput {
    totalCount!: number;
    items!: GetShortLeaveForEditOutput[] | undefined;

    constructor(data?: IPagedResultDtoOfGetShortLeaveForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetShortLeaveForEditOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetShortLeaveForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetShortLeaveForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetShortLeaveForEditOutput {
    totalCount: number;
    items: GetShortLeaveForEditOutput[] | undefined;
}

export class GetShortLeave implements IGetShortLeave {
    count!: number;
    maxnoofshortLeave!: number;

    constructor(data?: IGetShortLeave) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            this.maxnoofshortLeave = _data["maxnoofshortLeave"];
        }
    }

    static fromJS(data: any): GetShortLeave {
        data = typeof data === 'object' ? data : {};
        let result = new GetShortLeave();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["maxnoofshortLeave"] = this.maxnoofshortLeave;
        return data;
    }
}

export interface IGetShortLeave {
    count: number;
    maxnoofshortLeave: number;
}

export class GetAttendanceRuleValidation implements IGetAttendanceRuleValidation {
    maximumdayslimitforattendancecorrection!: number;
    maximumnoofattendancecorrection!: number;
    maximumdayslimitforonduty!: number;
    maximumdayslimitforshortleave!: number;
    totalAttendanceCorrection!: number;
    otRate!: number | undefined;

    constructor(data?: IGetAttendanceRuleValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maximumdayslimitforattendancecorrection = _data["maximumdayslimitforattendancecorrection"];
            this.maximumnoofattendancecorrection = _data["maximumnoofattendancecorrection"];
            this.maximumdayslimitforonduty = _data["maximumdayslimitforonduty"];
            this.maximumdayslimitforshortleave = _data["maximumdayslimitforshortleave"];
            this.totalAttendanceCorrection = _data["totalAttendanceCorrection"];
            this.otRate = _data["otRate"];
        }
    }

    static fromJS(data: any): GetAttendanceRuleValidation {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttendanceRuleValidation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maximumdayslimitforattendancecorrection"] = this.maximumdayslimitforattendancecorrection;
        data["maximumnoofattendancecorrection"] = this.maximumnoofattendancecorrection;
        data["maximumdayslimitforonduty"] = this.maximumdayslimitforonduty;
        data["maximumdayslimitforshortleave"] = this.maximumdayslimitforshortleave;
        data["totalAttendanceCorrection"] = this.totalAttendanceCorrection;
        data["otRate"] = this.otRate;
        return data;
    }
}

export interface IGetAttendanceRuleValidation {
    maximumdayslimitforattendancecorrection: number;
    maximumnoofattendancecorrection: number;
    maximumdayslimitforonduty: number;
    maximumdayslimitforshortleave: number;
    totalAttendanceCorrection: number;
    otRate: number | undefined;
}

export class GetAttendanceValidation implements IGetAttendanceValidation {
    count!: number;
    maxnoofcorrection!: number;

    constructor(data?: IGetAttendanceValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            this.maxnoofcorrection = _data["maxnoofcorrection"];
        }
    }

    static fromJS(data: any): GetAttendanceValidation {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttendanceValidation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["maxnoofcorrection"] = this.maxnoofcorrection;
        return data;
    }
}

export interface IGetAttendanceValidation {
    count: number;
    maxnoofcorrection: number;
}

export class GetShiftForValidation implements IGetShiftForValidation {
    shiftStartTime!: string;
    shiftEndTime!: string;

    constructor(data?: IGetShiftForValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftStartTime = _data["shiftStartTime"];
            this.shiftEndTime = _data["shiftEndTime"];
        }
    }

    static fromJS(data: any): GetShiftForValidation {
        data = typeof data === 'object' ? data : {};
        let result = new GetShiftForValidation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftStartTime"] = this.shiftStartTime;
        data["shiftEndTime"] = this.shiftEndTime;
        return data;
    }
}

export interface IGetShiftForValidation {
    shiftStartTime: string;
    shiftEndTime: string;
}

export class GetOnDutyMonthlyStats implements IGetOnDutyMonthlyStats {
    monthlyAllowedLimit!: number;
    monthlyUsed!: number;
    yearlyAllowed!: number | undefined;
    yearlyUsed!: number | undefined;

    constructor(data?: IGetOnDutyMonthlyStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthlyAllowedLimit = _data["monthlyAllowedLimit"];
            this.monthlyUsed = _data["monthlyUsed"];
            this.yearlyAllowed = _data["yearlyAllowed"];
            this.yearlyUsed = _data["yearlyUsed"];
        }
    }

    static fromJS(data: any): GetOnDutyMonthlyStats {
        data = typeof data === 'object' ? data : {};
        let result = new GetOnDutyMonthlyStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthlyAllowedLimit"] = this.monthlyAllowedLimit;
        data["monthlyUsed"] = this.monthlyUsed;
        data["yearlyAllowed"] = this.yearlyAllowed;
        data["yearlyUsed"] = this.yearlyUsed;
        return data;
    }
}

export interface IGetOnDutyMonthlyStats {
    monthlyAllowedLimit: number;
    monthlyUsed: number;
    yearlyAllowed: number | undefined;
    yearlyUsed: number | undefined;
}

export class GetShortLeaveMonthlyStats implements IGetShortLeaveMonthlyStats {
    monthlyAllowedLimit!: number;
    monthlyUsed!: number;
    yearlyAllowed!: number | undefined;
    yearlyUsed!: number | undefined;

    constructor(data?: IGetShortLeaveMonthlyStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthlyAllowedLimit = _data["monthlyAllowedLimit"];
            this.monthlyUsed = _data["monthlyUsed"];
            this.yearlyAllowed = _data["yearlyAllowed"];
            this.yearlyUsed = _data["yearlyUsed"];
        }
    }

    static fromJS(data: any): GetShortLeaveMonthlyStats {
        data = typeof data === 'object' ? data : {};
        let result = new GetShortLeaveMonthlyStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthlyAllowedLimit"] = this.monthlyAllowedLimit;
        data["monthlyUsed"] = this.monthlyUsed;
        data["yearlyAllowed"] = this.yearlyAllowed;
        data["yearlyUsed"] = this.yearlyUsed;
        return data;
    }
}

export interface IGetShortLeaveMonthlyStats {
    monthlyAllowedLimit: number;
    monthlyUsed: number;
    yearlyAllowed: number | undefined;
    yearlyUsed: number | undefined;
}

export class ShiftTimeDto implements IShiftTimeDto {
    shiftStartTime!: string;
    shiftEndTime!: string;

    constructor(data?: IShiftTimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftStartTime = _data["shiftStartTime"];
            this.shiftEndTime = _data["shiftEndTime"];
        }
    }

    static fromJS(data: any): ShiftTimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftTimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftStartTime"] = this.shiftStartTime;
        data["shiftEndTime"] = this.shiftEndTime;
        return data;
    }
}

export interface IShiftTimeDto {
    shiftStartTime: string;
    shiftEndTime: string;
}

export class AttendanceCorrectionAlertResultDto implements IAttendanceCorrectionAlertResultDto {
    employeesChecked!: number;
    alertsSent!: number;
    whatsAppSent!: number;
    emailsSent!: number;

    constructor(data?: IAttendanceCorrectionAlertResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeesChecked = _data["employeesChecked"];
            this.alertsSent = _data["alertsSent"];
            this.whatsAppSent = _data["whatsAppSent"];
            this.emailsSent = _data["emailsSent"];
        }
    }

    static fromJS(data: any): AttendanceCorrectionAlertResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceCorrectionAlertResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeesChecked"] = this.employeesChecked;
        data["alertsSent"] = this.alertsSent;
        data["whatsAppSent"] = this.whatsAppSent;
        data["emailsSent"] = this.emailsSent;
        return data;
    }
}

export interface IAttendanceCorrectionAlertResultDto {
    employeesChecked: number;
    alertsSent: number;
    whatsAppSent: number;
    emailsSent: number;
}

export class AttendancePunchDto implements IAttendancePunchDto {
    inTime!: string | undefined;
    outTime!: string | undefined;
    type!: number | undefined;
    attendanceId!: number;
    id!: number;

    constructor(data?: IAttendancePunchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inTime = _data["inTime"];
            this.outTime = _data["outTime"];
            this.type = _data["type"];
            this.attendanceId = _data["attendanceId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AttendancePunchDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendancePunchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inTime"] = this.inTime;
        data["outTime"] = this.outTime;
        data["type"] = this.type;
        data["attendanceId"] = this.attendanceId;
        data["id"] = this.id;
        return data;
    }
}

export interface IAttendancePunchDto {
    inTime: string | undefined;
    outTime: string | undefined;
    type: number | undefined;
    attendanceId: number;
    id: number;
}

export class GetAttendancePunchForViewDto implements IGetAttendancePunchForViewDto {
    attendancePunch!: AttendancePunchDto;

    constructor(data?: IGetAttendancePunchForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendancePunch = _data["attendancePunch"] ? AttendancePunchDto.fromJS(_data["attendancePunch"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAttendancePunchForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttendancePunchForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendancePunch"] = this.attendancePunch ? this.attendancePunch.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAttendancePunchForViewDto {
    attendancePunch: AttendancePunchDto;
}

export class PagedResultDtoOfGetAttendancePunchForViewDto implements IPagedResultDtoOfGetAttendancePunchForViewDto {
    totalCount!: number;
    items!: GetAttendancePunchForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAttendancePunchForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAttendancePunchForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAttendancePunchForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAttendancePunchForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAttendancePunchForViewDto {
    totalCount: number;
    items: GetAttendancePunchForViewDto[] | undefined;
}

export class CreateOrEditAttendancePunchDto implements ICreateOrEditAttendancePunchDto {
    inTime!: string | undefined;
    outTime!: string | undefined;
    type!: number | undefined;
    attendanceId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAttendancePunchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inTime = _data["inTime"];
            this.outTime = _data["outTime"];
            this.type = _data["type"];
            this.attendanceId = _data["attendanceId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAttendancePunchDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAttendancePunchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inTime"] = this.inTime;
        data["outTime"] = this.outTime;
        data["type"] = this.type;
        data["attendanceId"] = this.attendanceId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditAttendancePunchDto {
    inTime: string | undefined;
    outTime: string | undefined;
    type: number | undefined;
    attendanceId: number;
    id: number | undefined;
}

export class GetAttendancePunchForEditOutput implements IGetAttendancePunchForEditOutput {
    attendancePunch!: CreateOrEditAttendancePunchDto;

    constructor(data?: IGetAttendancePunchForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendancePunch = _data["attendancePunch"] ? CreateOrEditAttendancePunchDto.fromJS(_data["attendancePunch"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAttendancePunchForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttendancePunchForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendancePunch"] = this.attendancePunch ? this.attendancePunch.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAttendancePunchForEditOutput {
    attendancePunch: CreateOrEditAttendancePunchDto;
}

export enum PenaltyCalculationMode {
    CycleBased = 0,
    PostThreshold = 1,
}

export enum ExtraWorkingBenefit {
    NoBenefit = 0,
    AddToOt = 1,
    AddToCompOff = 2,
    CountAsPresent = 3,
}

export class AttendanceRuleDto implements IAttendanceRuleDto {
    attendanceRuleName!: string | undefined;
    attendanceRuleDesc!: string | undefined;
    maximumBackDaysAttendance!: number | undefined;
    maximumBackDaysOnDuty!: number | undefined;
    maximumBackDaysShortLeave!: number | undefined;
    maximumAttendanceRegularizeInMonth!: number | undefined;
    setMinimumWorkingDaysPolicy!: number | undefined;
    setMinimumWorkingDaysPolicyonBasisofDays!: number | undefined;
    arrearUpto!: number;
    markAbsentWeeklyoffAbsent!: number;
    markAbsentHolidayAbsent!: number;
    markAbsentWeeklyoffOneSideSandwich!: boolean;
    markAbsentHolidayOneSideSandwich!: boolean;
    graceTime!: number;
    graceDaysGivenToComeLateGoEarly!: number;
    alternateDaysDeductionAfterCompletionOfGrace!: number;
    penaltyCalculationMode!: PenaltyCalculationMode;
    lateCommingAndEarlyGoingDeductionDoneFrom!: number;
    lateCommingAndEarlyGoingDeductionType!: number;
    doNotGenrateCompOffOn!: string | undefined;
    doNotGenrateOvertimeOn!: string | undefined;
    extraWorkingBenefit!: ExtraWorkingBenefit;
    doYouWantAutoInitiateExtraWorking!: number;
    overTimeHoursRoundOff!: number;
    compOffWillExpire!: number;
    minimumWorkingHoursForFullDays!: number;
    minimumWorkingHoursForHaffDays!: number;
    compOffWillExpireDays!: number | undefined;
    onDutyType!: string | undefined;
    lateEarlyLeaveDeduction!: string | undefined;
    maximumdayslimitforattendancecorrection!: number | undefined;
    maximumnoofattendancecorrection!: number | undefined;
    id!: number;

    constructor(data?: IAttendanceRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendanceRuleName = _data["attendanceRuleName"];
            this.attendanceRuleDesc = _data["attendanceRuleDesc"];
            this.maximumBackDaysAttendance = _data["maximumBackDaysAttendance"];
            this.maximumBackDaysOnDuty = _data["maximumBackDaysOnDuty"];
            this.maximumBackDaysShortLeave = _data["maximumBackDaysShortLeave"];
            this.maximumAttendanceRegularizeInMonth = _data["maximumAttendanceRegularizeInMonth"];
            this.setMinimumWorkingDaysPolicy = _data["setMinimumWorkingDaysPolicy"];
            this.setMinimumWorkingDaysPolicyonBasisofDays = _data["setMinimumWorkingDaysPolicyonBasisofDays"];
            this.arrearUpto = _data["arrearUpto"];
            this.markAbsentWeeklyoffAbsent = _data["markAbsentWeeklyoffAbsent"];
            this.markAbsentHolidayAbsent = _data["markAbsentHolidayAbsent"];
            this.markAbsentWeeklyoffOneSideSandwich = _data["markAbsentWeeklyoffOneSideSandwich"];
            this.markAbsentHolidayOneSideSandwich = _data["markAbsentHolidayOneSideSandwich"];
            this.graceTime = _data["graceTime"];
            this.graceDaysGivenToComeLateGoEarly = _data["graceDaysGivenToComeLateGoEarly"];
            this.alternateDaysDeductionAfterCompletionOfGrace = _data["alternateDaysDeductionAfterCompletionOfGrace"];
            this.penaltyCalculationMode = _data["penaltyCalculationMode"];
            this.lateCommingAndEarlyGoingDeductionDoneFrom = _data["lateCommingAndEarlyGoingDeductionDoneFrom"];
            this.lateCommingAndEarlyGoingDeductionType = _data["lateCommingAndEarlyGoingDeductionType"];
            this.doNotGenrateCompOffOn = _data["doNotGenrateCompOffOn"];
            this.doNotGenrateOvertimeOn = _data["doNotGenrateOvertimeOn"];
            this.extraWorkingBenefit = _data["extraWorkingBenefit"];
            this.doYouWantAutoInitiateExtraWorking = _data["doYouWantAutoInitiateExtraWorking"];
            this.overTimeHoursRoundOff = _data["overTimeHoursRoundOff"];
            this.compOffWillExpire = _data["compOffWillExpire"];
            this.minimumWorkingHoursForFullDays = _data["minimumWorkingHoursForFullDays"];
            this.minimumWorkingHoursForHaffDays = _data["minimumWorkingHoursForHaffDays"];
            this.compOffWillExpireDays = _data["compOffWillExpireDays"];
            this.onDutyType = _data["onDutyType"];
            this.lateEarlyLeaveDeduction = _data["lateEarlyLeaveDeduction"];
            this.maximumdayslimitforattendancecorrection = _data["maximumdayslimitforattendancecorrection"];
            this.maximumnoofattendancecorrection = _data["maximumnoofattendancecorrection"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AttendanceRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendanceRuleName"] = this.attendanceRuleName;
        data["attendanceRuleDesc"] = this.attendanceRuleDesc;
        data["maximumBackDaysAttendance"] = this.maximumBackDaysAttendance;
        data["maximumBackDaysOnDuty"] = this.maximumBackDaysOnDuty;
        data["maximumBackDaysShortLeave"] = this.maximumBackDaysShortLeave;
        data["maximumAttendanceRegularizeInMonth"] = this.maximumAttendanceRegularizeInMonth;
        data["setMinimumWorkingDaysPolicy"] = this.setMinimumWorkingDaysPolicy;
        data["setMinimumWorkingDaysPolicyonBasisofDays"] = this.setMinimumWorkingDaysPolicyonBasisofDays;
        data["arrearUpto"] = this.arrearUpto;
        data["markAbsentWeeklyoffAbsent"] = this.markAbsentWeeklyoffAbsent;
        data["markAbsentHolidayAbsent"] = this.markAbsentHolidayAbsent;
        data["markAbsentWeeklyoffOneSideSandwich"] = this.markAbsentWeeklyoffOneSideSandwich;
        data["markAbsentHolidayOneSideSandwich"] = this.markAbsentHolidayOneSideSandwich;
        data["graceTime"] = this.graceTime;
        data["graceDaysGivenToComeLateGoEarly"] = this.graceDaysGivenToComeLateGoEarly;
        data["alternateDaysDeductionAfterCompletionOfGrace"] = this.alternateDaysDeductionAfterCompletionOfGrace;
        data["penaltyCalculationMode"] = this.penaltyCalculationMode;
        data["lateCommingAndEarlyGoingDeductionDoneFrom"] = this.lateCommingAndEarlyGoingDeductionDoneFrom;
        data["lateCommingAndEarlyGoingDeductionType"] = this.lateCommingAndEarlyGoingDeductionType;
        data["doNotGenrateCompOffOn"] = this.doNotGenrateCompOffOn;
        data["doNotGenrateOvertimeOn"] = this.doNotGenrateOvertimeOn;
        data["extraWorkingBenefit"] = this.extraWorkingBenefit;
        data["doYouWantAutoInitiateExtraWorking"] = this.doYouWantAutoInitiateExtraWorking;
        data["overTimeHoursRoundOff"] = this.overTimeHoursRoundOff;
        data["compOffWillExpire"] = this.compOffWillExpire;
        data["minimumWorkingHoursForFullDays"] = this.minimumWorkingHoursForFullDays;
        data["minimumWorkingHoursForHaffDays"] = this.minimumWorkingHoursForHaffDays;
        data["compOffWillExpireDays"] = this.compOffWillExpireDays;
        data["onDutyType"] = this.onDutyType;
        data["lateEarlyLeaveDeduction"] = this.lateEarlyLeaveDeduction;
        data["maximumdayslimitforattendancecorrection"] = this.maximumdayslimitforattendancecorrection;
        data["maximumnoofattendancecorrection"] = this.maximumnoofattendancecorrection;
        data["id"] = this.id;
        return data;
    }
}

export interface IAttendanceRuleDto {
    attendanceRuleName: string | undefined;
    attendanceRuleDesc: string | undefined;
    maximumBackDaysAttendance: number | undefined;
    maximumBackDaysOnDuty: number | undefined;
    maximumBackDaysShortLeave: number | undefined;
    maximumAttendanceRegularizeInMonth: number | undefined;
    setMinimumWorkingDaysPolicy: number | undefined;
    setMinimumWorkingDaysPolicyonBasisofDays: number | undefined;
    arrearUpto: number;
    markAbsentWeeklyoffAbsent: number;
    markAbsentHolidayAbsent: number;
    markAbsentWeeklyoffOneSideSandwich: boolean;
    markAbsentHolidayOneSideSandwich: boolean;
    graceTime: number;
    graceDaysGivenToComeLateGoEarly: number;
    alternateDaysDeductionAfterCompletionOfGrace: number;
    penaltyCalculationMode: PenaltyCalculationMode;
    lateCommingAndEarlyGoingDeductionDoneFrom: number;
    lateCommingAndEarlyGoingDeductionType: number;
    doNotGenrateCompOffOn: string | undefined;
    doNotGenrateOvertimeOn: string | undefined;
    extraWorkingBenefit: ExtraWorkingBenefit;
    doYouWantAutoInitiateExtraWorking: number;
    overTimeHoursRoundOff: number;
    compOffWillExpire: number;
    minimumWorkingHoursForFullDays: number;
    minimumWorkingHoursForHaffDays: number;
    compOffWillExpireDays: number | undefined;
    onDutyType: string | undefined;
    lateEarlyLeaveDeduction: string | undefined;
    maximumdayslimitforattendancecorrection: number | undefined;
    maximumnoofattendancecorrection: number | undefined;
    id: number;
}

export class GetAttendanceRuleForViewDto implements IGetAttendanceRuleForViewDto {
    attendanceRule!: AttendanceRuleDto;

    constructor(data?: IGetAttendanceRuleForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendanceRule = _data["attendanceRule"] ? AttendanceRuleDto.fromJS(_data["attendanceRule"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAttendanceRuleForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttendanceRuleForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendanceRule"] = this.attendanceRule ? this.attendanceRule.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAttendanceRuleForViewDto {
    attendanceRule: AttendanceRuleDto;
}

export class PagedResultDtoOfGetAttendanceRuleForViewDto implements IPagedResultDtoOfGetAttendanceRuleForViewDto {
    totalCount!: number;
    items!: GetAttendanceRuleForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAttendanceRuleForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAttendanceRuleForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAttendanceRuleForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAttendanceRuleForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAttendanceRuleForViewDto {
    totalCount: number;
    items: GetAttendanceRuleForViewDto[] | undefined;
}

export class ExtraWorkings implements IExtraWorkings {
    days!: number;
    compensatoryOff!: number | undefined;

    constructor(data?: IExtraWorkings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.days = _data["days"];
            this.compensatoryOff = _data["compensatoryOff"];
        }
    }

    static fromJS(data: any): ExtraWorkings {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraWorkings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["days"] = this.days;
        data["compensatoryOff"] = this.compensatoryOff;
        return data;
    }
}

export interface IExtraWorkings {
    days: number;
    compensatoryOff: number | undefined;
}

export class OnDutyTypes implements IOnDutyTypes {
    onDutyType!: string | undefined;
    maximumOnDutyCountMonth!: number;
    maximumOnDutyCountYear!: number;
    locationRequired!: number;

    constructor(data?: IOnDutyTypes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onDutyType = _data["onDutyType"];
            this.maximumOnDutyCountMonth = _data["maximumOnDutyCountMonth"];
            this.maximumOnDutyCountYear = _data["maximumOnDutyCountYear"];
            this.locationRequired = _data["locationRequired"];
        }
    }

    static fromJS(data: any): OnDutyTypes {
        data = typeof data === 'object' ? data : {};
        let result = new OnDutyTypes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onDutyType"] = this.onDutyType;
        data["maximumOnDutyCountMonth"] = this.maximumOnDutyCountMonth;
        data["maximumOnDutyCountYear"] = this.maximumOnDutyCountYear;
        data["locationRequired"] = this.locationRequired;
        return data;
    }
}

export interface IOnDutyTypes {
    onDutyType: string | undefined;
    maximumOnDutyCountMonth: number;
    maximumOnDutyCountYear: number;
    locationRequired: number;
}

export class ShortLeaveTypes implements IShortLeaveTypes {
    shortLeaveType!: string | undefined;
    maximumShortLeaveCountMonth!: number;
    maximumShortLeaveCountYear!: number;
    locationRequired!: number;

    constructor(data?: IShortLeaveTypes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shortLeaveType = _data["shortLeaveType"];
            this.maximumShortLeaveCountMonth = _data["maximumShortLeaveCountMonth"];
            this.maximumShortLeaveCountYear = _data["maximumShortLeaveCountYear"];
            this.locationRequired = _data["locationRequired"];
        }
    }

    static fromJS(data: any): ShortLeaveTypes {
        data = typeof data === 'object' ? data : {};
        let result = new ShortLeaveTypes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shortLeaveType"] = this.shortLeaveType;
        data["maximumShortLeaveCountMonth"] = this.maximumShortLeaveCountMonth;
        data["maximumShortLeaveCountYear"] = this.maximumShortLeaveCountYear;
        data["locationRequired"] = this.locationRequired;
        return data;
    }
}

export interface IShortLeaveTypes {
    shortLeaveType: string | undefined;
    maximumShortLeaveCountMonth: number;
    maximumShortLeaveCountYear: number;
    locationRequired: number;
}

export class LateEarlyDeduction implements ILateEarlyDeduction {
    priority!: number;
    leaveCode!: number;

    constructor(data?: ILateEarlyDeduction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.priority = _data["priority"];
            this.leaveCode = _data["leaveCode"];
        }
    }

    static fromJS(data: any): LateEarlyDeduction {
        data = typeof data === 'object' ? data : {};
        let result = new LateEarlyDeduction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priority"] = this.priority;
        data["leaveCode"] = this.leaveCode;
        return data;
    }
}

export interface ILateEarlyDeduction {
    priority: number;
    leaveCode: number;
}

export enum OtApplicableOn {
    Effective = 0,
    Gross = 1,
}

export enum CalculateOtOn {
    PostShift = 0,
    PreShift = 1,
    Both = 2,
}

export enum OTAllowedType {
    WorkingDays = 1,
    WeeklyOff = 2,
    Holidays = 4,
}

export enum OTRoundingType {
    Exact = 1,
    Upper15 = 2,
    Lower15 = 3,
    Upper30 = 4,
    Lower30 = 5,
    Upper60 = 6,
    Lower60 = 7,
}

export enum OTRateType {
    AsPerSalaryStructure = 1,
    FixedRate = 2,
}

export class CreateOrEditAttendanceRuleDto implements ICreateOrEditAttendanceRuleDto {
    attendanceRuleName!: string | undefined;
    attendanceRuleDesc!: string | undefined;
    maximumBackDaysAttendance!: number | undefined;
    maximumBackDaysOnDuty!: number | undefined;
    maximumBackDaysShortLeave!: number | undefined;
    yearlyOnDutyLimit!: number | undefined;
    monthlyShortLeaveLimit!: number | undefined;
    maximumAttendanceRegularizeInMonth!: number | undefined;
    setMinimumWorkingDaysPolicy!: number | undefined;
    setMinimumWorkingDaysPolicyonBasisofDays!: number | undefined;
    arrearUpto!: number;
    markAbsentWeeklyoffAbsent!: number;
    markAbsentHolidayAbsent!: number;
    markAbsentWeeklyoffOneSideSandwich!: boolean;
    markAbsentHolidayOneSideSandwich!: boolean;
    graceTime!: number;
    graceDaysGivenToComeLateGoEarly!: number;
    alternateDaysDeductionAfterCompletionOfGrace!: number;
    penaltyCalculationMode!: PenaltyCalculationMode;
    otOnWorkingDays!: boolean;
    lateCommingAndEarlyGoingDeductionDoneFrom!: number;
    lateCommingAndEarlyGoingDeductionType!: number;
    doNotGenrateCompOffOn!: string | undefined;
    doNotGenrateOvertimeOn!: string | undefined;
    extraWorkingBenefit!: ExtraWorkingBenefit;
    doYouWantAutoInitiateExtraWorking!: number;
    overTimeHoursRoundOff!: number;
    compOffWillExpire!: number;
    minimumWorkingHoursForFullDays!: number;
    minimumWorkingHoursForHaffDays!: number;
    compOffWillExpireDays!: number | undefined;
    onDutyType!: string | undefined;
    lateEarlyLeaveDeduction!: string | undefined;
    maximumdayslimitforattendancecorrection!: number | undefined;
    maximumnoofattendancecorrection!: number | undefined;
    allowPresentOnleave!: boolean;
    compOffOn_AllowPresentOnleave!: boolean;
    compOffOn_Holiday!: boolean;
    compOffApplicable!: boolean;
    extraWorkingList!: ExtraWorkings[] | undefined;
    onDutyTypeList!: OnDutyTypes[] | undefined;
    shortLeaveTypeList!: ShortLeaveTypes[] | undefined;
    lateEarlyDeductionList!: LateEarlyDeduction[] | undefined;
    hoMultiplyingFactor!: number;
    woMultiplyingFactor!: number;
    workingDaysMultiplyingFactor!: number;
    otApplicableOn!: OtApplicableOn;
    otRangeMinMinutes!: number | undefined;
    otRangeMaxMinutes!: number | undefined;
    calculateOtOn!: CalculateOtOn;
    singlePunchOutMode!: boolean;
    otAllowed!: OTAllowedType;
    otRounding!: OTRoundingType;
    otRate!: OTRateType;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAttendanceRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendanceRuleName = _data["attendanceRuleName"];
            this.attendanceRuleDesc = _data["attendanceRuleDesc"];
            this.maximumBackDaysAttendance = _data["maximumBackDaysAttendance"];
            this.maximumBackDaysOnDuty = _data["maximumBackDaysOnDuty"];
            this.maximumBackDaysShortLeave = _data["maximumBackDaysShortLeave"];
            this.yearlyOnDutyLimit = _data["yearlyOnDutyLimit"];
            this.monthlyShortLeaveLimit = _data["monthlyShortLeaveLimit"];
            this.maximumAttendanceRegularizeInMonth = _data["maximumAttendanceRegularizeInMonth"];
            this.setMinimumWorkingDaysPolicy = _data["setMinimumWorkingDaysPolicy"];
            this.setMinimumWorkingDaysPolicyonBasisofDays = _data["setMinimumWorkingDaysPolicyonBasisofDays"];
            this.arrearUpto = _data["arrearUpto"];
            this.markAbsentWeeklyoffAbsent = _data["markAbsentWeeklyoffAbsent"];
            this.markAbsentHolidayAbsent = _data["markAbsentHolidayAbsent"];
            this.markAbsentWeeklyoffOneSideSandwich = _data["markAbsentWeeklyoffOneSideSandwich"];
            this.markAbsentHolidayOneSideSandwich = _data["markAbsentHolidayOneSideSandwich"];
            this.graceTime = _data["graceTime"];
            this.graceDaysGivenToComeLateGoEarly = _data["graceDaysGivenToComeLateGoEarly"];
            this.alternateDaysDeductionAfterCompletionOfGrace = _data["alternateDaysDeductionAfterCompletionOfGrace"];
            this.penaltyCalculationMode = _data["penaltyCalculationMode"];
            this.otOnWorkingDays = _data["otOnWorkingDays"];
            this.lateCommingAndEarlyGoingDeductionDoneFrom = _data["lateCommingAndEarlyGoingDeductionDoneFrom"];
            this.lateCommingAndEarlyGoingDeductionType = _data["lateCommingAndEarlyGoingDeductionType"];
            this.doNotGenrateCompOffOn = _data["doNotGenrateCompOffOn"];
            this.doNotGenrateOvertimeOn = _data["doNotGenrateOvertimeOn"];
            this.extraWorkingBenefit = _data["extraWorkingBenefit"];
            this.doYouWantAutoInitiateExtraWorking = _data["doYouWantAutoInitiateExtraWorking"];
            this.overTimeHoursRoundOff = _data["overTimeHoursRoundOff"];
            this.compOffWillExpire = _data["compOffWillExpire"];
            this.minimumWorkingHoursForFullDays = _data["minimumWorkingHoursForFullDays"];
            this.minimumWorkingHoursForHaffDays = _data["minimumWorkingHoursForHaffDays"];
            this.compOffWillExpireDays = _data["compOffWillExpireDays"];
            this.onDutyType = _data["onDutyType"];
            this.lateEarlyLeaveDeduction = _data["lateEarlyLeaveDeduction"];
            this.maximumdayslimitforattendancecorrection = _data["maximumdayslimitforattendancecorrection"];
            this.maximumnoofattendancecorrection = _data["maximumnoofattendancecorrection"];
            this.allowPresentOnleave = _data["allowPresentOnleave"];
            this.compOffOn_AllowPresentOnleave = _data["compOffOn_AllowPresentOnleave"];
            this.compOffOn_Holiday = _data["compOffOn_Holiday"];
            this.compOffApplicable = _data["compOffApplicable"];
            if (Array.isArray(_data["extraWorkingList"])) {
                this.extraWorkingList = [] as any;
                for (let item of _data["extraWorkingList"])
                    this.extraWorkingList!.push(ExtraWorkings.fromJS(item));
            }
            if (Array.isArray(_data["onDutyTypeList"])) {
                this.onDutyTypeList = [] as any;
                for (let item of _data["onDutyTypeList"])
                    this.onDutyTypeList!.push(OnDutyTypes.fromJS(item));
            }
            if (Array.isArray(_data["shortLeaveTypeList"])) {
                this.shortLeaveTypeList = [] as any;
                for (let item of _data["shortLeaveTypeList"])
                    this.shortLeaveTypeList!.push(ShortLeaveTypes.fromJS(item));
            }
            if (Array.isArray(_data["lateEarlyDeductionList"])) {
                this.lateEarlyDeductionList = [] as any;
                for (let item of _data["lateEarlyDeductionList"])
                    this.lateEarlyDeductionList!.push(LateEarlyDeduction.fromJS(item));
            }
            this.hoMultiplyingFactor = _data["hoMultiplyingFactor"];
            this.woMultiplyingFactor = _data["woMultiplyingFactor"];
            this.workingDaysMultiplyingFactor = _data["workingDaysMultiplyingFactor"];
            this.otApplicableOn = _data["otApplicableOn"];
            this.otRangeMinMinutes = _data["otRangeMinMinutes"];
            this.otRangeMaxMinutes = _data["otRangeMaxMinutes"];
            this.calculateOtOn = _data["calculateOtOn"];
            this.singlePunchOutMode = _data["singlePunchOutMode"];
            this.otAllowed = _data["otAllowed"];
            this.otRounding = _data["otRounding"];
            this.otRate = _data["otRate"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAttendanceRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAttendanceRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendanceRuleName"] = this.attendanceRuleName;
        data["attendanceRuleDesc"] = this.attendanceRuleDesc;
        data["maximumBackDaysAttendance"] = this.maximumBackDaysAttendance;
        data["maximumBackDaysOnDuty"] = this.maximumBackDaysOnDuty;
        data["maximumBackDaysShortLeave"] = this.maximumBackDaysShortLeave;
        data["yearlyOnDutyLimit"] = this.yearlyOnDutyLimit;
        data["monthlyShortLeaveLimit"] = this.monthlyShortLeaveLimit;
        data["maximumAttendanceRegularizeInMonth"] = this.maximumAttendanceRegularizeInMonth;
        data["setMinimumWorkingDaysPolicy"] = this.setMinimumWorkingDaysPolicy;
        data["setMinimumWorkingDaysPolicyonBasisofDays"] = this.setMinimumWorkingDaysPolicyonBasisofDays;
        data["arrearUpto"] = this.arrearUpto;
        data["markAbsentWeeklyoffAbsent"] = this.markAbsentWeeklyoffAbsent;
        data["markAbsentHolidayAbsent"] = this.markAbsentHolidayAbsent;
        data["markAbsentWeeklyoffOneSideSandwich"] = this.markAbsentWeeklyoffOneSideSandwich;
        data["markAbsentHolidayOneSideSandwich"] = this.markAbsentHolidayOneSideSandwich;
        data["graceTime"] = this.graceTime;
        data["graceDaysGivenToComeLateGoEarly"] = this.graceDaysGivenToComeLateGoEarly;
        data["alternateDaysDeductionAfterCompletionOfGrace"] = this.alternateDaysDeductionAfterCompletionOfGrace;
        data["penaltyCalculationMode"] = this.penaltyCalculationMode;
        data["otOnWorkingDays"] = this.otOnWorkingDays;
        data["lateCommingAndEarlyGoingDeductionDoneFrom"] = this.lateCommingAndEarlyGoingDeductionDoneFrom;
        data["lateCommingAndEarlyGoingDeductionType"] = this.lateCommingAndEarlyGoingDeductionType;
        data["doNotGenrateCompOffOn"] = this.doNotGenrateCompOffOn;
        data["doNotGenrateOvertimeOn"] = this.doNotGenrateOvertimeOn;
        data["extraWorkingBenefit"] = this.extraWorkingBenefit;
        data["doYouWantAutoInitiateExtraWorking"] = this.doYouWantAutoInitiateExtraWorking;
        data["overTimeHoursRoundOff"] = this.overTimeHoursRoundOff;
        data["compOffWillExpire"] = this.compOffWillExpire;
        data["minimumWorkingHoursForFullDays"] = this.minimumWorkingHoursForFullDays;
        data["minimumWorkingHoursForHaffDays"] = this.minimumWorkingHoursForHaffDays;
        data["compOffWillExpireDays"] = this.compOffWillExpireDays;
        data["onDutyType"] = this.onDutyType;
        data["lateEarlyLeaveDeduction"] = this.lateEarlyLeaveDeduction;
        data["maximumdayslimitforattendancecorrection"] = this.maximumdayslimitforattendancecorrection;
        data["maximumnoofattendancecorrection"] = this.maximumnoofattendancecorrection;
        data["allowPresentOnleave"] = this.allowPresentOnleave;
        data["compOffOn_AllowPresentOnleave"] = this.compOffOn_AllowPresentOnleave;
        data["compOffOn_Holiday"] = this.compOffOn_Holiday;
        data["compOffApplicable"] = this.compOffApplicable;
        if (Array.isArray(this.extraWorkingList)) {
            data["extraWorkingList"] = [];
            for (let item of this.extraWorkingList)
                data["extraWorkingList"].push(item.toJSON());
        }
        if (Array.isArray(this.onDutyTypeList)) {
            data["onDutyTypeList"] = [];
            for (let item of this.onDutyTypeList)
                data["onDutyTypeList"].push(item.toJSON());
        }
        if (Array.isArray(this.shortLeaveTypeList)) {
            data["shortLeaveTypeList"] = [];
            for (let item of this.shortLeaveTypeList)
                data["shortLeaveTypeList"].push(item.toJSON());
        }
        if (Array.isArray(this.lateEarlyDeductionList)) {
            data["lateEarlyDeductionList"] = [];
            for (let item of this.lateEarlyDeductionList)
                data["lateEarlyDeductionList"].push(item.toJSON());
        }
        data["hoMultiplyingFactor"] = this.hoMultiplyingFactor;
        data["woMultiplyingFactor"] = this.woMultiplyingFactor;
        data["workingDaysMultiplyingFactor"] = this.workingDaysMultiplyingFactor;
        data["otApplicableOn"] = this.otApplicableOn;
        data["otRangeMinMinutes"] = this.otRangeMinMinutes;
        data["otRangeMaxMinutes"] = this.otRangeMaxMinutes;
        data["calculateOtOn"] = this.calculateOtOn;
        data["singlePunchOutMode"] = this.singlePunchOutMode;
        data["otAllowed"] = this.otAllowed;
        data["otRounding"] = this.otRounding;
        data["otRate"] = this.otRate;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditAttendanceRuleDto {
    attendanceRuleName: string | undefined;
    attendanceRuleDesc: string | undefined;
    maximumBackDaysAttendance: number | undefined;
    maximumBackDaysOnDuty: number | undefined;
    maximumBackDaysShortLeave: number | undefined;
    yearlyOnDutyLimit: number | undefined;
    monthlyShortLeaveLimit: number | undefined;
    maximumAttendanceRegularizeInMonth: number | undefined;
    setMinimumWorkingDaysPolicy: number | undefined;
    setMinimumWorkingDaysPolicyonBasisofDays: number | undefined;
    arrearUpto: number;
    markAbsentWeeklyoffAbsent: number;
    markAbsentHolidayAbsent: number;
    markAbsentWeeklyoffOneSideSandwich: boolean;
    markAbsentHolidayOneSideSandwich: boolean;
    graceTime: number;
    graceDaysGivenToComeLateGoEarly: number;
    alternateDaysDeductionAfterCompletionOfGrace: number;
    penaltyCalculationMode: PenaltyCalculationMode;
    otOnWorkingDays: boolean;
    lateCommingAndEarlyGoingDeductionDoneFrom: number;
    lateCommingAndEarlyGoingDeductionType: number;
    doNotGenrateCompOffOn: string | undefined;
    doNotGenrateOvertimeOn: string | undefined;
    extraWorkingBenefit: ExtraWorkingBenefit;
    doYouWantAutoInitiateExtraWorking: number;
    overTimeHoursRoundOff: number;
    compOffWillExpire: number;
    minimumWorkingHoursForFullDays: number;
    minimumWorkingHoursForHaffDays: number;
    compOffWillExpireDays: number | undefined;
    onDutyType: string | undefined;
    lateEarlyLeaveDeduction: string | undefined;
    maximumdayslimitforattendancecorrection: number | undefined;
    maximumnoofattendancecorrection: number | undefined;
    allowPresentOnleave: boolean;
    compOffOn_AllowPresentOnleave: boolean;
    compOffOn_Holiday: boolean;
    compOffApplicable: boolean;
    extraWorkingList: ExtraWorkings[] | undefined;
    onDutyTypeList: OnDutyTypes[] | undefined;
    shortLeaveTypeList: ShortLeaveTypes[] | undefined;
    lateEarlyDeductionList: LateEarlyDeduction[] | undefined;
    hoMultiplyingFactor: number;
    woMultiplyingFactor: number;
    workingDaysMultiplyingFactor: number;
    otApplicableOn: OtApplicableOn;
    otRangeMinMinutes: number | undefined;
    otRangeMaxMinutes: number | undefined;
    calculateOtOn: CalculateOtOn;
    singlePunchOutMode: boolean;
    otAllowed: OTAllowedType;
    otRounding: OTRoundingType;
    otRate: OTRateType;
    id: number | undefined;
}

export class GetAttendanceRuleForEditOutput implements IGetAttendanceRuleForEditOutput {
    attendanceRule!: CreateOrEditAttendanceRuleDto;

    constructor(data?: IGetAttendanceRuleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendanceRule = _data["attendanceRule"] ? CreateOrEditAttendanceRuleDto.fromJS(_data["attendanceRule"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAttendanceRuleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttendanceRuleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendanceRule"] = this.attendanceRule ? this.attendanceRule.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAttendanceRuleForEditOutput {
    attendanceRule: CreateOrEditAttendanceRuleDto;
}

export class GetShiftDetails implements IGetShiftDetails {
    employeeCode!: string | undefined;
    employee!: string | undefined;
    department!: string | undefined;
    location!: string | undefined;
    shiftType!: string | undefined;
    weeklyOff!: number;
    id!: number;

    constructor(data?: IGetShiftDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeCode = _data["employeeCode"];
            this.employee = _data["employee"];
            this.department = _data["department"];
            this.location = _data["location"];
            this.shiftType = _data["shiftType"];
            this.weeklyOff = _data["weeklyOff"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetShiftDetails {
        data = typeof data === 'object' ? data : {};
        let result = new GetShiftDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeCode"] = this.employeeCode;
        data["employee"] = this.employee;
        data["department"] = this.department;
        data["location"] = this.location;
        data["shiftType"] = this.shiftType;
        data["weeklyOff"] = this.weeklyOff;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetShiftDetails {
    employeeCode: string | undefined;
    employee: string | undefined;
    department: string | undefined;
    location: string | undefined;
    shiftType: string | undefined;
    weeklyOff: number;
    id: number;
}

export class PagedResultDtoOfGetShiftDetails implements IPagedResultDtoOfGetShiftDetails {
    totalCount!: number;
    items!: GetShiftDetails[] | undefined;

    constructor(data?: IPagedResultDtoOfGetShiftDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetShiftDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetShiftDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetShiftDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetShiftDetails {
    totalCount: number;
    items: GetShiftDetails[] | undefined;
}

export class UpdateshiftAttendance implements IUpdateshiftAttendance {
    attendanceDate!: moment.Moment;
    employeeId!: number | undefined;
    shiftId!: number | undefined;
    tenantId!: number | undefined;
    graceTime!: number | undefined;
    shiftStartTime!: string;
    shiftEndTime!: string;
    id!: number | undefined;

    constructor(data?: IUpdateshiftAttendance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendanceDate = _data["attendanceDate"] ? moment(_data["attendanceDate"].toString()) : <any>undefined;
            this.employeeId = _data["employeeId"];
            this.shiftId = _data["shiftId"];
            this.tenantId = _data["tenantId"];
            this.graceTime = _data["graceTime"];
            this.shiftStartTime = _data["shiftStartTime"];
            this.shiftEndTime = _data["shiftEndTime"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateshiftAttendance {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateshiftAttendance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendanceDate"] = this.attendanceDate ? this.attendanceDate.toISOString() : <any>undefined;
        data["employeeId"] = this.employeeId;
        data["shiftId"] = this.shiftId;
        data["tenantId"] = this.tenantId;
        data["graceTime"] = this.graceTime;
        data["shiftStartTime"] = this.shiftStartTime;
        data["shiftEndTime"] = this.shiftEndTime;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateshiftAttendance {
    attendanceDate: moment.Moment;
    employeeId: number | undefined;
    shiftId: number | undefined;
    tenantId: number | undefined;
    graceTime: number | undefined;
    shiftStartTime: string;
    shiftEndTime: string;
    id: number | undefined;
}

export class Atdata implements IAtdata {
    mat!: number;
    tat!: number;
    tatpm!: number;
    pat!: number;
    pr!: number;
    novertime!: number;
    overtime!: number;

    constructor(data?: IAtdata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mat = _data["mat"];
            this.tat = _data["tat"];
            this.tatpm = _data["tatpm"];
            this.pat = _data["pat"];
            this.pr = _data["pr"];
            this.novertime = _data["novertime"];
            this.overtime = _data["overtime"];
        }
    }

    static fromJS(data: any): Atdata {
        data = typeof data === 'object' ? data : {};
        let result = new Atdata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mat"] = this.mat;
        data["tat"] = this.tat;
        data["tatpm"] = this.tatpm;
        data["pat"] = this.pat;
        data["pr"] = this.pr;
        data["novertime"] = this.novertime;
        data["overtime"] = this.overtime;
        return data;
    }
}

export interface IAtdata {
    mat: number;
    tat: number;
    tatpm: number;
    pat: number;
    pr: number;
    novertime: number;
    overtime: number;
}

export class Week implements IWeek {
    shiftname!: string | undefined;
    shiftno!: number | undefined;

    constructor(data?: IWeek) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftname = _data["shiftname"];
            this.shiftno = _data["shiftno"];
        }
    }

    static fromJS(data: any): Week {
        data = typeof data === 'object' ? data : {};
        let result = new Week();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftname"] = this.shiftname;
        data["shiftno"] = this.shiftno;
        return data;
    }
}

export interface IWeek {
    shiftname: string | undefined;
    shiftno: number | undefined;
}

export class Holiday implements IHoliday {
    name!: string | undefined;
    holidayno!: number;

    constructor(data?: IHoliday) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.holidayno = _data["holidayno"];
        }
    }

    static fromJS(data: any): Holiday {
        data = typeof data === 'object' ? data : {};
        let result = new Holiday();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["holidayno"] = this.holidayno;
        return data;
    }
}

export interface IHoliday {
    name: string | undefined;
    holidayno: number;
}

export class Shift2 implements IShift2 {
    shiftname!: string | undefined;
    employeeno!: number;

    constructor(data?: IShift2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftname = _data["shiftname"];
            this.employeeno = _data["employeeno"];
        }
    }

    static fromJS(data: any): Shift2 {
        data = typeof data === 'object' ? data : {};
        let result = new Shift2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftname"] = this.shiftname;
        data["employeeno"] = this.employeeno;
        return data;
    }
}

export interface IShift2 {
    shiftname: string | undefined;
    employeeno: number;
}

export class AttendanceDto implements IAttendanceDto {
    attendanceDate!: moment.Moment | undefined;
    in1!: string | undefined;
    out1!: string | undefined;
    in2!: string | undefined;
    out2!: string | undefined;
    in3!: string | undefined;
    out3!: string | undefined;
    in4!: string | undefined;
    out4!: string | undefined;
    in5!: string | undefined;
    out5!: string | undefined;
    attendanceMode!: string | undefined;
    firsthalf!: string | undefined;
    secondhalf!: string | undefined;
    employeeId!: number | undefined;
    latecoming!: number | undefined;
    earlyGoing!: number | undefined;
    remarks!: string | undefined;
    attendancestatus!: string | undefined;
    overTime!: number;
    overTimeString!: string | undefined;
    holiday!: string | undefined;
    createdBy!: number | undefined;
    availableShifts!: string[] | undefined;
    checkIn!: string | undefined;
    checkOut!: string | undefined;
    id!: number;

    constructor(data?: IAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendanceDate = _data["attendanceDate"] ? moment(_data["attendanceDate"].toString()) : <any>undefined;
            this.in1 = _data["in1"];
            this.out1 = _data["out1"];
            this.in2 = _data["in2"];
            this.out2 = _data["out2"];
            this.in3 = _data["in3"];
            this.out3 = _data["out3"];
            this.in4 = _data["in4"];
            this.out4 = _data["out4"];
            this.in5 = _data["in5"];
            this.out5 = _data["out5"];
            this.attendanceMode = _data["attendanceMode"];
            this.firsthalf = _data["firsthalf"];
            this.secondhalf = _data["secondhalf"];
            this.employeeId = _data["employeeId"];
            this.latecoming = _data["latecoming"];
            this.earlyGoing = _data["earlyGoing"];
            this.remarks = _data["remarks"];
            this.attendancestatus = _data["attendancestatus"];
            this.overTime = _data["overTime"];
            this.overTimeString = _data["overTimeString"];
            this.holiday = _data["holiday"];
            this.createdBy = _data["createdBy"];
            if (Array.isArray(_data["availableShifts"])) {
                this.availableShifts = [] as any;
                for (let item of _data["availableShifts"])
                    this.availableShifts!.push(item);
            }
            this.checkIn = _data["checkIn"];
            this.checkOut = _data["checkOut"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendanceDate"] = this.attendanceDate ? this.attendanceDate.toISOString() : <any>undefined;
        data["in1"] = this.in1;
        data["out1"] = this.out1;
        data["in2"] = this.in2;
        data["out2"] = this.out2;
        data["in3"] = this.in3;
        data["out3"] = this.out3;
        data["in4"] = this.in4;
        data["out4"] = this.out4;
        data["in5"] = this.in5;
        data["out5"] = this.out5;
        data["attendanceMode"] = this.attendanceMode;
        data["firsthalf"] = this.firsthalf;
        data["secondhalf"] = this.secondhalf;
        data["employeeId"] = this.employeeId;
        data["latecoming"] = this.latecoming;
        data["earlyGoing"] = this.earlyGoing;
        data["remarks"] = this.remarks;
        data["attendancestatus"] = this.attendancestatus;
        data["overTime"] = this.overTime;
        data["overTimeString"] = this.overTimeString;
        data["holiday"] = this.holiday;
        data["createdBy"] = this.createdBy;
        if (Array.isArray(this.availableShifts)) {
            data["availableShifts"] = [];
            for (let item of this.availableShifts)
                data["availableShifts"].push(item);
        }
        data["checkIn"] = this.checkIn;
        data["checkOut"] = this.checkOut;
        data["id"] = this.id;
        return data;
    }
}

export interface IAttendanceDto {
    attendanceDate: moment.Moment | undefined;
    in1: string | undefined;
    out1: string | undefined;
    in2: string | undefined;
    out2: string | undefined;
    in3: string | undefined;
    out3: string | undefined;
    in4: string | undefined;
    out4: string | undefined;
    in5: string | undefined;
    out5: string | undefined;
    attendanceMode: string | undefined;
    firsthalf: string | undefined;
    secondhalf: string | undefined;
    employeeId: number | undefined;
    latecoming: number | undefined;
    earlyGoing: number | undefined;
    remarks: string | undefined;
    attendancestatus: string | undefined;
    overTime: number;
    overTimeString: string | undefined;
    holiday: string | undefined;
    createdBy: number | undefined;
    availableShifts: string[] | undefined;
    checkIn: string | undefined;
    checkOut: string | undefined;
    id: number;
}

export class GetAttendanceForViewDto implements IGetAttendanceForViewDto {
    departmentName!: string | undefined;
    branchName!: string | undefined;
    attendance!: AttendanceDto;
    empCode!: string | undefined;
    employeeFirstName!: string | undefined;
    shiftName!: string | undefined;
    shiftId!: number | undefined;
    bioMetricID!: string | undefined;
    status!: number;
    presentCount!: number;
    halfDayCount!: number;
    checkedIn!: number;
    employeeId!: number | undefined;
    requestStatus!: string | undefined;

    constructor(data?: IGetAttendanceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentName = _data["departmentName"];
            this.branchName = _data["branchName"];
            this.attendance = _data["attendance"] ? AttendanceDto.fromJS(_data["attendance"]) : <any>undefined;
            this.empCode = _data["empCode"];
            this.employeeFirstName = _data["employeeFirstName"];
            this.shiftName = _data["shiftName"];
            this.shiftId = _data["shiftId"];
            this.bioMetricID = _data["bioMetricID"];
            this.status = _data["status"];
            this.presentCount = _data["presentCount"];
            this.halfDayCount = _data["halfDayCount"];
            this.checkedIn = _data["checkedIn"];
            this.employeeId = _data["employeeId"];
            this.requestStatus = _data["requestStatus"];
        }
    }

    static fromJS(data: any): GetAttendanceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttendanceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentName"] = this.departmentName;
        data["branchName"] = this.branchName;
        data["attendance"] = this.attendance ? this.attendance.toJSON() : <any>undefined;
        data["empCode"] = this.empCode;
        data["employeeFirstName"] = this.employeeFirstName;
        data["shiftName"] = this.shiftName;
        data["shiftId"] = this.shiftId;
        data["bioMetricID"] = this.bioMetricID;
        data["status"] = this.status;
        data["presentCount"] = this.presentCount;
        data["halfDayCount"] = this.halfDayCount;
        data["checkedIn"] = this.checkedIn;
        data["employeeId"] = this.employeeId;
        data["requestStatus"] = this.requestStatus;
        return data;
    }
}

export interface IGetAttendanceForViewDto {
    departmentName: string | undefined;
    branchName: string | undefined;
    attendance: AttendanceDto;
    empCode: string | undefined;
    employeeFirstName: string | undefined;
    shiftName: string | undefined;
    shiftId: number | undefined;
    bioMetricID: string | undefined;
    status: number;
    presentCount: number;
    halfDayCount: number;
    checkedIn: number;
    employeeId: number | undefined;
    requestStatus: string | undefined;
}

export class PagedResultDtoOfGetAttendanceForViewDto implements IPagedResultDtoOfGetAttendanceForViewDto {
    totalCount!: number;
    items!: GetAttendanceForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAttendanceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAttendanceForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAttendanceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAttendanceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAttendanceForViewDto {
    totalCount: number;
    items: GetAttendanceForViewDto[] | undefined;
}

export class CreateAttendanceDto implements ICreateAttendanceDto {
    attendanceDate!: moment.Moment;
    in1!: string | undefined;
    out1!: string | undefined;
    in2!: string | undefined;
    out2!: string | undefined;
    in3!: string | undefined;
    out3!: string | undefined;
    in4!: string | undefined;
    out4!: string | undefined;
    in5!: string | undefined;
    out5!: string | undefined;
    firsthalf!: string | undefined;
    secondhalf!: string | undefined;
    employeeId!: number | undefined;
    latecomingEarlyGoing!: number | undefined;
    remarks!: string | undefined;
    attendanceRemarks!: string | undefined;
    attendanceStatus!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendanceDate = _data["attendanceDate"] ? moment(_data["attendanceDate"].toString()) : <any>undefined;
            this.in1 = _data["in1"];
            this.out1 = _data["out1"];
            this.in2 = _data["in2"];
            this.out2 = _data["out2"];
            this.in3 = _data["in3"];
            this.out3 = _data["out3"];
            this.in4 = _data["in4"];
            this.out4 = _data["out4"];
            this.in5 = _data["in5"];
            this.out5 = _data["out5"];
            this.firsthalf = _data["firsthalf"];
            this.secondhalf = _data["secondhalf"];
            this.employeeId = _data["employeeId"];
            this.latecomingEarlyGoing = _data["latecomingEarlyGoing"];
            this.remarks = _data["remarks"];
            this.attendanceRemarks = _data["attendanceRemarks"];
            this.attendanceStatus = _data["attendanceStatus"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateAttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendanceDate"] = this.attendanceDate ? this.attendanceDate.toISOString() : <any>undefined;
        data["in1"] = this.in1;
        data["out1"] = this.out1;
        data["in2"] = this.in2;
        data["out2"] = this.out2;
        data["in3"] = this.in3;
        data["out3"] = this.out3;
        data["in4"] = this.in4;
        data["out4"] = this.out4;
        data["in5"] = this.in5;
        data["out5"] = this.out5;
        data["firsthalf"] = this.firsthalf;
        data["secondhalf"] = this.secondhalf;
        data["employeeId"] = this.employeeId;
        data["latecomingEarlyGoing"] = this.latecomingEarlyGoing;
        data["remarks"] = this.remarks;
        data["attendanceRemarks"] = this.attendanceRemarks;
        data["attendanceStatus"] = this.attendanceStatus;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateAttendanceDto {
    attendanceDate: moment.Moment;
    in1: string | undefined;
    out1: string | undefined;
    in2: string | undefined;
    out2: string | undefined;
    in3: string | undefined;
    out3: string | undefined;
    in4: string | undefined;
    out4: string | undefined;
    in5: string | undefined;
    out5: string | undefined;
    firsthalf: string | undefined;
    secondhalf: string | undefined;
    employeeId: number | undefined;
    latecomingEarlyGoing: number | undefined;
    remarks: string | undefined;
    attendanceRemarks: string | undefined;
    attendanceStatus: string | undefined;
    id: number | undefined;
}

export class GetAttendanceForEditOutputNew implements IGetAttendanceForEditOutputNew {
    attendance!: CreateAttendanceDto;
    employeeFirstName!: string | undefined;

    constructor(data?: IGetAttendanceForEditOutputNew) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendance = _data["attendance"] ? CreateAttendanceDto.fromJS(_data["attendance"]) : <any>undefined;
            this.employeeFirstName = _data["employeeFirstName"];
        }
    }

    static fromJS(data: any): GetAttendanceForEditOutputNew {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttendanceForEditOutputNew();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendance"] = this.attendance ? this.attendance.toJSON() : <any>undefined;
        data["employeeFirstName"] = this.employeeFirstName;
        return data;
    }
}

export interface IGetAttendanceForEditOutputNew {
    attendance: CreateAttendanceDto;
    employeeFirstName: string | undefined;
}

export class RequestApproval implements IRequestApproval {
    tenantId!: number;
    tenant!: Tenant;
    requestType!: number;
    level!: number | undefined;
    approvalRole!: number | undefined;
    approvalUserId!: number | undefined;
    approvedBy!: number | undefined;
    approvedOn!: moment.Moment | undefined;
    remarks!: string | undefined;
    notficationSend!: boolean;
    isProcessFeed!: boolean;
    requestForApprovalId!: number | undefined;
    requestForApprovalFk!: RequestForApproval;
    rejectedOn!: moment.Moment | undefined;
    reviewedStatus!: number | undefined;
    id!: number;

    constructor(data?: IRequestApproval) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.requestType = _data["requestType"];
            this.level = _data["level"];
            this.approvalRole = _data["approvalRole"];
            this.approvalUserId = _data["approvalUserId"];
            this.approvedBy = _data["approvedBy"];
            this.approvedOn = _data["approvedOn"] ? moment(_data["approvedOn"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
            this.notficationSend = _data["notficationSend"];
            this.isProcessFeed = _data["isProcessFeed"];
            this.requestForApprovalId = _data["requestForApprovalId"];
            this.requestForApprovalFk = _data["requestForApprovalFk"] ? RequestForApproval.fromJS(_data["requestForApprovalFk"]) : <any>undefined;
            this.rejectedOn = _data["rejectedOn"] ? moment(_data["rejectedOn"].toString()) : <any>undefined;
            this.reviewedStatus = _data["reviewedStatus"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RequestApproval {
        data = typeof data === 'object' ? data : {};
        let result = new RequestApproval();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["requestType"] = this.requestType;
        data["level"] = this.level;
        data["approvalRole"] = this.approvalRole;
        data["approvalUserId"] = this.approvalUserId;
        data["approvedBy"] = this.approvedBy;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["notficationSend"] = this.notficationSend;
        data["isProcessFeed"] = this.isProcessFeed;
        data["requestForApprovalId"] = this.requestForApprovalId;
        data["requestForApprovalFk"] = this.requestForApprovalFk ? this.requestForApprovalFk.toJSON() : <any>undefined;
        data["rejectedOn"] = this.rejectedOn ? this.rejectedOn.toISOString() : <any>undefined;
        data["reviewedStatus"] = this.reviewedStatus;
        data["id"] = this.id;
        return data;
    }
}

export interface IRequestApproval {
    tenantId: number;
    tenant: Tenant;
    requestType: number;
    level: number | undefined;
    approvalRole: number | undefined;
    approvalUserId: number | undefined;
    approvedBy: number | undefined;
    approvedOn: moment.Moment | undefined;
    remarks: string | undefined;
    notficationSend: boolean;
    isProcessFeed: boolean;
    requestForApprovalId: number | undefined;
    requestForApprovalFk: RequestForApproval;
    rejectedOn: moment.Moment | undefined;
    reviewedStatus: number | undefined;
    id: number;
}

export class RequestForApproval implements IRequestForApproval {
    tenantId!: number;
    tenant!: Tenant;
    requestDate!: moment.Moment;
    requestBy!: number | undefined;
    requestByFK!: Employee;
    payload!: string | undefined;
    requestTypeId!: number | undefined;
    status!: string | undefined;
    requestApprovals!: RequestApproval[] | undefined;
    level!: number | undefined;
    completed!: boolean;
    id!: number;

    constructor(data?: IRequestForApproval) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.requestDate = _data["requestDate"] ? moment(_data["requestDate"].toString()) : <any>undefined;
            this.requestBy = _data["requestBy"];
            this.requestByFK = _data["requestByFK"] ? Employee.fromJS(_data["requestByFK"]) : <any>undefined;
            this.payload = _data["payload"];
            this.requestTypeId = _data["requestTypeId"];
            this.status = _data["status"];
            if (Array.isArray(_data["requestApprovals"])) {
                this.requestApprovals = [] as any;
                for (let item of _data["requestApprovals"])
                    this.requestApprovals!.push(RequestApproval.fromJS(item));
            }
            this.level = _data["level"];
            this.completed = _data["completed"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RequestForApproval {
        data = typeof data === 'object' ? data : {};
        let result = new RequestForApproval();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["requestBy"] = this.requestBy;
        data["requestByFK"] = this.requestByFK ? this.requestByFK.toJSON() : <any>undefined;
        data["payload"] = this.payload;
        data["requestTypeId"] = this.requestTypeId;
        data["status"] = this.status;
        if (Array.isArray(this.requestApprovals)) {
            data["requestApprovals"] = [];
            for (let item of this.requestApprovals)
                data["requestApprovals"].push(item.toJSON());
        }
        data["level"] = this.level;
        data["completed"] = this.completed;
        data["id"] = this.id;
        return data;
    }
}

export interface IRequestForApproval {
    tenantId: number;
    tenant: Tenant;
    requestDate: moment.Moment;
    requestBy: number | undefined;
    requestByFK: Employee;
    payload: string | undefined;
    requestTypeId: number | undefined;
    status: string | undefined;
    requestApprovals: RequestApproval[] | undefined;
    level: number | undefined;
    completed: boolean;
    id: number;
}

export enum AttendanceStatus {
    All = 0,
    CheckIn = 1,
    Absent = 2,
    HalfDay = 3,
}

export class GetAttendancesForBulkInput implements IGetAttendancesForBulkInput {
    fromdate!: moment.Moment;
    todate!: moment.Moment;
    employeeId!: number;
    departmentId!: number;
    branchId!: number;
    status!: string | undefined;
    isExporttoExecl!: boolean;
    attendanceStatus!: AttendanceStatus;
    sorting!: string | undefined;
    skipCount!: number;
    maxResultCount!: number;

    constructor(data?: IGetAttendancesForBulkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromdate = _data["fromdate"] ? moment(_data["fromdate"].toString()) : <any>undefined;
            this.todate = _data["todate"] ? moment(_data["todate"].toString()) : <any>undefined;
            this.employeeId = _data["employeeId"];
            this.departmentId = _data["departmentId"];
            this.branchId = _data["branchId"];
            this.status = _data["status"];
            this.isExporttoExecl = _data["isExporttoExecl"];
            this.attendanceStatus = _data["attendanceStatus"];
            this.sorting = _data["sorting"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAttendancesForBulkInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttendancesForBulkInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromdate"] = this.fromdate ? this.fromdate.toISOString() : <any>undefined;
        data["todate"] = this.todate ? this.todate.toISOString() : <any>undefined;
        data["employeeId"] = this.employeeId;
        data["departmentId"] = this.departmentId;
        data["branchId"] = this.branchId;
        data["status"] = this.status;
        data["isExporttoExecl"] = this.isExporttoExecl;
        data["attendanceStatus"] = this.attendanceStatus;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAttendancesForBulkInput {
    fromdate: moment.Moment;
    todate: moment.Moment;
    employeeId: number;
    departmentId: number;
    branchId: number;
    status: string | undefined;
    isExporttoExecl: boolean;
    attendanceStatus: AttendanceStatus;
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;
}

export class AttendanceBulkEditResultDto implements IAttendanceBulkEditResultDto {
    items!: GetAttendanceForViewDto[] | undefined;
    totalCount!: number;
    presentCount!: number;
    absentCount!: number;
    holidayCount!: number;
    todayday!: number;
    totalLeave!: number;
    checkedCount!: number;
    weakOffCount!: number;
    halfDayCount!: number;
    totalEmployeee!: number;
    overtime!: string | undefined;
    totalEmployee!: number;

    constructor(data?: IAttendanceBulkEditResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAttendanceForViewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.presentCount = _data["presentCount"];
            this.absentCount = _data["absentCount"];
            this.holidayCount = _data["holidayCount"];
            this.todayday = _data["todayday"];
            this.totalLeave = _data["totalLeave"];
            this.checkedCount = _data["checkedCount"];
            this.weakOffCount = _data["weakOffCount"];
            this.halfDayCount = _data["halfDayCount"];
            this.totalEmployeee = _data["totalEmployeee"];
            this.overtime = _data["overtime"];
            this.totalEmployee = _data["totalEmployee"];
        }
    }

    static fromJS(data: any): AttendanceBulkEditResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceBulkEditResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["presentCount"] = this.presentCount;
        data["absentCount"] = this.absentCount;
        data["holidayCount"] = this.holidayCount;
        data["todayday"] = this.todayday;
        data["totalLeave"] = this.totalLeave;
        data["checkedCount"] = this.checkedCount;
        data["weakOffCount"] = this.weakOffCount;
        data["halfDayCount"] = this.halfDayCount;
        data["totalEmployeee"] = this.totalEmployeee;
        data["overtime"] = this.overtime;
        data["totalEmployee"] = this.totalEmployee;
        return data;
    }
}

export interface IAttendanceBulkEditResultDto {
    items: GetAttendanceForViewDto[] | undefined;
    totalCount: number;
    presentCount: number;
    absentCount: number;
    holidayCount: number;
    todayday: number;
    totalLeave: number;
    checkedCount: number;
    weakOffCount: number;
    halfDayCount: number;
    totalEmployeee: number;
    overtime: string | undefined;
    totalEmployee: number;
}

export class GetTotalAttendanceDto implements IGetTotalAttendanceDto {
    totalPresent!: number;
    totalAbsent!: number;
    totalHoliday!: number;
    totalLeave!: number;
    totalDaysofmonth!: number;
    attendanceGap!: number;
    totalPresentprev!: number;
    totalAbsentprev!: number;
    totalHolidayprev!: number;
    totalLeaveprev!: number;
    totalDaysofmonthprev!: number;

    constructor(data?: IGetTotalAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalPresent = _data["totalPresent"];
            this.totalAbsent = _data["totalAbsent"];
            this.totalHoliday = _data["totalHoliday"];
            this.totalLeave = _data["totalLeave"];
            this.totalDaysofmonth = _data["totalDaysofmonth"];
            this.attendanceGap = _data["attendanceGap"];
            this.totalPresentprev = _data["totalPresentprev"];
            this.totalAbsentprev = _data["totalAbsentprev"];
            this.totalHolidayprev = _data["totalHolidayprev"];
            this.totalLeaveprev = _data["totalLeaveprev"];
            this.totalDaysofmonthprev = _data["totalDaysofmonthprev"];
        }
    }

    static fromJS(data: any): GetTotalAttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTotalAttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPresent"] = this.totalPresent;
        data["totalAbsent"] = this.totalAbsent;
        data["totalHoliday"] = this.totalHoliday;
        data["totalLeave"] = this.totalLeave;
        data["totalDaysofmonth"] = this.totalDaysofmonth;
        data["attendanceGap"] = this.attendanceGap;
        data["totalPresentprev"] = this.totalPresentprev;
        data["totalAbsentprev"] = this.totalAbsentprev;
        data["totalHolidayprev"] = this.totalHolidayprev;
        data["totalLeaveprev"] = this.totalLeaveprev;
        data["totalDaysofmonthprev"] = this.totalDaysofmonthprev;
        return data;
    }
}

export interface IGetTotalAttendanceDto {
    totalPresent: number;
    totalAbsent: number;
    totalHoliday: number;
    totalLeave: number;
    totalDaysofmonth: number;
    attendanceGap: number;
    totalPresentprev: number;
    totalAbsentprev: number;
    totalHolidayprev: number;
    totalLeaveprev: number;
    totalDaysofmonthprev: number;
}

export class MarkAttendanceDto implements IMarkAttendanceDto {
    punchDate!: moment.Moment;
    punchTime!: string;
    machine!: string | undefined;
    location!: string | undefined;
    employeeId!: number;
    inOut!: string | undefined;
    createdBy!: number | undefined;
    locationName!: string | undefined;
    id!: number;

    constructor(data?: IMarkAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.punchDate = _data["punchDate"] ? moment(_data["punchDate"].toString()) : <any>undefined;
            this.punchTime = _data["punchTime"];
            this.machine = _data["machine"];
            this.location = _data["location"];
            this.employeeId = _data["employeeId"];
            this.inOut = _data["inOut"];
            this.createdBy = _data["createdBy"];
            this.locationName = _data["locationName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MarkAttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarkAttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["punchDate"] = this.punchDate ? this.punchDate.toISOString() : <any>undefined;
        data["punchTime"] = this.punchTime;
        data["machine"] = this.machine;
        data["location"] = this.location;
        data["employeeId"] = this.employeeId;
        data["inOut"] = this.inOut;
        data["createdBy"] = this.createdBy;
        data["locationName"] = this.locationName;
        data["id"] = this.id;
        return data;
    }
}

export interface IMarkAttendanceDto {
    punchDate: moment.Moment;
    punchTime: string;
    machine: string | undefined;
    location: string | undefined;
    employeeId: number;
    inOut: string | undefined;
    createdBy: number | undefined;
    locationName: string | undefined;
    id: number;
}

export class GetPunchesForViewDto implements IGetPunchesForViewDto {
    markAttendance!: MarkAttendanceDto;
    employeeFirstName!: string | undefined;
    empCode!: string | undefined;
    isWip!: boolean;

    constructor(data?: IGetPunchesForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.markAttendance = _data["markAttendance"] ? MarkAttendanceDto.fromJS(_data["markAttendance"]) : <any>undefined;
            this.employeeFirstName = _data["employeeFirstName"];
            this.empCode = _data["empCode"];
            this.isWip = _data["isWip"];
        }
    }

    static fromJS(data: any): GetPunchesForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPunchesForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["markAttendance"] = this.markAttendance ? this.markAttendance.toJSON() : <any>undefined;
        data["employeeFirstName"] = this.employeeFirstName;
        data["empCode"] = this.empCode;
        data["isWip"] = this.isWip;
        return data;
    }
}

export interface IGetPunchesForViewDto {
    markAttendance: MarkAttendanceDto;
    employeeFirstName: string | undefined;
    empCode: string | undefined;
    isWip: boolean;
}

export class CreateOrEditAttendanceDto implements ICreateOrEditAttendanceDto {
    attendanceDate!: moment.Moment | undefined;
    in1!: string | undefined;
    out1!: string | undefined;
    in2!: string | undefined;
    out2!: string | undefined;
    in3!: string | undefined;
    out3!: string | undefined;
    in4!: string | undefined;
    out4!: string | undefined;
    in5!: string | undefined;
    out5!: string | undefined;
    firsthalf!: string | undefined;
    secondhalf!: string | undefined;
    employeeId!: number | undefined;
    latecomingEarlyGoing!: number | undefined;
    remarks!: string | undefined;
    attendanceRemarks!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendanceDate = _data["attendanceDate"] ? moment(_data["attendanceDate"].toString()) : <any>undefined;
            this.in1 = _data["in1"];
            this.out1 = _data["out1"];
            this.in2 = _data["in2"];
            this.out2 = _data["out2"];
            this.in3 = _data["in3"];
            this.out3 = _data["out3"];
            this.in4 = _data["in4"];
            this.out4 = _data["out4"];
            this.in5 = _data["in5"];
            this.out5 = _data["out5"];
            this.firsthalf = _data["firsthalf"];
            this.secondhalf = _data["secondhalf"];
            this.employeeId = _data["employeeId"];
            this.latecomingEarlyGoing = _data["latecomingEarlyGoing"];
            this.remarks = _data["remarks"];
            this.attendanceRemarks = _data["attendanceRemarks"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendanceDate"] = this.attendanceDate ? this.attendanceDate.toISOString() : <any>undefined;
        data["in1"] = this.in1;
        data["out1"] = this.out1;
        data["in2"] = this.in2;
        data["out2"] = this.out2;
        data["in3"] = this.in3;
        data["out3"] = this.out3;
        data["in4"] = this.in4;
        data["out4"] = this.out4;
        data["in5"] = this.in5;
        data["out5"] = this.out5;
        data["firsthalf"] = this.firsthalf;
        data["secondhalf"] = this.secondhalf;
        data["employeeId"] = this.employeeId;
        data["latecomingEarlyGoing"] = this.latecomingEarlyGoing;
        data["remarks"] = this.remarks;
        data["attendanceRemarks"] = this.attendanceRemarks;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditAttendanceDto {
    attendanceDate: moment.Moment | undefined;
    in1: string | undefined;
    out1: string | undefined;
    in2: string | undefined;
    out2: string | undefined;
    in3: string | undefined;
    out3: string | undefined;
    in4: string | undefined;
    out4: string | undefined;
    in5: string | undefined;
    out5: string | undefined;
    firsthalf: string | undefined;
    secondhalf: string | undefined;
    employeeId: number | undefined;
    latecomingEarlyGoing: number | undefined;
    remarks: string | undefined;
    attendanceRemarks: string | undefined;
    id: number | undefined;
}

export class GetAttendanceForEditOutput implements IGetAttendanceForEditOutput {
    attendance!: CreateOrEditAttendanceDto;
    employeeFirstName!: string | undefined;

    constructor(data?: IGetAttendanceForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendance = _data["attendance"] ? CreateOrEditAttendanceDto.fromJS(_data["attendance"]) : <any>undefined;
            this.employeeFirstName = _data["employeeFirstName"];
        }
    }

    static fromJS(data: any): GetAttendanceForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttendanceForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendance"] = this.attendance ? this.attendance.toJSON() : <any>undefined;
        data["employeeFirstName"] = this.employeeFirstName;
        return data;
    }
}

export interface IGetAttendanceForEditOutput {
    attendance: CreateOrEditAttendanceDto;
    employeeFirstName: string | undefined;
}

export class AttendanceEmployeeLookupTableDto implements IAttendanceEmployeeLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IAttendanceEmployeeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): AttendanceEmployeeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceEmployeeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IAttendanceEmployeeLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class AttandanceList implements IAttandanceList {
    attandaceDate!: moment.Moment;
    employeeCode!: string | undefined;
    machine!: string | undefined;
    punchTime!: string | undefined;

    constructor(data?: IAttandanceList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attandaceDate = _data["attandaceDate"] ? moment(_data["attandaceDate"].toString()) : <any>undefined;
            this.employeeCode = _data["employeeCode"];
            this.machine = _data["machine"];
            this.punchTime = _data["punchTime"];
        }
    }

    static fromJS(data: any): AttandanceList {
        data = typeof data === 'object' ? data : {};
        let result = new AttandanceList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attandaceDate"] = this.attandaceDate ? this.attandaceDate.format('YYYY-MM-DD') : <any>undefined;
        data["employeeCode"] = this.employeeCode;
        data["machine"] = this.machine;
        data["punchTime"] = this.punchTime;
        return data;
    }
}

export interface IAttandanceList {
    attandaceDate: moment.Moment;
    employeeCode: string | undefined;
    machine: string | undefined;
    punchTime: string | undefined;
}

export class AttandanceListForAttandance implements IAttandanceListForAttandance {
    attandaceDate!: moment.Moment;
    employeeCode!: string | undefined;
    in1Time!: string | undefined;
    out1Time!: string | undefined;
    in2Time!: string | undefined;
    out2Time!: string | undefined;
    in3Time!: string | undefined;
    out3Time!: string | undefined;
    in4Time!: string | undefined;
    out4Time!: string | undefined;
    in5Time!: string | undefined;
    out5Time!: string | undefined;
    attendanceStatus!: string | undefined;

    constructor(data?: IAttandanceListForAttandance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attandaceDate = _data["attandaceDate"] ? moment(_data["attandaceDate"].toString()) : <any>undefined;
            this.employeeCode = _data["employeeCode"];
            this.in1Time = _data["in1Time"];
            this.out1Time = _data["out1Time"];
            this.in2Time = _data["in2Time"];
            this.out2Time = _data["out2Time"];
            this.in3Time = _data["in3Time"];
            this.out3Time = _data["out3Time"];
            this.in4Time = _data["in4Time"];
            this.out4Time = _data["out4Time"];
            this.in5Time = _data["in5Time"];
            this.out5Time = _data["out5Time"];
            this.attendanceStatus = _data["attendanceStatus"];
        }
    }

    static fromJS(data: any): AttandanceListForAttandance {
        data = typeof data === 'object' ? data : {};
        let result = new AttandanceListForAttandance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attandaceDate"] = this.attandaceDate ? this.attandaceDate.format('YYYY-MM-DD') : <any>undefined;
        data["employeeCode"] = this.employeeCode;
        data["in1Time"] = this.in1Time;
        data["out1Time"] = this.out1Time;
        data["in2Time"] = this.in2Time;
        data["out2Time"] = this.out2Time;
        data["in3Time"] = this.in3Time;
        data["out3Time"] = this.out3Time;
        data["in4Time"] = this.in4Time;
        data["out4Time"] = this.out4Time;
        data["in5Time"] = this.in5Time;
        data["out5Time"] = this.out5Time;
        data["attendanceStatus"] = this.attendanceStatus;
        return data;
    }
}

export interface IAttandanceListForAttandance {
    attandaceDate: moment.Moment;
    employeeCode: string | undefined;
    in1Time: string | undefined;
    out1Time: string | undefined;
    in2Time: string | undefined;
    out2Time: string | undefined;
    in3Time: string | undefined;
    out3Time: string | undefined;
    in4Time: string | undefined;
    out4Time: string | undefined;
    in5Time: string | undefined;
    out5Time: string | undefined;
    attendanceStatus: string | undefined;
}

export class PortList implements IPortList {
    name!: string | undefined;
    attandanceList!: AttandanceList[] | undefined;
    attandanceListForAttandance!: AttandanceListForAttandance[] | undefined;
    id!: number | undefined;

    constructor(data?: IPortList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["attandanceList"])) {
                this.attandanceList = [] as any;
                for (let item of _data["attandanceList"])
                    this.attandanceList!.push(AttandanceList.fromJS(item));
            }
            if (Array.isArray(_data["attandanceListForAttandance"])) {
                this.attandanceListForAttandance = [] as any;
                for (let item of _data["attandanceListForAttandance"])
                    this.attandanceListForAttandance!.push(AttandanceListForAttandance.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PortList {
        data = typeof data === 'object' ? data : {};
        let result = new PortList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.attandanceList)) {
            data["attandanceList"] = [];
            for (let item of this.attandanceList)
                data["attandanceList"].push(item.toJSON());
        }
        if (Array.isArray(this.attandanceListForAttandance)) {
            data["attandanceListForAttandance"] = [];
            for (let item of this.attandanceListForAttandance)
                data["attandanceListForAttandance"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IPortList {
    name: string | undefined;
    attandanceList: AttandanceList[] | undefined;
    attandanceListForAttandance: AttandanceListForAttandance[] | undefined;
    id: number | undefined;
}

export class AttandanceAlreadyExits implements IAttandanceAlreadyExits {
    attandaceDate!: moment.Moment;
    employeeCode!: string | undefined;
    message!: string | undefined;

    constructor(data?: IAttandanceAlreadyExits) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attandaceDate = _data["attandaceDate"] ? moment(_data["attandaceDate"].toString()) : <any>undefined;
            this.employeeCode = _data["employeeCode"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): AttandanceAlreadyExits {
        data = typeof data === 'object' ? data : {};
        let result = new AttandanceAlreadyExits();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attandaceDate"] = this.attandaceDate ? this.attandaceDate.toISOString() : <any>undefined;
        data["employeeCode"] = this.employeeCode;
        data["message"] = this.message;
        return data;
    }
}

export interface IAttandanceAlreadyExits {
    attandaceDate: moment.Moment;
    employeeCode: string | undefined;
    message: string | undefined;
}

export class WorkingHoursDto implements IWorkingHoursDto {
    hours!: string;
    isTimerRunning!: boolean;

    constructor(data?: IWorkingHoursDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hours = _data["hours"];
            this.isTimerRunning = _data["isTimerRunning"];
        }
    }

    static fromJS(data: any): WorkingHoursDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkingHoursDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hours"] = this.hours;
        data["isTimerRunning"] = this.isTimerRunning;
        return data;
    }
}

export interface IWorkingHoursDto {
    hours: string;
    isTimerRunning: boolean;
}

export class PunchesDto implements IPunchesDto {
    in!: string | undefined;
    out!: string | undefined;

    constructor(data?: IPunchesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.in = _data["in"];
            this.out = _data["out"];
        }
    }

    static fromJS(data: any): PunchesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PunchesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["in"] = this.in;
        data["out"] = this.out;
        return data;
    }
}

export interface IPunchesDto {
    in: string | undefined;
    out: string | undefined;
}

export class BiometricMasterDto implements IBiometricMasterDto {
    id!: number | undefined;
    devieName!: string | undefined;
    direction!: string | undefined;
    machineLoocation!: string | undefined;
    ipAddress!: string | undefined;

    constructor(data?: IBiometricMasterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.devieName = _data["devieName"];
            this.direction = _data["direction"];
            this.machineLoocation = _data["machineLoocation"];
            this.ipAddress = _data["ipAddress"];
        }
    }

    static fromJS(data: any): BiometricMasterDto {
        data = typeof data === 'object' ? data : {};
        let result = new BiometricMasterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["devieName"] = this.devieName;
        data["direction"] = this.direction;
        data["machineLoocation"] = this.machineLoocation;
        data["ipAddress"] = this.ipAddress;
        return data;
    }
}

export interface IBiometricMasterDto {
    id: number | undefined;
    devieName: string | undefined;
    direction: string | undefined;
    machineLoocation: string | undefined;
    ipAddress: string | undefined;
}

export class AuditLogListDto implements IAuditLogListDto {
    userId!: number | undefined;
    userName!: string | undefined;
    impersonatorTenantId!: number | undefined;
    impersonatorUserId!: number | undefined;
    serviceName!: string | undefined;
    methodName!: string | undefined;
    parameters!: string | undefined;
    executionTime!: moment.Moment;
    executionDuration!: number;
    clientIpAddress!: string | undefined;
    clientName!: string | undefined;
    browserInfo!: string | undefined;
    exception!: string | undefined;
    customData!: string | undefined;
    id!: number;

    constructor(data?: IAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.impersonatorTenantId = _data["impersonatorTenantId"];
            this.impersonatorUserId = _data["impersonatorUserId"];
            this.serviceName = _data["serviceName"];
            this.methodName = _data["methodName"];
            this.parameters = _data["parameters"];
            this.executionTime = _data["executionTime"] ? moment(_data["executionTime"].toString()) : <any>undefined;
            this.executionDuration = _data["executionDuration"];
            this.clientIpAddress = _data["clientIpAddress"];
            this.clientName = _data["clientName"];
            this.browserInfo = _data["browserInfo"];
            this.exception = _data["exception"];
            this.customData = _data["customData"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["parameters"] = this.parameters;
        data["executionTime"] = this.executionTime ? this.executionTime.toISOString() : <any>undefined;
        data["executionDuration"] = this.executionDuration;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["exception"] = this.exception;
        data["customData"] = this.customData;
        data["id"] = this.id;
        return data;
    }
}

export interface IAuditLogListDto {
    userId: number | undefined;
    userName: string | undefined;
    impersonatorTenantId: number | undefined;
    impersonatorUserId: number | undefined;
    serviceName: string | undefined;
    methodName: string | undefined;
    parameters: string | undefined;
    executionTime: moment.Moment;
    executionDuration: number;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    exception: string | undefined;
    customData: string | undefined;
    id: number;
}

export class PagedResultDtoOfAuditLogListDto implements IPagedResultDtoOfAuditLogListDto {
    totalCount!: number;
    items!: AuditLogListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AuditLogListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfAuditLogListDto {
    totalCount: number;
    items: AuditLogListDto[] | undefined;
}

export class NameValueDto implements INameValueDto {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValueDto {
    name: string | undefined;
    value: string | undefined;
}

export enum EntityChangeType {
    Created = 0,
    Updated = 1,
    Deleted = 2,
}

export class EntityChangeListDto implements IEntityChangeListDto {
    userId!: number | undefined;
    userName!: string | undefined;
    changeTime!: moment.Moment;
    entityTypeFullName!: string | undefined;
    changeType!: EntityChangeType;
    readonly changeTypeName!: string | undefined;
    entityChangeSetId!: number;
    id!: number;

    constructor(data?: IEntityChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.changeTime = _data["changeTime"] ? moment(_data["changeTime"].toString()) : <any>undefined;
            this.entityTypeFullName = _data["entityTypeFullName"];
            this.changeType = _data["changeType"];
            (<any>this).changeTypeName = _data["changeTypeName"];
            this.entityChangeSetId = _data["entityChangeSetId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["changeTime"] = this.changeTime ? this.changeTime.toISOString() : <any>undefined;
        data["entityTypeFullName"] = this.entityTypeFullName;
        data["changeType"] = this.changeType;
        data["changeTypeName"] = this.changeTypeName;
        data["entityChangeSetId"] = this.entityChangeSetId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityChangeListDto {
    userId: number | undefined;
    userName: string | undefined;
    changeTime: moment.Moment;
    entityTypeFullName: string | undefined;
    changeType: EntityChangeType;
    changeTypeName: string | undefined;
    entityChangeSetId: number;
    id: number;
}

export class PagedResultDtoOfEntityChangeListDto implements IPagedResultDtoOfEntityChangeListDto {
    totalCount!: number;
    items!: EntityChangeListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfEntityChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EntityChangeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEntityChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEntityChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfEntityChangeListDto {
    totalCount: number;
    items: EntityChangeListDto[] | undefined;
}

export class EntityPropertyChangeDto implements IEntityPropertyChangeDto {
    entityChangeId!: number;
    newValue!: string | undefined;
    originalValue!: string | undefined;
    propertyName!: string | undefined;
    propertyTypeFullName!: string | undefined;
    tenantId!: number | undefined;
    id!: number;

    constructor(data?: IEntityPropertyChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityChangeId = _data["entityChangeId"];
            this.newValue = _data["newValue"];
            this.originalValue = _data["originalValue"];
            this.propertyName = _data["propertyName"];
            this.propertyTypeFullName = _data["propertyTypeFullName"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityPropertyChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityPropertyChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityChangeId"] = this.entityChangeId;
        data["newValue"] = this.newValue;
        data["originalValue"] = this.originalValue;
        data["propertyName"] = this.propertyName;
        data["propertyTypeFullName"] = this.propertyTypeFullName;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityPropertyChangeDto {
    entityChangeId: number;
    newValue: string | undefined;
    originalValue: string | undefined;
    propertyName: string | undefined;
    propertyTypeFullName: string | undefined;
    tenantId: number | undefined;
    id: number;
}

export enum WorkflowRequestType {
    AdvanceRequest = 1,
    AttendanceCorrection = 2,
    LeaveRequest = 3,
    OnDuty = 4,
    UpdateDetails = 5,
    JobOpening = 6,
    Expense = 7,
    SeparationRequest = 8,
    TimeSheetActivity = 9,
    IncrementRequest = 10,
    ComoffLeave = 11,
    ShortLeave = 12,
    Arrears = 13,
    AssetConfirmation = 14,
}

export class RoleClaim implements IRoleClaim {
    tenantId!: number | undefined;
    roleId!: number;
    claimType!: string | undefined;
    claimValue!: string | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IRoleClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.roleId = _data["roleId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleClaim {
        data = typeof data === 'object' ? data : {};
        let result = new RoleClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["roleId"] = this.roleId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IRoleClaim {
    tenantId: number | undefined;
    roleId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class RolePermissionSetting implements IRolePermissionSetting {
    roleId!: number;
    tenantId!: number | undefined;
    name!: string;
    isGranted!: boolean;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IRolePermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isGranted = _data["isGranted"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RolePermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new RolePermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IRolePermissionSetting {
    roleId: number;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Role implements IRole {
    normalizedName!: string;
    claims!: RoleClaim[] | undefined;
    concurrencyStamp!: string | undefined;
    deleterUser!: User;
    creatorUser!: User;
    lastModifierUser!: User;
    tenantId!: number | undefined;
    name!: string;
    displayName!: string;
    isStatic!: boolean;
    isDefault!: boolean;
    permissions!: RolePermissionSetting[] | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.normalizedName = _data["normalizedName"];
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(RoleClaim.fromJS(item));
            }
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(RolePermissionSetting.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["normalizedName"] = this.normalizedName;
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IRole {
    normalizedName: string;
    claims: RoleClaim[] | undefined;
    concurrencyStamp: string | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    tenantId: number | undefined;
    name: string;
    displayName: string;
    isStatic: boolean;
    isDefault: boolean;
    permissions: RolePermissionSetting[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class WorkflowStep implements IWorkflowStep {
    level!: number;
    intimationOnly!: boolean;
    turnAroundTime!: number;
    role!: Role;
    hierarchy!: number | undefined;

    constructor(data?: IWorkflowStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.level = _data["level"];
            this.intimationOnly = _data["intimationOnly"];
            this.turnAroundTime = _data["turnAroundTime"];
            this.role = _data["role"] ? Role.fromJS(_data["role"]) : <any>undefined;
            this.hierarchy = _data["hierarchy"];
        }
    }

    static fromJS(data: any): WorkflowStep {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["intimationOnly"] = this.intimationOnly;
        data["turnAroundTime"] = this.turnAroundTime;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        data["hierarchy"] = this.hierarchy;
        return data;
    }
}

export interface IWorkflowStep {
    level: number;
    intimationOnly: boolean;
    turnAroundTime: number;
    role: Role;
    hierarchy: number | undefined;
}

export class Workflow implements IWorkflow {
    tenantId!: number;
    tenant!: Tenant;
    readonly name!: string | undefined;
    readonly description!: string | undefined;
    type!: WorkflowRequestType;
    creatorUserId!: number | undefined;
    creationTime!: moment.Moment;
    lastModifierUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    readonly steps!: WorkflowStep[] | undefined;
    id!: number;

    constructor(data?: IWorkflow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            (<any>this).name = _data["name"];
            (<any>this).description = _data["description"];
            this.type = _data["type"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["steps"])) {
                (<any>this).steps = [] as any;
                for (let item of _data["steps"])
                    (<any>this).steps!.push(WorkflowStep.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Workflow {
        data = typeof data === 'object' ? data : {};
        let result = new Workflow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["type"] = this.type;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IWorkflow {
    tenantId: number;
    tenant: Tenant;
    name: string | undefined;
    description: string | undefined;
    type: WorkflowRequestType;
    creatorUserId: number | undefined;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    steps: WorkflowStep[] | undefined;
    id: number;
}

export class BankBranchDetailsDto implements IBankBranchDetailsDto {
    branchName!: string | undefined;
    ifsccode!: string | undefined;
    micrCode!: string | undefined;
    iBanNo!: string | undefined;
    location!: string | undefined;
    address!: string | undefined;
    bankBranchId!: number | undefined;
    id!: number;

    constructor(data?: IBankBranchDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchName = _data["branchName"];
            this.ifsccode = _data["ifsccode"];
            this.micrCode = _data["micrCode"];
            this.iBanNo = _data["iBanNo"];
            this.location = _data["location"];
            this.address = _data["address"];
            this.bankBranchId = _data["bankBranchId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BankBranchDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankBranchDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchName"] = this.branchName;
        data["ifsccode"] = this.ifsccode;
        data["micrCode"] = this.micrCode;
        data["iBanNo"] = this.iBanNo;
        data["location"] = this.location;
        data["address"] = this.address;
        data["bankBranchId"] = this.bankBranchId;
        data["id"] = this.id;
        return data;
    }
}

export interface IBankBranchDetailsDto {
    branchName: string | undefined;
    ifsccode: string | undefined;
    micrCode: string | undefined;
    iBanNo: string | undefined;
    location: string | undefined;
    address: string | undefined;
    bankBranchId: number | undefined;
    id: number;
}

export class GetBankBranchDetailsForViewDto implements IGetBankBranchDetailsForViewDto {
    bankBranchDetails!: BankBranchDetailsDto;
    bankBranchBankName!: string | undefined;

    constructor(data?: IGetBankBranchDetailsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankBranchDetails = _data["bankBranchDetails"] ? BankBranchDetailsDto.fromJS(_data["bankBranchDetails"]) : <any>undefined;
            this.bankBranchBankName = _data["bankBranchBankName"];
        }
    }

    static fromJS(data: any): GetBankBranchDetailsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBankBranchDetailsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankBranchDetails"] = this.bankBranchDetails ? this.bankBranchDetails.toJSON() : <any>undefined;
        data["bankBranchBankName"] = this.bankBranchBankName;
        return data;
    }
}

export interface IGetBankBranchDetailsForViewDto {
    bankBranchDetails: BankBranchDetailsDto;
    bankBranchBankName: string | undefined;
}

export class PagedResultDtoOfGetBankBranchDetailsForViewDto implements IPagedResultDtoOfGetBankBranchDetailsForViewDto {
    totalCount!: number;
    items!: GetBankBranchDetailsForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBankBranchDetailsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetBankBranchDetailsForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBankBranchDetailsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBankBranchDetailsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetBankBranchDetailsForViewDto {
    totalCount: number;
    items: GetBankBranchDetailsForViewDto[] | undefined;
}

export class CreateOrEditBankBranchDetailsDto implements ICreateOrEditBankBranchDetailsDto {
    branchName!: string | undefined;
    ifsccode!: string | undefined;
    micrCode!: string | undefined;
    iBanNo!: string | undefined;
    location!: string | undefined;
    address!: string | undefined;
    bankBranchId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditBankBranchDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchName = _data["branchName"];
            this.ifsccode = _data["ifsccode"];
            this.micrCode = _data["micrCode"];
            this.iBanNo = _data["iBanNo"];
            this.location = _data["location"];
            this.address = _data["address"];
            this.bankBranchId = _data["bankBranchId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditBankBranchDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBankBranchDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchName"] = this.branchName;
        data["ifsccode"] = this.ifsccode;
        data["micrCode"] = this.micrCode;
        data["iBanNo"] = this.iBanNo;
        data["location"] = this.location;
        data["address"] = this.address;
        data["bankBranchId"] = this.bankBranchId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditBankBranchDetailsDto {
    branchName: string | undefined;
    ifsccode: string | undefined;
    micrCode: string | undefined;
    iBanNo: string | undefined;
    location: string | undefined;
    address: string | undefined;
    bankBranchId: number | undefined;
    id: number | undefined;
}

export class GetBankBranchDetailsForEditOutput implements IGetBankBranchDetailsForEditOutput {
    bankBranchDetails!: CreateOrEditBankBranchDetailsDto;
    bankBranchBankName!: string | undefined;

    constructor(data?: IGetBankBranchDetailsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankBranchDetails = _data["bankBranchDetails"] ? CreateOrEditBankBranchDetailsDto.fromJS(_data["bankBranchDetails"]) : <any>undefined;
            this.bankBranchBankName = _data["bankBranchBankName"];
        }
    }

    static fromJS(data: any): GetBankBranchDetailsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBankBranchDetailsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankBranchDetails"] = this.bankBranchDetails ? this.bankBranchDetails.toJSON() : <any>undefined;
        data["bankBranchBankName"] = this.bankBranchBankName;
        return data;
    }
}

export interface IGetBankBranchDetailsForEditOutput {
    bankBranchDetails: CreateOrEditBankBranchDetailsDto;
    bankBranchBankName: string | undefined;
}

export class BankBranchDetailsBankBranchLookupTableDto implements IBankBranchDetailsBankBranchLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IBankBranchDetailsBankBranchLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): BankBranchDetailsBankBranchLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankBranchDetailsBankBranchLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IBankBranchDetailsBankBranchLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class BankBranchDto implements IBankBranchDto {
    bankName!: string | undefined;
    shortName!: string | undefined;
    address!: string | undefined;
    id!: number;

    constructor(data?: IBankBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankName = _data["bankName"];
            this.shortName = _data["shortName"];
            this.address = _data["address"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BankBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankName"] = this.bankName;
        data["shortName"] = this.shortName;
        data["address"] = this.address;
        data["id"] = this.id;
        return data;
    }
}

export interface IBankBranchDto {
    bankName: string | undefined;
    shortName: string | undefined;
    address: string | undefined;
    id: number;
}

export class GetBankBranchForViewDto implements IGetBankBranchForViewDto {
    bankBranch!: BankBranchDto;

    constructor(data?: IGetBankBranchForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankBranch = _data["bankBranch"] ? BankBranchDto.fromJS(_data["bankBranch"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBankBranchForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBankBranchForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankBranch"] = this.bankBranch ? this.bankBranch.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetBankBranchForViewDto {
    bankBranch: BankBranchDto;
}

export class PagedResultDtoOfGetBankBranchForViewDto implements IPagedResultDtoOfGetBankBranchForViewDto {
    totalCount!: number;
    items!: GetBankBranchForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBankBranchForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetBankBranchForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBankBranchForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBankBranchForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetBankBranchForViewDto {
    totalCount: number;
    items: GetBankBranchForViewDto[] | undefined;
}

export class CreateOrEditBankBranchDto implements ICreateOrEditBankBranchDto {
    bankName!: string | undefined;
    shortName!: string | undefined;
    address!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditBankBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankName = _data["bankName"];
            this.shortName = _data["shortName"];
            this.address = _data["address"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditBankBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBankBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankName"] = this.bankName;
        data["shortName"] = this.shortName;
        data["address"] = this.address;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditBankBranchDto {
    bankName: string | undefined;
    shortName: string | undefined;
    address: string | undefined;
    id: number | undefined;
}

export class GetBankBranchForEditOutput implements IGetBankBranchForEditOutput {
    bankBranch!: CreateOrEditBankBranchDto;

    constructor(data?: IGetBankBranchForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankBranch = _data["bankBranch"] ? CreateOrEditBankBranchDto.fromJS(_data["bankBranch"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBankBranchForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBankBranchForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankBranch"] = this.bankBranch ? this.bankBranch.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetBankBranchForEditOutput {
    bankBranch: CreateOrEditBankBranchDto;
}

export class BirthdayWishesSettingDto implements IBirthdayWishesSettingDto {
    tenantId!: number;
    pastNoOfDays!: number;
    futureNoOfDays!: number;
    branch!: number;
    bithdayWiseMail!: string | undefined;
    birthdayWishWhatsApp!: string | undefined;
    workAnniversaryWishWhatsApp!: string | undefined;
    marriageAnniversaryWishWhatsApp!: string | undefined;

    constructor(data?: IBirthdayWishesSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.pastNoOfDays = _data["pastNoOfDays"];
            this.futureNoOfDays = _data["futureNoOfDays"];
            this.branch = _data["branch"];
            this.bithdayWiseMail = _data["bithdayWiseMail"];
            this.birthdayWishWhatsApp = _data["birthdayWishWhatsApp"];
            this.workAnniversaryWishWhatsApp = _data["workAnniversaryWishWhatsApp"];
            this.marriageAnniversaryWishWhatsApp = _data["marriageAnniversaryWishWhatsApp"];
        }
    }

    static fromJS(data: any): BirthdayWishesSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new BirthdayWishesSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["pastNoOfDays"] = this.pastNoOfDays;
        data["futureNoOfDays"] = this.futureNoOfDays;
        data["branch"] = this.branch;
        data["bithdayWiseMail"] = this.bithdayWiseMail;
        data["birthdayWishWhatsApp"] = this.birthdayWishWhatsApp;
        data["workAnniversaryWishWhatsApp"] = this.workAnniversaryWishWhatsApp;
        data["marriageAnniversaryWishWhatsApp"] = this.marriageAnniversaryWishWhatsApp;
        return data;
    }
}

export interface IBirthdayWishesSettingDto {
    tenantId: number;
    pastNoOfDays: number;
    futureNoOfDays: number;
    branch: number;
    bithdayWiseMail: string | undefined;
    birthdayWishWhatsApp: string | undefined;
    workAnniversaryWishWhatsApp: string | undefined;
    marriageAnniversaryWishWhatsApp: string | undefined;
}

export class NewHiresSettingDto implements INewHiresSettingDto {
    tenantId!: number;
    branch1!: number;

    constructor(data?: INewHiresSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.branch1 = _data["branch1"];
        }
    }

    static fromJS(data: any): NewHiresSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewHiresSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["branch1"] = this.branch1;
        return data;
    }
}

export interface INewHiresSettingDto {
    tenantId: number;
    branch1: number;
}

export class CacheDto implements ICacheDto {
    name!: string | undefined;

    constructor(data?: ICacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new CacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICacheDto {
    name: string | undefined;
}

export class ListResultDtoOfCacheDto implements IListResultDtoOfCacheDto {
    items!: CacheDto[] | undefined;

    constructor(data?: IListResultDtoOfCacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CacheDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfCacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfCacheDto {
    items: CacheDto[] | undefined;
}

export class EntityDtoOfString implements IEntityDtoOfString {
    id!: string | undefined;

    constructor(data?: IEntityDtoOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfString {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfString {
    id: string | undefined;
}

export class CandidateDocumnetsDto implements ICandidateDocumnetsDto {
    documentTypeId!: number;
    name!: string | undefined;
    documentUrl!: string | undefined;
    remarks!: string | undefined;
    candidateId!: number | undefined;
    id!: number;

    constructor(data?: ICandidateDocumnetsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentTypeId = _data["documentTypeId"];
            this.name = _data["name"];
            this.documentUrl = _data["documentUrl"];
            this.remarks = _data["remarks"];
            this.candidateId = _data["candidateId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CandidateDocumnetsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidateDocumnetsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentTypeId"] = this.documentTypeId;
        data["name"] = this.name;
        data["documentUrl"] = this.documentUrl;
        data["remarks"] = this.remarks;
        data["candidateId"] = this.candidateId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICandidateDocumnetsDto {
    documentTypeId: number;
    name: string | undefined;
    documentUrl: string | undefined;
    remarks: string | undefined;
    candidateId: number | undefined;
    id: number;
}

export class GetCandidateDocumnetsForViewDto implements IGetCandidateDocumnetsForViewDto {
    candidateDocumnets!: CandidateDocumnetsDto;
    candidateName!: string | undefined;

    constructor(data?: IGetCandidateDocumnetsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidateDocumnets = _data["candidateDocumnets"] ? CandidateDocumnetsDto.fromJS(_data["candidateDocumnets"]) : <any>undefined;
            this.candidateName = _data["candidateName"];
        }
    }

    static fromJS(data: any): GetCandidateDocumnetsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCandidateDocumnetsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidateDocumnets"] = this.candidateDocumnets ? this.candidateDocumnets.toJSON() : <any>undefined;
        data["candidateName"] = this.candidateName;
        return data;
    }
}

export interface IGetCandidateDocumnetsForViewDto {
    candidateDocumnets: CandidateDocumnetsDto;
    candidateName: string | undefined;
}

export class PagedResultDtoOfGetCandidateDocumnetsForViewDto implements IPagedResultDtoOfGetCandidateDocumnetsForViewDto {
    totalCount!: number;
    items!: GetCandidateDocumnetsForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCandidateDocumnetsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetCandidateDocumnetsForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCandidateDocumnetsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCandidateDocumnetsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCandidateDocumnetsForViewDto {
    totalCount: number;
    items: GetCandidateDocumnetsForViewDto[] | undefined;
}

export class CreateOrEditCandidateDocumnetsDto implements ICreateOrEditCandidateDocumnetsDto {
    documentTypeId!: number;
    name!: string | undefined;
    documentUrl!: string | undefined;
    remarks!: string | undefined;
    candidateId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCandidateDocumnetsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentTypeId = _data["documentTypeId"];
            this.name = _data["name"];
            this.documentUrl = _data["documentUrl"];
            this.remarks = _data["remarks"];
            this.candidateId = _data["candidateId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCandidateDocumnetsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCandidateDocumnetsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentTypeId"] = this.documentTypeId;
        data["name"] = this.name;
        data["documentUrl"] = this.documentUrl;
        data["remarks"] = this.remarks;
        data["candidateId"] = this.candidateId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCandidateDocumnetsDto {
    documentTypeId: number;
    name: string | undefined;
    documentUrl: string | undefined;
    remarks: string | undefined;
    candidateId: number | undefined;
    id: number | undefined;
}

export class GetCandidateDocumnetsForEditOutput implements IGetCandidateDocumnetsForEditOutput {
    candidateDocumnets!: CreateOrEditCandidateDocumnetsDto;
    candidateName!: string | undefined;

    constructor(data?: IGetCandidateDocumnetsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidateDocumnets = _data["candidateDocumnets"] ? CreateOrEditCandidateDocumnetsDto.fromJS(_data["candidateDocumnets"]) : <any>undefined;
            this.candidateName = _data["candidateName"];
        }
    }

    static fromJS(data: any): GetCandidateDocumnetsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCandidateDocumnetsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidateDocumnets"] = this.candidateDocumnets ? this.candidateDocumnets.toJSON() : <any>undefined;
        data["candidateName"] = this.candidateName;
        return data;
    }
}

export interface IGetCandidateDocumnetsForEditOutput {
    candidateDocumnets: CreateOrEditCandidateDocumnetsDto;
    candidateName: string | undefined;
}

export class CandidateDocumnetsCandidateLookupTableDto implements ICandidateDocumnetsCandidateLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICandidateDocumnetsCandidateLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): CandidateDocumnetsCandidateLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidateDocumnetsCandidateLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICandidateDocumnetsCandidateLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class CandidateinterviewDetailsDto implements ICandidateinterviewDetailsDto {
    roundId!: number;
    interviwerId!: number | undefined;
    interviwerDate!: moment.Moment | undefined;
    feedback!: string | undefined;
    status!: string | undefined;
    candidateId!: number | undefined;
    id!: number;

    constructor(data?: ICandidateinterviewDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roundId = _data["roundId"];
            this.interviwerId = _data["interviwerId"];
            this.interviwerDate = _data["interviwerDate"] ? moment(_data["interviwerDate"].toString()) : <any>undefined;
            this.feedback = _data["feedback"];
            this.status = _data["status"];
            this.candidateId = _data["candidateId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CandidateinterviewDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidateinterviewDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roundId"] = this.roundId;
        data["interviwerId"] = this.interviwerId;
        data["interviwerDate"] = this.interviwerDate ? this.interviwerDate.toISOString() : <any>undefined;
        data["feedback"] = this.feedback;
        data["status"] = this.status;
        data["candidateId"] = this.candidateId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICandidateinterviewDetailsDto {
    roundId: number;
    interviwerId: number | undefined;
    interviwerDate: moment.Moment | undefined;
    feedback: string | undefined;
    status: string | undefined;
    candidateId: number | undefined;
    id: number;
}

export class GetCandidateinterviewDetailsForViewDto implements IGetCandidateinterviewDetailsForViewDto {
    candidateinterviewDetails!: CandidateinterviewDetailsDto;
    candidateName!: string | undefined;
    round!: string | undefined;
    jobTittle!: string | undefined;
    interviewer!: string | undefined;

    constructor(data?: IGetCandidateinterviewDetailsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidateinterviewDetails = _data["candidateinterviewDetails"] ? CandidateinterviewDetailsDto.fromJS(_data["candidateinterviewDetails"]) : <any>undefined;
            this.candidateName = _data["candidateName"];
            this.round = _data["round"];
            this.jobTittle = _data["jobTittle"];
            this.interviewer = _data["interviewer"];
        }
    }

    static fromJS(data: any): GetCandidateinterviewDetailsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCandidateinterviewDetailsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidateinterviewDetails"] = this.candidateinterviewDetails ? this.candidateinterviewDetails.toJSON() : <any>undefined;
        data["candidateName"] = this.candidateName;
        data["round"] = this.round;
        data["jobTittle"] = this.jobTittle;
        data["interviewer"] = this.interviewer;
        return data;
    }
}

export interface IGetCandidateinterviewDetailsForViewDto {
    candidateinterviewDetails: CandidateinterviewDetailsDto;
    candidateName: string | undefined;
    round: string | undefined;
    jobTittle: string | undefined;
    interviewer: string | undefined;
}

export class PagedResultDtoOfGetCandidateinterviewDetailsForViewDto implements IPagedResultDtoOfGetCandidateinterviewDetailsForViewDto {
    totalCount!: number;
    items!: GetCandidateinterviewDetailsForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCandidateinterviewDetailsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetCandidateinterviewDetailsForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCandidateinterviewDetailsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCandidateinterviewDetailsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCandidateinterviewDetailsForViewDto {
    totalCount: number;
    items: GetCandidateinterviewDetailsForViewDto[] | undefined;
}

export class CreateOrEditCandidateinterviewDetailsDto implements ICreateOrEditCandidateinterviewDetailsDto {
    roundId!: number;
    interviwerId!: number | undefined;
    interviwerDate!: moment.Moment | undefined;
    feedback!: string | undefined;
    status!: string | undefined;
    candidateId!: number | undefined;
    rateing!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCandidateinterviewDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roundId = _data["roundId"];
            this.interviwerId = _data["interviwerId"];
            this.interviwerDate = _data["interviwerDate"] ? moment(_data["interviwerDate"].toString()) : <any>undefined;
            this.feedback = _data["feedback"];
            this.status = _data["status"];
            this.candidateId = _data["candidateId"];
            this.rateing = _data["rateing"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCandidateinterviewDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCandidateinterviewDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roundId"] = this.roundId;
        data["interviwerId"] = this.interviwerId;
        data["interviwerDate"] = this.interviwerDate ? this.interviwerDate.toISOString() : <any>undefined;
        data["feedback"] = this.feedback;
        data["status"] = this.status;
        data["candidateId"] = this.candidateId;
        data["rateing"] = this.rateing;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCandidateinterviewDetailsDto {
    roundId: number;
    interviwerId: number | undefined;
    interviwerDate: moment.Moment | undefined;
    feedback: string | undefined;
    status: string | undefined;
    candidateId: number | undefined;
    rateing: number | undefined;
    id: number | undefined;
}

export class GetCandidateinterviewDetailsForEditOutput implements IGetCandidateinterviewDetailsForEditOutput {
    candidateinterviewDetails!: CreateOrEditCandidateinterviewDetailsDto;
    candidateName!: string | undefined;

    constructor(data?: IGetCandidateinterviewDetailsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidateinterviewDetails = _data["candidateinterviewDetails"] ? CreateOrEditCandidateinterviewDetailsDto.fromJS(_data["candidateinterviewDetails"]) : <any>undefined;
            this.candidateName = _data["candidateName"];
        }
    }

    static fromJS(data: any): GetCandidateinterviewDetailsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCandidateinterviewDetailsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidateinterviewDetails"] = this.candidateinterviewDetails ? this.candidateinterviewDetails.toJSON() : <any>undefined;
        data["candidateName"] = this.candidateName;
        return data;
    }
}

export interface IGetCandidateinterviewDetailsForEditOutput {
    candidateinterviewDetails: CreateOrEditCandidateinterviewDetailsDto;
    candidateName: string | undefined;
}

export class CandidateinterviewDetailsCandidateLookupTableDto implements ICandidateinterviewDetailsCandidateLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICandidateinterviewDetailsCandidateLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): CandidateinterviewDetailsCandidateLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidateinterviewDetailsCandidateLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICandidateinterviewDetailsCandidateLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class CandidateQualificationDto implements ICandidateQualificationDto {
    education!: string | undefined;
    specialization!: string | undefined;
    modes!: string | undefined;
    passingYear!: number;
    institution!: string | undefined;
    percentage!: string | undefined;
    candidateId!: number;
    id!: number;

    constructor(data?: ICandidateQualificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.education = _data["education"];
            this.specialization = _data["specialization"];
            this.modes = _data["modes"];
            this.passingYear = _data["passingYear"];
            this.institution = _data["institution"];
            this.percentage = _data["percentage"];
            this.candidateId = _data["candidateId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CandidateQualificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidateQualificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["education"] = this.education;
        data["specialization"] = this.specialization;
        data["modes"] = this.modes;
        data["passingYear"] = this.passingYear;
        data["institution"] = this.institution;
        data["percentage"] = this.percentage;
        data["candidateId"] = this.candidateId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICandidateQualificationDto {
    education: string | undefined;
    specialization: string | undefined;
    modes: string | undefined;
    passingYear: number;
    institution: string | undefined;
    percentage: string | undefined;
    candidateId: number;
    id: number;
}

export class GetCandidateQualificationForViewDto implements IGetCandidateQualificationForViewDto {
    candidateQualification!: CandidateQualificationDto;
    candidateName!: string | undefined;

    constructor(data?: IGetCandidateQualificationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidateQualification = _data["candidateQualification"] ? CandidateQualificationDto.fromJS(_data["candidateQualification"]) : <any>undefined;
            this.candidateName = _data["candidateName"];
        }
    }

    static fromJS(data: any): GetCandidateQualificationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCandidateQualificationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidateQualification"] = this.candidateQualification ? this.candidateQualification.toJSON() : <any>undefined;
        data["candidateName"] = this.candidateName;
        return data;
    }
}

export interface IGetCandidateQualificationForViewDto {
    candidateQualification: CandidateQualificationDto;
    candidateName: string | undefined;
}

export class PagedResultDtoOfGetCandidateQualificationForViewDto implements IPagedResultDtoOfGetCandidateQualificationForViewDto {
    totalCount!: number;
    items!: GetCandidateQualificationForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCandidateQualificationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetCandidateQualificationForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCandidateQualificationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCandidateQualificationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCandidateQualificationForViewDto {
    totalCount: number;
    items: GetCandidateQualificationForViewDto[] | undefined;
}

export class CreateOrEditCandidateQualificationDto implements ICreateOrEditCandidateQualificationDto {
    education!: string | undefined;
    specialization!: string | undefined;
    modes!: string | undefined;
    passingYear!: number;
    institution!: string | undefined;
    percentage!: string | undefined;
    candidateId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCandidateQualificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.education = _data["education"];
            this.specialization = _data["specialization"];
            this.modes = _data["modes"];
            this.passingYear = _data["passingYear"];
            this.institution = _data["institution"];
            this.percentage = _data["percentage"];
            this.candidateId = _data["candidateId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCandidateQualificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCandidateQualificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["education"] = this.education;
        data["specialization"] = this.specialization;
        data["modes"] = this.modes;
        data["passingYear"] = this.passingYear;
        data["institution"] = this.institution;
        data["percentage"] = this.percentage;
        data["candidateId"] = this.candidateId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCandidateQualificationDto {
    education: string | undefined;
    specialization: string | undefined;
    modes: string | undefined;
    passingYear: number;
    institution: string | undefined;
    percentage: string | undefined;
    candidateId: number;
    id: number | undefined;
}

export class GetCandidateQualificationForEditOutput implements IGetCandidateQualificationForEditOutput {
    candidateQualification!: CreateOrEditCandidateQualificationDto;
    candidateName!: string | undefined;

    constructor(data?: IGetCandidateQualificationForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidateQualification = _data["candidateQualification"] ? CreateOrEditCandidateQualificationDto.fromJS(_data["candidateQualification"]) : <any>undefined;
            this.candidateName = _data["candidateName"];
        }
    }

    static fromJS(data: any): GetCandidateQualificationForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCandidateQualificationForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidateQualification"] = this.candidateQualification ? this.candidateQualification.toJSON() : <any>undefined;
        data["candidateName"] = this.candidateName;
        return data;
    }
}

export interface IGetCandidateQualificationForEditOutput {
    candidateQualification: CreateOrEditCandidateQualificationDto;
    candidateName: string | undefined;
}

export class CandidateQualificationCandidateLookupTableDto implements ICandidateQualificationCandidateLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICandidateQualificationCandidateLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): CandidateQualificationCandidateLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidateQualificationCandidateLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICandidateQualificationCandidateLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfCandidateQualificationCandidateLookupTableDto implements IPagedResultDtoOfCandidateQualificationCandidateLookupTableDto {
    totalCount!: number;
    items!: CandidateQualificationCandidateLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCandidateQualificationCandidateLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CandidateQualificationCandidateLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCandidateQualificationCandidateLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCandidateQualificationCandidateLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfCandidateQualificationCandidateLookupTableDto {
    totalCount: number;
    items: CandidateQualificationCandidateLookupTableDto[] | undefined;
}

export class CandidateDto implements ICandidateDto {
    name!: string | undefined;
    dob!: moment.Moment;
    fatherName!: string | undefined;
    permanentAddress!: string | undefined;
    postalAddress!: string | undefined;
    email!: string | undefined;
    contactNumber!: number;
    sex!: string | undefined;
    matrialStatus!: string | undefined;
    passportNo!: string | undefined;
    releventExperience!: number;
    document!: string | undefined;
    id!: number;

    constructor(data?: ICandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.dob = _data["dob"] ? moment(_data["dob"].toString()) : <any>undefined;
            this.fatherName = _data["fatherName"];
            this.permanentAddress = _data["permanentAddress"];
            this.postalAddress = _data["postalAddress"];
            this.email = _data["email"];
            this.contactNumber = _data["contactNumber"];
            this.sex = _data["sex"];
            this.matrialStatus = _data["matrialStatus"];
            this.passportNo = _data["passportNo"];
            this.releventExperience = _data["releventExperience"];
            this.document = _data["document"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CandidateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["fatherName"] = this.fatherName;
        data["permanentAddress"] = this.permanentAddress;
        data["postalAddress"] = this.postalAddress;
        data["email"] = this.email;
        data["contactNumber"] = this.contactNumber;
        data["sex"] = this.sex;
        data["matrialStatus"] = this.matrialStatus;
        data["passportNo"] = this.passportNo;
        data["releventExperience"] = this.releventExperience;
        data["document"] = this.document;
        data["id"] = this.id;
        return data;
    }
}

export interface ICandidateDto {
    name: string | undefined;
    dob: moment.Moment;
    fatherName: string | undefined;
    permanentAddress: string | undefined;
    postalAddress: string | undefined;
    email: string | undefined;
    contactNumber: number;
    sex: string | undefined;
    matrialStatus: string | undefined;
    passportNo: string | undefined;
    releventExperience: number;
    document: string | undefined;
    id: number;
}

export class GetCandidateForViewDto implements IGetCandidateForViewDto {
    candidate!: CandidateDto;

    constructor(data?: IGetCandidateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidate = _data["candidate"] ? CandidateDto.fromJS(_data["candidate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCandidateForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCandidateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidate"] = this.candidate ? this.candidate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCandidateForViewDto {
    candidate: CandidateDto;
}

export class PagedResultDtoOfGetCandidateForViewDto implements IPagedResultDtoOfGetCandidateForViewDto {
    totalCount!: number;
    items!: GetCandidateForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCandidateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetCandidateForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCandidateForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCandidateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCandidateForViewDto {
    totalCount: number;
    items: GetCandidateForViewDto[] | undefined;
}

export class GetCreateOrEditCandidateDto implements IGetCreateOrEditCandidateDto {
    name!: string | undefined;
    dob!: moment.Moment;
    fatherName!: string | undefined;
    permanentAddress!: string | undefined;
    postalAddress!: string | undefined;
    email!: string | undefined;
    contactNumber!: number;
    sex!: string | undefined;
    matrialStatus!: string | undefined;
    passportNo!: string | undefined;
    releventExperience!: number;
    document!: string | undefined;
    candidateQualification!: GetCandidateQualificationForEditOutput[] | undefined;
    candidateDocuments!: GetCandidateDocumnetsForEditOutput[] | undefined;
    jobId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IGetCreateOrEditCandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.dob = _data["dob"] ? moment(_data["dob"].toString()) : <any>undefined;
            this.fatherName = _data["fatherName"];
            this.permanentAddress = _data["permanentAddress"];
            this.postalAddress = _data["postalAddress"];
            this.email = _data["email"];
            this.contactNumber = _data["contactNumber"];
            this.sex = _data["sex"];
            this.matrialStatus = _data["matrialStatus"];
            this.passportNo = _data["passportNo"];
            this.releventExperience = _data["releventExperience"];
            this.document = _data["document"];
            if (Array.isArray(_data["candidateQualification"])) {
                this.candidateQualification = [] as any;
                for (let item of _data["candidateQualification"])
                    this.candidateQualification!.push(GetCandidateQualificationForEditOutput.fromJS(item));
            }
            if (Array.isArray(_data["candidateDocuments"])) {
                this.candidateDocuments = [] as any;
                for (let item of _data["candidateDocuments"])
                    this.candidateDocuments!.push(GetCandidateDocumnetsForEditOutput.fromJS(item));
            }
            this.jobId = _data["jobId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCreateOrEditCandidateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateOrEditCandidateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["fatherName"] = this.fatherName;
        data["permanentAddress"] = this.permanentAddress;
        data["postalAddress"] = this.postalAddress;
        data["email"] = this.email;
        data["contactNumber"] = this.contactNumber;
        data["sex"] = this.sex;
        data["matrialStatus"] = this.matrialStatus;
        data["passportNo"] = this.passportNo;
        data["releventExperience"] = this.releventExperience;
        data["document"] = this.document;
        if (Array.isArray(this.candidateQualification)) {
            data["candidateQualification"] = [];
            for (let item of this.candidateQualification)
                data["candidateQualification"].push(item.toJSON());
        }
        if (Array.isArray(this.candidateDocuments)) {
            data["candidateDocuments"] = [];
            for (let item of this.candidateDocuments)
                data["candidateDocuments"].push(item.toJSON());
        }
        data["jobId"] = this.jobId;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetCreateOrEditCandidateDto {
    name: string | undefined;
    dob: moment.Moment;
    fatherName: string | undefined;
    permanentAddress: string | undefined;
    postalAddress: string | undefined;
    email: string | undefined;
    contactNumber: number;
    sex: string | undefined;
    matrialStatus: string | undefined;
    passportNo: string | undefined;
    releventExperience: number;
    document: string | undefined;
    candidateQualification: GetCandidateQualificationForEditOutput[] | undefined;
    candidateDocuments: GetCandidateDocumnetsForEditOutput[] | undefined;
    jobId: number | undefined;
    id: number | undefined;
}

export class GetCandidateForEditOutput implements IGetCandidateForEditOutput {
    candidate!: GetCreateOrEditCandidateDto;

    constructor(data?: IGetCandidateForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidate = _data["candidate"] ? GetCreateOrEditCandidateDto.fromJS(_data["candidate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCandidateForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCandidateForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidate"] = this.candidate ? this.candidate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCandidateForEditOutput {
    candidate: GetCreateOrEditCandidateDto;
}

export class RoundInterview implements IRoundInterview {
    round!: string | undefined;
    interviewerId!: number;
    interviewerName!: string | undefined;
    id!: number | undefined;

    constructor(data?: IRoundInterview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.round = _data["round"];
            this.interviewerId = _data["interviewerId"];
            this.interviewerName = _data["interviewerName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoundInterview {
        data = typeof data === 'object' ? data : {};
        let result = new RoundInterview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["round"] = this.round;
        data["interviewerId"] = this.interviewerId;
        data["interviewerName"] = this.interviewerName;
        data["id"] = this.id;
        return data;
    }
}

export interface IRoundInterview {
    round: string | undefined;
    interviewerId: number;
    interviewerName: string | undefined;
    id: number | undefined;
}

export class CreateOrEditCandidateDto implements ICreateOrEditCandidateDto {
    name!: string | undefined;
    dob!: moment.Moment;
    fatherName!: string | undefined;
    permanentAddress!: string | undefined;
    postalAddress!: string | undefined;
    email!: string | undefined;
    contactNumber!: number;
    sex!: string | undefined;
    matrialStatus!: string | undefined;
    passportNo!: string | undefined;
    releventExperience!: number;
    document!: string | undefined;
    jobId!: number | undefined;
    candidateQualification!: CreateOrEditCandidateQualificationDto[] | undefined;
    candidateDocuments!: CreateOrEditCandidateDocumnetsDto[] | undefined;
    roundInterview!: RoundInterview[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCandidateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.dob = _data["dob"] ? moment(_data["dob"].toString()) : <any>undefined;
            this.fatherName = _data["fatherName"];
            this.permanentAddress = _data["permanentAddress"];
            this.postalAddress = _data["postalAddress"];
            this.email = _data["email"];
            this.contactNumber = _data["contactNumber"];
            this.sex = _data["sex"];
            this.matrialStatus = _data["matrialStatus"];
            this.passportNo = _data["passportNo"];
            this.releventExperience = _data["releventExperience"];
            this.document = _data["document"];
            this.jobId = _data["jobId"];
            if (Array.isArray(_data["candidateQualification"])) {
                this.candidateQualification = [] as any;
                for (let item of _data["candidateQualification"])
                    this.candidateQualification!.push(CreateOrEditCandidateQualificationDto.fromJS(item));
            }
            if (Array.isArray(_data["candidateDocuments"])) {
                this.candidateDocuments = [] as any;
                for (let item of _data["candidateDocuments"])
                    this.candidateDocuments!.push(CreateOrEditCandidateDocumnetsDto.fromJS(item));
            }
            if (Array.isArray(_data["roundInterview"])) {
                this.roundInterview = [] as any;
                for (let item of _data["roundInterview"])
                    this.roundInterview!.push(RoundInterview.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCandidateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCandidateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["fatherName"] = this.fatherName;
        data["permanentAddress"] = this.permanentAddress;
        data["postalAddress"] = this.postalAddress;
        data["email"] = this.email;
        data["contactNumber"] = this.contactNumber;
        data["sex"] = this.sex;
        data["matrialStatus"] = this.matrialStatus;
        data["passportNo"] = this.passportNo;
        data["releventExperience"] = this.releventExperience;
        data["document"] = this.document;
        data["jobId"] = this.jobId;
        if (Array.isArray(this.candidateQualification)) {
            data["candidateQualification"] = [];
            for (let item of this.candidateQualification)
                data["candidateQualification"].push(item.toJSON());
        }
        if (Array.isArray(this.candidateDocuments)) {
            data["candidateDocuments"] = [];
            for (let item of this.candidateDocuments)
                data["candidateDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.roundInterview)) {
            data["roundInterview"] = [];
            for (let item of this.roundInterview)
                data["roundInterview"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCandidateDto {
    name: string | undefined;
    dob: moment.Moment;
    fatherName: string | undefined;
    permanentAddress: string | undefined;
    postalAddress: string | undefined;
    email: string | undefined;
    contactNumber: number;
    sex: string | undefined;
    matrialStatus: string | undefined;
    passportNo: string | undefined;
    releventExperience: number;
    document: string | undefined;
    jobId: number | undefined;
    candidateQualification: CreateOrEditCandidateQualificationDto[] | undefined;
    candidateDocuments: CreateOrEditCandidateDocumnetsDto[] | undefined;
    roundInterview: RoundInterview[] | undefined;
    id: number | undefined;
}

export class CandidateMatchListDto implements ICandidateMatchListDto {
    matchId!: number;
    jobId!: number;
    candidateId!: number;
    name!: string | undefined;
    releventExperience!: number;
    matchScore!: number;
    strengths!: string | undefined;
    gaps!: string | undefined;
    recommendation!: string | undefined;
    isShortlisted!: boolean;

    constructor(data?: ICandidateMatchListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchId = _data["matchId"];
            this.jobId = _data["jobId"];
            this.candidateId = _data["candidateId"];
            this.name = _data["name"];
            this.releventExperience = _data["releventExperience"];
            this.matchScore = _data["matchScore"];
            this.strengths = _data["strengths"];
            this.gaps = _data["gaps"];
            this.recommendation = _data["recommendation"];
            this.isShortlisted = _data["isShortlisted"];
        }
    }

    static fromJS(data: any): CandidateMatchListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidateMatchListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchId"] = this.matchId;
        data["jobId"] = this.jobId;
        data["candidateId"] = this.candidateId;
        data["name"] = this.name;
        data["releventExperience"] = this.releventExperience;
        data["matchScore"] = this.matchScore;
        data["strengths"] = this.strengths;
        data["gaps"] = this.gaps;
        data["recommendation"] = this.recommendation;
        data["isShortlisted"] = this.isShortlisted;
        return data;
    }
}

export interface ICandidateMatchListDto {
    matchId: number;
    jobId: number;
    candidateId: number;
    name: string | undefined;
    releventExperience: number;
    matchScore: number;
    strengths: string | undefined;
    gaps: string | undefined;
    recommendation: string | undefined;
    isShortlisted: boolean;
}

export class CandidateMatchDto implements ICandidateMatchDto {
    candidateId!: number;
    name!: string | undefined;
    releventExperience!: number;
    matchScore!: number;
    strengths!: string | undefined;
    gaps!: string | undefined;
    recommendation!: string | undefined;

    constructor(data?: ICandidateMatchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.candidateId = _data["candidateId"];
            this.name = _data["name"];
            this.releventExperience = _data["releventExperience"];
            this.matchScore = _data["matchScore"];
            this.strengths = _data["strengths"];
            this.gaps = _data["gaps"];
            this.recommendation = _data["recommendation"];
        }
    }

    static fromJS(data: any): CandidateMatchDto {
        data = typeof data === 'object' ? data : {};
        let result = new CandidateMatchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["candidateId"] = this.candidateId;
        data["name"] = this.name;
        data["releventExperience"] = this.releventExperience;
        data["matchScore"] = this.matchScore;
        data["strengths"] = this.strengths;
        data["gaps"] = this.gaps;
        data["recommendation"] = this.recommendation;
        return data;
    }
}

export interface ICandidateMatchDto {
    candidateId: number;
    name: string | undefined;
    releventExperience: number;
    matchScore: number;
    strengths: string | undefined;
    gaps: string | undefined;
    recommendation: string | undefined;
}

export class ScheduleInterviewInput implements IScheduleInterviewInput {
    matchId!: number;
    jobId!: number;
    candidateId!: number;
    interviewDate!: moment.Moment | undefined;
    remarks!: string | undefined;

    constructor(data?: IScheduleInterviewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchId = _data["matchId"];
            this.jobId = _data["jobId"];
            this.candidateId = _data["candidateId"];
            this.interviewDate = _data["interviewDate"] ? moment(_data["interviewDate"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): ScheduleInterviewInput {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleInterviewInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchId"] = this.matchId;
        data["jobId"] = this.jobId;
        data["candidateId"] = this.candidateId;
        data["interviewDate"] = this.interviewDate ? this.interviewDate.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IScheduleInterviewInput {
    matchId: number;
    jobId: number;
    candidateId: number;
    interviewDate: moment.Moment | undefined;
    remarks: string | undefined;
}

export class RecruitmentInterviewDto implements IRecruitmentInterviewDto {
    id!: number;
    matchId!: number;
    jobId!: number;
    candidateId!: number;
    interviewToken!: string | undefined;
    interviewLink!: string | undefined;
    availableFrom!: moment.Moment;
    availableTill!: moment.Moment;
    status!: string | undefined;
    emailSent!: boolean;
    emailSentTime!: moment.Moment | undefined;
    remarks!: string | undefined;
    beyondPresenceSessionId!: string | undefined;

    constructor(data?: IRecruitmentInterviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.matchId = _data["matchId"];
            this.jobId = _data["jobId"];
            this.candidateId = _data["candidateId"];
            this.interviewToken = _data["interviewToken"];
            this.interviewLink = _data["interviewLink"];
            this.availableFrom = _data["availableFrom"] ? moment(_data["availableFrom"].toString()) : <any>undefined;
            this.availableTill = _data["availableTill"] ? moment(_data["availableTill"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.emailSent = _data["emailSent"];
            this.emailSentTime = _data["emailSentTime"] ? moment(_data["emailSentTime"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
            this.beyondPresenceSessionId = _data["beyondPresenceSessionId"];
        }
    }

    static fromJS(data: any): RecruitmentInterviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecruitmentInterviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["matchId"] = this.matchId;
        data["jobId"] = this.jobId;
        data["candidateId"] = this.candidateId;
        data["interviewToken"] = this.interviewToken;
        data["interviewLink"] = this.interviewLink;
        data["availableFrom"] = this.availableFrom ? this.availableFrom.toISOString() : <any>undefined;
        data["availableTill"] = this.availableTill ? this.availableTill.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["emailSent"] = this.emailSent;
        data["emailSentTime"] = this.emailSentTime ? this.emailSentTime.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["beyondPresenceSessionId"] = this.beyondPresenceSessionId;
        return data;
    }
}

export interface IRecruitmentInterviewDto {
    id: number;
    matchId: number;
    jobId: number;
    candidateId: number;
    interviewToken: string | undefined;
    interviewLink: string | undefined;
    availableFrom: moment.Moment;
    availableTill: moment.Moment;
    status: string | undefined;
    emailSent: boolean;
    emailSentTime: moment.Moment | undefined;
    remarks: string | undefined;
    beyondPresenceSessionId: string | undefined;
}

export class BeyondPresenceEvaluationDto implements IBeyondPresenceEvaluationDto {
    topic!: string | undefined;
    userSentiment!: string | undefined;
    durationMinutes!: number | undefined;
    messagesCount!: number | undefined;

    constructor(data?: IBeyondPresenceEvaluationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topic = _data["topic"];
            this.userSentiment = _data["userSentiment"];
            this.durationMinutes = _data["durationMinutes"];
            this.messagesCount = _data["messagesCount"];
        }
    }

    static fromJS(data: any): BeyondPresenceEvaluationDto {
        data = typeof data === 'object' ? data : {};
        let result = new BeyondPresenceEvaluationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topic"] = this.topic;
        data["userSentiment"] = this.userSentiment;
        data["durationMinutes"] = this.durationMinutes;
        data["messagesCount"] = this.messagesCount;
        return data;
    }
}

export interface IBeyondPresenceEvaluationDto {
    topic: string | undefined;
    userSentiment: string | undefined;
    durationMinutes: number | undefined;
    messagesCount: number | undefined;
}

export class BeyondPresenceMessageDto implements IBeyondPresenceMessageDto {
    sender!: string | undefined;
    message!: string | undefined;
    sentAt!: moment.Moment | undefined;

    constructor(data?: IBeyondPresenceMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sender = _data["sender"];
            this.message = _data["message"];
            this.sentAt = _data["sentAt"] ? moment(_data["sentAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BeyondPresenceMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new BeyondPresenceMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sender"] = this.sender;
        data["message"] = this.message;
        data["sentAt"] = this.sentAt ? this.sentAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBeyondPresenceMessageDto {
    sender: string | undefined;
    message: string | undefined;
    sentAt: moment.Moment | undefined;
}

export class BeyondPresenceWebhookDto implements IBeyondPresenceWebhookDto {
    eventType!: string | undefined;
    callId!: string | undefined;
    userName!: string | undefined;
    evaluation!: BeyondPresenceEvaluationDto;
    messages!: BeyondPresenceMessageDto[] | undefined;

    constructor(data?: IBeyondPresenceWebhookDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventType = _data["eventType"];
            this.callId = _data["callId"];
            this.userName = _data["userName"];
            this.evaluation = _data["evaluation"] ? BeyondPresenceEvaluationDto.fromJS(_data["evaluation"]) : <any>undefined;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(BeyondPresenceMessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BeyondPresenceWebhookDto {
        data = typeof data === 'object' ? data : {};
        let result = new BeyondPresenceWebhookDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventType"] = this.eventType;
        data["callId"] = this.callId;
        data["userName"] = this.userName;
        data["evaluation"] = this.evaluation ? this.evaluation.toJSON() : <any>undefined;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBeyondPresenceWebhookDto {
    eventType: string | undefined;
    callId: string | undefined;
    userName: string | undefined;
    evaluation: BeyondPresenceEvaluationDto;
    messages: BeyondPresenceMessageDto[] | undefined;
}

export class RecruitmentInterviewResultDto implements IRecruitmentInterviewResultDto {
    summary!: string | undefined;
    recruitmentInterviewId!: number;
    interviewStatus!: string | undefined;
    completedTime!: moment.Moment | undefined;
    beyondPresenceCallId!: string | undefined;
    transcriptText!: string | undefined;
    transcriptJson!: string | undefined;
    evaluationJson!: string | undefined;
    rawWebhookJson!: string | undefined;
    topic!: string | undefined;
    userSentiment!: string | undefined;
    durationMinutes!: number | undefined;
    messagesCount!: number | undefined;

    constructor(data?: IRecruitmentInterviewResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"];
            this.recruitmentInterviewId = _data["recruitmentInterviewId"];
            this.interviewStatus = _data["interviewStatus"];
            this.completedTime = _data["completedTime"] ? moment(_data["completedTime"].toString()) : <any>undefined;
            this.beyondPresenceCallId = _data["beyondPresenceCallId"];
            this.transcriptText = _data["transcriptText"];
            this.transcriptJson = _data["transcriptJson"];
            this.evaluationJson = _data["evaluationJson"];
            this.rawWebhookJson = _data["rawWebhookJson"];
            this.topic = _data["topic"];
            this.userSentiment = _data["userSentiment"];
            this.durationMinutes = _data["durationMinutes"];
            this.messagesCount = _data["messagesCount"];
        }
    }

    static fromJS(data: any): RecruitmentInterviewResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecruitmentInterviewResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary;
        data["recruitmentInterviewId"] = this.recruitmentInterviewId;
        data["interviewStatus"] = this.interviewStatus;
        data["completedTime"] = this.completedTime ? this.completedTime.toISOString() : <any>undefined;
        data["beyondPresenceCallId"] = this.beyondPresenceCallId;
        data["transcriptText"] = this.transcriptText;
        data["transcriptJson"] = this.transcriptJson;
        data["evaluationJson"] = this.evaluationJson;
        data["rawWebhookJson"] = this.rawWebhookJson;
        data["topic"] = this.topic;
        data["userSentiment"] = this.userSentiment;
        data["durationMinutes"] = this.durationMinutes;
        data["messagesCount"] = this.messagesCount;
        return data;
    }
}

export interface IRecruitmentInterviewResultDto {
    summary: string | undefined;
    recruitmentInterviewId: number;
    interviewStatus: string | undefined;
    completedTime: moment.Moment | undefined;
    beyondPresenceCallId: string | undefined;
    transcriptText: string | undefined;
    transcriptJson: string | undefined;
    evaluationJson: string | undefined;
    rawWebhookJson: string | undefined;
    topic: string | undefined;
    userSentiment: string | undefined;
    durationMinutes: number | undefined;
    messagesCount: number | undefined;
}

export enum FriendshipState {
    Accepted = 1,
    Blocked = 2,
}

export class FriendDto implements IFriendDto {
    friendUserId!: number;
    friendTenantId!: number | undefined;
    friendUserName!: string | undefined;
    friendTenancyName!: string | undefined;
    friendProfilePictureId!: string | undefined;
    unreadMessageCount!: number;
    isOnline!: boolean;
    state!: FriendshipState;

    constructor(data?: IFriendDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.friendUserId = _data["friendUserId"];
            this.friendTenantId = _data["friendTenantId"];
            this.friendUserName = _data["friendUserName"];
            this.friendTenancyName = _data["friendTenancyName"];
            this.friendProfilePictureId = _data["friendProfilePictureId"];
            this.unreadMessageCount = _data["unreadMessageCount"];
            this.isOnline = _data["isOnline"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): FriendDto {
        data = typeof data === 'object' ? data : {};
        let result = new FriendDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["friendUserId"] = this.friendUserId;
        data["friendTenantId"] = this.friendTenantId;
        data["friendUserName"] = this.friendUserName;
        data["friendTenancyName"] = this.friendTenancyName;
        data["friendProfilePictureId"] = this.friendProfilePictureId;
        data["unreadMessageCount"] = this.unreadMessageCount;
        data["isOnline"] = this.isOnline;
        data["state"] = this.state;
        return data;
    }
}

export interface IFriendDto {
    friendUserId: number;
    friendTenantId: number | undefined;
    friendUserName: string | undefined;
    friendTenancyName: string | undefined;
    friendProfilePictureId: string | undefined;
    unreadMessageCount: number;
    isOnline: boolean;
    state: FriendshipState;
}

export class GetUserChatFriendsWithSettingsOutput implements IGetUserChatFriendsWithSettingsOutput {
    serverTime!: moment.Moment;
    friends!: FriendDto[] | undefined;

    constructor(data?: IGetUserChatFriendsWithSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serverTime = _data["serverTime"] ? moment(_data["serverTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["friends"])) {
                this.friends = [] as any;
                for (let item of _data["friends"])
                    this.friends!.push(FriendDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserChatFriendsWithSettingsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserChatFriendsWithSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverTime"] = this.serverTime ? this.serverTime.toISOString() : <any>undefined;
        if (Array.isArray(this.friends)) {
            data["friends"] = [];
            for (let item of this.friends)
                data["friends"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserChatFriendsWithSettingsOutput {
    serverTime: moment.Moment;
    friends: FriendDto[] | undefined;
}

export enum ChatSide {
    Sender = 1,
    Receiver = 2,
}

export enum ChatMessageReadState {
    Unread = 1,
    Read = 2,
}

export class ChatMessageDto implements IChatMessageDto {
    userId!: number;
    tenantId!: number | undefined;
    targetUserId!: number;
    targetTenantId!: number | undefined;
    side!: ChatSide;
    readState!: ChatMessageReadState;
    receiverReadState!: ChatMessageReadState;
    message!: string | undefined;
    creationTime!: moment.Moment;
    sharedMessageId!: string | undefined;
    id!: number;

    constructor(data?: IChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.targetUserId = _data["targetUserId"];
            this.targetTenantId = _data["targetTenantId"];
            this.side = _data["side"];
            this.readState = _data["readState"];
            this.receiverReadState = _data["receiverReadState"];
            this.message = _data["message"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.sharedMessageId = _data["sharedMessageId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ChatMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["targetUserId"] = this.targetUserId;
        data["targetTenantId"] = this.targetTenantId;
        data["side"] = this.side;
        data["readState"] = this.readState;
        data["receiverReadState"] = this.receiverReadState;
        data["message"] = this.message;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["sharedMessageId"] = this.sharedMessageId;
        data["id"] = this.id;
        return data;
    }
}

export interface IChatMessageDto {
    userId: number;
    tenantId: number | undefined;
    targetUserId: number;
    targetTenantId: number | undefined;
    side: ChatSide;
    readState: ChatMessageReadState;
    receiverReadState: ChatMessageReadState;
    message: string | undefined;
    creationTime: moment.Moment;
    sharedMessageId: string | undefined;
    id: number;
}

export class ListResultDtoOfChatMessageDto implements IListResultDtoOfChatMessageDto {
    items!: ChatMessageDto[] | undefined;

    constructor(data?: IListResultDtoOfChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChatMessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfChatMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfChatMessageDto {
    items: ChatMessageDto[] | undefined;
}

export class MarkAllUnreadMessagesOfUserAsReadInput implements IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IMarkAllUnreadMessagesOfUserAsReadInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): MarkAllUnreadMessagesOfUserAsReadInput {
        data = typeof data === 'object' ? data : {};
        let result = new MarkAllUnreadMessagesOfUserAsReadInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId: number | undefined;
    userId: number;
}

export class CityDto implements ICityDto {
    name!: string | undefined;
    stateId!: number | undefined;
    id!: number;

    constructor(data?: ICityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.stateId = _data["stateId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["stateId"] = this.stateId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICityDto {
    name: string | undefined;
    stateId: number | undefined;
    id: number;
}

export class GetCityForViewDto implements IGetCityForViewDto {
    city!: CityDto;
    stateName!: string | undefined;

    constructor(data?: IGetCityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.city = _data["city"] ? CityDto.fromJS(_data["city"]) : <any>undefined;
            this.stateName = _data["stateName"];
        }
    }

    static fromJS(data: any): GetCityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["city"] = this.city ? this.city.toJSON() : <any>undefined;
        data["stateName"] = this.stateName;
        return data;
    }
}

export interface IGetCityForViewDto {
    city: CityDto;
    stateName: string | undefined;
}

export class PagedResultDtoOfGetCityForViewDto implements IPagedResultDtoOfGetCityForViewDto {
    totalCount!: number;
    items!: GetCityForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetCityForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCityForViewDto {
    totalCount: number;
    items: GetCityForViewDto[] | undefined;
}

export class CreateOrEditCityDto implements ICreateOrEditCityDto {
    name!: string | undefined;
    stateId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.stateId = _data["stateId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["stateId"] = this.stateId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCityDto {
    name: string | undefined;
    stateId: number | undefined;
    id: number | undefined;
}

export class GetCityForEditOutput implements IGetCityForEditOutput {
    city!: CreateOrEditCityDto;
    stateName!: string | undefined;

    constructor(data?: IGetCityForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.city = _data["city"] ? CreateOrEditCityDto.fromJS(_data["city"]) : <any>undefined;
            this.stateName = _data["stateName"];
        }
    }

    static fromJS(data: any): GetCityForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCityForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["city"] = this.city ? this.city.toJSON() : <any>undefined;
        data["stateName"] = this.stateName;
        return data;
    }
}

export interface IGetCityForEditOutput {
    city: CreateOrEditCityDto;
    stateName: string | undefined;
}

export class CityStateLookupTableDto implements ICityStateLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICityStateLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): CityStateLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CityStateLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICityStateLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfCityStateLookupTableDto implements IPagedResultDtoOfCityStateLookupTableDto {
    totalCount!: number;
    items!: CityStateLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCityStateLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CityStateLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCityStateLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCityStateLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfCityStateLookupTableDto {
    totalCount: number;
    items: CityStateLookupTableDto[] | undefined;
}

export class StatusTaskDto implements IStatusTaskDto {
    tenantId!: number;
    taskId!: number;
    employeeid!: number;
    isCompleted!: boolean;
    id!: number;

    constructor(data?: IStatusTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.taskId = _data["taskId"];
            this.employeeid = _data["employeeid"];
            this.isCompleted = _data["isCompleted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StatusTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["taskId"] = this.taskId;
        data["employeeid"] = this.employeeid;
        data["isCompleted"] = this.isCompleted;
        data["id"] = this.id;
        return data;
    }
}

export interface IStatusTaskDto {
    tenantId: number;
    taskId: number;
    employeeid: number;
    isCompleted: boolean;
    id: number;
}

export class GetstatusListForView implements IGetstatusListForView {
    statusTask!: StatusTaskDto;

    constructor(data?: IGetstatusListForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusTask = _data["statusTask"] ? StatusTaskDto.fromJS(_data["statusTask"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetstatusListForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetstatusListForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusTask"] = this.statusTask ? this.statusTask.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetstatusListForView {
    statusTask: StatusTaskDto;
}

export class Taskidnumber implements ITaskidnumber {
    tasknumber!: number;
    iscompleted!: boolean;

    constructor(data?: ITaskidnumber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tasknumber = _data["tasknumber"];
            this.iscompleted = _data["iscompleted"];
        }
    }

    static fromJS(data: any): Taskidnumber {
        data = typeof data === 'object' ? data : {};
        let result = new Taskidnumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tasknumber"] = this.tasknumber;
        data["iscompleted"] = this.iscompleted;
        return data;
    }
}

export interface ITaskidnumber {
    tasknumber: number;
    iscompleted: boolean;
}

export class CreateorEditStatusTask implements ICreateorEditStatusTask {
    tenantId!: number;
    employeeid!: number;
    isCompleted!: boolean;
    taskidnumbers!: Taskidnumber[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateorEditStatusTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.employeeid = _data["employeeid"];
            this.isCompleted = _data["isCompleted"];
            if (Array.isArray(_data["taskidnumbers"])) {
                this.taskidnumbers = [] as any;
                for (let item of _data["taskidnumbers"])
                    this.taskidnumbers!.push(Taskidnumber.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateorEditStatusTask {
        data = typeof data === 'object' ? data : {};
        let result = new CreateorEditStatusTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["employeeid"] = this.employeeid;
        data["isCompleted"] = this.isCompleted;
        if (Array.isArray(this.taskidnumbers)) {
            data["taskidnumbers"] = [];
            for (let item of this.taskidnumbers)
                data["taskidnumbers"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateorEditStatusTask {
    tenantId: number;
    employeeid: number;
    isCompleted: boolean;
    taskidnumbers: Taskidnumber[] | undefined;
    id: number | undefined;
}

export class ClearanceTaskDto implements IClearanceTaskDto {
    task!: string | undefined;
    assignedTo!: number;
    dueOn!: number;
    ischecked!: boolean;
    id!: number;

    constructor(data?: IClearanceTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.task = _data["task"];
            this.assignedTo = _data["assignedTo"];
            this.dueOn = _data["dueOn"];
            this.ischecked = _data["ischecked"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClearanceTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClearanceTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["task"] = this.task;
        data["assignedTo"] = this.assignedTo;
        data["dueOn"] = this.dueOn;
        data["ischecked"] = this.ischecked;
        data["id"] = this.id;
        return data;
    }
}

export interface IClearanceTaskDto {
    task: string | undefined;
    assignedTo: number;
    dueOn: number;
    ischecked: boolean;
    id: number;
}

export class GetClearanceListForView implements IGetClearanceListForView {
    clearanceTask!: ClearanceTaskDto;
    assignedName!: string | undefined;

    constructor(data?: IGetClearanceListForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clearanceTask = _data["clearanceTask"] ? ClearanceTaskDto.fromJS(_data["clearanceTask"]) : <any>undefined;
            this.assignedName = _data["assignedName"];
        }
    }

    static fromJS(data: any): GetClearanceListForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetClearanceListForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clearanceTask"] = this.clearanceTask ? this.clearanceTask.toJSON() : <any>undefined;
        data["assignedName"] = this.assignedName;
        return data;
    }
}

export interface IGetClearanceListForView {
    clearanceTask: ClearanceTaskDto;
    assignedName: string | undefined;
}

export class PagedResultDtoOfGetClearanceListForView implements IPagedResultDtoOfGetClearanceListForView {
    totalCount!: number;
    items!: GetClearanceListForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetClearanceListForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetClearanceListForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetClearanceListForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetClearanceListForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetClearanceListForView {
    totalCount: number;
    items: GetClearanceListForView[] | undefined;
}

export class CreateOrEditClearanceTaskList implements ICreateOrEditClearanceTaskList {
    tenantId!: number | undefined;
    task!: string | undefined;
    assignedTo!: number;
    dueOn!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditClearanceTaskList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.task = _data["task"];
            this.assignedTo = _data["assignedTo"];
            this.dueOn = _data["dueOn"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditClearanceTaskList {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditClearanceTaskList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["task"] = this.task;
        data["assignedTo"] = this.assignedTo;
        data["dueOn"] = this.dueOn;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditClearanceTaskList {
    tenantId: number | undefined;
    task: string | undefined;
    assignedTo: number;
    dueOn: number;
    id: number | undefined;
}

export class SubscribableEditionComboboxItemDto implements ISubscribableEditionComboboxItemDto {
    isFree!: boolean | undefined;
    value!: string | undefined;
    displayText!: string | undefined;
    isSelected!: boolean;

    constructor(data?: ISubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFree = _data["isFree"];
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): SubscribableEditionComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFree"] = this.isFree;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface ISubscribableEditionComboboxItemDto {
    isFree: boolean | undefined;
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;
}

export class ListResultDtoOfSubscribableEditionComboboxItemDto implements IListResultDtoOfSubscribableEditionComboboxItemDto {
    items!: SubscribableEditionComboboxItemDto[] | undefined;

    constructor(data?: IListResultDtoOfSubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSubscribableEditionComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfSubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfSubscribableEditionComboboxItemDto {
    items: SubscribableEditionComboboxItemDto[] | undefined;
}

export class FindUsersInput implements IFindUsersInput {
    tenantId!: number | undefined;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FindUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IFindUsersInput {
    tenantId: number | undefined;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class PagedResultDtoOfNameValueDto implements IPagedResultDtoOfNameValueDto {
    totalCount!: number;
    items!: NameValueDto[] | undefined;

    constructor(data?: IPagedResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfNameValueDto {
    totalCount: number;
    items: NameValueDto[] | undefined;
}

export class GetDefaultEditionNameOutput implements IGetDefaultEditionNameOutput {
    name!: string | undefined;

    constructor(data?: IGetDefaultEditionNameOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetDefaultEditionNameOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDefaultEditionNameOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IGetDefaultEditionNameOutput {
    name: string | undefined;
}

export class TenancyDetailsDetailsDto implements ITenancyDetailsDetailsDto {
    companyName!: string | undefined;
    pfApplicable!: string | undefined;
    pfNumber!: string | undefined;
    esiApplicable!: string | undefined;
    esiNumber!: string | undefined;
    leaveCycle!: string | undefined;
    performanceReviewCycle!: string | undefined;
    noOfLicensedUser!: number;

    constructor(data?: ITenancyDetailsDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.pfApplicable = _data["pfApplicable"];
            this.pfNumber = _data["pfNumber"];
            this.esiApplicable = _data["esiApplicable"];
            this.esiNumber = _data["esiNumber"];
            this.leaveCycle = _data["leaveCycle"];
            this.performanceReviewCycle = _data["performanceReviewCycle"];
            this.noOfLicensedUser = _data["noOfLicensedUser"];
        }
    }

    static fromJS(data: any): TenancyDetailsDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenancyDetailsDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["pfApplicable"] = this.pfApplicable;
        data["pfNumber"] = this.pfNumber;
        data["esiApplicable"] = this.esiApplicable;
        data["esiNumber"] = this.esiNumber;
        data["leaveCycle"] = this.leaveCycle;
        data["performanceReviewCycle"] = this.performanceReviewCycle;
        data["noOfLicensedUser"] = this.noOfLicensedUser;
        return data;
    }
}

export interface ITenancyDetailsDetailsDto {
    companyName: string | undefined;
    pfApplicable: string | undefined;
    pfNumber: string | undefined;
    esiApplicable: string | undefined;
    esiNumber: string | undefined;
    leaveCycle: string | undefined;
    performanceReviewCycle: string | undefined;
    noOfLicensedUser: number;
}

export class DepartmentsDto implements IDepartmentsDto {
    name!: string | undefined;
    id!: number;

    constructor(data?: IDepartmentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DepartmentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IDepartmentsDto {
    name: string | undefined;
    id: number;
}

export class GetDepartmentsForViewDto implements IGetDepartmentsForViewDto {
    departments!: DepartmentsDto;

    constructor(data?: IGetDepartmentsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departments = _data["departments"] ? DepartmentsDto.fromJS(_data["departments"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDepartmentsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDepartmentsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departments"] = this.departments ? this.departments.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDepartmentsForViewDto {
    departments: DepartmentsDto;
}

export class ContratorDto implements IContratorDto {
    name!: string | undefined;
    streetAddress!: string | undefined;
    city!: string | undefined;
    state!: number;
    country!: number;
    pinCode!: number;
    contactName!: string | undefined;
    contactEmail!: string | undefined;
    contactMobile!: string | undefined;
    gstIN!: string | undefined;
    id!: number;

    constructor(data?: IContratorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.streetAddress = _data["streetAddress"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.pinCode = _data["pinCode"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.contactMobile = _data["contactMobile"];
            this.gstIN = _data["gstIN"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ContratorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContratorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["streetAddress"] = this.streetAddress;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["pinCode"] = this.pinCode;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["contactMobile"] = this.contactMobile;
        data["gstIN"] = this.gstIN;
        data["id"] = this.id;
        return data;
    }
}

export interface IContratorDto {
    name: string | undefined;
    streetAddress: string | undefined;
    city: string | undefined;
    state: number;
    country: number;
    pinCode: number;
    contactName: string | undefined;
    contactEmail: string | undefined;
    contactMobile: string | undefined;
    gstIN: string | undefined;
    id: number;
}

export class GetContratorForViewDto implements IGetContratorForViewDto {
    contrator!: ContratorDto;
    state!: string | undefined;
    country!: string | undefined;

    constructor(data?: IGetContratorForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contrator = _data["contrator"] ? ContratorDto.fromJS(_data["contrator"]) : <any>undefined;
            this.state = _data["state"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): GetContratorForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetContratorForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contrator"] = this.contrator ? this.contrator.toJSON() : <any>undefined;
        data["state"] = this.state;
        data["country"] = this.country;
        return data;
    }
}

export interface IGetContratorForViewDto {
    contrator: ContratorDto;
    state: string | undefined;
    country: string | undefined;
}

export class PagedResultDtoOfGetContratorForViewDto implements IPagedResultDtoOfGetContratorForViewDto {
    totalCount!: number;
    items!: GetContratorForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetContratorForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetContratorForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetContratorForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetContratorForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetContratorForViewDto {
    totalCount: number;
    items: GetContratorForViewDto[] | undefined;
}

export class CreateOrEditContratorDto implements ICreateOrEditContratorDto {
    name!: string | undefined;
    streetAddress!: string;
    city!: string | undefined;
    state!: number;
    country!: number;
    pinCode!: number;
    contactName!: string | undefined;
    contactEmail!: string | undefined;
    contactMobile!: string | undefined;
    gstIN!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditContratorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.streetAddress = _data["streetAddress"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.pinCode = _data["pinCode"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.contactMobile = _data["contactMobile"];
            this.gstIN = _data["gstIN"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditContratorDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditContratorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["streetAddress"] = this.streetAddress;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["pinCode"] = this.pinCode;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["contactMobile"] = this.contactMobile;
        data["gstIN"] = this.gstIN;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditContratorDto {
    name: string | undefined;
    streetAddress: string;
    city: string | undefined;
    state: number;
    country: number;
    pinCode: number;
    contactName: string | undefined;
    contactEmail: string | undefined;
    contactMobile: string | undefined;
    gstIN: string | undefined;
    id: number | undefined;
}

export class GetContratorForEditOutput implements IGetContratorForEditOutput {
    contrator!: CreateOrEditContratorDto;

    constructor(data?: IGetContratorForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contrator = _data["contrator"] ? CreateOrEditContratorDto.fromJS(_data["contrator"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetContratorForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetContratorForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contrator"] = this.contrator ? this.contrator.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetContratorForEditOutput {
    contrator: CreateOrEditContratorDto;
}

export class ColumnValue implements IColumnValue {
    columnName!: string | undefined;
    format!: boolean;

    constructor(data?: IColumnValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.columnName = _data["columnName"];
            this.format = _data["format"];
        }
    }

    static fromJS(data: any): ColumnValue {
        data = typeof data === 'object' ? data : {};
        let result = new ColumnValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["columnName"] = this.columnName;
        data["format"] = this.format;
        return data;
    }
}

export interface IColumnValue {
    columnName: string | undefined;
    format: boolean;
}

export class RowValue implements IRowValue {
    columnName!: string | undefined;
    rowvalue!: string | undefined;
    format!: boolean;
    isBold!: boolean;

    constructor(data?: IRowValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.columnName = _data["columnName"];
            this.rowvalue = _data["rowvalue"];
            this.format = _data["format"];
            this.isBold = _data["isBold"];
        }
    }

    static fromJS(data: any): RowValue {
        data = typeof data === 'object' ? data : {};
        let result = new RowValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["columnName"] = this.columnName;
        data["rowvalue"] = this.rowvalue;
        data["format"] = this.format;
        data["isBold"] = this.isBold;
        return data;
    }
}

export interface IRowValue {
    columnName: string | undefined;
    rowvalue: string | undefined;
    format: boolean;
    isBold: boolean;
}

export class RowValueList implements IRowValueList {
    rowvallist!: RowValue[] | undefined;

    constructor(data?: IRowValueList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rowvallist"])) {
                this.rowvallist = [] as any;
                for (let item of _data["rowvallist"])
                    this.rowvallist!.push(RowValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RowValueList {
        data = typeof data === 'object' ? data : {};
        let result = new RowValueList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rowvallist)) {
            data["rowvallist"] = [];
            for (let item of this.rowvallist)
                data["rowvallist"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRowValueList {
    rowvallist: RowValue[] | undefined;
}

export class ClumnRowData implements IClumnRowData {
    columns!: ColumnValue[] | undefined;
    rows!: RowValueList[] | undefined;
    opening!: number;
    totalRecordS!: number;

    constructor(data?: IClumnRowData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(ColumnValue.fromJS(item));
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(RowValueList.fromJS(item));
            }
            this.opening = _data["opening"];
            this.totalRecordS = _data["totalRecordS"];
        }
    }

    static fromJS(data: any): ClumnRowData {
        data = typeof data === 'object' ? data : {};
        let result = new ClumnRowData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["opening"] = this.opening;
        data["totalRecordS"] = this.totalRecordS;
        return data;
    }
}

export interface IClumnRowData {
    columns: ColumnValue[] | undefined;
    rows: RowValueList[] | undefined;
    opening: number;
    totalRecordS: number;
}

export class CountryDto implements ICountryDto {
    name!: string | undefined;
    nationality!: string | undefined;
    id!: number;

    constructor(data?: ICountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nationality = _data["nationality"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nationality"] = this.nationality;
        data["id"] = this.id;
        return data;
    }
}

export interface ICountryDto {
    name: string | undefined;
    nationality: string | undefined;
    id: number;
}

export class GetCountryForViewDto implements IGetCountryForViewDto {
    country!: CountryDto;

    constructor(data?: IGetCountryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"] ? CountryDto.fromJS(_data["country"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCountryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCountryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCountryForViewDto {
    country: CountryDto;
}

export class PagedResultDtoOfGetCountryForViewDto implements IPagedResultDtoOfGetCountryForViewDto {
    totalCount!: number;
    items!: GetCountryForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCountryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetCountryForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCountryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCountryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCountryForViewDto {
    totalCount: number;
    items: GetCountryForViewDto[] | undefined;
}

export class CreateOrEditCountryDto implements ICreateOrEditCountryDto {
    name!: string | undefined;
    nationality!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nationality = _data["nationality"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nationality"] = this.nationality;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCountryDto {
    name: string | undefined;
    nationality: string | undefined;
    id: number | undefined;
}

export class GetCountryForEditOutput implements IGetCountryForEditOutput {
    country!: CreateOrEditCountryDto;

    constructor(data?: IGetCountryForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"] ? CreateOrEditCountryDto.fromJS(_data["country"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCountryForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCountryForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCountryForEditOutput {
    country: CreateOrEditCountryDto;
}

export class Customer implements ICustomer {
    tenantId!: number | undefined;
    name!: string | undefined;
    address!: string | undefined;
    stateId!: number | undefined;
    countryId!: number | undefined;
    organizationName!: string | undefined;
    contactPersonName!: string | undefined;
    mobileNo!: string | undefined;
    designation!: string | undefined;
    email!: string | undefined;
    city!: string | undefined;
    district!: string | undefined;
    pinCode!: string | undefined;
    customerType!: string | undefined;
    leadSource!: string | undefined;
    id!: number;

    constructor(data?: ICustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.stateId = _data["stateId"];
            this.countryId = _data["countryId"];
            this.organizationName = _data["organizationName"];
            this.contactPersonName = _data["contactPersonName"];
            this.mobileNo = _data["mobileNo"];
            this.designation = _data["designation"];
            this.email = _data["email"];
            this.city = _data["city"];
            this.district = _data["district"];
            this.pinCode = _data["pinCode"];
            this.customerType = _data["customerType"];
            this.leadSource = _data["leadSource"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["address"] = this.address;
        data["stateId"] = this.stateId;
        data["countryId"] = this.countryId;
        data["organizationName"] = this.organizationName;
        data["contactPersonName"] = this.contactPersonName;
        data["mobileNo"] = this.mobileNo;
        data["designation"] = this.designation;
        data["email"] = this.email;
        data["city"] = this.city;
        data["district"] = this.district;
        data["pinCode"] = this.pinCode;
        data["customerType"] = this.customerType;
        data["leadSource"] = this.leadSource;
        data["id"] = this.id;
        return data;
    }
}

export interface ICustomer {
    tenantId: number | undefined;
    name: string | undefined;
    address: string | undefined;
    stateId: number | undefined;
    countryId: number | undefined;
    organizationName: string | undefined;
    contactPersonName: string | undefined;
    mobileNo: string | undefined;
    designation: string | undefined;
    email: string | undefined;
    city: string | undefined;
    district: string | undefined;
    pinCode: string | undefined;
    customerType: string | undefined;
    leadSource: string | undefined;
    id: number;
}

export class GetCustomerDto implements IGetCustomerDto {
    id!: number;
    state!: string | undefined;
    country!: string | undefined;
    name!: string | undefined;
    address!: string | undefined;
    organizationName!: string | undefined;
    contactPersonName!: string | undefined;
    mobileNo!: string | undefined;
    designation!: string | undefined;
    email!: string | undefined;
    city!: string | undefined;
    district!: string | undefined;
    pinCode!: string | undefined;
    customerType!: string | undefined;
    leadSource!: string | undefined;

    constructor(data?: IGetCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.organizationName = _data["organizationName"];
            this.contactPersonName = _data["contactPersonName"];
            this.mobileNo = _data["mobileNo"];
            this.designation = _data["designation"];
            this.email = _data["email"];
            this.city = _data["city"];
            this.district = _data["district"];
            this.pinCode = _data["pinCode"];
            this.customerType = _data["customerType"];
            this.leadSource = _data["leadSource"];
        }
    }

    static fromJS(data: any): GetCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["state"] = this.state;
        data["country"] = this.country;
        data["name"] = this.name;
        data["address"] = this.address;
        data["organizationName"] = this.organizationName;
        data["contactPersonName"] = this.contactPersonName;
        data["mobileNo"] = this.mobileNo;
        data["designation"] = this.designation;
        data["email"] = this.email;
        data["city"] = this.city;
        data["district"] = this.district;
        data["pinCode"] = this.pinCode;
        data["customerType"] = this.customerType;
        data["leadSource"] = this.leadSource;
        return data;
    }
}

export interface IGetCustomerDto {
    id: number;
    state: string | undefined;
    country: string | undefined;
    name: string | undefined;
    address: string | undefined;
    organizationName: string | undefined;
    contactPersonName: string | undefined;
    mobileNo: string | undefined;
    designation: string | undefined;
    email: string | undefined;
    city: string | undefined;
    district: string | undefined;
    pinCode: string | undefined;
    customerType: string | undefined;
    leadSource: string | undefined;
}

export class CreateOrEditCustomerMappingDtos implements ICreateOrEditCustomerMappingDtos {
    id!: number | undefined;
    employeeId!: number;
    employeeCode!: string | undefined;
    employeeName!: string | undefined;
    designationName!: string | undefined;
    createdOn!: moment.Moment | undefined;
    createdBy!: number | undefined;
    updatedOn!: moment.Moment | undefined;
    updatedBy!: number | undefined;
    customerId!: number[] | undefined;
    ids!: number | undefined;

    constructor(data?: ICreateOrEditCustomerMappingDtos) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.employeeCode = _data["employeeCode"];
            this.employeeName = _data["employeeName"];
            this.designationName = _data["designationName"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? moment(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            if (Array.isArray(_data["customerId"])) {
                this.customerId = [] as any;
                for (let item of _data["customerId"])
                    this.customerId!.push(item);
            }
            this.ids = _data["ids"];
        }
    }

    static fromJS(data: any): CreateOrEditCustomerMappingDtos {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCustomerMappingDtos();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["employeeCode"] = this.employeeCode;
        data["employeeName"] = this.employeeName;
        data["designationName"] = this.designationName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        if (Array.isArray(this.customerId)) {
            data["customerId"] = [];
            for (let item of this.customerId)
                data["customerId"].push(item);
        }
        data["ids"] = this.ids;
        return data;
    }
}

export interface ICreateOrEditCustomerMappingDtos {
    id: number | undefined;
    employeeId: number;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    designationName: string | undefined;
    createdOn: moment.Moment | undefined;
    createdBy: number | undefined;
    updatedOn: moment.Moment | undefined;
    updatedBy: number | undefined;
    customerId: number[] | undefined;
    ids: number | undefined;
}

export class GetCustomerMappingForEditOutput implements IGetCustomerMappingForEditOutput {
    customerMapping!: CreateOrEditCustomerMappingDtos;
    customerName!: string[] | undefined;

    constructor(data?: IGetCustomerMappingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerMapping = _data["customerMapping"] ? CreateOrEditCustomerMappingDtos.fromJS(_data["customerMapping"]) : <any>undefined;
            if (Array.isArray(_data["customerName"])) {
                this.customerName = [] as any;
                for (let item of _data["customerName"])
                    this.customerName!.push(item);
            }
        }
    }

    static fromJS(data: any): GetCustomerMappingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerMappingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerMapping"] = this.customerMapping ? this.customerMapping.toJSON() : <any>undefined;
        if (Array.isArray(this.customerName)) {
            data["customerName"] = [];
            for (let item of this.customerName)
                data["customerName"].push(item);
        }
        return data;
    }
}

export interface IGetCustomerMappingForEditOutput {
    customerMapping: CreateOrEditCustomerMappingDtos;
    customerName: string[] | undefined;
}

export class CustomerDto implements ICustomerDto {
    customerName!: string[] | undefined;

    constructor(data?: ICustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customerName"])) {
                this.customerName = [] as any;
                for (let item of _data["customerName"])
                    this.customerName!.push(item);
            }
        }
    }

    static fromJS(data: any): CustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customerName)) {
            data["customerName"] = [];
            for (let item of this.customerName)
                data["customerName"].push(item);
        }
        return data;
    }
}

export interface ICustomerDto {
    customerName: string[] | undefined;
}

export class VisitEmpdtos implements IVisitEmpdtos {
    id!: number | undefined;
    tenantId!: number | undefined;
    visitDate!: moment.Moment;
    employeeId!: number | undefined;
    employeeCode!: string | undefined;
    employeeName!: string | undefined;
    remarks!: string | undefined;
    customerId!: number;
    customerName!: string | undefined;
    visit_In_Location!: string | undefined;
    visit_out_Loaction!: string | undefined;
    visit_In_Long!: string | undefined;
    visit_In_Latt!: string | undefined;
    visit_Out_Long!: string | undefined;
    visit_Out_Latt!: string | undefined;
    visit_In_time!: string;
    visit_out_time!: string;
    image!: string | undefined;
    imageOut!: string | undefined;

    constructor(data?: IVisitEmpdtos) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.visitDate = _data["visitDate"] ? moment(_data["visitDate"].toString()) : <any>undefined;
            this.employeeId = _data["employeeId"];
            this.employeeCode = _data["employeeCode"];
            this.employeeName = _data["employeeName"];
            this.remarks = _data["remarks"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.visit_In_Location = _data["visit_In_Location"];
            this.visit_out_Loaction = _data["visit_out_Loaction"];
            this.visit_In_Long = _data["visit_In_Long"];
            this.visit_In_Latt = _data["visit_In_Latt"];
            this.visit_Out_Long = _data["visit_Out_Long"];
            this.visit_Out_Latt = _data["visit_Out_Latt"];
            this.visit_In_time = _data["visit_In_time"];
            this.visit_out_time = _data["visit_out_time"];
            this.image = _data["image"];
            this.imageOut = _data["imageOut"];
        }
    }

    static fromJS(data: any): VisitEmpdtos {
        data = typeof data === 'object' ? data : {};
        let result = new VisitEmpdtos();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["visitDate"] = this.visitDate ? this.visitDate.toISOString() : <any>undefined;
        data["employeeId"] = this.employeeId;
        data["employeeCode"] = this.employeeCode;
        data["employeeName"] = this.employeeName;
        data["remarks"] = this.remarks;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["visit_In_Location"] = this.visit_In_Location;
        data["visit_out_Loaction"] = this.visit_out_Loaction;
        data["visit_In_Long"] = this.visit_In_Long;
        data["visit_In_Latt"] = this.visit_In_Latt;
        data["visit_Out_Long"] = this.visit_Out_Long;
        data["visit_Out_Latt"] = this.visit_Out_Latt;
        data["visit_In_time"] = this.visit_In_time;
        data["visit_out_time"] = this.visit_out_time;
        data["image"] = this.image;
        data["imageOut"] = this.imageOut;
        return data;
    }
}

export interface IVisitEmpdtos {
    id: number | undefined;
    tenantId: number | undefined;
    visitDate: moment.Moment;
    employeeId: number | undefined;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    remarks: string | undefined;
    customerId: number;
    customerName: string | undefined;
    visit_In_Location: string | undefined;
    visit_out_Loaction: string | undefined;
    visit_In_Long: string | undefined;
    visit_In_Latt: string | undefined;
    visit_Out_Long: string | undefined;
    visit_Out_Latt: string | undefined;
    visit_In_time: string;
    visit_out_time: string;
    image: string | undefined;
    imageOut: string | undefined;
}

export class ValueTupleOfInt32ListOfVisitEmpdtos implements IValueTupleOfInt32ListOfVisitEmpdtos {
    item1!: number;
    item2!: VisitEmpdtos[] | undefined;

    constructor(data?: IValueTupleOfInt32ListOfVisitEmpdtos) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item1 = _data["item1"];
            if (Array.isArray(_data["item2"])) {
                this.item2 = [] as any;
                for (let item of _data["item2"])
                    this.item2!.push(VisitEmpdtos.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValueTupleOfInt32ListOfVisitEmpdtos {
        data = typeof data === 'object' ? data : {};
        let result = new ValueTupleOfInt32ListOfVisitEmpdtos();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1;
        if (Array.isArray(this.item2)) {
            data["item2"] = [];
            for (let item of this.item2)
                data["item2"].push(item.toJSON());
        }
        return data;
    }
}

export interface IValueTupleOfInt32ListOfVisitEmpdtos {
    item1: number;
    item2: VisitEmpdtos[] | undefined;
}

export class EmployeeVisitSummaryDto implements IEmployeeVisitSummaryDto {
    id!: number;
    employeeId!: number;
    employeeName!: string | undefined;
    visitCount!: number;
    visitDate!: moment.Moment | undefined;
    dayStartTime!: string | undefined;
    dayEndTime!: string | undefined;

    constructor(data?: IEmployeeVisitSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.visitCount = _data["visitCount"];
            this.visitDate = _data["visitDate"] ? moment(_data["visitDate"].toString()) : <any>undefined;
            this.dayStartTime = _data["dayStartTime"];
            this.dayEndTime = _data["dayEndTime"];
        }
    }

    static fromJS(data: any): EmployeeVisitSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeVisitSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["visitCount"] = this.visitCount;
        data["visitDate"] = this.visitDate ? this.visitDate.toISOString() : <any>undefined;
        data["dayStartTime"] = this.dayStartTime;
        data["dayEndTime"] = this.dayEndTime;
        return data;
    }
}

export interface IEmployeeVisitSummaryDto {
    id: number;
    employeeId: number;
    employeeName: string | undefined;
    visitCount: number;
    visitDate: moment.Moment | undefined;
    dayStartTime: string | undefined;
    dayEndTime: string | undefined;
}

export class ValueTupleOfListOfEmployeeVisitSummaryDtoInt32 implements IValueTupleOfListOfEmployeeVisitSummaryDtoInt32 {
    item1!: EmployeeVisitSummaryDto[] | undefined;
    item2!: number;

    constructor(data?: IValueTupleOfListOfEmployeeVisitSummaryDtoInt32) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["item1"])) {
                this.item1 = [] as any;
                for (let item of _data["item1"])
                    this.item1!.push(EmployeeVisitSummaryDto.fromJS(item));
            }
            this.item2 = _data["item2"];
        }
    }

    static fromJS(data: any): ValueTupleOfListOfEmployeeVisitSummaryDtoInt32 {
        data = typeof data === 'object' ? data : {};
        let result = new ValueTupleOfListOfEmployeeVisitSummaryDtoInt32();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.item1)) {
            data["item1"] = [];
            for (let item of this.item1)
                data["item1"].push(item.toJSON());
        }
        data["item2"] = this.item2;
        return data;
    }
}

export interface IValueTupleOfListOfEmployeeVisitSummaryDtoInt32 {
    item1: EmployeeVisitSummaryDto[] | undefined;
    item2: number;
}

export class DataCaptureHeaderDto implements IDataCaptureHeaderDto {
    id!: number;
    dateCaptured!: moment.Moment;
    employeeId!: number;

    constructor(data?: IDataCaptureHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateCaptured = _data["dateCaptured"] ? moment(_data["dateCaptured"].toString()) : <any>undefined;
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): DataCaptureHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataCaptureHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateCaptured"] = this.dateCaptured ? this.dateCaptured.toISOString() : <any>undefined;
        data["employeeId"] = this.employeeId;
        return data;
    }
}

export interface IDataCaptureHeaderDto {
    id: number;
    dateCaptured: moment.Moment;
    employeeId: number;
}

export class DataCaptureDetailDto implements IDataCaptureDetailDto {
    id!: number;
    fk_KpiDataCapture!: number;
    fk_KPI_KRA_Criteria_Id!: number;
    measurable!: string | undefined;
    actualValue!: number;
    comments!: string | undefined;

    constructor(data?: IDataCaptureDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fk_KpiDataCapture = _data["fk_KpiDataCapture"];
            this.fk_KPI_KRA_Criteria_Id = _data["fk_KPI_KRA_Criteria_Id"];
            this.measurable = _data["measurable"];
            this.actualValue = _data["actualValue"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): DataCaptureDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataCaptureDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fk_KpiDataCapture"] = this.fk_KpiDataCapture;
        data["fk_KPI_KRA_Criteria_Id"] = this.fk_KPI_KRA_Criteria_Id;
        data["measurable"] = this.measurable;
        data["actualValue"] = this.actualValue;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IDataCaptureDetailDto {
    id: number;
    fk_KpiDataCapture: number;
    fk_KPI_KRA_Criteria_Id: number;
    measurable: string | undefined;
    actualValue: number;
    comments: string | undefined;
}

export class GetDataCaptureForViewDto implements IGetDataCaptureForViewDto {
    id!: number;
    dateCaptured!: moment.Moment;
    employeeId!: number | undefined;
    tenantId!: number;
    employee!: string | undefined;
    designation!: string | undefined;
    employeeName!: string | undefined;
    dataCaptureHeader!: DataCaptureHeaderDto;
    dataCaptureDetails!: DataCaptureDetailDto[] | undefined;

    constructor(data?: IGetDataCaptureForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateCaptured = _data["dateCaptured"] ? moment(_data["dateCaptured"].toString()) : <any>undefined;
            this.employeeId = _data["employeeId"];
            this.tenantId = _data["tenantId"];
            this.employee = _data["employee"];
            this.designation = _data["designation"];
            this.employeeName = _data["employeeName"];
            this.dataCaptureHeader = _data["dataCaptureHeader"] ? DataCaptureHeaderDto.fromJS(_data["dataCaptureHeader"]) : <any>undefined;
            if (Array.isArray(_data["dataCaptureDetails"])) {
                this.dataCaptureDetails = [] as any;
                for (let item of _data["dataCaptureDetails"])
                    this.dataCaptureDetails!.push(DataCaptureDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDataCaptureForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataCaptureForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateCaptured"] = this.dateCaptured ? this.dateCaptured.toISOString() : <any>undefined;
        data["employeeId"] = this.employeeId;
        data["tenantId"] = this.tenantId;
        data["employee"] = this.employee;
        data["designation"] = this.designation;
        data["employeeName"] = this.employeeName;
        data["dataCaptureHeader"] = this.dataCaptureHeader ? this.dataCaptureHeader.toJSON() : <any>undefined;
        if (Array.isArray(this.dataCaptureDetails)) {
            data["dataCaptureDetails"] = [];
            for (let item of this.dataCaptureDetails)
                data["dataCaptureDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDataCaptureForViewDto {
    id: number;
    dateCaptured: moment.Moment;
    employeeId: number | undefined;
    tenantId: number;
    employee: string | undefined;
    designation: string | undefined;
    employeeName: string | undefined;
    dataCaptureHeader: DataCaptureHeaderDto;
    dataCaptureDetails: DataCaptureDetailDto[] | undefined;
}

export class PagedResultDtoOfGetDataCaptureForViewDto implements IPagedResultDtoOfGetDataCaptureForViewDto {
    totalCount!: number;
    items!: GetDataCaptureForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetDataCaptureForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetDataCaptureForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetDataCaptureForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetDataCaptureForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetDataCaptureForViewDto {
    totalCount: number;
    items: GetDataCaptureForViewDto[] | undefined;
}

export class GetEmployeeKRADataDetailsForView implements IGetEmployeeKRADataDetailsForView {
    kranAme!: string | undefined;
    actualValue!: number;
    comment!: string | undefined;
    feedback_value!: string | undefined;
    kpiPolicyKraId!: number;
    measurable!: string;
    kraId!: number;
    subKraCount!: number;

    constructor(data?: IGetEmployeeKRADataDetailsForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kranAme = _data["kranAme"];
            this.actualValue = _data["actualValue"];
            this.comment = _data["comment"];
            this.feedback_value = _data["feedback_value"];
            this.kpiPolicyKraId = _data["kpiPolicyKraId"];
            this.measurable = _data["measurable"];
            this.kraId = _data["kraId"];
            this.subKraCount = _data["subKraCount"];
        }
    }

    static fromJS(data: any): GetEmployeeKRADataDetailsForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeKRADataDetailsForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kranAme"] = this.kranAme;
        data["actualValue"] = this.actualValue;
        data["comment"] = this.comment;
        data["feedback_value"] = this.feedback_value;
        data["kpiPolicyKraId"] = this.kpiPolicyKraId;
        data["measurable"] = this.measurable;
        data["kraId"] = this.kraId;
        data["subKraCount"] = this.subKraCount;
        return data;
    }
}

export interface IGetEmployeeKRADataDetailsForView {
    kranAme: string | undefined;
    actualValue: number;
    comment: string | undefined;
    feedback_value: string | undefined;
    kpiPolicyKraId: number;
    measurable: string;
    kraId: number;
    subKraCount: number;
}

export class GetEmployeeKRADataForView implements IGetEmployeeKRADataForView {
    employeeName!: string | undefined;
    employeeId!: number;
    datacaptured!: moment.Moment;
    designation!: string | undefined;
    getEmployeeKRADataDetailsForViews!: GetEmployeeKRADataDetailsForView[] | undefined;

    constructor(data?: IGetEmployeeKRADataForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeName = _data["employeeName"];
            this.employeeId = _data["employeeId"];
            this.datacaptured = _data["datacaptured"] ? moment(_data["datacaptured"].toString()) : <any>undefined;
            this.designation = _data["designation"];
            if (Array.isArray(_data["getEmployeeKRADataDetailsForViews"])) {
                this.getEmployeeKRADataDetailsForViews = [] as any;
                for (let item of _data["getEmployeeKRADataDetailsForViews"])
                    this.getEmployeeKRADataDetailsForViews!.push(GetEmployeeKRADataDetailsForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEmployeeKRADataForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeKRADataForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeName"] = this.employeeName;
        data["employeeId"] = this.employeeId;
        data["datacaptured"] = this.datacaptured ? this.datacaptured.toISOString() : <any>undefined;
        data["designation"] = this.designation;
        if (Array.isArray(this.getEmployeeKRADataDetailsForViews)) {
            data["getEmployeeKRADataDetailsForViews"] = [];
            for (let item of this.getEmployeeKRADataDetailsForViews)
                data["getEmployeeKRADataDetailsForViews"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEmployeeKRADataForView {
    employeeName: string | undefined;
    employeeId: number;
    datacaptured: moment.Moment;
    designation: string | undefined;
    getEmployeeKRADataDetailsForViews: GetEmployeeKRADataDetailsForView[] | undefined;
}

export class CreateOrEditDataCaptureDetail implements ICreateOrEditDataCaptureDetail {
    actualValue!: number;
    comment!: string | undefined;
    dataCaptureId!: number;
    fkCriteriaId!: number;
    tenantId!: number;
    measurable!: string | undefined;
    kpiPolicyKraId!: number;
    id!: number;

    constructor(data?: ICreateOrEditDataCaptureDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actualValue = _data["actualValue"];
            this.comment = _data["comment"];
            this.dataCaptureId = _data["dataCaptureId"];
            this.fkCriteriaId = _data["fkCriteriaId"];
            this.tenantId = _data["tenantId"];
            this.measurable = _data["measurable"];
            this.kpiPolicyKraId = _data["kpiPolicyKraId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditDataCaptureDetail {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditDataCaptureDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actualValue"] = this.actualValue;
        data["comment"] = this.comment;
        data["dataCaptureId"] = this.dataCaptureId;
        data["fkCriteriaId"] = this.fkCriteriaId;
        data["tenantId"] = this.tenantId;
        data["measurable"] = this.measurable;
        data["kpiPolicyKraId"] = this.kpiPolicyKraId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditDataCaptureDetail {
    actualValue: number;
    comment: string | undefined;
    dataCaptureId: number;
    fkCriteriaId: number;
    tenantId: number;
    measurable: string | undefined;
    kpiPolicyKraId: number;
    id: number;
}

export class CreateorEditDataCaptureDto implements ICreateorEditDataCaptureDto {
    dateCaptured!: moment.Moment | undefined;
    employeeId!: number | undefined;
    tenantId!: number;
    dataCaptureDetailedData!: CreateOrEditDataCaptureDetail[] | undefined;
    id!: number;

    constructor(data?: ICreateorEditDataCaptureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCaptured = _data["dateCaptured"] ? moment(_data["dateCaptured"].toString()) : <any>undefined;
            this.employeeId = _data["employeeId"];
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["dataCaptureDetailedData"])) {
                this.dataCaptureDetailedData = [] as any;
                for (let item of _data["dataCaptureDetailedData"])
                    this.dataCaptureDetailedData!.push(CreateOrEditDataCaptureDetail.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateorEditDataCaptureDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateorEditDataCaptureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCaptured"] = this.dateCaptured ? this.dateCaptured.toISOString() : <any>undefined;
        data["employeeId"] = this.employeeId;
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.dataCaptureDetailedData)) {
            data["dataCaptureDetailedData"] = [];
            for (let item of this.dataCaptureDetailedData)
                data["dataCaptureDetailedData"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateorEditDataCaptureDto {
    dateCaptured: moment.Moment | undefined;
    employeeId: number | undefined;
    tenantId: number;
    dataCaptureDetailedData: CreateOrEditDataCaptureDetail[] | undefined;
    id: number;
}

export class EmployeeKraDto implements IEmployeeKraDto {
    employeeId!: number;
    employeeName!: string | undefined;
    kraName!: string | undefined;
    comment!: string | undefined;
    measurable!: string;
    designation!: string | undefined;
    actualValue!: number;
    kpiPolicyKraId!: number;

    constructor(data?: IEmployeeKraDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.kraName = _data["kraName"];
            this.comment = _data["comment"];
            this.measurable = _data["measurable"];
            this.designation = _data["designation"];
            this.actualValue = _data["actualValue"];
            this.kpiPolicyKraId = _data["kpiPolicyKraId"];
        }
    }

    static fromJS(data: any): EmployeeKraDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeKraDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["kraName"] = this.kraName;
        data["comment"] = this.comment;
        data["measurable"] = this.measurable;
        data["designation"] = this.designation;
        data["actualValue"] = this.actualValue;
        data["kpiPolicyKraId"] = this.kpiPolicyKraId;
        return data;
    }
}

export interface IEmployeeKraDto {
    employeeId: number;
    employeeName: string | undefined;
    kraName: string | undefined;
    comment: string | undefined;
    measurable: string;
    designation: string | undefined;
    actualValue: number;
    kpiPolicyKraId: number;
}

export class DateToStringOutput implements IDateToStringOutput {
    dateString!: string | undefined;

    constructor(data?: IDateToStringOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateString = _data["dateString"];
        }
    }

    static fromJS(data: any): DateToStringOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DateToStringOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateString"] = this.dateString;
        return data;
    }
}

export interface IDateToStringOutput {
    dateString: string | undefined;
}

export class NameValueOfString implements INameValueOfString {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValueOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValueOfString {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValueOfString {
    name: string | undefined;
    value: string | undefined;
}

export class StringOutput implements IStringOutput {
    output!: string | undefined;

    constructor(data?: IStringOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.output = _data["output"];
        }
    }

    static fromJS(data: any): StringOutput {
        data = typeof data === 'object' ? data : {};
        let result = new StringOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["output"] = this.output;
        return data;
    }
}

export interface IStringOutput {
    output: string | undefined;
}

export class PagedResultDtoOfGetDepartmentsForViewDto implements IPagedResultDtoOfGetDepartmentsForViewDto {
    totalCount!: number;
    items!: GetDepartmentsForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetDepartmentsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetDepartmentsForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetDepartmentsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetDepartmentsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetDepartmentsForViewDto {
    totalCount: number;
    items: GetDepartmentsForViewDto[] | undefined;
}

export class CreateOrEditDepartmentsDto implements ICreateOrEditDepartmentsDto {
    name!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditDepartmentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditDepartmentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditDepartmentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditDepartmentsDto {
    name: string | undefined;
    id: number | undefined;
}

export class GetDepartmentsForEditOutput implements IGetDepartmentsForEditOutput {
    departments!: CreateOrEditDepartmentsDto;

    constructor(data?: IGetDepartmentsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departments = _data["departments"] ? CreateOrEditDepartmentsDto.fromJS(_data["departments"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDepartmentsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDepartmentsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departments"] = this.departments ? this.departments.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDepartmentsForEditOutput {
    departments: CreateOrEditDepartmentsDto;
}

export class DesignationDto implements IDesignationDto {
    name!: string | undefined;
    id!: number;

    constructor(data?: IDesignationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DesignationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DesignationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IDesignationDto {
    name: string | undefined;
    id: number;
}

export class GetDesignationForViewDto implements IGetDesignationForViewDto {
    designation!: DesignationDto;

    constructor(data?: IGetDesignationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.designation = _data["designation"] ? DesignationDto.fromJS(_data["designation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDesignationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDesignationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["designation"] = this.designation ? this.designation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDesignationForViewDto {
    designation: DesignationDto;
}

export class PagedResultDtoOfGetDesignationForViewDto implements IPagedResultDtoOfGetDesignationForViewDto {
    totalCount!: number;
    items!: GetDesignationForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetDesignationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetDesignationForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetDesignationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetDesignationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetDesignationForViewDto {
    totalCount: number;
    items: GetDesignationForViewDto[] | undefined;
}

export class CreateOrEditDesignationDto implements ICreateOrEditDesignationDto {
    name!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditDesignationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditDesignationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditDesignationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditDesignationDto {
    name: string | undefined;
    id: number | undefined;
}

export class GetDesignationForEditOutput implements IGetDesignationForEditOutput {
    designation!: CreateOrEditDesignationDto;

    constructor(data?: IGetDesignationForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.designation = _data["designation"] ? CreateOrEditDesignationDto.fromJS(_data["designation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDesignationForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDesignationForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["designation"] = this.designation ? this.designation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDesignationForEditOutput {
    designation: CreateOrEditDesignationDto;
}

export class DivisionDto implements IDivisionDto {
    name!: string | undefined;
    id!: number;

    constructor(data?: IDivisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DivisionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DivisionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IDivisionDto {
    name: string | undefined;
    id: number;
}

export class GetDivisionForViewDto implements IGetDivisionForViewDto {
    division!: DivisionDto;

    constructor(data?: IGetDivisionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.division = _data["division"] ? DivisionDto.fromJS(_data["division"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDivisionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDivisionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["division"] = this.division ? this.division.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDivisionForViewDto {
    division: DivisionDto;
}

export class PagedResultDtoOfGetDivisionForViewDto implements IPagedResultDtoOfGetDivisionForViewDto {
    totalCount!: number;
    items!: GetDivisionForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetDivisionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetDivisionForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetDivisionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetDivisionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetDivisionForViewDto {
    totalCount: number;
    items: GetDivisionForViewDto[] | undefined;
}

export class CreateOrEditDivisionDto implements ICreateOrEditDivisionDto {
    name!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditDivisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditDivisionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditDivisionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditDivisionDto {
    name: string | undefined;
    id: number | undefined;
}

export class GetDivisionForEditOutput implements IGetDivisionForEditOutput {
    division!: CreateOrEditDivisionDto;

    constructor(data?: IGetDivisionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.division = _data["division"] ? CreateOrEditDivisionDto.fromJS(_data["division"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDivisionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDivisionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["division"] = this.division ? this.division.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDivisionForEditOutput {
    division: CreateOrEditDivisionDto;
}

export class DocumentTypeDto implements IDocumentTypeDto {
    name!: string | undefined;
    description!: string | undefined;
    mandatory!: boolean;
    id!: number;

    constructor(data?: IDocumentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.mandatory = _data["mandatory"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DocumentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["mandatory"] = this.mandatory;
        data["id"] = this.id;
        return data;
    }
}

export interface IDocumentTypeDto {
    name: string | undefined;
    description: string | undefined;
    mandatory: boolean;
    id: number;
}

export class GetDocumentTypeForViewDto implements IGetDocumentTypeForViewDto {
    documentType!: DocumentTypeDto;

    constructor(data?: IGetDocumentTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentType = _data["documentType"] ? DocumentTypeDto.fromJS(_data["documentType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDocumentTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType ? this.documentType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDocumentTypeForViewDto {
    documentType: DocumentTypeDto;
}

export class PagedResultDtoOfGetDocumentTypeForViewDto implements IPagedResultDtoOfGetDocumentTypeForViewDto {
    totalCount!: number;
    items!: GetDocumentTypeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetDocumentTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetDocumentTypeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetDocumentTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetDocumentTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetDocumentTypeForViewDto {
    totalCount: number;
    items: GetDocumentTypeForViewDto[] | undefined;
}

export class CreateOrEditDocumentTypeDto implements ICreateOrEditDocumentTypeDto {
    name!: string | undefined;
    description!: string | undefined;
    mandatory!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditDocumentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.mandatory = _data["mandatory"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditDocumentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditDocumentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["mandatory"] = this.mandatory;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditDocumentTypeDto {
    name: string | undefined;
    description: string | undefined;
    mandatory: boolean;
    id: number | undefined;
}

export class GetDocumentTypeForEditOutput implements IGetDocumentTypeForEditOutput {
    documentType!: CreateOrEditDocumentTypeDto;

    constructor(data?: IGetDocumentTypeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentType = _data["documentType"] ? CreateOrEditDocumentTypeDto.fromJS(_data["documentType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDocumentTypeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentTypeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType ? this.documentType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDocumentTypeForEditOutput {
    documentType: CreateOrEditDocumentTypeDto;
}

export class AttendanceDetailsPanel implements IAttendanceDetailsPanel {
    title!: string | undefined;
    start!: string | undefined;
    color!: string | undefined;

    constructor(data?: IAttendanceDetailsPanel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.start = _data["start"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): AttendanceDetailsPanel {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceDetailsPanel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["start"] = this.start;
        data["color"] = this.color;
        return data;
    }
}

export interface IAttendanceDetailsPanel {
    title: string | undefined;
    start: string | undefined;
    color: string | undefined;
}

export class AttendanceInOutPunches implements IAttendanceInOutPunches {
    in1!: string | undefined;
    in2!: string | undefined;
    in3!: string | undefined;
    in4!: string | undefined;
    in5!: string | undefined;
    out1!: string | undefined;
    out2!: string | undefined;
    out3!: string | undefined;
    out4!: string | undefined;
    out5!: string | undefined;
    date!: string | undefined;

    constructor(data?: IAttendanceInOutPunches) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.in1 = _data["in1"];
            this.in2 = _data["in2"];
            this.in3 = _data["in3"];
            this.in4 = _data["in4"];
            this.in5 = _data["in5"];
            this.out1 = _data["out1"];
            this.out2 = _data["out2"];
            this.out3 = _data["out3"];
            this.out4 = _data["out4"];
            this.out5 = _data["out5"];
            this.date = _data["date"];
        }
    }

    static fromJS(data: any): AttendanceInOutPunches {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceInOutPunches();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["in1"] = this.in1;
        data["in2"] = this.in2;
        data["in3"] = this.in3;
        data["in4"] = this.in4;
        data["in5"] = this.in5;
        data["out1"] = this.out1;
        data["out2"] = this.out2;
        data["out3"] = this.out3;
        data["out4"] = this.out4;
        data["out5"] = this.out5;
        data["date"] = this.date;
        return data;
    }
}

export interface IAttendanceInOutPunches {
    in1: string | undefined;
    in2: string | undefined;
    in3: string | undefined;
    in4: string | undefined;
    in5: string | undefined;
    out1: string | undefined;
    out2: string | undefined;
    out3: string | undefined;
    out4: string | undefined;
    out5: string | undefined;
    date: string | undefined;
}

export class FtpDto implements IFtpDto {
    ftpServer!: string | undefined;
    ftpUsername!: string | undefined;
    ftpPassword!: string | undefined;

    constructor(data?: IFtpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ftpServer = _data["ftpServer"];
            this.ftpUsername = _data["ftpUsername"];
            this.ftpPassword = _data["ftpPassword"];
        }
    }

    static fromJS(data: any): FtpDto {
        data = typeof data === 'object' ? data : {};
        let result = new FtpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ftpServer"] = this.ftpServer;
        data["ftpUsername"] = this.ftpUsername;
        data["ftpPassword"] = this.ftpPassword;
        return data;
    }
}

export interface IFtpDto {
    ftpServer: string | undefined;
    ftpUsername: string | undefined;
    ftpPassword: string | undefined;
}

export class DropDownNature implements IDropDownNature {
    value!: number | undefined;
    label!: string | undefined;

    constructor(data?: IDropDownNature) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): DropDownNature {
        data = typeof data === 'object' ? data : {};
        let result = new DropDownNature();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }
}

export interface IDropDownNature {
    value: number | undefined;
    label: string | undefined;
}

export class AdvanceReferenceDto implements IAdvanceReferenceDto {
    id!: number;
    displayText!: string | undefined;

    constructor(data?: IAdvanceReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayText = _data["displayText"];
        }
    }

    static fromJS(data: any): AdvanceReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvanceReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayText"] = this.displayText;
        return data;
    }
}

export interface IAdvanceReferenceDto {
    id: number;
    displayText: string | undefined;
}

export class HrEmployeeDTO implements IHrEmployeeDTO {
    roleDisplayName!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    mobileNumber!: string | undefined;
    email!: string | undefined;

    constructor(data?: IHrEmployeeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleDisplayName = _data["roleDisplayName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.mobileNumber = _data["mobileNumber"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): HrEmployeeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HrEmployeeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleDisplayName"] = this.roleDisplayName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["mobileNumber"] = this.mobileNumber;
        data["email"] = this.email;
        return data;
    }
}

export interface IHrEmployeeDTO {
    roleDisplayName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    mobileNumber: string | undefined;
    email: string | undefined;
}

export class HrTenantGroupDTO implements IHrTenantGroupDTO {
    tenantName!: string | undefined;
    employees!: HrEmployeeDTO[] | undefined;

    constructor(data?: IHrTenantGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantName = _data["tenantName"];
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(HrEmployeeDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HrTenantGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HrTenantGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHrTenantGroupDTO {
    tenantName: string | undefined;
    employees: HrEmployeeDTO[] | undefined;
}

export class DropDownExpenseNatureWise implements IDropDownExpenseNatureWise {
    value!: number | undefined;
    label!: string | undefined;
    natureType!: string | undefined;

    constructor(data?: IDropDownExpenseNatureWise) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
            this.natureType = _data["natureType"];
        }
    }

    static fromJS(data: any): DropDownExpenseNatureWise {
        data = typeof data === 'object' ? data : {};
        let result = new DropDownExpenseNatureWise();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        data["natureType"] = this.natureType;
        return data;
    }
}

export interface IDropDownExpenseNatureWise {
    value: number | undefined;
    label: string | undefined;
    natureType: string | undefined;
}

export class EmployeeActiveStatus implements IEmployeeActiveStatus {
    employeeStatus!: string | undefined;
    abpUserStatus!: string | undefined;
    userSignUpStatus!: string | undefined;

    constructor(data?: IEmployeeActiveStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeStatus = _data["employeeStatus"];
            this.abpUserStatus = _data["abpUserStatus"];
            this.userSignUpStatus = _data["userSignUpStatus"];
        }
    }

    static fromJS(data: any): EmployeeActiveStatus {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeActiveStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeStatus"] = this.employeeStatus;
        data["abpUserStatus"] = this.abpUserStatus;
        data["userSignUpStatus"] = this.userSignUpStatus;
        return data;
    }
}

export interface IEmployeeActiveStatus {
    employeeStatus: string | undefined;
    abpUserStatus: string | undefined;
    userSignUpStatus: string | undefined;
}

export class DropDownCountry implements IDropDownCountry {
    value!: number;
    label!: string | undefined;
    nationality!: string | undefined;

    constructor(data?: IDropDownCountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
            this.nationality = _data["nationality"];
        }
    }

    static fromJS(data: any): DropDownCountry {
        data = typeof data === 'object' ? data : {};
        let result = new DropDownCountry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        data["nationality"] = this.nationality;
        return data;
    }
}

export interface IDropDownCountry {
    value: number;
    label: string | undefined;
    nationality: string | undefined;
}

export class LeaveBlanceDetails implements ILeaveBlanceDetails {
    total!: string | undefined;
    balance!: number | undefined;
    used!: number | undefined;
    negativeAllowed!: boolean | undefined;

    constructor(data?: ILeaveBlanceDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.balance = _data["balance"];
            this.used = _data["used"];
            this.negativeAllowed = _data["negativeAllowed"];
        }
    }

    static fromJS(data: any): LeaveBlanceDetails {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveBlanceDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["balance"] = this.balance;
        data["used"] = this.used;
        data["negativeAllowed"] = this.negativeAllowed;
        return data;
    }
}

export interface ILeaveBlanceDetails {
    total: string | undefined;
    balance: number | undefined;
    used: number | undefined;
    negativeAllowed: boolean | undefined;
}

export class DropDownLeaveType implements IDropDownLeaveType {
    value!: string | undefined;
    label!: string | undefined;

    constructor(data?: IDropDownLeaveType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): DropDownLeaveType {
        data = typeof data === 'object' ? data : {};
        let result = new DropDownLeaveType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }
}

export interface IDropDownLeaveType {
    value: string | undefined;
    label: string | undefined;
}

export class DropDownEmployee implements IDropDownEmployee {
    value!: string | undefined;
    label!: string | undefined;
    selected!: boolean;
    isAlreadyAssigned!: boolean;
    disabled!: boolean;

    constructor(data?: IDropDownEmployee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
            this.selected = _data["selected"];
            this.isAlreadyAssigned = _data["isAlreadyAssigned"];
            this.disabled = _data["disabled"];
        }
    }

    static fromJS(data: any): DropDownEmployee {
        data = typeof data === 'object' ? data : {};
        let result = new DropDownEmployee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        data["selected"] = this.selected;
        data["isAlreadyAssigned"] = this.isAlreadyAssigned;
        data["disabled"] = this.disabled;
        return data;
    }
}

export interface IDropDownEmployee {
    value: string | undefined;
    label: string | undefined;
    selected: boolean;
    isAlreadyAssigned: boolean;
    disabled: boolean;
}

export class ReviewCycleDropDown implements IReviewCycleDropDown {
    value!: string | undefined;
    label!: string | undefined;
    employeeId!: number | undefined;
    performanceCycle!: number | undefined;

    constructor(data?: IReviewCycleDropDown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
            this.employeeId = _data["employeeId"];
            this.performanceCycle = _data["performanceCycle"];
        }
    }

    static fromJS(data: any): ReviewCycleDropDown {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewCycleDropDown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        data["employeeId"] = this.employeeId;
        data["performanceCycle"] = this.performanceCycle;
        return data;
    }
}

export interface IReviewCycleDropDown {
    value: string | undefined;
    label: string | undefined;
    employeeId: number | undefined;
    performanceCycle: number | undefined;
}

export class DuesOverridesDto implements IDuesOverridesDto {
    noticePeriodBuyout!: number | undefined;
    deduction!: number | undefined;
    id!: number;

    constructor(data?: IDuesOverridesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noticePeriodBuyout = _data["noticePeriodBuyout"];
            this.deduction = _data["deduction"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DuesOverridesDto {
        data = typeof data === 'object' ? data : {};
        let result = new DuesOverridesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noticePeriodBuyout"] = this.noticePeriodBuyout;
        data["deduction"] = this.deduction;
        data["id"] = this.id;
        return data;
    }
}

export interface IDuesOverridesDto {
    noticePeriodBuyout: number | undefined;
    deduction: number | undefined;
    id: number;
}

export class GetDuesOverridesDto implements IGetDuesOverridesDto {
    duesOverrides!: DuesOverridesDto;
    id!: number | undefined;

    constructor(data?: IGetDuesOverridesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.duesOverrides = _data["duesOverrides"] ? DuesOverridesDto.fromJS(_data["duesOverrides"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetDuesOverridesDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDuesOverridesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duesOverrides"] = this.duesOverrides ? this.duesOverrides.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetDuesOverridesDto {
    duesOverrides: DuesOverridesDto;
    id: number | undefined;
}

export class EditionListDto implements IEditionListDto {
    name!: string | undefined;
    displayName!: string | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    trialDayCount!: number | undefined;
    expiringEditionDisplayName!: string | undefined;
    id!: number;

    constructor(data?: IEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.trialDayCount = _data["trialDayCount"];
            this.expiringEditionDisplayName = _data["expiringEditionDisplayName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["trialDayCount"] = this.trialDayCount;
        data["expiringEditionDisplayName"] = this.expiringEditionDisplayName;
        data["id"] = this.id;
        return data;
    }
}

export interface IEditionListDto {
    name: string | undefined;
    displayName: string | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    waitingDayAfterExpire: number | undefined;
    trialDayCount: number | undefined;
    expiringEditionDisplayName: string | undefined;
    id: number;
}

export class ListResultDtoOfEditionListDto implements IListResultDtoOfEditionListDto {
    items!: EditionListDto[] | undefined;

    constructor(data?: IListResultDtoOfEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EditionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfEditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfEditionListDto {
    items: EditionListDto[] | undefined;
}

export class EditionEditDto implements IEditionEditDto {
    id!: number | undefined;
    displayName!: string;
    expiringEditionId!: number | undefined;

    constructor(data?: IEditionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.expiringEditionId = _data["expiringEditionId"];
        }
    }

    static fromJS(data: any): EditionEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        return data;
    }
}

export interface IEditionEditDto {
    id: number | undefined;
    displayName: string;
    expiringEditionId: number | undefined;
}

export class IValueValidator implements IIValueValidator {
    readonly name!: string | undefined;
    readonly attributes!: { [key: string]: any; } | undefined;

    constructor(data?: IIValueValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            if (_data["attributes"]) {
                (<any>this).attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (<any>(<any>this).attributes)![key] = _data["attributes"][key];
                }
            }
        }
    }

    static fromJS(data: any): IValueValidator {
        data = typeof data === 'object' ? data : {};
        let result = new IValueValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (<any>data["attributes"])[key] = (<any>this.attributes)[key];
            }
        }
        return data;
    }
}

export interface IIValueValidator {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
}

export class LocalizableComboboxItemDto implements ILocalizableComboboxItemDto {
    value!: string | undefined;
    displayText!: string | undefined;

    constructor(data?: ILocalizableComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayText = _data["displayText"];
        }
    }

    static fromJS(data: any): LocalizableComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        return data;
    }
}

export interface ILocalizableComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
}

export class LocalizableComboboxItemSourceDto implements ILocalizableComboboxItemSourceDto {
    items!: LocalizableComboboxItemDto[] | undefined;

    constructor(data?: ILocalizableComboboxItemSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LocalizableComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocalizableComboboxItemSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocalizableComboboxItemSourceDto {
    items: LocalizableComboboxItemDto[] | undefined;
}

export class FeatureInputTypeDto implements IFeatureInputTypeDto {
    name!: string | undefined;
    attributes!: { [key: string]: any; } | undefined;
    validator!: IValueValidator;
    itemSource!: LocalizableComboboxItemSourceDto;

    constructor(data?: IFeatureInputTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (_data["attributes"]) {
                this.attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (<any>this.attributes)![key] = _data["attributes"][key];
                }
            }
            this.validator = _data["validator"] ? IValueValidator.fromJS(_data["validator"]) : <any>undefined;
            this.itemSource = _data["itemSource"] ? LocalizableComboboxItemSourceDto.fromJS(_data["itemSource"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FeatureInputTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureInputTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (<any>data["attributes"])[key] = (<any>this.attributes)[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        data["itemSource"] = this.itemSource ? this.itemSource.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFeatureInputTypeDto {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
    validator: IValueValidator;
    itemSource: LocalizableComboboxItemSourceDto;
}

export class FlatFeatureDto implements IFlatFeatureDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    defaultValue!: string | undefined;
    inputType!: FeatureInputTypeDto;

    constructor(data?: IFlatFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            this.inputType = _data["inputType"] ? FeatureInputTypeDto.fromJS(_data["inputType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FlatFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFlatFeatureDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: FeatureInputTypeDto;
}

export class GetEditionEditOutput implements IGetEditionEditOutput {
    edition!: EditionEditDto;
    featureValues!: NameValueDto[] | undefined;
    features!: FlatFeatureDto[] | undefined;

    constructor(data?: IGetEditionEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionEditDto.fromJS(_data["edition"]) : <any>undefined;
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditionEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEditionEditOutput {
    edition: EditionEditDto;
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class EditionCreateDto implements IEditionCreateDto {
    id!: number | undefined;
    displayName!: string;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    trialDayCount!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    expiringEditionId!: number | undefined;

    constructor(data?: IEditionCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.trialDayCount = _data["trialDayCount"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.expiringEditionId = _data["expiringEditionId"];
        }
    }

    static fromJS(data: any): EditionCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["expiringEditionId"] = this.expiringEditionId;
        return data;
    }
}

export interface IEditionCreateDto {
    id: number | undefined;
    displayName: string;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    expiringEditionId: number | undefined;
}

export class CreateEditionDto implements ICreateEditionDto {
    edition!: EditionCreateDto;
    featureValues!: NameValueDto[];

    constructor(data?: ICreateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.edition = new EditionCreateDto();
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionCreateDto.fromJS(_data["edition"]) : new EditionCreateDto();
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateEditionDto {
    edition: EditionCreateDto;
    featureValues: NameValueDto[];
}

export class UpdateEditionDto implements IUpdateEditionDto {
    edition!: EditionEditDto;
    featureValues!: NameValueDto[];

    constructor(data?: IUpdateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.edition = new EditionEditDto();
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionEditDto.fromJS(_data["edition"]) : new EditionEditDto();
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateEditionDto {
    edition: EditionEditDto;
    featureValues: NameValueDto[];
}

export class MoveTenantsToAnotherEditionDto implements IMoveTenantsToAnotherEditionDto {
    sourceEditionId!: number;
    targetEditionId!: number;

    constructor(data?: IMoveTenantsToAnotherEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceEditionId = _data["sourceEditionId"];
            this.targetEditionId = _data["targetEditionId"];
        }
    }

    static fromJS(data: any): MoveTenantsToAnotherEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveTenantsToAnotherEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceEditionId"] = this.sourceEditionId;
        data["targetEditionId"] = this.targetEditionId;
        return data;
    }
}

export interface IMoveTenantsToAnotherEditionDto {
    sourceEditionId: number;
    targetEditionId: number;
}

export class Specializations implements ISpecializations {
    educationId!: number;
    name!: string | undefined;
    status!: number;
    id!: number | undefined;

    constructor(data?: ISpecializations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.educationId = _data["educationId"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Specializations {
        data = typeof data === 'object' ? data : {};
        let result = new Specializations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["educationId"] = this.educationId;
        data["name"] = this.name;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface ISpecializations {
    educationId: number;
    name: string | undefined;
    status: number;
    id: number | undefined;
}

export class CreateOrEditEducationDto implements ICreateOrEditEducationDto {
    name!: string | undefined;
    status!: number;
    specializations!: Specializations[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditEducationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.status = _data["status"];
            if (Array.isArray(_data["specializations"])) {
                this.specializations = [] as any;
                for (let item of _data["specializations"])
                    this.specializations!.push(Specializations.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEducationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEducationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["status"] = this.status;
        if (Array.isArray(this.specializations)) {
            data["specializations"] = [];
            for (let item of this.specializations)
                data["specializations"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditEducationDto {
    name: string | undefined;
    status: number;
    specializations: Specializations[] | undefined;
    id: number | undefined;
}

export class EducationDto implements IEducationDto {
    tenantId!: number;
    name!: string | undefined;
    status!: number;
    id!: number;

    constructor(data?: IEducationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EducationDto {
        data = typeof data === 'object' ? data : {};
        let result = new EducationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface IEducationDto {
    tenantId: number;
    name: string | undefined;
    status: number;
    id: number;
}

export class GetEducationForViewDto implements IGetEducationForViewDto {
    education!: EducationDto;

    constructor(data?: IGetEducationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.education = _data["education"] ? EducationDto.fromJS(_data["education"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEducationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEducationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["education"] = this.education ? this.education.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEducationForViewDto {
    education: EducationDto;
}

export class PagedResultDtoOfGetEducationForViewDto implements IPagedResultDtoOfGetEducationForViewDto {
    totalCount!: number;
    items!: GetEducationForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEducationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetEducationForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEducationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEducationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetEducationForViewDto {
    totalCount: number;
    items: GetEducationForViewDto[] | undefined;
}

export class GetEducationWithSpecializations implements IGetEducationWithSpecializations {
    education!: string | undefined;
    specialization!: string | undefined;

    constructor(data?: IGetEducationWithSpecializations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.education = _data["education"];
            this.specialization = _data["specialization"];
        }
    }

    static fromJS(data: any): GetEducationWithSpecializations {
        data = typeof data === 'object' ? data : {};
        let result = new GetEducationWithSpecializations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["education"] = this.education;
        data["specialization"] = this.specialization;
        return data;
    }
}

export interface IGetEducationWithSpecializations {
    education: string | undefined;
    specialization: string | undefined;
}

export class PagedResultDtoOfGetEducationWithSpecializations implements IPagedResultDtoOfGetEducationWithSpecializations {
    totalCount!: number;
    items!: GetEducationWithSpecializations[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEducationWithSpecializations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetEducationWithSpecializations.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEducationWithSpecializations {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEducationWithSpecializations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetEducationWithSpecializations {
    totalCount: number;
    items: GetEducationWithSpecializations[] | undefined;
}

export class EmplolyeeCodeSettingDto implements IEmplolyeeCodeSettingDto {
    preFix!: string | undefined;
    startingNo!: number | undefined;
    editable!: boolean;
    id!: number;

    constructor(data?: IEmplolyeeCodeSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preFix = _data["preFix"];
            this.startingNo = _data["startingNo"];
            this.editable = _data["editable"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EmplolyeeCodeSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmplolyeeCodeSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preFix"] = this.preFix;
        data["startingNo"] = this.startingNo;
        data["editable"] = this.editable;
        data["id"] = this.id;
        return data;
    }
}

export interface IEmplolyeeCodeSettingDto {
    preFix: string | undefined;
    startingNo: number | undefined;
    editable: boolean;
    id: number;
}

export class GetEmplolyeeCodeSettingForViewDto implements IGetEmplolyeeCodeSettingForViewDto {
    emplolyeeCodeSetting!: EmplolyeeCodeSettingDto;

    constructor(data?: IGetEmplolyeeCodeSettingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emplolyeeCodeSetting = _data["emplolyeeCodeSetting"] ? EmplolyeeCodeSettingDto.fromJS(_data["emplolyeeCodeSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEmplolyeeCodeSettingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmplolyeeCodeSettingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emplolyeeCodeSetting"] = this.emplolyeeCodeSetting ? this.emplolyeeCodeSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEmplolyeeCodeSettingForViewDto {
    emplolyeeCodeSetting: EmplolyeeCodeSettingDto;
}

export class PagedResultDtoOfGetEmplolyeeCodeSettingForViewDto implements IPagedResultDtoOfGetEmplolyeeCodeSettingForViewDto {
    totalCount!: number;
    items!: GetEmplolyeeCodeSettingForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEmplolyeeCodeSettingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetEmplolyeeCodeSettingForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEmplolyeeCodeSettingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEmplolyeeCodeSettingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetEmplolyeeCodeSettingForViewDto {
    totalCount: number;
    items: GetEmplolyeeCodeSettingForViewDto[] | undefined;
}

export class CreateOrEditEmplolyeeCodeSettingDto implements ICreateOrEditEmplolyeeCodeSettingDto {
    preFix!: string | undefined;
    startingNo!: number | undefined;
    editable!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditEmplolyeeCodeSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preFix = _data["preFix"];
            this.startingNo = _data["startingNo"];
            this.editable = _data["editable"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEmplolyeeCodeSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEmplolyeeCodeSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preFix"] = this.preFix;
        data["startingNo"] = this.startingNo;
        data["editable"] = this.editable;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditEmplolyeeCodeSettingDto {
    preFix: string | undefined;
    startingNo: number | undefined;
    editable: boolean;
    id: number | undefined;
}

export class GetEmplolyeeCodeSettingForEditOutput implements IGetEmplolyeeCodeSettingForEditOutput {
    emplolyeeCodeSetting!: CreateOrEditEmplolyeeCodeSettingDto;

    constructor(data?: IGetEmplolyeeCodeSettingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emplolyeeCodeSetting = _data["emplolyeeCodeSetting"] ? CreateOrEditEmplolyeeCodeSettingDto.fromJS(_data["emplolyeeCodeSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEmplolyeeCodeSettingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmplolyeeCodeSettingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emplolyeeCodeSetting"] = this.emplolyeeCodeSetting ? this.emplolyeeCodeSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEmplolyeeCodeSettingForEditOutput {
    emplolyeeCodeSetting: CreateOrEditEmplolyeeCodeSettingDto;
}

export class CreateorEditAccountDetails implements ICreateorEditAccountDetails {
    panNo!: string | undefined;
    providentFundContribution!: number | undefined;
    professionalTaxContribution!: number | undefined;
    professionalFundNo!: string | undefined;
    providentFundGrosslimit!: number | undefined;
    voluntaryprovidentFunContribution!: number | undefined;
    contributeEmployeeStateInsurance!: number | undefined;
    employeeStateInsuranceNumber!: string | undefined;
    esiGrossLimit!: number | undefined;
    contributeEmployeeStateInsuranceOnOverTime!: number | undefined;
    overTimePartOfGross!: number | undefined;
    uanNumber!: string | undefined;
    pension!: number | undefined;
    labourWelfareFundContribution!: number;
    pensionNo!: string | undefined;
    taxRegime!: number | undefined;
    aadharNo!: string | undefined;
    deductionForEmployerContributionNps!: number | undefined;
    employeeId!: number;
    salarySlipLog!: boolean;
    id!: number;

    constructor(data?: ICreateorEditAccountDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.panNo = _data["panNo"];
            this.providentFundContribution = _data["providentFundContribution"];
            this.professionalTaxContribution = _data["professionalTaxContribution"];
            this.professionalFundNo = _data["professionalFundNo"];
            this.providentFundGrosslimit = _data["providentFundGrosslimit"];
            this.voluntaryprovidentFunContribution = _data["voluntaryprovidentFunContribution"];
            this.contributeEmployeeStateInsurance = _data["contributeEmployeeStateInsurance"];
            this.employeeStateInsuranceNumber = _data["employeeStateInsuranceNumber"];
            this.esiGrossLimit = _data["esiGrossLimit"];
            this.contributeEmployeeStateInsuranceOnOverTime = _data["contributeEmployeeStateInsuranceOnOverTime"];
            this.overTimePartOfGross = _data["overTimePartOfGross"];
            this.uanNumber = _data["uanNumber"];
            this.pension = _data["pension"];
            this.labourWelfareFundContribution = _data["labourWelfareFundContribution"];
            this.pensionNo = _data["pensionNo"];
            this.taxRegime = _data["taxRegime"];
            this.aadharNo = _data["aadharNo"];
            this.deductionForEmployerContributionNps = _data["deductionForEmployerContributionNps"];
            this.employeeId = _data["employeeId"];
            this.salarySlipLog = _data["salarySlipLog"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateorEditAccountDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CreateorEditAccountDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["panNo"] = this.panNo;
        data["providentFundContribution"] = this.providentFundContribution;
        data["professionalTaxContribution"] = this.professionalTaxContribution;
        data["professionalFundNo"] = this.professionalFundNo;
        data["providentFundGrosslimit"] = this.providentFundGrosslimit;
        data["voluntaryprovidentFunContribution"] = this.voluntaryprovidentFunContribution;
        data["contributeEmployeeStateInsurance"] = this.contributeEmployeeStateInsurance;
        data["employeeStateInsuranceNumber"] = this.employeeStateInsuranceNumber;
        data["esiGrossLimit"] = this.esiGrossLimit;
        data["contributeEmployeeStateInsuranceOnOverTime"] = this.contributeEmployeeStateInsuranceOnOverTime;
        data["overTimePartOfGross"] = this.overTimePartOfGross;
        data["uanNumber"] = this.uanNumber;
        data["pension"] = this.pension;
        data["labourWelfareFundContribution"] = this.labourWelfareFundContribution;
        data["pensionNo"] = this.pensionNo;
        data["taxRegime"] = this.taxRegime;
        data["aadharNo"] = this.aadharNo;
        data["deductionForEmployerContributionNps"] = this.deductionForEmployerContributionNps;
        data["employeeId"] = this.employeeId;
        data["salarySlipLog"] = this.salarySlipLog;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateorEditAccountDetails {
    panNo: string | undefined;
    providentFundContribution: number | undefined;
    professionalTaxContribution: number | undefined;
    professionalFundNo: string | undefined;
    providentFundGrosslimit: number | undefined;
    voluntaryprovidentFunContribution: number | undefined;
    contributeEmployeeStateInsurance: number | undefined;
    employeeStateInsuranceNumber: string | undefined;
    esiGrossLimit: number | undefined;
    contributeEmployeeStateInsuranceOnOverTime: number | undefined;
    overTimePartOfGross: number | undefined;
    uanNumber: string | undefined;
    pension: number | undefined;
    labourWelfareFundContribution: number;
    pensionNo: string | undefined;
    taxRegime: number | undefined;
    aadharNo: string | undefined;
    deductionForEmployerContributionNps: number | undefined;
    employeeId: number;
    salarySlipLog: boolean;
    id: number;
}

export class GetEmployeeAccountDetailsEditOutput implements IGetEmployeeAccountDetailsEditOutput {
    accountDetails!: CreateorEditAccountDetails;

    constructor(data?: IGetEmployeeAccountDetailsEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountDetails = _data["accountDetails"] ? CreateorEditAccountDetails.fromJS(_data["accountDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEmployeeAccountDetailsEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeAccountDetailsEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountDetails"] = this.accountDetails ? this.accountDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEmployeeAccountDetailsEditOutput {
    accountDetails: CreateorEditAccountDetails;
}

export class CreateOrEditEmployeeOtherDetials implements ICreateOrEditEmployeeOtherDetials {
    joinIngDateforForm5!: moment.Moment | undefined;
    leavingDateforForm10!: moment.Moment | undefined;
    guaturity!: moment.Moment | undefined;
    dispensaryName!: string | undefined;
    employeeId!: number;
    id!: number;

    constructor(data?: ICreateOrEditEmployeeOtherDetials) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.joinIngDateforForm5 = _data["joinIngDateforForm5"] ? moment(_data["joinIngDateforForm5"].toString()) : <any>undefined;
            this.leavingDateforForm10 = _data["leavingDateforForm10"] ? moment(_data["leavingDateforForm10"].toString()) : <any>undefined;
            this.guaturity = _data["guaturity"] ? moment(_data["guaturity"].toString()) : <any>undefined;
            this.dispensaryName = _data["dispensaryName"];
            this.employeeId = _data["employeeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEmployeeOtherDetials {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEmployeeOtherDetials();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["joinIngDateforForm5"] = this.joinIngDateforForm5 ? this.joinIngDateforForm5.toISOString() : <any>undefined;
        data["leavingDateforForm10"] = this.leavingDateforForm10 ? this.leavingDateforForm10.toISOString() : <any>undefined;
        data["guaturity"] = this.guaturity ? this.guaturity.toISOString() : <any>undefined;
        data["dispensaryName"] = this.dispensaryName;
        data["employeeId"] = this.employeeId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditEmployeeOtherDetials {
    joinIngDateforForm5: moment.Moment | undefined;
    leavingDateforForm10: moment.Moment | undefined;
    guaturity: moment.Moment | undefined;
    dispensaryName: string | undefined;
    employeeId: number;
    id: number;
}

export class GetEmployeeOtherDetailsEditOutput implements IGetEmployeeOtherDetailsEditOutput {
    accountDetails!: CreateOrEditEmployeeOtherDetials;

    constructor(data?: IGetEmployeeOtherDetailsEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountDetails = _data["accountDetails"] ? CreateOrEditEmployeeOtherDetials.fromJS(_data["accountDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEmployeeOtherDetailsEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeOtherDetailsEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountDetails"] = this.accountDetails ? this.accountDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEmployeeOtherDetailsEditOutput {
    accountDetails: CreateOrEditEmployeeOtherDetials;
}

export class CreateoreditEmployeeperivouesDetails implements ICreateoreditEmployeeperivouesDetails {
    taxableSalary!: number | undefined;
    taxDeductedPreviousEmployer!: number | undefined;
    exemptedGratuity!: number | undefined;
    exemptedEncashedLeave!: number | undefined;
    employeeId!: number;
    id!: number;

    constructor(data?: ICreateoreditEmployeeperivouesDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxableSalary = _data["taxableSalary"];
            this.taxDeductedPreviousEmployer = _data["taxDeductedPreviousEmployer"];
            this.exemptedGratuity = _data["exemptedGratuity"];
            this.exemptedEncashedLeave = _data["exemptedEncashedLeave"];
            this.employeeId = _data["employeeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateoreditEmployeeperivouesDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CreateoreditEmployeeperivouesDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxableSalary"] = this.taxableSalary;
        data["taxDeductedPreviousEmployer"] = this.taxDeductedPreviousEmployer;
        data["exemptedGratuity"] = this.exemptedGratuity;
        data["exemptedEncashedLeave"] = this.exemptedEncashedLeave;
        data["employeeId"] = this.employeeId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateoreditEmployeeperivouesDetails {
    taxableSalary: number | undefined;
    taxDeductedPreviousEmployer: number | undefined;
    exemptedGratuity: number | undefined;
    exemptedEncashedLeave: number | undefined;
    employeeId: number;
    id: number;
}

export class GetCreateorEditEmployeePerivouseDetails implements IGetCreateorEditEmployeePerivouseDetails {
    employeePerviousDetails!: CreateoreditEmployeeperivouesDetails;

    constructor(data?: IGetCreateorEditEmployeePerivouseDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeePerviousDetails = _data["employeePerviousDetails"] ? CreateoreditEmployeeperivouesDetails.fromJS(_data["employeePerviousDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCreateorEditEmployeePerivouseDetails {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateorEditEmployeePerivouseDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeePerviousDetails"] = this.employeePerviousDetails ? this.employeePerviousDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCreateorEditEmployeePerivouseDetails {
    employeePerviousDetails: CreateoreditEmployeeperivouesDetails;
}

export class GetEmployeeAttendanceModeDto implements IGetEmployeeAttendanceModeDto {
    tenantId!: number;
    employeeName!: string | undefined;
    employeeId!: number;
    employeeCode!: string | undefined;
    facialRecognition!: boolean;
    biometric!: boolean;
    mobile_App!: boolean;
    web_App!: boolean;
    third_Party_App!: boolean;
    geoFencing!: boolean;
    longitude!: string | undefined;
    latitude!: string | undefined;
    branch!: string | undefined;
    radius!: number;
    isChecked!: boolean;
    isDistanceTravel!: boolean;
    locationTracking!: number;

    constructor(data?: IGetEmployeeAttendanceModeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.employeeName = _data["employeeName"];
            this.employeeId = _data["employeeId"];
            this.employeeCode = _data["employeeCode"];
            this.facialRecognition = _data["facialRecognition"];
            this.biometric = _data["biometric"];
            this.mobile_App = _data["mobile_App"];
            this.web_App = _data["web_App"];
            this.third_Party_App = _data["third_Party_App"];
            this.geoFencing = _data["geoFencing"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.branch = _data["branch"];
            this.radius = _data["radius"];
            this.isChecked = _data["isChecked"];
            this.isDistanceTravel = _data["isDistanceTravel"];
            this.locationTracking = _data["locationTracking"];
        }
    }

    static fromJS(data: any): GetEmployeeAttendanceModeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeAttendanceModeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["employeeName"] = this.employeeName;
        data["employeeId"] = this.employeeId;
        data["employeeCode"] = this.employeeCode;
        data["facialRecognition"] = this.facialRecognition;
        data["biometric"] = this.biometric;
        data["mobile_App"] = this.mobile_App;
        data["web_App"] = this.web_App;
        data["third_Party_App"] = this.third_Party_App;
        data["geoFencing"] = this.geoFencing;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["branch"] = this.branch;
        data["radius"] = this.radius;
        data["isChecked"] = this.isChecked;
        data["isDistanceTravel"] = this.isDistanceTravel;
        data["locationTracking"] = this.locationTracking;
        return data;
    }
}

export interface IGetEmployeeAttendanceModeDto {
    tenantId: number;
    employeeName: string | undefined;
    employeeId: number;
    employeeCode: string | undefined;
    facialRecognition: boolean;
    biometric: boolean;
    mobile_App: boolean;
    web_App: boolean;
    third_Party_App: boolean;
    geoFencing: boolean;
    longitude: string | undefined;
    latitude: string | undefined;
    branch: string | undefined;
    radius: number;
    isChecked: boolean;
    isDistanceTravel: boolean;
    locationTracking: number;
}

export class PagedResultDtoOfGetEmployeeAttendanceModeDto implements IPagedResultDtoOfGetEmployeeAttendanceModeDto {
    totalCount!: number;
    items!: GetEmployeeAttendanceModeDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEmployeeAttendanceModeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetEmployeeAttendanceModeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEmployeeAttendanceModeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEmployeeAttendanceModeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetEmployeeAttendanceModeDto {
    totalCount: number;
    items: GetEmployeeAttendanceModeDto[] | undefined;
}

export class GetBranchModeDto implements IGetBranchModeDto {
    employeeId!: number;
    employeeName!: string | undefined;
    longitude!: string | undefined;
    latitude!: string | undefined;
    branch!: string | undefined;
    radius!: number;

    constructor(data?: IGetBranchModeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.branch = _data["branch"];
            this.radius = _data["radius"];
        }
    }

    static fromJS(data: any): GetBranchModeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBranchModeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["branch"] = this.branch;
        data["radius"] = this.radius;
        return data;
    }
}

export interface IGetBranchModeDto {
    employeeId: number;
    employeeName: string | undefined;
    longitude: string | undefined;
    latitude: string | undefined;
    branch: string | undefined;
    radius: number;
}

export class PagedResultDtoOfGetBranchModeDto implements IPagedResultDtoOfGetBranchModeDto {
    totalCount!: number;
    items!: GetBranchModeDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBranchModeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetBranchModeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBranchModeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBranchModeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetBranchModeDto {
    totalCount: number;
    items: GetBranchModeDto[] | undefined;
}

export class EmployeebankdetailsDto implements IEmployeebankdetailsDto {
    payMode!: number;
    ifsccode!: string | undefined;
    accountNumber!: string | undefined;
    effectiveMonthYear!: moment.Moment | undefined;
    employeeID!: number;
    bankBranchId!: string | undefined;
    bankBranchDetailsId!: string | undefined;
    id!: number;

    constructor(data?: IEmployeebankdetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payMode = _data["payMode"];
            this.ifsccode = _data["ifsccode"];
            this.accountNumber = _data["accountNumber"];
            this.effectiveMonthYear = _data["effectiveMonthYear"] ? moment(_data["effectiveMonthYear"].toString()) : <any>undefined;
            this.employeeID = _data["employeeID"];
            this.bankBranchId = _data["bankBranchId"];
            this.bankBranchDetailsId = _data["bankBranchDetailsId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EmployeebankdetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeebankdetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payMode"] = this.payMode;
        data["ifsccode"] = this.ifsccode;
        data["accountNumber"] = this.accountNumber;
        data["effectiveMonthYear"] = this.effectiveMonthYear ? this.effectiveMonthYear.toISOString() : <any>undefined;
        data["employeeID"] = this.employeeID;
        data["bankBranchId"] = this.bankBranchId;
        data["bankBranchDetailsId"] = this.bankBranchDetailsId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEmployeebankdetailsDto {
    payMode: number;
    ifsccode: string | undefined;
    accountNumber: string | undefined;
    effectiveMonthYear: moment.Moment | undefined;
    employeeID: number;
    bankBranchId: string | undefined;
    bankBranchDetailsId: string | undefined;
    id: number;
}

export class GetEmployeebankdetailsForViewDto implements IGetEmployeebankdetailsForViewDto {
    employeebankdetails!: EmployeebankdetailsDto;
    bankBranchBankName!: string | undefined;
    bankBranchDetailsBranchName!: string | undefined;

    constructor(data?: IGetEmployeebankdetailsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeebankdetails = _data["employeebankdetails"] ? EmployeebankdetailsDto.fromJS(_data["employeebankdetails"]) : <any>undefined;
            this.bankBranchBankName = _data["bankBranchBankName"];
            this.bankBranchDetailsBranchName = _data["bankBranchDetailsBranchName"];
        }
    }

    static fromJS(data: any): GetEmployeebankdetailsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeebankdetailsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeebankdetails"] = this.employeebankdetails ? this.employeebankdetails.toJSON() : <any>undefined;
        data["bankBranchBankName"] = this.bankBranchBankName;
        data["bankBranchDetailsBranchName"] = this.bankBranchDetailsBranchName;
        return data;
    }
}

export interface IGetEmployeebankdetailsForViewDto {
    employeebankdetails: EmployeebankdetailsDto;
    bankBranchBankName: string | undefined;
    bankBranchDetailsBranchName: string | undefined;
}

export class PagedResultDtoOfGetEmployeebankdetailsForViewDto implements IPagedResultDtoOfGetEmployeebankdetailsForViewDto {
    totalCount!: number;
    items!: GetEmployeebankdetailsForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEmployeebankdetailsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetEmployeebankdetailsForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEmployeebankdetailsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEmployeebankdetailsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetEmployeebankdetailsForViewDto {
    totalCount: number;
    items: GetEmployeebankdetailsForViewDto[] | undefined;
}

export class CreateOrEditEmployeebankdetailsDto implements ICreateOrEditEmployeebankdetailsDto {
    netSalary!: boolean;
    remimburshment!: boolean;
    payMode!: number;
    ifsccode!: string | undefined;
    accountNumber!: string | undefined;
    effectiveMonthYear!: moment.Moment | undefined;
    employeeID!: number;
    bankBranchId!: string | undefined;
    bankBranchDetailsId!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditEmployeebankdetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.netSalary = _data["netSalary"];
            this.remimburshment = _data["remimburshment"];
            this.payMode = _data["payMode"];
            this.ifsccode = _data["ifsccode"];
            this.accountNumber = _data["accountNumber"];
            this.effectiveMonthYear = _data["effectiveMonthYear"] ? moment(_data["effectiveMonthYear"].toString()) : <any>undefined;
            this.employeeID = _data["employeeID"];
            this.bankBranchId = _data["bankBranchId"];
            this.bankBranchDetailsId = _data["bankBranchDetailsId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEmployeebankdetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEmployeebankdetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["netSalary"] = this.netSalary;
        data["remimburshment"] = this.remimburshment;
        data["payMode"] = this.payMode;
        data["ifsccode"] = this.ifsccode;
        data["accountNumber"] = this.accountNumber;
        data["effectiveMonthYear"] = this.effectiveMonthYear ? this.effectiveMonthYear.toISOString() : <any>undefined;
        data["employeeID"] = this.employeeID;
        data["bankBranchId"] = this.bankBranchId;
        data["bankBranchDetailsId"] = this.bankBranchDetailsId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditEmployeebankdetailsDto {
    netSalary: boolean;
    remimburshment: boolean;
    payMode: number;
    ifsccode: string | undefined;
    accountNumber: string | undefined;
    effectiveMonthYear: moment.Moment | undefined;
    employeeID: number;
    bankBranchId: string | undefined;
    bankBranchDetailsId: string | undefined;
    id: number | undefined;
}

export class GetEmployeebankdetailsForEditOutput implements IGetEmployeebankdetailsForEditOutput {
    employeebankdetails!: CreateOrEditEmployeebankdetailsDto;
    bankBranchBankName!: string | undefined;
    bankBranchDetailsBranchName!: string | undefined;

    constructor(data?: IGetEmployeebankdetailsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeebankdetails = _data["employeebankdetails"] ? CreateOrEditEmployeebankdetailsDto.fromJS(_data["employeebankdetails"]) : <any>undefined;
            this.bankBranchBankName = _data["bankBranchBankName"];
            this.bankBranchDetailsBranchName = _data["bankBranchDetailsBranchName"];
        }
    }

    static fromJS(data: any): GetEmployeebankdetailsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeebankdetailsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeebankdetails"] = this.employeebankdetails ? this.employeebankdetails.toJSON() : <any>undefined;
        data["bankBranchBankName"] = this.bankBranchBankName;
        data["bankBranchDetailsBranchName"] = this.bankBranchDetailsBranchName;
        return data;
    }
}

export interface IGetEmployeebankdetailsForEditOutput {
    employeebankdetails: CreateOrEditEmployeebankdetailsDto;
    bankBranchBankName: string | undefined;
    bankBranchDetailsBranchName: string | undefined;
}

export class EmployeebankdetailsBankBranchLookupTableDto implements IEmployeebankdetailsBankBranchLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IEmployeebankdetailsBankBranchLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): EmployeebankdetailsBankBranchLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeebankdetailsBankBranchLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IEmployeebankdetailsBankBranchLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class EmployeebankdetailsBankBranchDetailsLookupTableDto implements IEmployeebankdetailsBankBranchDetailsLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    ifscCode!: string | undefined;

    constructor(data?: IEmployeebankdetailsBankBranchDetailsLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.ifscCode = _data["ifscCode"];
        }
    }

    static fromJS(data: any): EmployeebankdetailsBankBranchDetailsLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeebankdetailsBankBranchDetailsLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["ifscCode"] = this.ifscCode;
        return data;
    }
}

export interface IEmployeebankdetailsBankBranchDetailsLookupTableDto {
    id: number;
    displayName: string | undefined;
    ifscCode: string | undefined;
}

export class IfscVerificationDto implements IIfscVerificationDto {
    micr!: string | undefined;
    branch!: string | undefined;
    address!: string | undefined;
    state!: string | undefined;
    contact!: string | undefined;
    upi!: boolean;
    rtgs!: boolean;
    city!: string | undefined;
    centre!: string | undefined;
    district!: string | undefined;
    neft!: boolean;
    imps!: boolean;
    swift!: string | undefined;
    iso3166!: string | undefined;
    bank!: string | undefined;
    bankcode!: string | undefined;
    ifsc!: string | undefined;

    constructor(data?: IIfscVerificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.micr = _data["micr"];
            this.branch = _data["branch"];
            this.address = _data["address"];
            this.state = _data["state"];
            this.contact = _data["contact"];
            this.upi = _data["upi"];
            this.rtgs = _data["rtgs"];
            this.city = _data["city"];
            this.centre = _data["centre"];
            this.district = _data["district"];
            this.neft = _data["neft"];
            this.imps = _data["imps"];
            this.swift = _data["swift"];
            this.iso3166 = _data["iso3166"];
            this.bank = _data["bank"];
            this.bankcode = _data["bankcode"];
            this.ifsc = _data["ifsc"];
        }
    }

    static fromJS(data: any): IfscVerificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new IfscVerificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["micr"] = this.micr;
        data["branch"] = this.branch;
        data["address"] = this.address;
        data["state"] = this.state;
        data["contact"] = this.contact;
        data["upi"] = this.upi;
        data["rtgs"] = this.rtgs;
        data["city"] = this.city;
        data["centre"] = this.centre;
        data["district"] = this.district;
        data["neft"] = this.neft;
        data["imps"] = this.imps;
        data["swift"] = this.swift;
        data["iso3166"] = this.iso3166;
        data["bank"] = this.bank;
        data["bankcode"] = this.bankcode;
        data["ifsc"] = this.ifsc;
        return data;
    }
}

export interface IIfscVerificationDto {
    micr: string | undefined;
    branch: string | undefined;
    address: string | undefined;
    state: string | undefined;
    contact: string | undefined;
    upi: boolean;
    rtgs: boolean;
    city: string | undefined;
    centre: string | undefined;
    district: string | undefined;
    neft: boolean;
    imps: boolean;
    swift: string | undefined;
    iso3166: string | undefined;
    bank: string | undefined;
    bankcode: string | undefined;
    ifsc: string | undefined;
}

export class EmployeeInputeFileDto implements IEmployeeInputeFileDto {
    excelFilePath!: string | undefined;

    constructor(data?: IEmployeeInputeFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.excelFilePath = _data["excelFilePath"];
        }
    }

    static fromJS(data: any): EmployeeInputeFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeInputeFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["excelFilePath"] = this.excelFilePath;
        return data;
    }
}

export interface IEmployeeInputeFileDto {
    excelFilePath: string | undefined;
}

export class ErrorFileDto implements IErrorFileDto {
    fileName!: string | undefined;
    fileContent!: string | undefined;
    success!: boolean;
    batchId!: string | undefined;

    constructor(data?: IErrorFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileContent = _data["fileContent"];
            this.success = _data["success"];
            this.batchId = _data["batchId"];
        }
    }

    static fromJS(data: any): ErrorFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileContent"] = this.fileContent;
        data["success"] = this.success;
        data["batchId"] = this.batchId;
        return data;
    }
}

export interface IErrorFileDto {
    fileName: string | undefined;
    fileContent: string | undefined;
    success: boolean;
    batchId: string | undefined;
}

export class ImportRejectedEmployeeRowUpdateDto implements IImportRejectedEmployeeRowUpdateDto {
    id!: number;
    rowDataJson!: string | undefined;

    constructor(data?: IImportRejectedEmployeeRowUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rowDataJson = _data["rowDataJson"];
        }
    }

    static fromJS(data: any): ImportRejectedEmployeeRowUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportRejectedEmployeeRowUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rowDataJson"] = this.rowDataJson;
        return data;
    }
}

export interface IImportRejectedEmployeeRowUpdateDto {
    id: number;
    rowDataJson: string | undefined;
}

export class ImportRejectedEmployeeDto implements IImportRejectedEmployeeDto {
    id!: number;
    rowNumber!: number;
    rowDataJson!: string | undefined;
    errorMessagesJson!: string | undefined;
    status!: string | undefined;

    constructor(data?: IImportRejectedEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rowNumber = _data["rowNumber"];
            this.rowDataJson = _data["rowDataJson"];
            this.errorMessagesJson = _data["errorMessagesJson"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ImportRejectedEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportRejectedEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rowNumber"] = this.rowNumber;
        data["rowDataJson"] = this.rowDataJson;
        data["errorMessagesJson"] = this.errorMessagesJson;
        data["status"] = this.status;
        return data;
    }
}

export interface IImportRejectedEmployeeDto {
    id: number;
    rowNumber: number;
    rowDataJson: string | undefined;
    errorMessagesJson: string | undefined;
    status: string | undefined;
}

export class RowErrorDto implements IRowErrorDto {
    rowNumber!: number;
    errorMessages!: string[] | undefined;

    constructor(data?: IRowErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowNumber = _data["rowNumber"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
        }
    }

    static fromJS(data: any): RowErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new RowErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowNumber"] = this.rowNumber;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        return data;
    }
}

export interface IRowErrorDto {
    rowNumber: number;
    errorMessages: string[] | undefined;
}

export class EmployeeNameDto implements IEmployeeNameDto {
    salutation!: number;
    firstName!: string | undefined;
    lastName!: string | undefined;

    constructor(data?: IEmployeeNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salutation = _data["salutation"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): EmployeeNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salutation"] = this.salutation;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface IEmployeeNameDto {
    salutation: number;
    firstName: string | undefined;
    lastName: string | undefined;
}

export class CreateOrEditEmploymentForMRRDto implements ICreateOrEditEmploymentForMRRDto {
    dateOfJoining!: moment.Moment;
    division!: string | undefined;
    department!: string | undefined;
    designation!: string | undefined;
    location!: string | undefined;
    headquarterId!: number;
    refrenceDetails!: string | undefined;

    constructor(data?: ICreateOrEditEmploymentForMRRDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateOfJoining = _data["dateOfJoining"] ? moment(_data["dateOfJoining"].toString()) : <any>undefined;
            this.division = _data["division"];
            this.department = _data["department"];
            this.designation = _data["designation"];
            this.location = _data["location"];
            this.headquarterId = _data["headquarterId"];
            this.refrenceDetails = _data["refrenceDetails"];
        }
    }

    static fromJS(data: any): CreateOrEditEmploymentForMRRDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEmploymentForMRRDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateOfJoining"] = this.dateOfJoining ? this.dateOfJoining.toISOString() : <any>undefined;
        data["division"] = this.division;
        data["department"] = this.department;
        data["designation"] = this.designation;
        data["location"] = this.location;
        data["headquarterId"] = this.headquarterId;
        data["refrenceDetails"] = this.refrenceDetails;
        return data;
    }
}

export interface ICreateOrEditEmploymentForMRRDto {
    dateOfJoining: moment.Moment;
    division: string | undefined;
    department: string | undefined;
    designation: string | undefined;
    location: string | undefined;
    headquarterId: number;
    refrenceDetails: string | undefined;
}

export class AddressDto implements IAddressDto {
    street!: string | undefined;
    city!: string | undefined;
    state!: number;
    country!: number;
    zipCode!: string | undefined;
    ward!: string | undefined;
    district!: string | undefined;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.street = _data["street"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.zipCode = _data["zipCode"];
            this.ward = _data["ward"];
            this.district = _data["district"];
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["zipCode"] = this.zipCode;
        data["ward"] = this.ward;
        data["district"] = this.district;
        return data;
    }
}

export interface IAddressDto {
    street: string | undefined;
    city: string | undefined;
    state: number;
    country: number;
    zipCode: string | undefined;
    ward: string | undefined;
    district: string | undefined;
}

export class CreateOrEditPersonalDetailsForMRRDto implements ICreateOrEditPersonalDetailsForMRRDto {
    email!: string | undefined;
    fatherName!: string | undefined;
    aadharCard!: string | undefined;
    panCard!: string | undefined;
    maritalStatus!: string | undefined;
    marriageDate!: moment.Moment | undefined;
    currentAddress!: AddressDto;
    permanentAddress!: AddressDto;
    personalMobileNo!: string | undefined;

    constructor(data?: ICreateOrEditPersonalDetailsForMRRDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.fatherName = _data["fatherName"];
            this.aadharCard = _data["aadharCard"];
            this.panCard = _data["panCard"];
            this.maritalStatus = _data["maritalStatus"];
            this.marriageDate = _data["marriageDate"] ? moment(_data["marriageDate"].toString()) : <any>undefined;
            this.currentAddress = _data["currentAddress"] ? AddressDto.fromJS(_data["currentAddress"]) : <any>undefined;
            this.permanentAddress = _data["permanentAddress"] ? AddressDto.fromJS(_data["permanentAddress"]) : <any>undefined;
            this.personalMobileNo = _data["personalMobileNo"];
        }
    }

    static fromJS(data: any): CreateOrEditPersonalDetailsForMRRDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPersonalDetailsForMRRDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["fatherName"] = this.fatherName;
        data["aadharCard"] = this.aadharCard;
        data["panCard"] = this.panCard;
        data["maritalStatus"] = this.maritalStatus;
        data["marriageDate"] = this.marriageDate ? this.marriageDate.toISOString() : <any>undefined;
        data["currentAddress"] = this.currentAddress ? this.currentAddress.toJSON() : <any>undefined;
        data["permanentAddress"] = this.permanentAddress ? this.permanentAddress.toJSON() : <any>undefined;
        data["personalMobileNo"] = this.personalMobileNo;
        return data;
    }
}

export interface ICreateOrEditPersonalDetailsForMRRDto {
    email: string | undefined;
    fatherName: string | undefined;
    aadharCard: string | undefined;
    panCard: string | undefined;
    maritalStatus: string | undefined;
    marriageDate: moment.Moment | undefined;
    currentAddress: AddressDto;
    permanentAddress: AddressDto;
    personalMobileNo: string | undefined;
}

export class CreateOrEditEmployeeForMRRDto implements ICreateOrEditEmployeeForMRRDto {
    employeeCode!: string | undefined;
    email!: string | undefined;
    mobileNumber!: string | undefined;
    employeeName!: EmployeeNameDto;
    gender!: number;
    dateOfBirth!: moment.Moment;
    bioMetricId!: string | undefined;
    nationality!: number;
    employment!: CreateOrEditEmploymentForMRRDto;
    personalDetails!: CreateOrEditPersonalDetailsForMRRDto;
    id!: number | undefined;

    constructor(data?: ICreateOrEditEmployeeForMRRDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeCode = _data["employeeCode"];
            this.email = _data["email"];
            this.mobileNumber = _data["mobileNumber"];
            this.employeeName = _data["employeeName"] ? EmployeeNameDto.fromJS(_data["employeeName"]) : <any>undefined;
            this.gender = _data["gender"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : <any>undefined;
            this.bioMetricId = _data["bioMetricId"];
            this.nationality = _data["nationality"];
            this.employment = _data["employment"] ? CreateOrEditEmploymentForMRRDto.fromJS(_data["employment"]) : <any>undefined;
            this.personalDetails = _data["personalDetails"] ? CreateOrEditPersonalDetailsForMRRDto.fromJS(_data["personalDetails"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEmployeeForMRRDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEmployeeForMRRDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeCode"] = this.employeeCode;
        data["email"] = this.email;
        data["mobileNumber"] = this.mobileNumber;
        data["employeeName"] = this.employeeName ? this.employeeName.toJSON() : <any>undefined;
        data["gender"] = this.gender;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["bioMetricId"] = this.bioMetricId;
        data["nationality"] = this.nationality;
        data["employment"] = this.employment ? this.employment.toJSON() : <any>undefined;
        data["personalDetails"] = this.personalDetails ? this.personalDetails.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditEmployeeForMRRDto {
    employeeCode: string | undefined;
    email: string | undefined;
    mobileNumber: string | undefined;
    employeeName: EmployeeNameDto;
    gender: number;
    dateOfBirth: moment.Moment;
    bioMetricId: string | undefined;
    nationality: number;
    employment: CreateOrEditEmploymentForMRRDto;
    personalDetails: CreateOrEditPersonalDetailsForMRRDto;
    id: number | undefined;
}

export class EmployeeListViewDto implements IEmployeeListViewDto {
    employeeCode!: string | undefined;
    firstName!: string | undefined;
    name!: string | undefined;
    dateofBirth!: moment.Moment;
    dateofJoining!: moment.Moment;
    dateofLeaving!: moment.Moment | undefined;
    employeeImage!: string | undefined;
    gender!: number;
    email!: string | undefined;
    nationality!: string | undefined;
    divison!: string | undefined;
    department!: string | undefined;
    headquarter!: string | undefined;
    designation!: string | undefined;
    location!: string | undefined;
    reportingManeger!: string | undefined;
    abpUserId!: number | undefined;
    contactor!: string | undefined;
    vpf!: number | undefined;
    tenantId!: number;
    mobileNumber!: string | undefined;
    fatherName!: string | undefined;
    adharNumber!: string | undefined;
    panNumber!: string | undefined;
    id!: number;

    constructor(data?: IEmployeeListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeCode = _data["employeeCode"];
            this.firstName = _data["firstName"];
            this.name = _data["name"];
            this.dateofBirth = _data["dateofBirth"] ? moment(_data["dateofBirth"].toString()) : <any>undefined;
            this.dateofJoining = _data["dateofJoining"] ? moment(_data["dateofJoining"].toString()) : <any>undefined;
            this.dateofLeaving = _data["dateofLeaving"] ? moment(_data["dateofLeaving"].toString()) : <any>undefined;
            this.employeeImage = _data["employeeImage"];
            this.gender = _data["gender"];
            this.email = _data["email"];
            this.nationality = _data["nationality"];
            this.divison = _data["divison"];
            this.department = _data["department"];
            this.headquarter = _data["headquarter"];
            this.designation = _data["designation"];
            this.location = _data["location"];
            this.reportingManeger = _data["reportingManeger"];
            this.abpUserId = _data["abpUserId"];
            this.contactor = _data["contactor"];
            this.vpf = _data["vpf"];
            this.tenantId = _data["tenantId"];
            this.mobileNumber = _data["mobileNumber"];
            this.fatherName = _data["fatherName"];
            this.adharNumber = _data["adharNumber"];
            this.panNumber = _data["panNumber"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EmployeeListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeCode"] = this.employeeCode;
        data["firstName"] = this.firstName;
        data["name"] = this.name;
        data["dateofBirth"] = this.dateofBirth ? this.dateofBirth.toISOString() : <any>undefined;
        data["dateofJoining"] = this.dateofJoining ? this.dateofJoining.toISOString() : <any>undefined;
        data["dateofLeaving"] = this.dateofLeaving ? this.dateofLeaving.toISOString() : <any>undefined;
        data["employeeImage"] = this.employeeImage;
        data["gender"] = this.gender;
        data["email"] = this.email;
        data["nationality"] = this.nationality;
        data["divison"] = this.divison;
        data["department"] = this.department;
        data["headquarter"] = this.headquarter;
        data["designation"] = this.designation;
        data["location"] = this.location;
        data["reportingManeger"] = this.reportingManeger;
        data["abpUserId"] = this.abpUserId;
        data["contactor"] = this.contactor;
        data["vpf"] = this.vpf;
        data["tenantId"] = this.tenantId;
        data["mobileNumber"] = this.mobileNumber;
        data["fatherName"] = this.fatherName;
        data["adharNumber"] = this.adharNumber;
        data["panNumber"] = this.panNumber;
        data["id"] = this.id;
        return data;
    }
}

export interface IEmployeeListViewDto {
    employeeCode: string | undefined;
    firstName: string | undefined;
    name: string | undefined;
    dateofBirth: moment.Moment;
    dateofJoining: moment.Moment;
    dateofLeaving: moment.Moment | undefined;
    employeeImage: string | undefined;
    gender: number;
    email: string | undefined;
    nationality: string | undefined;
    divison: string | undefined;
    department: string | undefined;
    headquarter: string | undefined;
    designation: string | undefined;
    location: string | undefined;
    reportingManeger: string | undefined;
    abpUserId: number | undefined;
    contactor: string | undefined;
    vpf: number | undefined;
    tenantId: number;
    mobileNumber: string | undefined;
    fatherName: string | undefined;
    adharNumber: string | undefined;
    panNumber: string | undefined;
    id: number;
}

export class GetEmployeeForListViewDto implements IGetEmployeeForListViewDto {
    employee!: EmployeeListViewDto;

    constructor(data?: IGetEmployeeForListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? EmployeeListViewDto.fromJS(_data["employee"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEmployeeForListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeForListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEmployeeForListViewDto {
    employee: EmployeeListViewDto;
}

export class ContractEmployeeDto implements IContractEmployeeDto {
    id!: number;
    employeeId!: number;
    employeeName!: string | undefined;
    employeeCode!: string | undefined;
    contractorName!: string | undefined;
    departmentName!: string | undefined;
    amount!: number;
    month!: string | undefined;
    year!: number;
    mothlyctc!: number;

    constructor(data?: IContractEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.employeeCode = _data["employeeCode"];
            this.contractorName = _data["contractorName"];
            this.departmentName = _data["departmentName"];
            this.amount = _data["amount"];
            this.month = _data["month"];
            this.year = _data["year"];
            this.mothlyctc = _data["mothlyctc"];
        }
    }

    static fromJS(data: any): ContractEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["employeeCode"] = this.employeeCode;
        data["contractorName"] = this.contractorName;
        data["departmentName"] = this.departmentName;
        data["amount"] = this.amount;
        data["month"] = this.month;
        data["year"] = this.year;
        data["mothlyctc"] = this.mothlyctc;
        return data;
    }
}

export interface IContractEmployeeDto {
    id: number;
    employeeId: number;
    employeeName: string | undefined;
    employeeCode: string | undefined;
    contractorName: string | undefined;
    departmentName: string | undefined;
    amount: number;
    month: string | undefined;
    year: number;
    mothlyctc: number;
}

export class ContractEmployeeSummaryDto implements IContractEmployeeSummaryDto {
    monthYear!: string | undefined;
    employeeCount!: number;
    totalAmount!: number;

    constructor(data?: IContractEmployeeSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthYear = _data["monthYear"];
            this.employeeCount = _data["employeeCount"];
            this.totalAmount = _data["totalAmount"];
        }
    }

    static fromJS(data: any): ContractEmployeeSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractEmployeeSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthYear"] = this.monthYear;
        data["employeeCount"] = this.employeeCount;
        data["totalAmount"] = this.totalAmount;
        return data;
    }
}

export interface IContractEmployeeSummaryDto {
    monthYear: string | undefined;
    employeeCount: number;
    totalAmount: number;
}

export class MigrateDocumentsResultDto implements IMigrateDocumentsResultDto {
    totalProcessed!: number;
    success!: number;
    failed!: number;
    errors!: string[] | undefined;

    constructor(data?: IMigrateDocumentsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProcessed = _data["totalProcessed"];
            this.success = _data["success"];
            this.failed = _data["failed"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): MigrateDocumentsResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MigrateDocumentsResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProcessed"] = this.totalProcessed;
        data["success"] = this.success;
        data["failed"] = this.failed;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IMigrateDocumentsResultDto {
    totalProcessed: number;
    success: number;
    failed: number;
    errors: string[] | undefined;
}

export class AttendanceCorrectionAlertEmployeeDto implements IAttendanceCorrectionAlertEmployeeDto {
    id!: number;
    employeeCode!: string | undefined;
    employeeName!: string | undefined;
    status!: string | undefined;
    attendanceCorrectionAlert!: boolean;

    constructor(data?: IAttendanceCorrectionAlertEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeCode = _data["employeeCode"];
            this.employeeName = _data["employeeName"];
            this.status = _data["status"];
            this.attendanceCorrectionAlert = _data["attendanceCorrectionAlert"];
        }
    }

    static fromJS(data: any): AttendanceCorrectionAlertEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceCorrectionAlertEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeCode"] = this.employeeCode;
        data["employeeName"] = this.employeeName;
        data["status"] = this.status;
        data["attendanceCorrectionAlert"] = this.attendanceCorrectionAlert;
        return data;
    }
}

export interface IAttendanceCorrectionAlertEmployeeDto {
    id: number;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    status: string | undefined;
    attendanceCorrectionAlert: boolean;
}

export class UpdateAttendanceCorrectionAlertInput implements IUpdateAttendanceCorrectionAlertInput {
    employeeIds!: number[] | undefined;
    alertEnabled!: boolean;

    constructor(data?: IUpdateAttendanceCorrectionAlertInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employeeIds"])) {
                this.employeeIds = [] as any;
                for (let item of _data["employeeIds"])
                    this.employeeIds!.push(item);
            }
            this.alertEnabled = _data["alertEnabled"];
        }
    }

    static fromJS(data: any): UpdateAttendanceCorrectionAlertInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAttendanceCorrectionAlertInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employeeIds)) {
            data["employeeIds"] = [];
            for (let item of this.employeeIds)
                data["employeeIds"].push(item);
        }
        data["alertEnabled"] = this.alertEnabled;
        return data;
    }
}

export interface IUpdateAttendanceCorrectionAlertInput {
    employeeIds: number[] | undefined;
    alertEnabled: boolean;
}

export class EmployeeSalaryDetailsDto implements IEmployeeSalaryDetailsDto {
    employeeCode!: string | undefined;
    name!: string | undefined;
    department!: string | undefined;
    salary!: number;
    id!: number;

    constructor(data?: IEmployeeSalaryDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeCode = _data["employeeCode"];
            this.name = _data["name"];
            this.department = _data["department"];
            this.salary = _data["salary"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EmployeeSalaryDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeSalaryDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeCode"] = this.employeeCode;
        data["name"] = this.name;
        data["department"] = this.department;
        data["salary"] = this.salary;
        data["id"] = this.id;
        return data;
    }
}

export interface IEmployeeSalaryDetailsDto {
    employeeCode: string | undefined;
    name: string | undefined;
    department: string | undefined;
    salary: number;
    id: number;
}

export class GetEmployeeForSalaryViewDto implements IGetEmployeeForSalaryViewDto {
    empSalaryData!: EmployeeSalaryDetailsDto;

    constructor(data?: IGetEmployeeForSalaryViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empSalaryData = _data["empSalaryData"] ? EmployeeSalaryDetailsDto.fromJS(_data["empSalaryData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEmployeeForSalaryViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeForSalaryViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empSalaryData"] = this.empSalaryData ? this.empSalaryData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEmployeeForSalaryViewDto {
    empSalaryData: EmployeeSalaryDetailsDto;
}

export class PagedResultDtoOfGetEmployeeForSalaryViewDto implements IPagedResultDtoOfGetEmployeeForSalaryViewDto {
    totalCount!: number;
    items!: GetEmployeeForSalaryViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEmployeeForSalaryViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetEmployeeForSalaryViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEmployeeForSalaryViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEmployeeForSalaryViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetEmployeeForSalaryViewDto {
    totalCount: number;
    items: GetEmployeeForSalaryViewDto[] | undefined;
}

export class PagedResultDtoOfGetEmployeeForListViewDto implements IPagedResultDtoOfGetEmployeeForListViewDto {
    totalCount!: number;
    items!: GetEmployeeForListViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEmployeeForListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetEmployeeForListViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEmployeeForListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEmployeeForListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetEmployeeForListViewDto {
    totalCount: number;
    items: GetEmployeeForListViewDto[] | undefined;
}

export class BasicEmployeeDto implements IBasicEmployeeDto {
    tenantId!: number;
    employeeId!: number;
    employeeCode!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    fatherName!: string | undefined;

    constructor(data?: IBasicEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.employeeId = _data["employeeId"];
            this.employeeCode = _data["employeeCode"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fatherName = _data["fatherName"];
        }
    }

    static fromJS(data: any): BasicEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new BasicEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["employeeId"] = this.employeeId;
        data["employeeCode"] = this.employeeCode;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fatherName"] = this.fatherName;
        return data;
    }
}

export interface IBasicEmployeeDto {
    tenantId: number;
    employeeId: number;
    employeeCode: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    fatherName: string | undefined;
}

export class Detail implements IDetail {
    name!: string | undefined;
    avatar!: string | undefined;

    constructor(data?: IDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.avatar = _data["avatar"];
        }
    }

    static fromJS(data: any): Detail {
        data = typeof data === 'object' ? data : {};
        let result = new Detail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["avatar"] = this.avatar;
        return data;
    }
}

export interface IDetail {
    name: string | undefined;
    avatar: string | undefined;
}

export class TreeNode implements ITreeNode {
    name!: string | undefined;
    label!: string | undefined;
    type!: string | undefined;
    styleClass!: string | undefined;
    expanded!: boolean;
    data!: Detail;
    children!: TreeNode[] | undefined;

    constructor(data?: ITreeNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.label = _data["label"];
            this.type = _data["type"];
            this.styleClass = _data["styleClass"];
            this.expanded = _data["expanded"];
            this.data = _data["data"] ? Detail.fromJS(_data["data"]) : <any>undefined;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(TreeNode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreeNode {
        data = typeof data === 'object' ? data : {};
        let result = new TreeNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["label"] = this.label;
        data["type"] = this.type;
        data["styleClass"] = this.styleClass;
        data["expanded"] = this.expanded;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITreeNode {
    name: string | undefined;
    label: string | undefined;
    type: string | undefined;
    styleClass: string | undefined;
    expanded: boolean;
    data: Detail;
    children: TreeNode[] | undefined;
}

export class EmergencyContactDto implements IEmergencyContactDto {
    name!: string | undefined;
    mobile!: string | undefined;
    relationShip!: EmployeeRelation;

    constructor(data?: IEmergencyContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.mobile = _data["mobile"];
            this.relationShip = _data["relationShip"];
        }
    }

    static fromJS(data: any): EmergencyContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmergencyContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["mobile"] = this.mobile;
        data["relationShip"] = this.relationShip;
        return data;
    }
}

export interface IEmergencyContactDto {
    name: string | undefined;
    mobile: string | undefined;
    relationShip: EmployeeRelation;
}

export class EmploymentViewDto implements IEmploymentViewDto {
    dateOfJoining!: moment.Moment;
    dateOfLeaving!: moment.Moment | undefined;
    division!: string | undefined;
    department!: string | undefined;
    subDepartment!: string | undefined;
    designation!: string | undefined;
    location!: string | undefined;
    reportingManager!: string | undefined;
    employmentType!: string | undefined;
    shiftId!: string | undefined;

    constructor(data?: IEmploymentViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateOfJoining = _data["dateOfJoining"] ? moment(_data["dateOfJoining"].toString()) : <any>undefined;
            this.dateOfLeaving = _data["dateOfLeaving"] ? moment(_data["dateOfLeaving"].toString()) : <any>undefined;
            this.division = _data["division"];
            this.department = _data["department"];
            this.subDepartment = _data["subDepartment"];
            this.designation = _data["designation"];
            this.location = _data["location"];
            this.reportingManager = _data["reportingManager"];
            this.employmentType = _data["employmentType"];
            this.shiftId = _data["shiftId"];
        }
    }

    static fromJS(data: any): EmploymentViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmploymentViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateOfJoining"] = this.dateOfJoining ? this.dateOfJoining.toISOString() : <any>undefined;
        data["dateOfLeaving"] = this.dateOfLeaving ? this.dateOfLeaving.toISOString() : <any>undefined;
        data["division"] = this.division;
        data["department"] = this.department;
        data["subDepartment"] = this.subDepartment;
        data["designation"] = this.designation;
        data["location"] = this.location;
        data["reportingManager"] = this.reportingManager;
        data["employmentType"] = this.employmentType;
        data["shiftId"] = this.shiftId;
        return data;
    }
}

export interface IEmploymentViewDto {
    dateOfJoining: moment.Moment;
    dateOfLeaving: moment.Moment | undefined;
    division: string | undefined;
    department: string | undefined;
    subDepartment: string | undefined;
    designation: string | undefined;
    location: string | undefined;
    reportingManager: string | undefined;
    employmentType: string | undefined;
    shiftId: string | undefined;
}

export class AddressViewDto implements IAddressViewDto {
    street!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    country!: string | undefined;
    zipCode!: string | undefined;

    constructor(data?: IAddressViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.street = _data["street"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.zipCode = _data["zipCode"];
        }
    }

    static fromJS(data: any): AddressViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["zipCode"] = this.zipCode;
        return data;
    }
}

export interface IAddressViewDto {
    street: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    zipCode: string | undefined;
}

export class EmployeeDependentViewDto implements IEmployeeDependentViewDto {
    name!: string | undefined;
    dateOfBirth!: moment.Moment;
    dependentType!: string | undefined;
    remarks!: string | undefined;

    constructor(data?: IEmployeeDependentViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : <any>undefined;
            this.dependentType = _data["dependentType"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): EmployeeDependentViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDependentViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["dependentType"] = this.dependentType;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IEmployeeDependentViewDto {
    name: string | undefined;
    dateOfBirth: moment.Moment;
    dependentType: string | undefined;
    remarks: string | undefined;
}

export class PersonalDetailsViewDto implements IPersonalDetailsViewDto {
    email!: string | undefined;
    fatherName!: string | undefined;
    motherName!: string | undefined;
    religion!: string | undefined;
    bloodGroup!: string | undefined;
    maritalStatus!: string | undefined;
    marriageDate!: moment.Moment | undefined;
    currentIllness!: string | undefined;
    currentAddress!: AddressViewDto;
    permanentAddress!: AddressViewDto;
    dependents!: EmployeeDependentViewDto[] | undefined;

    constructor(data?: IPersonalDetailsViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.fatherName = _data["fatherName"];
            this.motherName = _data["motherName"];
            this.religion = _data["religion"];
            this.bloodGroup = _data["bloodGroup"];
            this.maritalStatus = _data["maritalStatus"];
            this.marriageDate = _data["marriageDate"] ? moment(_data["marriageDate"].toString()) : <any>undefined;
            this.currentIllness = _data["currentIllness"];
            this.currentAddress = _data["currentAddress"] ? AddressViewDto.fromJS(_data["currentAddress"]) : <any>undefined;
            this.permanentAddress = _data["permanentAddress"] ? AddressViewDto.fromJS(_data["permanentAddress"]) : <any>undefined;
            if (Array.isArray(_data["dependents"])) {
                this.dependents = [] as any;
                for (let item of _data["dependents"])
                    this.dependents!.push(EmployeeDependentViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PersonalDetailsViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalDetailsViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["fatherName"] = this.fatherName;
        data["motherName"] = this.motherName;
        data["religion"] = this.religion;
        data["bloodGroup"] = this.bloodGroup;
        data["maritalStatus"] = this.maritalStatus;
        data["marriageDate"] = this.marriageDate ? this.marriageDate.toISOString() : <any>undefined;
        data["currentIllness"] = this.currentIllness;
        data["currentAddress"] = this.currentAddress ? this.currentAddress.toJSON() : <any>undefined;
        data["permanentAddress"] = this.permanentAddress ? this.permanentAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.dependents)) {
            data["dependents"] = [];
            for (let item of this.dependents)
                data["dependents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPersonalDetailsViewDto {
    email: string | undefined;
    fatherName: string | undefined;
    motherName: string | undefined;
    religion: string | undefined;
    bloodGroup: string | undefined;
    maritalStatus: string | undefined;
    marriageDate: moment.Moment | undefined;
    currentIllness: string | undefined;
    currentAddress: AddressViewDto;
    permanentAddress: AddressViewDto;
    dependents: EmployeeDependentViewDto[] | undefined;
}

export class QualificationDto implements IQualificationDto {
    education!: string | undefined;
    specialization!: string | undefined;
    modes!: string | undefined;
    passingYear!: number;
    institution!: string | undefined;
    percentage!: number | undefined;

    constructor(data?: IQualificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.education = _data["education"];
            this.specialization = _data["specialization"];
            this.modes = _data["modes"];
            this.passingYear = _data["passingYear"];
            this.institution = _data["institution"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): QualificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["education"] = this.education;
        data["specialization"] = this.specialization;
        data["modes"] = this.modes;
        data["passingYear"] = this.passingYear;
        data["institution"] = this.institution;
        data["percentage"] = this.percentage;
        return data;
    }
}

export interface IQualificationDto {
    education: string | undefined;
    specialization: string | undefined;
    modes: string | undefined;
    passingYear: number;
    institution: string | undefined;
    percentage: number | undefined;
}

export class EmployeeDocumentViewDto implements IEmployeeDocumentViewDto {
    documentType!: string | undefined;
    name!: string | undefined;
    documentUrl!: string | undefined;
    remarks!: string | undefined;

    constructor(data?: IEmployeeDocumentViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentType = _data["documentType"];
            this.name = _data["name"];
            this.documentUrl = _data["documentUrl"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): EmployeeDocumentViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDocumentViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType;
        data["name"] = this.name;
        data["documentUrl"] = this.documentUrl;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IEmployeeDocumentViewDto {
    documentType: string | undefined;
    name: string | undefined;
    documentUrl: string | undefined;
    remarks: string | undefined;
}

export class EmployeeViewDto implements IEmployeeViewDto {
    employeeCode!: string | undefined;
    email!: string | undefined;
    abpUserId!: number | undefined;
    mobileNumber!: string | undefined;
    employeeName!: EmployeeNameDto;
    gender!: string | undefined;
    dateOfBirth!: moment.Moment;
    bioMetricId!: string | undefined;
    status!: string | undefined;
    probation!: string | undefined;
    reportingManagerImageURL!: string | undefined;
    reportingManagerId!: number | undefined;
    nationality!: string | undefined;
    imageUrl!: string | undefined;
    mrrExists!: boolean | undefined;
    emergencyContact!: EmergencyContactDto;
    employment!: EmploymentViewDto;
    personalDetails!: PersonalDetailsViewDto;
    qualifications!: QualificationDto[] | undefined;
    documents!: EmployeeDocumentViewDto[] | undefined;
    id!: number;

    constructor(data?: IEmployeeViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeCode = _data["employeeCode"];
            this.email = _data["email"];
            this.abpUserId = _data["abpUserId"];
            this.mobileNumber = _data["mobileNumber"];
            this.employeeName = _data["employeeName"] ? EmployeeNameDto.fromJS(_data["employeeName"]) : <any>undefined;
            this.gender = _data["gender"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : <any>undefined;
            this.bioMetricId = _data["bioMetricId"];
            this.status = _data["status"];
            this.probation = _data["probation"];
            this.reportingManagerImageURL = _data["reportingManagerImageURL"];
            this.reportingManagerId = _data["reportingManagerId"];
            this.nationality = _data["nationality"];
            this.imageUrl = _data["imageUrl"];
            this.mrrExists = _data["mrrExists"];
            this.emergencyContact = _data["emergencyContact"] ? EmergencyContactDto.fromJS(_data["emergencyContact"]) : <any>undefined;
            this.employment = _data["employment"] ? EmploymentViewDto.fromJS(_data["employment"]) : <any>undefined;
            this.personalDetails = _data["personalDetails"] ? PersonalDetailsViewDto.fromJS(_data["personalDetails"]) : <any>undefined;
            if (Array.isArray(_data["qualifications"])) {
                this.qualifications = [] as any;
                for (let item of _data["qualifications"])
                    this.qualifications!.push(QualificationDto.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(EmployeeDocumentViewDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EmployeeViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeCode"] = this.employeeCode;
        data["email"] = this.email;
        data["abpUserId"] = this.abpUserId;
        data["mobileNumber"] = this.mobileNumber;
        data["employeeName"] = this.employeeName ? this.employeeName.toJSON() : <any>undefined;
        data["gender"] = this.gender;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["bioMetricId"] = this.bioMetricId;
        data["status"] = this.status;
        data["probation"] = this.probation;
        data["reportingManagerImageURL"] = this.reportingManagerImageURL;
        data["reportingManagerId"] = this.reportingManagerId;
        data["nationality"] = this.nationality;
        data["imageUrl"] = this.imageUrl;
        data["mrrExists"] = this.mrrExists;
        data["emergencyContact"] = this.emergencyContact ? this.emergencyContact.toJSON() : <any>undefined;
        data["employment"] = this.employment ? this.employment.toJSON() : <any>undefined;
        data["personalDetails"] = this.personalDetails ? this.personalDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.qualifications)) {
            data["qualifications"] = [];
            for (let item of this.qualifications)
                data["qualifications"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IEmployeeViewDto {
    employeeCode: string | undefined;
    email: string | undefined;
    abpUserId: number | undefined;
    mobileNumber: string | undefined;
    employeeName: EmployeeNameDto;
    gender: string | undefined;
    dateOfBirth: moment.Moment;
    bioMetricId: string | undefined;
    status: string | undefined;
    probation: string | undefined;
    reportingManagerImageURL: string | undefined;
    reportingManagerId: number | undefined;
    nationality: string | undefined;
    imageUrl: string | undefined;
    mrrExists: boolean | undefined;
    emergencyContact: EmergencyContactDto;
    employment: EmploymentViewDto;
    personalDetails: PersonalDetailsViewDto;
    qualifications: QualificationDto[] | undefined;
    documents: EmployeeDocumentViewDto[] | undefined;
    id: number;
}

export class GetEmployeeForViewDto implements IGetEmployeeForViewDto {
    employee!: EmployeeViewDto;

    constructor(data?: IGetEmployeeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? EmployeeViewDto.fromJS(_data["employee"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEmployeeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEmployeeForViewDto {
    employee: EmployeeViewDto;
}

export class CreateOrEditEmploymentDto implements ICreateOrEditEmploymentDto {
    dateOfJoining!: moment.Moment;
    dateOfLeaving!: moment.Moment | undefined;
    confirmDate!: moment.Moment | undefined;
    previousEmployeeCode!: string | undefined;
    divisionId!: number;
    departmentId!: number;
    subDepartmentId!: number | undefined;
    designationId!: number;
    locationId!: number;
    reportingManagerId!: number | undefined;
    functionalManagerId!: number | undefined;
    employmentTypeId!: number;
    shiftId!: number | undefined;
    contractorId!: number | undefined;
    headquarterId!: number | undefined;
    referenceDetails!: string | undefined;
    rehireEligibility!: number | undefined;

    constructor(data?: ICreateOrEditEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateOfJoining = _data["dateOfJoining"] ? moment(_data["dateOfJoining"].toString()) : <any>undefined;
            this.dateOfLeaving = _data["dateOfLeaving"] ? moment(_data["dateOfLeaving"].toString()) : <any>undefined;
            this.confirmDate = _data["confirmDate"] ? moment(_data["confirmDate"].toString()) : <any>undefined;
            this.previousEmployeeCode = _data["previousEmployeeCode"];
            this.divisionId = _data["divisionId"];
            this.departmentId = _data["departmentId"];
            this.subDepartmentId = _data["subDepartmentId"];
            this.designationId = _data["designationId"];
            this.locationId = _data["locationId"];
            this.reportingManagerId = _data["reportingManagerId"];
            this.functionalManagerId = _data["functionalManagerId"];
            this.employmentTypeId = _data["employmentTypeId"];
            this.shiftId = _data["shiftId"];
            this.contractorId = _data["contractorId"];
            this.headquarterId = _data["headquarterId"];
            this.referenceDetails = _data["referenceDetails"];
            this.rehireEligibility = _data["rehireEligibility"];
        }
    }

    static fromJS(data: any): CreateOrEditEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateOfJoining"] = this.dateOfJoining ? this.dateOfJoining.toISOString() : <any>undefined;
        data["dateOfLeaving"] = this.dateOfLeaving ? this.dateOfLeaving.toISOString() : <any>undefined;
        data["confirmDate"] = this.confirmDate ? this.confirmDate.toISOString() : <any>undefined;
        data["previousEmployeeCode"] = this.previousEmployeeCode;
        data["divisionId"] = this.divisionId;
        data["departmentId"] = this.departmentId;
        data["subDepartmentId"] = this.subDepartmentId;
        data["designationId"] = this.designationId;
        data["locationId"] = this.locationId;
        data["reportingManagerId"] = this.reportingManagerId;
        data["functionalManagerId"] = this.functionalManagerId;
        data["employmentTypeId"] = this.employmentTypeId;
        data["shiftId"] = this.shiftId;
        data["contractorId"] = this.contractorId;
        data["headquarterId"] = this.headquarterId;
        data["referenceDetails"] = this.referenceDetails;
        data["rehireEligibility"] = this.rehireEligibility;
        return data;
    }
}

export interface ICreateOrEditEmploymentDto {
    dateOfJoining: moment.Moment;
    dateOfLeaving: moment.Moment | undefined;
    confirmDate: moment.Moment | undefined;
    previousEmployeeCode: string | undefined;
    divisionId: number;
    departmentId: number;
    subDepartmentId: number | undefined;
    designationId: number;
    locationId: number;
    reportingManagerId: number | undefined;
    functionalManagerId: number | undefined;
    employmentTypeId: number;
    shiftId: number | undefined;
    contractorId: number | undefined;
    headquarterId: number | undefined;
    referenceDetails: string | undefined;
    rehireEligibility: number | undefined;
}

export class EmployeeDependentDto implements IEmployeeDependentDto {
    name!: string | undefined;
    phonenumber!: string | undefined;
    dateOfBirth!: moment.Moment;
    dependentType!: number;
    remarks!: string | undefined;
    aadharcard!: string | undefined;
    pancard!: string | undefined;

    constructor(data?: IEmployeeDependentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.phonenumber = _data["phonenumber"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : <any>undefined;
            this.dependentType = _data["dependentType"];
            this.remarks = _data["remarks"];
            this.aadharcard = _data["aadharcard"];
            this.pancard = _data["pancard"];
        }
    }

    static fromJS(data: any): EmployeeDependentDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDependentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phonenumber"] = this.phonenumber;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["dependentType"] = this.dependentType;
        data["remarks"] = this.remarks;
        data["aadharcard"] = this.aadharcard;
        data["pancard"] = this.pancard;
        return data;
    }
}

export interface IEmployeeDependentDto {
    name: string | undefined;
    phonenumber: string | undefined;
    dateOfBirth: moment.Moment;
    dependentType: number;
    remarks: string | undefined;
    aadharcard: string | undefined;
    pancard: string | undefined;
}

export class CreateOrEditPersonalDetailsDto implements ICreateOrEditPersonalDetailsDto {
    email!: string | undefined;
    fatherName!: string | undefined;
    motherName!: string | undefined;
    aadharCard!: string | undefined;
    panCard!: string | undefined;
    personalMobileNo!: string | undefined;
    religion!: string | undefined;
    bloodGroup!: string | undefined;
    maritalStatus!: string | undefined;
    marriageDate!: moment.Moment | undefined;
    currentIllness!: string | undefined;
    currentAddress!: AddressDto;
    permanentAddress!: AddressDto;
    dependents!: EmployeeDependentDto[] | undefined;

    constructor(data?: ICreateOrEditPersonalDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.fatherName = _data["fatherName"];
            this.motherName = _data["motherName"];
            this.aadharCard = _data["aadharCard"];
            this.panCard = _data["panCard"];
            this.personalMobileNo = _data["personalMobileNo"];
            this.religion = _data["religion"];
            this.bloodGroup = _data["bloodGroup"];
            this.maritalStatus = _data["maritalStatus"];
            this.marriageDate = _data["marriageDate"] ? moment(_data["marriageDate"].toString()) : <any>undefined;
            this.currentIllness = _data["currentIllness"];
            this.currentAddress = _data["currentAddress"] ? AddressDto.fromJS(_data["currentAddress"]) : <any>undefined;
            this.permanentAddress = _data["permanentAddress"] ? AddressDto.fromJS(_data["permanentAddress"]) : <any>undefined;
            if (Array.isArray(_data["dependents"])) {
                this.dependents = [] as any;
                for (let item of _data["dependents"])
                    this.dependents!.push(EmployeeDependentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditPersonalDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPersonalDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["fatherName"] = this.fatherName;
        data["motherName"] = this.motherName;
        data["aadharCard"] = this.aadharCard;
        data["panCard"] = this.panCard;
        data["personalMobileNo"] = this.personalMobileNo;
        data["religion"] = this.religion;
        data["bloodGroup"] = this.bloodGroup;
        data["maritalStatus"] = this.maritalStatus;
        data["marriageDate"] = this.marriageDate ? this.marriageDate.toISOString() : <any>undefined;
        data["currentIllness"] = this.currentIllness;
        data["currentAddress"] = this.currentAddress ? this.currentAddress.toJSON() : <any>undefined;
        data["permanentAddress"] = this.permanentAddress ? this.permanentAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.dependents)) {
            data["dependents"] = [];
            for (let item of this.dependents)
                data["dependents"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrEditPersonalDetailsDto {
    email: string | undefined;
    fatherName: string | undefined;
    motherName: string | undefined;
    aadharCard: string | undefined;
    panCard: string | undefined;
    personalMobileNo: string | undefined;
    religion: string | undefined;
    bloodGroup: string | undefined;
    maritalStatus: string | undefined;
    marriageDate: moment.Moment | undefined;
    currentIllness: string | undefined;
    currentAddress: AddressDto;
    permanentAddress: AddressDto;
    dependents: EmployeeDependentDto[] | undefined;
}

export class EmployeeDocumentDto implements IEmployeeDocumentDto {
    documentTypeId!: number;
    documentTypeName!: string | undefined;
    name!: string | undefined;
    documentUrl!: string | undefined;
    remarks!: string | undefined;

    constructor(data?: IEmployeeDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentTypeId = _data["documentTypeId"];
            this.documentTypeName = _data["documentTypeName"];
            this.name = _data["name"];
            this.documentUrl = _data["documentUrl"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): EmployeeDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentTypeId"] = this.documentTypeId;
        data["documentTypeName"] = this.documentTypeName;
        data["name"] = this.name;
        data["documentUrl"] = this.documentUrl;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IEmployeeDocumentDto {
    documentTypeId: number;
    documentTypeName: string | undefined;
    name: string | undefined;
    documentUrl: string | undefined;
    remarks: string | undefined;
}

export class CreateOrEditEmployeeDto implements ICreateOrEditEmployeeDto {
    employeeCode!: string | undefined;
    employeePrefix!: string | undefined;
    employeePostfix!: string | undefined;
    email!: string | undefined;
    mobileNumber!: string | undefined;
    employeeName!: EmployeeNameDto;
    gender!: number;
    dateOfBirth!: moment.Moment;
    bioMetricId!: string | undefined;
    status!: number;
    probationMonth!: number | undefined;
    nationality!: number;
    longitude!: string | undefined;
    latitude!: string | undefined;
    radius!: number;
    remarks!: string | undefined;
    employeeImage!: string | undefined;
    incrementCycle!: number;
    iamgeUrl!: string | undefined;
    otApplicable!: boolean | undefined;
    mrrExists!: boolean;
    pickUpPreviousEmployeeDetails!: boolean;
    dimensionCode!: number | undefined;
    reportingMangager!: boolean | undefined;
    emergencyContact!: EmergencyContactDto;
    employment!: CreateOrEditEmploymentDto;
    personalDetails!: CreateOrEditPersonalDetailsDto;
    qualifications!: QualificationDto[] | undefined;
    documents!: EmployeeDocumentDto[] | undefined;
    employeeattendancemode!: GetEmployeeAttendanceModeDto;
    id!: number | undefined;

    constructor(data?: ICreateOrEditEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeCode = _data["employeeCode"];
            this.employeePrefix = _data["employeePrefix"];
            this.employeePostfix = _data["employeePostfix"];
            this.email = _data["email"];
            this.mobileNumber = _data["mobileNumber"];
            this.employeeName = _data["employeeName"] ? EmployeeNameDto.fromJS(_data["employeeName"]) : <any>undefined;
            this.gender = _data["gender"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : <any>undefined;
            this.bioMetricId = _data["bioMetricId"];
            this.status = _data["status"];
            this.probationMonth = _data["probationMonth"];
            this.nationality = _data["nationality"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.radius = _data["radius"];
            this.remarks = _data["remarks"];
            this.employeeImage = _data["employeeImage"];
            this.incrementCycle = _data["incrementCycle"];
            this.iamgeUrl = _data["iamgeUrl"];
            this.otApplicable = _data["otApplicable"];
            this.mrrExists = _data["mrrExists"];
            this.pickUpPreviousEmployeeDetails = _data["pickUpPreviousEmployeeDetails"];
            this.dimensionCode = _data["dimensionCode"];
            this.reportingMangager = _data["reportingMangager"];
            this.emergencyContact = _data["emergencyContact"] ? EmergencyContactDto.fromJS(_data["emergencyContact"]) : <any>undefined;
            this.employment = _data["employment"] ? CreateOrEditEmploymentDto.fromJS(_data["employment"]) : <any>undefined;
            this.personalDetails = _data["personalDetails"] ? CreateOrEditPersonalDetailsDto.fromJS(_data["personalDetails"]) : <any>undefined;
            if (Array.isArray(_data["qualifications"])) {
                this.qualifications = [] as any;
                for (let item of _data["qualifications"])
                    this.qualifications!.push(QualificationDto.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(EmployeeDocumentDto.fromJS(item));
            }
            this.employeeattendancemode = _data["employeeattendancemode"] ? GetEmployeeAttendanceModeDto.fromJS(_data["employeeattendancemode"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeCode"] = this.employeeCode;
        data["employeePrefix"] = this.employeePrefix;
        data["employeePostfix"] = this.employeePostfix;
        data["email"] = this.email;
        data["mobileNumber"] = this.mobileNumber;
        data["employeeName"] = this.employeeName ? this.employeeName.toJSON() : <any>undefined;
        data["gender"] = this.gender;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["bioMetricId"] = this.bioMetricId;
        data["status"] = this.status;
        data["probationMonth"] = this.probationMonth;
        data["nationality"] = this.nationality;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["radius"] = this.radius;
        data["remarks"] = this.remarks;
        data["employeeImage"] = this.employeeImage;
        data["incrementCycle"] = this.incrementCycle;
        data["iamgeUrl"] = this.iamgeUrl;
        data["otApplicable"] = this.otApplicable;
        data["mrrExists"] = this.mrrExists;
        data["pickUpPreviousEmployeeDetails"] = this.pickUpPreviousEmployeeDetails;
        data["dimensionCode"] = this.dimensionCode;
        data["reportingMangager"] = this.reportingMangager;
        data["emergencyContact"] = this.emergencyContact ? this.emergencyContact.toJSON() : <any>undefined;
        data["employment"] = this.employment ? this.employment.toJSON() : <any>undefined;
        data["personalDetails"] = this.personalDetails ? this.personalDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.qualifications)) {
            data["qualifications"] = [];
            for (let item of this.qualifications)
                data["qualifications"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["employeeattendancemode"] = this.employeeattendancemode ? this.employeeattendancemode.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditEmployeeDto {
    employeeCode: string | undefined;
    employeePrefix: string | undefined;
    employeePostfix: string | undefined;
    email: string | undefined;
    mobileNumber: string | undefined;
    employeeName: EmployeeNameDto;
    gender: number;
    dateOfBirth: moment.Moment;
    bioMetricId: string | undefined;
    status: number;
    probationMonth: number | undefined;
    nationality: number;
    longitude: string | undefined;
    latitude: string | undefined;
    radius: number;
    remarks: string | undefined;
    employeeImage: string | undefined;
    incrementCycle: number;
    iamgeUrl: string | undefined;
    otApplicable: boolean | undefined;
    mrrExists: boolean;
    pickUpPreviousEmployeeDetails: boolean;
    dimensionCode: number | undefined;
    reportingMangager: boolean | undefined;
    emergencyContact: EmergencyContactDto;
    employment: CreateOrEditEmploymentDto;
    personalDetails: CreateOrEditPersonalDetailsDto;
    qualifications: QualificationDto[] | undefined;
    documents: EmployeeDocumentDto[] | undefined;
    employeeattendancemode: GetEmployeeAttendanceModeDto;
    id: number | undefined;
}

export class GetEmployeeForEditOutput implements IGetEmployeeForEditOutput {
    employee!: CreateOrEditEmployeeDto;
    reasonName!: string | undefined;
    requestedBy!: number | undefined;
    requestDate!: moment.Moment | undefined;
    requestFlow!: string | undefined;
    leaveRejectStatus!: string | undefined;

    constructor(data?: IGetEmployeeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? CreateOrEditEmployeeDto.fromJS(_data["employee"]) : <any>undefined;
            this.reasonName = _data["reasonName"];
            this.requestedBy = _data["requestedBy"];
            this.requestDate = _data["requestDate"] ? moment(_data["requestDate"].toString()) : <any>undefined;
            this.requestFlow = _data["requestFlow"];
            this.leaveRejectStatus = _data["leaveRejectStatus"];
        }
    }

    static fromJS(data: any): GetEmployeeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["reasonName"] = this.reasonName;
        data["requestedBy"] = this.requestedBy;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["requestFlow"] = this.requestFlow;
        data["leaveRejectStatus"] = this.leaveRejectStatus;
        return data;
    }
}

export interface IGetEmployeeForEditOutput {
    employee: CreateOrEditEmployeeDto;
    reasonName: string | undefined;
    requestedBy: number | undefined;
    requestDate: moment.Moment | undefined;
    requestFlow: string | undefined;
    leaveRejectStatus: string | undefined;
}

export class EmployeeStatusDto implements IEmployeeStatusDto {
    employeeId!: number;
    dateOfLeaving!: moment.Moment | undefined;
    confirmDate!: moment.Moment | undefined;
    employeeStatus!: number;
    probationMonth!: number | undefined;
    rehireEligibility!: number;
    remarks!: string | undefined;

    constructor(data?: IEmployeeStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.dateOfLeaving = _data["dateOfLeaving"] ? moment(_data["dateOfLeaving"].toString()) : <any>undefined;
            this.confirmDate = _data["confirmDate"] ? moment(_data["confirmDate"].toString()) : <any>undefined;
            this.employeeStatus = _data["employeeStatus"];
            this.probationMonth = _data["probationMonth"];
            this.rehireEligibility = _data["rehireEligibility"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): EmployeeStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["dateOfLeaving"] = this.dateOfLeaving ? this.dateOfLeaving.toISOString() : <any>undefined;
        data["confirmDate"] = this.confirmDate ? this.confirmDate.toISOString() : <any>undefined;
        data["employeeStatus"] = this.employeeStatus;
        data["probationMonth"] = this.probationMonth;
        data["rehireEligibility"] = this.rehireEligibility;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IEmployeeStatusDto {
    employeeId: number;
    dateOfLeaving: moment.Moment | undefined;
    confirmDate: moment.Moment | undefined;
    employeeStatus: number;
    probationMonth: number | undefined;
    rehireEligibility: number;
    remarks: string | undefined;
}

export class AadharPanDuplicateResultDto implements IAadharPanDuplicateResultDto {
    employeeId!: number;
    employeeCode!: string | undefined;
    employeeName!: string | undefined;
    matchedOn!: string | undefined;

    constructor(data?: IAadharPanDuplicateResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.employeeCode = _data["employeeCode"];
            this.employeeName = _data["employeeName"];
            this.matchedOn = _data["matchedOn"];
        }
    }

    static fromJS(data: any): AadharPanDuplicateResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AadharPanDuplicateResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["employeeCode"] = this.employeeCode;
        data["employeeName"] = this.employeeName;
        data["matchedOn"] = this.matchedOn;
        return data;
    }
}

export interface IAadharPanDuplicateResultDto {
    employeeId: number;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    matchedOn: string | undefined;
}

export class CreateNewManualPassword implements ICreateNewManualPassword {
    id!: number;
    newpass!: string | undefined;
    newemail!: string | undefined;

    constructor(data?: ICreateNewManualPassword) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newpass = _data["newpass"];
            this.newemail = _data["newemail"];
        }
    }

    static fromJS(data: any): CreateNewManualPassword {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNewManualPassword();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newpass"] = this.newpass;
        data["newemail"] = this.newemail;
        return data;
    }
}

export interface ICreateNewManualPassword {
    id: number;
    newpass: string | undefined;
    newemail: string | undefined;
}

export class GetManualForEdit implements IGetManualForEdit {
    newmanual!: CreateNewManualPassword;

    constructor(data?: IGetManualForEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newmanual = _data["newmanual"] ? CreateNewManualPassword.fromJS(_data["newmanual"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetManualForEdit {
        data = typeof data === 'object' ? data : {};
        let result = new GetManualForEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newmanual"] = this.newmanual ? this.newmanual.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetManualForEdit {
    newmanual: CreateNewManualPassword;
}

export class CreateNewManualSMSPassword implements ICreateNewManualSMSPassword {
    id!: number;
    newpass!: string | undefined;
    newphnno!: string | undefined;

    constructor(data?: ICreateNewManualSMSPassword) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newpass = _data["newpass"];
            this.newphnno = _data["newphnno"];
        }
    }

    static fromJS(data: any): CreateNewManualSMSPassword {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNewManualSMSPassword();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newpass"] = this.newpass;
        data["newphnno"] = this.newphnno;
        return data;
    }
}

export interface ICreateNewManualSMSPassword {
    id: number;
    newpass: string | undefined;
    newphnno: string | undefined;
}

export class GetManualSMSForEdit implements IGetManualSMSForEdit {
    newsmsmanual!: CreateNewManualSMSPassword;

    constructor(data?: IGetManualSMSForEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newsmsmanual = _data["newsmsmanual"] ? CreateNewManualSMSPassword.fromJS(_data["newsmsmanual"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetManualSMSForEdit {
        data = typeof data === 'object' ? data : {};
        let result = new GetManualSMSForEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newsmsmanual"] = this.newsmsmanual ? this.newsmsmanual.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetManualSMSForEdit {
    newsmsmanual: CreateNewManualSMSPassword;
}

export class FtbImage implements IFtbImage {
    documentTypeId!: number;
    ftbData!: string | undefined;
    name!: string | undefined;
    documentType!: string | undefined;
    branchId!: number | undefined;
    designantionId!: number | undefined;

    constructor(data?: IFtbImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentTypeId = _data["documentTypeId"];
            this.ftbData = _data["ftbData"];
            this.name = _data["name"];
            this.documentType = _data["documentType"];
            this.branchId = _data["branchId"];
            this.designantionId = _data["designantionId"];
        }
    }

    static fromJS(data: any): FtbImage {
        data = typeof data === 'object' ? data : {};
        let result = new FtbImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentTypeId"] = this.documentTypeId;
        data["ftbData"] = this.ftbData;
        data["name"] = this.name;
        data["documentType"] = this.documentType;
        data["branchId"] = this.branchId;
        data["designantionId"] = this.designantionId;
        return data;
    }
}

export interface IFtbImage {
    documentTypeId: number;
    ftbData: string | undefined;
    name: string | undefined;
    documentType: string | undefined;
    branchId: number | undefined;
    designantionId: number | undefined;
}

export class CreateOrEditEmployeeDtoPort implements ICreateOrEditEmployeeDtoPort {
    employeeCode!: string | undefined;
    employeePrefix!: string | undefined;
    employeePostfix!: string | undefined;
    email!: string | undefined;
    mobileNumber!: string | undefined;
    salutation!: number;
    firstName!: string | undefined;
    lastName!: string | undefined;
    gender!: number;
    dateOfBirth!: moment.Moment;
    incrementCycle!: number;
    bioMetricId!: string | undefined;
    status!: number;
    probationMonth!: number | undefined;
    nationality!: number;
    remarks!: string | undefined;
    employeeImage!: string | undefined;
    street!: string | undefined;
    city!: string | undefined;
    state!: number;
    country!: number;
    zipCode!: string | undefined;
    iamgeUrl!: string | undefined;
    emergencyContactName!: string | undefined;
    emergencyContactMobile!: string | undefined;
    relationShip!: EmployeeRelation;
    persionalEmail!: string | undefined;
    fatherName!: string | undefined;
    motherName!: string | undefined;
    aadharCard!: string | undefined;
    panCard!: string | undefined;
    personalMobileNo!: string | undefined;
    religion!: string | undefined;
    bloodGroup!: string | undefined;
    maritalStatus!: string | undefined;
    marriageDate!: moment.Moment | undefined;
    currentIllness!: string | undefined;
    dateOfJoining!: moment.Moment;
    dateOfLeaving!: moment.Moment | undefined;
    previousEmployeeCode!: string | undefined;
    employment!: CreateOrEditEmploymentDto;
    qualifications!: QualificationDto[] | undefined;
    documents!: EmployeeDocumentDto[] | undefined;
    esi!: string | undefined;
    pf!: string | undefined;
    conveyance!: string | undefined;
    hra!: string | undefined;
    basic!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditEmployeeDtoPort) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeCode = _data["employeeCode"];
            this.employeePrefix = _data["employeePrefix"];
            this.employeePostfix = _data["employeePostfix"];
            this.email = _data["email"];
            this.mobileNumber = _data["mobileNumber"];
            this.salutation = _data["salutation"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gender = _data["gender"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : <any>undefined;
            this.incrementCycle = _data["incrementCycle"];
            this.bioMetricId = _data["bioMetricId"];
            this.status = _data["status"];
            this.probationMonth = _data["probationMonth"];
            this.nationality = _data["nationality"];
            this.remarks = _data["remarks"];
            this.employeeImage = _data["employeeImage"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.zipCode = _data["zipCode"];
            this.iamgeUrl = _data["iamgeUrl"];
            this.emergencyContactName = _data["emergencyContactName"];
            this.emergencyContactMobile = _data["emergencyContactMobile"];
            this.relationShip = _data["relationShip"];
            this.persionalEmail = _data["persionalEmail"];
            this.fatherName = _data["fatherName"];
            this.motherName = _data["motherName"];
            this.aadharCard = _data["aadharCard"];
            this.panCard = _data["panCard"];
            this.personalMobileNo = _data["personalMobileNo"];
            this.religion = _data["religion"];
            this.bloodGroup = _data["bloodGroup"];
            this.maritalStatus = _data["maritalStatus"];
            this.marriageDate = _data["marriageDate"] ? moment(_data["marriageDate"].toString()) : <any>undefined;
            this.currentIllness = _data["currentIllness"];
            this.dateOfJoining = _data["dateOfJoining"] ? moment(_data["dateOfJoining"].toString()) : <any>undefined;
            this.dateOfLeaving = _data["dateOfLeaving"] ? moment(_data["dateOfLeaving"].toString()) : <any>undefined;
            this.previousEmployeeCode = _data["previousEmployeeCode"];
            this.employment = _data["employment"] ? CreateOrEditEmploymentDto.fromJS(_data["employment"]) : <any>undefined;
            if (Array.isArray(_data["qualifications"])) {
                this.qualifications = [] as any;
                for (let item of _data["qualifications"])
                    this.qualifications!.push(QualificationDto.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(EmployeeDocumentDto.fromJS(item));
            }
            this.esi = _data["esi"];
            this.pf = _data["pf"];
            this.conveyance = _data["conveyance"];
            this.hra = _data["hra"];
            this.basic = _data["basic"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEmployeeDtoPort {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEmployeeDtoPort();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeCode"] = this.employeeCode;
        data["employeePrefix"] = this.employeePrefix;
        data["employeePostfix"] = this.employeePostfix;
        data["email"] = this.email;
        data["mobileNumber"] = this.mobileNumber;
        data["salutation"] = this.salutation;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gender"] = this.gender;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["incrementCycle"] = this.incrementCycle;
        data["bioMetricId"] = this.bioMetricId;
        data["status"] = this.status;
        data["probationMonth"] = this.probationMonth;
        data["nationality"] = this.nationality;
        data["remarks"] = this.remarks;
        data["employeeImage"] = this.employeeImage;
        data["street"] = this.street;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["zipCode"] = this.zipCode;
        data["iamgeUrl"] = this.iamgeUrl;
        data["emergencyContactName"] = this.emergencyContactName;
        data["emergencyContactMobile"] = this.emergencyContactMobile;
        data["relationShip"] = this.relationShip;
        data["persionalEmail"] = this.persionalEmail;
        data["fatherName"] = this.fatherName;
        data["motherName"] = this.motherName;
        data["aadharCard"] = this.aadharCard;
        data["panCard"] = this.panCard;
        data["personalMobileNo"] = this.personalMobileNo;
        data["religion"] = this.religion;
        data["bloodGroup"] = this.bloodGroup;
        data["maritalStatus"] = this.maritalStatus;
        data["marriageDate"] = this.marriageDate ? this.marriageDate.toISOString() : <any>undefined;
        data["currentIllness"] = this.currentIllness;
        data["dateOfJoining"] = this.dateOfJoining ? this.dateOfJoining.toISOString() : <any>undefined;
        data["dateOfLeaving"] = this.dateOfLeaving ? this.dateOfLeaving.toISOString() : <any>undefined;
        data["previousEmployeeCode"] = this.previousEmployeeCode;
        data["employment"] = this.employment ? this.employment.toJSON() : <any>undefined;
        if (Array.isArray(this.qualifications)) {
            data["qualifications"] = [];
            for (let item of this.qualifications)
                data["qualifications"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["esi"] = this.esi;
        data["pf"] = this.pf;
        data["conveyance"] = this.conveyance;
        data["hra"] = this.hra;
        data["basic"] = this.basic;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditEmployeeDtoPort {
    employeeCode: string | undefined;
    employeePrefix: string | undefined;
    employeePostfix: string | undefined;
    email: string | undefined;
    mobileNumber: string | undefined;
    salutation: number;
    firstName: string | undefined;
    lastName: string | undefined;
    gender: number;
    dateOfBirth: moment.Moment;
    incrementCycle: number;
    bioMetricId: string | undefined;
    status: number;
    probationMonth: number | undefined;
    nationality: number;
    remarks: string | undefined;
    employeeImage: string | undefined;
    street: string | undefined;
    city: string | undefined;
    state: number;
    country: number;
    zipCode: string | undefined;
    iamgeUrl: string | undefined;
    emergencyContactName: string | undefined;
    emergencyContactMobile: string | undefined;
    relationShip: EmployeeRelation;
    persionalEmail: string | undefined;
    fatherName: string | undefined;
    motherName: string | undefined;
    aadharCard: string | undefined;
    panCard: string | undefined;
    personalMobileNo: string | undefined;
    religion: string | undefined;
    bloodGroup: string | undefined;
    maritalStatus: string | undefined;
    marriageDate: moment.Moment | undefined;
    currentIllness: string | undefined;
    dateOfJoining: moment.Moment;
    dateOfLeaving: moment.Moment | undefined;
    previousEmployeeCode: string | undefined;
    employment: CreateOrEditEmploymentDto;
    qualifications: QualificationDto[] | undefined;
    documents: EmployeeDocumentDto[] | undefined;
    esi: string | undefined;
    pf: string | undefined;
    conveyance: string | undefined;
    hra: string | undefined;
    basic: string | undefined;
    id: number | undefined;
}

export class PendingImportBatchDto implements IPendingImportBatchDto {
    batchId!: string | undefined;
    creationTime!: moment.Moment;
    totalRows!: number;
    invalidRows!: number;
    importType!: string | undefined;

    constructor(data?: IPendingImportBatchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchId = _data["batchId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.totalRows = _data["totalRows"];
            this.invalidRows = _data["invalidRows"];
            this.importType = _data["importType"];
        }
    }

    static fromJS(data: any): PendingImportBatchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PendingImportBatchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchId"] = this.batchId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["totalRows"] = this.totalRows;
        data["invalidRows"] = this.invalidRows;
        data["importType"] = this.importType;
        return data;
    }
}

export interface IPendingImportBatchDto {
    batchId: string | undefined;
    creationTime: moment.Moment;
    totalRows: number;
    invalidRows: number;
    importType: string | undefined;
}

export class LeaveDetailsForSalarySlip implements ILeaveDetailsForSalarySlip {
    leaveName!: string | undefined;
    leaveType!: string | undefined;
    leaveUsed!: number;
    leaveAllowed!: number;
    leavecarryforward!: number;
    negativeBalanceAllowed!: boolean;
    id!: number;

    constructor(data?: ILeaveDetailsForSalarySlip) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveName = _data["leaveName"];
            this.leaveType = _data["leaveType"];
            this.leaveUsed = _data["leaveUsed"];
            this.leaveAllowed = _data["leaveAllowed"];
            this.leavecarryforward = _data["leavecarryforward"];
            this.negativeBalanceAllowed = _data["negativeBalanceAllowed"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LeaveDetailsForSalarySlip {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveDetailsForSalarySlip();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveName"] = this.leaveName;
        data["leaveType"] = this.leaveType;
        data["leaveUsed"] = this.leaveUsed;
        data["leaveAllowed"] = this.leaveAllowed;
        data["leavecarryforward"] = this.leavecarryforward;
        data["negativeBalanceAllowed"] = this.negativeBalanceAllowed;
        data["id"] = this.id;
        return data;
    }
}

export interface ILeaveDetailsForSalarySlip {
    leaveName: string | undefined;
    leaveType: string | undefined;
    leaveUsed: number;
    leaveAllowed: number;
    leavecarryforward: number;
    negativeBalanceAllowed: boolean;
    id: number;
}

export class EaringComponets implements IEaringComponets {
    name!: string | undefined;
    rate!: number | undefined;
    rs!: number | undefined;
    arrear!: number | undefined;
    ytd!: number | undefined;

    constructor(data?: IEaringComponets) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.rate = _data["rate"];
            this.rs = _data["rs"];
            this.arrear = _data["arrear"];
            this.ytd = _data["ytd"];
        }
    }

    static fromJS(data: any): EaringComponets {
        data = typeof data === 'object' ? data : {};
        let result = new EaringComponets();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["rate"] = this.rate;
        data["rs"] = this.rs;
        data["arrear"] = this.arrear;
        data["ytd"] = this.ytd;
        return data;
    }
}

export interface IEaringComponets {
    name: string | undefined;
    rate: number | undefined;
    rs: number | undefined;
    arrear: number | undefined;
    ytd: number | undefined;
}

export class DedctionComponets implements IDedctionComponets {
    name!: string | undefined;
    rate!: number | undefined;
    rs!: number | undefined;
    ytd!: number | undefined;

    constructor(data?: IDedctionComponets) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.rate = _data["rate"];
            this.rs = _data["rs"];
            this.ytd = _data["ytd"];
        }
    }

    static fromJS(data: any): DedctionComponets {
        data = typeof data === 'object' ? data : {};
        let result = new DedctionComponets();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["rate"] = this.rate;
        data["rs"] = this.rs;
        data["ytd"] = this.ytd;
        return data;
    }
}

export interface IDedctionComponets {
    name: string | undefined;
    rate: number | undefined;
    rs: number | undefined;
    ytd: number | undefined;
}

export class SalarySlipExpenseBreakup implements ISalarySlipExpenseBreakup {
    expenseName!: string | undefined;
    amount!: number;

    constructor(data?: ISalarySlipExpenseBreakup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expenseName = _data["expenseName"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): SalarySlipExpenseBreakup {
        data = typeof data === 'object' ? data : {};
        let result = new SalarySlipExpenseBreakup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expenseName"] = this.expenseName;
        data["amount"] = this.amount;
        return data;
    }
}

export interface ISalarySlipExpenseBreakup {
    expenseName: string | undefined;
    amount: number;
}

export class EmployeeSalaryReportData implements IEmployeeSalaryReportData {
    tenantaddress!: string | undefined;
    countryCode!: string | undefined;
    logoImage!: string | undefined;
    companyName!: string | undefined;
    location!: string | undefined;
    employeeName!: string | undefined;
    salaryid!: number;
    fatherName!: string | undefined;
    doj!: string | undefined;
    employeeId!: string | undefined;
    designation!: string | undefined;
    department!: string | undefined;
    bankAcNo!: string | undefined;
    pfNo!: string | undefined;
    esiNo!: string | undefined;
    bankName!: string | undefined;
    headQuarter!: string | undefined;
    panCard!: string | undefined;
    pfUanNo!: string | undefined;
    workDays!: number | undefined;
    lossOFpay!: number | undefined;
    present!: number | undefined;
    absent!: number | undefined;
    netSalary!: number | undefined;
    leave!: number | undefined;
    totalearnYtd!: number | undefined;
    totalearn!: number | undefined;
    totaldeductionYtd!: number | undefined;
    totaldeduction!: number | undefined;
    totalleaveTaken!: number | undefined;
    totalleaveBalance!: number | undefined;
    earingComponets!: EaringComponets[] | undefined;
    dedctionComponets!: DedctionComponets[] | undefined;
    levaeBalanceDetails!: LeaveDetailsForSalarySlip[] | undefined;
    showleaveonsalary!: boolean;
    monthing!: string | undefined;
    wo!: number | undefined;
    ho!: number | undefined;
    totalArrear!: number | undefined;
    salaryTemplate!: number | undefined;
    expenseBreakup!: SalarySlipExpenseBreakup[] | undefined;
    totalReimbursement!: number | undefined;

    constructor(data?: IEmployeeSalaryReportData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantaddress = _data["tenantaddress"];
            this.countryCode = _data["countryCode"];
            this.logoImage = _data["logoImage"];
            this.companyName = _data["companyName"];
            this.location = _data["location"];
            this.employeeName = _data["employeeName"];
            this.salaryid = _data["salaryid"];
            this.fatherName = _data["fatherName"];
            this.doj = _data["doj"];
            this.employeeId = _data["employeeId"];
            this.designation = _data["designation"];
            this.department = _data["department"];
            this.bankAcNo = _data["bankAcNo"];
            this.pfNo = _data["pfNo"];
            this.esiNo = _data["esiNo"];
            this.bankName = _data["bankName"];
            this.headQuarter = _data["headQuarter"];
            this.panCard = _data["panCard"];
            this.pfUanNo = _data["pfUanNo"];
            this.workDays = _data["workDays"];
            this.lossOFpay = _data["lossOFpay"];
            this.present = _data["present"];
            this.absent = _data["absent"];
            this.netSalary = _data["netSalary"];
            this.leave = _data["leave"];
            this.totalearnYtd = _data["totalearnYtd"];
            this.totalearn = _data["totalearn"];
            this.totaldeductionYtd = _data["totaldeductionYtd"];
            this.totaldeduction = _data["totaldeduction"];
            this.totalleaveTaken = _data["totalleaveTaken"];
            this.totalleaveBalance = _data["totalleaveBalance"];
            if (Array.isArray(_data["earingComponets"])) {
                this.earingComponets = [] as any;
                for (let item of _data["earingComponets"])
                    this.earingComponets!.push(EaringComponets.fromJS(item));
            }
            if (Array.isArray(_data["dedctionComponets"])) {
                this.dedctionComponets = [] as any;
                for (let item of _data["dedctionComponets"])
                    this.dedctionComponets!.push(DedctionComponets.fromJS(item));
            }
            if (Array.isArray(_data["levaeBalanceDetails"])) {
                this.levaeBalanceDetails = [] as any;
                for (let item of _data["levaeBalanceDetails"])
                    this.levaeBalanceDetails!.push(LeaveDetailsForSalarySlip.fromJS(item));
            }
            this.showleaveonsalary = _data["showleaveonsalary"];
            this.monthing = _data["monthing"];
            this.wo = _data["wo"];
            this.ho = _data["ho"];
            this.totalArrear = _data["totalArrear"];
            this.salaryTemplate = _data["salaryTemplate"];
            if (Array.isArray(_data["expenseBreakup"])) {
                this.expenseBreakup = [] as any;
                for (let item of _data["expenseBreakup"])
                    this.expenseBreakup!.push(SalarySlipExpenseBreakup.fromJS(item));
            }
            this.totalReimbursement = _data["totalReimbursement"];
        }
    }

    static fromJS(data: any): EmployeeSalaryReportData {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeSalaryReportData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantaddress"] = this.tenantaddress;
        data["countryCode"] = this.countryCode;
        data["logoImage"] = this.logoImage;
        data["companyName"] = this.companyName;
        data["location"] = this.location;
        data["employeeName"] = this.employeeName;
        data["salaryid"] = this.salaryid;
        data["fatherName"] = this.fatherName;
        data["doj"] = this.doj;
        data["employeeId"] = this.employeeId;
        data["designation"] = this.designation;
        data["department"] = this.department;
        data["bankAcNo"] = this.bankAcNo;
        data["pfNo"] = this.pfNo;
        data["esiNo"] = this.esiNo;
        data["bankName"] = this.bankName;
        data["headQuarter"] = this.headQuarter;
        data["panCard"] = this.panCard;
        data["pfUanNo"] = this.pfUanNo;
        data["workDays"] = this.workDays;
        data["lossOFpay"] = this.lossOFpay;
        data["present"] = this.present;
        data["absent"] = this.absent;
        data["netSalary"] = this.netSalary;
        data["leave"] = this.leave;
        data["totalearnYtd"] = this.totalearnYtd;
        data["totalearn"] = this.totalearn;
        data["totaldeductionYtd"] = this.totaldeductionYtd;
        data["totaldeduction"] = this.totaldeduction;
        data["totalleaveTaken"] = this.totalleaveTaken;
        data["totalleaveBalance"] = this.totalleaveBalance;
        if (Array.isArray(this.earingComponets)) {
            data["earingComponets"] = [];
            for (let item of this.earingComponets)
                data["earingComponets"].push(item.toJSON());
        }
        if (Array.isArray(this.dedctionComponets)) {
            data["dedctionComponets"] = [];
            for (let item of this.dedctionComponets)
                data["dedctionComponets"].push(item.toJSON());
        }
        if (Array.isArray(this.levaeBalanceDetails)) {
            data["levaeBalanceDetails"] = [];
            for (let item of this.levaeBalanceDetails)
                data["levaeBalanceDetails"].push(item.toJSON());
        }
        data["showleaveonsalary"] = this.showleaveonsalary;
        data["monthing"] = this.monthing;
        data["wo"] = this.wo;
        data["ho"] = this.ho;
        data["totalArrear"] = this.totalArrear;
        data["salaryTemplate"] = this.salaryTemplate;
        if (Array.isArray(this.expenseBreakup)) {
            data["expenseBreakup"] = [];
            for (let item of this.expenseBreakup)
                data["expenseBreakup"].push(item.toJSON());
        }
        data["totalReimbursement"] = this.totalReimbursement;
        return data;
    }
}

export interface IEmployeeSalaryReportData {
    tenantaddress: string | undefined;
    countryCode: string | undefined;
    logoImage: string | undefined;
    companyName: string | undefined;
    location: string | undefined;
    employeeName: string | undefined;
    salaryid: number;
    fatherName: string | undefined;
    doj: string | undefined;
    employeeId: string | undefined;
    designation: string | undefined;
    department: string | undefined;
    bankAcNo: string | undefined;
    pfNo: string | undefined;
    esiNo: string | undefined;
    bankName: string | undefined;
    headQuarter: string | undefined;
    panCard: string | undefined;
    pfUanNo: string | undefined;
    workDays: number | undefined;
    lossOFpay: number | undefined;
    present: number | undefined;
    absent: number | undefined;
    netSalary: number | undefined;
    leave: number | undefined;
    totalearnYtd: number | undefined;
    totalearn: number | undefined;
    totaldeductionYtd: number | undefined;
    totaldeduction: number | undefined;
    totalleaveTaken: number | undefined;
    totalleaveBalance: number | undefined;
    earingComponets: EaringComponets[] | undefined;
    dedctionComponets: DedctionComponets[] | undefined;
    levaeBalanceDetails: LeaveDetailsForSalarySlip[] | undefined;
    showleaveonsalary: boolean;
    monthing: string | undefined;
    wo: number | undefined;
    ho: number | undefined;
    totalArrear: number | undefined;
    salaryTemplate: number | undefined;
    expenseBreakup: SalarySlipExpenseBreakup[] | undefined;
    totalReimbursement: number | undefined;
}

export class EaringComponetsStandardPdf implements IEaringComponetsStandardPdf {
    name!: string | undefined;
    amount!: number | undefined;

    constructor(data?: IEaringComponetsStandardPdf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): EaringComponetsStandardPdf {
        data = typeof data === 'object' ? data : {};
        let result = new EaringComponetsStandardPdf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IEaringComponetsStandardPdf {
    name: string | undefined;
    amount: number | undefined;
}

export class EaringComponetsPdf implements IEaringComponetsPdf {
    name!: string | undefined;
    amount!: number | undefined;

    constructor(data?: IEaringComponetsPdf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): EaringComponetsPdf {
        data = typeof data === 'object' ? data : {};
        let result = new EaringComponetsPdf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IEaringComponetsPdf {
    name: string | undefined;
    amount: number | undefined;
}

export class DedctionComponetsPdf implements IDedctionComponetsPdf {
    name!: string | undefined;
    amount!: number | undefined;

    constructor(data?: IDedctionComponetsPdf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): DedctionComponetsPdf {
        data = typeof data === 'object' ? data : {};
        let result = new DedctionComponetsPdf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IDedctionComponetsPdf {
    name: string | undefined;
    amount: number | undefined;
}

export class SalaryRegisterPdfReportData implements ISalaryRegisterPdfReportData {
    companyName!: string | undefined;
    location!: string | undefined;
    employeeName!: string | undefined;
    salaryid!: number;
    fatherName!: string | undefined;
    doj!: moment.Moment;
    employeeId!: string | undefined;
    designation!: string | undefined;
    department!: string | undefined;
    bankAcNo!: string | undefined;
    pfNo!: string | undefined;
    esiNo!: string | undefined;
    bankName!: string | undefined;
    panCard!: string | undefined;
    pfUanNo!: string | undefined;
    workDays!: number | undefined;
    leave!: number | undefined;
    el!: number;
    cl!: number;
    sl!: number;
    dob!: moment.Moment;
    aadharCard!: string | undefined;
    netSalary!: number;
    wd!: number;
    wo!: number;
    holiday!: number;
    lwp!: number;
    absent!: number;
    paiddays!: number;
    earingComponetstandard!: EaringComponetsStandardPdf[] | undefined;
    earingComponets!: EaringComponetsPdf[] | undefined;
    dedctionComponets!: DedctionComponetsPdf[] | undefined;
    leavesBalanceDetails!: LeaveDetailsForSalarySlip[] | undefined;

    constructor(data?: ISalaryRegisterPdfReportData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.location = _data["location"];
            this.employeeName = _data["employeeName"];
            this.salaryid = _data["salaryid"];
            this.fatherName = _data["fatherName"];
            this.doj = _data["doj"] ? moment(_data["doj"].toString()) : <any>undefined;
            this.employeeId = _data["employeeId"];
            this.designation = _data["designation"];
            this.department = _data["department"];
            this.bankAcNo = _data["bankAcNo"];
            this.pfNo = _data["pfNo"];
            this.esiNo = _data["esiNo"];
            this.bankName = _data["bankName"];
            this.panCard = _data["panCard"];
            this.pfUanNo = _data["pfUanNo"];
            this.workDays = _data["workDays"];
            this.leave = _data["leave"];
            this.el = _data["el"];
            this.cl = _data["cl"];
            this.sl = _data["sl"];
            this.dob = _data["dob"] ? moment(_data["dob"].toString()) : <any>undefined;
            this.aadharCard = _data["aadharCard"];
            this.netSalary = _data["netSalary"];
            this.wd = _data["wd"];
            this.wo = _data["wo"];
            this.holiday = _data["holiday"];
            this.lwp = _data["lwp"];
            this.absent = _data["absent"];
            this.paiddays = _data["paiddays"];
            if (Array.isArray(_data["earingComponetstandard"])) {
                this.earingComponetstandard = [] as any;
                for (let item of _data["earingComponetstandard"])
                    this.earingComponetstandard!.push(EaringComponetsStandardPdf.fromJS(item));
            }
            if (Array.isArray(_data["earingComponets"])) {
                this.earingComponets = [] as any;
                for (let item of _data["earingComponets"])
                    this.earingComponets!.push(EaringComponetsPdf.fromJS(item));
            }
            if (Array.isArray(_data["dedctionComponets"])) {
                this.dedctionComponets = [] as any;
                for (let item of _data["dedctionComponets"])
                    this.dedctionComponets!.push(DedctionComponetsPdf.fromJS(item));
            }
            if (Array.isArray(_data["leavesBalanceDetails"])) {
                this.leavesBalanceDetails = [] as any;
                for (let item of _data["leavesBalanceDetails"])
                    this.leavesBalanceDetails!.push(LeaveDetailsForSalarySlip.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SalaryRegisterPdfReportData {
        data = typeof data === 'object' ? data : {};
        let result = new SalaryRegisterPdfReportData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["location"] = this.location;
        data["employeeName"] = this.employeeName;
        data["salaryid"] = this.salaryid;
        data["fatherName"] = this.fatherName;
        data["doj"] = this.doj ? this.doj.toISOString() : <any>undefined;
        data["employeeId"] = this.employeeId;
        data["designation"] = this.designation;
        data["department"] = this.department;
        data["bankAcNo"] = this.bankAcNo;
        data["pfNo"] = this.pfNo;
        data["esiNo"] = this.esiNo;
        data["bankName"] = this.bankName;
        data["panCard"] = this.panCard;
        data["pfUanNo"] = this.pfUanNo;
        data["workDays"] = this.workDays;
        data["leave"] = this.leave;
        data["el"] = this.el;
        data["cl"] = this.cl;
        data["sl"] = this.sl;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["aadharCard"] = this.aadharCard;
        data["netSalary"] = this.netSalary;
        data["wd"] = this.wd;
        data["wo"] = this.wo;
        data["holiday"] = this.holiday;
        data["lwp"] = this.lwp;
        data["absent"] = this.absent;
        data["paiddays"] = this.paiddays;
        if (Array.isArray(this.earingComponetstandard)) {
            data["earingComponetstandard"] = [];
            for (let item of this.earingComponetstandard)
                data["earingComponetstandard"].push(item.toJSON());
        }
        if (Array.isArray(this.earingComponets)) {
            data["earingComponets"] = [];
            for (let item of this.earingComponets)
                data["earingComponets"].push(item.toJSON());
        }
        if (Array.isArray(this.dedctionComponets)) {
            data["dedctionComponets"] = [];
            for (let item of this.dedctionComponets)
                data["dedctionComponets"].push(item.toJSON());
        }
        if (Array.isArray(this.leavesBalanceDetails)) {
            data["leavesBalanceDetails"] = [];
            for (let item of this.leavesBalanceDetails)
                data["leavesBalanceDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISalaryRegisterPdfReportData {
    companyName: string | undefined;
    location: string | undefined;
    employeeName: string | undefined;
    salaryid: number;
    fatherName: string | undefined;
    doj: moment.Moment;
    employeeId: string | undefined;
    designation: string | undefined;
    department: string | undefined;
    bankAcNo: string | undefined;
    pfNo: string | undefined;
    esiNo: string | undefined;
    bankName: string | undefined;
    panCard: string | undefined;
    pfUanNo: string | undefined;
    workDays: number | undefined;
    leave: number | undefined;
    el: number;
    cl: number;
    sl: number;
    dob: moment.Moment;
    aadharCard: string | undefined;
    netSalary: number;
    wd: number;
    wo: number;
    holiday: number;
    lwp: number;
    absent: number;
    paiddays: number;
    earingComponetstandard: EaringComponetsStandardPdf[] | undefined;
    earingComponets: EaringComponetsPdf[] | undefined;
    dedctionComponets: DedctionComponetsPdf[] | undefined;
    leavesBalanceDetails: LeaveDetailsForSalarySlip[] | undefined;
}

export class EmployeeSalaryComponentsDto implements IEmployeeSalaryComponentsDto {
    payComponet!: number;
    amount!: number;
    approval!: boolean;
    status!: string | undefined;
    employeeId!: number;
    id!: number;

    constructor(data?: IEmployeeSalaryComponentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payComponet = _data["payComponet"];
            this.amount = _data["amount"];
            this.approval = _data["approval"];
            this.status = _data["status"];
            this.employeeId = _data["employeeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EmployeeSalaryComponentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeSalaryComponentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payComponet"] = this.payComponet;
        data["amount"] = this.amount;
        data["approval"] = this.approval;
        data["status"] = this.status;
        data["employeeId"] = this.employeeId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEmployeeSalaryComponentsDto {
    payComponet: number;
    amount: number;
    approval: boolean;
    status: string | undefined;
    employeeId: number;
    id: number;
}

export class GetEmployeeSalaryComponentsForViewDto implements IGetEmployeeSalaryComponentsForViewDto {
    employeeSalaryComponents!: EmployeeSalaryComponentsDto;
    employeeEmployeeCode!: string | undefined;

    constructor(data?: IGetEmployeeSalaryComponentsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeSalaryComponents = _data["employeeSalaryComponents"] ? EmployeeSalaryComponentsDto.fromJS(_data["employeeSalaryComponents"]) : <any>undefined;
            this.employeeEmployeeCode = _data["employeeEmployeeCode"];
        }
    }

    static fromJS(data: any): GetEmployeeSalaryComponentsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeSalaryComponentsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeSalaryComponents"] = this.employeeSalaryComponents ? this.employeeSalaryComponents.toJSON() : <any>undefined;
        data["employeeEmployeeCode"] = this.employeeEmployeeCode;
        return data;
    }
}

export interface IGetEmployeeSalaryComponentsForViewDto {
    employeeSalaryComponents: EmployeeSalaryComponentsDto;
    employeeEmployeeCode: string | undefined;
}

export class PagedResultDtoOfGetEmployeeSalaryComponentsForViewDto implements IPagedResultDtoOfGetEmployeeSalaryComponentsForViewDto {
    totalCount!: number;
    items!: GetEmployeeSalaryComponentsForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEmployeeSalaryComponentsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetEmployeeSalaryComponentsForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEmployeeSalaryComponentsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEmployeeSalaryComponentsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetEmployeeSalaryComponentsForViewDto {
    totalCount: number;
    items: GetEmployeeSalaryComponentsForViewDto[] | undefined;
}

export class PaySalaryComponetStructure implements IPaySalaryComponetStructure {
    paymentComponentId!: number;
    payTypeGrade!: string | undefined;
    paYComponetsType!: string | undefined;
    amount!: number;
    percent!: number | undefined;
    approval!: boolean;
    isFrozen!: boolean;
    withEffectFrom!: string | undefined;
    incrementCycle!: number;
    taxable!: number;
    isPartofGross!: number;

    constructor(data?: IPaySalaryComponetStructure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentComponentId = _data["paymentComponentId"];
            this.payTypeGrade = _data["payTypeGrade"];
            this.paYComponetsType = _data["paYComponetsType"];
            this.amount = _data["amount"];
            this.percent = _data["percent"];
            this.approval = _data["approval"];
            this.isFrozen = _data["isFrozen"];
            this.withEffectFrom = _data["withEffectFrom"];
            this.incrementCycle = _data["incrementCycle"];
            this.taxable = _data["taxable"];
            this.isPartofGross = _data["isPartofGross"];
        }
    }

    static fromJS(data: any): PaySalaryComponetStructure {
        data = typeof data === 'object' ? data : {};
        let result = new PaySalaryComponetStructure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentComponentId"] = this.paymentComponentId;
        data["payTypeGrade"] = this.payTypeGrade;
        data["paYComponetsType"] = this.paYComponetsType;
        data["amount"] = this.amount;
        data["percent"] = this.percent;
        data["approval"] = this.approval;
        data["isFrozen"] = this.isFrozen;
        data["withEffectFrom"] = this.withEffectFrom;
        data["incrementCycle"] = this.incrementCycle;
        data["taxable"] = this.taxable;
        data["isPartofGross"] = this.isPartofGross;
        return data;
    }
}

export interface IPaySalaryComponetStructure {
    paymentComponentId: number;
    payTypeGrade: string | undefined;
    paYComponetsType: string | undefined;
    amount: number;
    percent: number | undefined;
    approval: boolean;
    isFrozen: boolean;
    withEffectFrom: string | undefined;
    incrementCycle: number;
    taxable: number;
    isPartofGross: number;
}

export class PaySalaryComponetApprove implements IPaySalaryComponetApprove {
    employeeId!: number;
    empCode!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    ctc!: string | undefined;
    payTypeGrade!: string | undefined;

    constructor(data?: IPaySalaryComponetApprove) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.empCode = _data["empCode"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.ctc = _data["ctc"];
            this.payTypeGrade = _data["payTypeGrade"];
        }
    }

    static fromJS(data: any): PaySalaryComponetApprove {
        data = typeof data === 'object' ? data : {};
        let result = new PaySalaryComponetApprove();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["empCode"] = this.empCode;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["ctc"] = this.ctc;
        data["payTypeGrade"] = this.payTypeGrade;
        return data;
    }
}

export interface IPaySalaryComponetApprove {
    employeeId: number;
    empCode: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    ctc: string | undefined;
    payTypeGrade: string | undefined;
}

export class CreateOrEditEmployeeSalaryComponentsDto implements ICreateOrEditEmployeeSalaryComponentsDto {
    payComponet!: number;
    payGradeId!: number;
    amount!: number;
    approval!: boolean;
    status!: string | undefined;
    employeeId!: number;
    withEffectFrom!: string | undefined;
    incrementCycle!: number;
    incrementDueDate!: moment.Moment;
    otAmount!: number | undefined;
    paySalaryComponetStructure!: PaySalaryComponetStructure[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditEmployeeSalaryComponentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payComponet = _data["payComponet"];
            this.payGradeId = _data["payGradeId"];
            this.amount = _data["amount"];
            this.approval = _data["approval"];
            this.status = _data["status"];
            this.employeeId = _data["employeeId"];
            this.withEffectFrom = _data["withEffectFrom"];
            this.incrementCycle = _data["incrementCycle"];
            this.incrementDueDate = _data["incrementDueDate"] ? moment(_data["incrementDueDate"].toString()) : <any>undefined;
            this.otAmount = _data["otAmount"];
            if (Array.isArray(_data["paySalaryComponetStructure"])) {
                this.paySalaryComponetStructure = [] as any;
                for (let item of _data["paySalaryComponetStructure"])
                    this.paySalaryComponetStructure!.push(PaySalaryComponetStructure.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEmployeeSalaryComponentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEmployeeSalaryComponentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payComponet"] = this.payComponet;
        data["payGradeId"] = this.payGradeId;
        data["amount"] = this.amount;
        data["approval"] = this.approval;
        data["status"] = this.status;
        data["employeeId"] = this.employeeId;
        data["withEffectFrom"] = this.withEffectFrom;
        data["incrementCycle"] = this.incrementCycle;
        data["incrementDueDate"] = this.incrementDueDate ? this.incrementDueDate.toISOString() : <any>undefined;
        data["otAmount"] = this.otAmount;
        if (Array.isArray(this.paySalaryComponetStructure)) {
            data["paySalaryComponetStructure"] = [];
            for (let item of this.paySalaryComponetStructure)
                data["paySalaryComponetStructure"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditEmployeeSalaryComponentsDto {
    payComponet: number;
    payGradeId: number;
    amount: number;
    approval: boolean;
    status: string | undefined;
    employeeId: number;
    withEffectFrom: string | undefined;
    incrementCycle: number;
    incrementDueDate: moment.Moment;
    otAmount: number | undefined;
    paySalaryComponetStructure: PaySalaryComponetStructure[] | undefined;
    id: number | undefined;
}

export class GetEmployeeSalaryComponentsForEditOutput implements IGetEmployeeSalaryComponentsForEditOutput {
    employeeSalaryComponents!: CreateOrEditEmployeeSalaryComponentsDto;
    employeeEmployeeCode!: string | undefined;

    constructor(data?: IGetEmployeeSalaryComponentsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeSalaryComponents = _data["employeeSalaryComponents"] ? CreateOrEditEmployeeSalaryComponentsDto.fromJS(_data["employeeSalaryComponents"]) : <any>undefined;
            this.employeeEmployeeCode = _data["employeeEmployeeCode"];
        }
    }

    static fromJS(data: any): GetEmployeeSalaryComponentsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeSalaryComponentsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeSalaryComponents"] = this.employeeSalaryComponents ? this.employeeSalaryComponents.toJSON() : <any>undefined;
        data["employeeEmployeeCode"] = this.employeeEmployeeCode;
        return data;
    }
}

export interface IGetEmployeeSalaryComponentsForEditOutput {
    employeeSalaryComponents: CreateOrEditEmployeeSalaryComponentsDto;
    employeeEmployeeCode: string | undefined;
}

export class SalaryAndJoinDateDto implements ISalaryAndJoinDateDto {
    salaryAlreadyAssign!: number;
    joinDate!: string | undefined;
    withEffectFrom!: string | undefined;

    constructor(data?: ISalaryAndJoinDateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salaryAlreadyAssign = _data["salaryAlreadyAssign"];
            this.joinDate = _data["joinDate"];
            this.withEffectFrom = _data["withEffectFrom"];
        }
    }

    static fromJS(data: any): SalaryAndJoinDateDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalaryAndJoinDateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salaryAlreadyAssign"] = this.salaryAlreadyAssign;
        data["joinDate"] = this.joinDate;
        data["withEffectFrom"] = this.withEffectFrom;
        return data;
    }
}

export interface ISalaryAndJoinDateDto {
    salaryAlreadyAssign: number;
    joinDate: string | undefined;
    withEffectFrom: string | undefined;
}

export class LeaveBlanceByTypeDetails implements ILeaveBlanceByTypeDetails {
    el!: number | undefined;
    cl!: number | undefined;
    sl!: number | undefined;
    elOpen!: number | undefined;
    clOpen!: number | undefined;
    slOpen!: number | undefined;
    totalEL!: number | undefined;
    totalCL!: number | undefined;
    totalSL!: number | undefined;

    constructor(data?: ILeaveBlanceByTypeDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.el = _data["el"];
            this.cl = _data["cl"];
            this.sl = _data["sl"];
            this.elOpen = _data["elOpen"];
            this.clOpen = _data["clOpen"];
            this.slOpen = _data["slOpen"];
            this.totalEL = _data["totalEL"];
            this.totalCL = _data["totalCL"];
            this.totalSL = _data["totalSL"];
        }
    }

    static fromJS(data: any): LeaveBlanceByTypeDetails {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveBlanceByTypeDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["el"] = this.el;
        data["cl"] = this.cl;
        data["sl"] = this.sl;
        data["elOpen"] = this.elOpen;
        data["clOpen"] = this.clOpen;
        data["slOpen"] = this.slOpen;
        data["totalEL"] = this.totalEL;
        data["totalCL"] = this.totalCL;
        data["totalSL"] = this.totalSL;
        return data;
    }
}

export interface ILeaveBlanceByTypeDetails {
    el: number | undefined;
    cl: number | undefined;
    sl: number | undefined;
    elOpen: number | undefined;
    clOpen: number | undefined;
    slOpen: number | undefined;
    totalEL: number | undefined;
    totalCL: number | undefined;
    totalSL: number | undefined;
}

export class LeaveBalanceList implements ILeaveBalanceList {
    leavetype!: string | undefined;
    leaveName!: string | undefined;
    leaveid!: number;
    total!: number | undefined;
    yearlyUsed!: number | undefined;
    balance!: number | undefined;
    percent!: number | undefined;
    resultvalue!: number | undefined;
    percentbal!: number | undefined;
    resultbal!: number | undefined;
    accrued!: number | undefined;
    negativeBal!: boolean;
    carryFwdLeave!: number | undefined;
    broghtFwdLeave!: number | undefined;
    deducted!: number | undefined;

    constructor(data?: ILeaveBalanceList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leavetype = _data["leavetype"];
            this.leaveName = _data["leaveName"];
            this.leaveid = _data["leaveid"];
            this.total = _data["total"];
            this.yearlyUsed = _data["yearlyUsed"];
            this.balance = _data["balance"];
            this.percent = _data["percent"];
            this.resultvalue = _data["resultvalue"];
            this.percentbal = _data["percentbal"];
            this.resultbal = _data["resultbal"];
            this.accrued = _data["accrued"];
            this.negativeBal = _data["negativeBal"];
            this.carryFwdLeave = _data["carryFwdLeave"];
            this.broghtFwdLeave = _data["broghtFwdLeave"];
            this.deducted = _data["deducted"];
        }
    }

    static fromJS(data: any): LeaveBalanceList {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveBalanceList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leavetype"] = this.leavetype;
        data["leaveName"] = this.leaveName;
        data["leaveid"] = this.leaveid;
        data["total"] = this.total;
        data["yearlyUsed"] = this.yearlyUsed;
        data["balance"] = this.balance;
        data["percent"] = this.percent;
        data["resultvalue"] = this.resultvalue;
        data["percentbal"] = this.percentbal;
        data["resultbal"] = this.resultbal;
        data["accrued"] = this.accrued;
        data["negativeBal"] = this.negativeBal;
        data["carryFwdLeave"] = this.carryFwdLeave;
        data["broghtFwdLeave"] = this.broghtFwdLeave;
        data["deducted"] = this.deducted;
        return data;
    }
}

export interface ILeaveBalanceList {
    leavetype: string | undefined;
    leaveName: string | undefined;
    leaveid: number;
    total: number | undefined;
    yearlyUsed: number | undefined;
    balance: number | undefined;
    percent: number | undefined;
    resultvalue: number | undefined;
    percentbal: number | undefined;
    resultbal: number | undefined;
    accrued: number | undefined;
    negativeBal: boolean;
    carryFwdLeave: number | undefined;
    broghtFwdLeave: number | undefined;
    deducted: number | undefined;
}

export class BalanceByLeaveType implements IBalanceByLeaveType {
    leaveName!: string | undefined;
    balanceValueByLeave!: number;
    leaveUsed!: number;

    constructor(data?: IBalanceByLeaveType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveName = _data["leaveName"];
            this.balanceValueByLeave = _data["balanceValueByLeave"];
            this.leaveUsed = _data["leaveUsed"];
        }
    }

    static fromJS(data: any): BalanceByLeaveType {
        data = typeof data === 'object' ? data : {};
        let result = new BalanceByLeaveType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveName"] = this.leaveName;
        data["balanceValueByLeave"] = this.balanceValueByLeave;
        data["leaveUsed"] = this.leaveUsed;
        return data;
    }
}

export interface IBalanceByLeaveType {
    leaveName: string | undefined;
    balanceValueByLeave: number;
    leaveUsed: number;
}

export class GetBalanceDtaDto implements IGetBalanceDtaDto {
    accured!: number | undefined;
    totalleave!: number;
    usedleave!: number;
    balance!: number;
    balanceArray!: BalanceByLeaveType[] | undefined;

    constructor(data?: IGetBalanceDtaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accured = _data["accured"];
            this.totalleave = _data["totalleave"];
            this.usedleave = _data["usedleave"];
            this.balance = _data["balance"];
            if (Array.isArray(_data["balanceArray"])) {
                this.balanceArray = [] as any;
                for (let item of _data["balanceArray"])
                    this.balanceArray!.push(BalanceByLeaveType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBalanceDtaDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBalanceDtaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accured"] = this.accured;
        data["totalleave"] = this.totalleave;
        data["usedleave"] = this.usedleave;
        data["balance"] = this.balance;
        if (Array.isArray(this.balanceArray)) {
            data["balanceArray"] = [];
            for (let item of this.balanceArray)
                data["balanceArray"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBalanceDtaDto {
    accured: number | undefined;
    totalleave: number;
    usedleave: number;
    balance: number;
    balanceArray: BalanceByLeaveType[] | undefined;
}

export class EmployeeStateInsuranceDto implements IEmployeeStateInsuranceDto {
    applicable!: boolean;
    companyESINo!: string | undefined;
    esiLocalOffice!: string | undefined;
    depositeEmployeeSalaryHold!: boolean;
    deductESIonOT!: boolean;
    deductESIonArrears!: boolean;
    employeeRoundOff!: number;
    roundOffESIAmount!: boolean;
    employeerRoundOff!: number;
    employeePercent!: number;
    employeerPercent!: number;
    esiLimit!: number;
    deductESIonESILimit!: boolean;
    doNotDeductESI!: boolean;
    multipleGroup!: boolean;
    id!: number;

    constructor(data?: IEmployeeStateInsuranceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicable = _data["applicable"];
            this.companyESINo = _data["companyESINo"];
            this.esiLocalOffice = _data["esiLocalOffice"];
            this.depositeEmployeeSalaryHold = _data["depositeEmployeeSalaryHold"];
            this.deductESIonOT = _data["deductESIonOT"];
            this.deductESIonArrears = _data["deductESIonArrears"];
            this.employeeRoundOff = _data["employeeRoundOff"];
            this.roundOffESIAmount = _data["roundOffESIAmount"];
            this.employeerRoundOff = _data["employeerRoundOff"];
            this.employeePercent = _data["employeePercent"];
            this.employeerPercent = _data["employeerPercent"];
            this.esiLimit = _data["esiLimit"];
            this.deductESIonESILimit = _data["deductESIonESILimit"];
            this.doNotDeductESI = _data["doNotDeductESI"];
            this.multipleGroup = _data["multipleGroup"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EmployeeStateInsuranceDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeStateInsuranceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicable"] = this.applicable;
        data["companyESINo"] = this.companyESINo;
        data["esiLocalOffice"] = this.esiLocalOffice;
        data["depositeEmployeeSalaryHold"] = this.depositeEmployeeSalaryHold;
        data["deductESIonOT"] = this.deductESIonOT;
        data["deductESIonArrears"] = this.deductESIonArrears;
        data["employeeRoundOff"] = this.employeeRoundOff;
        data["roundOffESIAmount"] = this.roundOffESIAmount;
        data["employeerRoundOff"] = this.employeerRoundOff;
        data["employeePercent"] = this.employeePercent;
        data["employeerPercent"] = this.employeerPercent;
        data["esiLimit"] = this.esiLimit;
        data["deductESIonESILimit"] = this.deductESIonESILimit;
        data["doNotDeductESI"] = this.doNotDeductESI;
        data["multipleGroup"] = this.multipleGroup;
        data["id"] = this.id;
        return data;
    }
}

export interface IEmployeeStateInsuranceDto {
    applicable: boolean;
    companyESINo: string | undefined;
    esiLocalOffice: string | undefined;
    depositeEmployeeSalaryHold: boolean;
    deductESIonOT: boolean;
    deductESIonArrears: boolean;
    employeeRoundOff: number;
    roundOffESIAmount: boolean;
    employeerRoundOff: number;
    employeePercent: number;
    employeerPercent: number;
    esiLimit: number;
    deductESIonESILimit: boolean;
    doNotDeductESI: boolean;
    multipleGroup: boolean;
    id: number;
}

export class GetEmployeeStateInsuranceForViewDto implements IGetEmployeeStateInsuranceForViewDto {
    employeeStateInsurance!: EmployeeStateInsuranceDto;

    constructor(data?: IGetEmployeeStateInsuranceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeStateInsurance = _data["employeeStateInsurance"] ? EmployeeStateInsuranceDto.fromJS(_data["employeeStateInsurance"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEmployeeStateInsuranceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeStateInsuranceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeStateInsurance"] = this.employeeStateInsurance ? this.employeeStateInsurance.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEmployeeStateInsuranceForViewDto {
    employeeStateInsurance: EmployeeStateInsuranceDto;
}

export class PagedResultDtoOfGetEmployeeStateInsuranceForViewDto implements IPagedResultDtoOfGetEmployeeStateInsuranceForViewDto {
    totalCount!: number;
    items!: GetEmployeeStateInsuranceForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEmployeeStateInsuranceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetEmployeeStateInsuranceForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEmployeeStateInsuranceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEmployeeStateInsuranceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetEmployeeStateInsuranceForViewDto {
    totalCount: number;
    items: GetEmployeeStateInsuranceForViewDto[] | undefined;
}

export class CreateOrEditEmployeeStateInsuranceDto implements ICreateOrEditEmployeeStateInsuranceDto {
    applicable!: boolean;
    companyESINo!: string | undefined;
    esiLocalOffice!: string | undefined;
    depositeEmployeeSalaryHold!: boolean;
    deductESIonOT!: boolean;
    deductESIonArrears!: boolean;
    employeeRoundOff!: number;
    roundOffESIAmount!: boolean;
    employeerRoundOff!: number;
    employeePercent!: number;
    employeerPercent!: number;
    esiLimit!: number;
    deductESIonESILimit!: boolean;
    doNotDeductESI!: boolean;
    multipleGroup!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditEmployeeStateInsuranceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicable = _data["applicable"];
            this.companyESINo = _data["companyESINo"];
            this.esiLocalOffice = _data["esiLocalOffice"];
            this.depositeEmployeeSalaryHold = _data["depositeEmployeeSalaryHold"];
            this.deductESIonOT = _data["deductESIonOT"];
            this.deductESIonArrears = _data["deductESIonArrears"];
            this.employeeRoundOff = _data["employeeRoundOff"];
            this.roundOffESIAmount = _data["roundOffESIAmount"];
            this.employeerRoundOff = _data["employeerRoundOff"];
            this.employeePercent = _data["employeePercent"];
            this.employeerPercent = _data["employeerPercent"];
            this.esiLimit = _data["esiLimit"];
            this.deductESIonESILimit = _data["deductESIonESILimit"];
            this.doNotDeductESI = _data["doNotDeductESI"];
            this.multipleGroup = _data["multipleGroup"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEmployeeStateInsuranceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEmployeeStateInsuranceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicable"] = this.applicable;
        data["companyESINo"] = this.companyESINo;
        data["esiLocalOffice"] = this.esiLocalOffice;
        data["depositeEmployeeSalaryHold"] = this.depositeEmployeeSalaryHold;
        data["deductESIonOT"] = this.deductESIonOT;
        data["deductESIonArrears"] = this.deductESIonArrears;
        data["employeeRoundOff"] = this.employeeRoundOff;
        data["roundOffESIAmount"] = this.roundOffESIAmount;
        data["employeerRoundOff"] = this.employeerRoundOff;
        data["employeePercent"] = this.employeePercent;
        data["employeerPercent"] = this.employeerPercent;
        data["esiLimit"] = this.esiLimit;
        data["deductESIonESILimit"] = this.deductESIonESILimit;
        data["doNotDeductESI"] = this.doNotDeductESI;
        data["multipleGroup"] = this.multipleGroup;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditEmployeeStateInsuranceDto {
    applicable: boolean;
    companyESINo: string | undefined;
    esiLocalOffice: string | undefined;
    depositeEmployeeSalaryHold: boolean;
    deductESIonOT: boolean;
    deductESIonArrears: boolean;
    employeeRoundOff: number;
    roundOffESIAmount: boolean;
    employeerRoundOff: number;
    employeePercent: number;
    employeerPercent: number;
    esiLimit: number;
    deductESIonESILimit: boolean;
    doNotDeductESI: boolean;
    multipleGroup: boolean;
    id: number | undefined;
}

export class GetEmployeeStateInsuranceForEditOutput implements IGetEmployeeStateInsuranceForEditOutput {
    employeeStateInsurance!: CreateOrEditEmployeeStateInsuranceDto;

    constructor(data?: IGetEmployeeStateInsuranceForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeStateInsurance = _data["employeeStateInsurance"] ? CreateOrEditEmployeeStateInsuranceDto.fromJS(_data["employeeStateInsurance"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEmployeeStateInsuranceForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeStateInsuranceForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeStateInsurance"] = this.employeeStateInsurance ? this.employeeStateInsurance.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEmployeeStateInsuranceForEditOutput {
    employeeStateInsurance: CreateOrEditEmployeeStateInsuranceDto;
}

export class VPFEmployeeListViewDto implements IVPFEmployeeListViewDto {
    employeeId!: number;
    vpfAmt!: number | undefined;

    constructor(data?: IVPFEmployeeListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.vpfAmt = _data["vpfAmt"];
        }
    }

    static fromJS(data: any): VPFEmployeeListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new VPFEmployeeListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["vpfAmt"] = this.vpfAmt;
        return data;
    }
}

export interface IVPFEmployeeListViewDto {
    employeeId: number;
    vpfAmt: number | undefined;
}

export class GetEmployeeVPFViewListDto implements IGetEmployeeVPFViewListDto {
    vpfEmployee!: VPFEmployeeListViewDto;
    employeeCode!: string | undefined;
    name!: string | undefined;
    fatherName!: string | undefined;

    constructor(data?: IGetEmployeeVPFViewListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vpfEmployee = _data["vpfEmployee"] ? VPFEmployeeListViewDto.fromJS(_data["vpfEmployee"]) : <any>undefined;
            this.employeeCode = _data["employeeCode"];
            this.name = _data["name"];
            this.fatherName = _data["fatherName"];
        }
    }

    static fromJS(data: any): GetEmployeeVPFViewListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeVPFViewListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vpfEmployee"] = this.vpfEmployee ? this.vpfEmployee.toJSON() : <any>undefined;
        data["employeeCode"] = this.employeeCode;
        data["name"] = this.name;
        data["fatherName"] = this.fatherName;
        return data;
    }
}

export interface IGetEmployeeVPFViewListDto {
    vpfEmployee: VPFEmployeeListViewDto;
    employeeCode: string | undefined;
    name: string | undefined;
    fatherName: string | undefined;
}

export class PagedResultDtoOfGetEmployeeVPFViewListDto implements IPagedResultDtoOfGetEmployeeVPFViewListDto {
    totalCount!: number;
    items!: GetEmployeeVPFViewListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEmployeeVPFViewListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetEmployeeVPFViewListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEmployeeVPFViewListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEmployeeVPFViewListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetEmployeeVPFViewListDto {
    totalCount: number;
    items: GetEmployeeVPFViewListDto[] | undefined;
}

export class EmployeeVPFlist implements IEmployeeVPFlist {
    employeeCode!: string | undefined;
    vpfAmount!: number | undefined;

    constructor(data?: IEmployeeVPFlist) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeCode = _data["employeeCode"];
            this.vpfAmount = _data["vpfAmount"];
        }
    }

    static fromJS(data: any): EmployeeVPFlist {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeVPFlist();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeCode"] = this.employeeCode;
        data["vpfAmount"] = this.vpfAmount;
        return data;
    }
}

export interface IEmployeeVPFlist {
    employeeCode: string | undefined;
    vpfAmount: number | undefined;
}

export class EmployeeVPFportedAttendance implements IEmployeeVPFportedAttendance {
    employeeVPFlist!: EmployeeVPFlist[] | undefined;
    id!: number | undefined;

    constructor(data?: IEmployeeVPFportedAttendance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employeeVPFlist"])) {
                this.employeeVPFlist = [] as any;
                for (let item of _data["employeeVPFlist"])
                    this.employeeVPFlist!.push(EmployeeVPFlist.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EmployeeVPFportedAttendance {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeVPFportedAttendance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employeeVPFlist)) {
            data["employeeVPFlist"] = [];
            for (let item of this.employeeVPFlist)
                data["employeeVPFlist"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IEmployeeVPFportedAttendance {
    employeeVPFlist: EmployeeVPFlist[] | undefined;
    id: number | undefined;
}

export class EmployeeVPFportAlreadyExits implements IEmployeeVPFportAlreadyExits {
    employeeCode!: string | undefined;
    message!: string | undefined;

    constructor(data?: IEmployeeVPFportAlreadyExits) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeCode = _data["employeeCode"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): EmployeeVPFportAlreadyExits {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeVPFportAlreadyExits();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeCode"] = this.employeeCode;
        data["message"] = this.message;
        return data;
    }
}

export interface IEmployeeVPFportAlreadyExits {
    employeeCode: string | undefined;
    message: string | undefined;
}

export class QuestionDto implements IQuestionDto {
    question!: string | undefined;
    id!: number;

    constructor(data?: IQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.question = _data["question"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): QuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["question"] = this.question;
        data["id"] = this.id;
        return data;
    }
}

export interface IQuestionDto {
    question: string | undefined;
    id: number;
}

export class ExitInterviewDto implements IExitInterviewDto {
    questionDto!: QuestionDto;
    answerCount!: number | undefined;

    constructor(data?: IExitInterviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionDto = _data["questionDto"] ? QuestionDto.fromJS(_data["questionDto"]) : <any>undefined;
            this.answerCount = _data["answerCount"];
        }
    }

    static fromJS(data: any): ExitInterviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExitInterviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionDto"] = this.questionDto ? this.questionDto.toJSON() : <any>undefined;
        data["answerCount"] = this.answerCount;
        return data;
    }
}

export interface IExitInterviewDto {
    questionDto: QuestionDto;
    answerCount: number | undefined;
}

export class PagedResultDtoOfExitInterviewDto implements IPagedResultDtoOfExitInterviewDto {
    totalCount!: number;
    items!: ExitInterviewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfExitInterviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExitInterviewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfExitInterviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfExitInterviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfExitInterviewDto {
    totalCount: number;
    items: ExitInterviewDto[] | undefined;
}

export class CreateOrEditAnswerDto implements ICreateOrEditAnswerDto {
    answer!: string | undefined;
    questionId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.answer = _data["answer"];
            this.questionId = _data["questionId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answer"] = this.answer;
        data["questionId"] = this.questionId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditAnswerDto {
    answer: string | undefined;
    questionId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditquestionDto implements ICreateOrEditquestionDto {
    question!: string | undefined;
    answer!: CreateOrEditAnswerDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditquestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.question = _data["question"];
            if (Array.isArray(_data["answer"])) {
                this.answer = [] as any;
                for (let item of _data["answer"])
                    this.answer!.push(CreateOrEditAnswerDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditquestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditquestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["question"] = this.question;
        if (Array.isArray(this.answer)) {
            data["answer"] = [];
            for (let item of this.answer)
                data["answer"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditquestionDto {
    question: string | undefined;
    answer: CreateOrEditAnswerDto[] | undefined;
    id: number | undefined;
}

export class GetquestionforEditOutput implements IGetquestionforEditOutput {
    questionEditDto!: CreateOrEditquestionDto;

    constructor(data?: IGetquestionforEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionEditDto = _data["questionEditDto"] ? CreateOrEditquestionDto.fromJS(_data["questionEditDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetquestionforEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetquestionforEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionEditDto"] = this.questionEditDto ? this.questionEditDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetquestionforEditOutput {
    questionEditDto: CreateOrEditquestionDto;
}

export class CreateOrEditQuizLog implements ICreateOrEditQuizLog {
    tenantId!: number;
    questionId!: number;
    answerId!: number;
    employeeId!: number;
    createdOn!: moment.Moment | undefined;
    updtedOn!: moment.Moment | undefined;
    createdBy!: number | undefined;
    updatedBy!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditQuizLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.questionId = _data["questionId"];
            this.answerId = _data["answerId"];
            this.employeeId = _data["employeeId"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.updtedOn = _data["updtedOn"] ? moment(_data["updtedOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditQuizLog {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditQuizLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["questionId"] = this.questionId;
        data["answerId"] = this.answerId;
        data["employeeId"] = this.employeeId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updtedOn"] = this.updtedOn ? this.updtedOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditQuizLog {
    tenantId: number;
    questionId: number;
    answerId: number;
    employeeId: number;
    createdOn: moment.Moment | undefined;
    updtedOn: moment.Moment | undefined;
    createdBy: number | undefined;
    updatedBy: number | undefined;
    id: number | undefined;
}

export class SaveQuizLogDto implements ISaveQuizLogDto {
    createOrEditQuizLog!: CreateOrEditQuizLog[] | undefined;
    id!: number | undefined;

    constructor(data?: ISaveQuizLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["createOrEditQuizLog"])) {
                this.createOrEditQuizLog = [] as any;
                for (let item of _data["createOrEditQuizLog"])
                    this.createOrEditQuizLog!.push(CreateOrEditQuizLog.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SaveQuizLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveQuizLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.createOrEditQuizLog)) {
            data["createOrEditQuizLog"] = [];
            for (let item of this.createOrEditQuizLog)
                data["createOrEditQuizLog"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ISaveQuizLogDto {
    createOrEditQuizLog: CreateOrEditQuizLog[] | undefined;
    id: number | undefined;
}

export class GetInterviewLogEditDto implements IGetInterviewLogEditDto {
    tenantId!: number;
    questionId!: number;
    answerId!: number;
    employeeId!: number;
    createdOn!: moment.Moment | undefined;
    updtedOn!: moment.Moment | undefined;
    createdBy!: number | undefined;
    updatedBy!: number | undefined;
    id!: number | undefined;

    constructor(data?: IGetInterviewLogEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.questionId = _data["questionId"];
            this.answerId = _data["answerId"];
            this.employeeId = _data["employeeId"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.updtedOn = _data["updtedOn"] ? moment(_data["updtedOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetInterviewLogEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetInterviewLogEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["questionId"] = this.questionId;
        data["answerId"] = this.answerId;
        data["employeeId"] = this.employeeId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updtedOn"] = this.updtedOn ? this.updtedOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetInterviewLogEditDto {
    tenantId: number;
    questionId: number;
    answerId: number;
    employeeId: number;
    createdOn: moment.Moment | undefined;
    updtedOn: moment.Moment | undefined;
    createdBy: number | undefined;
    updatedBy: number | undefined;
    id: number | undefined;
}

export class GetInterviewLogViewDto implements IGetInterviewLogViewDto {
    tenantId!: number;
    question!: string | undefined;
    answer!: string | undefined;
    employeeName!: string | undefined;
    createdOn!: moment.Moment | undefined;
    updtedOn!: moment.Moment | undefined;
    createdBy!: string | undefined;
    updatedBy!: string | undefined;

    constructor(data?: IGetInterviewLogViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.question = _data["question"];
            this.answer = _data["answer"];
            this.employeeName = _data["employeeName"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.updtedOn = _data["updtedOn"] ? moment(_data["updtedOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): GetInterviewLogViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetInterviewLogViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["question"] = this.question;
        data["answer"] = this.answer;
        data["employeeName"] = this.employeeName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updtedOn"] = this.updtedOn ? this.updtedOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IGetInterviewLogViewDto {
    tenantId: number;
    question: string | undefined;
    answer: string | undefined;
    employeeName: string | undefined;
    createdOn: moment.Moment | undefined;
    updtedOn: moment.Moment | undefined;
    createdBy: string | undefined;
    updatedBy: string | undefined;
}

export class AnswerDto implements IAnswerDto {
    answer!: string | undefined;
    questionId!: number | undefined;
    id!: number;

    constructor(data?: IAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.answer = _data["answer"];
            this.questionId = _data["questionId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answer"] = this.answer;
        data["questionId"] = this.questionId;
        data["id"] = this.id;
        return data;
    }
}

export interface IAnswerDto {
    answer: string | undefined;
    questionId: number | undefined;
    id: number;
}

export class GetAnswersForViewDto implements IGetAnswersForViewDto {
    answer!: AnswerDto;
    questionName!: string | undefined;

    constructor(data?: IGetAnswersForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.answer = _data["answer"] ? AnswerDto.fromJS(_data["answer"]) : <any>undefined;
            this.questionName = _data["questionName"];
        }
    }

    static fromJS(data: any): GetAnswersForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAnswersForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answer"] = this.answer ? this.answer.toJSON() : <any>undefined;
        data["questionName"] = this.questionName;
        return data;
    }
}

export interface IGetAnswersForViewDto {
    answer: AnswerDto;
    questionName: string | undefined;
}

export class PagedResultDtoOfGetAnswersForViewDto implements IPagedResultDtoOfGetAnswersForViewDto {
    totalCount!: number;
    items!: GetAnswersForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAnswersForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAnswersForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAnswersForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAnswersForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAnswersForViewDto {
    totalCount: number;
    items: GetAnswersForViewDto[] | undefined;
}

export class GetAnswerForEditOutput implements IGetAnswerForEditOutput {
    answer!: CreateOrEditAnswerDto;
    questionName!: string | undefined;

    constructor(data?: IGetAnswerForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.answer = _data["answer"] ? CreateOrEditAnswerDto.fromJS(_data["answer"]) : <any>undefined;
            this.questionName = _data["questionName"];
        }
    }

    static fromJS(data: any): GetAnswerForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAnswerForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answer"] = this.answer ? this.answer.toJSON() : <any>undefined;
        data["questionName"] = this.questionName;
        return data;
    }
}

export interface IGetAnswerForEditOutput {
    answer: CreateOrEditAnswerDto;
    questionName: string | undefined;
}

export class QuestionAnsLookupTableDto implements IQuestionAnsLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IQuestionAnsLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): QuestionAnsLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionAnsLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IQuestionAnsLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfQuestionAnsLookupTableDto implements IPagedResultDtoOfQuestionAnsLookupTableDto {
    totalCount!: number;
    items!: QuestionAnsLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfQuestionAnsLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(QuestionAnsLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfQuestionAnsLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfQuestionAnsLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfQuestionAnsLookupTableDto {
    totalCount: number;
    items: QuestionAnsLookupTableDto[] | undefined;
}

export class EndTaskDto implements IEndTaskDto {
    task!: string | undefined;
    employeeName!: string | undefined;
    dueOn!: moment.Moment;
    id!: number;

    constructor(data?: IEndTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.task = _data["task"];
            this.employeeName = _data["employeeName"];
            this.dueOn = _data["dueOn"] ? moment(_data["dueOn"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EndTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new EndTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["task"] = this.task;
        data["employeeName"] = this.employeeName;
        data["dueOn"] = this.dueOn ? this.dueOn.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IEndTaskDto {
    task: string | undefined;
    employeeName: string | undefined;
    dueOn: moment.Moment;
    id: number;
}

export class GetEndListForView implements IGetEndListForView {
    endlist!: EndTaskDto;

    constructor(data?: IGetEndListForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.endlist = _data["endlist"] ? EndTaskDto.fromJS(_data["endlist"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEndListForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetEndListForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endlist"] = this.endlist ? this.endlist.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEndListForView {
    endlist: EndTaskDto;
}

export class CreateOrEditTaskList implements ICreateOrEditTaskList {
    tenantId!: number;
    task!: string | undefined;
    employeeId!: number;
    dueOn!: moment.Moment;
    id!: number;

    constructor(data?: ICreateOrEditTaskList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.task = _data["task"];
            this.employeeId = _data["employeeId"];
            this.dueOn = _data["dueOn"] ? moment(_data["dueOn"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTaskList {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTaskList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["task"] = this.task;
        data["employeeId"] = this.employeeId;
        data["dueOn"] = this.dueOn ? this.dueOn.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTaskList {
    tenantId: number;
    task: string | undefined;
    employeeId: number;
    dueOn: moment.Moment;
    id: number;
}

export class GetEndTaskForEdit implements IGetEndTaskForEdit {
    showEndList!: CreateOrEditTaskList;

    constructor(data?: IGetEndTaskForEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.showEndList = _data["showEndList"] ? CreateOrEditTaskList.fromJS(_data["showEndList"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEndTaskForEdit {
        data = typeof data === 'object' ? data : {};
        let result = new GetEndTaskForEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showEndList"] = this.showEndList ? this.showEndList.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEndTaskForEdit {
    showEndList: CreateOrEditTaskList;
}

export class ExpenseTypeDto implements IExpenseTypeDto {
    tenantId!: number;
    name!: string | undefined;
    fkNatureId!: number | undefined;
    desc!: string | undefined;
    payRoll!: boolean;
    id!: number;

    constructor(data?: IExpenseTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.fkNatureId = _data["fkNatureId"];
            this.desc = _data["desc"];
            this.payRoll = _data["payRoll"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ExpenseTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["fkNatureId"] = this.fkNatureId;
        data["desc"] = this.desc;
        data["payRoll"] = this.payRoll;
        data["id"] = this.id;
        return data;
    }
}

export interface IExpenseTypeDto {
    tenantId: number;
    name: string | undefined;
    fkNatureId: number | undefined;
    desc: string | undefined;
    payRoll: boolean;
    id: number;
}

export class GetAllExpenseForView implements IGetAllExpenseForView {
    expenseType!: ExpenseTypeDto;

    constructor(data?: IGetAllExpenseForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expenseType = _data["expenseType"] ? ExpenseTypeDto.fromJS(_data["expenseType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAllExpenseForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllExpenseForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expenseType"] = this.expenseType ? this.expenseType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAllExpenseForView {
    expenseType: ExpenseTypeDto;
}

export class PagedResultDtoOfGetAllExpenseForView implements IPagedResultDtoOfGetAllExpenseForView {
    totalCount!: number;
    items!: GetAllExpenseForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllExpenseForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllExpenseForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllExpenseForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllExpenseForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAllExpenseForView {
    totalCount: number;
    items: GetAllExpenseForView[] | undefined;
}

export class GetAllEditExpense implements IGetAllEditExpense {
    expenseType!: ExpenseTypeDto;
    id!: number | undefined;

    constructor(data?: IGetAllEditExpense) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expenseType = _data["expenseType"] ? ExpenseTypeDto.fromJS(_data["expenseType"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetAllEditExpense {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllEditExpense();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expenseType"] = this.expenseType ? this.expenseType.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetAllEditExpense {
    expenseType: ExpenseTypeDto;
    id: number | undefined;
}

export class CreateOrEditExpense implements ICreateOrEditExpense {
    name!: string | undefined;
    fkNature!: number | undefined;
    desc!: string | undefined;
    payroll!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditExpense) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.fkNature = _data["fkNature"];
            this.desc = _data["desc"];
            this.payroll = _data["payroll"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditExpense {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditExpense();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["fkNature"] = this.fkNature;
        data["desc"] = this.desc;
        data["payroll"] = this.payroll;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditExpense {
    name: string | undefined;
    fkNature: number | undefined;
    desc: string | undefined;
    payroll: boolean;
    id: number | undefined;
}

export class ExpensePoliciesDto implements IExpensePoliciesDto {
    name!: string | undefined;
    expenseLimit!: number;
    id!: number;

    constructor(data?: IExpensePoliciesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.expenseLimit = _data["expenseLimit"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ExpensePoliciesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpensePoliciesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["expenseLimit"] = this.expenseLimit;
        data["id"] = this.id;
        return data;
    }
}

export interface IExpensePoliciesDto {
    name: string | undefined;
    expenseLimit: number;
    id: number;
}

export class GetExpensePolicyForViewDto implements IGetExpensePolicyForViewDto {
    expensePolicyes!: ExpensePoliciesDto;
    expenseNames!: string | undefined;
    employeeid!: number;
    designation!: number;

    constructor(data?: IGetExpensePolicyForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expensePolicyes = _data["expensePolicyes"] ? ExpensePoliciesDto.fromJS(_data["expensePolicyes"]) : <any>undefined;
            this.expenseNames = _data["expenseNames"];
            this.employeeid = _data["employeeid"];
            this.designation = _data["designation"];
        }
    }

    static fromJS(data: any): GetExpensePolicyForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetExpensePolicyForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expensePolicyes"] = this.expensePolicyes ? this.expensePolicyes.toJSON() : <any>undefined;
        data["expenseNames"] = this.expenseNames;
        data["employeeid"] = this.employeeid;
        data["designation"] = this.designation;
        return data;
    }
}

export interface IGetExpensePolicyForViewDto {
    expensePolicyes: ExpensePoliciesDto;
    expenseNames: string | undefined;
    employeeid: number;
    designation: number;
}

export class PagedResultDtoOfGetExpensePolicyForViewDto implements IPagedResultDtoOfGetExpensePolicyForViewDto {
    totalCount!: number;
    items!: GetExpensePolicyForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetExpensePolicyForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetExpensePolicyForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetExpensePolicyForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetExpensePolicyForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetExpensePolicyForViewDto {
    totalCount: number;
    items: GetExpensePolicyForViewDto[] | undefined;
}

export class CreateOrEditExpensePolicy implements ICreateOrEditExpensePolicy {
    name!: string | undefined;
    expenseLimit!: number;
    expenseName!: number[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditExpensePolicy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.expenseLimit = _data["expenseLimit"];
            if (Array.isArray(_data["expenseName"])) {
                this.expenseName = [] as any;
                for (let item of _data["expenseName"])
                    this.expenseName!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditExpensePolicy {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditExpensePolicy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["expenseLimit"] = this.expenseLimit;
        if (Array.isArray(this.expenseName)) {
            data["expenseName"] = [];
            for (let item of this.expenseName)
                data["expenseName"].push(item);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditExpensePolicy {
    name: string | undefined;
    expenseLimit: number;
    expenseName: number[] | undefined;
    id: number | undefined;
}

export class GetExpensePolicyForEditOutput implements IGetExpensePolicyForEditOutput {
    expensePolicies!: CreateOrEditExpensePolicy;

    constructor(data?: IGetExpensePolicyForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expensePolicies = _data["expensePolicies"] ? CreateOrEditExpensePolicy.fromJS(_data["expensePolicies"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetExpensePolicyForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetExpensePolicyForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expensePolicies"] = this.expensePolicies ? this.expensePolicies.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetExpensePolicyForEditOutput {
    expensePolicies: CreateOrEditExpensePolicy;
}

export class NewExpenseModule implements INewExpenseModule {
    empCode!: string | undefined;
    policyName!: string | undefined;
    type!: string | undefined;
    designation!: string | undefined;
    name!: string | undefined;

    constructor(data?: INewExpenseModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empCode = _data["empCode"];
            this.policyName = _data["policyName"];
            this.type = _data["type"];
            this.designation = _data["designation"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): NewExpenseModule {
        data = typeof data === 'object' ? data : {};
        let result = new NewExpenseModule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empCode"] = this.empCode;
        data["policyName"] = this.policyName;
        data["type"] = this.type;
        data["designation"] = this.designation;
        data["name"] = this.name;
        return data;
    }
}

export interface INewExpenseModule {
    empCode: string | undefined;
    policyName: string | undefined;
    type: string | undefined;
    designation: string | undefined;
    name: string | undefined;
}

export class BranchlistIDs implements IBranchlistIDs {
    values!: number;

    constructor(data?: IBranchlistIDs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.values = _data["values"];
        }
    }

    static fromJS(data: any): BranchlistIDs {
        data = typeof data === 'object' ? data : {};
        let result = new BranchlistIDs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["values"] = this.values;
        return data;
    }
}

export interface IBranchlistIDs {
    values: number;
}

export class CreateOrEditExpenseMapPolicyDtoNew implements ICreateOrEditExpenseMapPolicyDtoNew {
    tenantId!: number;
    policyId!: number;
    branchID!: number;
    employeeId!: number | undefined;
    designationId!: number | undefined;
    departmentId!: number;
    divisionId!: number;
    policyType!: string | undefined;
    employeelist!: BranchlistIDs;
    id!: number | undefined;

    constructor(data?: ICreateOrEditExpenseMapPolicyDtoNew) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.policyId = _data["policyId"];
            this.branchID = _data["branchID"];
            this.employeeId = _data["employeeId"];
            this.designationId = _data["designationId"];
            this.departmentId = _data["departmentId"];
            this.divisionId = _data["divisionId"];
            this.policyType = _data["policyType"];
            this.employeelist = _data["employeelist"] ? BranchlistIDs.fromJS(_data["employeelist"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditExpenseMapPolicyDtoNew {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditExpenseMapPolicyDtoNew();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["policyId"] = this.policyId;
        data["branchID"] = this.branchID;
        data["employeeId"] = this.employeeId;
        data["designationId"] = this.designationId;
        data["departmentId"] = this.departmentId;
        data["divisionId"] = this.divisionId;
        data["policyType"] = this.policyType;
        data["employeelist"] = this.employeelist ? this.employeelist.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditExpenseMapPolicyDtoNew {
    tenantId: number;
    policyId: number;
    branchID: number;
    employeeId: number | undefined;
    designationId: number | undefined;
    departmentId: number;
    divisionId: number;
    policyType: string | undefined;
    employeelist: BranchlistIDs;
    id: number | undefined;
}

export class GetExpenseMapPolicyDtoNew implements IGetExpenseMapPolicyDtoNew {
    tenantId!: number;
    policyId!: number;
    branchID!: number;
    designationId!: number | undefined;
    departmentId!: number;
    divisionId!: number;
    employeeiD!: number;
    labelname!: string | undefined;
    policyType!: string | undefined;
    employeelist!: BranchlistIDs;
    id!: number | undefined;

    constructor(data?: IGetExpenseMapPolicyDtoNew) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.policyId = _data["policyId"];
            this.branchID = _data["branchID"];
            this.designationId = _data["designationId"];
            this.departmentId = _data["departmentId"];
            this.divisionId = _data["divisionId"];
            this.employeeiD = _data["employeeiD"];
            this.labelname = _data["labelname"];
            this.policyType = _data["policyType"];
            this.employeelist = _data["employeelist"] ? BranchlistIDs.fromJS(_data["employeelist"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetExpenseMapPolicyDtoNew {
        data = typeof data === 'object' ? data : {};
        let result = new GetExpenseMapPolicyDtoNew();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["policyId"] = this.policyId;
        data["branchID"] = this.branchID;
        data["designationId"] = this.designationId;
        data["departmentId"] = this.departmentId;
        data["divisionId"] = this.divisionId;
        data["employeeiD"] = this.employeeiD;
        data["labelname"] = this.labelname;
        data["policyType"] = this.policyType;
        data["employeelist"] = this.employeelist ? this.employeelist.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetExpenseMapPolicyDtoNew {
    tenantId: number;
    policyId: number;
    branchID: number;
    designationId: number | undefined;
    departmentId: number;
    divisionId: number;
    employeeiD: number;
    labelname: string | undefined;
    policyType: string | undefined;
    employeelist: BranchlistIDs;
    id: number | undefined;
}

export class GetSalarySettlementDto implements IGetSalarySettlementDto {
    salaryTitle!: string | undefined;
    salaryDescription!: string | undefined;
    sumAmount!: number | undefined;

    constructor(data?: IGetSalarySettlementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salaryTitle = _data["salaryTitle"];
            this.salaryDescription = _data["salaryDescription"];
            this.sumAmount = _data["sumAmount"];
        }
    }

    static fromJS(data: any): GetSalarySettlementDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalarySettlementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salaryTitle"] = this.salaryTitle;
        data["salaryDescription"] = this.salaryDescription;
        data["sumAmount"] = this.sumAmount;
        return data;
    }
}

export interface IGetSalarySettlementDto {
    salaryTitle: string | undefined;
    salaryDescription: string | undefined;
    sumAmount: number | undefined;
}

export class ValueTupleOfListOfGetSalarySettlementDtoListOfString implements IValueTupleOfListOfGetSalarySettlementDtoListOfString {
    item1!: GetSalarySettlementDto[] | undefined;
    item2!: string[] | undefined;

    constructor(data?: IValueTupleOfListOfGetSalarySettlementDtoListOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["item1"])) {
                this.item1 = [] as any;
                for (let item of _data["item1"])
                    this.item1!.push(GetSalarySettlementDto.fromJS(item));
            }
            if (Array.isArray(_data["item2"])) {
                this.item2 = [] as any;
                for (let item of _data["item2"])
                    this.item2!.push(item);
            }
        }
    }

    static fromJS(data: any): ValueTupleOfListOfGetSalarySettlementDtoListOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ValueTupleOfListOfGetSalarySettlementDtoListOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.item1)) {
            data["item1"] = [];
            for (let item of this.item1)
                data["item1"].push(item.toJSON());
        }
        if (Array.isArray(this.item2)) {
            data["item2"] = [];
            for (let item of this.item2)
                data["item2"].push(item);
        }
        return data;
    }
}

export interface IValueTupleOfListOfGetSalarySettlementDtoListOfString {
    item1: GetSalarySettlementDto[] | undefined;
    item2: string[] | undefined;
}

export class PayablesFnFDto implements IPayablesFnFDto {
    payComponentName!: string | undefined;
    payComponent!: number | undefined;
    amount!: number | undefined;
    id!: number;

    constructor(data?: IPayablesFnFDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payComponentName = _data["payComponentName"];
            this.payComponent = _data["payComponent"];
            this.amount = _data["amount"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PayablesFnFDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayablesFnFDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payComponentName"] = this.payComponentName;
        data["payComponent"] = this.payComponent;
        data["amount"] = this.amount;
        data["id"] = this.id;
        return data;
    }
}

export interface IPayablesFnFDto {
    payComponentName: string | undefined;
    payComponent: number | undefined;
    amount: number | undefined;
    id: number;
}

export class GetPayables implements IGetPayables {
    payables!: PayablesFnFDto;
    id!: number | undefined;

    constructor(data?: IGetPayables) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payables = _data["payables"] ? PayablesFnFDto.fromJS(_data["payables"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetPayables {
        data = typeof data === 'object' ? data : {};
        let result = new GetPayables();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payables"] = this.payables ? this.payables.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetPayables {
    payables: PayablesFnFDto;
    id: number | undefined;
}

export class FNFCompontsP implements IFNFCompontsP {
    employeeId!: number;
    workDays!: number | undefined;
    wo!: number;
    holiday!: number;
    leaves!: number;
    paidDays!: number;
    absent!: number;

    constructor(data?: IFNFCompontsP) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.workDays = _data["workDays"];
            this.wo = _data["wo"];
            this.holiday = _data["holiday"];
            this.leaves = _data["leaves"];
            this.paidDays = _data["paidDays"];
            this.absent = _data["absent"];
        }
    }

    static fromJS(data: any): FNFCompontsP {
        data = typeof data === 'object' ? data : {};
        let result = new FNFCompontsP();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["workDays"] = this.workDays;
        data["wo"] = this.wo;
        data["holiday"] = this.holiday;
        data["leaves"] = this.leaves;
        data["paidDays"] = this.paidDays;
        data["absent"] = this.absent;
        return data;
    }
}

export interface IFNFCompontsP {
    employeeId: number;
    workDays: number | undefined;
    wo: number;
    holiday: number;
    leaves: number;
    paidDays: number;
    absent: number;
}

export class EaringComponetsFNF implements IEaringComponetsFNF {
    name!: string | undefined;
    rate!: number | undefined;
    rs!: number | undefined;
    monthName!: string | undefined;

    constructor(data?: IEaringComponetsFNF) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.rate = _data["rate"];
            this.rs = _data["rs"];
            this.monthName = _data["monthName"];
        }
    }

    static fromJS(data: any): EaringComponetsFNF {
        data = typeof data === 'object' ? data : {};
        let result = new EaringComponetsFNF();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["rate"] = this.rate;
        data["rs"] = this.rs;
        data["monthName"] = this.monthName;
        return data;
    }
}

export interface IEaringComponetsFNF {
    name: string | undefined;
    rate: number | undefined;
    rs: number | undefined;
    monthName: string | undefined;
}

export class DedctionComponetsFNF implements IDedctionComponetsFNF {
    name!: string | undefined;
    rate!: number | undefined;
    rs!: number | undefined;
    monthName!: string | undefined;

    constructor(data?: IDedctionComponetsFNF) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.rate = _data["rate"];
            this.rs = _data["rs"];
            this.monthName = _data["monthName"];
        }
    }

    static fromJS(data: any): DedctionComponetsFNF {
        data = typeof data === 'object' ? data : {};
        let result = new DedctionComponetsFNF();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["rate"] = this.rate;
        data["rs"] = this.rs;
        data["monthName"] = this.monthName;
        return data;
    }
}

export interface IDedctionComponetsFNF {
    name: string | undefined;
    rate: number | undefined;
    rs: number | undefined;
    monthName: string | undefined;
}

export class EmployeeSalaryFNFtData implements IEmployeeSalaryFNFtData {
    tenantAddress!: string | undefined;
    logoImage!: string | undefined;
    companyName!: string | undefined;
    location!: string | undefined;
    employeeName!: string | undefined;
    salaryid!: number;
    fatherName!: string | undefined;
    doj!: string | undefined;
    employeeId!: string | undefined;
    designation!: string | undefined;
    department!: string | undefined;
    bankAcNo!: string | undefined;
    pfNo!: string | undefined;
    esiNo!: string | undefined;
    bankName!: string | undefined;
    panCard!: string | undefined;
    pfUanNo!: string | undefined;
    workDays!: number | undefined;
    lossOFpay!: number | undefined;
    present!: number | undefined;
    netSalary!: number | undefined;
    leave!: number | undefined;
    el!: number;
    cl!: number;
    sl!: number;
    monthName!: string | undefined;
    fnfCompontsPs!: FNFCompontsP[] | undefined;
    earingComponets!: EaringComponetsFNF[] | undefined;
    dedctionComponets!: DedctionComponetsFNF[] | undefined;

    constructor(data?: IEmployeeSalaryFNFtData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantAddress = _data["tenantAddress"];
            this.logoImage = _data["logoImage"];
            this.companyName = _data["companyName"];
            this.location = _data["location"];
            this.employeeName = _data["employeeName"];
            this.salaryid = _data["salaryid"];
            this.fatherName = _data["fatherName"];
            this.doj = _data["doj"];
            this.employeeId = _data["employeeId"];
            this.designation = _data["designation"];
            this.department = _data["department"];
            this.bankAcNo = _data["bankAcNo"];
            this.pfNo = _data["pfNo"];
            this.esiNo = _data["esiNo"];
            this.bankName = _data["bankName"];
            this.panCard = _data["panCard"];
            this.pfUanNo = _data["pfUanNo"];
            this.workDays = _data["workDays"];
            this.lossOFpay = _data["lossOFpay"];
            this.present = _data["present"];
            this.netSalary = _data["netSalary"];
            this.leave = _data["leave"];
            this.el = _data["el"];
            this.cl = _data["cl"];
            this.sl = _data["sl"];
            this.monthName = _data["monthName"];
            if (Array.isArray(_data["fnfCompontsPs"])) {
                this.fnfCompontsPs = [] as any;
                for (let item of _data["fnfCompontsPs"])
                    this.fnfCompontsPs!.push(FNFCompontsP.fromJS(item));
            }
            if (Array.isArray(_data["earingComponets"])) {
                this.earingComponets = [] as any;
                for (let item of _data["earingComponets"])
                    this.earingComponets!.push(EaringComponetsFNF.fromJS(item));
            }
            if (Array.isArray(_data["dedctionComponets"])) {
                this.dedctionComponets = [] as any;
                for (let item of _data["dedctionComponets"])
                    this.dedctionComponets!.push(DedctionComponetsFNF.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeeSalaryFNFtData {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeSalaryFNFtData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantAddress"] = this.tenantAddress;
        data["logoImage"] = this.logoImage;
        data["companyName"] = this.companyName;
        data["location"] = this.location;
        data["employeeName"] = this.employeeName;
        data["salaryid"] = this.salaryid;
        data["fatherName"] = this.fatherName;
        data["doj"] = this.doj;
        data["employeeId"] = this.employeeId;
        data["designation"] = this.designation;
        data["department"] = this.department;
        data["bankAcNo"] = this.bankAcNo;
        data["pfNo"] = this.pfNo;
        data["esiNo"] = this.esiNo;
        data["bankName"] = this.bankName;
        data["panCard"] = this.panCard;
        data["pfUanNo"] = this.pfUanNo;
        data["workDays"] = this.workDays;
        data["lossOFpay"] = this.lossOFpay;
        data["present"] = this.present;
        data["netSalary"] = this.netSalary;
        data["leave"] = this.leave;
        data["el"] = this.el;
        data["cl"] = this.cl;
        data["sl"] = this.sl;
        data["monthName"] = this.monthName;
        if (Array.isArray(this.fnfCompontsPs)) {
            data["fnfCompontsPs"] = [];
            for (let item of this.fnfCompontsPs)
                data["fnfCompontsPs"].push(item.toJSON());
        }
        if (Array.isArray(this.earingComponets)) {
            data["earingComponets"] = [];
            for (let item of this.earingComponets)
                data["earingComponets"].push(item.toJSON());
        }
        if (Array.isArray(this.dedctionComponets)) {
            data["dedctionComponets"] = [];
            for (let item of this.dedctionComponets)
                data["dedctionComponets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmployeeSalaryFNFtData {
    tenantAddress: string | undefined;
    logoImage: string | undefined;
    companyName: string | undefined;
    location: string | undefined;
    employeeName: string | undefined;
    salaryid: number;
    fatherName: string | undefined;
    doj: string | undefined;
    employeeId: string | undefined;
    designation: string | undefined;
    department: string | undefined;
    bankAcNo: string | undefined;
    pfNo: string | undefined;
    esiNo: string | undefined;
    bankName: string | undefined;
    panCard: string | undefined;
    pfUanNo: string | undefined;
    workDays: number | undefined;
    lossOFpay: number | undefined;
    present: number | undefined;
    netSalary: number | undefined;
    leave: number | undefined;
    el: number;
    cl: number;
    sl: number;
    monthName: string | undefined;
    fnfCompontsPs: FNFCompontsP[] | undefined;
    earingComponets: EaringComponetsFNF[] | undefined;
    dedctionComponets: DedctionComponetsFNF[] | undefined;
}

export class FreezsalaryDto implements IFreezsalaryDto {
    monthYear!: string | undefined;
    freezDate!: moment.Moment | undefined;
    freezeAdvance!: boolean | undefined;
    freezeTDS!: boolean | undefined;
    freezeAttendance!: boolean | undefined;
    freezeSalary!: boolean | undefined;
    freezeOtherAmount!: boolean | undefined;
    freezePreview!: boolean | undefined;
    freezeOnHold!: boolean | undefined;
    freezeOnBonus!: boolean | undefined;
    freezeOnIncentive!: boolean | undefined;
    freezePayout!: boolean | undefined;
    arrear!: boolean | undefined;
    id!: number;

    constructor(data?: IFreezsalaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthYear = _data["monthYear"];
            this.freezDate = _data["freezDate"] ? moment(_data["freezDate"].toString()) : <any>undefined;
            this.freezeAdvance = _data["freezeAdvance"];
            this.freezeTDS = _data["freezeTDS"];
            this.freezeAttendance = _data["freezeAttendance"];
            this.freezeSalary = _data["freezeSalary"];
            this.freezeOtherAmount = _data["freezeOtherAmount"];
            this.freezePreview = _data["freezePreview"];
            this.freezeOnHold = _data["freezeOnHold"];
            this.freezeOnBonus = _data["freezeOnBonus"];
            this.freezeOnIncentive = _data["freezeOnIncentive"];
            this.freezePayout = _data["freezePayout"];
            this.arrear = _data["arrear"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FreezsalaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new FreezsalaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthYear"] = this.monthYear;
        data["freezDate"] = this.freezDate ? this.freezDate.toISOString() : <any>undefined;
        data["freezeAdvance"] = this.freezeAdvance;
        data["freezeTDS"] = this.freezeTDS;
        data["freezeAttendance"] = this.freezeAttendance;
        data["freezeSalary"] = this.freezeSalary;
        data["freezeOtherAmount"] = this.freezeOtherAmount;
        data["freezePreview"] = this.freezePreview;
        data["freezeOnHold"] = this.freezeOnHold;
        data["freezeOnBonus"] = this.freezeOnBonus;
        data["freezeOnIncentive"] = this.freezeOnIncentive;
        data["freezePayout"] = this.freezePayout;
        data["arrear"] = this.arrear;
        data["id"] = this.id;
        return data;
    }
}

export interface IFreezsalaryDto {
    monthYear: string | undefined;
    freezDate: moment.Moment | undefined;
    freezeAdvance: boolean | undefined;
    freezeTDS: boolean | undefined;
    freezeAttendance: boolean | undefined;
    freezeSalary: boolean | undefined;
    freezeOtherAmount: boolean | undefined;
    freezePreview: boolean | undefined;
    freezeOnHold: boolean | undefined;
    freezeOnBonus: boolean | undefined;
    freezeOnIncentive: boolean | undefined;
    freezePayout: boolean | undefined;
    arrear: boolean | undefined;
    id: number;
}

export class GetFreezsalaryForViewDto implements IGetFreezsalaryForViewDto {
    freezsalary!: FreezsalaryDto;

    constructor(data?: IGetFreezsalaryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.freezsalary = _data["freezsalary"] ? FreezsalaryDto.fromJS(_data["freezsalary"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFreezsalaryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFreezsalaryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["freezsalary"] = this.freezsalary ? this.freezsalary.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetFreezsalaryForViewDto {
    freezsalary: FreezsalaryDto;
}

export class PagedResultDtoOfGetFreezsalaryForViewDto implements IPagedResultDtoOfGetFreezsalaryForViewDto {
    totalCount!: number;
    items!: GetFreezsalaryForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetFreezsalaryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetFreezsalaryForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetFreezsalaryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetFreezsalaryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetFreezsalaryForViewDto {
    totalCount: number;
    items: GetFreezsalaryForViewDto[] | undefined;
}

export class CreateOrEditFreezsalaryDto implements ICreateOrEditFreezsalaryDto {
    monthYear!: string | undefined;
    freezDate!: moment.Moment | undefined;
    freezeAdvance!: boolean | undefined;
    freezeTDS!: boolean | undefined;
    freezeAttendance!: boolean | undefined;
    freezeSalary!: boolean | undefined;
    freezeOtherAmount!: boolean | undefined;
    freezeOnHold!: boolean | undefined;
    freezeOnBonus!: boolean | undefined;
    freezeOnIncentive!: boolean | undefined;
    freezePreview!: boolean | undefined;
    freezePayout!: boolean | undefined;
    arrear!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditFreezsalaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthYear = _data["monthYear"];
            this.freezDate = _data["freezDate"] ? moment(_data["freezDate"].toString()) : <any>undefined;
            this.freezeAdvance = _data["freezeAdvance"];
            this.freezeTDS = _data["freezeTDS"];
            this.freezeAttendance = _data["freezeAttendance"];
            this.freezeSalary = _data["freezeSalary"];
            this.freezeOtherAmount = _data["freezeOtherAmount"];
            this.freezeOnHold = _data["freezeOnHold"];
            this.freezeOnBonus = _data["freezeOnBonus"];
            this.freezeOnIncentive = _data["freezeOnIncentive"];
            this.freezePreview = _data["freezePreview"];
            this.freezePayout = _data["freezePayout"];
            this.arrear = _data["arrear"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditFreezsalaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditFreezsalaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthYear"] = this.monthYear;
        data["freezDate"] = this.freezDate ? this.freezDate.toISOString() : <any>undefined;
        data["freezeAdvance"] = this.freezeAdvance;
        data["freezeTDS"] = this.freezeTDS;
        data["freezeAttendance"] = this.freezeAttendance;
        data["freezeSalary"] = this.freezeSalary;
        data["freezeOtherAmount"] = this.freezeOtherAmount;
        data["freezeOnHold"] = this.freezeOnHold;
        data["freezeOnBonus"] = this.freezeOnBonus;
        data["freezeOnIncentive"] = this.freezeOnIncentive;
        data["freezePreview"] = this.freezePreview;
        data["freezePayout"] = this.freezePayout;
        data["arrear"] = this.arrear;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditFreezsalaryDto {
    monthYear: string | undefined;
    freezDate: moment.Moment | undefined;
    freezeAdvance: boolean | undefined;
    freezeTDS: boolean | undefined;
    freezeAttendance: boolean | undefined;
    freezeSalary: boolean | undefined;
    freezeOtherAmount: boolean | undefined;
    freezeOnHold: boolean | undefined;
    freezeOnBonus: boolean | undefined;
    freezeOnIncentive: boolean | undefined;
    freezePreview: boolean | undefined;
    freezePayout: boolean | undefined;
    arrear: boolean | undefined;
    id: number | undefined;
}

export class GetFreezsalaryForEditOutput implements IGetFreezsalaryForEditOutput {
    freezsalary!: CreateOrEditFreezsalaryDto;

    constructor(data?: IGetFreezsalaryForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.freezsalary = _data["freezsalary"] ? CreateOrEditFreezsalaryDto.fromJS(_data["freezsalary"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFreezsalaryForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFreezsalaryForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["freezsalary"] = this.freezsalary ? this.freezsalary.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetFreezsalaryForEditOutput {
    freezsalary: CreateOrEditFreezsalaryDto;
}

export class CreateFriendshipRequestInput implements ICreateFriendshipRequestInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: ICreateFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ICreateFriendshipRequestInput {
    userId: number;
    tenantId: number | undefined;
}

export class CreateFriendshipRequestByUserNameInput implements ICreateFriendshipRequestByUserNameInput {
    tenancyName!: string;
    userName!: string | undefined;

    constructor(data?: ICreateFriendshipRequestByUserNameInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestByUserNameInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFriendshipRequestByUserNameInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        return data;
    }
}

export interface ICreateFriendshipRequestByUserNameInput {
    tenancyName: string;
    userName: string | undefined;
}

export class BlockUserInput implements IBlockUserInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: IBlockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): BlockUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new BlockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IBlockUserInput {
    userId: number;
    tenantId: number | undefined;
}

export class UnblockUserInput implements IUnblockUserInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: IUnblockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): UnblockUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new UnblockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IUnblockUserInput {
    userId: number;
    tenantId: number | undefined;
}

export class AcceptFriendshipRequestInput implements IAcceptFriendshipRequestInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: IAcceptFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AcceptFriendshipRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IAcceptFriendshipRequestInput {
    userId: number;
    tenantId: number | undefined;
}

export class GpsTripDetailsDto implements IGpsTripDetailsDto {
    id!: number;
    tenantId!: number;
    fkTripId!: number;
    sequenceNo!: number | undefined;
    longitude!: string | undefined;
    latitude!: string | undefined;
    timesTamp!: moment.Moment | undefined;
    locationName!: string | undefined;
    destinationToTrip!: string | undefined;
    remark!: string | undefined;
    employeeName!: string | undefined;

    constructor(data?: IGpsTripDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.fkTripId = _data["fkTripId"];
            this.sequenceNo = _data["sequenceNo"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.timesTamp = _data["timesTamp"] ? moment(_data["timesTamp"].toString()) : <any>undefined;
            this.locationName = _data["locationName"];
            this.destinationToTrip = _data["destinationToTrip"];
            this.remark = _data["remark"];
            this.employeeName = _data["employeeName"];
        }
    }

    static fromJS(data: any): GpsTripDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GpsTripDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["fkTripId"] = this.fkTripId;
        data["sequenceNo"] = this.sequenceNo;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["timesTamp"] = this.timesTamp ? this.timesTamp.toISOString() : <any>undefined;
        data["locationName"] = this.locationName;
        data["destinationToTrip"] = this.destinationToTrip;
        data["remark"] = this.remark;
        data["employeeName"] = this.employeeName;
        return data;
    }
}

export interface IGpsTripDetailsDto {
    id: number;
    tenantId: number;
    fkTripId: number;
    sequenceNo: number | undefined;
    longitude: string | undefined;
    latitude: string | undefined;
    timesTamp: moment.Moment | undefined;
    locationName: string | undefined;
    destinationToTrip: string | undefined;
    remark: string | undefined;
    employeeName: string | undefined;
}

export class GpsTripDto implements IGpsTripDto {
    id!: number;
    tenantId!: number;
    employeeId!: number;
    startDeviceTime!: moment.Moment | undefined;
    startServerTime!: moment.Moment | undefined;
    startLocationName!: string | undefined;
    startLatitude!: string | undefined;
    startLongitude!: string | undefined;
    destinationToTrip!: string | undefined;
    endLongitude!: string | undefined;
    endLatitude!: string | undefined;
    endLocationName!: string | undefined;
    completedDeviceTime!: moment.Moment | undefined;
    completedServerTime!: moment.Moment | undefined;
    distanceTravel!: number | undefined;
    status!: string | undefined;
    remarks!: string | undefined;
    deviceId!: string | undefined;
    details!: GpsTripDetailsDto[] | undefined;

    constructor(data?: IGpsTripDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.employeeId = _data["employeeId"];
            this.startDeviceTime = _data["startDeviceTime"] ? moment(_data["startDeviceTime"].toString()) : <any>undefined;
            this.startServerTime = _data["startServerTime"] ? moment(_data["startServerTime"].toString()) : <any>undefined;
            this.startLocationName = _data["startLocationName"];
            this.startLatitude = _data["startLatitude"];
            this.startLongitude = _data["startLongitude"];
            this.destinationToTrip = _data["destinationToTrip"];
            this.endLongitude = _data["endLongitude"];
            this.endLatitude = _data["endLatitude"];
            this.endLocationName = _data["endLocationName"];
            this.completedDeviceTime = _data["completedDeviceTime"] ? moment(_data["completedDeviceTime"].toString()) : <any>undefined;
            this.completedServerTime = _data["completedServerTime"] ? moment(_data["completedServerTime"].toString()) : <any>undefined;
            this.distanceTravel = _data["distanceTravel"];
            this.status = _data["status"];
            this.remarks = _data["remarks"];
            this.deviceId = _data["deviceId"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(GpsTripDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GpsTripDto {
        data = typeof data === 'object' ? data : {};
        let result = new GpsTripDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["employeeId"] = this.employeeId;
        data["startDeviceTime"] = this.startDeviceTime ? this.startDeviceTime.toISOString() : <any>undefined;
        data["startServerTime"] = this.startServerTime ? this.startServerTime.toISOString() : <any>undefined;
        data["startLocationName"] = this.startLocationName;
        data["startLatitude"] = this.startLatitude;
        data["startLongitude"] = this.startLongitude;
        data["destinationToTrip"] = this.destinationToTrip;
        data["endLongitude"] = this.endLongitude;
        data["endLatitude"] = this.endLatitude;
        data["endLocationName"] = this.endLocationName;
        data["completedDeviceTime"] = this.completedDeviceTime ? this.completedDeviceTime.toISOString() : <any>undefined;
        data["completedServerTime"] = this.completedServerTime ? this.completedServerTime.toISOString() : <any>undefined;
        data["distanceTravel"] = this.distanceTravel;
        data["status"] = this.status;
        data["remarks"] = this.remarks;
        data["deviceId"] = this.deviceId;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGpsTripDto {
    id: number;
    tenantId: number;
    employeeId: number;
    startDeviceTime: moment.Moment | undefined;
    startServerTime: moment.Moment | undefined;
    startLocationName: string | undefined;
    startLatitude: string | undefined;
    startLongitude: string | undefined;
    destinationToTrip: string | undefined;
    endLongitude: string | undefined;
    endLatitude: string | undefined;
    endLocationName: string | undefined;
    completedDeviceTime: moment.Moment | undefined;
    completedServerTime: moment.Moment | undefined;
    distanceTravel: number | undefined;
    status: string | undefined;
    remarks: string | undefined;
    deviceId: string | undefined;
    details: GpsTripDetailsDto[] | undefined;
}

export class GpsLocationDto implements IGpsLocationDto {
    employeeId!: number;
    deviceTimestamp!: moment.Moment;
    latitude!: string | undefined;
    deviceId!: string | undefined;
    longitude!: string | undefined;
    locationName!: string | undefined;

    constructor(data?: IGpsLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.deviceTimestamp = _data["deviceTimestamp"] ? moment(_data["deviceTimestamp"].toString()) : <any>undefined;
            this.latitude = _data["latitude"];
            this.deviceId = _data["deviceId"];
            this.longitude = _data["longitude"];
            this.locationName = _data["locationName"];
        }
    }

    static fromJS(data: any): GpsLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GpsLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["deviceTimestamp"] = this.deviceTimestamp ? this.deviceTimestamp.toISOString() : <any>undefined;
        data["latitude"] = this.latitude;
        data["deviceId"] = this.deviceId;
        data["longitude"] = this.longitude;
        data["locationName"] = this.locationName;
        return data;
    }
}

export interface IGpsLocationDto {
    employeeId: number;
    deviceTimestamp: moment.Moment;
    latitude: string | undefined;
    deviceId: string | undefined;
    longitude: string | undefined;
    locationName: string | undefined;
}

export class GpsLocationResponseDto implements IGpsLocationResponseDto {
    success!: boolean;
    serverTimestamp!: moment.Moment | undefined;
    message!: string | undefined;

    constructor(data?: IGpsLocationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.serverTimestamp = _data["serverTimestamp"] ? moment(_data["serverTimestamp"].toString()) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): GpsLocationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GpsLocationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["serverTimestamp"] = this.serverTimestamp ? this.serverTimestamp.toISOString() : <any>undefined;
        data["message"] = this.message;
        return data;
    }
}

export interface IGpsLocationResponseDto {
    success: boolean;
    serverTimestamp: moment.Moment | undefined;
    message: string | undefined;
}

export enum GpsReportType {
    Location = 1,
    Trip = 2,
    TripDetails = 3,
}

export class GpsReportResponseDto implements IGpsReportResponseDto {
    data!: any | undefined;

    constructor(data?: IGpsReportResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): GpsReportResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GpsReportResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        return data;
    }
}

export interface IGpsReportResponseDto {
    data: any | undefined;
}

export class MovementLogRowDto implements IMovementLogRowDto {
    employeeId!: number;
    employeeName!: string | undefined;
    fromTime!: moment.Moment;
    toTime!: moment.Moment;
    latitudeDisplay!: string | undefined;
    longitudeDisplay!: string | undefined;
    haltDisplay!: string | undefined;
    locationName!: string | undefined;

    constructor(data?: IMovementLogRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.fromTime = _data["fromTime"] ? moment(_data["fromTime"].toString()) : <any>undefined;
            this.toTime = _data["toTime"] ? moment(_data["toTime"].toString()) : <any>undefined;
            this.latitudeDisplay = _data["latitudeDisplay"];
            this.longitudeDisplay = _data["longitudeDisplay"];
            this.haltDisplay = _data["haltDisplay"];
            this.locationName = _data["locationName"];
        }
    }

    static fromJS(data: any): MovementLogRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new MovementLogRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["fromTime"] = this.fromTime ? this.fromTime.toISOString() : <any>undefined;
        data["toTime"] = this.toTime ? this.toTime.toISOString() : <any>undefined;
        data["latitudeDisplay"] = this.latitudeDisplay;
        data["longitudeDisplay"] = this.longitudeDisplay;
        data["haltDisplay"] = this.haltDisplay;
        data["locationName"] = this.locationName;
        return data;
    }
}

export interface IMovementLogRowDto {
    employeeId: number;
    employeeName: string | undefined;
    fromTime: moment.Moment;
    toTime: moment.Moment;
    latitudeDisplay: string | undefined;
    longitudeDisplay: string | undefined;
    haltDisplay: string | undefined;
    locationName: string | undefined;
}

export class CurrentHaltSummaryDto implements ICurrentHaltSummaryDto {
    employeeId!: number;
    employeeName!: string | undefined;
    haltDisplay!: string | undefined;
    locationName!: string | undefined;
    lastLatitude!: string | undefined;
    lastLongitude!: string | undefined;

    constructor(data?: ICurrentHaltSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.haltDisplay = _data["haltDisplay"];
            this.locationName = _data["locationName"];
            this.lastLatitude = _data["lastLatitude"];
            this.lastLongitude = _data["lastLongitude"];
        }
    }

    static fromJS(data: any): CurrentHaltSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentHaltSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["haltDisplay"] = this.haltDisplay;
        data["locationName"] = this.locationName;
        data["lastLatitude"] = this.lastLatitude;
        data["lastLongitude"] = this.lastLongitude;
        return data;
    }
}

export interface ICurrentHaltSummaryDto {
    employeeId: number;
    employeeName: string | undefined;
    haltDisplay: string | undefined;
    locationName: string | undefined;
    lastLatitude: string | undefined;
    lastLongitude: string | undefined;
}

export class MovementHaltItemDto implements IMovementHaltItemDto {
    employeeId!: number;
    employeeName!: string | undefined;
    haltDisplay!: string | undefined;
    locationName!: string | undefined;

    constructor(data?: IMovementHaltItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.haltDisplay = _data["haltDisplay"];
            this.locationName = _data["locationName"];
        }
    }

    static fromJS(data: any): MovementHaltItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MovementHaltItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["haltDisplay"] = this.haltDisplay;
        data["locationName"] = this.locationName;
        return data;
    }
}

export interface IMovementHaltItemDto {
    employeeId: number;
    employeeName: string | undefined;
    haltDisplay: string | undefined;
    locationName: string | undefined;
}

export class MovementReportDto implements IMovementReportDto {
    completeLog!: MovementLogRowDto[] | undefined;
    currentHalts!: CurrentHaltSummaryDto[] | undefined;
    allHalts!: MovementHaltItemDto[] | undefined;
    totalRecordCount!: number;
    completeLogSummary!: string | undefined;

    constructor(data?: IMovementReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["completeLog"])) {
                this.completeLog = [] as any;
                for (let item of _data["completeLog"])
                    this.completeLog!.push(MovementLogRowDto.fromJS(item));
            }
            if (Array.isArray(_data["currentHalts"])) {
                this.currentHalts = [] as any;
                for (let item of _data["currentHalts"])
                    this.currentHalts!.push(CurrentHaltSummaryDto.fromJS(item));
            }
            if (Array.isArray(_data["allHalts"])) {
                this.allHalts = [] as any;
                for (let item of _data["allHalts"])
                    this.allHalts!.push(MovementHaltItemDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.completeLogSummary = _data["completeLogSummary"];
        }
    }

    static fromJS(data: any): MovementReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new MovementReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.completeLog)) {
            data["completeLog"] = [];
            for (let item of this.completeLog)
                data["completeLog"].push(item.toJSON());
        }
        if (Array.isArray(this.currentHalts)) {
            data["currentHalts"] = [];
            for (let item of this.currentHalts)
                data["currentHalts"].push(item.toJSON());
        }
        if (Array.isArray(this.allHalts)) {
            data["allHalts"] = [];
            for (let item of this.allHalts)
                data["allHalts"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["completeLogSummary"] = this.completeLogSummary;
        return data;
    }
}

export interface IMovementReportDto {
    completeLog: MovementLogRowDto[] | undefined;
    currentHalts: CurrentHaltSummaryDto[] | undefined;
    allHalts: MovementHaltItemDto[] | undefined;
    totalRecordCount: number;
    completeLogSummary: string | undefined;
}

export class GetGpsReportInput implements IGetGpsReportInput {
    reportType!: GpsReportType;
    isLatestOnly!: boolean;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    employeeIds!: number[] | undefined;

    constructor(data?: IGetGpsReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportType = _data["reportType"];
            this.isLatestOnly = _data["isLatestOnly"];
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["employeeIds"])) {
                this.employeeIds = [] as any;
                for (let item of _data["employeeIds"])
                    this.employeeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetGpsReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGpsReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportType"] = this.reportType;
        data["isLatestOnly"] = this.isLatestOnly;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        if (Array.isArray(this.employeeIds)) {
            data["employeeIds"] = [];
            for (let item of this.employeeIds)
                data["employeeIds"].push(item);
        }
        return data;
    }
}

export interface IGetGpsReportInput {
    reportType: GpsReportType;
    isLatestOnly: boolean;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    employeeIds: number[] | undefined;
}

export class RoutePointDto implements IRoutePointDto {
    sequenceNo!: number | undefined;
    latitude!: number;
    longitude!: number;
    timestamp!: moment.Moment | undefined;

    constructor(data?: IRoutePointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sequenceNo = _data["sequenceNo"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.timestamp = _data["timestamp"] ? moment(_data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RoutePointDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoutePointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sequenceNo"] = this.sequenceNo;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRoutePointDto {
    sequenceNo: number | undefined;
    latitude: number;
    longitude: number;
    timestamp: moment.Moment | undefined;
}

export class TripRouteDto implements ITripRouteDto {
    tripId!: number;
    startLatitude!: number;
    startLongitude!: number;
    endLatitude!: number;
    endLongitude!: number;
    routePoints!: RoutePointDto[] | undefined;

    constructor(data?: ITripRouteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tripId = _data["tripId"];
            this.startLatitude = _data["startLatitude"];
            this.startLongitude = _data["startLongitude"];
            this.endLatitude = _data["endLatitude"];
            this.endLongitude = _data["endLongitude"];
            if (Array.isArray(_data["routePoints"])) {
                this.routePoints = [] as any;
                for (let item of _data["routePoints"])
                    this.routePoints!.push(RoutePointDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TripRouteDto {
        data = typeof data === 'object' ? data : {};
        let result = new TripRouteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripId"] = this.tripId;
        data["startLatitude"] = this.startLatitude;
        data["startLongitude"] = this.startLongitude;
        data["endLatitude"] = this.endLatitude;
        data["endLongitude"] = this.endLongitude;
        if (Array.isArray(this.routePoints)) {
            data["routePoints"] = [];
            for (let item of this.routePoints)
                data["routePoints"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITripRouteDto {
    tripId: number;
    startLatitude: number;
    startLongitude: number;
    endLatitude: number;
    endLongitude: number;
    routePoints: RoutePointDto[] | undefined;
}

export class GpsTripListDto implements IGpsTripListDto {
    tripId!: number;
    startTime!: moment.Moment | undefined;
    endTime!: moment.Moment | undefined;
    headingToLocationName!: string | undefined;
    startLocationName!: string | undefined;
    endLocationName!: string | undefined;
    distanceKm!: number | undefined;
    status!: string | undefined;
    remarks!: string | undefined;

    constructor(data?: IGpsTripListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tripId = _data["tripId"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.headingToLocationName = _data["headingToLocationName"];
            this.startLocationName = _data["startLocationName"];
            this.endLocationName = _data["endLocationName"];
            this.distanceKm = _data["distanceKm"];
            this.status = _data["status"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): GpsTripListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GpsTripListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripId"] = this.tripId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["headingToLocationName"] = this.headingToLocationName;
        data["startLocationName"] = this.startLocationName;
        data["endLocationName"] = this.endLocationName;
        data["distanceKm"] = this.distanceKm;
        data["status"] = this.status;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IGpsTripListDto {
    tripId: number;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    headingToLocationName: string | undefined;
    startLocationName: string | undefined;
    endLocationName: string | undefined;
    distanceKm: number | undefined;
    status: string | undefined;
    remarks: string | undefined;
}

export class PagedTripResultDto implements IPagedTripResultDto {
    page!: number;
    pageSize!: number;
    totalRecords!: number;
    items!: GpsTripListDto[] | undefined;

    constructor(data?: IPagedTripResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GpsTripListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedTripResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedTripResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedTripResultDto {
    page: number;
    pageSize: number;
    totalRecords: number;
    items: GpsTripListDto[] | undefined;
}

export class LocationDisabledDto implements ILocationDisabledDto {
    employeeId!: number;
    deviceId!: string | undefined;
    latitude!: string | undefined;
    longitude!: string | undefined;
    locationName!: string | undefined;
    triggerSource!: string | undefined;

    constructor(data?: ILocationDisabledDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.deviceId = _data["deviceId"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.locationName = _data["locationName"];
            this.triggerSource = _data["triggerSource"];
        }
    }

    static fromJS(data: any): LocationDisabledDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDisabledDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["deviceId"] = this.deviceId;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["locationName"] = this.locationName;
        data["triggerSource"] = this.triggerSource;
        return data;
    }
}

export interface ILocationDisabledDto {
    employeeId: number;
    deviceId: string | undefined;
    latitude: string | undefined;
    longitude: string | undefined;
    locationName: string | undefined;
    triggerSource: string | undefined;
}

export class GetAllHQForView implements IGetAllHQForView {
    id!: number;
    hqName!: string | undefined;
    stateName!: string | undefined;

    constructor(data?: IGetAllHQForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hqName = _data["hqName"];
            this.stateName = _data["stateName"];
        }
    }

    static fromJS(data: any): GetAllHQForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllHQForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hqName"] = this.hqName;
        data["stateName"] = this.stateName;
        return data;
    }
}

export interface IGetAllHQForView {
    id: number;
    hqName: string | undefined;
    stateName: string | undefined;
}

export class PagedResultDtoOfGetAllHQForView implements IPagedResultDtoOfGetAllHQForView {
    totalCount!: number;
    items!: GetAllHQForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllHQForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllHQForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllHQForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllHQForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAllHQForView {
    totalCount: number;
    items: GetAllHQForView[] | undefined;
}

export class CreateOrEditHeadQuarterDto implements ICreateOrEditHeadQuarterDto {
    hqName!: string | undefined;
    stateId!: number;
    tenantId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditHeadQuarterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hqName = _data["hqName"];
            this.stateId = _data["stateId"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditHeadQuarterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditHeadQuarterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hqName"] = this.hqName;
        data["stateId"] = this.stateId;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditHeadQuarterDto {
    hqName: string | undefined;
    stateId: number;
    tenantId: number;
    id: number | undefined;
}

export class GetHeadquarterForEditOutput implements IGetHeadquarterForEditOutput {
    headquater!: CreateOrEditHeadQuarterDto;

    constructor(data?: IGetHeadquarterForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.headquater = _data["headquater"] ? CreateOrEditHeadQuarterDto.fromJS(_data["headquater"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetHeadquarterForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetHeadquarterForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["headquater"] = this.headquater ? this.headquater.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetHeadquarterForEditOutput {
    headquater: CreateOrEditHeadQuarterDto;
}

export class HoldiayPolicyDto implements IHoldiayPolicyDto {
    name!: string | undefined;
    maxHolidayNo!: number;
    id!: number;

    constructor(data?: IHoldiayPolicyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.maxHolidayNo = _data["maxHolidayNo"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HoldiayPolicyDto {
        data = typeof data === 'object' ? data : {};
        let result = new HoldiayPolicyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["maxHolidayNo"] = this.maxHolidayNo;
        data["id"] = this.id;
        return data;
    }
}

export interface IHoldiayPolicyDto {
    name: string | undefined;
    maxHolidayNo: number;
    id: number;
}

export class GetHoldiayPolicyForViewDto implements IGetHoldiayPolicyForViewDto {
    holdiayPolicy!: HoldiayPolicyDto;

    constructor(data?: IGetHoldiayPolicyForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.holdiayPolicy = _data["holdiayPolicy"] ? HoldiayPolicyDto.fromJS(_data["holdiayPolicy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetHoldiayPolicyForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetHoldiayPolicyForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["holdiayPolicy"] = this.holdiayPolicy ? this.holdiayPolicy.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetHoldiayPolicyForViewDto {
    holdiayPolicy: HoldiayPolicyDto;
}

export class PagedResultDtoOfGetHoldiayPolicyForViewDto implements IPagedResultDtoOfGetHoldiayPolicyForViewDto {
    totalCount!: number;
    items!: GetHoldiayPolicyForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetHoldiayPolicyForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetHoldiayPolicyForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetHoldiayPolicyForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetHoldiayPolicyForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetHoldiayPolicyForViewDto {
    totalCount: number;
    items: GetHoldiayPolicyForViewDto[] | undefined;
}

export class CreateOrEditHoldiayPolicyDto implements ICreateOrEditHoldiayPolicyDto {
    name!: string | undefined;
    maxHolidayNo!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditHoldiayPolicyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.maxHolidayNo = _data["maxHolidayNo"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditHoldiayPolicyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditHoldiayPolicyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["maxHolidayNo"] = this.maxHolidayNo;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditHoldiayPolicyDto {
    name: string | undefined;
    maxHolidayNo: number;
    id: number | undefined;
}

export class GetHoldiayPolicyForEditOutput implements IGetHoldiayPolicyForEditOutput {
    holdiayPolicy!: CreateOrEditHoldiayPolicyDto;

    constructor(data?: IGetHoldiayPolicyForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.holdiayPolicy = _data["holdiayPolicy"] ? CreateOrEditHoldiayPolicyDto.fromJS(_data["holdiayPolicy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetHoldiayPolicyForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetHoldiayPolicyForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["holdiayPolicy"] = this.holdiayPolicy ? this.holdiayPolicy.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetHoldiayPolicyForEditOutput {
    holdiayPolicy: CreateOrEditHoldiayPolicyDto;
}

export class BranchDropDown implements IBranchDropDown {
    value!: number;
    label!: string | undefined;
    isAlreadyAssigned!: boolean;
    selected!: boolean;

    constructor(data?: IBranchDropDown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
            this.isAlreadyAssigned = _data["isAlreadyAssigned"];
            this.selected = _data["selected"];
        }
    }

    static fromJS(data: any): BranchDropDown {
        data = typeof data === 'object' ? data : {};
        let result = new BranchDropDown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        data["isAlreadyAssigned"] = this.isAlreadyAssigned;
        data["selected"] = this.selected;
        return data;
    }
}

export interface IBranchDropDown {
    value: number;
    label: string | undefined;
    isAlreadyAssigned: boolean;
    selected: boolean;
}

export class CreateOrEditHolidayMapPolicyDtoNew implements ICreateOrEditHolidayMapPolicyDtoNew {
    tenantId!: number;
    policyId!: number;
    branchID!: number;
    employeeId!: number;
    departmentId!: number;
    divisionId!: number;
    policyType!: string | undefined;
    branchlist!: BranchDropDown;
    id!: number | undefined;

    constructor(data?: ICreateOrEditHolidayMapPolicyDtoNew) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.policyId = _data["policyId"];
            this.branchID = _data["branchID"];
            this.employeeId = _data["employeeId"];
            this.departmentId = _data["departmentId"];
            this.divisionId = _data["divisionId"];
            this.policyType = _data["policyType"];
            this.branchlist = _data["branchlist"] ? BranchDropDown.fromJS(_data["branchlist"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditHolidayMapPolicyDtoNew {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditHolidayMapPolicyDtoNew();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["policyId"] = this.policyId;
        data["branchID"] = this.branchID;
        data["employeeId"] = this.employeeId;
        data["departmentId"] = this.departmentId;
        data["divisionId"] = this.divisionId;
        data["policyType"] = this.policyType;
        data["branchlist"] = this.branchlist ? this.branchlist.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditHolidayMapPolicyDtoNew {
    tenantId: number;
    policyId: number;
    branchID: number;
    employeeId: number;
    departmentId: number;
    divisionId: number;
    policyType: string | undefined;
    branchlist: BranchDropDown;
    id: number | undefined;
}

export class CreateOrEditHolidayMapPolicyDto implements ICreateOrEditHolidayMapPolicyDto {
    tenantId!: number;
    policyId!: number;
    branchId!: number;
    departmentId!: number;
    divisionId!: number;
    employeeId!: number;
    policyType!: string | undefined;
    branchlist!: BranchDropDown;
    employeeList!: DropDownEmployee;
    id!: number | undefined;

    constructor(data?: ICreateOrEditHolidayMapPolicyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.policyId = _data["policyId"];
            this.branchId = _data["branchId"];
            this.departmentId = _data["departmentId"];
            this.divisionId = _data["divisionId"];
            this.employeeId = _data["employeeId"];
            this.policyType = _data["policyType"];
            this.branchlist = _data["branchlist"] ? BranchDropDown.fromJS(_data["branchlist"]) : <any>undefined;
            this.employeeList = _data["employeeList"] ? DropDownEmployee.fromJS(_data["employeeList"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditHolidayMapPolicyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditHolidayMapPolicyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["policyId"] = this.policyId;
        data["branchId"] = this.branchId;
        data["departmentId"] = this.departmentId;
        data["divisionId"] = this.divisionId;
        data["employeeId"] = this.employeeId;
        data["policyType"] = this.policyType;
        data["branchlist"] = this.branchlist ? this.branchlist.toJSON() : <any>undefined;
        data["employeeList"] = this.employeeList ? this.employeeList.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditHolidayMapPolicyDto {
    tenantId: number;
    policyId: number;
    branchId: number;
    departmentId: number;
    divisionId: number;
    employeeId: number;
    policyType: string | undefined;
    branchlist: BranchDropDown;
    employeeList: DropDownEmployee;
    id: number | undefined;
}

export class AlreadyAssignedDto implements IAlreadyAssignedDto {
    branchId!: number | undefined;
    policyId!: number | undefined;

    constructor(data?: IAlreadyAssignedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchId = _data["branchId"];
            this.policyId = _data["policyId"];
        }
    }

    static fromJS(data: any): AlreadyAssignedDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlreadyAssignedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId;
        data["policyId"] = this.policyId;
        return data;
    }
}

export interface IAlreadyAssignedDto {
    branchId: number | undefined;
    policyId: number | undefined;
}

export class HolidayDto implements IHolidayDto {
    holidayName!: string | undefined;
    nationalHoliday!: boolean;
    reservedHoliday!: boolean;
    holidayDate!: moment.Moment;
    id!: number;

    constructor(data?: IHolidayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.holidayName = _data["holidayName"];
            this.nationalHoliday = _data["nationalHoliday"];
            this.reservedHoliday = _data["reservedHoliday"];
            this.holidayDate = _data["holidayDate"] ? moment(_data["holidayDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HolidayDto {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["holidayName"] = this.holidayName;
        data["nationalHoliday"] = this.nationalHoliday;
        data["reservedHoliday"] = this.reservedHoliday;
        data["holidayDate"] = this.holidayDate ? this.holidayDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IHolidayDto {
    holidayName: string | undefined;
    nationalHoliday: boolean;
    reservedHoliday: boolean;
    holidayDate: moment.Moment;
    id: number;
}

export class GetHolidayForViewDto implements IGetHolidayForViewDto {
    holiday!: HolidayDto;
    holidaydate!: string | undefined;
    holidaaete!: moment.Moment | undefined;

    constructor(data?: IGetHolidayForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.holiday = _data["holiday"] ? HolidayDto.fromJS(_data["holiday"]) : <any>undefined;
            this.holidaydate = _data["holidaydate"];
            this.holidaaete = _data["holidaaete"] ? moment(_data["holidaaete"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetHolidayForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetHolidayForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["holiday"] = this.holiday ? this.holiday.toJSON() : <any>undefined;
        data["holidaydate"] = this.holidaydate;
        data["holidaaete"] = this.holidaaete ? this.holidaaete.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetHolidayForViewDto {
    holiday: HolidayDto;
    holidaydate: string | undefined;
    holidaaete: moment.Moment | undefined;
}

export class PagedResultDtoOfGetHolidayForViewDto implements IPagedResultDtoOfGetHolidayForViewDto {
    totalCount!: number;
    items!: GetHolidayForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetHolidayForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetHolidayForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetHolidayForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetHolidayForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetHolidayForViewDto {
    totalCount: number;
    items: GetHolidayForViewDto[] | undefined;
}

export class CreateOrEditHolidayDto implements ICreateOrEditHolidayDto {
    holidayName!: string | undefined;
    nationalHoliday!: boolean;
    reservedHoliday!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditHolidayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.holidayName = _data["holidayName"];
            this.nationalHoliday = _data["nationalHoliday"];
            this.reservedHoliday = _data["reservedHoliday"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditHolidayDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditHolidayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["holidayName"] = this.holidayName;
        data["nationalHoliday"] = this.nationalHoliday;
        data["reservedHoliday"] = this.reservedHoliday;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditHolidayDto {
    holidayName: string | undefined;
    nationalHoliday: boolean;
    reservedHoliday: boolean;
    id: number | undefined;
}

export class GetHolidayForEditOutput implements IGetHolidayForEditOutput {
    holiday!: CreateOrEditHolidayDto;

    constructor(data?: IGetHolidayForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.holiday = _data["holiday"] ? CreateOrEditHolidayDto.fromJS(_data["holiday"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetHolidayForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetHolidayForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["holiday"] = this.holiday ? this.holiday.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetHolidayForEditOutput {
    holiday: CreateOrEditHolidayDto;
}

export class BranchWiseHolidayDto implements IBranchWiseHolidayDto {
    branchId!: number;
    branchName!: string | undefined;
    holidayId!: number;
    holidayName!: string | undefined;
    holidayDate!: moment.Moment | undefined;
    holidayDateFormatted!: string | undefined;

    constructor(data?: IBranchWiseHolidayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchId = _data["branchId"];
            this.branchName = _data["branchName"];
            this.holidayId = _data["holidayId"];
            this.holidayName = _data["holidayName"];
            this.holidayDate = _data["holidayDate"] ? moment(_data["holidayDate"].toString()) : <any>undefined;
            this.holidayDateFormatted = _data["holidayDateFormatted"];
        }
    }

    static fromJS(data: any): BranchWiseHolidayDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchWiseHolidayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId;
        data["branchName"] = this.branchName;
        data["holidayId"] = this.holidayId;
        data["holidayName"] = this.holidayName;
        data["holidayDate"] = this.holidayDate ? this.holidayDate.toISOString() : <any>undefined;
        data["holidayDateFormatted"] = this.holidayDateFormatted;
        return data;
    }
}

export interface IBranchWiseHolidayDto {
    branchId: number;
    branchName: string | undefined;
    holidayId: number;
    holidayName: string | undefined;
    holidayDate: moment.Moment | undefined;
    holidayDateFormatted: string | undefined;
}

export class PagedResultDtoOfBranchWiseHolidayDto implements IPagedResultDtoOfBranchWiseHolidayDto {
    totalCount!: number;
    items!: BranchWiseHolidayDto[] | undefined;

    constructor(data?: IPagedResultDtoOfBranchWiseHolidayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BranchWiseHolidayDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBranchWiseHolidayDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBranchWiseHolidayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfBranchWiseHolidayDto {
    totalCount: number;
    items: BranchWiseHolidayDto[] | undefined;
}

export class GetBranchWiseHolidayListInput implements IGetBranchWiseHolidayListInput {
    branchId!: number | undefined;
    holidayNameFilter!: string | undefined;
    year!: number | undefined;
    sorting!: string | undefined;
    skipCount!: number;
    maxResultCount!: number;

    constructor(data?: IGetBranchWiseHolidayListInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchId = _data["branchId"];
            this.holidayNameFilter = _data["holidayNameFilter"];
            this.year = _data["year"];
            this.sorting = _data["sorting"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetBranchWiseHolidayListInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBranchWiseHolidayListInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId;
        data["holidayNameFilter"] = this.holidayNameFilter;
        data["year"] = this.year;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetBranchWiseHolidayListInput {
    branchId: number | undefined;
    holidayNameFilter: string | undefined;
    year: number | undefined;
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;
}

export class HolidaypolicyDetailsDto implements IHolidaypolicyDetailsDto {
    holidayPolicy!: number;
    holidayId!: number;
    financialYear!: number;
    holidayDate!: moment.Moment | undefined;
    applicable!: boolean;
    id!: number;

    constructor(data?: IHolidaypolicyDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.holidayPolicy = _data["holidayPolicy"];
            this.holidayId = _data["holidayId"];
            this.financialYear = _data["financialYear"];
            this.holidayDate = _data["holidayDate"] ? moment(_data["holidayDate"].toString()) : <any>undefined;
            this.applicable = _data["applicable"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HolidaypolicyDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new HolidaypolicyDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["holidayPolicy"] = this.holidayPolicy;
        data["holidayId"] = this.holidayId;
        data["financialYear"] = this.financialYear;
        data["holidayDate"] = this.holidayDate ? this.holidayDate.toISOString() : <any>undefined;
        data["applicable"] = this.applicable;
        data["id"] = this.id;
        return data;
    }
}

export interface IHolidaypolicyDetailsDto {
    holidayPolicy: number;
    holidayId: number;
    financialYear: number;
    holidayDate: moment.Moment | undefined;
    applicable: boolean;
    id: number;
}

export class GetHolidaypolicyDetailsForViewDto implements IGetHolidaypolicyDetailsForViewDto {
    holidaypolicyDetails!: HolidaypolicyDetailsDto;

    constructor(data?: IGetHolidaypolicyDetailsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.holidaypolicyDetails = _data["holidaypolicyDetails"] ? HolidaypolicyDetailsDto.fromJS(_data["holidaypolicyDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetHolidaypolicyDetailsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetHolidaypolicyDetailsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["holidaypolicyDetails"] = this.holidaypolicyDetails ? this.holidaypolicyDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetHolidaypolicyDetailsForViewDto {
    holidaypolicyDetails: HolidaypolicyDetailsDto;
}

export class PagedResultDtoOfGetHolidaypolicyDetailsForViewDto implements IPagedResultDtoOfGetHolidaypolicyDetailsForViewDto {
    totalCount!: number;
    items!: GetHolidaypolicyDetailsForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetHolidaypolicyDetailsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetHolidaypolicyDetailsForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetHolidaypolicyDetailsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetHolidaypolicyDetailsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetHolidaypolicyDetailsForViewDto {
    totalCount: number;
    items: GetHolidaypolicyDetailsForViewDto[] | undefined;
}

export class HolidayDetails implements IHolidayDetails {
    applicable!: boolean;
    holidayId!: number;
    holidayName!: string | undefined;
    reservedHoliday!: boolean;
    nationalHoliday!: boolean;
    holidayDate!: moment.Moment | undefined;

    constructor(data?: IHolidayDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicable = _data["applicable"];
            this.holidayId = _data["holidayId"];
            this.holidayName = _data["holidayName"];
            this.reservedHoliday = _data["reservedHoliday"];
            this.nationalHoliday = _data["nationalHoliday"];
            this.holidayDate = _data["holidayDate"] ? moment(_data["holidayDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HolidayDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicable"] = this.applicable;
        data["holidayId"] = this.holidayId;
        data["holidayName"] = this.holidayName;
        data["reservedHoliday"] = this.reservedHoliday;
        data["nationalHoliday"] = this.nationalHoliday;
        data["holidayDate"] = this.holidayDate ? this.holidayDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IHolidayDetails {
    applicable: boolean;
    holidayId: number;
    holidayName: string | undefined;
    reservedHoliday: boolean;
    nationalHoliday: boolean;
    holidayDate: moment.Moment | undefined;
}

export class GetHoliday implements IGetHoliday {
    holidayDetails!: HolidayDetails;

    constructor(data?: IGetHoliday) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.holidayDetails = _data["holidayDetails"] ? HolidayDetails.fromJS(_data["holidayDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetHoliday {
        data = typeof data === 'object' ? data : {};
        let result = new GetHoliday();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["holidayDetails"] = this.holidayDetails ? this.holidayDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetHoliday {
    holidayDetails: HolidayDetails;
}

export class PagedResultDtoOfGetHoliday implements IPagedResultDtoOfGetHoliday {
    totalCount!: number;
    items!: GetHoliday[] | undefined;

    constructor(data?: IPagedResultDtoOfGetHoliday) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetHoliday.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetHoliday {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetHoliday();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetHoliday {
    totalCount: number;
    items: GetHoliday[] | undefined;
}

export class CreateOrEditHolidaypolicyDetailsDto implements ICreateOrEditHolidaypolicyDetailsDto {
    holidayPolicy!: number;
    holidayId!: number;
    financialYear!: number;
    holidayDate!: moment.Moment | undefined;
    applicable!: boolean;
    holidayDetails!: HolidayDetails[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditHolidaypolicyDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.holidayPolicy = _data["holidayPolicy"];
            this.holidayId = _data["holidayId"];
            this.financialYear = _data["financialYear"];
            this.holidayDate = _data["holidayDate"] ? moment(_data["holidayDate"].toString()) : <any>undefined;
            this.applicable = _data["applicable"];
            if (Array.isArray(_data["holidayDetails"])) {
                this.holidayDetails = [] as any;
                for (let item of _data["holidayDetails"])
                    this.holidayDetails!.push(HolidayDetails.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditHolidaypolicyDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditHolidaypolicyDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["holidayPolicy"] = this.holidayPolicy;
        data["holidayId"] = this.holidayId;
        data["financialYear"] = this.financialYear;
        data["holidayDate"] = this.holidayDate ? this.holidayDate.toISOString() : <any>undefined;
        data["applicable"] = this.applicable;
        if (Array.isArray(this.holidayDetails)) {
            data["holidayDetails"] = [];
            for (let item of this.holidayDetails)
                data["holidayDetails"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditHolidaypolicyDetailsDto {
    holidayPolicy: number;
    holidayId: number;
    financialYear: number;
    holidayDate: moment.Moment | undefined;
    applicable: boolean;
    holidayDetails: HolidayDetails[] | undefined;
    id: number | undefined;
}

export class GetHolidaypolicyDetailsForEditOutput implements IGetHolidaypolicyDetailsForEditOutput {
    holidaypolicyDetails!: CreateOrEditHolidaypolicyDetailsDto;

    constructor(data?: IGetHolidaypolicyDetailsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.holidaypolicyDetails = _data["holidaypolicyDetails"] ? CreateOrEditHolidaypolicyDetailsDto.fromJS(_data["holidaypolicyDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetHolidaypolicyDetailsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetHolidaypolicyDetailsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["holidaypolicyDetails"] = this.holidaypolicyDetails ? this.holidaypolicyDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetHolidaypolicyDetailsForEditOutput {
    holidaypolicyDetails: CreateOrEditHolidaypolicyDetailsDto;
}

export enum ChartDateInterval {
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
}

export class IncomeStastistic implements IIncomeStastistic {
    label!: string | undefined;
    date!: moment.Moment;
    amount!: number;

    constructor(data?: IIncomeStastistic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): IncomeStastistic {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeStastistic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IIncomeStastistic {
    label: string | undefined;
    date: moment.Moment;
    amount: number;
}

export class TenantEdition implements ITenantEdition {
    label!: string | undefined;
    value!: number;

    constructor(data?: ITenantEdition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TenantEdition {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEdition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

export interface ITenantEdition {
    label: string | undefined;
    value: number;
}

export class ExpiringTenant implements IExpiringTenant {
    tenantName!: string | undefined;
    remainingDayCount!: number;

    constructor(data?: IExpiringTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantName = _data["tenantName"];
            this.remainingDayCount = _data["remainingDayCount"];
        }
    }

    static fromJS(data: any): ExpiringTenant {
        data = typeof data === 'object' ? data : {};
        let result = new ExpiringTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["remainingDayCount"] = this.remainingDayCount;
        return data;
    }
}

export interface IExpiringTenant {
    tenantName: string | undefined;
    remainingDayCount: number;
}

export class RecentTenant implements IRecentTenant {
    id!: number;
    name!: string | undefined;
    creationTime!: moment.Moment;

    constructor(data?: IRecentTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RecentTenant {
        data = typeof data === 'object' ? data : {};
        let result = new RecentTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRecentTenant {
    id: number;
    name: string | undefined;
    creationTime: moment.Moment;
}

export class HostDashboardData implements IHostDashboardData {
    newTenantsCount!: number;
    newSubscriptionAmount!: number;
    dashboardPlaceholder1!: number;
    dashboardPlaceholder2!: number;
    incomeStatistics!: IncomeStastistic[] | undefined;
    editionStatistics!: TenantEdition[] | undefined;
    expiringTenants!: ExpiringTenant[] | undefined;
    recentTenants!: RecentTenant[] | undefined;
    maxExpiringTenantsShownCount!: number;
    maxRecentTenantsShownCount!: number;
    subscriptionEndAlertDayCount!: number;
    recentTenantsDayCount!: number;
    subscriptionEndDateStart!: moment.Moment;
    subscriptionEndDateEnd!: moment.Moment;
    tenantCreationStartDate!: moment.Moment;

    constructor(data?: IHostDashboardData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newTenantsCount = _data["newTenantsCount"];
            this.newSubscriptionAmount = _data["newSubscriptionAmount"];
            this.dashboardPlaceholder1 = _data["dashboardPlaceholder1"];
            this.dashboardPlaceholder2 = _data["dashboardPlaceholder2"];
            if (Array.isArray(_data["incomeStatistics"])) {
                this.incomeStatistics = [] as any;
                for (let item of _data["incomeStatistics"])
                    this.incomeStatistics!.push(IncomeStastistic.fromJS(item));
            }
            if (Array.isArray(_data["editionStatistics"])) {
                this.editionStatistics = [] as any;
                for (let item of _data["editionStatistics"])
                    this.editionStatistics!.push(TenantEdition.fromJS(item));
            }
            if (Array.isArray(_data["expiringTenants"])) {
                this.expiringTenants = [] as any;
                for (let item of _data["expiringTenants"])
                    this.expiringTenants!.push(ExpiringTenant.fromJS(item));
            }
            if (Array.isArray(_data["recentTenants"])) {
                this.recentTenants = [] as any;
                for (let item of _data["recentTenants"])
                    this.recentTenants!.push(RecentTenant.fromJS(item));
            }
            this.maxExpiringTenantsShownCount = _data["maxExpiringTenantsShownCount"];
            this.maxRecentTenantsShownCount = _data["maxRecentTenantsShownCount"];
            this.subscriptionEndAlertDayCount = _data["subscriptionEndAlertDayCount"];
            this.recentTenantsDayCount = _data["recentTenantsDayCount"];
            this.subscriptionEndDateStart = _data["subscriptionEndDateStart"] ? moment(_data["subscriptionEndDateStart"].toString()) : <any>undefined;
            this.subscriptionEndDateEnd = _data["subscriptionEndDateEnd"] ? moment(_data["subscriptionEndDateEnd"].toString()) : <any>undefined;
            this.tenantCreationStartDate = _data["tenantCreationStartDate"] ? moment(_data["tenantCreationStartDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HostDashboardData {
        data = typeof data === 'object' ? data : {};
        let result = new HostDashboardData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newTenantsCount"] = this.newTenantsCount;
        data["newSubscriptionAmount"] = this.newSubscriptionAmount;
        data["dashboardPlaceholder1"] = this.dashboardPlaceholder1;
        data["dashboardPlaceholder2"] = this.dashboardPlaceholder2;
        if (Array.isArray(this.incomeStatistics)) {
            data["incomeStatistics"] = [];
            for (let item of this.incomeStatistics)
                data["incomeStatistics"].push(item.toJSON());
        }
        if (Array.isArray(this.editionStatistics)) {
            data["editionStatistics"] = [];
            for (let item of this.editionStatistics)
                data["editionStatistics"].push(item.toJSON());
        }
        if (Array.isArray(this.expiringTenants)) {
            data["expiringTenants"] = [];
            for (let item of this.expiringTenants)
                data["expiringTenants"].push(item.toJSON());
        }
        if (Array.isArray(this.recentTenants)) {
            data["recentTenants"] = [];
            for (let item of this.recentTenants)
                data["recentTenants"].push(item.toJSON());
        }
        data["maxExpiringTenantsShownCount"] = this.maxExpiringTenantsShownCount;
        data["maxRecentTenantsShownCount"] = this.maxRecentTenantsShownCount;
        data["subscriptionEndAlertDayCount"] = this.subscriptionEndAlertDayCount;
        data["recentTenantsDayCount"] = this.recentTenantsDayCount;
        data["subscriptionEndDateStart"] = this.subscriptionEndDateStart ? this.subscriptionEndDateStart.toISOString() : <any>undefined;
        data["subscriptionEndDateEnd"] = this.subscriptionEndDateEnd ? this.subscriptionEndDateEnd.toISOString() : <any>undefined;
        data["tenantCreationStartDate"] = this.tenantCreationStartDate ? this.tenantCreationStartDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IHostDashboardData {
    newTenantsCount: number;
    newSubscriptionAmount: number;
    dashboardPlaceholder1: number;
    dashboardPlaceholder2: number;
    incomeStatistics: IncomeStastistic[] | undefined;
    editionStatistics: TenantEdition[] | undefined;
    expiringTenants: ExpiringTenant[] | undefined;
    recentTenants: RecentTenant[] | undefined;
    maxExpiringTenantsShownCount: number;
    maxRecentTenantsShownCount: number;
    subscriptionEndAlertDayCount: number;
    recentTenantsDayCount: number;
    subscriptionEndDateStart: moment.Moment;
    subscriptionEndDateEnd: moment.Moment;
    tenantCreationStartDate: moment.Moment;
}

export class GetIncomeStatisticsDataOutput implements IGetIncomeStatisticsDataOutput {
    incomeStatistics!: IncomeStastistic[] | undefined;

    constructor(data?: IGetIncomeStatisticsDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["incomeStatistics"])) {
                this.incomeStatistics = [] as any;
                for (let item of _data["incomeStatistics"])
                    this.incomeStatistics!.push(IncomeStastistic.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetIncomeStatisticsDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetIncomeStatisticsDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.incomeStatistics)) {
            data["incomeStatistics"] = [];
            for (let item of this.incomeStatistics)
                data["incomeStatistics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetIncomeStatisticsDataOutput {
    incomeStatistics: IncomeStastistic[] | undefined;
}

export class GetEditionTenantStatisticsOutput implements IGetEditionTenantStatisticsOutput {
    editionStatistics!: TenantEdition[] | undefined;

    constructor(data?: IGetEditionTenantStatisticsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["editionStatistics"])) {
                this.editionStatistics = [] as any;
                for (let item of _data["editionStatistics"])
                    this.editionStatistics!.push(TenantEdition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionTenantStatisticsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditionTenantStatisticsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.editionStatistics)) {
            data["editionStatistics"] = [];
            for (let item of this.editionStatistics)
                data["editionStatistics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEditionTenantStatisticsOutput {
    editionStatistics: TenantEdition[] | undefined;
}

export class GeneralSettingsEditDto implements IGeneralSettingsEditDto {
    timezone!: string | undefined;
    timezoneForComparison!: string | undefined;

    constructor(data?: IGeneralSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timezone = _data["timezone"];
            this.timezoneForComparison = _data["timezoneForComparison"];
        }
    }

    static fromJS(data: any): GeneralSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timezone"] = this.timezone;
        data["timezoneForComparison"] = this.timezoneForComparison;
        return data;
    }
}

export interface IGeneralSettingsEditDto {
    timezone: string | undefined;
    timezoneForComparison: string | undefined;
}

export class HostUserManagementSettingsEditDto implements IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin!: boolean;
    smsVerificationEnabled!: boolean;
    isCookieConsentEnabled!: boolean;
    isQuickThemeSelectEnabled!: boolean;

    constructor(data?: IHostUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEmailConfirmationRequiredForLogin = _data["isEmailConfirmationRequiredForLogin"];
            this.smsVerificationEnabled = _data["smsVerificationEnabled"];
            this.isCookieConsentEnabled = _data["isCookieConsentEnabled"];
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
        }
    }

    static fromJS(data: any): HostUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["smsVerificationEnabled"] = this.smsVerificationEnabled;
        data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        return data;
    }
}

export interface IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin: boolean;
    smsVerificationEnabled: boolean;
    isCookieConsentEnabled: boolean;
    isQuickThemeSelectEnabled: boolean;
}

export class EmailSettingsEditDto implements IEmailSettingsEditDto {
    defaultFromAddress!: string | undefined;
    defaultFromDisplayName!: string | undefined;
    smtpHost!: string | undefined;
    smtpPort!: number;
    smtpUserName!: string | undefined;
    smtpPassword!: string | undefined;
    smtpDomain!: string | undefined;
    smtpEnableSsl!: boolean;
    smtpUseDefaultCredentials!: boolean;

    constructor(data?: IEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultFromAddress = _data["defaultFromAddress"];
            this.defaultFromDisplayName = _data["defaultFromDisplayName"];
            this.smtpHost = _data["smtpHost"];
            this.smtpPort = _data["smtpPort"];
            this.smtpUserName = _data["smtpUserName"];
            this.smtpPassword = _data["smtpPassword"];
            this.smtpDomain = _data["smtpDomain"];
            this.smtpEnableSsl = _data["smtpEnableSsl"];
            this.smtpUseDefaultCredentials = _data["smtpUseDefaultCredentials"];
        }
    }

    static fromJS(data: any): EmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        return data;
    }
}

export interface IEmailSettingsEditDto {
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;
}

export class TenantManagementSettingsEditDto implements ITenantManagementSettingsEditDto {
    allowSelfRegistration!: boolean;
    isNewRegisteredTenantActiveByDefault!: boolean;
    useCaptchaOnRegistration!: boolean;
    defaultEditionId!: number | undefined;

    constructor(data?: ITenantManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowSelfRegistration = _data["allowSelfRegistration"];
            this.isNewRegisteredTenantActiveByDefault = _data["isNewRegisteredTenantActiveByDefault"];
            this.useCaptchaOnRegistration = _data["useCaptchaOnRegistration"];
            this.defaultEditionId = _data["defaultEditionId"];
        }
    }

    static fromJS(data: any): TenantManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredTenantActiveByDefault"] = this.isNewRegisteredTenantActiveByDefault;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["defaultEditionId"] = this.defaultEditionId;
        return data;
    }
}

export interface ITenantManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredTenantActiveByDefault: boolean;
    useCaptchaOnRegistration: boolean;
    defaultEditionId: number | undefined;
}

export class PasswordComplexitySetting implements IPasswordComplexitySetting {
    requireDigit!: boolean;
    requireLowercase!: boolean;
    requireNonAlphanumeric!: boolean;
    requireUppercase!: boolean;
    requiredLength!: number;

    constructor(data?: IPasswordComplexitySetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requireDigit = _data["requireDigit"];
            this.requireLowercase = _data["requireLowercase"];
            this.requireNonAlphanumeric = _data["requireNonAlphanumeric"];
            this.requireUppercase = _data["requireUppercase"];
            this.requiredLength = _data["requiredLength"];
        }
    }

    static fromJS(data: any): PasswordComplexitySetting {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordComplexitySetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requireDigit"] = this.requireDigit;
        data["requireLowercase"] = this.requireLowercase;
        data["requireNonAlphanumeric"] = this.requireNonAlphanumeric;
        data["requireUppercase"] = this.requireUppercase;
        data["requiredLength"] = this.requiredLength;
        return data;
    }
}

export interface IPasswordComplexitySetting {
    requireDigit: boolean;
    requireLowercase: boolean;
    requireNonAlphanumeric: boolean;
    requireUppercase: boolean;
    requiredLength: number;
}

export class UserLockOutSettingsEditDto implements IUserLockOutSettingsEditDto {
    isEnabled!: boolean;
    maxFailedAccessAttemptsBeforeLockout!: number;
    defaultAccountLockoutSeconds!: number;

    constructor(data?: IUserLockOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.maxFailedAccessAttemptsBeforeLockout = _data["maxFailedAccessAttemptsBeforeLockout"];
            this.defaultAccountLockoutSeconds = _data["defaultAccountLockoutSeconds"];
        }
    }

    static fromJS(data: any): UserLockOutSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLockOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["maxFailedAccessAttemptsBeforeLockout"] = this.maxFailedAccessAttemptsBeforeLockout;
        data["defaultAccountLockoutSeconds"] = this.defaultAccountLockoutSeconds;
        return data;
    }
}

export interface IUserLockOutSettingsEditDto {
    isEnabled: boolean;
    maxFailedAccessAttemptsBeforeLockout: number;
    defaultAccountLockoutSeconds: number;
}

export class TwoFactorLoginSettingsEditDto implements ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication!: boolean;
    isEnabled!: boolean;
    isEmailProviderEnabled!: boolean;
    isSmsProviderEnabled!: boolean;
    isRememberBrowserEnabled!: boolean;
    isGoogleAuthenticatorEnabled!: boolean;

    constructor(data?: ITwoFactorLoginSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabledForApplication = _data["isEnabledForApplication"];
            this.isEnabled = _data["isEnabled"];
            this.isEmailProviderEnabled = _data["isEmailProviderEnabled"];
            this.isSmsProviderEnabled = _data["isSmsProviderEnabled"];
            this.isRememberBrowserEnabled = _data["isRememberBrowserEnabled"];
            this.isGoogleAuthenticatorEnabled = _data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): TwoFactorLoginSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFactorLoginSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabledForApplication"] = this.isEnabledForApplication;
        data["isEnabled"] = this.isEnabled;
        data["isEmailProviderEnabled"] = this.isEmailProviderEnabled;
        data["isSmsProviderEnabled"] = this.isSmsProviderEnabled;
        data["isRememberBrowserEnabled"] = this.isRememberBrowserEnabled;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data;
    }
}

export interface ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication: boolean;
    isEnabled: boolean;
    isEmailProviderEnabled: boolean;
    isSmsProviderEnabled: boolean;
    isRememberBrowserEnabled: boolean;
    isGoogleAuthenticatorEnabled: boolean;
}

export class SecuritySettingsEditDto implements ISecuritySettingsEditDto {
    useDefaultPasswordComplexitySettings!: boolean;
    passwordComplexity!: PasswordComplexitySetting;
    defaultPasswordComplexity!: PasswordComplexitySetting;
    userLockOut!: UserLockOutSettingsEditDto;
    twoFactorLogin!: TwoFactorLoginSettingsEditDto;

    constructor(data?: ISecuritySettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.useDefaultPasswordComplexitySettings = _data["useDefaultPasswordComplexitySettings"];
            this.passwordComplexity = _data["passwordComplexity"] ? PasswordComplexitySetting.fromJS(_data["passwordComplexity"]) : <any>undefined;
            this.defaultPasswordComplexity = _data["defaultPasswordComplexity"] ? PasswordComplexitySetting.fromJS(_data["defaultPasswordComplexity"]) : <any>undefined;
            this.userLockOut = _data["userLockOut"] ? UserLockOutSettingsEditDto.fromJS(_data["userLockOut"]) : <any>undefined;
            this.twoFactorLogin = _data["twoFactorLogin"] ? TwoFactorLoginSettingsEditDto.fromJS(_data["twoFactorLogin"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SecuritySettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecuritySettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useDefaultPasswordComplexitySettings"] = this.useDefaultPasswordComplexitySettings;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
        data["defaultPasswordComplexity"] = this.defaultPasswordComplexity ? this.defaultPasswordComplexity.toJSON() : <any>undefined;
        data["userLockOut"] = this.userLockOut ? this.userLockOut.toJSON() : <any>undefined;
        data["twoFactorLogin"] = this.twoFactorLogin ? this.twoFactorLogin.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISecuritySettingsEditDto {
    useDefaultPasswordComplexitySettings: boolean;
    passwordComplexity: PasswordComplexitySetting;
    defaultPasswordComplexity: PasswordComplexitySetting;
    userLockOut: UserLockOutSettingsEditDto;
    twoFactorLogin: TwoFactorLoginSettingsEditDto;
}

export class HostBillingSettingsEditDto implements IHostBillingSettingsEditDto {
    legalName!: string | undefined;
    address!: string | undefined;

    constructor(data?: IHostBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalName = _data["legalName"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): HostBillingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        return data;
    }
}

export interface IHostBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
}

export class OtherSettingsEditDto implements IOtherSettingsEditDto {
    isQuickThemeSelectEnabled!: boolean;

    constructor(data?: IOtherSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
        }
    }

    static fromJS(data: any): OtherSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OtherSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        return data;
    }
}

export interface IOtherSettingsEditDto {
    isQuickThemeSelectEnabled: boolean;
}

export class HostSettingsEditDto implements IHostSettingsEditDto {
    general!: GeneralSettingsEditDto;
    userManagement!: HostUserManagementSettingsEditDto;
    email!: EmailSettingsEditDto;
    tenantManagement!: TenantManagementSettingsEditDto;
    security!: SecuritySettingsEditDto;
    billing!: HostBillingSettingsEditDto;
    otherSettings!: OtherSettingsEditDto;

    constructor(data?: IHostSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.general = new GeneralSettingsEditDto();
            this.userManagement = new HostUserManagementSettingsEditDto();
            this.email = new EmailSettingsEditDto();
            this.tenantManagement = new TenantManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneralSettingsEditDto.fromJS(_data["general"]) : new GeneralSettingsEditDto();
            this.userManagement = _data["userManagement"] ? HostUserManagementSettingsEditDto.fromJS(_data["userManagement"]) : new HostUserManagementSettingsEditDto();
            this.email = _data["email"] ? EmailSettingsEditDto.fromJS(_data["email"]) : new EmailSettingsEditDto();
            this.tenantManagement = _data["tenantManagement"] ? TenantManagementSettingsEditDto.fromJS(_data["tenantManagement"]) : new TenantManagementSettingsEditDto();
            this.security = _data["security"] ? SecuritySettingsEditDto.fromJS(_data["security"]) : new SecuritySettingsEditDto();
            this.billing = _data["billing"] ? HostBillingSettingsEditDto.fromJS(_data["billing"]) : <any>undefined;
            this.otherSettings = _data["otherSettings"] ? OtherSettingsEditDto.fromJS(_data["otherSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HostSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["tenantManagement"] = this.tenantManagement ? this.tenantManagement.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        data["otherSettings"] = this.otherSettings ? this.otherSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHostSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: HostUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    tenantManagement: TenantManagementSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: HostBillingSettingsEditDto;
    otherSettings: OtherSettingsEditDto;
}

export class SendTestEmailInput implements ISendTestEmailInput {
    emailAddress!: string;

    constructor(data?: ISendTestEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendTestEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendTestEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendTestEmailInput {
    emailAddress: string;
}

export enum DataFormat {
    Numeric = 1,
    Percentage = 2,
    Text = 3,
}

export class Column implements IColumn {
    fieldName!: string | undefined;
    displayName!: string | undefined;
    format!: DataFormat;

    constructor(data?: IColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldName = _data["fieldName"];
            this.displayName = _data["displayName"];
            this.format = _data["format"];
        }
    }

    static fromJS(data: any): Column {
        data = typeof data === 'object' ? data : {};
        let result = new Column();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldName"] = this.fieldName;
        data["displayName"] = this.displayName;
        data["format"] = this.format;
        return data;
    }
}

export interface IColumn {
    fieldName: string | undefined;
    displayName: string | undefined;
    format: DataFormat;
}

export class AdvanceRequestsTable implements IAdvanceRequestsTable {
    empCode!: string | undefined;
    employee!: string | undefined;
    advanceType!: string | undefined;
    amount!: number;
    noOfEmi!: number;
    advanceRequireDate!: string | undefined;
    advanceRequestDate!: string | undefined;

    constructor(data?: IAdvanceRequestsTable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empCode = _data["empCode"];
            this.employee = _data["employee"];
            this.advanceType = _data["advanceType"];
            this.amount = _data["amount"];
            this.noOfEmi = _data["noOfEmi"];
            this.advanceRequireDate = _data["advanceRequireDate"];
            this.advanceRequestDate = _data["advanceRequestDate"];
        }
    }

    static fromJS(data: any): AdvanceRequestsTable {
        data = typeof data === 'object' ? data : {};
        let result = new AdvanceRequestsTable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empCode"] = this.empCode;
        data["employee"] = this.employee;
        data["advanceType"] = this.advanceType;
        data["amount"] = this.amount;
        data["noOfEmi"] = this.noOfEmi;
        data["advanceRequireDate"] = this.advanceRequireDate;
        data["advanceRequestDate"] = this.advanceRequestDate;
        return data;
    }
}

export interface IAdvanceRequestsTable {
    empCode: string | undefined;
    employee: string | undefined;
    advanceType: string | undefined;
    amount: number;
    noOfEmi: number;
    advanceRequireDate: string | undefined;
    advanceRequestDate: string | undefined;
}

export class TabularReportOfAdvanceRequestsTable implements ITabularReportOfAdvanceRequestsTable {
    columns!: Column[] | undefined;
    data!: AdvanceRequestsTable[] | undefined;
    name!: string | undefined;
    description!: string | undefined;

    constructor(data?: ITabularReportOfAdvanceRequestsTable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(Column.fromJS(item));
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AdvanceRequestsTable.fromJS(item));
            }
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TabularReportOfAdvanceRequestsTable {
        data = typeof data === 'object' ? data : {};
        let result = new TabularReportOfAdvanceRequestsTable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface ITabularReportOfAdvanceRequestsTable {
    columns: Column[] | undefined;
    data: AdvanceRequestsTable[] | undefined;
    name: string | undefined;
    description: string | undefined;
}

export class PFForm12A implements IPFForm12A {
    empOnCont!: number;
    empOnRegular!: number;
    newJoinee!: number;
    lastMthEmp!: number;
    pF_Rate!: number;
    nofEmp!: number;
    wages!: number;
    contEmp!: number;
    contEmployr!: number;
    tenantName!: string | undefined;
    bankName!: string | undefined;
    chequeNo!: string | undefined;
    depositDate!: string | undefined;

    constructor(data?: IPFForm12A) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empOnCont = _data["empOnCont"];
            this.empOnRegular = _data["empOnRegular"];
            this.newJoinee = _data["newJoinee"];
            this.lastMthEmp = _data["lastMthEmp"];
            this.pF_Rate = _data["pF_Rate"];
            this.nofEmp = _data["nofEmp"];
            this.wages = _data["wages"];
            this.contEmp = _data["contEmp"];
            this.contEmployr = _data["contEmployr"];
            this.tenantName = _data["tenantName"];
            this.bankName = _data["bankName"];
            this.chequeNo = _data["chequeNo"];
            this.depositDate = _data["depositDate"];
        }
    }

    static fromJS(data: any): PFForm12A {
        data = typeof data === 'object' ? data : {};
        let result = new PFForm12A();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empOnCont"] = this.empOnCont;
        data["empOnRegular"] = this.empOnRegular;
        data["newJoinee"] = this.newJoinee;
        data["lastMthEmp"] = this.lastMthEmp;
        data["pF_Rate"] = this.pF_Rate;
        data["nofEmp"] = this.nofEmp;
        data["wages"] = this.wages;
        data["contEmp"] = this.contEmp;
        data["contEmployr"] = this.contEmployr;
        data["tenantName"] = this.tenantName;
        data["bankName"] = this.bankName;
        data["chequeNo"] = this.chequeNo;
        data["depositDate"] = this.depositDate;
        return data;
    }
}

export interface IPFForm12A {
    empOnCont: number;
    empOnRegular: number;
    newJoinee: number;
    lastMthEmp: number;
    pF_Rate: number;
    nofEmp: number;
    wages: number;
    contEmp: number;
    contEmployr: number;
    tenantName: string | undefined;
    bankName: string | undefined;
    chequeNo: string | undefined;
    depositDate: string | undefined;
}

export class MonthlyPFChallan implements IMonthlyPFChallan {
    tenantName!: string | undefined;
    bankName!: string | undefined;
    nofEmp!: number;
    wages!: number;
    contEmp!: number;
    contEmployr!: number;
    chequeNo!: string | undefined;
    depositDate!: string | undefined;
    paymentType!: string | undefined;
    monthYrName!: string | undefined;

    constructor(data?: IMonthlyPFChallan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantName = _data["tenantName"];
            this.bankName = _data["bankName"];
            this.nofEmp = _data["nofEmp"];
            this.wages = _data["wages"];
            this.contEmp = _data["contEmp"];
            this.contEmployr = _data["contEmployr"];
            this.chequeNo = _data["chequeNo"];
            this.depositDate = _data["depositDate"];
            this.paymentType = _data["paymentType"];
            this.monthYrName = _data["monthYrName"];
        }
    }

    static fromJS(data: any): MonthlyPFChallan {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyPFChallan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["bankName"] = this.bankName;
        data["nofEmp"] = this.nofEmp;
        data["wages"] = this.wages;
        data["contEmp"] = this.contEmp;
        data["contEmployr"] = this.contEmployr;
        data["chequeNo"] = this.chequeNo;
        data["depositDate"] = this.depositDate;
        data["paymentType"] = this.paymentType;
        data["monthYrName"] = this.monthYrName;
        return data;
    }
}

export interface IMonthlyPFChallan {
    tenantName: string | undefined;
    bankName: string | undefined;
    nofEmp: number;
    wages: number;
    contEmp: number;
    contEmployr: number;
    chequeNo: string | undefined;
    depositDate: string | undefined;
    paymentType: string | undefined;
    monthYrName: string | undefined;
}

export class GetPunchSummaryParameterDto implements IGetPunchSummaryParameterDto {
    fromDate!: moment.Moment;
    toDate!: moment.Moment;
    employeeIds!: number[] | undefined;
    locationIds!: number[] | undefined;
    departmentIds!: number[] | undefined;
    modes!: string[] | undefined;
    isPunchProcess!: boolean;

    constructor(data?: IGetPunchSummaryParameterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["employeeIds"])) {
                this.employeeIds = [] as any;
                for (let item of _data["employeeIds"])
                    this.employeeIds!.push(item);
            }
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            if (Array.isArray(_data["departmentIds"])) {
                this.departmentIds = [] as any;
                for (let item of _data["departmentIds"])
                    this.departmentIds!.push(item);
            }
            if (Array.isArray(_data["modes"])) {
                this.modes = [] as any;
                for (let item of _data["modes"])
                    this.modes!.push(item);
            }
            this.isPunchProcess = _data["isPunchProcess"];
        }
    }

    static fromJS(data: any): GetPunchSummaryParameterDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPunchSummaryParameterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        if (Array.isArray(this.employeeIds)) {
            data["employeeIds"] = [];
            for (let item of this.employeeIds)
                data["employeeIds"].push(item);
        }
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        if (Array.isArray(this.departmentIds)) {
            data["departmentIds"] = [];
            for (let item of this.departmentIds)
                data["departmentIds"].push(item);
        }
        if (Array.isArray(this.modes)) {
            data["modes"] = [];
            for (let item of this.modes)
                data["modes"].push(item);
        }
        data["isPunchProcess"] = this.isPunchProcess;
        return data;
    }
}

export interface IGetPunchSummaryParameterDto {
    fromDate: moment.Moment;
    toDate: moment.Moment;
    employeeIds: number[] | undefined;
    locationIds: number[] | undefined;
    departmentIds: number[] | undefined;
    modes: string[] | undefined;
    isPunchProcess: boolean;
}

export class ClumnRowDataLeave implements IClumnRowDataLeave {
    columns!: ColumnValue[] | undefined;
    rows!: RowValueList[] | undefined;
    employeeName!: string | undefined;
    employeeCode!: string | undefined;
    openingBalance!: number;
    totalRecordS!: number;

    constructor(data?: IClumnRowDataLeave) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(ColumnValue.fromJS(item));
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(RowValueList.fromJS(item));
            }
            this.employeeName = _data["employeeName"];
            this.employeeCode = _data["employeeCode"];
            this.openingBalance = _data["openingBalance"];
            this.totalRecordS = _data["totalRecordS"];
        }
    }

    static fromJS(data: any): ClumnRowDataLeave {
        data = typeof data === 'object' ? data : {};
        let result = new ClumnRowDataLeave();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["employeeName"] = this.employeeName;
        data["employeeCode"] = this.employeeCode;
        data["openingBalance"] = this.openingBalance;
        data["totalRecordS"] = this.totalRecordS;
        return data;
    }
}

export interface IClumnRowDataLeave {
    columns: ColumnValue[] | undefined;
    rows: RowValueList[] | undefined;
    employeeName: string | undefined;
    employeeCode: string | undefined;
    openingBalance: number;
    totalRecordS: number;
}

export class EmployeeDailySummary implements IEmployeeDailySummary {
    tenancyName!: string | undefined;
    shiftName!: string | undefined;
    date!: string | undefined;
    totalEmployeeCount!: number;
    totalBioMetricPunches!: number;
    totalEmployeePunches!: number;
    totalCompleteAttendance!: number;
    totalInCompleteAttendance!: number;
    totalAbsentEmployee!: number;
    totalLeave!: number;
    totalWeeklyOff!: number;
    totalHoliday!: number;
    total!: number;
    currentDayApprovalPending!: number;
    threeDayPendingApproval!: number;
    tenDaysPendingApproval!: number;

    constructor(data?: IEmployeeDailySummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.shiftName = _data["shiftName"];
            this.date = _data["date"];
            this.totalEmployeeCount = _data["totalEmployeeCount"];
            this.totalBioMetricPunches = _data["totalBioMetricPunches"];
            this.totalEmployeePunches = _data["totalEmployeePunches"];
            this.totalCompleteAttendance = _data["totalCompleteAttendance"];
            this.totalInCompleteAttendance = _data["totalInCompleteAttendance"];
            this.totalAbsentEmployee = _data["totalAbsentEmployee"];
            this.totalLeave = _data["totalLeave"];
            this.totalWeeklyOff = _data["totalWeeklyOff"];
            this.totalHoliday = _data["totalHoliday"];
            this.total = _data["total"];
            this.currentDayApprovalPending = _data["currentDayApprovalPending"];
            this.threeDayPendingApproval = _data["threeDayPendingApproval"];
            this.tenDaysPendingApproval = _data["tenDaysPendingApproval"];
        }
    }

    static fromJS(data: any): EmployeeDailySummary {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDailySummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["shiftName"] = this.shiftName;
        data["date"] = this.date;
        data["totalEmployeeCount"] = this.totalEmployeeCount;
        data["totalBioMetricPunches"] = this.totalBioMetricPunches;
        data["totalEmployeePunches"] = this.totalEmployeePunches;
        data["totalCompleteAttendance"] = this.totalCompleteAttendance;
        data["totalInCompleteAttendance"] = this.totalInCompleteAttendance;
        data["totalAbsentEmployee"] = this.totalAbsentEmployee;
        data["totalLeave"] = this.totalLeave;
        data["totalWeeklyOff"] = this.totalWeeklyOff;
        data["totalHoliday"] = this.totalHoliday;
        data["total"] = this.total;
        data["currentDayApprovalPending"] = this.currentDayApprovalPending;
        data["threeDayPendingApproval"] = this.threeDayPendingApproval;
        data["tenDaysPendingApproval"] = this.tenDaysPendingApproval;
        return data;
    }
}

export interface IEmployeeDailySummary {
    tenancyName: string | undefined;
    shiftName: string | undefined;
    date: string | undefined;
    totalEmployeeCount: number;
    totalBioMetricPunches: number;
    totalEmployeePunches: number;
    totalCompleteAttendance: number;
    totalInCompleteAttendance: number;
    totalAbsentEmployee: number;
    totalLeave: number;
    totalWeeklyOff: number;
    totalHoliday: number;
    total: number;
    currentDayApprovalPending: number;
    threeDayPendingApproval: number;
    tenDaysPendingApproval: number;
}

export class AttendanceDetailDTO implements IAttendanceDetailDTO {
    date!: string | undefined;
    attendanceStatus!: string | undefined;
    in1!: string | undefined;
    out1!: string | undefined;

    constructor(data?: IAttendanceDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.attendanceStatus = _data["attendanceStatus"];
            this.in1 = _data["in1"];
            this.out1 = _data["out1"];
        }
    }

    static fromJS(data: any): AttendanceDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["attendanceStatus"] = this.attendanceStatus;
        data["in1"] = this.in1;
        data["out1"] = this.out1;
        return data;
    }
}

export interface IAttendanceDetailDTO {
    date: string | undefined;
    attendanceStatus: string | undefined;
    in1: string | undefined;
    out1: string | undefined;
}

export class AttendanceSummaryDTO implements IAttendanceSummaryDTO {
    employeeName!: string | undefined;
    employeeCode!: string | undefined;
    biometricId!: string | undefined;
    branch!: string | undefined;
    department!: string | undefined;
    designation!: string | undefined;
    attendanceDetails!: AttendanceDetailDTO[] | undefined;
    present!: number;
    paidLeaves!: number;
    unpaidLeaves!: number;
    weekoff!: number;
    holidays!: number;
    extraWork!: number;
    absent!: number;
    leaveWithoutPay!: number;
    lop!: number;
    monthDays!: number;

    constructor(data?: IAttendanceSummaryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeName = _data["employeeName"];
            this.employeeCode = _data["employeeCode"];
            this.biometricId = _data["biometricId"];
            this.branch = _data["branch"];
            this.department = _data["department"];
            this.designation = _data["designation"];
            if (Array.isArray(_data["attendanceDetails"])) {
                this.attendanceDetails = [] as any;
                for (let item of _data["attendanceDetails"])
                    this.attendanceDetails!.push(AttendanceDetailDTO.fromJS(item));
            }
            this.present = _data["present"];
            this.paidLeaves = _data["paidLeaves"];
            this.unpaidLeaves = _data["unpaidLeaves"];
            this.weekoff = _data["weekoff"];
            this.holidays = _data["holidays"];
            this.extraWork = _data["extraWork"];
            this.absent = _data["absent"];
            this.leaveWithoutPay = _data["leaveWithoutPay"];
            this.lop = _data["lop"];
            this.monthDays = _data["monthDays"];
        }
    }

    static fromJS(data: any): AttendanceSummaryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceSummaryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeName"] = this.employeeName;
        data["employeeCode"] = this.employeeCode;
        data["biometricId"] = this.biometricId;
        data["branch"] = this.branch;
        data["department"] = this.department;
        data["designation"] = this.designation;
        if (Array.isArray(this.attendanceDetails)) {
            data["attendanceDetails"] = [];
            for (let item of this.attendanceDetails)
                data["attendanceDetails"].push(item.toJSON());
        }
        data["present"] = this.present;
        data["paidLeaves"] = this.paidLeaves;
        data["unpaidLeaves"] = this.unpaidLeaves;
        data["weekoff"] = this.weekoff;
        data["holidays"] = this.holidays;
        data["extraWork"] = this.extraWork;
        data["absent"] = this.absent;
        data["leaveWithoutPay"] = this.leaveWithoutPay;
        data["lop"] = this.lop;
        data["monthDays"] = this.monthDays;
        return data;
    }
}

export interface IAttendanceSummaryDTO {
    employeeName: string | undefined;
    employeeCode: string | undefined;
    biometricId: string | undefined;
    branch: string | undefined;
    department: string | undefined;
    designation: string | undefined;
    attendanceDetails: AttendanceDetailDTO[] | undefined;
    present: number;
    paidLeaves: number;
    unpaidLeaves: number;
    weekoff: number;
    holidays: number;
    extraWork: number;
    absent: number;
    leaveWithoutPay: number;
    lop: number;
    monthDays: number;
}

export class GetRequestPendingParameterDto implements IGetRequestPendingParameterDto {
    fromDate!: moment.Moment;
    toDate!: moment.Moment;
    employeeIds!: number[] | undefined;
    locationIds!: number[] | undefined;
    departmentIds!: number[] | undefined;
    requestDate!: moment.Moment;

    constructor(data?: IGetRequestPendingParameterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["employeeIds"])) {
                this.employeeIds = [] as any;
                for (let item of _data["employeeIds"])
                    this.employeeIds!.push(item);
            }
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            if (Array.isArray(_data["departmentIds"])) {
                this.departmentIds = [] as any;
                for (let item of _data["departmentIds"])
                    this.departmentIds!.push(item);
            }
            this.requestDate = _data["requestDate"] ? moment(_data["requestDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRequestPendingParameterDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRequestPendingParameterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        if (Array.isArray(this.employeeIds)) {
            data["employeeIds"] = [];
            for (let item of this.employeeIds)
                data["employeeIds"].push(item);
        }
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        if (Array.isArray(this.departmentIds)) {
            data["departmentIds"] = [];
            for (let item of this.departmentIds)
                data["departmentIds"].push(item);
        }
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetRequestPendingParameterDto {
    fromDate: moment.Moment;
    toDate: moment.Moment;
    employeeIds: number[] | undefined;
    locationIds: number[] | undefined;
    departmentIds: number[] | undefined;
    requestDate: moment.Moment;
}

export class GetLeaveRegisterReport implements IGetLeaveRegisterReport {
    fromDate!: moment.Moment;
    toDate!: moment.Moment;
    employeeIds!: number[] | undefined;
    locationIds!: number[] | undefined;
    departmentIds!: number[] | undefined;

    constructor(data?: IGetLeaveRegisterReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["employeeIds"])) {
                this.employeeIds = [] as any;
                for (let item of _data["employeeIds"])
                    this.employeeIds!.push(item);
            }
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            if (Array.isArray(_data["departmentIds"])) {
                this.departmentIds = [] as any;
                for (let item of _data["departmentIds"])
                    this.departmentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetLeaveRegisterReport {
        data = typeof data === 'object' ? data : {};
        let result = new GetLeaveRegisterReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        if (Array.isArray(this.employeeIds)) {
            data["employeeIds"] = [];
            for (let item of this.employeeIds)
                data["employeeIds"].push(item);
        }
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        if (Array.isArray(this.departmentIds)) {
            data["departmentIds"] = [];
            for (let item of this.departmentIds)
                data["departmentIds"].push(item);
        }
        return data;
    }
}

export interface IGetLeaveRegisterReport {
    fromDate: moment.Moment;
    toDate: moment.Moment;
    employeeIds: number[] | undefined;
    locationIds: number[] | undefined;
    departmentIds: number[] | undefined;
}

export class GetYearlyLeaveReport implements IGetYearlyLeaveReport {
    showNegativeAllowedLeaves!: boolean;
    fromYear!: string | undefined;
    toYear!: string | undefined;
    employeeIds!: number[] | undefined;
    locationIds!: number[] | undefined;
    sortingPreference!: number;

    constructor(data?: IGetYearlyLeaveReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.showNegativeAllowedLeaves = _data["showNegativeAllowedLeaves"];
            this.fromYear = _data["fromYear"];
            this.toYear = _data["toYear"];
            if (Array.isArray(_data["employeeIds"])) {
                this.employeeIds = [] as any;
                for (let item of _data["employeeIds"])
                    this.employeeIds!.push(item);
            }
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            this.sortingPreference = _data["sortingPreference"];
        }
    }

    static fromJS(data: any): GetYearlyLeaveReport {
        data = typeof data === 'object' ? data : {};
        let result = new GetYearlyLeaveReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showNegativeAllowedLeaves"] = this.showNegativeAllowedLeaves;
        data["fromYear"] = this.fromYear;
        data["toYear"] = this.toYear;
        if (Array.isArray(this.employeeIds)) {
            data["employeeIds"] = [];
            for (let item of this.employeeIds)
                data["employeeIds"].push(item);
        }
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        data["sortingPreference"] = this.sortingPreference;
        return data;
    }
}

export interface IGetYearlyLeaveReport {
    showNegativeAllowedLeaves: boolean;
    fromYear: string | undefined;
    toYear: string | undefined;
    employeeIds: number[] | undefined;
    locationIds: number[] | undefined;
    sortingPreference: number;
}

export class GetMonthlyLeaveReport implements IGetMonthlyLeaveReport {
    showNegativeAllowedLeaves!: boolean;
    fromMonth!: number;
    toMonth!: number;
    year!: number;
    employeeIds!: number[] | undefined;
    locationIds!: number[] | undefined;
    sortingPreference!: number;

    constructor(data?: IGetMonthlyLeaveReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.showNegativeAllowedLeaves = _data["showNegativeAllowedLeaves"];
            this.fromMonth = _data["fromMonth"];
            this.toMonth = _data["toMonth"];
            this.year = _data["year"];
            if (Array.isArray(_data["employeeIds"])) {
                this.employeeIds = [] as any;
                for (let item of _data["employeeIds"])
                    this.employeeIds!.push(item);
            }
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            this.sortingPreference = _data["sortingPreference"];
        }
    }

    static fromJS(data: any): GetMonthlyLeaveReport {
        data = typeof data === 'object' ? data : {};
        let result = new GetMonthlyLeaveReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showNegativeAllowedLeaves"] = this.showNegativeAllowedLeaves;
        data["fromMonth"] = this.fromMonth;
        data["toMonth"] = this.toMonth;
        data["year"] = this.year;
        if (Array.isArray(this.employeeIds)) {
            data["employeeIds"] = [];
            for (let item of this.employeeIds)
                data["employeeIds"].push(item);
        }
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        data["sortingPreference"] = this.sortingPreference;
        return data;
    }
}

export interface IGetMonthlyLeaveReport {
    showNegativeAllowedLeaves: boolean;
    fromMonth: number;
    toMonth: number;
    year: number;
    employeeIds: number[] | undefined;
    locationIds: number[] | undefined;
    sortingPreference: number;
}

export class PunchReportDto implements IPunchReportDto {
    employeeCode!: string | undefined;
    punchId!: number;
    name!: string | undefined;
    biometricId!: string | undefined;
    mode!: string | undefined;
    shiftId!: number | undefined;
    punchDate!: string | undefined;
    punchTime!: string | undefined;
    branch!: string | undefined;
    department!: string | undefined;
    attendanceDate!: moment.Moment | undefined;
    formattedDate!: string | undefined;
    inOut!: string | undefined;

    constructor(data?: IPunchReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeCode = _data["employeeCode"];
            this.punchId = _data["punchId"];
            this.name = _data["name"];
            this.biometricId = _data["biometricId"];
            this.mode = _data["mode"];
            this.shiftId = _data["shiftId"];
            this.punchDate = _data["punchDate"];
            this.punchTime = _data["punchTime"];
            this.branch = _data["branch"];
            this.department = _data["department"];
            this.attendanceDate = _data["attendanceDate"] ? moment(_data["attendanceDate"].toString()) : <any>undefined;
            this.formattedDate = _data["formattedDate"];
            this.inOut = _data["inOut"];
        }
    }

    static fromJS(data: any): PunchReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new PunchReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeCode"] = this.employeeCode;
        data["punchId"] = this.punchId;
        data["name"] = this.name;
        data["biometricId"] = this.biometricId;
        data["mode"] = this.mode;
        data["shiftId"] = this.shiftId;
        data["punchDate"] = this.punchDate;
        data["punchTime"] = this.punchTime;
        data["branch"] = this.branch;
        data["department"] = this.department;
        data["attendanceDate"] = this.attendanceDate ? this.attendanceDate.toISOString() : <any>undefined;
        data["formattedDate"] = this.formattedDate;
        data["inOut"] = this.inOut;
        return data;
    }
}

export interface IPunchReportDto {
    employeeCode: string | undefined;
    punchId: number;
    name: string | undefined;
    biometricId: string | undefined;
    mode: string | undefined;
    shiftId: number | undefined;
    punchDate: string | undefined;
    punchTime: string | undefined;
    branch: string | undefined;
    department: string | undefined;
    attendanceDate: moment.Moment | undefined;
    formattedDate: string | undefined;
    inOut: string | undefined;
}

export class ClumnRow implements IClumnRow {
    columns!: any[] | undefined;
    rows!: any[] | undefined;
    totalRecordS!: number;

    constructor(data?: IClumnRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(item);
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(item);
            }
            this.totalRecordS = _data["totalRecordS"];
        }
    }

    static fromJS(data: any): ClumnRow {
        data = typeof data === 'object' ? data : {};
        let result = new ClumnRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item);
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item);
        }
        data["totalRecordS"] = this.totalRecordS;
        return data;
    }
}

export interface IClumnRow {
    columns: any[] | undefined;
    rows: any[] | undefined;
    totalRecordS: number;
}

export class MonthlyAttendanceDto implements IMonthlyAttendanceDto {
    monthName!: string | undefined;
    present!: number;
    absent!: number;
    weekoff!: number;
    holiday!: number;
    paidLeaves!: number;
    unpaidLeaves!: number;
    leaveWithoutPay!: number;
    extraWork!: number;
    lop!: number;
    totalDays!: number;

    constructor(data?: IMonthlyAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthName = _data["monthName"];
            this.present = _data["present"];
            this.absent = _data["absent"];
            this.weekoff = _data["weekoff"];
            this.holiday = _data["holiday"];
            this.paidLeaves = _data["paidLeaves"];
            this.unpaidLeaves = _data["unpaidLeaves"];
            this.leaveWithoutPay = _data["leaveWithoutPay"];
            this.extraWork = _data["extraWork"];
            this.lop = _data["lop"];
            this.totalDays = _data["totalDays"];
        }
    }

    static fromJS(data: any): MonthlyAttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyAttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthName"] = this.monthName;
        data["present"] = this.present;
        data["absent"] = this.absent;
        data["weekoff"] = this.weekoff;
        data["holiday"] = this.holiday;
        data["paidLeaves"] = this.paidLeaves;
        data["unpaidLeaves"] = this.unpaidLeaves;
        data["leaveWithoutPay"] = this.leaveWithoutPay;
        data["extraWork"] = this.extraWork;
        data["lop"] = this.lop;
        data["totalDays"] = this.totalDays;
        return data;
    }
}

export interface IMonthlyAttendanceDto {
    monthName: string | undefined;
    present: number;
    absent: number;
    weekoff: number;
    holiday: number;
    paidLeaves: number;
    unpaidLeaves: number;
    leaveWithoutPay: number;
    extraWork: number;
    lop: number;
    totalDays: number;
}

export class EmployeeAttendanceDto implements IEmployeeAttendanceDto {
    branch!: string | undefined;
    department!: string | undefined;
    employeeName!: string | undefined;
    employeeCode!: string | undefined;
    bioMetricId!: string | undefined;
    designation!: string | undefined;
    monthlyAttendance!: MonthlyAttendanceDto[] | undefined;

    constructor(data?: IEmployeeAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branch = _data["branch"];
            this.department = _data["department"];
            this.employeeName = _data["employeeName"];
            this.employeeCode = _data["employeeCode"];
            this.bioMetricId = _data["bioMetricId"];
            this.designation = _data["designation"];
            if (Array.isArray(_data["monthlyAttendance"])) {
                this.monthlyAttendance = [] as any;
                for (let item of _data["monthlyAttendance"])
                    this.monthlyAttendance!.push(MonthlyAttendanceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeeAttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeAttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branch"] = this.branch;
        data["department"] = this.department;
        data["employeeName"] = this.employeeName;
        data["employeeCode"] = this.employeeCode;
        data["bioMetricId"] = this.bioMetricId;
        data["designation"] = this.designation;
        if (Array.isArray(this.monthlyAttendance)) {
            data["monthlyAttendance"] = [];
            for (let item of this.monthlyAttendance)
                data["monthlyAttendance"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmployeeAttendanceDto {
    branch: string | undefined;
    department: string | undefined;
    employeeName: string | undefined;
    employeeCode: string | undefined;
    bioMetricId: string | undefined;
    designation: string | undefined;
    monthlyAttendance: MonthlyAttendanceDto[] | undefined;
}

export class EmployeeAttendanceReportDto implements IEmployeeAttendanceReportDto {
    employeeAttendanceList!: EmployeeAttendanceDto[] | undefined;

    constructor(data?: IEmployeeAttendanceReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employeeAttendanceList"])) {
                this.employeeAttendanceList = [] as any;
                for (let item of _data["employeeAttendanceList"])
                    this.employeeAttendanceList!.push(EmployeeAttendanceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeeAttendanceReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeAttendanceReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employeeAttendanceList)) {
            data["employeeAttendanceList"] = [];
            for (let item of this.employeeAttendanceList)
                data["employeeAttendanceList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmployeeAttendanceReportDto {
    employeeAttendanceList: EmployeeAttendanceDto[] | undefined;
}

export class ColumnDto implements IColumnDto {
    columnName!: string | undefined;
    format!: boolean;

    constructor(data?: IColumnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.columnName = _data["columnName"];
            this.format = _data["format"];
        }
    }

    static fromJS(data: any): ColumnDto {
        data = typeof data === 'object' ? data : {};
        let result = new ColumnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["columnName"] = this.columnName;
        data["format"] = this.format;
        return data;
    }
}

export interface IColumnDto {
    columnName: string | undefined;
    format: boolean;
}

export class RowValueDto implements IRowValueDto {
    rowValue!: string | undefined;
    format!: boolean;

    constructor(data?: IRowValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowValue = _data["rowValue"];
            this.format = _data["format"];
        }
    }

    static fromJS(data: any): RowValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new RowValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowValue"] = this.rowValue;
        data["format"] = this.format;
        return data;
    }
}

export interface IRowValueDto {
    rowValue: string | undefined;
    format: boolean;
}

export class RowDto implements IRowDto {
    rowvallist!: RowValueDto[] | undefined;

    constructor(data?: IRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rowvallist"])) {
                this.rowvallist = [] as any;
                for (let item of _data["rowvallist"])
                    this.rowvallist!.push(RowValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RowDto {
        data = typeof data === 'object' ? data : {};
        let result = new RowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rowvallist)) {
            data["rowvallist"] = [];
            for (let item of this.rowvallist)
                data["rowvallist"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRowDto {
    rowvallist: RowValueDto[] | undefined;
}

export class LeaveSummaryTransformedDto implements ILeaveSummaryTransformedDto {
    columns!: ColumnDto[] | undefined;
    rows!: RowDto[] | undefined;
    totalRecordS!: number;

    constructor(data?: ILeaveSummaryTransformedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(ColumnDto.fromJS(item));
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(RowDto.fromJS(item));
            }
            this.totalRecordS = _data["totalRecordS"];
        }
    }

    static fromJS(data: any): LeaveSummaryTransformedDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveSummaryTransformedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalRecordS"] = this.totalRecordS;
        return data;
    }
}

export interface ILeaveSummaryTransformedDto {
    columns: ColumnDto[] | undefined;
    rows: RowDto[] | undefined;
    totalRecordS: number;
}

export class OnDutyReport implements IOnDutyReport {
    fromDate!: moment.Moment;
    toDate!: moment.Moment;
    employeeIds!: number[] | undefined;
    locationIds!: number[] | undefined;
    onDutyTypeIds!: number[] | undefined;
    reportFlag!: number;
    sortingPreference!: number;

    constructor(data?: IOnDutyReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["employeeIds"])) {
                this.employeeIds = [] as any;
                for (let item of _data["employeeIds"])
                    this.employeeIds!.push(item);
            }
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            if (Array.isArray(_data["onDutyTypeIds"])) {
                this.onDutyTypeIds = [] as any;
                for (let item of _data["onDutyTypeIds"])
                    this.onDutyTypeIds!.push(item);
            }
            this.reportFlag = _data["reportFlag"];
            this.sortingPreference = _data["sortingPreference"];
        }
    }

    static fromJS(data: any): OnDutyReport {
        data = typeof data === 'object' ? data : {};
        let result = new OnDutyReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        if (Array.isArray(this.employeeIds)) {
            data["employeeIds"] = [];
            for (let item of this.employeeIds)
                data["employeeIds"].push(item);
        }
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        if (Array.isArray(this.onDutyTypeIds)) {
            data["onDutyTypeIds"] = [];
            for (let item of this.onDutyTypeIds)
                data["onDutyTypeIds"].push(item);
        }
        data["reportFlag"] = this.reportFlag;
        data["sortingPreference"] = this.sortingPreference;
        return data;
    }
}

export interface IOnDutyReport {
    fromDate: moment.Moment;
    toDate: moment.Moment;
    employeeIds: number[] | undefined;
    locationIds: number[] | undefined;
    onDutyTypeIds: number[] | undefined;
    reportFlag: number;
    sortingPreference: number;
}

export class ArrearReport implements IArrearReport {
    employeeIds!: number[] | undefined;
    locationIds!: number[] | undefined;
    departmentIds!: number[] | undefined;
    month!: string | undefined;
    year!: string | undefined;

    constructor(data?: IArrearReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employeeIds"])) {
                this.employeeIds = [] as any;
                for (let item of _data["employeeIds"])
                    this.employeeIds!.push(item);
            }
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            if (Array.isArray(_data["departmentIds"])) {
                this.departmentIds = [] as any;
                for (let item of _data["departmentIds"])
                    this.departmentIds!.push(item);
            }
            this.month = _data["month"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): ArrearReport {
        data = typeof data === 'object' ? data : {};
        let result = new ArrearReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employeeIds)) {
            data["employeeIds"] = [];
            for (let item of this.employeeIds)
                data["employeeIds"].push(item);
        }
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        if (Array.isArray(this.departmentIds)) {
            data["departmentIds"] = [];
            for (let item of this.departmentIds)
                data["departmentIds"].push(item);
        }
        data["month"] = this.month;
        data["year"] = this.year;
        return data;
    }
}

export interface IArrearReport {
    employeeIds: number[] | undefined;
    locationIds: number[] | undefined;
    departmentIds: number[] | undefined;
    month: string | undefined;
    year: string | undefined;
}

export class ClumnRowDatasetList implements IClumnRowDatasetList {
    columns!: ColumnValue[] | undefined;
    columns1!: ColumnValue[] | undefined;
    columns2!: ColumnValue[] | undefined;
    columns3!: ColumnValue[] | undefined;
    rows!: RowValueList[] | undefined;
    rows1!: RowValueList[] | undefined;
    rows2!: RowValueList[] | undefined;
    rows3!: RowValueList[] | undefined;
    totalRecordS!: number;
    partAMember!: string | undefined;
    partBMember!: string | undefined;
    partCMember!: string | undefined;

    constructor(data?: IClumnRowDatasetList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(ColumnValue.fromJS(item));
            }
            if (Array.isArray(_data["columns1"])) {
                this.columns1 = [] as any;
                for (let item of _data["columns1"])
                    this.columns1!.push(ColumnValue.fromJS(item));
            }
            if (Array.isArray(_data["columns2"])) {
                this.columns2 = [] as any;
                for (let item of _data["columns2"])
                    this.columns2!.push(ColumnValue.fromJS(item));
            }
            if (Array.isArray(_data["columns3"])) {
                this.columns3 = [] as any;
                for (let item of _data["columns3"])
                    this.columns3!.push(ColumnValue.fromJS(item));
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(RowValueList.fromJS(item));
            }
            if (Array.isArray(_data["rows1"])) {
                this.rows1 = [] as any;
                for (let item of _data["rows1"])
                    this.rows1!.push(RowValueList.fromJS(item));
            }
            if (Array.isArray(_data["rows2"])) {
                this.rows2 = [] as any;
                for (let item of _data["rows2"])
                    this.rows2!.push(RowValueList.fromJS(item));
            }
            if (Array.isArray(_data["rows3"])) {
                this.rows3 = [] as any;
                for (let item of _data["rows3"])
                    this.rows3!.push(RowValueList.fromJS(item));
            }
            this.totalRecordS = _data["totalRecordS"];
            this.partAMember = _data["partAMember"];
            this.partBMember = _data["partBMember"];
            this.partCMember = _data["partCMember"];
        }
    }

    static fromJS(data: any): ClumnRowDatasetList {
        data = typeof data === 'object' ? data : {};
        let result = new ClumnRowDatasetList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (Array.isArray(this.columns1)) {
            data["columns1"] = [];
            for (let item of this.columns1)
                data["columns1"].push(item.toJSON());
        }
        if (Array.isArray(this.columns2)) {
            data["columns2"] = [];
            for (let item of this.columns2)
                data["columns2"].push(item.toJSON());
        }
        if (Array.isArray(this.columns3)) {
            data["columns3"] = [];
            for (let item of this.columns3)
                data["columns3"].push(item.toJSON());
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        if (Array.isArray(this.rows1)) {
            data["rows1"] = [];
            for (let item of this.rows1)
                data["rows1"].push(item.toJSON());
        }
        if (Array.isArray(this.rows2)) {
            data["rows2"] = [];
            for (let item of this.rows2)
                data["rows2"].push(item.toJSON());
        }
        if (Array.isArray(this.rows3)) {
            data["rows3"] = [];
            for (let item of this.rows3)
                data["rows3"].push(item.toJSON());
        }
        data["totalRecordS"] = this.totalRecordS;
        data["partAMember"] = this.partAMember;
        data["partBMember"] = this.partBMember;
        data["partCMember"] = this.partCMember;
        return data;
    }
}

export interface IClumnRowDatasetList {
    columns: ColumnValue[] | undefined;
    columns1: ColumnValue[] | undefined;
    columns2: ColumnValue[] | undefined;
    columns3: ColumnValue[] | undefined;
    rows: RowValueList[] | undefined;
    rows1: RowValueList[] | undefined;
    rows2: RowValueList[] | undefined;
    rows3: RowValueList[] | undefined;
    totalRecordS: number;
    partAMember: string | undefined;
    partBMember: string | undefined;
    partCMember: string | undefined;
}

export class PFsunm implements IPFsunm {
    header!: string | undefined;
    count!: number;

    constructor(data?: IPFsunm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): PFsunm {
        data = typeof data === 'object' ? data : {};
        let result = new PFsunm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header;
        data["count"] = this.count;
        return data;
    }
}

export interface IPFsunm {
    header: string | undefined;
    count: number;
}

export class PFsunmSecon implements IPFsunmSecon {
    header!: string | undefined;
    employee!: string | undefined;

    constructor(data?: IPFsunmSecon) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"];
            this.employee = _data["employee"];
        }
    }

    static fromJS(data: any): PFsunmSecon {
        data = typeof data === 'object' ? data : {};
        let result = new PFsunmSecon();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header;
        data["employee"] = this.employee;
        return data;
    }
}

export interface IPFsunmSecon {
    header: string | undefined;
    employee: string | undefined;
}

export class PFsunmThrid implements IPFsunmThrid {
    header!: string | undefined;
    employee!: string | undefined;
    total!: string | undefined;

    constructor(data?: IPFsunmThrid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"];
            this.employee = _data["employee"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): PFsunmThrid {
        data = typeof data === 'object' ? data : {};
        let result = new PFsunmThrid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header;
        data["employee"] = this.employee;
        data["total"] = this.total;
        return data;
    }
}

export interface IPFsunmThrid {
    header: string | undefined;
    employee: string | undefined;
    total: string | undefined;
}

export class PfSummaryChart implements IPfSummaryChart {
    pFsunm!: PFsunm[] | undefined;
    pFsunmSecon!: PFsunmSecon[] | undefined;
    pFsunmThrid!: PFsunmThrid[] | undefined;

    constructor(data?: IPfSummaryChart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pFsunm"])) {
                this.pFsunm = [] as any;
                for (let item of _data["pFsunm"])
                    this.pFsunm!.push(PFsunm.fromJS(item));
            }
            if (Array.isArray(_data["pFsunmSecon"])) {
                this.pFsunmSecon = [] as any;
                for (let item of _data["pFsunmSecon"])
                    this.pFsunmSecon!.push(PFsunmSecon.fromJS(item));
            }
            if (Array.isArray(_data["pFsunmThrid"])) {
                this.pFsunmThrid = [] as any;
                for (let item of _data["pFsunmThrid"])
                    this.pFsunmThrid!.push(PFsunmThrid.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PfSummaryChart {
        data = typeof data === 'object' ? data : {};
        let result = new PfSummaryChart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pFsunm)) {
            data["pFsunm"] = [];
            for (let item of this.pFsunm)
                data["pFsunm"].push(item.toJSON());
        }
        if (Array.isArray(this.pFsunmSecon)) {
            data["pFsunmSecon"] = [];
            for (let item of this.pFsunmSecon)
                data["pFsunmSecon"].push(item.toJSON());
        }
        if (Array.isArray(this.pFsunmThrid)) {
            data["pFsunmThrid"] = [];
            for (let item of this.pFsunmThrid)
                data["pFsunmThrid"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPfSummaryChart {
    pFsunm: PFsunm[] | undefined;
    pFsunmSecon: PFsunmSecon[] | undefined;
    pFsunmThrid: PFsunmThrid[] | undefined;
}

export class ESIChartSummary implements IESIChartSummary {
    esIsunm!: PFsunm[] | undefined;

    constructor(data?: IESIChartSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["esIsunm"])) {
                this.esIsunm = [] as any;
                for (let item of _data["esIsunm"])
                    this.esIsunm!.push(PFsunm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ESIChartSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ESIChartSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.esIsunm)) {
            data["esIsunm"] = [];
            for (let item of this.esIsunm)
                data["esIsunm"].push(item.toJSON());
        }
        return data;
    }
}

export interface IESIChartSummary {
    esIsunm: PFsunm[] | undefined;
}

export class ClumnRowDataESI implements IClumnRowDataESI {
    columns!: ColumnValue[] | undefined;
    columns1!: ColumnValue[] | undefined;
    rows!: RowValueList[] | undefined;
    contributionPeriod!: string | undefined;
    totalRecordS!: number;

    constructor(data?: IClumnRowDataESI) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(ColumnValue.fromJS(item));
            }
            if (Array.isArray(_data["columns1"])) {
                this.columns1 = [] as any;
                for (let item of _data["columns1"])
                    this.columns1!.push(ColumnValue.fromJS(item));
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(RowValueList.fromJS(item));
            }
            this.contributionPeriod = _data["contributionPeriod"];
            this.totalRecordS = _data["totalRecordS"];
        }
    }

    static fromJS(data: any): ClumnRowDataESI {
        data = typeof data === 'object' ? data : {};
        let result = new ClumnRowDataESI();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (Array.isArray(this.columns1)) {
            data["columns1"] = [];
            for (let item of this.columns1)
                data["columns1"].push(item.toJSON());
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["contributionPeriod"] = this.contributionPeriod;
        data["totalRecordS"] = this.totalRecordS;
        return data;
    }
}

export interface IClumnRowDataESI {
    columns: ColumnValue[] | undefined;
    columns1: ColumnValue[] | undefined;
    rows: RowValueList[] | undefined;
    contributionPeriod: string | undefined;
    totalRecordS: number;
}

export class IncentiveDetailsDTO implements IIncentiveDetailsDTO {
    employeeId!: number;
    monthYear!: string | undefined;
    amount!: number;
    incentiveTypeId!: number;
    add_Deduct!: string | undefined;
    remarks!: string | undefined;
    id!: number;

    constructor(data?: IIncentiveDetailsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.monthYear = _data["monthYear"];
            this.amount = _data["amount"];
            this.incentiveTypeId = _data["incentiveTypeId"];
            this.add_Deduct = _data["add_Deduct"];
            this.remarks = _data["remarks"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): IncentiveDetailsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IncentiveDetailsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["monthYear"] = this.monthYear;
        data["amount"] = this.amount;
        data["incentiveTypeId"] = this.incentiveTypeId;
        data["add_Deduct"] = this.add_Deduct;
        data["remarks"] = this.remarks;
        data["id"] = this.id;
        return data;
    }
}

export interface IIncentiveDetailsDTO {
    employeeId: number;
    monthYear: string | undefined;
    amount: number;
    incentiveTypeId: number;
    add_Deduct: string | undefined;
    remarks: string | undefined;
    id: number;
}

export class GetIncentiveDetailsForViewDto implements IGetIncentiveDetailsForViewDto {
    incentiveDetails!: IncentiveDetailsDTO[] | undefined;
    employeeName!: string | undefined;
    employeeCode!: string | undefined;
    employeeId!: number;

    constructor(data?: IGetIncentiveDetailsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["incentiveDetails"])) {
                this.incentiveDetails = [] as any;
                for (let item of _data["incentiveDetails"])
                    this.incentiveDetails!.push(IncentiveDetailsDTO.fromJS(item));
            }
            this.employeeName = _data["employeeName"];
            this.employeeCode = _data["employeeCode"];
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): GetIncentiveDetailsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetIncentiveDetailsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.incentiveDetails)) {
            data["incentiveDetails"] = [];
            for (let item of this.incentiveDetails)
                data["incentiveDetails"].push(item.toJSON());
        }
        data["employeeName"] = this.employeeName;
        data["employeeCode"] = this.employeeCode;
        data["employeeId"] = this.employeeId;
        return data;
    }
}

export interface IGetIncentiveDetailsForViewDto {
    incentiveDetails: IncentiveDetailsDTO[] | undefined;
    employeeName: string | undefined;
    employeeCode: string | undefined;
    employeeId: number;
}

export class PagedResultDtoOfGetIncentiveDetailsForViewDto implements IPagedResultDtoOfGetIncentiveDetailsForViewDto {
    totalCount!: number;
    items!: GetIncentiveDetailsForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetIncentiveDetailsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetIncentiveDetailsForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetIncentiveDetailsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetIncentiveDetailsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetIncentiveDetailsForViewDto {
    totalCount: number;
    items: GetIncentiveDetailsForViewDto[] | undefined;
}

export class IncentiveTypeDTO implements IIncentiveTypeDTO {
    incentiveName!: string | undefined;
    type!: string | undefined;
    id!: number;

    constructor(data?: IIncentiveTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incentiveName = _data["incentiveName"];
            this.type = _data["type"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): IncentiveTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IncentiveTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incentiveName"] = this.incentiveName;
        data["type"] = this.type;
        data["id"] = this.id;
        return data;
    }
}

export interface IIncentiveTypeDTO {
    incentiveName: string | undefined;
    type: string | undefined;
    id: number;
}

export class IncentiveDetailsListDto implements IIncentiveDetailsListDto {
    incentiveDetailsForViewDtos!: GetIncentiveDetailsForViewDto[] | undefined;
    incentiveTypeDTOs!: IncentiveTypeDTO[] | undefined;
    totalCount!: number;

    constructor(data?: IIncentiveDetailsListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["incentiveDetailsForViewDtos"])) {
                this.incentiveDetailsForViewDtos = [] as any;
                for (let item of _data["incentiveDetailsForViewDtos"])
                    this.incentiveDetailsForViewDtos!.push(GetIncentiveDetailsForViewDto.fromJS(item));
            }
            if (Array.isArray(_data["incentiveTypeDTOs"])) {
                this.incentiveTypeDTOs = [] as any;
                for (let item of _data["incentiveTypeDTOs"])
                    this.incentiveTypeDTOs!.push(IncentiveTypeDTO.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): IncentiveDetailsListDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncentiveDetailsListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.incentiveDetailsForViewDtos)) {
            data["incentiveDetailsForViewDtos"] = [];
            for (let item of this.incentiveDetailsForViewDtos)
                data["incentiveDetailsForViewDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.incentiveTypeDTOs)) {
            data["incentiveTypeDTOs"] = [];
            for (let item of this.incentiveTypeDTOs)
                data["incentiveTypeDTOs"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IIncentiveDetailsListDto {
    incentiveDetailsForViewDtos: GetIncentiveDetailsForViewDto[] | undefined;
    incentiveTypeDTOs: IncentiveTypeDTO[] | undefined;
    totalCount: number;
}

export class GetIncentiveTypeForViewDto implements IGetIncentiveTypeForViewDto {
    incentiveType!: IncentiveTypeDTO;

    constructor(data?: IGetIncentiveTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incentiveType = _data["incentiveType"] ? IncentiveTypeDTO.fromJS(_data["incentiveType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetIncentiveTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetIncentiveTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incentiveType"] = this.incentiveType ? this.incentiveType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetIncentiveTypeForViewDto {
    incentiveType: IncentiveTypeDTO;
}

export class PagedResultDtoOfGetIncentiveTypeForViewDto implements IPagedResultDtoOfGetIncentiveTypeForViewDto {
    totalCount!: number;
    items!: GetIncentiveTypeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetIncentiveTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetIncentiveTypeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetIncentiveTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetIncentiveTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetIncentiveTypeForViewDto {
    totalCount: number;
    items: GetIncentiveTypeForViewDto[] | undefined;
}

export class GetIncrementDataView implements IGetIncrementDataView {
    id!: number;
    employeeId!: number;
    employeeCode!: string | undefined;
    employeeName!: string | undefined;
    employeeFatherName!: string | undefined;
    location!: string | undefined;
    department!: string | undefined;
    designation!: string | undefined;
    incrementCycle!: number | undefined;
    incrementDueOn!: moment.Moment | undefined;
    lastIncrement!: moment.Moment;
    currentCTC!: number | undefined;
    proposedIncreasePercent!: number;
    proposedCTC!: number | undefined;
    status!: string | undefined;
    effectiveFrom!: moment.Moment;

    constructor(data?: IGetIncrementDataView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.employeeCode = _data["employeeCode"];
            this.employeeName = _data["employeeName"];
            this.employeeFatherName = _data["employeeFatherName"];
            this.location = _data["location"];
            this.department = _data["department"];
            this.designation = _data["designation"];
            this.incrementCycle = _data["incrementCycle"];
            this.incrementDueOn = _data["incrementDueOn"] ? moment(_data["incrementDueOn"].toString()) : <any>undefined;
            this.lastIncrement = _data["lastIncrement"] ? moment(_data["lastIncrement"].toString()) : <any>undefined;
            this.currentCTC = _data["currentCTC"];
            this.proposedIncreasePercent = _data["proposedIncreasePercent"];
            this.proposedCTC = _data["proposedCTC"];
            this.status = _data["status"];
            this.effectiveFrom = _data["effectiveFrom"] ? moment(_data["effectiveFrom"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetIncrementDataView {
        data = typeof data === 'object' ? data : {};
        let result = new GetIncrementDataView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["employeeCode"] = this.employeeCode;
        data["employeeName"] = this.employeeName;
        data["employeeFatherName"] = this.employeeFatherName;
        data["location"] = this.location;
        data["department"] = this.department;
        data["designation"] = this.designation;
        data["incrementCycle"] = this.incrementCycle;
        data["incrementDueOn"] = this.incrementDueOn ? this.incrementDueOn.toISOString() : <any>undefined;
        data["lastIncrement"] = this.lastIncrement ? this.lastIncrement.toISOString() : <any>undefined;
        data["currentCTC"] = this.currentCTC;
        data["proposedIncreasePercent"] = this.proposedIncreasePercent;
        data["proposedCTC"] = this.proposedCTC;
        data["status"] = this.status;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetIncrementDataView {
    id: number;
    employeeId: number;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    employeeFatherName: string | undefined;
    location: string | undefined;
    department: string | undefined;
    designation: string | undefined;
    incrementCycle: number | undefined;
    incrementDueOn: moment.Moment | undefined;
    lastIncrement: moment.Moment;
    currentCTC: number | undefined;
    proposedIncreasePercent: number;
    proposedCTC: number | undefined;
    status: string | undefined;
    effectiveFrom: moment.Moment;
}

export class PagedResultDtoOfGetIncrementDataView implements IPagedResultDtoOfGetIncrementDataView {
    totalCount!: number;
    items!: GetIncrementDataView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetIncrementDataView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetIncrementDataView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetIncrementDataView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetIncrementDataView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetIncrementDataView {
    totalCount: number;
    items: GetIncrementDataView[] | undefined;
}

export class GetincrementListDataForEdit implements IGetincrementListDataForEdit {
    requestforApprovalId!: number | undefined;
    paySalaryComponetStructurePre!: PaySalaryComponetStructure[] | undefined;
    paySalaryComponetStructureNew!: PaySalaryComponetStructure[] | undefined;
    payGradeIdPre!: number;
    payGradeIdNew!: number;
    designationPre!: number;
    designationNew!: number;
    newMonthYear!: string | undefined;
    preMonthYear!: string | undefined;
    percentageChange!: number;
    previousChangeCtcPercentage!: number;
    remarks!: string | undefined;

    constructor(data?: IGetincrementListDataForEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestforApprovalId = _data["requestforApprovalId"];
            if (Array.isArray(_data["paySalaryComponetStructurePre"])) {
                this.paySalaryComponetStructurePre = [] as any;
                for (let item of _data["paySalaryComponetStructurePre"])
                    this.paySalaryComponetStructurePre!.push(PaySalaryComponetStructure.fromJS(item));
            }
            if (Array.isArray(_data["paySalaryComponetStructureNew"])) {
                this.paySalaryComponetStructureNew = [] as any;
                for (let item of _data["paySalaryComponetStructureNew"])
                    this.paySalaryComponetStructureNew!.push(PaySalaryComponetStructure.fromJS(item));
            }
            this.payGradeIdPre = _data["payGradeIdPre"];
            this.payGradeIdNew = _data["payGradeIdNew"];
            this.designationPre = _data["designationPre"];
            this.designationNew = _data["designationNew"];
            this.newMonthYear = _data["newMonthYear"];
            this.preMonthYear = _data["preMonthYear"];
            this.percentageChange = _data["percentageChange"];
            this.previousChangeCtcPercentage = _data["previousChangeCtcPercentage"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): GetincrementListDataForEdit {
        data = typeof data === 'object' ? data : {};
        let result = new GetincrementListDataForEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestforApprovalId"] = this.requestforApprovalId;
        if (Array.isArray(this.paySalaryComponetStructurePre)) {
            data["paySalaryComponetStructurePre"] = [];
            for (let item of this.paySalaryComponetStructurePre)
                data["paySalaryComponetStructurePre"].push(item.toJSON());
        }
        if (Array.isArray(this.paySalaryComponetStructureNew)) {
            data["paySalaryComponetStructureNew"] = [];
            for (let item of this.paySalaryComponetStructureNew)
                data["paySalaryComponetStructureNew"].push(item.toJSON());
        }
        data["payGradeIdPre"] = this.payGradeIdPre;
        data["payGradeIdNew"] = this.payGradeIdNew;
        data["designationPre"] = this.designationPre;
        data["designationNew"] = this.designationNew;
        data["newMonthYear"] = this.newMonthYear;
        data["preMonthYear"] = this.preMonthYear;
        data["percentageChange"] = this.percentageChange;
        data["previousChangeCtcPercentage"] = this.previousChangeCtcPercentage;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IGetincrementListDataForEdit {
    requestforApprovalId: number | undefined;
    paySalaryComponetStructurePre: PaySalaryComponetStructure[] | undefined;
    paySalaryComponetStructureNew: PaySalaryComponetStructure[] | undefined;
    payGradeIdPre: number;
    payGradeIdNew: number;
    designationPre: number;
    designationNew: number;
    newMonthYear: string | undefined;
    preMonthYear: string | undefined;
    percentageChange: number;
    previousChangeCtcPercentage: number;
    remarks: string | undefined;
}

export class Increment implements IIncrement {
    employeeId!: number;
    employeeCode!: string | undefined;
    salutation!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    employeeStatus!: string | undefined;
    department!: string | undefined;
    designation!: string | undefined;
    payGrade!: string | undefined;
    revisedDesignation!: string | undefined;
    revisedPayGrade!: string | undefined;
    advance!: number;
    basic!: number;
    bonus!: number | undefined;
    conveyance!: number;
    da!: number;
    esi!: number;
    hra!: number;
    monthlyPerformance!: number;
    new1!: number;
    pf!: number;
    reimbursement!: number;
    specialAllwoance!: number;
    tds!: number;

    constructor(data?: IIncrement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.employeeCode = _data["employeeCode"];
            this.salutation = _data["salutation"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.employeeStatus = _data["employeeStatus"];
            this.department = _data["department"];
            this.designation = _data["designation"];
            this.payGrade = _data["payGrade"];
            this.revisedDesignation = _data["revisedDesignation"];
            this.revisedPayGrade = _data["revisedPayGrade"];
            this.advance = _data["advance"];
            this.basic = _data["basic"];
            this.bonus = _data["bonus"];
            this.conveyance = _data["conveyance"];
            this.da = _data["da"];
            this.esi = _data["esi"];
            this.hra = _data["hra"];
            this.monthlyPerformance = _data["monthlyPerformance"];
            this.new1 = _data["new1"];
            this.pf = _data["pf"];
            this.reimbursement = _data["reimbursement"];
            this.specialAllwoance = _data["specialAllwoance"];
            this.tds = _data["tds"];
        }
    }

    static fromJS(data: any): Increment {
        data = typeof data === 'object' ? data : {};
        let result = new Increment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["employeeCode"] = this.employeeCode;
        data["salutation"] = this.salutation;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["employeeStatus"] = this.employeeStatus;
        data["department"] = this.department;
        data["designation"] = this.designation;
        data["payGrade"] = this.payGrade;
        data["revisedDesignation"] = this.revisedDesignation;
        data["revisedPayGrade"] = this.revisedPayGrade;
        data["advance"] = this.advance;
        data["basic"] = this.basic;
        data["bonus"] = this.bonus;
        data["conveyance"] = this.conveyance;
        data["da"] = this.da;
        data["esi"] = this.esi;
        data["hra"] = this.hra;
        data["monthlyPerformance"] = this.monthlyPerformance;
        data["new1"] = this.new1;
        data["pf"] = this.pf;
        data["reimbursement"] = this.reimbursement;
        data["specialAllwoance"] = this.specialAllwoance;
        data["tds"] = this.tds;
        return data;
    }
}

export interface IIncrement {
    employeeId: number;
    employeeCode: string | undefined;
    salutation: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    employeeStatus: string | undefined;
    department: string | undefined;
    designation: string | undefined;
    payGrade: string | undefined;
    revisedDesignation: string | undefined;
    revisedPayGrade: string | undefined;
    advance: number;
    basic: number;
    bonus: number | undefined;
    conveyance: number;
    da: number;
    esi: number;
    hra: number;
    monthlyPerformance: number;
    new1: number;
    pf: number;
    reimbursement: number;
    specialAllwoance: number;
    tds: number;
}

export class CreateOrEditEmployeeSalaryComponentsDtoForIncrement implements ICreateOrEditEmployeeSalaryComponentsDtoForIncrement {
    payComponet!: number;
    payGradeId!: number;
    amount!: number;
    percent!: number;
    approval!: boolean;
    status!: string | undefined;
    employeeId!: number;
    paySalaryComponetStructure!: PaySalaryComponetStructure[] | undefined;
    increments!: Increment;
    id!: number | undefined;

    constructor(data?: ICreateOrEditEmployeeSalaryComponentsDtoForIncrement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payComponet = _data["payComponet"];
            this.payGradeId = _data["payGradeId"];
            this.amount = _data["amount"];
            this.percent = _data["percent"];
            this.approval = _data["approval"];
            this.status = _data["status"];
            this.employeeId = _data["employeeId"];
            if (Array.isArray(_data["paySalaryComponetStructure"])) {
                this.paySalaryComponetStructure = [] as any;
                for (let item of _data["paySalaryComponetStructure"])
                    this.paySalaryComponetStructure!.push(PaySalaryComponetStructure.fromJS(item));
            }
            this.increments = _data["increments"] ? Increment.fromJS(_data["increments"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEmployeeSalaryComponentsDtoForIncrement {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEmployeeSalaryComponentsDtoForIncrement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payComponet"] = this.payComponet;
        data["payGradeId"] = this.payGradeId;
        data["amount"] = this.amount;
        data["percent"] = this.percent;
        data["approval"] = this.approval;
        data["status"] = this.status;
        data["employeeId"] = this.employeeId;
        if (Array.isArray(this.paySalaryComponetStructure)) {
            data["paySalaryComponetStructure"] = [];
            for (let item of this.paySalaryComponetStructure)
                data["paySalaryComponetStructure"].push(item.toJSON());
        }
        data["increments"] = this.increments ? this.increments.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditEmployeeSalaryComponentsDtoForIncrement {
    payComponet: number;
    payGradeId: number;
    amount: number;
    percent: number;
    approval: boolean;
    status: string | undefined;
    employeeId: number;
    paySalaryComponetStructure: PaySalaryComponetStructure[] | undefined;
    increments: Increment;
    id: number | undefined;
}

export class IncrementRequestPayload implements IIncrementRequestPayload {
    employeeId!: number;
    previousMonthYear!: string | undefined;
    newMonthYear!: string | undefined;
    previousCTC!: number | undefined;
    newCTC!: number | undefined;
    approvedMonthYear!: string | undefined;
    precentChange!: number;
    previousGrade!: number;
    previousGradeName!: string | undefined;
    newGrade!: number;
    newGradeName!: string | undefined;
    reportingManager!: boolean | undefined;
    previousDesignation!: number;
    previousDesignationName!: string | undefined;
    newDesignation!: number;
    newDesignationName!: string | undefined;
    approvedBy!: number;
    proposedBy!: number;
    approvedOn!: moment.Moment | undefined;
    createdOn!: moment.Moment | undefined;
    remarks!: string | undefined;
    tenantId!: number;
    assignComponent!: CreateOrEditEmployeeSalaryComponentsDtoForIncrement;
    requestForApprovalLogId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IIncrementRequestPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.previousMonthYear = _data["previousMonthYear"];
            this.newMonthYear = _data["newMonthYear"];
            this.previousCTC = _data["previousCTC"];
            this.newCTC = _data["newCTC"];
            this.approvedMonthYear = _data["approvedMonthYear"];
            this.precentChange = _data["precentChange"];
            this.previousGrade = _data["previousGrade"];
            this.previousGradeName = _data["previousGradeName"];
            this.newGrade = _data["newGrade"];
            this.newGradeName = _data["newGradeName"];
            this.reportingManager = _data["reportingManager"];
            this.previousDesignation = _data["previousDesignation"];
            this.previousDesignationName = _data["previousDesignationName"];
            this.newDesignation = _data["newDesignation"];
            this.newDesignationName = _data["newDesignationName"];
            this.approvedBy = _data["approvedBy"];
            this.proposedBy = _data["proposedBy"];
            this.approvedOn = _data["approvedOn"] ? moment(_data["approvedOn"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
            this.tenantId = _data["tenantId"];
            this.assignComponent = _data["assignComponent"] ? CreateOrEditEmployeeSalaryComponentsDtoForIncrement.fromJS(_data["assignComponent"]) : <any>undefined;
            this.requestForApprovalLogId = _data["requestForApprovalLogId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): IncrementRequestPayload {
        data = typeof data === 'object' ? data : {};
        let result = new IncrementRequestPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["previousMonthYear"] = this.previousMonthYear;
        data["newMonthYear"] = this.newMonthYear;
        data["previousCTC"] = this.previousCTC;
        data["newCTC"] = this.newCTC;
        data["approvedMonthYear"] = this.approvedMonthYear;
        data["precentChange"] = this.precentChange;
        data["previousGrade"] = this.previousGrade;
        data["previousGradeName"] = this.previousGradeName;
        data["newGrade"] = this.newGrade;
        data["newGradeName"] = this.newGradeName;
        data["reportingManager"] = this.reportingManager;
        data["previousDesignation"] = this.previousDesignation;
        data["previousDesignationName"] = this.previousDesignationName;
        data["newDesignation"] = this.newDesignation;
        data["newDesignationName"] = this.newDesignationName;
        data["approvedBy"] = this.approvedBy;
        data["proposedBy"] = this.proposedBy;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["tenantId"] = this.tenantId;
        data["assignComponent"] = this.assignComponent ? this.assignComponent.toJSON() : <any>undefined;
        data["requestForApprovalLogId"] = this.requestForApprovalLogId;
        data["id"] = this.id;
        return data;
    }
}

export interface IIncrementRequestPayload {
    employeeId: number;
    previousMonthYear: string | undefined;
    newMonthYear: string | undefined;
    previousCTC: number | undefined;
    newCTC: number | undefined;
    approvedMonthYear: string | undefined;
    precentChange: number;
    previousGrade: number;
    previousGradeName: string | undefined;
    newGrade: number;
    newGradeName: string | undefined;
    reportingManager: boolean | undefined;
    previousDesignation: number;
    previousDesignationName: string | undefined;
    newDesignation: number;
    newDesignationName: string | undefined;
    approvedBy: number;
    proposedBy: number;
    approvedOn: moment.Moment | undefined;
    createdOn: moment.Moment | undefined;
    remarks: string | undefined;
    tenantId: number;
    assignComponent: CreateOrEditEmployeeSalaryComponentsDtoForIncrement;
    requestForApprovalLogId: number | undefined;
    id: number | undefined;
}

export class InstallDto implements IInstallDto {
    connectionString!: string;
    adminPassword!: string;
    webSiteUrl!: string;
    serverUrl!: string | undefined;
    defaultLanguage!: string;
    smtpSettings!: EmailSettingsEditDto;
    billInfo!: HostBillingSettingsEditDto;

    constructor(data?: IInstallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectionString = _data["connectionString"];
            this.adminPassword = _data["adminPassword"];
            this.webSiteUrl = _data["webSiteUrl"];
            this.serverUrl = _data["serverUrl"];
            this.defaultLanguage = _data["defaultLanguage"];
            this.smtpSettings = _data["smtpSettings"] ? EmailSettingsEditDto.fromJS(_data["smtpSettings"]) : <any>undefined;
            this.billInfo = _data["billInfo"] ? HostBillingSettingsEditDto.fromJS(_data["billInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InstallDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionString"] = this.connectionString;
        data["adminPassword"] = this.adminPassword;
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverUrl"] = this.serverUrl;
        data["defaultLanguage"] = this.defaultLanguage;
        data["smtpSettings"] = this.smtpSettings ? this.smtpSettings.toJSON() : <any>undefined;
        data["billInfo"] = this.billInfo ? this.billInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInstallDto {
    connectionString: string;
    adminPassword: string;
    webSiteUrl: string;
    serverUrl: string | undefined;
    defaultLanguage: string;
    smtpSettings: EmailSettingsEditDto;
    billInfo: HostBillingSettingsEditDto;
}

export class NameValue implements INameValue {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValue {
        data = typeof data === 'object' ? data : {};
        let result = new NameValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValue {
    name: string | undefined;
    value: string | undefined;
}

export class AppSettingsJsonDto implements IAppSettingsJsonDto {
    webSiteUrl!: string | undefined;
    serverSiteUrl!: string | undefined;
    languages!: NameValue[] | undefined;

    constructor(data?: IAppSettingsJsonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webSiteUrl = _data["webSiteUrl"];
            this.serverSiteUrl = _data["serverSiteUrl"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(NameValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppSettingsJsonDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppSettingsJsonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverSiteUrl"] = this.serverSiteUrl;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAppSettingsJsonDto {
    webSiteUrl: string | undefined;
    serverSiteUrl: string | undefined;
    languages: NameValue[] | undefined;
}

export class CheckDatabaseOutput implements ICheckDatabaseOutput {
    isDatabaseExist!: boolean;

    constructor(data?: ICheckDatabaseOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDatabaseExist = _data["isDatabaseExist"];
        }
    }

    static fromJS(data: any): CheckDatabaseOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckDatabaseOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDatabaseExist"] = this.isDatabaseExist;
        return data;
    }
}

export interface ICheckDatabaseOutput {
    isDatabaseExist: boolean;
}

export class InvestmentDecUserForView implements IInvestmentDecUserForView {
    declaration!: string | undefined;
    numberOfDeclaration!: number;
    amount!: number;
    proofSubmitted!: number;

    constructor(data?: IInvestmentDecUserForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.declaration = _data["declaration"];
            this.numberOfDeclaration = _data["numberOfDeclaration"];
            this.amount = _data["amount"];
            this.proofSubmitted = _data["proofSubmitted"];
        }
    }

    static fromJS(data: any): InvestmentDecUserForView {
        data = typeof data === 'object' ? data : {};
        let result = new InvestmentDecUserForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["declaration"] = this.declaration;
        data["numberOfDeclaration"] = this.numberOfDeclaration;
        data["amount"] = this.amount;
        data["proofSubmitted"] = this.proofSubmitted;
        return data;
    }
}

export interface IInvestmentDecUserForView {
    declaration: string | undefined;
    numberOfDeclaration: number;
    amount: number;
    proofSubmitted: number;
}

export class Taxsavingdto implements ITaxsavingdto {
    section!: string | undefined;
    deductionName!: string | undefined;
    maxLimit!: string | undefined;
    taxsavingid!: string | undefined;
    id!: number;

    constructor(data?: ITaxsavingdto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.section = _data["section"];
            this.deductionName = _data["deductionName"];
            this.maxLimit = _data["maxLimit"];
            this.taxsavingid = _data["taxsavingid"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Taxsavingdto {
        data = typeof data === 'object' ? data : {};
        let result = new Taxsavingdto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["section"] = this.section;
        data["deductionName"] = this.deductionName;
        data["maxLimit"] = this.maxLimit;
        data["taxsavingid"] = this.taxsavingid;
        data["id"] = this.id;
        return data;
    }
}

export interface ITaxsavingdto {
    section: string | undefined;
    deductionName: string | undefined;
    maxLimit: string | undefined;
    taxsavingid: string | undefined;
    id: number;
}

export class Taxsavingforviewdto implements ITaxsavingforviewdto {
    taxinvestment!: Taxsavingdto;
    amount!: number;
    totaldocument!: string | undefined;
    totalamount!: number;

    constructor(data?: ITaxsavingforviewdto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxinvestment = _data["taxinvestment"] ? Taxsavingdto.fromJS(_data["taxinvestment"]) : <any>undefined;
            this.amount = _data["amount"];
            this.totaldocument = _data["totaldocument"];
            this.totalamount = _data["totalamount"];
        }
    }

    static fromJS(data: any): Taxsavingforviewdto {
        data = typeof data === 'object' ? data : {};
        let result = new Taxsavingforviewdto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxinvestment"] = this.taxinvestment ? this.taxinvestment.toJSON() : <any>undefined;
        data["amount"] = this.amount;
        data["totaldocument"] = this.totaldocument;
        data["totalamount"] = this.totalamount;
        return data;
    }
}

export interface ITaxsavingforviewdto {
    taxinvestment: Taxsavingdto;
    amount: number;
    totaldocument: string | undefined;
    totalamount: number;
}

export class Ccinvestmentdto implements ICcinvestmentdto {
    section!: string | undefined;
    deductionName!: string | undefined;
    maxLimit!: string | undefined;
    ccInvestmentId!: string | undefined;
    id!: number;

    constructor(data?: ICcinvestmentdto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.section = _data["section"];
            this.deductionName = _data["deductionName"];
            this.maxLimit = _data["maxLimit"];
            this.ccInvestmentId = _data["ccInvestmentId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Ccinvestmentdto {
        data = typeof data === 'object' ? data : {};
        let result = new Ccinvestmentdto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["section"] = this.section;
        data["deductionName"] = this.deductionName;
        data["maxLimit"] = this.maxLimit;
        data["ccInvestmentId"] = this.ccInvestmentId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICcinvestmentdto {
    section: string | undefined;
    deductionName: string | undefined;
    maxLimit: string | undefined;
    ccInvestmentId: string | undefined;
    id: number;
}

export class Ccinvestmentforviewdto implements ICcinvestmentforviewdto {
    ccinvestment!: Ccinvestmentdto;
    amount!: number;
    totaldocument!: string | undefined;
    totalamount!: number;

    constructor(data?: ICcinvestmentforviewdto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ccinvestment = _data["ccinvestment"] ? Ccinvestmentdto.fromJS(_data["ccinvestment"]) : <any>undefined;
            this.amount = _data["amount"];
            this.totaldocument = _data["totaldocument"];
            this.totalamount = _data["totalamount"];
        }
    }

    static fromJS(data: any): Ccinvestmentforviewdto {
        data = typeof data === 'object' ? data : {};
        let result = new Ccinvestmentforviewdto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ccinvestment"] = this.ccinvestment ? this.ccinvestment.toJSON() : <any>undefined;
        data["amount"] = this.amount;
        data["totaldocument"] = this.totaldocument;
        data["totalamount"] = this.totalamount;
        return data;
    }
}

export interface ICcinvestmentforviewdto {
    ccinvestment: Ccinvestmentdto;
    amount: number;
    totaldocument: string | undefined;
    totalamount: number;
}

export class Otherinvestmentdto implements IOtherinvestmentdto {
    section!: string | undefined;
    deductionName!: string | undefined;
    maxLimit!: string | undefined;
    otherInvestmentId!: string | undefined;
    id!: number;

    constructor(data?: IOtherinvestmentdto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.section = _data["section"];
            this.deductionName = _data["deductionName"];
            this.maxLimit = _data["maxLimit"];
            this.otherInvestmentId = _data["otherInvestmentId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Otherinvestmentdto {
        data = typeof data === 'object' ? data : {};
        let result = new Otherinvestmentdto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["section"] = this.section;
        data["deductionName"] = this.deductionName;
        data["maxLimit"] = this.maxLimit;
        data["otherInvestmentId"] = this.otherInvestmentId;
        data["id"] = this.id;
        return data;
    }
}

export interface IOtherinvestmentdto {
    section: string | undefined;
    deductionName: string | undefined;
    maxLimit: string | undefined;
    otherInvestmentId: string | undefined;
    id: number;
}

export class Otherinvestmentforviewdto implements IOtherinvestmentforviewdto {
    otherinvestment!: Otherinvestmentdto;
    amount!: number;
    totaldocument!: string | undefined;
    totalamount!: number;

    constructor(data?: IOtherinvestmentforviewdto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.otherinvestment = _data["otherinvestment"] ? Otherinvestmentdto.fromJS(_data["otherinvestment"]) : <any>undefined;
            this.amount = _data["amount"];
            this.totaldocument = _data["totaldocument"];
            this.totalamount = _data["totalamount"];
        }
    }

    static fromJS(data: any): Otherinvestmentforviewdto {
        data = typeof data === 'object' ? data : {};
        let result = new Otherinvestmentforviewdto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["otherinvestment"] = this.otherinvestment ? this.otherinvestment.toJSON() : <any>undefined;
        data["amount"] = this.amount;
        data["totaldocument"] = this.totaldocument;
        data["totalamount"] = this.totalamount;
        return data;
    }
}

export interface IOtherinvestmentforviewdto {
    otherinvestment: Otherinvestmentdto;
    amount: number;
    totaldocument: string | undefined;
    totalamount: number;
}

export class CreateorEditInvestmentDecDto implements ICreateorEditInvestmentDecDto {
    tenantId!: number;
    employeeId!: number;
    financialYear!: string | undefined;
    amount!: number;
    investmentIdUser!: string | undefined;
    imagePath!: string | undefined;
    docname!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateorEditInvestmentDecDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.employeeId = _data["employeeId"];
            this.financialYear = _data["financialYear"];
            this.amount = _data["amount"];
            this.investmentIdUser = _data["investmentIdUser"];
            this.imagePath = _data["imagePath"];
            this.docname = _data["docname"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateorEditInvestmentDecDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateorEditInvestmentDecDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["employeeId"] = this.employeeId;
        data["financialYear"] = this.financialYear;
        data["amount"] = this.amount;
        data["investmentIdUser"] = this.investmentIdUser;
        data["imagePath"] = this.imagePath;
        data["docname"] = this.docname;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateorEditInvestmentDecDto {
    tenantId: number;
    employeeId: number;
    financialYear: string | undefined;
    amount: number;
    investmentIdUser: string | undefined;
    imagePath: string | undefined;
    docname: string | undefined;
    id: number | undefined;
}

export class InvoiceDto implements IInvoiceDto {
    amount!: number;
    editionDisplayName!: string | undefined;
    invoiceNo!: string | undefined;
    invoiceDate!: moment.Moment;
    tenantLegalName!: string | undefined;
    tenantAddress!: string[] | undefined;
    tenantTaxNo!: string | undefined;
    hostLegalName!: string | undefined;
    hostAddress!: string[] | undefined;

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.editionDisplayName = _data["editionDisplayName"];
            this.invoiceNo = _data["invoiceNo"];
            this.invoiceDate = _data["invoiceDate"] ? moment(_data["invoiceDate"].toString()) : <any>undefined;
            this.tenantLegalName = _data["tenantLegalName"];
            if (Array.isArray(_data["tenantAddress"])) {
                this.tenantAddress = [] as any;
                for (let item of _data["tenantAddress"])
                    this.tenantAddress!.push(item);
            }
            this.tenantTaxNo = _data["tenantTaxNo"];
            this.hostLegalName = _data["hostLegalName"];
            if (Array.isArray(_data["hostAddress"])) {
                this.hostAddress = [] as any;
                for (let item of _data["hostAddress"])
                    this.hostAddress!.push(item);
            }
        }
    }

    static fromJS(data: any): InvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["editionDisplayName"] = this.editionDisplayName;
        data["invoiceNo"] = this.invoiceNo;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["tenantLegalName"] = this.tenantLegalName;
        if (Array.isArray(this.tenantAddress)) {
            data["tenantAddress"] = [];
            for (let item of this.tenantAddress)
                data["tenantAddress"].push(item);
        }
        data["tenantTaxNo"] = this.tenantTaxNo;
        data["hostLegalName"] = this.hostLegalName;
        if (Array.isArray(this.hostAddress)) {
            data["hostAddress"] = [];
            for (let item of this.hostAddress)
                data["hostAddress"].push(item);
        }
        return data;
    }
}

export interface IInvoiceDto {
    amount: number;
    editionDisplayName: string | undefined;
    invoiceNo: string | undefined;
    invoiceDate: moment.Moment;
    tenantLegalName: string | undefined;
    tenantAddress: string[] | undefined;
    tenantTaxNo: string | undefined;
    hostLegalName: string | undefined;
    hostAddress: string[] | undefined;
}

export class CreateInvoiceDto implements ICreateInvoiceDto {
    subscriptionPaymentId!: number;

    constructor(data?: ICreateInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionPaymentId = _data["subscriptionPaymentId"];
        }
    }

    static fromJS(data: any): CreateInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionPaymentId"] = this.subscriptionPaymentId;
        return data;
    }
}

export interface ICreateInvoiceDto {
    subscriptionPaymentId: number;
}

export class CreateOrEditJobOpeningDto implements ICreateOrEditJobOpeningDto {
    postionCode!: string | undefined;
    degination!: number | undefined;
    department!: number | undefined;
    subdepartment!: number | undefined;
    branch!: number | undefined;
    level!: number | undefined;
    reportingManager!: boolean | undefined;
    subBranch!: number | undefined;
    employeementType!: number;
    positionType!: number | undefined;
    noOfPostion!: number | undefined;
    openingDate!: moment.Moment;
    closeDate!: moment.Moment | undefined;
    name!: string | undefined;
    experince!: string | undefined;
    type!: string | undefined;
    qualification!: string | undefined;
    descripiton!: string | undefined;
    closed!: boolean;
    requestId!: number | undefined;
    roundList!: RoundInterview[] | undefined;
    requestForApprovalLogId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditJobOpeningDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postionCode = _data["postionCode"];
            this.degination = _data["degination"];
            this.department = _data["department"];
            this.subdepartment = _data["subdepartment"];
            this.branch = _data["branch"];
            this.level = _data["level"];
            this.reportingManager = _data["reportingManager"];
            this.subBranch = _data["subBranch"];
            this.employeementType = _data["employeementType"];
            this.positionType = _data["positionType"];
            this.noOfPostion = _data["noOfPostion"];
            this.openingDate = _data["openingDate"] ? moment(_data["openingDate"].toString()) : <any>undefined;
            this.closeDate = _data["closeDate"] ? moment(_data["closeDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.experince = _data["experince"];
            this.type = _data["type"];
            this.qualification = _data["qualification"];
            this.descripiton = _data["descripiton"];
            this.closed = _data["closed"];
            this.requestId = _data["requestId"];
            if (Array.isArray(_data["roundList"])) {
                this.roundList = [] as any;
                for (let item of _data["roundList"])
                    this.roundList!.push(RoundInterview.fromJS(item));
            }
            this.requestForApprovalLogId = _data["requestForApprovalLogId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditJobOpeningDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditJobOpeningDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postionCode"] = this.postionCode;
        data["degination"] = this.degination;
        data["department"] = this.department;
        data["subdepartment"] = this.subdepartment;
        data["branch"] = this.branch;
        data["level"] = this.level;
        data["reportingManager"] = this.reportingManager;
        data["subBranch"] = this.subBranch;
        data["employeementType"] = this.employeementType;
        data["positionType"] = this.positionType;
        data["noOfPostion"] = this.noOfPostion;
        data["openingDate"] = this.openingDate ? this.openingDate.toISOString() : <any>undefined;
        data["closeDate"] = this.closeDate ? this.closeDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["experince"] = this.experince;
        data["type"] = this.type;
        data["qualification"] = this.qualification;
        data["descripiton"] = this.descripiton;
        data["closed"] = this.closed;
        data["requestId"] = this.requestId;
        if (Array.isArray(this.roundList)) {
            data["roundList"] = [];
            for (let item of this.roundList)
                data["roundList"].push(item.toJSON());
        }
        data["requestForApprovalLogId"] = this.requestForApprovalLogId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditJobOpeningDto {
    postionCode: string | undefined;
    degination: number | undefined;
    department: number | undefined;
    subdepartment: number | undefined;
    branch: number | undefined;
    level: number | undefined;
    reportingManager: boolean | undefined;
    subBranch: number | undefined;
    employeementType: number;
    positionType: number | undefined;
    noOfPostion: number | undefined;
    openingDate: moment.Moment;
    closeDate: moment.Moment | undefined;
    name: string | undefined;
    experince: string | undefined;
    type: string | undefined;
    qualification: string | undefined;
    descripiton: string | undefined;
    closed: boolean;
    requestId: number | undefined;
    roundList: RoundInterview[] | undefined;
    requestForApprovalLogId: number | undefined;
    id: number | undefined;
}

export class GetJobOpeningForEditOutput implements IGetJobOpeningForEditOutput {
    jobOpenings!: CreateOrEditJobOpeningDto;
    requestedBy!: number | undefined;
    requestFlow!: string | undefined;
    leaveRejectStatus!: string | undefined;
    closedStatus!: boolean;

    constructor(data?: IGetJobOpeningForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobOpenings = _data["jobOpenings"] ? CreateOrEditJobOpeningDto.fromJS(_data["jobOpenings"]) : <any>undefined;
            this.requestedBy = _data["requestedBy"];
            this.requestFlow = _data["requestFlow"];
            this.leaveRejectStatus = _data["leaveRejectStatus"];
            this.closedStatus = _data["closedStatus"];
        }
    }

    static fromJS(data: any): GetJobOpeningForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetJobOpeningForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobOpenings"] = this.jobOpenings ? this.jobOpenings.toJSON() : <any>undefined;
        data["requestedBy"] = this.requestedBy;
        data["requestFlow"] = this.requestFlow;
        data["leaveRejectStatus"] = this.leaveRejectStatus;
        data["closedStatus"] = this.closedStatus;
        return data;
    }
}

export interface IGetJobOpeningForEditOutput {
    jobOpenings: CreateOrEditJobOpeningDto;
    requestedBy: number | undefined;
    requestFlow: string | undefined;
    leaveRejectStatus: string | undefined;
    closedStatus: boolean;
}

export class PagedResultDtoOfGetJobOpeningForEditOutput implements IPagedResultDtoOfGetJobOpeningForEditOutput {
    totalCount!: number;
    items!: GetJobOpeningForEditOutput[] | undefined;

    constructor(data?: IPagedResultDtoOfGetJobOpeningForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetJobOpeningForEditOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetJobOpeningForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetJobOpeningForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetJobOpeningForEditOutput {
    totalCount: number;
    items: GetJobOpeningForEditOutput[] | undefined;
}

export class JobOpeningDto implements IJobOpeningDto {
    postionCode!: string | undefined;
    degination!: number | undefined;
    department!: number | undefined;
    subdepartment!: number | undefined;
    branch!: number | undefined;
    level!: number | undefined;
    employeementType!: number;
    openingDate!: moment.Moment;
    closeDate!: moment.Moment | undefined;
    name!: string | undefined;
    experince!: string | undefined;
    type!: string | undefined;
    qualification!: string | undefined;
    descripiton!: string | undefined;
    closed!: boolean;
    id!: number;

    constructor(data?: IJobOpeningDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postionCode = _data["postionCode"];
            this.degination = _data["degination"];
            this.department = _data["department"];
            this.subdepartment = _data["subdepartment"];
            this.branch = _data["branch"];
            this.level = _data["level"];
            this.employeementType = _data["employeementType"];
            this.openingDate = _data["openingDate"] ? moment(_data["openingDate"].toString()) : <any>undefined;
            this.closeDate = _data["closeDate"] ? moment(_data["closeDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.experince = _data["experince"];
            this.type = _data["type"];
            this.qualification = _data["qualification"];
            this.descripiton = _data["descripiton"];
            this.closed = _data["closed"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): JobOpeningDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobOpeningDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postionCode"] = this.postionCode;
        data["degination"] = this.degination;
        data["department"] = this.department;
        data["subdepartment"] = this.subdepartment;
        data["branch"] = this.branch;
        data["level"] = this.level;
        data["employeementType"] = this.employeementType;
        data["openingDate"] = this.openingDate ? this.openingDate.toISOString() : <any>undefined;
        data["closeDate"] = this.closeDate ? this.closeDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["experince"] = this.experince;
        data["type"] = this.type;
        data["qualification"] = this.qualification;
        data["descripiton"] = this.descripiton;
        data["closed"] = this.closed;
        data["id"] = this.id;
        return data;
    }
}

export interface IJobOpeningDto {
    postionCode: string | undefined;
    degination: number | undefined;
    department: number | undefined;
    subdepartment: number | undefined;
    branch: number | undefined;
    level: number | undefined;
    employeementType: number;
    openingDate: moment.Moment;
    closeDate: moment.Moment | undefined;
    name: string | undefined;
    experince: string | undefined;
    type: string | undefined;
    qualification: string | undefined;
    descripiton: string | undefined;
    closed: boolean;
    id: number;
}

export class GetJobOpeningForViewDto implements IGetJobOpeningForViewDto {
    jobOpening!: JobOpeningDto;

    constructor(data?: IGetJobOpeningForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobOpening = _data["jobOpening"] ? JobOpeningDto.fromJS(_data["jobOpening"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetJobOpeningForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJobOpeningForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobOpening"] = this.jobOpening ? this.jobOpening.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetJobOpeningForViewDto {
    jobOpening: JobOpeningDto;
}

export class JObRoundDetailsDto implements IJObRoundDetailsDto {
    name!: string | undefined;
    interviewer!: number | undefined;
    jobOpeningId!: number | undefined;
    id!: number;

    constructor(data?: IJObRoundDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.interviewer = _data["interviewer"];
            this.jobOpeningId = _data["jobOpeningId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): JObRoundDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new JObRoundDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["interviewer"] = this.interviewer;
        data["jobOpeningId"] = this.jobOpeningId;
        data["id"] = this.id;
        return data;
    }
}

export interface IJObRoundDetailsDto {
    name: string | undefined;
    interviewer: number | undefined;
    jobOpeningId: number | undefined;
    id: number;
}

export class GetJObRoundDetailsForViewDto implements IGetJObRoundDetailsForViewDto {
    jObRoundDetails!: JObRoundDetailsDto;
    jobOpeningPostionCode!: string | undefined;

    constructor(data?: IGetJObRoundDetailsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jObRoundDetails = _data["jObRoundDetails"] ? JObRoundDetailsDto.fromJS(_data["jObRoundDetails"]) : <any>undefined;
            this.jobOpeningPostionCode = _data["jobOpeningPostionCode"];
        }
    }

    static fromJS(data: any): GetJObRoundDetailsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJObRoundDetailsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jObRoundDetails"] = this.jObRoundDetails ? this.jObRoundDetails.toJSON() : <any>undefined;
        data["jobOpeningPostionCode"] = this.jobOpeningPostionCode;
        return data;
    }
}

export interface IGetJObRoundDetailsForViewDto {
    jObRoundDetails: JObRoundDetailsDto;
    jobOpeningPostionCode: string | undefined;
}

export class PagedResultDtoOfGetJObRoundDetailsForViewDto implements IPagedResultDtoOfGetJObRoundDetailsForViewDto {
    totalCount!: number;
    items!: GetJObRoundDetailsForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetJObRoundDetailsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetJObRoundDetailsForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetJObRoundDetailsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetJObRoundDetailsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetJObRoundDetailsForViewDto {
    totalCount: number;
    items: GetJObRoundDetailsForViewDto[] | undefined;
}

export class CreateOrEditJObRoundDetailsDto implements ICreateOrEditJObRoundDetailsDto {
    name!: string | undefined;
    interviewer!: number | undefined;
    jobOpeningId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditJObRoundDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.interviewer = _data["interviewer"];
            this.jobOpeningId = _data["jobOpeningId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditJObRoundDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditJObRoundDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["interviewer"] = this.interviewer;
        data["jobOpeningId"] = this.jobOpeningId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditJObRoundDetailsDto {
    name: string | undefined;
    interviewer: number | undefined;
    jobOpeningId: number | undefined;
    id: number | undefined;
}

export class GetJObRoundDetailsForEditOutput implements IGetJObRoundDetailsForEditOutput {
    jObRoundDetails!: CreateOrEditJObRoundDetailsDto;
    jobOpeningPostionCode!: string | undefined;

    constructor(data?: IGetJObRoundDetailsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jObRoundDetails = _data["jObRoundDetails"] ? CreateOrEditJObRoundDetailsDto.fromJS(_data["jObRoundDetails"]) : <any>undefined;
            this.jobOpeningPostionCode = _data["jobOpeningPostionCode"];
        }
    }

    static fromJS(data: any): GetJObRoundDetailsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetJObRoundDetailsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jObRoundDetails"] = this.jObRoundDetails ? this.jObRoundDetails.toJSON() : <any>undefined;
        data["jobOpeningPostionCode"] = this.jobOpeningPostionCode;
        return data;
    }
}

export interface IGetJObRoundDetailsForEditOutput {
    jObRoundDetails: CreateOrEditJObRoundDetailsDto;
    jobOpeningPostionCode: string | undefined;
}

export class JObRoundDetailsJobOpeningLookupTableDto implements IJObRoundDetailsJobOpeningLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IJObRoundDetailsJobOpeningLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): JObRoundDetailsJobOpeningLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new JObRoundDetailsJobOpeningLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IJObRoundDetailsJobOpeningLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class GetKPIPolicyAssignmentDto implements IGetKPIPolicyAssignmentDto {
    employeeCode!: string | undefined;
    employeeName!: string | undefined;
    designationName!: string | undefined;
    designationId!: number;
    assignedDate!: moment.Moment;
    isActive!: boolean;
    cycle_Name!: number;
    kpI_Policy_Name!: number;
    employeeId!: number | undefined;
    tenantId!: number;

    constructor(data?: IGetKPIPolicyAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeCode = _data["employeeCode"];
            this.employeeName = _data["employeeName"];
            this.designationName = _data["designationName"];
            this.designationId = _data["designationId"];
            this.assignedDate = _data["assignedDate"] ? moment(_data["assignedDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.cycle_Name = _data["cycle_Name"];
            this.kpI_Policy_Name = _data["kpI_Policy_Name"];
            this.employeeId = _data["employeeId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): GetKPIPolicyAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetKPIPolicyAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeCode"] = this.employeeCode;
        data["employeeName"] = this.employeeName;
        data["designationName"] = this.designationName;
        data["designationId"] = this.designationId;
        data["assignedDate"] = this.assignedDate ? this.assignedDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["cycle_Name"] = this.cycle_Name;
        data["kpI_Policy_Name"] = this.kpI_Policy_Name;
        data["employeeId"] = this.employeeId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IGetKPIPolicyAssignmentDto {
    employeeCode: string | undefined;
    employeeName: string | undefined;
    designationName: string | undefined;
    designationId: number;
    assignedDate: moment.Moment;
    isActive: boolean;
    cycle_Name: number;
    kpI_Policy_Name: number;
    employeeId: number | undefined;
    tenantId: number;
}

export class PagedResultDtoOfGetKPIPolicyAssignmentDto implements IPagedResultDtoOfGetKPIPolicyAssignmentDto {
    totalCount!: number;
    items!: GetKPIPolicyAssignmentDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetKPIPolicyAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetKPIPolicyAssignmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetKPIPolicyAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetKPIPolicyAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetKPIPolicyAssignmentDto {
    totalCount: number;
    items: GetKPIPolicyAssignmentDto[] | undefined;
}

export class CreateOrEditKPIPolicyAssignment implements ICreateOrEditKPIPolicyAssignment {
    assignedDate!: moment.Moment;
    isActive!: boolean;
    fk_CycleId!: number;
    fk_Policy_Id!: number;
    employeeId!: number | undefined;
    tenantId!: number;

    constructor(data?: ICreateOrEditKPIPolicyAssignment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignedDate = _data["assignedDate"] ? moment(_data["assignedDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.fk_CycleId = _data["fk_CycleId"];
            this.fk_Policy_Id = _data["fk_Policy_Id"];
            this.employeeId = _data["employeeId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): CreateOrEditKPIPolicyAssignment {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditKPIPolicyAssignment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedDate"] = this.assignedDate ? this.assignedDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["fk_CycleId"] = this.fk_CycleId;
        data["fk_Policy_Id"] = this.fk_Policy_Id;
        data["employeeId"] = this.employeeId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ICreateOrEditKPIPolicyAssignment {
    assignedDate: moment.Moment;
    isActive: boolean;
    fk_CycleId: number;
    fk_Policy_Id: number;
    employeeId: number | undefined;
    tenantId: number;
}

export class GetEmployeeScoreCard implements IGetEmployeeScoreCard {
    rowIndex!: number;
    branch!: string | undefined;
    department!: string | undefined;
    employeeCode!: string | undefined;
    employeeName!: string | undefined;
    headquarter!: string | undefined;
    designation!: string | undefined;
    reviewCycle!: string | undefined;
    reportingManager!: string | undefined;
    division!: string | undefined;
    policy!: string | undefined;
    score!: number;

    constructor(data?: IGetEmployeeScoreCard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowIndex = _data["rowIndex"];
            this.branch = _data["branch"];
            this.department = _data["department"];
            this.employeeCode = _data["employeeCode"];
            this.employeeName = _data["employeeName"];
            this.headquarter = _data["headquarter"];
            this.designation = _data["designation"];
            this.reviewCycle = _data["reviewCycle"];
            this.reportingManager = _data["reportingManager"];
            this.division = _data["division"];
            this.policy = _data["policy"];
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): GetEmployeeScoreCard {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeScoreCard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowIndex"] = this.rowIndex;
        data["branch"] = this.branch;
        data["department"] = this.department;
        data["employeeCode"] = this.employeeCode;
        data["employeeName"] = this.employeeName;
        data["headquarter"] = this.headquarter;
        data["designation"] = this.designation;
        data["reviewCycle"] = this.reviewCycle;
        data["reportingManager"] = this.reportingManager;
        data["division"] = this.division;
        data["policy"] = this.policy;
        data["score"] = this.score;
        return data;
    }
}

export interface IGetEmployeeScoreCard {
    rowIndex: number;
    branch: string | undefined;
    department: string | undefined;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    headquarter: string | undefined;
    designation: string | undefined;
    reviewCycle: string | undefined;
    reportingManager: string | undefined;
    division: string | undefined;
    policy: string | undefined;
    score: number;
}

export class GetEmployeeScoreCardDetailed implements IGetEmployeeScoreCardDetailed {
    rowIndex!: number;
    branch!: string | undefined;
    department!: string | undefined;
    employeeCode!: string | undefined;
    employeeName!: string | undefined;
    headquarter!: string | undefined;
    designation!: string | undefined;
    reviewCycle!: string | undefined;
    reportingManager!: string | undefined;
    division!: string | undefined;
    policy!: string | undefined;
    kra!: string | undefined;
    weightage!: number;
    capturedCount!: number;
    employeeAssesment!: number;
    employeeRemark!: string | undefined;
    managerAssesment!: number;
    managerRemark!: string | undefined;
    net!: number;
    score!: number;

    constructor(data?: IGetEmployeeScoreCardDetailed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowIndex = _data["rowIndex"];
            this.branch = _data["branch"];
            this.department = _data["department"];
            this.employeeCode = _data["employeeCode"];
            this.employeeName = _data["employeeName"];
            this.headquarter = _data["headquarter"];
            this.designation = _data["designation"];
            this.reviewCycle = _data["reviewCycle"];
            this.reportingManager = _data["reportingManager"];
            this.division = _data["division"];
            this.policy = _data["policy"];
            this.kra = _data["kra"];
            this.weightage = _data["weightage"];
            this.capturedCount = _data["capturedCount"];
            this.employeeAssesment = _data["employeeAssesment"];
            this.employeeRemark = _data["employeeRemark"];
            this.managerAssesment = _data["managerAssesment"];
            this.managerRemark = _data["managerRemark"];
            this.net = _data["net"];
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): GetEmployeeScoreCardDetailed {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeScoreCardDetailed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowIndex"] = this.rowIndex;
        data["branch"] = this.branch;
        data["department"] = this.department;
        data["employeeCode"] = this.employeeCode;
        data["employeeName"] = this.employeeName;
        data["headquarter"] = this.headquarter;
        data["designation"] = this.designation;
        data["reviewCycle"] = this.reviewCycle;
        data["reportingManager"] = this.reportingManager;
        data["division"] = this.division;
        data["policy"] = this.policy;
        data["kra"] = this.kra;
        data["weightage"] = this.weightage;
        data["capturedCount"] = this.capturedCount;
        data["employeeAssesment"] = this.employeeAssesment;
        data["employeeRemark"] = this.employeeRemark;
        data["managerAssesment"] = this.managerAssesment;
        data["managerRemark"] = this.managerRemark;
        data["net"] = this.net;
        data["score"] = this.score;
        return data;
    }
}

export interface IGetEmployeeScoreCardDetailed {
    rowIndex: number;
    branch: string | undefined;
    department: string | undefined;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    headquarter: string | undefined;
    designation: string | undefined;
    reviewCycle: string | undefined;
    reportingManager: string | undefined;
    division: string | undefined;
    policy: string | undefined;
    kra: string | undefined;
    weightage: number;
    capturedCount: number;
    employeeAssesment: number;
    employeeRemark: string | undefined;
    managerAssesment: number;
    managerRemark: string | undefined;
    net: number;
    score: number;
}

export class EmployeeAndManagerReviewDto implements IEmployeeAndManagerReviewDto {
    employeeStatus!: string | undefined;
    managerStatus!: string | undefined;
    employeeSubmitteOn!: moment.Moment | undefined;
    managerSubmitteOn!: moment.Moment | undefined;
    period_From!: moment.Moment;
    period_To!: moment.Moment;
    fk_Policy_Id!: number | undefined;
    employeeId!: number | undefined;
    tenantId!: number;

    constructor(data?: IEmployeeAndManagerReviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeStatus = _data["employeeStatus"];
            this.managerStatus = _data["managerStatus"];
            this.employeeSubmitteOn = _data["employeeSubmitteOn"] ? moment(_data["employeeSubmitteOn"].toString()) : <any>undefined;
            this.managerSubmitteOn = _data["managerSubmitteOn"] ? moment(_data["managerSubmitteOn"].toString()) : <any>undefined;
            this.period_From = _data["period_From"] ? moment(_data["period_From"].toString()) : <any>undefined;
            this.period_To = _data["period_To"] ? moment(_data["period_To"].toString()) : <any>undefined;
            this.fk_Policy_Id = _data["fk_Policy_Id"];
            this.employeeId = _data["employeeId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): EmployeeAndManagerReviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeAndManagerReviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeStatus"] = this.employeeStatus;
        data["managerStatus"] = this.managerStatus;
        data["employeeSubmitteOn"] = this.employeeSubmitteOn ? this.employeeSubmitteOn.toISOString() : <any>undefined;
        data["managerSubmitteOn"] = this.managerSubmitteOn ? this.managerSubmitteOn.toISOString() : <any>undefined;
        data["period_From"] = this.period_From ? this.period_From.toISOString() : <any>undefined;
        data["period_To"] = this.period_To ? this.period_To.toISOString() : <any>undefined;
        data["fk_Policy_Id"] = this.fk_Policy_Id;
        data["employeeId"] = this.employeeId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IEmployeeAndManagerReviewDto {
    employeeStatus: string | undefined;
    managerStatus: string | undefined;
    employeeSubmitteOn: moment.Moment | undefined;
    managerSubmitteOn: moment.Moment | undefined;
    period_From: moment.Moment;
    period_To: moment.Moment;
    fk_Policy_Id: number | undefined;
    employeeId: number | undefined;
    tenantId: number;
}

export class CreateOrEditCriteriaList implements ICreateOrEditCriteriaList {
    id!: number;
    fk_Policy_KRAs_Id!: number | undefined;
    tenantId!: number;
    range_From!: number | undefined;
    range_To!: number | undefined;
    score!: number | undefined;
    fk_Feedback_Level_Id!: number | undefined;
    feedbackName!: string | undefined;

    constructor(data?: ICreateOrEditCriteriaList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fk_Policy_KRAs_Id = _data["fk_Policy_KRAs_Id"];
            this.tenantId = _data["tenantId"];
            this.range_From = _data["range_From"];
            this.range_To = _data["range_To"];
            this.score = _data["score"];
            this.fk_Feedback_Level_Id = _data["fk_Feedback_Level_Id"];
            this.feedbackName = _data["feedbackName"];
        }
    }

    static fromJS(data: any): CreateOrEditCriteriaList {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCriteriaList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fk_Policy_KRAs_Id"] = this.fk_Policy_KRAs_Id;
        data["tenantId"] = this.tenantId;
        data["range_From"] = this.range_From;
        data["range_To"] = this.range_To;
        data["score"] = this.score;
        data["fk_Feedback_Level_Id"] = this.fk_Feedback_Level_Id;
        data["feedbackName"] = this.feedbackName;
        return data;
    }
}

export interface ICreateOrEditCriteriaList {
    id: number;
    fk_Policy_KRAs_Id: number | undefined;
    tenantId: number;
    range_From: number | undefined;
    range_To: number | undefined;
    score: number | undefined;
    fk_Feedback_Level_Id: number | undefined;
    feedbackName: string | undefined;
}

export class CreateOrEditCriteria implements ICreateOrEditCriteria {
    criteriaList!: CreateOrEditCriteriaList[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["criteriaList"])) {
                this.criteriaList = [] as any;
                for (let item of _data["criteriaList"])
                    this.criteriaList!.push(CreateOrEditCriteriaList.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.criteriaList)) {
            data["criteriaList"] = [];
            for (let item of this.criteriaList)
                data["criteriaList"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCriteria {
    criteriaList: CreateOrEditCriteriaList[] | undefined;
    id: number | undefined;
}

export class KraTypesDto implements IKraTypesDto {
    name!: string | undefined;
    subKraCount!: number;
    type!: string;
    measurable!: string;
    isActive!: boolean;
    tenantId!: number;
    id!: number;

    constructor(data?: IKraTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.subKraCount = _data["subKraCount"];
            this.type = _data["type"];
            this.measurable = _data["measurable"];
            this.isActive = _data["isActive"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): KraTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new KraTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["subKraCount"] = this.subKraCount;
        data["type"] = this.type;
        data["measurable"] = this.measurable;
        data["isActive"] = this.isActive;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface IKraTypesDto {
    name: string | undefined;
    subKraCount: number;
    type: string;
    measurable: string;
    isActive: boolean;
    tenantId: number;
    id: number;
}

export class GetKraForViewDto implements IGetKraForViewDto {
    kraTypes!: KraTypesDto;
    typevalue!: string | undefined;
    measurablevalue!: string | undefined;

    constructor(data?: IGetKraForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kraTypes = _data["kraTypes"] ? KraTypesDto.fromJS(_data["kraTypes"]) : <any>undefined;
            this.typevalue = _data["typevalue"];
            this.measurablevalue = _data["measurablevalue"];
        }
    }

    static fromJS(data: any): GetKraForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetKraForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kraTypes"] = this.kraTypes ? this.kraTypes.toJSON() : <any>undefined;
        data["typevalue"] = this.typevalue;
        data["measurablevalue"] = this.measurablevalue;
        return data;
    }
}

export interface IGetKraForViewDto {
    kraTypes: KraTypesDto;
    typevalue: string | undefined;
    measurablevalue: string | undefined;
}

export class PagedResultDtoOfGetKraForViewDto implements IPagedResultDtoOfGetKraForViewDto {
    totalCount!: number;
    items!: GetKraForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetKraForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetKraForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetKraForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetKraForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetKraForViewDto {
    totalCount: number;
    items: GetKraForViewDto[] | undefined;
}

export class CreateOrEditKraDto implements ICreateOrEditKraDto {
    name!: string | undefined;
    type!: string;
    measurable!: string;
    isActive!: boolean;
    tenantId!: number;
    createdBy!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditKraDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.measurable = _data["measurable"];
            this.isActive = _data["isActive"];
            this.tenantId = _data["tenantId"];
            this.createdBy = _data["createdBy"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditKraDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditKraDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["measurable"] = this.measurable;
        data["isActive"] = this.isActive;
        data["tenantId"] = this.tenantId;
        data["createdBy"] = this.createdBy;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditKraDto {
    name: string | undefined;
    type: string;
    measurable: string;
    isActive: boolean;
    tenantId: number;
    createdBy: number;
    id: number | undefined;
}

export class GetKraForEditOutput implements IGetKraForEditOutput {
    kraTypes!: CreateOrEditKraDto;

    constructor(data?: IGetKraForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kraTypes = _data["kraTypes"] ? CreateOrEditKraDto.fromJS(_data["kraTypes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetKraForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetKraForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kraTypes"] = this.kraTypes ? this.kraTypes.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetKraForEditOutput {
    kraTypes: CreateOrEditKraDto;
}

export class LabourWelfaresettingDto implements ILabourWelfaresettingDto {
    lwfDesductiononBasis!: number;
    deductLwfOnArrear!: number;
    deductLwfonSettlement!: number;
    labourwelfareRegistration!: string | undefined;
    id!: number;

    constructor(data?: ILabourWelfaresettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lwfDesductiononBasis = _data["lwfDesductiononBasis"];
            this.deductLwfOnArrear = _data["deductLwfOnArrear"];
            this.deductLwfonSettlement = _data["deductLwfonSettlement"];
            this.labourwelfareRegistration = _data["labourwelfareRegistration"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LabourWelfaresettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new LabourWelfaresettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lwfDesductiononBasis"] = this.lwfDesductiononBasis;
        data["deductLwfOnArrear"] = this.deductLwfOnArrear;
        data["deductLwfonSettlement"] = this.deductLwfonSettlement;
        data["labourwelfareRegistration"] = this.labourwelfareRegistration;
        data["id"] = this.id;
        return data;
    }
}

export interface ILabourWelfaresettingDto {
    lwfDesductiononBasis: number;
    deductLwfOnArrear: number;
    deductLwfonSettlement: number;
    labourwelfareRegistration: string | undefined;
    id: number;
}

export class GetLabourWelfaresettingForViewDto implements IGetLabourWelfaresettingForViewDto {
    labourWelfaresetting!: LabourWelfaresettingDto;

    constructor(data?: IGetLabourWelfaresettingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.labourWelfaresetting = _data["labourWelfaresetting"] ? LabourWelfaresettingDto.fromJS(_data["labourWelfaresetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetLabourWelfaresettingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetLabourWelfaresettingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labourWelfaresetting"] = this.labourWelfaresetting ? this.labourWelfaresetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetLabourWelfaresettingForViewDto {
    labourWelfaresetting: LabourWelfaresettingDto;
}

export class PagedResultDtoOfGetLabourWelfaresettingForViewDto implements IPagedResultDtoOfGetLabourWelfaresettingForViewDto {
    totalCount!: number;
    items!: GetLabourWelfaresettingForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetLabourWelfaresettingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetLabourWelfaresettingForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetLabourWelfaresettingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetLabourWelfaresettingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetLabourWelfaresettingForViewDto {
    totalCount: number;
    items: GetLabourWelfaresettingForViewDto[] | undefined;
}

export class CreateOrEditLabourWelfaresettingDto implements ICreateOrEditLabourWelfaresettingDto {
    lwfDesductiononBasis!: number;
    deductLwfOnArrear!: number;
    deductLwfonSettlement!: number;
    labourwelfareRegistration!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditLabourWelfaresettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lwfDesductiononBasis = _data["lwfDesductiononBasis"];
            this.deductLwfOnArrear = _data["deductLwfOnArrear"];
            this.deductLwfonSettlement = _data["deductLwfonSettlement"];
            this.labourwelfareRegistration = _data["labourwelfareRegistration"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditLabourWelfaresettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditLabourWelfaresettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lwfDesductiononBasis"] = this.lwfDesductiononBasis;
        data["deductLwfOnArrear"] = this.deductLwfOnArrear;
        data["deductLwfonSettlement"] = this.deductLwfonSettlement;
        data["labourwelfareRegistration"] = this.labourwelfareRegistration;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditLabourWelfaresettingDto {
    lwfDesductiononBasis: number;
    deductLwfOnArrear: number;
    deductLwfonSettlement: number;
    labourwelfareRegistration: string | undefined;
    id: number | undefined;
}

export class GetLabourWelfaresettingForEditOutput implements IGetLabourWelfaresettingForEditOutput {
    labourWelfaresetting!: CreateOrEditLabourWelfaresettingDto;

    constructor(data?: IGetLabourWelfaresettingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.labourWelfaresetting = _data["labourWelfaresetting"] ? CreateOrEditLabourWelfaresettingDto.fromJS(_data["labourWelfaresetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetLabourWelfaresettingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLabourWelfaresettingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labourWelfaresetting"] = this.labourWelfaresetting ? this.labourWelfaresetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetLabourWelfaresettingForEditOutput {
    labourWelfaresetting: CreateOrEditLabourWelfaresettingDto;
}

export class ApplicationLanguageListDto implements IApplicationLanguageListDto {
    tenantId!: number | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    icon!: string | undefined;
    isDisabled!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IApplicationLanguageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.icon = _data["icon"];
            this.isDisabled = _data["isDisabled"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationLanguageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["icon"] = this.icon;
        data["isDisabled"] = this.isDisabled;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationLanguageListDto {
    tenantId: number | undefined;
    name: string | undefined;
    displayName: string | undefined;
    icon: string | undefined;
    isDisabled: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class GetLanguagesOutput implements IGetLanguagesOutput {
    defaultLanguageName!: string | undefined;
    items!: ApplicationLanguageListDto[] | undefined;

    constructor(data?: IGetLanguagesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultLanguageName = _data["defaultLanguageName"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApplicationLanguageListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguagesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguagesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultLanguageName"] = this.defaultLanguageName;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetLanguagesOutput {
    defaultLanguageName: string | undefined;
    items: ApplicationLanguageListDto[] | undefined;
}

export class ApplicationLanguageEditDto implements IApplicationLanguageEditDto {
    id!: number | undefined;
    name!: string;
    icon!: string | undefined;
    isEnabled!: boolean;

    constructor(data?: IApplicationLanguageEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): ApplicationLanguageEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguageEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IApplicationLanguageEditDto {
    id: number | undefined;
    name: string;
    icon: string | undefined;
    isEnabled: boolean;
}

export class ComboboxItemDto implements IComboboxItemDto {
    value!: string | undefined;
    displayText!: string | undefined;
    isSelected!: boolean;

    constructor(data?: IComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): ComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;
}

export class GetLanguageForEditOutput implements IGetLanguageForEditOutput {
    language!: ApplicationLanguageEditDto;
    languageNames!: ComboboxItemDto[] | undefined;
    flags!: ComboboxItemDto[] | undefined;

    constructor(data?: IGetLanguageForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"] ? ApplicationLanguageEditDto.fromJS(_data["language"]) : <any>undefined;
            if (Array.isArray(_data["languageNames"])) {
                this.languageNames = [] as any;
                for (let item of _data["languageNames"])
                    this.languageNames!.push(ComboboxItemDto.fromJS(item));
            }
            if (Array.isArray(_data["flags"])) {
                this.flags = [] as any;
                for (let item of _data["flags"])
                    this.flags!.push(ComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguageForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguageForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        if (Array.isArray(this.languageNames)) {
            data["languageNames"] = [];
            for (let item of this.languageNames)
                data["languageNames"].push(item.toJSON());
        }
        if (Array.isArray(this.flags)) {
            data["flags"] = [];
            for (let item of this.flags)
                data["flags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetLanguageForEditOutput {
    language: ApplicationLanguageEditDto;
    languageNames: ComboboxItemDto[] | undefined;
    flags: ComboboxItemDto[] | undefined;
}

export class CreateOrUpdateLanguageInput implements ICreateOrUpdateLanguageInput {
    language!: ApplicationLanguageEditDto;

    constructor(data?: ICreateOrUpdateLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.language = new ApplicationLanguageEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"] ? ApplicationLanguageEditDto.fromJS(_data["language"]) : new ApplicationLanguageEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLanguageInput {
    language: ApplicationLanguageEditDto;
}

export class SetDefaultLanguageInput implements ISetDefaultLanguageInput {
    name!: string;

    constructor(data?: ISetDefaultLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SetDefaultLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new SetDefaultLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ISetDefaultLanguageInput {
    name: string;
}

export class LanguageTextListDto implements ILanguageTextListDto {
    key!: string | undefined;
    baseValue!: string | undefined;
    targetValue!: string | undefined;

    constructor(data?: ILanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.baseValue = _data["baseValue"];
            this.targetValue = _data["targetValue"];
        }
    }

    static fromJS(data: any): LanguageTextListDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["baseValue"] = this.baseValue;
        data["targetValue"] = this.targetValue;
        return data;
    }
}

export interface ILanguageTextListDto {
    key: string | undefined;
    baseValue: string | undefined;
    targetValue: string | undefined;
}

export class PagedResultDtoOfLanguageTextListDto implements IPagedResultDtoOfLanguageTextListDto {
    totalCount!: number;
    items!: LanguageTextListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LanguageTextListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLanguageTextListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfLanguageTextListDto {
    totalCount: number;
    items: LanguageTextListDto[] | undefined;
}

export class UpdateLanguageTextInput implements IUpdateLanguageTextInput {
    languageName!: string;
    sourceName!: string;
    key!: string;
    value!: string;

    constructor(data?: IUpdateLanguageTextInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
            this.sourceName = _data["sourceName"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateLanguageTextInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLanguageTextInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        data["sourceName"] = this.sourceName;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateLanguageTextInput {
    languageName: string;
    sourceName: string;
    key: string;
    value: string;
}

export class LeaveBlancesDto implements ILeaveBlancesDto {
    employeeId!: number | undefined;
    financeYear!: string | undefined;
    leaveUsed!: number | undefined;
    leaveType!: number | undefined;
    leaveBalance!: number | undefined;
    carryForwardLeave!: number | undefined;
    id!: number;

    constructor(data?: ILeaveBlancesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.financeYear = _data["financeYear"];
            this.leaveUsed = _data["leaveUsed"];
            this.leaveType = _data["leaveType"];
            this.leaveBalance = _data["leaveBalance"];
            this.carryForwardLeave = _data["carryForwardLeave"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LeaveBlancesDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveBlancesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["financeYear"] = this.financeYear;
        data["leaveUsed"] = this.leaveUsed;
        data["leaveType"] = this.leaveType;
        data["leaveBalance"] = this.leaveBalance;
        data["carryForwardLeave"] = this.carryForwardLeave;
        data["id"] = this.id;
        return data;
    }
}

export interface ILeaveBlancesDto {
    employeeId: number | undefined;
    financeYear: string | undefined;
    leaveUsed: number | undefined;
    leaveType: number | undefined;
    leaveBalance: number | undefined;
    carryForwardLeave: number | undefined;
    id: number;
}

export class GetLeaveBlancesForViewDto implements IGetLeaveBlancesForViewDto {
    leaveBlances!: LeaveBlancesDto;
    leaveType!: string | undefined;
    employeeName!: string | undefined;
    employeeCode!: string | undefined;

    constructor(data?: IGetLeaveBlancesForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveBlances = _data["leaveBlances"] ? LeaveBlancesDto.fromJS(_data["leaveBlances"]) : <any>undefined;
            this.leaveType = _data["leaveType"];
            this.employeeName = _data["employeeName"];
            this.employeeCode = _data["employeeCode"];
        }
    }

    static fromJS(data: any): GetLeaveBlancesForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetLeaveBlancesForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveBlances"] = this.leaveBlances ? this.leaveBlances.toJSON() : <any>undefined;
        data["leaveType"] = this.leaveType;
        data["employeeName"] = this.employeeName;
        data["employeeCode"] = this.employeeCode;
        return data;
    }
}

export interface IGetLeaveBlancesForViewDto {
    leaveBlances: LeaveBlancesDto;
    leaveType: string | undefined;
    employeeName: string | undefined;
    employeeCode: string | undefined;
}

export class PagedResultDtoOfGetLeaveBlancesForViewDto implements IPagedResultDtoOfGetLeaveBlancesForViewDto {
    totalCount!: number;
    items!: GetLeaveBlancesForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetLeaveBlancesForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetLeaveBlancesForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetLeaveBlancesForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetLeaveBlancesForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetLeaveBlancesForViewDto {
    totalCount: number;
    items: GetLeaveBlancesForViewDto[] | undefined;
}

export class CreateOrEditLeaveBlancesDto implements ICreateOrEditLeaveBlancesDto {
    employeeId!: number | undefined;
    financeYear!: string | undefined;
    leaveUsed!: number | undefined;
    leaveType!: number | undefined;
    leaveAllow!: number | undefined;
    leaveCarryforwad!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditLeaveBlancesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.financeYear = _data["financeYear"];
            this.leaveUsed = _data["leaveUsed"];
            this.leaveType = _data["leaveType"];
            this.leaveAllow = _data["leaveAllow"];
            this.leaveCarryforwad = _data["leaveCarryforwad"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditLeaveBlancesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditLeaveBlancesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["financeYear"] = this.financeYear;
        data["leaveUsed"] = this.leaveUsed;
        data["leaveType"] = this.leaveType;
        data["leaveAllow"] = this.leaveAllow;
        data["leaveCarryforwad"] = this.leaveCarryforwad;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditLeaveBlancesDto {
    employeeId: number | undefined;
    financeYear: string | undefined;
    leaveUsed: number | undefined;
    leaveType: number | undefined;
    leaveAllow: number | undefined;
    leaveCarryforwad: number | undefined;
    id: number | undefined;
}

export class GetLeaveBlancesForEditOutput implements IGetLeaveBlancesForEditOutput {
    leaveBlances!: CreateOrEditLeaveBlancesDto;

    constructor(data?: IGetLeaveBlancesForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveBlances = _data["leaveBlances"] ? CreateOrEditLeaveBlancesDto.fromJS(_data["leaveBlances"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetLeaveBlancesForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLeaveBlancesForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveBlances"] = this.leaveBlances ? this.leaveBlances.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetLeaveBlancesForEditOutput {
    leaveBlances: CreateOrEditLeaveBlancesDto;
}

export class LeaveRequestsDto implements ILeaveRequestsDto {
    leaveTypeId!: number;
    leaveFrom!: moment.Moment | undefined;
    leaveTo!: moment.Moment | undefined;
    leaveDays!: number;
    requestReasons!: string | undefined;
    leaveStatus!: string | undefined;
    documentName!: string | undefined;
    documentUrl!: string | undefined;
    firstHalf!: boolean;
    secondHalf!: boolean;
    id!: number;

    constructor(data?: ILeaveRequestsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveTypeId = _data["leaveTypeId"];
            this.leaveFrom = _data["leaveFrom"] ? moment(_data["leaveFrom"].toString()) : <any>undefined;
            this.leaveTo = _data["leaveTo"] ? moment(_data["leaveTo"].toString()) : <any>undefined;
            this.leaveDays = _data["leaveDays"];
            this.requestReasons = _data["requestReasons"];
            this.leaveStatus = _data["leaveStatus"];
            this.documentName = _data["documentName"];
            this.documentUrl = _data["documentUrl"];
            this.firstHalf = _data["firstHalf"];
            this.secondHalf = _data["secondHalf"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LeaveRequestsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveRequestsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveTypeId"] = this.leaveTypeId;
        data["leaveFrom"] = this.leaveFrom ? this.leaveFrom.toISOString() : <any>undefined;
        data["leaveTo"] = this.leaveTo ? this.leaveTo.toISOString() : <any>undefined;
        data["leaveDays"] = this.leaveDays;
        data["requestReasons"] = this.requestReasons;
        data["leaveStatus"] = this.leaveStatus;
        data["documentName"] = this.documentName;
        data["documentUrl"] = this.documentUrl;
        data["firstHalf"] = this.firstHalf;
        data["secondHalf"] = this.secondHalf;
        data["id"] = this.id;
        return data;
    }
}

export interface ILeaveRequestsDto {
    leaveTypeId: number;
    leaveFrom: moment.Moment | undefined;
    leaveTo: moment.Moment | undefined;
    leaveDays: number;
    requestReasons: string | undefined;
    leaveStatus: string | undefined;
    documentName: string | undefined;
    documentUrl: string | undefined;
    firstHalf: boolean;
    secondHalf: boolean;
    id: number;
}

export class GetLeaveRequestsForViewDto implements IGetLeaveRequestsForViewDto {
    leaveRequests!: LeaveRequestsDto;
    leaveName!: string | undefined;
    requestedBy!: number | undefined;

    constructor(data?: IGetLeaveRequestsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveRequests = _data["leaveRequests"] ? LeaveRequestsDto.fromJS(_data["leaveRequests"]) : <any>undefined;
            this.leaveName = _data["leaveName"];
            this.requestedBy = _data["requestedBy"];
        }
    }

    static fromJS(data: any): GetLeaveRequestsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetLeaveRequestsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveRequests"] = this.leaveRequests ? this.leaveRequests.toJSON() : <any>undefined;
        data["leaveName"] = this.leaveName;
        data["requestedBy"] = this.requestedBy;
        return data;
    }
}

export interface IGetLeaveRequestsForViewDto {
    leaveRequests: LeaveRequestsDto;
    leaveName: string | undefined;
    requestedBy: number | undefined;
}

export class PagedResultDtoOfGetLeaveRequestsForViewDto implements IPagedResultDtoOfGetLeaveRequestsForViewDto {
    totalCount!: number;
    items!: GetLeaveRequestsForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetLeaveRequestsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetLeaveRequestsForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetLeaveRequestsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetLeaveRequestsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetLeaveRequestsForViewDto {
    totalCount: number;
    items: GetLeaveRequestsForViewDto[] | undefined;
}

export class LeaveOnSelfService implements ILeaveOnSelfService {
    leaveTypeId!: number;
    leavetype!: string | undefined;
    leavefrom!: moment.Moment | undefined;
    leaveto!: moment.Moment | undefined;
    leavedays!: number;
    reason!: string | undefined;
    status!: string | undefined;
    requestedOn!: moment.Moment | undefined;
    requestedBy!: number | undefined;
    id!: number | undefined;
    documentURL!: string | undefined;
    documentName!: string | undefined;
    firstHalf!: boolean;
    secondHalf!: boolean;

    constructor(data?: ILeaveOnSelfService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveTypeId = _data["leaveTypeId"];
            this.leavetype = _data["leavetype"];
            this.leavefrom = _data["leavefrom"] ? moment(_data["leavefrom"].toString()) : <any>undefined;
            this.leaveto = _data["leaveto"] ? moment(_data["leaveto"].toString()) : <any>undefined;
            this.leavedays = _data["leavedays"];
            this.reason = _data["reason"];
            this.status = _data["status"];
            this.requestedOn = _data["requestedOn"] ? moment(_data["requestedOn"].toString()) : <any>undefined;
            this.requestedBy = _data["requestedBy"];
            this.id = _data["id"];
            this.documentURL = _data["documentURL"];
            this.documentName = _data["documentName"];
            this.firstHalf = _data["firstHalf"];
            this.secondHalf = _data["secondHalf"];
        }
    }

    static fromJS(data: any): LeaveOnSelfService {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveOnSelfService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveTypeId"] = this.leaveTypeId;
        data["leavetype"] = this.leavetype;
        data["leavefrom"] = this.leavefrom ? this.leavefrom.toISOString() : <any>undefined;
        data["leaveto"] = this.leaveto ? this.leaveto.toISOString() : <any>undefined;
        data["leavedays"] = this.leavedays;
        data["reason"] = this.reason;
        data["status"] = this.status;
        data["requestedOn"] = this.requestedOn ? this.requestedOn.toISOString() : <any>undefined;
        data["requestedBy"] = this.requestedBy;
        data["id"] = this.id;
        data["documentURL"] = this.documentURL;
        data["documentName"] = this.documentName;
        data["firstHalf"] = this.firstHalf;
        data["secondHalf"] = this.secondHalf;
        return data;
    }
}

export interface ILeaveOnSelfService {
    leaveTypeId: number;
    leavetype: string | undefined;
    leavefrom: moment.Moment | undefined;
    leaveto: moment.Moment | undefined;
    leavedays: number;
    reason: string | undefined;
    status: string | undefined;
    requestedOn: moment.Moment | undefined;
    requestedBy: number | undefined;
    id: number | undefined;
    documentURL: string | undefined;
    documentName: string | undefined;
    firstHalf: boolean;
    secondHalf: boolean;
}

export class PagedResultDtoOfLeaveOnSelfService implements IPagedResultDtoOfLeaveOnSelfService {
    totalCount!: number;
    items!: LeaveOnSelfService[] | undefined;

    constructor(data?: IPagedResultDtoOfLeaveOnSelfService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LeaveOnSelfService.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLeaveOnSelfService {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLeaveOnSelfService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfLeaveOnSelfService {
    totalCount: number;
    items: LeaveOnSelfService[] | undefined;
}

export class CancelledLeaveDTO implements ICancelledLeaveDTO {
    leaveTypeId!: number;
    leaveFrom!: moment.Moment | undefined;
    leaveTo!: moment.Moment | undefined;
    leaveDays!: number;
    reportingManager!: boolean | undefined;
    requestReasons!: string | undefined;
    leaveStatus!: string | undefined;
    firstHalf!: boolean;
    secondHalf!: boolean;
    fromFullDay!: boolean;
    toFirstHalfFullDay!: boolean;
    fromSecondHalfFullDay!: boolean;
    toFullDay!: boolean;
    fromSecondHalf!: boolean;
    toFirstHalf!: boolean;
    fullDay!: boolean;
    cancelLeave!: boolean;
    cancelLeaveDate!: moment.Moment | undefined;
    documentName!: string | undefined;
    documentURL!: string | undefined;
    imagePath!: string | undefined;
    requestForApprovalLogId!: number | undefined;
    employeeId!: number | undefined;
    appliedID!: number;
    createdOn!: moment.Moment;
    id!: number | undefined;

    constructor(data?: ICancelledLeaveDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveTypeId = _data["leaveTypeId"];
            this.leaveFrom = _data["leaveFrom"] ? moment(_data["leaveFrom"].toString()) : <any>undefined;
            this.leaveTo = _data["leaveTo"] ? moment(_data["leaveTo"].toString()) : <any>undefined;
            this.leaveDays = _data["leaveDays"];
            this.reportingManager = _data["reportingManager"];
            this.requestReasons = _data["requestReasons"];
            this.leaveStatus = _data["leaveStatus"];
            this.firstHalf = _data["firstHalf"];
            this.secondHalf = _data["secondHalf"];
            this.fromFullDay = _data["fromFullDay"];
            this.toFirstHalfFullDay = _data["toFirstHalfFullDay"];
            this.fromSecondHalfFullDay = _data["fromSecondHalfFullDay"];
            this.toFullDay = _data["toFullDay"];
            this.fromSecondHalf = _data["fromSecondHalf"];
            this.toFirstHalf = _data["toFirstHalf"];
            this.fullDay = _data["fullDay"];
            this.cancelLeave = _data["cancelLeave"];
            this.cancelLeaveDate = _data["cancelLeaveDate"] ? moment(_data["cancelLeaveDate"].toString()) : <any>undefined;
            this.documentName = _data["documentName"];
            this.documentURL = _data["documentURL"];
            this.imagePath = _data["imagePath"];
            this.requestForApprovalLogId = _data["requestForApprovalLogId"];
            this.employeeId = _data["employeeId"];
            this.appliedID = _data["appliedID"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CancelledLeaveDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CancelledLeaveDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveTypeId"] = this.leaveTypeId;
        data["leaveFrom"] = this.leaveFrom ? this.leaveFrom.toISOString() : <any>undefined;
        data["leaveTo"] = this.leaveTo ? this.leaveTo.toISOString() : <any>undefined;
        data["leaveDays"] = this.leaveDays;
        data["reportingManager"] = this.reportingManager;
        data["requestReasons"] = this.requestReasons;
        data["leaveStatus"] = this.leaveStatus;
        data["firstHalf"] = this.firstHalf;
        data["secondHalf"] = this.secondHalf;
        data["fromFullDay"] = this.fromFullDay;
        data["toFirstHalfFullDay"] = this.toFirstHalfFullDay;
        data["fromSecondHalfFullDay"] = this.fromSecondHalfFullDay;
        data["toFullDay"] = this.toFullDay;
        data["fromSecondHalf"] = this.fromSecondHalf;
        data["toFirstHalf"] = this.toFirstHalf;
        data["fullDay"] = this.fullDay;
        data["cancelLeave"] = this.cancelLeave;
        data["cancelLeaveDate"] = this.cancelLeaveDate ? this.cancelLeaveDate.toISOString() : <any>undefined;
        data["documentName"] = this.documentName;
        data["documentURL"] = this.documentURL;
        data["imagePath"] = this.imagePath;
        data["requestForApprovalLogId"] = this.requestForApprovalLogId;
        data["employeeId"] = this.employeeId;
        data["appliedID"] = this.appliedID;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICancelledLeaveDTO {
    leaveTypeId: number;
    leaveFrom: moment.Moment | undefined;
    leaveTo: moment.Moment | undefined;
    leaveDays: number;
    reportingManager: boolean | undefined;
    requestReasons: string | undefined;
    leaveStatus: string | undefined;
    firstHalf: boolean;
    secondHalf: boolean;
    fromFullDay: boolean;
    toFirstHalfFullDay: boolean;
    fromSecondHalfFullDay: boolean;
    toFullDay: boolean;
    fromSecondHalf: boolean;
    toFirstHalf: boolean;
    fullDay: boolean;
    cancelLeave: boolean;
    cancelLeaveDate: moment.Moment | undefined;
    documentName: string | undefined;
    documentURL: string | undefined;
    imagePath: string | undefined;
    requestForApprovalLogId: number | undefined;
    employeeId: number | undefined;
    appliedID: number;
    createdOn: moment.Moment;
    id: number | undefined;
}

export class GetCancelledLeaveForViewDto implements IGetCancelledLeaveForViewDto {
    cancelledLeave!: CancelledLeaveDTO;
    leaveName!: string | undefined;

    constructor(data?: IGetCancelledLeaveForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cancelledLeave = _data["cancelledLeave"] ? CancelledLeaveDTO.fromJS(_data["cancelledLeave"]) : <any>undefined;
            this.leaveName = _data["leaveName"];
        }
    }

    static fromJS(data: any): GetCancelledLeaveForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCancelledLeaveForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cancelledLeave"] = this.cancelledLeave ? this.cancelledLeave.toJSON() : <any>undefined;
        data["leaveName"] = this.leaveName;
        return data;
    }
}

export interface IGetCancelledLeaveForViewDto {
    cancelledLeave: CancelledLeaveDTO;
    leaveName: string | undefined;
}

export class PagedResultDtoOfGetCancelledLeaveForViewDto implements IPagedResultDtoOfGetCancelledLeaveForViewDto {
    totalCount!: number;
    items!: GetCancelledLeaveForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCancelledLeaveForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetCancelledLeaveForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCancelledLeaveForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCancelledLeaveForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCancelledLeaveForViewDto {
    totalCount: number;
    items: GetCancelledLeaveForViewDto[] | undefined;
}

export class CreateOrEditLeaveRequestsDto implements ICreateOrEditLeaveRequestsDto {
    leaveTypeId!: number;
    leaveFrom!: moment.Moment | undefined;
    leaveTo!: moment.Moment | undefined;
    leaveDays!: number;
    reportingManager!: boolean | undefined;
    requestReasons!: string | undefined;
    leaveStatus!: string | undefined;
    firstHalf!: boolean;
    secondHalf!: boolean;
    fromFullDay!: boolean;
    toFirstHalfFullDay!: boolean;
    fromSecondHalfFullDay!: boolean;
    toFullDay!: boolean;
    fromSecondHalf!: boolean;
    toFirstHalf!: boolean;
    fullDay!: boolean;
    cancelLeave!: boolean;
    cancelLeaveDate!: moment.Moment | undefined;
    documentName!: string | undefined;
    documentURL!: string | undefined;
    imagePath!: string | undefined;
    requestForApprovalLogId!: number | undefined;
    employeeId!: number | undefined;
    appliedID!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditLeaveRequestsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveTypeId = _data["leaveTypeId"];
            this.leaveFrom = _data["leaveFrom"] ? moment(_data["leaveFrom"].toString()) : <any>undefined;
            this.leaveTo = _data["leaveTo"] ? moment(_data["leaveTo"].toString()) : <any>undefined;
            this.leaveDays = _data["leaveDays"];
            this.reportingManager = _data["reportingManager"];
            this.requestReasons = _data["requestReasons"];
            this.leaveStatus = _data["leaveStatus"];
            this.firstHalf = _data["firstHalf"];
            this.secondHalf = _data["secondHalf"];
            this.fromFullDay = _data["fromFullDay"];
            this.toFirstHalfFullDay = _data["toFirstHalfFullDay"];
            this.fromSecondHalfFullDay = _data["fromSecondHalfFullDay"];
            this.toFullDay = _data["toFullDay"];
            this.fromSecondHalf = _data["fromSecondHalf"];
            this.toFirstHalf = _data["toFirstHalf"];
            this.fullDay = _data["fullDay"];
            this.cancelLeave = _data["cancelLeave"];
            this.cancelLeaveDate = _data["cancelLeaveDate"] ? moment(_data["cancelLeaveDate"].toString()) : <any>undefined;
            this.documentName = _data["documentName"];
            this.documentURL = _data["documentURL"];
            this.imagePath = _data["imagePath"];
            this.requestForApprovalLogId = _data["requestForApprovalLogId"];
            this.employeeId = _data["employeeId"];
            this.appliedID = _data["appliedID"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditLeaveRequestsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditLeaveRequestsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveTypeId"] = this.leaveTypeId;
        data["leaveFrom"] = this.leaveFrom ? this.leaveFrom.toISOString() : <any>undefined;
        data["leaveTo"] = this.leaveTo ? this.leaveTo.toISOString() : <any>undefined;
        data["leaveDays"] = this.leaveDays;
        data["reportingManager"] = this.reportingManager;
        data["requestReasons"] = this.requestReasons;
        data["leaveStatus"] = this.leaveStatus;
        data["firstHalf"] = this.firstHalf;
        data["secondHalf"] = this.secondHalf;
        data["fromFullDay"] = this.fromFullDay;
        data["toFirstHalfFullDay"] = this.toFirstHalfFullDay;
        data["fromSecondHalfFullDay"] = this.fromSecondHalfFullDay;
        data["toFullDay"] = this.toFullDay;
        data["fromSecondHalf"] = this.fromSecondHalf;
        data["toFirstHalf"] = this.toFirstHalf;
        data["fullDay"] = this.fullDay;
        data["cancelLeave"] = this.cancelLeave;
        data["cancelLeaveDate"] = this.cancelLeaveDate ? this.cancelLeaveDate.toISOString() : <any>undefined;
        data["documentName"] = this.documentName;
        data["documentURL"] = this.documentURL;
        data["imagePath"] = this.imagePath;
        data["requestForApprovalLogId"] = this.requestForApprovalLogId;
        data["employeeId"] = this.employeeId;
        data["appliedID"] = this.appliedID;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditLeaveRequestsDto {
    leaveTypeId: number;
    leaveFrom: moment.Moment | undefined;
    leaveTo: moment.Moment | undefined;
    leaveDays: number;
    reportingManager: boolean | undefined;
    requestReasons: string | undefined;
    leaveStatus: string | undefined;
    firstHalf: boolean;
    secondHalf: boolean;
    fromFullDay: boolean;
    toFirstHalfFullDay: boolean;
    fromSecondHalfFullDay: boolean;
    toFullDay: boolean;
    fromSecondHalf: boolean;
    toFirstHalf: boolean;
    fullDay: boolean;
    cancelLeave: boolean;
    cancelLeaveDate: moment.Moment | undefined;
    documentName: string | undefined;
    documentURL: string | undefined;
    imagePath: string | undefined;
    requestForApprovalLogId: number | undefined;
    employeeId: number | undefined;
    appliedID: number;
    id: number | undefined;
}

export class EmployeesOnLeaveDto implements IEmployeesOnLeaveDto {
    employeeId!: number;
    employeeName!: string | undefined;
    fromDate!: moment.Moment;
    toDate!: moment.Moment;
    leaveType!: string | undefined;

    constructor(data?: IEmployeesOnLeaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>undefined;
            this.leaveType = _data["leaveType"];
        }
    }

    static fromJS(data: any): EmployeesOnLeaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeesOnLeaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["leaveType"] = this.leaveType;
        return data;
    }
}

export interface IEmployeesOnLeaveDto {
    employeeId: number;
    employeeName: string | undefined;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    leaveType: string | undefined;
}

export class GetLeaveRequestsForEditOutput implements IGetLeaveRequestsForEditOutput {
    leaveRequests!: CreateOrEditLeaveRequestsDto;
    leaveName!: string | undefined;
    requestedBy!: number | undefined;
    requestFlow!: string | undefined;
    leaveRejectStatus!: string | undefined;
    requestedOn!: moment.Moment | undefined;
    employeesOnLeave!: EmployeesOnLeaveDto[] | undefined;

    constructor(data?: IGetLeaveRequestsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveRequests = _data["leaveRequests"] ? CreateOrEditLeaveRequestsDto.fromJS(_data["leaveRequests"]) : <any>undefined;
            this.leaveName = _data["leaveName"];
            this.requestedBy = _data["requestedBy"];
            this.requestFlow = _data["requestFlow"];
            this.leaveRejectStatus = _data["leaveRejectStatus"];
            this.requestedOn = _data["requestedOn"] ? moment(_data["requestedOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["employeesOnLeave"])) {
                this.employeesOnLeave = [] as any;
                for (let item of _data["employeesOnLeave"])
                    this.employeesOnLeave!.push(EmployeesOnLeaveDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLeaveRequestsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLeaveRequestsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveRequests"] = this.leaveRequests ? this.leaveRequests.toJSON() : <any>undefined;
        data["leaveName"] = this.leaveName;
        data["requestedBy"] = this.requestedBy;
        data["requestFlow"] = this.requestFlow;
        data["leaveRejectStatus"] = this.leaveRejectStatus;
        data["requestedOn"] = this.requestedOn ? this.requestedOn.toISOString() : <any>undefined;
        if (Array.isArray(this.employeesOnLeave)) {
            data["employeesOnLeave"] = [];
            for (let item of this.employeesOnLeave)
                data["employeesOnLeave"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetLeaveRequestsForEditOutput {
    leaveRequests: CreateOrEditLeaveRequestsDto;
    leaveName: string | undefined;
    requestedBy: number | undefined;
    requestFlow: string | undefined;
    leaveRejectStatus: string | undefined;
    requestedOn: moment.Moment | undefined;
    employeesOnLeave: EmployeesOnLeaveDto[] | undefined;
}

export class GetLeaveRuleDateValidation implements IGetLeaveRuleDateValidation {
    maxDateForLeavedApplied!: number;

    constructor(data?: IGetLeaveRuleDateValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxDateForLeavedApplied = _data["maxDateForLeavedApplied"];
        }
    }

    static fromJS(data: any): GetLeaveRuleDateValidation {
        data = typeof data === 'object' ? data : {};
        let result = new GetLeaveRuleDateValidation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxDateForLeavedApplied"] = this.maxDateForLeavedApplied;
        return data;
    }
}

export interface IGetLeaveRuleDateValidation {
    maxDateForLeavedApplied: number;
}

export class CreateOrEditLeaveApplicationDto implements ICreateOrEditLeaveApplicationDto {
    leaveTypeId!: number;
    leaveFrom!: moment.Moment | undefined;
    leaveTo!: moment.Moment | undefined;
    leaveDays!: number;
    requestReasons!: string | undefined;
    leaveStatus!: string | undefined;
    createdBy!: number;
    createdOn!: moment.Moment;
    cancelLeave!: boolean;
    cancelLeaveDate!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditLeaveApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveTypeId = _data["leaveTypeId"];
            this.leaveFrom = _data["leaveFrom"] ? moment(_data["leaveFrom"].toString()) : <any>undefined;
            this.leaveTo = _data["leaveTo"] ? moment(_data["leaveTo"].toString()) : <any>undefined;
            this.leaveDays = _data["leaveDays"];
            this.requestReasons = _data["requestReasons"];
            this.leaveStatus = _data["leaveStatus"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.cancelLeave = _data["cancelLeave"];
            this.cancelLeaveDate = _data["cancelLeaveDate"] ? moment(_data["cancelLeaveDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditLeaveApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditLeaveApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveTypeId"] = this.leaveTypeId;
        data["leaveFrom"] = this.leaveFrom ? this.leaveFrom.toISOString() : <any>undefined;
        data["leaveTo"] = this.leaveTo ? this.leaveTo.toISOString() : <any>undefined;
        data["leaveDays"] = this.leaveDays;
        data["requestReasons"] = this.requestReasons;
        data["leaveStatus"] = this.leaveStatus;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["cancelLeave"] = this.cancelLeave;
        data["cancelLeaveDate"] = this.cancelLeaveDate ? this.cancelLeaveDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditLeaveApplicationDto {
    leaveTypeId: number;
    leaveFrom: moment.Moment | undefined;
    leaveTo: moment.Moment | undefined;
    leaveDays: number;
    requestReasons: string | undefined;
    leaveStatus: string | undefined;
    createdBy: number;
    createdOn: moment.Moment;
    cancelLeave: boolean;
    cancelLeaveDate: moment.Moment | undefined;
    id: number | undefined;
}

export class GetLeaveRequestDto implements IGetLeaveRequestDto {
    leaveRequests!: LeaveRequestsDto;
    leaveName!: string | undefined;
    requestedBy!: number | undefined;
    employeeName!: string | undefined;

    constructor(data?: IGetLeaveRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveRequests = _data["leaveRequests"] ? LeaveRequestsDto.fromJS(_data["leaveRequests"]) : <any>undefined;
            this.leaveName = _data["leaveName"];
            this.requestedBy = _data["requestedBy"];
            this.employeeName = _data["employeeName"];
        }
    }

    static fromJS(data: any): GetLeaveRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetLeaveRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveRequests"] = this.leaveRequests ? this.leaveRequests.toJSON() : <any>undefined;
        data["leaveName"] = this.leaveName;
        data["requestedBy"] = this.requestedBy;
        data["employeeName"] = this.employeeName;
        return data;
    }
}

export interface IGetLeaveRequestDto {
    leaveRequests: LeaveRequestsDto;
    leaveName: string | undefined;
    requestedBy: number | undefined;
    employeeName: string | undefined;
}

export class PagedResultDtoOfGetLeaveRequestDto implements IPagedResultDtoOfGetLeaveRequestDto {
    totalCount!: number;
    items!: GetLeaveRequestDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetLeaveRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetLeaveRequestDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetLeaveRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetLeaveRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetLeaveRequestDto {
    totalCount: number;
    items: GetLeaveRequestDto[] | undefined;
}

export class CreateOrEditManualLeaveDto implements ICreateOrEditManualLeaveDto {
    leaveTypeId!: number;
    leaveFrom!: moment.Moment | undefined;
    leaveTo!: moment.Moment | undefined;
    leaveDays!: number;
    requestReasons!: string | undefined;
    leaveStatus!: string | undefined;
    firstHalf!: boolean;
    secondHalf!: boolean;
    cancelLeave!: boolean;
    cancelLeaveDate!: moment.Moment | undefined;
    employeeId!: number;
    documentName!: string | undefined;
    documentURL!: string | undefined;
    appliedID!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditManualLeaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveTypeId = _data["leaveTypeId"];
            this.leaveFrom = _data["leaveFrom"] ? moment(_data["leaveFrom"].toString()) : <any>undefined;
            this.leaveTo = _data["leaveTo"] ? moment(_data["leaveTo"].toString()) : <any>undefined;
            this.leaveDays = _data["leaveDays"];
            this.requestReasons = _data["requestReasons"];
            this.leaveStatus = _data["leaveStatus"];
            this.firstHalf = _data["firstHalf"];
            this.secondHalf = _data["secondHalf"];
            this.cancelLeave = _data["cancelLeave"];
            this.cancelLeaveDate = _data["cancelLeaveDate"] ? moment(_data["cancelLeaveDate"].toString()) : <any>undefined;
            this.employeeId = _data["employeeId"];
            this.documentName = _data["documentName"];
            this.documentURL = _data["documentURL"];
            this.appliedID = _data["appliedID"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditManualLeaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditManualLeaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveTypeId"] = this.leaveTypeId;
        data["leaveFrom"] = this.leaveFrom ? this.leaveFrom.toISOString() : <any>undefined;
        data["leaveTo"] = this.leaveTo ? this.leaveTo.toISOString() : <any>undefined;
        data["leaveDays"] = this.leaveDays;
        data["requestReasons"] = this.requestReasons;
        data["leaveStatus"] = this.leaveStatus;
        data["firstHalf"] = this.firstHalf;
        data["secondHalf"] = this.secondHalf;
        data["cancelLeave"] = this.cancelLeave;
        data["cancelLeaveDate"] = this.cancelLeaveDate ? this.cancelLeaveDate.toISOString() : <any>undefined;
        data["employeeId"] = this.employeeId;
        data["documentName"] = this.documentName;
        data["documentURL"] = this.documentURL;
        data["appliedID"] = this.appliedID;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditManualLeaveDto {
    leaveTypeId: number;
    leaveFrom: moment.Moment | undefined;
    leaveTo: moment.Moment | undefined;
    leaveDays: number;
    requestReasons: string | undefined;
    leaveStatus: string | undefined;
    firstHalf: boolean;
    secondHalf: boolean;
    cancelLeave: boolean;
    cancelLeaveDate: moment.Moment | undefined;
    employeeId: number;
    documentName: string | undefined;
    documentURL: string | undefined;
    appliedID: number;
    id: number | undefined;
}

export class CreateLeaveRequest implements ICreateLeaveRequest {
    employeeId!: number;
    leaveRequestss!: CreateOrEditLeaveRequestsDto;

    constructor(data?: ICreateLeaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.leaveRequestss = _data["leaveRequestss"] ? CreateOrEditLeaveRequestsDto.fromJS(_data["leaveRequestss"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateLeaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLeaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["leaveRequestss"] = this.leaveRequestss ? this.leaveRequestss.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateLeaveRequest {
    employeeId: number;
    leaveRequestss: CreateOrEditLeaveRequestsDto;
}

export class PagedResultDtoOfGetLeaveRequestsForEditOutput implements IPagedResultDtoOfGetLeaveRequestsForEditOutput {
    totalCount!: number;
    items!: GetLeaveRequestsForEditOutput[] | undefined;

    constructor(data?: IPagedResultDtoOfGetLeaveRequestsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetLeaveRequestsForEditOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetLeaveRequestsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetLeaveRequestsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetLeaveRequestsForEditOutput {
    totalCount: number;
    items: GetLeaveRequestsForEditOutput[] | undefined;
}

export class LeaveBalanceYearDto implements ILeaveBalanceYearDto {
    year!: string | undefined;
    bf!: number;
    accrued!: number;
    used!: number;
    cf!: number;

    constructor(data?: ILeaveBalanceYearDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.bf = _data["bf"];
            this.accrued = _data["accrued"];
            this.used = _data["used"];
            this.cf = _data["cf"];
        }
    }

    static fromJS(data: any): LeaveBalanceYearDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveBalanceYearDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["bf"] = this.bf;
        data["accrued"] = this.accrued;
        data["used"] = this.used;
        data["cf"] = this.cf;
        return data;
    }
}

export interface ILeaveBalanceYearDto {
    year: string | undefined;
    bf: number;
    accrued: number;
    used: number;
    cf: number;
}

export class LeaveBalanceDto implements ILeaveBalanceDto {
    balance!: number;
    actualBalance!: number;
    carryForward!: boolean;
    limit!: number;
    leaveBalanceHistory!: LeaveBalanceYearDto[] | undefined;

    constructor(data?: ILeaveBalanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.balance = _data["balance"];
            this.actualBalance = _data["actualBalance"];
            this.carryForward = _data["carryForward"];
            this.limit = _data["limit"];
            if (Array.isArray(_data["leaveBalanceHistory"])) {
                this.leaveBalanceHistory = [] as any;
                for (let item of _data["leaveBalanceHistory"])
                    this.leaveBalanceHistory!.push(LeaveBalanceYearDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LeaveBalanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveBalanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["balance"] = this.balance;
        data["actualBalance"] = this.actualBalance;
        data["carryForward"] = this.carryForward;
        data["limit"] = this.limit;
        if (Array.isArray(this.leaveBalanceHistory)) {
            data["leaveBalanceHistory"] = [];
            for (let item of this.leaveBalanceHistory)
                data["leaveBalanceHistory"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILeaveBalanceDto {
    balance: number;
    actualBalance: number;
    carryForward: boolean;
    limit: number;
    leaveBalanceHistory: LeaveBalanceYearDto[] | undefined;
}

export class ValueTupleOfDateTimeDateTimeInt32 implements IValueTupleOfDateTimeDateTimeInt32 {
    item1!: moment.Moment;
    item2!: moment.Moment;
    item3!: number;

    constructor(data?: IValueTupleOfDateTimeDateTimeInt32) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item1 = _data["item1"] ? moment(_data["item1"].toString()) : <any>undefined;
            this.item2 = _data["item2"] ? moment(_data["item2"].toString()) : <any>undefined;
            this.item3 = _data["item3"];
        }
    }

    static fromJS(data: any): ValueTupleOfDateTimeDateTimeInt32 {
        data = typeof data === 'object' ? data : {};
        let result = new ValueTupleOfDateTimeDateTimeInt32();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toISOString() : <any>undefined;
        data["item2"] = this.item2 ? this.item2.toISOString() : <any>undefined;
        data["item3"] = this.item3;
        return data;
    }
}

export interface IValueTupleOfDateTimeDateTimeInt32 {
    item1: moment.Moment;
    item2: moment.Moment;
    item3: number;
}

export class LeaveRuleDto implements ILeaveRuleDto {
    leaveTypeId!: number;
    leaveCycle!: number;
    halfDayLeaveAllowed!: boolean;
    miximumLeaveRequestperYear!: number | undefined;
    miximumLeaveRequestperMonth!: number | undefined;
    miximumLeavesPerMonth!: number | undefined;
    minimumLeavePerRequest!: number | undefined;
    miximumLeavePerRequest!: number | undefined;
    priorDaysRequiredRequestLeave!: number | undefined;
    includeWeeklyOffasLeave!: boolean;
    whenLeaveIsAppliedBeforeWeeklyOff!: number | undefined;
    includeHolidayasLeave!: boolean;
    whenLeaveIsAppliedBeforeHoliday!: number | undefined;
    negativeBalanceAllowed!: boolean;
    canApplyasLeaveWithoutPay!: string | undefined;
    carryForwardToNextYear!: boolean;
    carryForwardLimit!: number | undefined;
    maxAccruedAndCarryForwardLimit!: number | undefined;
    leaveEncashable!: boolean;
    miximumEncashmentLimit!: number | undefined;
    minimumBalanceLimitAfterEncashment!: number | undefined;
    documentRequiredWhenLeaveMoreThan!: number | undefined;
    applicableForLTA!: boolean;
    unpaidLeave!: boolean;
    backDatedLeaveAllowed!: boolean;
    backDatedLeaveAllowedDays!: number | undefined;
    allowPartialLeaveCancellation!: boolean;
    leaveClubbingNotAllowedWith!: boolean;
    leaveClubbingNotAllowedWithLeaveType!: string | undefined;
    doYouWantToCreditLeave!: number | undefined;
    noOfCreditLeave!: number | undefined;
    leaveWillBeCreditedAt!: number | undefined;
    basedOn!: number | undefined;
    basedOnCondition!: number | undefined;
    basedOnDay!: number | undefined;
    leaveWillBe!: number | undefined;
    leaveWillBeAvail!: number | undefined;
    leaveWillBeCreditedAtMonthDay!: string | undefined;
    leaveOpeningBalalnce!: number | undefined;
    leaveCreditAtTimeOfJoining!: number | undefined;
    creditRuleBasedonEmployee!: boolean;
    creditRuleBasedonEmployeeStatusList!: string | undefined;
    leaveEligibilityrule!: string | undefined;
    paidDaysDeductionRule!: string | undefined;
    leaveBalancecreditrule!: string | undefined;
    id!: number;

    constructor(data?: ILeaveRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveTypeId = _data["leaveTypeId"];
            this.leaveCycle = _data["leaveCycle"];
            this.halfDayLeaveAllowed = _data["halfDayLeaveAllowed"];
            this.miximumLeaveRequestperYear = _data["miximumLeaveRequestperYear"];
            this.miximumLeaveRequestperMonth = _data["miximumLeaveRequestperMonth"];
            this.miximumLeavesPerMonth = _data["miximumLeavesPerMonth"];
            this.minimumLeavePerRequest = _data["minimumLeavePerRequest"];
            this.miximumLeavePerRequest = _data["miximumLeavePerRequest"];
            this.priorDaysRequiredRequestLeave = _data["priorDaysRequiredRequestLeave"];
            this.includeWeeklyOffasLeave = _data["includeWeeklyOffasLeave"];
            this.whenLeaveIsAppliedBeforeWeeklyOff = _data["whenLeaveIsAppliedBeforeWeeklyOff"];
            this.includeHolidayasLeave = _data["includeHolidayasLeave"];
            this.whenLeaveIsAppliedBeforeHoliday = _data["whenLeaveIsAppliedBeforeHoliday"];
            this.negativeBalanceAllowed = _data["negativeBalanceAllowed"];
            this.canApplyasLeaveWithoutPay = _data["canApplyasLeaveWithoutPay"];
            this.carryForwardToNextYear = _data["carryForwardToNextYear"];
            this.carryForwardLimit = _data["carryForwardLimit"];
            this.maxAccruedAndCarryForwardLimit = _data["maxAccruedAndCarryForwardLimit"];
            this.leaveEncashable = _data["leaveEncashable"];
            this.miximumEncashmentLimit = _data["miximumEncashmentLimit"];
            this.minimumBalanceLimitAfterEncashment = _data["minimumBalanceLimitAfterEncashment"];
            this.documentRequiredWhenLeaveMoreThan = _data["documentRequiredWhenLeaveMoreThan"];
            this.applicableForLTA = _data["applicableForLTA"];
            this.unpaidLeave = _data["unpaidLeave"];
            this.backDatedLeaveAllowed = _data["backDatedLeaveAllowed"];
            this.backDatedLeaveAllowedDays = _data["backDatedLeaveAllowedDays"];
            this.allowPartialLeaveCancellation = _data["allowPartialLeaveCancellation"];
            this.leaveClubbingNotAllowedWith = _data["leaveClubbingNotAllowedWith"];
            this.leaveClubbingNotAllowedWithLeaveType = _data["leaveClubbingNotAllowedWithLeaveType"];
            this.doYouWantToCreditLeave = _data["doYouWantToCreditLeave"];
            this.noOfCreditLeave = _data["noOfCreditLeave"];
            this.leaveWillBeCreditedAt = _data["leaveWillBeCreditedAt"];
            this.basedOn = _data["basedOn"];
            this.basedOnCondition = _data["basedOnCondition"];
            this.basedOnDay = _data["basedOnDay"];
            this.leaveWillBe = _data["leaveWillBe"];
            this.leaveWillBeAvail = _data["leaveWillBeAvail"];
            this.leaveWillBeCreditedAtMonthDay = _data["leaveWillBeCreditedAtMonthDay"];
            this.leaveOpeningBalalnce = _data["leaveOpeningBalalnce"];
            this.leaveCreditAtTimeOfJoining = _data["leaveCreditAtTimeOfJoining"];
            this.creditRuleBasedonEmployee = _data["creditRuleBasedonEmployee"];
            this.creditRuleBasedonEmployeeStatusList = _data["creditRuleBasedonEmployeeStatusList"];
            this.leaveEligibilityrule = _data["leaveEligibilityrule"];
            this.paidDaysDeductionRule = _data["paidDaysDeductionRule"];
            this.leaveBalancecreditrule = _data["leaveBalancecreditrule"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LeaveRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveTypeId"] = this.leaveTypeId;
        data["leaveCycle"] = this.leaveCycle;
        data["halfDayLeaveAllowed"] = this.halfDayLeaveAllowed;
        data["miximumLeaveRequestperYear"] = this.miximumLeaveRequestperYear;
        data["miximumLeaveRequestperMonth"] = this.miximumLeaveRequestperMonth;
        data["miximumLeavesPerMonth"] = this.miximumLeavesPerMonth;
        data["minimumLeavePerRequest"] = this.minimumLeavePerRequest;
        data["miximumLeavePerRequest"] = this.miximumLeavePerRequest;
        data["priorDaysRequiredRequestLeave"] = this.priorDaysRequiredRequestLeave;
        data["includeWeeklyOffasLeave"] = this.includeWeeklyOffasLeave;
        data["whenLeaveIsAppliedBeforeWeeklyOff"] = this.whenLeaveIsAppliedBeforeWeeklyOff;
        data["includeHolidayasLeave"] = this.includeHolidayasLeave;
        data["whenLeaveIsAppliedBeforeHoliday"] = this.whenLeaveIsAppliedBeforeHoliday;
        data["negativeBalanceAllowed"] = this.negativeBalanceAllowed;
        data["canApplyasLeaveWithoutPay"] = this.canApplyasLeaveWithoutPay;
        data["carryForwardToNextYear"] = this.carryForwardToNextYear;
        data["carryForwardLimit"] = this.carryForwardLimit;
        data["maxAccruedAndCarryForwardLimit"] = this.maxAccruedAndCarryForwardLimit;
        data["leaveEncashable"] = this.leaveEncashable;
        data["miximumEncashmentLimit"] = this.miximumEncashmentLimit;
        data["minimumBalanceLimitAfterEncashment"] = this.minimumBalanceLimitAfterEncashment;
        data["documentRequiredWhenLeaveMoreThan"] = this.documentRequiredWhenLeaveMoreThan;
        data["applicableForLTA"] = this.applicableForLTA;
        data["unpaidLeave"] = this.unpaidLeave;
        data["backDatedLeaveAllowed"] = this.backDatedLeaveAllowed;
        data["backDatedLeaveAllowedDays"] = this.backDatedLeaveAllowedDays;
        data["allowPartialLeaveCancellation"] = this.allowPartialLeaveCancellation;
        data["leaveClubbingNotAllowedWith"] = this.leaveClubbingNotAllowedWith;
        data["leaveClubbingNotAllowedWithLeaveType"] = this.leaveClubbingNotAllowedWithLeaveType;
        data["doYouWantToCreditLeave"] = this.doYouWantToCreditLeave;
        data["noOfCreditLeave"] = this.noOfCreditLeave;
        data["leaveWillBeCreditedAt"] = this.leaveWillBeCreditedAt;
        data["basedOn"] = this.basedOn;
        data["basedOnCondition"] = this.basedOnCondition;
        data["basedOnDay"] = this.basedOnDay;
        data["leaveWillBe"] = this.leaveWillBe;
        data["leaveWillBeAvail"] = this.leaveWillBeAvail;
        data["leaveWillBeCreditedAtMonthDay"] = this.leaveWillBeCreditedAtMonthDay;
        data["leaveOpeningBalalnce"] = this.leaveOpeningBalalnce;
        data["leaveCreditAtTimeOfJoining"] = this.leaveCreditAtTimeOfJoining;
        data["creditRuleBasedonEmployee"] = this.creditRuleBasedonEmployee;
        data["creditRuleBasedonEmployeeStatusList"] = this.creditRuleBasedonEmployeeStatusList;
        data["leaveEligibilityrule"] = this.leaveEligibilityrule;
        data["paidDaysDeductionRule"] = this.paidDaysDeductionRule;
        data["leaveBalancecreditrule"] = this.leaveBalancecreditrule;
        data["id"] = this.id;
        return data;
    }
}

export interface ILeaveRuleDto {
    leaveTypeId: number;
    leaveCycle: number;
    halfDayLeaveAllowed: boolean;
    miximumLeaveRequestperYear: number | undefined;
    miximumLeaveRequestperMonth: number | undefined;
    miximumLeavesPerMonth: number | undefined;
    minimumLeavePerRequest: number | undefined;
    miximumLeavePerRequest: number | undefined;
    priorDaysRequiredRequestLeave: number | undefined;
    includeWeeklyOffasLeave: boolean;
    whenLeaveIsAppliedBeforeWeeklyOff: number | undefined;
    includeHolidayasLeave: boolean;
    whenLeaveIsAppliedBeforeHoliday: number | undefined;
    negativeBalanceAllowed: boolean;
    canApplyasLeaveWithoutPay: string | undefined;
    carryForwardToNextYear: boolean;
    carryForwardLimit: number | undefined;
    maxAccruedAndCarryForwardLimit: number | undefined;
    leaveEncashable: boolean;
    miximumEncashmentLimit: number | undefined;
    minimumBalanceLimitAfterEncashment: number | undefined;
    documentRequiredWhenLeaveMoreThan: number | undefined;
    applicableForLTA: boolean;
    unpaidLeave: boolean;
    backDatedLeaveAllowed: boolean;
    backDatedLeaveAllowedDays: number | undefined;
    allowPartialLeaveCancellation: boolean;
    leaveClubbingNotAllowedWith: boolean;
    leaveClubbingNotAllowedWithLeaveType: string | undefined;
    doYouWantToCreditLeave: number | undefined;
    noOfCreditLeave: number | undefined;
    leaveWillBeCreditedAt: number | undefined;
    basedOn: number | undefined;
    basedOnCondition: number | undefined;
    basedOnDay: number | undefined;
    leaveWillBe: number | undefined;
    leaveWillBeAvail: number | undefined;
    leaveWillBeCreditedAtMonthDay: string | undefined;
    leaveOpeningBalalnce: number | undefined;
    leaveCreditAtTimeOfJoining: number | undefined;
    creditRuleBasedonEmployee: boolean;
    creditRuleBasedonEmployeeStatusList: string | undefined;
    leaveEligibilityrule: string | undefined;
    paidDaysDeductionRule: string | undefined;
    leaveBalancecreditrule: string | undefined;
    id: number;
}

export class GetLeaveRuleForViewDto implements IGetLeaveRuleForViewDto {
    leaveRule!: LeaveRuleDto;
    leaveTypeName!: string | undefined;
    leaveCycleName!: string | undefined;
    leaveType!: string | undefined;

    constructor(data?: IGetLeaveRuleForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveRule = _data["leaveRule"] ? LeaveRuleDto.fromJS(_data["leaveRule"]) : <any>undefined;
            this.leaveTypeName = _data["leaveTypeName"];
            this.leaveCycleName = _data["leaveCycleName"];
            this.leaveType = _data["leaveType"];
        }
    }

    static fromJS(data: any): GetLeaveRuleForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetLeaveRuleForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveRule"] = this.leaveRule ? this.leaveRule.toJSON() : <any>undefined;
        data["leaveTypeName"] = this.leaveTypeName;
        data["leaveCycleName"] = this.leaveCycleName;
        data["leaveType"] = this.leaveType;
        return data;
    }
}

export interface IGetLeaveRuleForViewDto {
    leaveRule: LeaveRuleDto;
    leaveTypeName: string | undefined;
    leaveCycleName: string | undefined;
    leaveType: string | undefined;
}

export class PagedResultDtoOfGetLeaveRuleForViewDto implements IPagedResultDtoOfGetLeaveRuleForViewDto {
    totalCount!: number;
    items!: GetLeaveRuleForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetLeaveRuleForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetLeaveRuleForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetLeaveRuleForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetLeaveRuleForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetLeaveRuleForViewDto {
    totalCount: number;
    items: GetLeaveRuleForViewDto[] | undefined;
}

export class LeaveCreditedAtMonthDay implements ILeaveCreditedAtMonthDay {
    day!: number;
    noOfCreditLeave!: number;

    constructor(data?: ILeaveCreditedAtMonthDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"];
            this.noOfCreditLeave = _data["noOfCreditLeave"];
        }
    }

    static fromJS(data: any): LeaveCreditedAtMonthDay {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveCreditedAtMonthDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day;
        data["noOfCreditLeave"] = this.noOfCreditLeave;
        return data;
    }
}

export interface ILeaveCreditedAtMonthDay {
    day: number;
    noOfCreditLeave: number;
}

export class CreditRuleOnEmployeeStatus implements ICreditRuleOnEmployeeStatus {
    employeeStatus!: number;
    noOfLeave!: number;
    frequency!: number;

    constructor(data?: ICreditRuleOnEmployeeStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeStatus = _data["employeeStatus"];
            this.noOfLeave = _data["noOfLeave"];
            this.frequency = _data["frequency"];
        }
    }

    static fromJS(data: any): CreditRuleOnEmployeeStatus {
        data = typeof data === 'object' ? data : {};
        let result = new CreditRuleOnEmployeeStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeStatus"] = this.employeeStatus;
        data["noOfLeave"] = this.noOfLeave;
        data["frequency"] = this.frequency;
        return data;
    }
}

export interface ICreditRuleOnEmployeeStatus {
    employeeStatus: number;
    noOfLeave: number;
    frequency: number;
}

export class LeaveEligibilityRule implements ILeaveEligibilityRule {
    eligibilityRule!: number;
    eligibilityMulti!: string[] | undefined;
    eligibility!: string | undefined;
    eligibilityCondition!: string | undefined;
    conditionDay!: string | undefined;
    includeAbsentDays!: boolean;

    constructor(data?: ILeaveEligibilityRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eligibilityRule = _data["eligibilityRule"];
            if (Array.isArray(_data["eligibilityMulti"])) {
                this.eligibilityMulti = [] as any;
                for (let item of _data["eligibilityMulti"])
                    this.eligibilityMulti!.push(item);
            }
            this.eligibility = _data["eligibility"];
            this.eligibilityCondition = _data["eligibilityCondition"];
            this.conditionDay = _data["conditionDay"];
            this.includeAbsentDays = _data["includeAbsentDays"];
        }
    }

    static fromJS(data: any): LeaveEligibilityRule {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveEligibilityRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eligibilityRule"] = this.eligibilityRule;
        if (Array.isArray(this.eligibilityMulti)) {
            data["eligibilityMulti"] = [];
            for (let item of this.eligibilityMulti)
                data["eligibilityMulti"].push(item);
        }
        data["eligibility"] = this.eligibility;
        data["eligibilityCondition"] = this.eligibilityCondition;
        data["conditionDay"] = this.conditionDay;
        data["includeAbsentDays"] = this.includeAbsentDays;
        return data;
    }
}

export interface ILeaveEligibilityRule {
    eligibilityRule: number;
    eligibilityMulti: string[] | undefined;
    eligibility: string | undefined;
    eligibilityCondition: string | undefined;
    conditionDay: string | undefined;
    includeAbsentDays: boolean;
}

export class PaidDayDeductionRule implements IPaidDayDeductionRule {
    leaverangeFrom!: number;
    leaverangeTo!: number;
    salaryDeduction!: number;

    constructor(data?: IPaidDayDeductionRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaverangeFrom = _data["leaverangeFrom"];
            this.leaverangeTo = _data["leaverangeTo"];
            this.salaryDeduction = _data["salaryDeduction"];
        }
    }

    static fromJS(data: any): PaidDayDeductionRule {
        data = typeof data === 'object' ? data : {};
        let result = new PaidDayDeductionRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaverangeFrom"] = this.leaverangeFrom;
        data["leaverangeTo"] = this.leaverangeTo;
        data["salaryDeduction"] = this.salaryDeduction;
        return data;
    }
}

export interface IPaidDayDeductionRule {
    leaverangeFrom: number;
    leaverangeTo: number;
    salaryDeduction: number;
}

export class CreateOrEditLeaveRuleDto implements ICreateOrEditLeaveRuleDto {
    leaveTypeId!: number;
    leaveName!: string | undefined;
    leaveCycle!: number;
    halfDayLeaveAllowed!: boolean;
    miximumLeaveRequestperYear!: number | undefined;
    miximumLeaveRequestperMonth!: number | undefined;
    miximumLeavesPerMonth!: number | undefined;
    minimumLeavePerRequest!: number | undefined;
    miximumLeavePerRequest!: number | undefined;
    priorDaysRequiredRequestLeave!: number | undefined;
    includeWeeklyOffasLeave!: boolean;
    whenLeaveIsAppliedBeforeWeeklyOff!: number | undefined;
    includeHolidayasLeave!: boolean;
    whenLeaveIsAppliedBeforeHoliday!: number | undefined;
    negativeBalanceAllowed!: boolean;
    canApplyasLeaveWithoutPay!: string | undefined;
    carryForwardToNextYear!: boolean;
    carryForwardLimit!: number | undefined;
    carryForwardFrequency!: number | undefined;
    carryForwardLapsed!: number | undefined;
    maxAccruedAndCarryForwardLimit!: number | undefined;
    leaveEncashable!: boolean;
    miximumEncashmentLimit!: number | undefined;
    minimumBalanceLimitAfterEncashment!: number | undefined;
    documentRequiredWhenLeaveMoreThan!: number | undefined;
    applicableForLTA!: boolean;
    unpaidLeave!: boolean;
    backDatedLeaveAllowed!: boolean;
    backDatedLeaveAllowedDays!: number | undefined;
    allowPartialLeaveCancellation!: boolean;
    leaveClubbingNotAllowedWith!: boolean;
    leaveClubbingNotAllowedWithLeaveType!: string | undefined;
    doYouWantToCreditLeave!: number | undefined;
    noOfCreditLeave!: number | undefined;
    leaveWillBeCreditedAt!: number | undefined;
    basedOn!: number | undefined;
    basedOnCondition!: number | undefined;
    basedOnDay!: number | undefined;
    leaveWillBe!: number | undefined;
    leaveWillBeAvail!: number | undefined;
    leaveWillBeCreditedAtMonthDay!: string | undefined;
    leaveOpeningBalalnce!: number | undefined;
    leaveCreditAtTimeOfJoining!: number | undefined;
    creditRuleBasedonEmployee!: boolean;
    creditRuleBasedonEmployeeStatusList!: string | undefined;
    leaveEligibilityRule!: string | undefined;
    paidDaysDeductionRule!: string | undefined;
    leaveCreditedAtMonthDayList!: LeaveCreditedAtMonthDay[] | undefined;
    creditRuleEmployeeStatusList!: CreditRuleOnEmployeeStatus[] | undefined;
    leaveEligibilityRuleList!: LeaveEligibilityRule[] | undefined;
    paidDayDeductionRuleList!: PaidDayDeductionRule[] | undefined;
    dayofDOJMonth_Elgibility!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditLeaveRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveTypeId = _data["leaveTypeId"];
            this.leaveName = _data["leaveName"];
            this.leaveCycle = _data["leaveCycle"];
            this.halfDayLeaveAllowed = _data["halfDayLeaveAllowed"];
            this.miximumLeaveRequestperYear = _data["miximumLeaveRequestperYear"];
            this.miximumLeaveRequestperMonth = _data["miximumLeaveRequestperMonth"];
            this.miximumLeavesPerMonth = _data["miximumLeavesPerMonth"];
            this.minimumLeavePerRequest = _data["minimumLeavePerRequest"];
            this.miximumLeavePerRequest = _data["miximumLeavePerRequest"];
            this.priorDaysRequiredRequestLeave = _data["priorDaysRequiredRequestLeave"];
            this.includeWeeklyOffasLeave = _data["includeWeeklyOffasLeave"];
            this.whenLeaveIsAppliedBeforeWeeklyOff = _data["whenLeaveIsAppliedBeforeWeeklyOff"];
            this.includeHolidayasLeave = _data["includeHolidayasLeave"];
            this.whenLeaveIsAppliedBeforeHoliday = _data["whenLeaveIsAppliedBeforeHoliday"];
            this.negativeBalanceAllowed = _data["negativeBalanceAllowed"];
            this.canApplyasLeaveWithoutPay = _data["canApplyasLeaveWithoutPay"];
            this.carryForwardToNextYear = _data["carryForwardToNextYear"];
            this.carryForwardLimit = _data["carryForwardLimit"];
            this.carryForwardFrequency = _data["carryForwardFrequency"];
            this.carryForwardLapsed = _data["carryForwardLapsed"];
            this.maxAccruedAndCarryForwardLimit = _data["maxAccruedAndCarryForwardLimit"];
            this.leaveEncashable = _data["leaveEncashable"];
            this.miximumEncashmentLimit = _data["miximumEncashmentLimit"];
            this.minimumBalanceLimitAfterEncashment = _data["minimumBalanceLimitAfterEncashment"];
            this.documentRequiredWhenLeaveMoreThan = _data["documentRequiredWhenLeaveMoreThan"];
            this.applicableForLTA = _data["applicableForLTA"];
            this.unpaidLeave = _data["unpaidLeave"];
            this.backDatedLeaveAllowed = _data["backDatedLeaveAllowed"];
            this.backDatedLeaveAllowedDays = _data["backDatedLeaveAllowedDays"];
            this.allowPartialLeaveCancellation = _data["allowPartialLeaveCancellation"];
            this.leaveClubbingNotAllowedWith = _data["leaveClubbingNotAllowedWith"];
            this.leaveClubbingNotAllowedWithLeaveType = _data["leaveClubbingNotAllowedWithLeaveType"];
            this.doYouWantToCreditLeave = _data["doYouWantToCreditLeave"];
            this.noOfCreditLeave = _data["noOfCreditLeave"];
            this.leaveWillBeCreditedAt = _data["leaveWillBeCreditedAt"];
            this.basedOn = _data["basedOn"];
            this.basedOnCondition = _data["basedOnCondition"];
            this.basedOnDay = _data["basedOnDay"];
            this.leaveWillBe = _data["leaveWillBe"];
            this.leaveWillBeAvail = _data["leaveWillBeAvail"];
            this.leaveWillBeCreditedAtMonthDay = _data["leaveWillBeCreditedAtMonthDay"];
            this.leaveOpeningBalalnce = _data["leaveOpeningBalalnce"];
            this.leaveCreditAtTimeOfJoining = _data["leaveCreditAtTimeOfJoining"];
            this.creditRuleBasedonEmployee = _data["creditRuleBasedonEmployee"];
            this.creditRuleBasedonEmployeeStatusList = _data["creditRuleBasedonEmployeeStatusList"];
            this.leaveEligibilityRule = _data["leaveEligibilityRule"];
            this.paidDaysDeductionRule = _data["paidDaysDeductionRule"];
            if (Array.isArray(_data["leaveCreditedAtMonthDayList"])) {
                this.leaveCreditedAtMonthDayList = [] as any;
                for (let item of _data["leaveCreditedAtMonthDayList"])
                    this.leaveCreditedAtMonthDayList!.push(LeaveCreditedAtMonthDay.fromJS(item));
            }
            if (Array.isArray(_data["creditRuleEmployeeStatusList"])) {
                this.creditRuleEmployeeStatusList = [] as any;
                for (let item of _data["creditRuleEmployeeStatusList"])
                    this.creditRuleEmployeeStatusList!.push(CreditRuleOnEmployeeStatus.fromJS(item));
            }
            if (Array.isArray(_data["leaveEligibilityRuleList"])) {
                this.leaveEligibilityRuleList = [] as any;
                for (let item of _data["leaveEligibilityRuleList"])
                    this.leaveEligibilityRuleList!.push(LeaveEligibilityRule.fromJS(item));
            }
            if (Array.isArray(_data["paidDayDeductionRuleList"])) {
                this.paidDayDeductionRuleList = [] as any;
                for (let item of _data["paidDayDeductionRuleList"])
                    this.paidDayDeductionRuleList!.push(PaidDayDeductionRule.fromJS(item));
            }
            this.dayofDOJMonth_Elgibility = _data["dayofDOJMonth_Elgibility"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditLeaveRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditLeaveRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveTypeId"] = this.leaveTypeId;
        data["leaveName"] = this.leaveName;
        data["leaveCycle"] = this.leaveCycle;
        data["halfDayLeaveAllowed"] = this.halfDayLeaveAllowed;
        data["miximumLeaveRequestperYear"] = this.miximumLeaveRequestperYear;
        data["miximumLeaveRequestperMonth"] = this.miximumLeaveRequestperMonth;
        data["miximumLeavesPerMonth"] = this.miximumLeavesPerMonth;
        data["minimumLeavePerRequest"] = this.minimumLeavePerRequest;
        data["miximumLeavePerRequest"] = this.miximumLeavePerRequest;
        data["priorDaysRequiredRequestLeave"] = this.priorDaysRequiredRequestLeave;
        data["includeWeeklyOffasLeave"] = this.includeWeeklyOffasLeave;
        data["whenLeaveIsAppliedBeforeWeeklyOff"] = this.whenLeaveIsAppliedBeforeWeeklyOff;
        data["includeHolidayasLeave"] = this.includeHolidayasLeave;
        data["whenLeaveIsAppliedBeforeHoliday"] = this.whenLeaveIsAppliedBeforeHoliday;
        data["negativeBalanceAllowed"] = this.negativeBalanceAllowed;
        data["canApplyasLeaveWithoutPay"] = this.canApplyasLeaveWithoutPay;
        data["carryForwardToNextYear"] = this.carryForwardToNextYear;
        data["carryForwardLimit"] = this.carryForwardLimit;
        data["carryForwardFrequency"] = this.carryForwardFrequency;
        data["carryForwardLapsed"] = this.carryForwardLapsed;
        data["maxAccruedAndCarryForwardLimit"] = this.maxAccruedAndCarryForwardLimit;
        data["leaveEncashable"] = this.leaveEncashable;
        data["miximumEncashmentLimit"] = this.miximumEncashmentLimit;
        data["minimumBalanceLimitAfterEncashment"] = this.minimumBalanceLimitAfterEncashment;
        data["documentRequiredWhenLeaveMoreThan"] = this.documentRequiredWhenLeaveMoreThan;
        data["applicableForLTA"] = this.applicableForLTA;
        data["unpaidLeave"] = this.unpaidLeave;
        data["backDatedLeaveAllowed"] = this.backDatedLeaveAllowed;
        data["backDatedLeaveAllowedDays"] = this.backDatedLeaveAllowedDays;
        data["allowPartialLeaveCancellation"] = this.allowPartialLeaveCancellation;
        data["leaveClubbingNotAllowedWith"] = this.leaveClubbingNotAllowedWith;
        data["leaveClubbingNotAllowedWithLeaveType"] = this.leaveClubbingNotAllowedWithLeaveType;
        data["doYouWantToCreditLeave"] = this.doYouWantToCreditLeave;
        data["noOfCreditLeave"] = this.noOfCreditLeave;
        data["leaveWillBeCreditedAt"] = this.leaveWillBeCreditedAt;
        data["basedOn"] = this.basedOn;
        data["basedOnCondition"] = this.basedOnCondition;
        data["basedOnDay"] = this.basedOnDay;
        data["leaveWillBe"] = this.leaveWillBe;
        data["leaveWillBeAvail"] = this.leaveWillBeAvail;
        data["leaveWillBeCreditedAtMonthDay"] = this.leaveWillBeCreditedAtMonthDay;
        data["leaveOpeningBalalnce"] = this.leaveOpeningBalalnce;
        data["leaveCreditAtTimeOfJoining"] = this.leaveCreditAtTimeOfJoining;
        data["creditRuleBasedonEmployee"] = this.creditRuleBasedonEmployee;
        data["creditRuleBasedonEmployeeStatusList"] = this.creditRuleBasedonEmployeeStatusList;
        data["leaveEligibilityRule"] = this.leaveEligibilityRule;
        data["paidDaysDeductionRule"] = this.paidDaysDeductionRule;
        if (Array.isArray(this.leaveCreditedAtMonthDayList)) {
            data["leaveCreditedAtMonthDayList"] = [];
            for (let item of this.leaveCreditedAtMonthDayList)
                data["leaveCreditedAtMonthDayList"].push(item.toJSON());
        }
        if (Array.isArray(this.creditRuleEmployeeStatusList)) {
            data["creditRuleEmployeeStatusList"] = [];
            for (let item of this.creditRuleEmployeeStatusList)
                data["creditRuleEmployeeStatusList"].push(item.toJSON());
        }
        if (Array.isArray(this.leaveEligibilityRuleList)) {
            data["leaveEligibilityRuleList"] = [];
            for (let item of this.leaveEligibilityRuleList)
                data["leaveEligibilityRuleList"].push(item.toJSON());
        }
        if (Array.isArray(this.paidDayDeductionRuleList)) {
            data["paidDayDeductionRuleList"] = [];
            for (let item of this.paidDayDeductionRuleList)
                data["paidDayDeductionRuleList"].push(item.toJSON());
        }
        data["dayofDOJMonth_Elgibility"] = this.dayofDOJMonth_Elgibility;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditLeaveRuleDto {
    leaveTypeId: number;
    leaveName: string | undefined;
    leaveCycle: number;
    halfDayLeaveAllowed: boolean;
    miximumLeaveRequestperYear: number | undefined;
    miximumLeaveRequestperMonth: number | undefined;
    miximumLeavesPerMonth: number | undefined;
    minimumLeavePerRequest: number | undefined;
    miximumLeavePerRequest: number | undefined;
    priorDaysRequiredRequestLeave: number | undefined;
    includeWeeklyOffasLeave: boolean;
    whenLeaveIsAppliedBeforeWeeklyOff: number | undefined;
    includeHolidayasLeave: boolean;
    whenLeaveIsAppliedBeforeHoliday: number | undefined;
    negativeBalanceAllowed: boolean;
    canApplyasLeaveWithoutPay: string | undefined;
    carryForwardToNextYear: boolean;
    carryForwardLimit: number | undefined;
    carryForwardFrequency: number | undefined;
    carryForwardLapsed: number | undefined;
    maxAccruedAndCarryForwardLimit: number | undefined;
    leaveEncashable: boolean;
    miximumEncashmentLimit: number | undefined;
    minimumBalanceLimitAfterEncashment: number | undefined;
    documentRequiredWhenLeaveMoreThan: number | undefined;
    applicableForLTA: boolean;
    unpaidLeave: boolean;
    backDatedLeaveAllowed: boolean;
    backDatedLeaveAllowedDays: number | undefined;
    allowPartialLeaveCancellation: boolean;
    leaveClubbingNotAllowedWith: boolean;
    leaveClubbingNotAllowedWithLeaveType: string | undefined;
    doYouWantToCreditLeave: number | undefined;
    noOfCreditLeave: number | undefined;
    leaveWillBeCreditedAt: number | undefined;
    basedOn: number | undefined;
    basedOnCondition: number | undefined;
    basedOnDay: number | undefined;
    leaveWillBe: number | undefined;
    leaveWillBeAvail: number | undefined;
    leaveWillBeCreditedAtMonthDay: string | undefined;
    leaveOpeningBalalnce: number | undefined;
    leaveCreditAtTimeOfJoining: number | undefined;
    creditRuleBasedonEmployee: boolean;
    creditRuleBasedonEmployeeStatusList: string | undefined;
    leaveEligibilityRule: string | undefined;
    paidDaysDeductionRule: string | undefined;
    leaveCreditedAtMonthDayList: LeaveCreditedAtMonthDay[] | undefined;
    creditRuleEmployeeStatusList: CreditRuleOnEmployeeStatus[] | undefined;
    leaveEligibilityRuleList: LeaveEligibilityRule[] | undefined;
    paidDayDeductionRuleList: PaidDayDeductionRule[] | undefined;
    dayofDOJMonth_Elgibility: number | undefined;
    id: number | undefined;
}

export class GetLeaveRuleForEditOutput implements IGetLeaveRuleForEditOutput {
    leaveRule!: CreateOrEditLeaveRuleDto;

    constructor(data?: IGetLeaveRuleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveRule = _data["leaveRule"] ? CreateOrEditLeaveRuleDto.fromJS(_data["leaveRule"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetLeaveRuleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLeaveRuleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveRule"] = this.leaveRule ? this.leaveRule.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetLeaveRuleForEditOutput {
    leaveRule: CreateOrEditLeaveRuleDto;
}

export class LeaveTypesDto implements ILeaveTypesDto {
    leaveType!: string | undefined;
    leaveName!: string | undefined;
    id!: number;

    constructor(data?: ILeaveTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveType = _data["leaveType"];
            this.leaveName = _data["leaveName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LeaveTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveType"] = this.leaveType;
        data["leaveName"] = this.leaveName;
        data["id"] = this.id;
        return data;
    }
}

export interface ILeaveTypesDto {
    leaveType: string | undefined;
    leaveName: string | undefined;
    id: number;
}

export class LeaveTypesModelDto implements ILeaveTypesModelDto {
    leaveType!: string | undefined;
    leaveName!: string | undefined;
    halfdayleaveallowed!: boolean;
    maximumleaverequestperyear!: number;
    maximumleaverequestperMonth!: number;
    priorDaysRequiredRequestLeave!: number;
    negativeBalanceAllowed!: boolean;
    carryForwardToNextYear!: boolean;
    leaveEncashable!: boolean;
    unpaidLeave!: boolean;
    leaveBalancecreditrule!: string | undefined;
    leaveeligibilityrule!: string | undefined;
    id!: number;

    constructor(data?: ILeaveTypesModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveType = _data["leaveType"];
            this.leaveName = _data["leaveName"];
            this.halfdayleaveallowed = _data["halfdayleaveallowed"];
            this.maximumleaverequestperyear = _data["maximumleaverequestperyear"];
            this.maximumleaverequestperMonth = _data["maximumleaverequestperMonth"];
            this.priorDaysRequiredRequestLeave = _data["priorDaysRequiredRequestLeave"];
            this.negativeBalanceAllowed = _data["negativeBalanceAllowed"];
            this.carryForwardToNextYear = _data["carryForwardToNextYear"];
            this.leaveEncashable = _data["leaveEncashable"];
            this.unpaidLeave = _data["unpaidLeave"];
            this.leaveBalancecreditrule = _data["leaveBalancecreditrule"];
            this.leaveeligibilityrule = _data["leaveeligibilityrule"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LeaveTypesModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveTypesModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveType"] = this.leaveType;
        data["leaveName"] = this.leaveName;
        data["halfdayleaveallowed"] = this.halfdayleaveallowed;
        data["maximumleaverequestperyear"] = this.maximumleaverequestperyear;
        data["maximumleaverequestperMonth"] = this.maximumleaverequestperMonth;
        data["priorDaysRequiredRequestLeave"] = this.priorDaysRequiredRequestLeave;
        data["negativeBalanceAllowed"] = this.negativeBalanceAllowed;
        data["carryForwardToNextYear"] = this.carryForwardToNextYear;
        data["leaveEncashable"] = this.leaveEncashable;
        data["unpaidLeave"] = this.unpaidLeave;
        data["leaveBalancecreditrule"] = this.leaveBalancecreditrule;
        data["leaveeligibilityrule"] = this.leaveeligibilityrule;
        data["id"] = this.id;
        return data;
    }
}

export interface ILeaveTypesModelDto {
    leaveType: string | undefined;
    leaveName: string | undefined;
    halfdayleaveallowed: boolean;
    maximumleaverequestperyear: number;
    maximumleaverequestperMonth: number;
    priorDaysRequiredRequestLeave: number;
    negativeBalanceAllowed: boolean;
    carryForwardToNextYear: boolean;
    leaveEncashable: boolean;
    unpaidLeave: boolean;
    leaveBalancecreditrule: string | undefined;
    leaveeligibilityrule: string | undefined;
    id: number;
}

export class GetLeaveTypesForViewDto implements IGetLeaveTypesForViewDto {
    leaveTypes!: LeaveTypesDto;
    leaveTypesModel!: LeaveTypesModelDto;

    constructor(data?: IGetLeaveTypesForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveTypes = _data["leaveTypes"] ? LeaveTypesDto.fromJS(_data["leaveTypes"]) : <any>undefined;
            this.leaveTypesModel = _data["leaveTypesModel"] ? LeaveTypesModelDto.fromJS(_data["leaveTypesModel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetLeaveTypesForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetLeaveTypesForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveTypes"] = this.leaveTypes ? this.leaveTypes.toJSON() : <any>undefined;
        data["leaveTypesModel"] = this.leaveTypesModel ? this.leaveTypesModel.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetLeaveTypesForViewDto {
    leaveTypes: LeaveTypesDto;
    leaveTypesModel: LeaveTypesModelDto;
}

export class PagedResultDtoOfGetLeaveTypesForViewDto implements IPagedResultDtoOfGetLeaveTypesForViewDto {
    totalCount!: number;
    items!: GetLeaveTypesForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetLeaveTypesForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetLeaveTypesForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetLeaveTypesForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetLeaveTypesForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetLeaveTypesForViewDto {
    totalCount: number;
    items: GetLeaveTypesForViewDto[] | undefined;
}

export class CreateOrEditLeaveTypesDto implements ICreateOrEditLeaveTypesDto {
    leaveType!: string | undefined;
    leaveName!: string | undefined;
    specialLeave!: boolean;
    maximumLeaveRequestPerYear!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditLeaveTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveType = _data["leaveType"];
            this.leaveName = _data["leaveName"];
            this.specialLeave = _data["specialLeave"];
            this.maximumLeaveRequestPerYear = _data["maximumLeaveRequestPerYear"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditLeaveTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditLeaveTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveType"] = this.leaveType;
        data["leaveName"] = this.leaveName;
        data["specialLeave"] = this.specialLeave;
        data["maximumLeaveRequestPerYear"] = this.maximumLeaveRequestPerYear;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditLeaveTypesDto {
    leaveType: string | undefined;
    leaveName: string | undefined;
    specialLeave: boolean;
    maximumLeaveRequestPerYear: number | undefined;
    id: number | undefined;
}

export class GetLeaveTypesForEditOutput implements IGetLeaveTypesForEditOutput {
    leaveTypes!: CreateOrEditLeaveTypesDto;

    constructor(data?: IGetLeaveTypesForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveTypes = _data["leaveTypes"] ? CreateOrEditLeaveTypesDto.fromJS(_data["leaveTypes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetLeaveTypesForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLeaveTypesForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveTypes"] = this.leaveTypes ? this.leaveTypes.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetLeaveTypesForEditOutput {
    leaveTypes: CreateOrEditLeaveTypesDto;
}

export class CurrentlocationEmployeeDto implements ICurrentlocationEmployeeDto {
    value!: number | undefined;
    label!: string | undefined;

    constructor(data?: ICurrentlocationEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): CurrentlocationEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentlocationEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }
}

export interface ICurrentlocationEmployeeDto {
    value: number | undefined;
    label: string | undefined;
}

export class CurrentlocationDto implements ICurrentlocationDto {
    name!: string | undefined;
    address!: string | undefined;
    longitude!: string | undefined;
    latitude!: string | undefined;
    fromlocationdatetime!: moment.Moment;
    id!: number;

    constructor(data?: ICurrentlocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.address = _data["address"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.fromlocationdatetime = _data["fromlocationdatetime"] ? moment(_data["fromlocationdatetime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CurrentlocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentlocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["fromlocationdatetime"] = this.fromlocationdatetime ? this.fromlocationdatetime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICurrentlocationDto {
    name: string | undefined;
    address: string | undefined;
    longitude: string | undefined;
    latitude: string | undefined;
    fromlocationdatetime: moment.Moment;
    id: number;
}

export class LocationsDto implements ILocationsDto {
    name!: string | undefined;
    latitude!: string | undefined;
    longitude!: string | undefined;
    radius!: number;
    pt!: boolean;
    lwf!: boolean;
    state!: number;
    id!: number;

    constructor(data?: ILocationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.radius = _data["radius"];
            this.pt = _data["pt"];
            this.lwf = _data["lwf"];
            this.state = _data["state"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LocationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["radius"] = this.radius;
        data["pt"] = this.pt;
        data["lwf"] = this.lwf;
        data["state"] = this.state;
        data["id"] = this.id;
        return data;
    }
}

export interface ILocationsDto {
    name: string | undefined;
    latitude: string | undefined;
    longitude: string | undefined;
    radius: number;
    pt: boolean;
    lwf: boolean;
    state: number;
    id: number;
}

export class GetLocationsForViewDto implements IGetLocationsForViewDto {
    locations!: LocationsDto;

    constructor(data?: IGetLocationsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locations = _data["locations"] ? LocationsDto.fromJS(_data["locations"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetLocationsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locations"] = this.locations ? this.locations.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetLocationsForViewDto {
    locations: LocationsDto;
}

export class PagedResultDtoOfGetLocationsForViewDto implements IPagedResultDtoOfGetLocationsForViewDto {
    totalCount!: number;
    items!: GetLocationsForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetLocationsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetLocationsForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetLocationsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetLocationsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetLocationsForViewDto {
    totalCount: number;
    items: GetLocationsForViewDto[] | undefined;
}

export class CreateOrEditLocationsDto implements ICreateOrEditLocationsDto {
    name!: string | undefined;
    latitude!: string | undefined;
    longitude!: string | undefined;
    radius!: number;
    branchCompanyName!: string | undefined;
    branchCompanyAddress!: string | undefined;
    pt!: boolean;
    lwf!: boolean;
    state!: number;
    logoname!: string | undefined;
    iamgeUrl!: string | undefined;
    logoFileType!: string | undefined;
    logoId!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditLocationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.radius = _data["radius"];
            this.branchCompanyName = _data["branchCompanyName"];
            this.branchCompanyAddress = _data["branchCompanyAddress"];
            this.pt = _data["pt"];
            this.lwf = _data["lwf"];
            this.state = _data["state"];
            this.logoname = _data["logoname"];
            this.iamgeUrl = _data["iamgeUrl"];
            this.logoFileType = _data["logoFileType"];
            this.logoId = _data["logoId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditLocationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditLocationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["radius"] = this.radius;
        data["branchCompanyName"] = this.branchCompanyName;
        data["branchCompanyAddress"] = this.branchCompanyAddress;
        data["pt"] = this.pt;
        data["lwf"] = this.lwf;
        data["state"] = this.state;
        data["logoname"] = this.logoname;
        data["iamgeUrl"] = this.iamgeUrl;
        data["logoFileType"] = this.logoFileType;
        data["logoId"] = this.logoId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditLocationsDto {
    name: string | undefined;
    latitude: string | undefined;
    longitude: string | undefined;
    radius: number;
    branchCompanyName: string | undefined;
    branchCompanyAddress: string | undefined;
    pt: boolean;
    lwf: boolean;
    state: number;
    logoname: string | undefined;
    iamgeUrl: string | undefined;
    logoFileType: string | undefined;
    logoId: string | undefined;
    id: number | undefined;
}

export class GetLocationsForEditOutput implements IGetLocationsForEditOutput {
    locations!: CreateOrEditLocationsDto;

    constructor(data?: IGetLocationsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locations = _data["locations"] ? CreateOrEditLocationsDto.fromJS(_data["locations"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetLocationsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locations"] = this.locations ? this.locations.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetLocationsForEditOutput {
    locations: CreateOrEditLocationsDto;
}

export class ManualLeaveAccrualDto implements IManualLeaveAccrualDto {
    id!: number;
    month!: string | undefined;
    year!: number;
    leaveType!: string | undefined;
    noOfLeavesCredited!: number;

    constructor(data?: IManualLeaveAccrualDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.month = _data["month"];
            this.year = _data["year"];
            this.leaveType = _data["leaveType"];
            this.noOfLeavesCredited = _data["noOfLeavesCredited"];
        }
    }

    static fromJS(data: any): ManualLeaveAccrualDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManualLeaveAccrualDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["month"] = this.month;
        data["year"] = this.year;
        data["leaveType"] = this.leaveType;
        data["noOfLeavesCredited"] = this.noOfLeavesCredited;
        return data;
    }
}

export interface IManualLeaveAccrualDto {
    id: number;
    month: string | undefined;
    year: number;
    leaveType: string | undefined;
    noOfLeavesCredited: number;
}

export class PagedResultDtoOfManualLeaveAccrualDto implements IPagedResultDtoOfManualLeaveAccrualDto {
    totalCount!: number;
    items!: ManualLeaveAccrualDto[] | undefined;

    constructor(data?: IPagedResultDtoOfManualLeaveAccrualDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ManualLeaveAccrualDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfManualLeaveAccrualDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfManualLeaveAccrualDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfManualLeaveAccrualDto {
    totalCount: number;
    items: ManualLeaveAccrualDto[] | undefined;
}

export class GetMarkAttendanceForViewDto implements IGetMarkAttendanceForViewDto {
    markAttendance!: MarkAttendanceDto;
    empCode!: string | undefined;
    employeeFirstName!: string | undefined;

    constructor(data?: IGetMarkAttendanceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.markAttendance = _data["markAttendance"] ? MarkAttendanceDto.fromJS(_data["markAttendance"]) : <any>undefined;
            this.empCode = _data["empCode"];
            this.employeeFirstName = _data["employeeFirstName"];
        }
    }

    static fromJS(data: any): GetMarkAttendanceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMarkAttendanceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["markAttendance"] = this.markAttendance ? this.markAttendance.toJSON() : <any>undefined;
        data["empCode"] = this.empCode;
        data["employeeFirstName"] = this.employeeFirstName;
        return data;
    }
}

export interface IGetMarkAttendanceForViewDto {
    markAttendance: MarkAttendanceDto;
    empCode: string | undefined;
    employeeFirstName: string | undefined;
}

export class PagedResultDtoOfGetMarkAttendanceForViewDto implements IPagedResultDtoOfGetMarkAttendanceForViewDto {
    totalCount!: number;
    items!: GetMarkAttendanceForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetMarkAttendanceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetMarkAttendanceForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetMarkAttendanceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetMarkAttendanceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetMarkAttendanceForViewDto {
    totalCount: number;
    items: GetMarkAttendanceForViewDto[] | undefined;
}

export class GpsLocationLatLon implements IGpsLocationLatLon {
    lattitude!: string | undefined;
    longitude!: string | undefined;
    locationName!: string | undefined;

    constructor(data?: IGpsLocationLatLon) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lattitude = _data["lattitude"];
            this.longitude = _data["longitude"];
            this.locationName = _data["locationName"];
        }
    }

    static fromJS(data: any): GpsLocationLatLon {
        data = typeof data === 'object' ? data : {};
        let result = new GpsLocationLatLon();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lattitude"] = this.lattitude;
        data["longitude"] = this.longitude;
        data["locationName"] = this.locationName;
        return data;
    }
}

export interface IGpsLocationLatLon {
    lattitude: string | undefined;
    longitude: string | undefined;
    locationName: string | undefined;
}

export class CreateOrEditMarkAttendanceDto implements ICreateOrEditMarkAttendanceDto {
    punchDate!: moment.Moment;
    punchTime!: string;
    machine!: string | undefined;
    location!: string | undefined;
    gpsLocations!: GpsLocationLatLon[] | undefined;
    employeeId!: number;
    inOut!: string | undefined;
    createdBy!: number | undefined;
    locationName!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditMarkAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.punchDate = _data["punchDate"] ? moment(_data["punchDate"].toString()) : <any>undefined;
            this.punchTime = _data["punchTime"];
            this.machine = _data["machine"];
            this.location = _data["location"];
            if (Array.isArray(_data["gpsLocations"])) {
                this.gpsLocations = [] as any;
                for (let item of _data["gpsLocations"])
                    this.gpsLocations!.push(GpsLocationLatLon.fromJS(item));
            }
            this.employeeId = _data["employeeId"];
            this.inOut = _data["inOut"];
            this.createdBy = _data["createdBy"];
            this.locationName = _data["locationName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditMarkAttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditMarkAttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["punchDate"] = this.punchDate ? this.punchDate.toISOString() : <any>undefined;
        data["punchTime"] = this.punchTime;
        data["machine"] = this.machine;
        data["location"] = this.location;
        if (Array.isArray(this.gpsLocations)) {
            data["gpsLocations"] = [];
            for (let item of this.gpsLocations)
                data["gpsLocations"].push(item.toJSON());
        }
        data["employeeId"] = this.employeeId;
        data["inOut"] = this.inOut;
        data["createdBy"] = this.createdBy;
        data["locationName"] = this.locationName;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditMarkAttendanceDto {
    punchDate: moment.Moment;
    punchTime: string;
    machine: string | undefined;
    location: string | undefined;
    gpsLocations: GpsLocationLatLon[] | undefined;
    employeeId: number;
    inOut: string | undefined;
    createdBy: number | undefined;
    locationName: string | undefined;
    id: number | undefined;
}

export class GetMarkAttendanceForEditOutput implements IGetMarkAttendanceForEditOutput {
    markAttendance!: CreateOrEditMarkAttendanceDto;

    constructor(data?: IGetMarkAttendanceForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.markAttendance = _data["markAttendance"] ? CreateOrEditMarkAttendanceDto.fromJS(_data["markAttendance"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMarkAttendanceForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMarkAttendanceForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["markAttendance"] = this.markAttendance ? this.markAttendance.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMarkAttendanceForEditOutput {
    markAttendance: CreateOrEditMarkAttendanceDto;
}

export class CreateOrEditMarkAttendanceMRRDto implements ICreateOrEditMarkAttendanceMRRDto {
    punchDate!: moment.Moment;
    punchTime!: string;
    machine!: string | undefined;
    location!: string | undefined;
    gpsLocations!: GpsLocationLatLon[] | undefined;
    employeeId!: string | undefined;
    inOut!: string | undefined;
    deviceName!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditMarkAttendanceMRRDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.punchDate = _data["punchDate"] ? moment(_data["punchDate"].toString()) : <any>undefined;
            this.punchTime = _data["punchTime"];
            this.machine = _data["machine"];
            this.location = _data["location"];
            if (Array.isArray(_data["gpsLocations"])) {
                this.gpsLocations = [] as any;
                for (let item of _data["gpsLocations"])
                    this.gpsLocations!.push(GpsLocationLatLon.fromJS(item));
            }
            this.employeeId = _data["employeeId"];
            this.inOut = _data["inOut"];
            this.deviceName = _data["deviceName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditMarkAttendanceMRRDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditMarkAttendanceMRRDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["punchDate"] = this.punchDate ? this.punchDate.toISOString() : <any>undefined;
        data["punchTime"] = this.punchTime;
        data["machine"] = this.machine;
        data["location"] = this.location;
        if (Array.isArray(this.gpsLocations)) {
            data["gpsLocations"] = [];
            for (let item of this.gpsLocations)
                data["gpsLocations"].push(item.toJSON());
        }
        data["employeeId"] = this.employeeId;
        data["inOut"] = this.inOut;
        data["deviceName"] = this.deviceName;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditMarkAttendanceMRRDto {
    punchDate: moment.Moment;
    punchTime: string;
    machine: string | undefined;
    location: string | undefined;
    gpsLocations: GpsLocationLatLon[] | undefined;
    employeeId: string | undefined;
    inOut: string | undefined;
    deviceName: string | undefined;
    id: number | undefined;
}

export class CreateOrEditPunchBiometricDto implements ICreateOrEditPunchBiometricDto {
    punchDate!: moment.Moment;
    punchTime!: string;
    machine!: string | undefined;
    location!: string | undefined;
    gpsLocations!: GpsLocationLatLon[] | undefined;
    biometricId!: string | undefined;
    inOut!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPunchBiometricDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.punchDate = _data["punchDate"] ? moment(_data["punchDate"].toString()) : <any>undefined;
            this.punchTime = _data["punchTime"];
            this.machine = _data["machine"];
            this.location = _data["location"];
            if (Array.isArray(_data["gpsLocations"])) {
                this.gpsLocations = [] as any;
                for (let item of _data["gpsLocations"])
                    this.gpsLocations!.push(GpsLocationLatLon.fromJS(item));
            }
            this.biometricId = _data["biometricId"];
            this.inOut = _data["inOut"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPunchBiometricDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPunchBiometricDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["punchDate"] = this.punchDate ? this.punchDate.toISOString() : <any>undefined;
        data["punchTime"] = this.punchTime;
        data["machine"] = this.machine;
        data["location"] = this.location;
        if (Array.isArray(this.gpsLocations)) {
            data["gpsLocations"] = [];
            for (let item of this.gpsLocations)
                data["gpsLocations"].push(item.toJSON());
        }
        data["biometricId"] = this.biometricId;
        data["inOut"] = this.inOut;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditPunchBiometricDto {
    punchDate: moment.Moment;
    punchTime: string;
    machine: string | undefined;
    location: string | undefined;
    gpsLocations: GpsLocationLatLon[] | undefined;
    biometricId: string | undefined;
    inOut: string | undefined;
    id: number | undefined;
}

export class CreateOrEditPerfettoIdDto implements ICreateOrEditPerfettoIdDto {
    punchDate!: moment.Moment;
    punchTime!: string;
    machine!: string | undefined;
    location!: string | undefined;
    gpsLocations!: GpsLocationLatLon[] | undefined;
    perfettoId!: number;
    inOut!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPerfettoIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.punchDate = _data["punchDate"] ? moment(_data["punchDate"].toString()) : <any>undefined;
            this.punchTime = _data["punchTime"];
            this.machine = _data["machine"];
            this.location = _data["location"];
            if (Array.isArray(_data["gpsLocations"])) {
                this.gpsLocations = [] as any;
                for (let item of _data["gpsLocations"])
                    this.gpsLocations!.push(GpsLocationLatLon.fromJS(item));
            }
            this.perfettoId = _data["perfettoId"];
            this.inOut = _data["inOut"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPerfettoIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPerfettoIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["punchDate"] = this.punchDate ? this.punchDate.toISOString() : <any>undefined;
        data["punchTime"] = this.punchTime;
        data["machine"] = this.machine;
        data["location"] = this.location;
        if (Array.isArray(this.gpsLocations)) {
            data["gpsLocations"] = [];
            for (let item of this.gpsLocations)
                data["gpsLocations"].push(item.toJSON());
        }
        data["perfettoId"] = this.perfettoId;
        data["inOut"] = this.inOut;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditPerfettoIdDto {
    punchDate: moment.Moment;
    punchTime: string;
    machine: string | undefined;
    location: string | undefined;
    gpsLocations: GpsLocationLatLon[] | undefined;
    perfettoId: number;
    inOut: string | undefined;
    id: number | undefined;
}

export class MRRDTO implements IMRRDTO {
    punchDate!: string | undefined;
    name!: string | undefined;
    empcode!: string | undefined;

    constructor(data?: IMRRDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.punchDate = _data["punchDate"];
            this.name = _data["name"];
            this.empcode = _data["empcode"];
        }
    }

    static fromJS(data: any): MRRDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MRRDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["punchDate"] = this.punchDate;
        data["name"] = this.name;
        data["empcode"] = this.empcode;
        return data;
    }
}

export interface IMRRDTO {
    punchDate: string | undefined;
    name: string | undefined;
    empcode: string | undefined;
}

export class PunchDetails implements IPunchDetails {
    punchDate!: string | undefined;
    punchTime!: string | undefined;

    constructor(data?: IPunchDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.punchDate = _data["punchDate"];
            this.punchTime = _data["punchTime"];
        }
    }

    static fromJS(data: any): PunchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PunchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["punchDate"] = this.punchDate;
        data["punchTime"] = this.punchTime;
        return data;
    }
}

export interface IPunchDetails {
    punchDate: string | undefined;
    punchTime: string | undefined;
}

export class EmployeePunchFailureCount implements IEmployeePunchFailureCount {
    employeeId!: string | undefined;
    count!: number;
    punches!: PunchDetails[] | undefined;

    constructor(data?: IEmployeePunchFailureCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.count = _data["count"];
            if (Array.isArray(_data["punches"])) {
                this.punches = [] as any;
                for (let item of _data["punches"])
                    this.punches!.push(PunchDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeePunchFailureCount {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeePunchFailureCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["count"] = this.count;
        if (Array.isArray(this.punches)) {
            data["punches"] = [];
            for (let item of this.punches)
                data["punches"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmployeePunchFailureCount {
    employeeId: string | undefined;
    count: number;
    punches: PunchDetails[] | undefined;
}

export class AddpunchDto implements IAddpunchDto {
    punchDate!: moment.Moment;
    punchTime!: string;
    employeeId!: string | undefined;

    constructor(data?: IAddpunchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.punchDate = _data["punchDate"] ? moment(_data["punchDate"].toString()) : <any>undefined;
            this.punchTime = _data["punchTime"];
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): AddpunchDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddpunchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["punchDate"] = this.punchDate ? this.punchDate.toISOString() : <any>undefined;
        data["punchTime"] = this.punchTime;
        data["employeeId"] = this.employeeId;
        return data;
    }
}

export interface IAddpunchDto {
    punchDate: moment.Moment;
    punchTime: string;
    employeeId: string | undefined;
}

export class GetEmployeeForListMyTeam implements IGetEmployeeForListMyTeam {
    rowNumber!: number;
    employeeId!: number;
    name!: string | undefined;
    employeeCode!: string | undefined;
    employeeImage!: string | undefined;
    status!: string | undefined;
    leave!: string | undefined;

    constructor(data?: IGetEmployeeForListMyTeam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowNumber = _data["rowNumber"];
            this.employeeId = _data["employeeId"];
            this.name = _data["name"];
            this.employeeCode = _data["employeeCode"];
            this.employeeImage = _data["employeeImage"];
            this.status = _data["status"];
            this.leave = _data["leave"];
        }
    }

    static fromJS(data: any): GetEmployeeForListMyTeam {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeForListMyTeam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowNumber"] = this.rowNumber;
        data["employeeId"] = this.employeeId;
        data["name"] = this.name;
        data["employeeCode"] = this.employeeCode;
        data["employeeImage"] = this.employeeImage;
        data["status"] = this.status;
        data["leave"] = this.leave;
        return data;
    }
}

export interface IGetEmployeeForListMyTeam {
    rowNumber: number;
    employeeId: number;
    name: string | undefined;
    employeeCode: string | undefined;
    employeeImage: string | undefined;
    status: string | undefined;
    leave: string | undefined;
}

export class GetEmployeeForListMyTeamshowdata implements IGetEmployeeForListMyTeamshowdata {
    getEmployeeForListMyTeam!: GetEmployeeForListMyTeam;
    isReportingManager!: boolean;

    constructor(data?: IGetEmployeeForListMyTeamshowdata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.getEmployeeForListMyTeam = _data["getEmployeeForListMyTeam"] ? GetEmployeeForListMyTeam.fromJS(_data["getEmployeeForListMyTeam"]) : <any>undefined;
            this.isReportingManager = _data["isReportingManager"];
        }
    }

    static fromJS(data: any): GetEmployeeForListMyTeamshowdata {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeForListMyTeamshowdata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["getEmployeeForListMyTeam"] = this.getEmployeeForListMyTeam ? this.getEmployeeForListMyTeam.toJSON() : <any>undefined;
        data["isReportingManager"] = this.isReportingManager;
        return data;
    }
}

export interface IGetEmployeeForListMyTeamshowdata {
    getEmployeeForListMyTeam: GetEmployeeForListMyTeam;
    isReportingManager: boolean;
}

export class GpsLocationLatLonMobile implements IGpsLocationLatLonMobile {
    lattitude!: string | undefined;
    longitude!: string | undefined;
    locationName!: string | undefined;

    constructor(data?: IGpsLocationLatLonMobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lattitude = _data["lattitude"];
            this.longitude = _data["longitude"];
            this.locationName = _data["locationName"];
        }
    }

    static fromJS(data: any): GpsLocationLatLonMobile {
        data = typeof data === 'object' ? data : {};
        let result = new GpsLocationLatLonMobile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lattitude"] = this.lattitude;
        data["longitude"] = this.longitude;
        data["locationName"] = this.locationName;
        return data;
    }
}

export interface IGpsLocationLatLonMobile {
    lattitude: string | undefined;
    longitude: string | undefined;
    locationName: string | undefined;
}

export class CreateOrEditMarkAttendanceMobileDto implements ICreateOrEditMarkAttendanceMobileDto {
    punchDate!: moment.Moment;
    punchTime!: string;
    machine!: string | undefined;
    location!: string | undefined;
    gpsLocations!: GpsLocationLatLonMobile[] | undefined;
    employeeId!: number;
    inOut!: string | undefined;
    tenantId!: number;
    locationName!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditMarkAttendanceMobileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.punchDate = _data["punchDate"] ? moment(_data["punchDate"].toString()) : <any>undefined;
            this.punchTime = _data["punchTime"];
            this.machine = _data["machine"];
            this.location = _data["location"];
            if (Array.isArray(_data["gpsLocations"])) {
                this.gpsLocations = [] as any;
                for (let item of _data["gpsLocations"])
                    this.gpsLocations!.push(GpsLocationLatLonMobile.fromJS(item));
            }
            this.employeeId = _data["employeeId"];
            this.inOut = _data["inOut"];
            this.tenantId = _data["tenantId"];
            this.locationName = _data["locationName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditMarkAttendanceMobileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditMarkAttendanceMobileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["punchDate"] = this.punchDate ? this.punchDate.toISOString() : <any>undefined;
        data["punchTime"] = this.punchTime;
        data["machine"] = this.machine;
        data["location"] = this.location;
        if (Array.isArray(this.gpsLocations)) {
            data["gpsLocations"] = [];
            for (let item of this.gpsLocations)
                data["gpsLocations"].push(item.toJSON());
        }
        data["employeeId"] = this.employeeId;
        data["inOut"] = this.inOut;
        data["tenantId"] = this.tenantId;
        data["locationName"] = this.locationName;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditMarkAttendanceMobileDto {
    punchDate: moment.Moment;
    punchTime: string;
    machine: string | undefined;
    location: string | undefined;
    gpsLocations: GpsLocationLatLonMobile[] | undefined;
    employeeId: number;
    inOut: string | undefined;
    tenantId: number;
    locationName: string | undefined;
    id: number | undefined;
}

export class CreateOrEditLeaveRequestsMobileDto implements ICreateOrEditLeaveRequestsMobileDto {
    leaveTypeId!: number;
    leaveFrom!: moment.Moment | undefined;
    leaveTo!: moment.Moment | undefined;
    leaveDays!: number;
    requestReasons!: string | undefined;
    leaveStatus!: string | undefined;
    firstHalf!: boolean;
    secondHalf!: boolean;
    abpUserId!: number;
    tenantId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditLeaveRequestsMobileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveTypeId = _data["leaveTypeId"];
            this.leaveFrom = _data["leaveFrom"] ? moment(_data["leaveFrom"].toString()) : <any>undefined;
            this.leaveTo = _data["leaveTo"] ? moment(_data["leaveTo"].toString()) : <any>undefined;
            this.leaveDays = _data["leaveDays"];
            this.requestReasons = _data["requestReasons"];
            this.leaveStatus = _data["leaveStatus"];
            this.firstHalf = _data["firstHalf"];
            this.secondHalf = _data["secondHalf"];
            this.abpUserId = _data["abpUserId"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditLeaveRequestsMobileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditLeaveRequestsMobileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveTypeId"] = this.leaveTypeId;
        data["leaveFrom"] = this.leaveFrom ? this.leaveFrom.toISOString() : <any>undefined;
        data["leaveTo"] = this.leaveTo ? this.leaveTo.toISOString() : <any>undefined;
        data["leaveDays"] = this.leaveDays;
        data["requestReasons"] = this.requestReasons;
        data["leaveStatus"] = this.leaveStatus;
        data["firstHalf"] = this.firstHalf;
        data["secondHalf"] = this.secondHalf;
        data["abpUserId"] = this.abpUserId;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditLeaveRequestsMobileDto {
    leaveTypeId: number;
    leaveFrom: moment.Moment | undefined;
    leaveTo: moment.Moment | undefined;
    leaveDays: number;
    requestReasons: string | undefined;
    leaveStatus: string | undefined;
    firstHalf: boolean;
    secondHalf: boolean;
    abpUserId: number;
    tenantId: number;
    id: number | undefined;
}

export class CreateOrEditAttendanceCorrectionMobileDto implements ICreateOrEditAttendanceCorrectionMobileDto {
    reason!: number;
    attendanceDate!: moment.Moment;
    in1Time!: string;
    in2Time!: string | undefined;
    in3Time!: string | undefined;
    in4Time!: string | undefined;
    in5Time!: string | undefined;
    out1Time!: string | undefined;
    out2Time!: string | undefined;
    out3Time!: string | undefined;
    out4Time!: string | undefined;
    out5Time!: string | undefined;
    oldIn1Time!: string | undefined;
    oldIn2Time!: string | undefined;
    oldIn3Time!: string | undefined;
    oldIn4Time!: string | undefined;
    oldIn5Time!: string | undefined;
    oldOut1Time!: string | undefined;
    oldOut2Time!: string | undefined;
    oldOut3Time!: string | undefined;
    oldOut4Time!: string | undefined;
    oldOut5Time!: string | undefined;
    firsthalf!: string | undefined;
    secondhalf!: string | undefined;
    emoloyeeId!: number;
    tenantId!: number;
    remarks!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAttendanceCorrectionMobileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
            this.attendanceDate = _data["attendanceDate"] ? moment(_data["attendanceDate"].toString()) : <any>undefined;
            this.in1Time = _data["in1Time"];
            this.in2Time = _data["in2Time"];
            this.in3Time = _data["in3Time"];
            this.in4Time = _data["in4Time"];
            this.in5Time = _data["in5Time"];
            this.out1Time = _data["out1Time"];
            this.out2Time = _data["out2Time"];
            this.out3Time = _data["out3Time"];
            this.out4Time = _data["out4Time"];
            this.out5Time = _data["out5Time"];
            this.oldIn1Time = _data["oldIn1Time"];
            this.oldIn2Time = _data["oldIn2Time"];
            this.oldIn3Time = _data["oldIn3Time"];
            this.oldIn4Time = _data["oldIn4Time"];
            this.oldIn5Time = _data["oldIn5Time"];
            this.oldOut1Time = _data["oldOut1Time"];
            this.oldOut2Time = _data["oldOut2Time"];
            this.oldOut3Time = _data["oldOut3Time"];
            this.oldOut4Time = _data["oldOut4Time"];
            this.oldOut5Time = _data["oldOut5Time"];
            this.firsthalf = _data["firsthalf"];
            this.secondhalf = _data["secondhalf"];
            this.emoloyeeId = _data["emoloyeeId"];
            this.tenantId = _data["tenantId"];
            this.remarks = _data["remarks"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAttendanceCorrectionMobileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAttendanceCorrectionMobileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        data["attendanceDate"] = this.attendanceDate ? this.attendanceDate.toISOString() : <any>undefined;
        data["in1Time"] = this.in1Time;
        data["in2Time"] = this.in2Time;
        data["in3Time"] = this.in3Time;
        data["in4Time"] = this.in4Time;
        data["in5Time"] = this.in5Time;
        data["out1Time"] = this.out1Time;
        data["out2Time"] = this.out2Time;
        data["out3Time"] = this.out3Time;
        data["out4Time"] = this.out4Time;
        data["out5Time"] = this.out5Time;
        data["oldIn1Time"] = this.oldIn1Time;
        data["oldIn2Time"] = this.oldIn2Time;
        data["oldIn3Time"] = this.oldIn3Time;
        data["oldIn4Time"] = this.oldIn4Time;
        data["oldIn5Time"] = this.oldIn5Time;
        data["oldOut1Time"] = this.oldOut1Time;
        data["oldOut2Time"] = this.oldOut2Time;
        data["oldOut3Time"] = this.oldOut3Time;
        data["oldOut4Time"] = this.oldOut4Time;
        data["oldOut5Time"] = this.oldOut5Time;
        data["firsthalf"] = this.firsthalf;
        data["secondhalf"] = this.secondhalf;
        data["emoloyeeId"] = this.emoloyeeId;
        data["tenantId"] = this.tenantId;
        data["remarks"] = this.remarks;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditAttendanceCorrectionMobileDto {
    reason: number;
    attendanceDate: moment.Moment;
    in1Time: string;
    in2Time: string | undefined;
    in3Time: string | undefined;
    in4Time: string | undefined;
    in5Time: string | undefined;
    out1Time: string | undefined;
    out2Time: string | undefined;
    out3Time: string | undefined;
    out4Time: string | undefined;
    out5Time: string | undefined;
    oldIn1Time: string | undefined;
    oldIn2Time: string | undefined;
    oldIn3Time: string | undefined;
    oldIn4Time: string | undefined;
    oldIn5Time: string | undefined;
    oldOut1Time: string | undefined;
    oldOut2Time: string | undefined;
    oldOut3Time: string | undefined;
    oldOut4Time: string | undefined;
    oldOut5Time: string | undefined;
    firsthalf: string | undefined;
    secondhalf: string | undefined;
    emoloyeeId: number;
    tenantId: number;
    remarks: string | undefined;
    id: number | undefined;
}

export class GetAttendanceValidationmobile implements IGetAttendanceValidationmobile {
    count!: number;
    maxnoofcorrection!: number;
    mindays!: number;

    constructor(data?: IGetAttendanceValidationmobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            this.maxnoofcorrection = _data["maxnoofcorrection"];
            this.mindays = _data["mindays"];
        }
    }

    static fromJS(data: any): GetAttendanceValidationmobile {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttendanceValidationmobile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["maxnoofcorrection"] = this.maxnoofcorrection;
        data["mindays"] = this.mindays;
        return data;
    }
}

export interface IGetAttendanceValidationmobile {
    count: number;
    maxnoofcorrection: number;
    mindays: number;
}

export class CreateOrEditOnDutyMobileDto implements ICreateOrEditOnDutyMobileDto {
    odType!: number;
    date!: moment.Moment;
    inTime!: string;
    outTime!: string;
    remarks!: string | undefined;
    abpUserId!: number;
    tenantId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditOnDutyMobileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odType = _data["odType"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.inTime = _data["inTime"];
            this.outTime = _data["outTime"];
            this.remarks = _data["remarks"];
            this.abpUserId = _data["abpUserId"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditOnDutyMobileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditOnDutyMobileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["odType"] = this.odType;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["inTime"] = this.inTime;
        data["outTime"] = this.outTime;
        data["remarks"] = this.remarks;
        data["abpUserId"] = this.abpUserId;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditOnDutyMobileDto {
    odType: number;
    date: moment.Moment;
    inTime: string;
    outTime: string;
    remarks: string | undefined;
    abpUserId: number;
    tenantId: number;
    id: number | undefined;
}

export class RequestForApprovalDto implements IRequestForApprovalDto {
    requestDate!: moment.Moment;
    requestBy!: number | undefined;
    payload!: string | undefined;
    requestTypeId!: number | undefined;
    status!: string | undefined;
    requestForApprovalLogId!: number;
    id!: number;

    constructor(data?: IRequestForApprovalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestDate = _data["requestDate"] ? moment(_data["requestDate"].toString()) : <any>undefined;
            this.requestBy = _data["requestBy"];
            this.payload = _data["payload"];
            this.requestTypeId = _data["requestTypeId"];
            this.status = _data["status"];
            this.requestForApprovalLogId = _data["requestForApprovalLogId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RequestForApprovalDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestForApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["requestBy"] = this.requestBy;
        data["payload"] = this.payload;
        data["requestTypeId"] = this.requestTypeId;
        data["status"] = this.status;
        data["requestForApprovalLogId"] = this.requestForApprovalLogId;
        data["id"] = this.id;
        return data;
    }
}

export interface IRequestForApprovalDto {
    requestDate: moment.Moment;
    requestBy: number | undefined;
    payload: string | undefined;
    requestTypeId: number | undefined;
    status: string | undefined;
    requestForApprovalLogId: number;
    id: number;
}

export class GetRequestForApprovalForViewDto implements IGetRequestForApprovalForViewDto {
    requestForApproval!: RequestForApprovalDto;
    requestByname!: string | undefined;
    requestTypeName!: string | undefined;
    description!: string | undefined;
    approvedOn!: moment.Moment;
    rejetedON!: moment.Moment | undefined;

    constructor(data?: IGetRequestForApprovalForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestForApproval = _data["requestForApproval"] ? RequestForApprovalDto.fromJS(_data["requestForApproval"]) : <any>undefined;
            this.requestByname = _data["requestByname"];
            this.requestTypeName = _data["requestTypeName"];
            this.description = _data["description"];
            this.approvedOn = _data["approvedOn"] ? moment(_data["approvedOn"].toString()) : <any>undefined;
            this.rejetedON = _data["rejetedON"] ? moment(_data["rejetedON"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRequestForApprovalForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRequestForApprovalForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestForApproval"] = this.requestForApproval ? this.requestForApproval.toJSON() : <any>undefined;
        data["requestByname"] = this.requestByname;
        data["requestTypeName"] = this.requestTypeName;
        data["description"] = this.description;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : <any>undefined;
        data["rejetedON"] = this.rejetedON ? this.rejetedON.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetRequestForApprovalForViewDto {
    requestForApproval: RequestForApprovalDto;
    requestByname: string | undefined;
    requestTypeName: string | undefined;
    description: string | undefined;
    approvedOn: moment.Moment;
    rejetedON: moment.Moment | undefined;
}

export class PagedResultDtoOfGetRequestForApprovalForViewDto implements IPagedResultDtoOfGetRequestForApprovalForViewDto {
    totalCount!: number;
    items!: GetRequestForApprovalForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetRequestForApprovalForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetRequestForApprovalForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetRequestForApprovalForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetRequestForApprovalForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetRequestForApprovalForViewDto {
    totalCount: number;
    items: GetRequestForApprovalForViewDto[] | undefined;
}

export class AttendanceDetailsPanelMobile implements IAttendanceDetailsPanelMobile {
    title!: string | undefined;
    startdate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    color!: string | undefined;

    constructor(data?: IAttendanceDetailsPanelMobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.startdate = _data["startdate"] ? moment(_data["startdate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): AttendanceDetailsPanelMobile {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceDetailsPanelMobile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["startdate"] = this.startdate ? this.startdate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["color"] = this.color;
        return data;
    }
}

export interface IAttendanceDetailsPanelMobile {
    title: string | undefined;
    startdate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    color: string | undefined;
}

export class CreateOrEditAdvanceRequestDtoMobile implements ICreateOrEditAdvanceRequestDtoMobile {
    amount!: number;
    advanceRequestDate!: moment.Moment;
    advanceRequireDate!: moment.Moment;
    noOfEMI!: number;
    remarks!: string | undefined;
    advanceTypeId!: number;
    advance_Return!: number;
    emiAmmount!: number;
    employeeId!: number;
    tenantId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAdvanceRequestDtoMobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.advanceRequestDate = _data["advanceRequestDate"] ? moment(_data["advanceRequestDate"].toString()) : <any>undefined;
            this.advanceRequireDate = _data["advanceRequireDate"] ? moment(_data["advanceRequireDate"].toString()) : <any>undefined;
            this.noOfEMI = _data["noOfEMI"];
            this.remarks = _data["remarks"];
            this.advanceTypeId = _data["advanceTypeId"];
            this.advance_Return = _data["advance_Return"];
            this.emiAmmount = _data["emiAmmount"];
            this.employeeId = _data["employeeId"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAdvanceRequestDtoMobile {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAdvanceRequestDtoMobile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["advanceRequestDate"] = this.advanceRequestDate ? this.advanceRequestDate.toISOString() : <any>undefined;
        data["advanceRequireDate"] = this.advanceRequireDate ? this.advanceRequireDate.toISOString() : <any>undefined;
        data["noOfEMI"] = this.noOfEMI;
        data["remarks"] = this.remarks;
        data["advanceTypeId"] = this.advanceTypeId;
        data["advance_Return"] = this.advance_Return;
        data["emiAmmount"] = this.emiAmmount;
        data["employeeId"] = this.employeeId;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditAdvanceRequestDtoMobile {
    amount: number;
    advanceRequestDate: moment.Moment;
    advanceRequireDate: moment.Moment;
    noOfEMI: number;
    remarks: string | undefined;
    advanceTypeId: number;
    advance_Return: number;
    emiAmmount: number;
    employeeId: number;
    tenantId: number;
    id: number | undefined;
}

export class EaringComponetsMobile implements IEaringComponetsMobile {
    name!: string | undefined;
    rate!: number | undefined;
    rs!: number | undefined;
    ytd!: number | undefined;

    constructor(data?: IEaringComponetsMobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.rate = _data["rate"];
            this.rs = _data["rs"];
            this.ytd = _data["ytd"];
        }
    }

    static fromJS(data: any): EaringComponetsMobile {
        data = typeof data === 'object' ? data : {};
        let result = new EaringComponetsMobile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["rate"] = this.rate;
        data["rs"] = this.rs;
        data["ytd"] = this.ytd;
        return data;
    }
}

export interface IEaringComponetsMobile {
    name: string | undefined;
    rate: number | undefined;
    rs: number | undefined;
    ytd: number | undefined;
}

export class DedctionComponetsMobile implements IDedctionComponetsMobile {
    name!: string | undefined;
    rate!: number | undefined;
    rs!: number | undefined;
    ytd!: number | undefined;

    constructor(data?: IDedctionComponetsMobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.rate = _data["rate"];
            this.rs = _data["rs"];
            this.ytd = _data["ytd"];
        }
    }

    static fromJS(data: any): DedctionComponetsMobile {
        data = typeof data === 'object' ? data : {};
        let result = new DedctionComponetsMobile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["rate"] = this.rate;
        data["rs"] = this.rs;
        data["ytd"] = this.ytd;
        return data;
    }
}

export interface IDedctionComponetsMobile {
    name: string | undefined;
    rate: number | undefined;
    rs: number | undefined;
    ytd: number | undefined;
}

export class SalaryViewDto implements ISalaryViewDto {
    showleaveonss!: boolean;
    logoImage!: string | undefined;
    companyName!: string | undefined;
    location!: string | undefined;
    employeeName!: string | undefined;
    salaryid!: number;
    fatherName!: string | undefined;
    doj!: string | undefined;
    employeeId!: string | undefined;
    designation!: string | undefined;
    department!: string | undefined;
    bankAcNo!: string | undefined;
    pfNo!: string | undefined;
    esiNo!: string | undefined;
    bankName!: string | undefined;
    panCard!: string | undefined;
    pfUanNo!: string | undefined;
    wo!: number | undefined;
    ho!: number | undefined;
    workDays!: number | undefined;
    lossOFpay!: number | undefined;
    present!: number | undefined;
    netSalary!: number | undefined;
    leave!: number | undefined;
    el!: number;
    cl!: number;
    sl!: number;
    earingComponetsMobile!: EaringComponetsMobile[] | undefined;
    dedctionComponetsMobile!: DedctionComponetsMobile[] | undefined;
    levaeBalanceDetailsMobile!: LeaveBlanceByTypeDetails;

    constructor(data?: ISalaryViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.showleaveonss = _data["showleaveonss"];
            this.logoImage = _data["logoImage"];
            this.companyName = _data["companyName"];
            this.location = _data["location"];
            this.employeeName = _data["employeeName"];
            this.salaryid = _data["salaryid"];
            this.fatherName = _data["fatherName"];
            this.doj = _data["doj"];
            this.employeeId = _data["employeeId"];
            this.designation = _data["designation"];
            this.department = _data["department"];
            this.bankAcNo = _data["bankAcNo"];
            this.pfNo = _data["pfNo"];
            this.esiNo = _data["esiNo"];
            this.bankName = _data["bankName"];
            this.panCard = _data["panCard"];
            this.pfUanNo = _data["pfUanNo"];
            this.wo = _data["wo"];
            this.ho = _data["ho"];
            this.workDays = _data["workDays"];
            this.lossOFpay = _data["lossOFpay"];
            this.present = _data["present"];
            this.netSalary = _data["netSalary"];
            this.leave = _data["leave"];
            this.el = _data["el"];
            this.cl = _data["cl"];
            this.sl = _data["sl"];
            if (Array.isArray(_data["earingComponetsMobile"])) {
                this.earingComponetsMobile = [] as any;
                for (let item of _data["earingComponetsMobile"])
                    this.earingComponetsMobile!.push(EaringComponetsMobile.fromJS(item));
            }
            if (Array.isArray(_data["dedctionComponetsMobile"])) {
                this.dedctionComponetsMobile = [] as any;
                for (let item of _data["dedctionComponetsMobile"])
                    this.dedctionComponetsMobile!.push(DedctionComponetsMobile.fromJS(item));
            }
            this.levaeBalanceDetailsMobile = _data["levaeBalanceDetailsMobile"] ? LeaveBlanceByTypeDetails.fromJS(_data["levaeBalanceDetailsMobile"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SalaryViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalaryViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showleaveonss"] = this.showleaveonss;
        data["logoImage"] = this.logoImage;
        data["companyName"] = this.companyName;
        data["location"] = this.location;
        data["employeeName"] = this.employeeName;
        data["salaryid"] = this.salaryid;
        data["fatherName"] = this.fatherName;
        data["doj"] = this.doj;
        data["employeeId"] = this.employeeId;
        data["designation"] = this.designation;
        data["department"] = this.department;
        data["bankAcNo"] = this.bankAcNo;
        data["pfNo"] = this.pfNo;
        data["esiNo"] = this.esiNo;
        data["bankName"] = this.bankName;
        data["panCard"] = this.panCard;
        data["pfUanNo"] = this.pfUanNo;
        data["wo"] = this.wo;
        data["ho"] = this.ho;
        data["workDays"] = this.workDays;
        data["lossOFpay"] = this.lossOFpay;
        data["present"] = this.present;
        data["netSalary"] = this.netSalary;
        data["leave"] = this.leave;
        data["el"] = this.el;
        data["cl"] = this.cl;
        data["sl"] = this.sl;
        if (Array.isArray(this.earingComponetsMobile)) {
            data["earingComponetsMobile"] = [];
            for (let item of this.earingComponetsMobile)
                data["earingComponetsMobile"].push(item.toJSON());
        }
        if (Array.isArray(this.dedctionComponetsMobile)) {
            data["dedctionComponetsMobile"] = [];
            for (let item of this.dedctionComponetsMobile)
                data["dedctionComponetsMobile"].push(item.toJSON());
        }
        data["levaeBalanceDetailsMobile"] = this.levaeBalanceDetailsMobile ? this.levaeBalanceDetailsMobile.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISalaryViewDto {
    showleaveonss: boolean;
    logoImage: string | undefined;
    companyName: string | undefined;
    location: string | undefined;
    employeeName: string | undefined;
    salaryid: number;
    fatherName: string | undefined;
    doj: string | undefined;
    employeeId: string | undefined;
    designation: string | undefined;
    department: string | undefined;
    bankAcNo: string | undefined;
    pfNo: string | undefined;
    esiNo: string | undefined;
    bankName: string | undefined;
    panCard: string | undefined;
    pfUanNo: string | undefined;
    wo: number | undefined;
    ho: number | undefined;
    workDays: number | undefined;
    lossOFpay: number | undefined;
    present: number | undefined;
    netSalary: number | undefined;
    leave: number | undefined;
    el: number;
    cl: number;
    sl: number;
    earingComponetsMobile: EaringComponetsMobile[] | undefined;
    dedctionComponetsMobile: DedctionComponetsMobile[] | undefined;
    levaeBalanceDetailsMobile: LeaveBlanceByTypeDetails;
}

export class LeaveBalanceListDashMobile implements ILeaveBalanceListDashMobile {
    leavetype!: string | undefined;
    leaveid!: number;
    total!: number | undefined;
    yearlyUsed!: number | undefined;
    balance!: number | undefined;
    percent!: number | undefined;
    resultvalue!: number | undefined;
    percentbal!: number | undefined;
    resultbal!: number | undefined;
    negativeBal!: boolean;

    constructor(data?: ILeaveBalanceListDashMobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leavetype = _data["leavetype"];
            this.leaveid = _data["leaveid"];
            this.total = _data["total"];
            this.yearlyUsed = _data["yearlyUsed"];
            this.balance = _data["balance"];
            this.percent = _data["percent"];
            this.resultvalue = _data["resultvalue"];
            this.percentbal = _data["percentbal"];
            this.resultbal = _data["resultbal"];
            this.negativeBal = _data["negativeBal"];
        }
    }

    static fromJS(data: any): LeaveBalanceListDashMobile {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveBalanceListDashMobile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leavetype"] = this.leavetype;
        data["leaveid"] = this.leaveid;
        data["total"] = this.total;
        data["yearlyUsed"] = this.yearlyUsed;
        data["balance"] = this.balance;
        data["percent"] = this.percent;
        data["resultvalue"] = this.resultvalue;
        data["percentbal"] = this.percentbal;
        data["resultbal"] = this.resultbal;
        data["negativeBal"] = this.negativeBal;
        return data;
    }
}

export interface ILeaveBalanceListDashMobile {
    leavetype: string | undefined;
    leaveid: number;
    total: number | undefined;
    yearlyUsed: number | undefined;
    balance: number | undefined;
    percent: number | undefined;
    resultvalue: number | undefined;
    percentbal: number | undefined;
    resultbal: number | undefined;
    negativeBal: boolean;
}

export class GetHolidayForViewMobile implements IGetHolidayForViewMobile {
    holiday!: HolidayDto;

    constructor(data?: IGetHolidayForViewMobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.holiday = _data["holiday"] ? HolidayDto.fromJS(_data["holiday"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetHolidayForViewMobile {
        data = typeof data === 'object' ? data : {};
        let result = new GetHolidayForViewMobile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["holiday"] = this.holiday ? this.holiday.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetHolidayForViewMobile {
    holiday: HolidayDto;
}

export class EmployeevisitDto implements IEmployeevisitDto {

    constructor(data?: IEmployeevisitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): EmployeevisitDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeevisitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IEmployeevisitDto {
}

export class VisitDaySummaryDto implements IVisitDaySummaryDto {
    employeeId!: number;
    startLongitude!: string | undefined;
    startLatitude!: string | undefined;
    locationAddress!: string | undefined;

    constructor(data?: IVisitDaySummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.startLongitude = _data["startLongitude"];
            this.startLatitude = _data["startLatitude"];
            this.locationAddress = _data["locationAddress"];
        }
    }

    static fromJS(data: any): VisitDaySummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new VisitDaySummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["startLongitude"] = this.startLongitude;
        data["startLatitude"] = this.startLatitude;
        data["locationAddress"] = this.locationAddress;
        return data;
    }
}

export interface IVisitDaySummaryDto {
    employeeId: number;
    startLongitude: string | undefined;
    startLatitude: string | undefined;
    locationAddress: string | undefined;
}

export class EmployeeVisitInDetailsDto implements IEmployeeVisitInDetailsDto {
    iamgeUrl!: string | undefined;
    visitDate!: moment.Moment;
    customerId!: number;
    otherCustomer!: string | undefined;
    visit_In_Long!: string | undefined;
    visit_In_Latt!: string | undefined;
    locationAddress!: string | undefined;
    readonly noteImage!: string | undefined;

    constructor(data?: IEmployeeVisitInDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iamgeUrl = _data["iamgeUrl"];
            this.visitDate = _data["visitDate"] ? moment(_data["visitDate"].toString()) : <any>undefined;
            this.customerId = _data["customerId"];
            this.otherCustomer = _data["otherCustomer"];
            this.visit_In_Long = _data["visit_In_Long"];
            this.visit_In_Latt = _data["visit_In_Latt"];
            this.locationAddress = _data["locationAddress"];
            (<any>this).noteImage = _data["noteImage"];
        }
    }

    static fromJS(data: any): EmployeeVisitInDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeVisitInDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iamgeUrl"] = this.iamgeUrl;
        data["visitDate"] = this.visitDate ? this.visitDate.toISOString() : <any>undefined;
        data["customerId"] = this.customerId;
        data["otherCustomer"] = this.otherCustomer;
        data["visit_In_Long"] = this.visit_In_Long;
        data["visit_In_Latt"] = this.visit_In_Latt;
        data["locationAddress"] = this.locationAddress;
        data["noteImage"] = this.noteImage;
        return data;
    }
}

export interface IEmployeeVisitInDetailsDto {
    iamgeUrl: string | undefined;
    visitDate: moment.Moment;
    customerId: number;
    otherCustomer: string | undefined;
    visit_In_Long: string | undefined;
    visit_In_Latt: string | undefined;
    locationAddress: string | undefined;
    noteImage: string | undefined;
}

export class EmployeeVisitDetailsUpdateDto implements IEmployeeVisitDetailsUpdateDto {
    customerId!: number;
    otherCustomer!: string | undefined;
    locationAddress!: string | undefined;
    visitInDetailsImage!: string | undefined;
    remarks!: string | undefined;

    constructor(data?: IEmployeeVisitDetailsUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.otherCustomer = _data["otherCustomer"];
            this.locationAddress = _data["locationAddress"];
            this.visitInDetailsImage = _data["visitInDetailsImage"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): EmployeeVisitDetailsUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeVisitDetailsUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["otherCustomer"] = this.otherCustomer;
        data["locationAddress"] = this.locationAddress;
        data["visitInDetailsImage"] = this.visitInDetailsImage;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IEmployeeVisitDetailsUpdateDto {
    customerId: number;
    otherCustomer: string | undefined;
    locationAddress: string | undefined;
    visitInDetailsImage: string | undefined;
    remarks: string | undefined;
}

export class EmployeeVisitOutDetailsDto implements IEmployeeVisitOutDetailsDto {
    customerId!: number;
    otherCustomer!: string | undefined;
    locationAddress!: string | undefined;
    visit_Out_Long!: string | undefined;
    visit_Out_Latt!: string | undefined;

    constructor(data?: IEmployeeVisitOutDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.otherCustomer = _data["otherCustomer"];
            this.locationAddress = _data["locationAddress"];
            this.visit_Out_Long = _data["visit_Out_Long"];
            this.visit_Out_Latt = _data["visit_Out_Latt"];
        }
    }

    static fromJS(data: any): EmployeeVisitOutDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeVisitOutDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["otherCustomer"] = this.otherCustomer;
        data["locationAddress"] = this.locationAddress;
        data["visit_Out_Long"] = this.visit_Out_Long;
        data["visit_Out_Latt"] = this.visit_Out_Latt;
        return data;
    }
}

export interface IEmployeeVisitOutDetailsDto {
    customerId: number;
    otherCustomer: string | undefined;
    locationAddress: string | undefined;
    visit_Out_Long: string | undefined;
    visit_Out_Latt: string | undefined;
}

export class CurrentActiveVisitDto implements ICurrentActiveVisitDto {
    visitDate!: moment.Moment;
    visit_In_Time!: string | undefined;
    visit_Out_Time!: string | undefined;
    customer!: string | undefined;
    customerId!: number;
    otherCustomer!: string | undefined;
    visit_In_Long!: string | undefined;
    visit_In_Latt!: string | undefined;
    visit_Out_Long!: string | undefined;
    visit_Out_Latt!: string | undefined;
    visitInLocation!: string | undefined;
    visitOutLocation!: string | undefined;

    constructor(data?: ICurrentActiveVisitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.visitDate = _data["visitDate"] ? moment(_data["visitDate"].toString()) : <any>undefined;
            this.visit_In_Time = _data["visit_In_Time"];
            this.visit_Out_Time = _data["visit_Out_Time"];
            this.customer = _data["customer"];
            this.customerId = _data["customerId"];
            this.otherCustomer = _data["otherCustomer"];
            this.visit_In_Long = _data["visit_In_Long"];
            this.visit_In_Latt = _data["visit_In_Latt"];
            this.visit_Out_Long = _data["visit_Out_Long"];
            this.visit_Out_Latt = _data["visit_Out_Latt"];
            this.visitInLocation = _data["visitInLocation"];
            this.visitOutLocation = _data["visitOutLocation"];
        }
    }

    static fromJS(data: any): CurrentActiveVisitDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentActiveVisitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visitDate"] = this.visitDate ? this.visitDate.toISOString() : <any>undefined;
        data["visit_In_Time"] = this.visit_In_Time;
        data["visit_Out_Time"] = this.visit_Out_Time;
        data["customer"] = this.customer;
        data["customerId"] = this.customerId;
        data["otherCustomer"] = this.otherCustomer;
        data["visit_In_Long"] = this.visit_In_Long;
        data["visit_In_Latt"] = this.visit_In_Latt;
        data["visit_Out_Long"] = this.visit_Out_Long;
        data["visit_Out_Latt"] = this.visit_Out_Latt;
        data["visitInLocation"] = this.visitInLocation;
        data["visitOutLocation"] = this.visitOutLocation;
        return data;
    }
}

export interface ICurrentActiveVisitDto {
    visitDate: moment.Moment;
    visit_In_Time: string | undefined;
    visit_Out_Time: string | undefined;
    customer: string | undefined;
    customerId: number;
    otherCustomer: string | undefined;
    visit_In_Long: string | undefined;
    visit_In_Latt: string | undefined;
    visit_Out_Long: string | undefined;
    visit_Out_Latt: string | undefined;
    visitInLocation: string | undefined;
    visitOutLocation: string | undefined;
}

export class EmployeeCurrentVisitDetailsDto implements IEmployeeCurrentVisitDetailsDto {
    isDayStarted!: boolean;
    isDayEnded!: boolean;
    currentActiveVisit!: CurrentActiveVisitDto;

    constructor(data?: IEmployeeCurrentVisitDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDayStarted = _data["isDayStarted"];
            this.isDayEnded = _data["isDayEnded"];
            this.currentActiveVisit = _data["currentActiveVisit"] ? CurrentActiveVisitDto.fromJS(_data["currentActiveVisit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeeCurrentVisitDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeCurrentVisitDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDayStarted"] = this.isDayStarted;
        data["isDayEnded"] = this.isDayEnded;
        data["currentActiveVisit"] = this.currentActiveVisit ? this.currentActiveVisit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmployeeCurrentVisitDetailsDto {
    isDayStarted: boolean;
    isDayEnded: boolean;
    currentActiveVisit: CurrentActiveVisitDto;
}

export class VisitDaySummaryEndDto implements IVisitDaySummaryEndDto {
    employeeId!: number;
    locationAddress!: string | undefined;
    endLongitude!: string | undefined;
    endLatitude!: string | undefined;

    constructor(data?: IVisitDaySummaryEndDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.locationAddress = _data["locationAddress"];
            this.endLongitude = _data["endLongitude"];
            this.endLatitude = _data["endLatitude"];
        }
    }

    static fromJS(data: any): VisitDaySummaryEndDto {
        data = typeof data === 'object' ? data : {};
        let result = new VisitDaySummaryEndDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["locationAddress"] = this.locationAddress;
        data["endLongitude"] = this.endLongitude;
        data["endLatitude"] = this.endLatitude;
        return data;
    }
}

export interface IVisitDaySummaryEndDto {
    employeeId: number;
    locationAddress: string | undefined;
    endLongitude: string | undefined;
    endLatitude: string | undefined;
}

export class MonthlyDetails implements IMonthlyDetails {
    date!: moment.Moment;
    in!: string;
    out!: string;
    shift!: string | undefined;
    late!: string;
    workingHours!: string;
    otHours!: string;
    early!: string;
    totalTime!: string;
    attendanceStatus!: string | undefined;

    constructor(data?: IMonthlyDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.in = _data["in"];
            this.out = _data["out"];
            this.shift = _data["shift"];
            this.late = _data["late"];
            this.workingHours = _data["workingHours"];
            this.otHours = _data["otHours"];
            this.early = _data["early"];
            this.totalTime = _data["totalTime"];
            this.attendanceStatus = _data["attendanceStatus"];
        }
    }

    static fromJS(data: any): MonthlyDetails {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["in"] = this.in;
        data["out"] = this.out;
        data["shift"] = this.shift;
        data["late"] = this.late;
        data["workingHours"] = this.workingHours;
        data["otHours"] = this.otHours;
        data["early"] = this.early;
        data["totalTime"] = this.totalTime;
        data["attendanceStatus"] = this.attendanceStatus;
        return data;
    }
}

export interface IMonthlyDetails {
    date: moment.Moment;
    in: string;
    out: string;
    shift: string | undefined;
    late: string;
    workingHours: string;
    otHours: string;
    early: string;
    totalTime: string;
    attendanceStatus: string | undefined;
}

export class MonthlyPerformanceReportDto implements IMonthlyPerformanceReportDto {
    department!: string | undefined;
    name!: string | undefined;
    empCode!: string | undefined;
    designation!: string | undefined;
    late!: string | undefined;
    totalWorkingHours!: string | undefined;
    totalOtHours!: string | undefined;
    absent!: number;
    present!: number;
    paidDays!: number;
    weeklyOff!: number;
    leave!: number;
    totalweekoff!: number;
    forgetout!: number;
    wooffPresent!: number;
    ph!: number;
    poh!: number;
    totalLeave!: number;
    lwp!: number;
    totalpaiddays!: number;
    totalPh!: number;
    hld!: number;
    details!: MonthlyDetails[] | undefined;

    constructor(data?: IMonthlyPerformanceReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.department = _data["department"];
            this.name = _data["name"];
            this.empCode = _data["empCode"];
            this.designation = _data["designation"];
            this.late = _data["late"];
            this.totalWorkingHours = _data["totalWorkingHours"];
            this.totalOtHours = _data["totalOtHours"];
            this.absent = _data["absent"];
            this.present = _data["present"];
            this.paidDays = _data["paidDays"];
            this.weeklyOff = _data["weeklyOff"];
            this.leave = _data["leave"];
            this.totalweekoff = _data["totalweekoff"];
            this.forgetout = _data["forgetout"];
            this.wooffPresent = _data["wooffPresent"];
            this.ph = _data["ph"];
            this.poh = _data["poh"];
            this.totalLeave = _data["totalLeave"];
            this.lwp = _data["lwp"];
            this.totalpaiddays = _data["totalpaiddays"];
            this.totalPh = _data["totalPh"];
            this.hld = _data["hld"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(MonthlyDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MonthlyPerformanceReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyPerformanceReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["department"] = this.department;
        data["name"] = this.name;
        data["empCode"] = this.empCode;
        data["designation"] = this.designation;
        data["late"] = this.late;
        data["totalWorkingHours"] = this.totalWorkingHours;
        data["totalOtHours"] = this.totalOtHours;
        data["absent"] = this.absent;
        data["present"] = this.present;
        data["paidDays"] = this.paidDays;
        data["weeklyOff"] = this.weeklyOff;
        data["leave"] = this.leave;
        data["totalweekoff"] = this.totalweekoff;
        data["forgetout"] = this.forgetout;
        data["wooffPresent"] = this.wooffPresent;
        data["ph"] = this.ph;
        data["poh"] = this.poh;
        data["totalLeave"] = this.totalLeave;
        data["lwp"] = this.lwp;
        data["totalpaiddays"] = this.totalpaiddays;
        data["totalPh"] = this.totalPh;
        data["hld"] = this.hld;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMonthlyPerformanceReportDto {
    department: string | undefined;
    name: string | undefined;
    empCode: string | undefined;
    designation: string | undefined;
    late: string | undefined;
    totalWorkingHours: string | undefined;
    totalOtHours: string | undefined;
    absent: number;
    present: number;
    paidDays: number;
    weeklyOff: number;
    leave: number;
    totalweekoff: number;
    forgetout: number;
    wooffPresent: number;
    ph: number;
    poh: number;
    totalLeave: number;
    lwp: number;
    totalpaiddays: number;
    totalPh: number;
    hld: number;
    details: MonthlyDetails[] | undefined;
}

export class MonthWiseportattandnaceDto implements IMonthWiseportattandnaceDto {
    employeeId!: number;
    monthYear!: string | undefined;
    attendance!: number | undefined;
    employeeName!: string | undefined;
    employeeCode!: string | undefined;
    overTime!: number | undefined;
    weekOff!: number | undefined;
    holiday!: number | undefined;
    id!: number;

    constructor(data?: IMonthWiseportattandnaceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.monthYear = _data["monthYear"];
            this.attendance = _data["attendance"];
            this.employeeName = _data["employeeName"];
            this.employeeCode = _data["employeeCode"];
            this.overTime = _data["overTime"];
            this.weekOff = _data["weekOff"];
            this.holiday = _data["holiday"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MonthWiseportattandnaceDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthWiseportattandnaceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["monthYear"] = this.monthYear;
        data["attendance"] = this.attendance;
        data["employeeName"] = this.employeeName;
        data["employeeCode"] = this.employeeCode;
        data["overTime"] = this.overTime;
        data["weekOff"] = this.weekOff;
        data["holiday"] = this.holiday;
        data["id"] = this.id;
        return data;
    }
}

export interface IMonthWiseportattandnaceDto {
    employeeId: number;
    monthYear: string | undefined;
    attendance: number | undefined;
    employeeName: string | undefined;
    employeeCode: string | undefined;
    overTime: number | undefined;
    weekOff: number | undefined;
    holiday: number | undefined;
    id: number;
}

export class GetMonthWiseportattandnaceForViewDto implements IGetMonthWiseportattandnaceForViewDto {
    monthWiseportattandnace!: MonthWiseportattandnaceDto;

    constructor(data?: IGetMonthWiseportattandnaceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthWiseportattandnace = _data["monthWiseportattandnace"] ? MonthWiseportattandnaceDto.fromJS(_data["monthWiseportattandnace"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMonthWiseportattandnaceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMonthWiseportattandnaceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthWiseportattandnace"] = this.monthWiseportattandnace ? this.monthWiseportattandnace.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMonthWiseportattandnaceForViewDto {
    monthWiseportattandnace: MonthWiseportattandnaceDto;
}

export class PagedResultDtoOfGetMonthWiseportattandnaceForViewDto implements IPagedResultDtoOfGetMonthWiseportattandnaceForViewDto {
    totalCount!: number;
    items!: GetMonthWiseportattandnaceForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetMonthWiseportattandnaceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetMonthWiseportattandnaceForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetMonthWiseportattandnaceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetMonthWiseportattandnaceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetMonthWiseportattandnaceForViewDto {
    totalCount: number;
    items: GetMonthWiseportattandnaceForViewDto[] | undefined;
}

export class CreateOrEditMonthWiseportattandnaceDto implements ICreateOrEditMonthWiseportattandnaceDto {
    employeeId!: number;
    monthYear!: string | undefined;
    attendance!: number | undefined;
    overTime!: number | undefined;
    weekOff!: number | undefined;
    holiday!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditMonthWiseportattandnaceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.monthYear = _data["monthYear"];
            this.attendance = _data["attendance"];
            this.overTime = _data["overTime"];
            this.weekOff = _data["weekOff"];
            this.holiday = _data["holiday"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditMonthWiseportattandnaceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditMonthWiseportattandnaceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["monthYear"] = this.monthYear;
        data["attendance"] = this.attendance;
        data["overTime"] = this.overTime;
        data["weekOff"] = this.weekOff;
        data["holiday"] = this.holiday;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditMonthWiseportattandnaceDto {
    employeeId: number;
    monthYear: string | undefined;
    attendance: number | undefined;
    overTime: number | undefined;
    weekOff: number | undefined;
    holiday: number | undefined;
    id: number | undefined;
}

export class GetMonthWiseportattandnaceForEditOutput implements IGetMonthWiseportattandnaceForEditOutput {
    monthWiseportattandnace!: CreateOrEditMonthWiseportattandnaceDto;

    constructor(data?: IGetMonthWiseportattandnaceForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthWiseportattandnace = _data["monthWiseportattandnace"] ? CreateOrEditMonthWiseportattandnaceDto.fromJS(_data["monthWiseportattandnace"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMonthWiseportattandnaceForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMonthWiseportattandnaceForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthWiseportattandnace"] = this.monthWiseportattandnace ? this.monthWiseportattandnace.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMonthWiseportattandnaceForEditOutput {
    monthWiseportattandnace: CreateOrEditMonthWiseportattandnaceDto;
}

export class Montportedlist implements IMontportedlist {
    employeeCode!: string | undefined;
    monthYear!: string | undefined;
    attendance!: number | undefined;
    overTime!: number | undefined;
    weekOff!: number | undefined;
    holiday!: number | undefined;

    constructor(data?: IMontportedlist) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeCode = _data["employeeCode"];
            this.monthYear = _data["monthYear"];
            this.attendance = _data["attendance"];
            this.overTime = _data["overTime"];
            this.weekOff = _data["weekOff"];
            this.holiday = _data["holiday"];
        }
    }

    static fromJS(data: any): Montportedlist {
        data = typeof data === 'object' ? data : {};
        let result = new Montportedlist();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeCode"] = this.employeeCode;
        data["monthYear"] = this.monthYear;
        data["attendance"] = this.attendance;
        data["overTime"] = this.overTime;
        data["weekOff"] = this.weekOff;
        data["holiday"] = this.holiday;
        return data;
    }
}

export interface IMontportedlist {
    employeeCode: string | undefined;
    monthYear: string | undefined;
    attendance: number | undefined;
    overTime: number | undefined;
    weekOff: number | undefined;
    holiday: number | undefined;
}

export class MonthWisportedAttendance implements IMonthWisportedAttendance {
    montportedlist!: Montportedlist[] | undefined;
    id!: number | undefined;

    constructor(data?: IMonthWisportedAttendance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["montportedlist"])) {
                this.montportedlist = [] as any;
                for (let item of _data["montportedlist"])
                    this.montportedlist!.push(Montportedlist.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MonthWisportedAttendance {
        data = typeof data === 'object' ? data : {};
        let result = new MonthWisportedAttendance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.montportedlist)) {
            data["montportedlist"] = [];
            for (let item of this.montportedlist)
                data["montportedlist"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IMonthWisportedAttendance {
    montportedlist: Montportedlist[] | undefined;
    id: number | undefined;
}

export class MonthportAlreadyExits implements IMonthportAlreadyExits {
    employeeCode!: string | undefined;
    message!: string | undefined;

    constructor(data?: IMonthportAlreadyExits) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeCode = _data["employeeCode"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): MonthportAlreadyExits {
        data = typeof data === 'object' ? data : {};
        let result = new MonthportAlreadyExits();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeCode"] = this.employeeCode;
        data["message"] = this.message;
        return data;
    }
}

export interface IMonthportAlreadyExits {
    employeeCode: string | undefined;
    message: string | undefined;
}

export class GetEmployeeForListForPunch implements IGetEmployeeForListForPunch {
    rowNumber!: number;
    employeeId!: number;
    name!: string | undefined;
    employeeCode!: string | undefined;
    employeeImage!: string | undefined;
    shiftName!: string | undefined;
    designationName!: string | undefined;
    gender!: number;
    punchTime!: string;
    mode!: string | undefined;
    locationName!: string | undefined;

    constructor(data?: IGetEmployeeForListForPunch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowNumber = _data["rowNumber"];
            this.employeeId = _data["employeeId"];
            this.name = _data["name"];
            this.employeeCode = _data["employeeCode"];
            this.employeeImage = _data["employeeImage"];
            this.shiftName = _data["shiftName"];
            this.designationName = _data["designationName"];
            this.gender = _data["gender"];
            this.punchTime = _data["punchTime"];
            this.mode = _data["mode"];
            this.locationName = _data["locationName"];
        }
    }

    static fromJS(data: any): GetEmployeeForListForPunch {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeForListForPunch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowNumber"] = this.rowNumber;
        data["employeeId"] = this.employeeId;
        data["name"] = this.name;
        data["employeeCode"] = this.employeeCode;
        data["employeeImage"] = this.employeeImage;
        data["shiftName"] = this.shiftName;
        data["designationName"] = this.designationName;
        data["gender"] = this.gender;
        data["punchTime"] = this.punchTime;
        data["mode"] = this.mode;
        data["locationName"] = this.locationName;
        return data;
    }
}

export interface IGetEmployeeForListForPunch {
    rowNumber: number;
    employeeId: number;
    name: string | undefined;
    employeeCode: string | undefined;
    employeeImage: string | undefined;
    shiftName: string | undefined;
    designationName: string | undefined;
    gender: number;
    punchTime: string;
    mode: string | undefined;
    locationName: string | undefined;
}

export class GetEmployeeForList implements IGetEmployeeForList {
    getEmployeeForForPunch!: GetEmployeeForListForPunch;
    totalCount!: number;

    constructor(data?: IGetEmployeeForList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.getEmployeeForForPunch = _data["getEmployeeForForPunch"] ? GetEmployeeForListForPunch.fromJS(_data["getEmployeeForForPunch"]) : <any>undefined;
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): GetEmployeeForList {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeForList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["getEmployeeForForPunch"] = this.getEmployeeForForPunch ? this.getEmployeeForForPunch.toJSON() : <any>undefined;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IGetEmployeeForList {
    getEmployeeForForPunch: GetEmployeeForListForPunch;
    totalCount: number;
}

export class PagedResultDtoOfGetEmployeeForList implements IPagedResultDtoOfGetEmployeeForList {
    totalCount!: number;
    items!: GetEmployeeForList[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEmployeeForList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetEmployeeForList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEmployeeForList {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEmployeeForList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetEmployeeForList {
    totalCount: number;
    items: GetEmployeeForList[] | undefined;
}

export class GetLeaveTodayList implements IGetLeaveTodayList {
    employeeCode!: string | undefined;
    employeeName!: string | undefined;
    leaveName!: string | undefined;
    leaveDay!: string | undefined;
    employeeImage!: string | undefined;
    designation!: string | undefined;
    gender!: number;

    constructor(data?: IGetLeaveTodayList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeCode = _data["employeeCode"];
            this.employeeName = _data["employeeName"];
            this.leaveName = _data["leaveName"];
            this.leaveDay = _data["leaveDay"];
            this.employeeImage = _data["employeeImage"];
            this.designation = _data["designation"];
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): GetLeaveTodayList {
        data = typeof data === 'object' ? data : {};
        let result = new GetLeaveTodayList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeCode"] = this.employeeCode;
        data["employeeName"] = this.employeeName;
        data["leaveName"] = this.leaveName;
        data["leaveDay"] = this.leaveDay;
        data["employeeImage"] = this.employeeImage;
        data["designation"] = this.designation;
        data["gender"] = this.gender;
        return data;
    }
}

export interface IGetLeaveTodayList {
    employeeCode: string | undefined;
    employeeName: string | undefined;
    leaveName: string | undefined;
    leaveDay: string | undefined;
    employeeImage: string | undefined;
    designation: string | undefined;
    gender: number;
}

export class PagedResultDtoOfGetLeaveTodayList implements IPagedResultDtoOfGetLeaveTodayList {
    totalCount!: number;
    items!: GetLeaveTodayList[] | undefined;

    constructor(data?: IPagedResultDtoOfGetLeaveTodayList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetLeaveTodayList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetLeaveTodayList {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetLeaveTodayList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetLeaveTodayList {
    totalCount: number;
    items: GetLeaveTodayList[] | undefined;
}

export class GetEmployeeWhoIsLate implements IGetEmployeeWhoIsLate {
    rowNumber!: number;
    empId!: number;
    name!: string | undefined;
    employeeCode!: string | undefined;
    employeeImage!: string | undefined;
    shiftName!: string | undefined;
    shiftTime!: string;
    punchIn!: string;
    designationName!: string | undefined;
    gender!: number;

    constructor(data?: IGetEmployeeWhoIsLate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowNumber = _data["rowNumber"];
            this.empId = _data["empId"];
            this.name = _data["name"];
            this.employeeCode = _data["employeeCode"];
            this.employeeImage = _data["employeeImage"];
            this.shiftName = _data["shiftName"];
            this.shiftTime = _data["shiftTime"];
            this.punchIn = _data["punchIn"];
            this.designationName = _data["designationName"];
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): GetEmployeeWhoIsLate {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeWhoIsLate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowNumber"] = this.rowNumber;
        data["empId"] = this.empId;
        data["name"] = this.name;
        data["employeeCode"] = this.employeeCode;
        data["employeeImage"] = this.employeeImage;
        data["shiftName"] = this.shiftName;
        data["shiftTime"] = this.shiftTime;
        data["punchIn"] = this.punchIn;
        data["designationName"] = this.designationName;
        data["gender"] = this.gender;
        return data;
    }
}

export interface IGetEmployeeWhoIsLate {
    rowNumber: number;
    empId: number;
    name: string | undefined;
    employeeCode: string | undefined;
    employeeImage: string | undefined;
    shiftName: string | undefined;
    shiftTime: string;
    punchIn: string;
    designationName: string | undefined;
    gender: number;
}

export class GetLateEmployeeList implements IGetLateEmployeeList {
    getEmployeeWhoIsLate!: GetEmployeeWhoIsLate;
    totalCount!: number;

    constructor(data?: IGetLateEmployeeList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.getEmployeeWhoIsLate = _data["getEmployeeWhoIsLate"] ? GetEmployeeWhoIsLate.fromJS(_data["getEmployeeWhoIsLate"]) : <any>undefined;
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): GetLateEmployeeList {
        data = typeof data === 'object' ? data : {};
        let result = new GetLateEmployeeList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["getEmployeeWhoIsLate"] = this.getEmployeeWhoIsLate ? this.getEmployeeWhoIsLate.toJSON() : <any>undefined;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IGetLateEmployeeList {
    getEmployeeWhoIsLate: GetEmployeeWhoIsLate;
    totalCount: number;
}

export class PagedResultDtoOfGetLateEmployeeList implements IPagedResultDtoOfGetLateEmployeeList {
    totalCount!: number;
    items!: GetLateEmployeeList[] | undefined;

    constructor(data?: IPagedResultDtoOfGetLateEmployeeList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetLateEmployeeList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetLateEmployeeList {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetLateEmployeeList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetLateEmployeeList {
    totalCount: number;
    items: GetLateEmployeeList[] | undefined;
}

export class GetTeamMemberList implements IGetTeamMemberList {
    employeeCode!: string | undefined;
    employeeName!: string | undefined;
    branch!: string | undefined;
    gender!: string | undefined;
    employeeImage!: string | undefined;
    designation!: string | undefined;
    increamentDueDate!: moment.Moment;

    constructor(data?: IGetTeamMemberList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeCode = _data["employeeCode"];
            this.employeeName = _data["employeeName"];
            this.branch = _data["branch"];
            this.gender = _data["gender"];
            this.employeeImage = _data["employeeImage"];
            this.designation = _data["designation"];
            this.increamentDueDate = _data["increamentDueDate"] ? moment(_data["increamentDueDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTeamMemberList {
        data = typeof data === 'object' ? data : {};
        let result = new GetTeamMemberList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeCode"] = this.employeeCode;
        data["employeeName"] = this.employeeName;
        data["branch"] = this.branch;
        data["gender"] = this.gender;
        data["employeeImage"] = this.employeeImage;
        data["designation"] = this.designation;
        data["increamentDueDate"] = this.increamentDueDate ? this.increamentDueDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetTeamMemberList {
    employeeCode: string | undefined;
    employeeName: string | undefined;
    branch: string | undefined;
    gender: string | undefined;
    employeeImage: string | undefined;
    designation: string | undefined;
    increamentDueDate: moment.Moment;
}

export class PagedResultDtoOfGetTeamMemberList implements IPagedResultDtoOfGetTeamMemberList {
    totalCount!: number;
    items!: GetTeamMemberList[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTeamMemberList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTeamMemberList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTeamMemberList {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTeamMemberList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTeamMemberList {
    totalCount: number;
    items: GetTeamMemberList[] | undefined;
}

export class NationalityDto implements INationalityDto {
    name!: string | undefined;
    id!: number;

    constructor(data?: INationalityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NationalityDto {
        data = typeof data === 'object' ? data : {};
        let result = new NationalityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface INationalityDto {
    name: string | undefined;
    id: number;
}

export class GetNationalityForViewDto implements IGetNationalityForViewDto {
    nationality!: NationalityDto;

    constructor(data?: IGetNationalityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nationality = _data["nationality"] ? NationalityDto.fromJS(_data["nationality"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetNationalityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetNationalityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nationality"] = this.nationality ? this.nationality.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetNationalityForViewDto {
    nationality: NationalityDto;
}

export class PagedResultDtoOfGetNationalityForViewDto implements IPagedResultDtoOfGetNationalityForViewDto {
    totalCount!: number;
    items!: GetNationalityForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetNationalityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetNationalityForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetNationalityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetNationalityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetNationalityForViewDto {
    totalCount: number;
    items: GetNationalityForViewDto[] | undefined;
}

export class CreateOrEditNationalityDto implements ICreateOrEditNationalityDto {
    name!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditNationalityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditNationalityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditNationalityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditNationalityDto {
    name: string | undefined;
    id: number | undefined;
}

export class GetNationalityForEditOutput implements IGetNationalityForEditOutput {
    nationality!: CreateOrEditNationalityDto;

    constructor(data?: IGetNationalityForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nationality = _data["nationality"] ? CreateOrEditNationalityDto.fromJS(_data["nationality"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetNationalityForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNationalityForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nationality"] = this.nationality ? this.nationality.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetNationalityForEditOutput {
    nationality: CreateOrEditNationalityDto;
}

export enum UserNotificationState {
    Unread = 0,
    Read = 1,
}

export class NotificationData implements INotificationData {
    readonly type!: string | undefined;
    properties!: { [key: string]: any; } | undefined;

    constructor(data?: INotificationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).type = _data["type"];
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): NotificationData {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = (<any>this.properties)[key];
            }
        }
        return data;
    }
}

export interface INotificationData {
    type: string | undefined;
    properties: { [key: string]: any; } | undefined;
}

export enum NotificationSeverity {
    Info = 0,
    Success = 1,
    Warn = 2,
    Error = 3,
    Fatal = 4,
}

export class TenantNotification implements ITenantNotification {
    tenantId!: number | undefined;
    notificationName!: string | undefined;
    data!: NotificationData;
    entityType!: string | undefined;
    entityTypeName!: string | undefined;
    entityId!: any | undefined;
    severity!: NotificationSeverity;
    creationTime!: moment.Moment;
    id!: string;

    constructor(data?: ITenantNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.notificationName = _data["notificationName"];
            this.data = _data["data"] ? NotificationData.fromJS(_data["data"]) : <any>undefined;
            this.entityType = _data["entityType"];
            this.entityTypeName = _data["entityTypeName"];
            this.entityId = _data["entityId"];
            this.severity = _data["severity"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantNotification {
        data = typeof data === 'object' ? data : {};
        let result = new TenantNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["notificationName"] = this.notificationName;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["entityType"] = this.entityType;
        data["entityTypeName"] = this.entityTypeName;
        data["entityId"] = this.entityId;
        data["severity"] = this.severity;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantNotification {
    tenantId: number | undefined;
    notificationName: string | undefined;
    data: NotificationData;
    entityType: string | undefined;
    entityTypeName: string | undefined;
    entityId: any | undefined;
    severity: NotificationSeverity;
    creationTime: moment.Moment;
    id: string;
}

export class UserNotification implements IUserNotification {
    tenantId!: number | undefined;
    userId!: number;
    state!: UserNotificationState;
    notification!: TenantNotification;
    id!: string;

    constructor(data?: IUserNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.state = _data["state"];
            this.notification = _data["notification"] ? TenantNotification.fromJS(_data["notification"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserNotification {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["state"] = this.state;
        data["notification"] = this.notification ? this.notification.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserNotification {
    tenantId: number | undefined;
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification;
    id: string;
}

export class GetNotificationsOutput implements IGetNotificationsOutput {
    unreadCount!: number;
    totalCount!: number;
    items!: UserNotification[] | undefined;

    constructor(data?: IGetNotificationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unreadCount = _data["unreadCount"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unreadCount"] = this.unreadCount;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetNotificationsOutput {
    unreadCount: number;
    totalCount: number;
    items: UserNotification[] | undefined;
}

export class EntityDtoOfGuid implements IEntityDtoOfGuid {
    id!: string;

    constructor(data?: IEntityDtoOfGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfGuid {
    id: string;
}

export class NotificationSubscriptionWithDisplayNameDto implements INotificationSubscriptionWithDisplayNameDto {
    displayName!: string | undefined;
    description!: string | undefined;
    name!: string;
    isSubscribed!: boolean;

    constructor(data?: INotificationSubscriptionWithDisplayNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.name = _data["name"];
            this.isSubscribed = _data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionWithDisplayNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionWithDisplayNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data;
    }
}

export interface INotificationSubscriptionWithDisplayNameDto {
    displayName: string | undefined;
    description: string | undefined;
    name: string;
    isSubscribed: boolean;
}

export class GetNotificationSettingsOutput implements IGetNotificationSettingsOutput {
    receiveNotifications!: boolean;
    notifications!: NotificationSubscriptionWithDisplayNameDto[] | undefined;

    constructor(data?: IGetNotificationSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiveNotifications = _data["receiveNotifications"];
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(NotificationSubscriptionWithDisplayNameDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationSettingsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetNotificationSettingsOutput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionWithDisplayNameDto[] | undefined;
}

export class NotificationSubscriptionDto implements INotificationSubscriptionDto {
    name!: string;
    isSubscribed!: boolean;

    constructor(data?: INotificationSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isSubscribed = _data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data;
    }
}

export interface INotificationSubscriptionDto {
    name: string;
    isSubscribed: boolean;
}

export class UpdateNotificationSettingsInput implements IUpdateNotificationSettingsInput {
    receiveNotifications!: boolean;
    notifications!: NotificationSubscriptionDto[] | undefined;

    constructor(data?: IUpdateNotificationSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiveNotifications = _data["receiveNotifications"];
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(NotificationSubscriptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateNotificationSettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNotificationSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateNotificationSettingsInput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionDto[] | undefined;
}

export class OffersTempleteDto implements IOffersTempleteDto {
    name!: string | undefined;
    documentUrl!: string | undefined;
    documentTypeId!: number;
    status!: boolean;
    branchId!: number | undefined;
    id!: number;

    constructor(data?: IOffersTempleteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.documentUrl = _data["documentUrl"];
            this.documentTypeId = _data["documentTypeId"];
            this.status = _data["status"];
            this.branchId = _data["branchId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OffersTempleteDto {
        data = typeof data === 'object' ? data : {};
        let result = new OffersTempleteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["documentUrl"] = this.documentUrl;
        data["documentTypeId"] = this.documentTypeId;
        data["status"] = this.status;
        data["branchId"] = this.branchId;
        data["id"] = this.id;
        return data;
    }
}

export interface IOffersTempleteDto {
    name: string | undefined;
    documentUrl: string | undefined;
    documentTypeId: number;
    status: boolean;
    branchId: number | undefined;
    id: number;
}

export class GetOffersTempleteForViewDto implements IGetOffersTempleteForViewDto {
    offersTemplete!: OffersTempleteDto;

    constructor(data?: IGetOffersTempleteForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offersTemplete = _data["offersTemplete"] ? OffersTempleteDto.fromJS(_data["offersTemplete"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOffersTempleteForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOffersTempleteForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offersTemplete"] = this.offersTemplete ? this.offersTemplete.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetOffersTempleteForViewDto {
    offersTemplete: OffersTempleteDto;
}

export class PagedResultDtoOfGetOffersTempleteForViewDto implements IPagedResultDtoOfGetOffersTempleteForViewDto {
    totalCount!: number;
    items!: GetOffersTempleteForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetOffersTempleteForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetOffersTempleteForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetOffersTempleteForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetOffersTempleteForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetOffersTempleteForViewDto {
    totalCount: number;
    items: GetOffersTempleteForViewDto[] | undefined;
}

export class CreateOrEditOffersTempleteDto implements ICreateOrEditOffersTempleteDto {
    name!: string | undefined;
    documentUrl!: string | undefined;
    documentTypeId!: number;
    status!: boolean;
    branchId!: number | undefined;
    designationId!: number | undefined;
    documents!: EmployeeDocumentDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditOffersTempleteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.documentUrl = _data["documentUrl"];
            this.documentTypeId = _data["documentTypeId"];
            this.status = _data["status"];
            this.branchId = _data["branchId"];
            this.designationId = _data["designationId"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(EmployeeDocumentDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditOffersTempleteDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditOffersTempleteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["documentUrl"] = this.documentUrl;
        data["documentTypeId"] = this.documentTypeId;
        data["status"] = this.status;
        data["branchId"] = this.branchId;
        data["designationId"] = this.designationId;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditOffersTempleteDto {
    name: string | undefined;
    documentUrl: string | undefined;
    documentTypeId: number;
    status: boolean;
    branchId: number | undefined;
    designationId: number | undefined;
    documents: EmployeeDocumentDto[] | undefined;
    id: number | undefined;
}

export class GetOffersTempleteForEditOutput implements IGetOffersTempleteForEditOutput {
    offersTemplete!: CreateOrEditOffersTempleteDto;

    constructor(data?: IGetOffersTempleteForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offersTemplete = _data["offersTemplete"] ? CreateOrEditOffersTempleteDto.fromJS(_data["offersTemplete"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOffersTempleteForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetOffersTempleteForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offersTemplete"] = this.offersTemplete ? this.offersTemplete.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetOffersTempleteForEditOutput {
    offersTemplete: CreateOrEditOffersTempleteDto;
}

export class UploadedOfferTemplateDto implements IUploadedOfferTemplateDto {
    id!: number;
    branchId!: number | undefined;
    designationId!: number | undefined;
    documentTypeId!: number;
    name!: string | undefined;
    documentUrl!: string | undefined;
    status!: boolean;

    constructor(data?: IUploadedOfferTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.branchId = _data["branchId"];
            this.designationId = _data["designationId"];
            this.documentTypeId = _data["documentTypeId"];
            this.name = _data["name"];
            this.documentUrl = _data["documentUrl"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UploadedOfferTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadedOfferTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["branchId"] = this.branchId;
        data["designationId"] = this.designationId;
        data["documentTypeId"] = this.documentTypeId;
        data["name"] = this.name;
        data["documentUrl"] = this.documentUrl;
        data["status"] = this.status;
        return data;
    }
}

export interface IUploadedOfferTemplateDto {
    id: number;
    branchId: number | undefined;
    designationId: number | undefined;
    documentTypeId: number;
    name: string | undefined;
    documentUrl: string | undefined;
    status: boolean;
}

export class OndutyDto implements IOndutyDto {
    attendanceDate!: moment.Moment;
    reason!: string | undefined;
    inTime!: string;
    outTime!: string;
    remarks!: string | undefined;
    status!: string | undefined;
    id!: number;

    constructor(data?: IOndutyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendanceDate = _data["attendanceDate"] ? moment(_data["attendanceDate"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            this.inTime = _data["inTime"];
            this.outTime = _data["outTime"];
            this.remarks = _data["remarks"];
            this.status = _data["status"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OndutyDto {
        data = typeof data === 'object' ? data : {};
        let result = new OndutyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendanceDate"] = this.attendanceDate ? this.attendanceDate.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        data["inTime"] = this.inTime;
        data["outTime"] = this.outTime;
        data["remarks"] = this.remarks;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface IOndutyDto {
    attendanceDate: moment.Moment;
    reason: string | undefined;
    inTime: string;
    outTime: string;
    remarks: string | undefined;
    status: string | undefined;
    id: number;
}

export class GetOndutyForViewDto implements IGetOndutyForViewDto {
    onduty!: OndutyDto;

    constructor(data?: IGetOndutyForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onduty = _data["onduty"] ? OndutyDto.fromJS(_data["onduty"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOndutyForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOndutyForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onduty"] = this.onduty ? this.onduty.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetOndutyForViewDto {
    onduty: OndutyDto;
}

export class PagedResultDtoOfGetOndutyForViewDto implements IPagedResultDtoOfGetOndutyForViewDto {
    totalCount!: number;
    items!: GetOndutyForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetOndutyForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetOndutyForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetOndutyForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetOndutyForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetOndutyForViewDto {
    totalCount: number;
    items: GetOndutyForViewDto[] | undefined;
}

export class CreateOrEditOndutyDto implements ICreateOrEditOndutyDto {
    attendanceDate!: moment.Moment;
    reason!: string | undefined;
    inTime!: moment.Moment;
    outTime!: moment.Moment;
    remarks!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditOndutyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendanceDate = _data["attendanceDate"] ? moment(_data["attendanceDate"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            this.inTime = _data["inTime"] ? moment(_data["inTime"].toString()) : <any>undefined;
            this.outTime = _data["outTime"] ? moment(_data["outTime"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
            this.status = _data["status"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditOndutyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditOndutyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendanceDate"] = this.attendanceDate ? this.attendanceDate.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        data["inTime"] = this.inTime ? this.inTime.toISOString() : <any>undefined;
        data["outTime"] = this.outTime ? this.outTime.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditOndutyDto {
    attendanceDate: moment.Moment;
    reason: string | undefined;
    inTime: moment.Moment;
    outTime: moment.Moment;
    remarks: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class GetOndutyForEditOutput implements IGetOndutyForEditOutput {
    onduty!: CreateOrEditOndutyDto;

    constructor(data?: IGetOndutyForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onduty = _data["onduty"] ? CreateOrEditOndutyDto.fromJS(_data["onduty"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOndutyForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetOndutyForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onduty"] = this.onduty ? this.onduty.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetOndutyForEditOutput {
    onduty: CreateOrEditOndutyDto;
}

export class OnDutyTypesDto implements IOnDutyTypesDto {
    onDutyTypeName!: string | undefined;
    tenantId!: number;
    id!: number;

    constructor(data?: IOnDutyTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onDutyTypeName = _data["onDutyTypeName"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OnDutyTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new OnDutyTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onDutyTypeName"] = this.onDutyTypeName;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface IOnDutyTypesDto {
    onDutyTypeName: string | undefined;
    tenantId: number;
    id: number;
}

export class GetOnDutyTypesForViewDto implements IGetOnDutyTypesForViewDto {
    onDutyTypes!: OnDutyTypesDto;

    constructor(data?: IGetOnDutyTypesForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onDutyTypes = _data["onDutyTypes"] ? OnDutyTypesDto.fromJS(_data["onDutyTypes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOnDutyTypesForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOnDutyTypesForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onDutyTypes"] = this.onDutyTypes ? this.onDutyTypes.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetOnDutyTypesForViewDto {
    onDutyTypes: OnDutyTypesDto;
}

export class PagedResultDtoOfGetOnDutyTypesForViewDto implements IPagedResultDtoOfGetOnDutyTypesForViewDto {
    totalCount!: number;
    items!: GetOnDutyTypesForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetOnDutyTypesForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetOnDutyTypesForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetOnDutyTypesForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetOnDutyTypesForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetOnDutyTypesForViewDto {
    totalCount: number;
    items: GetOnDutyTypesForViewDto[] | undefined;
}

export class CreateOrEditOnDutyTypesDto implements ICreateOrEditOnDutyTypesDto {
    onDutyTypeName!: string | undefined;
    tenantId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditOnDutyTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onDutyTypeName = _data["onDutyTypeName"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditOnDutyTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditOnDutyTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onDutyTypeName"] = this.onDutyTypeName;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditOnDutyTypesDto {
    onDutyTypeName: string | undefined;
    tenantId: number;
    id: number | undefined;
}

export class GetOnDutyTypesForEditOutput implements IGetOnDutyTypesForEditOutput {
    onDutyTypes!: CreateOrEditOnDutyTypesDto;

    constructor(data?: IGetOnDutyTypesForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onDutyTypes = _data["onDutyTypes"] ? CreateOrEditOnDutyTypesDto.fromJS(_data["onDutyTypes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOnDutyTypesForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetOnDutyTypesForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onDutyTypes"] = this.onDutyTypes ? this.onDutyTypes.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetOnDutyTypesForEditOutput {
    onDutyTypes: CreateOrEditOnDutyTypesDto;
}

export class OrganizationalChartDto implements IOrganizationalChartDto {
    employeeId!: number;
    employeeCode!: string | undefined;
    employeeName!: string | undefined;
    designation!: string | undefined;
    employeeImage!: string | undefined;
    department!: string | undefined;
    location!: string | undefined;
    type!: string | undefined;
    styleClass!: string | undefined;
    expanded!: boolean;
    children!: OrganizationalChartDto[] | undefined;

    constructor(data?: IOrganizationalChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.employeeCode = _data["employeeCode"];
            this.employeeName = _data["employeeName"];
            this.designation = _data["designation"];
            this.employeeImage = _data["employeeImage"];
            this.department = _data["department"];
            this.location = _data["location"];
            this.type = _data["type"];
            this.styleClass = _data["styleClass"];
            this.expanded = _data["expanded"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(OrganizationalChartDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationalChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["employeeCode"] = this.employeeCode;
        data["employeeName"] = this.employeeName;
        data["designation"] = this.designation;
        data["employeeImage"] = this.employeeImage;
        data["department"] = this.department;
        data["location"] = this.location;
        data["type"] = this.type;
        data["styleClass"] = this.styleClass;
        data["expanded"] = this.expanded;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrganizationalChartDto {
    employeeId: number;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    designation: string | undefined;
    employeeImage: string | undefined;
    department: string | undefined;
    location: string | undefined;
    type: string | undefined;
    styleClass: string | undefined;
    expanded: boolean;
    children: OrganizationalChartDto[] | undefined;
}

export class OrganizationUnitDto implements IOrganizationUnitDto {
    parentId!: number | undefined;
    code!: string | undefined;
    displayName!: string | undefined;
    memberCount!: number;
    roleCount!: number;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.code = _data["code"];
            this.displayName = _data["displayName"];
            this.memberCount = _data["memberCount"];
            this.roleCount = _data["roleCount"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["memberCount"] = this.memberCount;
        data["roleCount"] = this.roleCount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnitDto {
    parentId: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    memberCount: number;
    roleCount: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ListResultDtoOfOrganizationUnitDto implements IListResultDtoOfOrganizationUnitDto {
    items!: OrganizationUnitDto[] | undefined;

    constructor(data?: IListResultDtoOfOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfOrganizationUnitDto {
    items: OrganizationUnitDto[] | undefined;
}

export class OrganizationUnitUserListDto implements IOrganizationUnitUserListDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    addedTime!: moment.Moment;
    id!: number;

    constructor(data?: IOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.profilePictureId = _data["profilePictureId"];
            this.addedTime = _data["addedTime"] ? moment(_data["addedTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["addedTime"] = this.addedTime ? this.addedTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnitUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    addedTime: moment.Moment;
    id: number;
}

export class PagedResultDtoOfOrganizationUnitUserListDto implements IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount!: number;
    items!: OrganizationUnitUserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitUserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount: number;
    items: OrganizationUnitUserListDto[] | undefined;
}

export class OrganizationUnitRoleListDto implements IOrganizationUnitRoleListDto {
    displayName!: string | undefined;
    name!: string | undefined;
    addedTime!: moment.Moment;
    id!: number;

    constructor(data?: IOrganizationUnitRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.name = _data["name"];
            this.addedTime = _data["addedTime"] ? moment(_data["addedTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["name"] = this.name;
        data["addedTime"] = this.addedTime ? this.addedTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnitRoleListDto {
    displayName: string | undefined;
    name: string | undefined;
    addedTime: moment.Moment;
    id: number;
}

export class PagedResultDtoOfOrganizationUnitRoleListDto implements IPagedResultDtoOfOrganizationUnitRoleListDto {
    totalCount!: number;
    items!: OrganizationUnitRoleListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrganizationUnitRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitRoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationUnitRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfOrganizationUnitRoleListDto {
    totalCount: number;
    items: OrganizationUnitRoleListDto[] | undefined;
}

export class CreateOrganizationUnitInput implements ICreateOrganizationUnitInput {
    parentId!: number | undefined;
    displayName!: string;

    constructor(data?: ICreateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): CreateOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICreateOrganizationUnitInput {
    parentId: number | undefined;
    displayName: string;
}

export class UpdateOrganizationUnitInput implements IUpdateOrganizationUnitInput {
    id!: number;
    displayName!: string;

    constructor(data?: IUpdateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): UpdateOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IUpdateOrganizationUnitInput {
    id: number;
    displayName: string;
}

export class MoveOrganizationUnitInput implements IMoveOrganizationUnitInput {
    id!: number;
    newParentId!: number | undefined;

    constructor(data?: IMoveOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newParentId = _data["newParentId"];
        }
    }

    static fromJS(data: any): MoveOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new MoveOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newParentId"] = this.newParentId;
        return data;
    }
}

export interface IMoveOrganizationUnitInput {
    id: number;
    newParentId: number | undefined;
}

export class UsersToOrganizationUnitInput implements IUsersToOrganizationUnitInput {
    userIds!: number[] | undefined;
    organizationUnitId!: number;

    constructor(data?: IUsersToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): UsersToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UsersToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }
}

export interface IUsersToOrganizationUnitInput {
    userIds: number[] | undefined;
    organizationUnitId: number;
}

export class RolesToOrganizationUnitInput implements IRolesToOrganizationUnitInput {
    roleIds!: number[] | undefined;
    organizationUnitId!: number;

    constructor(data?: IRolesToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): RolesToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new RolesToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }
}

export interface IRolesToOrganizationUnitInput {
    roleIds: number[] | undefined;
    organizationUnitId: number;
}

export class FindOrganizationUnitUsersInput implements IFindOrganizationUnitUsersInput {
    organizationUnitId!: number;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindOrganizationUnitUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitId = _data["organizationUnitId"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindOrganizationUnitUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IFindOrganizationUnitUsersInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class FindOrganizationUnitRolesInput implements IFindOrganizationUnitRolesInput {
    organizationUnitId!: number;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindOrganizationUnitRolesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitId = _data["organizationUnitId"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitRolesInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindOrganizationUnitRolesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IFindOrganizationUnitRolesInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class GetEmployeeParameterDto implements IGetEmployeeParameterDto {
    branches!: number[] | undefined;
    designations!: number[] | undefined;
    departments!: number[] | undefined;
    subDepartments!: number[] | undefined;
    shifts!: number[] | undefined;
    divisions!: number[] | undefined;
    contractors!: number[] | undefined;
    employees!: number[] | undefined;
    sorting!: string | undefined;
    skipCount!: number;
    maxResultCount!: number;

    constructor(data?: IGetEmployeeParameterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(item);
            }
            if (Array.isArray(_data["designations"])) {
                this.designations = [] as any;
                for (let item of _data["designations"])
                    this.designations!.push(item);
            }
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(item);
            }
            if (Array.isArray(_data["subDepartments"])) {
                this.subDepartments = [] as any;
                for (let item of _data["subDepartments"])
                    this.subDepartments!.push(item);
            }
            if (Array.isArray(_data["shifts"])) {
                this.shifts = [] as any;
                for (let item of _data["shifts"])
                    this.shifts!.push(item);
            }
            if (Array.isArray(_data["divisions"])) {
                this.divisions = [] as any;
                for (let item of _data["divisions"])
                    this.divisions!.push(item);
            }
            if (Array.isArray(_data["contractors"])) {
                this.contractors = [] as any;
                for (let item of _data["contractors"])
                    this.contractors!.push(item);
            }
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(item);
            }
            this.sorting = _data["sorting"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetEmployeeParameterDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeParameterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item);
        }
        if (Array.isArray(this.designations)) {
            data["designations"] = [];
            for (let item of this.designations)
                data["designations"].push(item);
        }
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item);
        }
        if (Array.isArray(this.subDepartments)) {
            data["subDepartments"] = [];
            for (let item of this.subDepartments)
                data["subDepartments"].push(item);
        }
        if (Array.isArray(this.shifts)) {
            data["shifts"] = [];
            for (let item of this.shifts)
                data["shifts"].push(item);
        }
        if (Array.isArray(this.divisions)) {
            data["divisions"] = [];
            for (let item of this.divisions)
                data["divisions"].push(item);
        }
        if (Array.isArray(this.contractors)) {
            data["contractors"] = [];
            for (let item of this.contractors)
                data["contractors"].push(item);
        }
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item);
        }
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetEmployeeParameterDto {
    branches: number[] | undefined;
    designations: number[] | undefined;
    departments: number[] | undefined;
    subDepartments: number[] | undefined;
    shifts: number[] | undefined;
    divisions: number[] | undefined;
    contractors: number[] | undefined;
    employees: number[] | undefined;
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;
}

export class GetEmployeeListDto implements IGetEmployeeListDto {
    id!: number;
    name!: string | undefined;
    otAplicable!: string | undefined;
    employeeCode!: string | undefined;
    bioMetricId!: string | undefined;
    shiftName!: string | undefined;
    shiftId!: number | undefined;
    designation!: string | undefined;
    division!: string | undefined;
    branch!: string | undefined;
    department!: string | undefined;
    subDepartment!: string | undefined;
    contractor!: string | undefined;

    constructor(data?: IGetEmployeeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.otAplicable = _data["otAplicable"];
            this.employeeCode = _data["employeeCode"];
            this.bioMetricId = _data["bioMetricId"];
            this.shiftName = _data["shiftName"];
            this.shiftId = _data["shiftId"];
            this.designation = _data["designation"];
            this.division = _data["division"];
            this.branch = _data["branch"];
            this.department = _data["department"];
            this.subDepartment = _data["subDepartment"];
            this.contractor = _data["contractor"];
        }
    }

    static fromJS(data: any): GetEmployeeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["otAplicable"] = this.otAplicable;
        data["employeeCode"] = this.employeeCode;
        data["bioMetricId"] = this.bioMetricId;
        data["shiftName"] = this.shiftName;
        data["shiftId"] = this.shiftId;
        data["designation"] = this.designation;
        data["division"] = this.division;
        data["branch"] = this.branch;
        data["department"] = this.department;
        data["subDepartment"] = this.subDepartment;
        data["contractor"] = this.contractor;
        return data;
    }
}

export interface IGetEmployeeListDto {
    id: number;
    name: string | undefined;
    otAplicable: string | undefined;
    employeeCode: string | undefined;
    bioMetricId: string | undefined;
    shiftName: string | undefined;
    shiftId: number | undefined;
    designation: string | undefined;
    division: string | undefined;
    branch: string | undefined;
    department: string | undefined;
    subDepartment: string | undefined;
    contractor: string | undefined;
}

export class PagedResultDtoOfGetEmployeeListDto implements IPagedResultDtoOfGetEmployeeListDto {
    totalCount!: number;
    items!: GetEmployeeListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEmployeeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetEmployeeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEmployeeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEmployeeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetEmployeeListDto {
    totalCount: number;
    items: GetEmployeeListDto[] | undefined;
}

export class ValueTupleOfListOfGetPayablesInt32 implements IValueTupleOfListOfGetPayablesInt32 {
    item1!: GetPayables[] | undefined;
    item2!: number;

    constructor(data?: IValueTupleOfListOfGetPayablesInt32) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["item1"])) {
                this.item1 = [] as any;
                for (let item of _data["item1"])
                    this.item1!.push(GetPayables.fromJS(item));
            }
            this.item2 = _data["item2"];
        }
    }

    static fromJS(data: any): ValueTupleOfListOfGetPayablesInt32 {
        data = typeof data === 'object' ? data : {};
        let result = new ValueTupleOfListOfGetPayablesInt32();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.item1)) {
            data["item1"] = [];
            for (let item of this.item1)
                data["item1"].push(item.toJSON());
        }
        data["item2"] = this.item2;
        return data;
    }
}

export interface IValueTupleOfListOfGetPayablesInt32 {
    item1: GetPayables[] | undefined;
    item2: number;
}

export class PayDto implements IPayDto {
    employeeid!: number | undefined;
    payComponent!: number | undefined;
    amount!: number | undefined;
    id!: number | undefined;

    constructor(data?: IPayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeid = _data["employeeid"];
            this.payComponent = _data["payComponent"];
            this.amount = _data["amount"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PayDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeid"] = this.employeeid;
        data["payComponent"] = this.payComponent;
        data["amount"] = this.amount;
        data["id"] = this.id;
        return data;
    }
}

export interface IPayDto {
    employeeid: number | undefined;
    payComponent: number | undefined;
    amount: number | undefined;
    id: number | undefined;
}

export class PayComponetsDto implements IPayComponetsDto {
    name!: string | undefined;
    payComponetType!: number;
    prorateAccordingToPaidDays!: number | undefined;
    partofGross!: number | undefined;
    partofPFGross!: number | undefined;
    partofEsiGross!: number | undefined;
    partOfEsiRateGross!: number | undefined;
    partofRateGross!: number | undefined;
    partOfProfessionalTax!: number | undefined;
    variable!: number | undefined;
    rounding!: number | undefined;
    arrearApplicable!: number | undefined;
    partOfCTC!: number | undefined;
    active!: number | undefined;
    taxable!: number;
    nonTaxableLimit!: number | undefined;
    taxTobeDeducted!: number | undefined;
    selectSectionForForm16!: number | undefined;
    displayCaption!: string | undefined;
    calculationMethod!: number;
    salaryRegisterSortOrder!: number | undefined;
    showInSalaryResgister!: number | undefined;
    showonPaySlip!: number | undefined;
    calculateatRuntime!: number | undefined;
    proprateAccordingtoDojandDol!: number | undefined;
    sequencetoClculateatRuntime!: number | undefined;
    id!: number;

    constructor(data?: IPayComponetsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.payComponetType = _data["payComponetType"];
            this.prorateAccordingToPaidDays = _data["prorateAccordingToPaidDays"];
            this.partofGross = _data["partofGross"];
            this.partofPFGross = _data["partofPFGross"];
            this.partofEsiGross = _data["partofEsiGross"];
            this.partOfEsiRateGross = _data["partOfEsiRateGross"];
            this.partofRateGross = _data["partofRateGross"];
            this.partOfProfessionalTax = _data["partOfProfessionalTax"];
            this.variable = _data["variable"];
            this.rounding = _data["rounding"];
            this.arrearApplicable = _data["arrearApplicable"];
            this.partOfCTC = _data["partOfCTC"];
            this.active = _data["active"];
            this.taxable = _data["taxable"];
            this.nonTaxableLimit = _data["nonTaxableLimit"];
            this.taxTobeDeducted = _data["taxTobeDeducted"];
            this.selectSectionForForm16 = _data["selectSectionForForm16"];
            this.displayCaption = _data["displayCaption"];
            this.calculationMethod = _data["calculationMethod"];
            this.salaryRegisterSortOrder = _data["salaryRegisterSortOrder"];
            this.showInSalaryResgister = _data["showInSalaryResgister"];
            this.showonPaySlip = _data["showonPaySlip"];
            this.calculateatRuntime = _data["calculateatRuntime"];
            this.proprateAccordingtoDojandDol = _data["proprateAccordingtoDojandDol"];
            this.sequencetoClculateatRuntime = _data["sequencetoClculateatRuntime"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PayComponetsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayComponetsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["payComponetType"] = this.payComponetType;
        data["prorateAccordingToPaidDays"] = this.prorateAccordingToPaidDays;
        data["partofGross"] = this.partofGross;
        data["partofPFGross"] = this.partofPFGross;
        data["partofEsiGross"] = this.partofEsiGross;
        data["partOfEsiRateGross"] = this.partOfEsiRateGross;
        data["partofRateGross"] = this.partofRateGross;
        data["partOfProfessionalTax"] = this.partOfProfessionalTax;
        data["variable"] = this.variable;
        data["rounding"] = this.rounding;
        data["arrearApplicable"] = this.arrearApplicable;
        data["partOfCTC"] = this.partOfCTC;
        data["active"] = this.active;
        data["taxable"] = this.taxable;
        data["nonTaxableLimit"] = this.nonTaxableLimit;
        data["taxTobeDeducted"] = this.taxTobeDeducted;
        data["selectSectionForForm16"] = this.selectSectionForForm16;
        data["displayCaption"] = this.displayCaption;
        data["calculationMethod"] = this.calculationMethod;
        data["salaryRegisterSortOrder"] = this.salaryRegisterSortOrder;
        data["showInSalaryResgister"] = this.showInSalaryResgister;
        data["showonPaySlip"] = this.showonPaySlip;
        data["calculateatRuntime"] = this.calculateatRuntime;
        data["proprateAccordingtoDojandDol"] = this.proprateAccordingtoDojandDol;
        data["sequencetoClculateatRuntime"] = this.sequencetoClculateatRuntime;
        data["id"] = this.id;
        return data;
    }
}

export interface IPayComponetsDto {
    name: string | undefined;
    payComponetType: number;
    prorateAccordingToPaidDays: number | undefined;
    partofGross: number | undefined;
    partofPFGross: number | undefined;
    partofEsiGross: number | undefined;
    partOfEsiRateGross: number | undefined;
    partofRateGross: number | undefined;
    partOfProfessionalTax: number | undefined;
    variable: number | undefined;
    rounding: number | undefined;
    arrearApplicable: number | undefined;
    partOfCTC: number | undefined;
    active: number | undefined;
    taxable: number;
    nonTaxableLimit: number | undefined;
    taxTobeDeducted: number | undefined;
    selectSectionForForm16: number | undefined;
    displayCaption: string | undefined;
    calculationMethod: number;
    salaryRegisterSortOrder: number | undefined;
    showInSalaryResgister: number | undefined;
    showonPaySlip: number | undefined;
    calculateatRuntime: number | undefined;
    proprateAccordingtoDojandDol: number | undefined;
    sequencetoClculateatRuntime: number | undefined;
    id: number;
}

export class GetPayComponetsForViewDto implements IGetPayComponetsForViewDto {
    payComponets!: PayComponetsDto;
    paymentTypeS!: string | undefined;
    round!: string | undefined;

    constructor(data?: IGetPayComponetsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payComponets = _data["payComponets"] ? PayComponetsDto.fromJS(_data["payComponets"]) : <any>undefined;
            this.paymentTypeS = _data["paymentTypeS"];
            this.round = _data["round"];
        }
    }

    static fromJS(data: any): GetPayComponetsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPayComponetsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payComponets"] = this.payComponets ? this.payComponets.toJSON() : <any>undefined;
        data["paymentTypeS"] = this.paymentTypeS;
        data["round"] = this.round;
        return data;
    }
}

export interface IGetPayComponetsForViewDto {
    payComponets: PayComponetsDto;
    paymentTypeS: string | undefined;
    round: string | undefined;
}

export class PagedResultDtoOfGetPayComponetsForViewDto implements IPagedResultDtoOfGetPayComponetsForViewDto {
    totalCount!: number;
    items!: GetPayComponetsForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPayComponetsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPayComponetsForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPayComponetsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPayComponetsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetPayComponetsForViewDto {
    totalCount: number;
    items: GetPayComponetsForViewDto[] | undefined;
}

export enum PaymentTypeList {
    Allowances = 1,
    Deduction = 2,
    Fixed = 3,
    Advance = 4,
    Other = 5,
    Reimbursable = 6,
    Reimbursement = 7,
}

export enum Rounding {
    None = 1,
    Paise = 2,
    Rupees = 3,
}

export enum CalculationMethod {
    AMOUNT = 1,
    SIMPLEFLAT = 2,
    REDUCINGBALANCE = 3,
    REDUCINGBALANCEINSTALMENT = 4,
}

export class CreateOrEditPayComponetsDto implements ICreateOrEditPayComponetsDto {
    name!: string | undefined;
    payComponetType!: PaymentTypeList;
    prorateAccordingToPaidDays!: number | undefined;
    partofGross!: number | undefined;
    partofPFGross!: number | undefined;
    partofEsiGross!: number | undefined;
    partOfEsiRateGross!: number | undefined;
    partofRateGross!: number | undefined;
    partOfProfessionalTax!: number | undefined;
    variable!: number | undefined;
    rounding!: Rounding;
    arrearApplicable!: number | undefined;
    otApplicable!: number | undefined;
    partOfCTC!: number | undefined;
    active!: number | undefined;
    taxable!: number;
    nonTaxableLimit!: number | undefined;
    taxTobeDeducted!: number | undefined;
    selectSectionForForm16!: number | undefined;
    displayCaption!: string | undefined;
    calculationMethod!: CalculationMethod;
    salaryRegisterSortOrder!: number | undefined;
    showInSalaryResgister!: number | undefined;
    showonPaySlip!: number | undefined;
    calculateatRuntime!: number | undefined;
    proprateAccordingtoDojandDol!: number | undefined;
    sequencetoClculateatRuntime!: number | undefined;
    hidden!: number | undefined;
    reserved!: number | undefined;
    isAutoCalculate!: number | undefined;
    isPaidAnnualy!: number | undefined;
    accode!: number | undefined;
    employeeDimensionLinked!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPayComponetsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.payComponetType = _data["payComponetType"];
            this.prorateAccordingToPaidDays = _data["prorateAccordingToPaidDays"];
            this.partofGross = _data["partofGross"];
            this.partofPFGross = _data["partofPFGross"];
            this.partofEsiGross = _data["partofEsiGross"];
            this.partOfEsiRateGross = _data["partOfEsiRateGross"];
            this.partofRateGross = _data["partofRateGross"];
            this.partOfProfessionalTax = _data["partOfProfessionalTax"];
            this.variable = _data["variable"];
            this.rounding = _data["rounding"];
            this.arrearApplicable = _data["arrearApplicable"];
            this.otApplicable = _data["otApplicable"];
            this.partOfCTC = _data["partOfCTC"];
            this.active = _data["active"];
            this.taxable = _data["taxable"];
            this.nonTaxableLimit = _data["nonTaxableLimit"];
            this.taxTobeDeducted = _data["taxTobeDeducted"];
            this.selectSectionForForm16 = _data["selectSectionForForm16"];
            this.displayCaption = _data["displayCaption"];
            this.calculationMethod = _data["calculationMethod"];
            this.salaryRegisterSortOrder = _data["salaryRegisterSortOrder"];
            this.showInSalaryResgister = _data["showInSalaryResgister"];
            this.showonPaySlip = _data["showonPaySlip"];
            this.calculateatRuntime = _data["calculateatRuntime"];
            this.proprateAccordingtoDojandDol = _data["proprateAccordingtoDojandDol"];
            this.sequencetoClculateatRuntime = _data["sequencetoClculateatRuntime"];
            this.hidden = _data["hidden"];
            this.reserved = _data["reserved"];
            this.isAutoCalculate = _data["isAutoCalculate"];
            this.isPaidAnnualy = _data["isPaidAnnualy"];
            this.accode = _data["accode"];
            this.employeeDimensionLinked = _data["employeeDimensionLinked"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPayComponetsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPayComponetsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["payComponetType"] = this.payComponetType;
        data["prorateAccordingToPaidDays"] = this.prorateAccordingToPaidDays;
        data["partofGross"] = this.partofGross;
        data["partofPFGross"] = this.partofPFGross;
        data["partofEsiGross"] = this.partofEsiGross;
        data["partOfEsiRateGross"] = this.partOfEsiRateGross;
        data["partofRateGross"] = this.partofRateGross;
        data["partOfProfessionalTax"] = this.partOfProfessionalTax;
        data["variable"] = this.variable;
        data["rounding"] = this.rounding;
        data["arrearApplicable"] = this.arrearApplicable;
        data["otApplicable"] = this.otApplicable;
        data["partOfCTC"] = this.partOfCTC;
        data["active"] = this.active;
        data["taxable"] = this.taxable;
        data["nonTaxableLimit"] = this.nonTaxableLimit;
        data["taxTobeDeducted"] = this.taxTobeDeducted;
        data["selectSectionForForm16"] = this.selectSectionForForm16;
        data["displayCaption"] = this.displayCaption;
        data["calculationMethod"] = this.calculationMethod;
        data["salaryRegisterSortOrder"] = this.salaryRegisterSortOrder;
        data["showInSalaryResgister"] = this.showInSalaryResgister;
        data["showonPaySlip"] = this.showonPaySlip;
        data["calculateatRuntime"] = this.calculateatRuntime;
        data["proprateAccordingtoDojandDol"] = this.proprateAccordingtoDojandDol;
        data["sequencetoClculateatRuntime"] = this.sequencetoClculateatRuntime;
        data["hidden"] = this.hidden;
        data["reserved"] = this.reserved;
        data["isAutoCalculate"] = this.isAutoCalculate;
        data["isPaidAnnualy"] = this.isPaidAnnualy;
        data["accode"] = this.accode;
        data["employeeDimensionLinked"] = this.employeeDimensionLinked;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditPayComponetsDto {
    name: string | undefined;
    payComponetType: PaymentTypeList;
    prorateAccordingToPaidDays: number | undefined;
    partofGross: number | undefined;
    partofPFGross: number | undefined;
    partofEsiGross: number | undefined;
    partOfEsiRateGross: number | undefined;
    partofRateGross: number | undefined;
    partOfProfessionalTax: number | undefined;
    variable: number | undefined;
    rounding: Rounding;
    arrearApplicable: number | undefined;
    otApplicable: number | undefined;
    partOfCTC: number | undefined;
    active: number | undefined;
    taxable: number;
    nonTaxableLimit: number | undefined;
    taxTobeDeducted: number | undefined;
    selectSectionForForm16: number | undefined;
    displayCaption: string | undefined;
    calculationMethod: CalculationMethod;
    salaryRegisterSortOrder: number | undefined;
    showInSalaryResgister: number | undefined;
    showonPaySlip: number | undefined;
    calculateatRuntime: number | undefined;
    proprateAccordingtoDojandDol: number | undefined;
    sequencetoClculateatRuntime: number | undefined;
    hidden: number | undefined;
    reserved: number | undefined;
    isAutoCalculate: number | undefined;
    isPaidAnnualy: number | undefined;
    accode: number | undefined;
    employeeDimensionLinked: boolean;
    id: number | undefined;
}

export class GetPayComponetsForEditOutput implements IGetPayComponetsForEditOutput {
    payComponets!: CreateOrEditPayComponetsDto;

    constructor(data?: IGetPayComponetsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payComponets = _data["payComponets"] ? CreateOrEditPayComponetsDto.fromJS(_data["payComponets"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPayComponetsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPayComponetsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payComponets"] = this.payComponets ? this.payComponets.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPayComponetsForEditOutput {
    payComponets: CreateOrEditPayComponetsDto;
}

export class PayGradeDetailsDto implements IPayGradeDetailsDto {
    calculationType!: string | undefined;
    formulaString!: string | undefined;
    amount!: number | undefined;
    sequence!: number;
    payGradeId!: number;
    payComponetsId!: number;
    id!: number;

    constructor(data?: IPayGradeDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calculationType = _data["calculationType"];
            this.formulaString = _data["formulaString"];
            this.amount = _data["amount"];
            this.sequence = _data["sequence"];
            this.payGradeId = _data["payGradeId"];
            this.payComponetsId = _data["payComponetsId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PayGradeDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayGradeDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calculationType"] = this.calculationType;
        data["formulaString"] = this.formulaString;
        data["amount"] = this.amount;
        data["sequence"] = this.sequence;
        data["payGradeId"] = this.payGradeId;
        data["payComponetsId"] = this.payComponetsId;
        data["id"] = this.id;
        return data;
    }
}

export interface IPayGradeDetailsDto {
    calculationType: string | undefined;
    formulaString: string | undefined;
    amount: number | undefined;
    sequence: number;
    payGradeId: number;
    payComponetsId: number;
    id: number;
}

export class GetPayGradeDetailsForViewDto implements IGetPayGradeDetailsForViewDto {
    payGradeDetails!: PayGradeDetailsDto;
    payGradeName!: string | undefined;
    payComponetsName!: string | undefined;

    constructor(data?: IGetPayGradeDetailsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payGradeDetails = _data["payGradeDetails"] ? PayGradeDetailsDto.fromJS(_data["payGradeDetails"]) : <any>undefined;
            this.payGradeName = _data["payGradeName"];
            this.payComponetsName = _data["payComponetsName"];
        }
    }

    static fromJS(data: any): GetPayGradeDetailsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPayGradeDetailsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payGradeDetails"] = this.payGradeDetails ? this.payGradeDetails.toJSON() : <any>undefined;
        data["payGradeName"] = this.payGradeName;
        data["payComponetsName"] = this.payComponetsName;
        return data;
    }
}

export interface IGetPayGradeDetailsForViewDto {
    payGradeDetails: PayGradeDetailsDto;
    payGradeName: string | undefined;
    payComponetsName: string | undefined;
}

export class PagedResultDtoOfGetPayGradeDetailsForViewDto implements IPagedResultDtoOfGetPayGradeDetailsForViewDto {
    totalCount!: number;
    items!: GetPayGradeDetailsForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPayGradeDetailsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPayGradeDetailsForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPayGradeDetailsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPayGradeDetailsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetPayGradeDetailsForViewDto {
    totalCount: number;
    items: GetPayGradeDetailsForViewDto[] | undefined;
}

export class CreateOrEditPayGradeDetailsDto implements ICreateOrEditPayGradeDetailsDto {
    calculationType!: string | undefined;
    formulaString!: string | undefined;
    amount!: number | undefined;
    sequence!: number;
    payGradeId!: number;
    payComponetId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPayGradeDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calculationType = _data["calculationType"];
            this.formulaString = _data["formulaString"];
            this.amount = _data["amount"];
            this.sequence = _data["sequence"];
            this.payGradeId = _data["payGradeId"];
            this.payComponetId = _data["payComponetId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPayGradeDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPayGradeDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calculationType"] = this.calculationType;
        data["formulaString"] = this.formulaString;
        data["amount"] = this.amount;
        data["sequence"] = this.sequence;
        data["payGradeId"] = this.payGradeId;
        data["payComponetId"] = this.payComponetId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditPayGradeDetailsDto {
    calculationType: string | undefined;
    formulaString: string | undefined;
    amount: number | undefined;
    sequence: number;
    payGradeId: number;
    payComponetId: number;
    id: number | undefined;
}

export class CreateOrEditPayGradeDto implements ICreateOrEditPayGradeDto {
    name!: string | undefined;
    description!: string | undefined;
    saveType!: string | undefined;
    payGradeDetails!: CreateOrEditPayGradeDetailsDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPayGradeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.saveType = _data["saveType"];
            if (Array.isArray(_data["payGradeDetails"])) {
                this.payGradeDetails = [] as any;
                for (let item of _data["payGradeDetails"])
                    this.payGradeDetails!.push(CreateOrEditPayGradeDetailsDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPayGradeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPayGradeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["saveType"] = this.saveType;
        if (Array.isArray(this.payGradeDetails)) {
            data["payGradeDetails"] = [];
            for (let item of this.payGradeDetails)
                data["payGradeDetails"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditPayGradeDto {
    name: string | undefined;
    description: string | undefined;
    saveType: string | undefined;
    payGradeDetails: CreateOrEditPayGradeDetailsDto[] | undefined;
    id: number | undefined;
}

export class PayGradeDto implements IPayGradeDto {
    name!: string | undefined;
    description!: string | undefined;
    id!: number;

    constructor(data?: IPayGradeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PayGradeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayGradeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }
}

export interface IPayGradeDto {
    name: string | undefined;
    description: string | undefined;
    id: number;
}

export class GetPayGradeForViewDto implements IGetPayGradeForViewDto {
    payGrade!: PayGradeDto;
    componetsName!: string | undefined;
    payComponentType!: string | undefined;

    constructor(data?: IGetPayGradeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payGrade = _data["payGrade"] ? PayGradeDto.fromJS(_data["payGrade"]) : <any>undefined;
            this.componetsName = _data["componetsName"];
            this.payComponentType = _data["payComponentType"];
        }
    }

    static fromJS(data: any): GetPayGradeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPayGradeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payGrade"] = this.payGrade ? this.payGrade.toJSON() : <any>undefined;
        data["componetsName"] = this.componetsName;
        data["payComponentType"] = this.payComponentType;
        return data;
    }
}

export interface IGetPayGradeForViewDto {
    payGrade: PayGradeDto;
    componetsName: string | undefined;
    payComponentType: string | undefined;
}

export class PagedResultDtoOfGetPayGradeForViewDto implements IPagedResultDtoOfGetPayGradeForViewDto {
    totalCount!: number;
    items!: GetPayGradeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPayGradeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPayGradeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPayGradeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPayGradeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetPayGradeForViewDto {
    totalCount: number;
    items: GetPayGradeForViewDto[] | undefined;
}

export class GetPayGradeForEditOutput implements IGetPayGradeForEditOutput {
    payGrade!: CreateOrEditPayGradeDto;

    constructor(data?: IGetPayGradeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payGrade = _data["payGrade"] ? CreateOrEditPayGradeDto.fromJS(_data["payGrade"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPayGradeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPayGradeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payGrade"] = this.payGrade ? this.payGrade.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPayGradeForEditOutput {
    payGrade: CreateOrEditPayGradeDto;
}

export class EditionSelectDto implements IEditionSelectDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    expiringEditionId!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    trialDayCount!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    isFree!: boolean;
    additionalData!: AdditionalData | undefined;

    constructor(data?: IEditionSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.expiringEditionId = _data["expiringEditionId"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.trialDayCount = _data["trialDayCount"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.isFree = _data["isFree"];
            this.additionalData = _data["additionalData"] ? AdditionalData.fromJS(_data["additionalData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditionSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["isFree"] = this.isFree;
        data["additionalData"] = this.additionalData ? this.additionalData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEditionSelectDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    expiringEditionId: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    isFree: boolean;
    additionalData: AdditionalData | undefined;
}

export class PaymentInfoDto implements IPaymentInfoDto {
    edition!: EditionSelectDto;
    additionalPrice!: number;

    constructor(data?: IPaymentInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionSelectDto.fromJS(_data["edition"]) : <any>undefined;
            this.additionalPrice = _data["additionalPrice"];
        }
    }

    static fromJS(data: any): PaymentInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["additionalPrice"] = this.additionalPrice;
        return data;
    }
}

export interface IPaymentInfoDto {
    edition: EditionSelectDto;
    additionalPrice: number;
}

export enum EditionPaymentType {
    NewRegistration = 0,
    BuyNow = 1,
    Upgrade = 2,
    Extend = 3,
}

export enum PaymentPeriodType {
    Monthly = 30,
    Annual = 365,
}

export enum SubscriptionPaymentGatewayType {
    Paypal = 1,
    Stripe = 2,
}

export class CreatePaymentDto implements ICreatePaymentDto {
    editionId!: number;
    editionPaymentType!: EditionPaymentType;
    paymentPeriodType!: PaymentPeriodType;
    subscriptionPaymentGatewayType!: SubscriptionPaymentGatewayType;
    recurringPaymentEnabled!: boolean;
    successUrl!: string | undefined;
    errorUrl!: string | undefined;

    constructor(data?: ICreatePaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.editionId = _data["editionId"];
            this.editionPaymentType = _data["editionPaymentType"];
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.subscriptionPaymentGatewayType = _data["subscriptionPaymentGatewayType"];
            this.recurringPaymentEnabled = _data["recurringPaymentEnabled"];
            this.successUrl = _data["successUrl"];
            this.errorUrl = _data["errorUrl"];
        }
    }

    static fromJS(data: any): CreatePaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editionId"] = this.editionId;
        data["editionPaymentType"] = this.editionPaymentType;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionPaymentGatewayType"] = this.subscriptionPaymentGatewayType;
        data["recurringPaymentEnabled"] = this.recurringPaymentEnabled;
        data["successUrl"] = this.successUrl;
        data["errorUrl"] = this.errorUrl;
        return data;
    }
}

export interface ICreatePaymentDto {
    editionId: number;
    editionPaymentType: EditionPaymentType;
    paymentPeriodType: PaymentPeriodType;
    subscriptionPaymentGatewayType: SubscriptionPaymentGatewayType;
    recurringPaymentEnabled: boolean;
    successUrl: string | undefined;
    errorUrl: string | undefined;
}

export class CancelPaymentDto implements ICancelPaymentDto {
    paymentId!: string | undefined;
    gateway!: SubscriptionPaymentGatewayType;

    constructor(data?: ICancelPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.gateway = _data["gateway"];
        }
    }

    static fromJS(data: any): CancelPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CancelPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["gateway"] = this.gateway;
        return data;
    }
}

export interface ICancelPaymentDto {
    paymentId: string | undefined;
    gateway: SubscriptionPaymentGatewayType;
}

export class SubscriptionPaymentListDto implements ISubscriptionPaymentListDto {
    gateway!: string | undefined;
    amount!: number;
    editionId!: number;
    dayCount!: number;
    paymentPeriodType!: string | undefined;
    paymentId!: string | undefined;
    payerId!: string | undefined;
    status!: string | undefined;
    editionDisplayName!: string | undefined;
    tenantId!: number;
    invoiceNo!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ISubscriptionPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gateway = _data["gateway"];
            this.amount = _data["amount"];
            this.editionId = _data["editionId"];
            this.dayCount = _data["dayCount"];
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.paymentId = _data["paymentId"];
            this.payerId = _data["payerId"];
            this.status = _data["status"];
            this.editionDisplayName = _data["editionDisplayName"];
            this.tenantId = _data["tenantId"];
            this.invoiceNo = _data["invoiceNo"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SubscriptionPaymentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gateway"] = this.gateway;
        data["amount"] = this.amount;
        data["editionId"] = this.editionId;
        data["dayCount"] = this.dayCount;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["paymentId"] = this.paymentId;
        data["payerId"] = this.payerId;
        data["status"] = this.status;
        data["editionDisplayName"] = this.editionDisplayName;
        data["tenantId"] = this.tenantId;
        data["invoiceNo"] = this.invoiceNo;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISubscriptionPaymentListDto {
    gateway: string | undefined;
    amount: number;
    editionId: number;
    dayCount: number;
    paymentPeriodType: string | undefined;
    paymentId: string | undefined;
    payerId: string | undefined;
    status: string | undefined;
    editionDisplayName: string | undefined;
    tenantId: number;
    invoiceNo: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class PagedResultDtoOfSubscriptionPaymentListDto implements IPagedResultDtoOfSubscriptionPaymentListDto {
    totalCount!: number;
    items!: SubscriptionPaymentListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSubscriptionPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SubscriptionPaymentListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSubscriptionPaymentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSubscriptionPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfSubscriptionPaymentListDto {
    totalCount: number;
    items: SubscriptionPaymentListDto[] | undefined;
}

export class PaymentGatewayModel implements IPaymentGatewayModel {
    gatewayType!: SubscriptionPaymentGatewayType;
    supportsRecurringPayments!: boolean;

    constructor(data?: IPaymentGatewayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gatewayType = _data["gatewayType"];
            this.supportsRecurringPayments = _data["supportsRecurringPayments"];
        }
    }

    static fromJS(data: any): PaymentGatewayModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentGatewayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayType"] = this.gatewayType;
        data["supportsRecurringPayments"] = this.supportsRecurringPayments;
        return data;
    }
}

export interface IPaymentGatewayModel {
    gatewayType: SubscriptionPaymentGatewayType;
    supportsRecurringPayments: boolean;
}

export enum SubscriptionPaymentStatus {
    NotPaid = 1,
    Paid = 2,
    Failed = 3,
    Cancelled = 4,
    Completed = 5,
}

export class SubscriptionPaymentDto implements ISubscriptionPaymentDto {
    description!: string | undefined;
    gateway!: SubscriptionPaymentGatewayType;
    amount!: number;
    editionId!: number;
    tenantId!: number;
    dayCount!: number;
    paymentPeriodType!: PaymentPeriodType;
    paymentId!: string | undefined;
    payerId!: string | undefined;
    editionDisplayName!: string | undefined;
    invoiceNo!: number;
    status!: SubscriptionPaymentStatus;
    isRecurring!: boolean;
    externalPaymentId!: string | undefined;
    successUrl!: string | undefined;
    errorUrl!: string | undefined;
    id!: number;

    constructor(data?: ISubscriptionPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.gateway = _data["gateway"];
            this.amount = _data["amount"];
            this.editionId = _data["editionId"];
            this.tenantId = _data["tenantId"];
            this.dayCount = _data["dayCount"];
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.paymentId = _data["paymentId"];
            this.payerId = _data["payerId"];
            this.editionDisplayName = _data["editionDisplayName"];
            this.invoiceNo = _data["invoiceNo"];
            this.status = _data["status"];
            this.isRecurring = _data["isRecurring"];
            this.externalPaymentId = _data["externalPaymentId"];
            this.successUrl = _data["successUrl"];
            this.errorUrl = _data["errorUrl"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SubscriptionPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["gateway"] = this.gateway;
        data["amount"] = this.amount;
        data["editionId"] = this.editionId;
        data["tenantId"] = this.tenantId;
        data["dayCount"] = this.dayCount;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["paymentId"] = this.paymentId;
        data["payerId"] = this.payerId;
        data["editionDisplayName"] = this.editionDisplayName;
        data["invoiceNo"] = this.invoiceNo;
        data["status"] = this.status;
        data["isRecurring"] = this.isRecurring;
        data["externalPaymentId"] = this.externalPaymentId;
        data["successUrl"] = this.successUrl;
        data["errorUrl"] = this.errorUrl;
        data["id"] = this.id;
        return data;
    }
}

export interface ISubscriptionPaymentDto {
    description: string | undefined;
    gateway: SubscriptionPaymentGatewayType;
    amount: number;
    editionId: number;
    tenantId: number;
    dayCount: number;
    paymentPeriodType: PaymentPeriodType;
    paymentId: string | undefined;
    payerId: string | undefined;
    editionDisplayName: string | undefined;
    invoiceNo: number;
    status: SubscriptionPaymentStatus;
    isRecurring: boolean;
    externalPaymentId: string | undefined;
    successUrl: string | undefined;
    errorUrl: string | undefined;
    id: number;
}

export class PayPalConfigurationDto implements IPayPalConfigurationDto {
    clientId!: string | undefined;
    environment!: string | undefined;
    demoUsername!: string | undefined;
    demoPassword!: string | undefined;

    constructor(data?: IPayPalConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.environment = _data["environment"];
            this.demoUsername = _data["demoUsername"];
            this.demoPassword = _data["demoPassword"];
        }
    }

    static fromJS(data: any): PayPalConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayPalConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["environment"] = this.environment;
        data["demoUsername"] = this.demoUsername;
        data["demoPassword"] = this.demoPassword;
        return data;
    }
}

export interface IPayPalConfigurationDto {
    clientId: string | undefined;
    environment: string | undefined;
    demoUsername: string | undefined;
    demoPassword: string | undefined;
}

export class GetPolicyNameViewDto implements IGetPolicyNameViewDto {
    policyName!: string | undefined;
    id!: number;

    constructor(data?: IGetPolicyNameViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.policyName = _data["policyName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetPolicyNameViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPolicyNameViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyName"] = this.policyName;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetPolicyNameViewDto {
    policyName: string | undefined;
    id: number;
}

export class PagedResultDtoOfGetPolicyNameViewDto implements IPagedResultDtoOfGetPolicyNameViewDto {
    totalCount!: number;
    items!: GetPolicyNameViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPolicyNameViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPolicyNameViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPolicyNameViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPolicyNameViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetPolicyNameViewDto {
    totalCount: number;
    items: GetPolicyNameViewDto[] | undefined;
}

export class CreateOrEditPolicyKRAs implements ICreateOrEditPolicyKRAs {
    id!: number;
    policyId!: number | undefined;
    kraId!: number | undefined;
    kraName!: string | undefined;
    weightage!: number | undefined;
    measurable!: string | undefined;
    policyKRAid!: number;
    policyName!: string | undefined;

    constructor(data?: ICreateOrEditPolicyKRAs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.policyId = _data["policyId"];
            this.kraId = _data["kraId"];
            this.kraName = _data["kraName"];
            this.weightage = _data["weightage"];
            this.measurable = _data["measurable"];
            this.policyKRAid = _data["policyKRAid"];
            this.policyName = _data["policyName"];
        }
    }

    static fromJS(data: any): CreateOrEditPolicyKRAs {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPolicyKRAs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["policyId"] = this.policyId;
        data["kraId"] = this.kraId;
        data["kraName"] = this.kraName;
        data["weightage"] = this.weightage;
        data["measurable"] = this.measurable;
        data["policyKRAid"] = this.policyKRAid;
        data["policyName"] = this.policyName;
        return data;
    }
}

export interface ICreateOrEditPolicyKRAs {
    id: number;
    policyId: number | undefined;
    kraId: number | undefined;
    kraName: string | undefined;
    weightage: number | undefined;
    measurable: string | undefined;
    policyKRAid: number;
    policyName: string | undefined;
}

export class CreateOrEditPerPolicyDto implements ICreateOrEditPerPolicyDto {
    kpI_Name!: string | undefined;
    tenantId!: number;
    message!: string | undefined;
    krAsDetails!: CreateOrEditPolicyKRAs[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPerPolicyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kpI_Name = _data["kpI_Name"];
            this.tenantId = _data["tenantId"];
            this.message = _data["message"];
            if (Array.isArray(_data["krAsDetails"])) {
                this.krAsDetails = [] as any;
                for (let item of _data["krAsDetails"])
                    this.krAsDetails!.push(CreateOrEditPolicyKRAs.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPerPolicyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPerPolicyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kpI_Name"] = this.kpI_Name;
        data["tenantId"] = this.tenantId;
        data["message"] = this.message;
        if (Array.isArray(this.krAsDetails)) {
            data["krAsDetails"] = [];
            for (let item of this.krAsDetails)
                data["krAsDetails"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditPerPolicyDto {
    kpI_Name: string | undefined;
    tenantId: number;
    message: string | undefined;
    krAsDetails: CreateOrEditPolicyKRAs[] | undefined;
    id: number | undefined;
}

export class FlatPermissionWithLevelDto implements IFlatPermissionWithLevelDto {
    level!: number;
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    isGrantedByDefault!: boolean;

    constructor(data?: IFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.level = _data["level"];
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isGrantedByDefault = _data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionWithLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data;
    }
}

export interface IFlatPermissionWithLevelDto {
    level: number;
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
}

export class ListResultDtoOfFlatPermissionWithLevelDto implements IListResultDtoOfFlatPermissionWithLevelDto {
    items!: FlatPermissionWithLevelDto[] | undefined;

    constructor(data?: IListResultDtoOfFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FlatPermissionWithLevelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfFlatPermissionWithLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfFlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfFlatPermissionWithLevelDto {
    items: FlatPermissionWithLevelDto[] | undefined;
}

export class PoliciesDto implements IPoliciesDto {
    name!: string | undefined;
    doucumentUrl!: string | undefined;
    doucmnetName!: string | undefined;
    isReviewMendate!: boolean;
    id!: number;

    constructor(data?: IPoliciesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.doucumentUrl = _data["doucumentUrl"];
            this.doucmnetName = _data["doucmnetName"];
            this.isReviewMendate = _data["isReviewMendate"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PoliciesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PoliciesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["doucumentUrl"] = this.doucumentUrl;
        data["doucmnetName"] = this.doucmnetName;
        data["isReviewMendate"] = this.isReviewMendate;
        data["id"] = this.id;
        return data;
    }
}

export interface IPoliciesDto {
    name: string | undefined;
    doucumentUrl: string | undefined;
    doucmnetName: string | undefined;
    isReviewMendate: boolean;
    id: number;
}

export class GetPoliciesForViewDto implements IGetPoliciesForViewDto {
    policies!: PoliciesDto;

    constructor(data?: IGetPoliciesForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.policies = _data["policies"] ? PoliciesDto.fromJS(_data["policies"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPoliciesForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPoliciesForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policies"] = this.policies ? this.policies.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPoliciesForViewDto {
    policies: PoliciesDto;
}

export class PagedResultDtoOfGetPoliciesForViewDto implements IPagedResultDtoOfGetPoliciesForViewDto {
    totalCount!: number;
    items!: GetPoliciesForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPoliciesForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPoliciesForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPoliciesForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPoliciesForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetPoliciesForViewDto {
    totalCount: number;
    items: GetPoliciesForViewDto[] | undefined;
}

export class CreateOrEditPoliciesDto implements ICreateOrEditPoliciesDto {
    name!: string | undefined;
    doucumentUrl!: string | undefined;
    doucmnetName!: string | undefined;
    isReviewMendate!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPoliciesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.doucumentUrl = _data["doucumentUrl"];
            this.doucmnetName = _data["doucmnetName"];
            this.isReviewMendate = _data["isReviewMendate"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPoliciesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPoliciesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["doucumentUrl"] = this.doucumentUrl;
        data["doucmnetName"] = this.doucmnetName;
        data["isReviewMendate"] = this.isReviewMendate;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditPoliciesDto {
    name: string | undefined;
    doucumentUrl: string | undefined;
    doucmnetName: string | undefined;
    isReviewMendate: boolean;
    id: number | undefined;
}

export class GetPoliciesForEditOutput implements IGetPoliciesForEditOutput {
    policies!: CreateOrEditPoliciesDto;

    constructor(data?: IGetPoliciesForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.policies = _data["policies"] ? CreateOrEditPoliciesDto.fromJS(_data["policies"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPoliciesForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPoliciesForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policies"] = this.policies ? this.policies.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPoliciesForEditOutput {
    policies: CreateOrEditPoliciesDto;
}

export class ProfessionalDto implements IProfessionalDto {
    applicable!: number;
    certificateNumber!: number | undefined;
    circleNo!: string | undefined;
    depositeProfessionalEmpHodSalaryTax!: number;
    calculateProfessionalTax!: number;
    calculateProfessionalTaxBasedOn!: number;
    multipleGroup!: number;
    id!: number;

    constructor(data?: IProfessionalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicable = _data["applicable"];
            this.certificateNumber = _data["certificateNumber"];
            this.circleNo = _data["circleNo"];
            this.depositeProfessionalEmpHodSalaryTax = _data["depositeProfessionalEmpHodSalaryTax"];
            this.calculateProfessionalTax = _data["calculateProfessionalTax"];
            this.calculateProfessionalTaxBasedOn = _data["calculateProfessionalTaxBasedOn"];
            this.multipleGroup = _data["multipleGroup"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProfessionalDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicable"] = this.applicable;
        data["certificateNumber"] = this.certificateNumber;
        data["circleNo"] = this.circleNo;
        data["depositeProfessionalEmpHodSalaryTax"] = this.depositeProfessionalEmpHodSalaryTax;
        data["calculateProfessionalTax"] = this.calculateProfessionalTax;
        data["calculateProfessionalTaxBasedOn"] = this.calculateProfessionalTaxBasedOn;
        data["multipleGroup"] = this.multipleGroup;
        data["id"] = this.id;
        return data;
    }
}

export interface IProfessionalDto {
    applicable: number;
    certificateNumber: number | undefined;
    circleNo: string | undefined;
    depositeProfessionalEmpHodSalaryTax: number;
    calculateProfessionalTax: number;
    calculateProfessionalTaxBasedOn: number;
    multipleGroup: number;
    id: number;
}

export class GetProfessionalForViewDto implements IGetProfessionalForViewDto {
    professional!: ProfessionalDto;

    constructor(data?: IGetProfessionalForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professional = _data["professional"] ? ProfessionalDto.fromJS(_data["professional"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProfessionalForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfessionalForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professional"] = this.professional ? this.professional.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetProfessionalForViewDto {
    professional: ProfessionalDto;
}

export class PagedResultDtoOfGetProfessionalForViewDto implements IPagedResultDtoOfGetProfessionalForViewDto {
    totalCount!: number;
    items!: GetProfessionalForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetProfessionalForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetProfessionalForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetProfessionalForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetProfessionalForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetProfessionalForViewDto {
    totalCount: number;
    items: GetProfessionalForViewDto[] | undefined;
}

export class CreateOrEditProfessionalDto implements ICreateOrEditProfessionalDto {
    applicable!: number;
    certificateNumber!: number | undefined;
    circleNo!: string | undefined;
    depositeProfessionalEmpHodSalaryTax!: number;
    calculateProfessionalTax!: number;
    calculateProfessionalTaxBasedOn!: number;
    multipleGroup!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditProfessionalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicable = _data["applicable"];
            this.certificateNumber = _data["certificateNumber"];
            this.circleNo = _data["circleNo"];
            this.depositeProfessionalEmpHodSalaryTax = _data["depositeProfessionalEmpHodSalaryTax"];
            this.calculateProfessionalTax = _data["calculateProfessionalTax"];
            this.calculateProfessionalTaxBasedOn = _data["calculateProfessionalTaxBasedOn"];
            this.multipleGroup = _data["multipleGroup"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditProfessionalDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditProfessionalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicable"] = this.applicable;
        data["certificateNumber"] = this.certificateNumber;
        data["circleNo"] = this.circleNo;
        data["depositeProfessionalEmpHodSalaryTax"] = this.depositeProfessionalEmpHodSalaryTax;
        data["calculateProfessionalTax"] = this.calculateProfessionalTax;
        data["calculateProfessionalTaxBasedOn"] = this.calculateProfessionalTaxBasedOn;
        data["multipleGroup"] = this.multipleGroup;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditProfessionalDto {
    applicable: number;
    certificateNumber: number | undefined;
    circleNo: string | undefined;
    depositeProfessionalEmpHodSalaryTax: number;
    calculateProfessionalTax: number;
    calculateProfessionalTaxBasedOn: number;
    multipleGroup: number;
    id: number | undefined;
}

export class GetProfessionalForEditOutput implements IGetProfessionalForEditOutput {
    professional!: CreateOrEditProfessionalDto;

    constructor(data?: IGetProfessionalForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professional = _data["professional"] ? CreateOrEditProfessionalDto.fromJS(_data["professional"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProfessionalForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfessionalForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professional"] = this.professional ? this.professional.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetProfessionalForEditOutput {
    professional: CreateOrEditProfessionalDto;
}

export class CurrentUserProfileEditDto implements ICurrentUserProfileEditDto {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    phoneNumber!: string | undefined;
    isPhoneNumberConfirmed!: boolean;
    timezone!: string | undefined;
    qrCodeSetupImageUrl!: string | undefined;
    isGoogleAuthenticatorEnabled!: boolean;

    constructor(data?: ICurrentUserProfileEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.timezone = _data["timezone"];
            this.qrCodeSetupImageUrl = _data["qrCodeSetupImageUrl"];
            this.isGoogleAuthenticatorEnabled = _data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): CurrentUserProfileEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserProfileEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["timezone"] = this.timezone;
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data;
    }
}

export interface ICurrentUserProfileEditDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    timezone: string | undefined;
    qrCodeSetupImageUrl: string | undefined;
    isGoogleAuthenticatorEnabled: boolean;
}

export class UpdateGoogleAuthenticatorKeyOutput implements IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl!: string | undefined;

    constructor(data?: IUpdateGoogleAuthenticatorKeyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qrCodeSetupImageUrl = _data["qrCodeSetupImageUrl"];
        }
    }

    static fromJS(data: any): UpdateGoogleAuthenticatorKeyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGoogleAuthenticatorKeyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        return data;
    }
}

export interface IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl: string | undefined;
}

export class SendVerificationSmsInputDto implements ISendVerificationSmsInputDto {
    phoneNumber!: string | undefined;

    constructor(data?: ISendVerificationSmsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): SendVerificationSmsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerificationSmsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ISendVerificationSmsInputDto {
    phoneNumber: string | undefined;
}

export class VerifySmsCodeInputDto implements IVerifySmsCodeInputDto {
    code!: string | undefined;
    phoneNumber!: string | undefined;

    constructor(data?: IVerifySmsCodeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): VerifySmsCodeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifySmsCodeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IVerifySmsCodeInputDto {
    code: string | undefined;
    phoneNumber: string | undefined;
}

export class ChangePasswordInput implements IChangePasswordInput {
    currentPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordInput {
    currentPassword: string;
    newPassword: string;
}

export class UpdateProfilePictureInput implements IUpdateProfilePictureInput {
    fileToken!: string;
    x!: number;
    y!: number;
    width!: number;
    height!: number;

    constructor(data?: IUpdateProfilePictureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileToken = _data["fileToken"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.width = _data["width"];
            this.height = _data["height"];
        }
    }

    static fromJS(data: any): UpdateProfilePictureInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfilePictureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileToken"] = this.fileToken;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data;
    }
}

export interface IUpdateProfilePictureInput {
    fileToken: string;
    x: number;
    y: number;
    width: number;
    height: number;
}

export class GetPasswordComplexitySettingOutput implements IGetPasswordComplexitySettingOutput {
    setting!: PasswordComplexitySetting;

    constructor(data?: IGetPasswordComplexitySettingOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.setting = _data["setting"] ? PasswordComplexitySetting.fromJS(_data["setting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPasswordComplexitySettingOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPasswordComplexitySettingOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["setting"] = this.setting ? this.setting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPasswordComplexitySettingOutput {
    setting: PasswordComplexitySetting;
}

export class GetProfilePictureOutput implements IGetProfilePictureOutput {
    profilePicture!: string | undefined;

    constructor(data?: IGetProfilePictureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePicture = _data["profilePicture"];
        }
    }

    static fromJS(data: any): GetProfilePictureOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfilePictureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePicture"] = this.profilePicture;
        return data;
    }
}

export interface IGetProfilePictureOutput {
    profilePicture: string | undefined;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName!: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class Project implements IProject {
    tenantId!: number | undefined;
    customerId!: number;
    projectCode!: string | undefined;
    projectName!: string | undefined;
    budgetedHours!: number;
    id!: number;

    constructor(data?: IProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.customerId = _data["customerId"];
            this.projectCode = _data["projectCode"];
            this.projectName = _data["projectName"];
            this.budgetedHours = _data["budgetedHours"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Project {
        data = typeof data === 'object' ? data : {};
        let result = new Project();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["customerId"] = this.customerId;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        data["budgetedHours"] = this.budgetedHours;
        data["id"] = this.id;
        return data;
    }
}

export interface IProject {
    tenantId: number | undefined;
    customerId: number;
    projectCode: string | undefined;
    projectName: string | undefined;
    budgetedHours: number;
    id: number;
}

export class GetProjectDto implements IGetProjectDto {
    id!: number;
    projectCode!: string | undefined;
    projectName!: string | undefined;
    budgetedHours!: number;
    customer!: string | undefined;

    constructor(data?: IGetProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectCode = _data["projectCode"];
            this.projectName = _data["projectName"];
            this.budgetedHours = _data["budgetedHours"];
            this.customer = _data["customer"];
        }
    }

    static fromJS(data: any): GetProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        data["budgetedHours"] = this.budgetedHours;
        data["customer"] = this.customer;
        return data;
    }
}

export interface IGetProjectDto {
    id: number;
    projectCode: string | undefined;
    projectName: string | undefined;
    budgetedHours: number;
    customer: string | undefined;
}

export class ProvidentFundDto implements IProvidentFundDto {
    monthYear!: string | undefined;
    paymnetDate!: moment.Moment | undefined;
    paymentType!: number | undefined;
    bankName!: number | undefined;
    branchName!: number | undefined;
    draftNumber!: string | undefined;
    darftDate!: moment.Moment | undefined;
    chequeNumber!: string | undefined;
    chequeDate!: moment.Moment | undefined;
    id!: number;

    constructor(data?: IProvidentFundDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthYear = _data["monthYear"];
            this.paymnetDate = _data["paymnetDate"] ? moment(_data["paymnetDate"].toString()) : <any>undefined;
            this.paymentType = _data["paymentType"];
            this.bankName = _data["bankName"];
            this.branchName = _data["branchName"];
            this.draftNumber = _data["draftNumber"];
            this.darftDate = _data["darftDate"] ? moment(_data["darftDate"].toString()) : <any>undefined;
            this.chequeNumber = _data["chequeNumber"];
            this.chequeDate = _data["chequeDate"] ? moment(_data["chequeDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProvidentFundDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProvidentFundDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthYear"] = this.monthYear;
        data["paymnetDate"] = this.paymnetDate ? this.paymnetDate.toISOString() : <any>undefined;
        data["paymentType"] = this.paymentType;
        data["bankName"] = this.bankName;
        data["branchName"] = this.branchName;
        data["draftNumber"] = this.draftNumber;
        data["darftDate"] = this.darftDate ? this.darftDate.toISOString() : <any>undefined;
        data["chequeNumber"] = this.chequeNumber;
        data["chequeDate"] = this.chequeDate ? this.chequeDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IProvidentFundDto {
    monthYear: string | undefined;
    paymnetDate: moment.Moment | undefined;
    paymentType: number | undefined;
    bankName: number | undefined;
    branchName: number | undefined;
    draftNumber: string | undefined;
    darftDate: moment.Moment | undefined;
    chequeNumber: string | undefined;
    chequeDate: moment.Moment | undefined;
    id: number;
}

export class GetProvidentFundForViewDto implements IGetProvidentFundForViewDto {
    providentFund!: ProvidentFundDto;

    constructor(data?: IGetProvidentFundForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providentFund = _data["providentFund"] ? ProvidentFundDto.fromJS(_data["providentFund"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProvidentFundForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProvidentFundForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providentFund"] = this.providentFund ? this.providentFund.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetProvidentFundForViewDto {
    providentFund: ProvidentFundDto;
}

export class PagedResultDtoOfGetProvidentFundForViewDto implements IPagedResultDtoOfGetProvidentFundForViewDto {
    totalCount!: number;
    items!: GetProvidentFundForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetProvidentFundForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetProvidentFundForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetProvidentFundForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetProvidentFundForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetProvidentFundForViewDto {
    totalCount: number;
    items: GetProvidentFundForViewDto[] | undefined;
}

export class CreateOrEditProvidentFundDto implements ICreateOrEditProvidentFundDto {
    monthYear!: string | undefined;
    paymnetDate!: moment.Moment | undefined;
    paymentType!: number | undefined;
    bankName!: number | undefined;
    branchName!: number | undefined;
    draftNumber!: string | undefined;
    darftDate!: moment.Moment | undefined;
    chequeNumber!: string | undefined;
    chequeDate!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditProvidentFundDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthYear = _data["monthYear"];
            this.paymnetDate = _data["paymnetDate"] ? moment(_data["paymnetDate"].toString()) : <any>undefined;
            this.paymentType = _data["paymentType"];
            this.bankName = _data["bankName"];
            this.branchName = _data["branchName"];
            this.draftNumber = _data["draftNumber"];
            this.darftDate = _data["darftDate"] ? moment(_data["darftDate"].toString()) : <any>undefined;
            this.chequeNumber = _data["chequeNumber"];
            this.chequeDate = _data["chequeDate"] ? moment(_data["chequeDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditProvidentFundDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditProvidentFundDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthYear"] = this.monthYear;
        data["paymnetDate"] = this.paymnetDate ? this.paymnetDate.toISOString() : <any>undefined;
        data["paymentType"] = this.paymentType;
        data["bankName"] = this.bankName;
        data["branchName"] = this.branchName;
        data["draftNumber"] = this.draftNumber;
        data["darftDate"] = this.darftDate ? this.darftDate.toISOString() : <any>undefined;
        data["chequeNumber"] = this.chequeNumber;
        data["chequeDate"] = this.chequeDate ? this.chequeDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditProvidentFundDto {
    monthYear: string | undefined;
    paymnetDate: moment.Moment | undefined;
    paymentType: number | undefined;
    bankName: number | undefined;
    branchName: number | undefined;
    draftNumber: string | undefined;
    darftDate: moment.Moment | undefined;
    chequeNumber: string | undefined;
    chequeDate: moment.Moment | undefined;
    id: number | undefined;
}

export class GetProvidentFundForEditOutput implements IGetProvidentFundForEditOutput {
    providentFund!: CreateOrEditProvidentFundDto;

    constructor(data?: IGetProvidentFundForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providentFund = _data["providentFund"] ? CreateOrEditProvidentFundDto.fromJS(_data["providentFund"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProvidentFundForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProvidentFundForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providentFund"] = this.providentFund ? this.providentFund.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetProvidentFundForEditOutput {
    providentFund: CreateOrEditProvidentFundDto;
}

export class ProvidentFundSettingDto implements IProvidentFundSettingDto {
    applicable!: boolean;
    companyPfNo!: string | undefined;
    proratepfAsperemployee!: boolean;
    proratepfconsideringsalary!: boolean;
    depositepfofemployee!: boolean;
    establishment!: string | undefined;
    displayholdemploye!: boolean;
    displayemployeewhose!: boolean;
    deductpfonArrear!: boolean;
    roundpfamountonarrearpf!: boolean;
    roundoff!: string | undefined;
    employeeProvidentfund!: number;
    accountno10B!: number;
    accountno01!: number;
    accountno21!: number;
    accountno02!: number;
    accountno02minLimit!: number;
    accountno22!: number;
    accountno22minLimit!: number;
    employeesharelimit!: number;
    calculatepensionpro!: boolean;
    employersharelimit!: number;
    pensionfundlimit!: number;
    deductpensiononarrear!: string | undefined;
    adminchargeaccount21!: string | undefined;
    adminchargeaccount22!: string | undefined;
    voluntryprovidentfund!: boolean;
    calculateVPF!: boolean;
    vpfroundoff!: string | undefined;
    multiplegroup!: boolean;
    id!: number;

    constructor(data?: IProvidentFundSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicable = _data["applicable"];
            this.companyPfNo = _data["companyPfNo"];
            this.proratepfAsperemployee = _data["proratepfAsperemployee"];
            this.proratepfconsideringsalary = _data["proratepfconsideringsalary"];
            this.depositepfofemployee = _data["depositepfofemployee"];
            this.establishment = _data["establishment"];
            this.displayholdemploye = _data["displayholdemploye"];
            this.displayemployeewhose = _data["displayemployeewhose"];
            this.deductpfonArrear = _data["deductpfonArrear"];
            this.roundpfamountonarrearpf = _data["roundpfamountonarrearpf"];
            this.roundoff = _data["roundoff"];
            this.employeeProvidentfund = _data["employeeProvidentfund"];
            this.accountno10B = _data["accountno10B"];
            this.accountno01 = _data["accountno01"];
            this.accountno21 = _data["accountno21"];
            this.accountno02 = _data["accountno02"];
            this.accountno02minLimit = _data["accountno02minLimit"];
            this.accountno22 = _data["accountno22"];
            this.accountno22minLimit = _data["accountno22minLimit"];
            this.employeesharelimit = _data["employeesharelimit"];
            this.calculatepensionpro = _data["calculatepensionpro"];
            this.employersharelimit = _data["employersharelimit"];
            this.pensionfundlimit = _data["pensionfundlimit"];
            this.deductpensiononarrear = _data["deductpensiononarrear"];
            this.adminchargeaccount21 = _data["adminchargeaccount21"];
            this.adminchargeaccount22 = _data["adminchargeaccount22"];
            this.voluntryprovidentfund = _data["voluntryprovidentfund"];
            this.calculateVPF = _data["calculateVPF"];
            this.vpfroundoff = _data["vpfroundoff"];
            this.multiplegroup = _data["multiplegroup"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProvidentFundSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProvidentFundSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicable"] = this.applicable;
        data["companyPfNo"] = this.companyPfNo;
        data["proratepfAsperemployee"] = this.proratepfAsperemployee;
        data["proratepfconsideringsalary"] = this.proratepfconsideringsalary;
        data["depositepfofemployee"] = this.depositepfofemployee;
        data["establishment"] = this.establishment;
        data["displayholdemploye"] = this.displayholdemploye;
        data["displayemployeewhose"] = this.displayemployeewhose;
        data["deductpfonArrear"] = this.deductpfonArrear;
        data["roundpfamountonarrearpf"] = this.roundpfamountonarrearpf;
        data["roundoff"] = this.roundoff;
        data["employeeProvidentfund"] = this.employeeProvidentfund;
        data["accountno10B"] = this.accountno10B;
        data["accountno01"] = this.accountno01;
        data["accountno21"] = this.accountno21;
        data["accountno02"] = this.accountno02;
        data["accountno02minLimit"] = this.accountno02minLimit;
        data["accountno22"] = this.accountno22;
        data["accountno22minLimit"] = this.accountno22minLimit;
        data["employeesharelimit"] = this.employeesharelimit;
        data["calculatepensionpro"] = this.calculatepensionpro;
        data["employersharelimit"] = this.employersharelimit;
        data["pensionfundlimit"] = this.pensionfundlimit;
        data["deductpensiononarrear"] = this.deductpensiononarrear;
        data["adminchargeaccount21"] = this.adminchargeaccount21;
        data["adminchargeaccount22"] = this.adminchargeaccount22;
        data["voluntryprovidentfund"] = this.voluntryprovidentfund;
        data["calculateVPF"] = this.calculateVPF;
        data["vpfroundoff"] = this.vpfroundoff;
        data["multiplegroup"] = this.multiplegroup;
        data["id"] = this.id;
        return data;
    }
}

export interface IProvidentFundSettingDto {
    applicable: boolean;
    companyPfNo: string | undefined;
    proratepfAsperemployee: boolean;
    proratepfconsideringsalary: boolean;
    depositepfofemployee: boolean;
    establishment: string | undefined;
    displayholdemploye: boolean;
    displayemployeewhose: boolean;
    deductpfonArrear: boolean;
    roundpfamountonarrearpf: boolean;
    roundoff: string | undefined;
    employeeProvidentfund: number;
    accountno10B: number;
    accountno01: number;
    accountno21: number;
    accountno02: number;
    accountno02minLimit: number;
    accountno22: number;
    accountno22minLimit: number;
    employeesharelimit: number;
    calculatepensionpro: boolean;
    employersharelimit: number;
    pensionfundlimit: number;
    deductpensiononarrear: string | undefined;
    adminchargeaccount21: string | undefined;
    adminchargeaccount22: string | undefined;
    voluntryprovidentfund: boolean;
    calculateVPF: boolean;
    vpfroundoff: string | undefined;
    multiplegroup: boolean;
    id: number;
}

export class GetProvidentFundSettingForViewDto implements IGetProvidentFundSettingForViewDto {
    providentFundSetting!: ProvidentFundSettingDto;

    constructor(data?: IGetProvidentFundSettingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providentFundSetting = _data["providentFundSetting"] ? ProvidentFundSettingDto.fromJS(_data["providentFundSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProvidentFundSettingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProvidentFundSettingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providentFundSetting"] = this.providentFundSetting ? this.providentFundSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetProvidentFundSettingForViewDto {
    providentFundSetting: ProvidentFundSettingDto;
}

export class PagedResultDtoOfGetProvidentFundSettingForViewDto implements IPagedResultDtoOfGetProvidentFundSettingForViewDto {
    totalCount!: number;
    items!: GetProvidentFundSettingForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetProvidentFundSettingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetProvidentFundSettingForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetProvidentFundSettingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetProvidentFundSettingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetProvidentFundSettingForViewDto {
    totalCount: number;
    items: GetProvidentFundSettingForViewDto[] | undefined;
}

export class CreateOrEditProvidentFundSettingDto implements ICreateOrEditProvidentFundSettingDto {
    applicable!: boolean;
    companyPfNo!: string | undefined;
    proratepfAsperemployee!: boolean;
    proratepfconsideringsalary!: boolean;
    depositepfofemployee!: boolean;
    establishment!: string | undefined;
    displayholdemploye!: boolean;
    displayemployeewhose!: boolean;
    deductpfonArrear!: boolean;
    roundpfamountonarrearpf!: boolean;
    roundoff!: string | undefined;
    employeeProvidentfund!: number;
    accountno10B!: number;
    accountno01!: number;
    accountno21!: number;
    accountno02!: number;
    accountno02minLimit!: number;
    accountno22!: number;
    accountno22minLimit!: number;
    employeesharelimit!: number;
    calculatepensionpro!: boolean;
    employersharelimit!: number;
    pensionfundlimit!: number;
    deductpensiononarrear!: string | undefined;
    adminchargeaccount21!: string | undefined;
    adminchargeaccount22!: string | undefined;
    voluntryprovidentfund!: boolean;
    calculateVPF!: boolean;
    vpfroundoff!: string | undefined;
    multiplegroup!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditProvidentFundSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicable = _data["applicable"];
            this.companyPfNo = _data["companyPfNo"];
            this.proratepfAsperemployee = _data["proratepfAsperemployee"];
            this.proratepfconsideringsalary = _data["proratepfconsideringsalary"];
            this.depositepfofemployee = _data["depositepfofemployee"];
            this.establishment = _data["establishment"];
            this.displayholdemploye = _data["displayholdemploye"];
            this.displayemployeewhose = _data["displayemployeewhose"];
            this.deductpfonArrear = _data["deductpfonArrear"];
            this.roundpfamountonarrearpf = _data["roundpfamountonarrearpf"];
            this.roundoff = _data["roundoff"];
            this.employeeProvidentfund = _data["employeeProvidentfund"];
            this.accountno10B = _data["accountno10B"];
            this.accountno01 = _data["accountno01"];
            this.accountno21 = _data["accountno21"];
            this.accountno02 = _data["accountno02"];
            this.accountno02minLimit = _data["accountno02minLimit"];
            this.accountno22 = _data["accountno22"];
            this.accountno22minLimit = _data["accountno22minLimit"];
            this.employeesharelimit = _data["employeesharelimit"];
            this.calculatepensionpro = _data["calculatepensionpro"];
            this.employersharelimit = _data["employersharelimit"];
            this.pensionfundlimit = _data["pensionfundlimit"];
            this.deductpensiononarrear = _data["deductpensiononarrear"];
            this.adminchargeaccount21 = _data["adminchargeaccount21"];
            this.adminchargeaccount22 = _data["adminchargeaccount22"];
            this.voluntryprovidentfund = _data["voluntryprovidentfund"];
            this.calculateVPF = _data["calculateVPF"];
            this.vpfroundoff = _data["vpfroundoff"];
            this.multiplegroup = _data["multiplegroup"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditProvidentFundSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditProvidentFundSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicable"] = this.applicable;
        data["companyPfNo"] = this.companyPfNo;
        data["proratepfAsperemployee"] = this.proratepfAsperemployee;
        data["proratepfconsideringsalary"] = this.proratepfconsideringsalary;
        data["depositepfofemployee"] = this.depositepfofemployee;
        data["establishment"] = this.establishment;
        data["displayholdemploye"] = this.displayholdemploye;
        data["displayemployeewhose"] = this.displayemployeewhose;
        data["deductpfonArrear"] = this.deductpfonArrear;
        data["roundpfamountonarrearpf"] = this.roundpfamountonarrearpf;
        data["roundoff"] = this.roundoff;
        data["employeeProvidentfund"] = this.employeeProvidentfund;
        data["accountno10B"] = this.accountno10B;
        data["accountno01"] = this.accountno01;
        data["accountno21"] = this.accountno21;
        data["accountno02"] = this.accountno02;
        data["accountno02minLimit"] = this.accountno02minLimit;
        data["accountno22"] = this.accountno22;
        data["accountno22minLimit"] = this.accountno22minLimit;
        data["employeesharelimit"] = this.employeesharelimit;
        data["calculatepensionpro"] = this.calculatepensionpro;
        data["employersharelimit"] = this.employersharelimit;
        data["pensionfundlimit"] = this.pensionfundlimit;
        data["deductpensiononarrear"] = this.deductpensiononarrear;
        data["adminchargeaccount21"] = this.adminchargeaccount21;
        data["adminchargeaccount22"] = this.adminchargeaccount22;
        data["voluntryprovidentfund"] = this.voluntryprovidentfund;
        data["calculateVPF"] = this.calculateVPF;
        data["vpfroundoff"] = this.vpfroundoff;
        data["multiplegroup"] = this.multiplegroup;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditProvidentFundSettingDto {
    applicable: boolean;
    companyPfNo: string | undefined;
    proratepfAsperemployee: boolean;
    proratepfconsideringsalary: boolean;
    depositepfofemployee: boolean;
    establishment: string | undefined;
    displayholdemploye: boolean;
    displayemployeewhose: boolean;
    deductpfonArrear: boolean;
    roundpfamountonarrearpf: boolean;
    roundoff: string | undefined;
    employeeProvidentfund: number;
    accountno10B: number;
    accountno01: number;
    accountno21: number;
    accountno02: number;
    accountno02minLimit: number;
    accountno22: number;
    accountno22minLimit: number;
    employeesharelimit: number;
    calculatepensionpro: boolean;
    employersharelimit: number;
    pensionfundlimit: number;
    deductpensiononarrear: string | undefined;
    adminchargeaccount21: string | undefined;
    adminchargeaccount22: string | undefined;
    voluntryprovidentfund: boolean;
    calculateVPF: boolean;
    vpfroundoff: string | undefined;
    multiplegroup: boolean;
    id: number | undefined;
}

export class GetProvidentFundSettingForEditOutput implements IGetProvidentFundSettingForEditOutput {
    providentFundSetting!: CreateOrEditProvidentFundSettingDto;

    constructor(data?: IGetProvidentFundSettingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providentFundSetting = _data["providentFundSetting"] ? CreateOrEditProvidentFundSettingDto.fromJS(_data["providentFundSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProvidentFundSettingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProvidentFundSettingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providentFundSetting"] = this.providentFundSetting ? this.providentFundSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetProvidentFundSettingForEditOutput {
    providentFundSetting: CreateOrEditProvidentFundSettingDto;
}

export class QuikLinksDto implements IQuikLinksDto {
    name!: string | undefined;
    url!: string | undefined;
    id!: number;

    constructor(data?: IQuikLinksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.url = _data["url"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): QuikLinksDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuikLinksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["url"] = this.url;
        data["id"] = this.id;
        return data;
    }
}

export interface IQuikLinksDto {
    name: string | undefined;
    url: string | undefined;
    id: number;
}

export class GetQuikLinksForViewDto implements IGetQuikLinksForViewDto {
    quikLinks!: QuikLinksDto;

    constructor(data?: IGetQuikLinksForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quikLinks = _data["quikLinks"] ? QuikLinksDto.fromJS(_data["quikLinks"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetQuikLinksForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuikLinksForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quikLinks"] = this.quikLinks ? this.quikLinks.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetQuikLinksForViewDto {
    quikLinks: QuikLinksDto;
}

export class PagedResultDtoOfGetQuikLinksForViewDto implements IPagedResultDtoOfGetQuikLinksForViewDto {
    totalCount!: number;
    items!: GetQuikLinksForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetQuikLinksForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetQuikLinksForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetQuikLinksForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetQuikLinksForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetQuikLinksForViewDto {
    totalCount: number;
    items: GetQuikLinksForViewDto[] | undefined;
}

export class CreateOrEditQuikLinksDto implements ICreateOrEditQuikLinksDto {
    name!: string;
    url!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditQuikLinksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.url = _data["url"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditQuikLinksDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditQuikLinksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["url"] = this.url;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditQuikLinksDto {
    name: string;
    url: string;
    id: number | undefined;
}

export class GetQuikLinksForEditOutput implements IGetQuikLinksForEditOutput {
    quikLinks!: CreateOrEditQuikLinksDto;

    constructor(data?: IGetQuikLinksForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quikLinks = _data["quikLinks"] ? CreateOrEditQuikLinksDto.fromJS(_data["quikLinks"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetQuikLinksForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuikLinksForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quikLinks"] = this.quikLinks ? this.quikLinks.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetQuikLinksForEditOutput {
    quikLinks: CreateOrEditQuikLinksDto;
}

export class GetAllReasonView implements IGetAllReasonView {
    reason!: string | undefined;
    id!: number;

    constructor(data?: IGetAllReasonView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetAllReasonView {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllReasonView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetAllReasonView {
    reason: string | undefined;
    id: number;
}

export class PagedResultDtoOfGetAllReasonView implements IPagedResultDtoOfGetAllReasonView {
    totalCount!: number;
    items!: GetAllReasonView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllReasonView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllReasonView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllReasonView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllReasonView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAllReasonView {
    totalCount: number;
    items: GetAllReasonView[] | undefined;
}

export class CreateOrEditReasonDto implements ICreateOrEditReasonDto {
    name!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditReasonDto {
    name: string | undefined;
    id: number | undefined;
}

export class AttendanceReportDto implements IAttendanceReportDto {
    employeeId!: number | undefined;
    location!: string | undefined;
    department!: string | undefined;
    designation!: string | undefined;
    employeeCode!: string | undefined;
    name!: string | undefined;
    bioMetricId!: string | undefined;
    date!: string | undefined;
    attendanceStatus!: string | undefined;
    shiftName!: string | undefined;
    firstHalf!: string | undefined;
    secondHalf!: string | undefined;
    in1Time!: string | undefined;
    out1Time!: string | undefined;
    in2Time!: string | undefined;
    out2Time!: string | undefined;
    in3Time!: string | undefined;
    out3Time!: string | undefined;
    in4Time!: string | undefined;
    out4Time!: string | undefined;
    in5Time!: string | undefined;
    out5Time!: string | undefined;
    lateComing!: number | undefined;
    attendanceMode!: string | undefined;
    contractorName!: string | undefined;

    constructor(data?: IAttendanceReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.location = _data["location"];
            this.department = _data["department"];
            this.designation = _data["designation"];
            this.employeeCode = _data["employeeCode"];
            this.name = _data["name"];
            this.bioMetricId = _data["bioMetricId"];
            this.date = _data["date"];
            this.attendanceStatus = _data["attendanceStatus"];
            this.shiftName = _data["shiftName"];
            this.firstHalf = _data["firstHalf"];
            this.secondHalf = _data["secondHalf"];
            this.in1Time = _data["in1Time"];
            this.out1Time = _data["out1Time"];
            this.in2Time = _data["in2Time"];
            this.out2Time = _data["out2Time"];
            this.in3Time = _data["in3Time"];
            this.out3Time = _data["out3Time"];
            this.in4Time = _data["in4Time"];
            this.out4Time = _data["out4Time"];
            this.in5Time = _data["in5Time"];
            this.out5Time = _data["out5Time"];
            this.lateComing = _data["lateComing"];
            this.attendanceMode = _data["attendanceMode"];
            this.contractorName = _data["contractorName"];
        }
    }

    static fromJS(data: any): AttendanceReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["location"] = this.location;
        data["department"] = this.department;
        data["designation"] = this.designation;
        data["employeeCode"] = this.employeeCode;
        data["name"] = this.name;
        data["bioMetricId"] = this.bioMetricId;
        data["date"] = this.date;
        data["attendanceStatus"] = this.attendanceStatus;
        data["shiftName"] = this.shiftName;
        data["firstHalf"] = this.firstHalf;
        data["secondHalf"] = this.secondHalf;
        data["in1Time"] = this.in1Time;
        data["out1Time"] = this.out1Time;
        data["in2Time"] = this.in2Time;
        data["out2Time"] = this.out2Time;
        data["in3Time"] = this.in3Time;
        data["out3Time"] = this.out3Time;
        data["in4Time"] = this.in4Time;
        data["out4Time"] = this.out4Time;
        data["in5Time"] = this.in5Time;
        data["out5Time"] = this.out5Time;
        data["lateComing"] = this.lateComing;
        data["attendanceMode"] = this.attendanceMode;
        data["contractorName"] = this.contractorName;
        return data;
    }
}

export interface IAttendanceReportDto {
    employeeId: number | undefined;
    location: string | undefined;
    department: string | undefined;
    designation: string | undefined;
    employeeCode: string | undefined;
    name: string | undefined;
    bioMetricId: string | undefined;
    date: string | undefined;
    attendanceStatus: string | undefined;
    shiftName: string | undefined;
    firstHalf: string | undefined;
    secondHalf: string | undefined;
    in1Time: string | undefined;
    out1Time: string | undefined;
    in2Time: string | undefined;
    out2Time: string | undefined;
    in3Time: string | undefined;
    out3Time: string | undefined;
    in4Time: string | undefined;
    out4Time: string | undefined;
    in5Time: string | undefined;
    out5Time: string | undefined;
    lateComing: number | undefined;
    attendanceMode: string | undefined;
    contractorName: string | undefined;
}

export class AttendanceReportShiftWiseDto implements IAttendanceReportShiftWiseDto {
    shiftName!: string | undefined;
    title!: string | undefined;
    attendanceReport!: AttendanceReportDto[] | undefined;

    constructor(data?: IAttendanceReportShiftWiseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftName = _data["shiftName"];
            this.title = _data["title"];
            if (Array.isArray(_data["attendanceReport"])) {
                this.attendanceReport = [] as any;
                for (let item of _data["attendanceReport"])
                    this.attendanceReport!.push(AttendanceReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AttendanceReportShiftWiseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceReportShiftWiseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftName"] = this.shiftName;
        data["title"] = this.title;
        if (Array.isArray(this.attendanceReport)) {
            data["attendanceReport"] = [];
            for (let item of this.attendanceReport)
                data["attendanceReport"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAttendanceReportShiftWiseDto {
    shiftName: string | undefined;
    title: string | undefined;
    attendanceReport: AttendanceReportDto[] | undefined;
}

export class SendAttendanceReportMailPrms implements ISendAttendanceReportMailPrms {
    attendanceDate!: moment.Moment | undefined;
    shiftId!: number | undefined;
    toEmails!: string[] | undefined;
    ccEmails!: string[] | undefined;
    reportName!: string | undefined;
    reportType!: string | undefined;

    constructor(data?: ISendAttendanceReportMailPrms) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendanceDate = _data["attendanceDate"] ? moment(_data["attendanceDate"].toString()) : <any>undefined;
            this.shiftId = _data["shiftId"];
            if (Array.isArray(_data["toEmails"])) {
                this.toEmails = [] as any;
                for (let item of _data["toEmails"])
                    this.toEmails!.push(item);
            }
            if (Array.isArray(_data["ccEmails"])) {
                this.ccEmails = [] as any;
                for (let item of _data["ccEmails"])
                    this.ccEmails!.push(item);
            }
            this.reportName = _data["reportName"];
            this.reportType = _data["reportType"];
        }
    }

    static fromJS(data: any): SendAttendanceReportMailPrms {
        data = typeof data === 'object' ? data : {};
        let result = new SendAttendanceReportMailPrms();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendanceDate"] = this.attendanceDate ? this.attendanceDate.toISOString() : <any>undefined;
        data["shiftId"] = this.shiftId;
        if (Array.isArray(this.toEmails)) {
            data["toEmails"] = [];
            for (let item of this.toEmails)
                data["toEmails"].push(item);
        }
        if (Array.isArray(this.ccEmails)) {
            data["ccEmails"] = [];
            for (let item of this.ccEmails)
                data["ccEmails"].push(item);
        }
        data["reportName"] = this.reportName;
        data["reportType"] = this.reportType;
        return data;
    }
}

export interface ISendAttendanceReportMailPrms {
    attendanceDate: moment.Moment | undefined;
    shiftId: number | undefined;
    toEmails: string[] | undefined;
    ccEmails: string[] | undefined;
    reportName: string | undefined;
    reportType: string | undefined;
}

export class ReportingEmployeeFnfDto implements IReportingEmployeeFnfDto {
    employeeid!: number | undefined;
    previousreportingemployeeid!: number | undefined;
    reportingemployeeid!: number | undefined;
    reportingemployee!: string | undefined;
    id!: number;

    constructor(data?: IReportingEmployeeFnfDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeid = _data["employeeid"];
            this.previousreportingemployeeid = _data["previousreportingemployeeid"];
            this.reportingemployeeid = _data["reportingemployeeid"];
            this.reportingemployee = _data["reportingemployee"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ReportingEmployeeFnfDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportingEmployeeFnfDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeid"] = this.employeeid;
        data["previousreportingemployeeid"] = this.previousreportingemployeeid;
        data["reportingemployeeid"] = this.reportingemployeeid;
        data["reportingemployee"] = this.reportingemployee;
        data["id"] = this.id;
        return data;
    }
}

export interface IReportingEmployeeFnfDto {
    employeeid: number | undefined;
    previousreportingemployeeid: number | undefined;
    reportingemployeeid: number | undefined;
    reportingemployee: string | undefined;
    id: number;
}

export class DropdownManagerEmployees implements IDropdownManagerEmployees {
    value!: number | undefined;
    label!: string | undefined;
    id!: number | undefined;

    constructor(data?: IDropdownManagerEmployees) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DropdownManagerEmployees {
        data = typeof data === 'object' ? data : {};
        let result = new DropdownManagerEmployees();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        data["id"] = this.id;
        return data;
    }
}

export interface IDropdownManagerEmployees {
    value: number | undefined;
    label: string | undefined;
    id: number | undefined;
}

export class SaveReportingEmployeeDto implements ISaveReportingEmployeeDto {
    report!: ReportingEmployeeFnfDto[] | undefined;
    flag!: number | undefined;
    id!: number | undefined;

    constructor(data?: ISaveReportingEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["report"])) {
                this.report = [] as any;
                for (let item of _data["report"])
                    this.report!.push(ReportingEmployeeFnfDto.fromJS(item));
            }
            this.flag = _data["flag"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SaveReportingEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveReportingEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.report)) {
            data["report"] = [];
            for (let item of this.report)
                data["report"].push(item.toJSON());
        }
        data["flag"] = this.flag;
        data["id"] = this.id;
        return data;
    }
}

export interface ISaveReportingEmployeeDto {
    report: ReportingEmployeeFnfDto[] | undefined;
    flag: number | undefined;
    id: number | undefined;
}

export class ReportSchemasDto implements IReportSchemasDto {
    reportName!: string | undefined;
    tableName!: string | undefined;
    reportColumn!: string | undefined;
    reportFrom!: string | undefined;
    filter!: string | undefined;
    id!: number;

    constructor(data?: IReportSchemasDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportName = _data["reportName"];
            this.tableName = _data["tableName"];
            this.reportColumn = _data["reportColumn"];
            this.reportFrom = _data["reportFrom"];
            this.filter = _data["filter"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ReportSchemasDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportSchemasDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportName"] = this.reportName;
        data["tableName"] = this.tableName;
        data["reportColumn"] = this.reportColumn;
        data["reportFrom"] = this.reportFrom;
        data["filter"] = this.filter;
        data["id"] = this.id;
        return data;
    }
}

export interface IReportSchemasDto {
    reportName: string | undefined;
    tableName: string | undefined;
    reportColumn: string | undefined;
    reportFrom: string | undefined;
    filter: string | undefined;
    id: number;
}

export class GetReportSchemasForViewDto implements IGetReportSchemasForViewDto {
    reportSchemas!: ReportSchemasDto;

    constructor(data?: IGetReportSchemasForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportSchemas = _data["reportSchemas"] ? ReportSchemasDto.fromJS(_data["reportSchemas"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetReportSchemasForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportSchemasForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportSchemas"] = this.reportSchemas ? this.reportSchemas.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetReportSchemasForViewDto {
    reportSchemas: ReportSchemasDto;
}

export class PagedResultDtoOfGetReportSchemasForViewDto implements IPagedResultDtoOfGetReportSchemasForViewDto {
    totalCount!: number;
    items!: GetReportSchemasForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetReportSchemasForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetReportSchemasForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetReportSchemasForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetReportSchemasForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetReportSchemasForViewDto {
    totalCount: number;
    items: GetReportSchemasForViewDto[] | undefined;
}

export class CreateOrEditReportSchemasDto implements ICreateOrEditReportSchemasDto {
    reportName!: string;
    tableName!: string;
    reportColumn!: string;
    reportFrom!: string;
    filter!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditReportSchemasDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportName = _data["reportName"];
            this.tableName = _data["tableName"];
            this.reportColumn = _data["reportColumn"];
            this.reportFrom = _data["reportFrom"];
            this.filter = _data["filter"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditReportSchemasDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditReportSchemasDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportName"] = this.reportName;
        data["tableName"] = this.tableName;
        data["reportColumn"] = this.reportColumn;
        data["reportFrom"] = this.reportFrom;
        data["filter"] = this.filter;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditReportSchemasDto {
    reportName: string;
    tableName: string;
    reportColumn: string;
    reportFrom: string;
    filter: string | undefined;
    id: number | undefined;
}

export class GetReportSchemasForEditOutput implements IGetReportSchemasForEditOutput {
    reportSchemas!: CreateOrEditReportSchemasDto;

    constructor(data?: IGetReportSchemasForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportSchemas = _data["reportSchemas"] ? CreateOrEditReportSchemasDto.fromJS(_data["reportSchemas"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetReportSchemasForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportSchemasForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportSchemas"] = this.reportSchemas ? this.reportSchemas.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetReportSchemasForEditOutput {
    reportSchemas: CreateOrEditReportSchemasDto;
}

export class RequestApprovalDto implements IRequestApprovalDto {
    requestType!: number;
    level!: number | undefined;
    approvedBy!: number | undefined;
    approvedOn!: moment.Moment | undefined;
    remarks!: string | undefined;
    notficationSend!: boolean;
    isProcessFeed!: boolean;
    requestForApprovalId!: number | undefined;
    id!: number;

    constructor(data?: IRequestApprovalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestType = _data["requestType"];
            this.level = _data["level"];
            this.approvedBy = _data["approvedBy"];
            this.approvedOn = _data["approvedOn"] ? moment(_data["approvedOn"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
            this.notficationSend = _data["notficationSend"];
            this.isProcessFeed = _data["isProcessFeed"];
            this.requestForApprovalId = _data["requestForApprovalId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RequestApprovalDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestType"] = this.requestType;
        data["level"] = this.level;
        data["approvedBy"] = this.approvedBy;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["notficationSend"] = this.notficationSend;
        data["isProcessFeed"] = this.isProcessFeed;
        data["requestForApprovalId"] = this.requestForApprovalId;
        data["id"] = this.id;
        return data;
    }
}

export interface IRequestApprovalDto {
    requestType: number;
    level: number | undefined;
    approvedBy: number | undefined;
    approvedOn: moment.Moment | undefined;
    remarks: string | undefined;
    notficationSend: boolean;
    isProcessFeed: boolean;
    requestForApprovalId: number | undefined;
    id: number;
}

export class GetRequestApprovalForViewDto implements IGetRequestApprovalForViewDto {
    requestApproval!: RequestApprovalDto;
    requestForApprovalStatus!: string | undefined;

    constructor(data?: IGetRequestApprovalForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestApproval = _data["requestApproval"] ? RequestApprovalDto.fromJS(_data["requestApproval"]) : <any>undefined;
            this.requestForApprovalStatus = _data["requestForApprovalStatus"];
        }
    }

    static fromJS(data: any): GetRequestApprovalForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRequestApprovalForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestApproval"] = this.requestApproval ? this.requestApproval.toJSON() : <any>undefined;
        data["requestForApprovalStatus"] = this.requestForApprovalStatus;
        return data;
    }
}

export interface IGetRequestApprovalForViewDto {
    requestApproval: RequestApprovalDto;
    requestForApprovalStatus: string | undefined;
}

export class PagedResultDtoOfGetRequestApprovalForViewDto implements IPagedResultDtoOfGetRequestApprovalForViewDto {
    totalCount!: number;
    items!: GetRequestApprovalForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetRequestApprovalForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetRequestApprovalForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetRequestApprovalForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetRequestApprovalForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetRequestApprovalForViewDto {
    totalCount: number;
    items: GetRequestApprovalForViewDto[] | undefined;
}

export class CreateOrEditRequestApprovalDto implements ICreateOrEditRequestApprovalDto {
    requestType!: number;
    level!: number | undefined;
    approvedBy!: number | undefined;
    approvedOn!: moment.Moment | undefined;
    remarks!: string | undefined;
    notficationSend!: boolean;
    isProcessFeed!: boolean;
    requestForApprovalId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditRequestApprovalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestType = _data["requestType"];
            this.level = _data["level"];
            this.approvedBy = _data["approvedBy"];
            this.approvedOn = _data["approvedOn"] ? moment(_data["approvedOn"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
            this.notficationSend = _data["notficationSend"];
            this.isProcessFeed = _data["isProcessFeed"];
            this.requestForApprovalId = _data["requestForApprovalId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditRequestApprovalDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditRequestApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestType"] = this.requestType;
        data["level"] = this.level;
        data["approvedBy"] = this.approvedBy;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["notficationSend"] = this.notficationSend;
        data["isProcessFeed"] = this.isProcessFeed;
        data["requestForApprovalId"] = this.requestForApprovalId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditRequestApprovalDto {
    requestType: number;
    level: number | undefined;
    approvedBy: number | undefined;
    approvedOn: moment.Moment | undefined;
    remarks: string | undefined;
    notficationSend: boolean;
    isProcessFeed: boolean;
    requestForApprovalId: number | undefined;
    id: number | undefined;
}

export class GetRequestApprovalForEditOutput implements IGetRequestApprovalForEditOutput {
    requestApproval!: CreateOrEditRequestApprovalDto;
    requestForApprovalStatus!: string | undefined;

    constructor(data?: IGetRequestApprovalForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestApproval = _data["requestApproval"] ? CreateOrEditRequestApprovalDto.fromJS(_data["requestApproval"]) : <any>undefined;
            this.requestForApprovalStatus = _data["requestForApprovalStatus"];
        }
    }

    static fromJS(data: any): GetRequestApprovalForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRequestApprovalForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestApproval"] = this.requestApproval ? this.requestApproval.toJSON() : <any>undefined;
        data["requestForApprovalStatus"] = this.requestForApprovalStatus;
        return data;
    }
}

export interface IGetRequestApprovalForEditOutput {
    requestApproval: CreateOrEditRequestApprovalDto;
    requestForApprovalStatus: string | undefined;
}

export class RequestApprovalRequestForApprovalLookupTableDto implements IRequestApprovalRequestForApprovalLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IRequestApprovalRequestForApprovalLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): RequestApprovalRequestForApprovalLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestApprovalRequestForApprovalLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IRequestApprovalRequestForApprovalLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfRequestApprovalRequestForApprovalLookupTableDto implements IPagedResultDtoOfRequestApprovalRequestForApprovalLookupTableDto {
    totalCount!: number;
    items!: RequestApprovalRequestForApprovalLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRequestApprovalRequestForApprovalLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RequestApprovalRequestForApprovalLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRequestApprovalRequestForApprovalLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRequestApprovalRequestForApprovalLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfRequestApprovalRequestForApprovalLookupTableDto {
    totalCount: number;
    items: RequestApprovalRequestForApprovalLookupTableDto[] | undefined;
}

export class CreateOrEditRequestForApprovalDto implements ICreateOrEditRequestForApprovalDto {
    requestDate!: moment.Moment;
    requestBy!: number;
    payload!: string | undefined;
    requestTypeId!: number | undefined;
    status!: string | undefined;
    requestApprovals!: CreateOrEditRequestApprovalDto[] | undefined;
    level!: number | undefined;
    completed!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditRequestForApprovalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestDate = _data["requestDate"] ? moment(_data["requestDate"].toString()) : <any>undefined;
            this.requestBy = _data["requestBy"];
            this.payload = _data["payload"];
            this.requestTypeId = _data["requestTypeId"];
            this.status = _data["status"];
            if (Array.isArray(_data["requestApprovals"])) {
                this.requestApprovals = [] as any;
                for (let item of _data["requestApprovals"])
                    this.requestApprovals!.push(CreateOrEditRequestApprovalDto.fromJS(item));
            }
            this.level = _data["level"];
            this.completed = _data["completed"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditRequestForApprovalDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditRequestForApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["requestBy"] = this.requestBy;
        data["payload"] = this.payload;
        data["requestTypeId"] = this.requestTypeId;
        data["status"] = this.status;
        if (Array.isArray(this.requestApprovals)) {
            data["requestApprovals"] = [];
            for (let item of this.requestApprovals)
                data["requestApprovals"].push(item.toJSON());
        }
        data["level"] = this.level;
        data["completed"] = this.completed;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditRequestForApprovalDto {
    requestDate: moment.Moment;
    requestBy: number;
    payload: string | undefined;
    requestTypeId: number | undefined;
    status: string | undefined;
    requestApprovals: CreateOrEditRequestApprovalDto[] | undefined;
    level: number | undefined;
    completed: boolean;
    id: number | undefined;
}

export class GetRequestForApprovalForEditOutput implements IGetRequestForApprovalForEditOutput {
    requestForApproval!: CreateOrEditRequestForApprovalDto;

    constructor(data?: IGetRequestForApprovalForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestForApproval = _data["requestForApproval"] ? CreateOrEditRequestForApprovalDto.fromJS(_data["requestForApproval"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRequestForApprovalForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRequestForApprovalForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestForApproval"] = this.requestForApproval ? this.requestForApproval.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRequestForApprovalForEditOutput {
    requestForApproval: CreateOrEditRequestForApprovalDto;
}

export class RequestWorkflowStepDto implements IRequestWorkflowStepDto {
    level!: number;
    intimationOnly!: boolean;
    turnAroundTime!: number;
    roleId!: number | undefined;
    requesrFlowId!: number | undefined;
    id!: number;

    constructor(data?: IRequestWorkflowStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.level = _data["level"];
            this.intimationOnly = _data["intimationOnly"];
            this.turnAroundTime = _data["turnAroundTime"];
            this.roleId = _data["roleId"];
            this.requesrFlowId = _data["requesrFlowId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RequestWorkflowStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestWorkflowStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["intimationOnly"] = this.intimationOnly;
        data["turnAroundTime"] = this.turnAroundTime;
        data["roleId"] = this.roleId;
        data["requesrFlowId"] = this.requesrFlowId;
        data["id"] = this.id;
        return data;
    }
}

export interface IRequestWorkflowStepDto {
    level: number;
    intimationOnly: boolean;
    turnAroundTime: number;
    roleId: number | undefined;
    requesrFlowId: number | undefined;
    id: number;
}

export class GetRequestWorkflowStepForViewDto implements IGetRequestWorkflowStepForViewDto {
    requestWorkflowStep!: RequestWorkflowStepDto;
    roleName!: string | undefined;
    requesrFlowDescription!: string | undefined;

    constructor(data?: IGetRequestWorkflowStepForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestWorkflowStep = _data["requestWorkflowStep"] ? RequestWorkflowStepDto.fromJS(_data["requestWorkflowStep"]) : <any>undefined;
            this.roleName = _data["roleName"];
            this.requesrFlowDescription = _data["requesrFlowDescription"];
        }
    }

    static fromJS(data: any): GetRequestWorkflowStepForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRequestWorkflowStepForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestWorkflowStep"] = this.requestWorkflowStep ? this.requestWorkflowStep.toJSON() : <any>undefined;
        data["roleName"] = this.roleName;
        data["requesrFlowDescription"] = this.requesrFlowDescription;
        return data;
    }
}

export interface IGetRequestWorkflowStepForViewDto {
    requestWorkflowStep: RequestWorkflowStepDto;
    roleName: string | undefined;
    requesrFlowDescription: string | undefined;
}

export class PagedResultDtoOfGetRequestWorkflowStepForViewDto implements IPagedResultDtoOfGetRequestWorkflowStepForViewDto {
    totalCount!: number;
    items!: GetRequestWorkflowStepForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetRequestWorkflowStepForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetRequestWorkflowStepForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetRequestWorkflowStepForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetRequestWorkflowStepForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetRequestWorkflowStepForViewDto {
    totalCount: number;
    items: GetRequestWorkflowStepForViewDto[] | undefined;
}

export class WorkFlowSteps implements IWorkFlowSteps {
    level!: number;
    intimationOnly!: boolean;
    turnAroundTime!: number;
    roleId!: number;
    hierarchy!: number | undefined;

    constructor(data?: IWorkFlowSteps) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.level = _data["level"];
            this.intimationOnly = _data["intimationOnly"];
            this.turnAroundTime = _data["turnAroundTime"];
            this.roleId = _data["roleId"];
            this.hierarchy = _data["hierarchy"];
        }
    }

    static fromJS(data: any): WorkFlowSteps {
        data = typeof data === 'object' ? data : {};
        let result = new WorkFlowSteps();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["intimationOnly"] = this.intimationOnly;
        data["turnAroundTime"] = this.turnAroundTime;
        data["roleId"] = this.roleId;
        data["hierarchy"] = this.hierarchy;
        return data;
    }
}

export interface IWorkFlowSteps {
    level: number;
    intimationOnly: boolean;
    turnAroundTime: number;
    roleId: number;
    hierarchy: number | undefined;
}

export class CreateOrEditRequestWorkflowStepDto implements ICreateOrEditRequestWorkflowStepDto {
    name!: string | undefined;
    description!: string | undefined;
    type!: number;
    steps!: WorkFlowSteps[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditRequestWorkflowStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.type = _data["type"];
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(WorkFlowSteps.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditRequestWorkflowStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditRequestWorkflowStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["type"] = this.type;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditRequestWorkflowStepDto {
    name: string | undefined;
    description: string | undefined;
    type: number;
    steps: WorkFlowSteps[] | undefined;
    id: number | undefined;
}

export class RequestWorkflowStepRoleLookupTableDto implements IRequestWorkflowStepRoleLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IRequestWorkflowStepRoleLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): RequestWorkflowStepRoleLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestWorkflowStepRoleLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IRequestWorkflowStepRoleLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfRequestWorkflowStepRoleLookupTableDto implements IPagedResultDtoOfRequestWorkflowStepRoleLookupTableDto {
    totalCount!: number;
    items!: RequestWorkflowStepRoleLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRequestWorkflowStepRoleLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RequestWorkflowStepRoleLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRequestWorkflowStepRoleLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRequestWorkflowStepRoleLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfRequestWorkflowStepRoleLookupTableDto {
    totalCount: number;
    items: RequestWorkflowStepRoleLookupTableDto[] | undefined;
}

export class RequestWorkflowStepRequesrFlowLookupTableDto implements IRequestWorkflowStepRequesrFlowLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IRequestWorkflowStepRequesrFlowLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): RequestWorkflowStepRequesrFlowLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestWorkflowStepRequesrFlowLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IRequestWorkflowStepRequesrFlowLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfRequestWorkflowStepRequesrFlowLookupTableDto implements IPagedResultDtoOfRequestWorkflowStepRequesrFlowLookupTableDto {
    totalCount!: number;
    items!: RequestWorkflowStepRequesrFlowLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRequestWorkflowStepRequesrFlowLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RequestWorkflowStepRequesrFlowLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRequestWorkflowStepRequesrFlowLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRequestWorkflowStepRequesrFlowLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfRequestWorkflowStepRequesrFlowLookupTableDto {
    totalCount: number;
    items: RequestWorkflowStepRequesrFlowLookupTableDto[] | undefined;
}

export class GetReviewStatusViewDto implements IGetReviewStatusViewDto {
    employeeName!: string | undefined;
    cycle!: string | undefined;
    dueOn!: string | undefined;
    employeeSubmittedOn!: string | undefined;
    managerSubmittedOn!: string | undefined;
    averageScore!: number;
    id!: number;

    constructor(data?: IGetReviewStatusViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeName = _data["employeeName"];
            this.cycle = _data["cycle"];
            this.dueOn = _data["dueOn"];
            this.employeeSubmittedOn = _data["employeeSubmittedOn"];
            this.managerSubmittedOn = _data["managerSubmittedOn"];
            this.averageScore = _data["averageScore"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetReviewStatusViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetReviewStatusViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeName"] = this.employeeName;
        data["cycle"] = this.cycle;
        data["dueOn"] = this.dueOn;
        data["employeeSubmittedOn"] = this.employeeSubmittedOn;
        data["managerSubmittedOn"] = this.managerSubmittedOn;
        data["averageScore"] = this.averageScore;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetReviewStatusViewDto {
    employeeName: string | undefined;
    cycle: string | undefined;
    dueOn: string | undefined;
    employeeSubmittedOn: string | undefined;
    managerSubmittedOn: string | undefined;
    averageScore: number;
    id: number;
}

export class PagedResultDtoOfGetReviewStatusViewDto implements IPagedResultDtoOfGetReviewStatusViewDto {
    totalCount!: number;
    items!: GetReviewStatusViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetReviewStatusViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetReviewStatusViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetReviewStatusViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetReviewStatusViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetReviewStatusViewDto {
    totalCount: number;
    items: GetReviewStatusViewDto[] | undefined;
}

export class GetCriteriaData implements IGetCriteriaData {
    maxValue!: number;
    minValue!: number;
    countValue!: string | undefined;
    criteriaScore!: number;

    constructor(data?: IGetCriteriaData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxValue = _data["maxValue"];
            this.minValue = _data["minValue"];
            this.countValue = _data["countValue"];
            this.criteriaScore = _data["criteriaScore"];
        }
    }

    static fromJS(data: any): GetCriteriaData {
        data = typeof data === 'object' ? data : {};
        let result = new GetCriteriaData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxValue"] = this.maxValue;
        data["minValue"] = this.minValue;
        data["countValue"] = this.countValue;
        data["criteriaScore"] = this.criteriaScore;
        return data;
    }
}

export interface IGetCriteriaData {
    maxValue: number;
    minValue: number;
    countValue: string | undefined;
    criteriaScore: number;
}

export class GetCreateOrEditReviewedData implements IGetCreateOrEditReviewedData {
    rowIndex!: number;
    kraId!: number;
    kraName!: string | undefined;
    kraMeasurable!: string | undefined;
    weightage!: number;
    capturedData!: number;
    employeeFeedback!: number;
    managerFeedback!: number;
    employeeId!: number;
    policyId!: number;
    kpI_Policy_kra_id!: number;
    selfAssessment!: number;
    l1Assessment!: number;
    netValue!: number;
    scoreValue!: number;
    employeeRemark!: string | undefined;
    managerRemark!: string | undefined;
    finalReviewFeedback!: number | undefined;
    finalReviewRemark!: string | undefined;
    l2Assessment!: number | undefined;

    constructor(data?: IGetCreateOrEditReviewedData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowIndex = _data["rowIndex"];
            this.kraId = _data["kraId"];
            this.kraName = _data["kraName"];
            this.kraMeasurable = _data["kraMeasurable"];
            this.weightage = _data["weightage"];
            this.capturedData = _data["capturedData"];
            this.employeeFeedback = _data["employeeFeedback"];
            this.managerFeedback = _data["managerFeedback"];
            this.employeeId = _data["employeeId"];
            this.policyId = _data["policyId"];
            this.kpI_Policy_kra_id = _data["kpI_Policy_kra_id"];
            this.selfAssessment = _data["selfAssessment"];
            this.l1Assessment = _data["l1Assessment"];
            this.netValue = _data["netValue"];
            this.scoreValue = _data["scoreValue"];
            this.employeeRemark = _data["employeeRemark"];
            this.managerRemark = _data["managerRemark"];
            this.finalReviewFeedback = _data["finalReviewFeedback"];
            this.finalReviewRemark = _data["finalReviewRemark"];
            this.l2Assessment = _data["l2Assessment"];
        }
    }

    static fromJS(data: any): GetCreateOrEditReviewedData {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateOrEditReviewedData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowIndex"] = this.rowIndex;
        data["kraId"] = this.kraId;
        data["kraName"] = this.kraName;
        data["kraMeasurable"] = this.kraMeasurable;
        data["weightage"] = this.weightage;
        data["capturedData"] = this.capturedData;
        data["employeeFeedback"] = this.employeeFeedback;
        data["managerFeedback"] = this.managerFeedback;
        data["employeeId"] = this.employeeId;
        data["policyId"] = this.policyId;
        data["kpI_Policy_kra_id"] = this.kpI_Policy_kra_id;
        data["selfAssessment"] = this.selfAssessment;
        data["l1Assessment"] = this.l1Assessment;
        data["netValue"] = this.netValue;
        data["scoreValue"] = this.scoreValue;
        data["employeeRemark"] = this.employeeRemark;
        data["managerRemark"] = this.managerRemark;
        data["finalReviewFeedback"] = this.finalReviewFeedback;
        data["finalReviewRemark"] = this.finalReviewRemark;
        data["l2Assessment"] = this.l2Assessment;
        return data;
    }
}

export interface IGetCreateOrEditReviewedData {
    rowIndex: number;
    kraId: number;
    kraName: string | undefined;
    kraMeasurable: string | undefined;
    weightage: number;
    capturedData: number;
    employeeFeedback: number;
    managerFeedback: number;
    employeeId: number;
    policyId: number;
    kpI_Policy_kra_id: number;
    selfAssessment: number;
    l1Assessment: number;
    netValue: number;
    scoreValue: number;
    employeeRemark: string | undefined;
    managerRemark: string | undefined;
    finalReviewFeedback: number | undefined;
    finalReviewRemark: string | undefined;
    l2Assessment: number | undefined;
}

export class GetReviewDataForViewPopUp implements IGetReviewDataForViewPopUp {
    maxValue!: number;
    captured_Feedback_level!: string | undefined;
    manager_Feedback_level!: string | undefined;
    finalFeedbacklevel!: string | undefined;
    feedback_level!: string | undefined;
    employeeNAme!: string | undefined;
    cycleName!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    ediatble!: string | undefined;
    message!: string | undefined;
    isEmployeeSubmitted!: boolean;
    getCreateOrEditReviewedData!: GetCreateOrEditReviewedData;

    constructor(data?: IGetReviewDataForViewPopUp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxValue = _data["maxValue"];
            this.captured_Feedback_level = _data["captured_Feedback_level"];
            this.manager_Feedback_level = _data["manager_Feedback_level"];
            this.finalFeedbacklevel = _data["finalFeedbacklevel"];
            this.feedback_level = _data["feedback_level"];
            this.employeeNAme = _data["employeeNAme"];
            this.cycleName = _data["cycleName"];
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>undefined;
            this.ediatble = _data["ediatble"];
            this.message = _data["message"];
            this.isEmployeeSubmitted = _data["isEmployeeSubmitted"];
            this.getCreateOrEditReviewedData = _data["getCreateOrEditReviewedData"] ? GetCreateOrEditReviewedData.fromJS(_data["getCreateOrEditReviewedData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetReviewDataForViewPopUp {
        data = typeof data === 'object' ? data : {};
        let result = new GetReviewDataForViewPopUp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxValue"] = this.maxValue;
        data["captured_Feedback_level"] = this.captured_Feedback_level;
        data["manager_Feedback_level"] = this.manager_Feedback_level;
        data["finalFeedbacklevel"] = this.finalFeedbacklevel;
        data["feedback_level"] = this.feedback_level;
        data["employeeNAme"] = this.employeeNAme;
        data["cycleName"] = this.cycleName;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["ediatble"] = this.ediatble;
        data["message"] = this.message;
        data["isEmployeeSubmitted"] = this.isEmployeeSubmitted;
        data["getCreateOrEditReviewedData"] = this.getCreateOrEditReviewedData ? this.getCreateOrEditReviewedData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetReviewDataForViewPopUp {
    maxValue: number;
    captured_Feedback_level: string | undefined;
    manager_Feedback_level: string | undefined;
    finalFeedbacklevel: string | undefined;
    feedback_level: string | undefined;
    employeeNAme: string | undefined;
    cycleName: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    ediatble: string | undefined;
    message: string | undefined;
    isEmployeeSubmitted: boolean;
    getCreateOrEditReviewedData: GetCreateOrEditReviewedData;
}

export class GetReviewedData implements IGetReviewedData {
    branchName!: string | undefined;
    department!: string | undefined;
    employeeCode!: string | undefined;
    employeeName!: string | undefined;
    policyName!: string | undefined;
    cycleName!: string | undefined;
    managerStatus!: string | undefined;

    constructor(data?: IGetReviewedData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchName = _data["branchName"];
            this.department = _data["department"];
            this.employeeCode = _data["employeeCode"];
            this.employeeName = _data["employeeName"];
            this.policyName = _data["policyName"];
            this.cycleName = _data["cycleName"];
            this.managerStatus = _data["managerStatus"];
        }
    }

    static fromJS(data: any): GetReviewedData {
        data = typeof data === 'object' ? data : {};
        let result = new GetReviewedData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchName"] = this.branchName;
        data["department"] = this.department;
        data["employeeCode"] = this.employeeCode;
        data["employeeName"] = this.employeeName;
        data["policyName"] = this.policyName;
        data["cycleName"] = this.cycleName;
        data["managerStatus"] = this.managerStatus;
        return data;
    }
}

export interface IGetReviewedData {
    branchName: string | undefined;
    department: string | undefined;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    policyName: string | undefined;
    cycleName: string | undefined;
    managerStatus: string | undefined;
}

export class PerformanceReviewExportDto implements IPerformanceReviewExportDto {
    branchIds!: number[] | undefined;
    departmentIds!: number[] | undefined;
    employeeIds!: number[] | undefined;
    cycleNames!: string[] | undefined;
    status!: string | undefined;

    constructor(data?: IPerformanceReviewExportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["branchIds"])) {
                this.branchIds = [] as any;
                for (let item of _data["branchIds"])
                    this.branchIds!.push(item);
            }
            if (Array.isArray(_data["departmentIds"])) {
                this.departmentIds = [] as any;
                for (let item of _data["departmentIds"])
                    this.departmentIds!.push(item);
            }
            if (Array.isArray(_data["employeeIds"])) {
                this.employeeIds = [] as any;
                for (let item of _data["employeeIds"])
                    this.employeeIds!.push(item);
            }
            if (Array.isArray(_data["cycleNames"])) {
                this.cycleNames = [] as any;
                for (let item of _data["cycleNames"])
                    this.cycleNames!.push(item);
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): PerformanceReviewExportDto {
        data = typeof data === 'object' ? data : {};
        let result = new PerformanceReviewExportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.branchIds)) {
            data["branchIds"] = [];
            for (let item of this.branchIds)
                data["branchIds"].push(item);
        }
        if (Array.isArray(this.departmentIds)) {
            data["departmentIds"] = [];
            for (let item of this.departmentIds)
                data["departmentIds"].push(item);
        }
        if (Array.isArray(this.employeeIds)) {
            data["employeeIds"] = [];
            for (let item of this.employeeIds)
                data["employeeIds"].push(item);
        }
        if (Array.isArray(this.cycleNames)) {
            data["cycleNames"] = [];
            for (let item of this.cycleNames)
                data["cycleNames"].push(item);
        }
        data["status"] = this.status;
        return data;
    }
}

export interface IPerformanceReviewExportDto {
    branchIds: number[] | undefined;
    departmentIds: number[] | undefined;
    employeeIds: number[] | undefined;
    cycleNames: string[] | undefined;
    status: string | undefined;
}

export class GetCreateOrEditReviewedEmployeeData implements IGetCreateOrEditReviewedEmployeeData {
    policyName!: string | undefined;
    employeeName!: string | undefined;
    cycleName!: string | undefined;
    timeperiod!: number;
    fromDate!: string | undefined;
    toDate!: string | undefined;
    message!: string | undefined;

    constructor(data?: IGetCreateOrEditReviewedEmployeeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.policyName = _data["policyName"];
            this.employeeName = _data["employeeName"];
            this.cycleName = _data["cycleName"];
            this.timeperiod = _data["timeperiod"];
            this.fromDate = _data["fromDate"];
            this.toDate = _data["toDate"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): GetCreateOrEditReviewedEmployeeData {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateOrEditReviewedEmployeeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyName"] = this.policyName;
        data["employeeName"] = this.employeeName;
        data["cycleName"] = this.cycleName;
        data["timeperiod"] = this.timeperiod;
        data["fromDate"] = this.fromDate;
        data["toDate"] = this.toDate;
        data["message"] = this.message;
        return data;
    }
}

export interface IGetCreateOrEditReviewedEmployeeData {
    policyName: string | undefined;
    employeeName: string | undefined;
    cycleName: string | undefined;
    timeperiod: number;
    fromDate: string | undefined;
    toDate: string | undefined;
    message: string | undefined;
}

export class GetReviewIdForPopup implements IGetReviewIdForPopup {
    buttonText!: string | undefined;
    reviewId!: number;

    constructor(data?: IGetReviewIdForPopup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buttonText = _data["buttonText"];
            this.reviewId = _data["reviewId"];
        }
    }

    static fromJS(data: any): GetReviewIdForPopup {
        data = typeof data === 'object' ? data : {};
        let result = new GetReviewIdForPopup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buttonText"] = this.buttonText;
        data["reviewId"] = this.reviewId;
        return data;
    }
}

export interface IGetReviewIdForPopup {
    buttonText: string | undefined;
    reviewId: number;
}

export class CreateOrEditReviewStatusDetails implements ICreateOrEditReviewStatusDetails {
    weightage!: number;
    captured_Count!: number;
    employee_feedback!: number;
    manager_feedback!: number;
    self_assessment!: number;
    l1_Assessment!: number;
    net!: number;
    score!: number;
    employeeRemark!: string | undefined;
    managerRemark!: string | undefined;
    fk_ReviewId!: number;
    krA_Id!: number;
    tenantId!: number;
    finalReviewRemark!: string | undefined;
    finalReviewFeedback!: number | undefined;
    l2_Assessment!: number | undefined;
    id!: number;

    constructor(data?: ICreateOrEditReviewStatusDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weightage = _data["weightage"];
            this.captured_Count = _data["captured_Count"];
            this.employee_feedback = _data["employee_feedback"];
            this.manager_feedback = _data["manager_feedback"];
            this.self_assessment = _data["self_assessment"];
            this.l1_Assessment = _data["l1_Assessment"];
            this.net = _data["net"];
            this.score = _data["score"];
            this.employeeRemark = _data["employeeRemark"];
            this.managerRemark = _data["managerRemark"];
            this.fk_ReviewId = _data["fk_ReviewId"];
            this.krA_Id = _data["krA_Id"];
            this.tenantId = _data["tenantId"];
            this.finalReviewRemark = _data["finalReviewRemark"];
            this.finalReviewFeedback = _data["finalReviewFeedback"];
            this.l2_Assessment = _data["l2_Assessment"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditReviewStatusDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditReviewStatusDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weightage"] = this.weightage;
        data["captured_Count"] = this.captured_Count;
        data["employee_feedback"] = this.employee_feedback;
        data["manager_feedback"] = this.manager_feedback;
        data["self_assessment"] = this.self_assessment;
        data["l1_Assessment"] = this.l1_Assessment;
        data["net"] = this.net;
        data["score"] = this.score;
        data["employeeRemark"] = this.employeeRemark;
        data["managerRemark"] = this.managerRemark;
        data["fk_ReviewId"] = this.fk_ReviewId;
        data["krA_Id"] = this.krA_Id;
        data["tenantId"] = this.tenantId;
        data["finalReviewRemark"] = this.finalReviewRemark;
        data["finalReviewFeedback"] = this.finalReviewFeedback;
        data["l2_Assessment"] = this.l2_Assessment;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditReviewStatusDetails {
    weightage: number;
    captured_Count: number;
    employee_feedback: number;
    manager_feedback: number;
    self_assessment: number;
    l1_Assessment: number;
    net: number;
    score: number;
    employeeRemark: string | undefined;
    managerRemark: string | undefined;
    fk_ReviewId: number;
    krA_Id: number;
    tenantId: number;
    finalReviewRemark: string | undefined;
    finalReviewFeedback: number | undefined;
    l2_Assessment: number | undefined;
    id: number;
}

export class CreateOrEditReviewStatus implements ICreateOrEditReviewStatus {
    period_From!: moment.Moment | undefined;
    period_To!: moment.Moment | undefined;
    fK_Policy_Id!: number;
    employeeId!: number;
    tenantId!: number;
    employeeStatus!: string | undefined;
    managerStatus!: string | undefined;
    employeeSubmittedOn!: moment.Moment;
    managerSubmittedOn!: moment.Moment;
    cycleName!: string | undefined;
    reviewStatusDetails!: CreateOrEditReviewStatusDetails[] | undefined;
    id!: number;

    constructor(data?: ICreateOrEditReviewStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.period_From = _data["period_From"] ? moment(_data["period_From"].toString()) : <any>undefined;
            this.period_To = _data["period_To"] ? moment(_data["period_To"].toString()) : <any>undefined;
            this.fK_Policy_Id = _data["fK_Policy_Id"];
            this.employeeId = _data["employeeId"];
            this.tenantId = _data["tenantId"];
            this.employeeStatus = _data["employeeStatus"];
            this.managerStatus = _data["managerStatus"];
            this.employeeSubmittedOn = _data["employeeSubmittedOn"] ? moment(_data["employeeSubmittedOn"].toString()) : <any>undefined;
            this.managerSubmittedOn = _data["managerSubmittedOn"] ? moment(_data["managerSubmittedOn"].toString()) : <any>undefined;
            this.cycleName = _data["cycleName"];
            if (Array.isArray(_data["reviewStatusDetails"])) {
                this.reviewStatusDetails = [] as any;
                for (let item of _data["reviewStatusDetails"])
                    this.reviewStatusDetails!.push(CreateOrEditReviewStatusDetails.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditReviewStatus {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditReviewStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period_From"] = this.period_From ? this.period_From.toISOString() : <any>undefined;
        data["period_To"] = this.period_To ? this.period_To.toISOString() : <any>undefined;
        data["fK_Policy_Id"] = this.fK_Policy_Id;
        data["employeeId"] = this.employeeId;
        data["tenantId"] = this.tenantId;
        data["employeeStatus"] = this.employeeStatus;
        data["managerStatus"] = this.managerStatus;
        data["employeeSubmittedOn"] = this.employeeSubmittedOn ? this.employeeSubmittedOn.toISOString() : <any>undefined;
        data["managerSubmittedOn"] = this.managerSubmittedOn ? this.managerSubmittedOn.toISOString() : <any>undefined;
        data["cycleName"] = this.cycleName;
        if (Array.isArray(this.reviewStatusDetails)) {
            data["reviewStatusDetails"] = [];
            for (let item of this.reviewStatusDetails)
                data["reviewStatusDetails"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditReviewStatus {
    period_From: moment.Moment | undefined;
    period_To: moment.Moment | undefined;
    fK_Policy_Id: number;
    employeeId: number;
    tenantId: number;
    employeeStatus: string | undefined;
    managerStatus: string | undefined;
    employeeSubmittedOn: moment.Moment;
    managerSubmittedOn: moment.Moment;
    cycleName: string | undefined;
    reviewStatusDetails: CreateOrEditReviewStatusDetails[] | undefined;
    id: number;
}

export enum ScoreType {
    SelfAssessmentL1L2 = 0,
    L1L2 = 1,
    L2 = 2,
    SelfAssessmentL1 = 3,
    L1 = 4,
}

export class ScoreDto implements IScoreDto {
    scoreType!: ScoreType;

    constructor(data?: IScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scoreType = _data["scoreType"];
        }
    }

    static fromJS(data: any): ScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scoreType"] = this.scoreType;
        return data;
    }
}

export interface IScoreDto {
    scoreType: ScoreType;
}

export class CommonScoreSetup implements ICommonScoreSetup {
    tenantId!: number | undefined;
    tenant!: Tenant;
    createdBy!: number | undefined;
    scoreType!: ScoreType;
    createdAt!: moment.Moment;
    id!: number;

    constructor(data?: ICommonScoreSetup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.scoreType = _data["scoreType"];
            this.createdAt = _data["createdAt"] ? moment(_data["createdAt"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CommonScoreSetup {
        data = typeof data === 'object' ? data : {};
        let result = new CommonScoreSetup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["scoreType"] = this.scoreType;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICommonScoreSetup {
    tenantId: number | undefined;
    tenant: Tenant;
    createdBy: number | undefined;
    scoreType: ScoreType;
    createdAt: moment.Moment;
    id: number;
}

export class RoleListDto implements IRoleListDto {
    name!: string | undefined;
    displayName!: string | undefined;
    isStatic!: boolean;
    isDefault!: boolean;
    creationTime!: moment.Moment;
    id!: number;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
    id: number;
}

export class ListResultDtoOfRoleListDto implements IListResultDtoOfRoleListDto {
    items!: RoleListDto[] | undefined;

    constructor(data?: IListResultDtoOfRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfRoleListDto {
    items: RoleListDto[] | undefined;
}

export class RoleEditDto implements IRoleEditDto {
    id!: number | undefined;
    displayName!: string;
    isDefault!: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IRoleEditDto {
    id: number | undefined;
    displayName: string;
    isDefault: boolean;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    isGrantedByDefault!: boolean;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isGrantedByDefault = _data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data;
    }
}

export interface IFlatPermissionDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role!: RoleEditDto;
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class CreateOrUpdateRoleInput implements ICreateOrUpdateRoleInput {
    role!: RoleEditDto;
    grantedPermissionNames!: string[];

    constructor(data?: ICreateOrUpdateRoleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.role = new RoleEditDto();
            this.grantedPermissionNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : new RoleEditDto();
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateRoleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRoleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface ICreateOrUpdateRoleInput {
    role: RoleEditDto;
    grantedPermissionNames: string[];
}

export class GetRosterDataParam implements IGetRosterDataParam {
    branchId!: number[] | undefined;
    departmentId!: number[] | undefined;
    subDepartmentId!: number[] | undefined;
    employeeId!: number[] | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;

    constructor(data?: IGetRosterDataParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["branchId"])) {
                this.branchId = [] as any;
                for (let item of _data["branchId"])
                    this.branchId!.push(item);
            }
            if (Array.isArray(_data["departmentId"])) {
                this.departmentId = [] as any;
                for (let item of _data["departmentId"])
                    this.departmentId!.push(item);
            }
            if (Array.isArray(_data["subDepartmentId"])) {
                this.subDepartmentId = [] as any;
                for (let item of _data["subDepartmentId"])
                    this.subDepartmentId!.push(item);
            }
            if (Array.isArray(_data["employeeId"])) {
                this.employeeId = [] as any;
                for (let item of _data["employeeId"])
                    this.employeeId!.push(item);
            }
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRosterDataParam {
        data = typeof data === 'object' ? data : {};
        let result = new GetRosterDataParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.branchId)) {
            data["branchId"] = [];
            for (let item of this.branchId)
                data["branchId"].push(item);
        }
        if (Array.isArray(this.departmentId)) {
            data["departmentId"] = [];
            for (let item of this.departmentId)
                data["departmentId"].push(item);
        }
        if (Array.isArray(this.subDepartmentId)) {
            data["subDepartmentId"] = [];
            for (let item of this.subDepartmentId)
                data["subDepartmentId"].push(item);
        }
        if (Array.isArray(this.employeeId)) {
            data["employeeId"] = [];
            for (let item of this.employeeId)
                data["employeeId"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetRosterDataParam {
    branchId: number[] | undefined;
    departmentId: number[] | undefined;
    subDepartmentId: number[] | undefined;
    employeeId: number[] | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
}

export class ShiftDate implements IShiftDate {
    date!: string | undefined;
    shift!: number | undefined;
    woHo!: string | undefined;

    constructor(data?: IShiftDate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.shift = _data["shift"];
            this.woHo = _data["woHo"];
        }
    }

    static fromJS(data: any): ShiftDate {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftDate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["shift"] = this.shift;
        data["woHo"] = this.woHo;
        return data;
    }
}

export interface IShiftDate {
    date: string | undefined;
    shift: number | undefined;
    woHo: string | undefined;
}

export class GetRosterDataDto implements IGetRosterDataDto {
    employeeId!: number;
    employeeCode!: string | undefined;
    employeeName!: string | undefined;
    shiftDateList!: ShiftDate[] | undefined;

    constructor(data?: IGetRosterDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.employeeCode = _data["employeeCode"];
            this.employeeName = _data["employeeName"];
            if (Array.isArray(_data["shiftDateList"])) {
                this.shiftDateList = [] as any;
                for (let item of _data["shiftDateList"])
                    this.shiftDateList!.push(ShiftDate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRosterDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRosterDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["employeeCode"] = this.employeeCode;
        data["employeeName"] = this.employeeName;
        if (Array.isArray(this.shiftDateList)) {
            data["shiftDateList"] = [];
            for (let item of this.shiftDateList)
                data["shiftDateList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRosterDataDto {
    employeeId: number;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    shiftDateList: ShiftDate[] | undefined;
}

export class UpdateShiftsDto implements IUpdateShiftsDto {
    employeeId!: number;
    shiftDate!: ShiftDate;

    constructor(data?: IUpdateShiftsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.shiftDate = _data["shiftDate"] ? ShiftDate.fromJS(_data["shiftDate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateShiftsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateShiftsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["shiftDate"] = this.shiftDate ? this.shiftDate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateShiftsDto {
    employeeId: number;
    shiftDate: ShiftDate;
}

export class GetReimbursementDto implements IGetReimbursementDto {
    totalEmployee!: number;
    totalSubmission!: number;
    totalAmount!: number;
    pendingRequest!: number;

    constructor(data?: IGetReimbursementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalEmployee = _data["totalEmployee"];
            this.totalSubmission = _data["totalSubmission"];
            this.totalAmount = _data["totalAmount"];
            this.pendingRequest = _data["pendingRequest"];
        }
    }

    static fromJS(data: any): GetReimbursementDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetReimbursementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalEmployee"] = this.totalEmployee;
        data["totalSubmission"] = this.totalSubmission;
        data["totalAmount"] = this.totalAmount;
        data["pendingRequest"] = this.pendingRequest;
        return data;
    }
}

export interface IGetReimbursementDto {
    totalEmployee: number;
    totalSubmission: number;
    totalAmount: number;
    pendingRequest: number;
}

export class GetOnholdsalaryDto implements IGetOnholdsalaryDto {
    totalEmployee!: number;
    totalAmount!: number;

    constructor(data?: IGetOnholdsalaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalEmployee = _data["totalEmployee"];
            this.totalAmount = _data["totalAmount"];
        }
    }

    static fromJS(data: any): GetOnholdsalaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOnholdsalaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalEmployee"] = this.totalEmployee;
        data["totalAmount"] = this.totalAmount;
        return data;
    }
}

export interface IGetOnholdsalaryDto {
    totalEmployee: number;
    totalAmount: number;
}

export class ProcessLateComing implements IProcessLateComing {
    id!: number;
    employeeCode!: string | undefined;
    employeeName!: string | undefined;
    lateComing!: number;
    deducted!: number | undefined;

    constructor(data?: IProcessLateComing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeCode = _data["employeeCode"];
            this.employeeName = _data["employeeName"];
            this.lateComing = _data["lateComing"];
            this.deducted = _data["deducted"];
        }
    }

    static fromJS(data: any): ProcessLateComing {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessLateComing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeCode"] = this.employeeCode;
        data["employeeName"] = this.employeeName;
        data["lateComing"] = this.lateComing;
        data["deducted"] = this.deducted;
        return data;
    }
}

export interface IProcessLateComing {
    id: number;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    lateComing: number;
    deducted: number | undefined;
}

export class PagedResultDtoOfProcessLateComing implements IPagedResultDtoOfProcessLateComing {
    totalCount!: number;
    items!: ProcessLateComing[] | undefined;

    constructor(data?: IPagedResultDtoOfProcessLateComing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProcessLateComing.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfProcessLateComing {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfProcessLateComing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfProcessLateComing {
    totalCount: number;
    items: ProcessLateComing[] | undefined;
}

export class GetOnholdsalaryForGridDto implements IGetOnholdsalaryForGridDto {
    id!: number;
    employeeCode!: string | undefined;
    employeeName!: string | undefined;
    onHold!: string | undefined;

    constructor(data?: IGetOnholdsalaryForGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeCode = _data["employeeCode"];
            this.employeeName = _data["employeeName"];
            this.onHold = _data["onHold"];
        }
    }

    static fromJS(data: any): GetOnholdsalaryForGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOnholdsalaryForGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeCode"] = this.employeeCode;
        data["employeeName"] = this.employeeName;
        data["onHold"] = this.onHold;
        return data;
    }
}

export interface IGetOnholdsalaryForGridDto {
    id: number;
    employeeCode: string | undefined;
    employeeName: string | undefined;
    onHold: string | undefined;
}

export class CreateOrEditOnHoldSalary implements ICreateOrEditOnHoldSalary {
    id!: number;
    employeeId!: number;
    tenantId!: number;
    onhold!: boolean;
    monthYear!: string | undefined;

    constructor(data?: ICreateOrEditOnHoldSalary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.tenantId = _data["tenantId"];
            this.onhold = _data["onhold"];
            this.monthYear = _data["monthYear"];
        }
    }

    static fromJS(data: any): CreateOrEditOnHoldSalary {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditOnHoldSalary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["tenantId"] = this.tenantId;
        data["onhold"] = this.onhold;
        data["monthYear"] = this.monthYear;
        return data;
    }
}

export interface ICreateOrEditOnHoldSalary {
    id: number;
    employeeId: number;
    tenantId: number;
    onhold: boolean;
    monthYear: string | undefined;
}

export class GetReimbursementViewDto implements IGetReimbursementViewDto {
    employeeCode!: string | undefined;
    employeeName!: string | undefined;
    expense!: string | undefined;
    amount!: string | undefined;
    approvedOn!: string | undefined;
    monthyear!: string | undefined;
    employeeId!: number;
    payroll!: string | undefined;

    constructor(data?: IGetReimbursementViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeCode = _data["employeeCode"];
            this.employeeName = _data["employeeName"];
            this.expense = _data["expense"];
            this.amount = _data["amount"];
            this.approvedOn = _data["approvedOn"];
            this.monthyear = _data["monthyear"];
            this.employeeId = _data["employeeId"];
            this.payroll = _data["payroll"];
        }
    }

    static fromJS(data: any): GetReimbursementViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetReimbursementViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeCode"] = this.employeeCode;
        data["employeeName"] = this.employeeName;
        data["expense"] = this.expense;
        data["amount"] = this.amount;
        data["approvedOn"] = this.approvedOn;
        data["monthyear"] = this.monthyear;
        data["employeeId"] = this.employeeId;
        data["payroll"] = this.payroll;
        return data;
    }
}

export interface IGetReimbursementViewDto {
    employeeCode: string | undefined;
    employeeName: string | undefined;
    expense: string | undefined;
    amount: string | undefined;
    approvedOn: string | undefined;
    monthyear: string | undefined;
    employeeId: number;
    payroll: string | undefined;
}

export class Salarydata implements ISalarydata {
    actual!: number | undefined;
    name!: string | undefined;

    constructor(data?: ISalarydata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actual = _data["actual"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Salarydata {
        data = typeof data === 'object' ? data : {};
        let result = new Salarydata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actual"] = this.actual;
        data["name"] = this.name;
        return data;
    }
}

export interface ISalarydata {
    actual: number | undefined;
    name: string | undefined;
}

export class SalaryDto implements ISalaryDto {
    monthyear!: string | undefined;
    branch!: number | undefined;
    employeeId!: number;
    present!: number;
    weekOff!: number | undefined;
    holiday!: number | undefined;
    leaves!: number | undefined;
    earnings!: number | undefined;
    deductions!: number | undefined;
    netPay!: number | undefined;
    onHold!: boolean;
    hrApproved!: boolean;
    id!: number;

    constructor(data?: ISalaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthyear = _data["monthyear"];
            this.branch = _data["branch"];
            this.employeeId = _data["employeeId"];
            this.present = _data["present"];
            this.weekOff = _data["weekOff"];
            this.holiday = _data["holiday"];
            this.leaves = _data["leaves"];
            this.earnings = _data["earnings"];
            this.deductions = _data["deductions"];
            this.netPay = _data["netPay"];
            this.onHold = _data["onHold"];
            this.hrApproved = _data["hrApproved"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SalaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthyear"] = this.monthyear;
        data["branch"] = this.branch;
        data["employeeId"] = this.employeeId;
        data["present"] = this.present;
        data["weekOff"] = this.weekOff;
        data["holiday"] = this.holiday;
        data["leaves"] = this.leaves;
        data["earnings"] = this.earnings;
        data["deductions"] = this.deductions;
        data["netPay"] = this.netPay;
        data["onHold"] = this.onHold;
        data["hrApproved"] = this.hrApproved;
        data["id"] = this.id;
        return data;
    }
}

export interface ISalaryDto {
    monthyear: string | undefined;
    branch: number | undefined;
    employeeId: number;
    present: number;
    weekOff: number | undefined;
    holiday: number | undefined;
    leaves: number | undefined;
    earnings: number | undefined;
    deductions: number | undefined;
    netPay: number | undefined;
    onHold: boolean;
    hrApproved: boolean;
    id: number;
}

export class GetSalaryForViewDto implements IGetSalaryForViewDto {
    salary!: SalaryDto;

    constructor(data?: IGetSalaryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salary = _data["salary"] ? SalaryDto.fromJS(_data["salary"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSalaryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalaryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salary"] = this.salary ? this.salary.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSalaryForViewDto {
    salary: SalaryDto;
}

export class PagedResultDtoOfGetSalaryForViewDto implements IPagedResultDtoOfGetSalaryForViewDto {
    totalCount!: number;
    items!: GetSalaryForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSalaryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSalaryForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSalaryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSalaryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSalaryForViewDto {
    totalCount: number;
    items: GetSalaryForViewDto[] | undefined;
}

export class CreateOrEditSalaryDto implements ICreateOrEditSalaryDto {
    monthyear!: number | undefined;
    branch!: number | undefined;
    employeeId!: number;
    present!: number;
    weekOff!: number | undefined;
    holiday!: number | undefined;
    leaves!: number | undefined;
    earnings!: number | undefined;
    deductions!: number | undefined;
    netPay!: number | undefined;
    onHold!: boolean;
    hrApproved!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSalaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthyear = _data["monthyear"];
            this.branch = _data["branch"];
            this.employeeId = _data["employeeId"];
            this.present = _data["present"];
            this.weekOff = _data["weekOff"];
            this.holiday = _data["holiday"];
            this.leaves = _data["leaves"];
            this.earnings = _data["earnings"];
            this.deductions = _data["deductions"];
            this.netPay = _data["netPay"];
            this.onHold = _data["onHold"];
            this.hrApproved = _data["hrApproved"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSalaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSalaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthyear"] = this.monthyear;
        data["branch"] = this.branch;
        data["employeeId"] = this.employeeId;
        data["present"] = this.present;
        data["weekOff"] = this.weekOff;
        data["holiday"] = this.holiday;
        data["leaves"] = this.leaves;
        data["earnings"] = this.earnings;
        data["deductions"] = this.deductions;
        data["netPay"] = this.netPay;
        data["onHold"] = this.onHold;
        data["hrApproved"] = this.hrApproved;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSalaryDto {
    monthyear: number | undefined;
    branch: number | undefined;
    employeeId: number;
    present: number;
    weekOff: number | undefined;
    holiday: number | undefined;
    leaves: number | undefined;
    earnings: number | undefined;
    deductions: number | undefined;
    netPay: number | undefined;
    onHold: boolean;
    hrApproved: boolean;
    id: number | undefined;
}

export class GetSalaryForEditOutput implements IGetSalaryForEditOutput {
    salary!: CreateOrEditSalaryDto;

    constructor(data?: IGetSalaryForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salary = _data["salary"] ? CreateOrEditSalaryDto.fromJS(_data["salary"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSalaryForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalaryForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salary"] = this.salary ? this.salary.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSalaryForEditOutput {
    salary: CreateOrEditSalaryDto;
}

export class ArrearsReportDTO implements IArrearsReportDTO {
    employeeId!: number;
    employeeName!: string | undefined;
    employeeCode!: string | undefined;
    yearFormats!: string | undefined;
    arrearMonth!: string | undefined;
    attendanceArrears!: number;
    salaryArrears!: number;
    manualArrears!: number;
    incrementWithEffectFrom!: string | undefined;
    incrementDoneDate!: string | undefined;
    attendnaceCount!: number;
    salaryMonthCount!: number;
    approvalStaus!: boolean | undefined;

    constructor(data?: IArrearsReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.employeeCode = _data["employeeCode"];
            this.yearFormats = _data["yearFormats"];
            this.arrearMonth = _data["arrearMonth"];
            this.attendanceArrears = _data["attendanceArrears"];
            this.salaryArrears = _data["salaryArrears"];
            this.manualArrears = _data["manualArrears"];
            this.incrementWithEffectFrom = _data["incrementWithEffectFrom"];
            this.incrementDoneDate = _data["incrementDoneDate"];
            this.attendnaceCount = _data["attendnaceCount"];
            this.salaryMonthCount = _data["salaryMonthCount"];
            this.approvalStaus = _data["approvalStaus"];
        }
    }

    static fromJS(data: any): ArrearsReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ArrearsReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["employeeCode"] = this.employeeCode;
        data["yearFormats"] = this.yearFormats;
        data["arrearMonth"] = this.arrearMonth;
        data["attendanceArrears"] = this.attendanceArrears;
        data["salaryArrears"] = this.salaryArrears;
        data["manualArrears"] = this.manualArrears;
        data["incrementWithEffectFrom"] = this.incrementWithEffectFrom;
        data["incrementDoneDate"] = this.incrementDoneDate;
        data["attendnaceCount"] = this.attendnaceCount;
        data["salaryMonthCount"] = this.salaryMonthCount;
        data["approvalStaus"] = this.approvalStaus;
        return data;
    }
}

export interface IArrearsReportDTO {
    employeeId: number;
    employeeName: string | undefined;
    employeeCode: string | undefined;
    yearFormats: string | undefined;
    arrearMonth: string | undefined;
    attendanceArrears: number;
    salaryArrears: number;
    manualArrears: number;
    incrementWithEffectFrom: string | undefined;
    incrementDoneDate: string | undefined;
    attendnaceCount: number;
    salaryMonthCount: number;
    approvalStaus: boolean | undefined;
}

export class PayComponentDTO implements IPayComponentDTO {
    componentId!: number;
    componentName!: string | undefined;
    componentAmount!: number;

    constructor(data?: IPayComponentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentId = _data["componentId"];
            this.componentName = _data["componentName"];
            this.componentAmount = _data["componentAmount"];
        }
    }

    static fromJS(data: any): PayComponentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PayComponentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId;
        data["componentName"] = this.componentName;
        data["componentAmount"] = this.componentAmount;
        return data;
    }
}

export interface IPayComponentDTO {
    componentId: number;
    componentName: string | undefined;
    componentAmount: number;
}

export class ArrearsDetailDto implements IArrearsDetailDto {
    monthYear!: string | undefined;
    employeeId!: number;
    type!: string | undefined;
    payComponent!: number;
    amount!: number;
    componentName!: string | undefined;

    constructor(data?: IArrearsDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthYear = _data["monthYear"];
            this.employeeId = _data["employeeId"];
            this.type = _data["type"];
            this.payComponent = _data["payComponent"];
            this.amount = _data["amount"];
            this.componentName = _data["componentName"];
        }
    }

    static fromJS(data: any): ArrearsDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArrearsDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthYear"] = this.monthYear;
        data["employeeId"] = this.employeeId;
        data["type"] = this.type;
        data["payComponent"] = this.payComponent;
        data["amount"] = this.amount;
        data["componentName"] = this.componentName;
        return data;
    }
}

export interface IArrearsDetailDto {
    monthYear: string | undefined;
    employeeId: number;
    type: string | undefined;
    payComponent: number;
    amount: number;
    componentName: string | undefined;
}

export class ArrearsDetailsResponseDto implements IArrearsDetailsResponseDto {
    details!: ArrearsDetailDto[] | undefined;
    totalAmount!: number;

    constructor(data?: IArrearsDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(ArrearsDetailDto.fromJS(item));
            }
            this.totalAmount = _data["totalAmount"];
        }
    }

    static fromJS(data: any): ArrearsDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArrearsDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["totalAmount"] = this.totalAmount;
        return data;
    }
}

export interface IArrearsDetailsResponseDto {
    details: ArrearsDetailDto[] | undefined;
    totalAmount: number;
}

export class ArrearComponentDto implements IArrearComponentDto {
    payComponent!: number;
    payComponentId!: number;
    payComponentName!: string | undefined;
    attendance!: number;
    salary!: number;
    manual!: number;

    constructor(data?: IArrearComponentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payComponent = _data["payComponent"];
            this.payComponentId = _data["payComponentId"];
            this.payComponentName = _data["payComponentName"];
            this.attendance = _data["attendance"];
            this.salary = _data["salary"];
            this.manual = _data["manual"];
        }
    }

    static fromJS(data: any): ArrearComponentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArrearComponentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payComponent"] = this.payComponent;
        data["payComponentId"] = this.payComponentId;
        data["payComponentName"] = this.payComponentName;
        data["attendance"] = this.attendance;
        data["salary"] = this.salary;
        data["manual"] = this.manual;
        return data;
    }
}

export interface IArrearComponentDto {
    payComponent: number;
    payComponentId: number;
    payComponentName: string | undefined;
    attendance: number;
    salary: number;
    manual: number;
}

export class SaveArrearsDto implements ISaveArrearsDto {
    monthYear!: string | undefined;
    employeeId!: number;
    reportingManager!: boolean;
    isManual!: boolean | undefined;
    components!: ArrearComponentDto[] | undefined;

    constructor(data?: ISaveArrearsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthYear = _data["monthYear"];
            this.employeeId = _data["employeeId"];
            this.reportingManager = _data["reportingManager"];
            this.isManual = _data["isManual"];
            if (Array.isArray(_data["components"])) {
                this.components = [] as any;
                for (let item of _data["components"])
                    this.components!.push(ArrearComponentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveArrearsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveArrearsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthYear"] = this.monthYear;
        data["employeeId"] = this.employeeId;
        data["reportingManager"] = this.reportingManager;
        data["isManual"] = this.isManual;
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveArrearsDto {
    monthYear: string | undefined;
    employeeId: number;
    reportingManager: boolean;
    isManual: boolean | undefined;
    components: ArrearComponentDto[] | undefined;
}

export class ManualArrearApprovalDto implements IManualArrearApprovalDto {
    requestId!: number;
    employeeId!: number;
    employeeName!: string | undefined;
    employeeCode!: string | undefined;
    monthYear!: string | undefined;
    components!: ArrearComponentDto[] | undefined;
    requestDate!: moment.Moment;
    status!: string | undefined;

    constructor(data?: IManualArrearApprovalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.employeeCode = _data["employeeCode"];
            this.monthYear = _data["monthYear"];
            if (Array.isArray(_data["components"])) {
                this.components = [] as any;
                for (let item of _data["components"])
                    this.components!.push(ArrearComponentDto.fromJS(item));
            }
            this.requestDate = _data["requestDate"] ? moment(_data["requestDate"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ManualArrearApprovalDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManualArrearApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["employeeCode"] = this.employeeCode;
        data["monthYear"] = this.monthYear;
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item.toJSON());
        }
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface IManualArrearApprovalDto {
    requestId: number;
    employeeId: number;
    employeeName: string | undefined;
    employeeCode: string | undefined;
    monthYear: string | undefined;
    components: ArrearComponentDto[] | undefined;
    requestDate: moment.Moment;
    status: string | undefined;
}

export class SalaryAdvanceDto implements ISalaryAdvanceDto {
    policyName!: string | undefined;
    advanceEligibility!: number;
    maximumNoOfEMI!: number;
    rateOfIntrest!: number;
    allowException!: boolean;
    payComponentId!: number;
    advanceTypeId!: number;
    advancePercentage!: number | undefined;
    payGradeId!: number;
    id!: number;

    constructor(data?: ISalaryAdvanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.policyName = _data["policyName"];
            this.advanceEligibility = _data["advanceEligibility"];
            this.maximumNoOfEMI = _data["maximumNoOfEMI"];
            this.rateOfIntrest = _data["rateOfIntrest"];
            this.allowException = _data["allowException"];
            this.payComponentId = _data["payComponentId"];
            this.advanceTypeId = _data["advanceTypeId"];
            this.advancePercentage = _data["advancePercentage"];
            this.payGradeId = _data["payGradeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SalaryAdvanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalaryAdvanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyName"] = this.policyName;
        data["advanceEligibility"] = this.advanceEligibility;
        data["maximumNoOfEMI"] = this.maximumNoOfEMI;
        data["rateOfIntrest"] = this.rateOfIntrest;
        data["allowException"] = this.allowException;
        data["payComponentId"] = this.payComponentId;
        data["advanceTypeId"] = this.advanceTypeId;
        data["advancePercentage"] = this.advancePercentage;
        data["payGradeId"] = this.payGradeId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISalaryAdvanceDto {
    policyName: string | undefined;
    advanceEligibility: number;
    maximumNoOfEMI: number;
    rateOfIntrest: number;
    allowException: boolean;
    payComponentId: number;
    advanceTypeId: number;
    advancePercentage: number | undefined;
    payGradeId: number;
    id: number;
}

export class GetSalaryAdvanceForViewDto implements IGetSalaryAdvanceForViewDto {
    salaryAdvance!: SalaryAdvanceDto;
    advanceTypeType!: string | undefined;
    payGradeName!: string | undefined;
    payComponentName!: string | undefined;

    constructor(data?: IGetSalaryAdvanceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salaryAdvance = _data["salaryAdvance"] ? SalaryAdvanceDto.fromJS(_data["salaryAdvance"]) : <any>undefined;
            this.advanceTypeType = _data["advanceTypeType"];
            this.payGradeName = _data["payGradeName"];
            this.payComponentName = _data["payComponentName"];
        }
    }

    static fromJS(data: any): GetSalaryAdvanceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalaryAdvanceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salaryAdvance"] = this.salaryAdvance ? this.salaryAdvance.toJSON() : <any>undefined;
        data["advanceTypeType"] = this.advanceTypeType;
        data["payGradeName"] = this.payGradeName;
        data["payComponentName"] = this.payComponentName;
        return data;
    }
}

export interface IGetSalaryAdvanceForViewDto {
    salaryAdvance: SalaryAdvanceDto;
    advanceTypeType: string | undefined;
    payGradeName: string | undefined;
    payComponentName: string | undefined;
}

export class PagedResultDtoOfGetSalaryAdvanceForViewDto implements IPagedResultDtoOfGetSalaryAdvanceForViewDto {
    totalCount!: number;
    items!: GetSalaryAdvanceForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSalaryAdvanceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSalaryAdvanceForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSalaryAdvanceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSalaryAdvanceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSalaryAdvanceForViewDto {
    totalCount: number;
    items: GetSalaryAdvanceForViewDto[] | undefined;
}

export class CreateOrEditSalaryAdvanceDto implements ICreateOrEditSalaryAdvanceDto {
    policyName!: string | undefined;
    advanceEligibility!: number;
    maximumNoOfEMI!: number;
    rateOfIntrest!: number;
    allowException!: boolean;
    payComponentId!: number;
    advanceTypeId!: number;
    payGradeId!: number;
    percentage!: number | undefined;
    allowDocument!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSalaryAdvanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.policyName = _data["policyName"];
            this.advanceEligibility = _data["advanceEligibility"];
            this.maximumNoOfEMI = _data["maximumNoOfEMI"];
            this.rateOfIntrest = _data["rateOfIntrest"];
            this.allowException = _data["allowException"];
            this.payComponentId = _data["payComponentId"];
            this.advanceTypeId = _data["advanceTypeId"];
            this.payGradeId = _data["payGradeId"];
            this.percentage = _data["percentage"];
            this.allowDocument = _data["allowDocument"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSalaryAdvanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSalaryAdvanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyName"] = this.policyName;
        data["advanceEligibility"] = this.advanceEligibility;
        data["maximumNoOfEMI"] = this.maximumNoOfEMI;
        data["rateOfIntrest"] = this.rateOfIntrest;
        data["allowException"] = this.allowException;
        data["payComponentId"] = this.payComponentId;
        data["advanceTypeId"] = this.advanceTypeId;
        data["payGradeId"] = this.payGradeId;
        data["percentage"] = this.percentage;
        data["allowDocument"] = this.allowDocument;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSalaryAdvanceDto {
    policyName: string | undefined;
    advanceEligibility: number;
    maximumNoOfEMI: number;
    rateOfIntrest: number;
    allowException: boolean;
    payComponentId: number;
    advanceTypeId: number;
    payGradeId: number;
    percentage: number | undefined;
    allowDocument: boolean;
    id: number | undefined;
}

export class GetSalaryAdvanceForEditOutput implements IGetSalaryAdvanceForEditOutput {
    salaryAdvance!: CreateOrEditSalaryAdvanceDto;
    advanceTypeType!: string | undefined;
    payGradeName!: string | undefined;

    constructor(data?: IGetSalaryAdvanceForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salaryAdvance = _data["salaryAdvance"] ? CreateOrEditSalaryAdvanceDto.fromJS(_data["salaryAdvance"]) : <any>undefined;
            this.advanceTypeType = _data["advanceTypeType"];
            this.payGradeName = _data["payGradeName"];
        }
    }

    static fromJS(data: any): GetSalaryAdvanceForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalaryAdvanceForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salaryAdvance"] = this.salaryAdvance ? this.salaryAdvance.toJSON() : <any>undefined;
        data["advanceTypeType"] = this.advanceTypeType;
        data["payGradeName"] = this.payGradeName;
        return data;
    }
}

export interface IGetSalaryAdvanceForEditOutput {
    salaryAdvance: CreateOrEditSalaryAdvanceDto;
    advanceTypeType: string | undefined;
    payGradeName: string | undefined;
}

export class SalaryAdvanceAdvanceTypeLookupTableDto implements ISalaryAdvanceAdvanceTypeLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISalaryAdvanceAdvanceTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SalaryAdvanceAdvanceTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalaryAdvanceAdvanceTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISalaryAdvanceAdvanceTypeLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SalaryAdvancePayGradeLookupTableDto implements ISalaryAdvancePayGradeLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISalaryAdvancePayGradeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SalaryAdvancePayGradeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalaryAdvancePayGradeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISalaryAdvancePayGradeLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SalaryDetialsDto implements ISalaryDetialsDto {
    monthyear!: string | undefined;
    employeeid!: number | undefined;
    paycomponent!: number | undefined;
    standard!: number | undefined;
    actual!: number | undefined;
    salaryId!: number;
    id!: number;

    constructor(data?: ISalaryDetialsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthyear = _data["monthyear"];
            this.employeeid = _data["employeeid"];
            this.paycomponent = _data["paycomponent"];
            this.standard = _data["standard"];
            this.actual = _data["actual"];
            this.salaryId = _data["salaryId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SalaryDetialsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalaryDetialsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthyear"] = this.monthyear;
        data["employeeid"] = this.employeeid;
        data["paycomponent"] = this.paycomponent;
        data["standard"] = this.standard;
        data["actual"] = this.actual;
        data["salaryId"] = this.salaryId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISalaryDetialsDto {
    monthyear: string | undefined;
    employeeid: number | undefined;
    paycomponent: number | undefined;
    standard: number | undefined;
    actual: number | undefined;
    salaryId: number;
    id: number;
}

export class GetSalaryDetialsForViewDto implements IGetSalaryDetialsForViewDto {
    salaryDetials!: SalaryDetialsDto;

    constructor(data?: IGetSalaryDetialsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salaryDetials = _data["salaryDetials"] ? SalaryDetialsDto.fromJS(_data["salaryDetials"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSalaryDetialsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalaryDetialsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salaryDetials"] = this.salaryDetials ? this.salaryDetials.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSalaryDetialsForViewDto {
    salaryDetials: SalaryDetialsDto;
}

export class PagedResultDtoOfGetSalaryDetialsForViewDto implements IPagedResultDtoOfGetSalaryDetialsForViewDto {
    totalCount!: number;
    items!: GetSalaryDetialsForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSalaryDetialsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSalaryDetialsForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSalaryDetialsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSalaryDetialsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSalaryDetialsForViewDto {
    totalCount: number;
    items: GetSalaryDetialsForViewDto[] | undefined;
}

export class CreateOrEditSalaryDetialsDto implements ICreateOrEditSalaryDetialsDto {
    monthyear!: number | undefined;
    employeeid!: number | undefined;
    paycomponent!: number | undefined;
    standard!: number | undefined;
    actual!: number | undefined;
    salaryId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSalaryDetialsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthyear = _data["monthyear"];
            this.employeeid = _data["employeeid"];
            this.paycomponent = _data["paycomponent"];
            this.standard = _data["standard"];
            this.actual = _data["actual"];
            this.salaryId = _data["salaryId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSalaryDetialsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSalaryDetialsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthyear"] = this.monthyear;
        data["employeeid"] = this.employeeid;
        data["paycomponent"] = this.paycomponent;
        data["standard"] = this.standard;
        data["actual"] = this.actual;
        data["salaryId"] = this.salaryId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSalaryDetialsDto {
    monthyear: number | undefined;
    employeeid: number | undefined;
    paycomponent: number | undefined;
    standard: number | undefined;
    actual: number | undefined;
    salaryId: number;
    id: number | undefined;
}

export class GetSalaryDetialsForEditOutput implements IGetSalaryDetialsForEditOutput {
    salaryDetials!: CreateOrEditSalaryDetialsDto;

    constructor(data?: IGetSalaryDetialsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salaryDetials = _data["salaryDetials"] ? CreateOrEditSalaryDetialsDto.fromJS(_data["salaryDetials"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSalaryDetialsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalaryDetialsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salaryDetials"] = this.salaryDetials ? this.salaryDetials.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSalaryDetialsForEditOutput {
    salaryDetials: CreateOrEditSalaryDetialsDto;
}

export class GetAllSeparationRequestInput implements IGetAllSeparationRequestInput {
    employeeId!: number;
    nameFilter!: string | undefined;
    requestType!: string | undefined;

    constructor(data?: IGetAllSeparationRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.nameFilter = _data["nameFilter"];
            this.requestType = _data["requestType"];
        }
    }

    static fromJS(data: any): GetAllSeparationRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSeparationRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["nameFilter"] = this.nameFilter;
        data["requestType"] = this.requestType;
        return data;
    }
}

export interface IGetAllSeparationRequestInput {
    employeeId: number;
    nameFilter: string | undefined;
    requestType: string | undefined;
}

export class GetSeparationRequestForViewDto implements IGetSeparationRequestForViewDto {
    employeeId!: number;
    employeeName!: string | undefined;
    employeeCode!: string | undefined;
    requestType!: string | undefined;
    noticeperiod!: string | undefined;
    lastworkingDay!: string | undefined;
    proposedlastworkingday!: string | undefined;
    clearanceCompleted!: boolean;
    exitInterview!: boolean;
    fandfCompleted!: boolean;
    acceptance!: boolean;
    isRejected!: boolean;
    isFnfInitiated!: boolean;
    id!: number;

    constructor(data?: IGetSeparationRequestForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.employeeCode = _data["employeeCode"];
            this.requestType = _data["requestType"];
            this.noticeperiod = _data["noticeperiod"];
            this.lastworkingDay = _data["lastworkingDay"];
            this.proposedlastworkingday = _data["proposedlastworkingday"];
            this.clearanceCompleted = _data["clearanceCompleted"];
            this.exitInterview = _data["exitInterview"];
            this.fandfCompleted = _data["fandfCompleted"];
            this.acceptance = _data["acceptance"];
            this.isRejected = _data["isRejected"];
            this.isFnfInitiated = _data["isFnfInitiated"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetSeparationRequestForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSeparationRequestForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["employeeCode"] = this.employeeCode;
        data["requestType"] = this.requestType;
        data["noticeperiod"] = this.noticeperiod;
        data["lastworkingDay"] = this.lastworkingDay;
        data["proposedlastworkingday"] = this.proposedlastworkingday;
        data["clearanceCompleted"] = this.clearanceCompleted;
        data["exitInterview"] = this.exitInterview;
        data["fandfCompleted"] = this.fandfCompleted;
        data["acceptance"] = this.acceptance;
        data["isRejected"] = this.isRejected;
        data["isFnfInitiated"] = this.isFnfInitiated;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetSeparationRequestForViewDto {
    employeeId: number;
    employeeName: string | undefined;
    employeeCode: string | undefined;
    requestType: string | undefined;
    noticeperiod: string | undefined;
    lastworkingDay: string | undefined;
    proposedlastworkingday: string | undefined;
    clearanceCompleted: boolean;
    exitInterview: boolean;
    fandfCompleted: boolean;
    acceptance: boolean;
    isRejected: boolean;
    isFnfInitiated: boolean;
    id: number;
}

export class PagedResultDtoOfGetSeparationRequestForViewDto implements IPagedResultDtoOfGetSeparationRequestForViewDto {
    totalCount!: number;
    items!: GetSeparationRequestForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSeparationRequestForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSeparationRequestForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSeparationRequestForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSeparationRequestForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSeparationRequestForViewDto {
    totalCount: number;
    items: GetSeparationRequestForViewDto[] | undefined;
}

export class CreateOrEditExitNoticeLog implements ICreateOrEditExitNoticeLog {
    leaveType!: string | undefined;
    leaveTypeId!: number;
    leaveBalance!: number;
    noticePeriodExtention!: number | undefined;
    avaiability!: boolean;
    isAvaiability!: number;

    constructor(data?: ICreateOrEditExitNoticeLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveType = _data["leaveType"];
            this.leaveTypeId = _data["leaveTypeId"];
            this.leaveBalance = _data["leaveBalance"];
            this.noticePeriodExtention = _data["noticePeriodExtention"];
            this.avaiability = _data["avaiability"];
            this.isAvaiability = _data["isAvaiability"];
        }
    }

    static fromJS(data: any): CreateOrEditExitNoticeLog {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditExitNoticeLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveType"] = this.leaveType;
        data["leaveTypeId"] = this.leaveTypeId;
        data["leaveBalance"] = this.leaveBalance;
        data["noticePeriodExtention"] = this.noticePeriodExtention;
        data["avaiability"] = this.avaiability;
        data["isAvaiability"] = this.isAvaiability;
        return data;
    }
}

export interface ICreateOrEditExitNoticeLog {
    leaveType: string | undefined;
    leaveTypeId: number;
    leaveBalance: number;
    noticePeriodExtention: number | undefined;
    avaiability: boolean;
    isAvaiability: number;
}

export class CreateOrEditSeparationRequestDto implements ICreateOrEditSeparationRequestDto {
    sepId!: number | undefined;
    employeeid!: number;
    requestType!: number;
    reportingManager!: boolean | undefined;
    noticeperiod!: number;
    lastworkingDay!: moment.Moment;
    proposedlastworkingday!: moment.Moment | undefined;
    remarks!: string | undefined;
    requestedon!: moment.Moment;
    createdon!: moment.Moment;
    createdby!: number;
    updateedon!: moment.Moment | undefined;
    updatedby!: number;
    status!: string | undefined;
    clearanceCompletedon!: moment.Moment | undefined;
    exitInterview!: moment.Moment | undefined;
    fandfCompletedon!: moment.Moment | undefined;
    acceptedon!: moment.Moment | undefined;
    reasonId!: number;
    exitNoticeValue!: CreateOrEditExitNoticeLog[] | undefined;
    requestForApprovalLogId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSeparationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sepId = _data["sepId"];
            this.employeeid = _data["employeeid"];
            this.requestType = _data["requestType"];
            this.reportingManager = _data["reportingManager"];
            this.noticeperiod = _data["noticeperiod"];
            this.lastworkingDay = _data["lastworkingDay"] ? moment(_data["lastworkingDay"].toString()) : <any>undefined;
            this.proposedlastworkingday = _data["proposedlastworkingday"] ? moment(_data["proposedlastworkingday"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
            this.requestedon = _data["requestedon"] ? moment(_data["requestedon"].toString()) : <any>undefined;
            this.createdon = _data["createdon"] ? moment(_data["createdon"].toString()) : <any>undefined;
            this.createdby = _data["createdby"];
            this.updateedon = _data["updateedon"] ? moment(_data["updateedon"].toString()) : <any>undefined;
            this.updatedby = _data["updatedby"];
            this.status = _data["status"];
            this.clearanceCompletedon = _data["clearanceCompletedon"] ? moment(_data["clearanceCompletedon"].toString()) : <any>undefined;
            this.exitInterview = _data["exitInterview"] ? moment(_data["exitInterview"].toString()) : <any>undefined;
            this.fandfCompletedon = _data["fandfCompletedon"] ? moment(_data["fandfCompletedon"].toString()) : <any>undefined;
            this.acceptedon = _data["acceptedon"] ? moment(_data["acceptedon"].toString()) : <any>undefined;
            this.reasonId = _data["reasonId"];
            if (Array.isArray(_data["exitNoticeValue"])) {
                this.exitNoticeValue = [] as any;
                for (let item of _data["exitNoticeValue"])
                    this.exitNoticeValue!.push(CreateOrEditExitNoticeLog.fromJS(item));
            }
            this.requestForApprovalLogId = _data["requestForApprovalLogId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSeparationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSeparationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sepId"] = this.sepId;
        data["employeeid"] = this.employeeid;
        data["requestType"] = this.requestType;
        data["reportingManager"] = this.reportingManager;
        data["noticeperiod"] = this.noticeperiod;
        data["lastworkingDay"] = this.lastworkingDay ? this.lastworkingDay.toISOString() : <any>undefined;
        data["proposedlastworkingday"] = this.proposedlastworkingday ? this.proposedlastworkingday.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["requestedon"] = this.requestedon ? this.requestedon.toISOString() : <any>undefined;
        data["createdon"] = this.createdon ? this.createdon.toISOString() : <any>undefined;
        data["createdby"] = this.createdby;
        data["updateedon"] = this.updateedon ? this.updateedon.toISOString() : <any>undefined;
        data["updatedby"] = this.updatedby;
        data["status"] = this.status;
        data["clearanceCompletedon"] = this.clearanceCompletedon ? this.clearanceCompletedon.toISOString() : <any>undefined;
        data["exitInterview"] = this.exitInterview ? this.exitInterview.toISOString() : <any>undefined;
        data["fandfCompletedon"] = this.fandfCompletedon ? this.fandfCompletedon.toISOString() : <any>undefined;
        data["acceptedon"] = this.acceptedon ? this.acceptedon.toISOString() : <any>undefined;
        data["reasonId"] = this.reasonId;
        if (Array.isArray(this.exitNoticeValue)) {
            data["exitNoticeValue"] = [];
            for (let item of this.exitNoticeValue)
                data["exitNoticeValue"].push(item.toJSON());
        }
        data["requestForApprovalLogId"] = this.requestForApprovalLogId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSeparationRequestDto {
    sepId: number | undefined;
    employeeid: number;
    requestType: number;
    reportingManager: boolean | undefined;
    noticeperiod: number;
    lastworkingDay: moment.Moment;
    proposedlastworkingday: moment.Moment | undefined;
    remarks: string | undefined;
    requestedon: moment.Moment;
    createdon: moment.Moment;
    createdby: number;
    updateedon: moment.Moment | undefined;
    updatedby: number;
    status: string | undefined;
    clearanceCompletedon: moment.Moment | undefined;
    exitInterview: moment.Moment | undefined;
    fandfCompletedon: moment.Moment | undefined;
    acceptedon: moment.Moment | undefined;
    reasonId: number;
    exitNoticeValue: CreateOrEditExitNoticeLog[] | undefined;
    requestForApprovalLogId: number | undefined;
    id: number | undefined;
}

export class GetSeparationRequestForEdit implements IGetSeparationRequestForEdit {
    separatereq!: CreateOrEditSeparationRequestDto;

    constructor(data?: IGetSeparationRequestForEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.separatereq = _data["separatereq"] ? CreateOrEditSeparationRequestDto.fromJS(_data["separatereq"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSeparationRequestForEdit {
        data = typeof data === 'object' ? data : {};
        let result = new GetSeparationRequestForEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["separatereq"] = this.separatereq ? this.separatereq.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSeparationRequestForEdit {
    separatereq: CreateOrEditSeparationRequestDto;
}

export class SeparationRequestDto implements ISeparationRequestDto {
    employeeName!: string | undefined;
    employeeCode!: string | undefined;
    requestType!: string | undefined;
    noticeperiod!: string | undefined;
    lastworkingDay!: string | undefined;
    proposedlastworkingday!: string | undefined;
    requestedOn!: string | undefined;
    clearanceCompleted!: string | undefined;
    exitInterview!: string | undefined;
    fandfCompleted!: string | undefined;
    acceptance!: string | undefined;
    remarks!: string | undefined;
    reason!: string | undefined;
    id!: number;

    constructor(data?: ISeparationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeName = _data["employeeName"];
            this.employeeCode = _data["employeeCode"];
            this.requestType = _data["requestType"];
            this.noticeperiod = _data["noticeperiod"];
            this.lastworkingDay = _data["lastworkingDay"];
            this.proposedlastworkingday = _data["proposedlastworkingday"];
            this.requestedOn = _data["requestedOn"];
            this.clearanceCompleted = _data["clearanceCompleted"];
            this.exitInterview = _data["exitInterview"];
            this.fandfCompleted = _data["fandfCompleted"];
            this.acceptance = _data["acceptance"];
            this.remarks = _data["remarks"];
            this.reason = _data["reason"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SeparationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeparationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeName"] = this.employeeName;
        data["employeeCode"] = this.employeeCode;
        data["requestType"] = this.requestType;
        data["noticeperiod"] = this.noticeperiod;
        data["lastworkingDay"] = this.lastworkingDay;
        data["proposedlastworkingday"] = this.proposedlastworkingday;
        data["requestedOn"] = this.requestedOn;
        data["clearanceCompleted"] = this.clearanceCompleted;
        data["exitInterview"] = this.exitInterview;
        data["fandfCompleted"] = this.fandfCompleted;
        data["acceptance"] = this.acceptance;
        data["remarks"] = this.remarks;
        data["reason"] = this.reason;
        data["id"] = this.id;
        return data;
    }
}

export interface ISeparationRequestDto {
    employeeName: string | undefined;
    employeeCode: string | undefined;
    requestType: string | undefined;
    noticeperiod: string | undefined;
    lastworkingDay: string | undefined;
    proposedlastworkingday: string | undefined;
    requestedOn: string | undefined;
    clearanceCompleted: string | undefined;
    exitInterview: string | undefined;
    fandfCompleted: string | undefined;
    acceptance: string | undefined;
    remarks: string | undefined;
    reason: string | undefined;
    id: number;
}

export class GetSeparationForView implements IGetSeparationForView {
    separationRequest!: SeparationRequestDto;

    constructor(data?: IGetSeparationForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.separationRequest = _data["separationRequest"] ? SeparationRequestDto.fromJS(_data["separationRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSeparationForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetSeparationForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["separationRequest"] = this.separationRequest ? this.separationRequest.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSeparationForView {
    separationRequest: SeparationRequestDto;
}

export class GetAllLeaveTypForSeparationDto implements IGetAllLeaveTypForSeparationDto {
    leaveType!: string | undefined;
    leaveTypeId!: number;
    leaveBalance!: number;
    avaiability!: boolean;
    noticePeriodExtention!: number;
    disableapproval!: boolean;
    isAvaiability!: number;

    constructor(data?: IGetAllLeaveTypForSeparationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveType = _data["leaveType"];
            this.leaveTypeId = _data["leaveTypeId"];
            this.leaveBalance = _data["leaveBalance"];
            this.avaiability = _data["avaiability"];
            this.noticePeriodExtention = _data["noticePeriodExtention"];
            this.disableapproval = _data["disableapproval"];
            this.isAvaiability = _data["isAvaiability"];
        }
    }

    static fromJS(data: any): GetAllLeaveTypForSeparationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllLeaveTypForSeparationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveType"] = this.leaveType;
        data["leaveTypeId"] = this.leaveTypeId;
        data["leaveBalance"] = this.leaveBalance;
        data["avaiability"] = this.avaiability;
        data["noticePeriodExtention"] = this.noticePeriodExtention;
        data["disableapproval"] = this.disableapproval;
        data["isAvaiability"] = this.isAvaiability;
        return data;
    }
}

export interface IGetAllLeaveTypForSeparationDto {
    leaveType: string | undefined;
    leaveTypeId: number;
    leaveBalance: number;
    avaiability: boolean;
    noticePeriodExtention: number;
    disableapproval: boolean;
    isAvaiability: number;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    id!: number;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.profilePictureId = _data["profilePictureId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    id: number;
}

export class EditionInfoDto implements IEditionInfoDto {
    displayName!: string | undefined;
    trialDayCount!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    isHighestEdition!: boolean;
    isFree!: boolean;
    id!: number;

    constructor(data?: IEditionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.trialDayCount = _data["trialDayCount"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.isHighestEdition = _data["isHighestEdition"];
            this.isFree = _data["isFree"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EditionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["trialDayCount"] = this.trialDayCount;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["isHighestEdition"] = this.isHighestEdition;
        data["isFree"] = this.isFree;
        data["id"] = this.id;
        return data;
    }
}

export interface IEditionInfoDto {
    displayName: string | undefined;
    trialDayCount: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    isHighestEdition: boolean;
    isFree: boolean;
    id: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName!: string | undefined;
    countryCode!: string | undefined;
    name!: string | undefined;
    logoId!: string | undefined;
    logoFileType!: string | undefined;
    customCssId!: string | undefined;
    subscriptionEndDateUtc!: moment.Moment | undefined;
    isInTrialPeriod!: boolean;
    subscriptionPaymentType!: SubscriptionPaymentType;
    edition!: EditionInfoDto;
    creationTime!: moment.Moment;
    paymentPeriodType!: PaymentPeriodType;
    subscriptionDateString!: string | undefined;
    creationTimeString!: string | undefined;
    id!: number;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.countryCode = _data["countryCode"];
            this.name = _data["name"];
            this.logoId = _data["logoId"];
            this.logoFileType = _data["logoFileType"];
            this.customCssId = _data["customCssId"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? moment(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.subscriptionPaymentType = _data["subscriptionPaymentType"];
            this.edition = _data["edition"] ? EditionInfoDto.fromJS(_data["edition"]) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.subscriptionDateString = _data["subscriptionDateString"];
            this.creationTimeString = _data["creationTimeString"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["countryCode"] = this.countryCode;
        data["name"] = this.name;
        data["logoId"] = this.logoId;
        data["logoFileType"] = this.logoFileType;
        data["customCssId"] = this.customCssId;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["subscriptionPaymentType"] = this.subscriptionPaymentType;
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionDateString"] = this.subscriptionDateString;
        data["creationTimeString"] = this.creationTimeString;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantLoginInfoDto {
    tenancyName: string | undefined;
    countryCode: string | undefined;
    name: string | undefined;
    logoId: string | undefined;
    logoFileType: string | undefined;
    customCssId: string | undefined;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    subscriptionPaymentType: SubscriptionPaymentType;
    edition: EditionInfoDto;
    creationTime: moment.Moment;
    paymentPeriodType: PaymentPeriodType;
    subscriptionDateString: string | undefined;
    creationTimeString: string | undefined;
    id: number;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version!: string | undefined;
    releaseDate!: moment.Moment;
    currency!: string | undefined;
    currencySign!: string | undefined;
    allowTenantsToChangeEmailSettings!: boolean;
    features!: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : <any>undefined;
            this.currency = _data["currency"];
            this.currencySign = _data["currencySign"];
            this.allowTenantsToChangeEmailSettings = _data["allowTenantsToChangeEmailSettings"];
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)![key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        data["currency"] = this.currency;
        data["currencySign"] = this.currencySign;
        data["allowTenantsToChangeEmailSettings"] = this.allowTenantsToChangeEmailSettings;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = (<any>this.features)[key];
            }
        }
        return data;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    currency: string | undefined;
    currencySign: string | undefined;
    allowTenantsToChangeEmailSettings: boolean;
    features: { [key: string]: boolean; } | undefined;
}

export class ThemeLayoutSettingsDto implements IThemeLayoutSettingsDto {
    layoutType!: string | undefined;

    constructor(data?: IThemeLayoutSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.layoutType = _data["layoutType"];
        }
    }

    static fromJS(data: any): ThemeLayoutSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeLayoutSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layoutType"] = this.layoutType;
        return data;
    }
}

export interface IThemeLayoutSettingsDto {
    layoutType: string | undefined;
}

export class ThemeHeaderSettingsDto implements IThemeHeaderSettingsDto {
    desktopFixedHeader!: boolean;
    mobileFixedHeader!: boolean;
    headerSkin!: string | undefined;
    minimizeDesktopHeaderType!: string | undefined;
    headerMenuArrows!: boolean;

    constructor(data?: IThemeHeaderSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.desktopFixedHeader = _data["desktopFixedHeader"];
            this.mobileFixedHeader = _data["mobileFixedHeader"];
            this.headerSkin = _data["headerSkin"];
            this.minimizeDesktopHeaderType = _data["minimizeDesktopHeaderType"];
            this.headerMenuArrows = _data["headerMenuArrows"];
        }
    }

    static fromJS(data: any): ThemeHeaderSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeHeaderSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desktopFixedHeader"] = this.desktopFixedHeader;
        data["mobileFixedHeader"] = this.mobileFixedHeader;
        data["headerSkin"] = this.headerSkin;
        data["minimizeDesktopHeaderType"] = this.minimizeDesktopHeaderType;
        data["headerMenuArrows"] = this.headerMenuArrows;
        return data;
    }
}

export interface IThemeHeaderSettingsDto {
    desktopFixedHeader: boolean;
    mobileFixedHeader: boolean;
    headerSkin: string | undefined;
    minimizeDesktopHeaderType: string | undefined;
    headerMenuArrows: boolean;
}

export class ThemeSubHeaderSettingsDto implements IThemeSubHeaderSettingsDto {
    fixedSubHeader!: boolean;
    subheaderStyle!: string | undefined;

    constructor(data?: IThemeSubHeaderSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fixedSubHeader = _data["fixedSubHeader"];
            this.subheaderStyle = _data["subheaderStyle"];
        }
    }

    static fromJS(data: any): ThemeSubHeaderSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeSubHeaderSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedSubHeader"] = this.fixedSubHeader;
        data["subheaderStyle"] = this.subheaderStyle;
        return data;
    }
}

export interface IThemeSubHeaderSettingsDto {
    fixedSubHeader: boolean;
    subheaderStyle: string | undefined;
}

export class ThemeMenuSettingsDto implements IThemeMenuSettingsDto {
    position!: string | undefined;
    asideSkin!: string | undefined;
    fixedAside!: boolean;
    allowAsideMinimizing!: boolean;
    defaultMinimizedAside!: boolean;
    submenuToggle!: string | undefined;

    constructor(data?: IThemeMenuSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.position = _data["position"];
            this.asideSkin = _data["asideSkin"];
            this.fixedAside = _data["fixedAside"];
            this.allowAsideMinimizing = _data["allowAsideMinimizing"];
            this.defaultMinimizedAside = _data["defaultMinimizedAside"];
            this.submenuToggle = _data["submenuToggle"];
        }
    }

    static fromJS(data: any): ThemeMenuSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeMenuSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["asideSkin"] = this.asideSkin;
        data["fixedAside"] = this.fixedAside;
        data["allowAsideMinimizing"] = this.allowAsideMinimizing;
        data["defaultMinimizedAside"] = this.defaultMinimizedAside;
        data["submenuToggle"] = this.submenuToggle;
        return data;
    }
}

export interface IThemeMenuSettingsDto {
    position: string | undefined;
    asideSkin: string | undefined;
    fixedAside: boolean;
    allowAsideMinimizing: boolean;
    defaultMinimizedAside: boolean;
    submenuToggle: string | undefined;
}

export class ThemeFooterSettingsDto implements IThemeFooterSettingsDto {
    fixedFooter!: boolean;

    constructor(data?: IThemeFooterSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fixedFooter = _data["fixedFooter"];
        }
    }

    static fromJS(data: any): ThemeFooterSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeFooterSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedFooter"] = this.fixedFooter;
        return data;
    }
}

export interface IThemeFooterSettingsDto {
    fixedFooter: boolean;
}

export class ThemeSettingsDto implements IThemeSettingsDto {
    theme!: string | undefined;
    layout!: ThemeLayoutSettingsDto;
    header!: ThemeHeaderSettingsDto;
    subHeader!: ThemeSubHeaderSettingsDto;
    menu!: ThemeMenuSettingsDto;
    footer!: ThemeFooterSettingsDto;

    constructor(data?: IThemeSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
            this.layout = _data["layout"] ? ThemeLayoutSettingsDto.fromJS(_data["layout"]) : <any>undefined;
            this.header = _data["header"] ? ThemeHeaderSettingsDto.fromJS(_data["header"]) : <any>undefined;
            this.subHeader = _data["subHeader"] ? ThemeSubHeaderSettingsDto.fromJS(_data["subHeader"]) : <any>undefined;
            this.menu = _data["menu"] ? ThemeMenuSettingsDto.fromJS(_data["menu"]) : <any>undefined;
            this.footer = _data["footer"] ? ThemeFooterSettingsDto.fromJS(_data["footer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ThemeSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        data["layout"] = this.layout ? this.layout.toJSON() : <any>undefined;
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        data["subHeader"] = this.subHeader ? this.subHeader.toJSON() : <any>undefined;
        data["menu"] = this.menu ? this.menu.toJSON() : <any>undefined;
        data["footer"] = this.footer ? this.footer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IThemeSettingsDto {
    theme: string | undefined;
    layout: ThemeLayoutSettingsDto;
    header: ThemeHeaderSettingsDto;
    subHeader: ThemeSubHeaderSettingsDto;
    menu: ThemeMenuSettingsDto;
    footer: ThemeFooterSettingsDto;
}

export class UiCustomizationSettingsDto implements IUiCustomizationSettingsDto {
    baseSettings!: ThemeSettingsDto;
    isLeftMenuUsed!: boolean;
    isTopMenuUsed!: boolean;
    isTabMenuUsed!: boolean;
    allowMenuScroll!: boolean;

    constructor(data?: IUiCustomizationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseSettings = _data["baseSettings"] ? ThemeSettingsDto.fromJS(_data["baseSettings"]) : <any>undefined;
            this.isLeftMenuUsed = _data["isLeftMenuUsed"];
            this.isTopMenuUsed = _data["isTopMenuUsed"];
            this.isTabMenuUsed = _data["isTabMenuUsed"];
            this.allowMenuScroll = _data["allowMenuScroll"];
        }
    }

    static fromJS(data: any): UiCustomizationSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UiCustomizationSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseSettings"] = this.baseSettings ? this.baseSettings.toJSON() : <any>undefined;
        data["isLeftMenuUsed"] = this.isLeftMenuUsed;
        data["isTopMenuUsed"] = this.isTopMenuUsed;
        data["isTabMenuUsed"] = this.isTabMenuUsed;
        data["allowMenuScroll"] = this.allowMenuScroll;
        return data;
    }
}

export interface IUiCustomizationSettingsDto {
    baseSettings: ThemeSettingsDto;
    isLeftMenuUsed: boolean;
    isTopMenuUsed: boolean;
    isTabMenuUsed: boolean;
    allowMenuScroll: boolean;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    user!: UserLoginInfoDto;
    tenant!: TenantLoginInfoDto;
    application!: ApplicationInfoDto;
    theme!: UiCustomizationSettingsDto;
    employeeID!: number | undefined;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.theme = _data["theme"] ? UiCustomizationSettingsDto.fromJS(_data["theme"]) : <any>undefined;
            this.employeeID = _data["employeeID"];
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["theme"] = this.theme ? this.theme.toJSON() : <any>undefined;
        data["employeeID"] = this.employeeID;
        return data;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    application: ApplicationInfoDto;
    theme: UiCustomizationSettingsDto;
    employeeID: number | undefined;
}

export class UpdateUserSignInTokenOutput implements IUpdateUserSignInTokenOutput {
    signInToken!: string | undefined;
    encodedUserId!: string | undefined;
    encodedTenantId!: string | undefined;

    constructor(data?: IUpdateUserSignInTokenOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signInToken = _data["signInToken"];
            this.encodedUserId = _data["encodedUserId"];
            this.encodedTenantId = _data["encodedTenantId"];
        }
    }

    static fromJS(data: any): UpdateUserSignInTokenOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserSignInTokenOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signInToken"] = this.signInToken;
        data["encodedUserId"] = this.encodedUserId;
        data["encodedTenantId"] = this.encodedTenantId;
        return data;
    }
}

export interface IUpdateUserSignInTokenOutput {
    signInToken: string | undefined;
    encodedUserId: string | undefined;
    encodedTenantId: string | undefined;
}

export class ShiftDetailsDto implements IShiftDetailsDto {
    weekOfMonth!: number | undefined;
    dayofWeek!: number | undefined;
    shiftId!: number | undefined;
    id!: number;

    constructor(data?: IShiftDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weekOfMonth = _data["weekOfMonth"];
            this.dayofWeek = _data["dayofWeek"];
            this.shiftId = _data["shiftId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShiftDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weekOfMonth"] = this.weekOfMonth;
        data["dayofWeek"] = this.dayofWeek;
        data["shiftId"] = this.shiftId;
        data["id"] = this.id;
        return data;
    }
}

export interface IShiftDetailsDto {
    weekOfMonth: number | undefined;
    dayofWeek: number | undefined;
    shiftId: number | undefined;
    id: number;
}

export class GetShiftDetailsForViewDto implements IGetShiftDetailsForViewDto {
    shiftDetails!: ShiftDetailsDto;
    shiftShiftName!: string | undefined;

    constructor(data?: IGetShiftDetailsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftDetails = _data["shiftDetails"] ? ShiftDetailsDto.fromJS(_data["shiftDetails"]) : <any>undefined;
            this.shiftShiftName = _data["shiftShiftName"];
        }
    }

    static fromJS(data: any): GetShiftDetailsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShiftDetailsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftDetails"] = this.shiftDetails ? this.shiftDetails.toJSON() : <any>undefined;
        data["shiftShiftName"] = this.shiftShiftName;
        return data;
    }
}

export interface IGetShiftDetailsForViewDto {
    shiftDetails: ShiftDetailsDto;
    shiftShiftName: string | undefined;
}

export class PagedResultDtoOfGetShiftDetailsForViewDto implements IPagedResultDtoOfGetShiftDetailsForViewDto {
    totalCount!: number;
    items!: GetShiftDetailsForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetShiftDetailsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetShiftDetailsForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetShiftDetailsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetShiftDetailsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetShiftDetailsForViewDto {
    totalCount: number;
    items: GetShiftDetailsForViewDto[] | undefined;
}

export class CreateOrEditShiftDetailsDto implements ICreateOrEditShiftDetailsDto {
    weekOfMonth!: number | undefined;
    dayofWeek!: number | undefined;
    shiftId!: number | undefined;
    dayValue!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditShiftDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weekOfMonth = _data["weekOfMonth"];
            this.dayofWeek = _data["dayofWeek"];
            this.shiftId = _data["shiftId"];
            this.dayValue = _data["dayValue"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditShiftDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditShiftDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weekOfMonth"] = this.weekOfMonth;
        data["dayofWeek"] = this.dayofWeek;
        data["shiftId"] = this.shiftId;
        data["dayValue"] = this.dayValue;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditShiftDetailsDto {
    weekOfMonth: number | undefined;
    dayofWeek: number | undefined;
    shiftId: number | undefined;
    dayValue: number | undefined;
    id: number | undefined;
}

export class GetShiftDetailsForEditOutput implements IGetShiftDetailsForEditOutput {
    shiftDetails!: CreateOrEditShiftDetailsDto;
    shiftShiftName!: string | undefined;

    constructor(data?: IGetShiftDetailsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftDetails = _data["shiftDetails"] ? CreateOrEditShiftDetailsDto.fromJS(_data["shiftDetails"]) : <any>undefined;
            this.shiftShiftName = _data["shiftShiftName"];
        }
    }

    static fromJS(data: any): GetShiftDetailsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetShiftDetailsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftDetails"] = this.shiftDetails ? this.shiftDetails.toJSON() : <any>undefined;
        data["shiftShiftName"] = this.shiftShiftName;
        return data;
    }
}

export interface IGetShiftDetailsForEditOutput {
    shiftDetails: CreateOrEditShiftDetailsDto;
    shiftShiftName: string | undefined;
}

export class ShiftDetailsShiftLookupTableDto implements IShiftDetailsShiftLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IShiftDetailsShiftLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): ShiftDetailsShiftLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftDetailsShiftLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IShiftDetailsShiftLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class GetShiftsForViewDto implements IGetShiftsForViewDto {
    shiftId!: number | undefined;
    shiftCode!: string | undefined;
    shiftName!: string | undefined;
    shiftStartTime!: string | undefined;
    shiftEndTime!: string | undefined;
    nightShift!: boolean | undefined;
    singlePunch!: boolean | undefined;
    autoPunch!: boolean | undefined;
    halfDayShift!: boolean | undefined;
    weekOffs!: boolean | undefined;
    shiftAllowance!: boolean | undefined;
    weekOff!: string | undefined;
    isPaidWeekOff!: boolean | undefined;
    showTimingsOnCalendar!: boolean | undefined;
    priorComingAllowed!: number | undefined;

    constructor(data?: IGetShiftsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftId = _data["shiftId"];
            this.shiftCode = _data["shiftCode"];
            this.shiftName = _data["shiftName"];
            this.shiftStartTime = _data["shiftStartTime"];
            this.shiftEndTime = _data["shiftEndTime"];
            this.nightShift = _data["nightShift"];
            this.singlePunch = _data["singlePunch"];
            this.autoPunch = _data["autoPunch"];
            this.halfDayShift = _data["halfDayShift"];
            this.weekOffs = _data["weekOffs"];
            this.shiftAllowance = _data["shiftAllowance"];
            this.weekOff = _data["weekOff"];
            this.isPaidWeekOff = _data["isPaidWeekOff"];
            this.showTimingsOnCalendar = _data["showTimingsOnCalendar"];
            this.priorComingAllowed = _data["priorComingAllowed"];
        }
    }

    static fromJS(data: any): GetShiftsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShiftsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftId"] = this.shiftId;
        data["shiftCode"] = this.shiftCode;
        data["shiftName"] = this.shiftName;
        data["shiftStartTime"] = this.shiftStartTime;
        data["shiftEndTime"] = this.shiftEndTime;
        data["nightShift"] = this.nightShift;
        data["singlePunch"] = this.singlePunch;
        data["autoPunch"] = this.autoPunch;
        data["halfDayShift"] = this.halfDayShift;
        data["weekOffs"] = this.weekOffs;
        data["shiftAllowance"] = this.shiftAllowance;
        data["weekOff"] = this.weekOff;
        data["isPaidWeekOff"] = this.isPaidWeekOff;
        data["showTimingsOnCalendar"] = this.showTimingsOnCalendar;
        data["priorComingAllowed"] = this.priorComingAllowed;
        return data;
    }
}

export interface IGetShiftsForViewDto {
    shiftId: number | undefined;
    shiftCode: string | undefined;
    shiftName: string | undefined;
    shiftStartTime: string | undefined;
    shiftEndTime: string | undefined;
    nightShift: boolean | undefined;
    singlePunch: boolean | undefined;
    autoPunch: boolean | undefined;
    halfDayShift: boolean | undefined;
    weekOffs: boolean | undefined;
    shiftAllowance: boolean | undefined;
    weekOff: string | undefined;
    isPaidWeekOff: boolean | undefined;
    showTimingsOnCalendar: boolean | undefined;
    priorComingAllowed: number | undefined;
}

export class ShiftDto implements IShiftDto {
    shiftCode!: string | undefined;
    shiftName!: string | undefined;
    shiftStartTime!: string;
    shiftEndTime!: string;
    halfDayShift!: boolean;
    weekOffs!: boolean;
    minimumWorkingHoursForFullDays!: number;
    minimumWorkingHoursForHaffDays!: number;
    weekOff!: string | undefined;
    breakTime!: number | undefined;
    shiftHours!: number;
    empCount!: number;
    timeDiff!: number;
    showTimingsOnCalendar!: boolean;
    id!: number;

    constructor(data?: IShiftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftCode = _data["shiftCode"];
            this.shiftName = _data["shiftName"];
            this.shiftStartTime = _data["shiftStartTime"];
            this.shiftEndTime = _data["shiftEndTime"];
            this.halfDayShift = _data["halfDayShift"];
            this.weekOffs = _data["weekOffs"];
            this.minimumWorkingHoursForFullDays = _data["minimumWorkingHoursForFullDays"];
            this.minimumWorkingHoursForHaffDays = _data["minimumWorkingHoursForHaffDays"];
            this.weekOff = _data["weekOff"];
            this.breakTime = _data["breakTime"];
            this.shiftHours = _data["shiftHours"];
            this.empCount = _data["empCount"];
            this.timeDiff = _data["timeDiff"];
            this.showTimingsOnCalendar = _data["showTimingsOnCalendar"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShiftDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftCode"] = this.shiftCode;
        data["shiftName"] = this.shiftName;
        data["shiftStartTime"] = this.shiftStartTime;
        data["shiftEndTime"] = this.shiftEndTime;
        data["halfDayShift"] = this.halfDayShift;
        data["weekOffs"] = this.weekOffs;
        data["minimumWorkingHoursForFullDays"] = this.minimumWorkingHoursForFullDays;
        data["minimumWorkingHoursForHaffDays"] = this.minimumWorkingHoursForHaffDays;
        data["weekOff"] = this.weekOff;
        data["breakTime"] = this.breakTime;
        data["shiftHours"] = this.shiftHours;
        data["empCount"] = this.empCount;
        data["timeDiff"] = this.timeDiff;
        data["showTimingsOnCalendar"] = this.showTimingsOnCalendar;
        data["id"] = this.id;
        return data;
    }
}

export interface IShiftDto {
    shiftCode: string | undefined;
    shiftName: string | undefined;
    shiftStartTime: string;
    shiftEndTime: string;
    halfDayShift: boolean;
    weekOffs: boolean;
    minimumWorkingHoursForFullDays: number;
    minimumWorkingHoursForHaffDays: number;
    weekOff: string | undefined;
    breakTime: number | undefined;
    shiftHours: number;
    empCount: number;
    timeDiff: number;
    showTimingsOnCalendar: boolean;
    id: number;
}

export class GetShiftForViewDto implements IGetShiftForViewDto {
    shift!: ShiftDto;

    constructor(data?: IGetShiftForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shift = _data["shift"] ? ShiftDto.fromJS(_data["shift"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetShiftForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShiftForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shift"] = this.shift ? this.shift.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetShiftForViewDto {
    shift: ShiftDto;
}

export class PagedResultDtoOfGetShiftForViewDto implements IPagedResultDtoOfGetShiftForViewDto {
    totalCount!: number;
    items!: GetShiftForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetShiftForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetShiftForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetShiftForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetShiftForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetShiftForViewDto {
    totalCount: number;
    items: GetShiftForViewDto[] | undefined;
}

export enum WeekOfMonth {
    Week1 = 1,
    Week2 = 2,
    Week3 = 3,
    Week4 = 4,
    Week5 = 5,
}

export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
}

export class DayOfMonth implements IDayOfMonth {
    weekOfMonth!: WeekOfMonth;
    dayOfWeek!: DayOfWeek;
    dayValue!: number;

    constructor(data?: IDayOfMonth) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weekOfMonth = _data["weekOfMonth"];
            this.dayOfWeek = _data["dayOfWeek"];
            this.dayValue = _data["dayValue"];
        }
    }

    static fromJS(data: any): DayOfMonth {
        data = typeof data === 'object' ? data : {};
        let result = new DayOfMonth();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weekOfMonth"] = this.weekOfMonth;
        data["dayOfWeek"] = this.dayOfWeek;
        data["dayValue"] = this.dayValue;
        return data;
    }
}

export interface IDayOfMonth {
    weekOfMonth: WeekOfMonth;
    dayOfWeek: DayOfWeek;
    dayValue: number;
}

export class CreateOrEditShiftDto implements ICreateOrEditShiftDto {
    shiftCode!: string | undefined;
    shiftName!: string | undefined;
    shiftStartTime!: string | undefined;
    shiftHours!: number;
    shiftEndTime!: string | undefined;
    markHalfDayAfterTime!: string | undefined;
    weekOffs!: boolean;
    minimumWorkingHoursForFullDays!: number;
    minimumWorkingHoursForHaffDays!: number;
    weekOff!: string | undefined;
    showTimingsOnCalendar!: boolean;
    priorComingAllowed!: number | undefined;
    breakTime!: number | undefined;
    overtTimeApplicable!: boolean;
    weeklyOffs!: DayOfMonth[] | undefined;
    shiftDetails!: CreateOrEditShiftDetailsDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditShiftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftCode = _data["shiftCode"];
            this.shiftName = _data["shiftName"];
            this.shiftStartTime = _data["shiftStartTime"];
            this.shiftHours = _data["shiftHours"];
            this.shiftEndTime = _data["shiftEndTime"];
            this.markHalfDayAfterTime = _data["markHalfDayAfterTime"];
            this.weekOffs = _data["weekOffs"];
            this.minimumWorkingHoursForFullDays = _data["minimumWorkingHoursForFullDays"];
            this.minimumWorkingHoursForHaffDays = _data["minimumWorkingHoursForHaffDays"];
            this.weekOff = _data["weekOff"];
            this.showTimingsOnCalendar = _data["showTimingsOnCalendar"];
            this.priorComingAllowed = _data["priorComingAllowed"];
            this.breakTime = _data["breakTime"];
            this.overtTimeApplicable = _data["overtTimeApplicable"];
            if (Array.isArray(_data["weeklyOffs"])) {
                this.weeklyOffs = [] as any;
                for (let item of _data["weeklyOffs"])
                    this.weeklyOffs!.push(DayOfMonth.fromJS(item));
            }
            if (Array.isArray(_data["shiftDetails"])) {
                this.shiftDetails = [] as any;
                for (let item of _data["shiftDetails"])
                    this.shiftDetails!.push(CreateOrEditShiftDetailsDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditShiftDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditShiftDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftCode"] = this.shiftCode;
        data["shiftName"] = this.shiftName;
        data["shiftStartTime"] = this.shiftStartTime;
        data["shiftHours"] = this.shiftHours;
        data["shiftEndTime"] = this.shiftEndTime;
        data["markHalfDayAfterTime"] = this.markHalfDayAfterTime;
        data["weekOffs"] = this.weekOffs;
        data["minimumWorkingHoursForFullDays"] = this.minimumWorkingHoursForFullDays;
        data["minimumWorkingHoursForHaffDays"] = this.minimumWorkingHoursForHaffDays;
        data["weekOff"] = this.weekOff;
        data["showTimingsOnCalendar"] = this.showTimingsOnCalendar;
        data["priorComingAllowed"] = this.priorComingAllowed;
        data["breakTime"] = this.breakTime;
        data["overtTimeApplicable"] = this.overtTimeApplicable;
        if (Array.isArray(this.weeklyOffs)) {
            data["weeklyOffs"] = [];
            for (let item of this.weeklyOffs)
                data["weeklyOffs"].push(item.toJSON());
        }
        if (Array.isArray(this.shiftDetails)) {
            data["shiftDetails"] = [];
            for (let item of this.shiftDetails)
                data["shiftDetails"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditShiftDto {
    shiftCode: string | undefined;
    shiftName: string | undefined;
    shiftStartTime: string | undefined;
    shiftHours: number;
    shiftEndTime: string | undefined;
    markHalfDayAfterTime: string | undefined;
    weekOffs: boolean;
    minimumWorkingHoursForFullDays: number;
    minimumWorkingHoursForHaffDays: number;
    weekOff: string | undefined;
    showTimingsOnCalendar: boolean;
    priorComingAllowed: number | undefined;
    breakTime: number | undefined;
    overtTimeApplicable: boolean;
    weeklyOffs: DayOfMonth[] | undefined;
    shiftDetails: CreateOrEditShiftDetailsDto[] | undefined;
    id: number | undefined;
}

export class GetShiftForEditOutput implements IGetShiftForEditOutput {
    shift!: CreateOrEditShiftDto;

    constructor(data?: IGetShiftForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shift = _data["shift"] ? CreateOrEditShiftDto.fromJS(_data["shift"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetShiftForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetShiftForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shift"] = this.shift ? this.shift.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetShiftForEditOutput {
    shift: CreateOrEditShiftDto;
}

export class ShortLeaveTypesDto implements IShortLeaveTypesDto {
    shortLeaveTypeName!: string | undefined;
    tenantId!: number;
    id!: number;

    constructor(data?: IShortLeaveTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shortLeaveTypeName = _data["shortLeaveTypeName"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShortLeaveTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShortLeaveTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shortLeaveTypeName"] = this.shortLeaveTypeName;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface IShortLeaveTypesDto {
    shortLeaveTypeName: string | undefined;
    tenantId: number;
    id: number;
}

export class GetShortLeaveTypesForViewDto implements IGetShortLeaveTypesForViewDto {
    shortLeaveTypes!: ShortLeaveTypesDto;

    constructor(data?: IGetShortLeaveTypesForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shortLeaveTypes = _data["shortLeaveTypes"] ? ShortLeaveTypesDto.fromJS(_data["shortLeaveTypes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetShortLeaveTypesForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShortLeaveTypesForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shortLeaveTypes"] = this.shortLeaveTypes ? this.shortLeaveTypes.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetShortLeaveTypesForViewDto {
    shortLeaveTypes: ShortLeaveTypesDto;
}

export class PagedResultDtoOfGetShortLeaveTypesForViewDto implements IPagedResultDtoOfGetShortLeaveTypesForViewDto {
    totalCount!: number;
    items!: GetShortLeaveTypesForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetShortLeaveTypesForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetShortLeaveTypesForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetShortLeaveTypesForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetShortLeaveTypesForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetShortLeaveTypesForViewDto {
    totalCount: number;
    items: GetShortLeaveTypesForViewDto[] | undefined;
}

export class CreateOrEditShortLeaveTypesDto implements ICreateOrEditShortLeaveTypesDto {
    shortLeaveTypeName!: string | undefined;
    tenantId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditShortLeaveTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shortLeaveTypeName = _data["shortLeaveTypeName"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditShortLeaveTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditShortLeaveTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shortLeaveTypeName"] = this.shortLeaveTypeName;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditShortLeaveTypesDto {
    shortLeaveTypeName: string | undefined;
    tenantId: number;
    id: number | undefined;
}

export class GetShortLeaveTypesForEditOutput implements IGetShortLeaveTypesForEditOutput {
    shortLeaveTypes!: CreateOrEditShortLeaveTypesDto;

    constructor(data?: IGetShortLeaveTypesForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shortLeaveTypes = _data["shortLeaveTypes"] ? CreateOrEditShortLeaveTypesDto.fromJS(_data["shortLeaveTypes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetShortLeaveTypesForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetShortLeaveTypesForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shortLeaveTypes"] = this.shortLeaveTypes ? this.shortLeaveTypes.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetShortLeaveTypesForEditOutput {
    shortLeaveTypes: CreateOrEditShortLeaveTypesDto;
}

export class StateDto implements IStateDto {
    name!: string | undefined;
    countryId!: number | undefined;
    id!: number;

    constructor(data?: IStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.countryId = _data["countryId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StateDto {
        data = typeof data === 'object' ? data : {};
        let result = new StateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["countryId"] = this.countryId;
        data["id"] = this.id;
        return data;
    }
}

export interface IStateDto {
    name: string | undefined;
    countryId: number | undefined;
    id: number;
}

export class GetStateForViewDto implements IGetStateForViewDto {
    state!: StateDto;
    countryName!: string | undefined;

    constructor(data?: IGetStateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"] ? StateDto.fromJS(_data["state"]) : <any>undefined;
            this.countryName = _data["countryName"];
        }
    }

    static fromJS(data: any): GetStateForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetStateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state ? this.state.toJSON() : <any>undefined;
        data["countryName"] = this.countryName;
        return data;
    }
}

export interface IGetStateForViewDto {
    state: StateDto;
    countryName: string | undefined;
}

export class PagedResultDtoOfGetStateForViewDto implements IPagedResultDtoOfGetStateForViewDto {
    totalCount!: number;
    items!: GetStateForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetStateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetStateForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetStateForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetStateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetStateForViewDto {
    totalCount: number;
    items: GetStateForViewDto[] | undefined;
}

export class CreateOrEditStateDto implements ICreateOrEditStateDto {
    name!: string | undefined;
    countryId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.countryId = _data["countryId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["countryId"] = this.countryId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditStateDto {
    name: string | undefined;
    countryId: number | undefined;
    id: number | undefined;
}

export class GetStateForEditOutput implements IGetStateForEditOutput {
    state!: CreateOrEditStateDto;
    countryName!: string | undefined;

    constructor(data?: IGetStateForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"] ? CreateOrEditStateDto.fromJS(_data["state"]) : <any>undefined;
            this.countryName = _data["countryName"];
        }
    }

    static fromJS(data: any): GetStateForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetStateForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state ? this.state.toJSON() : <any>undefined;
        data["countryName"] = this.countryName;
        return data;
    }
}

export interface IGetStateForEditOutput {
    state: CreateOrEditStateDto;
    countryName: string | undefined;
}

export class StateCountryLookupTableDto implements IStateCountryLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IStateCountryLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): StateCountryLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new StateCountryLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IStateCountryLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfStateCountryLookupTableDto implements IPagedResultDtoOfStateCountryLookupTableDto {
    totalCount!: number;
    items!: StateCountryLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfStateCountryLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StateCountryLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfStateCountryLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfStateCountryLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfStateCountryLookupTableDto {
    totalCount: number;
    items: StateCountryLookupTableDto[] | undefined;
}

export class StatutoryConfigurationDto implements IStatutoryConfigurationDto {
    minimumLimit!: number | undefined;
    maximumLimit!: number | undefined;
    isDeductionEmpContMonth!: boolean;
    professionalTax!: boolean;
    labourTax!: boolean;
    stateId!: number | undefined;
    locationId!: number | undefined;
    id!: number;

    constructor(data?: IStatutoryConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minimumLimit = _data["minimumLimit"];
            this.maximumLimit = _data["maximumLimit"];
            this.isDeductionEmpContMonth = _data["isDeductionEmpContMonth"];
            this.professionalTax = _data["professionalTax"];
            this.labourTax = _data["labourTax"];
            this.stateId = _data["stateId"];
            this.locationId = _data["locationId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StatutoryConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatutoryConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minimumLimit"] = this.minimumLimit;
        data["maximumLimit"] = this.maximumLimit;
        data["isDeductionEmpContMonth"] = this.isDeductionEmpContMonth;
        data["professionalTax"] = this.professionalTax;
        data["labourTax"] = this.labourTax;
        data["stateId"] = this.stateId;
        data["locationId"] = this.locationId;
        data["id"] = this.id;
        return data;
    }
}

export interface IStatutoryConfigurationDto {
    minimumLimit: number | undefined;
    maximumLimit: number | undefined;
    isDeductionEmpContMonth: boolean;
    professionalTax: boolean;
    labourTax: boolean;
    stateId: number | undefined;
    locationId: number | undefined;
    id: number;
}

export class GetStatutoryConfigurationForViewDto implements IGetStatutoryConfigurationForViewDto {
    statutoryConfiguration!: StatutoryConfigurationDto;
    stateName!: string | undefined;
    locationName!: string | undefined;

    constructor(data?: IGetStatutoryConfigurationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statutoryConfiguration = _data["statutoryConfiguration"] ? StatutoryConfigurationDto.fromJS(_data["statutoryConfiguration"]) : <any>undefined;
            this.stateName = _data["stateName"];
            this.locationName = _data["locationName"];
        }
    }

    static fromJS(data: any): GetStatutoryConfigurationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetStatutoryConfigurationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statutoryConfiguration"] = this.statutoryConfiguration ? this.statutoryConfiguration.toJSON() : <any>undefined;
        data["stateName"] = this.stateName;
        data["locationName"] = this.locationName;
        return data;
    }
}

export interface IGetStatutoryConfigurationForViewDto {
    statutoryConfiguration: StatutoryConfigurationDto;
    stateName: string | undefined;
    locationName: string | undefined;
}

export class PagedResultDtoOfGetStatutoryConfigurationForViewDto implements IPagedResultDtoOfGetStatutoryConfigurationForViewDto {
    totalCount!: number;
    items!: GetStatutoryConfigurationForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetStatutoryConfigurationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetStatutoryConfigurationForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetStatutoryConfigurationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetStatutoryConfigurationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetStatutoryConfigurationForViewDto {
    totalCount: number;
    items: GetStatutoryConfigurationForViewDto[] | undefined;
}

export class CreateOrEditStatutoryConfigurationDto implements ICreateOrEditStatutoryConfigurationDto {
    minimumLimit!: number | undefined;
    maximumLimit!: number | undefined;
    isDeductionEmpContMonth!: boolean;
    professionalTax!: boolean;
    labourTax!: boolean;
    stateId!: number | undefined;
    locationId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditStatutoryConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minimumLimit = _data["minimumLimit"];
            this.maximumLimit = _data["maximumLimit"];
            this.isDeductionEmpContMonth = _data["isDeductionEmpContMonth"];
            this.professionalTax = _data["professionalTax"];
            this.labourTax = _data["labourTax"];
            this.stateId = _data["stateId"];
            this.locationId = _data["locationId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditStatutoryConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditStatutoryConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minimumLimit"] = this.minimumLimit;
        data["maximumLimit"] = this.maximumLimit;
        data["isDeductionEmpContMonth"] = this.isDeductionEmpContMonth;
        data["professionalTax"] = this.professionalTax;
        data["labourTax"] = this.labourTax;
        data["stateId"] = this.stateId;
        data["locationId"] = this.locationId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditStatutoryConfigurationDto {
    minimumLimit: number | undefined;
    maximumLimit: number | undefined;
    isDeductionEmpContMonth: boolean;
    professionalTax: boolean;
    labourTax: boolean;
    stateId: number | undefined;
    locationId: number | undefined;
    id: number | undefined;
}

export class GetStatutoryConfigurationForEditOutput implements IGetStatutoryConfigurationForEditOutput {
    statutoryConfiguration!: CreateOrEditStatutoryConfigurationDto;
    stateName!: string | undefined;
    locationName!: string | undefined;

    constructor(data?: IGetStatutoryConfigurationForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statutoryConfiguration = _data["statutoryConfiguration"] ? CreateOrEditStatutoryConfigurationDto.fromJS(_data["statutoryConfiguration"]) : <any>undefined;
            this.stateName = _data["stateName"];
            this.locationName = _data["locationName"];
        }
    }

    static fromJS(data: any): GetStatutoryConfigurationForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetStatutoryConfigurationForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statutoryConfiguration"] = this.statutoryConfiguration ? this.statutoryConfiguration.toJSON() : <any>undefined;
        data["stateName"] = this.stateName;
        data["locationName"] = this.locationName;
        return data;
    }
}

export interface IGetStatutoryConfigurationForEditOutput {
    statutoryConfiguration: CreateOrEditStatutoryConfigurationDto;
    stateName: string | undefined;
    locationName: string | undefined;
}

export class StatutoryConfigurationStateLookupTableDto implements IStatutoryConfigurationStateLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IStatutoryConfigurationStateLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): StatutoryConfigurationStateLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatutoryConfigurationStateLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IStatutoryConfigurationStateLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfStatutoryConfigurationStateLookupTableDto implements IPagedResultDtoOfStatutoryConfigurationStateLookupTableDto {
    totalCount!: number;
    items!: StatutoryConfigurationStateLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfStatutoryConfigurationStateLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StatutoryConfigurationStateLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfStatutoryConfigurationStateLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfStatutoryConfigurationStateLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfStatutoryConfigurationStateLookupTableDto {
    totalCount: number;
    items: StatutoryConfigurationStateLookupTableDto[] | undefined;
}

export class StatutoryConfigurationLocationLookupTableDto implements IStatutoryConfigurationLocationLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IStatutoryConfigurationLocationLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): StatutoryConfigurationLocationLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatutoryConfigurationLocationLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IStatutoryConfigurationLocationLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfStatutoryConfigurationLocationLookupTableDto implements IPagedResultDtoOfStatutoryConfigurationLocationLookupTableDto {
    totalCount!: number;
    items!: StatutoryConfigurationLocationLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfStatutoryConfigurationLocationLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StatutoryConfigurationLocationLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfStatutoryConfigurationLocationLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfStatutoryConfigurationLocationLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfStatutoryConfigurationLocationLookupTableDto {
    totalCount: number;
    items: StatutoryConfigurationLocationLookupTableDto[] | undefined;
}

export class StripeConfirmPaymentInput implements IStripeConfirmPaymentInput {
    paymentId!: number;
    stripeToken!: string | undefined;

    constructor(data?: IStripeConfirmPaymentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.stripeToken = _data["stripeToken"];
        }
    }

    static fromJS(data: any): StripeConfirmPaymentInput {
        data = typeof data === 'object' ? data : {};
        let result = new StripeConfirmPaymentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["stripeToken"] = this.stripeToken;
        return data;
    }
}

export interface IStripeConfirmPaymentInput {
    paymentId: number;
    stripeToken: string | undefined;
}

export class StripeCreateSubscriptionInput implements IStripeCreateSubscriptionInput {
    paymentId!: number;
    stripeToken!: string | undefined;

    constructor(data?: IStripeCreateSubscriptionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.stripeToken = _data["stripeToken"];
        }
    }

    static fromJS(data: any): StripeCreateSubscriptionInput {
        data = typeof data === 'object' ? data : {};
        let result = new StripeCreateSubscriptionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["stripeToken"] = this.stripeToken;
        return data;
    }
}

export interface IStripeCreateSubscriptionInput {
    paymentId: number;
    stripeToken: string | undefined;
}

export class StripeUpdateSubscriptionInput implements IStripeUpdateSubscriptionInput {
    paymentId!: number;

    constructor(data?: IStripeUpdateSubscriptionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
        }
    }

    static fromJS(data: any): StripeUpdateSubscriptionInput {
        data = typeof data === 'object' ? data : {};
        let result = new StripeUpdateSubscriptionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        return data;
    }
}

export interface IStripeUpdateSubscriptionInput {
    paymentId: number;
}

export class StripeConfigurationDto implements IStripeConfigurationDto {
    publishableKey!: string | undefined;

    constructor(data?: IStripeConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publishableKey = _data["publishableKey"];
        }
    }

    static fromJS(data: any): StripeConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StripeConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publishableKey"] = this.publishableKey;
        return data;
    }
}

export interface IStripeConfigurationDto {
    publishableKey: string | undefined;
}

export class SubDepartmentDto implements ISubDepartmentDto {
    name!: string | undefined;
    departmentId!: number | undefined;
    id!: number;

    constructor(data?: ISubDepartmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.departmentId = _data["departmentId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SubDepartmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubDepartmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["departmentId"] = this.departmentId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISubDepartmentDto {
    name: string | undefined;
    departmentId: number | undefined;
    id: number;
}

export class GetSubDepartmentForViewDto implements IGetSubDepartmentForViewDto {
    subDepartment!: SubDepartmentDto;
    departmentName!: string | undefined;

    constructor(data?: IGetSubDepartmentForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subDepartment = _data["subDepartment"] ? SubDepartmentDto.fromJS(_data["subDepartment"]) : <any>undefined;
            this.departmentName = _data["departmentName"];
        }
    }

    static fromJS(data: any): GetSubDepartmentForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubDepartmentForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subDepartment"] = this.subDepartment ? this.subDepartment.toJSON() : <any>undefined;
        data["departmentName"] = this.departmentName;
        return data;
    }
}

export interface IGetSubDepartmentForViewDto {
    subDepartment: SubDepartmentDto;
    departmentName: string | undefined;
}

export class PagedResultDtoOfGetSubDepartmentForViewDto implements IPagedResultDtoOfGetSubDepartmentForViewDto {
    totalCount!: number;
    items!: GetSubDepartmentForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSubDepartmentForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSubDepartmentForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSubDepartmentForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSubDepartmentForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSubDepartmentForViewDto {
    totalCount: number;
    items: GetSubDepartmentForViewDto[] | undefined;
}

export class CreateOrEditSubDepartmentDto implements ICreateOrEditSubDepartmentDto {
    name!: string | undefined;
    departmentId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSubDepartmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.departmentId = _data["departmentId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSubDepartmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSubDepartmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["departmentId"] = this.departmentId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSubDepartmentDto {
    name: string | undefined;
    departmentId: number | undefined;
    id: number | undefined;
}

export class GetSubDepartmentForEditOutput implements IGetSubDepartmentForEditOutput {
    subDepartment!: CreateOrEditSubDepartmentDto;
    departmentName!: string | undefined;

    constructor(data?: IGetSubDepartmentForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subDepartment = _data["subDepartment"] ? CreateOrEditSubDepartmentDto.fromJS(_data["subDepartment"]) : <any>undefined;
            this.departmentName = _data["departmentName"];
        }
    }

    static fromJS(data: any): GetSubDepartmentForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubDepartmentForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subDepartment"] = this.subDepartment ? this.subDepartment.toJSON() : <any>undefined;
        data["departmentName"] = this.departmentName;
        return data;
    }
}

export interface IGetSubDepartmentForEditOutput {
    subDepartment: CreateOrEditSubDepartmentDto;
    departmentName: string | undefined;
}

export class SubDepartmentDepartmentLookupTableDto implements ISubDepartmentDepartmentLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISubDepartmentDepartmentLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SubDepartmentDepartmentLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubDepartmentDepartmentLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISubDepartmentDepartmentLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class CreateSubKra implements ICreateSubKra {
    id!: number;
    description!: string | undefined;
    tenantId!: number;
    fk_kRAId!: number;

    constructor(data?: ICreateSubKra) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.tenantId = _data["tenantId"];
            this.fk_kRAId = _data["fk_kRAId"];
        }
    }

    static fromJS(data: any): CreateSubKra {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubKra();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["tenantId"] = this.tenantId;
        data["fk_kRAId"] = this.fk_kRAId;
        return data;
    }
}

export interface ICreateSubKra {
    id: number;
    description: string | undefined;
    tenantId: number;
    fk_kRAId: number;
}

export class SubKraDto implements ISubKraDto {
    id!: number;
    description!: string | undefined;

    constructor(data?: ISubKraDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): SubKraDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubKraDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }
}

export interface ISubKraDto {
    id: number;
    description: string | undefined;
}

export class SubLocationDto implements ISubLocationDto {
    name!: string | undefined;
    locationId!: number | undefined;
    id!: number;

    constructor(data?: ISubLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.locationId = _data["locationId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SubLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["locationId"] = this.locationId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISubLocationDto {
    name: string | undefined;
    locationId: number | undefined;
    id: number;
}

export class GetSubLocationForViewDto implements IGetSubLocationForViewDto {
    subLocation!: SubLocationDto;
    locationName!: string | undefined;

    constructor(data?: IGetSubLocationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subLocation = _data["subLocation"] ? SubLocationDto.fromJS(_data["subLocation"]) : <any>undefined;
            this.locationName = _data["locationName"];
        }
    }

    static fromJS(data: any): GetSubLocationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubLocationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subLocation"] = this.subLocation ? this.subLocation.toJSON() : <any>undefined;
        data["locationName"] = this.locationName;
        return data;
    }
}

export interface IGetSubLocationForViewDto {
    subLocation: SubLocationDto;
    locationName: string | undefined;
}

export class PagedResultDtoOfGetSubLocationForViewDto implements IPagedResultDtoOfGetSubLocationForViewDto {
    totalCount!: number;
    items!: GetSubLocationForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSubLocationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSubLocationForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSubLocationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSubLocationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSubLocationForViewDto {
    totalCount: number;
    items: GetSubLocationForViewDto[] | undefined;
}

export class CreateOrEditSubLocationDto implements ICreateOrEditSubLocationDto {
    name!: string | undefined;
    locationId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSubLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.locationId = _data["locationId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSubLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSubLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["locationId"] = this.locationId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSubLocationDto {
    name: string | undefined;
    locationId: number | undefined;
    id: number | undefined;
}

export class GetSubLocationForEditOutput implements IGetSubLocationForEditOutput {
    subLocation!: CreateOrEditSubLocationDto;
    locationName!: string | undefined;

    constructor(data?: IGetSubLocationForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subLocation = _data["subLocation"] ? CreateOrEditSubLocationDto.fromJS(_data["subLocation"]) : <any>undefined;
            this.locationName = _data["locationName"];
        }
    }

    static fromJS(data: any): GetSubLocationForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubLocationForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subLocation"] = this.subLocation ? this.subLocation.toJSON() : <any>undefined;
        data["locationName"] = this.locationName;
        return data;
    }
}

export interface IGetSubLocationForEditOutput {
    subLocation: CreateOrEditSubLocationDto;
    locationName: string | undefined;
}

export class SubLocationLocationLookupTableDto implements ISubLocationLocationLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISubLocationLocationLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SubLocationLocationLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubLocationLocationLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISubLocationLocationLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export enum Priority {
    Low = 0,
    Medium = 1,
    High = 2,
}

export class TaskDetail implements ITaskDetail {
    tenantId!: number | undefined;
    taskName!: string | undefined;
    taskAssignedTime!: string;
    internalDeadline!: moment.Moment;
    actualDeadline!: moment.Moment;
    fromEmployee!: number | undefined;
    toEmployee!: number | undefined;
    taskTypeId!: number;
    priority!: Priority;
    taskAssignedDate!: moment.Moment;
    projectId!: number;
    budgetHours!: number;
    billable!: boolean;
    createdOn!: moment.Moment;
    createdBy!: number;
    updatedOn!: moment.Moment;
    updatedBy!: number;
    id!: number;

    constructor(data?: ITaskDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.taskName = _data["taskName"];
            this.taskAssignedTime = _data["taskAssignedTime"];
            this.internalDeadline = _data["internalDeadline"] ? moment(_data["internalDeadline"].toString()) : <any>undefined;
            this.actualDeadline = _data["actualDeadline"] ? moment(_data["actualDeadline"].toString()) : <any>undefined;
            this.fromEmployee = _data["fromEmployee"];
            this.toEmployee = _data["toEmployee"];
            this.taskTypeId = _data["taskTypeId"];
            this.priority = _data["priority"];
            this.taskAssignedDate = _data["taskAssignedDate"] ? moment(_data["taskAssignedDate"].toString()) : <any>undefined;
            this.projectId = _data["projectId"];
            this.budgetHours = _data["budgetHours"];
            this.billable = _data["billable"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? moment(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TaskDetail {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["taskName"] = this.taskName;
        data["taskAssignedTime"] = this.taskAssignedTime;
        data["internalDeadline"] = this.internalDeadline ? this.internalDeadline.toISOString() : <any>undefined;
        data["actualDeadline"] = this.actualDeadline ? this.actualDeadline.toISOString() : <any>undefined;
        data["fromEmployee"] = this.fromEmployee;
        data["toEmployee"] = this.toEmployee;
        data["taskTypeId"] = this.taskTypeId;
        data["priority"] = this.priority;
        data["taskAssignedDate"] = this.taskAssignedDate ? this.taskAssignedDate.toISOString() : <any>undefined;
        data["projectId"] = this.projectId;
        data["budgetHours"] = this.budgetHours;
        data["billable"] = this.billable;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["id"] = this.id;
        return data;
    }
}

export interface ITaskDetail {
    tenantId: number | undefined;
    taskName: string | undefined;
    taskAssignedTime: string;
    internalDeadline: moment.Moment;
    actualDeadline: moment.Moment;
    fromEmployee: number | undefined;
    toEmployee: number | undefined;
    taskTypeId: number;
    priority: Priority;
    taskAssignedDate: moment.Moment;
    projectId: number;
    budgetHours: number;
    billable: boolean;
    createdOn: moment.Moment;
    createdBy: number;
    updatedOn: moment.Moment;
    updatedBy: number;
    id: number;
}

export class GetTaskDto implements IGetTaskDto {
    id!: number;
    taskName!: string | undefined;
    taskType!: string | undefined;
    priority!: string | undefined;
    taskAssignedDate!: string | undefined;
    project!: string | undefined;
    projectCode!: string | undefined;
    customer!: string | undefined;
    budgetHours!: number;
    billable!: string | undefined;
    createdOn!: string | undefined;
    createdby!: number;
    updatedBy!: number;
    updatedOn!: string | undefined;
    fileNo!: string | undefined;
    taskAssignedTime!: string;
    internalDeadline!: string | undefined;
    actualDeadline!: string | undefined;
    deliveryDate!: string | undefined;
    deliveryTime!: string;
    fromEmployee!: string | undefined;
    toEmployee!: string | undefined;
    remarks!: string | undefined;

    constructor(data?: IGetTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskName = _data["taskName"];
            this.taskType = _data["taskType"];
            this.priority = _data["priority"];
            this.taskAssignedDate = _data["taskAssignedDate"];
            this.project = _data["project"];
            this.projectCode = _data["projectCode"];
            this.customer = _data["customer"];
            this.budgetHours = _data["budgetHours"];
            this.billable = _data["billable"];
            this.createdOn = _data["createdOn"];
            this.createdby = _data["createdby"];
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"];
            this.fileNo = _data["fileNo"];
            this.taskAssignedTime = _data["taskAssignedTime"];
            this.internalDeadline = _data["internalDeadline"];
            this.actualDeadline = _data["actualDeadline"];
            this.deliveryDate = _data["deliveryDate"];
            this.deliveryTime = _data["deliveryTime"];
            this.fromEmployee = _data["fromEmployee"];
            this.toEmployee = _data["toEmployee"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): GetTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskName"] = this.taskName;
        data["taskType"] = this.taskType;
        data["priority"] = this.priority;
        data["taskAssignedDate"] = this.taskAssignedDate;
        data["project"] = this.project;
        data["projectCode"] = this.projectCode;
        data["customer"] = this.customer;
        data["budgetHours"] = this.budgetHours;
        data["billable"] = this.billable;
        data["createdOn"] = this.createdOn;
        data["createdby"] = this.createdby;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn;
        data["fileNo"] = this.fileNo;
        data["taskAssignedTime"] = this.taskAssignedTime;
        data["internalDeadline"] = this.internalDeadline;
        data["actualDeadline"] = this.actualDeadline;
        data["deliveryDate"] = this.deliveryDate;
        data["deliveryTime"] = this.deliveryTime;
        data["fromEmployee"] = this.fromEmployee;
        data["toEmployee"] = this.toEmployee;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IGetTaskDto {
    id: number;
    taskName: string | undefined;
    taskType: string | undefined;
    priority: string | undefined;
    taskAssignedDate: string | undefined;
    project: string | undefined;
    projectCode: string | undefined;
    customer: string | undefined;
    budgetHours: number;
    billable: string | undefined;
    createdOn: string | undefined;
    createdby: number;
    updatedBy: number;
    updatedOn: string | undefined;
    fileNo: string | undefined;
    taskAssignedTime: string;
    internalDeadline: string | undefined;
    actualDeadline: string | undefined;
    deliveryDate: string | undefined;
    deliveryTime: string;
    fromEmployee: string | undefined;
    toEmployee: string | undefined;
    remarks: string | undefined;
}

export class TaskType implements ITaskType {
    tenantId!: number | undefined;
    taskTypeName!: string | undefined;
    id!: number;

    constructor(data?: ITaskType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.taskTypeName = _data["taskTypeName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TaskType {
        data = typeof data === 'object' ? data : {};
        let result = new TaskType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["taskTypeName"] = this.taskTypeName;
        data["id"] = this.id;
        return data;
    }
}

export interface ITaskType {
    tenantId: number | undefined;
    taskTypeName: string | undefined;
    id: number;
}

export class TDSFeedingDto implements ITDSFeedingDto {
    tenantId!: number;
    monthYear!: string | undefined;
    employeeCode!: string | undefined;
    employeeId!: number;
    tdsAmount!: number;
    id!: number;

    constructor(data?: ITDSFeedingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.monthYear = _data["monthYear"];
            this.employeeCode = _data["employeeCode"];
            this.employeeId = _data["employeeId"];
            this.tdsAmount = _data["tdsAmount"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TDSFeedingDto {
        data = typeof data === 'object' ? data : {};
        let result = new TDSFeedingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["monthYear"] = this.monthYear;
        data["employeeCode"] = this.employeeCode;
        data["employeeId"] = this.employeeId;
        data["tdsAmount"] = this.tdsAmount;
        data["id"] = this.id;
        return data;
    }
}

export interface ITDSFeedingDto {
    tenantId: number;
    monthYear: string | undefined;
    employeeCode: string | undefined;
    employeeId: number;
    tdsAmount: number;
    id: number;
}

export class GetTDSFeedingForViewDto implements IGetTDSFeedingForViewDto {
    tdsFeeding!: TDSFeedingDto;
    empName!: string | undefined;
    monthyear!: string | undefined;

    constructor(data?: IGetTDSFeedingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tdsFeeding = _data["tdsFeeding"] ? TDSFeedingDto.fromJS(_data["tdsFeeding"]) : <any>undefined;
            this.empName = _data["empName"];
            this.monthyear = _data["monthyear"];
        }
    }

    static fromJS(data: any): GetTDSFeedingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTDSFeedingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tdsFeeding"] = this.tdsFeeding ? this.tdsFeeding.toJSON() : <any>undefined;
        data["empName"] = this.empName;
        data["monthyear"] = this.monthyear;
        return data;
    }
}

export interface IGetTDSFeedingForViewDto {
    tdsFeeding: TDSFeedingDto;
    empName: string | undefined;
    monthyear: string | undefined;
}

export class PagedResultDtoOfGetTDSFeedingForViewDto implements IPagedResultDtoOfGetTDSFeedingForViewDto {
    totalCount!: number;
    items!: GetTDSFeedingForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTDSFeedingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTDSFeedingForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTDSFeedingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTDSFeedingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTDSFeedingForViewDto {
    totalCount: number;
    items: GetTDSFeedingForViewDto[] | undefined;
}

export class BONUSFeedingDto implements IBONUSFeedingDto {
    tenantId!: number;
    monthYear!: string | undefined;
    employeeId!: number;
    employeecode!: string | undefined;
    bonusAmount!: number;
    tdsAmount!: number;
    advanceAmount!: number;
    reimbursementAmount!: number;
    totalSalary!: number;
    totalCount!: number;
    previewStatus!: number;
    salaryFreezeStatus!: number;
    previewSalary!: number;
    id!: number;

    constructor(data?: IBONUSFeedingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.monthYear = _data["monthYear"];
            this.employeeId = _data["employeeId"];
            this.employeecode = _data["employeecode"];
            this.bonusAmount = _data["bonusAmount"];
            this.tdsAmount = _data["tdsAmount"];
            this.advanceAmount = _data["advanceAmount"];
            this.reimbursementAmount = _data["reimbursementAmount"];
            this.totalSalary = _data["totalSalary"];
            this.totalCount = _data["totalCount"];
            this.previewStatus = _data["previewStatus"];
            this.salaryFreezeStatus = _data["salaryFreezeStatus"];
            this.previewSalary = _data["previewSalary"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BONUSFeedingDto {
        data = typeof data === 'object' ? data : {};
        let result = new BONUSFeedingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["monthYear"] = this.monthYear;
        data["employeeId"] = this.employeeId;
        data["employeecode"] = this.employeecode;
        data["bonusAmount"] = this.bonusAmount;
        data["tdsAmount"] = this.tdsAmount;
        data["advanceAmount"] = this.advanceAmount;
        data["reimbursementAmount"] = this.reimbursementAmount;
        data["totalSalary"] = this.totalSalary;
        data["totalCount"] = this.totalCount;
        data["previewStatus"] = this.previewStatus;
        data["salaryFreezeStatus"] = this.salaryFreezeStatus;
        data["previewSalary"] = this.previewSalary;
        data["id"] = this.id;
        return data;
    }
}

export interface IBONUSFeedingDto {
    tenantId: number;
    monthYear: string | undefined;
    employeeId: number;
    employeecode: string | undefined;
    bonusAmount: number;
    tdsAmount: number;
    advanceAmount: number;
    reimbursementAmount: number;
    totalSalary: number;
    totalCount: number;
    previewStatus: number;
    salaryFreezeStatus: number;
    previewSalary: number;
    id: number;
}

export class GetBonusFeedingForViewDto implements IGetBonusFeedingForViewDto {
    tdsFeeding!: BONUSFeedingDto;
    empName!: string | undefined;
    monthyear!: string | undefined;

    constructor(data?: IGetBonusFeedingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tdsFeeding = _data["tdsFeeding"] ? BONUSFeedingDto.fromJS(_data["tdsFeeding"]) : <any>undefined;
            this.empName = _data["empName"];
            this.monthyear = _data["monthyear"];
        }
    }

    static fromJS(data: any): GetBonusFeedingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBonusFeedingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tdsFeeding"] = this.tdsFeeding ? this.tdsFeeding.toJSON() : <any>undefined;
        data["empName"] = this.empName;
        data["monthyear"] = this.monthyear;
        return data;
    }
}

export interface IGetBonusFeedingForViewDto {
    tdsFeeding: BONUSFeedingDto;
    empName: string | undefined;
    monthyear: string | undefined;
}

export class PagedResultDtoOfGetBonusFeedingForViewDto implements IPagedResultDtoOfGetBonusFeedingForViewDto {
    totalCount!: number;
    items!: GetBonusFeedingForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBonusFeedingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetBonusFeedingForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBonusFeedingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBonusFeedingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetBonusFeedingForViewDto {
    totalCount: number;
    items: GetBonusFeedingForViewDto[] | undefined;
}

export class CreateOrEditTDSFeedingDto implements ICreateOrEditTDSFeedingDto {
    tenantId!: number;
    monthYear!: string | undefined;
    employeeId!: number;
    tdsAmount!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTDSFeedingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.monthYear = _data["monthYear"];
            this.employeeId = _data["employeeId"];
            this.tdsAmount = _data["tdsAmount"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTDSFeedingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTDSFeedingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["monthYear"] = this.monthYear;
        data["employeeId"] = this.employeeId;
        data["tdsAmount"] = this.tdsAmount;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTDSFeedingDto {
    tenantId: number;
    monthYear: string | undefined;
    employeeId: number;
    tdsAmount: number;
    id: number | undefined;
}

export class GetTDSFeedingForEditOutput implements IGetTDSFeedingForEditOutput {
    tdsFeeding!: CreateOrEditTDSFeedingDto;

    constructor(data?: IGetTDSFeedingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tdsFeeding = _data["tdsFeeding"] ? CreateOrEditTDSFeedingDto.fromJS(_data["tdsFeeding"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTDSFeedingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTDSFeedingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tdsFeeding"] = this.tdsFeeding ? this.tdsFeeding.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTDSFeedingForEditOutput {
    tdsFeeding: CreateOrEditTDSFeedingDto;
}

export class UploadIamgedata implements IUploadIamgedata {
    iamgeData!: string | undefined;
    name!: string | undefined;
    documentType!: string | undefined;
    documentTypeID!: number;
    employeeId!: number;

    constructor(data?: IUploadIamgedata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iamgeData = _data["iamgeData"];
            this.name = _data["name"];
            this.documentType = _data["documentType"];
            this.documentTypeID = _data["documentTypeID"];
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): UploadIamgedata {
        data = typeof data === 'object' ? data : {};
        let result = new UploadIamgedata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iamgeData"] = this.iamgeData;
        data["name"] = this.name;
        data["documentType"] = this.documentType;
        data["documentTypeID"] = this.documentTypeID;
        data["employeeId"] = this.employeeId;
        return data;
    }
}

export interface IUploadIamgedata {
    iamgeData: string | undefined;
    name: string | undefined;
    documentType: string | undefined;
    documentTypeID: number;
    employeeId: number;
}

export class TenancyConfiguratonWizardDto implements ITenancyConfiguratonWizardDto {
    sequence!: number | undefined;
    feature!: string | undefined;
    form!: string | undefined;
    status!: boolean;
    percentage!: number | undefined;
    id!: number;

    constructor(data?: ITenancyConfiguratonWizardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sequence = _data["sequence"];
            this.feature = _data["feature"];
            this.form = _data["form"];
            this.status = _data["status"];
            this.percentage = _data["percentage"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenancyConfiguratonWizardDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenancyConfiguratonWizardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sequence"] = this.sequence;
        data["feature"] = this.feature;
        data["form"] = this.form;
        data["status"] = this.status;
        data["percentage"] = this.percentage;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenancyConfiguratonWizardDto {
    sequence: number | undefined;
    feature: string | undefined;
    form: string | undefined;
    status: boolean;
    percentage: number | undefined;
    id: number;
}

export class GetTenancyConfiguratonWizardForViewDto implements IGetTenancyConfiguratonWizardForViewDto {
    tenancyConfiguratonWizard!: TenancyConfiguratonWizardDto;

    constructor(data?: IGetTenancyConfiguratonWizardForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyConfiguratonWizard = _data["tenancyConfiguratonWizard"] ? TenancyConfiguratonWizardDto.fromJS(_data["tenancyConfiguratonWizard"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTenancyConfiguratonWizardForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenancyConfiguratonWizardForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyConfiguratonWizard"] = this.tenancyConfiguratonWizard ? this.tenancyConfiguratonWizard.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTenancyConfiguratonWizardForViewDto {
    tenancyConfiguratonWizard: TenancyConfiguratonWizardDto;
}

export class PagedResultDtoOfGetTenancyConfiguratonWizardForViewDto implements IPagedResultDtoOfGetTenancyConfiguratonWizardForViewDto {
    totalCount!: number;
    items!: GetTenancyConfiguratonWizardForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTenancyConfiguratonWizardForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTenancyConfiguratonWizardForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTenancyConfiguratonWizardForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTenancyConfiguratonWizardForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTenancyConfiguratonWizardForViewDto {
    totalCount: number;
    items: GetTenancyConfiguratonWizardForViewDto[] | undefined;
}

export class CreateOrEditTenancyConfiguratonWizardDto implements ICreateOrEditTenancyConfiguratonWizardDto {
    sequence!: number | undefined;
    feature!: string | undefined;
    form!: string | undefined;
    status!: boolean;
    percentage!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTenancyConfiguratonWizardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sequence = _data["sequence"];
            this.feature = _data["feature"];
            this.form = _data["form"];
            this.status = _data["status"];
            this.percentage = _data["percentage"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTenancyConfiguratonWizardDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTenancyConfiguratonWizardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sequence"] = this.sequence;
        data["feature"] = this.feature;
        data["form"] = this.form;
        data["status"] = this.status;
        data["percentage"] = this.percentage;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTenancyConfiguratonWizardDto {
    sequence: number | undefined;
    feature: string | undefined;
    form: string | undefined;
    status: boolean;
    percentage: number | undefined;
    id: number | undefined;
}

export class GetTenancyConfiguratonWizardForEditOutput implements IGetTenancyConfiguratonWizardForEditOutput {
    tenancyConfiguratonWizard!: CreateOrEditTenancyConfiguratonWizardDto;

    constructor(data?: IGetTenancyConfiguratonWizardForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyConfiguratonWizard = _data["tenancyConfiguratonWizard"] ? CreateOrEditTenancyConfiguratonWizardDto.fromJS(_data["tenancyConfiguratonWizard"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTenancyConfiguratonWizardForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenancyConfiguratonWizardForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyConfiguratonWizard"] = this.tenancyConfiguratonWizard ? this.tenancyConfiguratonWizard.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTenancyConfiguratonWizardForEditOutput {
    tenancyConfiguratonWizard: CreateOrEditTenancyConfiguratonWizardDto;
}

export class GetIntallationMenu implements IGetIntallationMenu {
    label!: string | undefined;

    constructor(data?: IGetIntallationMenu) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): GetIntallationMenu {
        data = typeof data === 'object' ? data : {};
        let result = new GetIntallationMenu();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        return data;
    }
}

export interface IGetIntallationMenu {
    label: string | undefined;
}

export class TenantListDto implements ITenantListDto {
    tenancyName!: string | undefined;
    remarks!: string | undefined;
    name!: string | undefined;
    editionDisplayName!: string | undefined;
    connectionString!: string | undefined;
    isActive!: boolean;
    creationTime!: moment.Moment;
    subscriptionEndDateUtc!: moment.Moment | undefined;
    editionId!: number | undefined;
    isInTrialPeriod!: boolean;
    id!: number;

    constructor(data?: ITenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.remarks = _data["remarks"];
            this.name = _data["name"];
            this.editionDisplayName = _data["editionDisplayName"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? moment(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.editionId = _data["editionId"];
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["remarks"] = this.remarks;
        data["name"] = this.name;
        data["editionDisplayName"] = this.editionDisplayName;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["editionId"] = this.editionId;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantListDto {
    tenancyName: string | undefined;
    remarks: string | undefined;
    name: string | undefined;
    editionDisplayName: string | undefined;
    connectionString: string | undefined;
    isActive: boolean;
    creationTime: moment.Moment;
    subscriptionEndDateUtc: moment.Moment | undefined;
    editionId: number | undefined;
    isInTrialPeriod: boolean;
    id: number;
}

export class PagedResultDtoOfTenantListDto implements IPagedResultDtoOfTenantListDto {
    totalCount!: number;
    items!: TenantListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfTenantListDto {
    totalCount: number;
    items: TenantListDto[] | undefined;
}

export class CreateTenantInput implements ICreateTenantInput {
    tenancyName!: string;
    name!: string;
    adminEmailAddress!: string;
    adminPassword!: string | undefined;
    connectionString!: string | undefined;
    tenancyAddress!: string | undefined;
    remarks!: string | undefined;
    maxusercount!: number;
    graceEmployee!: number;
    shouldChangePasswordOnNextLogin!: boolean;
    sendActivationEmail!: boolean;
    editionId!: number | undefined;
    isActive!: boolean;
    subscriptionEndDateUtc!: moment.Moment | undefined;
    isInTrialPeriod!: boolean;
    leaveCycle!: number | undefined;
    performanceCycle!: number | undefined;
    showLeaveOnss!: boolean;
    mrrExists!: boolean;
    erpExists!: boolean;
    countryCode!: string | undefined;
    capturedFailedPunches!: boolean;
    salaryTemplate!: number | undefined;

    constructor(data?: ICreateTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.adminPassword = _data["adminPassword"];
            this.connectionString = _data["connectionString"];
            this.tenancyAddress = _data["tenancyAddress"];
            this.remarks = _data["remarks"];
            this.maxusercount = _data["maxusercount"];
            this.graceEmployee = _data["graceEmployee"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.sendActivationEmail = _data["sendActivationEmail"];
            this.editionId = _data["editionId"];
            this.isActive = _data["isActive"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? moment(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.leaveCycle = _data["leaveCycle"];
            this.performanceCycle = _data["performanceCycle"];
            this.showLeaveOnss = _data["showLeaveOnss"];
            this.mrrExists = _data["mrrExists"];
            this.erpExists = _data["erpExists"];
            this.countryCode = _data["countryCode"];
            this.capturedFailedPunches = _data["capturedFailedPunches"];
            this.salaryTemplate = _data["salaryTemplate"];
        }
    }

    static fromJS(data: any): CreateTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["connectionString"] = this.connectionString;
        data["tenancyAddress"] = this.tenancyAddress;
        data["remarks"] = this.remarks;
        data["maxusercount"] = this.maxusercount;
        data["graceEmployee"] = this.graceEmployee;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["leaveCycle"] = this.leaveCycle;
        data["performanceCycle"] = this.performanceCycle;
        data["showLeaveOnss"] = this.showLeaveOnss;
        data["mrrExists"] = this.mrrExists;
        data["erpExists"] = this.erpExists;
        data["countryCode"] = this.countryCode;
        data["capturedFailedPunches"] = this.capturedFailedPunches;
        data["salaryTemplate"] = this.salaryTemplate;
        return data;
    }
}

export interface ICreateTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string | undefined;
    connectionString: string | undefined;
    tenancyAddress: string | undefined;
    remarks: string | undefined;
    maxusercount: number;
    graceEmployee: number;
    shouldChangePasswordOnNextLogin: boolean;
    sendActivationEmail: boolean;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    leaveCycle: number | undefined;
    performanceCycle: number | undefined;
    showLeaveOnss: boolean;
    mrrExists: boolean;
    erpExists: boolean;
    countryCode: string | undefined;
    capturedFailedPunches: boolean;
    salaryTemplate: number | undefined;
}

export class TenantEditDto implements ITenantEditDto {
    tenancyName!: string;
    name!: string;
    connectionString!: string | undefined;
    tenancyAddress!: string | undefined;
    remarks!: string | undefined;
    editionId!: number | undefined;
    isActive!: boolean;
    subscriptionEndDateUtc!: moment.Moment | undefined;
    isInTrialPeriod!: boolean;
    leaveCycle!: number | undefined;
    performanceCycle!: number | undefined;
    showLeaveOnss!: boolean;
    mrrExists!: boolean;
    erpExists!: boolean;
    graceEmployee!: number;
    maxUserCount!: number;
    countryCode!: string | undefined;
    capturedFailedPunches!: boolean;
    salaryTemplate!: number | undefined;
    id!: number;

    constructor(data?: ITenantEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.connectionString = _data["connectionString"];
            this.tenancyAddress = _data["tenancyAddress"];
            this.remarks = _data["remarks"];
            this.editionId = _data["editionId"];
            this.isActive = _data["isActive"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? moment(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.leaveCycle = _data["leaveCycle"];
            this.performanceCycle = _data["performanceCycle"];
            this.showLeaveOnss = _data["showLeaveOnss"];
            this.mrrExists = _data["mrrExists"];
            this.erpExists = _data["erpExists"];
            this.graceEmployee = _data["graceEmployee"];
            this.maxUserCount = _data["maxUserCount"];
            this.countryCode = _data["countryCode"];
            this.capturedFailedPunches = _data["capturedFailedPunches"];
            this.salaryTemplate = _data["salaryTemplate"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["tenancyAddress"] = this.tenancyAddress;
        data["remarks"] = this.remarks;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["leaveCycle"] = this.leaveCycle;
        data["performanceCycle"] = this.performanceCycle;
        data["showLeaveOnss"] = this.showLeaveOnss;
        data["mrrExists"] = this.mrrExists;
        data["erpExists"] = this.erpExists;
        data["graceEmployee"] = this.graceEmployee;
        data["maxUserCount"] = this.maxUserCount;
        data["countryCode"] = this.countryCode;
        data["capturedFailedPunches"] = this.capturedFailedPunches;
        data["salaryTemplate"] = this.salaryTemplate;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantEditDto {
    tenancyName: string;
    name: string;
    connectionString: string | undefined;
    tenancyAddress: string | undefined;
    remarks: string | undefined;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    leaveCycle: number | undefined;
    performanceCycle: number | undefined;
    showLeaveOnss: boolean;
    mrrExists: boolean;
    erpExists: boolean;
    graceEmployee: number;
    maxUserCount: number;
    countryCode: string | undefined;
    capturedFailedPunches: boolean;
    salaryTemplate: number | undefined;
    id: number;
}

export class GetTenantFeaturesEditOutput implements IGetTenantFeaturesEditOutput {
    featureValues!: NameValueDto[] | undefined;
    features!: FlatFeatureDto[] | undefined;

    constructor(data?: IGetTenantFeaturesEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantFeaturesEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantFeaturesEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTenantFeaturesEditOutput {
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class UpdateTenantFeaturesInput implements IUpdateTenantFeaturesInput {
    id!: number;
    featureValues!: NameValueDto[];

    constructor(data?: IUpdateTenantFeaturesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTenantFeaturesInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantFeaturesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateTenantFeaturesInput {
    id: number;
    featureValues: NameValueDto[];
}

export class EntityDto implements IEntityDto {
    id!: number;

    constructor(data?: IEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDto {
    id: number;
}

export class PolicyMandateUpdateDto implements IPolicyMandateUpdateDto {
    policyId!: number;
    policyName!: string | undefined;
    isDownloaded!: boolean;
    documentUrl!: string | undefined;
    documentName!: string | undefined;
    acknowledgedOn!: moment.Moment | undefined;
    isChecked!: boolean;
    isLoading!: boolean;
    id!: number;

    constructor(data?: IPolicyMandateUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.policyId = _data["policyId"];
            this.policyName = _data["policyName"];
            this.isDownloaded = _data["isDownloaded"];
            this.documentUrl = _data["documentUrl"];
            this.documentName = _data["documentName"];
            this.acknowledgedOn = _data["acknowledgedOn"] ? moment(_data["acknowledgedOn"].toString()) : <any>undefined;
            this.isChecked = _data["isChecked"];
            this.isLoading = _data["isLoading"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PolicyMandateUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyMandateUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyId"] = this.policyId;
        data["policyName"] = this.policyName;
        data["isDownloaded"] = this.isDownloaded;
        data["documentUrl"] = this.documentUrl;
        data["documentName"] = this.documentName;
        data["acknowledgedOn"] = this.acknowledgedOn ? this.acknowledgedOn.toISOString() : <any>undefined;
        data["isChecked"] = this.isChecked;
        data["isLoading"] = this.isLoading;
        data["id"] = this.id;
        return data;
    }
}

export interface IPolicyMandateUpdateDto {
    policyId: number;
    policyName: string | undefined;
    isDownloaded: boolean;
    documentUrl: string | undefined;
    documentName: string | undefined;
    acknowledgedOn: moment.Moment | undefined;
    isChecked: boolean;
    isLoading: boolean;
    id: number;
}

export class GetIncreamentDueList implements IGetIncreamentDueList {
    employeeCode!: string | undefined;
    employeeName!: string | undefined;
    branch!: string | undefined;
    gender!: string | undefined;
    employeeImage!: string | undefined;
    designation!: string | undefined;
    increamentDueDate!: moment.Moment;

    constructor(data?: IGetIncreamentDueList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeCode = _data["employeeCode"];
            this.employeeName = _data["employeeName"];
            this.branch = _data["branch"];
            this.gender = _data["gender"];
            this.employeeImage = _data["employeeImage"];
            this.designation = _data["designation"];
            this.increamentDueDate = _data["increamentDueDate"] ? moment(_data["increamentDueDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetIncreamentDueList {
        data = typeof data === 'object' ? data : {};
        let result = new GetIncreamentDueList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeCode"] = this.employeeCode;
        data["employeeName"] = this.employeeName;
        data["branch"] = this.branch;
        data["gender"] = this.gender;
        data["employeeImage"] = this.employeeImage;
        data["designation"] = this.designation;
        data["increamentDueDate"] = this.increamentDueDate ? this.increamentDueDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetIncreamentDueList {
    employeeCode: string | undefined;
    employeeName: string | undefined;
    branch: string | undefined;
    gender: string | undefined;
    employeeImage: string | undefined;
    designation: string | undefined;
    increamentDueDate: moment.Moment;
}

export class GetEmployeeForListForLeave implements IGetEmployeeForListForLeave {
    rowNumber!: number;
    employeeId!: number;
    name!: string | undefined;
    employeeCode!: string | undefined;
    employeeImage!: string | undefined;
    leave!: string | undefined;
    designationName!: string | undefined;
    gender!: number;

    constructor(data?: IGetEmployeeForListForLeave) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowNumber = _data["rowNumber"];
            this.employeeId = _data["employeeId"];
            this.name = _data["name"];
            this.employeeCode = _data["employeeCode"];
            this.employeeImage = _data["employeeImage"];
            this.leave = _data["leave"];
            this.designationName = _data["designationName"];
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): GetEmployeeForListForLeave {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeForListForLeave();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowNumber"] = this.rowNumber;
        data["employeeId"] = this.employeeId;
        data["name"] = this.name;
        data["employeeCode"] = this.employeeCode;
        data["employeeImage"] = this.employeeImage;
        data["leave"] = this.leave;
        data["designationName"] = this.designationName;
        data["gender"] = this.gender;
        return data;
    }
}

export interface IGetEmployeeForListForLeave {
    rowNumber: number;
    employeeId: number;
    name: string | undefined;
    employeeCode: string | undefined;
    employeeImage: string | undefined;
    leave: string | undefined;
    designationName: string | undefined;
    gender: number;
}

export class GetOnLeaveTodayList implements IGetOnLeaveTodayList {
    getEmployeeForListforleave!: GetEmployeeForListForLeave;
    totalCount!: number;

    constructor(data?: IGetOnLeaveTodayList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.getEmployeeForListforleave = _data["getEmployeeForListforleave"] ? GetEmployeeForListForLeave.fromJS(_data["getEmployeeForListforleave"]) : <any>undefined;
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): GetOnLeaveTodayList {
        data = typeof data === 'object' ? data : {};
        let result = new GetOnLeaveTodayList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["getEmployeeForListforleave"] = this.getEmployeeForListforleave ? this.getEmployeeForListforleave.toJSON() : <any>undefined;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IGetOnLeaveTodayList {
    getEmployeeForListforleave: GetEmployeeForListForLeave;
    totalCount: number;
}

export class MemberActivity implements IMemberActivity {
    name!: string | undefined;
    earnings!: string | undefined;
    cases!: number;
    closed!: number;
    rate!: string | undefined;

    constructor(data?: IMemberActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.earnings = _data["earnings"];
            this.cases = _data["cases"];
            this.closed = _data["closed"];
            this.rate = _data["rate"];
        }
    }

    static fromJS(data: any): MemberActivity {
        data = typeof data === 'object' ? data : {};
        let result = new MemberActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["earnings"] = this.earnings;
        data["cases"] = this.cases;
        data["closed"] = this.closed;
        data["rate"] = this.rate;
        return data;
    }
}

export interface IMemberActivity {
    name: string | undefined;
    earnings: string | undefined;
    cases: number;
    closed: number;
    rate: string | undefined;
}

export class GetMemberActivityOutput implements IGetMemberActivityOutput {
    memberActivities!: MemberActivity[] | undefined;

    constructor(data?: IGetMemberActivityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["memberActivities"])) {
                this.memberActivities = [] as any;
                for (let item of _data["memberActivities"])
                    this.memberActivities!.push(MemberActivity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMemberActivityOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMemberActivityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.memberActivities)) {
            data["memberActivities"] = [];
            for (let item of this.memberActivities)
                data["memberActivities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMemberActivityOutput {
    memberActivities: MemberActivity[] | undefined;
}

export enum SalesSummaryDatePeriod {
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
}

export class SalesSummaryData implements ISalesSummaryData {
    period!: string | undefined;
    sales!: number;
    profit!: number;

    constructor(data?: ISalesSummaryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.period = _data["period"];
            this.sales = _data["sales"];
            this.profit = _data["profit"];
        }
    }

    static fromJS(data: any): SalesSummaryData {
        data = typeof data === 'object' ? data : {};
        let result = new SalesSummaryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period;
        data["sales"] = this.sales;
        data["profit"] = this.profit;
        return data;
    }
}

export interface ISalesSummaryData {
    period: string | undefined;
    sales: number;
    profit: number;
}

export class GetDashboardDataOutput implements IGetDashboardDataOutput {
    totalProfit!: number;
    newFeedbacks!: number;
    newOrders!: number;
    newUsers!: number;
    salesSummary!: SalesSummaryData[] | undefined;
    totalSales!: number;
    revenue!: number;
    expenses!: number;
    growth!: number;
    transactionPercent!: number;
    newVisitPercent!: number;
    bouncePercent!: number;
    dailySales!: number[] | undefined;
    profitShares!: number[] | undefined;

    constructor(data?: IGetDashboardDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProfit = _data["totalProfit"];
            this.newFeedbacks = _data["newFeedbacks"];
            this.newOrders = _data["newOrders"];
            this.newUsers = _data["newUsers"];
            if (Array.isArray(_data["salesSummary"])) {
                this.salesSummary = [] as any;
                for (let item of _data["salesSummary"])
                    this.salesSummary!.push(SalesSummaryData.fromJS(item));
            }
            this.totalSales = _data["totalSales"];
            this.revenue = _data["revenue"];
            this.expenses = _data["expenses"];
            this.growth = _data["growth"];
            this.transactionPercent = _data["transactionPercent"];
            this.newVisitPercent = _data["newVisitPercent"];
            this.bouncePercent = _data["bouncePercent"];
            if (Array.isArray(_data["dailySales"])) {
                this.dailySales = [] as any;
                for (let item of _data["dailySales"])
                    this.dailySales!.push(item);
            }
            if (Array.isArray(_data["profitShares"])) {
                this.profitShares = [] as any;
                for (let item of _data["profitShares"])
                    this.profitShares!.push(item);
            }
        }
    }

    static fromJS(data: any): GetDashboardDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDashboardDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProfit"] = this.totalProfit;
        data["newFeedbacks"] = this.newFeedbacks;
        data["newOrders"] = this.newOrders;
        data["newUsers"] = this.newUsers;
        if (Array.isArray(this.salesSummary)) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item.toJSON());
        }
        data["totalSales"] = this.totalSales;
        data["revenue"] = this.revenue;
        data["expenses"] = this.expenses;
        data["growth"] = this.growth;
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        if (Array.isArray(this.dailySales)) {
            data["dailySales"] = [];
            for (let item of this.dailySales)
                data["dailySales"].push(item);
        }
        if (Array.isArray(this.profitShares)) {
            data["profitShares"] = [];
            for (let item of this.profitShares)
                data["profitShares"].push(item);
        }
        return data;
    }
}

export interface IGetDashboardDataOutput {
    totalProfit: number;
    newFeedbacks: number;
    newOrders: number;
    newUsers: number;
    salesSummary: SalesSummaryData[] | undefined;
    totalSales: number;
    revenue: number;
    expenses: number;
    growth: number;
    transactionPercent: number;
    newVisitPercent: number;
    bouncePercent: number;
    dailySales: number[] | undefined;
    profitShares: number[] | undefined;
}

export class GetSalesSummaryOutput implements IGetSalesSummaryOutput {
    salesSummary!: SalesSummaryData[] | undefined;

    constructor(data?: IGetSalesSummaryOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["salesSummary"])) {
                this.salesSummary = [] as any;
                for (let item of _data["salesSummary"])
                    this.salesSummary!.push(SalesSummaryData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSalesSummaryOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesSummaryOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.salesSummary)) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSalesSummaryOutput {
    salesSummary: SalesSummaryData[] | undefined;
}

export class NewHireingOutput implements INewHireingOutput {
    empId!: number;
    empCode!: string | undefined;
    name!: string | undefined;
    degination!: string | undefined;
    department!: string | undefined;
    city!: string | undefined;
    phoneNo!: string | undefined;
    date!: moment.Moment;
    status!: string | undefined;
    marriageStatus!: string | undefined;
    image!: string | undefined;
    totalCount!: number;

    constructor(data?: INewHireingOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empId = _data["empId"];
            this.empCode = _data["empCode"];
            this.name = _data["name"];
            this.degination = _data["degination"];
            this.department = _data["department"];
            this.city = _data["city"];
            this.phoneNo = _data["phoneNo"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.marriageStatus = _data["marriageStatus"];
            this.image = _data["image"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): NewHireingOutput {
        data = typeof data === 'object' ? data : {};
        let result = new NewHireingOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empId"] = this.empId;
        data["empCode"] = this.empCode;
        data["name"] = this.name;
        data["degination"] = this.degination;
        data["department"] = this.department;
        data["city"] = this.city;
        data["phoneNo"] = this.phoneNo;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["marriageStatus"] = this.marriageStatus;
        data["image"] = this.image;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface INewHireingOutput {
    empId: number;
    empCode: string | undefined;
    name: string | undefined;
    degination: string | undefined;
    department: string | undefined;
    city: string | undefined;
    phoneNo: string | undefined;
    date: moment.Moment;
    status: string | undefined;
    marriageStatus: string | undefined;
    image: string | undefined;
    totalCount: number;
}

export class DailyWorkScoreDto implements IDailyWorkScoreDto {
    yesterdayScore!: number;
    tillDateScore!: number;

    constructor(data?: IDailyWorkScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.yesterdayScore = _data["yesterdayScore"];
            this.tillDateScore = _data["tillDateScore"];
        }
    }

    static fromJS(data: any): DailyWorkScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new DailyWorkScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["yesterdayScore"] = this.yesterdayScore;
        data["tillDateScore"] = this.tillDateScore;
        return data;
    }
}

export interface IDailyWorkScoreDto {
    yesterdayScore: number;
    tillDateScore: number;
}

export class CreateOrEditPostDto implements ICreateOrEditPostDto {
    post!: string | undefined;
    imagePath!: string | undefined;
    postname!: string | undefined;

    constructor(data?: ICreateOrEditPostDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.post = _data["post"];
            this.imagePath = _data["imagePath"];
            this.postname = _data["postname"];
        }
    }

    static fromJS(data: any): CreateOrEditPostDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPostDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["post"] = this.post;
        data["imagePath"] = this.imagePath;
        data["postname"] = this.postname;
        return data;
    }
}

export interface ICreateOrEditPostDto {
    post: string | undefined;
    imagePath: string | undefined;
    postname: string | undefined;
}

export class PerfetooPost implements IPerfetooPost {
    postedBy!: number;
    approvedBy!: number;
    post!: string | undefined;
    imagePath!: string | undefined;
    postDate!: moment.Moment;
    tenantId!: number;
    tenant!: Tenant;
    id!: number;

    constructor(data?: IPerfetooPost) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postedBy = _data["postedBy"];
            this.approvedBy = _data["approvedBy"];
            this.post = _data["post"];
            this.imagePath = _data["imagePath"];
            this.postDate = _data["postDate"] ? moment(_data["postDate"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PerfetooPost {
        data = typeof data === 'object' ? data : {};
        let result = new PerfetooPost();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postedBy"] = this.postedBy;
        data["approvedBy"] = this.approvedBy;
        data["post"] = this.post;
        data["imagePath"] = this.imagePath;
        data["postDate"] = this.postDate ? this.postDate.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IPerfetooPost {
    postedBy: number;
    approvedBy: number;
    post: string | undefined;
    imagePath: string | undefined;
    postDate: moment.Moment;
    tenantId: number;
    tenant: Tenant;
    id: number;
}

export class TownHallList implements ITownHallList {
    id!: number;
    postBy!: number;
    postContent!: string | undefined;
    count!: number;
    islikes!: number;
    image!: string | undefined;
    pDate!: moment.Moment;
    postbyName!: string | undefined;
    postbyImage!: string | undefined;
    caption!: string | undefined;
    commentCount!: number;
    totalcount!: number;

    constructor(data?: ITownHallList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.postBy = _data["postBy"];
            this.postContent = _data["postContent"];
            this.count = _data["count"];
            this.islikes = _data["islikes"];
            this.image = _data["image"];
            this.pDate = _data["pDate"] ? moment(_data["pDate"].toString()) : <any>undefined;
            this.postbyName = _data["postbyName"];
            this.postbyImage = _data["postbyImage"];
            this.caption = _data["caption"];
            this.commentCount = _data["commentCount"];
            this.totalcount = _data["totalcount"];
        }
    }

    static fromJS(data: any): TownHallList {
        data = typeof data === 'object' ? data : {};
        let result = new TownHallList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["postBy"] = this.postBy;
        data["postContent"] = this.postContent;
        data["count"] = this.count;
        data["islikes"] = this.islikes;
        data["image"] = this.image;
        data["pDate"] = this.pDate ? this.pDate.toISOString() : <any>undefined;
        data["postbyName"] = this.postbyName;
        data["postbyImage"] = this.postbyImage;
        data["caption"] = this.caption;
        data["commentCount"] = this.commentCount;
        data["totalcount"] = this.totalcount;
        return data;
    }
}

export interface ITownHallList {
    id: number;
    postBy: number;
    postContent: string | undefined;
    count: number;
    islikes: number;
    image: string | undefined;
    pDate: moment.Moment;
    postbyName: string | undefined;
    postbyImage: string | undefined;
    caption: string | undefined;
    commentCount: number;
    totalcount: number;
}

export class KraData implements IKraData {
    krA_Name!: string | undefined;
    kpI_Name!: string | undefined;
    employeeId!: number;
    weightage!: number;

    constructor(data?: IKraData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.krA_Name = _data["krA_Name"];
            this.kpI_Name = _data["kpI_Name"];
            this.employeeId = _data["employeeId"];
            this.weightage = _data["weightage"];
        }
    }

    static fromJS(data: any): KraData {
        data = typeof data === 'object' ? data : {};
        let result = new KraData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["krA_Name"] = this.krA_Name;
        data["kpI_Name"] = this.kpI_Name;
        data["employeeId"] = this.employeeId;
        data["weightage"] = this.weightage;
        return data;
    }
}

export interface IKraData {
    krA_Name: string | undefined;
    kpI_Name: string | undefined;
    employeeId: number;
    weightage: number;
}

export class ResponseList implements IResponseList {
    postid!: number;
    reactedBy!: number;
    liked!: number;
    comment!: string | undefined;

    constructor(data?: IResponseList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postid = _data["postid"];
            this.reactedBy = _data["reactedBy"];
            this.liked = _data["liked"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): ResponseList {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postid"] = this.postid;
        data["reactedBy"] = this.reactedBy;
        data["liked"] = this.liked;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IResponseList {
    postid: number;
    reactedBy: number;
    liked: number;
    comment: string | undefined;
}

export class CommentList implements ICommentList {
    id!: number;
    postid!: number;
    reactedBy!: number;
    liked!: number;
    comment!: string | undefined;
    reactorName!: string | undefined;
    image!: string | undefined;

    constructor(data?: ICommentList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.postid = _data["postid"];
            this.reactedBy = _data["reactedBy"];
            this.liked = _data["liked"];
            this.comment = _data["comment"];
            this.reactorName = _data["reactorName"];
            this.image = _data["image"];
        }
    }

    static fromJS(data: any): CommentList {
        data = typeof data === 'object' ? data : {};
        let result = new CommentList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["postid"] = this.postid;
        data["reactedBy"] = this.reactedBy;
        data["liked"] = this.liked;
        data["comment"] = this.comment;
        data["reactorName"] = this.reactorName;
        data["image"] = this.image;
        return data;
    }
}

export interface ICommentList {
    id: number;
    postid: number;
    reactedBy: number;
    liked: number;
    comment: string | undefined;
    reactorName: string | undefined;
    image: string | undefined;
}

export class DropDownQucikLinks implements IDropDownQucikLinks {
    uRl!: string | undefined;
    label!: string | undefined;
    totalCount!: number;

    constructor(data?: IDropDownQucikLinks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uRl = _data["uRl"];
            this.label = _data["label"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DropDownQucikLinks {
        data = typeof data === 'object' ? data : {};
        let result = new DropDownQucikLinks();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uRl"] = this.uRl;
        data["label"] = this.label;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IDropDownQucikLinks {
    uRl: string | undefined;
    label: string | undefined;
    totalCount: number;
}

export class AnnouncemntCount implements IAnnouncemntCount {
    name!: string | undefined;
    annnouncemnetDate!: moment.Moment | undefined;

    constructor(data?: IAnnouncemntCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.annnouncemnetDate = _data["annnouncemnetDate"] ? moment(_data["annnouncemnetDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AnnouncemntCount {
        data = typeof data === 'object' ? data : {};
        let result = new AnnouncemntCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["annnouncemnetDate"] = this.annnouncemnetDate ? this.annnouncemnetDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAnnouncemntCount {
    name: string | undefined;
    annnouncemnetDate: moment.Moment | undefined;
}

export class NewOpenings implements INewOpenings {
    name!: string | undefined;
    keySkills!: string | undefined;
    qualification!: string | undefined;
    descripion!: string | undefined;
    experinvceS!: string | undefined;
    closed!: boolean;
    type!: string | undefined;
    totalCount!: number;

    constructor(data?: INewOpenings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.keySkills = _data["keySkills"];
            this.qualification = _data["qualification"];
            this.descripion = _data["descripion"];
            this.experinvceS = _data["experinvceS"];
            this.closed = _data["closed"];
            this.type = _data["type"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): NewOpenings {
        data = typeof data === 'object' ? data : {};
        let result = new NewOpenings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["keySkills"] = this.keySkills;
        data["qualification"] = this.qualification;
        data["descripion"] = this.descripion;
        data["experinvceS"] = this.experinvceS;
        data["closed"] = this.closed;
        data["type"] = this.type;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface INewOpenings {
    name: string | undefined;
    keySkills: string | undefined;
    qualification: string | undefined;
    descripion: string | undefined;
    experinvceS: string | undefined;
    closed: boolean;
    type: string | undefined;
    totalCount: number;
}

export class PolicyeCountCount implements IPolicyeCountCount {
    name!: string | undefined;
    doucumnetName!: string | undefined;
    doucumnetUrl!: string | undefined;
    image!: string | undefined;
    totalCount!: number;

    constructor(data?: IPolicyeCountCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.doucumnetName = _data["doucumnetName"];
            this.doucumnetUrl = _data["doucumnetUrl"];
            this.image = _data["image"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PolicyeCountCount {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyeCountCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["doucumnetName"] = this.doucumnetName;
        data["doucumnetUrl"] = this.doucumnetUrl;
        data["image"] = this.image;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPolicyeCountCount {
    name: string | undefined;
    doucumnetName: string | undefined;
    doucumnetUrl: string | undefined;
    image: string | undefined;
    totalCount: number;
}

export class RegionalStatCountry implements IRegionalStatCountry {
    countryName!: string | undefined;
    sales!: number;
    change!: number[] | undefined;
    averagePrice!: number;
    totalPrice!: number;

    constructor(data?: IRegionalStatCountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryName = _data["countryName"];
            this.sales = _data["sales"];
            if (Array.isArray(_data["change"])) {
                this.change = [] as any;
                for (let item of _data["change"])
                    this.change!.push(item);
            }
            this.averagePrice = _data["averagePrice"];
            this.totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): RegionalStatCountry {
        data = typeof data === 'object' ? data : {};
        let result = new RegionalStatCountry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryName"] = this.countryName;
        data["sales"] = this.sales;
        if (Array.isArray(this.change)) {
            data["change"] = [];
            for (let item of this.change)
                data["change"].push(item);
        }
        data["averagePrice"] = this.averagePrice;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}

export interface IRegionalStatCountry {
    countryName: string | undefined;
    sales: number;
    change: number[] | undefined;
    averagePrice: number;
    totalPrice: number;
}

export class GetRegionalStatsOutput implements IGetRegionalStatsOutput {
    stats!: RegionalStatCountry[] | undefined;

    constructor(data?: IGetRegionalStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["stats"])) {
                this.stats = [] as any;
                for (let item of _data["stats"])
                    this.stats!.push(RegionalStatCountry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRegionalStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegionalStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stats)) {
            data["stats"] = [];
            for (let item of this.stats)
                data["stats"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRegionalStatsOutput {
    stats: RegionalStatCountry[] | undefined;
}

export class GetGeneralStatsOutput implements IGetGeneralStatsOutput {
    transactionPercent!: number;
    newVisitPercent!: number;
    bouncePercent!: number;

    constructor(data?: IGetGeneralStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionPercent = _data["transactionPercent"];
            this.newVisitPercent = _data["newVisitPercent"];
            this.bouncePercent = _data["bouncePercent"];
        }
    }

    static fromJS(data: any): GetGeneralStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeneralStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        return data;
    }
}

export interface IGetGeneralStatsOutput {
    transactionPercent: number;
    newVisitPercent: number;
    bouncePercent: number;
}

export class PerformanceScoreDto implements IPerformanceScoreDto {
    cycle!: string | undefined;
    finalSubmittedOn!: moment.Moment | undefined;
    score!: number;

    constructor(data?: IPerformanceScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cycle = _data["cycle"];
            this.finalSubmittedOn = _data["finalSubmittedOn"] ? moment(_data["finalSubmittedOn"].toString()) : <any>undefined;
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): PerformanceScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new PerformanceScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cycle"] = this.cycle;
        data["finalSubmittedOn"] = this.finalSubmittedOn ? this.finalSubmittedOn.toISOString() : <any>undefined;
        data["score"] = this.score;
        return data;
    }
}

export interface IPerformanceScoreDto {
    cycle: string | undefined;
    finalSubmittedOn: moment.Moment | undefined;
    score: number;
}

export class QuarterRange implements IQuarterRange {
    fromdate!: moment.Moment;
    todate!: moment.Moment;

    constructor(data?: IQuarterRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromdate = _data["fromdate"] ? moment(_data["fromdate"].toString()) : <any>undefined;
            this.todate = _data["todate"] ? moment(_data["todate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): QuarterRange {
        data = typeof data === 'object' ? data : {};
        let result = new QuarterRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromdate"] = this.fromdate ? this.fromdate.toISOString() : <any>undefined;
        data["todate"] = this.todate ? this.todate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IQuarterRange {
    fromdate: moment.Moment;
    todate: moment.Moment;
}

export class HalfYearRange implements IHalfYearRange {
    fromdate!: moment.Moment;
    todate!: moment.Moment;

    constructor(data?: IHalfYearRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromdate = _data["fromdate"] ? moment(_data["fromdate"].toString()) : <any>undefined;
            this.todate = _data["todate"] ? moment(_data["todate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HalfYearRange {
        data = typeof data === 'object' ? data : {};
        let result = new HalfYearRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromdate"] = this.fromdate ? this.fromdate.toISOString() : <any>undefined;
        data["todate"] = this.todate ? this.todate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IHalfYearRange {
    fromdate: moment.Moment;
    todate: moment.Moment;
}

export enum SubscriptionStartType {
    Free = 1,
    Trial = 2,
    Paid = 3,
}

export class RegisterTenantInput implements IRegisterTenantInput {
    tenancyName!: string;
    name!: string | undefined;
    tenancyAddress!: string | undefined;
    tenancyRemarks!: string | undefined;
    maxusercount!: number;
    graceEmployee!: number;
    adminEmailAddress!: string;
    adminPassword!: string | undefined;
    captchaResponse!: string | undefined;
    subscriptionStartType!: SubscriptionStartType;
    editionId!: number | undefined;
    leaveCycle!: number | undefined;
    performanceCycle!: number | undefined;
    showLeaveOnss!: boolean;
    mrrExists!: boolean;
    erpExists!: boolean;

    constructor(data?: IRegisterTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.tenancyAddress = _data["tenancyAddress"];
            this.tenancyRemarks = _data["tenancyRemarks"];
            this.maxusercount = _data["maxusercount"];
            this.graceEmployee = _data["graceEmployee"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.adminPassword = _data["adminPassword"];
            this.captchaResponse = _data["captchaResponse"];
            this.subscriptionStartType = _data["subscriptionStartType"];
            this.editionId = _data["editionId"];
            this.leaveCycle = _data["leaveCycle"];
            this.performanceCycle = _data["performanceCycle"];
            this.showLeaveOnss = _data["showLeaveOnss"];
            this.mrrExists = _data["mrrExists"];
            this.erpExists = _data["erpExists"];
        }
    }

    static fromJS(data: any): RegisterTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["tenancyAddress"] = this.tenancyAddress;
        data["tenancyRemarks"] = this.tenancyRemarks;
        data["maxusercount"] = this.maxusercount;
        data["graceEmployee"] = this.graceEmployee;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["captchaResponse"] = this.captchaResponse;
        data["subscriptionStartType"] = this.subscriptionStartType;
        data["editionId"] = this.editionId;
        data["leaveCycle"] = this.leaveCycle;
        data["performanceCycle"] = this.performanceCycle;
        data["showLeaveOnss"] = this.showLeaveOnss;
        data["mrrExists"] = this.mrrExists;
        data["erpExists"] = this.erpExists;
        return data;
    }
}

export interface IRegisterTenantInput {
    tenancyName: string;
    name: string | undefined;
    tenancyAddress: string | undefined;
    tenancyRemarks: string | undefined;
    maxusercount: number;
    graceEmployee: number;
    adminEmailAddress: string;
    adminPassword: string | undefined;
    captchaResponse: string | undefined;
    subscriptionStartType: SubscriptionStartType;
    editionId: number | undefined;
    leaveCycle: number | undefined;
    performanceCycle: number | undefined;
    showLeaveOnss: boolean;
    mrrExists: boolean;
    erpExists: boolean;
}

export class RegisterTenantOutput implements IRegisterTenantOutput {
    tenantId!: number;
    tenancyAddress!: string | undefined;
    tenancyName!: string | undefined;
    remarks!: string | undefined;
    name!: string | undefined;
    maxUserCount!: number;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    isTenantActive!: boolean;
    isActive!: boolean;
    isEmailConfirmationRequired!: boolean;
    leaveCycle!: number | undefined;
    performanceCycle!: number | undefined;

    constructor(data?: IRegisterTenantOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenancyAddress = _data["tenancyAddress"];
            this.tenancyName = _data["tenancyName"];
            this.remarks = _data["remarks"];
            this.name = _data["name"];
            this.maxUserCount = _data["maxUserCount"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.isTenantActive = _data["isTenantActive"];
            this.isActive = _data["isActive"];
            this.isEmailConfirmationRequired = _data["isEmailConfirmationRequired"];
            this.leaveCycle = _data["leaveCycle"];
            this.performanceCycle = _data["performanceCycle"];
        }
    }

    static fromJS(data: any): RegisterTenantOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterTenantOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyAddress"] = this.tenancyAddress;
        data["tenancyName"] = this.tenancyName;
        data["remarks"] = this.remarks;
        data["name"] = this.name;
        data["maxUserCount"] = this.maxUserCount;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["isTenantActive"] = this.isTenantActive;
        data["isActive"] = this.isActive;
        data["isEmailConfirmationRequired"] = this.isEmailConfirmationRequired;
        data["leaveCycle"] = this.leaveCycle;
        data["performanceCycle"] = this.performanceCycle;
        return data;
    }
}

export interface IRegisterTenantOutput {
    tenantId: number;
    tenancyAddress: string | undefined;
    tenancyName: string | undefined;
    remarks: string | undefined;
    name: string | undefined;
    maxUserCount: number;
    userName: string | undefined;
    emailAddress: string | undefined;
    isTenantActive: boolean;
    isActive: boolean;
    isEmailConfirmationRequired: boolean;
    leaveCycle: number | undefined;
    performanceCycle: number | undefined;
}

export class IInputType implements IIInputType {
    readonly name!: string | undefined;
    readonly attributes!: { [key: string]: any; } | undefined;
    validator!: IValueValidator;

    constructor(data?: IIInputType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            if (_data["attributes"]) {
                (<any>this).attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (<any>(<any>this).attributes)![key] = _data["attributes"][key];
                }
            }
            this.validator = _data["validator"] ? IValueValidator.fromJS(_data["validator"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IInputType {
        data = typeof data === 'object' ? data : {};
        let result = new IInputType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (<any>data["attributes"])[key] = (<any>this.attributes)[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIInputType {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
    validator: IValueValidator;
}

export class FlatFeatureSelectDto implements IFlatFeatureSelectDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    defaultValue!: string | undefined;
    inputType!: IInputType;
    textHtmlColor!: string | undefined;

    constructor(data?: IFlatFeatureSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            this.inputType = _data["inputType"] ? IInputType.fromJS(_data["inputType"]) : <any>undefined;
            this.textHtmlColor = _data["textHtmlColor"];
        }
    }

    static fromJS(data: any): FlatFeatureSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatFeatureSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        data["textHtmlColor"] = this.textHtmlColor;
        return data;
    }
}

export interface IFlatFeatureSelectDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: IInputType;
    textHtmlColor: string | undefined;
}

export class EditionWithFeaturesDto implements IEditionWithFeaturesDto {
    edition!: EditionSelectDto;
    featureValues!: NameValueDto[] | undefined;

    constructor(data?: IEditionWithFeaturesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionSelectDto.fromJS(_data["edition"]) : <any>undefined;
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionWithFeaturesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionWithFeaturesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditionWithFeaturesDto {
    edition: EditionSelectDto;
    featureValues: NameValueDto[] | undefined;
}

export class EditionsSelectOutput implements IEditionsSelectOutput {
    allFeatures!: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures!: EditionWithFeaturesDto[] | undefined;
    tenantEditionId!: number | undefined;

    constructor(data?: IEditionsSelectOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["allFeatures"])) {
                this.allFeatures = [] as any;
                for (let item of _data["allFeatures"])
                    this.allFeatures!.push(FlatFeatureSelectDto.fromJS(item));
            }
            if (Array.isArray(_data["editionsWithFeatures"])) {
                this.editionsWithFeatures = [] as any;
                for (let item of _data["editionsWithFeatures"])
                    this.editionsWithFeatures!.push(EditionWithFeaturesDto.fromJS(item));
            }
            this.tenantEditionId = _data["tenantEditionId"];
        }
    }

    static fromJS(data: any): EditionsSelectOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EditionsSelectOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allFeatures)) {
            data["allFeatures"] = [];
            for (let item of this.allFeatures)
                data["allFeatures"].push(item.toJSON());
        }
        if (Array.isArray(this.editionsWithFeatures)) {
            data["editionsWithFeatures"] = [];
            for (let item of this.editionsWithFeatures)
                data["editionsWithFeatures"].push(item.toJSON());
        }
        data["tenantEditionId"] = this.tenantEditionId;
        return data;
    }
}

export interface IEditionsSelectOutput {
    allFeatures: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures: EditionWithFeaturesDto[] | undefined;
    tenantEditionId: number | undefined;
}

export class TenantUserManagementSettingsEditDto implements ITenantUserManagementSettingsEditDto {
    allowSelfRegistration!: boolean;
    isNewRegisteredUserActiveByDefault!: boolean;
    isEmailConfirmationRequiredForLogin!: boolean;
    useCaptchaOnRegistration!: boolean;
    isCookieConsentEnabled!: boolean;
    isQuickThemeSelectEnabled!: boolean;

    constructor(data?: ITenantUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowSelfRegistration = _data["allowSelfRegistration"];
            this.isNewRegisteredUserActiveByDefault = _data["isNewRegisteredUserActiveByDefault"];
            this.isEmailConfirmationRequiredForLogin = _data["isEmailConfirmationRequiredForLogin"];
            this.useCaptchaOnRegistration = _data["useCaptchaOnRegistration"];
            this.isCookieConsentEnabled = _data["isCookieConsentEnabled"];
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
        }
    }

    static fromJS(data: any): TenantUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredUserActiveByDefault"] = this.isNewRegisteredUserActiveByDefault;
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        return data;
    }
}

export interface ITenantUserManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredUserActiveByDefault: boolean;
    isEmailConfirmationRequiredForLogin: boolean;
    useCaptchaOnRegistration: boolean;
    isCookieConsentEnabled: boolean;
    isQuickThemeSelectEnabled: boolean;
}

export class TenantEmailSettingsEditDto implements ITenantEmailSettingsEditDto {
    useHostDefaultEmailSettings!: boolean;
    defaultFromAddress!: string | undefined;
    defaultFromDisplayName!: string | undefined;
    smtpHost!: string | undefined;
    smtpPort!: number;
    smtpUserName!: string | undefined;
    smtpPassword!: string | undefined;
    smtpDomain!: string | undefined;
    smtpEnableSsl!: boolean;
    smtpUseDefaultCredentials!: boolean;

    constructor(data?: ITenantEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.useHostDefaultEmailSettings = _data["useHostDefaultEmailSettings"];
            this.defaultFromAddress = _data["defaultFromAddress"];
            this.defaultFromDisplayName = _data["defaultFromDisplayName"];
            this.smtpHost = _data["smtpHost"];
            this.smtpPort = _data["smtpPort"];
            this.smtpUserName = _data["smtpUserName"];
            this.smtpPassword = _data["smtpPassword"];
            this.smtpDomain = _data["smtpDomain"];
            this.smtpEnableSsl = _data["smtpEnableSsl"];
            this.smtpUseDefaultCredentials = _data["smtpUseDefaultCredentials"];
        }
    }

    static fromJS(data: any): TenantEmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useHostDefaultEmailSettings"] = this.useHostDefaultEmailSettings;
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        return data;
    }
}

export interface ITenantEmailSettingsEditDto {
    useHostDefaultEmailSettings: boolean;
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;
}

export class LdapSettingsEditDto implements ILdapSettingsEditDto {
    isModuleEnabled!: boolean;
    isEnabled!: boolean;
    domain!: string | undefined;
    userName!: string | undefined;
    password!: string | undefined;

    constructor(data?: ILdapSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isModuleEnabled = _data["isModuleEnabled"];
            this.isEnabled = _data["isEnabled"];
            this.domain = _data["domain"];
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LdapSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new LdapSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isModuleEnabled"] = this.isModuleEnabled;
        data["isEnabled"] = this.isEnabled;
        data["domain"] = this.domain;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface ILdapSettingsEditDto {
    isModuleEnabled: boolean;
    isEnabled: boolean;
    domain: string | undefined;
    userName: string | undefined;
    password: string | undefined;
}

export class TenantBillingSettingsEditDto implements ITenantBillingSettingsEditDto {
    legalName!: string | undefined;
    address!: string | undefined;
    taxVatNo!: string | undefined;

    constructor(data?: ITenantBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalName = _data["legalName"];
            this.address = _data["address"];
            this.taxVatNo = _data["taxVatNo"];
        }
    }

    static fromJS(data: any): TenantBillingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        data["taxVatNo"] = this.taxVatNo;
        return data;
    }
}

export interface ITenantBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
    taxVatNo: string | undefined;
}

export class TenantOtherSettingsEditDto implements ITenantOtherSettingsEditDto {
    isQuickThemeSelectEnabled!: boolean;

    constructor(data?: ITenantOtherSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
        }
    }

    static fromJS(data: any): TenantOtherSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantOtherSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        return data;
    }
}

export interface ITenantOtherSettingsEditDto {
    isQuickThemeSelectEnabled: boolean;
}

export class TenantSettingsEditDto implements ITenantSettingsEditDto {
    general!: GeneralSettingsEditDto;
    userManagement!: TenantUserManagementSettingsEditDto;
    email!: TenantEmailSettingsEditDto;
    ldap!: LdapSettingsEditDto;
    security!: SecuritySettingsEditDto;
    billing!: TenantBillingSettingsEditDto;
    otherSettings!: TenantOtherSettingsEditDto;

    constructor(data?: ITenantSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userManagement = new TenantUserManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneralSettingsEditDto.fromJS(_data["general"]) : <any>undefined;
            this.userManagement = _data["userManagement"] ? TenantUserManagementSettingsEditDto.fromJS(_data["userManagement"]) : new TenantUserManagementSettingsEditDto();
            this.email = _data["email"] ? TenantEmailSettingsEditDto.fromJS(_data["email"]) : <any>undefined;
            this.ldap = _data["ldap"] ? LdapSettingsEditDto.fromJS(_data["ldap"]) : <any>undefined;
            this.security = _data["security"] ? SecuritySettingsEditDto.fromJS(_data["security"]) : new SecuritySettingsEditDto();
            this.billing = _data["billing"] ? TenantBillingSettingsEditDto.fromJS(_data["billing"]) : <any>undefined;
            this.otherSettings = _data["otherSettings"] ? TenantOtherSettingsEditDto.fromJS(_data["otherSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["ldap"] = this.ldap ? this.ldap.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        data["otherSettings"] = this.otherSettings ? this.otherSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITenantSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: TenantUserManagementSettingsEditDto;
    email: TenantEmailSettingsEditDto;
    ldap: LdapSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: TenantBillingSettingsEditDto;
    otherSettings: TenantOtherSettingsEditDto;
}

export class Logodto implements ILogodto {
    tenantId!: number;
    logoname!: string | undefined;
    iamgeUrl!: string | undefined;
    logoFileType!: string | undefined;
    logoId!: number;

    constructor(data?: ILogodto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.logoname = _data["logoname"];
            this.iamgeUrl = _data["iamgeUrl"];
            this.logoFileType = _data["logoFileType"];
            this.logoId = _data["logoId"];
        }
    }

    static fromJS(data: any): Logodto {
        data = typeof data === 'object' ? data : {};
        let result = new Logodto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["logoname"] = this.logoname;
        data["iamgeUrl"] = this.iamgeUrl;
        data["logoFileType"] = this.logoFileType;
        data["logoId"] = this.logoId;
        return data;
    }
}

export interface ILogodto {
    tenantId: number;
    logoname: string | undefined;
    iamgeUrl: string | undefined;
    logoFileType: string | undefined;
    logoId: number;
}

export class SubmitTimeSheetDto implements ISubmitTimeSheetDto {
    fkEmployeeId!: number;
    timeSheetDate!: moment.Moment;
    reportingManager!: boolean | undefined;

    constructor(data?: ISubmitTimeSheetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fkEmployeeId = _data["fkEmployeeId"];
            this.timeSheetDate = _data["timeSheetDate"] ? moment(_data["timeSheetDate"].toString()) : <any>undefined;
            this.reportingManager = _data["reportingManager"];
        }
    }

    static fromJS(data: any): SubmitTimeSheetDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitTimeSheetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fkEmployeeId"] = this.fkEmployeeId;
        data["timeSheetDate"] = this.timeSheetDate ? this.timeSheetDate.toISOString() : <any>undefined;
        data["reportingManager"] = this.reportingManager;
        return data;
    }
}

export interface ISubmitTimeSheetDto {
    fkEmployeeId: number;
    timeSheetDate: moment.Moment;
    reportingManager: boolean | undefined;
}

export class GetTimeSheetForApprovalDto implements IGetTimeSheetForApprovalDto {
    timeSheetHeaderId!: number;
    timeSheetDate!: string | undefined;
    employeeId!: number;

    constructor(data?: IGetTimeSheetForApprovalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeSheetHeaderId = _data["timeSheetHeaderId"];
            this.timeSheetDate = _data["timeSheetDate"];
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): GetTimeSheetForApprovalDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTimeSheetForApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeSheetHeaderId"] = this.timeSheetHeaderId;
        data["timeSheetDate"] = this.timeSheetDate;
        data["employeeId"] = this.employeeId;
        return data;
    }
}

export interface IGetTimeSheetForApprovalDto {
    timeSheetHeaderId: number;
    timeSheetDate: string | undefined;
    employeeId: number;
}

export enum SettingScopes {
    Application = 1,
    Tenant = 2,
    User = 4,
    All = 7,
}

export class ListResultDtoOfNameValueDto implements IListResultDtoOfNameValueDto {
    items!: NameValueDto[] | undefined;

    constructor(data?: IListResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfNameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfNameValueDto {
    items: NameValueDto[] | undefined;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress!: string;
    password!: string;
    twoFactorVerificationCode!: string | undefined;
    rememberClient!: boolean;
    twoFactorRememberClientToken!: string | undefined;
    singleSignIn!: boolean | undefined;
    returnUrl!: string | undefined;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.twoFactorVerificationCode = _data["twoFactorVerificationCode"];
            this.rememberClient = _data["rememberClient"];
            this.twoFactorRememberClientToken = _data["twoFactorRememberClientToken"];
            this.singleSignIn = _data["singleSignIn"];
            this.returnUrl = _data["returnUrl"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["twoFactorVerificationCode"] = this.twoFactorVerificationCode;
        data["rememberClient"] = this.rememberClient;
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["singleSignIn"] = this.singleSignIn;
        data["returnUrl"] = this.returnUrl;
        return data;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    twoFactorVerificationCode: string | undefined;
    rememberClient: boolean;
    twoFactorRememberClientToken: string | undefined;
    singleSignIn: boolean | undefined;
    returnUrl: string | undefined;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    shouldResetPassword!: boolean;
    passwordResetCode!: string | undefined;
    userId!: number;
    requiresTwoFactorVerification!: boolean;
    twoFactorAuthProviders!: string[] | undefined;
    twoFactorRememberClientToken!: string | undefined;
    returnUrl!: string | undefined;
    refreshToken!: string | undefined;
    tenantId!: number;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.shouldResetPassword = _data["shouldResetPassword"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.userId = _data["userId"];
            this.requiresTwoFactorVerification = _data["requiresTwoFactorVerification"];
            if (Array.isArray(_data["twoFactorAuthProviders"])) {
                this.twoFactorAuthProviders = [] as any;
                for (let item of _data["twoFactorAuthProviders"])
                    this.twoFactorAuthProviders!.push(item);
            }
            this.twoFactorRememberClientToken = _data["twoFactorRememberClientToken"];
            this.returnUrl = _data["returnUrl"];
            this.refreshToken = _data["refreshToken"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["shouldResetPassword"] = this.shouldResetPassword;
        data["passwordResetCode"] = this.passwordResetCode;
        data["userId"] = this.userId;
        data["requiresTwoFactorVerification"] = this.requiresTwoFactorVerification;
        if (Array.isArray(this.twoFactorAuthProviders)) {
            data["twoFactorAuthProviders"] = [];
            for (let item of this.twoFactorAuthProviders)
                data["twoFactorAuthProviders"].push(item);
        }
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["returnUrl"] = this.returnUrl;
        data["refreshToken"] = this.refreshToken;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    shouldResetPassword: boolean;
    passwordResetCode: string | undefined;
    userId: number;
    requiresTwoFactorVerification: boolean;
    twoFactorAuthProviders: string[] | undefined;
    twoFactorRememberClientToken: string | undefined;
    returnUrl: string | undefined;
    refreshToken: string | undefined;
    tenantId: number;
}

export class MobileAuthenticateResultModel implements IMobileAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    shouldResetPassword!: boolean;
    passwordResetCode!: string | undefined;
    userId!: number;
    specialFacialRecognition!: boolean | undefined;
    isDistenceTravelTrackingEnable!: boolean | undefined;
    gpsTrackingInterval!: number | undefined;
    requiresTwoFactorVerification!: boolean;
    twoFactorAuthProviders!: string[] | undefined;
    twoFactorRememberClientToken!: string | undefined;
    returnUrl!: string | undefined;
    refreshToken!: string | undefined;
    tenantId!: number;
    employeeId!: number;
    employeeName!: string | undefined;
    deviceId!: string | undefined;
    organizationLogo!: string | undefined;
    organizationName!: string | undefined;

    constructor(data?: IMobileAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.shouldResetPassword = _data["shouldResetPassword"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.userId = _data["userId"];
            this.specialFacialRecognition = _data["specialFacialRecognition"];
            this.isDistenceTravelTrackingEnable = _data["isDistenceTravelTrackingEnable"];
            this.gpsTrackingInterval = _data["gpsTrackingInterval"];
            this.requiresTwoFactorVerification = _data["requiresTwoFactorVerification"];
            if (Array.isArray(_data["twoFactorAuthProviders"])) {
                this.twoFactorAuthProviders = [] as any;
                for (let item of _data["twoFactorAuthProviders"])
                    this.twoFactorAuthProviders!.push(item);
            }
            this.twoFactorRememberClientToken = _data["twoFactorRememberClientToken"];
            this.returnUrl = _data["returnUrl"];
            this.refreshToken = _data["refreshToken"];
            this.tenantId = _data["tenantId"];
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.deviceId = _data["deviceId"];
            this.organizationLogo = _data["organizationLogo"];
            this.organizationName = _data["organizationName"];
        }
    }

    static fromJS(data: any): MobileAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new MobileAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["shouldResetPassword"] = this.shouldResetPassword;
        data["passwordResetCode"] = this.passwordResetCode;
        data["userId"] = this.userId;
        data["specialFacialRecognition"] = this.specialFacialRecognition;
        data["isDistenceTravelTrackingEnable"] = this.isDistenceTravelTrackingEnable;
        data["gpsTrackingInterval"] = this.gpsTrackingInterval;
        data["requiresTwoFactorVerification"] = this.requiresTwoFactorVerification;
        if (Array.isArray(this.twoFactorAuthProviders)) {
            data["twoFactorAuthProviders"] = [];
            for (let item of this.twoFactorAuthProviders)
                data["twoFactorAuthProviders"].push(item);
        }
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["returnUrl"] = this.returnUrl;
        data["refreshToken"] = this.refreshToken;
        data["tenantId"] = this.tenantId;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["deviceId"] = this.deviceId;
        data["organizationLogo"] = this.organizationLogo;
        data["organizationName"] = this.organizationName;
        return data;
    }
}

export interface IMobileAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    shouldResetPassword: boolean;
    passwordResetCode: string | undefined;
    userId: number;
    specialFacialRecognition: boolean | undefined;
    isDistenceTravelTrackingEnable: boolean | undefined;
    gpsTrackingInterval: number | undefined;
    requiresTwoFactorVerification: boolean;
    twoFactorAuthProviders: string[] | undefined;
    twoFactorRememberClientToken: string | undefined;
    returnUrl: string | undefined;
    refreshToken: string | undefined;
    tenantId: number;
    employeeId: number;
    employeeName: string | undefined;
    deviceId: string | undefined;
    organizationLogo: string | undefined;
    organizationName: string | undefined;
}

export class RefreshTokenResult implements IRefreshTokenResult {
    accessToken!: string | undefined;

    constructor(data?: IRefreshTokenResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
        }
    }

    static fromJS(data: any): RefreshTokenResult {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        return data;
    }
}

export interface IRefreshTokenResult {
    accessToken: string | undefined;
}

export class SendTwoFactorAuthCodeModel implements ISendTwoFactorAuthCodeModel {
    userId!: number;
    provider!: string;

    constructor(data?: ISendTwoFactorAuthCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.provider = _data["provider"];
        }
    }

    static fromJS(data: any): SendTwoFactorAuthCodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendTwoFactorAuthCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["provider"] = this.provider;
        return data;
    }
}

export interface ISendTwoFactorAuthCodeModel {
    userId: number;
    provider: string;
}

export class ImpersonatedAuthenticateResultModel implements IImpersonatedAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: IImpersonatedAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): ImpersonatedAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonatedAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface IImpersonatedAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class SwitchedAccountAuthenticateResultModel implements ISwitchedAccountAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: ISwitchedAccountAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): SwitchedAccountAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchedAccountAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface ISwitchedAccountAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name!: string | undefined;
    clientId!: string | undefined;
    additionalParams!: { [key: string]: string; } | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
            if (_data["additionalParams"]) {
                this.additionalParams = {} as any;
                for (let key in _data["additionalParams"]) {
                    if (_data["additionalParams"].hasOwnProperty(key))
                        (<any>this.additionalParams)![key] = _data["additionalParams"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        if (this.additionalParams) {
            data["additionalParams"] = {};
            for (let key in this.additionalParams) {
                if (this.additionalParams.hasOwnProperty(key))
                    (<any>data["additionalParams"])[key] = (<any>this.additionalParams)[key];
            }
        }
        return data;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
    additionalParams: { [key: string]: string; } | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider!: string;
    providerKey!: string;
    providerAccessCode!: string;
    returnUrl!: string | undefined;
    singleSignIn!: boolean | undefined;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
            this.returnUrl = _data["returnUrl"];
            this.singleSignIn = _data["singleSignIn"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        return data;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
    returnUrl: string | undefined;
    singleSignIn: boolean | undefined;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    waitingForActivation!: boolean;
    returnUrl!: string | undefined;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
            this.returnUrl = _data["returnUrl"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        data["returnUrl"] = this.returnUrl;
        return data;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
    returnUrl: string | undefined;
}

export class TrnAssetMasterDetailsDto implements ITrnAssetMasterDetailsDto {
    assigne_Return!: string | undefined;
    date!: moment.Moment;
    from_To!: number;
    assetId!: number | undefined;
    id!: number;

    constructor(data?: ITrnAssetMasterDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assigne_Return = _data["assigne_Return"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.from_To = _data["from_To"];
            this.assetId = _data["assetId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TrnAssetMasterDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrnAssetMasterDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assigne_Return"] = this.assigne_Return;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["from_To"] = this.from_To;
        data["assetId"] = this.assetId;
        data["id"] = this.id;
        return data;
    }
}

export interface ITrnAssetMasterDetailsDto {
    assigne_Return: string | undefined;
    date: moment.Moment;
    from_To: number;
    assetId: number | undefined;
    id: number;
}

export class GetTrnAssetMasterDetailsForViewDto implements IGetTrnAssetMasterDetailsForViewDto {
    trnAssetMasterDetails!: TrnAssetMasterDetailsDto;
    assetAssetName!: string | undefined;

    constructor(data?: IGetTrnAssetMasterDetailsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trnAssetMasterDetails = _data["trnAssetMasterDetails"] ? TrnAssetMasterDetailsDto.fromJS(_data["trnAssetMasterDetails"]) : <any>undefined;
            this.assetAssetName = _data["assetAssetName"];
        }
    }

    static fromJS(data: any): GetTrnAssetMasterDetailsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrnAssetMasterDetailsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trnAssetMasterDetails"] = this.trnAssetMasterDetails ? this.trnAssetMasterDetails.toJSON() : <any>undefined;
        data["assetAssetName"] = this.assetAssetName;
        return data;
    }
}

export interface IGetTrnAssetMasterDetailsForViewDto {
    trnAssetMasterDetails: TrnAssetMasterDetailsDto;
    assetAssetName: string | undefined;
}

export class PagedResultDtoOfGetTrnAssetMasterDetailsForViewDto implements IPagedResultDtoOfGetTrnAssetMasterDetailsForViewDto {
    totalCount!: number;
    items!: GetTrnAssetMasterDetailsForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTrnAssetMasterDetailsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTrnAssetMasterDetailsForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTrnAssetMasterDetailsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTrnAssetMasterDetailsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTrnAssetMasterDetailsForViewDto {
    totalCount: number;
    items: GetTrnAssetMasterDetailsForViewDto[] | undefined;
}

export class GetTrnAssetMasterDetailsForEditOutput implements IGetTrnAssetMasterDetailsForEditOutput {
    trnAssetMasterDetails!: CreateOrEditTrnAssetMasterDetailsDto;
    assetAssetName!: string | undefined;

    constructor(data?: IGetTrnAssetMasterDetailsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trnAssetMasterDetails = _data["trnAssetMasterDetails"] ? CreateOrEditTrnAssetMasterDetailsDto.fromJS(_data["trnAssetMasterDetails"]) : <any>undefined;
            this.assetAssetName = _data["assetAssetName"];
        }
    }

    static fromJS(data: any): GetTrnAssetMasterDetailsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrnAssetMasterDetailsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trnAssetMasterDetails"] = this.trnAssetMasterDetails ? this.trnAssetMasterDetails.toJSON() : <any>undefined;
        data["assetAssetName"] = this.assetAssetName;
        return data;
    }
}

export interface IGetTrnAssetMasterDetailsForEditOutput {
    trnAssetMasterDetails: CreateOrEditTrnAssetMasterDetailsDto;
    assetAssetName: string | undefined;
}

export class TrnAssetMasterDetailsAssetLookupTableDto implements ITrnAssetMasterDetailsAssetLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ITrnAssetMasterDetailsAssetLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): TrnAssetMasterDetailsAssetLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrnAssetMasterDetailsAssetLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ITrnAssetMasterDetailsAssetLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class TrnExpensesClaimDto implements ITrnExpensesClaimDto {
    expid!: number | undefined;
    expdate!: moment.Moment | undefined;
    amount!: number | undefined;
    billno!: string | undefined;
    merchantname!: string | undefined;
    distance!: number | undefined;
    travelperiodfrom!: moment.Moment | undefined;
    trevelperiodto!: moment.Moment | undefined;
    ownwardjourney!: moment.Moment | undefined;
    returnjourney!: moment.Moment | undefined;
    hotelname!: string | undefined;
    checkin!: moment.Moment | undefined;
    checkout!: moment.Moment | undefined;
    documenturl!: string | undefined;
    submission!: boolean;
    documentName!: string | undefined;
    remarks!: string | undefined;
    id!: number;

    constructor(data?: ITrnExpensesClaimDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expid = _data["expid"];
            this.expdate = _data["expdate"] ? moment(_data["expdate"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.billno = _data["billno"];
            this.merchantname = _data["merchantname"];
            this.distance = _data["distance"];
            this.travelperiodfrom = _data["travelperiodfrom"] ? moment(_data["travelperiodfrom"].toString()) : <any>undefined;
            this.trevelperiodto = _data["trevelperiodto"] ? moment(_data["trevelperiodto"].toString()) : <any>undefined;
            this.ownwardjourney = _data["ownwardjourney"] ? moment(_data["ownwardjourney"].toString()) : <any>undefined;
            this.returnjourney = _data["returnjourney"] ? moment(_data["returnjourney"].toString()) : <any>undefined;
            this.hotelname = _data["hotelname"];
            this.checkin = _data["checkin"] ? moment(_data["checkin"].toString()) : <any>undefined;
            this.checkout = _data["checkout"] ? moment(_data["checkout"].toString()) : <any>undefined;
            this.documenturl = _data["documenturl"];
            this.submission = _data["submission"];
            this.documentName = _data["documentName"];
            this.remarks = _data["remarks"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TrnExpensesClaimDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrnExpensesClaimDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expid"] = this.expid;
        data["expdate"] = this.expdate ? this.expdate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["billno"] = this.billno;
        data["merchantname"] = this.merchantname;
        data["distance"] = this.distance;
        data["travelperiodfrom"] = this.travelperiodfrom ? this.travelperiodfrom.toISOString() : <any>undefined;
        data["trevelperiodto"] = this.trevelperiodto ? this.trevelperiodto.toISOString() : <any>undefined;
        data["ownwardjourney"] = this.ownwardjourney ? this.ownwardjourney.toISOString() : <any>undefined;
        data["returnjourney"] = this.returnjourney ? this.returnjourney.toISOString() : <any>undefined;
        data["hotelname"] = this.hotelname;
        data["checkin"] = this.checkin ? this.checkin.toISOString() : <any>undefined;
        data["checkout"] = this.checkout ? this.checkout.toISOString() : <any>undefined;
        data["documenturl"] = this.documenturl;
        data["submission"] = this.submission;
        data["documentName"] = this.documentName;
        data["remarks"] = this.remarks;
        data["id"] = this.id;
        return data;
    }
}

export interface ITrnExpensesClaimDto {
    expid: number | undefined;
    expdate: moment.Moment | undefined;
    amount: number | undefined;
    billno: string | undefined;
    merchantname: string | undefined;
    distance: number | undefined;
    travelperiodfrom: moment.Moment | undefined;
    trevelperiodto: moment.Moment | undefined;
    ownwardjourney: moment.Moment | undefined;
    returnjourney: moment.Moment | undefined;
    hotelname: string | undefined;
    checkin: moment.Moment | undefined;
    checkout: moment.Moment | undefined;
    documenturl: string | undefined;
    submission: boolean;
    documentName: string | undefined;
    remarks: string | undefined;
    id: number;
}

export class GetTrnExpensesClaimForViewDto implements IGetTrnExpensesClaimForViewDto {
    trnExpensesClaim!: TrnExpensesClaimDto;
    expenseName!: string | undefined;
    natureName!: string | undefined;
    requestedBy!: number | undefined;
    requestFlow!: string | undefined;
    leaveRejectStatus!: string | undefined;
    requestedOn!: moment.Moment | undefined;
    remarks!: string | undefined;

    constructor(data?: IGetTrnExpensesClaimForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trnExpensesClaim = _data["trnExpensesClaim"] ? TrnExpensesClaimDto.fromJS(_data["trnExpensesClaim"]) : <any>undefined;
            this.expenseName = _data["expenseName"];
            this.natureName = _data["natureName"];
            this.requestedBy = _data["requestedBy"];
            this.requestFlow = _data["requestFlow"];
            this.leaveRejectStatus = _data["leaveRejectStatus"];
            this.requestedOn = _data["requestedOn"] ? moment(_data["requestedOn"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): GetTrnExpensesClaimForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrnExpensesClaimForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trnExpensesClaim"] = this.trnExpensesClaim ? this.trnExpensesClaim.toJSON() : <any>undefined;
        data["expenseName"] = this.expenseName;
        data["natureName"] = this.natureName;
        data["requestedBy"] = this.requestedBy;
        data["requestFlow"] = this.requestFlow;
        data["leaveRejectStatus"] = this.leaveRejectStatus;
        data["requestedOn"] = this.requestedOn ? this.requestedOn.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IGetTrnExpensesClaimForViewDto {
    trnExpensesClaim: TrnExpensesClaimDto;
    expenseName: string | undefined;
    natureName: string | undefined;
    requestedBy: number | undefined;
    requestFlow: string | undefined;
    leaveRejectStatus: string | undefined;
    requestedOn: moment.Moment | undefined;
    remarks: string | undefined;
}

export class CreateOrEditTrnExpensesClaimDto implements ICreateOrEditTrnExpensesClaimDto {
    expid!: number | undefined;
    expdate!: moment.Moment | undefined;
    amount!: number | undefined;
    billno!: string | undefined;
    merchantname!: string | undefined;
    distance!: number | undefined;
    travelperiodfrom!: moment.Moment | undefined;
    trevelperiodto!: moment.Moment | undefined;
    ownwardjourney!: moment.Moment | undefined;
    returnjourney!: moment.Moment | undefined;
    hotelname!: string | undefined;
    checkin!: moment.Moment | undefined;
    checkout!: moment.Moment | undefined;
    documenturl!: string | undefined;
    submission!: boolean;
    employeeId!: number | undefined;
    imagePath!: string | undefined;
    remarks!: string | undefined;
    requestForApprovalLogId!: number | undefined;
    expenseName!: string | undefined;
    expenseNature!: string | undefined;
    documentName!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTrnExpensesClaimDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expid = _data["expid"];
            this.expdate = _data["expdate"] ? moment(_data["expdate"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.billno = _data["billno"];
            this.merchantname = _data["merchantname"];
            this.distance = _data["distance"];
            this.travelperiodfrom = _data["travelperiodfrom"] ? moment(_data["travelperiodfrom"].toString()) : <any>undefined;
            this.trevelperiodto = _data["trevelperiodto"] ? moment(_data["trevelperiodto"].toString()) : <any>undefined;
            this.ownwardjourney = _data["ownwardjourney"] ? moment(_data["ownwardjourney"].toString()) : <any>undefined;
            this.returnjourney = _data["returnjourney"] ? moment(_data["returnjourney"].toString()) : <any>undefined;
            this.hotelname = _data["hotelname"];
            this.checkin = _data["checkin"] ? moment(_data["checkin"].toString()) : <any>undefined;
            this.checkout = _data["checkout"] ? moment(_data["checkout"].toString()) : <any>undefined;
            this.documenturl = _data["documenturl"];
            this.submission = _data["submission"];
            this.employeeId = _data["employeeId"];
            this.imagePath = _data["imagePath"];
            this.remarks = _data["remarks"];
            this.requestForApprovalLogId = _data["requestForApprovalLogId"];
            this.expenseName = _data["expenseName"];
            this.expenseNature = _data["expenseNature"];
            this.documentName = _data["documentName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTrnExpensesClaimDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTrnExpensesClaimDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expid"] = this.expid;
        data["expdate"] = this.expdate ? this.expdate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["billno"] = this.billno;
        data["merchantname"] = this.merchantname;
        data["distance"] = this.distance;
        data["travelperiodfrom"] = this.travelperiodfrom ? this.travelperiodfrom.toISOString() : <any>undefined;
        data["trevelperiodto"] = this.trevelperiodto ? this.trevelperiodto.toISOString() : <any>undefined;
        data["ownwardjourney"] = this.ownwardjourney ? this.ownwardjourney.toISOString() : <any>undefined;
        data["returnjourney"] = this.returnjourney ? this.returnjourney.toISOString() : <any>undefined;
        data["hotelname"] = this.hotelname;
        data["checkin"] = this.checkin ? this.checkin.toISOString() : <any>undefined;
        data["checkout"] = this.checkout ? this.checkout.toISOString() : <any>undefined;
        data["documenturl"] = this.documenturl;
        data["submission"] = this.submission;
        data["employeeId"] = this.employeeId;
        data["imagePath"] = this.imagePath;
        data["remarks"] = this.remarks;
        data["requestForApprovalLogId"] = this.requestForApprovalLogId;
        data["expenseName"] = this.expenseName;
        data["expenseNature"] = this.expenseNature;
        data["documentName"] = this.documentName;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTrnExpensesClaimDto {
    expid: number | undefined;
    expdate: moment.Moment | undefined;
    amount: number | undefined;
    billno: string | undefined;
    merchantname: string | undefined;
    distance: number | undefined;
    travelperiodfrom: moment.Moment | undefined;
    trevelperiodto: moment.Moment | undefined;
    ownwardjourney: moment.Moment | undefined;
    returnjourney: moment.Moment | undefined;
    hotelname: string | undefined;
    checkin: moment.Moment | undefined;
    checkout: moment.Moment | undefined;
    documenturl: string | undefined;
    submission: boolean;
    employeeId: number | undefined;
    imagePath: string | undefined;
    remarks: string | undefined;
    requestForApprovalLogId: number | undefined;
    expenseName: string | undefined;
    expenseNature: string | undefined;
    documentName: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetTrnExpensesClaimForViewDto implements IPagedResultDtoOfGetTrnExpensesClaimForViewDto {
    totalCount!: number;
    items!: GetTrnExpensesClaimForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTrnExpensesClaimForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTrnExpensesClaimForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTrnExpensesClaimForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTrnExpensesClaimForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTrnExpensesClaimForViewDto {
    totalCount: number;
    items: GetTrnExpensesClaimForViewDto[] | undefined;
}

export class GetTrnExpensesClaimForEditOutput implements IGetTrnExpensesClaimForEditOutput {
    trnExpensesClaim!: CreateOrEditTrnExpensesClaimDto;
    requestBy!: number | undefined;

    constructor(data?: IGetTrnExpensesClaimForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trnExpensesClaim = _data["trnExpensesClaim"] ? CreateOrEditTrnExpensesClaimDto.fromJS(_data["trnExpensesClaim"]) : <any>undefined;
            this.requestBy = _data["requestBy"];
        }
    }

    static fromJS(data: any): GetTrnExpensesClaimForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrnExpensesClaimForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trnExpensesClaim"] = this.trnExpensesClaim ? this.trnExpensesClaim.toJSON() : <any>undefined;
        data["requestBy"] = this.requestBy;
        return data;
    }
}

export interface IGetTrnExpensesClaimForEditOutput {
    trnExpensesClaim: CreateOrEditTrnExpensesClaimDto;
    requestBy: number | undefined;
}

export class BulKCreateOrEditTrnExpensesClaimDto implements IBulKCreateOrEditTrnExpensesClaimDto {
    submission!: boolean;
    trnExpensesClaimDtos!: CreateOrEditTrnExpensesClaimDto[] | undefined;

    constructor(data?: IBulKCreateOrEditTrnExpensesClaimDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submission = _data["submission"];
            if (Array.isArray(_data["trnExpensesClaimDtos"])) {
                this.trnExpensesClaimDtos = [] as any;
                for (let item of _data["trnExpensesClaimDtos"])
                    this.trnExpensesClaimDtos!.push(CreateOrEditTrnExpensesClaimDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BulKCreateOrEditTrnExpensesClaimDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulKCreateOrEditTrnExpensesClaimDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submission"] = this.submission;
        if (Array.isArray(this.trnExpensesClaimDtos)) {
            data["trnExpensesClaimDtos"] = [];
            for (let item of this.trnExpensesClaimDtos)
                data["trnExpensesClaimDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBulKCreateOrEditTrnExpensesClaimDto {
    submission: boolean;
    trnExpensesClaimDtos: CreateOrEditTrnExpensesClaimDto[] | undefined;
}

export class UserListRoleDto implements IUserListRoleDto {
    roleId!: number;
    roleName!: string | undefined;

    constructor(data?: IUserListRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): UserListRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        return data;
    }
}

export interface IUserListRoleDto {
    roleId: number;
    roleName: string | undefined;
}

export class UserListDto implements IUserListDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    phoneNumber!: string | undefined;
    profilePictureId!: string | undefined;
    isEmailConfirmed!: boolean;
    roles!: UserListRoleDto[] | undefined;
    isActive!: boolean;
    creationTime!: moment.Moment;
    id!: number;

    constructor(data?: IUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.profilePictureId = _data["profilePictureId"];
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserListRoleDto.fromJS(item));
            }
            this.isActive = _data["isActive"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["profilePictureId"] = this.profilePictureId;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    profilePictureId: string | undefined;
    isEmailConfirmed: boolean;
    roles: UserListRoleDto[] | undefined;
    isActive: boolean;
    creationTime: moment.Moment;
    id: number;
}

export class PagedResultDtoOfUserListDto implements IPagedResultDtoOfUserListDto {
    totalCount!: number;
    items!: UserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfUserListDto {
    totalCount: number;
    items: UserListDto[] | undefined;
}

export class UserEditDto implements IUserEditDto {
    id!: number | undefined;
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string | undefined;
    phoneNumber!: string | undefined;
    password!: string | undefined;
    isActive!: boolean;
    shouldChangePasswordOnNextLogin!: boolean;
    isTwoFactorEnabled!: boolean;
    isLockoutEnabled!: boolean;

    constructor(data?: IUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.password = _data["password"];
            this.isActive = _data["isActive"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
        }
    }

    static fromJS(data: any): UserEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["isActive"] = this.isActive;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        return data;
    }
}

export interface IUserEditDto {
    id: number | undefined;
    name: string;
    surname: string;
    userName: string;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    password: string | undefined;
    isActive: boolean;
    shouldChangePasswordOnNextLogin: boolean;
    isTwoFactorEnabled: boolean;
    isLockoutEnabled: boolean;
}

export class UserRoleDto implements IUserRoleDto {
    roleId!: number;
    roleName!: string | undefined;
    roleDisplayName!: string | undefined;
    isAssigned!: boolean;

    constructor(data?: IUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.roleDisplayName = _data["roleDisplayName"];
            this.isAssigned = _data["isAssigned"];
        }
    }

    static fromJS(data: any): UserRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleDisplayName"] = this.roleDisplayName;
        data["isAssigned"] = this.isAssigned;
        return data;
    }
}

export interface IUserRoleDto {
    roleId: number;
    roleName: string | undefined;
    roleDisplayName: string | undefined;
    isAssigned: boolean;
}

export class GetUserForEditOutput implements IGetUserForEditOutput {
    profilePictureId!: string | undefined;
    user!: UserEditDto;
    roles!: UserRoleDto[] | undefined;
    allOrganizationUnits!: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits!: string[] | undefined;

    constructor(data?: IGetUserForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePictureId = _data["profilePictureId"];
            this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRoleDto.fromJS(item));
            }
            if (Array.isArray(_data["allOrganizationUnits"])) {
                this.allOrganizationUnits = [] as any;
                for (let item of _data["allOrganizationUnits"])
                    this.allOrganizationUnits!.push(OrganizationUnitDto.fromJS(item));
            }
            if (Array.isArray(_data["memberedOrganizationUnits"])) {
                this.memberedOrganizationUnits = [] as any;
                for (let item of _data["memberedOrganizationUnits"])
                    this.memberedOrganizationUnits!.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePictureId"] = this.profilePictureId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.allOrganizationUnits)) {
            data["allOrganizationUnits"] = [];
            for (let item of this.allOrganizationUnits)
                data["allOrganizationUnits"].push(item.toJSON());
        }
        if (Array.isArray(this.memberedOrganizationUnits)) {
            data["memberedOrganizationUnits"] = [];
            for (let item of this.memberedOrganizationUnits)
                data["memberedOrganizationUnits"].push(item);
        }
        return data;
    }
}

export interface IGetUserForEditOutput {
    profilePictureId: string | undefined;
    user: UserEditDto;
    roles: UserRoleDto[] | undefined;
    allOrganizationUnits: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits: string[] | undefined;
}

export class GetUserPermissionsForEditOutput implements IGetUserPermissionsForEditOutput {
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetUserPermissionsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserPermissionsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserPermissionsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IGetUserPermissionsForEditOutput {
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class EntityDtoOfInt64 implements IEntityDtoOfInt64 {
    id!: number;

    constructor(data?: IEntityDtoOfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfInt64 {
    id: number;
}

export class UpdateUserPermissionsInput implements IUpdateUserPermissionsInput {
    id!: number;
    grantedPermissionNames!: string[];

    constructor(data?: IUpdateUserPermissionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.grantedPermissionNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserPermissionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPermissionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IUpdateUserPermissionsInput {
    id: number;
    grantedPermissionNames: string[];
}

export class CreateOrUpdateUserInput implements ICreateOrUpdateUserInput {
    user!: UserEditDto;
    assignedRoleNames!: string[];
    sendActivationEmail!: boolean;
    setRandomPassword!: boolean;
    organizationUnits!: number[] | undefined;

    constructor(data?: ICreateOrUpdateUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user = new UserEditDto();
            this.assignedRoleNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : new UserEditDto();
            if (Array.isArray(_data["assignedRoleNames"])) {
                this.assignedRoleNames = [] as any;
                for (let item of _data["assignedRoleNames"])
                    this.assignedRoleNames!.push(item);
            }
            this.sendActivationEmail = _data["sendActivationEmail"];
            this.setRandomPassword = _data["setRandomPassword"];
            if (Array.isArray(_data["organizationUnits"])) {
                this.organizationUnits = [] as any;
                for (let item of _data["organizationUnits"])
                    this.organizationUnits!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.assignedRoleNames)) {
            data["assignedRoleNames"] = [];
            for (let item of this.assignedRoleNames)
                data["assignedRoleNames"].push(item);
        }
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["setRandomPassword"] = this.setRandomPassword;
        if (Array.isArray(this.organizationUnits)) {
            data["organizationUnits"] = [];
            for (let item of this.organizationUnits)
                data["organizationUnits"].push(item);
        }
        return data;
    }
}

export interface ICreateOrUpdateUserInput {
    user: UserEditDto;
    assignedRoleNames: string[];
    sendActivationEmail: boolean;
    setRandomPassword: boolean;
    organizationUnits: number[] | undefined;
}

export class LinkToUserInput implements ILinkToUserInput {
    tenancyName!: string | undefined;
    usernameOrEmailAddress!: string;
    password!: string;

    constructor(data?: ILinkToUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.usernameOrEmailAddress = _data["usernameOrEmailAddress"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LinkToUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new LinkToUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["usernameOrEmailAddress"] = this.usernameOrEmailAddress;
        data["password"] = this.password;
        return data;
    }
}

export interface ILinkToUserInput {
    tenancyName: string | undefined;
    usernameOrEmailAddress: string;
    password: string;
}

export class LinkedUserDto implements ILinkedUserDto {
    tenantId!: number | undefined;
    tenancyName!: string | undefined;
    username!: string | undefined;
    id!: number;

    constructor(data?: ILinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenancyName = _data["tenancyName"];
            this.username = _data["username"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["username"] = this.username;
        data["id"] = this.id;
        return data;
    }
}

export interface ILinkedUserDto {
    tenantId: number | undefined;
    tenancyName: string | undefined;
    username: string | undefined;
    id: number;
}

export class PagedResultDtoOfLinkedUserDto implements IPagedResultDtoOfLinkedUserDto {
    totalCount!: number;
    items!: LinkedUserDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfLinkedUserDto {
    totalCount: number;
    items: LinkedUserDto[] | undefined;
}

export class ListResultDtoOfLinkedUserDto implements IListResultDtoOfLinkedUserDto {
    items!: LinkedUserDto[] | undefined;

    constructor(data?: IListResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfLinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfLinkedUserDto {
    items: LinkedUserDto[] | undefined;
}

export class UnlinkUserInput implements IUnlinkUserInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IUnlinkUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UnlinkUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new UnlinkUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUnlinkUserInput {
    tenantId: number | undefined;
    userId: number;
}

export class UserLoginAttemptDto implements IUserLoginAttemptDto {
    tenancyName!: string | undefined;
    userNameOrEmail!: string | undefined;
    clientIpAddress!: string | undefined;
    clientName!: string | undefined;
    browserInfo!: string | undefined;
    result!: string | undefined;
    creationTime!: moment.Moment;

    constructor(data?: IUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.userNameOrEmail = _data["userNameOrEmail"];
            this.clientIpAddress = _data["clientIpAddress"];
            this.clientName = _data["clientName"];
            this.browserInfo = _data["browserInfo"];
            this.result = _data["result"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserLoginAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userNameOrEmail"] = this.userNameOrEmail;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["result"] = this.result;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserLoginAttemptDto {
    tenancyName: string | undefined;
    userNameOrEmail: string | undefined;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    result: string | undefined;
    creationTime: moment.Moment;
}

export class ListResultDtoOfUserLoginAttemptDto implements IListResultDtoOfUserLoginAttemptDto {
    items!: UserLoginAttemptDto[] | undefined;

    constructor(data?: IListResultDtoOfUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserLoginAttemptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfUserLoginAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfUserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfUserLoginAttemptDto {
    items: UserLoginAttemptDto[] | undefined;
}

export class GetLatestWebLogsOutput implements IGetLatestWebLogsOutput {
    latestWebLogLines!: string[] | undefined;

    constructor(data?: IGetLatestWebLogsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["latestWebLogLines"])) {
                this.latestWebLogLines = [] as any;
                for (let item of _data["latestWebLogLines"])
                    this.latestWebLogLines!.push(item);
            }
        }
    }

    static fromJS(data: any): GetLatestWebLogsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLatestWebLogsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.latestWebLogLines)) {
            data["latestWebLogLines"] = [];
            for (let item of this.latestWebLogLines)
                data["latestWebLogLines"].push(item);
        }
        return data;
    }
}

export interface IGetLatestWebLogsOutput {
    latestWebLogLines: string[] | undefined;
}

export class KeyValuePairOfStringIEnumerableOfString implements IKeyValuePairOfStringIEnumerableOfString {
    key!: string | undefined;
    value!: string[] | undefined;

    constructor(data?: IKeyValuePairOfStringIEnumerableOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
        }
    }

    static fromJS(data: any): KeyValuePairOfStringIEnumerableOfString {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfStringIEnumerableOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        return data;
    }
}

export interface IKeyValuePairOfStringIEnumerableOfString {
    key: string | undefined;
    value: string[] | undefined;
}

export class HttpContent implements IHttpContent {
    readonly headers!: KeyValuePairOfStringIEnumerableOfString[] | undefined;

    constructor(data?: IHttpContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["headers"])) {
                (<any>this).headers = [] as any;
                for (let item of _data["headers"])
                    (<any>this).headers!.push(KeyValuePairOfStringIEnumerableOfString.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HttpContent {
        data = typeof data === 'object' ? data : {};
        let result = new HttpContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHttpContent {
    headers: KeyValuePairOfStringIEnumerableOfString[] | undefined;
}

export class HttpMethod implements IHttpMethod {
    method!: string | undefined;

    constructor(data?: IHttpMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.method = _data["method"];
        }
    }

    static fromJS(data: any): HttpMethod {
        data = typeof data === 'object' ? data : {};
        let result = new HttpMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["method"] = this.method;
        return data;
    }
}

export interface IHttpMethod {
    method: string | undefined;
}

export class HttpRequestMessage implements IHttpRequestMessage {
    version!: string | undefined;
    content!: HttpContent;
    method!: HttpMethod;
    requestUri!: string | undefined;
    readonly headers!: KeyValuePairOfStringIEnumerableOfString[] | undefined;
    readonly properties!: { [key: string]: any; } | undefined;

    constructor(data?: IHttpRequestMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.content = _data["content"] ? HttpContent.fromJS(_data["content"]) : <any>undefined;
            this.method = _data["method"] ? HttpMethod.fromJS(_data["method"]) : <any>undefined;
            this.requestUri = _data["requestUri"];
            if (Array.isArray(_data["headers"])) {
                (<any>this).headers = [] as any;
                for (let item of _data["headers"])
                    (<any>this).headers!.push(KeyValuePairOfStringIEnumerableOfString.fromJS(item));
            }
            if (_data["properties"]) {
                (<any>this).properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>(<any>this).properties)![key] = _data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): HttpRequestMessage {
        data = typeof data === 'object' ? data : {};
        let result = new HttpRequestMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["method"] = this.method ? this.method.toJSON() : <any>undefined;
        data["requestUri"] = this.requestUri;
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item.toJSON());
        }
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = (<any>this.properties)[key];
            }
        }
        return data;
    }
}

export interface IHttpRequestMessage {
    version: string | undefined;
    content: HttpContent;
    method: HttpMethod;
    requestUri: string | undefined;
    headers: KeyValuePairOfStringIEnumerableOfString[] | undefined;
    properties: { [key: string]: any; } | undefined;
}

export class WipPunchDto implements IWipPunchDto {
    id!: number;
    tenantId!: number;
    employeeId!: number;
    employeeName!: string | undefined;
    employeeCode!: string | undefined;
    punchDate!: moment.Moment;
    punchTime!: string;
    machine!: string | undefined;
    locationName!: string | undefined;
    inOut!: string | undefined;
    deviceName!: string | undefined;
    status!: string | undefined;
    retryCount!: number;
    errorMessage!: string | undefined;
    createdAt!: moment.Moment;
    processedAt!: moment.Moment | undefined;
    failedAt!: moment.Moment | undefined;
    failureReason!: string | undefined;
    punchId!: number | undefined;

    constructor(data?: IWipPunchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.employeeCode = _data["employeeCode"];
            this.punchDate = _data["punchDate"] ? moment(_data["punchDate"].toString()) : <any>undefined;
            this.punchTime = _data["punchTime"];
            this.machine = _data["machine"];
            this.locationName = _data["locationName"];
            this.inOut = _data["inOut"];
            this.deviceName = _data["deviceName"];
            this.status = _data["status"];
            this.retryCount = _data["retryCount"];
            this.errorMessage = _data["errorMessage"];
            this.createdAt = _data["createdAt"] ? moment(_data["createdAt"].toString()) : <any>undefined;
            this.processedAt = _data["processedAt"] ? moment(_data["processedAt"].toString()) : <any>undefined;
            this.failedAt = _data["failedAt"] ? moment(_data["failedAt"].toString()) : <any>undefined;
            this.failureReason = _data["failureReason"];
            this.punchId = _data["punchId"];
        }
    }

    static fromJS(data: any): WipPunchDto {
        data = typeof data === 'object' ? data : {};
        let result = new WipPunchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["employeeCode"] = this.employeeCode;
        data["punchDate"] = this.punchDate ? this.punchDate.toISOString() : <any>undefined;
        data["punchTime"] = this.punchTime;
        data["machine"] = this.machine;
        data["locationName"] = this.locationName;
        data["inOut"] = this.inOut;
        data["deviceName"] = this.deviceName;
        data["status"] = this.status;
        data["retryCount"] = this.retryCount;
        data["errorMessage"] = this.errorMessage;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["processedAt"] = this.processedAt ? this.processedAt.toISOString() : <any>undefined;
        data["failedAt"] = this.failedAt ? this.failedAt.toISOString() : <any>undefined;
        data["failureReason"] = this.failureReason;
        data["punchId"] = this.punchId;
        return data;
    }
}

export interface IWipPunchDto {
    id: number;
    tenantId: number;
    employeeId: number;
    employeeName: string | undefined;
    employeeCode: string | undefined;
    punchDate: moment.Moment;
    punchTime: string;
    machine: string | undefined;
    locationName: string | undefined;
    inOut: string | undefined;
    deviceName: string | undefined;
    status: string | undefined;
    retryCount: number;
    errorMessage: string | undefined;
    createdAt: moment.Moment;
    processedAt: moment.Moment | undefined;
    failedAt: moment.Moment | undefined;
    failureReason: string | undefined;
    punchId: number | undefined;
}

export class PagedResultDtoOfWipPunchDto implements IPagedResultDtoOfWipPunchDto {
    totalCount!: number;
    items!: WipPunchDto[] | undefined;

    constructor(data?: IPagedResultDtoOfWipPunchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WipPunchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfWipPunchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfWipPunchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfWipPunchDto {
    totalCount: number;
    items: WipPunchDto[] | undefined;
}

export class WipPunchStatsDto implements IWipPunchStatsDto {
    pending!: number;
    processing!: number;
    processed!: number;
    failed!: number;
    skipped!: number;

    constructor(data?: IWipPunchStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pending = _data["pending"];
            this.processing = _data["processing"];
            this.processed = _data["processed"];
            this.failed = _data["failed"];
            this.skipped = _data["skipped"];
        }
    }

    static fromJS(data: any): WipPunchStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new WipPunchStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pending"] = this.pending;
        data["processing"] = this.processing;
        data["processed"] = this.processed;
        data["failed"] = this.failed;
        data["skipped"] = this.skipped;
        return data;
    }
}

export interface IWipPunchStatsDto {
    pending: number;
    processing: number;
    processed: number;
    failed: number;
    skipped: number;
}

export class WorkflowListDto implements IWorkflowListDto {
    name!: string | undefined;
    description!: string | undefined;
    type!: string | undefined;
    steps!: string | undefined;
    id!: number;

    constructor(data?: IWorkflowListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.steps = _data["steps"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WorkflowListDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["type"] = this.type;
        data["steps"] = this.steps;
        data["id"] = this.id;
        return data;
    }
}

export interface IWorkflowListDto {
    name: string | undefined;
    description: string | undefined;
    type: string | undefined;
    steps: string | undefined;
    id: number;
}

export class GetWorkflowForViewDto implements IGetWorkflowForViewDto {
    workflow!: WorkflowListDto;

    constructor(data?: IGetWorkflowForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflow = _data["workflow"] ? WorkflowListDto.fromJS(_data["workflow"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetWorkflowForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetWorkflowForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflow"] = this.workflow ? this.workflow.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetWorkflowForViewDto {
    workflow: WorkflowListDto;
}

export class PagedResultDtoOfGetWorkflowForViewDto implements IPagedResultDtoOfGetWorkflowForViewDto {
    totalCount!: number;
    items!: GetWorkflowForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetWorkflowForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetWorkflowForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetWorkflowForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetWorkflowForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetWorkflowForViewDto {
    totalCount: number;
    items: GetWorkflowForViewDto[] | undefined;
}

export class WorkFlowDto implements IWorkFlowDto {
    name!: string | undefined;
    description!: string | undefined;
    type!: number;
    steps!: WorkFlowSteps[] | undefined;
    id!: number;

    constructor(data?: IWorkFlowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.type = _data["type"];
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(WorkFlowSteps.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WorkFlowDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkFlowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["type"] = this.type;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IWorkFlowDto {
    name: string | undefined;
    description: string | undefined;
    type: number;
    steps: WorkFlowSteps[] | undefined;
    id: number;
}

export class WorkFlowviewDto implements IWorkFlowviewDto {
    wrokFlow!: WorkFlowDto;

    constructor(data?: IWorkFlowviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wrokFlow = _data["wrokFlow"] ? WorkFlowDto.fromJS(_data["wrokFlow"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkFlowviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkFlowviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wrokFlow"] = this.wrokFlow ? this.wrokFlow.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWorkFlowviewDto {
    wrokFlow: WorkFlowDto;
}

export class GetRequesrFlowForEditOutput implements IGetRequesrFlowForEditOutput {
    workFlow!: CreateOrEditRequestWorkflowStepDto;

    constructor(data?: IGetRequesrFlowForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workFlow = _data["workFlow"] ? CreateOrEditRequestWorkflowStepDto.fromJS(_data["workFlow"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRequesrFlowForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRequesrFlowForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workFlow"] = this.workFlow ? this.workFlow.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRequesrFlowForEditOutput {
    workFlow: CreateOrEditRequestWorkflowStepDto;
}

export class AdditionalData implements IAdditionalData {
    paypal!: { [key: string]: string; };
    stripe!: { [key: string]: string; };

    [key: string]: any;

    constructor(data?: IAdditionalData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["Paypal"]) {
                this.paypal = {} as any;
                for (let key in _data["Paypal"]) {
                    if (_data["Paypal"].hasOwnProperty(key))
                        (<any>this.paypal)![key] = _data["Paypal"][key];
                }
            }
            if (_data["Stripe"]) {
                this.stripe = {} as any;
                for (let key in _data["Stripe"]) {
                    if (_data["Stripe"].hasOwnProperty(key))
                        (<any>this.stripe)![key] = _data["Stripe"][key];
                }
            }
        }
    }

    static fromJS(data: any): AdditionalData {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.paypal) {
            data["Paypal"] = {};
            for (let key in this.paypal) {
                if (this.paypal.hasOwnProperty(key))
                    (<any>data["Paypal"])[key] = (<any>this.paypal)[key];
            }
        }
        if (this.stripe) {
            data["Stripe"] = {};
            for (let key in this.stripe) {
                if (this.stripe.hasOwnProperty(key))
                    (<any>data["Stripe"])[key] = (<any>this.stripe)[key];
            }
        }
        return data;
    }
}

export interface IAdditionalData {
    paypal: { [key: string]: string; };
    stripe: { [key: string]: string; };

    [key: string]: any;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}